export default [
    {
        "golabel": "ABL1_regulon_activity",
        "gene": [
            "PLEKHG2",
            "DCHS1",
            "ADAMTS7",
            "LPAR1",
            "COL4A2",
            "COL4A1",
            "RNFT1",
            "NCS1",
            "NEU1",
            "SH3PXD2B",
            "C5orf28",
            "SRI",
            "ANKRD46",
            "ZNF618",
            "DBI",
            "IFT20",
            "NOTCH1",
            "NACC2",
            "DENND1A",
            "AMZ2P1",
            "TMEM218",
            "RXRA",
            "BAT2L1",
            "ANKRD49",
            "MIF4GD",
            "WDSUB1",
            "BRD3",
            "ABL2",
            "MEF2D",
            "SFT2D1",
            "TECPR2",
            "MLX",
            "EHMT1",
            "C17orf95",
            "PHF2",
            "INVS",
            "HNRNPA0",
            "NUP214",
            "RBM15B"
        ]
    },
    {
        "golabel": "ABTB1_regulon_activity",
        "gene": [
            "CYP3A5",
            "VILL",
            "LGALS9C",
            "RNASE13",
            "GJC2",
            "C5orf32",
            "NRADDP",
            "MYO15B",
            "USHBP1",
            "PIWIL4",
            "PLAC9",
            "KANK3",
            "MUSTN1",
            "ZFPM1",
            "CCDC48",
            "MPP6",
            "C3orf47",
            "CENPF",
            "ALS2CL",
            "IDUA",
            "TMEM91",
            "CRYGS",
            "LOC146880",
            "CROCC",
            "UBXN11",
            "ZMYND15",
            "RDX",
            "TNFRSF14",
            "SYTL1",
            "FKBP14",
            "CBX7",
            "HOMER1",
            "LYL1",
            "ECHDC2",
            "ANKMY1",
            "ACADS",
            "CDK10",
            "C17orf108",
            "EXD3",
            "RIPK3",
            "PHKA1",
            "DPP7",
            "PLEKHA8",
            "SCRN2",
            "FAM109A",
            "KLC4",
            "FCHSD1",
            "PNPLA2",
            "GARS",
            "ARHGEF1",
            "SCFD1",
            "C17orf56",
            "HDAC11",
            "HEMK1",
            "LYSMD4",
            "CCDC61",
            "CKAP5",
            "RRM1",
            "FAM98C",
            "EIF5B",
            "CCDC130",
            "PANX1",
            "TNFSF12",
            "ENAH",
            "NAT6",
            "SH3GLB2",
            "SPSB3",
            "LMAN1",
            "DKC1",
            "IPO7",
            "FAM199X",
            "NAA15",
            "HSPA9",
            "DLAT",
            "LARP4",
            "ZFAND2B",
            "EPRS",
            "STT3A",
            "INPP5K",
            "UTP15",
            "SSR1",
            "TBC1D17",
            "RAB6A",
            "PUS3",
            "PHF1",
            "ZFYVE27",
            "HSPA4",
            "RPAP3",
            "AASDHPPT",
            "EEFSEC",
            "ARCN1",
            "YARS",
            "NR1H2",
            "EI24",
            "TPRA1",
            "HNRNPR",
            "ATMIN"
        ]
    },
    {
        "golabel": "AES_regulon_activity",
        "gene": [
            "LIFR",
            "FUT3",
            "ZBTB10",
            "NPDC1",
            "IDUA",
            "RPL36",
            "N4BP2",
            "MRPL54",
            "SEPW1",
            "PPDPF",
            "C10orf11",
            "EPB49",
            "NDUFA11",
            "RPS15",
            "ZNF518B",
            "TLE2",
            "CIB1",
            "NDUFB7",
            "MPHOSPH9",
            "UBXN7",
            "PEX11G",
            "TRAPPC5",
            "ATP5D",
            "UQCR11",
            "ALKBH7",
            "SBNO1",
            "MPG",
            "STAP2",
            "C19orf70",
            "RIF1",
            "ZNF524",
            "C19orf24",
            "CARS2",
            "SMC3",
            "BSG",
            "ZNF358",
            "C19orf25",
            "RFXANK",
            "KIAA0947",
            "RSC1A1",
            "CNN2",
            "DNAJC17",
            "SUZ12",
            "NUP153",
            "MPND",
            "C19orf22",
            "SNAPC2",
            "NDUFS7",
            "SIRT6",
            "MARCH2",
            "HMG20B",
            "C19orf39",
            "FAM108A1",
            "CLPP",
            "PIN1",
            "FKBP8",
            "KIAA1429",
            "TECR",
            "EIF3G",
            "C19orf43",
            "SLC39A3",
            "ELOF1",
            "CCDC94",
            "C19orf56",
            "GPR108",
            "SCAMP4",
            "POLR2E",
            "RAB11B",
            "FUBP1",
            "UBXN6",
            "PPP2R4"
        ]
    },
    {
        "golabel": "AFF1_regulon_activity",
        "gene": [
            "POLR2F",
            "COX6B1",
            "ERN1",
            "NFATC2",
            "KRT10",
            "CRIM1",
            "LOC150381",
            "STRA13",
            "NXT1",
            "NDUFB9",
            "LSMD1",
            "SHROOM3",
            "C2orf7",
            "MRPL52",
            "LAGE3",
            "FAM160A1",
            "NQO2",
            "EXOSC4",
            "ANAPC11",
            "SPATA13",
            "HERC3",
            "NOTCH2",
            "GADD45GIP1",
            "DYNLT1",
            "WWC2",
            "COX4I1",
            "MRPL12",
            "ZNF511",
            "PSMG1",
            "ATP10D",
            "MYO9A",
            "FAM96B",
            "TRIM56",
            "C11orf51",
            "PLEKHA7",
            "CCDC23",
            "PRDX2",
            "C17orf89",
            "RPP21",
            "TMEM2",
            "C19orf53",
            "GAB1",
            "MACF1",
            "REST",
            "SF3B5",
            "SNRNP25",
            "KIAA1109",
            "ZNRD1",
            "NR2C2AP",
            "MRPL27",
            "TFB1M",
            "CDS1",
            "AKAP9",
            "NEK1",
            "KIAA1370",
            "BANF1",
            "C7orf11",
            "MEA1",
            "SLC35D1",
            "CHD9",
            "NUTF2",
            "GCC2",
            "HSD17B10",
            "HERC1",
            "RAPGEF2",
            "NDUFS3",
            "FRYL",
            "BOD1L",
            "CHMP4A",
            "C17orf49",
            "ARHGEF12",
            "RPUSD3",
            "UQCRC1",
            "SH3D19",
            "KIAA2018",
            "SCARB2",
            "PDPK1",
            "DDX28",
            "MRPS16",
            "EXOSC1",
            "MBD5",
            "WDFY3",
            "NFKB1",
            "ANKRD17",
            "BIRC6",
            "CNOT6L",
            "SETX",
            "OTUD4",
            "TIMM22",
            "CENPC1",
            "STX17",
            "METTL14",
            "SEC24B",
            "C4orf41"
        ]
    },
    {
        "golabel": "AFF4_regulon_activity",
        "gene": [
            "SPRY4",
            "ARHGAP26",
            "THAP7",
            "ST20",
            "IL6ST",
            "RNF145",
            "C7orf59",
            "LOC100216545",
            "SGMS2",
            "MAN2A1",
            "BID",
            "PAM",
            "RAPGEF6",
            "SCAND1",
            "FER",
            "MRPL34",
            "ELL2",
            "PHF15",
            "MUTYH",
            "C11orf67",
            "PPCDC",
            "HAUS8",
            "FAHD2A",
            "C20orf27",
            "LRBA",
            "MARVELD2",
            "KIF3A",
            "MKL2",
            "MCCC2",
            "MIIP",
            "ARL2",
            "TOP1",
            "KTI12",
            "BDP1",
            "TSEN54",
            "FEM1C",
            "KIAA0232",
            "APC",
            "FBXW11",
            "FBXL17",
            "IQGAP1",
            "SEC24A",
            "ORAI1",
            "PJA2",
            "RAD50",
            "FNIP1",
            "SEPT8",
            "CTNNA1",
            "SMAD5",
            "DIAPH1",
            "SLC30A5",
            "PRRC1",
            "FAM53C",
            "KDM3B",
            "RBM27",
            "DDX46",
            "BCLAF1"
        ]
    },
    {
        "golabel": "AGAP3_regulon_activity",
        "gene": [
            "FRRS1",
            "KIFC2",
            "ANO9",
            "FBXL8",
            "CTAGE1",
            "ATG16L2",
            "LOC220429",
            "EIF5A2",
            "BAG4",
            "CROCC",
            "ABCA7",
            "SYTL1",
            "ALG10",
            "PLXNA3",
            "CNIH",
            "TMEM19",
            "SAMD10",
            "FLJ45340",
            "SLC9A3R2",
            "HSPA13",
            "RASA4P",
            "PLSCR1",
            "IMPDH1",
            "DCK",
            "GIGYF1",
            "ACAP3",
            "EXD3",
            "TMEM182",
            "SKIL",
            "HMHA1",
            "DVL1",
            "MAP3K6",
            "TBC1D15",
            "TCIRG1",
            "MIB2",
            "TNK2",
            "SELO",
            "TXNDC9",
            "EPS8L2",
            "MYNN",
            "MANEA",
            "RSRC1",
            "SH2B1",
            "TMUB1",
            "HEATR7A",
            "SLC35F5",
            "COMMD2",
            "TMX1",
            "PCBP4",
            "PUS7L",
            "SNAPC4",
            "PRKRIP1",
            "DPP9",
            "ARFRP1",
            "DCUN1D1",
            "LRCH4",
            "FAM73B",
            "C7orf43",
            "C5orf15",
            "TSN",
            "LOC284441",
            "ARSK",
            "RHOT2",
            "ANKRD13D",
            "PRCP",
            "PPP1R12C",
            "RARS2",
            "ATF1",
            "OGFR",
            "TSC22D4",
            "BRF1",
            "GMFB",
            "INPP5E",
            "NISCH",
            "SLC30A6",
            "C19orf6",
            "EIF1AX",
            "SLC4A2",
            "SNRNP70",
            "SPPL2A",
            "SEC62",
            "PPP1R2P3",
            "SLC33A1",
            "ABCB8",
            "MMADHC",
            "UEVLD",
            "CASP3",
            "TAOK2",
            "MBTPS2",
            "ELMOD2",
            "CC2D1A",
            "TRIM65",
            "C6orf211",
            "TIPRL",
            "MOBKL1B",
            "LRSAM1",
            "SRP72",
            "FYTTD1",
            "RALGDS",
            "CTDSPL2",
            "VTA1",
            "RQCD1",
            "ANAPC2",
            "CAMTA2",
            "PPP1R2",
            "RNGTT",
            "ZNF282",
            "RFX1",
            "COPB1",
            "EML3",
            "SPTY2D1",
            "SLC39A9",
            "CDC27",
            "HECTD3",
            "CDC73",
            "SMEK2",
            "ZFR",
            "TUBGCP2",
            "MARCH7",
            "UBXN4"
        ]
    },
    {
        "golabel": "AHCTF1_regulon_activity",
        "gene": [
            "RARRES3",
            "HLA-J",
            "TREM2",
            "LST1",
            "CRYBB1",
            "CD52",
            "CHML",
            "TYROBP",
            "IGSF22",
            "HLA-DMB",
            "HCST",
            "CCRL2",
            "HLA-DRA",
            "PYCARD",
            "HLA-DPB1",
            "PANK1",
            "TNFAIP8L2",
            "LGALS9",
            "GMFG",
            "CD74",
            "HLA-DMA",
            "TCN2",
            "TMEM86A",
            "SCCPDH",
            "NCF4",
            "FLVCR1",
            "HLA-A",
            "HLA-C",
            "CAPG",
            "STOML1",
            "KIAA1804",
            "DNAH14",
            "PHKA1",
            "LOC727896",
            "DHTKD1",
            "DARS2",
            "LPGAT1",
            "CHCHD6",
            "HLA-E",
            "SIRT2",
            "TBCE",
            "CEP170",
            "GPATCH4",
            "P2RX4",
            "PPM1M",
            "ESF1",
            "PDCD11",
            "IL10RB",
            "URB2",
            "HDGF",
            "PARP1",
            "AKR1A1",
            "DOK1",
            "UGGT1",
            "B3GALNT2",
            "HEATR1",
            "NOLC1",
            "ABL2",
            "C1orf107",
            "NECAP2",
            "MGAT1",
            "EPRS",
            "IARS2",
            "EIF3A",
            "UPF2",
            "DBNL",
            "NAGK",
            "RRP15",
            "TWF2",
            "CAMSAP1L1",
            "RBM34",
            "TPR",
            "ADSS",
            "FAM20B",
            "CEP350",
            "TOLLIP",
            "ARID4B",
            "RAB3GAP2",
            "NUP133",
            "BMS1",
            "SMG7",
            "TROVE2",
            "CDC73",
            "TAF5L",
            "WAC",
            "WDR26",
            "FUBP3",
            "HNRNPU"
        ]
    },
    {
        "golabel": "AHDC1_regulon_activity",
        "gene": [
            "MUC21",
            "SCUBE3",
            "CLDN9",
            "DOCK3",
            "FBXL16",
            "NCRNA00188",
            "ICAM5",
            "PLXNB3",
            "RSL24D1",
            "BAIAP3",
            "CACNB1",
            "KCNN4",
            "RPL22L1",
            "AGPHD1",
            "GTF3A",
            "KIF7",
            "C1orf170",
            "VASN",
            "NYNRIN",
            "EEF1B2",
            "MACC1",
            "MEGF6",
            "C1orf31",
            "PLEKHN1",
            "EPHA10",
            "GCH1",
            "PER3",
            "CROCC",
            "GARNL3",
            "GTF2A2",
            "GRID2IP",
            "PTPRU",
            "EVPL",
            "MICALL2",
            "MAP3K13",
            "C17orf107",
            "HIGD1A",
            "UQCRFS1",
            "JUN",
            "GPSM1",
            "GOLGA7",
            "PTPRS",
            "PPL",
            "SLC9A1",
            "PLXNA1",
            "SDC1",
            "APBA1",
            "IDI1",
            "ITGAE",
            "AGRN",
            "PRIC285",
            "FECH",
            "MTSS1L",
            "ZNF862",
            "ECE1",
            "CDC42BPG",
            "LIMK1",
            "C1QBP",
            "NDUFA9",
            "MAST2",
            "ABCA2",
            "ORAI2",
            "BTG1",
            "SDC3",
            "PKD1",
            "CCDC59",
            "BCL9L",
            "DBI",
            "C1orf89",
            "CUEDC1",
            "COX5A",
            "MAP3K6",
            "EXOSC8",
            "ZSWIM4",
            "EEF1E1",
            "KIAA0467",
            "ARHGEF10L",
            "PLXNB2",
            "PAK6",
            "MRPL42",
            "COPS3",
            "IKZF2",
            "C1orf201",
            "SVIL",
            "FAM96A",
            "RAB11FIP3",
            "RAI1",
            "PRDX3",
            "RHBDF1",
            "SLC12A9",
            "EHD1",
            "C10orf84",
            "ATF4",
            "CNKSR1",
            "GLTPD1",
            "PLEKHH3",
            "IQSEC2",
            "TIFA",
            "CXXC5",
            "CWF19L1",
            "DAGLB",
            "EHBP1L1",
            "PTPRF",
            "ZNF362",
            "C14orf109",
            "GPN3",
            "NPHP4",
            "ATF1",
            "RXRA",
            "METTL10",
            "CLSTN1",
            "PPARD",
            "SUCLG1",
            "ATP5A1",
            "KIAA1522",
            "POFUT2",
            "CRAT",
            "PSMA4",
            "RARA",
            "UBE2N",
            "GHITM",
            "TRIM62",
            "MAP7D1",
            "LDLRAP1",
            "CUTC",
            "ZDHHC18",
            "EVI5L",
            "ATP13A2",
            "ZNF22",
            "NSMCE4A",
            "NUP88",
            "XYLT2",
            "URGCP",
            "SMYD2",
            "RAB11FIP5",
            "AMD1",
            "MRPL30",
            "C9orf82",
            "NCDN",
            "C2orf43",
            "PHF13",
            "SKI",
            "NARS",
            "STK40",
            "EIF4A1",
            "TAF9",
            "ARID1A",
            "FAM131A",
            "OXNAD1",
            "PFKL",
            "MIS12",
            "SEPN1",
            "PPP1CC",
            "CIAPIN1",
            "C8orf41",
            "ZNF282",
            "PANK4",
            "ESD",
            "RFX1",
            "SLC35E1",
            "PPP1R9B",
            "PWP1",
            "EIF2A",
            "KCTD2",
            "WDTC1",
            "ZDHHC6",
            "SFRS3",
            "PHF12",
            "VGLL4",
            "MTRF1L",
            "ERP44",
            "MFN2",
            "HECTD3",
            "PHACTR4",
            "PLEKHM2",
            "DHDDS",
            "BSDC1",
            "TXLNA",
            "SFRS4"
        ]
    },
    {
        "golabel": "AHR_regulon_activity",
        "gene": [
            "C1orf95",
            "SLC16A14",
            "GPR110",
            "MFSD4",
            "MACC1",
            "SYTL2",
            "MPZL2",
            "TSPAN13",
            "IL1RAP",
            "RAB38",
            "DPYD",
            "MDFIC",
            "C1GALT1",
            "STK17A",
            "FRAT2",
            "SPRED1",
            "CROT",
            "TMEM106B",
            "PIM3",
            "TRAF2",
            "GNG12",
            "RCCD1",
            "C6orf136",
            "MAP3K5",
            "IFNAR2",
            "ANKMY2",
            "PTGES2",
            "PABPN1",
            "SNX13",
            "TAX1BP1",
            "PDHA1",
            "RBM19",
            "RAP1A",
            "EVI5",
            "NDUFS2",
            "FXR2",
            "ZNF12",
            "RSBN1L",
            "AAAS",
            "SEPT7",
            "TCHP",
            "ANP32A",
            "MIOS",
            "IFNAR1",
            "NAIF1",
            "HNRNPA0",
            "HERPUD2"
        ]
    },
    {
        "golabel": "AIP_regulon_activity",
        "gene": [
            "KLHL35",
            "HIST1H4J",
            "C20orf199",
            "VAMP5",
            "RPS21",
            "RPS18",
            "RPS7",
            "RPLP1",
            "RPL27",
            "KIAA0754",
            "RPS10",
            "C17orf61",
            "MRPL21",
            "RPS5",
            "RPS15A",
            "RPS3",
            "RPL35",
            "RPS6",
            "RPS16",
            "RPS14",
            "RPS29",
            "RPSA",
            "PFDN5",
            "RPL31",
            "RPL18A",
            "ROMO1",
            "RPL36",
            "TIMM16",
            "MACROD1",
            "CDK2AP2",
            "RPL8",
            "RPS19",
            "RNF168",
            "RPS8",
            "RPL24",
            "RPL26",
            "C6orf48",
            "RPL13A",
            "FKBP2",
            "LSMD1",
            "MRPL54",
            "RPS11",
            "RPL27A",
            "RPL29",
            "SSR4",
            "RPL5",
            "NDUFA2",
            "RPS9",
            "RPL10A",
            "NDUFA11",
            "RPL28",
            "CD320",
            "PHPT1",
            "RPL13",
            "RPL12",
            "MGMT",
            "C11orf83",
            "RPS15",
            "RPL41",
            "C2orf79",
            "MDP1",
            "RPL34",
            "RPL32",
            "NDUFA13",
            "RPL38",
            "NDUFB7",
            "RPL7A",
            "RPL37",
            "RNF181",
            "RPL18",
            "RPS13",
            "ANAPC11",
            "LSM7",
            "UBL5",
            "FIS1",
            "TRAPPC5",
            "KRTCAP2",
            "GADD45GIP1",
            "RPL37A",
            "RPL10",
            "UQCR11",
            "C16orf13",
            "ZNF511",
            "ALKBH7",
            "NDUFA3",
            "C11orf31",
            "ICAM3",
            "TMEM223",
            "HAX1",
            "SELK",
            "RPS20",
            "FAM96B",
            "NDUFA7",
            "RPS23",
            "RPS2",
            "OST4",
            "ATP5L",
            "FAU",
            "RPL30",
            "C19orf10",
            "ATP5E",
            "TEAD1",
            "RPL23",
            "CHCHD5",
            "UXT",
            "PRDX5",
            "RPL15",
            "EEF1D",
            "C19orf70",
            "GPX4",
            "C22orf32",
            "NDUFS8",
            "C19orf53",
            "ATP6V1F",
            "RPLP2",
            "MRPL53",
            "RPL3",
            "C9orf23",
            "POLD4",
            "THAP3",
            "CHCHD8",
            "RPL19",
            "FLOT1",
            "EEF1G",
            "TMEM134",
            "WDR25",
            "TRMT112",
            "LUZP1",
            "SSNA1",
            "DRAP1",
            "NDUFC2",
            "RPL23A",
            "YIF1A",
            "NDUFB8",
            "DBNDD2",
            "TMEM205",
            "COX8A",
            "MRPL43",
            "TMEM101",
            "TMEM179B",
            "RPS25",
            "SMG1",
            "COPE",
            "RNASEH2C",
            "NDUFAF3",
            "USE1",
            "UBA52",
            "C11orf10",
            "RNASEK",
            "SSSCA1",
            "C11orf59",
            "TRAPPC1",
            "ARL2",
            "NUDT22",
            "NDUFS7",
            "OAZ1",
            "HUWE1",
            "QSER1",
            "RPS6KB2",
            "C17orf49",
            "MTF1",
            "NPRL2",
            "ASB13",
            "CLPP",
            "WDR83",
            "PPP1CA",
            "PIN1",
            "BPTF",
            "GOLGB1",
            "LENG1",
            "NDUFV1",
            "DHPS",
            "DYNLRB1",
            "ANKRD17",
            "RANBP2",
            "BIRC6",
            "VEGFB",
            "C19orf56",
            "CORO1B",
            "SON",
            "UBXN1",
            "CUEDC2",
            "NUFIP2",
            "BCLAF1",
            "NUP98",
            "KAT5"
        ]
    },
    {
        "golabel": "AKAP8L_regulon_activity",
        "gene": [
            "RAPSN",
            "ARHGAP33",
            "C20orf106",
            "FITM1",
            "PCSK4",
            "ZGLP1",
            "MAPK8IP3",
            "LOC100132287",
            "DTX3",
            "PILRB",
            "CDK3",
            "LENG8",
            "RGL3",
            "CCNL2",
            "HAUS5",
            "LY6G5B",
            "AGAP6",
            "MORF4",
            "LOC100133331",
            "ZNF692",
            "KLHL17",
            "LRDD",
            "AGAP4",
            "LOC150776",
            "LOC729991-MEF2B",
            "FAM193B",
            "CDK5RAP3",
            "WASH7P",
            "TOP3B",
            "NDFIP2",
            "HSH2D",
            "SPPL2B",
            "ATXN7L2",
            "LUC7L",
            "MIB2",
            "CPSF1",
            "SFRS16",
            "HOOK2",
            "PCGF5",
            "SLC25A40",
            "C17orf56",
            "TRMT1",
            "GTPBP3",
            "RP2",
            "QTRT1",
            "CCDC130",
            "HEXIM1",
            "COX19",
            "PPP1R12C",
            "SYPL1",
            "ACBD5",
            "C19orf6",
            "SNRNP70",
            "SPPL2A",
            "PABPN1",
            "HSPA8",
            "SIN3B",
            "C1GALT1C1",
            "MBTPS2",
            "KRI1",
            "ABCC10",
            "RBM7",
            "ZNF335",
            "TMED7",
            "MINPP1",
            "ACIN1",
            "ZBTB17",
            "CMPK1",
            "HDGFRP2",
            "CASC4",
            "WASL",
            "ATP13A1",
            "MED26",
            "XAB2",
            "ILF3",
            "MAP2K7",
            "SPTLC1",
            "SAFB2",
            "SAFB",
            "VPS24",
            "SF4",
            "EWSR1",
            "AKAP8"
        ]
    },
    {
        "golabel": "AKNA_regulon_activity",
        "gene": [
            "FAM179A",
            "LRRC18",
            "DTHD1",
            "TTC16",
            "LTF",
            "C12orf63",
            "FHAD1",
            "SIAH3",
            "CD96",
            "LINGO3",
            "C14orf73",
            "NMB",
            "DBH",
            "DNAH1",
            "OXER1",
            "PTCH2",
            "SRGAP3",
            "ZNF831",
            "LOC728989",
            "FOXD4L6",
            "CARD11",
            "NLRP1",
            "NLRC3",
            "RASAL3",
            "ITGAL",
            "RUNDC2C",
            "KIF21B",
            "GTF2A2",
            "TMC8",
            "PLCB2",
            "IKZF1",
            "ACN9",
            "CIITA",
            "OR2A1",
            "PAPLN",
            "SYNE1",
            "SNAI3",
            "FGD3",
            "ARHGAP30",
            "BNIP3",
            "TMEM14B",
            "P4HA1",
            "FAM125B",
            "CRIPT",
            "TOMM22",
            "C3orf42",
            "MAP3K14",
            "C1orf57",
            "DENND3",
            "CCDC88C",
            "MICAL1",
            "PTS",
            "UQCRH",
            "RNF213",
            "GLRX3",
            "PIK3CD",
            "FYN",
            "KIAA0922",
            "ZBTB46",
            "GCNT2",
            "PPIL1",
            "PXMP2",
            "FAM36A",
            "PSMB5",
            "FBXO22OS",
            "DSTN",
            "MRS2",
            "EEF1E1",
            "TRANK1",
            "EVL",
            "ICOSLG",
            "NFATC1",
            "RASSF5",
            "PTK2B",
            "RCN2",
            "TMEM183A",
            "TGIF1",
            "PDIA6",
            "PRDX3",
            "TRIM14",
            "PIGF",
            "ARHGEF1",
            "SH3TC1",
            "CACYBP",
            "DEF6",
            "PARP14",
            "TEP1",
            "CEP110",
            "SLC35B2",
            "TSN",
            "SEMA4D",
            "DAD1",
            "DENND1C",
            "TSNAX",
            "MRPL45",
            "PL-5283",
            "FAM53B",
            "SDHC",
            "SRP9",
            "ABR",
            "DRG1",
            "MAST3",
            "CORO7",
            "S1PR2",
            "ARAP1",
            "SLC25A17",
            "SSH2",
            "ATXN7",
            "ZZEF1",
            "ZNFX1",
            "MYO9B",
            "CCDC90A",
            "VPS25",
            "FAM103A1",
            "C18orf55",
            "GMIP",
            "MOBKL2A",
            "MRPL30",
            "PSD4",
            "RALGDS",
            "NIF3L1",
            "TMCO1",
            "RAPGEF1",
            "YWHAE",
            "USP20",
            "C2orf47",
            "DARS",
            "CYTH1",
            "PPP1R9B",
            "PRKRA",
            "ELL",
            "TSG101",
            "XRCC6",
            "EI24",
            "RAB1A"
        ]
    },
    {
        "golabel": "ANKRD22_regulon_activity",
        "gene": [
            "COL25A1",
            "C1orf95",
            "TSPAN11",
            "KIT",
            "BCL2L14",
            "HMGB3",
            "FASN",
            "BCL2L15",
            "SYT7",
            "C5orf32",
            "LST1",
            "LIPH",
            "CLEC4A",
            "IGSF6",
            "RTP4",
            "KSR1",
            "GYLTL1B",
            "HLA-DMB",
            "C17orf60",
            "HLA-DRA",
            "MNDA",
            "JAG2",
            "HLA-DPA1",
            "HLA-DPB1",
            "IL7",
            "GALNT3",
            "CSF2RA",
            "TNFAIP8L2",
            "ETV7",
            "HLA-F",
            "AIF1",
            "CKLF",
            "IL18",
            "TPK1",
            "SMAGP",
            "CD74",
            "GBP2",
            "LAT2",
            "HNMT",
            "CARD16",
            "CASP1",
            "ZBTB12",
            "HLA-B",
            "CD58",
            "SELPLG",
            "PSMB10",
            "HS6ST1",
            "LGALS3",
            "SOCS7",
            "GPX1",
            "EPAS1",
            "DAPP1",
            "ARHGEF10",
            "CAPG",
            "SOX12",
            "ARHGDIB",
            "TK2",
            "MED13L",
            "CASP4",
            "TMEM51",
            "GSTK1",
            "ZNF236",
            "ARL6IP5",
            "MGST2",
            "EHMT2",
            "ATRN",
            "ARNT",
            "CDC42SE2",
            "RAB9A",
            "RPS6KC1",
            "GZF1",
            "FXR2"
        ]
    },
    {
        "golabel": "ANKRD42_regulon_activity",
        "gene": [
            "DNAI1",
            "C10orf79",
            "C6",
            "WDR63",
            "NWD1",
            "LRRC48",
            "WDR65",
            "CCDC81",
            "CCDC147",
            "HYDIN",
            "DNAH7",
            "AGBL2",
            "WDR93",
            "RSPH1",
            "CASC1",
            "IQUB",
            "LRGUK",
            "CCDC39",
            "C16orf71",
            "C10orf93",
            "C3orf15",
            "SPAG17",
            "BCO2",
            "EFCAB6",
            "KIAA1529",
            "CHST6",
            "CCDC40",
            "MAP6",
            "C2orf77",
            "SPEF2",
            "CCDC96",
            "C14orf174",
            "PIH1D2",
            "CCDC113",
            "LRRC6",
            "FANK1",
            "DYNC2H1",
            "CKS2",
            "RAB36",
            "CNTF",
            "MNS1",
            "RFX2",
            "NUF2",
            "C7orf63",
            "EPR1",
            "KIAA1377",
            "BIRC5",
            "CCDC30",
            "PSMA6",
            "CKS1B",
            "C22orf23",
            "C17orf97",
            "CASC2",
            "UBE2T",
            "SNRPG",
            "C14orf45",
            "LOC100130987",
            "C6orf129",
            "NSMCE2",
            "CC2D2A",
            "AKD1",
            "LRTOMT",
            "CYC1",
            "C11orf63",
            "IFT140",
            "DYX1C1",
            "PPIL5",
            "IFT172",
            "SHANK2",
            "NME1",
            "GLB1L",
            "CENPQ",
            "LSM2",
            "TTC12",
            "DTYMK",
            "SNRPB",
            "DUSP19",
            "ANAPC11",
            "CDC42BPG",
            "CENPL",
            "H2AFZ",
            "ACTL6A",
            "MRPL12",
            "PER2",
            "ARHGAP32",
            "SNRPD1",
            "C16orf46",
            "MED30",
            "RPGRIP1L",
            "IQCK",
            "CYB5D1",
            "C8orf33",
            "IQCE",
            "PSMA7",
            "FAM49B",
            "ICT1",
            "WDR60",
            "CACYBP",
            "WDR19",
            "YWHAQ",
            "ILF2",
            "TCTN2",
            "KIAA0556",
            "SUCLG1",
            "RSPH3",
            "NFAT5",
            "C2CD3",
            "GCC2",
            "CEP164",
            "MRPS7",
            "HIPK1",
            "RPIA",
            "C2CD2L",
            "BBS1",
            "ARHGEF12",
            "TP53BP1",
            "TRAF3IP1",
            "PHB",
            "TACO1",
            "COG7",
            "ATXN1L",
            "PHTF1",
            "SIK3",
            "CNBP",
            "SNX19",
            "TBRG1",
            "IK"
        ]
    },
    {
        "golabel": "ANKRD49_regulon_activity",
        "gene": [
            "TEX12",
            "MRPL21",
            "EAF2",
            "SNHG1",
            "KBTBD3",
            "MRPL48",
            "PLEC",
            "RNFT1",
            "LOC100216545",
            "HSD17B7P2",
            "RINL",
            "STAG3L4",
            "NOTCH3",
            "SH3PXD2B",
            "TMEM126B",
            "HSPG2",
            "SNORA8",
            "LRRC8A",
            "ZNF684",
            "C5orf28",
            "MTHFD2L",
            "C11orf54",
            "C7orf36",
            "RWDD2A",
            "TGDS",
            "C2orf64",
            "C20orf111",
            "PCDHGC3",
            "FASTKD3",
            "NFIC",
            "IFT46",
            "MTRF1",
            "ZNF630",
            "ZNF600",
            "MYNN",
            "AMZ2P1",
            "C11orf75",
            "C7orf44",
            "BAG3",
            "TMEM49",
            "MYH9",
            "TMEM218",
            "TUBD1",
            "PRKAG2",
            "NDST1",
            "TIA1",
            "CCDC121",
            "TRPT1",
            "C12orf47",
            "PRPF39",
            "TMEM179B",
            "TAF1D",
            "RNASEH2C",
            "SLC25A14",
            "ZNF799",
            "SDHD",
            "ZNF195",
            "C11orf59",
            "MITD1",
            "DYNC1H1",
            "CCDC76",
            "TUBE1",
            "PIGH",
            "CREBZF",
            "NACC1",
            "LOC285074",
            "CCDC7",
            "LIPT1",
            "NUPL2",
            "ZNF226",
            "DUSP28",
            "ZNF187",
            "WDSUB1",
            "SEC22A",
            "ALG13",
            "HTT",
            "ZRANB2",
            "TMEM216",
            "LOC653566",
            "GNA11",
            "EIF4G1",
            "THAP5",
            "EED",
            "USP45",
            "NR2C1",
            "C7orf64",
            "MRE11A",
            "MED19",
            "TMEM188",
            "FLII",
            "SUFU",
            "ZBED5",
            "IRAK4",
            "CWC15",
            "ABL1",
            "HK1",
            "CCDC82",
            "FAM76B",
            "MIS12",
            "DCTN1",
            "ING3",
            "ADPGK",
            "MAP4",
            "HINFP",
            "CTDP1",
            "MRPS31",
            "UFM1",
            "ORMDL1",
            "HDLBP",
            "GATAD2A",
            "SFRS2B",
            "CEP57",
            "VAMP4",
            "MSL3",
            "DDX24",
            "EIF4H",
            "ATG9A"
        ]
    },
    {
        "golabel": "ANKS1A_regulon_activity",
        "gene": [
            "CDX1",
            "C14orf72",
            "NCRNA00152",
            "LOC541471",
            "COX6B1",
            "GSTO1",
            "SNRPG",
            "PFDN5",
            "LOC150381",
            "FAM162A",
            "CKLF",
            "COX7B",
            "NDUFB1",
            "RALGAPA2",
            "ITPR3",
            "VPS29",
            "USMG5",
            "COMMD1",
            "SELK",
            "SAR1B",
            "OST4",
            "RBX1",
            "FAM22D",
            "DBI",
            "UXT",
            "LRRC16A",
            "KIF13A",
            "NDUFA1",
            "NDUFB4",
            "NOTCH1",
            "COX7C",
            "NDUFB3",
            "C12orf45",
            "PLEKHM3",
            "SARNP",
            "BRPF3",
            "COX17",
            "MRPL22",
            "SRPRB",
            "JARID2",
            "ORMDL2",
            "MSRB2",
            "NDUFA6",
            "PDZD11",
            "DDR1",
            "NDST1",
            "RPL36AL",
            "UHRF1BP1",
            "ARPC3",
            "C15orf24",
            "SEC61B",
            "CISD1",
            "NDUFC1",
            "C4orf27",
            "ZNF318",
            "RNF7",
            "EHMT2",
            "TAF8",
            "ZBTB8OS",
            "KDM1B",
            "HIRA",
            "CUL9",
            "CISD2",
            "AARS2",
            "RAPGEF2",
            "HIVEP1",
            "C6orf106",
            "HTT",
            "BAT2",
            "CREBBP",
            "KIAA0240",
            "ABCF1",
            "MCTS1",
            "DHX16",
            "SRF",
            "BRD2",
            "BAT3",
            "EXOC2",
            "RNF8",
            "TRIM39",
            "C6orf89",
            "FAM40A"
        ]
    },
    {
        "golabel": "ANKS3_regulon_activity",
        "gene": [
            "CACNA1F",
            "TMEM89",
            "TUBB8",
            "MYH7B",
            "PCP2",
            "ESPNP",
            "FAM183B",
            "AMY2B",
            "MYH3",
            "MAPK15",
            "KRTAP5-10",
            "COL9A2",
            "SCNN1D",
            "C1orf223",
            "KRTAP5-8",
            "PALM3",
            "ZDHHC11",
            "HSF4",
            "NCRNA00105",
            "POM121L9P",
            "PHKG1",
            "LOC730668",
            "COL6A4P2",
            "SPTBN5",
            "DNAJB13",
            "CCDC157",
            "UBE2NL",
            "TRIM46",
            "PPIEL",
            "NR2E3",
            "DNHD1",
            "LOC728392",
            "MYO15A",
            "BAIAP3",
            "PRR5-ARHGAP8",
            "UBQLNL",
            "REM2",
            "NPFF",
            "FITM1",
            "FLJ45445",
            "LRRC56",
            "ITGB1BP2",
            "TBC1D3H",
            "NPIPL3",
            "C4orf44",
            "EME2",
            "KATNAL2",
            "TMEM184A",
            "PRR22",
            "GOLGA2B",
            "C16orf93",
            "TBC1D3B",
            "LRP5L",
            "LOC100133161",
            "LOC91316",
            "UCP3",
            "ATG16L2",
            "LOC400752",
            "C6orf164",
            "PMS2L11",
            "LCAT",
            "DNM1P35",
            "DNASE1",
            "LOC100132247",
            "NCRNA00085",
            "ZGLP1",
            "FLJ10661",
            "C22orf36",
            "FAM22F",
            "C1orf213",
            "CORT",
            "LOC349114",
            "NCRNA00174",
            "CSAD",
            "RAB40AL",
            "GOLGA6L9",
            "ARVCF",
            "MAPK8IP3",
            "CCDC64B",
            "TTLL3",
            "CROCC",
            "LOC649330",
            "CROCCL2",
            "REEP3",
            "ABCA7",
            "MICALL2",
            "LOC100132287",
            "KIAA0895L",
            "CDK3",
            "WDR27",
            "CCNL2",
            "LOC100132288",
            "LDLRAD2",
            "LOC143666",
            "CROCCL1",
            "MORF4",
            "LOC100133331",
            "CEMP1",
            "ZNF692",
            "WDR90",
            "CSDAP1",
            "ROM1",
            "C16orf48",
            "PTPLB",
            "MGC3771",
            "INCA1",
            "CHKA",
            "FBF1",
            "TSPYL2",
            "WBP11P1",
            "HIF1A",
            "C11orf61",
            "C14orf129",
            "CCDC84",
            "FAM193B",
            "SGSM2",
            "CDK5RAP3",
            "LOC339047",
            "CTNNAL1",
            "LMF1",
            "WASH7P",
            "ACAP3",
            "NPIP",
            "FAM156A",
            "YPEL3",
            "UNKL",
            "CYB5R4",
            "PGAM4",
            "LUC7L",
            "PKD1",
            "NBR2",
            "NEK8",
            "KIAA0467",
            "TFAM",
            "TNK2",
            "SELO",
            "TAF1C",
            "SFI1",
            "BZW1",
            "THBS3",
            "C21orf2",
            "TUBG2",
            "LOC729020",
            "RAB24",
            "SLC25A45",
            "FCHSD1",
            "SH2B1",
            "ROGDI",
            "DHRS1",
            "TMEM175",
            "CSNK2A1P",
            "HEATR7A",
            "PLEKHH3",
            "HDAC10",
            "ACBD4",
            "LRCH4",
            "ARMC5",
            "LOC100190939",
            "GLUD2",
            "RABEP2",
            "PPIL2",
            "LZTR1",
            "KIAA0495",
            "C9orf41",
            "C17orf65",
            "RECQL5",
            "RHOT2",
            "IKBKG",
            "DMAP1",
            "ZBTB48",
            "RAB10",
            "ISCA1P1",
            "GMFB",
            "POFUT2",
            "SLC38A10",
            "RRN3P3",
            "SLC30A6",
            "MYST1",
            "FAM45B",
            "HSPA8",
            "KPNA3",
            "CCS",
            "RB1",
            "DR1",
            "COPS2",
            "C12orf5",
            "PCGF3",
            "CHMP2B",
            "IPO11",
            "FLYWCH1",
            "CCNI",
            "JMJD5",
            "ATG4B",
            "RAP1GDS1",
            "E4F1",
            "PPP4R2",
            "PPP2R5E",
            "MOBKL1B",
            "SRP72",
            "EIF2S1",
            "KPNA4",
            "ARL5A",
            "C17orf70",
            "VMAC",
            "TNPO1",
            "LUZP6",
            "EIF4E",
            "EXOC5",
            "M6PR",
            "GDI2",
            "CTDSPL2",
            "TSC2",
            "PRR14",
            "C9orf80",
            "MCFD2",
            "ZBTB17",
            "ZBTB6",
            "ROD1",
            "VPS4B",
            "ZNF500",
            "PHF1",
            "VPS26A",
            "USP38",
            "PLEKHB2",
            "COPB1",
            "RAD23B",
            "FBXO28",
            "EAF1",
            "RBM18",
            "YME1L1",
            "ZNF800",
            "C10orf119",
            "PPP3R1",
            "HIATL1",
            "SPTLC1",
            "CAPRIN1",
            "SMEK2",
            "UBQLN1",
            "DYNC1I2",
            "DYNC1LI1"
        ]
    },
    {
        "golabel": "APC_regulon_activity",
        "gene": [
            "PREX2",
            "BIK",
            "C4orf48",
            "SPRY4",
            "PCDHGA6",
            "COMTD1",
            "HES4",
            "TCTEX1D2",
            "CDKL5",
            "ST20",
            "IL6ST",
            "MCC",
            "MAST4",
            "ITPR2",
            "C7orf47",
            "CYFIP2",
            "YDJC",
            "SERINC5",
            "PSMG3",
            "ZNHIT1",
            "MAD2L2",
            "SLC25A10",
            "PSMB3",
            "DTYMK",
            "POP7",
            "RAPGEF6",
            "SIVA1",
            "ZNF593",
            "PYCRL",
            "ANAPC11",
            "SCAND1",
            "HEBP2",
            "MRPL12",
            "MED10",
            "C5orf53",
            "PDRG1",
            "MYO9A",
            "TTBK2",
            "FAM128B",
            "RGMB",
            "COL4A3BP",
            "ANKHD1-EIF4EBP3",
            "PIK3R1",
            "LNPEP",
            "C5orf41",
            "SMARCA2",
            "ERAP1",
            "POLR2J",
            "SGK269",
            "C14orf179",
            "MACF1",
            "AURKAIP1",
            "KIAA1109",
            "ARF5",
            "CIDECP",
            "JMY",
            "DTWD2",
            "NDST1",
            "CPEB4",
            "MYCBP2",
            "C1orf122",
            "PPP4C",
            "DHX29",
            "HSD17B4",
            "MARVELD2",
            "C7orf11",
            "PGP",
            "PURA",
            "ZFP106",
            "FAM13B",
            "CHD9",
            "VPS13B",
            "HERC1",
            "RDBP",
            "MYST4",
            "DGUOK",
            "ZC3H13",
            "TRIM23",
            "ANKHD1",
            "DCP2",
            "BDP1",
            "FBXO38",
            "TSEN54",
            "POLK",
            "ATRX",
            "POLH",
            "FBXL17",
            "IQGAP1",
            "KIAA0430",
            "AUP1",
            "PCNX",
            "MTR",
            "GSS",
            "AKAP11",
            "ZNF407",
            "YTHDC2",
            "DMXL1",
            "AFF4",
            "KIAA0240",
            "SEC13",
            "TTC37",
            "MED8",
            "TMEM55B",
            "MPHOSPH8",
            "CEP120",
            "UNC119",
            "SEPT8",
            "SAP30L",
            "NSD1",
            "SETX",
            "SON",
            "USP47",
            "AP3B1",
            "AGGF1",
            "PGGT1B"
        ]
    },
    {
        "golabel": "ARID2_regulon_activity",
        "gene": [
            "HAGHL",
            "PLCB1",
            "HYAL3",
            "BEND7",
            "CCDC85B",
            "VSIG10",
            "GUK1",
            "LCOR",
            "TRIP6",
            "C6orf1",
            "HEATR5A",
            "METRNL",
            "ZNF192",
            "RGS14",
            "ASL",
            "ADAM15",
            "GAA",
            "ZBTB39",
            "NINJ1",
            "YIF1A",
            "TMEM120A",
            "PMVK",
            "TCF7L2",
            "LOC400027",
            "MLL2",
            "WRN",
            "LMNA",
            "RGS19",
            "GXYLT1",
            "STX10",
            "ZNF664",
            "ALG10B",
            "ZNF507",
            "RMND5A",
            "DCAF16",
            "SIPA1",
            "SNAPC2",
            "KLF3",
            "TPST2",
            "CHMP6",
            "ESCO1",
            "MGA",
            "BAZ2B",
            "ZMYM2",
            "STUB1",
            "MON2",
            "FBXO21",
            "MAN1B1",
            "IREB2",
            "SMEK1",
            "DBNL",
            "BMPR1A",
            "C16orf42",
            "SOS1",
            "LOC144438",
            "USP34",
            "C11orf17",
            "TFCP2",
            "SFRS2IP",
            "PPM1B",
            "SP1",
            "FBXO11",
            "PUM2",
            "CTCF"
        ]
    },
    {
        "golabel": "ARID4A_regulon_activity",
        "gene": [
            "PTPN13",
            "NRXN3",
            "GALNT14",
            "STEAP1",
            "ATP8A1",
            "HSF2BP",
            "ITGA9",
            "CDKL1",
            "SNX30",
            "ST3GAL4",
            "LOC541471",
            "UBE2S",
            "SHROOM4",
            "MRPS12",
            "CENPM",
            "ECE2",
            "RPP25",
            "ANKRD44",
            "IL6R",
            "RPS6KA5",
            "ITPR2",
            "MIF",
            "TMSB10",
            "MRPL36",
            "BUD31",
            "CELF2",
            "NME1",
            "ZNF573",
            "SLC25A10",
            "RAPGEF5",
            "PSMB3",
            "ZNF608",
            "BOLA2",
            "FAM161B",
            "DTYMK",
            "POP7",
            "RAPGEF6",
            "RANBP1",
            "C20orf24",
            "SYNE2",
            "NDUFS6",
            "PPP1R13B",
            "ZNF844",
            "TOMM40",
            "KLHDC1",
            "H2AFX",
            "GADD45GIP1",
            "CCT5",
            "RAB11FIP2",
            "MRPL12",
            "DAAM1",
            "UTRN",
            "SCAI",
            "MYO9A",
            "TUBA1C",
            "NUDT1",
            "THOC4",
            "PSMC4",
            "PLOD1",
            "C5orf41",
            "GPR172A",
            "ZNF75D",
            "C14orf101",
            "C20orf194",
            "MOAP1",
            "FAM179B",
            "DDHD1",
            "EIF5A",
            "C19orf24",
            "ZNF441",
            "LSM4",
            "SPTLC2",
            "PSMD14",
            "REV3L",
            "TMEM93",
            "AURKAIP1",
            "KIAA1109",
            "C12orf44",
            "KLF16",
            "EIF5AL1",
            "PTPN4",
            "C11orf24",
            "B4GALT2",
            "SRM",
            "VPS13C",
            "ANGEL1",
            "MYCBP2",
            "C1orf122",
            "PPP4C",
            "TBRG4",
            "SYNJ1",
            "MRPS11",
            "ALG3",
            "SCAPER",
            "CNO",
            "MAP3K1",
            "OBFC2B",
            "FAM13B",
            "CPEB3",
            "CHD9",
            "ZC3H6",
            "HERC1",
            "AP2S1",
            "YKT6",
            "MLF2",
            "METTL11A",
            "RNF126",
            "EIF2C4",
            "ATG2B",
            "ZNF445",
            "ADRM1",
            "TSSC1",
            "SDCCAG1",
            "PHC3",
            "EBNA1BP2",
            "MRPL37",
            "RAPGEF2",
            "IMP4",
            "NOC4L",
            "FBXO34",
            "FTSJ1",
            "BTBD7",
            "PMM2",
            "UBE2M",
            "MAP4K5",
            "POLH",
            "SENP7",
            "SETDB2",
            "GNPTAB",
            "SFRS5",
            "SOS2",
            "PCNX",
            "HM13",
            "MTR",
            "GSS",
            "SH3GL1",
            "UBE2L3",
            "DMXL1",
            "GMPPA",
            "KIAA1737",
            "TNIP2",
            "BRMS1",
            "TPP2",
            "C12orf52",
            "ZNF776",
            "FCHSD2",
            "PREB",
            "SEC13",
            "LRRC59",
            "SNF8",
            "TBCK",
            "UBE2F",
            "MLL5",
            "PSMB2",
            "MPP5",
            "ATXN3",
            "KIAA0831",
            "PIKFYVE",
            "C14orf43",
            "TMED8",
            "MLH3",
            "DCAF5",
            "PPM1G",
            "NEK9",
            "SYNJ2BP",
            "SGTA",
            "PPM1A",
            "PCF11",
            "CFL1",
            "CENPC1",
            "ZBTB1",
            "DDX24",
            "NDST2",
            "KIAA2013",
            "NUMB",
            "ELF2"
        ]
    },
    {
        "golabel": "ARNTL2_regulon_activity",
        "gene": [
            "SH2D5",
            "HMGA2",
            "KLRC3",
            "SERPINB5",
            "IL23A",
            "FAM83B",
            "LAMA3",
            "MFI2",
            "CD70",
            "FOSL1",
            "ASAM",
            "GJB3",
            "LAMC2",
            "MGC87042",
            "GJB2",
            "SEMA7A",
            "C12orf70",
            "C15orf48",
            "GPR115",
            "TMEM171",
            "CACNA2D2",
            "PRDM8",
            "GPC6",
            "E2F7",
            "PCDH7",
            "CD109",
            "PLCD3",
            "GFPT2",
            "SLC2A1",
            "STEAP1",
            "BEND6",
            "IGF2BP2",
            "FERMT1",
            "ANLN",
            "CXCL17",
            "FRMD6",
            "SELENBP1",
            "PLEK2",
            "CLIC6",
            "MAD2L1",
            "TMPRSS2",
            "PRR11",
            "ADAM19",
            "CASC5",
            "GBP1",
            "DLGAP5",
            "HMMR",
            "RAD51AP1",
            "PTAFR",
            "ERO1L",
            "DAPK2",
            "LASS4",
            "KIAA1524",
            "CKAP2L",
            "CCNA2",
            "NCAPG",
            "ARHGAP11A",
            "LOC441869",
            "BCAR3",
            "RRM2",
            "CHADL",
            "EPSTI1",
            "DSG2",
            "KLHDC9",
            "C22orf36",
            "SALL2",
            "RAD51",
            "IRAK2",
            "MXD1",
            "DSE",
            "ADA",
            "PPFIBP1",
            "ECT2",
            "ACSS1",
            "GOLT1B",
            "TMEM125",
            "ZNF238",
            "C11orf52",
            "STK38L",
            "NKX2-1",
            "BICD1",
            "STAT1",
            "MED21",
            "KLHL5",
            "ALG10",
            "AP1S3",
            "C12orf11",
            "ANXA2P2",
            "EFHD2",
            "ELK3",
            "C6orf150",
            "ANXA2",
            "EXPH5",
            "STAMBPL1",
            "FAAH",
            "MAP4K4",
            "PBXIP1",
            "TMEM55A",
            "RAB17",
            "KLHDC5",
            "PGM2",
            "NSUN7",
            "FGFR1OP2",
            "NUAK2",
            "CRTC1",
            "GBE1",
            "DNAJC28",
            "SLC25A42",
            "ERGIC2",
            "TMEM194B",
            "PLIN3",
            "LIMS1",
            "RECQL",
            "NEK8",
            "NCK1",
            "RALB",
            "SLC25A4",
            "RELB",
            "TPM4",
            "AVL9",
            "IPO8",
            "RPS10P7",
            "TCTA",
            "ERLIN1",
            "ROGDI",
            "C1orf198",
            "SLC25A24",
            "CORO1C",
            "VASP",
            "GNRHR2",
            "PAFAH1B2",
            "BSCL2",
            "PDIK1L",
            "NBN",
            "PEBP1",
            "NAB1",
            "SUOX",
            "C12orf4",
            "UBA6",
            "VRK2",
            "RCOR3",
            "MOBKL1B",
            "BIRC2",
            "LUZP6",
            "MAP2K1",
            "M6PR",
            "ACTR3",
            "MED9",
            "ZNF764",
            "AGPS",
            "TMEM57",
            "CAPZA1",
            "ZNF652",
            "ARPC2",
            "ZNF672",
            "CDC27",
            "UBE2Z",
            "ACTR2"
        ]
    },
    {
        "golabel": "ASCC1_regulon_activity",
        "gene": [
            "C20orf199",
            "DDIT4",
            "RSL24D1",
            "HSF2BP",
            "INPP5J",
            "GSTO2",
            "LOC284837",
            "ANO9",
            "LRP5L",
            "LOC100128842",
            "PRDX1",
            "NPM3",
            "C5orf35",
            "LPIN1",
            "CYB5B",
            "ADK",
            "TMEM17",
            "KILLIN",
            "RNLS",
            "FAM175A",
            "C2orf28",
            "PSTK",
            "GIGYF1",
            "USMG5",
            "C10orf78",
            "PIGP",
            "ZNF841",
            "TRUB1",
            "MYO18A",
            "TFAM",
            "OBFC1",
            "PRDX3",
            "PIGF",
            "PPIL3",
            "NUDT5",
            "SNAPC4",
            "C10orf84",
            "RBM6",
            "GBA2",
            "VDAC2",
            "RGS12",
            "ARL3",
            "MRPS18B",
            "SFRS14",
            "CHCHD1",
            "RWDD2B",
            "SEPT10",
            "MRPL43",
            "TYSND1",
            "KDM6B",
            "PIGV",
            "INPP5E",
            "GHITM",
            "DENND4B",
            "ANAPC16",
            "CUTC",
            "TSC1",
            "TMEM85",
            "ZNF160",
            "RALGDS",
            "CDC123",
            "MRPS16",
            "EXOSC1",
            "RBM33",
            "GLUD1",
            "FAM45A",
            "RAB18",
            "KDM4B",
            "VPS26A",
            "TCTN3",
            "DDX50",
            "NXF1",
            "PTEN",
            "XRCC6",
            "ANXA7",
            "ECD",
            "SAR1A",
            "ACTR1A"
        ]
    },
    {
        "golabel": "ASCC3_regulon_activity",
        "gene": [
            "GUCY2D",
            "FLJ45244",
            "SLC27A5",
            "TPBG",
            "C7orf55",
            "MYL5",
            "INCA1",
            "TAOK1",
            "SIRT4",
            "RBL1",
            "NUDT14",
            "CHKB",
            "CDK12",
            "FRK",
            "C6orf167",
            "STXBP5",
            "ACOT1",
            "FAM135A",
            "STRN",
            "MAP3K5",
            "C3orf71",
            "RIF1",
            "PGM3",
            "SETD4",
            "C10orf12",
            "IGF2R",
            "KIAA1919",
            "TMEM30A",
            "PANX1",
            "LATS1",
            "RSF1",
            "OGFOD2",
            "CASP8AP2",
            "USE1",
            "HIVEP2",
            "CCDC12",
            "C5orf51",
            "ZNF691",
            "LOC729991",
            "MED14",
            "WBP1",
            "TEX264",
            "CDK19",
            "NPRL2",
            "IBTK",
            "ACTR1B",
            "RNGTT",
            "TRIP12",
            "SEC63",
            "FBXL4",
            "MAP3K7",
            "SLC30A7",
            "SMARCA5",
            "TAB2",
            "EXOC2",
            "GOPC",
            "SYNCRIP",
            "BCLAF1"
        ]
    },
    {
        "golabel": "ASH1L_regulon_activity",
        "gene": [
            "LGALS1",
            "CDX1",
            "NBEA",
            "C1orf111",
            "LOC387646",
            "LOC541471",
            "NOS1AP",
            "LOC641298",
            "GSTO1",
            "STXBP1",
            "NME1-NME2",
            "ATP11A",
            "TAF1L",
            "PRKCDBP",
            "CHCHD2",
            "FAM176B",
            "CDC42BPA",
            "NBEAL1",
            "NUDT2",
            "IL6R",
            "TMSB10",
            "NBPF10",
            "RALGAPA2",
            "LOC100270710",
            "H2AFJ",
            "KIAA1958",
            "WDR31",
            "FAM58A",
            "SHANK2",
            "SH3BGRL3",
            "GLA",
            "SOCS7",
            "BTBD9",
            "PSMB3",
            "CADPS2",
            "SLC41A1",
            "ANKRD36BP1",
            "GADD45GIP1",
            "ARHGEF2",
            "MTP18",
            "MYL6",
            "ZNF91",
            "MYO9A",
            "ETV3",
            "RBX1",
            "PARVB",
            "PHF5A",
            "MED13L",
            "RRP7A",
            "GABPB2",
            "PLEKHM3",
            "BRPF3",
            "KIF16B",
            "SF3B5",
            "DRAP1",
            "ERCC6",
            "LOC100129034",
            "PSMB1",
            "BCOR",
            "FUCA2",
            "C12orf10",
            "ATOX1",
            "SCAPER",
            "INADL",
            "ELK4",
            "PDE4DIP",
            "ZNF37A",
            "ZNF275",
            "ZNF318",
            "AP2S1",
            "C17orf79",
            "OTUD7B",
            "MLL3",
            "MYST4",
            "C1orf212",
            "KDM5B",
            "ARNT",
            "GON4L",
            "ANKHD1",
            "RNF169",
            "RPRD2",
            "HIVEP1",
            "ATRX",
            "PSMD13",
            "GATAD2B",
            "UBR3",
            "TRIP11",
            "DSTYK",
            "NR2C2",
            "ADAR",
            "SNX27",
            "ARHGEF12",
            "SNX11",
            "BPTF",
            "TAF1",
            "CREBBP",
            "BAT2L2",
            "ARPC4",
            "ZBTB44",
            "KIAA0240",
            "ZNF776",
            "KIDINS220",
            "HYAL2",
            "TWF2",
            "TTC17",
            "MLL5",
            "C3orf75",
            "DCAF6",
            "RHOG",
            "SNX17",
            "PFN1",
            "ACOT9",
            "PHF2",
            "KLHL20",
            "NFX1",
            "CEP350",
            "ARID4B",
            "RABGAP1",
            "EPC1",
            "SHISA5",
            "MKLN1",
            "EPC2",
            "ZC3H7A",
            "STAT3",
            "KDM3B",
            "GIGYF2",
            "FAM32A",
            "AFTPH",
            "RNF20",
            "PUM1",
            "PUM2"
        ]
    },
    {
        "golabel": "ATF1_regulon_activity",
        "gene": [
            "HAL",
            "CPE",
            "RASSF9",
            "PDE4D",
            "TTC39C",
            "C14orf147",
            "C1orf170",
            "LGALS9",
            "NXT2",
            "GOLT1B",
            "MICALL2",
            "PTP4A1",
            "RFK",
            "POC1B",
            "GLCE",
            "C6orf162",
            "SLC38A2",
            "EGLN1",
            "ERGIC2",
            "CCM2",
            "STRAP",
            "AHDC1",
            "CCNC",
            "ATE1",
            "TRUB1",
            "TBC1D15",
            "TFAM",
            "ARHGEF10L",
            "PYROXD1",
            "TWF1",
            "CHMP1B",
            "SLC44A1",
            "PLEKHA1",
            "TCEAL6",
            "C12orf66",
            "RCN2",
            "PCGF5",
            "DHRS1",
            "SLC12A9",
            "BMI1",
            "AEBP2",
            "TMED2",
            "PUS7L",
            "ARFRP1",
            "DEF6",
            "TCEAL3",
            "C1D",
            "FAM18B",
            "DAPK3",
            "TOMM20",
            "TSNAX",
            "STK11",
            "BBS10",
            "TELO2",
            "COG6",
            "OGFR",
            "LOC729082",
            "CRAT",
            "MOBKL3",
            "PPP2R5B",
            "C12orf26",
            "CLCN7",
            "SIPA1",
            "THAP1",
            "SLC33A1",
            "EVI5L",
            "YAF2",
            "PCSK7",
            "COPS2",
            "AGAP3",
            "NDUFS1",
            "PKN2",
            "MIER2",
            "URGCP",
            "CC2D1A",
            "RBM7",
            "ARL5A",
            "C17orf70",
            "TMED7",
            "NCDN",
            "OSBPL8",
            "GRINL1A",
            "LARP4",
            "MIER3",
            "NECAP1",
            "HDGFRP2",
            "GFM2",
            "VAC14",
            "AP1AR",
            "PFKL",
            "SSR1",
            "RNF41",
            "AMPD2",
            "FEM1B",
            "MORF4L1",
            "PCBP2",
            "YTHDF3",
            "PPP1R9B",
            "TMBIM6",
            "SHOC2",
            "KCTD2",
            "MAP3K11",
            "UBE2G1",
            "INTS6",
            "EML3",
            "XAB2",
            "AP1B1",
            "ARPP19",
            "AP1M1",
            "PPP3CB",
            "EXOC7",
            "DAZAP2",
            "TIAL1",
            "MARCH7",
            "ZNF143",
            "UBXN4"
        ]
    },
    {
        "golabel": "ATF2_regulon_activity",
        "gene": [
            "DCST2",
            "LMTK2",
            "LOC91450",
            "NPFF",
            "NPIPL3",
            "GSR",
            "FLJ45244",
            "SNURF",
            "PRR22",
            "CRYGS",
            "LAMB2L",
            "LRP12",
            "STARD4",
            "UBXN11",
            "CLTB",
            "CXADR",
            "IRF7",
            "C12orf49",
            "ZNF69",
            "FAM193B",
            "C20orf177",
            "MGAT4A",
            "FAM156A",
            "LOC150786",
            "MSI2",
            "GTF2A1",
            "ZKSCAN3",
            "ATE1",
            "TTC30A",
            "ZNF678",
            "PLK3",
            "MANEA",
            "SLC25A40",
            "SSBP4",
            "LOC100134713",
            "FICD",
            "TTC30B",
            "SLC35F5",
            "YIPF6",
            "APOOL",
            "ARFRP1",
            "TRIM37",
            "C1orf58",
            "GLUD2",
            "QTRT1",
            "MAPK8",
            "KIAA1715",
            "ZNF414",
            "WRN",
            "CHM",
            "CRY1",
            "MFSD9",
            "STT3B",
            "SEC23B",
            "DYM",
            "PPP1R2P3",
            "SLC33A1",
            "TM9SF2",
            "UGGT1",
            "EIF2AK3",
            "GMCL1",
            "PLBD2",
            "UEVLD",
            "WDSUB1",
            "CCNI",
            "UBR3",
            "NDUFS1",
            "TMED10P1",
            "MOBKL1B",
            "IPP",
            "TCF12",
            "ARL5A",
            "RNF115",
            "RSPRY1",
            "RCBTB1",
            "SNX12",
            "CHUK",
            "XRN2",
            "NCKAP1",
            "RBBP5",
            "SCRN3",
            "U2AF1",
            "RAB6A",
            "GTF3C3",
            "FBXL4",
            "PLEKHB2",
            "COPB1",
            "SLC25A28",
            "DUS2L",
            "RHBDD1",
            "CRK",
            "SPTY2D1",
            "CDK9",
            "MTMR14",
            "SEPT2",
            "EIF4G2",
            "DYNC1I2",
            "SP3",
            "UBXN4"
        ]
    },
    {
        "golabel": "ATF4_regulon_activity",
        "gene": [
            "FAM83F",
            "PHGDH",
            "CBX2",
            "ASNS",
            "PSAT1",
            "CBS",
            "CHAC1",
            "SNHG6",
            "SCARNA12",
            "ICAM1",
            "SNHG1",
            "FKBP11",
            "PER3",
            "SNHG3",
            "FNIP2",
            "NOL12",
            "KIAA0114",
            "MAGI3",
            "CHCHD10",
            "MAP3K13",
            "GALNT10",
            "SHMT2",
            "SNHG8",
            "MAML2",
            "HIP1",
            "IDI2",
            "PPL",
            "C19orf48",
            "XBP1",
            "PPPDE2",
            "MPST",
            "TOMM22",
            "FAM161B",
            "LOC388796",
            "SDF2L1",
            "PPIB",
            "DOCK9",
            "PICK1",
            "PTS",
            "RPS24",
            "ZFP36L1",
            "NOTCH2",
            "CRELD2",
            "PIM3",
            "MTP18",
            "NDUFA9",
            "DDT",
            "CSNK1E",
            "ALKBH2",
            "RBX1",
            "ERP29",
            "ADSL",
            "AHDC1",
            "MARS",
            "XPNPEP3",
            "PCK2",
            "KLHDC10",
            "PUS1",
            "CNPY2",
            "SMUG1",
            "RPS19BP1",
            "C12orf73",
            "SLC3A2",
            "RHBDD3",
            "ANKRD54",
            "MANF",
            "RRP7A",
            "RPL3",
            "UQCRB",
            "C12orf44",
            "TRMU",
            "NOP56",
            "SELS",
            "CAPN2",
            "PTDSS2",
            "RPL6",
            "SEC61B",
            "OBFC2B",
            "C11orf10",
            "KLF11",
            "RRAGC",
            "NAT9",
            "TRABD",
            "NACAP1",
            "RAB11FIP5",
            "NACA",
            "DYNLL1",
            "UBE2L3",
            "COPZ1",
            "TAB1",
            "PREB",
            "ANAPC7",
            "CARS",
            "NHP2L1",
            "MPP5",
            "MCRS1",
            "PES1",
            "FEZ2",
            "RNF187",
            "YARS",
            "SRP19",
            "METTL14"
        ]
    },
    {
        "golabel": "ATF7_regulon_activity",
        "gene": [
            "SECISBP2L",
            "RLN2",
            "RPS2P32",
            "GINS2",
            "RELL2",
            "KLF1",
            "C5orf55",
            "AQP11",
            "NBEAL1",
            "ATP2B4",
            "PPIL5",
            "RNASEH2A",
            "TNS1",
            "POC1A",
            "PHYH",
            "FGD4",
            "C18orf18",
            "EPAS1",
            "HPRT1",
            "RPA3",
            "DTYMK",
            "ERBB3",
            "H2AFZ",
            "ACVR1B",
            "MED13L",
            "DSN1",
            "DUSP16",
            "CALCOCO1",
            "HAUS8",
            "DRAP1",
            "LSM5",
            "C20orf27",
            "SLC25A19",
            "ZMIZ1",
            "RBMS2",
            "DNMBP",
            "TCF7L2",
            "TBRG4",
            "NFATC3",
            "C1orf52",
            "NCOR1",
            "MRPL4",
            "MYST4",
            "FOXP1",
            "KTI12",
            "RAPGEF2",
            "RREB1",
            "EIF4B",
            "ARHGEF12",
            "KIAA0430",
            "DDX56",
            "R3HDM2",
            "KIAA0240",
            "TMEM55B",
            "FOXJ2",
            "STAT3",
            "SP1",
            "RAB5B",
            "SEC31A",
            "UBE3B"
        ]
    },
    {
        "golabel": "ATF7IP_regulon_activity",
        "gene": [
            "C17orf61",
            "DPM3",
            "KIAA1467",
            "NFATC2",
            "NUDT6",
            "TOMM6",
            "C12orf35",
            "ZNF462",
            "ENDOG",
            "TAOK1",
            "BRWD3",
            "UBXN7",
            "SERF2",
            "HSD11B1L",
            "HTR7P1",
            "FAM165B",
            "SBNO1",
            "C11orf51",
            "FBXL15",
            "RIF1",
            "ASXL2",
            "C14orf179",
            "MGST3",
            "REST",
            "FLOT1",
            "TMEM134",
            "NCRNA00081",
            "NDUFB8",
            "CHCHD1",
            "MRPL43",
            "C1orf66",
            "DIP2B",
            "SSH1",
            "KDM5A",
            "CUTA",
            "C21orf59",
            "RFX7",
            "STK19",
            "CHD4",
            "VPRBP"
        ]
    },
    {
        "golabel": "ATMIN_regulon_activity",
        "gene": [
            "GCSH",
            "ZGLP1",
            "UBXN11",
            "GAN",
            "TNFRSF14",
            "P2RY11",
            "CENPN",
            "KIAA1609",
            "HMHA1",
            "C16orf46",
            "SFI1",
            "MPHOSPH6",
            "ABTB1",
            "QTRT1",
            "CCDC130",
            "ZBTB48",
            "ADAT1",
            "NIP7",
            "PLEKHJ1",
            "C19orf6",
            "MAP1LC3B2",
            "RFWD3",
            "CENPBD1",
            "RSPRY1",
            "ZFP1",
            "RALGDS",
            "MAP1LC3B",
            "FAM131A",
            "COX4NB",
            "LONP2",
            "TYK2",
            "PSMD7",
            "CAMSAP1L1",
            "CIRH1A",
            "MON1B",
            "GLG1",
            "SF3B3",
            "KARS",
            "USP10",
            "MBTPS1",
            "VPS35",
            "NUDT21",
            "DDX19A",
            "CBFB",
            "AP1G1",
            "TERF2",
            "KIAA0174",
            "CTCF"
        ]
    },
    {
        "golabel": "ATOH8_regulon_activity",
        "gene": [
            "PLA2G10",
            "AQP7",
            "CACNA2D2",
            "AFF3",
            "RASD1",
            "SFTPB",
            "KLF15",
            "TACC2",
            "GPR133",
            "AQP3",
            "MAOA",
            "TFCP2L1",
            "ID1",
            "GADD45G",
            "IRX3",
            "PDE4D",
            "AHCYL2",
            "PARM1",
            "ALDH3B1",
            "RHOBTB2",
            "C8orf4",
            "DEPDC1B",
            "CENPI",
            "DLGAP5",
            "KIAA1524",
            "CKAP2L",
            "C11orf82",
            "CCNA2",
            "PRKCZ",
            "NCAPH",
            "BUB1",
            "KIF4A",
            "ST3GAL5",
            "CENPK",
            "RRM2",
            "TOB1",
            "MLPH",
            "GPRC5C",
            "FANCB",
            "TBC1D2",
            "GPR39",
            "PLK4",
            "PER1",
            "RHOB",
            "RFTN1",
            "NEDD4L",
            "RPH3AL",
            "ST6GALNAC4",
            "STIL",
            "CISH",
            "PHF17",
            "BAG1",
            "FRAT1",
            "TRIM59",
            "EPAS1",
            "ARRB1",
            "TMEM150A",
            "LIMD1",
            "PIM3",
            "AVL9",
            "ZFAND5",
            "SLC25A20",
            "TBCCD1",
            "GLT25D1",
            "VAMP2",
            "ZNF267",
            "LUZP6",
            "SEPT7"
        ]
    },
    {
        "golabel": "ATRX_regulon_activity",
        "gene": [
            "C10orf125",
            "SORL1",
            "PARD3B",
            "MRPS12",
            "PSENEN",
            "ST20",
            "POLR2I",
            "ITPR2",
            "MRPL41",
            "NDUFA11",
            "ARSD",
            "PSD3",
            "BID",
            "MAGEE1",
            "FAM120C",
            "BOLA2",
            "ATP6V0B",
            "SDHAF1",
            "NDUFB7",
            "DISC1",
            "LSM7",
            "TRAPPC5",
            "GADD45GIP1",
            "ILVBL",
            "C9orf89",
            "GPX4",
            "NOSIP",
            "C9orf16",
            "YIF1B",
            "TRIM44",
            "FAM100B",
            "LSM4",
            "C17orf106",
            "REV3L",
            "KIAA1109",
            "MRPL2",
            "APOOL",
            "ZDHHC12",
            "ATP7A",
            "GIPC1",
            "RPS6KA3",
            "SSNA1",
            "ARHGAP5",
            "VPS13C",
            "ASH1L",
            "TAF9B",
            "SIRT7",
            "ZXDA",
            "PSMB7",
            "COPE",
            "ANKRD12",
            "CHIC1",
            "CHM",
            "CHD9",
            "ZNF275",
            "EEA1",
            "RDBP",
            "METTL11A",
            "MIIP",
            "MPV17L2",
            "MRPL38",
            "LOC729991",
            "SIRT6",
            "HUWE1",
            "HMG20B",
            "UBR3",
            "BOD1L",
            "APC",
            "ARHGEF12",
            "ASB13",
            "KIAA2018",
            "TIMM44",
            "GSS",
            "TAF1",
            "ORAI1",
            "MBD5",
            "WDFY3",
            "KIDINS220",
            "MAN1B1",
            "GNL3L",
            "YLPM1",
            "USP9X",
            "RANBP2",
            "UBAC1",
            "C19orf62",
            "TAB3",
            "C19orf43",
            "TOP2B",
            "ARMCX3",
            "BIRC6",
            "PBRM1",
            "ZBTB33",
            "RNF25",
            "PIK3C2A",
            "RAD23A",
            "TMEM203",
            "STAG2",
            "USP47",
            "CTR9",
            "XIAP",
            "DDX3X",
            "RLIM",
            "HNRNPH2",
            "C4orf41",
            "C19orf50",
            "DDX6"
        ]
    },
    {
        "golabel": "ATXN7_regulon_activity",
        "gene": [
            "QPCT",
            "LOC728875",
            "FKBP1B",
            "HOXB7",
            "RNF133",
            "BIK",
            "CIB2",
            "IKZF3",
            "COX6B1",
            "PAG1",
            "SNRPG",
            "PLCH1",
            "MRPS12",
            "RNPC3",
            "RNF19A",
            "NXT1",
            "ANKRD44",
            "C6orf129",
            "LIPT2",
            "IL6R",
            "LMOD3",
            "SYNE1",
            "ITPR2",
            "TBC1D7",
            "MIF",
            "COX7A2",
            "MRPL52",
            "MYEOV2",
            "PEMT",
            "POMP",
            "HSBP1",
            "PRICKLE2",
            "DTYMK",
            "SEPHS2",
            "SNRPB",
            "BOLA3",
            "DHRSX",
            "MTP18",
            "HEBP2",
            "NDUFA9",
            "PTMS",
            "PSMD8",
            "EDEM1",
            "AKNA",
            "PSMB5",
            "ADSL",
            "RAPH1",
            "C14orf156",
            "PHF5A",
            "C16orf61",
            "TRANK1",
            "DCTN2",
            "RPS19BP1",
            "RPP21",
            "NOSIP",
            "UBE2E3",
            "ATP5G3",
            "UCHL3",
            "PSMA7",
            "C14orf153",
            "FAM195B",
            "LYST",
            "PSMB6",
            "PSMD14",
            "TMEM93",
            "SF3B5",
            "UBL4A",
            "MAGED2",
            "PARP14",
            "BCL6",
            "MRPL51",
            "DAD1",
            "C19orf63",
            "UFD1L",
            "FYCO1",
            "PSMB1",
            "BANF1",
            "SYNJ1",
            "C14orf109",
            "MRPS11",
            "CECR5",
            "TP53RK",
            "EIF2B2",
            "NUTF2",
            "MRPL18",
            "RDH11",
            "HSD17B10",
            "MLL3",
            "GOLGA4",
            "PIGH",
            "DENND4C",
            "MCL1",
            "ZBTB43",
            "GTF3C6",
            "NSDHL",
            "PHC3",
            "RAPGEF2",
            "ANKRD13A",
            "USP25",
            "VPS25",
            "NR2C2",
            "CHD2",
            "ZNF264",
            "DYNLL1",
            "ZFYVE20",
            "SLC25A11",
            "ANKRD28",
            "GOT2",
            "MED19",
            "HELZ",
            "UBAC2",
            "ITSN2",
            "COX4NB",
            "GLRX5",
            "PSMD7",
            "TMEM55B",
            "COPS7A",
            "DDOST",
            "R3HCC1",
            "ZNF654",
            "TMF1",
            "MAP4",
            "OTUD4",
            "TM9SF1",
            "MKLN1",
            "TIMM22",
            "H2AFY",
            "VPRBP",
            "C3orf63",
            "C20orf43",
            "USP4"
        ]
    },
    {
        "golabel": "BACH1_regulon_activity",
        "gene": [
            "NCRNA00189",
            "VGLL3",
            "ASAM",
            "GREM1",
            "SLC2A14",
            "CD109",
            "HSF4",
            "GADD45G",
            "IRX3",
            "DFNA5",
            "GPR176",
            "IRX5",
            "TMEM105",
            "C3orf59",
            "PTAFR",
            "PTP4A3",
            "EFCAB2",
            "FBXL8",
            "MOBKL2B",
            "AKAP5",
            "KLHDC9",
            "HDGFRP3",
            "TMCC3",
            "DSE",
            "FAM195A",
            "PLXNC1",
            "CDK2AP2",
            "TMEM125",
            "FHIT",
            "RNF208",
            "SNHG7",
            "NKX2-1",
            "BICD1",
            "ZNF692",
            "C8orf55",
            "ABHD14A",
            "KLHL5",
            "TLR1",
            "SEPT11",
            "PHPT1",
            "ITGAV",
            "TM7SF2",
            "ELK3",
            "C5orf45",
            "ENDOG",
            "MGC70857",
            "UACA",
            "NUDT14",
            "HSPA13",
            "BMP2K",
            "GNB4",
            "SKAP2",
            "NME3",
            "HS2ST1",
            "TMEM9",
            "PGM2",
            "NPC1",
            "SLC30A4",
            "C16orf13",
            "RAB40C",
            "STXBP5",
            "RAB8B",
            "ASAP1",
            "APBB2",
            "RAB23",
            "LIMS1",
            "RECQL",
            "STRN",
            "CLIC4",
            "ADAM17",
            "EEF1D",
            "LRRC27",
            "C1orf103",
            "DDRGK1",
            "C14orf79",
            "DPM2",
            "MMAB",
            "SLC25A24",
            "APP",
            "TMEM134",
            "DCUN1D1",
            "LUZP1",
            "CCNYL1",
            "ADAM10",
            "QTRT1",
            "ESRRA",
            "FAM73A",
            "MVK",
            "BSCL2",
            "CYHR1",
            "NRAS",
            "ITSN1",
            "HAGH",
            "HPS5",
            "P4HTM",
            "BRF1",
            "C1orf35",
            "RRAGC",
            "NAB1",
            "PIK3CA",
            "ANO6",
            "BBX",
            "UBE2D1",
            "TNPO1",
            "LUZP6",
            "OSBPL8",
            "C2orf69",
            "PAK2",
            "CSGALNACT2",
            "NDUFV1",
            "CTTNBP2NL",
            "BMPR2",
            "PYCR2",
            "DNAJC13",
            "GNA13",
            "WDFY1",
            "RMND5B",
            "R3HCC1",
            "RNGTT",
            "AGPS",
            "NUS1",
            "MAP3K7",
            "GABPA",
            "KIAA1033",
            "CDK17",
            "ZNF672",
            "PICALM",
            "CDC27",
            "MORC3",
            "TMEM127",
            "ACTR2"
        ]
    },
    {
        "golabel": "BACH2_regulon_activity",
        "gene": [
            "ZNF521",
            "TSHZ2",
            "SMO",
            "FBLN1",
            "IRX5",
            "IGDCC4",
            "CLIP3",
            "ZCCHC18",
            "LSAMP",
            "PIP5KL1",
            "DST",
            "GPR161",
            "SFTA3",
            "PDZRN3",
            "TCF4",
            "EFNA1",
            "RPL8",
            "MICAL3",
            "PGAP1",
            "TCF7",
            "SEPT11",
            "C1orf210",
            "TBC1D1",
            "EPB41L2",
            "ASAP1",
            "TBC1D4",
            "C1orf43",
            "FBXO10",
            "MARCKS",
            "DPM2",
            "ROBLD3",
            "PCBD1",
            "LUZP1",
            "ESRRA",
            "TTL",
            "TMEM111",
            "HIVEP2",
            "NIN",
            "ZNF292",
            "ZNF624",
            "HECA",
            "NCK2",
            "PYCR2",
            "MLX",
            "ARF1"
        ]
    },
    {
        "golabel": "BAG1_regulon_activity",
        "gene": [
            "ASPG",
            "CBR1",
            "MSLNL",
            "PLA2G10",
            "MSLN",
            "CATSPERB",
            "S100P",
            "SLC7A2",
            "TESC",
            "AQP7",
            "C14orf184",
            "MAP7D2",
            "ATOH8",
            "RASD1",
            "DUSP4",
            "FXYD3",
            "AGR2",
            "CKMT1B",
            "TACC2",
            "CAPN5",
            "SPDEF",
            "AQP3",
            "IRS2",
            "ID1",
            "C9orf152",
            "ADSSL1",
            "PDE4D",
            "AVPI1",
            "EPHB2",
            "AHCYL2",
            "SIK1",
            "C8orf4",
            "MECOM",
            "FAM46A",
            "C19orf21",
            "SLC9A7",
            "ATP1B1",
            "KIF7",
            "SCNN1A",
            "TSC22D2",
            "TC2N",
            "LPAR1",
            "ARSJ",
            "TBC1D2",
            "SPIRE2",
            "ETNK2",
            "HERC5",
            "RORC",
            "STARD10",
            "FKBP11",
            "RPH3AL",
            "UNC13B",
            "GDF11",
            "KLF5",
            "MMD",
            "CDK2AP2",
            "RFK",
            "TRPC1",
            "KCNK1",
            "SNHG8",
            "HDX",
            "CREB3L4",
            "GSTP1",
            "TRIO",
            "SEPT11",
            "PHPT1",
            "FRAT1",
            "CHP",
            "FAM107B",
            "AIFM2",
            "FIGNL1",
            "CMTM3",
            "TTYH3",
            "IDS",
            "ELL3",
            "HIVEP3",
            "FAAH2",
            "MCEE",
            "FRAT2",
            "ATP8B2",
            "APOBEC3F",
            "LIMK1",
            "PIM3",
            "TRAF2",
            "NANS",
            "TPST1",
            "KDELC2",
            "RAB3D",
            "SEMA4F",
            "PHF19",
            "DNMT1",
            "SUCLG2",
            "C9orf23",
            "EML4",
            "ZNF33B",
            "APP",
            "VAPA",
            "SELS",
            "SLC25A20",
            "CHMP5",
            "FBXW5",
            "DNAJC1",
            "AUH",
            "ITSN1",
            "SEC61B",
            "CLSTN1",
            "EDF1",
            "ANAPC16",
            "SEC23B",
            "FPGS",
            "INTS10",
            "AK3",
            "DCTN6",
            "ARL13B",
            "ARFIP2",
            "PHF13",
            "DUSP22",
            "C1orf216",
            "MTIF3",
            "C9orf156",
            "NFX1",
            "SEPT7",
            "SECISBP2",
            "QARS",
            "EFTUD2",
            "PPP1R11"
        ]
    },
    {
        "golabel": "BATF_regulon_activity",
        "gene": [
            "IFI27L2",
            "EBI3",
            "LOC606724",
            "PSTPIP1",
            "HLA-F",
            "CARD16",
            "KIAA1958",
            "PSMB10",
            "PSMB8",
            "HLA-A",
            "TYMP",
            "TMEM149",
            "NFKBIE",
            "C16orf7",
            "LRP6",
            "POLD4",
            "FAM117B",
            "DRAP1",
            "TRADD",
            "IKBKG",
            "ATOX1",
            "OGFR",
            "MTMR12",
            "MYST4",
            "KDM1B",
            "SIPA1",
            "SMARCC1",
            "NDUFS7",
            "SIRT6",
            "ARHGAP19",
            "BPTF",
            "VAC14",
            "FBXO21",
            "CSNK1G1",
            "PBRM1",
            "RHOG",
            "USP34",
            "DCP1A",
            "UBE3A",
            "VPRBP",
            "BCLAF1",
            "SF3A1",
            "MAX",
            "PUM1",
            "RBM12"
        ]
    },
    {
        "golabel": "BATF3_regulon_activity",
        "gene": [
            "THEG",
            "S100A5",
            "SLC34A1",
            "CATSPER1",
            "TNNT1",
            "AIM2",
            "CST6",
            "CRABP2",
            "SPTB",
            "WFDC10B",
            "CD274",
            "MYO1G",
            "TNFRSF9",
            "PDLIM4",
            "BEND6",
            "PMAIP1",
            "GLS",
            "C9orf152",
            "SORBS2",
            "CA11",
            "ST6GALNAC1",
            "FAM126A",
            "UPP1",
            "PSMB9",
            "LOC541471",
            "ASAP2",
            "SLC22A23",
            "C1orf115",
            "C7orf40",
            "DPY19L1",
            "IL32",
            "RNF19A",
            "PBX1",
            "BEND7",
            "ABLIM1",
            "CCDC109B",
            "RGS10",
            "S100A10",
            "FLJ36031",
            "SHANK2",
            "MYH14",
            "C9orf46",
            "CMTM3",
            "PSMB8",
            "HSD3B7",
            "BET1",
            "PLEKHO1",
            "GPR56",
            "SH3BP4",
            "SYNE2",
            "LHFPL2",
            "CASZ1",
            "PER2",
            "TMEM181",
            "PSME2",
            "CCM2",
            "MAML3",
            "KIAA1671",
            "LYN",
            "C9orf21",
            "CDC34",
            "ATRN",
            "TSPAN17",
            "GFOD2",
            "KLF3",
            "OAZ1",
            "ZCCHC7",
            "ZNF267",
            "SNX33",
            "ABCF2",
            "DIS3L",
            "RNF34",
            "STAT3",
            "MBTPS1",
            "USP47",
            "SNX1",
            "RAB5B",
            "SIN3A",
            "SLTM"
        ]
    },
    {
        "golabel": "BAZ2A_regulon_activity",
        "gene": [
            "DENND5B",
            "C1QTNF2",
            "ARID3A",
            "C6orf225",
            "DSP",
            "SH3BGR",
            "GPR157",
            "CCT6B",
            "COX7A1",
            "NUP210",
            "HELB",
            "NUDT6",
            "LCOR",
            "FBXO4",
            "TAOK1",
            "C8orf40",
            "RFESD",
            "TMEM194A",
            "TSPAN6",
            "TCEAL1",
            "ATP5O",
            "BDH2",
            "LOC401397",
            "C11orf74",
            "FKBP7",
            "ZBTB39",
            "TMPPE",
            "COMMD6",
            "C11orf67",
            "THYN1",
            "HADH",
            "RPL23AP82",
            "SRR",
            "ANKRD52",
            "MLL2",
            "DIP2B",
            "C1orf50",
            "C4orf27",
            "STAT2",
            "ATP2A2",
            "RNASEH2B",
            "CUTA",
            "RREB1",
            "TPMT",
            "EP400",
            "RPA2",
            "NCOA6",
            "C19orf42",
            "LARP4",
            "R3HDM2",
            "COMMD9",
            "MON2",
            "SMARCC2",
            "ARF3",
            "BIRC6",
            "CS",
            "KDM3A",
            "RSU1",
            "SFRS2IP",
            "KDM2A",
            "SP1",
            "DNAJC14"
        ]
    },
    {
        "golabel": "BBX_regulon_activity",
        "gene": [
            "SLC16A1",
            "ITGA6",
            "SRPK3",
            "RHBDL1",
            "SFTA2",
            "FIGN",
            "SMPDL3B",
            "MAGIX",
            "B3GNT8",
            "SAMD9",
            "EGFL7",
            "CHADL",
            "DENND2C",
            "PMM1",
            "CDCP1",
            "SLC39A4",
            "HDGFRP3",
            "SAMD9L",
            "NUDT8",
            "LY75",
            "DCXR",
            "TRPS1",
            "ACAP2",
            "MAP7D3",
            "ADCK5",
            "ASPSCR1",
            "TLCD1",
            "EFNA1",
            "AGPAT2",
            "CDK2AP2",
            "RNF168",
            "ZDBF2",
            "C7orf55",
            "PLCXD2",
            "LOC344595",
            "ZBTB20",
            "TRERF1",
            "TM7SF2",
            "ENDOG",
            "FN3K",
            "NTHL1",
            "ELL3",
            "RANGRF",
            "NUDT14",
            "TMEM150A",
            "UBXN7",
            "RILP",
            "CEP97",
            "FLNB",
            "ATP13A3",
            "NRL",
            "NUDT16L1",
            "APOA1BP",
            "BPHL",
            "TOPBP1",
            "ATP10D",
            "L3MBTL3",
            "ACOT1",
            "RECQL",
            "SIGIRR",
            "RC3H2",
            "IPO8",
            "BCAT2",
            "RIF1",
            "ASXL2",
            "REST",
            "TP53I13",
            "CRYBG3",
            "RPAIN",
            "ATP2C1",
            "PMF1",
            "MPDU1",
            "MED11",
            "ATP11B",
            "FNDC3B",
            "FDX1L",
            "PMVK",
            "BACH1",
            "C19orf63",
            "SPATA2L",
            "BSCL2",
            "PTDSS2",
            "TMEM179B",
            "ANKRD16",
            "CASP8AP2",
            "CHIC1",
            "OPA1",
            "BTBD6",
            "ZDHHC16",
            "STAG1",
            "LOC646214",
            "PIK3CA",
            "PJA1",
            "CBLB",
            "PARP9",
            "NAA50",
            "ANO6",
            "CCS",
            "UBA6",
            "ARL13B",
            "FRYL",
            "TRAPPC4",
            "XRN1",
            "ZBTB38",
            "COQ6",
            "ATR",
            "NEDD1",
            "PAK2",
            "PPP1R12A",
            "DNAJC13",
            "GSK3B",
            "CDV3",
            "MAP3K7",
            "NFE2L1",
            "TAB2",
            "PIK3R4",
            "ZNF148",
            "EIF2B4"
        ]
    },
    {
        "golabel": "BCLAF1_regulon_activity",
        "gene": [
            "A1BG",
            "C4orf48",
            "PFN4",
            "COMTD1",
            "THAP7",
            "BATF",
            "GMCL1L",
            "FAM176B",
            "PBX1",
            "NCRNA00116",
            "C7orf59",
            "IRF7",
            "C7orf47",
            "MRPL41",
            "NDUFA11",
            "FAM58A",
            "ZNHIT1",
            "GUK1",
            "C6orf1",
            "C7orf50",
            "NDUFB7",
            "TRAPPC5",
            "C19orf60",
            "TMEM181",
            "ILVBL",
            "TMEM54",
            "PTRH1",
            "GALK1",
            "ASL",
            "C9orf142",
            "C17orf90",
            "C19orf70",
            "C9orf16",
            "ATP6V1F",
            "SHPRH",
            "PTPRK",
            "MRPL53",
            "POLD4",
            "FAM3A",
            "HS1BP3",
            "FASTK",
            "ARF5",
            "KIAA1919",
            "TMEM134",
            "TMEM120A",
            "JOSD2",
            "P2RX4",
            "PHIP",
            "ZNF770",
            "LATS1",
            "YIPF2",
            "CTU2",
            "FAM109B",
            "BAD",
            "PLEKHJ1",
            "ZDHHC24",
            "AIP",
            "EEA1",
            "FAM125A",
            "RFNG",
            "NUDT22",
            "BDP1",
            "NDUFS7",
            "HIPK1",
            "SIRT6",
            "ASCC3",
            "IDH3G",
            "ABCB8",
            "BOD1L",
            "FAM108A1",
            "PHF3",
            "ORAI1",
            "ZBTB44",
            "AFF4",
            "ZBTB24",
            "MAN1B1",
            "RANBP2",
            "TOP2B",
            "PBRM1",
            "VEGFB",
            "SEC63",
            "ARID1B",
            "SON",
            "RBMXL1",
            "CNOT1",
            "EPC2",
            "DDX3X",
            "RBM27",
            "DDX46",
            "SYNCRIP",
            "TPRA1",
            "RBM16",
            "CWC22",
            "DHX9",
            "USP7",
            "PUM2"
        ]
    },
    {
        "golabel": "BCOR_regulon_activity",
        "gene": [
            "GPR87",
            "MT2A",
            "MT1X",
            "CXXC4",
            "CDX1",
            "NBEA",
            "LOC374443",
            "C17orf60",
            "ATP11A",
            "CD72",
            "CSTB",
            "FXYD5",
            "ACVR2B",
            "EMP3",
            "NUDT2",
            "ZSWIM5",
            "LOC100270710",
            "CEBPB",
            "CD58",
            "FOXP4",
            "SH3BGRL3",
            "PSMB10",
            "SOCS7",
            "RHOC",
            "ANXA2",
            "BID",
            "PPP1R13B",
            "CCDC90B",
            "S100A11",
            "IKBIP",
            "ZNF618",
            "ZFHX3",
            "MYLIP",
            "EIF3K",
            "TPM4",
            "GSTK1",
            "NMI",
            "ARID5A",
            "VASP",
            "ASH1L",
            "ITGB1BP1",
            "RNF7",
            "FOXJ3",
            "NTAN1",
            "C3orf1",
            "ARID1A",
            "TLE3",
            "RHOG",
            "ATG7",
            "RNF149",
            "FAM32A"
        ]
    },
    {
        "golabel": "BDP1_regulon_activity",
        "gene": [
            "WDR17",
            "ANKRD31",
            "PAR5",
            "SELM",
            "NEU1",
            "BRI3",
            "BID",
            "RAD54L2",
            "DHFR",
            "NFKBIE",
            "RPS19BP1",
            "DGCR6L",
            "FAM190B",
            "COMMD7",
            "TXN2",
            "JMY",
            "DHX29",
            "MED13",
            "SMG1",
            "GXYLT1",
            "FAM109B",
            "BAD",
            "C11orf59",
            "MCCC2",
            "MTX3",
            "ZFC3H1",
            "ARL2",
            "DCAF16",
            "AKR1A1",
            "MOBKL1A",
            "CNPY3",
            "POLK",
            "CHD1",
            "CCDC112",
            "BOD1L",
            "APC",
            "ELOVL1",
            "MIER3",
            "BPTF",
            "AFF4",
            "RANBP2",
            "BIRC6",
            "PBRM1",
            "CHMP1A",
            "PIKFYVE",
            "AP4E1",
            "CORO1B",
            "SFRS12",
            "CEP350",
            "ERBB2IP",
            "ZFYVE16",
            "OTUD4",
            "PPWD1",
            "NOL8",
            "DDX46",
            "RAD17",
            "TPRA1",
            "BCLAF1"
        ]
    },
    {
        "golabel": "BHLHE41_regulon_activity",
        "gene": [
            "KRT79",
            "LYZ",
            "COL17A1",
            "HR",
            "ZNF365",
            "CAMK2N1",
            "MOSC1",
            "PPARG",
            "AFAP1L2",
            "C16orf54",
            "RTN1",
            "C8orf4",
            "EFNB1",
            "ABCB6",
            "PTAFR",
            "P2RX7",
            "ITGAM",
            "CYBB",
            "SAMD9",
            "AIM1",
            "OPLAH",
            "SSPN",
            "SPN",
            "MNDA",
            "CEBPD",
            "LY75",
            "CD180",
            "IMPA2",
            "NECAB3",
            "RPH3AL",
            "ITGB2",
            "LAIR1",
            "KIAA0114",
            "IL16",
            "DOCK2",
            "NCF2",
            "CDK2AP2",
            "TAGAP",
            "NCKAP1L",
            "BTK",
            "LCP1",
            "CD53",
            "EVI2B",
            "GAS7",
            "SELPLG",
            "CD4",
            "ARHGAP30",
            "AIFM2",
            "FN3K",
            "CMTM1",
            "RANGRF",
            "HIVEP3",
            "SHMT1",
            "EPB41L2",
            "LPXN",
            "KIAA1598",
            "DHTKD1",
            "TK2",
            "LYSMD1",
            "STK10",
            "SH2B3",
            "PMF1",
            "FLAD1",
            "MRPS18A",
            "PRDX6",
            "UBQLN4",
            "ENSA",
            "C1orf27",
            "PMPCA",
            "NVL"
        ]
    },
    {
        "golabel": "BOLA3_regulon_activity",
        "gene": [
            "GAL",
            "MT1G",
            "EIF4EBP1",
            "LOC645166",
            "C1orf182",
            "HIST2H2AC",
            "LOC100133985",
            "CCNB2",
            "CDKN3",
            "OIP5",
            "GINS2",
            "CKS2",
            "CENPA",
            "C12orf48",
            "NUF2",
            "LOC654342",
            "PFN2",
            "EPR1",
            "CENPW",
            "SPC25",
            "MRPL21",
            "NCRNA00152",
            "BIRC5",
            "CDCA3",
            "CDK1",
            "FAM54A",
            "KIAA0101",
            "LOC541471",
            "UBE2S",
            "ORC6L",
            "UBE2T",
            "COX6B1",
            "C1orf31",
            "PTCH1",
            "SNRPG",
            "CHAC2",
            "MRPS12",
            "PPP1R12B",
            "CENPM",
            "TMEM106C",
            "MTHFD2",
            "MAST4",
            "SNRPD2",
            "TIMM50",
            "COX7B",
            "SYNE1",
            "TMSB10",
            "MRPL13",
            "COX7A2",
            "EMG1",
            "PDCD5",
            "C2orf7",
            "TMEM147",
            "GAPDH",
            "TNS1",
            "GEMIN7",
            "COX5B",
            "TCEB1",
            "NME1",
            "LOC100130932",
            "GLA",
            "C11orf83",
            "MRPS15",
            "UQCRHL",
            "CRIPT",
            "POLE4",
            "FAM158A",
            "PSMB3",
            "AKAP13",
            "RPA3",
            "DTYMK",
            "POP7",
            "SNRPB",
            "RANBP1",
            "PTPN21",
            "COX6A1",
            "GEMIN6",
            "FKBP3",
            "PTS",
            "TOMM5",
            "ANAPC11",
            "RAN",
            "CCDC58",
            "PPIAL4G",
            "COQ3",
            "TOMM40",
            "UQCRH",
            "H2AFX",
            "NDUFB6",
            "VPS29",
            "H2AFZ",
            "MORN2",
            "PPIAL4C",
            "NAA10",
            "NDUFA9",
            "MRPL12",
            "COX7A2L",
            "CRY2",
            "PSMD8",
            "PSMG1",
            "HSPE1",
            "CYCS",
            "ALKBH2",
            "TUBA1C",
            "IAH1",
            "MRPL11",
            "SNRPF",
            "C14orf156",
            "CCDC59",
            "NUDT1",
            "FBXO22OS",
            "SNRPD1",
            "NUP37",
            "PHF5A",
            "APOO",
            "TIMM10",
            "SNRPA1",
            "KIAA1671",
            "KIF13A",
            "C16orf61",
            "NDUFA1",
            "CDKN2AIPNL",
            "PSMC4",
            "MRPL47",
            "MAGOHB",
            "C12orf73",
            "TPRKB",
            "SMARCA2",
            "ATP5G3",
            "TUBG1",
            "POLR2J",
            "DPY30",
            "RFC2",
            "TPI1",
            "NDUFB3",
            "NEDD8",
            "MACF1",
            "MRPL53",
            "TIMM9",
            "COX17",
            "PSMD14",
            "ICT1",
            "NFU1",
            "MEMO1",
            "PNO1",
            "TMEM126A",
            "NDUFAF4",
            "KLF13",
            "PDZD11",
            "MRPL27",
            "LSM5",
            "RPF2",
            "MRPL51",
            "ZMIZ1",
            "LOC728758",
            "LOC100129034",
            "UFD1L",
            "ZDHHC7",
            "FYCO1",
            "BANF1",
            "SLC25A39",
            "ARPC3",
            "PSMA2",
            "METTL5",
            "VPS13D",
            "SSBP1",
            "OBFC2B",
            "ITGB1BP1",
            "UBE2N",
            "UBE2MP1",
            "HSD17B10",
            "AP2S1",
            "C17orf79",
            "ATP5H",
            "DGUOK",
            "SF3B14",
            "ATXN7",
            "MRPS7",
            "NDUFA12",
            "DUSP11",
            "FAM136A",
            "PARL",
            "VPS25",
            "ZHX2",
            "POLH",
            "PDCL3",
            "KIAA0430",
            "AUP1",
            "PDPK1",
            "KCMF1",
            "XPC",
            "TACO1",
            "KIAA0240",
            "ERCC5",
            "SFRS9",
            "CPSF3",
            "PREB",
            "SNF8",
            "UBE2F",
            "ABHD10",
            "LSM12",
            "MDH1",
            "HTRA2",
            "ACP1",
            "CCT7",
            "MRPL35",
            "USP39",
            "N4BP1",
            "SMYD5",
            "ADD1"
        ]
    },
    {
        "golabel": "BPTF_regulon_activity",
        "gene": [
            "TAS2R3",
            "CDX1",
            "MT1F",
            "NNMT",
            "LOC387646",
            "PCLO",
            "SELM",
            "FTL",
            "BATF",
            "LOC440957",
            "RPL18A",
            "MRPL54",
            "IFI27L1",
            "NBPF10",
            "C9orf123",
            "MRPL41",
            "CYBA",
            "RPS9",
            "NDUFA11",
            "PSMB10",
            "ZNHIT1",
            "GUK1",
            "LCOR",
            "GPX1",
            "ATP6V0B",
            "NDUFB7",
            "SERTAD1",
            "RPL18",
            "UBL5",
            "C14orf142",
            "TRAPPC5",
            "NIPBL",
            "UQCR11",
            "NDUFA3",
            "MRPL34",
            "TANC2",
            "WNK1",
            "MYST3",
            "MSI2",
            "C9orf89",
            "UXT",
            "EIF3K",
            "TNRC6C",
            "SMPD2",
            "LRP6",
            "RABAC1",
            "C9orf16",
            "ATP6V1F",
            "BCORL1",
            "CCDC107",
            "CHD6",
            "GSTK1",
            "STXBP4",
            "SF3B5",
            "UBR5",
            "OSGEP",
            "LRBA",
            "ERCC6",
            "ASH1L",
            "ALMS1",
            "AKAP9",
            "ACACA",
            "MED13",
            "C12orf51",
            "SMG1",
            "ZCCHC11",
            "RSF1",
            "USE1",
            "AKAP1",
            "UBA52",
            "BCAS3",
            "ZKSCAN2",
            "NCOR1",
            "AIP",
            "ZNF318",
            "SRA1",
            "MBTD1",
            "ZNF507",
            "MOBKL1A",
            "HEATR6",
            "INTS2",
            "BDP1",
            "HUWE1",
            "TPST2",
            "BOD1L",
            "RNMT",
            "SYNRG",
            "DYNLL2",
            "C17orf49",
            "MGA",
            "CREB3",
            "KIAA2018",
            "MTMR4",
            "PIN1",
            "ZNF407",
            "TRIM33",
            "ARID1A",
            "CHD8",
            "BAT2L2",
            "HELZ",
            "ARPC4",
            "SNRNP200",
            "TMEM131",
            "FTSJ3",
            "KIDINS220",
            "UPF2",
            "HYAL2",
            "YLPM1",
            "ANKRD17",
            "EP300",
            "RANBP2",
            "MYST2",
            "BIRC6",
            "PIKFYVE",
            "CHD4",
            "URM1",
            "COG1",
            "ZNF652",
            "CEP350",
            "SOS1",
            "USP36",
            "SON",
            "CNOT1",
            "CLASP1",
            "GPATCH8",
            "USP34",
            "USP47",
            "DCAF7",
            "SRBD1",
            "ZNF638",
            "DDX42",
            "RBBP6",
            "HNRNPU",
            "YTHDC1",
            "GGNBP2"
        ]
    },
    {
        "golabel": "BRCA1_regulon_activity",
        "gene": [
            "RIMS2",
            "E2F7",
            "RNF157",
            "LOC127841",
            "TMEM163",
            "RDM1",
            "MCF2L2",
            "CLSPN",
            "SFTA2",
            "HIGD1B",
            "FIGN",
            "TFRC",
            "PLAC9",
            "AG2",
            "CDK5R1",
            "C15orf42",
            "ESPL1",
            "TMEM105",
            "FAM111B",
            "POLQ",
            "KIF18B",
            "KIF14",
            "CDC6",
            "CENPE",
            "TPI1P2",
            "BRIP1",
            "XRCC2",
            "MKI67",
            "TOP2A",
            "CST3",
            "E2F8",
            "ZNF367",
            "KIF24",
            "ATAD5",
            "PSMC3IP",
            "C17orf44",
            "NCAPG2",
            "TMEM125",
            "BRCA2",
            "FNDC8",
            "SEPW1",
            "RPL10A",
            "TSC22D1",
            "SLC20A1",
            "GPSM2",
            "NCAPD3",
            "EEF1A1P9",
            "UBTD1",
            "NUDT16L1",
            "FCGRT",
            "MSRA",
            "KDELC2",
            "RPL15",
            "YEATS2",
            "MYO19",
            "MOAP1",
            "KLC4",
            "KLHDC2",
            "RFFL",
            "RNASEN",
            "CRELD1",
            "NUP205",
            "ACLY",
            "TTF2",
            "PIGW",
            "SUZ12",
            "YWHAG",
            "RFWD3",
            "TNPO3",
            "UBA6",
            "GEMIN8",
            "CSRP1",
            "DUSP22",
            "PATL1",
            "KPNB1",
            "ZFYVE21",
            "DHX57",
            "TADA2A",
            "C9orf156",
            "GPR108",
            "NUP50",
            "PSME3",
            "EFTUD2"
        ]
    },
    {
        "golabel": "BRCA2_regulon_activity",
        "gene": [
            "PRDM13",
            "HOXA1",
            "CLSPN",
            "WFDC2",
            "METRN",
            "PRR11",
            "CASC5",
            "POLQ",
            "CENPE",
            "ATP1B1",
            "CKAP2L",
            "PMM1",
            "GAS2L3",
            "KLHDC9",
            "BRCA1",
            "TSTD1",
            "ATAD5",
            "HELB",
            "CKAP2",
            "SLC38A1",
            "SEPW1",
            "PPDPF",
            "ABHD14A",
            "TRERF1",
            "SMC4",
            "ZC3HAV1L",
            "SLC7A1",
            "SMC2",
            "BRWD3",
            "VWA1",
            "SLC9A3R2",
            "CENPJ",
            "CRKL",
            "CCDC88A",
            "ARL5B",
            "UBTD1",
            "C14orf106",
            "SBNO1",
            "RALGPS2",
            "DMXL2",
            "C22orf32",
            "B9D2",
            "DDRGK1",
            "CD151",
            "TTLL4",
            "TET3",
            "ZNF525",
            "HDAC11",
            "GNPTG",
            "CEP135",
            "HAGH",
            "JMJD8",
            "SMCR7",
            "FAM174A",
            "SCLT1",
            "GEMIN8",
            "C10orf18",
            "MRE11A",
            "PEX11B",
            "ZFYVE21",
            "ZUFSP",
            "PEF1",
            "KIAA1033",
            "APAF1",
            "XPO1",
            "LIN54",
            "TMEM115",
            "FAM134A"
        ]
    },
    {
        "golabel": "BRD1_regulon_activity",
        "gene": [
            "LONRF2",
            "POM121L10P",
            "WDR52",
            "ADM2",
            "GSTO1",
            "RORC",
            "LARGE",
            "GRAMD4",
            "LOC90834",
            "CFL2",
            "GLA",
            "PLXNB1",
            "SHANK3",
            "ATP1B3",
            "CASZ1",
            "CELSR1",
            "TUBGCP6",
            "CRTC1",
            "MRPL11",
            "C22orf29",
            "RABL2B",
            "UBE2E2",
            "KIAA0467",
            "PLXNB2",
            "GPN1",
            "SELO",
            "KIAA0284",
            "SBF1",
            "AIG1",
            "OLA1",
            "TNRC18",
            "TTC9C",
            "PNO1",
            "C9orf21",
            "MRPL1",
            "TMEM126A",
            "HDAC10",
            "CERK",
            "RPF2",
            "CCT4",
            "PSMA5",
            "SRRM2",
            "PSMB1",
            "POGZ",
            "MLL2",
            "PSMA2",
            "CABIN1",
            "ORMDL3",
            "AKAP1",
            "SDHD",
            "NISCH",
            "DPH3",
            "RERE",
            "SDHB",
            "KIAA0913",
            "UPF1",
            "DIP2A",
            "CHD2",
            "KDM5C",
            "COPS8",
            "ANAPC10",
            "PSMA1",
            "COPS4",
            "PCMT1",
            "EIF2B3",
            "ZC3H7B",
            "SMARCC2",
            "SAPS2",
            "MRPS18C",
            "SETD1B",
            "CAPZA1",
            "ZBED4",
            "TMX2",
            "DGCR8",
            "ZXDC",
            "RC3H1",
            "SP2"
        ]
    },
    {
        "golabel": "BRF1_regulon_activity",
        "gene": [
            "CKB",
            "PLBD1",
            "NOXA1",
            "EFCAB4A",
            "FRS3",
            "ANKRD9",
            "JAG2",
            "CRIP2",
            "DCXR",
            "NECAB3",
            "C20orf151",
            "C1orf56",
            "RNF208",
            "POC1B",
            "TM7SF2",
            "NUDT14",
            "SKAP2",
            "PPP1R13B",
            "TMEM55A",
            "TXNRD2",
            "RAB40C",
            "CELSR1",
            "CRTC1",
            "LOC100130093",
            "CYB5R4",
            "LIMS1",
            "ZBTB42",
            "RHBDD3",
            "KIAA0284",
            "MOAP1",
            "ZGPAT",
            "C14orf4",
            "ZNF707",
            "CNTROB",
            "C14orf79",
            "PLEKHH3",
            "WDR25",
            "MTA1",
            "RP2",
            "LRRC14",
            "ADCK1",
            "PPIL2",
            "BACH1",
            "ANGEL1",
            "TRMT61A",
            "FOXN2",
            "ZNF362",
            "ZNF821",
            "DCAF4",
            "BTBD6",
            "NEURL4",
            "C1orf35",
            "RCOR1",
            "ZBTB7B",
            "TBCD",
            "ZNF839",
            "POMT2",
            "C12orf4",
            "DPH3",
            "PELP1",
            "SURF6",
            "AGAP3",
            "CDC42BPB",
            "PACS2",
            "ZNF786",
            "SGSH",
            "AKT1",
            "OSBPL8",
            "MED9",
            "CMTM6",
            "ATG12",
            "SMEK1",
            "TECPR2",
            "ZFYVE21",
            "ATXN3",
            "C14orf169",
            "SNAP23",
            "PLDN",
            "WDR20",
            "ACTR2"
        ]
    },
    {
        "golabel": "BRIP1_regulon_activity",
        "gene": [
            "GREB1L",
            "PLA2G10",
            "NR6A1",
            "RNF157",
            "B4GALT6",
            "CLSPN",
            "IRX3",
            "DNAJC6",
            "LDHD",
            "ATAD3C",
            "FRMD5",
            "PRR11",
            "CDK5R1",
            "LDLRAD3",
            "ZMYND12",
            "CLTCL1",
            "RNASE4",
            "GPRIN1",
            "TSC22D2",
            "DSG2",
            "WDHD1",
            "ZNF93",
            "CNTLN",
            "BRCA1",
            "ST6GALNAC4",
            "TMEM125",
            "C11orf52",
            "XYLB",
            "BICD1",
            "KIF20B",
            "ALG10",
            "SMC4",
            "FIGNL1",
            "SLC9A3R2",
            "RBL1",
            "SLC20A1",
            "GPSM2",
            "MCM6",
            "C17orf91",
            "YPEL3",
            "MSRA",
            "C15orf41",
            "EIF2AK2",
            "MGC57346",
            "RALGPS2",
            "LRPAP1",
            "C22orf32",
            "AVL9",
            "E2F3",
            "TCTA",
            "HERPUD1",
            "TTLL4",
            "FBXO25",
            "NUP205",
            "C19orf63",
            "SGPL1",
            "TTF2",
            "JMJD8",
            "HEATR6",
            "UBA6",
            "MLYCD",
            "NPEPPS",
            "GEMIN8",
            "AKTIP",
            "ALG1",
            "ADNP2",
            "CSRP1",
            "LSM11",
            "FTSJ3",
            "DEXI",
            "NOL11",
            "RAD51L3",
            "INPP5K",
            "DHX57",
            "TADA2A",
            "C17orf71",
            "CCDC115",
            "CDC27"
        ]
    },
    {
        "golabel": "BRPF1_regulon_activity",
        "gene": [
            "NUP210",
            "TMEM99",
            "FUNDC2",
            "TRERF1",
            "BRP44",
            "NENF",
            "C1orf57",
            "FLNB",
            "DUSP7",
            "SRI",
            "C18orf32",
            "RAD54L2",
            "APITD1",
            "LYPLAL1",
            "TBCE",
            "NDUFB3",
            "PIGF",
            "TMEM126A",
            "DOT1L",
            "TMEM218",
            "ARL3",
            "GTF2H5",
            "SRP9",
            "ALG14",
            "CAMSAP1",
            "LRRC28",
            "BAT2L1",
            "DERL2",
            "PIGH",
            "ZNF445",
            "IQSEC1",
            "UFC1",
            "C1GALT1C1",
            "SDF2",
            "MRPS14",
            "TMCO1",
            "PIGC",
            "LOC653566",
            "TLN1",
            "TOR3A",
            "SETD5",
            "KDM4B",
            "VHL",
            "BRD4",
            "SPTAN1",
            "MAP4",
            "EHMT1",
            "GGPS1",
            "GNPAT",
            "LARS2",
            "VGLL4",
            "RNF123",
            "KLHL18",
            "SETD2",
            "VPRBP",
            "MTMR14",
            "PTPN23",
            "USP19",
            "RBM15B",
            "TATDN2",
            "DHX30",
            "QRICH1"
        ]
    },
    {
        "golabel": "BTF3_regulon_activity",
        "gene": [
            "RPL9",
            "RSL24D1",
            "SDR16C5",
            "RPS3A",
            "EEF1B2",
            "RPS14",
            "NCRNA00219",
            "COL16A1",
            "XRCC4",
            "UQCRQ",
            "RPL24",
            "TPT1",
            "RPL29",
            "MYO7A",
            "NACA2",
            "RPL10A",
            "TP53INP2",
            "C5orf35",
            "C11orf1",
            "EAPP",
            "DAGLA",
            "HINT1",
            "RPL7A",
            "EEF1A1",
            "COMMD10",
            "CCNG1",
            "NDUFAF2",
            "FCHO2",
            "ALG5",
            "CBFA2T2",
            "EIF3E",
            "RPL14",
            "ATP5S",
            "CMC1",
            "PNPLA4",
            "SLC25A5",
            "RPS23",
            "C19orf55",
            "PRDX2",
            "RPL15",
            "NPM1",
            "RPL4",
            "IQCE",
            "GNB2L1",
            "MRPS36",
            "RPS4X",
            "NDUFS4",
            "LSS",
            "COX7C",
            "MAP4K2",
            "DOPEY2",
            "RBM3",
            "THG1L",
            "CETN3",
            "PSME1",
            "ASNA1",
            "ALDH7A1",
            "NSA2",
            "TOMM20",
            "RPL36AL",
            "PPA2",
            "AK2",
            "PPA1",
            "NAA40",
            "SFRS12IP1",
            "TMEM111",
            "ZCCHC10",
            "MOCS2",
            "CDK7",
            "C5orf44",
            "VDAC1",
            "HEXB",
            "ISOC1",
            "TBCA",
            "SKP1",
            "C2CD3",
            "CEP164",
            "MCCC2",
            "PELO",
            "EIF1AX",
            "PTCD2",
            "KIAA1191",
            "SCAMP1",
            "SLC25A46",
            "UQCRC2",
            "UBE2E1",
            "MRPS27",
            "COPS2",
            "ANKRA2",
            "IPO11",
            "MYO9B",
            "IGBP1",
            "CHURC1",
            "EIF4B",
            "CAMLG",
            "WDR41",
            "ABCC10",
            "NACA",
            "FARS2",
            "DIP2A",
            "POC5",
            "FLJ33630",
            "C9orf82",
            "TAF7",
            "TMED7",
            "GMPR2",
            "PIGY",
            "PRKAG1",
            "ANAPC10",
            "CCNH",
            "UBE2B",
            "RAPGEF1",
            "C4orf14",
            "REEP5",
            "SPCS1",
            "PCNXL3",
            "NDFIP1",
            "GFM2",
            "STK38",
            "PFDN1",
            "C11orf58",
            "TMEM104",
            "PAIP2",
            "ESD",
            "FRG1",
            "EHMT1",
            "EIF1",
            "DNAJA2",
            "SLC30A5",
            "SARS",
            "APEH",
            "RIOK2",
            "KDM2A",
            "IPO13",
            "UBE2D3",
            "UBE2D2",
            "DCTD",
            "PLEKHM2"
        ]
    },
    {
        "golabel": "BTG1_regulon_activity",
        "gene": [
            "GKN2",
            "SLC14A2",
            "KCNE4",
            "PLA2G10",
            "HGD",
            "SLC7A2",
            "LPL",
            "SYT12",
            "SLC16A4",
            "SPTB",
            "RASD1",
            "GPR110",
            "ELMO1",
            "ZYG11A",
            "PDZD7",
            "PDE4D",
            "C8orf4",
            "SNX21",
            "ALDH3A2",
            "FAM46A",
            "ATP1B1",
            "AGA",
            "OSMR",
            "CHPT1",
            "MBOAT2",
            "DPY19L1",
            "FKBP11",
            "LARGE",
            "ATP8B1",
            "LMO4",
            "FBXO41",
            "TPT1",
            "FOXO1",
            "FBF1",
            "TRIO",
            "ZDHHC2",
            "LRRC70",
            "ZNHIT6",
            "FRAT1",
            "RPS27L",
            "LOC651250",
            "FIGNL1",
            "SNX22",
            "FAAH2",
            "GPSM2",
            "LIMK1",
            "ASAH1",
            "ZNF107",
            "PDIA3",
            "CNNM4",
            "N6AMT2",
            "MSRA",
            "MAST2",
            "CYB5D2",
            "ERP29",
            "CCM2",
            "AHDC1",
            "PRKAB1",
            "BCL9L",
            "KLHDC10",
            "CHMP1B",
            "C22orf32",
            "RASAL2",
            "ZNF341",
            "AVL9",
            "BRPF3",
            "H3F3A",
            "C10orf57",
            "DECR1",
            "VAPA",
            "MED11",
            "NCRNA00081",
            "GNA12",
            "C17orf48",
            "ITM2B",
            "SYNJ1",
            "C10orf32",
            "TWISTNB",
            "YPEL5",
            "PEBP1",
            "ANAPC16",
            "YKT6",
            "SUN1",
            "ZDHHC18",
            "INTS10",
            "GLB1",
            "TNPO3",
            "SPAG7",
            "DCTN6",
            "CCDC53",
            "NSMCE4A",
            "RNF216L",
            "RNF26",
            "NPEPPS",
            "RBAK",
            "DCLRE1B",
            "USP42",
            "DUSP22",
            "SLC37A3",
            "GABARAP",
            "TMEM66",
            "POM121C",
            "PPP3CC",
            "PCNXL3",
            "PWP2",
            "POM121",
            "RNF216",
            "LEPROTL1",
            "TBC1D10B",
            "ZNF12",
            "EIF1B",
            "TMEM104",
            "MORF4L1",
            "TMED10",
            "C9orf156",
            "ISCU",
            "SKIV2L",
            "SLC4A1AP",
            "IPO13",
            "WIPI2",
            "EXOC7",
            "DAZAP2",
            "XPO6"
        ]
    },
    {
        "golabel": "BTG2_regulon_activity",
        "gene": [
            "GRIA1",
            "SFTPA2",
            "SFTPA1",
            "CACNA2D2",
            "INMT",
            "SLC2A1",
            "RHOF",
            "FOS",
            "NCRNA00092",
            "ABCA3",
            "ANLN",
            "HSF2BP",
            "C1orf135",
            "HMGA1",
            "KIF23",
            "KIF2C",
            "CDCA8",
            "CGNL1",
            "SLC16A3",
            "METTL7A",
            "TK1",
            "SLC22A15",
            "ST6GALNAC4",
            "FAM46C",
            "UNC13B",
            "CYFIP2",
            "SNX8",
            "RCC1",
            "SLC35F2",
            "LRIG1",
            "TUBA1C",
            "CALU",
            "SPATS2L",
            "MOAP1",
            "GET4",
            "PKM2",
            "HEATR2",
            "ENO1",
            "C7orf49",
            "C2orf67",
            "FADD",
            "RAC1",
            "SH3GL1",
            "PSMD12",
            "EIF1AD"
        ]
    },
    {
        "golabel": "BUD31_regulon_activity",
        "gene": [
            "CAPZA2",
            "C7orf68",
            "CKS2",
            "LOC654342",
            "ZFAND2A",
            "MRPL21",
            "MGC72080",
            "ZP3",
            "ZNF366",
            "ATP5J2",
            "ERN1",
            "SNRPG",
            "PARD3B",
            "KRT10",
            "CHCHD2",
            "FAM162A",
            "C7orf59",
            "ARPC1A",
            "ACN9",
            "TP53TG1",
            "RNF32",
            "ZBED3",
            "MRPL36",
            "EMG1",
            "ARPC1B",
            "PMS2L1",
            "MRPL52",
            "MYEOV2",
            "STAG3L4",
            "FAM58A",
            "DERA",
            "TES",
            "BRI3",
            "PSMB3",
            "BET1",
            "BOLA2",
            "AKAP13",
            "RPA3",
            "DTYMK",
            "CPSF4",
            "ATP5I",
            "POP7",
            "IMMP2L",
            "EXOSC4",
            "GEMIN6",
            "PTS",
            "TOMM5",
            "SPATA13",
            "PDCD6",
            "UQCRH",
            "FIS1",
            "RHEB",
            "GADD45GIP1",
            "TTC28",
            "USMG5",
            "MORN2",
            "NAA10",
            "AP1S1",
            "MED10",
            "HSPE1",
            "COPS6",
            "UTRN",
            "SHFM1",
            "PPP1R14B",
            "C11orf48",
            "ATP5L",
            "ATP5E",
            "MRPL11",
            "PPIH",
            "TRAPPC2P1",
            "MRPS33",
            "PDAP1",
            "LOC401397",
            "HMBS",
            "C14orf2",
            "AP4M1",
            "SMUG1",
            "PDPR",
            "C19orf53",
            "PSMA7",
            "DPCD",
            "POLR2J",
            "C14orf153",
            "MAGOH",
            "EIF5A",
            "RFC2",
            "ORC5L",
            "NEDD8",
            "LSM4",
            "ARMC10",
            "REV3L",
            "KIAA1109",
            "RABL5",
            "C7orf44",
            "PDZD11",
            "POLR2G",
            "TRMT112",
            "LSM5",
            "NDUFC2",
            "CDK5",
            "MARCH8",
            "VPS13C",
            "MRPL51",
            "PSMA5",
            "C9orf119",
            "BCAP29",
            "MRTO4",
            "MYCBP2",
            "STYXL1",
            "PSMC2",
            "TRPT1",
            "BANF1",
            "PL-5283",
            "PPIA",
            "PMS2L5",
            "MRPL17",
            "PMPCB",
            "METTL5",
            "C7orf11",
            "NAA38",
            "SIGMAR1",
            "SSBP1",
            "ZNF3",
            "NUTF2",
            "MRPL18",
            "HERC1",
            "DIABLO",
            "RNF7",
            "ARID4A",
            "RP9",
            "GNB2",
            "DGUOK",
            "C1orf151",
            "WBSCR22",
            "DNAJC30",
            "MDH2",
            "FAM200A",
            "TMEM60",
            "NDUFA12",
            "EBNA1BP2",
            "RAPGEF2",
            "CHCHD3",
            "KIAA0430",
            "DYNLL1",
            "TBL2",
            "MTR",
            "DNAJB6",
            "EIF3I",
            "RBMX2",
            "ZNF407",
            "ZC3HC1",
            "CREBBP",
            "SBDSP1",
            "WDFY3",
            "DYNLRB1",
            "MED8",
            "NDUFA5",
            "PIKFYVE",
            "BCL7B",
            "NME6",
            "ZNF394",
            "USP34",
            "ANKFY1",
            "RABGEF1"
        ]
    },
    {
        "golabel": "BZW1_regulon_activity",
        "gene": [
            "KLRC2",
            "CYP24A1",
            "KYNU",
            "GPR97",
            "LYPD3",
            "LOC100131726",
            "FAM83A",
            "OPN3",
            "TXNRD1",
            "LOC645166",
            "MT1X",
            "PTGES",
            "SMOX",
            "PALM3",
            "USP2",
            "TTC21A",
            "CTSL1",
            "LOC285593",
            "NAMPT",
            "FAM184A",
            "LOC729176",
            "INPP5J",
            "TMPRSS2",
            "RFX2",
            "BZRAP1",
            "ERRFI1",
            "ERO1L",
            "MOCOS",
            "GOLGA2B",
            "LOC91316",
            "S100A16",
            "DSG2",
            "ANKRD57",
            "C22orf36",
            "ARVCF",
            "CROCCL2",
            "ACSS1",
            "RFK",
            "PPP1R3E",
            "POC1B",
            "TUBA4A",
            "IFT172",
            "CABC1",
            "LPIN1",
            "DERA",
            "HIF1A",
            "C11orf61",
            "ANKRD6",
            "CNIH",
            "C14orf129",
            "CBX7",
            "ASAP3",
            "POMP",
            "ZNF608",
            "PGK1",
            "PPFIBP2",
            "LDHA",
            "C20orf24",
            "CCDC88C",
            "ANKS3",
            "NPIP",
            "TUBGCP6",
            "SYNGAP1",
            "GBE1",
            "GNG10",
            "ITGB1",
            "CLDN12",
            "ZNF211",
            "KIAA0467",
            "TWF1",
            "TNK2",
            "SFI1",
            "SESN2",
            "LSS",
            "TMEM8B",
            "CLCN6",
            "AVEN",
            "C9orf30",
            "PKM2",
            "AGFG1",
            "TNFRSF1A",
            "CABIN1",
            "IFT122",
            "RAB10",
            "YWHAZ",
            "NIP7",
            "MOBKL3",
            "PGAM1",
            "ARAP1",
            "GTF2E2",
            "CUL9",
            "TMEM85",
            "RERE",
            "FLCN",
            "ELMOD2",
            "MORF4L2",
            "TMEM33",
            "ZBTB3",
            "PTPN18",
            "ZC3H15",
            "EZH1",
            "HDAC5",
            "KCMF1",
            "GGA2",
            "ARF4",
            "UBE2F",
            "RAB18",
            "AP3S1",
            "MADD",
            "RARS",
            "COQ10B",
            "SUMO1",
            "UGP2",
            "TMEM87B",
            "VPS26B",
            "RAD23B",
            "ATG16L1",
            "EML3",
            "HNRNPC",
            "GORASP2",
            "SURF4",
            "PLEKHA3"
        ]
    },
    {
        "golabel": "C1D_regulon_activity",
        "gene": [
            "TMEM14A",
            "RSL24D1",
            "LYPLA1",
            "OSTCL",
            "GTF2A2",
            "HIGD1A",
            "TDP2",
            "MED21",
            "GOLGA7",
            "C13orf37",
            "SELT",
            "PEX2",
            "CALM2",
            "ZNF462",
            "CNIH",
            "IDI1",
            "C14orf129",
            "MRPL33",
            "CNTNAP1",
            "AMN1",
            "COMMD8",
            "EAPP",
            "CRIPT",
            "ETNK1",
            "MREG",
            "NDUFB5",
            "MCEE",
            "RPS27A",
            "C5orf28",
            "SEP15",
            "SLMO2",
            "SCOC",
            "POLR2K",
            "COX7A2L",
            "ATP5S",
            "COMMD1",
            "PDCD10",
            "NDFIP2",
            "TMEM182",
            "TGDS",
            "C2orf64",
            "PKD1",
            "CCNC",
            "DSTN",
            "TRUB1",
            "TMEM165",
            "KIAA0467",
            "TXNDC9",
            "RCN2",
            "PHOSPHO2",
            "DPY30",
            "PCTP",
            "C3orf33",
            "ZMIZ2",
            "NDUFB3",
            "PSMC6",
            "PRPSAP2",
            "PRDX3",
            "PIGF",
            "H3F3A",
            "SLC35F5",
            "ERLEC1",
            "NFU1",
            "CCDC126",
            "MEMO1",
            "UBE2Q2",
            "C16orf63",
            "C5orf15",
            "CHMP5",
            "TSNAX",
            "EHBP1L1",
            "TMEM128",
            "HMGB1",
            "TMEM18",
            "SDHC",
            "CABIN1",
            "ZCCHC10",
            "SRP9",
            "COG6",
            "ATF1",
            "C5orf44",
            "FPGT",
            "ORC4L",
            "SUCLG1",
            "TM2D1",
            "NSL1",
            "YPEL5",
            "MOBKL3",
            "EFHA1",
            "PACRGL",
            "DPY19L4",
            "MLLT1",
            "UBE2E1",
            "BLOC1S2",
            "DUSP11",
            "ABHD13",
            "MMADHC",
            "MYO9B",
            "WDSUB1",
            "FAM103A1",
            "TAOK2",
            "ELMOD2",
            "TIPRL",
            "SPAST",
            "TADA1",
            "NUMA1",
            "ARL5A",
            "C9orf82",
            "TRMT61B",
            "SUMO1P3",
            "EIF4E",
            "UNC50",
            "ANAPC10",
            "UBA3",
            "TANK",
            "ACTR10",
            "UBE2B",
            "C2orf47",
            "SUCLA2",
            "MAP4K3",
            "ASNSD1",
            "NAPG",
            "RAB18",
            "POM121",
            "PPP1R2",
            "OCIAD1",
            "ABCB10",
            "YIPF4",
            "PPP1CB",
            "PIP5K1C",
            "C11orf58",
            "LIN7C",
            "LAPTM4A",
            "ACP1",
            "COQ10B",
            "SUMO1",
            "RFX1",
            "PRKRA",
            "DKFZp761E198",
            "SFRS3",
            "SMG6",
            "EML3",
            "AP1B1",
            "PPP3R1",
            "VAMP4",
            "SNRNP27",
            "KDM2A",
            "PEX13",
            "RAB28",
            "SMNDC1",
            "SAFB2",
            "CDC73",
            "RFWD2",
            "SMEK2",
            "TRIM26",
            "MARCH7",
            "PLEKHA3",
            "RAB1A"
        ]
    },
    {
        "golabel": "C20orf194_regulon_activity",
        "gene": [
            "OVCH2",
            "FLJ34503",
            "CD36",
            "TNXB",
            "ABCA8",
            "KCNJ5",
            "SOBP",
            "CCDC146",
            "AGAP11",
            "COL6A6",
            "DZIP1L",
            "PREX2",
            "C6orf155",
            "ITGA8",
            "SLIT3",
            "CDH23",
            "ABI3BP",
            "LOC401093",
            "DYNC2H1",
            "IQGAP2",
            "ABCA9",
            "SLIT2",
            "TAL1",
            "PHACTR1",
            "NHSL2",
            "MRPL21",
            "ARHGAP6",
            "PLEKHH2",
            "CKS1B",
            "C22orf23",
            "RGAG4",
            "ZNF366",
            "PLAGL1",
            "ASPRV1",
            "ECE2",
            "ACSS1",
            "MRPL36",
            "C20orf12",
            "TCEB1",
            "NME1",
            "PRDM11",
            "CBX7",
            "UQCRHL",
            "AKAP13",
            "PRICKLE2",
            "POP7",
            "LDHA",
            "SESN1",
            "DENND3",
            "TOMM5",
            "ANAPC11",
            "MAP3K12",
            "BRIX1",
            "SYNGAP1",
            "PPIAL4C",
            "MRPL12",
            "UTRN",
            "MRPS24",
            "PFDN2",
            "PPP1R14B",
            "C11orf48",
            "TTBK2",
            "LIMK2",
            "MRPL11",
            "APH1B",
            "ARAP3",
            "SCNM1",
            "RCBTB2",
            "DDX39",
            "AIMP2",
            "C14orf159",
            "SGK269",
            "EIF5A",
            "C12orf45",
            "ICT1",
            "REV3L",
            "CLCN6",
            "CHCHD8",
            "KIAA1109",
            "PSMB4",
            "MTX1",
            "EIF5AL1",
            "FLAD1",
            "MRTO4",
            "FARP2",
            "PPIA",
            "MRPL17",
            "METTL5",
            "C2orf86",
            "SIGMAR1",
            "VPS13D",
            "SSBP1",
            "PSMD4",
            "OBFC2B",
            "ALG8",
            "MTMR10",
            "TBC1D2B",
            "HERC1",
            "ARID4A",
            "ATRN",
            "ATP5H",
            "MDH2",
            "EIF2C4",
            "ZNF622",
            "ZZEF1",
            "FLCN",
            "MRPL37",
            "WDFY2",
            "ZFYVE26",
            "UBOX5",
            "GRPEL1",
            "PCNX",
            "TSPYL1",
            "TACO1",
            "CCT8",
            "MRPS16",
            "C12orf52",
            "ARPC5L",
            "PIKFYVE",
            "C5orf43",
            "VPS8",
            "PTPRA",
            "TBC1D20"
        ]
    },
    {
        "golabel": "CALCOCO1_regulon_activity",
        "gene": [
            "DLEC1",
            "OVCH2",
            "AGER",
            "RNASE13",
            "LRRK2",
            "CACNB4",
            "ACADL",
            "DUOX1",
            "BNIPL",
            "DUOXA1",
            "PLIN5",
            "SLC24A4",
            "SLFNL1",
            "C1orf175",
            "LOC148696",
            "PDE4C",
            "ADHFE1",
            "CAPN3",
            "DNAH1",
            "PRICKLE4",
            "ANLN",
            "C1orf101",
            "FANK1",
            "USHBP1",
            "SLC6A16",
            "SELENBP1",
            "RAC3",
            "DEPDC1B",
            "HCG2P7",
            "SEC31B",
            "TDRD6",
            "LRP2BP",
            "ADAMTS10",
            "TSSK3",
            "MRPS17",
            "SGOL2",
            "SLC22A15",
            "ACCS",
            "ACACB",
            "ZMYND15",
            "SATB1",
            "KPNA2",
            "RNASEH2A",
            "TENC1",
            "NCRNA00182",
            "DBF4",
            "CBX7",
            "IL11RA",
            "PPAT",
            "MCM6",
            "CCT5",
            "ARHGEF2",
            "PPIAL4C",
            "CYCS",
            "CLK4",
            "RABL2B",
            "RABL2A",
            "BZW2",
            "KLC4",
            "LRRC27",
            "RFC2",
            "AGXT2L2",
            "GARS",
            "DHRS1",
            "FLJ10038",
            "LSM5",
            "NICN1",
            "FOXO4",
            "ADCY6",
            "LOC400027",
            "TWISTNB",
            "PSMA2",
            "METTL2A",
            "C7orf70",
            "TRIM41",
            "NISCH",
            "YRDC",
            "EIF2C4",
            "C2orf67",
            "CHCHD3",
            "KIAA0430",
            "SFRS5",
            "LDB1",
            "STAT6",
            "EZH1",
            "KIAA0141",
            "XPC",
            "ENOPH1",
            "FAM160A2",
            "MTCH2",
            "SRRD",
            "ZNF500",
            "VPS39",
            "SNX1",
            "ATF7",
            "FAM98A"
        ]
    },
    {
        "golabel": "CAMTA2_regulon_activity",
        "gene": [
            "FUNDC2P2",
            "MYO15B",
            "USHBP1",
            "B3GALNT1",
            "CDRT15P",
            "ATG16L2",
            "TRPV1",
            "PERP",
            "ADCY4",
            "NXT2",
            "LENG8",
            "CAMKK1",
            "CNIH",
            "COMMD8",
            "UQCRHL",
            "DGKD",
            "FLJ45340",
            "FAM193B",
            "ANKMY1",
            "SGSM2",
            "SHANK3",
            "RASA4P",
            "JMJD7-PLA2G4B",
            "NPIP",
            "TUBGCP6",
            "CRTC1",
            "PDCD10",
            "ACADVL",
            "PKD1",
            "C20orf111",
            "HMHA1",
            "CCNC",
            "MPRIP",
            "ZNF276",
            "TWF1",
            "SLC44A1",
            "SBF1",
            "BTF3L4",
            "WBP5",
            "C1orf103",
            "MAN2C1",
            "ARHGEF1",
            "CNTROB",
            "TMEM123",
            "C17orf56",
            "TOM1L2",
            "NMD3",
            "DCUN1D1",
            "HDAC10",
            "C17orf68",
            "FAM160B2",
            "TSN",
            "PSMA5",
            "PTGES3",
            "NRAS",
            "YWHAQ",
            "METTL9",
            "KDM6B",
            "KIF1C",
            "CTNS",
            "ABR",
            "CHD3",
            "MAST3",
            "TNK1",
            "NEURL4",
            "POLE3",
            "WDR81",
            "ARAP1",
            "NISCH",
            "PNPLA6",
            "ARL6IP1",
            "ZBTB4",
            "TMEM102",
            "ATG5",
            "CUL9",
            "C16orf87",
            "DOCK6",
            "MXD4",
            "HN1L",
            "RBM5",
            "PRKCD",
            "AGAP3",
            "ABCC10",
            "RBM7",
            "LZIC",
            "LRSAM1",
            "KPNA4",
            "MINK1",
            "SUMO1P3",
            "ZC3H15",
            "HDAC5",
            "MON1A",
            "SNRNP40",
            "MUM1",
            "ZMPSTE24",
            "PSMA1",
            "USP20",
            "VTA1",
            "DPH1",
            "PTP4A2",
            "TYK2",
            "C17orf59",
            "ZCRB1",
            "RABGGTA",
            "SAPS2",
            "RBBP4",
            "HAT1",
            "VPS53",
            "PPP1R2",
            "PLD2",
            "NUS1",
            "SUMO1",
            "RFX1",
            "ZNF18",
            "SMG6",
            "EML3",
            "GNAI3",
            "MNT",
            "WTAP",
            "RNF123",
            "MAP2K7",
            "XRCC5",
            "PTPN23"
        ]
    },
    {
        "golabel": "CASZ1_regulon_activity",
        "gene": [
            "TTLL10",
            "VWA3A",
            "C9orf117",
            "WDR65",
            "CCDC81",
            "DNAH6",
            "BTNL9",
            "VSIG2",
            "CCDC146",
            "TMEM156",
            "CCL8",
            "GREM1",
            "LOC645166",
            "GPC6",
            "PLAU",
            "SLFNL1",
            "GGT6",
            "CPAMD8",
            "PIP5K1B",
            "FAM26F",
            "PRDM16",
            "BEND6",
            "PRICKLE4",
            "PLOD2",
            "PMAIP1",
            "FBXO32",
            "C8orf79",
            "GPR84",
            "TNFAIP6",
            "ELOVL6",
            "PDZD2",
            "CKS2",
            "BATF3",
            "TPPP",
            "FAP",
            "KCNQ1",
            "CCL4",
            "POSTN",
            "UBXN10",
            "CTHRC1",
            "TNFSF4",
            "NCRNA00152",
            "UPP1",
            "LOC80154",
            "SLC44A4",
            "LOC541471",
            "SLC22A23",
            "LOC374443",
            "KIAA1244",
            "PTTG1",
            "CCNB1",
            "PLXNA2",
            "LOC388152",
            "SHCBP1",
            "CCDC64B",
            "CROCC",
            "GPX8",
            "ACSS1",
            "CALML4",
            "SHROOM3",
            "MMP15",
            "RGS10",
            "IFT140",
            "KLHL5",
            "IFT172",
            "KIAA0513",
            "TNS1",
            "C1orf93",
            "SHANK2",
            "IL15RA",
            "MYH14",
            "NME1",
            "CTSC",
            "SOX13",
            "TRIM59",
            "C4orf46",
            "ASAP3",
            "ALDH1B1",
            "DUSP8",
            "MPL",
            "TTC12",
            "FAAH",
            "HSPA13",
            "LDHA",
            "UBE2L6",
            "TMEM55A",
            "RIPK2",
            "JMJD7-PLA2G4B",
            "RALGPS1",
            "ALDH4A1",
            "H2AFZ",
            "CTSB",
            "NRIP1",
            "CRY2",
            "PER2",
            "TICAM2",
            "ARHGEF16",
            "IKBIP",
            "CCDC59",
            "KIAA1671",
            "MTHFR",
            "UBE2E2",
            "CCNG2",
            "THRA",
            "MIB2",
            "GPN1",
            "KIAA0284",
            "SKA2",
            "ATXN7L1",
            "OSBPL2",
            "TMEM8B",
            "C1orf201",
            "PNPLA2",
            "ARHGEF7",
            "CNKSR1",
            "TOM1L2",
            "PDZD11",
            "TIFA",
            "SGSM3",
            "KLHL21",
            "FARP2",
            "KIAA0649",
            "ZBTB48",
            "RXRA",
            "VPS13D",
            "KIAA0319L",
            "KIAA1522",
            "PGAM1",
            "LDLRAP1",
            "GNPDA1",
            "CISD2",
            "RERE",
            "CLEC16A",
            "SUPT4H1",
            "UBE2E1",
            "ITFG2",
            "TAOK2",
            "WWP2",
            "BBS1",
            "PSD4",
            "STK40",
            "NADK",
            "KIAA1737",
            "COG7",
            "AP3S1",
            "C4orf43",
            "BUB3",
            "PPP1CC",
            "BRD1",
            "TBC1D17",
            "CNNM3",
            "METTL6",
            "THUMPD3",
            "UBE2Z",
            "LRRC47",
            "ARFGAP2"
        ]
    },
    {
        "golabel": "CBFA2T2_regulon_activity",
        "gene": [
            "SEZ6",
            "NPPA",
            "KCNC1",
            "CHRNB2",
            "CER1",
            "TMC2",
            "CHD5",
            "NKX6-3",
            "CAMK2B",
            "ABCC8",
            "KIF5C",
            "NEURL",
            "KIF1A",
            "PPM1E",
            "C12orf42",
            "KCNH2",
            "TDH",
            "KCNH8",
            "BSN",
            "CELF4",
            "SOX2",
            "SLC29A4",
            "DPY19L2",
            "GNAZ",
            "CASKIN1",
            "DLL1",
            "ATP2A3",
            "SCN8A",
            "ZNF711",
            "TIGD3",
            "ALPK3",
            "KSR1",
            "S100A14",
            "ANXA2P1",
            "S100A6",
            "LOC100303728",
            "S100A16",
            "USP49",
            "TM4SF1",
            "C9orf45",
            "ADORA2B",
            "PLEKHG5",
            "SERPINB1",
            "SRRM5",
            "PHF8",
            "NINL",
            "SQRDL",
            "MDFIC",
            "TBC1D8",
            "ANXA2P2",
            "SOCS7",
            "ZDHHC23",
            "KCNMB3",
            "ANXA2",
            "SS18L1",
            "HRH1",
            "GNA15",
            "LOC646762",
            "LOC100286844",
            "CEP192",
            "PLIN3",
            "CASP4",
            "KRBA1",
            "GK5",
            "RALB",
            "MARCH6",
            "KIAA1147",
            "DDHD1",
            "OBFC1",
            "CHD6",
            "ARL6IP5",
            "THG1L",
            "HSDL1",
            "PAPD7",
            "POGZ",
            "PPA1",
            "NAA40",
            "MYL12A",
            "ANXA5",
            "TRIM62",
            "DENND4B",
            "BTF3",
            "POMT2",
            "ZBTB40",
            "NFRKB",
            "CDK5RAP1",
            "ZNF335",
            "SBDS",
            "ARF4",
            "DHX35",
            "KDM2B",
            "RBM4B",
            "MYD88",
            "CAP1",
            "ASXL1",
            "NCOA5",
            "DCTD",
            "NRF1"
        ]
    },
    {
        "golabel": "CBFB_regulon_activity",
        "gene": [
            "FN3K",
            "CMTM1",
            "PPP1R16A",
            "SCRIB",
            "SLC26A11",
            "MPHOSPH6",
            "SLC46A1",
            "GABARAPL2",
            "RXRA",
            "NIP7",
            "NUTF2",
            "SLC38A10",
            "MAP1LC3B2",
            "C16orf87",
            "RFWD3",
            "SURF6",
            "ABCB8",
            "LRSAM1",
            "RSPRY1",
            "KIAA0195",
            "ZFP1",
            "SNTB2",
            "OSBPL8",
            "HDAC5",
            "GOT2",
            "MAP1LC3B",
            "TXNL4B",
            "SAPS2",
            "PSMD7",
            "SPCS3",
            "FTSJD1",
            "CIRH1A",
            "NAE1",
            "TBC1D13",
            "ARL2BP",
            "TERF2IP",
            "DNAJA2",
            "KARS",
            "C16orf80",
            "NUP93",
            "VPS35",
            "NUDT21",
            "BRD7",
            "SIAH1",
            "DYNC1LI2",
            "TMEM170A",
            "SCAP",
            "DDX19B",
            "ATMIN",
            "OGFOD1",
            "ACTR2",
            "VPS4A",
            "KIAA0174",
            "CTCF"
        ]
    },
    {
        "golabel": "CBL_regulon_activity",
        "gene": [
            "ODZ3",
            "FXYD3",
            "AGR2",
            "RAMP1",
            "ANG",
            "ASB9",
            "GAL3ST1",
            "ALG1L",
            "SACS",
            "C17orf61",
            "AGA",
            "TMEM141",
            "DPM3",
            "KRTCAP3",
            "TST",
            "C14orf49",
            "C12orf57",
            "CBX6",
            "DGKH",
            "STARD10",
            "PFDN5",
            "DOCK11",
            "UQCRQ",
            "HSD17B8",
            "ADI1",
            "MICAL3",
            "KCNK1",
            "LSMD1",
            "SSR4",
            "NDUFA2",
            "TOMM6",
            "GSTP1",
            "TSTA3",
            "FAM55C",
            "PHPT1",
            "COX5B",
            "C12orf35",
            "TMED3",
            "ACY1",
            "CRYZ",
            "NDUFA4",
            "RPL41",
            "C2orf79",
            "CCDC56",
            "C12orf62",
            "HSBP1",
            "NQO2",
            "RANGRF",
            "ATP5I",
            "HDDC3",
            "HINT1",
            "BLOC1S1",
            "PPIB",
            "FAAH2",
            "CCDC88A",
            "CCDC72",
            "CHKB",
            "ACOT13",
            "PRSS8",
            "GALE",
            "MCEE",
            "C2orf28",
            "ACADS",
            "C6orf108",
            "MRPS26",
            "SERF2",
            "MDN1",
            "C15orf63",
            "DYNLT1",
            "NCAPD3",
            "FOXK1",
            "SCOC",
            "HBXIP",
            "DHRSX",
            "KIAA0922",
            "PNPLA4",
            "CLDN7",
            "NDUFA7",
            "OST4",
            "MTHFS",
            "PNKD",
            "PIGP",
            "PRKAB1",
            "TEAD1",
            "BCL9L",
            "CRB3",
            "ATP11C",
            "CHCHD5",
            "FAM104B",
            "BNIP1",
            "SLC36A1",
            "YEATS2",
            "MYO5A",
            "CNPY2",
            "SLC25A4",
            "MRPS36",
            "C22orf32",
            "ZFYVE19",
            "FBXO10",
            "RASAL2",
            "DPCD",
            "CD63",
            "LOC388789",
            "COX7C",
            "C14orf179",
            "DDRGK1",
            "CEP170",
            "ATP5G2",
            "PHLPP2",
            "POLR2C",
            "PIGF",
            "WDR61",
            "DHRS7B",
            "CRYBG3",
            "TMEM62",
            "ERLEC1",
            "PPCS",
            "RBM3",
            "MMAB",
            "PCBD1",
            "PIP4K2A",
            "NDUFA6",
            "VAPA",
            "MPDU1",
            "TXN2",
            "MED11",
            "WDR25",
            "SURF1",
            "MRPS18A",
            "PEX7",
            "TRAM2",
            "MYCBP2",
            "C19orf63",
            "TMEM205",
            "CHCHD1",
            "MRPL43",
            "TMEM101",
            "ITSN1",
            "JAGN1",
            "CEP135",
            "MRPS11",
            "TMEM18",
            "ALG14",
            "ZNF70",
            "SRGAP2",
            "ZNF532",
            "FNBP1",
            "GRLF1",
            "NIN",
            "NDUFC1",
            "LMAN2",
            "HMGCL",
            "BAT2L1",
            "SSH1",
            "WIBG",
            "BICD2",
            "KIAA1432",
            "G6PC3",
            "SSH2",
            "STK16",
            "SPAG7",
            "KIAA0226",
            "MYO9B",
            "MLL",
            "NFRKB",
            "GEMIN8",
            "CDK19",
            "ABL2",
            "ATPAF2",
            "SEC11A",
            "COQ6",
            "MTF1",
            "IMP3",
            "C15orf40",
            "UNC50",
            "TLN1",
            "UBB",
            "AAK1",
            "SEC13",
            "DNAJC13",
            "COPS7A",
            "NPAT",
            "DENND5A",
            "YIPF3",
            "OCIAD1",
            "STK4",
            "SRP14",
            "PIKFYVE",
            "SPTAN1",
            "TMBIM6",
            "SIK3",
            "STX18",
            "OTUD4",
            "PDHB",
            "ZC3HAV1",
            "RNF167",
            "MRFAP1L1"
        ]
    },
    {
        "golabel": "CBX2_regulon_activity",
        "gene": [
            "UGT1A3",
            "UGT1A4",
            "UGT1A5",
            "LOC100190940",
            "NR0B1",
            "C1orf61",
            "KIF1A",
            "EPHB1",
            "CABYR",
            "TTLL7",
            "UCHL1",
            "RASAL1",
            "CARD14",
            "TRIM16L",
            "C4orf50",
            "NEIL3",
            "SLC7A11",
            "MAP2",
            "TSKU",
            "G6PD",
            "SLC7A5",
            "HPGDS",
            "PBK",
            "LRP8",
            "CX3CL1",
            "FAM72D",
            "PANX2",
            "PGD",
            "ESPL1",
            "PFN2",
            "KIF18B",
            "KIF14",
            "ABCB6",
            "FAM72B",
            "CENPF",
            "TLR2",
            "BLM",
            "HLA-DMB",
            "EMB",
            "SPAG5",
            "BAG2",
            "PAG1",
            "HLA-DPA1",
            "KIAA1549",
            "FNIP2",
            "BYSL",
            "ANKRD44",
            "GALNT10",
            "TXNIP",
            "C16orf59",
            "DPYD",
            "ENDOD1",
            "EPT1",
            "MGLL",
            "TIMELESS",
            "AIFM2",
            "N4BP2L1",
            "TRIM22",
            "CENPJ",
            "FECH",
            "SPRED1",
            "SDC4",
            "FEN1",
            "RAB27A",
            "RNF24",
            "ZNF671",
            "TGFBR2",
            "MAFG",
            "TK2",
            "KAT2B",
            "DARS2",
            "NOP2",
            "PUS1",
            "CBX8",
            "CTDSPL",
            "SLC3A2",
            "TMEM81",
            "CCDC21",
            "RBM43",
            "ATF4",
            "EIF4A3",
            "ULK1",
            "CCT3",
            "DHX37",
            "TAOK3",
            "GTF3C5",
            "PELP1",
            "MAZ",
            "RAP1A",
            "ANAPC7"
        ]
    },
    {
        "golabel": "CBX3_regulon_activity",
        "gene": [
            "TNXB",
            "CKS2",
            "CCT6A",
            "HSF2BP",
            "NUF2",
            "GBAS",
            "ZFAND2A",
            "HMMR",
            "MPP6",
            "CDK1",
            "CKS1B",
            "KIAA0101",
            "PPIAL4D",
            "VWF",
            "UBE2T",
            "MRPS17",
            "SNRPG",
            "CCNB1",
            "CHCHD2",
            "ACN9",
            "SEC61G",
            "GGCT",
            "CENPH",
            "PSMG3",
            "FKBP14",
            "TCEB1",
            "NME1",
            "LOC100130932",
            "ARL4A",
            "NDUFA4",
            "CBX7",
            "RPA3",
            "GEMIN6",
            "CCDC58",
            "PPIAL4G",
            "CENPL",
            "KRCC1",
            "C5orf28",
            "STARD3NL",
            "H2AFZ",
            "BRIX1",
            "PPIAL4C",
            "C7orf36",
            "COPS6",
            "CYCS",
            "MRPS24",
            "PPIH",
            "NUDT1",
            "TIMM8A",
            "NT5C3",
            "PLEKHA8",
            "KCTD6",
            "MYO18A",
            "AIMP2",
            "C12orf29",
            "ZNF138",
            "BZW2",
            "C7orf28B",
            "TPRKB",
            "BTF3L4",
            "RFC2",
            "ORC5L",
            "GARS",
            "MRPL32",
            "PNO1",
            "TOM1L2",
            "RMI1",
            "LSM5",
            "CCT4",
            "PSMA5",
            "MKI67IP",
            "HIBADH",
            "SLC43A2",
            "POLD2",
            "TBRG4",
            "PSMC2",
            "HEATR2",
            "SNRPE",
            "ENO1",
            "EIF3B",
            "RG9MTD1",
            "ZNRF2",
            "NUDCD2",
            "PPIA",
            "TWISTNB",
            "PSMA2",
            "C7orf11",
            "NAA38",
            "SSBP1",
            "GRN",
            "KDELR2",
            "WDR81",
            "YKT6",
            "SF3B14",
            "SLBP",
            "PHF14",
            "ZZEF1",
            "HMGN1",
            "THOC7",
            "C7orf25",
            "NUPL2",
            "SIDT2",
            "PLEKHM1",
            "MORF4L2",
            "BCAS2",
            "TAX1BP1",
            "MINK1",
            "VMA21",
            "RALA",
            "IL17RA",
            "RAC1",
            "THUMPD2",
            "H2AFV",
            "CPSF3",
            "MCTS1",
            "DNM2",
            "ABHD15",
            "PIP5K1C",
            "RARS",
            "AP2A2",
            "TBC1D17",
            "EIF2AK1",
            "ARAF",
            "SEPT7",
            "NUCB1",
            "SMG6",
            "SNRNP27",
            "PSMD6",
            "AIMP1",
            "MPHOSPH10",
            "HNRNPA2B1",
            "ADD1"
        ]
    },
    {
        "golabel": "CBX4_regulon_activity",
        "gene": [
            "GRIN1",
            "NECAB1",
            "FBXL16",
            "MMP17",
            "CPLX1",
            "FSCN2",
            "CELSR3",
            "C9orf172",
            "TMEM184A",
            "LOC653653",
            "ANKRD9",
            "JAG2",
            "GLIPR2",
            "RAB32",
            "C17orf107",
            "RNF208",
            "AP1S2",
            "TPM1",
            "CDC14A",
            "TNFAIP8",
            "AKAP7",
            "PIM3",
            "RAB11FIP2",
            "NR2F6",
            "C9orf72",
            "RAB8B",
            "FBRSL1",
            "BIVM",
            "CBX8",
            "B3GALTL",
            "TMUB1",
            "SEMA4C",
            "CRBN",
            "ZNF768",
            "PLEKHH3",
            "RP2",
            "C7orf27",
            "EPM2A",
            "DOHH",
            "ZC3H3",
            "SLC38A10",
            "ZBTB7B",
            "NOC2L",
            "RPTOR",
            "CCBL2",
            "FBXL5",
            "P4HB",
            "LONP1",
            "SAMD1",
            "DDX54",
            "GOLGA2",
            "UBE2O",
            "SYVN1",
            "LYRM2",
            "RAVER1",
            "HGS",
            "NCLN",
            "STX7",
            "FOXK2",
            "SNX14",
            "SCYL1",
            "EIF1B",
            "NPLOC4",
            "CEPT1",
            "HDLBP",
            "COPG",
            "GTF2H1",
            "PAPSS1",
            "MSL3",
            "TMEM214",
            "CDC40",
            "CSNK1D"
        ]
    },
    {
        "golabel": "CBX6_regulon_activity",
        "gene": [
            "TTLL7",
            "NPTXR",
            "FOXRED2",
            "USP51",
            "CDK2AP2",
            "UQCRQ",
            "RNF168",
            "HSBP1L1",
            "CEBPB",
            "CBX7",
            "KRTCAP2",
            "APOBEC3F",
            "MDN1",
            "C16orf13",
            "FAM168A",
            "HBXIP",
            "CYB5RL",
            "USMG5",
            "S100A11",
            "TTBK2",
            "RAB25",
            "SDC3",
            "NEU3",
            "SHPRH",
            "CYB561D1",
            "TRIM44",
            "H3F3A",
            "REV3L",
            "ROBLD3",
            "CBL",
            "KLF13",
            "JTB",
            "CHCHD1",
            "NEK1",
            "PI4KA",
            "GRLF1",
            "PPM1F",
            "MLXIP",
            "BAT2L1",
            "SMCR7L",
            "C14orf21",
            "WIBG",
            "IQSEC1",
            "ZFYVE26",
            "TNRC6B",
            "WASF2",
            "ZC3H7B",
            "CYTSA",
            "MTIF3",
            "MECP2",
            "C14orf43",
            "CEP68",
            "FAM120B",
            "ARF1"
        ]
    },
    {
        "golabel": "CBX7_regulon_activity",
        "gene": [
            "SEC14L3",
            "SCGB1A1",
            "LOC400891",
            "TMEM132C",
            "CCDC37",
            "DNAH9",
            "TTLL10",
            "VWA3A",
            "CHRNB3",
            "C1orf92",
            "DCDC2B",
            "DNAI2",
            "C22orf15",
            "ALS2CR12",
            "TCTE1",
            "C1orf87",
            "LOC100287718",
            "C1orf173",
            "DLEC1",
            "FAM92B",
            "CNGA4",
            "C6",
            "COL19A1",
            "SNTN",
            "NWD1",
            "DYNLRB2",
            "KCNE1",
            "LRRC18",
            "PTPRT",
            "RGS22",
            "LRRC48",
            "WDR65",
            "CCDC81",
            "CCDC147",
            "C2orf40",
            "DNAH6",
            "PACRG",
            "TTC16",
            "FAM154B",
            "TTLL9",
            "HEPN1",
            "DNAH10",
            "LRRC36",
            "TMEM232",
            "RSPH4A",
            "MS4A8B",
            "C11orf66",
            "MACROD2",
            "TXNDC6",
            "GAS2L2",
            "C18orf16",
            "PI16",
            "ACSBG1",
            "AQP10",
            "CCDC13",
            "SPAG8",
            "CCDC114",
            "BTNL9",
            "ACTN2",
            "SLC9A11",
            "ADH1A",
            "CCDC39",
            "LEFTY2",
            "CCDC141",
            "C3orf15",
            "FBXO15",
            "FIGF",
            "TPPP3",
            "OR56B1",
            "LCNL1",
            "NHLRC4",
            "C7",
            "PRSS12",
            "TNXB",
            "BCO2",
            "MGAT3",
            "ABCA10",
            "TNFRSF13B",
            "C1orf186",
            "ABCA8",
            "EFCAB6",
            "ADH1B",
            "KCNJ5",
            "ADAMTS8",
            "LOC283856",
            "TCF21",
            "NTRK3",
            "HDC",
            "CCDC146",
            "KIAA1529",
            "CHRDL1",
            "C15orf51",
            "C6orf25",
            "CLEC4F",
            "GATA5",
            "OSBPL6",
            "INMT",
            "NFASC",
            "GPR44",
            "CNR1",
            "RIC3",
            "ATP1A2",
            "CYP7A1",
            "CD22",
            "SCN11A",
            "GCNT4",
            "OR5K2",
            "MAP6",
            "SCN7A",
            "C1QTNF7",
            "PIP5K1B",
            "NRXN2",
            "MAMDC2",
            "FHL1",
            "NAP1L2",
            "SIGLECP3",
            "GATA1",
            "FXYD1",
            "MS4A2",
            "UNC45B",
            "TSPAN32",
            "LOC115110",
            "ABI3BP",
            "LOC121952",
            "CCNB2",
            "C8orf79",
            "RASGRP2",
            "LOC285593",
            "ADAMTS17",
            "SCN4B",
            "MFAP4",
            "EXO1",
            "FAIM3",
            "PTGDS",
            "AURKA",
            "RGS9",
            "LOC728392",
            "C16orf54",
            "SGCA",
            "ABCA9",
            "CENPA",
            "MAD2L1",
            "MCM10",
            "TUB",
            "SRGAP3",
            "C12orf48",
            "DEPDC1",
            "LOC92973",
            "AURKB",
            "CD40LG",
            "RFX2",
            "MUSTN1",
            "NUF2",
            "MYOM2",
            "GPRASP1",
            "TUBB3",
            "EPR1",
            "KIF23",
            "ZNF540",
            "HLA-DOA",
            "BIRC5",
            "CDC20",
            "NFIX",
            "CDCA3",
            "NDRG2",
            "LRP2BP",
            "CCNA2",
            "SGOL1",
            "NCAPG",
            "IQCG",
            "SKA3",
            "CCR6",
            "NEK2",
            "KIAA0101",
            "BUB1",
            "C22orf23",
            "RRM2",
            "CASC2",
            "ADAMTSL2",
            "ARHGEF37",
            "A2M",
            "KIAA0748",
            "GPR55",
            "GAS6",
            "UBE2T",
            "CEP55",
            "NLRP1",
            "CD37",
            "LTBP4",
            "C14orf139",
            "SNRPG",
            "SPN",
            "CCNB1",
            "C21orf49",
            "C15orf34",
            "CBX6",
            "KIF20A",
            "NAPSB",
            "PRCD",
            "METTL7A",
            "CCDC152",
            "GNPNAT1",
            "TTYH2",
            "CC2D2B",
            "ANKRD44",
            "ACACB",
            "IL16",
            "CIITA",
            "C18orf1",
            "RAI2",
            "MRPS35",
            "ZMYND15",
            "GCET2",
            "TXNIP",
            "GNG7",
            "ARRDC4",
            "TEF",
            "C15orf23",
            "GAB3",
            "CYFIP2",
            "LRRC3",
            "KPNA2",
            "C16orf86",
            "FMO4",
            "IFT172",
            "FLJ10357",
            "KIAA0513",
            "ARHGAP30",
            "NME1",
            "MFNG",
            "RASSF2",
            "RORA",
            "PLCG2",
            "APBB1",
            "ARHGAP24",
            "IL11RA",
            "DENND3",
            "RAN",
            "LOC653501",
            "MRPL15",
            "NRIP2",
            "MRPL12",
            "HSPE1",
            "HSPD1",
            "FAM117A",
            "SARM1",
            "SLC25A42",
            "PPP1R14B",
            "PAICS",
            "YARS2",
            "TUBA1C",
            "SNRPF",
            "RABL2B",
            "UBA7",
            "PIK3IP1",
            "C16orf5",
            "AIMP2",
            "TWF1",
            "LOC100129550",
            "C5orf41",
            "MAGOHB",
            "PTK2B",
            "BZW1",
            "MRPL42",
            "SUN2",
            "C20orf194",
            "CYB561D1",
            "CALCOCO1",
            "PSMD14",
            "MEMO1",
            "PGPEP1",
            "ABTB1",
            "EIF4A3",
            "DENND1C",
            "CCT3",
            "TCEANC",
            "RAB10",
            "ALG8",
            "FAM13B",
            "MAST3",
            "YWHAZ",
            "CBX3",
            "TBC1D2B",
            "PA2G4",
            "IQSEC1",
            "PDHX",
            "JMJD5",
            "SETDB2",
            "STIP1",
            "PDCL3",
            "PSD4",
            "UBE2K",
            "MRPL3",
            "EZH1",
            "MOBKL2C",
            "GGA2",
            "SAPS2",
            "SAP30L",
            "MTCH2",
            "MECP2",
            "CTBP2",
            "CCT7",
            "NOL10",
            "UBE2R2",
            "TBC1D22A",
            "MRPL19",
            "TBRG1"
        ]
    },
    {
        "golabel": "CBX8_regulon_activity",
        "gene": [
            "C19orf45",
            "SLC29A4",
            "CBX2",
            "IL7R",
            "PIK3CG",
            "IL6ST",
            "DCXR",
            "STRA13",
            "GLI4",
            "FAM195A",
            "ADCK5",
            "ASPSCR1",
            "TPK1",
            "TIMM16",
            "C16orf59",
            "AKAP2",
            "TIMM17B",
            "ARHGAP31",
            "C7orf47",
            "KHK",
            "RAG1AP1",
            "C6orf125",
            "SAMHD1",
            "C11orf83",
            "ETS1",
            "LOC92659",
            "SLC25A10",
            "PYCR1",
            "NTHL1",
            "DTYMK",
            "COX6A1",
            "EXOSC4",
            "ANAPC11",
            "EPB41L2",
            "PUSL1",
            "APOA1BP",
            "TGFBR2",
            "MRPL12",
            "ARL16",
            "MYO9A",
            "GALK1",
            "RAB8B",
            "C17orf90",
            "SAC3D1",
            "C17orf89",
            "HMBS",
            "PIK3R1",
            "LNPEP",
            "SMUG1",
            "C5orf41",
            "RPP21",
            "MRPL55",
            "NDUFS8",
            "HIPK3",
            "TMUB1",
            "MRPL53",
            "REST",
            "ATAD3A",
            "ICT1",
            "C9orf102",
            "TARBP2",
            "NT5C",
            "FASTK",
            "AURKAIP1",
            "MTX1",
            "MRPL27",
            "FLAD1",
            "FOXO3",
            "ANKRD39",
            "FDX1L",
            "TRAF4",
            "DUS1L",
            "LRCH1",
            "MYCBP2",
            "VPS72",
            "COX8A",
            "TRPT1",
            "SIRT7",
            "PTRH2",
            "SLC25A39",
            "OGFOD2",
            "PGP",
            "PSMD4",
            "CCDC137",
            "NUBP2",
            "CBX4",
            "C1orf35",
            "NARF",
            "NOC2L",
            "NAT9",
            "MRPS34",
            "RTKN",
            "NSUN5",
            "JMJD4",
            "MRPL38",
            "POLG2",
            "MRPS7",
            "RFNG",
            "ADRM1",
            "NUDT22",
            "CCS",
            "RRP1",
            "C16orf53",
            "TSEN54",
            "MAZ",
            "GNAQ",
            "WBP1",
            "IQGAP1",
            "C17orf70",
            "C1orf172",
            "LOC148413",
            "AUP1",
            "NUP85",
            "MFSD1",
            "PCNX",
            "GPS1",
            "RNF25",
            "WDR8",
            "JAK1",
            "UBE2J2",
            "SETX",
            "OTUB1",
            "PTPN9"
        ]
    },
    {
        "golabel": "CCDC71_regulon_activity",
        "gene": [
            "RPS10",
            "CENPF",
            "MKI67",
            "RPL35",
            "RPS14",
            "RPSA",
            "RPSAP58",
            "LOC440957",
            "RPSAP9",
            "HYAL3",
            "RPS8",
            "RPL24",
            "LSMD1",
            "MRPL54",
            "RPL29",
            "ABHD14A",
            "RPS9",
            "RPL10A",
            "ACY1",
            "GUK1",
            "GPX1",
            "RPL32",
            "NDUFA13",
            "KLHDC8B",
            "CCDC72",
            "TMEM42",
            "SERF2",
            "FIS1",
            "TKT",
            "RPL14",
            "CMC1",
            "C17orf108",
            "PNPLA4",
            "SELK",
            "C1orf203",
            "FAM86D",
            "FAU",
            "ARHGAP32",
            "MPG",
            "RPL15",
            "MAPKAPK3",
            "C3orf71",
            "RIF1",
            "POLR2L",
            "C10orf12",
            "ARL6IP5",
            "VPS28",
            "CRBN",
            "ZMAT5",
            "SMC3",
            "BTD",
            "SS18L2",
            "TMEM134",
            "HEMK1",
            "ABHD14B",
            "OSGEP",
            "CMTM8",
            "SLC25A20",
            "PPM1M",
            "SUMF1",
            "ACAA1",
            "TMEM101",
            "C15orf57",
            "TMEM219",
            "MED18",
            "SMC1A",
            "OXSM",
            "ELK4",
            "CEP290",
            "C3orf23",
            "UROD",
            "NDUFAF3",
            "P4HTM",
            "USE1",
            "NAT6",
            "RGPD3",
            "ZNF275",
            "SMCR7",
            "CCDC12",
            "CCDC51",
            "SETMAR",
            "SSH2",
            "TAX1BP3",
            "TBCC",
            "UBE2E1",
            "THOC7",
            "GLB1",
            "UGGT1",
            "SMC6",
            "UBR3",
            "DICER1",
            "RRP9",
            "TEX264",
            "IFRD2",
            "RPUSD3",
            "UQCRC1",
            "NPRL2",
            "MON1A",
            "CYB561D2",
            "LSM3",
            "SPCS1",
            "BAT2L2",
            "DALRD3",
            "BAZ1B",
            "ACTR1B",
            "RPUSD2",
            "ARF4",
            "SEC13",
            "HYAL2",
            "EXOSC7",
            "ZFYVE21",
            "RANBP2",
            "TWF2",
            "C3orf75",
            "IP6K2",
            "ALS2",
            "NME6",
            "GMPPB",
            "TUSC2",
            "BAT4",
            "RFT1",
            "SLC25A38",
            "CEP350",
            "METTL6",
            "SHISA5",
            "PDHB",
            "HPS6",
            "APEH",
            "SLC25A26",
            "ZC3H10",
            "QARS",
            "HNRNPUL2",
            "INTS12",
            "TADA3",
            "SEC22C",
            "SMG7",
            "PSMD6",
            "RHOA",
            "TMEM115",
            "ATRIP",
            "MLH1",
            "GLT8D1",
            "RPP14",
            "BAP1",
            "C3orf19",
            "IP6K1"
        ]
    },
    {
        "golabel": "CCNT1_regulon_activity",
        "gene": [
            "ASAH2B",
            "SGK196",
            "C1orf170",
            "GMCL1L",
            "STARD4",
            "HELB",
            "HMGN3",
            "LOC401052",
            "ZDBF2",
            "C12orf49",
            "IPMK",
            "ZNHIT2",
            "PTPLB",
            "ZKSCAN1",
            "WBP11P1",
            "ZNF460",
            "FAM173A",
            "ZC3HAV1L",
            "UHMK1",
            "FAM83G",
            "RAPGEF6",
            "C20orf177",
            "KLHL11",
            "UGCG",
            "PIK3C3",
            "TCP11L2",
            "SBNO1",
            "SKIL",
            "PPTC7",
            "STRN",
            "PRKAR2A",
            "NEU3",
            "RGP1",
            "KIAA1012",
            "NHLRC2",
            "IPO8",
            "PGLS",
            "DHX33",
            "ASXL2",
            "SLC25A40",
            "REST",
            "DHRS1",
            "FAM127A",
            "C11orf67",
            "PUS7L",
            "PMVK",
            "C9orf41",
            "ZNF641",
            "MAPK8",
            "GTF2H3",
            "LYPLA2",
            "C8orf58",
            "CCS",
            "PLBD2",
            "XKR8",
            "RIC8B",
            "ERCC4",
            "SENP1",
            "LARP4",
            "AKAP10",
            "IREB2",
            "RAB13",
            "DUS2L",
            "EAF1",
            "LOC144438",
            "SPTY2D1",
            "SFRS2IP",
            "EIF4G2",
            "GMEB1",
            "PPP1R7",
            "ZBTB11"
        ]
    },
    {
        "golabel": "CDC6_regulon_activity",
        "gene": [
            "GBX2",
            "RIMS2",
            "CTSL2",
            "ZBTB16",
            "GCLC",
            "EIF4EBP1",
            "CLEC4F",
            "INMT",
            "ATP1A2",
            "TMEM132E",
            "SFTPB",
            "LOC127841",
            "GPR133",
            "ABO",
            "ABCA3",
            "EXO1",
            "SLC22A3",
            "TFRC",
            "MYBL2",
            "CENPA",
            "PARM1",
            "MCM10",
            "SKA1",
            "RHOBTB2",
            "DEPDC1",
            "NDC80",
            "KCNQ1",
            "C15orf42",
            "TTK",
            "FOXM1",
            "ORC1L",
            "C1orf135",
            "CDC45",
            "RHPN2",
            "TPX2",
            "TRIP13",
            "TSC22D3",
            "TRIB3",
            "KIF23",
            "KIF2C",
            "CDC25A",
            "DAPK2",
            "KIFC1",
            "HJURP",
            "RAD54L",
            "KIAA1524",
            "CKAP2L",
            "SGOL1",
            "NCAPG",
            "BUB1B",
            "MELK",
            "GINS1",
            "SKA3",
            "C19orf40",
            "NCAPH",
            "BUB1",
            "TOP2A",
            "KIF4A",
            "CCDC34",
            "CDCA5",
            "RRM2",
            "CDCA8",
            "E2F8",
            "TYMS",
            "SPAG5",
            "HELLS",
            "PLK1",
            "MCM2",
            "GTSE1",
            "MLF1IP",
            "EME1",
            "CHEK1",
            "C7orf41",
            "RAD51",
            "SHCBP1",
            "SEMA4A",
            "TK1",
            "RFTN1",
            "BRCA1",
            "C17orf96",
            "MCM4",
            "ZWINT",
            "ASF1B",
            "CISH",
            "RAD54B",
            "DTL",
            "CD302",
            "FADS1",
            "FANCI",
            "KPNA2",
            "NOD1",
            "CHAF1B",
            "GINS3",
            "PTPRE",
            "PBXIP1",
            "FANCD2",
            "RCC1",
            "MCM6",
            "DONSON",
            "FEN1",
            "CRY2",
            "C21orf45",
            "MSRA",
            "PAICS",
            "C1orf112",
            "SLC25A13",
            "C15orf41",
            "TAPT1",
            "SLC5A6",
            "TIPIN",
            "CYP4V2",
            "PSMC4",
            "GTF2IRD2P1",
            "TUBG1",
            "POLA2",
            "GTF2IRD2",
            "TXNDC11",
            "ST6GALNAC6",
            "GNRHR2",
            "YWHAG",
            "C7orf49",
            "C16orf88",
            "ALAD",
            "RAD51C",
            "PSMD12",
            "SAE1",
            "TERF2IP",
            "PPM1G",
            "CNP",
            "PSME3"
        ]
    },
    {
        "golabel": "CDK9_regulon_activity",
        "gene": [
            "INE2",
            "C17orf55",
            "AK1",
            "PIP5KL1",
            "EGFL7",
            "IDUA",
            "ODF3B",
            "BAG4",
            "RNF208",
            "PTPLB",
            "HSPA13",
            "JUND",
            "DCK",
            "HS2ST1",
            "ARL5B",
            "GPR180",
            "PTRH1",
            "C9orf167",
            "LOC150786",
            "C9orf142",
            "TMEM135",
            "PGM3",
            "MANEA",
            "PNPLA2",
            "PRR24",
            "DPM2",
            "CCDC126",
            "TMX1",
            "PUS7L",
            "PHTF2",
            "UBE2Q2",
            "CNKSR1",
            "C9orf7",
            "NMD3",
            "AZIN1",
            "ST6GALNAC6",
            "FBXW5",
            "PIGQ",
            "ARRDC1",
            "NRAS",
            "SIX5",
            "KIAA1715",
            "RXRA",
            "COQ4",
            "NAT6",
            "FAM129B",
            "GMFB",
            "RRAGC",
            "CRAT",
            "SIPA1",
            "FPGS",
            "GMCL1",
            "LZIC",
            "PIGN",
            "LRSAM1",
            "LZTS2",
            "LMBR1",
            "FYTTD1",
            "OSBPL8",
            "CTDSPL2",
            "ALAD",
            "C2orf69",
            "USP20",
            "ATF2",
            "UHRF1BP1L",
            "ANAPC2",
            "ABCB10",
            "SSR1",
            "RNGTT",
            "CDC37",
            "RAB6A",
            "SMAD5",
            "MED26",
            "MOB2",
            "NUS1",
            "SIRT3",
            "NCRNA00094",
            "SLC25A28",
            "ZER1",
            "ASB6",
            "HNRPLL",
            "CTBP1",
            "NUDT21",
            "ZFR",
            "CTDSP1"
        ]
    },
    {
        "golabel": "CDX1_regulon_activity",
        "gene": [
            "ENTHD1",
            "DIRC1",
            "BFSP2",
            "TDO2",
            "XCL2",
            "FMO1",
            "GZMB",
            "MGC29506",
            "RAB33A",
            "CD69",
            "TNFAIP6",
            "LST1",
            "SIT1",
            "FAP",
            "CD52",
            "CTSK",
            "LTB",
            "PTPRCAP",
            "FUT7",
            "FCGR2B",
            "BCL2A1",
            "MIR155HG",
            "NCRNA00152",
            "CD3D",
            "LOC541471",
            "TBC1D10C",
            "IL21R",
            "LOC374443",
            "RARRES2",
            "LUM",
            "HCST",
            "C1orf54",
            "KIAA1244",
            "GSTO1",
            "GPX7",
            "FOXP3",
            "HAPLN3",
            "C5orf62",
            "PSTPIP1",
            "PLA2G5",
            "GLIPR2",
            "CD300A",
            "GMFG",
            "CHN1",
            "TNFRSF4",
            "PTPN7",
            "LXN",
            "CCDC109B",
            "NAALADL1",
            "CD58",
            "IGFBP7",
            "SOCS7",
            "PLEKHO1",
            "MAGI1",
            "CCDC90B",
            "ICAM3",
            "TICAM2",
            "MYL6",
            "IKBIP",
            "NOSIP",
            "LSM10",
            "LRBA",
            "ASH1L",
            "BCOR",
            "ACACA",
            "ATOX1",
            "INADL",
            "FNBP1L",
            "GTF2I",
            "OTUD7B",
            "ANKS1A",
            "TXNDC15",
            "RPRD2",
            "WDR41",
            "C17orf49",
            "ARHGEF12",
            "SNX11",
            "RBM47",
            "BPTF",
            "TOR3A",
            "ARPC4",
            "AP3S1",
            "PFN1",
            "ARPC2",
            "DNAJC24",
            "GIGYF2",
            "PUM1"
        ]
    },
    {
        "golabel": "CEBPB_regulon_activity",
        "gene": [
            "C21orf84",
            "RHOV",
            "KYNU",
            "GPR97",
            "LOC100131726",
            "FAM83A",
            "MT2A",
            "OPN3",
            "ANGPTL4",
            "RGS2",
            "MT1X",
            "PTGES",
            "DDIT4",
            "IER5L",
            "NAMPT",
            "NNMT",
            "DUSP23",
            "ERRFI1",
            "KRT7",
            "HES4",
            "SNAI1",
            "SEPX1",
            "ANKRD9",
            "VWA2",
            "CBX6",
            "SOCS3",
            "ST20",
            "CEBPD",
            "FAM176B",
            "SOD2",
            "FNIP2",
            "SLC25A37",
            "TMSB10",
            "OCLN",
            "MRPL41",
            "JUNB",
            "AMIGO1",
            "BCL3",
            "PPFIBP2",
            "FAM161B",
            "TYMP",
            "RAPGEF6",
            "C20orf24",
            "ITPKC",
            "KLHL11",
            "METRNL",
            "TRAPPC5",
            "LTBR",
            "SARM1",
            "PPP1R14B",
            "NFIL3",
            "SBNO2",
            "SLC29A1",
            "SH3RF1",
            "B4GALT1",
            "KBTBD7",
            "SHPRH",
            "ZNF441",
            "SPTLC2",
            "REV3L",
            "VPS13C",
            "FARP2",
            "FBXW5",
            "USP12",
            "HMGCR",
            "BCOR",
            "SYNJ1",
            "TNFRSF1A",
            "SEC61B",
            "TCEANC",
            "FAM13B",
            "CNN2",
            "ZNF619",
            "ZNF611",
            "TNRC6B",
            "TRPM7",
            "MAP2K2",
            "CTR9"
        ]
    },
    {
        "golabel": "CEBPD_regulon_activity",
        "gene": [
            "RLN3",
            "KCNG2",
            "GADD45G",
            "AG2",
            "C8orf4",
            "KIAA0754",
            "BHLHE41",
            "PTP4A3",
            "FBXL8",
            "OPLAH",
            "ANKRD9",
            "SLC39A4",
            "PER1",
            "RHOB",
            "GLI4",
            "ADCK5",
            "FLJ43663",
            "CDK2AP2",
            "RNF168",
            "C19orf20",
            "NKX2-1",
            "CEBPB",
            "NFKBIA",
            "FAM173A",
            "ENDOG",
            "MGC70857",
            "MITF",
            "DGAT1",
            "JUND",
            "C16orf13",
            "RPS20",
            "EXTL2",
            "FBXL15",
            "EEF1D",
            "PWWP2B",
            "SHARPIN",
            "UQCRB",
            "INO80B",
            "BCL6",
            "DCUN1D1",
            "LUZP1",
            "FBXW5",
            "CYHR1",
            "PHF6",
            "KIAA0146",
            "RRAGC",
            "PIK3CA",
            "ZNF436",
            "ORC3L",
            "PCYT1A",
            "RNF219",
            "MAF1",
            "ZNF845",
            "DNAJC13",
            "EIF5",
            "PAPSS1",
            "C1orf83",
            "TTC15",
            "TMEM184C",
            "PITPNB",
            "YWHAB"
        ]
    },
    {
        "golabel": "CENPK_regulon_activity",
        "gene": [
            "ATOH8",
            "E2F7",
            "TMEM22",
            "LOC728819",
            "GPR133",
            "MAOA",
            "ADAMTSL3",
            "PMAIP1",
            "IRX3",
            "RHOBTB2",
            "DEPDC1B",
            "RHEBL1",
            "POLR3G",
            "PRTFDC1",
            "NUP62CL",
            "KIAA0101",
            "C14orf143",
            "C13orf27",
            "CCNB1",
            "CHAC2",
            "DLEU2",
            "RFC4",
            "SEMA4A",
            "RORC",
            "XRCC4",
            "CENPH",
            "C13orf37",
            "CABC1",
            "FRAT1",
            "GLA",
            "GLMN",
            "C9orf40",
            "HPRT1",
            "RPA3",
            "ITGB3BP",
            "ATP1B3",
            "FANCD2",
            "PPP1R13B",
            "VPS29",
            "C10orf78",
            "C6orf182",
            "DHFR",
            "NT5C3",
            "THRA",
            "ZNF530",
            "TMEM63B",
            "TPRKB",
            "UCHL3",
            "ESRP2",
            "SAAL1",
            "FANCL",
            "C17orf75",
            "DPM1",
            "LSM5",
            "SFXN1",
            "PSMA2",
            "C17orf42",
            "SMN2",
            "CYB5R3",
            "DGCR2",
            "SLBP",
            "TOB2",
            "ERCC8",
            "MXD4",
            "PRKCD",
            "WWP2",
            "ZCCHC9",
            "PINK1",
            "EED",
            "TAF9",
            "INPP5A",
            "RBBP7",
            "TMEM57",
            "AP2A2",
            "DCTN1",
            "CNNM3",
            "ZER1"
        ]
    },
    {
        "golabel": "CHAF1A_regulon_activity",
        "gene": [
            "CAMK2N2",
            "MAST1",
            "ACSM3",
            "CELSR3",
            "C12orf69",
            "CYP39A1",
            "PDE1A",
            "RERG",
            "C15orf42",
            "ESPL1",
            "ZMYND12",
            "KIF18B",
            "KIFC1",
            "RAD54L",
            "GPRIN1",
            "CDT1",
            "GPR3",
            "CDCA5",
            "SEPP1",
            "GPR160",
            "SH3BGRL2",
            "SPAG5",
            "UHRF1",
            "PKMYT1",
            "GTSE1",
            "NFKBIL2",
            "ASF1B",
            "CHTF18",
            "HSD17B11",
            "HSD17B8",
            "TMX4",
            "C14orf80",
            "CDC25B",
            "PEX11A",
            "FEN1",
            "ASAH1",
            "SENP8",
            "C11orf54",
            "LMNB2",
            "TMEM50B",
            "FAM151B",
            "DNMT1",
            "PPP2R5A",
            "KLHDC2",
            "HERPUD1",
            "CLN5",
            "QSOX2",
            "HAUS8",
            "GDE1",
            "CD46",
            "THOP1",
            "LIG1",
            "SPHAR",
            "PPAN",
            "TMEM59",
            "POLD1",
            "C14orf28",
            "FAM8A1",
            "KLC2",
            "C10orf32",
            "TCOF1",
            "TCF3",
            "GLT25D1",
            "CCDC137",
            "N6AMT1",
            "LMBRD1",
            "TRIM28",
            "C2orf67",
            "PAFAH2",
            "GIT1",
            "MED24",
            "SCP2",
            "PCMTD1",
            "TMEM66",
            "TMEM9B",
            "IKZF5",
            "TRIM13",
            "GIN1",
            "FXC1",
            "MMAA",
            "FAM114A2",
            "WDR5",
            "SRRT",
            "VPS36",
            "SMPD4",
            "SACM1L",
            "RAB4A",
            "KHSRP",
            "NUP62",
            "FAM54B",
            "U2AF2",
            "CCDC115",
            "KCTD18",
            "MTA2",
            "HNRNPM",
            "PTBP1"
        ]
    },
    {
        "golabel": "CHD1_regulon_activity",
        "gene": [
            "ANKRD31",
            "METRN",
            "PPP1R14A",
            "STARD10",
            "TRAPPC6A",
            "DDX60L",
            "HOMER1",
            "NEU1",
            "LHPP",
            "SERF2",
            "FER",
            "SHISA4",
            "ERAP1",
            "KIF2A",
            "COMMD7",
            "RASA2",
            "HS1BP3",
            "RASA1",
            "B3GALT4",
            "WDR25",
            "C19orf63",
            "MRPL43",
            "ZSWIM6",
            "TOP1",
            "C14orf1",
            "BDP1",
            "CAST",
            "MAPK3",
            "TMEM161B",
            "RBM41",
            "YTHDC2",
            "TMEM55B",
            "UTP15",
            "CHMP1A",
            "PPIP5K2",
            "DIAPH1",
            "OTUD4",
            "WDR36",
            "NOL8",
            "STX5",
            "PAPD4",
            "STX17"
        ]
    },
    {
        "golabel": "CHD2_regulon_activity",
        "gene": [
            "SORCS2",
            "LOC148696",
            "GPLD1",
            "SNORD116-20",
            "ABCC6",
            "LOC541471",
            "UBE2Q2P1",
            "LOC388152",
            "CHCHD2",
            "NBEAL1",
            "EVPL",
            "MAST4",
            "MED27",
            "C2orf7",
            "BAHCC1",
            "SHANK2",
            "PPP1R9A",
            "GLA",
            "MYO5C",
            "C6orf115",
            "DGKD",
            "AKAP13",
            "POP7",
            "CDC42BPG",
            "MCTP2",
            "NKTR",
            "CELSR1",
            "TBCB",
            "WNK1",
            "TBPL1",
            "MPRIP",
            "ANKHD1-EIF4EBP3",
            "COPS3",
            "ATP6V1F",
            "CLCN6",
            "WDR60",
            "KIAA1109",
            "ARF5",
            "GYG1",
            "VPS13C",
            "SRRM2",
            "PPIP5K1",
            "PSMB1",
            "PL-5283",
            "SMG1",
            "MLL2",
            "ARPC5",
            "PSMA2",
            "INADL",
            "NFAT5",
            "TP53RK",
            "ANKS6",
            "GCC2",
            "MTX3",
            "BAHD1",
            "ATXN7",
            "TXNDC12",
            "RREB1",
            "CHIC2",
            "NR2C2",
            "KIAA0430",
            "SNX11",
            "ASB13",
            "EZH1",
            "MTR",
            "DNAJB6",
            "RGPD4",
            "SPEN",
            "TAF1",
            "TOR3A",
            "TNRC6A",
            "PCMT1",
            "PDE6D",
            "WDFY3",
            "MPHOSPH8",
            "BRD1",
            "WHAMM",
            "SPG11",
            "INO80D",
            "SFRS12",
            "TMEM199",
            "VPS39",
            "MCM3AP",
            "ZXDC",
            "INO80",
            "DDX42",
            "SLTM",
            "YTHDC1"
        ]
    },
    {
        "golabel": "CHD6_regulon_activity",
        "gene": [
            "CDA",
            "LEMD1",
            "CECR2",
            "CDON",
            "SDK1",
            "CTSL1",
            "ALX3",
            "RALGAPA1",
            "NBEA",
            "PDZK1IP1",
            "PLEK2",
            "KREMEN1",
            "GLRX",
            "TNFSF9",
            "ZFAND2A",
            "NCRNA00152",
            "PLCB1",
            "SORL1",
            "TSPYL3",
            "UPP1",
            "S100A14",
            "S100A6",
            "LOC541471",
            "SBK1",
            "SLC22A23",
            "BLVRB",
            "KIAA1244",
            "C17orf60",
            "GSTO1",
            "PELI2",
            "PYCARD",
            "SALL2",
            "CELSR2",
            "PRKCDBP",
            "RIN1",
            "FXYD5",
            "CADM4",
            "IL32",
            "RHOD",
            "ZNF704",
            "IL18",
            "ZNF286B",
            "SMAGP",
            "CLTB",
            "RPS6KA5",
            "ZNF397",
            "SDSL",
            "ETHE1",
            "ZSWIM5",
            "ARPC1B",
            "RALGAPA2",
            "S100A10",
            "LOC100270710",
            "CD58",
            "SHANK2",
            "IL15RA",
            "PSMB10",
            "C9orf46",
            "ZNF518B",
            "RHOC",
            "GPX1",
            "TMEM170B",
            "GGT7",
            "FAM125B",
            "SC4MOL",
            "SHROOM2",
            "SYNE2",
            "CCDC88C",
            "CAPG",
            "PPIAL4G",
            "GNA15",
            "ZNF594",
            "ZNF192",
            "CBFA2T2",
            "NOP10",
            "S100A11",
            "ATP9A",
            "C14orf102",
            "FMNL2",
            "ZNF91",
            "ZFHX3",
            "TRIM24",
            "PLIN3",
            "PLCG1",
            "PLAGL2",
            "SIPA1L3",
            "GSTK1",
            "WDR35",
            "ZBTB39",
            "IKZF4",
            "AVEN",
            "LYSMD2",
            "LOC388955",
            "PKM2",
            "ETFA",
            "ZNF496",
            "ALMS1",
            "C20orf112",
            "ZMYND8",
            "GRHL2",
            "C12orf51",
            "DNAL1",
            "PATZ1",
            "KIF3A",
            "PRELID1",
            "C15orf24",
            "FNBP1L",
            "RGPD3",
            "DIP2C",
            "MBTD1",
            "FOXJ3",
            "RERE",
            "ZHX3",
            "DIDO1",
            "C7orf25",
            "C11orf30",
            "IFRD2",
            "BPTF",
            "TAF1",
            "CHD8",
            "ARPC4",
            "GZF1",
            "HTATSF1",
            "CHCHD4",
            "ADNP",
            "DCAF5",
            "SUV420H1",
            "ELMO2",
            "CEP68",
            "ATG7",
            "RALGAPB",
            "SHISA5",
            "PHF12",
            "RNF149",
            "PCIF1"
        ]
    },
    {
        "golabel": "CHD7_regulon_activity",
        "gene": [
            "HMGB3",
            "LST1",
            "CENPE",
            "TLR2",
            "RRS1",
            "IFI27L2",
            "PYCARD",
            "ACVR2B",
            "RAB38",
            "C7orf23",
            "MRPL54",
            "HNMT",
            "C8orf39",
            "C10orf11",
            "TMEM159",
            "LGALS3",
            "ARHGAP39",
            "GPX1",
            "CSPP1",
            "CD59",
            "PRKDC",
            "TSPAN4",
            "FAH",
            "SCRIB",
            "EIF2C2",
            "ARHGDIB",
            "DNMT3A",
            "MR1",
            "BEND3",
            "MICA",
            "CCNJ",
            "ATP6V0E1",
            "PHLPP2",
            "CLN5",
            "TET3",
            "JARID2",
            "BLVRA",
            "UBR5",
            "TAF4",
            "POLR3A",
            "ZNF623",
            "C12orf51",
            "PDCD11",
            "KTN1",
            "POLR3GL",
            "RPS6KA1",
            "SCP2",
            "MTPAP",
            "C19orf42",
            "RBM12B",
            "SAPS3",
            "TARDBP"
        ]
    },
    {
        "golabel": "CHD9_regulon_activity",
        "gene": [
            "C1orf182",
            "LOC148696",
            "SLC16A7",
            "FMN1",
            "NHS",
            "RAC3",
            "NT5M",
            "STRA13",
            "ASPSCR1",
            "NBEAL1",
            "ANKRD44",
            "MIF",
            "ZBTB20",
            "YDJC",
            "KIF27",
            "PDCD2L",
            "C11orf83",
            "MRPS15",
            "CMTM1",
            "DTYMK",
            "POP7",
            "SNRPB",
            "NDUFS6",
            "ANAPC11",
            "H2AFX",
            "MRPL12",
            "PSMG1",
            "MYO9A",
            "TTBK2",
            "ARAP2",
            "TK2",
            "PFDN6",
            "SAC3D1",
            "RPGRIP1L",
            "KAT2B",
            "SCNM1",
            "AIMP2",
            "C5orf41",
            "GPR172A",
            "PDPR",
            "TBC1D8B",
            "NDUFS8",
            "TUBG1",
            "POLR2J",
            "EIF5A",
            "MACF1",
            "LSM4",
            "ABHD12",
            "RBM43",
            "KIAA1109",
            "SRM",
            "VPS13C",
            "ZMYND19",
            "ZNF175",
            "TCF7L2",
            "USP53",
            "KIAA1370",
            "BANF1",
            "NFATC3",
            "SIGMAR1",
            "PSMD4",
            "FKBPL",
            "SNRPC",
            "PDP2",
            "NFAT5",
            "DENND4A",
            "PTGES2",
            "GCC2",
            "HERC1",
            "ARID4A",
            "GNG5",
            "RDBP",
            "DDX49",
            "ADRM1",
            "ALPK1",
            "FTO",
            "RPIA",
            "ATRX",
            "RBL2",
            "TMEM11",
            "ZHX2",
            "CYLD",
            "APC",
            "ARMC6",
            "AFF1",
            "C6orf153",
            "RSPRY1",
            "SH3D19",
            "BAZ2B",
            "WDR74",
            "DMXL1",
            "WDFY3",
            "LONP2",
            "TBCK",
            "CEP120",
            "ATXN1L",
            "NOL7",
            "ZFP90",
            "CSNK2B",
            "SMARCB1",
            "TMCO7",
            "MON1B",
            "GLG1",
            "SPG11",
            "POLDIP2",
            "N4BP1",
            "CNOT1",
            "TIMM22",
            "NUDT21",
            "ERAL1",
            "DYNC1LI2",
            "TMEM170A",
            "AP1G1",
            "C4orf41"
        ]
    },
    {
        "golabel": "CHURC1_regulon_activity",
        "gene": [
            "IGJ",
            "THEMIS",
            "PDE1A",
            "LOC339524",
            "KLRB1",
            "MGP",
            "TMEM184A",
            "IQGAP3",
            "SPTBN2",
            "HSPB2",
            "FBXO41",
            "ECSCR",
            "HNMT",
            "GIMAP2",
            "CCNF",
            "CGRRF1",
            "AZI1",
            "POLE",
            "INTS1",
            "TCEAL1",
            "FBXL19",
            "KLHDC2",
            "DHX34",
            "RBM3",
            "UBLCP1",
            "ZNF410",
            "C17orf48",
            "RPL36AL",
            "ZCCHC10",
            "MAT2B",
            "BTF3",
            "TXNDC15",
            "RPTOR",
            "FBXL5",
            "MED7",
            "ANKRA2",
            "IGBP1",
            "LYRM7",
            "DVL3",
            "GIT1",
            "ACTR10",
            "UBE2O",
            "PCNXL3",
            "NDFIP1",
            "GIN1",
            "C11orf46",
            "FAM114A2",
            "SRRT",
            "SMPD4",
            "FOXK2",
            "ELP4",
            "MPP5",
            "C5orf24",
            "TMED10",
            "NPLOC4",
            "USP36",
            "JKAMP",
            "PPP2R5C",
            "ZBTB1",
            "DAZAP1"
        ]
    },
    {
        "golabel": "CIC_regulon_activity",
        "gene": [
            "LIPE",
            "GGN",
            "LTBP4",
            "LYPLA1",
            "NSMCE2",
            "MRPL13",
            "EMG1",
            "LACTB2",
            "C5orf35",
            "DERA",
            "NDUFA4",
            "LRP1",
            "TMEM14B",
            "ADK",
            "LPHN1",
            "NDUFB5",
            "IMMP2L",
            "ACOT13",
            "TMEM14C",
            "MRPS23",
            "MEGF8",
            "RPL26L1",
            "PPIAL4C",
            "MAP3K10",
            "PKD1",
            "MRPS33",
            "LOC401397",
            "MYO18A",
            "KIAA0467",
            "NOTCH1",
            "TXNDC9",
            "COPS3",
            "ATPBD4",
            "MRPS10",
            "SIPA1L3",
            "RAI1",
            "PRDX3",
            "PPIL3",
            "ARHGEF1",
            "MRPL49",
            "NFU1",
            "MRPL1",
            "C10orf84",
            "RUSC2",
            "ATP5C1",
            "ZNF496",
            "PTGES3",
            "CHMP5",
            "MRPS18B",
            "PPA2",
            "GPN3",
            "PMPCB",
            "PSMA2",
            "CABIN1",
            "MLL4",
            "C3orf23",
            "ZNF575",
            "GTF2B",
            "COX18",
            "NIP7",
            "MOBKL3",
            "ATP5F1",
            "IRGQ",
            "ATP5H",
            "EIF1AX",
            "NCOR2",
            "SUPT4H1",
            "KIAA0913",
            "PRR12",
            "GTPBP10",
            "MYO9B",
            "SUMO1P3",
            "KIAA0355",
            "SKI",
            "PSMA1",
            "NECAP1",
            "RAPGEF1",
            "TAF9",
            "C2orf47",
            "ZNF574",
            "TECPR2",
            "OCIAD1",
            "SETD1A",
            "MLX",
            "KDM4B",
            "C11orf58",
            "C19orf61",
            "SPTAN1",
            "SUMO1",
            "TMX2",
            "FRMD8",
            "PHF12",
            "SDHAF2",
            "UBE2D3",
            "AIMP1",
            "PTPN23"
        ]
    },
    {
        "golabel": "CIITA_regulon_activity",
        "gene": [
            "TMEM90A",
            "CHRNA5",
            "CASQ1",
            "ACSM5",
            "RUFY4",
            "FCGBP",
            "CLEC12B",
            "CPE",
            "ROS1",
            "TNFSF14",
            "HSPA7",
            "EMR4P",
            "TSPAN32",
            "TNFAIP2",
            "LOC115110",
            "PROX2",
            "C4A",
            "C11orf21",
            "C9orf139",
            "PLD4",
            "HLA-DRB6",
            "FUT7",
            "HLA-DOA",
            "PIK3R6",
            "SLC25A15",
            "SCARF1",
            "HLA-DRB1",
            "LOC100272216",
            "APOB48R",
            "HCG26",
            "SPATC1",
            "HLA-DMB",
            "HCG27",
            "NLRP1",
            "CD37",
            "RRN3P2",
            "SPN",
            "HLA-DRA",
            "HLA-DPA1",
            "NFAM1",
            "HLA-DPB1",
            "PSTPIP1",
            "ITGAL",
            "NFKBID",
            "TTLL3",
            "ITGB2",
            "HLA-F",
            "CCDC88B",
            "PARVG",
            "PLCB2",
            "SNX20",
            "ARHGAP9",
            "DOCK2",
            "SPI1",
            "ZMYND15",
            "FGD2",
            "CD74",
            "HLA-DMA",
            "HLA-L",
            "TNFRSF14",
            "SLC15A3",
            "GPR132",
            "GAB3",
            "MTFR1",
            "MYO1F",
            "TRAF1",
            "GPR113",
            "C1orf152",
            "DOCK8",
            "NCF4",
            "ARHGAP30",
            "WAS",
            "PLEKHM1P",
            "BNIP3",
            "CBX7",
            "CD97",
            "CBLN3",
            "TRIM22",
            "HIVEP3",
            "PION",
            "MAP3K14",
            "FLT3LG",
            "DENND3",
            "CCDC109A",
            "C5orf56",
            "C2orf15",
            "AKNA",
            "PSMB5",
            "HMHA1",
            "UBA7",
            "TMEM68",
            "PML",
            "ARHGEF10L",
            "EVL",
            "BTN2A3",
            "PLEKHA1",
            "MVP",
            "PHF15",
            "RCN2",
            "C14orf159",
            "TGIF1",
            "TCEA1",
            "LYST",
            "PDIA6",
            "FCHSD1",
            "TRIM14",
            "LOC221710",
            "NUDT15",
            "TEP1",
            "VDAC2",
            "AMPD3",
            "ARL3",
            "C19orf66",
            "RAB43",
            "BTN2A2",
            "FAM119A",
            "FAM111A",
            "MTMR2",
            "RPN2",
            "LCLAT1",
            "CLCN7",
            "ALPK1",
            "RFX5",
            "C10orf58",
            "RAB2A",
            "MOBKL2C",
            "YWHAE",
            "MRPS16",
            "GGA2",
            "CBARA1",
            "NFKB1",
            "CHUK",
            "YIPF4",
            "CTBP2",
            "BMPR1A",
            "DDX1",
            "TMEM110",
            "DKFZp761E198",
            "FKBP15",
            "MARCH5",
            "ANP32A",
            "TM9SF1",
            "EML3",
            "PPP1R11"
        ]
    },
    {
        "golabel": "CNBP_regulon_activity",
        "gene": [
            "KLRC1",
            "XCL2",
            "TMEM22",
            "RSL24D1",
            "AK3L1",
            "KIF26B",
            "ARVCF",
            "PFDN5",
            "FAM162A",
            "RPSAP9",
            "NSMCE2",
            "NOTCH4",
            "HIGD1A",
            "RPL24",
            "SELT",
            "CRIPT",
            "RPL35A",
            "SHANK3",
            "NDUFB5",
            "CCDC58",
            "COQ3",
            "C6orf162",
            "INTS1",
            "MED28",
            "NUAK2",
            "COX7A2L",
            "PDCD10",
            "C3orf26",
            "SELK",
            "PKD1",
            "CCDC59",
            "NUP37",
            "TMEM63A",
            "MYO18A",
            "NIT2",
            "NPM1",
            "NDUFB4",
            "NCK1",
            "SSR3",
            "IQCE",
            "CHCHD6",
            "LLGL2",
            "MYNN",
            "NUDT16P1",
            "RAB11FIP3",
            "RAI1",
            "COX17",
            "TNRC18",
            "SRPRB",
            "C1orf198",
            "CASKIN2",
            "LYSMD2",
            "NMD3",
            "GYG1",
            "PTGES3",
            "SERP1",
            "PSMB1",
            "RG9MTD1",
            "HMGB1",
            "GPN3",
            "RARS2",
            "DNAJC19",
            "POLE3",
            "UBE2N",
            "RCHY1",
            "RNF7",
            "MRPS22",
            "NAA50",
            "SIAH2",
            "UMPS",
            "YAF2",
            "PCSK7",
            "UBE2E1",
            "THOC7",
            "ANKRD42",
            "ATP13A2",
            "SDHB",
            "COPS2",
            "PCCB",
            "PARL",
            "LSM6",
            "C3orf1",
            "SUMO1P3",
            "MRPL3",
            "ANAPC10",
            "UBA3",
            "TSC2",
            "PCNP",
            "LSM3",
            "SLC35A5",
            "ARHGEF11",
            "AP2M1",
            "SPCS1",
            "OXNAD1",
            "PCMT1",
            "IGHMBP2",
            "SYVN1",
            "ZCRB1",
            "NLRX1",
            "PPP1R2",
            "MADD",
            "ABHD10",
            "PLD2",
            "RABL3",
            "EIF1B",
            "TMEM104",
            "PAIP2",
            "C3orf37",
            "FRG1",
            "C7orf26",
            "RPN1",
            "SUMO1",
            "PPP1R10",
            "PWP1",
            "AKIRIN2",
            "EIF2A",
            "ANAPC13",
            "METTL6",
            "SH3BP5L",
            "WTAP",
            "SNX4",
            "ATG3",
            "ATP6V1A",
            "PPHLN1",
            "UBA5",
            "ISY1",
            "UBE2D3",
            "RAB7A",
            "C3orf17",
            "RPP14"
        ]
    },
    {
        "golabel": "CNOT3_regulon_activity",
        "gene": [
            "LAMA5",
            "CLIC2",
            "RAB38",
            "SUV420H2",
            "CD59",
            "THAP2",
            "STARD3NL",
            "CNN3",
            "TCEAL1",
            "GNG12",
            "CNOT8",
            "FBRSL1",
            "MR1",
            "CD47",
            "SFRS16",
            "GLTSCR1",
            "FBXO46",
            "ECHDC1",
            "LAMP2",
            "DHX34",
            "PPT1",
            "INSIG2",
            "KLC2",
            "MLL4",
            "PPP1R12C",
            "ZNF8",
            "C19orf54",
            "MYPOP",
            "HEXB",
            "MAT2B",
            "PLCB3",
            "FIZ1",
            "EIF1AX",
            "TRIM28",
            "MMGT1",
            "MIER1",
            "SETD8",
            "SCAF1",
            "WHSC2",
            "FAM114A2",
            "ZNF384",
            "EHMT1",
            "ATXN7L3",
            "SARS",
            "NAIF1",
            "VAMP3",
            "FAM193A",
            "SEC22C",
            "UBE2D3",
            "FBXO18"
        ]
    },
    {
        "golabel": "CNOT7_regulon_activity",
        "gene": [
            "SLC7A2",
            "SEC11C",
            "TUSC3",
            "C8orf4",
            "APOB48R",
            "PDGFRL",
            "C1orf126",
            "PPP1R3B",
            "CDC42EP1",
            "FZD3",
            "EVPL",
            "MICALL2",
            "FBXO16",
            "PCM1",
            "FBF1",
            "ZDHHC2",
            "VPS37A",
            "NAT1",
            "AGPAT5",
            "FDFT1",
            "CRIPT",
            "FECH",
            "PINX1",
            "ERI1",
            "UBXN8",
            "C18orf32",
            "TXNL1",
            "HMHA1",
            "PPP2R2A",
            "LONRF1",
            "TGFB1",
            "MAPKBP1",
            "TFAM",
            "ARHGEF10L",
            "HMBOX1",
            "MRPL42",
            "NEIL2",
            "FUT10",
            "PRDX3",
            "RHBDF1",
            "SLC12A9",
            "FBXO25",
            "ELP3",
            "BNIP3L",
            "SFXN3",
            "NCRNA00081",
            "KCTD9",
            "WRN",
            "SRP9",
            "MOBKL3",
            "UBE2N",
            "TNKS",
            "GTF2E2",
            "CLCN7",
            "DYM",
            "INTS10",
            "C20orf30",
            "MED15",
            "MAK16",
            "PLEKHM1",
            "COPS2",
            "DCTN6",
            "MYO9B",
            "URGCP",
            "TTC7A",
            "ARL5A",
            "C9orf82",
            "HDAC7",
            "MTMR9",
            "MCPH1",
            "PPP2CB",
            "YWHAE",
            "LEPROTL1",
            "PPP1CC",
            "CCDC25",
            "C8orf41",
            "C11orf58",
            "LIN7C",
            "INTS9",
            "TMEM104",
            "CYTH1",
            "XPO7",
            "MARCH5",
            "PDHB",
            "PPP3R1",
            "PPP3CB",
            "GABPB1",
            "XRCC5",
            "FASTKD2"
        ]
    },
    {
        "golabel": "COPS2_regulon_activity",
        "gene": [
            "FLJ44635",
            "RPL31P11",
            "RSL24D1",
            "ANP32C",
            "VENTX",
            "LOC729176",
            "EEF1B2",
            "LOC91316",
            "ATG16L2",
            "GDPD5",
            "LOC349114",
            "C2orf81",
            "SLC25A35",
            "MAPK8IP3",
            "CROCC",
            "KIF21B",
            "LOC649330",
            "GTF2A2",
            "HIGD1A",
            "MORF4",
            "SQRDL",
            "CEMP1",
            "FBF1",
            "LOC399744",
            "PLXNA3",
            "CNIH",
            "DUSP8",
            "FLJ45340",
            "DAGLA",
            "ANKS3",
            "GIGYF1",
            "AZI1",
            "UBXN8",
            "MAPK6",
            "GBE1",
            "NDFIP2",
            "SPPL2B",
            "ORAI2",
            "PKD1",
            "PPP2R2A",
            "PLCG1",
            "TRUB1",
            "MYO18A",
            "KIAA0467",
            "NPM1",
            "TFAM",
            "ARHGEF10L",
            "RPL4",
            "TNK2",
            "SFI1",
            "DTWD1",
            "MRPL39",
            "ATPBD4",
            "ZMIZ2",
            "FUT10",
            "SIPA1L3",
            "RAB11FIP3",
            "SLC12A9",
            "ZNF707",
            "HEATR7A",
            "ADAL",
            "AVEN",
            "C17orf56",
            "MLLT6",
            "RGS12",
            "C2orf49",
            "ZNF770",
            "SEPT10",
            "C15orf57",
            "TELO2",
            "NCKAP5L",
            "C15orf24",
            "ATF1",
            "LOC729082",
            "LRRC28",
            "FBXO22",
            "ISCA1P1",
            "TMEM87A",
            "CORO7",
            "ZNF280D",
            "S1PR2",
            "GHITM",
            "CEP164",
            "TRIM62",
            "TBCD",
            "BTF3",
            "CLCN7",
            "SPPL2A",
            "TMEM85",
            "ZNF35",
            "UBE2E1",
            "MRPS27",
            "DCTN6",
            "GALK2",
            "SPATA5L1",
            "IDH3A",
            "NDUFAF1",
            "MMADHC",
            "C9orf85",
            "ZFAND6",
            "PACS2",
            "NPTN",
            "ELMOD2",
            "USP3",
            "LRSAM1",
            "SRP72",
            "C17orf70",
            "C9orf82",
            "TMED7",
            "KIAA0195",
            "GNPDA2",
            "EIF4E",
            "MAP2K1",
            "ATG2A",
            "GRINL1A",
            "CTDSPL2",
            "CNOT7",
            "COPS4",
            "TRNT1",
            "EIF3J",
            "GNB5",
            "SUCLA2",
            "CASC4",
            "NIPA2",
            "SPCS3",
            "RAB18",
            "OCIAD1",
            "ADRBK1",
            "CLPX",
            "ISCA1",
            "C11orf58",
            "EID1",
            "FEM1B",
            "MORF4L1",
            "VPS37C",
            "HAUS2",
            "USP8",
            "MESDC2",
            "MFAP1",
            "CNBP",
            "METTL6",
            "SNAP23",
            "NARG2",
            "TRIP4",
            "ARPP19",
            "ARL8B",
            "PPP3R1",
            "SNRNP27",
            "PLDN",
            "RWDD4A",
            "ASB7",
            "UBE3A",
            "UBE2D3",
            "BTBD1",
            "CSNK1D",
            "RPP14"
        ]
    },
    {
        "golabel": "COPS3_regulon_activity",
        "gene": [
            "NCRNA00188",
            "RSL24D1",
            "RPS18",
            "RPS7",
            "RPS10",
            "WDR52",
            "ALS2CL",
            "UBE2Q2P1",
            "LOC91316",
            "RPS3",
            "LOC100132247",
            "LOC100128842",
            "C15orf52",
            "CHAC2",
            "LOC100190986",
            "LOC90834",
            "CROCCL2",
            "HAUS1",
            "MST1R",
            "EVPL",
            "MRPS35",
            "MED31",
            "SNRPD2",
            "UQCRFS1",
            "B9D1",
            "GOLGA7",
            "PEMT",
            "TRIM66",
            "RPL41",
            "LSM2",
            "FLJ45340",
            "TOMM22",
            "COMMD10",
            "TOMM5",
            "RAN",
            "CDC42BPG",
            "AHCY",
            "GIGYF1",
            "VPS29",
            "C1QBP",
            "EIF3E",
            "NKTR",
            "TUBGCP6",
            "H6PD",
            "PSMD8",
            "TBPL1",
            "ABCA2",
            "ADSL",
            "AHDC1",
            "PKD1",
            "MRPL11",
            "TMEM63A",
            "PSMA3",
            "KIAA0467",
            "CDKN2AIPNL",
            "C12orf29",
            "TFAM",
            "STOML2",
            "TPRKB",
            "MRPL39",
            "PRPSAP2",
            "ERH",
            "PRDX3",
            "OLA1",
            "TNRC18",
            "RBM6",
            "DPH5",
            "FAM18B",
            "CCT4",
            "C17orf48",
            "SRRM2",
            "PTGES3",
            "ZDHHC7",
            "EHBP1L1",
            "YWHAQ",
            "GPN3",
            "TMEM18",
            "ILF2",
            "KIAA0556",
            "DRG1",
            "NFAT5",
            "TNKS1BP1",
            "POLE3",
            "UBE2N",
            "CRAMP1L",
            "CIC",
            "CLEC16A",
            "YAF2",
            "PCSK7",
            "SDHB",
            "DRG2",
            "TMEM11",
            "TAOK2",
            "ATPAF2",
            "NUMA1",
            "CHD2",
            "PSD4",
            "PRKAG1",
            "PDCD2",
            "PSMA1",
            "YWHAE",
            "CCT8",
            "TNRC6A",
            "UBB",
            "EIF2B3",
            "RBM33",
            "MRPL35",
            "TMEM199",
            "MAP2K4"
        ]
    },
    {
        "golabel": "COPS4_regulon_activity",
        "gene": [
            "FUNDC2P2",
            "CETN4P",
            "RPS3A",
            "NPIPL3",
            "TMEM184A",
            "SNURF",
            "C4orf12",
            "LOC100132247",
            "C6orf57",
            "C4orf36",
            "MAPK8IP3",
            "BAG4",
            "PAQR3",
            "TMEM86B",
            "NUDT6",
            "ANO8",
            "CFL2",
            "SELT",
            "PPP2R3C",
            "CNIH",
            "MRPL33",
            "COMMD8",
            "CGRRF1",
            "C4orf33",
            "FLJ45340",
            "PGK1",
            "SC4MOL",
            "HINT1",
            "TTC5",
            "FAM175A",
            "EEF1A1",
            "COMMD10",
            "DCK",
            "SEP15",
            "GIGYF1",
            "VBP1",
            "SCOC",
            "MED28",
            "SLC25A5",
            "SAR1B",
            "SPPL2B",
            "CYB5R4",
            "CNOT8",
            "PKD1",
            "FBRSL1",
            "ARL6",
            "LEPROT",
            "TNK2",
            "IQCE",
            "SLC25A4",
            "GLTSCR1",
            "RG9MTD2",
            "RRBP1",
            "MRPL49",
            "HEATR7A",
            "TNRC18",
            "CASKIN2",
            "BBS12",
            "SNAPC4",
            "MRPL1",
            "C17orf56",
            "PEX3",
            "HADH",
            "C16orf63",
            "TIFA",
            "RP2",
            "TMEM218",
            "ZNF410",
            "GYG1",
            "SRC",
            "PTGES3",
            "MAGT1",
            "DCTN3",
            "SNX3",
            "PPA2",
            "YWHAQ",
            "FAM188A",
            "ZC3H3",
            "NUDCD2",
            "SOLH",
            "GPN3",
            "PRCP",
            "RAB33B",
            "ZCCHC10",
            "MLL4",
            "ADH5",
            "C5orf44",
            "UBN2",
            "NSL1",
            "COX18",
            "NME7",
            "MTMR6",
            "GMFB",
            "CDC42",
            "SKP1",
            "ATP5F1",
            "RCHY1",
            "C4orf27",
            "CCDC111",
            "PACRGL",
            "ATG5",
            "EIF1AX",
            "PEX19",
            "NCOR2",
            "SNRNP70",
            "CISD2",
            "HSPA8",
            "PPP1R2P3",
            "SIN3B",
            "SLC25A46",
            "ERCC8",
            "GOLGA3",
            "FBXL5",
            "COPS2",
            "TAF1B",
            "MAPK7",
            "MMADHC",
            "IPO11",
            "MMGT1",
            "CCNI",
            "KLHL8",
            "ELMOD2",
            "RAP1GDS1",
            "RPA2",
            "NUP54",
            "WDR41",
            "RBM7",
            "LSM6",
            "FARS2",
            "SRP72",
            "EIF2S1",
            "ZNF335",
            "ZFP1",
            "COQ2",
            "MED25",
            "PIGY",
            "EIF4E",
            "DNAJB14",
            "MAPKSP1",
            "SNRNP40",
            "ANAPC10",
            "PCNP",
            "ELAC1",
            "LOC550112",
            "AXIN1",
            "SUCLA2",
            "SYVN1",
            "SCAF1",
            "MUTED",
            "ASNSD1",
            "KIAA1704",
            "G3BP2",
            "ENOPH1",
            "MRPS18C",
            "C4orf43",
            "REXO1",
            "CRTC2",
            "RNF41",
            "ATP13A1",
            "BRD1",
            "ELP4",
            "C11orf58",
            "CDKN2AIP",
            "SFRS8",
            "EIF1B",
            "FBXO8",
            "PAIP2",
            "FRG1",
            "ARFIP1",
            "METAP1",
            "THAP9",
            "C4orf3",
            "THAP6",
            "GRSF1",
            "C22orf28",
            "SNX2",
            "PPP2R5C",
            "SMARCAD1",
            "ATXN10",
            "RWDD4A",
            "HELQ",
            "UFSP2",
            "INTS12",
            "RAB28",
            "HIAT1",
            "UBE2D3",
            "SAFB",
            "DYNC1LI1",
            "MLH1"
        ]
    },
    {
        "golabel": "CRAMP1L_regulon_activity",
        "gene": [
            "USP49",
            "LOC100132247",
            "RPL23AP64",
            "SNORA39",
            "MAPK8IP3",
            "LOC100190986",
            "SPDYE7P",
            "PRDX4",
            "FLJ42627",
            "LOC283922",
            "C9orf46",
            "FLJ45340",
            "LOC442454",
            "GIGYF1",
            "UNKL",
            "PKD1",
            "C22orf29",
            "PSMA3",
            "KIAA0467",
            "MAPKBP1",
            "COPS3",
            "PRDX3",
            "C10orf84",
            "MLLT6",
            "SRRM2",
            "C2CD2",
            "CABIN1",
            "ZNF70",
            "LRRC28",
            "CISD1",
            "TBCA",
            "SLC7A6",
            "UBE2N",
            "RRN3P3",
            "ZBTB40",
            "CISD2",
            "SIN3B",
            "DIDO1",
            "BLOC1S2",
            "ARL1",
            "TSC2",
            "PSMA1",
            "PDPK1",
            "TAF9",
            "TNRC6A",
            "RBM33",
            "SUMO2",
            "ZCRB1",
            "ZNF500",
            "ATP6V1D",
            "UBN1",
            "NFATC2IP",
            "DYNC1LI1",
            "RAB1A"
        ]
    },
    {
        "golabel": "CREB1_regulon_activity",
        "gene": [
            "LOC100271831",
            "COMTD1",
            "THAP7",
            "KRT18",
            "CHCHD10",
            "MRPL41",
            "ANKRD36BP1",
            "ZNF430",
            "DAAM1",
            "ANKRD50",
            "MVD",
            "GTF2A1",
            "C9orf142",
            "SP4",
            "PARP11",
            "VPS18",
            "SLC3A2",
            "RHBDD3",
            "NDUFS8",
            "ANKRD54",
            "ZNF678",
            "NFKBIB",
            "KLHL28",
            "C21orf70",
            "INO80B",
            "C12orf44",
            "NR1D2",
            "FBXW5",
            "ALG3",
            "RNASEK",
            "CLN6",
            "ZDHHC24",
            "DNAJC17",
            "RNF126",
            "COMMD4",
            "MYO1B",
            "ACVR2A",
            "RFNG",
            "PEX16",
            "CCS",
            "SIRT6",
            "NOC4L",
            "UBE2M",
            "AKT1S1",
            "CAB39",
            "WDR47",
            "OSBPL8",
            "MIER1",
            "BRMS1",
            "IKZF5",
            "NDUFV1",
            "ZFPL1",
            "BMPR2",
            "ATP6V0C",
            "WDFY1",
            "SOCS5",
            "PBRM1",
            "ATXN3",
            "PIKFYVE",
            "RSBN1",
            "ING3",
            "SMAD4",
            "ZNF654",
            "CORO1B",
            "MAP2K2",
            "VEZF1",
            "CCNT2",
            "EPC2",
            "FAM178A",
            "TMEM214",
            "SP3",
            "DDX6",
            "DULLARD",
            "ELF2",
            "MATR3"
        ]
    },
    {
        "golabel": "CREB3L2_regulon_activity",
        "gene": [
            "ALDH1L2",
            "VCAN",
            "XYLT1",
            "RTP4",
            "GPR157",
            "RAB32",
            "RPL24",
            "C9orf123",
            "NUDT6",
            "HIPK2",
            "TP53INP2",
            "LCOR",
            "PSMB8",
            "SPATA24",
            "SH3PXD2B",
            "INSR",
            "PDIA4",
            "TMEM42",
            "MCTP2",
            "ZNF32",
            "SIK2",
            "ENTPD7",
            "CALU",
            "PHKA1",
            "EXOSC8",
            "NIPSNAP3A",
            "LIAS",
            "KLHDC10",
            "CHCHD6",
            "PCYT2",
            "NOSIP",
            "FAM114A1",
            "MRPL39",
            "MAN1A2",
            "MAGED1",
            "SH3PXD2A",
            "NMI",
            "C10orf12",
            "CRYBG3",
            "MTG1",
            "LYSMD2",
            "LYSMD4",
            "FNDC3B",
            "C10orf118",
            "AKAP9",
            "ADH5",
            "DNAJC19",
            "CHPF2",
            "MITD1",
            "C4orf27",
            "ZNF275",
            "SEC24D",
            "MLL3",
            "SETD7",
            "UBE2H",
            "TBCC",
            "RNASEH2B",
            "LIPT1",
            "ALDH18A1",
            "EIF2AK3",
            "MED7",
            "LSM6",
            "SEC24A",
            "PHF11",
            "SLC37A3",
            "DDX28",
            "SYVN1",
            "EXOSC7",
            "MRPS18C",
            "USP9X",
            "C3orf75",
            "ESD",
            "HDLBP",
            "SRPR",
            "ARCN1",
            "SFRS3",
            "MKLN1",
            "PRRC1",
            "GBF1",
            "SFRS7",
            "ZNF398",
            "SND1",
            "SEC31A"
        ]
    },
    {
        "golabel": "CREB3L4_regulon_activity",
        "gene": [
            "KIT",
            "C2CD4D",
            "SPDEF",
            "C9orf152",
            "DUSP23",
            "NLRP3",
            "PTAFR",
            "ATP1B1",
            "DST",
            "DPM3",
            "TC2N",
            "AIM1",
            "KLHDC9",
            "AXL",
            "CSF1R",
            "RORC",
            "STARD10",
            "VIM",
            "C1orf56",
            "FBXO16",
            "C10orf41",
            "BAG1",
            "ITGAV",
            "MXRA7",
            "ETS1",
            "XBP1",
            "BOLA1",
            "ADAP2",
            "FAAH2",
            "LHFPL2",
            "MCEE",
            "TMEM9",
            "ECE1",
            "DUSP7",
            "KIAA1949",
            "NOTCH2",
            "SFXN2",
            "MRPS21",
            "APOA1BP",
            "LRRC8C",
            "HAX1",
            "HSD17B7",
            "C14orf167",
            "RAB25",
            "LYSMD1",
            "TGFB1",
            "FAM63A",
            "MYO5A",
            "ARV1",
            "C1orf43",
            "STK10",
            "MOAP1",
            "GABPB2",
            "H3F3A",
            "TARBP1",
            "ZSCAN16",
            "SH2B3",
            "C10orf57",
            "EHD1",
            "SNAPIN",
            "FMNL3",
            "PIP4K2A",
            "PPOX",
            "PMF1",
            "SSR2",
            "JTB",
            "ZYX",
            "SDHC",
            "C1orf66",
            "PIGM",
            "MAP7D1",
            "PRUNE",
            "PNPLA6",
            "ANO6",
            "BCDIN3D",
            "ENSA",
            "UFC1",
            "ARFIP2",
            "C1orf27",
            "ALDH9A1",
            "MRPS14",
            "TMCO1",
            "SCYL3",
            "USP21",
            "GNAI2",
            "PYCR2",
            "PYGO2",
            "RBMS1",
            "RAB4A",
            "JAK1",
            "C1orf131",
            "RNF187",
            "GGPS1",
            "COG2",
            "ESYT1",
            "SH3GLB1",
            "GRB2"
        ]
    },
    {
        "golabel": "CREBBP_regulon_activity",
        "gene": [
            "CKS2",
            "RPL27",
            "GTF3A",
            "ATP5J2",
            "TIMM8B",
            "SNRPG",
            "LOC440957",
            "PFDN5",
            "GTF2A2",
            "ADCY9",
            "RPSAP9",
            "MED31",
            "NDUFB9",
            "COX7B",
            "HIGD1A",
            "C8orf59",
            "MRPL13",
            "FOXN3",
            "BUD31",
            "TCEB1",
            "LOC100130932",
            "MRPS15",
            "POMP",
            "FAM161B",
            "RPL38",
            "EBP",
            "TMEM126B",
            "CCDC72",
            "TOMM5",
            "PPIAL4G",
            "UQCRH",
            "RUNDC2A",
            "ZNF597",
            "NDUFB6",
            "VPS29",
            "USMG5",
            "HEBP2",
            "COMMD3",
            "C10orf78",
            "RBX1",
            "ATP5E",
            "C14orf156",
            "DBI",
            "PHF5A",
            "ATP5J",
            "ATP5O",
            "COX5A",
            "C14orf2",
            "ZNF827",
            "ATP5G3",
            "MRPL39",
            "NDUFB3",
            "SARNP",
            "MRPL32",
            "GLRX2",
            "TMEM126A",
            "ERC1",
            "SS18L2",
            "ATP5C1",
            "FOXO3",
            "MRPL40",
            "TFB1M",
            "PSMA5",
            "SRRM2",
            "ASH1L",
            "CHCHD1",
            "SNN",
            "ARPC3",
            "PSMA2",
            "MKL2",
            "ALG14",
            "SSBP1",
            "SNX29",
            "PSMA4",
            "ATP5H",
            "ANKS1A",
            "CLEC16A",
            "GTF3C6",
            "THOC7",
            "C7orf25",
            "KIAA0430",
            "UQCRC1",
            "CLTA",
            "PDPK1",
            "LSM3",
            "TAF9",
            "SPEN",
            "SPCS1",
            "ZNF646",
            "ZCCHC14",
            "MRPS18C",
            "ATXN1L",
            "EP300",
            "ZNF500",
            "MDH1",
            "ARID1B",
            "FOXJ2",
            "PHF2",
            "ZDHHC6",
            "MAML1",
            "UBN1",
            "AMBRA1",
            "PSMD6",
            "C16orf72",
            "USP7"
        ]
    },
    {
        "golabel": "CREBL2_regulon_activity",
        "gene": [
            "F13A1",
            "P2RY12",
            "FAM134B",
            "TMEM37",
            "MYBL2",
            "CDC20",
            "ITPR1",
            "CYBRD1",
            "SLC40A1",
            "CDT1",
            "RECQL4",
            "SEPP1",
            "PKMYT1",
            "CALCRL",
            "EME1",
            "IL6ST",
            "PSRC1",
            "NFKBIL2",
            "CHTF18",
            "C16orf59",
            "TRAIP",
            "EPS8",
            "DBNDD1",
            "FCHO2",
            "KPTN",
            "TGFBR2",
            "DNAH14",
            "C21orf45",
            "SAC3D1",
            "KAT2B",
            "C5orf41",
            "PARP11",
            "PTCD1",
            "TUBG1",
            "C20orf20",
            "DUSP16",
            "ATAD3A",
            "MRPL2",
            "PPAN",
            "SRM",
            "CCDC86",
            "ITM2B",
            "TBRG4",
            "LPCAT3",
            "FAM189B",
            "FKBPL",
            "C1orf35",
            "MAT2B",
            "ADRM1",
            "RRP1",
            "DDX27",
            "IQGAP1",
            "GMEB2",
            "GNPTAB",
            "M6PR",
            "CDC42SE2",
            "GTF2H4",
            "GSS",
            "NECAP1",
            "ACTR5",
            "SLC35A5",
            "TSPYL1",
            "NCOA4",
            "PJA2",
            "HEBP1",
            "GNL2",
            "CDKN1B",
            "SRRT",
            "SMPD4",
            "ELF1",
            "FOXJ2",
            "ZSWIM1",
            "SLU7",
            "EXOSC10"
        ]
    },
    {
        "golabel": "CREM_regulon_activity",
        "gene": [
            "HBD",
            "CLEC4D",
            "IL8",
            "LILRA5",
            "CTSL1",
            "ADAMTS4",
            "SRGN",
            "C1orf116",
            "PDE1A",
            "CACNB1",
            "C3orf59",
            "LOC284837",
            "KCNK5",
            "BAG2",
            "RHOH",
            "SNRPG",
            "FAM92A1",
            "PDE4B",
            "LOC146880",
            "ID3",
            "MTHFD2",
            "PER3",
            "DTX4",
            "HAUS1",
            "EVPL",
            "C6orf129",
            "RFK",
            "C2orf76",
            "FUNDC2",
            "PITPNM3",
            "COX7A2",
            "PRDX4",
            "C20orf7",
            "PPL",
            "OSBPL7",
            "ITPR3",
            "LRRC70",
            "PLEKHM1P",
            "SOX13",
            "MAP3K8",
            "GLA",
            "MYO5C",
            "NDUFA4",
            "LSM2",
            "MAGEH1",
            "PPFIBP2",
            "HSPA13",
            "ATP1B3",
            "RAN",
            "CDC42BPG",
            "GIGYF1",
            "HBXIP",
            "USMG5",
            "C18orf32",
            "POLR2K",
            "COMMD3",
            "CDK18",
            "CYCS",
            "IKBIP",
            "OSTC",
            "LOC90110",
            "SELK",
            "ZNF589",
            "TBPL1",
            "TXNL1",
            "C19orf10",
            "ARHGAP32",
            "TMEM63A",
            "RAB23",
            "PLEKHA7",
            "NFIL3",
            "CLIC4",
            "PLXNB2",
            "PAK6",
            "RCN2",
            "MRPL42",
            "MTMR3",
            "EPS8L2",
            "HSPA14",
            "ARHGAP27",
            "FKBP7",
            "SIPA1L3",
            "SLC12A9",
            "PSMD14",
            "CCDC126",
            "C12orf23",
            "EPB41L1",
            "NDUFAF4",
            "MLLT6",
            "CNKSR1",
            "TEP1",
            "SELS",
            "ATP5C1",
            "NCRNA00081",
            "ARL3",
            "FARP2",
            "ZDHHC7",
            "RECQL5",
            "FYCO1",
            "DNAJC1",
            "MKKS",
            "PRCP",
            "CABIN1",
            "MLLT4",
            "AKAP1",
            "ISCA1P1",
            "CISD1",
            "KIAA1522",
            "TNKS1BP1",
            "PSMA4",
            "UBE2N",
            "DPH3",
            "ATP6V0A1",
            "YAF2",
            "PLEKHM1",
            "CHIC2",
            "MLL",
            "RABEPK",
            "TAOK2",
            "RBM7",
            "NUMA1",
            "DYNLL1",
            "EZH1",
            "GDI2",
            "CDC123",
            "PDPK1",
            "SPCS3",
            "RAB18",
            "CUL2",
            "LEPROTL1",
            "MADD",
            "MLL5",
            "ISCA1",
            "ZMYM3",
            "MORF4L1",
            "SPTAN1",
            "GGA3",
            "KCTD2",
            "TOLLIP",
            "ZNF490",
            "WTAP",
            "NRBF2",
            "AMBRA1",
            "HECTD3",
            "DDX42",
            "ZC3H4",
            "MKRN1",
            "ARFGAP2"
        ]
    },
    {
        "golabel": "CRTC1_regulon_activity",
        "gene": [
            "RET",
            "GRK1",
            "TMEM59L",
            "CRLF1",
            "C1orf95",
            "LRRC16B",
            "PRMT8",
            "TSPAN11",
            "MCF2L",
            "ARNTL2",
            "PNPLA7",
            "RASSF10",
            "KIAA1683",
            "ZNF710",
            "KCNJ11",
            "KCNIP3",
            "LOC151009",
            "GOLGA7B",
            "ASPH",
            "PLA2G6",
            "MYO15A",
            "LOC92973",
            "INPP5J",
            "BZRAP1",
            "ZFAND2A",
            "FITM1",
            "LRRC56",
            "ERO1L",
            "SRCIN1",
            "ANO9",
            "KSR1",
            "TMEM80",
            "ANXA2P1",
            "EBF4",
            "C9orf45",
            "GALNT3",
            "ARVCF",
            "GRAMD4",
            "SQRDL",
            "S100A10",
            "ZNF219",
            "CAMKK1",
            "BAHCC1",
            "FOXP4",
            "ANXA2P2",
            "CACNB3",
            "HS6ST1",
            "EPOR",
            "ProSAPiP1",
            "TLE2",
            "GGT7",
            "FAM125B",
            "SC4MOL",
            "CCDC88C",
            "MZF1",
            "PPP1R13B",
            "PGM2",
            "CCDC90B",
            "SLC25A42",
            "SPPL2B",
            "PGAM4",
            "PKD1",
            "ZNF337",
            "CLDN12",
            "NEK8",
            "ARHGAP10",
            "RALB",
            "GPN1",
            "SSR3",
            "GLTSCR1",
            "ATPBD4",
            "TMEM8B",
            "BCL10",
            "SSBP4",
            "RAB11FIP3",
            "TRIM3",
            "NMI",
            "PGPEP1",
            "CIRBP",
            "ETFA",
            "RGS12",
            "PSMA5",
            "BCAP29",
            "HIBADH",
            "SFRS14",
            "PATZ1",
            "CABIN1",
            "KDM6B",
            "KLHL26",
            "BRF1",
            "ANXA5",
            "NISCH",
            "ATG5",
            "SPPL2A",
            "SIN3B",
            "LACTB",
            "MXD4",
            "DR1",
            "CHMP2B",
            "MMADHC",
            "UPF1",
            "GRPEL1",
            "AMD1",
            "SRP72",
            "NUMA1",
            "KIAA0195",
            "EIF4E",
            "LDB1",
            "HDAC5",
            "ACTR3",
            "TSC2",
            "WDR6",
            "PTP4A2",
            "HCCS",
            "ZCRB1",
            "NIPA2",
            "CAMTA2",
            "C4orf43",
            "POMT1",
            "BRD1",
            "RARS",
            "CAPZA1",
            "NUS1",
            "HSPA4",
            "HAUS2",
            "WDTC1",
            "KIAA0892",
            "GNAI3",
            "SF4"
        ]
    },
    {
        "golabel": "CTBP2_regulon_activity",
        "gene": [
            "TSPAN32",
            "RASGRP2",
            "C11orf21",
            "C9orf139",
            "ITGAX",
            "FGR",
            "C14orf139",
            "SPN",
            "AMICA1",
            "CD33",
            "HLA-DPB1",
            "DOK2",
            "ITGB2",
            "PARVG",
            "PIK3R5",
            "CIITA",
            "FGD2",
            "CD74",
            "ANKRD58",
            "BTK",
            "GAB3",
            "MYO1F",
            "NCF4",
            "ARHGAP30",
            "CBX7",
            "TRIM22",
            "ZNF442",
            "GLRX3",
            "KIAA1598",
            "ENTPD7",
            "C10orf2",
            "UBA7",
            "TFAM",
            "ACSL3",
            "PCGF5",
            "CCNJ",
            "ERLIN1",
            "PRDX3",
            "PWWP2B",
            "VDAC2",
            "DNMBP",
            "MAPK8",
            "BTN2A2",
            "PDCD11",
            "DHX32",
            "BBS9",
            "UROS",
            "GHITM",
            "HDGF",
            "ALDH18A1",
            "ECHS1",
            "BCCIP",
            "CARD8",
            "NOLC1",
            "TM9SF3",
            "KCMF1",
            "MRPS16",
            "EIF3A",
            "FAM45A",
            "SUPV3L1",
            "CHUK",
            "NCKAP1",
            "NT5C2",
            "C10orf88",
            "BMPR1A",
            "VPS26A",
            "COX15",
            "MARCH5",
            "PPRC1",
            "PPP2R2D",
            "C10orf119",
            "ATAD1",
            "GORASP2",
            "HNRNPF",
            "SEC23IP",
            "ZRANB1",
            "SMNDC1",
            "TIAL1",
            "MMS19",
            "FAM175B"
        ]
    },
    {
        "golabel": "CTCF_regulon_activity",
        "gene": [
            "CST6",
            "DHDH",
            "TREM2",
            "HAGHL",
            "SNX21",
            "FAT1",
            "PFN4",
            "UPP1",
            "LOC723972",
            "C7orf40",
            "TAF1L",
            "ATP8B1",
            "RAB38",
            "CMIP",
            "FAHD2B",
            "RBKS",
            "LCOR",
            "GPX1",
            "TRNAU1AP",
            "FBXO6",
            "STRADB",
            "KCTD3",
            "CAMK1",
            "NAA30",
            "CMTM4",
            "TUBG2",
            "RANBP10",
            "SMC3",
            "ZXDB",
            "NFATC3",
            "C1orf52",
            "FAM98B",
            "ZC3H13",
            "AKR1A1",
            "GFOD2",
            "AP4B1",
            "MARCH2",
            "NCOA6",
            "CSNK2A1",
            "PAPOLA",
            "MGA",
            "FAM131A",
            "APBA3",
            "ARID2",
            "YLPM1",
            "ATXN1L",
            "C2orf56",
            "SF3B3",
            "FAM20B",
            "UBE2G1",
            "CNOT1",
            "USP10",
            "CSTF2T",
            "ZC3H18",
            "TFCP2",
            "SRBD1",
            "RBM27",
            "SP1",
            "BRD7",
            "DYNC1LI2",
            "CBFB",
            "AP1G1",
            "TERF2",
            "ATMIN",
            "DHX9",
            "USP7"
        ]
    },
    {
        "golabel": "CTDSPL_regulon_activity",
        "gene": [
            "SLC6A20",
            "PVRL3",
            "SCN7A",
            "CBX2",
            "C1QTNF7",
            "MAMDC2",
            "SLC1A1",
            "SLC4A4",
            "MYBL2",
            "TROAP",
            "RERG",
            "NUF2",
            "FLRT3",
            "TBX4",
            "NFIX",
            "UBE2S",
            "ORC6L",
            "UBE2T",
            "SHROOM4",
            "NR3C2",
            "C16orf59",
            "PLCD1",
            "FRY",
            "SPRY2",
            "TOMM40",
            "KPTN",
            "WWC2",
            "TGFBR2",
            "MRPL12",
            "PFDN2",
            "FRMD4B",
            "THOC4",
            "ZDHHC3",
            "MTX1",
            "TCF7L2",
            "CCDC137",
            "LZTFL1",
            "FOXP1",
            "TRAK2",
            "GNAQ",
            "JMJD6",
            "XPC",
            "CXorf40B",
            "MED6",
            "SACM1L",
            "EIF4EBP2",
            "E2F4",
            "PDCD6IP"
        ]
    },
    {
        "golabel": "CTNNBIP1_regulon_activity",
        "gene": [
            "C6orf176",
            "LOC441177",
            "SLC1A7",
            "CST5",
            "GGTLC1",
            "MMEL1",
            "SUSD2",
            "HOXD1",
            "CLUL1",
            "RHCE",
            "C16orf89",
            "CD1C",
            "ATP13A4",
            "C17orf50",
            "DHDH",
            "SLC7A5",
            "LOC388588",
            "ALDH1L2",
            "C1orf130",
            "NAPSA",
            "C1orf116",
            "ARHGAP11B",
            "PRKAA2",
            "PLLP",
            "CASC5",
            "CACNB1",
            "IFT57",
            "SCARB1",
            "SLC15A2",
            "KIF14",
            "CDCA2",
            "UCK2",
            "NRARP",
            "BUB1B",
            "ARHGAP11A",
            "BLM",
            "MKI67",
            "SLC12A8",
            "SH3BGR",
            "LY6E",
            "C1orf133",
            "GCH1",
            "SOD2",
            "GSG2",
            "S100A13",
            "PER3",
            "SRGAP1",
            "RAB38",
            "HELB",
            "C7orf23",
            "HYI",
            "TEF",
            "TCEA3",
            "ARHGEF19",
            "NCAPD2",
            "EPT1",
            "KIF20B",
            "NAV1",
            "SPRY2",
            "IL28RA",
            "SDC1",
            "SERINC2",
            "MAL2",
            "SLC7A1",
            "TRNAU1AP",
            "FLVCR1",
            "VWA1",
            "FAAH",
            "FLT1",
            "MPHOSPH9",
            "XPOT",
            "SDC4",
            "FUCA1",
            "UBTD1",
            "GRAMD3",
            "ENTPD7",
            "SBNO1",
            "LOC727896",
            "DDX21",
            "C1orf89",
            "MAP3K6",
            "DNAJC10",
            "DARS2",
            "MAPKAPK3",
            "HMBOX1",
            "SESN2",
            "CPNE2",
            "FBXO44",
            "C21orf2",
            "HSP90B1",
            "ECHDC1",
            "ROGDI",
            "DHRS1",
            "THYN1",
            "SPATS2",
            "GDE1",
            "BLVRA",
            "HADH",
            "DAGLB",
            "SUMO3",
            "CAMTA1",
            "ENTPD4",
            "UROD",
            "PDCD11",
            "LMAN1",
            "MFSD9",
            "POLR3GL",
            "SMCR7",
            "PTTG1IP",
            "HMGCL",
            "LDLRAP1",
            "LYPLA2",
            "LYPLA2P1",
            "TBC1D10A",
            "ATP2A2",
            "AKR7A2",
            "UGGT1",
            "TPRG1L",
            "RPS6KA1",
            "MEAF6",
            "NOLC1",
            "PTPN11",
            "PEX10",
            "ELOVL1",
            "CRYZL1",
            "NARS",
            "PHC2",
            "LARP4",
            "PINK1",
            "R3HDM1",
            "RER1",
            "TMEM57",
            "FAM76A",
            "TMEM222",
            "CDV3",
            "LEO1",
            "CPSF3L",
            "PEF1",
            "INVS",
            "TMEM39B",
            "MUL1",
            "PEX14",
            "FAM54B",
            "PNRC2",
            "PRMT2",
            "VAMP3",
            "BSDC1"
        ]
    },
    {
        "golabel": "CUL5_regulon_activity",
        "gene": [
            "AGL",
            "C11orf65",
            "RDX",
            "ACAT1",
            "SH3BGRL3",
            "EFHD2",
            "C20orf177",
            "ZNF579",
            "LOC728024",
            "C11orf54",
            "USP28",
            "CCM2",
            "RBM42",
            "TMEM135",
            "YAP1",
            "FAM100B",
            "ALG9",
            "CAPNS1",
            "DAPK3",
            "ZNF770",
            "FDXACB1",
            "KIAA1826",
            "PRKRIR",
            "ZNF252",
            "DDX10",
            "CCDC124",
            "MTMR2",
            "SF3A2",
            "RNF126",
            "C19orf22",
            "GMCL1",
            "UBR1",
            "RBM7",
            "IPP",
            "ZFP1",
            "DLAT",
            "DBT",
            "EPN1",
            "NAGPA",
            "FKBP8",
            "STX4",
            "ZBTB44",
            "TESK1",
            "IREB2",
            "NPAT",
            "CCDC82",
            "RHOG",
            "STXBP2",
            "CDC37",
            "RAB6A",
            "MAP2K2",
            "ARHGDIA",
            "YTHDF3",
            "AASDHPPT",
            "CEP57",
            "ARCN1",
            "RAD23A",
            "KIAA0776",
            "USO1",
            "TBC1D12",
            "C11orf57",
            "SMARCAD1",
            "ARIH1",
            "NUDT21",
            "SEC23IP",
            "SAP30BP",
            "UBE3A",
            "PPP2R4",
            "USP16",
            "MED17",
            "MATR3"
        ]
    },
    {
        "golabel": "DAB2_regulon_activity",
        "gene": [
            "TIMD4",
            "CLEC4G",
            "CAPN11",
            "F13A1",
            "KCNJ5",
            "C6orf105",
            "FAM70A",
            "SNCA",
            "FOLR2",
            "MRC1",
            "TMEM52",
            "CD163L1",
            "GPNMB",
            "COLEC12",
            "MCTP1",
            "FOXA1",
            "UBASH3B",
            "RASGRP4",
            "SLCO2B1",
            "SDC2",
            "ADCK5",
            "PROS1",
            "VIM",
            "ARRDC4",
            "ARHGAP31",
            "ZNF692",
            "ANTXR2",
            "LPCAT2",
            "LOC202781",
            "ZEB2",
            "MITF",
            "LOC388796",
            "CARD6",
            "PRPF40B",
            "LGMN",
            "ACTR3B",
            "SOX12",
            "TOP1MT",
            "MTHFD2L",
            "WDR34",
            "LOC100125556",
            "TGFBR2",
            "KAT2A",
            "CCHCR1",
            "CPPED1",
            "GPR137B",
            "SLC36A1",
            "ABHD6",
            "FAM65A",
            "PRKRIP1",
            "ATG4D",
            "ATL2",
            "FLAD1",
            "RP2",
            "MNAT1",
            "VPS72",
            "ANKRD16",
            "ZNF3",
            "HEXB",
            "C1orf35",
            "PSAP",
            "TPP1",
            "MTA3",
            "CDK5RAP1",
            "LITAF",
            "SH3D19",
            "TSEN34",
            "DOLPP1",
            "PI4K2A",
            "STX7",
            "SERINC1",
            "SMARCD2",
            "MRPS5",
            "PPP2R2D",
            "PAPSS1"
        ]
    },
    {
        "golabel": "DAZAP2_regulon_activity",
        "gene": [
            "KIFC2",
            "C12orf57",
            "GABARAPL1",
            "PFDN5",
            "CHTF18",
            "TMBIM4",
            "POC1B",
            "C12orf62",
            "ETNK1",
            "BLOC1S1",
            "LOC642852",
            "AZI1",
            "RWDD2A",
            "BTG1",
            "PYROXD1",
            "FBXL19",
            "THBS3",
            "CD63",
            "SLC19A1",
            "MAD1L1",
            "ZDHHC8",
            "ORMDL2",
            "PCNT",
            "GTPBP3",
            "MTA1",
            "CCNDBP1",
            "ATF1",
            "YPEL5",
            "SKP1",
            "C12orf26",
            "PRR13",
            "RRP1",
            "FBXL5",
            "LMBRD1",
            "PACS2",
            "RAB11A",
            "RNF13",
            "ARL1",
            "PRKAG1",
            "TANK",
            "LYRM2",
            "TUT1",
            "PLEKHB2",
            "TMBIM6",
            "SPRYD3",
            "MFSD5",
            "ZC3H10",
            "STAM2",
            "RAB5B",
            "ATRIP",
            "ASB8"
        ]
    },
    {
        "golabel": "DCP1A_regulon_activity",
        "gene": [
            "BATF",
            "MTCP1NB",
            "NCRNA00120",
            "MBLAC1",
            "C11orf83",
            "FAM173A",
            "SLC4A7",
            "C9orf5",
            "ZNF717",
            "PRKAR2A",
            "SFMBT1",
            "F8A1",
            "FAM3A",
            "ZNF770",
            "BSCL2",
            "IKBKG",
            "LZTFL1",
            "ARHGEF3",
            "ZNF619",
            "DCAF16",
            "PEX16",
            "PPP4R2",
            "DPP3",
            "NARFL",
            "GMPPA",
            "BRMS1",
            "RFX7",
            "PBRM1",
            "VHL",
            "RYBP",
            "TMF1",
            "CORO1B",
            "XPO4",
            "RFT1",
            "EAF1",
            "APPL1",
            "SMARCAD1",
            "OXSR1",
            "CGGBP1",
            "KLHL18",
            "VPRBP",
            "C3orf63",
            "CLASP2",
            "FAM116A",
            "ZBTB11",
            "KIAA1143",
            "WDR48",
            "NGLY1",
            "PDE12",
            "CNOT10",
            "ACTR8",
            "WDR82",
            "RPP14",
            "IP6K1",
            "QRICH1"
        ]
    },
    {
        "golabel": "DDX54_regulon_activity",
        "gene": [
            "RGS13",
            "CLUL1",
            "SLC7A5",
            "CYSLTR1",
            "GPR34",
            "EVI2A",
            "SCARB1",
            "ETV1",
            "C6orf225",
            "RRS1",
            "MOXD1",
            "DCN",
            "SDSL",
            "STK32C",
            "AP1S2",
            "C21orf91",
            "SLC25A10",
            "KCTD12",
            "N4BP2L1",
            "LPAR6",
            "RNF144B",
            "ZNF552",
            "PITPNM2",
            "IPO4",
            "POLE",
            "LTBR",
            "HIP1R",
            "TRAF2",
            "C9orf72",
            "PKP3",
            "AACS",
            "CYP2U1",
            "C10orf2",
            "PGAM5",
            "ERP29",
            "FBRSL1",
            "PDAP1",
            "SGCB",
            "NOP2",
            "ZNF846",
            "RCBTB2",
            "PUS1",
            "SP4",
            "STK17B",
            "PXN",
            "PTCD1",
            "TMEM120B",
            "CKAP4",
            "MRM1",
            "ZNF709",
            "CCDC126",
            "ARL15",
            "BNIP3L",
            "IFNAR2",
            "MYBBP1A",
            "KIAA0664",
            "ULK1",
            "MVK",
            "RBBP9",
            "FAM188A",
            "RRP12",
            "VARS",
            "KLC2",
            "ACAD10",
            "RAB33B",
            "ZCCHC10",
            "TCOF1",
            "DHX37",
            "CBX4",
            "PACS1",
            "ZNF598",
            "MLF2",
            "NAA25",
            "NCOR2",
            "TXNDC15",
            "SLC24A6",
            "ATP2A2",
            "DDX55",
            "RPTOR",
            "PA2G4",
            "SNX13",
            "ACVR2A",
            "GOLGA3",
            "ABHD13",
            "GCN1L1",
            "NOC4L",
            "FAM172A",
            "LONP1",
            "LZTS2",
            "RILPL1",
            "LETM1",
            "ZNF25",
            "MIER1",
            "EIF4G1",
            "UBE2O",
            "SART1",
            "ZNF136",
            "SETD8",
            "C12orf52",
            "SFRS9",
            "WHSC2",
            "RBM10",
            "RBM19",
            "HGS",
            "ATXN2",
            "ANAPC7",
            "FOXK2",
            "SETD1B",
            "SCYL1",
            "FAM76A",
            "THAP4",
            "COASY",
            "ATXN7L3",
            "DKFZp761E198",
            "BAT3",
            "PRDM4",
            "IFNAR1",
            "SEC61A1",
            "ZBTB1",
            "ABCF3",
            "SPPL3",
            "VAMP3",
            "SART3",
            "REXO4",
            "EIF2B1",
            "TUBGCP2",
            "RAB35",
            "UBE3B",
            "BRAP",
            "CAMKK2",
            "ZFP161",
            "RNF10"
        ]
    },
    {
        "golabel": "DEK_regulon_activity",
        "gene": [
            "C11orf35",
            "FBXL8",
            "NPDC1",
            "IDUA",
            "WDHD1",
            "HEXDC",
            "SGOL2",
            "SLC22A18",
            "ZNF93",
            "FAM83E",
            "CCDC64B",
            "SOX18",
            "CKAP2",
            "SYTL1",
            "MYL5",
            "MFSD7",
            "CDKAL1",
            "FAM173A",
            "CENPQ",
            "MID1IP1",
            "SMC2",
            "RBL1",
            "ZFYVE28",
            "LMF1",
            "MSH2",
            "NME3",
            "PSIP1",
            "TOPBP1",
            "LOC341056",
            "PAK1IP1",
            "C14orf106",
            "RNF138",
            "ACADVL",
            "CCDC159",
            "ARSA",
            "LGALS3BP",
            "TFAM",
            "ZNF524",
            "MSH6",
            "TMC6",
            "MAN2C1",
            "SH3TC1",
            "LOC221710",
            "USP1",
            "SGSM3",
            "GLTSCR2",
            "RAD18",
            "IPO5",
            "RABEP2",
            "RRM1",
            "ELOVL5",
            "TRADD",
            "LRRC58",
            "PHF6",
            "ZZZ3",
            "WDR13",
            "RIOK1",
            "STAG1",
            "KDM1B",
            "NUP153",
            "MXD4",
            "RNPEPL1",
            "QSER1",
            "TOM1",
            "RNF219",
            "XKR8",
            "FYTTD1",
            "ZNF184",
            "NUP160",
            "FAM133B",
            "DHX36",
            "DNAJB2",
            "NADSYN1",
            "HMGXB4",
            "CDC5L",
            "ATP6V0C",
            "ZW10",
            "CBLL1",
            "ARAF",
            "RPA1",
            "NR1H2",
            "EXOC2",
            "NUDT21",
            "BET1L",
            "TTC15",
            "HNRNPR",
            "ZFR",
            "RBM12",
            "MATR3"
        ]
    },
    {
        "golabel": "DENND4A_regulon_activity",
        "gene": [
            "CLDN18",
            "ACER2",
            "RASSF6",
            "KCND3",
            "MIA2",
            "TGFBR3",
            "LDHAL6B",
            "C19orf46",
            "MBNL3",
            "ABHD2",
            "FSD1L",
            "CLDN3",
            "PAQR8",
            "MDK",
            "ZNF366",
            "ISYNA1",
            "PIK3CG",
            "GPRIN3",
            "IL6ST",
            "CRIM1",
            "ASPSCR1",
            "PLCL2",
            "C6orf204",
            "FAM71D",
            "HSPB1",
            "LAGE3",
            "PSMG3",
            "LOC92659",
            "C21orf56",
            "C7orf50",
            "PSMB3",
            "DDAH2",
            "RAPGEF6",
            "ZNF593",
            "IMPDH1",
            "FAM127B",
            "RCC1",
            "TMTC2",
            "ANAPC11",
            "SPATA13",
            "ABHD11",
            "EFNA4",
            "PCGF2",
            "SLC30A4",
            "WDR34",
            "MRPS24",
            "PFDN2",
            "FAM63B",
            "MYO9A",
            "PPP1R14B",
            "TTBK2",
            "RAB8B",
            "FAM128B",
            "APH1B",
            "ADAM15",
            "C8orf30A",
            "SLC2A4RG",
            "LRRC20",
            "FAM50A",
            "DMXL2",
            "C5orf41",
            "MRPL55",
            "GPR172A",
            "BCL7C",
            "NDUFS8",
            "RC3H2",
            "HIPK3",
            "C14orf153",
            "SGK269",
            "ASXL2",
            "TRIM44",
            "GET4",
            "FICD",
            "SHARPIN",
            "ABHD12",
            "REV3L",
            "C9orf102",
            "KIF22",
            "AURKAIP1",
            "BLVRA",
            "PSMB4",
            "ARF5",
            "MTX1",
            "C7orf27",
            "B4GALT2",
            "VPS13C",
            "TRAF4",
            "DUS1L",
            "LRCH1",
            "MYCBP2",
            "TRMT61A",
            "ZNF770",
            "PPIP5K1",
            "POLD2",
            "PPP4C",
            "USP12",
            "CYHR1",
            "MOSPD3",
            "SLC25A39",
            "NRSN2",
            "LATS1",
            "MEA1",
            "PSMD4",
            "ZFP106",
            "MTMR10",
            "SLC24A1",
            "NUBP2",
            "C1orf35",
            "TBC1D2B",
            "FAM89B",
            "CHD9",
            "HERC1",
            "ATM",
            "DENND4C",
            "NSUN5",
            "JMJD4",
            "MRPL38",
            "RFNG",
            "ADRM1",
            "SLC12A6",
            "SF3B4",
            "RRP1",
            "RB1",
            "TSEN54",
            "DPP8",
            "MAF1",
            "ALKBH4",
            "UBR1",
            "RAB11A",
            "USP3",
            "IQGAP1",
            "TCF12",
            "DDX56",
            "C7orf30",
            "AKAP11",
            "TSPYL1",
            "DMXL1",
            "LRRFIP1",
            "ZNF791",
            "PJA2",
            "RALY",
            "RFX7",
            "ZCCHC6",
            "TRPM7",
            "CSNK1G1",
            "MPHOSPH8",
            "CEP120",
            "GPS1",
            "CNOT6L",
            "AP4E1",
            "CYFIP1",
            "SPG11",
            "CNP",
            "SETX",
            "PIAS1",
            "BNIP2",
            "USP8",
            "NARG2",
            "TRAF6",
            "CHMP4B",
            "PLDN",
            "MEF2A",
            "CAPN7",
            "ERAL1",
            "INO80",
            "SMYD5",
            "WIPI2",
            "RNF111",
            "WDR11",
            "BTBD1",
            "RNF220"
        ]
    },
    {
        "golabel": "DEPDC1_regulon_activity",
        "gene": [
            "CDH18",
            "SLC6A15",
            "TEX15",
            "SH2D5",
            "MAGEA12",
            "MAGEA2",
            "FAM133A",
            "MAGEA6",
            "MAGEA3",
            "TMEFF1",
            "MKRN3",
            "HPDL",
            "LOC647946",
            "CRYM",
            "SLC26A9",
            "CYP4B1",
            "SUSD2",
            "SPATA18",
            "MGC87042",
            "SFTPD",
            "NEIL3",
            "C16orf89",
            "SCTR",
            "MURC",
            "LOC645166",
            "IGF2BP3",
            "MTL5",
            "GPC6",
            "DUOXA1",
            "SLFNL1",
            "GGT6",
            "TMEM132E",
            "FAM64A",
            "ABO",
            "PRICKLE4",
            "PLOD2",
            "RAP1GAP",
            "CCNB2",
            "ABCA3",
            "PSAT1",
            "VIPR1",
            "PBK",
            "IRX3",
            "ANLN",
            "DNAJC6",
            "CDKN3",
            "EXO1",
            "C9orf152",
            "FAM189A2",
            "OIP5",
            "SKP2",
            "AURKA",
            "SLC22A3",
            "KLF2",
            "CCT6A",
            "SELENBP1",
            "TFRC",
            "POLE2",
            "PLD4",
            "FAM72D",
            "CENPA",
            "AK3L1",
            "LOC399815",
            "PNMA2",
            "CAPN8",
            "MAD2L1",
            "WFDC2",
            "MCM10",
            "C1orf116",
            "SKA1",
            "C12orf48",
            "RHOBTB2",
            "NDC80",
            "TMPRSS2",
            "PRR11",
            "DIAPH3",
            "DEPDC1B",
            "C10orf95",
            "CASC5",
            "RACGAP1P",
            "NUF2",
            "TTK",
            "ORC1L",
            "KIF15",
            "GLOD5",
            "CCDC48",
            "ESPL1",
            "CENPI",
            "PFN2",
            "DLGAP5",
            "TPX2",
            "TRIP13",
            "EPR1",
            "KIF23",
            "HMMR",
            "KIF2C",
            "KIF14",
            "KIF4B",
            "POLR3G",
            "CDC6",
            "FAM72A",
            "RAD51AP1",
            "SPC25",
            "CDCA2",
            "FAM72B",
            "CDC25C",
            "ERO1L",
            "DAPK2",
            "BIRC5",
            "CDC20",
            "DSCC1",
            "CENPE",
            "HJURP",
            "PRR15L",
            "NFIX",
            "LTC4S",
            "RAD54L",
            "KIAA1524",
            "CKAP2L",
            "CDK1",
            "C11orf82",
            "CCNA2",
            "SGOL1",
            "PRTFDC1",
            "NCAPG",
            "BUB1B",
            "MELK",
            "ARHGAP11A",
            "GINS1",
            "LOC80154",
            "ASPM",
            "SIP1",
            "CFI",
            "CKS1B",
            "SKA3",
            "ABCC6",
            "ESCO2",
            "NEK2",
            "FAM54A",
            "NCAPH",
            "BUB1",
            "SLC44A4",
            "TOP2A",
            "KIF4A",
            "PRIM1",
            "CCDC34",
            "CDCA5",
            "RRM2",
            "RAPGEF3",
            "CDCA8",
            "G2E3",
            "TYMS",
            "CHADL",
            "DNA2",
            "IL17RE",
            "PLK1",
            "CEP55",
            "MALL",
            "TMEM38B",
            "MLPH",
            "FANCB",
            "KIF18A",
            "SMAD6",
            "ERCC6L",
            "C21orf63",
            "CCNB1",
            "PXMP4",
            "PYROXD2",
            "MLF1IP",
            "PYGL",
            "TNFRSF10C",
            "CDC7",
            "PLK4",
            "KIF20A",
            "CHAC2",
            "MMP24",
            "NAPSB",
            "SGOL2",
            "LOC388152",
            "CTPS",
            "KIF11",
            "SEMA4A",
            "NEIL1",
            "ECT2",
            "FAM83E",
            "PRC1",
            "TMEM106C",
            "ATAD2",
            "MTHFD2",
            "CCDC64B",
            "RICH2",
            "MEST",
            "FAM22A",
            "MUC1",
            "ACSS1",
            "C18orf54",
            "RACGAP1",
            "STIL",
            "B3GNT5",
            "C15orf56",
            "MMD",
            "RFC3",
            "CISH",
            "SSX2IP",
            "NUSAP1",
            "ZMYND15",
            "RAD54B",
            "C14orf33",
            "WDR67",
            "CKAP2",
            "ALDH2",
            "NETO2",
            "SPIN4",
            "RBPMS",
            "TDP1",
            "TMEM48",
            "SLC36A4",
            "FADS1",
            "FBXO5",
            "PDK1",
            "KPNA2",
            "C13orf37",
            "KLHL5",
            "EPT1",
            "KIF20B",
            "EMP2",
            "NOD1",
            "PPIL5",
            "MFSD7",
            "ARSD",
            "C12orf11",
            "CENPN",
            "SEC23A",
            "TENC1",
            "SMC4",
            "CENPQ",
            "DBF4",
            "CBX7",
            "HOMER1",
            "C4orf46",
            "HYLS1",
            "C6orf150",
            "GLMN",
            "ANKMY1",
            "SLC9A3R2",
            "PPFIBP2",
            "VRK1",
            "TMEM173",
            "SUGT1L1",
            "SEPT4",
            "C13orf34",
            "SASS6",
            "ATF7IP2",
            "PBXIP1",
            "PPAT",
            "GPSM2",
            "UBA2",
            "LMF1",
            "CENPO",
            "TMPO",
            "CENPL",
            "FLJ11235",
            "SLC27A1",
            "GPR180",
            "MAPK6",
            "ARL6IP6",
            "MGRN1",
            "VBP1",
            "UBTD1",
            "ACTL6A",
            "CRY2",
            "ZDHHC1",
            "SUV39H2",
            "CCDC99",
            "MSRA",
            "SNAPC1",
            "C6orf182",
            "PAICS",
            "C1orf112",
            "PGAM5",
            "RFC5",
            "TMC4",
            "CALU",
            "FBXO45",
            "TDG",
            "TMEM206",
            "DCUN1D5",
            "SMS",
            "KDELC2",
            "LIN9",
            "TNFSF13",
            "TFEB",
            "TMEM63B",
            "GPN1",
            "GTF2IRD2P1",
            "PDK2",
            "CSE1L",
            "KLC4",
            "LRRC27",
            "RSRC1",
            "LYAR",
            "DHRS1",
            "GTF2IRD2",
            "C18orf19",
            "USP1",
            "PRMT5",
            "C9orf30",
            "C20orf108",
            "HDAC11",
            "C1orf163",
            "HDAC2",
            "CIRBP",
            "NMD3",
            "DPM1",
            "GLTSCR2",
            "NICN1",
            "NFXL1",
            "CCT4",
            "SLC25A23",
            "SFXN1",
            "YBX1",
            "TAF1A",
            "TTL",
            "NRAS",
            "YWHAQ",
            "FBXW4",
            "LRRC42",
            "WDR43",
            "ATP9B",
            "PARN",
            "RPAP2",
            "CD81",
            "LRRC40",
            "DKC1",
            "ARL6IP1",
            "GHDC",
            "LCLAT1",
            "SLBP",
            "SCAMP2",
            "MXD4",
            "MRPL37",
            "UBA6",
            "PRKCD",
            "C7orf49",
            "LRPPRC",
            "PKN2",
            "NAA15",
            "CHCHD3",
            "WWP2",
            "DNAJA1",
            "USP14",
            "EIF2S1",
            "KPNA4",
            "STIP1",
            "RNASEH1",
            "VMAC",
            "ZC3H15",
            "ALAD",
            "ZNF259",
            "FARSB",
            "ABCE1",
            "C15orf17",
            "PRPF4",
            "RQCD1",
            "CPSF3",
            "INPP5K",
            "MTIF2",
            "RBBP7",
            "BUB3",
            "FAM82A2",
            "WDR75",
            "RTCD1",
            "DENR",
            "NOL10",
            "NUCB1",
            "FAF1",
            "EIF2S2",
            "RNH1",
            "XPO1",
            "SERBP1"
        ]
    },
    {
        "golabel": "DEPDC1B_regulon_activity",
        "gene": [
            "RIPPLY2",
            "TEX15",
            "RAB3B",
            "TMEFF1",
            "ZBTB16",
            "ATOH8",
            "FOLR1",
            "ATP1A2",
            "SORCS2",
            "CPAMD8",
            "UGT8",
            "LOC728819",
            "GPR133",
            "AQP3",
            "MND1",
            "EVPLL",
            "IRX3",
            "C1orf101",
            "CENPA",
            "AK3L1",
            "RHOBTB2",
            "DEPDC1",
            "AURKB",
            "DLGAP5",
            "SPC25",
            "CDC25C",
            "CCNA2",
            "NCAPG",
            "ABCC6",
            "CENPK",
            "C14orf143",
            "TMEM91",
            "PTTG1",
            "ELOVL7",
            "C21orf63",
            "CCNB1",
            "PYROXD2",
            "LOC388152",
            "SEMA4A",
            "RICH2",
            "PTPRU",
            "MUC1",
            "TCEA3",
            "HMGB2",
            "IFT140",
            "OPHN1",
            "CENPH",
            "PPIL5",
            "TRIM59",
            "C4orf46",
            "GTF2IRD2B",
            "ATF7IP2",
            "PBXIP1",
            "RIPK2",
            "DCK",
            "H2AFZ",
            "ZDHHC1",
            "CCDC99",
            "SNRPD1",
            "SMS",
            "TMEM63B",
            "GTF2IRD2P1",
            "CALCOCO1",
            "GTF2IRD2",
            "C9orf30",
            "SFXN1",
            "DNAJC9",
            "PARN",
            "RDH11",
            "ARL6IP1",
            "ZBTB4",
            "SLBP",
            "CASP3",
            "ACTR3",
            "HDAC1",
            "COG7",
            "RBBP7",
            "SAE1",
            "FAM82A2"
        ]
    },
    {
        "golabel": "DHX34_regulon_activity",
        "gene": [
            "KCNJ14",
            "PPFIA3",
            "AURKAPS1",
            "C5orf62",
            "CHTF18",
            "SRRM5",
            "LOC147804",
            "CRYL1",
            "ARHGAP39",
            "DBF4B",
            "CD59",
            "CLCN2",
            "PRRG4",
            "EEF1A1",
            "RAB27A",
            "KPTN",
            "DNMT3A",
            "KAT2A",
            "SFRS16",
            "TMEM81",
            "CTSO",
            "OBFC1",
            "SYMPK",
            "ARL6IP5",
            "LIG1",
            "MYBBP1A",
            "BTBD12",
            "CD3EAP",
            "ZNF598",
            "MAT2B",
            "FKRP",
            "SNRNP70",
            "KIAA1191",
            "PELP1",
            "CCBL2",
            "FBXL5",
            "CHURC1",
            "GIT1",
            "GMEB2",
            "CAST",
            "ZNF335",
            "IRF3",
            "MIER1",
            "NCOA4",
            "SCAF1",
            "CNOT3",
            "SRRT",
            "SMPD4",
            "MORC2",
            "ARFIP1",
            "C4orf3",
            "YIPF5",
            "ATXN7L3",
            "ILF3",
            "VAMP3",
            "STX12",
            "UBE2D3",
            "AZI2",
            "RHOA",
            "SAFB",
            "RBM14"
        ]
    },
    {
        "golabel": "DHX38_regulon_activity",
        "gene": [
            "GPR160",
            "PLEC",
            "LOC283922",
            "SELT",
            "TRAM1",
            "NDUFB5",
            "UBE2W",
            "C5orf28",
            "ZNF627",
            "EIF3E",
            "INTS1",
            "ANKRD46",
            "GNG10",
            "SAR1B",
            "FAM38A",
            "TMEM68",
            "HSDL2",
            "FASTKD3",
            "C1orf43",
            "TAF1C",
            "RG9MTD2",
            "MYNN",
            "RANBP10",
            "FAM65A",
            "PHLPP2",
            "SNAPIN",
            "ZNRF1",
            "BCAR1",
            "RUSC2",
            "SERP1",
            "DHODH",
            "SLC12A4",
            "ATP6V1G1",
            "ZNRF2",
            "MRPL50",
            "ZCCHC10",
            "SRP9",
            "ALG14",
            "KIAA0556",
            "SLC38A7",
            "COX11",
            "ISCA1P1",
            "CHD3",
            "NFAT5",
            "ACD",
            "C12orf26",
            "SPG7",
            "GFOD2",
            "LIPT1",
            "MKL1",
            "UBE2D4",
            "TPMT",
            "CCDC117",
            "TIPRL",
            "MINK1",
            "C9orf82",
            "PCNP",
            "UBA1",
            "SART1",
            "C9orf80",
            "WDR59",
            "TMEM9B",
            "ZCCHC14",
            "VAC14",
            "KATNB1",
            "C11orf46",
            "FAM120AOS",
            "ATXN1L",
            "CDC26",
            "SETD1A",
            "EDC4",
            "ISCA1",
            "KIAA1967",
            "AMPD2",
            "MON1B",
            "GTF3C1",
            "GLG1",
            "UBR4",
            "ANKRD11",
            "CDK11B",
            "SF3B3",
            "DUS2L",
            "PSKH1",
            "COG4",
            "ZC3H18",
            "E2F4",
            "EIF4E2",
            "DYNC1LI2",
            "DDX19A",
            "TUBGCP2",
            "TERF2",
            "C16orf70",
            "SF3B2",
            "KIAA0174"
        ]
    },
    {
        "golabel": "DMAP1_regulon_activity",
        "gene": [
            "C1orf223",
            "RAB27B",
            "LOC400752",
            "TMED7-TICAM2",
            "SGPP2",
            "MAN2A1",
            "TNFRSF10A",
            "PPP2R3B",
            "HRH1",
            "ANKS3",
            "UGCG",
            "CCHCR1",
            "FAM50A",
            "SDR39U1",
            "MUTYH",
            "HSPB11",
            "GLUD2",
            "C9orf41",
            "SLC31A1",
            "ZNF821",
            "ZBTB48",
            "TMEM69",
            "PPIE",
            "SEC24D",
            "STT3B",
            "SLC33A1",
            "ZNF691",
            "C12orf5",
            "JMJD5",
            "SEC24A",
            "NFYC",
            "CC2D1B",
            "ZBTB17",
            "RBM10",
            "NIPA2",
            "STK19",
            "CYFIP1",
            "RING1",
            "TMEM87B",
            "EAF1",
            "C9orf64",
            "IPO13",
            "GPATCH3"
        ]
    },
    {
        "golabel": "DNAJC1_regulon_activity",
        "gene": [
            "C8orf75",
            "BFSP2",
            "CDKL2",
            "DUSP4",
            "SMOX",
            "ATP13A4",
            "LOC96610",
            "MGC29506",
            "ICAM5",
            "RSL24D1",
            "PTPLA",
            "FAM184A",
            "CACNB1",
            "ACAD8",
            "ISG20",
            "FKBP11",
            "ENPP5",
            "NUDT2",
            "RFK",
            "BAG1",
            "CYBA",
            "RPS27L",
            "LOC651250",
            "FHOD1",
            "CREM",
            "ALG5",
            "COMMD3",
            "C19orf10",
            "COX5A",
            "PAK6",
            "APLP2",
            "DTWD1",
            "CPNE2",
            "MYO6",
            "BMI1",
            "AVEN",
            "MSRB2",
            "SELS",
            "ALKBH8",
            "PHLDB1",
            "LMLN",
            "PDIK1L",
            "MKKS",
            "MKL2",
            "SEC61B",
            "SRGAP2",
            "KLF11",
            "DCTN6",
            "STAM",
            "LEPROTL1",
            "ZMYM3",
            "KCTD2",
            "ERP44",
            "ANKRD40"
        ]
    },
    {
        "golabel": "DNMT1_regulon_activity",
        "gene": [
            "PACSIN1",
            "SLC16A4",
            "SEPT3",
            "C19orf57",
            "SFTA2",
            "ZNF878",
            "FAM124A",
            "LOC401431",
            "GPR161",
            "HIST1H2AC",
            "ACTR3C",
            "CLYBL",
            "CEP72",
            "HSD17B8",
            "TPT1",
            "TMBIM4",
            "NUDT13",
            "BAG1",
            "TRIO",
            "PEX2",
            "RPL10A",
            "RPS27L",
            "TSC22D1",
            "C11orf1",
            "TTYH3",
            "RBL1",
            "TTC7B",
            "CAD",
            "NUDT12",
            "CHKB",
            "MCEE",
            "SYNJ2",
            "SLC35A1",
            "UBXN8",
            "NCAPD3",
            "SENP8",
            "C18orf32",
            "ATP8B5P",
            "LOC389333",
            "CEP192",
            "N6AMT2",
            "MAST2",
            "C4orf52",
            "C9orf103",
            "FAM165B",
            "LLGL1",
            "RELT",
            "C19orf55",
            "PIGP",
            "CHAF1A",
            "DSTN",
            "PLCG1",
            "LYPLAL1",
            "SPR",
            "FBXO10",
            "SUCLG2",
            "CEP250",
            "OBFC1",
            "ATP6V0E1",
            "BFAR",
            "RNASEN",
            "MDC1",
            "VAPA",
            "MGST2",
            "NCRNA00081",
            "BBS4",
            "HEXA",
            "ZNF496",
            "TMEM59",
            "ITM2B",
            "TMEM201",
            "PPA2",
            "TMEM128",
            "SUMF1",
            "C9orf95",
            "GABARAPL2",
            "C15orf57",
            "JAGN1",
            "TOP3A",
            "TMEM111",
            "C3orf23",
            "YPEL5",
            "ANAPC16",
            "HMGCL",
            "SERPINB6",
            "TTC19",
            "TATDN3",
            "NUP188",
            "PARP1",
            "DLGAP4",
            "N6AMT1",
            "MED7",
            "DCTN6",
            "MYO9B",
            "PAFAH2",
            "USP42",
            "IMP3",
            "PIGB",
            "PHF13",
            "PPP2CB",
            "UNC50",
            "UBE2O",
            "SPCS1",
            "DALRD3",
            "NDFIP1",
            "MMAA",
            "AP3S2",
            "RNF216",
            "ZFYVE21",
            "ADIPOR1",
            "BRD4",
            "SLC25A38",
            "HCFC1",
            "GGPS1",
            "NUP62",
            "RBM15",
            "SLC25A26",
            "CCDC115",
            "SAP130",
            "ILF3",
            "DCTD",
            "XPO6",
            "VPS24",
            "HNRNPM"
        ]
    },
    {
        "golabel": "DNMT3A_regulon_activity",
        "gene": [
            "MYCN",
            "MYCNOS",
            "FAM171A2",
            "GPC2",
            "PRAME",
            "MSI1",
            "ATOH7",
            "NAT8L",
            "DNMT3B",
            "CASKIN1",
            "S100B",
            "TET1",
            "B4GALNT4",
            "MURC",
            "P2RY12",
            "CPA3",
            "OTX1",
            "VAX2",
            "MEX3A",
            "FOLR2",
            "RBPMS2",
            "ZNF280B",
            "ARID3A",
            "RGS18",
            "FAM69B",
            "ALPK3",
            "PLCB1",
            "PLEKHG2",
            "IGSF9",
            "HLA-DRB1",
            "CDH24",
            "GYLTL1B",
            "LY86",
            "SLC39A8",
            "CHD7",
            "HLA-DRA",
            "HLA-DPA1",
            "TLR3",
            "HLA-DPB1",
            "ACVR2B",
            "KIAA1549",
            "STEAP3",
            "FAS",
            "IL18",
            "TPK1",
            "ADORA2B",
            "GGTA1",
            "CD74",
            "HLA-DMA",
            "CASP1",
            "PAFAH1B3",
            "CD44",
            "TIMELESS",
            "SMARCA1",
            "SLC29A2",
            "CD97",
            "CD59",
            "LYRM1",
            "CARD6",
            "PRPF40B",
            "PMP22",
            "F8",
            "SOX12",
            "CROT",
            "IFNGR1",
            "SLC35A1",
            "POLE",
            "DBN1",
            "SOX4",
            "C13orf23",
            "PLEKHA8",
            "STOM",
            "FBRSL1",
            "BCL9",
            "ZNF74",
            "BEND3",
            "CCNJ",
            "GSTK1",
            "ARL6IP5",
            "TET3",
            "DHX34",
            "SEMA4C",
            "BBS12",
            "TAF4",
            "ULK1",
            "POGZ",
            "LIG3",
            "CCDC142",
            "KIAA0040",
            "TRAF3IP2",
            "EHMT2",
            "PAXIP1",
            "MAT2B",
            "SLC25A46",
            "TPRG1L",
            "SMG5",
            "ATAD2B",
            "MED24",
            "CRTAP",
            "CAST",
            "MTPAP",
            "SBDS",
            "PPP2CB",
            "SNRNP200",
            "SMPD4",
            "FOXK2",
            "CPSF6",
            "MORC2",
            "FBXO8",
            "ARL2BP",
            "IPO9",
            "INTS4",
            "GTF3C2",
            "UFSP2",
            "CCAR1",
            "VAMP3",
            "STX12",
            "SMG7",
            "IWS1"
        ]
    },
    {
        "golabel": "DOT1L_regulon_activity",
        "gene": [
            "ATP2A1",
            "HIC2",
            "C19orf71",
            "PPARGC1B",
            "QRICH2",
            "ANKRD36B",
            "RAP1GAP2",
            "ABCA7",
            "FBXO41",
            "MICAL3",
            "BPGM",
            "PPT2",
            "C4orf34",
            "OTUD3",
            "COMMD10",
            "KRCC1",
            "PNPLA4",
            "SAR1B",
            "SPPL2B",
            "MR1",
            "ISCA2",
            "JRK",
            "HDHD1A",
            "SNAPC4",
            "GBA2",
            "INSIG2",
            "SH3BP2",
            "PAPD7",
            "RWDD2B",
            "GTF2H5",
            "TCEAL8",
            "SOLH",
            "PGRMC1",
            "MLL4",
            "SYPL1",
            "SDHD",
            "SKP1",
            "DENND4B",
            "ZNF598",
            "DOCK6",
            "SIN3B",
            "EBAG9",
            "TPMT",
            "ZFAND6",
            "C1GALT1C1",
            "MBD3",
            "MAPKSP1",
            "MUM1",
            "UNC50",
            "CHFR",
            "PEX12",
            "CMPK1",
            "NDFIP1",
            "RBM33",
            "CASC4",
            "TYK2",
            "ZCRB1",
            "STRN4",
            "REXO1",
            "OCIAD1",
            "KDM4B",
            "TAF12",
            "C11orf58",
            "CSNK1G2",
            "ARL2BP",
            "ARFIP1",
            "SRF",
            "C19orf29",
            "DNAJA2",
            "HCFC1",
            "GGPS1",
            "PIAS4",
            "VPS35",
            "ILF3",
            "MRFAP1L1",
            "BRPF1",
            "PLEKHA3"
        ]
    },
    {
        "golabel": "DR1_regulon_activity",
        "gene": [
            "INE2",
            "C17orf55",
            "HSF4",
            "NCRNA00105",
            "HDAC9",
            "FUNDC2P2",
            "PLA2G6",
            "FRRS1",
            "SPACA4",
            "CRIPAK",
            "NPIPL3",
            "ANO9",
            "FBXL8",
            "LOC100133161",
            "TRPV1",
            "TMEM38B",
            "HEXDC",
            "EIF5A2",
            "DSE",
            "SLC25A35",
            "ACCS",
            "BAG4",
            "FAM22A",
            "PAQR3",
            "LOC100132287",
            "RGL3",
            "TIAF1",
            "ENGASE",
            "STK38L",
            "ZNF699",
            "LOC100133331",
            "CEMP1",
            "ZNF692",
            "MED21",
            "LRDD",
            "SELT",
            "NPEPL1",
            "D2HGDH",
            "SNX6",
            "CNIH",
            "SREBF1",
            "FN3K",
            "FAM193B",
            "SGSM2",
            "CDK5RAP3",
            "HSPA13",
            "LOC339047",
            "SPRN",
            "DCK",
            "HS2ST1",
            "CCDC57",
            "SEP15",
            "ANKS3",
            "CDRT4",
            "C17orf28",
            "NRIP1",
            "ARL6IP6",
            "TUBGCP6",
            "CRTC1",
            "AFG3L1",
            "LOC90110",
            "LUC7L",
            "ACADVL",
            "RAB23",
            "LIMS1",
            "CCDC75",
            "NEK8",
            "SNX7",
            "LEPROT",
            "CLIC4",
            "C12orf29",
            "NCK1",
            "GPN1",
            "HOOK2",
            "TAF1C",
            "TAF13",
            "SFRS17A",
            "RIOK3",
            "LRRC27",
            "FAM49B",
            "BTF3L4",
            "ESRP2",
            "MYNN",
            "MANEA",
            "POT1",
            "SLC25A40",
            "MRM1",
            "TMED5",
            "CNTROB",
            "BMI1",
            "COMMD2",
            "CCDC126",
            "TMX1",
            "USP1",
            "SLC25A24",
            "UBE2Q2",
            "ZNF444",
            "NMD3",
            "DCUN1D1",
            "HDAC10",
            "RP2",
            "ZNF468",
            "PPIL2",
            "SNX3",
            "FOXN2",
            "NRAS",
            "YWHAQ",
            "FBXW4",
            "ZNRF2",
            "ZZZ3",
            "OSTM1",
            "HMGN4",
            "TWISTNB",
            "C3orf38",
            "GTF2B",
            "RPAP2",
            "CHD3",
            "NEURL4",
            "RRAGC",
            "SLC38A10",
            "GTF2H3",
            "TBCD",
            "SUOX",
            "ATG5",
            "SNRNP70",
            "PPP1R2P3",
            "SPG7",
            "ZNF35",
            "MMGT1",
            "PNPLA8",
            "C6orf120",
            "ATN1",
            "CHIC2",
            "PIGK",
            "CTTN",
            "NUP54",
            "RBM7",
            "LZIC",
            "SGSH",
            "MOBKL1B",
            "LRSAM1",
            "EIF2S1",
            "KPNA4",
            "FYTTD1",
            "LUZP6",
            "DCLRE1B",
            "OSBPL8",
            "ZNF845",
            "CTDSPL2",
            "MIER1",
            "PCNP",
            "THAP5",
            "RNF11",
            "DPH1",
            "PCMT1",
            "ATG4C",
            "PPP1R2",
            "RNGTT",
            "ATP13A1",
            "CAPZA1",
            "TBC1D23",
            "FBXL4",
            "NUS1",
            "COG1",
            "HAUS2",
            "CEPT1",
            "SEPT7",
            "FAF1",
            "RBM18",
            "GNAI3",
            "USP33",
            "WTAP",
            "HNRPLL",
            "DIS3L2",
            "STXBP3",
            "HIAT1",
            "SH3GLB1",
            "UBE2D3",
            "MAPK14",
            "SEPT2",
            "ZFR",
            "HERPUD2",
            "ZNF143",
            "BTBD1",
            "PPIL4"
        ]
    },
    {
        "golabel": "DRAP1_regulon_activity",
        "gene": [
            "CCDC28B",
            "CD70",
            "CATSPER1",
            "MT2A",
            "KCND3",
            "LGALS1",
            "ISG15",
            "RAB33A",
            "TNFRSF18",
            "TNFSF15",
            "KLC3",
            "UBE2C",
            "C9orf152",
            "PDZD2",
            "DNTTIP1",
            "C4orf48",
            "LOC654342",
            "ABHD2",
            "C10orf125",
            "RHEBL1",
            "ZFAND2A",
            "SOCS1",
            "CENPW",
            "MRPL21",
            "NCRNA00152",
            "LOC541471",
            "UBE2S",
            "MDK",
            "RECQL4",
            "SPAG4",
            "PTPRB",
            "PTCH1",
            "LOC606724",
            "BATF",
            "C5orf55",
            "FAM176B",
            "IL32",
            "CENPM",
            "PSRC1",
            "ROMO1",
            "EHF",
            "NBEAL1",
            "ABLIM1",
            "ACOT7",
            "CCDC85B",
            "MED27",
            "HOMER3",
            "TACC3",
            "TMSB10",
            "RAB3IL1",
            "SATB1",
            "CD40",
            "LIMD2",
            "RALGAPA2",
            "CERCAM",
            "LAGE3",
            "RNASEH2A",
            "NDUFA11",
            "SNX8",
            "FAM58A",
            "POC1A",
            "MAD2L2",
            "C11orf83",
            "MYO5C",
            "GUK1",
            "SUV39H1",
            "CORO2A",
            "SH2D4A",
            "CDKN2D",
            "FHL3",
            "C7orf50",
            "CENPP",
            "PSMB3",
            "AKAP13",
            "PLEKHO1",
            "POP7",
            "DISC1",
            "UBE2L6",
            "LIMD1",
            "PYCRL",
            "NRM",
            "EXOSC4",
            "FAM127B",
            "MAGI1",
            "ANAPC11",
            "FBXO6",
            "LSM7",
            "H2AFX",
            "TRAPPC5",
            "GADD45GIP1",
            "RP9P",
            "NAA10",
            "MXD3",
            "TBCB",
            "MRPL12",
            "C11orf31",
            "PER2",
            "MED10",
            "COPS6",
            "PSME2",
            "PPP1R14B",
            "GALK1",
            "FAU",
            "USP54",
            "TUBA1C",
            "CCM2",
            "MRPL11",
            "PPIH",
            "NUDT1",
            "MAML3",
            "NFKBIE",
            "TIMM10",
            "KIAA1671",
            "LNX2",
            "PQBP1",
            "C11orf84",
            "THOC4",
            "DDX39",
            "HAUS7",
            "FAM50A",
            "LRP6",
            "BCL7C",
            "COMMD5",
            "NDUFS8",
            "KBTBD7",
            "TUBG1",
            "ATP6V1F",
            "POLA2",
            "PSMA7",
            "POLR2J",
            "FAM195B",
            "YIF1B",
            "PLEKHM3",
            "DUSP16",
            "C21orf70",
            "FAM127A",
            "PCYOX1",
            "AURKAIP1",
            "UBL4A",
            "KIAA1109",
            "BCL2L12",
            "ZNF33B",
            "ARF5",
            "DPY19L3",
            "PDZD11",
            "POLR2G",
            "TRMT112",
            "RPL23AP7",
            "CDC34",
            "C10orf118",
            "YIF1A",
            "LRBA",
            "PPAN",
            "SRM",
            "SLC25A19",
            "CCDC86",
            "MRTO4",
            "ASH1L",
            "YBX1",
            "IDE",
            "PPP4C",
            "COX8A",
            "PSMB1",
            "TFPT",
            "BANF1",
            "SLC25A39",
            "RNASEH2C",
            "RGS19",
            "MEA1",
            "CLINT1",
            "VPS13D",
            "ZFP106",
            "MTMR10",
            "ITGB1BP1",
            "PTAR1",
            "CTU2",
            "ACD",
            "SSSCA1",
            "FAM89B",
            "GCC2",
            "AIP",
            "HSD17B10",
            "MIIP",
            "ARL2",
            "SIPA1",
            "ADRM1",
            "SLC10A3",
            "RUVBL2",
            "FTSJ1",
            "IDH3G",
            "KIAA0232",
            "GNAQ",
            "RPS6KB2",
            "RRP9",
            "TJP1",
            "JMJD1C",
            "UBR1",
            "ACTG1",
            "KIAA0430",
            "PREPL",
            "BAZ2B",
            "WDR74",
            "TET2",
            "FADD",
            "JMJD6",
            "PPP1CA",
            "SH3GL1",
            "STX4",
            "RALY",
            "BRMS1",
            "EMD",
            "TRPM7",
            "ZFPL1",
            "IREB2",
            "SNF8",
            "ACTB",
            "MPHOSPH8",
            "FAM108B1",
            "UTP14C",
            "PSMB2",
            "GPS1",
            "VEGFB",
            "PIK3C2A",
            "HTRA2",
            "PFN1",
            "PSMC3",
            "SPG11",
            "ARHGDIA",
            "USP8",
            "SNX15",
            "MUS81",
            "C11orf68",
            "CFL1",
            "KDM3B",
            "FIBP",
            "ANKFY1",
            "RC3H1",
            "ARIH1",
            "ATF7",
            "E2F4",
            "CAPZB",
            "PAFAH1B1",
            "STX17",
            "EIF1AD"
        ]
    },
    {
        "golabel": "DSP_regulon_activity",
        "gene": [
            "PKP2",
            "CTSH",
            "RNF175",
            "RNASE1",
            "KLHDC7A",
            "CASC5",
            "ESPL1",
            "KIF14",
            "CENPF",
            "DSC2",
            "MKI67",
            "RAMP2",
            "ST3GAL6",
            "CLIC2",
            "CCDC152",
            "LGALS9",
            "CD74",
            "HLA-DMA",
            "NCAPD2",
            "C10orf11",
            "INCENP",
            "FAM83G",
            "PARD3",
            "FIP1L1",
            "NINJ1",
            "RILPL2",
            "YES1",
            "PPM1M",
            "TCEAL8",
            "RIOK1",
            "NUP153",
            "ATP6V0D1",
            "DOK1",
            "GCN1L1",
            "RNF130",
            "NCOA6",
            "BAZ2A",
            "SSR1",
            "CDYL",
            "WRNIP1",
            "PEF1",
            "HPS1",
            "YME1L1"
        ]
    },
    {
        "golabel": "DVL1_regulon_activity",
        "gene": [
            "FBXO2",
            "HAGHL",
            "EPHA2",
            "FSTL3",
            "PTK6",
            "C8orf73",
            "HES4",
            "C1orf170",
            "C7orf58",
            "ALS2CL",
            "TLR7",
            "ANKRD9",
            "PLEKHN1",
            "PIK3CG",
            "GPR65",
            "MARCH1",
            "TLR4",
            "C1orf113",
            "RAB30",
            "PLEC",
            "ITGA4",
            "ATAD3B",
            "RNF208",
            "KLHL17",
            "TTC39B",
            "TLR1",
            "C1orf93",
            "MAGEH1",
            "PACSIN3",
            "LOC401010",
            "AGRN",
            "INF2",
            "PPP1R16A",
            "ACAP3",
            "FAM83H",
            "FBXL6",
            "PUSL1",
            "ARHGEF16",
            "PKP3",
            "EXD3",
            "CYP2U1",
            "C1orf86",
            "ABCA2",
            "AGTRAP",
            "RAB8B",
            "GPR137B",
            "SLC2A4RG",
            "MTHFR",
            "MAP3K6",
            "MIB2",
            "C1orf159",
            "EPS8L2",
            "CD151",
            "PNPLA2",
            "PWWP2B",
            "SHARPIN",
            "ATAD3A",
            "AURKAIP1",
            "CNKSR1",
            "GLTPD1",
            "TIFA",
            "GYG1",
            "B4GALT2",
            "ARRDC1",
            "TAF9B",
            "SIRT7",
            "ENO1",
            "NDOR1",
            "OSTM1",
            "C14orf109",
            "SOLH",
            "PRCP",
            "LMNA",
            "VPS37B",
            "SSH3",
            "FAM129B",
            "KIAA1522",
            "NOC2L",
            "HSF1",
            "ZNF598",
            "LYPLA2",
            "ARSB",
            "PLCB3",
            "LYPLA2P1",
            "RNF126",
            "TXNDC15",
            "MKNK2",
            "ZDHHC18",
            "MED15",
            "RRP1",
            "TMCO4",
            "SURF6",
            "AGAP3",
            "RNF130",
            "NFKBIL1",
            "CTTN",
            "B3GALT6",
            "HCFC2",
            "PEX10",
            "LZTS2",
            "XKR8",
            "C1orf172",
            "OSBPL8",
            "C9orf86",
            "GOLGA2",
            "NADK",
            "ZBTB17",
            "RER1",
            "HGS",
            "WDR7",
            "SCYL1",
            "SDF4",
            "UBE2J2",
            "CPSF3L",
            "CDK11B",
            "EIF5",
            "ASB6",
            "MECR",
            "SSU72",
            "STK25",
            "CTBP1",
            "HECTD3",
            "RNF220",
            "ASB8"
        ]
    },
    {
        "golabel": "DVL3_regulon_activity",
        "gene": [
            "SHOX2",
            "CACNA1B",
            "LOC285548",
            "C3orf65",
            "HOXA10",
            "BAI2",
            "ZNF711",
            "IGF2BP2",
            "MYBL2",
            "KCNJ14",
            "DNM1",
            "EFS",
            "RPS3A",
            "ABCC5",
            "CLTCL1",
            "GPR161",
            "KIF7",
            "MAP6D1",
            "IQGAP3",
            "EEF1B2",
            "SEPT5",
            "RFC4",
            "MGC12982",
            "SDHAP2",
            "C3orf21",
            "SNHG8",
            "HNMT",
            "CABLES2",
            "RPL10A",
            "PLXNA1",
            "SUV420H2",
            "KCNMB3",
            "C4orf33",
            "C4orf34",
            "RPL34",
            "CLCN2",
            "EEF1A1",
            "ZNF256",
            "SDHAP1",
            "RPS13",
            "TMEM44",
            "FCHO2",
            "LOC220729",
            "POLE",
            "SYNGAP1",
            "MAST2",
            "TCEAL1",
            "RPS23",
            "YEATS2",
            "GK5",
            "TNK2",
            "LSG1",
            "SUCLG2",
            "POLR2L",
            "TET3",
            "ATP11B",
            "RCC2",
            "MAGEF1",
            "TBCCD1",
            "ULK1",
            "PIGX",
            "LMLN",
            "AUH",
            "IFT122",
            "SENP2",
            "PSMD2",
            "MTMR6",
            "DNAJB11",
            "SR140",
            "KIAA0226",
            "IGBP1",
            "CHURC1",
            "MARK4",
            "RILPL1",
            "SDCCAG8",
            "PHF13",
            "SENP5",
            "EIF4G1",
            "TMCC1",
            "AP2M1",
            "REEP5",
            "FAM131A",
            "TMEM9B",
            "GIN1",
            "STK38",
            "SPCS3",
            "FAM114A2",
            "SMPD4",
            "NCBP2",
            "FBXO8",
            "ARFIP1",
            "EEFSEC",
            "EIF2B5",
            "COPG",
            "LEMD2",
            "VPS8",
            "APEH",
            "RIOK2",
            "SEC61A1",
            "ABCF3"
        ]
    },
    {
        "golabel": "E2F5_regulon_activity",
        "gene": [
            "PITX2",
            "SEC11C",
            "BHLHA15",
            "HMGB3",
            "NPTXR",
            "MRPS28",
            "PNMAL2",
            "DST",
            "PTP4A3",
            "C8orf45",
            "ZFAND1",
            "OAT",
            "C1orf126",
            "FAM60A",
            "LYPLA1",
            "LAPTM4B",
            "LGALS9",
            "NR1D1",
            "C8orf76",
            "GSN",
            "SNTB1",
            "C8orf59",
            "MRPL13",
            "C8orf38",
            "MTFR1",
            "TSPAN9",
            "SLC9A1",
            "TCEB1",
            "BNIP3",
            "CARD6",
            "HIVEP3",
            "RPL7",
            "C14orf104",
            "UBE2W",
            "MRPL15",
            "STAU2",
            "ANKRD46",
            "NUDCD1",
            "CHCHD7",
            "LRRCC1",
            "OTUD6B",
            "PCDHGC3",
            "TMEM68",
            "PML",
            "DARS2",
            "DCAF13",
            "ARMC1",
            "PLXNB2",
            "C8orf33",
            "MAP3K5",
            "COPS5",
            "RIN3",
            "WDR12",
            "CCNJ",
            "PI4K2B",
            "FAM91A1",
            "TRMT12",
            "ACTN4",
            "UBE2V2",
            "IQSEC2",
            "SEH1L",
            "ZNF623",
            "INTS8",
            "ESRP1",
            "ZNF252",
            "CPNE3",
            "KIAA0146",
            "MARS2",
            "WDR43",
            "TFB2M",
            "GRN",
            "MTDH",
            "PRMT3",
            "MAP7D1",
            "LDLRAP1",
            "ZNF7",
            "GNL3",
            "TERF1",
            "ZCCHC7",
            "ZNF22",
            "ARL5A",
            "MTPAP",
            "LARP1B",
            "C2orf43",
            "MOBKL2C",
            "SLC25A32",
            "TTC35",
            "TRNT1",
            "KIAA1429",
            "SUPV3L1",
            "CHUK",
            "EXOC6",
            "PTCD3",
            "YTHDF3",
            "FAM35A",
            "DDX50",
            "GRSF1",
            "PPP3CB",
            "FAM35B",
            "PDE12",
            "RPP14",
            "RBM45"
        ]
    },
    {
        "golabel": "E2F7_regulon_activity",
        "gene": [
            "LINGO2",
            "SH2D5",
            "HMGA2",
            "FKBP9L",
            "ARNTL2",
            "FHOD3",
            "AQP3",
            "IGF2BP2",
            "MCF2L2",
            "CLSPN",
            "GJC1",
            "SFTA2",
            "NAPSA",
            "SULT1A2",
            "SACS",
            "KIF15",
            "TPX2",
            "KIF23",
            "C3orf67",
            "KIAA1524",
            "NINJ2",
            "NCAPG",
            "SFTA3",
            "B3GNT8",
            "ST3GAL5",
            "CENPK",
            "CDCA5",
            "HDGFRP3",
            "PLK4",
            "CNTLN",
            "BRCA1",
            "ST6GALNAC4",
            "STIL",
            "CISH",
            "MICAL3",
            "TCEA3",
            "FANCI",
            "C1orf210",
            "TMEM150A",
            "UBTD1",
            "CRB3",
            "ATP2C1",
            "TBCCD1",
            "SCLT1",
            "POLD3",
            "C2orf24"
        ]
    },
    {
        "golabel": "E4F1_regulon_activity",
        "gene": [
            "RAB26",
            "CASKIN1",
            "PRSS27",
            "LOC26102",
            "SNHG9",
            "CLDN3",
            "MAGIX",
            "DNASE1",
            "GLI4",
            "FAM195A",
            "CHTF18",
            "LOC100128788",
            "ZNF699",
            "NTHL1",
            "NME3",
            "DECR2",
            "ANKS3",
            "KCTD13",
            "DCI",
            "YPEL3",
            "GBE1",
            "B3GNTL1",
            "SIGIRR",
            "ZNF341",
            "C1orf159",
            "GET4",
            "TMUB1",
            "TP53I13",
            "AMDHD2",
            "TMX1",
            "FASTK",
            "ARRDC1",
            "SPATA2L",
            "NDOR1",
            "RHOT2",
            "IKBKG",
            "FOXRED1",
            "SOLH",
            "TELO2",
            "OGFOD2",
            "ZNF205",
            "HAGH",
            "WDR13",
            "PGP",
            "SPSB3",
            "NUBP2",
            "FAM100A",
            "IL17RC",
            "SLC38A10",
            "ZNF598",
            "MYST1",
            "CLCN7",
            "RFNG",
            "FLYWCH2",
            "RB1",
            "C12orf5",
            "ABCB8",
            "IPO11",
            "JMJD5",
            "PPP2R5E",
            "INO80E",
            "ZNF76",
            "TNPO1",
            "NARFL",
            "ZBTB6",
            "PTENP1",
            "NDUFV1",
            "GFER",
            "G3BP2",
            "C16orf68",
            "VPS4B",
            "USP38",
            "AAAS",
            "ZNF800",
            "KDSR",
            "ZNF148",
            "RNPS1",
            "BTBD1"
        ]
    },
    {
        "golabel": "EBF4_regulon_activity",
        "gene": [
            "FGFR3",
            "OXER1",
            "FLJ13197",
            "BZRAP1",
            "SLC22A17",
            "PNMAL2",
            "GABBR1",
            "SGOL1",
            "PLEKHH2",
            "RGAG4",
            "ADAMTSL2",
            "LCAT",
            "C22orf36",
            "CROCC",
            "DTX3",
            "C15orf23",
            "EFEMP2",
            "MTSS1L",
            "CRTC1",
            "ARAP3",
            "SORBS3",
            "C21orf2",
            "TMEM8B",
            "WDR12",
            "RAB11FIP3",
            "RGS12",
            "RAD18",
            "C9orf41",
            "SLC12A4",
            "WDR43",
            "WDR3",
            "HDGF",
            "GART",
            "GNL3",
            "SLC39A13",
            "MRPL3",
            "MAP2K1",
            "ZC3H15",
            "IARS",
            "ABCE1",
            "DNTTIP2",
            "CCT8",
            "OXNAD1",
            "ROD1",
            "UCHL5",
            "CAPZA1",
            "RAD23B",
            "HNRNPC",
            "PTPRA",
            "UBQLN1",
            "TBC1D20"
        ]
    },
    {
        "golabel": "EDF1_regulon_activity",
        "gene": [
            "HIST2H2AA3",
            "GADD45G",
            "DST",
            "TMEM141",
            "ISG20",
            "DPM3",
            "EGFL7",
            "RPL35",
            "COX6B1",
            "TXN",
            "DNLZ",
            "DCXR",
            "LOC440957",
            "LOC150381",
            "ROMO1",
            "AGPAT2",
            "MED27",
            "UQCRQ",
            "SNHG7",
            "LSMD1",
            "IFI27L1",
            "PPDPF",
            "MRPL41",
            "NDUFA2",
            "BAG1",
            "GSTP1",
            "TSTA3",
            "PHPT1",
            "WDR44",
            "GUK1",
            "ENDOG",
            "TAOK1",
            "NDUFA13",
            "BLOC1S1",
            "PPIB",
            "RPL7A",
            "BSPRY",
            "SERF2",
            "KRTCAP2",
            "GADD45GIP1",
            "ATP5D",
            "C15orf63",
            "C16orf13",
            "COX4I1",
            "MRPS21",
            "NDUFA3",
            "TRAF2",
            "ATP10D",
            "TTBK2",
            "NDUFA7",
            "ERP29",
            "SURF2",
            "HDHD3",
            "NANS",
            "DPP7",
            "C9orf142",
            "PFDN6",
            "PSMG4",
            "STRN",
            "CNPY2",
            "EEF1D",
            "C9orf16",
            "NDUFS8",
            "RIF1",
            "ZNF524",
            "CCDC107",
            "C9orf37",
            "HRAS",
            "HIGD2A",
            "DPM2",
            "ROBLD3",
            "VPS28",
            "NT5C",
            "MSRB2",
            "ATG4D",
            "PMF1",
            "ZDHHC12",
            "BSG",
            "SURF1",
            "SSNA1",
            "C9orf119",
            "NDUFB8",
            "MRPS2",
            "ZMYND19",
            "ESRRA",
            "FBXW5",
            "ARRDC1",
            "ATP6V1G1",
            "NEK1",
            "PSMB7",
            "NDUFA8",
            "SOAT1",
            "MKL2",
            "SEC61B",
            "ENAH",
            "COQ4",
            "BTBD6",
            "PTGES2",
            "CCDC12",
            "GNG5",
            "METTL11A",
            "MYO1B",
            "ARL6IP4",
            "ROCK1",
            "FPGS",
            "SLC2A8",
            "MAF1",
            "VPS41",
            "ERCC4",
            "UQCRC1",
            "PCGF1",
            "CYB561D2",
            "ATXN1",
            "MAN1B1",
            "PMPCA",
            "EXOSC7",
            "NPAT",
            "ARPC5L",
            "TSSC4",
            "PIKFYVE",
            "UCK1",
            "MOB2",
            "URM1",
            "ASB6",
            "TMEM203",
            "UBXN1",
            "DCAF17",
            "COBRA1",
            "PPP2R4"
        ]
    },
    {
        "golabel": "EEA1_regulon_activity",
        "gene": [
            "PRKG1",
            "SESN3",
            "DNLZ",
            "IL6ST",
            "STON1",
            "TIMM16",
            "MIF",
            "LSMD1",
            "C7orf47",
            "COBLL1",
            "MRPL41",
            "MRPL52",
            "SAMHD1",
            "PSMG3",
            "SLC8A1",
            "FGD6",
            "TACC1",
            "GADD45GIP1",
            "ATP5D",
            "LRRC61",
            "WDR34",
            "NDUFA3",
            "FAM63B",
            "MYO9A",
            "C1orf86",
            "C9orf142",
            "PSMG4",
            "LNPEP",
            "MRPL55",
            "ROCK2",
            "C9orf16",
            "NDUFS8",
            "SHPRH",
            "HIPK3",
            "MID2",
            "GAB1",
            "TMTC3",
            "LSM4",
            "TMUB1",
            "REV3L",
            "CARS2",
            "NT5C",
            "C18orf22",
            "ZDHHC12",
            "PXK",
            "C10orf118",
            "ITPA",
            "TFPT",
            "MED13",
            "LATS1",
            "NUBP2",
            "PTGES2",
            "PNKP",
            "QKI",
            "COMMD4",
            "TBCEL",
            "HIPK1",
            "SIRT6",
            "ARL13B",
            "ATRX",
            "UBE2M",
            "ALKBH4",
            "UBR3",
            "NFKBIL1",
            "HCFC2",
            "GNPTAB",
            "WDR47",
            "NEDD1",
            "OSBPL8",
            "MAP3K2",
            "DMXL1",
            "CSGALNACT2",
            "UHRF1BP1L",
            "HELZ",
            "POLR3B",
            "SCYL2",
            "PPP1R12A",
            "BMPR2",
            "OSBPL11",
            "EVI5",
            "VEZT",
            "PIH1D1",
            "TSSC4",
            "KIAA1033",
            "CDK17",
            "UBXN1",
            "SFRS2IP",
            "APPL1",
            "ZYG11B",
            "MORC3",
            "TNKS2",
            "SLAIN2",
            "BCLAF1"
        ]
    },
    {
        "golabel": "EEF1A1_regulon_activity",
        "gene": [
            "RGS13",
            "S100B",
            "NCRNA00188",
            "FOLR2",
            "RPL13AP6",
            "RPS18",
            "RPS3A",
            "RPS10",
            "RPS5",
            "RPS15A",
            "TMEM184A",
            "SNHG5",
            "EEF1B2",
            "LOC100133161",
            "RPS3",
            "RPS6",
            "RPS14",
            "RPS29",
            "RPSAP58",
            "LOC349114",
            "C6orf57",
            "RPL17",
            "RPS26",
            "PFDN5",
            "RPL31",
            "NFKBIL2",
            "RPS17",
            "LOC100132287",
            "RPS8",
            "TPT1",
            "RPL13A",
            "TMBIM4",
            "RPS11",
            "HNMT",
            "RPL27A",
            "FANCA",
            "RPL5",
            "MYO7A",
            "RPS9",
            "RPL10A",
            "RPL41",
            "KCNMB3",
            "RPL34",
            "RPL32",
            "FLJ45340",
            "DAGLA",
            "GPR56",
            "FAM175A",
            "RPL7A",
            "IRAK1BP1",
            "RPS13",
            "NASP",
            "THAP2",
            "AZI1",
            "SLC35A1",
            "ZNF627",
            "SCRIB",
            "RPL10",
            "RPS12",
            "EEF1A1P9",
            "POLE",
            "AFG3L1",
            "ATP5S",
            "RWDD2A",
            "EP400NL",
            "MAST2",
            "RPS23",
            "CYB5R4",
            "WHSC1",
            "RPL15",
            "FBXL19",
            "STK36",
            "GNB2L1",
            "RPS4X",
            "CEP250",
            "AIG1",
            "HDDC2",
            "ECHDC1",
            "TOMM7",
            "RPL3",
            "BMI1",
            "COMMD6",
            "DHX34",
            "UBE2CBP",
            "CRBN",
            "ZNF277",
            "RBM28",
            "C17orf48",
            "SNX3",
            "C15orf57",
            "NAA40",
            "RPS25",
            "BTBD12",
            "CCNDBP1",
            "RARS2",
            "MTMR6",
            "YPEL5",
            "EIF3L",
            "ANAPC16",
            "MAT2B",
            "BTF3",
            "LGTN",
            "RWDD1",
            "YAF2",
            "UQCRC2",
            "GOLGA3",
            "FBXL5",
            "LMBRD1",
            "HACL1",
            "SMG5",
            "DVL3",
            "EIF4B",
            "RMND1",
            "NT5DC1",
            "FARS2",
            "DIP2A",
            "CRTAP",
            "GMPR2",
            "GRINL1A",
            "PDCD2",
            "UBA3",
            "COPS4",
            "SFT2D1",
            "PNRC1",
            "UBB",
            "LYRM2",
            "CDKN1B",
            "SRRT",
            "RNF41",
            "EDC4",
            "EID1",
            "SNX14",
            "RPL22",
            "EIF1B",
            "PPP1R10",
            "LOC643387",
            "WTAP",
            "SARS",
            "APEH",
            "PPP3CB",
            "RHOA"
        ]
    },
    {
        "golabel": "EHMT1_regulon_activity",
        "gene": [
            "WNK2",
            "LEMD1",
            "FLJ44635",
            "QRFP",
            "C9orf172",
            "MRPS6",
            "SPTBN2",
            "PEX2",
            "C5orf35",
            "LYRM1",
            "COMMD10",
            "SLC25A25",
            "SRI",
            "WRB",
            "C4orf52",
            "SAR1B",
            "LOC401397",
            "NACC2",
            "DENND1A",
            "FANCC",
            "POLR2C",
            "QSOX2",
            "VAV2",
            "GDE1",
            "SNAPC4",
            "CETN3",
            "INSIG2",
            "RWDD2B",
            "GTF2H5",
            "TMEM128",
            "GABARAPL2",
            "SFRS12IP1",
            "TCEAL8",
            "KIAA0649",
            "MLL4",
            "CAMSAP1",
            "HEXB",
            "SKP1",
            "CCDC104",
            "BAT2L1",
            "BTF3",
            "TATDN3",
            "NUP188",
            "EIF1AX",
            "TXNDC15",
            "SEC16A",
            "EBAG9",
            "ODF2",
            "ZBTB34",
            "BRD3",
            "IPPK",
            "GOLGA2",
            "RAPGEF1",
            "PEX12",
            "NDFIP1",
            "TMEM188",
            "ABL1",
            "CNOT3",
            "ZNF746",
            "WDR5",
            "EID1",
            "ARL2BP",
            "MED22",
            "HCFC1",
            "IKBKAP",
            "FBXW2",
            "CIZ1",
            "GOLGA1",
            "NUP214",
            "BRPF1",
            "FBXO18",
            "FUBP3"
        ]
    },
    {
        "golabel": "EHMT2_regulon_activity",
        "gene": [
            "MYCNOS",
            "MOSC1",
            "FASN",
            "ANKRD22",
            "CLEC4A",
            "GPR34",
            "EVI2A",
            "RGS18",
            "RAP1B",
            "ALOX5AP",
            "GAPT",
            "SSPN",
            "MNDA",
            "IL7",
            "PANK1",
            "FAS",
            "NINL",
            "ARRDC4",
            "SGMS2",
            "ZBTB12",
            "CD58",
            "FOXP4",
            "STK17A",
            "TMEM154",
            "LGALS3",
            "ARHGAP39",
            "B2M",
            "IDS",
            "TNFAIP8",
            "MITF",
            "SOX12",
            "SPRED1",
            "AZI1",
            "SCRIB",
            "DNMT3A",
            "INPP1",
            "C6orf134",
            "GNG12",
            "C13orf23",
            "PRNP",
            "DHTKD1",
            "FBRSL1",
            "ARHGAP18",
            "ZNF74",
            "C6orf136",
            "INPPL1",
            "JARID2",
            "PFAS",
            "XPO5",
            "LYSMD2",
            "MDC1",
            "SETDB1",
            "MYBBP1A",
            "KIAA0664",
            "ZC3H3",
            "CUL7",
            "OSTM1",
            "VARS",
            "KLHL2",
            "ZNF193",
            "ZNF687",
            "NEURL4",
            "PBX2",
            "ANKS1A",
            "PELP1",
            "SH3BGRL",
            "TRIM11",
            "AARS2",
            "SLC39A7",
            "NFKBIL1",
            "ZNF786",
            "ABCC10",
            "ATG4A",
            "ZNF76",
            "TJAP1",
            "CAST",
            "SAMD1",
            "BAT2",
            "DVL2",
            "BANP",
            "CDC42SE2",
            "GTF2H4",
            "USP21",
            "BAT1",
            "ACVR1",
            "TMEM188",
            "ABCF1",
            "RBM10",
            "AP3S1",
            "UBAP2L",
            "SRRT",
            "ZNF777",
            "PPP2R5D",
            "FXR2",
            "ARL2BP",
            "CAP1",
            "ATF6B",
            "WRNIP1",
            "DHX16",
            "SRF",
            "VPS52",
            "PSPC1",
            "NFS1",
            "BRD2",
            "SKIV2L",
            "SH3BP5L",
            "BAT3",
            "HCG18",
            "LEMD2",
            "NAIF1",
            "TRIM27",
            "ILF3",
            "C6orf47",
            "TRIM39",
            "PCIF1",
            "DAXX",
            "RBM15B",
            "DHX30",
            "RBM14"
        ]
    },
    {
        "golabel": "EID1_regulon_activity",
        "gene": [
            "OMD",
            "TSLP",
            "NEGR1",
            "LPPR4",
            "KCNS2",
            "SERP2",
            "TMEM200A",
            "C1orf190",
            "PDE1A",
            "ESPL1",
            "KIF18B",
            "C6orf225",
            "PAMR1",
            "DDX12",
            "SNURF",
            "WNT5A",
            "RECQL4",
            "IQGAP3",
            "DCN",
            "CALCRL",
            "ECM2",
            "SDC2",
            "MSRB3",
            "NFKBIL2",
            "FEZ1",
            "NDN",
            "C15orf33",
            "CDK14",
            "PRDM5",
            "IGFBP7",
            "CNRIP1",
            "LRRC70",
            "RPS27L",
            "DBF4B",
            "DNAJB9",
            "LYRM1",
            "ELTD1",
            "EEF1A1",
            "COMMD10",
            "SPRED1",
            "RNF213",
            "SCRIB",
            "ACYP2",
            "POLE",
            "SENP8",
            "PNPLA4",
            "FAM165B",
            "CYP2U1",
            "TCEAL1",
            "WHSC1",
            "DSTN",
            "SGCB",
            "RPL15",
            "DIXDC1",
            "MYO19",
            "PTCD1",
            "FKBP7",
            "CRBN",
            "LYSMD2",
            "SLC25A22",
            "BBS4",
            "C7orf43",
            "ARL3",
            "TAF4",
            "FAM188A",
            "ZC3H3",
            "GABARAPL2",
            "C15orf57",
            "GTF2IRD1",
            "SFRS12IP1",
            "BBS10",
            "ZCCHC10",
            "MLL4",
            "CCNDBP1",
            "TTC33",
            "ENTPD1",
            "MTMR6",
            "SKP1",
            "LZTFL1",
            "PACS1",
            "PLCB3",
            "TXNDC15",
            "ZDHHC18",
            "TRIM23",
            "SH3BGRL",
            "MOV10",
            "FBXL5",
            "COPS2",
            "LMBRD1",
            "NDUFAF1",
            "SMG5",
            "CAMLG",
            "FAM172A",
            "FBXL17",
            "GMEB2",
            "CBR4",
            "PIGY",
            "CRYZL1",
            "UBE2B",
            "RNF11",
            "PEX12",
            "GNB5",
            "C3orf10",
            "PCNXL3",
            "NDFIP1",
            "GIN1",
            "C11orf46",
            "SRRT",
            "SMPD4",
            "SOCS5",
            "LAPTM4A",
            "EIF1B",
            "NDNL2",
            "C5orf24",
            "NPLOC4",
            "PAIP2",
            "EHMT1",
            "MARK2",
            "C4orf3",
            "PLDN",
            "UFSP2",
            "SEC22C",
            "AZI2",
            "OAZ2",
            "THAP11"
        ]
    },
    {
        "golabel": "EIF5B_regulon_activity",
        "gene": [
            "LCNL1",
            "SIGLECP3",
            "GATA1",
            "TSPAN32",
            "C11orf21",
            "C9orf139",
            "CELF6",
            "DPEP2",
            "LOC100131434",
            "BZRAP1",
            "C16orf79",
            "SEC31B",
            "LTC4S",
            "C16orf93",
            "ATG16L2",
            "ST3GAL6",
            "KIAA0664P3",
            "CSAD",
            "HSP90AB2P",
            "NFKBID",
            "MTMR9L",
            "LOC146880",
            "TTLL3",
            "PARVG",
            "UBXN11",
            "FGD2",
            "ENGASE",
            "TNFRSF14",
            "POU2F1",
            "C16orf86",
            "SNHG12",
            "NR1H3",
            "NCF4",
            "RASSF4",
            "C1orf63",
            "PLEKHM1P",
            "APBB3",
            "N4BP2L1",
            "PA2G4P4",
            "MAP4K4",
            "PION",
            "IL11RA",
            "CLK4",
            "LOC727896",
            "FAM113A",
            "GSDMD",
            "AGXT2L2",
            "AMDHD2",
            "ZNF266",
            "ABTB1",
            "CCDC130",
            "RHOT2",
            "ZNF700",
            "SPSB3",
            "PSMD1",
            "LCLAT1",
            "MRI1",
            "RMND5A",
            "TBC1D10A",
            "PHF14",
            "FLCN",
            "UGGT1",
            "FLYWCH1",
            "POLR1B",
            "NOLC1",
            "RNF166",
            "UBE2K",
            "HNRNPA3P1",
            "BAT2L2",
            "RASSF1",
            "SSB",
            "TAF3",
            "KIF5B",
            "RANBP2",
            "SET",
            "SSR1",
            "LSM12",
            "ABCD4",
            "DEF8",
            "PPM1G",
            "CWF19L2",
            "NCL",
            "HSPA4",
            "RAD23B",
            "SRBD1",
            "PPIG",
            "CIR1",
            "MRPL19",
            "FAM98A",
            "PRPF40A",
            "MPHOSPH10",
            "VCP",
            "RAB3GAP1",
            "RTF1",
            "BRAP",
            "HNRNPU"
        ]
    },
    {
        "golabel": "ELF1_regulon_activity",
        "gene": [
            "POF1B",
            "NRTN",
            "PRSS53",
            "TMEM52",
            "FMN1",
            "C19orf46",
            "MBNL3",
            "TIGD3",
            "FAM69B",
            "MAP6D1",
            "GPR3",
            "C5orf55",
            "IL6ST",
            "PRRG1",
            "KLF5",
            "PSMC3IP",
            "CHTF18",
            "C16orf59",
            "FOXO1",
            "SGMS2",
            "MBLAC1",
            "CD320",
            "LOC92659",
            "SLC25A10",
            "SH2D4A",
            "ZDHHC20",
            "NIPAL2",
            "PRAF2",
            "PDXP",
            "HERC3",
            "KLF6",
            "CCDC122",
            "RP9P",
            "WDR34",
            "MXD3",
            "TGFBR2",
            "CTU1",
            "NDFIP2",
            "KAT2A",
            "UBL3",
            "SAC3D1",
            "LNX2",
            "C17orf89",
            "FAM50A",
            "C5orf41",
            "KBTBD7",
            "GALC",
            "TCFL5",
            "HIPK3",
            "C13orf31",
            "TMUB1",
            "DUSP18",
            "KIF22",
            "BBS12",
            "GLUD2",
            "DUS1L",
            "FNDC3A",
            "LRCH1",
            "TMEM201",
            "USP12",
            "DOHH",
            "B3GAT3",
            "PELI3",
            "COG6",
            "PGP",
            "MBNL2",
            "MTMR6",
            "C1orf35",
            "STK24",
            "TMOD3",
            "NARF",
            "RP9",
            "ZC3H13",
            "SLC25A30",
            "RFNG",
            "ADRM1",
            "TM9SF2",
            "PARP4",
            "CCS",
            "C16orf53",
            "RB1",
            "TSEN54",
            "MAZ",
            "UEVLD",
            "MBD3",
            "C6orf211",
            "FBXL17",
            "IQGAP1",
            "CAB39",
            "ZBTB38",
            "NHLRC3",
            "FBXL3",
            "SH3D19",
            "TIMM44",
            "DNAJB14",
            "TANK",
            "AKAP11",
            "SPG20",
            "NCOA4",
            "PJA2",
            "CREBL2",
            "NDUFV1",
            "ZFPL1",
            "KIAA1704",
            "UTP14C",
            "VPS36",
            "JAK1",
            "DIS3",
            "SERINC1",
            "UFM1",
            "RNF6",
            "RHBDD1",
            "PTPN9",
            "RNF111",
            "TMEM184C",
            "SEC24B",
            "PDCD6IP"
        ]
    },
    {
        "golabel": "ELF3_regulon_activity",
        "gene": [
            "FAM3D",
            "FA2H",
            "ATF3",
            "DEGS2",
            "PTPRH",
            "GPC6",
            "BCL2L15",
            "CAPN8",
            "SPACA4",
            "FAM26E",
            "EPS8L1",
            "CLDN3",
            "EFCAB4A",
            "SLC44A4",
            "STX19",
            "CLDN23",
            "TRPM4",
            "RHBDL2",
            "DSE",
            "PLEKHA6",
            "FAM83E",
            "TMC5",
            "CCDC64B",
            "CYP2J2",
            "EFNA1",
            "GNA14",
            "LAMB1",
            "TFAP2C",
            "HES1",
            "TJP3",
            "PLS1",
            "GOLM1",
            "C1orf106",
            "PVRL4",
            "DUSP8",
            "GNB4",
            "CCDC88A",
            "IER2",
            "PRSS8",
            "OVOL2",
            "LRRC8C",
            "CLDN4",
            "RAB25",
            "TMC4",
            "HDHD3",
            "TMEM63A",
            "RECQL",
            "KIAA1543",
            "CLIC4",
            "SH3RF1",
            "ILDR1",
            "FERMT2",
            "MIDN",
            "TRAK1",
            "C9orf7",
            "GIPC1",
            "SLC37A1",
            "TRAF4",
            "ARRDC1",
            "TTL",
            "SGTB",
            "VPS37B",
            "SSH3",
            "QKI",
            "RNF103",
            "TMEM53",
            "DLG3",
            "OSBPL8",
            "COG7",
            "ARL8A",
            "CDC27"
        ]
    },
    {
        "golabel": "ELF4_regulon_activity",
        "gene": [
            "CBR1",
            "ENO3",
            "AKR1C2",
            "AKR1C1",
            "MFI2",
            "RASD1",
            "EPHX1",
            "FAM70A",
            "UGT8",
            "ASPHD2",
            "AFAP1L2",
            "ITGA2",
            "PDE4D",
            "NNMT",
            "C17orf61",
            "SLC45A3",
            "FLJ35776",
            "PTAFR",
            "SLC9A7",
            "SAMD9",
            "AIM1",
            "CDCP1",
            "DDX60",
            "MFSD3",
            "DCXR",
            "LDLR",
            "NCEH1",
            "MICB",
            "FBXO16",
            "BICD1",
            "SLC9A1",
            "ITPR3",
            "PLXNA1",
            "PHPT1",
            "XBP1",
            "C2orf79",
            "CMTM1",
            "RANGRF",
            "HIVEP3",
            "SMAD3",
            "MCEE",
            "TMEM9",
            "MRPS26",
            "FLNB",
            "KRTCAP2",
            "HERC3",
            "BPHL",
            "C2orf64",
            "PML",
            "LYPLAL1",
            "C22orf32",
            "VCL",
            "ZSWIM7",
            "TRIM14",
            "ZSCAN16",
            "RPAIN",
            "SLC9A6",
            "MED11",
            "CORO1C",
            "PTDSS2",
            "ANKRD16",
            "ABR",
            "ATP5A1",
            "TAOK3",
            "ZNFX1",
            "ANO6",
            "SPAG7",
            "PCYT1A",
            "CCDC90A",
            "WBP1",
            "ATPAF2",
            "ARHGEF18",
            "COQ6",
            "ENOX2",
            "PAK2",
            "WDFY1",
            "IP6K2",
            "MRPS31",
            "PDHB",
            "EIF2B4",
            "RDH14",
            "ZNF317"
        ]
    },
    {
        "golabel": "ELK3_regulon_activity",
        "gene": [
            "BLID",
            "HMGA2",
            "LOC145837",
            "TGM4",
            "AKR7L",
            "FOSL1",
            "LOC100126784",
            "ASAM",
            "THPO",
            "LAMC2",
            "GPR87",
            "TGFBI",
            "SEMA3A",
            "SEMA7A",
            "LOXL2",
            "KIAA1324",
            "EDIL3",
            "LCN12",
            "CD274",
            "LOC399959",
            "ARNTL2",
            "LOC100129066",
            "FHOD3",
            "TNC",
            "PLAU",
            "PCDH7",
            "DCBLD2",
            "SH3RF2",
            "CD109",
            "GPT2",
            "NT5E",
            "ADAMTS12",
            "KCNJ11",
            "FN1",
            "BICC1",
            "DCBLD1",
            "CDH3",
            "FAM3B",
            "BEND6",
            "TFCP2L1",
            "C10orf55",
            "TIPARP",
            "GADD45G",
            "LAYN",
            "LOX",
            "LDHD",
            "SRPX2",
            "ITGA2",
            "FRMD6",
            "TMEM200A",
            "EPHB2",
            "COL8A1",
            "SLC24A5",
            "PRKG1",
            "SLC16A2",
            "SEMA3C",
            "PTAFR",
            "ARHGAP29",
            "AGPHD1",
            "LASS4",
            "MAGIX",
            "STEAP2",
            "ADAM8",
            "GSTA4",
            "ANO9",
            "PHLDA1",
            "TSPAN5",
            "BCAR3",
            "PLEKHB1",
            "OSMR",
            "CDH11",
            "EFCAB2",
            "TSC22D2",
            "SAMD9",
            "C6orf26",
            "TMED7-TICAM2",
            "AIM1",
            "CDCP1",
            "SSPN",
            "KLHDC9",
            "EFNB2",
            "MBOAT2",
            "C10orf75",
            "SPIRE2",
            "C5orf62",
            "KIAA1462",
            "AXL",
            "ZNF185",
            "KIRREL",
            "PTPRG",
            "DSE",
            "IRS1",
            "TTC32",
            "PPFIBP1",
            "SLC25A35",
            "DCXR",
            "STARD10",
            "GYG2",
            "NECAB3",
            "NEDD4",
            "IFI16",
            "KIAA0114",
            "MAP7D3",
            "EMP1",
            "PLXNC1",
            "FAS",
            "UNC13B",
            "ASPSCR1",
            "LIPT2",
            "NCEH1",
            "HMGN3",
            "CDK2AP2",
            "MYLK",
            "ADI1",
            "NCS1",
            "BICD1",
            "MDFIC",
            "MAML2",
            "C8orf38",
            "KLHL5",
            "PDGFC",
            "CHKA",
            "MAN2A1",
            "BGLAP",
            "TIMP2",
            "SLC29A2",
            "SMURF2",
            "FAM164C",
            "C6orf125",
            "UCP2",
            "PALLD",
            "PLXDC2",
            "ITGAV",
            "ANTXR2",
            "STK17A",
            "HIF1A",
            "LOC202781",
            "ETS1",
            "GKAP1",
            "CMTM3",
            "MGC70857",
            "FN3K",
            "DAPP1",
            "IDS",
            "FLNA",
            "CMTM1",
            "RANGRF",
            "MYOF",
            "HRH1",
            "SLFN5",
            "SKAP2",
            "MARVELD1",
            "LHFPL2",
            "RAB40B",
            "FRAT2",
            "MRPS26",
            "KIAA1949",
            "EXOC6B",
            "LIMK1",
            "PTPN14",
            "NRIP1",
            "ICA1",
            "DDTL",
            "IKBIP",
            "MTERFD3",
            "ATP10D",
            "APOBEC3C",
            "GNG12",
            "KLF7",
            "CALU",
            "PRNP",
            "BCL9L",
            "PLIN3",
            "LIMS1",
            "RECQL",
            "FAM104B",
            "ARHGAP10",
            "CCNG2",
            "SIGIRR",
            "SPATS2L",
            "LEPROT",
            "C6orf136",
            "RALB",
            "RASAL2",
            "SDR39U1",
            "TPM4",
            "AVL9",
            "BCAT2",
            "BCL10",
            "VCL",
            "C2orf34",
            "DTNB",
            "COQ10A",
            "ZSCAN16",
            "ARL6IP5",
            "FBXO25",
            "RPAIN",
            "DCUN1D3",
            "RASA1",
            "TRIM34",
            "DOM3Z",
            "ATG4D",
            "EXT1",
            "RAP2B",
            "CORO1C",
            "LYSMD4",
            "LUZP1",
            "FNDC3B",
            "GNA12",
            "PGM1",
            "ZYX",
            "BACH1",
            "PAFAH1B2",
            "KLF10",
            "BSCL2",
            "C1orf66",
            "TMEM41B",
            "ZDHHC16",
            "RRAGC",
            "PEBP1",
            "SSH1",
            "SETD7",
            "PABPN1",
            "AIFM1",
            "ANO6",
            "DUSP28",
            "RAB11FIP5",
            "ZNF76",
            "NEK6",
            "CAST",
            "CAB39",
            "ZBTB38",
            "RIN2",
            "RSPRY1",
            "LUZP6",
            "PDHA1",
            "SH3D19",
            "MED9",
            "C2orf68",
            "ACVR1",
            "GNAI2",
            "CTTNBP2NL",
            "CBWD2",
            "RBMS1",
            "SFT2D3",
            "MYD88",
            "EHD4",
            "TMCO7",
            "CAP1",
            "PTPN12",
            "ORMDL1",
            "SEPT7",
            "MUL1",
            "C1orf77",
            "FCF1",
            "PTPN9",
            "TMEM184C",
            "TMEM127",
            "C16orf72",
            "EIF4H",
            "ACTR2"
        ]
    },
    {
        "golabel": "ELL3_regulon_activity",
        "gene": [
            "PLA2G10",
            "HGD",
            "CKMT1A",
            "NQO1",
            "CD109",
            "GAS5",
            "TIAM1",
            "EFCAB4A",
            "GPR161",
            "TSC22D2",
            "KRTCAP3",
            "CNTLN",
            "STARD10",
            "LOC440957",
            "MAP7D3",
            "C15orf56",
            "AKAP2",
            "FKBP2",
            "BICD1",
            "NUDT13",
            "BAG1",
            "ABHD14A",
            "TIMP2",
            "EHD3",
            "PLXNA1",
            "ACTN1",
            "TMED3",
            "C1orf210",
            "CHP",
            "MPST",
            "RBL1",
            "SNX22",
            "MCEE",
            "GOLIM4",
            "SERF2",
            "CATSPER2P1",
            "NOTCH2",
            "C15orf63",
            "KIF9",
            "PDIA3",
            "DAAM1",
            "CLDN7",
            "PDIA3P",
            "RAB25",
            "PNKD",
            "HDHD3",
            "ASAP1",
            "ATP11C",
            "YEATS2",
            "MRPS36",
            "ATPIF1",
            "SIPA1L1",
            "TCTA",
            "FBXO25",
            "TMEM62",
            "PCBD1",
            "ATP2C1",
            "MED11",
            "GNA12",
            "PRKD3",
            "OXSM",
            "MANBA",
            "CYP2R1",
            "TMEM87A",
            "PIK3CA",
            "PJA1",
            "CBLB",
            "ENSA",
            "BBX",
            "UFC1",
            "GALK2",
            "NDUFAF1",
            "DCLRE1B",
            "LCMT2",
            "IMP3",
            "PIGB",
            "SNUPN",
            "EIF3J",
            "RPUSD2",
            "SRP14",
            "MTFMT",
            "TM2D3",
            "MFAP1",
            "ZFYVE1",
            "SPG21"
        ]
    },
    {
        "golabel": "ENO1_regulon_activity",
        "gene": [
            "BTNL9",
            "FOSL1",
            "COL6A6",
            "PIP5K1B",
            "DNAH1",
            "PLOD2",
            "PMAIP1",
            "ATP1B2",
            "ANLN",
            "FHL5",
            "NMUR1",
            "ABCA9",
            "PFKFB4",
            "LOC654342",
            "PDE3B",
            "TUBB3",
            "ERRFI1",
            "CDC20",
            "SELP",
            "UPP1",
            "BTG2",
            "CABLES1",
            "VWF",
            "PTPRB",
            "CDCA8",
            "SFN",
            "SMAD6",
            "ENO2",
            "PYGL",
            "DAPK1",
            "SLC16A3",
            "C7orf40",
            "CHCHD2",
            "METTL7A",
            "TK1",
            "FAM162A",
            "ASF1B",
            "SEC61G",
            "BEND7",
            "CALML4",
            "CDCA4",
            "CENPH",
            "TUBA4A",
            "RNASEH2A",
            "CHAF1B",
            "GAPDH",
            "GINS3",
            "FRAT1",
            "CYYR1",
            "NME1",
            "TRAIP",
            "MAD2L2",
            "EPAS1",
            "P4HA1",
            "PGK1",
            "HPRT1",
            "LOC401010",
            "RPA3",
            "LDHA",
            "LIMD1",
            "P4HA2",
            "GPSM2",
            "RCC1",
            "PPIAL4G",
            "H2AFZ",
            "LIMK1",
            "PUSL1",
            "CCT5",
            "NRIP2",
            "PPIAL4C",
            "MTP18",
            "GBE1",
            "MED10",
            "MRPS24",
            "SNAPC1",
            "PPP1R14B",
            "PAICS",
            "PGAM4",
            "TUBA1C",
            "CCM2",
            "NUDT1",
            "DVL1",
            "ALDOA",
            "THOC4",
            "TUBB",
            "TUBG1",
            "TUBA1B",
            "SGK269",
            "RFC2",
            "TPI1",
            "LYAR",
            "C21orf70",
            "ATAD3A",
            "AURKAIP1",
            "UBL4A",
            "TRAK1",
            "PKM2",
            "RPF2",
            "HMGN2",
            "B4GALT2",
            "SRM",
            "PDCD4",
            "MRTO4",
            "POLD2",
            "STYXL1",
            "PSMC2",
            "EIF3B",
            "PPIA",
            "LRRC42",
            "PSMA2",
            "SSBP1",
            "MTMR10",
            "CBX3",
            "CPEB3",
            "SSSCA1",
            "PGAM1",
            "NOC2L",
            "HERC1",
            "NSUN5",
            "YWHAG",
            "ZZEF1",
            "RRP1",
            "EBNA1BP2",
            "MRPL37",
            "SDHB",
            "MLYCD",
            "GRPEL1",
            "PEX10",
            "EIF2S1",
            "ACTG1",
            "DDX56",
            "PHF13",
            "C7orf30",
            "PHC2",
            "FADD",
            "GSS",
            "EIF3I",
            "PARK7",
            "FARSB",
            "PHB",
            "TACO1",
            "FTSJ2",
            "SNRK",
            "DFFA",
            "VPS36",
            "PSMB2",
            "DARS",
            "PSMC3",
            "UBE2J2",
            "DNAJC8",
            "ABCF2",
            "UTP11L",
            "EPC1",
            "ICMT",
            "DDX41",
            "PEX14",
            "VPS39",
            "YARS",
            "EFTUD2",
            "SF3A3",
            "TTC4",
            "VAMP3",
            "GNB1",
            "DHDDS",
            "EIF4H",
            "UBE2I",
            "EXOSC10",
            "C1orf144"
        ]
    },
    {
        "golabel": "EP300_regulon_activity",
        "gene": [
            "SORL1",
            "PFDN5",
            "ZNHIT1",
            "LOC100130932",
            "C20orf117",
            "ITGB3BP",
            "ATP6V0B",
            "MYO10",
            "SYNE2",
            "MDN1",
            "TTC28",
            "MORN2",
            "NAA10",
            "MXD3",
            "COMMD3",
            "UTRN",
            "KIAA1671",
            "UXT",
            "BNIP1",
            "NDUFA1",
            "HCG11",
            "COMMD5",
            "MRPL22",
            "REST",
            "DOPEY2",
            "ERC1",
            "LOC388955",
            "PSME1",
            "ERCC6",
            "ZMIZ1",
            "PPARA",
            "PI4KA",
            "PRELID1",
            "ZNF70",
            "SREBF2",
            "MAPK1",
            "TANC1",
            "MYST4",
            "POLR2A",
            "ZC3H13",
            "TOB2",
            "LDOC1L",
            "RREB1",
            "HIVEP1",
            "RBM9",
            "TRIP11",
            "TNRC6B",
            "ARHGEF12",
            "C22orf30",
            "IL17RA",
            "CLTA",
            "SPEN",
            "BPTF",
            "CREBBP",
            "TCF20",
            "ZNF609",
            "ZC3H7B",
            "PEX26",
            "CYTSA",
            "MCTS1",
            "YLPM1",
            "DEPDC5",
            "TUG1",
            "CTNND1",
            "ARID1B",
            "SON",
            "TMEM203",
            "SF3A1",
            "EIF4ENIF1"
        ]
    },
    {
        "golabel": "EP400_regulon_activity",
        "gene": [
            "NUP210",
            "HSD17B8",
            "MGC16384",
            "KNTC1",
            "CEP152",
            "CALM2",
            "PITPNM2",
            "MPHOSPH9",
            "TSPAN6",
            "MDN1",
            "POLE",
            "RAD54L2",
            "RBX1",
            "SBNO1",
            "MED13L",
            "TMEM165",
            "TRRAP",
            "VKORC1",
            "TET3",
            "C11orf67",
            "BLVRA",
            "RPL23AP82",
            "TXN2",
            "IFNGR2",
            "TAGLN2",
            "ULK1",
            "GABARAPL2",
            "C12orf51",
            "MLL2",
            "MED18",
            "ARPC5",
            "CEP290",
            "UROD",
            "PDCD11",
            "ZNF268",
            "MLXIP",
            "C2CD3",
            "ZNF664",
            "ZCCHC17",
            "ZNF605",
            "ZNF84",
            "NAA25",
            "NCOR2",
            "STK16",
            "GOLGA3",
            "GCN1L1",
            "RREB1",
            "HUWE1",
            "LOC285033",
            "TRAPPC3",
            "ANKLE2",
            "BAZ2A",
            "PTPN11",
            "CREB3",
            "ELOVL1",
            "ZDHHC4",
            "SPEN",
            "PRDM10",
            "SETD8",
            "RBM19",
            "KDM2B",
            "ATXN2",
            "FBXW8",
            "BIRC6",
            "SETD1B",
            "SFRS8",
            "ARL2BP",
            "HCFC1",
            "ATP6V1E1",
            "TCHP",
            "ATP6V1D",
            "GPATCH8",
            "USP34",
            "SYS1",
            "PRDM4",
            "KDM2A",
            "NUP214",
            "SART3",
            "UBE3B"
        ]
    },
    {
        "golabel": "EPAS1_regulon_activity",
        "gene": [
            "KCNK3",
            "CACNA2D2",
            "SECISBP2L",
            "ATOH8",
            "NR4A1",
            "PDK4",
            "TACC2",
            "GPR133",
            "MAOA",
            "ADAMTSL3",
            "C6orf141",
            "EDNRB",
            "FHL5",
            "PDE4D",
            "TEK",
            "SEMA3G",
            "GPR20",
            "AK3L1",
            "ANKRD22",
            "FRMD5",
            "RHOBTB2",
            "SIK1",
            "DLC1",
            "SETBP1",
            "RHEBL1",
            "RAET1K",
            "PEAR1",
            "ROBO4",
            "VWF",
            "PTPRB",
            "DOCK5",
            "ALDOC",
            "RFC4",
            "CDH5",
            "NEDD4L",
            "FAM162A",
            "CKLF",
            "S1PR1",
            "PAQR4",
            "GATA2",
            "LDB2",
            "CD34",
            "LIMCH1",
            "CXorf36",
            "PTPRM",
            "MMRN2",
            "PSMB8",
            "HECW2",
            "CENPP",
            "HPRT1",
            "RPA3",
            "LIMD1",
            "ZCCHC2",
            "TTC28",
            "MED10",
            "SIK2",
            "PDRG1",
            "MED13L",
            "ZNF530",
            "TMEM51",
            "ZNF138",
            "SPTBN1",
            "CPEB2",
            "RFC2",
            "POT1",
            "FAM190B",
            "ZDHHC13",
            "WDR53",
            "NR3C1",
            "FANCL",
            "PCYOX1",
            "HAUS8",
            "HMGN2",
            "NCOA1",
            "ENO1",
            "SSBP1",
            "MRPS22",
            "GTPBP10",
            "SEC22A",
            "GSS",
            "MEF2D",
            "CRTC3",
            "ATF7"
        ]
    },
    {
        "golabel": "ESPL1_regulon_activity",
        "gene": [
            "LOC100132354",
            "CDH18",
            "C1QL4",
            "C2orf78",
            "INHBE",
            "ZIC1",
            "NKAIN1",
            "HOXD11",
            "FAM171A2",
            "RAB3B",
            "GDF1",
            "MAGEA12",
            "MAGEA2",
            "PATE2",
            "PEBP4",
            "MAGEA6",
            "MAGEA3",
            "MLLT11",
            "ATOH7",
            "CST5",
            "ACRV1",
            "MKRN3",
            "C6orf195",
            "DSCR6",
            "HPDL",
            "CRYM",
            "FCER1A",
            "DNMT3B",
            "SFTA1P",
            "C8orf34",
            "RCOR2",
            "HOPX",
            "MAST1",
            "ADH1B",
            "CD1E",
            "ROBO2",
            "CTSH",
            "MURC",
            "INMT",
            "MTL5",
            "STC2",
            "CD1C",
            "RNF157",
            "AGR3",
            "IL33",
            "CBX2",
            "C1QTNF7",
            "CNTN3",
            "C2orf58",
            "WDR62",
            "FXYD1",
            "FLJ36777",
            "CX3CR1",
            "RNASE1",
            "MCF2L2",
            "PCDP1",
            "CLSPN",
            "HIGD1B",
            "SCN4B",
            "MFAP4",
            "EXO1",
            "CYSLTR1",
            "AURKA",
            "TMEM37",
            "MYBL2",
            "NPC2",
            "KIF3C",
            "TROAP",
            "FAM72D",
            "PLAC9",
            "WFDC2",
            "C17orf53",
            "C1orf116",
            "EMCN",
            "ARHGAP11B",
            "DEPDC1",
            "PLLP",
            "NUP107",
            "C15orf42",
            "FOXM1",
            "ORC1L",
            "KIF15",
            "ZMYND12",
            "TPX2",
            "POLQ",
            "KIF2C",
            "ENTPD3",
            "KIF18B",
            "KIF14",
            "DRAM1",
            "FAM72A",
            "FAM72B",
            "E2F2",
            "KIFC1",
            "CENPE",
            "CENPF",
            "RAD54L",
            "CYBRD1",
            "MGP",
            "DSP",
            "NCAPG",
            "BUB1B",
            "ASPM",
            "CFI",
            "LOC222699",
            "BLM",
            "NCAPH",
            "BUB1",
            "TOP2A",
            "KIF4A",
            "PFKP",
            "RECQL4",
            "IQGAP3",
            "SPAG5",
            "FAM82A1",
            "C1orf133",
            "LOC100128191",
            "C21orf63",
            "PLK4",
            "KIF20A",
            "MPZL2",
            "BRCA1",
            "GSG2",
            "CCT6B",
            "C17orf96",
            "NFKBIL2",
            "GATSL1",
            "C9orf100",
            "ZWINT",
            "NUP210",
            "C1orf21",
            "LMNB1",
            "RACGAP1",
            "NR3C2",
            "KBTBD3",
            "WDR67",
            "C7orf23",
            "TACC3",
            "TMEM98",
            "BDNFOS",
            "SHMT2",
            "CD302",
            "BRI3BP",
            "KNTC1",
            "HNMT",
            "FADS1",
            "FANCI",
            "SEPW1",
            "EMP2",
            "TIMELESS",
            "TRERF1",
            "INCENP",
            "CCNF",
            "TSC22D1",
            "TMEM159",
            "SLC7A1",
            "DBF4B",
            "TSPAN3",
            "CD59",
            "PGCP",
            "CAD",
            "ZNF552",
            "TSPAN4",
            "CENPO",
            "FUCA1",
            "FLJ11235",
            "CAT",
            "RAB27A",
            "EIF2C2",
            "RRM2B",
            "FCGRT",
            "WHSC1",
            "CHAF1A",
            "STOM",
            "PIK3IP1",
            "CYP4V2",
            "CYB5R1",
            "PUS1",
            "ARV1",
            "CLPB",
            "STK17B",
            "CTSO",
            "E2F3",
            "ECHDC1",
            "HERPUD1",
            "TTLL4",
            "QSOX2",
            "GDE1",
            "EIF4E3",
            "BTD",
            "RBM28",
            "SPHAR",
            "TAF5",
            "RNF141",
            "FAM189B",
            "SLC38A7",
            "DHX37",
            "MBNL2",
            "CCDC137",
            "POLR3GL",
            "TXNDC15",
            "GCN1L1",
            "TPRG1L",
            "NOC4L",
            "SCP2",
            "NKIRAS1",
            "PPP2CB",
            "FBXO3",
            "CHFR",
            "REEP5",
            "TMEM9B",
            "TRIM13",
            "FXC1",
            "SMPD4",
            "EID1",
            "FAM82A2",
            "LAPTM4A",
            "C9orf156",
            "SFRS2B",
            "CCDC115",
            "CYP20A1",
            "RAB35"
        ]
    },
    {
        "golabel": "ESRRA_regulon_activity",
        "gene": [
            "RAB26",
            "RHBDL1",
            "ARHGAP28",
            "LOC100133612",
            "HAGHL",
            "NOXA1",
            "EFCAB4A",
            "COMTD1",
            "BACH2",
            "OPLAH",
            "SSPN",
            "UFSP1",
            "ANKRD9",
            "DNLZ",
            "SLC39A4",
            "AXL",
            "NUDT8",
            "MFSD3",
            "STARD10",
            "NECAB3",
            "ST6GALNAC4",
            "KIAA0114",
            "FAM195A",
            "PLXNC1",
            "ADCK5",
            "CHCHD10",
            "NELF",
            "TIMM16",
            "CDK2AP2",
            "SNHG7",
            "FKBP2",
            "SLC35C1",
            "C7orf47",
            "MRPL41",
            "C8orf55",
            "TPRN",
            "GSTP1",
            "TSTA3",
            "PHPT1",
            "LPCAT2",
            "C11orf83",
            "AIFM2",
            "ENDOG",
            "MGC70857",
            "DGAT1",
            "EPB41L2",
            "PPP1R16A",
            "ATP5D",
            "DCI",
            "ZNF511",
            "MRPL23",
            "PKP3",
            "PPP1R14B",
            "NDUFA7",
            "ACADVL",
            "C9orf142",
            "LIMS1",
            "SAC3D1",
            "PRDX5",
            "TCIRG1",
            "FBXL15",
            "C6orf136",
            "NDUFS8",
            "ZNF524",
            "SFXN4",
            "HRAS",
            "C19orf24",
            "GAB1",
            "SHARPIN",
            "C9orf23",
            "HACE1",
            "TMEM93",
            "NT5C",
            "CHCHD8",
            "ATG4D",
            "EEF1G",
            "TMEM134",
            "SSNA1",
            "DUS1L",
            "TMEM120A",
            "BACH1",
            "FBXW5",
            "COX8A",
            "TRPT1",
            "TIMM13",
            "REPIN1",
            "PRKD3",
            "DNAJC4",
            "C1orf66",
            "SSH3",
            "PTGES2",
            "EDF1",
            "BAD",
            "PLEKHJ1",
            "ZDHHC24",
            "PIK3CA",
            "PLCB3",
            "MDH2",
            "ZNF436",
            "NUDT22",
            "FPGS",
            "ANO6",
            "TRIM11",
            "CTTN",
            "XRN1",
            "IFRD2",
            "OSBPL8",
            "WDR74",
            "TIMM44",
            "DPP3",
            "ATXN1",
            "BRMS1",
            "NADSYN1",
            "NDUFV1",
            "TAF6L",
            "ZFPL1",
            "RABGGTA",
            "MRPL16",
            "GMPPB",
            "CORO1B",
            "ZFYVE27",
            "SERINC1",
            "OTUB1",
            "TAB2",
            "VEZF1",
            "C11orf2",
            "UBXN1",
            "MORC3",
            "TTC15",
            "RAB1B"
        ]
    },
    {
        "golabel": "ETS1_regulon_activity",
        "gene": [
            "TNFRSF8",
            "AFAP1L2",
            "CD163L1",
            "ABLIM3",
            "MGC12916",
            "ADAM19",
            "C10orf10",
            "VPS37D",
            "IL18R1",
            "KIAA1462",
            "TGM2",
            "TMCC3",
            "TLR6",
            "EGFL6",
            "MAP7D3",
            "C20orf151",
            "GEMIN8P4",
            "C1orf56",
            "TIMM16",
            "TNFAIP3",
            "AKAP2",
            "CREB3L4",
            "BDH1",
            "PRDM1",
            "C8orf55",
            "TNFAIP8L1",
            "KLF12",
            "ITPRIP",
            "RASA3",
            "FLI1",
            "ELK3",
            "CCDC24",
            "BOLA1",
            "PALM2-AKAP2",
            "PDCD6",
            "MRPS26",
            "DCI",
            "SH3KBP1",
            "DDT",
            "ATP10D",
            "ZFP36L2",
            "C10orf35",
            "CBX8",
            "LOC645332",
            "ZFYVE19",
            "PRRG2",
            "SEC14L1",
            "NMT2",
            "ARID5B",
            "KLF10",
            "MVK",
            "NEK1",
            "TMEM177",
            "HIVEP2",
            "NIN",
            "C1orf35",
            "PTPN1",
            "PRKCH",
            "AP1M2",
            "SLC37A4",
            "SNRK",
            "NIT1",
            "WDFY1",
            "TMEM186",
            "JAK1",
            "SETX",
            "DNAJA3"
        ]
    },
    {
        "golabel": "EZH1_regulon_activity",
        "gene": [
            "AGBL2",
            "CCDC114",
            "MYCBPAP",
            "CCDC39",
            "FAM138F",
            "OR56B1",
            "BCO2",
            "GP1BA",
            "IL8",
            "FAM95B1",
            "AMY2B",
            "CCDC146",
            "KIAA1529",
            "AGAP11",
            "NPY6R",
            "CAPN3",
            "LOC121952",
            "SLC6A16",
            "PXT1",
            "BTBD18",
            "ARL17B",
            "POM121L10P",
            "TAS2R4",
            "SEC31B",
            "EFHC1",
            "NEAT1",
            "LOC91316",
            "C6orf164",
            "FAM13AOS",
            "MASP2",
            "CHCHD2",
            "TTLL3",
            "CROCCL2",
            "ECE2",
            "ABCA5",
            "LENG8",
            "LMOD3",
            "KIAA1407",
            "PITPNM3",
            "DCTPP1",
            "LRRC37A2",
            "IFT172",
            "KLHL3",
            "PLEKHM1P",
            "TRIM66",
            "CBX7",
            "DENND3",
            "TOMM5",
            "RALGPS1",
            "GLRX3",
            "CREM",
            "TUBGCP6",
            "LOC441089",
            "CYCS",
            "OSTC",
            "LOC90110",
            "ZNF589",
            "PSMB5",
            "DCUN1D5",
            "C19orf44",
            "NEK8",
            "MYO18A",
            "LRRC37A",
            "MAPKBP1",
            "TNRC6C",
            "STOML2",
            "BZW2",
            "BZW1",
            "ARL17A",
            "UCHL3",
            "PAIP1",
            "ARHGAP27",
            "ERH",
            "CALCOCO1",
            "CLCN6",
            "SRPRB",
            "C12orf23",
            "PNO1",
            "SFRS18",
            "WDR19",
            "MLLT6",
            "TEP1",
            "MGAT2",
            "LSM5",
            "CCT4",
            "ADCY6",
            "PPIP5K1",
            "ZNF224",
            "BCL2L2",
            "CDK2AP1",
            "KCTD7",
            "POLE3",
            "UBE2N",
            "CXorf23",
            "YRDC",
            "CUL9",
            "ATP6V0A1",
            "PLEKHM1",
            "EBNA1BP2",
            "ZNF512",
            "CASP3",
            "POLH",
            "CHD2",
            "HDAC5",
            "ACTR3",
            "KIAA1267",
            "C15orf17",
            "BBS2",
            "WDR37",
            "RBM33",
            "UBE2G2",
            "HCCS",
            "UBE2F",
            "PHKA2",
            "CYTH1",
            "RSAD1",
            "HPS4",
            "FAM21C",
            "VPS39",
            "MCM3AP",
            "STAT5B",
            "SURF4",
            "NDST2",
            "TRIM39"
        ]
    },
    {
        "golabel": "FBXL19_regulon_activity",
        "gene": [
            "LOC388242",
            "C19orf23",
            "P2RY14",
            "RECQL4",
            "NCRNA00095",
            "SPTBN2",
            "NFKBIL2",
            "ZDHHC2",
            "C14orf80",
            "DNAJB9",
            "CLCN2",
            "EEF1A1",
            "CCNG1",
            "FCHO2",
            "AZI1",
            "SCRIB",
            "EEF1A1P9",
            "INTS1",
            "LMNB2",
            "HSDL2",
            "NIPSNAP3A",
            "STK17B",
            "TNRC18",
            "EIF4E3",
            "ZNF768",
            "GTPBP3",
            "ULK1",
            "EHBP1L1",
            "ZC3H3",
            "CCDC137",
            "ZNF598",
            "FBXL5",
            "CHURC1",
            "HCFC2",
            "CDC42SE2",
            "NCOA4",
            "FBRS",
            "NDFIP1",
            "HDGFRP2",
            "ZNF668",
            "GIN1",
            "MEN1",
            "REXO1",
            "SETD1A",
            "SRRT",
            "SMPD4",
            "ZNF282",
            "AMPD2",
            "PAIP2",
            "GTF3C1",
            "C9orf156",
            "ATXN7L3",
            "SKIV2L",
            "LEMD2",
            "ATXN2L",
            "TM9SF4",
            "DAZAP2",
            "AZI2",
            "SAFB",
            "DAZAP1",
            "PPP6C",
            "UBTF"
        ]
    },
    {
        "golabel": "FHL2_regulon_activity",
        "gene": [
            "CALHM3",
            "GJB5",
            "CYP4B1",
            "GJB3",
            "CCL7",
            "GPR87",
            "PPAPDC1A",
            "C15orf48",
            "C16orf89",
            "GPR115",
            "GREM1",
            "PTPRH",
            "PLAU",
            "KLF15",
            "THBS2",
            "ADAMTS12",
            "PLCD3",
            "KRT80",
            "MXRA5",
            "SLC2A1",
            "RHOF",
            "STEAP1",
            "CDH3",
            "COL3A1",
            "SULF1",
            "GLS2",
            "COL5A2",
            "TNFAIP6",
            "SELENBP1",
            "FAM184A",
            "COL5A1",
            "B3GNT3",
            "ADAMTS2",
            "PHACTR1",
            "ITGB4",
            "POSTN",
            "ARSI",
            "CTHRC1",
            "NOX4",
            "SLC45A3",
            "DAPK2",
            "STEAP2",
            "TAGLN",
            "SFTA3",
            "AADAT",
            "TPM2",
            "S100A16",
            "SPARC",
            "MMP14",
            "SLC39A14",
            "ACTA2",
            "SNX25",
            "PLAUR",
            "KRT18",
            "C1QTNF6",
            "PRKCDBP",
            "GPX8",
            "UNC13B",
            "OAF",
            "ACSS1",
            "CLTB",
            "TMEM125",
            "MYO1E",
            "KRT8",
            "CALD1",
            "NKX2-1",
            "TUBA4A",
            "ACAT1",
            "PDLIM7",
            "TIMP2",
            "NBL1",
            "CABC1",
            "PALLD",
            "FLJ36031",
            "KCNK6",
            "ACTN1",
            "FAM20C",
            "EFHD2",
            "RHOC",
            "ANXA2",
            "MCCC1",
            "IL11RA",
            "LIMD1",
            "USP13",
            "MARVELD1",
            "MRPS25",
            "CEP70",
            "ITGB5",
            "SCAI",
            "FAM117A",
            "GALNT11",
            "ITGB1",
            "TSPAN15",
            "TRIM24",
            "PLIN3",
            "NEK8",
            "HSDL2",
            "KCTD5",
            "RALB",
            "SLC25A4",
            "TPM4",
            "MOAP1",
            "BCL10",
            "RGL2",
            "BCAR1",
            "RUFY3",
            "TICAM1",
            "PDIK1L",
            "AMFR",
            "SNX9",
            "TRIP10",
            "CUL9",
            "CD276",
            "RCOR3",
            "SH3GL1",
            "GGA2",
            "TCEB3",
            "CAP1",
            "RSAD1",
            "SMYD4",
            "CFL1"
        ]
    },
    {
        "golabel": "FLI1_regulon_activity",
        "gene": [
            "HS3ST2",
            "DCC",
            "GYPE",
            "COL6A6",
            "COL29A1",
            "GFRA2",
            "UTS2D",
            "UNC45B",
            "ST8SIA1",
            "ABI3BP",
            "RGS9",
            "IQGAP2",
            "FMO2",
            "RCSD1",
            "LOC339524",
            "SELP",
            "P2RY14",
            "CLEC1A",
            "A2M",
            "MAN1C1",
            "C14orf139",
            "PTGER4",
            "SLC9A9",
            "CCDC69",
            "ITM2A",
            "PDE4B",
            "GIMAP8",
            "ACVRL1",
            "CC2D2B",
            "IKZF1",
            "IL16",
            "ENPP2",
            "DOCK2",
            "GIMAP7",
            "GGTA1",
            "ITGA4",
            "PLCL2",
            "GIMAP6",
            "SH2D3C",
            "PREX1",
            "GRAP",
            "GYPC",
            "MEF2C",
            "GIMAP4",
            "SLC29A2",
            "LMO2",
            "RHOJ",
            "ETS1",
            "PPM1K",
            "RASSF2",
            "RORA",
            "DBNDD1",
            "ZEB2",
            "RNF125",
            "ARHGAP25",
            "VASH1",
            "ARHGEF6",
            "AKAP7",
            "FYN",
            "GNG2",
            "MARVELD3",
            "LOC100125556",
            "LRRC8C",
            "ARHGEF16",
            "AACS",
            "PECAM1",
            "PHACTR2",
            "NIPSNAP1",
            "C10orf54",
            "H1F0",
            "SPINT1",
            "TBC1D4",
            "ABHD6",
            "PARP11",
            "EPCAM",
            "RASGRP3",
            "SMARCA2",
            "PLEKHA2",
            "JAZF1",
            "ADPRH",
            "NMT2",
            "EPM2A",
            "OTUD1",
            "KIAA0040",
            "RTKN",
            "MTA3",
            "HECA",
            "TRAP1",
            "MAP3K3",
            "LITAF",
            "PPP3CC",
            "ATIC",
            "COASY",
            "STAT5B"
        ]
    },
    {
        "golabel": "FOSL1_regulon_activity",
        "gene": [
            "FGF5",
            "LOC100216001",
            "S100A2",
            "MYH16",
            "BLID",
            "TH",
            "APCDD1L",
            "LOC554202",
            "TGM4",
            "FLNC",
            "RGS20",
            "LAMA3",
            "MFI2",
            "G0S2",
            "CDA",
            "GJB3",
            "LAMC2",
            "GPR87",
            "CDK6",
            "MT2A",
            "GPR115",
            "SLCO4A1",
            "CAV1",
            "MET",
            "ARNTL2",
            "ITGA5",
            "NGEF",
            "FHOD3",
            "PLAU",
            "CD109",
            "LETM2",
            "SLC2A1",
            "AHNAK2",
            "RHOF",
            "FJX1",
            "STEAP1",
            "CDH3",
            "FSCN1",
            "PMAIP1",
            "C10orf55",
            "ASPH",
            "CLCF1",
            "EPHB2",
            "PLEK2",
            "MFSD2B",
            "SPHK1",
            "EPHA2",
            "HMGA1",
            "DUSP5",
            "UNC13D",
            "PHLDA1",
            "BCAR3",
            "LAMB3",
            "GPR160",
            "S100A16",
            "CDCP1",
            "SFN",
            "PLAUR",
            "PHLDA2",
            "SLC16A3",
            "ITGA3",
            "RIN1",
            "TNFRSF12A",
            "RHOD",
            "RARG",
            "ZNF704",
            "EMP1",
            "UNC13B",
            "LOC100302401",
            "TUBB6",
            "PLEC",
            "CCDC85B",
            "NCS1",
            "CDC42EP2",
            "PDLIM7",
            "AP1S3",
            "FLJ36031",
            "SH3BGRL3",
            "TES",
            "TRIM68",
            "RHOC",
            "ELK3",
            "GKAP1",
            "TMEM170B",
            "GGT7",
            "ANXA2",
            "SIRT4",
            "OBFC2A",
            "PPFIBP2",
            "HRH1",
            "LRRC8A",
            "PLP2",
            "GNA15",
            "LRIG1",
            "RHBDF2",
            "ENPP4",
            "FAM117A",
            "CCRN4L",
            "MICALL1",
            "TUBA1C",
            "BCL9L",
            "PLIN3",
            "PML",
            "ARHGAP10",
            "KCTD5",
            "SPATS2L",
            "MYLIP",
            "RALB",
            "PXN",
            "TPM4",
            "MOAP1",
            "LYAR",
            "BCL10",
            "VCL",
            "EHD1",
            "DPP9",
            "PKM2",
            "ZYX",
            "CCDC121",
            "FAM8A1",
            "ENO1",
            "LMNA",
            "TCEANC",
            "RPS6KA4",
            "TRIP10",
            "MAP7D1",
            "TPD52L2",
            "YWHAG",
            "ANKLE2",
            "RCOR3",
            "ACTG1",
            "PREPL",
            "DOPEY1",
            "TNIP2",
            "ACTB",
            "ZNF652",
            "WDR1",
            "E2F4",
            "EIF4H",
            "RELA"
        ]
    },
    {
        "golabel": "FOSL2_regulon_activity",
        "gene": [
            "NR4A3",
            "LOC100131726",
            "FAM83A",
            "SLC6A14",
            "BIRC3",
            "MAFK",
            "AHNAK2",
            "RHOF",
            "ADAMTS4",
            "DDIT4",
            "PHLDB2",
            "CXCL17",
            "SIK1",
            "KLF4",
            "EPHA2",
            "FSTL3",
            "ERRFI1",
            "LASS4",
            "DUSP5",
            "OSMR",
            "PLAUR",
            "GADD45B",
            "SLC16A3",
            "MXD1",
            "PLEC",
            "MYO1E",
            "PPP1R13L",
            "ITPRIP",
            "C6orf125",
            "BHLHE40",
            "MDP1",
            "MPZL3",
            "NOTCH3",
            "SIRT4",
            "RANGRF",
            "MYOF",
            "ITPKC",
            "MARVELD1",
            "METRNL",
            "EXOC6B",
            "MYADM",
            "BCL9L",
            "PLIN3",
            "NFIL3",
            "SBNO2",
            "B4GALT1",
            "NACC2",
            "C22orf32",
            "ZNF232",
            "ZNF709",
            "RPAIN",
            "SERGEF",
            "TICAM1",
            "ZNF443",
            "LATS2",
            "LMNA",
            "TCEANC",
            "FAM129B",
            "ZNF195",
            "SSH1",
            "PIGH",
            "MCL1",
            "ZNF691",
            "RREB1",
            "TTC7A",
            "TMEM216",
            "ZNF564",
            "ALKBH1",
            "DTNBP1",
            "NDEL1"
        ]
    },
    {
        "golabel": "FOXA1_regulon_activity",
        "gene": [
            "ZMAT4",
            "FOXI3",
            "UMODL1",
            "LOC145837",
            "GFRA3",
            "PAX9",
            "SOX2",
            "HOXC9",
            "MIPOL1",
            "HMGB3",
            "RALGAPA1",
            "STAC",
            "CAV2",
            "TOX3",
            "PRKAA2",
            "FOXA2",
            "TIGD3",
            "PAIP2B",
            "SBK1",
            "TC2N",
            "UBASH3B",
            "SLC39A6",
            "PNN",
            "AXL",
            "FZD3",
            "EMP3",
            "ATP8B1",
            "BAZ1A",
            "PHF8",
            "CARD16",
            "SRP54",
            "CD44",
            "DAB2",
            "CD59",
            "CAPG",
            "HEATR5A",
            "PHLPP1",
            "RRAS",
            "STAU2",
            "NAA30",
            "SOX4",
            "HOOK1",
            "PML",
            "MAPKAPK3",
            "SFXN3",
            "GRHL2",
            "PTTG1IP",
            "MAP7D1",
            "EIF2AK3",
            "CRTAP",
            "PINK1",
            "GNAI2",
            "TNIP1",
            "ATG7"
        ]
    },
    {
        "golabel": "FOXA2_regulon_activity",
        "gene": [
            "GKN2",
            "PRMT8",
            "FAM105A",
            "C20orf56",
            "CYP4B1",
            "WNT4",
            "CLU",
            "FLJ42875",
            "C16orf89",
            "TSPAN7",
            "GREM1",
            "OTUD7A",
            "CXCL10",
            "GZMB",
            "TMEM163",
            "ADAM12",
            "GBP5",
            "PRDM16",
            "RAP1GAP",
            "GLS2",
            "SORBS2",
            "SLC22A3",
            "SLC2A5",
            "CENPA",
            "C17orf53",
            "MCM10",
            "PDCD1LG2",
            "PRR11",
            "CASC5",
            "POSTN",
            "CENPI",
            "FLRT3",
            "DLGAP5",
            "CTHRC1",
            "FAM72A",
            "KIAA1524",
            "CKAP2L",
            "WISP1",
            "C11orf82",
            "CCNA2",
            "ASPM",
            "DNALI1",
            "FOXA1",
            "NCAPH",
            "BUB1",
            "KIF4A",
            "MAPK8IP1",
            "IL2RB",
            "SH3BGRL2",
            "LILRB2",
            "GPRC5C",
            "PLK4",
            "C1QTNF6",
            "SLAMF8",
            "SHCBP1",
            "GSG2",
            "C15orf56",
            "TMEM125",
            "CCND3",
            "CAMKK1",
            "CABC1",
            "SEC23A",
            "TAP2",
            "MPL",
            "RAB17",
            "RAB40B",
            "DSTN",
            "PRRG2",
            "SETD4",
            "C11orf49",
            "SLC48A1",
            "DEAF1",
            "PEBP1",
            "TTC19",
            "BCL2L11",
            "STYX",
            "C2orf24",
            "CYP20A1",
            "OAZ2"
        ]
    },
    {
        "golabel": "FOXJ2_regulon_activity",
        "gene": [
            "AHNAK",
            "FAM66C",
            "TSPAN9",
            "MRPL52",
            "NME1",
            "FGD4",
            "C11orf83",
            "SNRPB",
            "EXOSC4",
            "ANAPC11",
            "MRPL12",
            "CHCHD8",
            "MRPL2",
            "MRPL27",
            "TRMT112",
            "BANF1",
            "C1RL",
            "LPCAT3",
            "ETV6",
            "VPS13D",
            "SNRPC",
            "SSH1",
            "KDM5A",
            "KTI12",
            "SLC12A6",
            "RPS6KB2",
            "ATN1",
            "WDR74",
            "ZNHIT3",
            "TMEM216",
            "PHB",
            "DCP1B",
            "CREBBP",
            "CREBL2",
            "ATXN1L",
            "JAK1",
            "OTUB1",
            "N4BP1",
            "SON",
            "SDHAF2",
            "ATF7"
        ]
    },
    {
        "golabel": "FOXK2_regulon_activity",
        "gene": [
            "DDN",
            "GCNT4",
            "CPA3",
            "C5orf32",
            "KLC3",
            "CYSLTR1",
            "C17orf53",
            "RAC3",
            "KIF18B",
            "NDRG2",
            "RNASE4",
            "RECQL4",
            "E2F1",
            "SPAG5",
            "CNKSR3",
            "EME1",
            "IL7",
            "NFKBIL2",
            "JAM2",
            "NT5DC3",
            "C16orf59",
            "HNMT",
            "KPNA2",
            "CCNF",
            "RPS27L",
            "LOC92659",
            "SLC25A10",
            "PYCR1",
            "FN3K",
            "DBF4B",
            "N4BP2L1",
            "CCNG1",
            "AZI1",
            "TBC1D16",
            "DNMT3A",
            "MRPL12",
            "MAFG",
            "THOC4",
            "RCBTB2",
            "MYO19",
            "TUBG1",
            "LRRC45",
            "WDR45L",
            "CRBN",
            "TRIM37",
            "DUS1L",
            "AUH",
            "ZC3H3",
            "GTF2IRD1",
            "CBX1",
            "CCDC137",
            "MTMR6",
            "CBX4",
            "NARF",
            "TBCD",
            "RTKN",
            "TDRD3",
            "RPTOR",
            "RFNG",
            "HEATR6",
            "SH3BGRL",
            "UBQLN4",
            "SF3B4",
            "USP32",
            "CHURC1",
            "P4HB",
            "GIT1",
            "C17orf70",
            "NUP85",
            "ITFG1",
            "PPP2CB",
            "DDX54",
            "PHF11",
            "UBE2O",
            "ZNF561",
            "TMEM66",
            "PSMD12",
            "FTSJ3",
            "MEN1",
            "HGS",
            "FTSJD1",
            "KPNB1",
            "C17orf62",
            "UBAP2L",
            "SMPD4",
            "CDKN2AIP",
            "GPS1",
            "TMEM104",
            "NPLOC4",
            "PPM1G",
            "UNK",
            "COASY",
            "CNP",
            "ATXN7L3",
            "PRCC",
            "USP36",
            "EFTUD2",
            "SAP130",
            "SAP30BP",
            "DDX42",
            "FAM104A",
            "TLK2",
            "CSNK1D"
        ]
    },
    {
        "golabel": "FOXM1_regulon_activity",
        "gene": [
            "C2orf78",
            "HOXD11",
            "IGF2BP1",
            "RAB3B",
            "GGTLC1",
            "HSD17B6",
            "ZNF385B",
            "CYP4B1",
            "SUSD2",
            "HOPX",
            "ADH1B",
            "SCTR",
            "C1orf88",
            "EIF4EBP1",
            "CD1E",
            "CTSH",
            "CLEC4F",
            "INMT",
            "HLF",
            "MTL5",
            "STC2",
            "TNNI3K",
            "CA3",
            "CD1C",
            "NME5",
            "LOC127841",
            "TMEM163",
            "MAMDC2",
            "C2orf58",
            "FXYD1",
            "FLJ36777",
            "SLC7A5",
            "CX3CR1",
            "CCNB2",
            "PCDP1",
            "FIGN",
            "GPR116",
            "SCN4B",
            "EXO1",
            "C1orf101",
            "FAM189A2",
            "NAPSA",
            "NPC2",
            "KIF3C",
            "GPR19",
            "CENPA",
            "PNMA2",
            "PLAC9",
            "WFDC2",
            "PLEKHG6",
            "MCM10",
            "C1orf116",
            "CITED2",
            "SKA1",
            "TMPRSS2",
            "CASC5",
            "TTK",
            "ESPL1",
            "ZMYND12",
            "DLGAP5",
            "TPX2",
            "HMGA1",
            "KIF23",
            "ENTPD3",
            "KIF18B",
            "KIF14",
            "DRAM1",
            "CDC6",
            "RAD51AP1",
            "CDCA2",
            "UCK2",
            "CDC25A",
            "CDC20",
            "CENPF",
            "HJURP",
            "CKAP2L",
            "CDCA3",
            "MGP",
            "CCNA2",
            "SGOL1",
            "BUB1B",
            "MELK",
            "CMAS",
            "ARHGAP11A",
            "ASPM",
            "CFI",
            "BLM",
            "SKA3",
            "STYK1",
            "NEK2",
            "MKI67",
            "KIF4A",
            "PFKP",
            "CCDC34",
            "CDCA5",
            "CDCA8",
            "FAM82A1",
            "PLK1",
            "CEP55",
            "UHRF1",
            "GTSE1",
            "PXMP4",
            "C21orf49",
            "KIF20A",
            "KIF11",
            "CCDC77",
            "PRC1",
            "C17orf96",
            "C1orf21",
            "ENPP5",
            "NUSAP1",
            "C17orf44",
            "KBTBD3",
            "FKBP4",
            "NCAPG2",
            "ZFP2",
            "GNG7",
            "C7orf23",
            "TMEM98",
            "BDNFOS",
            "NCAPD2",
            "FMO4",
            "TEAD4",
            "GAPDH",
            "C5orf45",
            "ZCWPW2",
            "SLC7A1",
            "PAM",
            "SSBP2",
            "PGCP",
            "ZNF552",
            "F8",
            "TOMM40",
            "KLHDC1",
            "FUCA1",
            "FLJ11235",
            "FEN1",
            "CAT",
            "DNM1L",
            "LMNB2",
            "ENPP4",
            "FCGRT",
            "HSPD1",
            "C17orf108",
            "GPI",
            "PVR",
            "SLC5A6",
            "BDH2",
            "HSDL2",
            "NOP2",
            "CYP4V2",
            "CYB5R1",
            "ARV1",
            "CLPB",
            "PPP2R5A",
            "MOAP1",
            "CKAP4",
            "CTSO",
            "TPI1",
            "ECHDC1",
            "GARS",
            "DHRS1",
            "GTF2IRD2",
            "CRBN",
            "EIF4E3",
            "RBM28",
            "IRAK1",
            "PUS10",
            "ST6GALNAC6",
            "MBLAC2",
            "TAF5",
            "EIF3B",
            "ERMAP",
            "SLC38A7",
            "POLR3GL",
            "YKT6",
            "TXNDC15",
            "YWHAG",
            "PA2G4",
            "N6AMT1",
            "FAM136A",
            "ANKRA2",
            "RNF26",
            "C7orf49",
            "WBP11",
            "NKIRAS1",
            "C12orf32",
            "SDCCAG8",
            "KIAA0141",
            "R3HDM1",
            "SETD8",
            "PEX11B",
            "GIN1",
            "SAE1",
            "PPM1G",
            "UBE2R2",
            "PRMT2",
            "VCP",
            "RAB35",
            "IMMT"
        ]
    },
    {
        "golabel": "FOXN2_regulon_activity",
        "gene": [
            "CLEC6A",
            "KLRC4",
            "INE2",
            "RAP1GAP",
            "SRGN",
            "THEMIS",
            "CD3G",
            "SAMSN1",
            "TNFSF13B",
            "SNX10",
            "AKAP5",
            "MLPH",
            "MARCH1",
            "MMP15",
            "IPMK",
            "VWA1",
            "GNB4",
            "PPAT",
            "UBE2W",
            "DCK",
            "RAB17",
            "ARL5B",
            "FGFR1OP2",
            "SLC39A10",
            "B3GNT9",
            "ARL6IP6",
            "C9orf72",
            "RNF138",
            "OTUD6B",
            "CCDC75",
            "TRUB1",
            "ARMC1",
            "RALGPS2",
            "TFAM",
            "RHBDD3",
            "RRBP1",
            "MANEA",
            "DDRGK1",
            "PUS7L",
            "C9orf7",
            "ZNF444",
            "CXXC5",
            "SGSM3",
            "RABEP2",
            "PIGQ",
            "LOC284441",
            "SAMD8",
            "BSCL2",
            "SGTB",
            "PRKD3",
            "ZNF205",
            "GSTCD",
            "WDR43",
            "JMJD8",
            "TNK1",
            "BRF1",
            "SLC30A6",
            "CYB5R3",
            "LYPLA2",
            "QKI",
            "C1orf96",
            "KIAA1432",
            "ME2",
            "ZNF446",
            "DR1",
            "TOM1",
            "XRN1",
            "VRK2",
            "SPAST",
            "MOBKL1B",
            "SRP72",
            "ARL5A",
            "ZNF267",
            "ALG12",
            "NOC3L",
            "OSBPL8",
            "CRLF3",
            "DNAJB14",
            "UBA3",
            "GPS2",
            "THAP5",
            "C2orf69",
            "MCAT",
            "MCFD2",
            "DNAJB2",
            "GNA13",
            "CUL2",
            "ABCB10",
            "RNGTT",
            "USP15",
            "DDX18",
            "SPOPL",
            "GABPA",
            "PPIP5K2",
            "KIAA1033",
            "CDK17",
            "KLRAQ1",
            "C1orf55",
            "SH3BP5L",
            "C10orf119",
            "PAPOLG",
            "HNRPLL",
            "LIN54",
            "C6orf47",
            "MARCH7",
            "ABI1",
            "ACTR2",
            "SP3"
        ]
    },
    {
        "golabel": "FOXO1_regulon_activity",
        "gene": [
            "SECISBP2L",
            "CNTN3",
            "ADAMTSL3",
            "CDCA7",
            "FRMD5",
            "SETBP1",
            "MECOM",
            "A2M",
            "LPAR1",
            "LAMA2",
            "PSRC1",
            "S1PR1",
            "LDB2",
            "ABCB9",
            "SPARCL1",
            "SATB1",
            "YDJC",
            "LAGE3",
            "ATP6V0E2",
            "RHOJ",
            "KLF9",
            "FIGNL1",
            "AKAP13",
            "BTG1",
            "SKA2",
            "TUBG1",
            "RFC2",
            "KIF22",
            "SNRNP25",
            "HAUS8",
            "FOXO3",
            "RUSC1",
            "PDCD4",
            "SLC25A19",
            "KIAA0040",
            "CTU2",
            "NARF",
            "FOXP1",
            "NUPL2",
            "TSEN54",
            "ALKBH4",
            "NUP85",
            "TIMM44",
            "RAD51C",
            "AKAP11",
            "SNRK",
            "MEN1",
            "SOCS5",
            "ELF1",
            "FAM160B1",
            "MFAP3",
            "PAFAH1B1",
            "PITPNA"
        ]
    },
    {
        "golabel": "FOXO3_regulon_activity",
        "gene": [
            "SNORA76",
            "AR",
            "SVEP1",
            "FAM38B",
            "LOC100133612",
            "F12",
            "GFOD1",
            "AHNAK",
            "PARD3B",
            "LAMA2",
            "C7orf40",
            "GAMT",
            "TIMM16",
            "FOXO1",
            "COBLL1",
            "MAML2",
            "PSMG3",
            "NME1",
            "AKAP13",
            "PLSCR4",
            "TACC1",
            "ANAPC11",
            "EPB41L2",
            "MTHFD2L",
            "MRPS21",
            "APOA1BP",
            "C7orf36",
            "NME2",
            "MRPL12",
            "UTRN",
            "HAX1",
            "C11orf48",
            "PHACTR2",
            "KIAA1671",
            "KCTD6",
            "CBX8",
            "C12orf73",
            "ZFYVE19",
            "ATXN7L1",
            "SMARCA2",
            "PTPRK",
            "SFXN4",
            "SEC14L1",
            "GAB1",
            "ICT1",
            "REV3L",
            "ROBLD3",
            "TARBP2",
            "JTB",
            "TMEM49",
            "MRPL27",
            "FLAD1",
            "POLR2H",
            "ARID5B",
            "MYCBP2",
            "CHCHD1",
            "PTRH2",
            "VPS13D",
            "SNX29",
            "FOXO3B",
            "TBC1D9",
            "NAT9",
            "TBCEL",
            "HIPK1",
            "HECA",
            "IFRD2",
            "CDK19",
            "PHF3",
            "NPRL2",
            "SNTB2",
            "GRHPR",
            "TBC1D5",
            "TSPYL1",
            "CREBBP",
            "THUMPD2",
            "ATXN1L",
            "PREP",
            "WDR7",
            "JAK1",
            "SEC63",
            "NME6",
            "ARID1B",
            "GLG1",
            "SERINC1",
            "ORMDL1",
            "STAT3",
            "SFRS7",
            "C6orf89"
        ]
    },
    {
        "golabel": "FOXP1_regulon_activity",
        "gene": [
            "LPL",
            "SPC24",
            "RPL39L",
            "SORBS2",
            "KBTBD11",
            "C11orf82",
            "GINS1",
            "BUB1",
            "ORC6L",
            "KHDC1",
            "TBC1D2",
            "RFTN1",
            "ECE2",
            "RAD54B",
            "FOXO1",
            "SUV39H1",
            "CPSF4",
            "GNB1L",
            "ARHGEF10",
            "C1orf112",
            "TMEM206",
            "ANKHD1-EIF4EBP3",
            "DSN1",
            "CTDSPL",
            "C20orf20",
            "SUCLG2",
            "WDR53",
            "MRPL49",
            "TTC9C",
            "C7orf70",
            "GNAQ",
            "C1orf174",
            "PPP3CA",
            "NUP85",
            "TM9SF3",
            "LRRFIP1",
            "FAM131A",
            "CXorf40B",
            "UTP18",
            "UNC119",
            "CTNNA1",
            "SLC7A6OS",
            "ATF7",
            "LRRFIP2",
            "RAB5A",
            "C3orf19"
        ]
    },
    {
        "golabel": "FUBP1_regulon_activity",
        "gene": [
            "C5orf38",
            "LOC113230",
            "SMARCD3",
            "HELB",
            "N4BP2",
            "SLC27A3",
            "LYL1",
            "UBXN7",
            "TRAPPC5",
            "ALKBH7",
            "DARS2",
            "C19orf70",
            "FIP1L1",
            "SIRT2",
            "MAN1A2",
            "ZZZ3",
            "WDR43",
            "PDLIM1",
            "WDR3",
            "URB2",
            "ATP2A2",
            "MPND",
            "SNAPC2",
            "SR140",
            "NDUFS7",
            "FAM199X",
            "MARCH2",
            "NDUFS1",
            "FAM108A1",
            "FXR1",
            "AES",
            "RPL7L1",
            "DHX36",
            "DNTTIP2",
            "GFM1",
            "MRE11A",
            "SNRNP200",
            "UBFD1",
            "CDC5L",
            "FBXO21",
            "RPS6KC1",
            "ISG20L2",
            "RFC1",
            "RBBP5",
            "POLR2B",
            "C19orf56",
            "GTF3C3",
            "GPR108",
            "RBMXL1",
            "RBM15",
            "DHX15",
            "UBXN6",
            "HNRNPR",
            "DHX9",
            "MED17"
        ]
    },
    {
        "golabel": "FUBP3_regulon_activity",
        "gene": [
            "GPR172B",
            "SPNS3",
            "ZMYND12",
            "LCA5L",
            "COX7A1",
            "SEPW1",
            "NAALADL1",
            "TMSL3",
            "SMC2",
            "FCGRT",
            "TMEM50B",
            "IFT46",
            "B4GALT1",
            "TMEM2",
            "RC3H2",
            "RIF1",
            "DGCR6L",
            "AMZ2P1",
            "QSOX2",
            "THYN1",
            "SMC3",
            "GTF3C4",
            "UROD",
            "AMMECR1",
            "CAMSAP1",
            "BAT2L1",
            "STRBP",
            "NUP188",
            "SEC16A",
            "N6AMT1",
            "BRD3",
            "PTPN11",
            "IPPK",
            "DCAF10",
            "EIF4G1",
            "HSPA5",
            "PRPF4",
            "SMC5",
            "EIF3A",
            "ROD1",
            "FKTN",
            "AHCTF1",
            "SET",
            "NCKAP1",
            "KIAA0368",
            "NCBP1",
            "GPR107",
            "NCL",
            "EHMT1",
            "RAD23B",
            "TTF1",
            "IKBKAP",
            "CIZ1",
            "NUP214",
            "PRMT2",
            "SYNCRIP",
            "UBQLN1",
            "HNRNPR",
            "VCP",
            "RNF20",
            "CWC22",
            "HNRNPK"
        ]
    },
    {
        "golabel": "FXR2_regulon_activity",
        "gene": [
            "ENO3",
            "ODC1",
            "FSTL4",
            "EGOT",
            "GDF5",
            "SLC7A2",
            "GPR87",
            "RASD1",
            "RARRES3",
            "ZNF710",
            "C2CD4D",
            "RNASE2",
            "FASN",
            "MT1F",
            "PDE4D",
            "IFI44",
            "ANKRD22",
            "SIK1",
            "COL8A2",
            "PTPN22",
            "RSAD2",
            "CHML",
            "IFIT2",
            "CSF1",
            "LOC374443",
            "GBP3",
            "CLEC7A",
            "AIM1",
            "TRPV1",
            "RAP1GAP2",
            "AHR",
            "IFIH1",
            "PER1",
            "DPY19L1",
            "APOBEC3G",
            "C4orf36",
            "RPH3AL",
            "ST6GALNAC4",
            "KIAA1549",
            "CKLF",
            "FAS",
            "PHF17",
            "NCEH1",
            "CCDC109B",
            "CD40",
            "RGS10",
            "CASP1",
            "TTC39B",
            "PEMT",
            "STK17A",
            "BPGM",
            "TMEM159",
            "OGFRL1",
            "USP43",
            "CMTM3",
            "FAM83G",
            "DAPP1",
            "PITPNM2",
            "SHMT1",
            "FECH",
            "PLSCR1",
            "KRCC1",
            "CDRT4",
            "PIM3",
            "SLFN12",
            "ACADVL",
            "NFKBIE",
            "TRAPPC9",
            "SPATS2L",
            "CYB5D1",
            "CAPN10",
            "DDRGK1",
            "PRPSAP2",
            "LAMP2",
            "CNTROB",
            "ARL6IP5",
            "RPAIN",
            "RBM43",
            "PFAS",
            "MPDU1",
            "CASP10",
            "IFNGR2",
            "IFNAR2",
            "FAM18B",
            "C17orf68",
            "SFT2D2",
            "MYBBP1A",
            "KIAA0664",
            "SHPK",
            "PITRM1",
            "FAM18B2",
            "PTDSS2",
            "SP110",
            "ZNRF2",
            "C17orf85",
            "KDM6B",
            "C1orf69",
            "KIF1C",
            "CTNS",
            "CHD3",
            "TNK1",
            "IL10RB",
            "C7orf70",
            "NEURL4",
            "VAMP2",
            "MCCC2",
            "EHMT2",
            "POLR2A",
            "GEMIN4",
            "SEC23B",
            "PELP1",
            "NTAN1",
            "FASTKD5",
            "SPAG7",
            "RNMTL1",
            "NUP88",
            "PEA15",
            "ZNF267",
            "CASP8",
            "SLC25A11",
            "DVL2",
            "MIER1",
            "KIAA0753",
            "RAC1",
            "MED9",
            "PRPF8",
            "METT10D",
            "NDUFS2",
            "VPS53",
            "KIAA1967",
            "COX10",
            "YWHAH",
            "UBE2G1",
            "ANP32A",
            "PHF23",
            "RNF167",
            "TMEM50A",
            "ALKBH5",
            "ELAC2",
            "DIS3L2",
            "NDEL1",
            "CAPZB",
            "PAFAH1B1",
            "ZMYM6",
            "RABEP1",
            "PITPNA",
            "DHX30",
            "DULLARD"
        ]
    },
    {
        "golabel": "GABPA_regulon_activity",
        "gene": [
            "STX1A",
            "CXADR",
            "ZNF699",
            "C21orf91",
            "SLC25A10",
            "BTG3",
            "F8",
            "PKP3",
            "RPUSD1",
            "ATP5J",
            "TBC1D15",
            "SP4",
            "C5orf41",
            "SELO",
            "MRPL39",
            "CAPN10",
            "MANEA",
            "TMUB1",
            "INO80B",
            "BACH1",
            "FOXN2",
            "DOHH",
            "BBS10",
            "CHPF2",
            "MBNL2",
            "PTGES2",
            "NEK7",
            "PNKP",
            "ZNF598",
            "QKI",
            "TRIM23",
            "SLC25A30",
            "ZNF624",
            "ABHD13",
            "USP25",
            "RNF219",
            "LYRM7",
            "ATG4B",
            "FBXL3",
            "CRYZL1",
            "DNAJB14",
            "KCTD20",
            "CCT8",
            "ZNF791",
            "ZBTB44",
            "IKZF5",
            "ZNF136",
            "KIAA1704",
            "HGS",
            "ATG4C",
            "RNF160",
            "SOCS5",
            "C5orf24",
            "RSBN1",
            "CWF19L2",
            "ARHGDIA",
            "PPIP5K2",
            "VAMP4",
            "STK25",
            "IFNAR1",
            "PLDN",
            "SMARCAD1",
            "PNRC2",
            "MORC3",
            "CDC40",
            "HIAT1",
            "DSCR3",
            "USP16",
            "DYRK1A",
            "KIAA1143",
            "EPS15",
            "MATR3"
        ]
    },
    {
        "golabel": "GABPB1_regulon_activity",
        "gene": [
            "ACSM1",
            "GGT3P",
            "C17orf50",
            "CCNB2",
            "GGTLC2",
            "UBE2NL",
            "RSL24D1",
            "MAD2L1",
            "C12orf48",
            "CACNB1",
            "POM121L10P",
            "CKS1B",
            "KIAA0101",
            "C1orf126",
            "SNRPG",
            "LRP12",
            "LOC649330",
            "GTF2A2",
            "RACGAP1",
            "RFC3",
            "C15orf23",
            "PLEKHM1P",
            "UBA2",
            "RAN",
            "CDC42BPG",
            "SLC27A1",
            "LOC441089",
            "ZWILCH",
            "CDK18",
            "TDG",
            "C1orf89",
            "LIN9",
            "RCN2",
            "MRPL42",
            "C9orf30",
            "HDAC11",
            "HDAC10",
            "PTGES3",
            "YWHAQ",
            "LOC92249",
            "GRN",
            "UBE2N",
            "LDLRAP1",
            "C12orf41",
            "ATP6V0A1",
            "CLEC16A",
            "PCSK7",
            "POLR3F",
            "ZC3H15",
            "CNOT7",
            "TBC1D9B",
            "NLRX1",
            "SAPS2",
            "PFKL",
            "AGPAT3",
            "HNRNPC",
            "ARPP19",
            "HNRPLL",
            "SMNDC1",
            "ZNF143",
            "TRA2B"
        ]
    },
    {
        "golabel": "GAS7_regulon_activity",
        "gene": [
            "RSPO1",
            "OGN",
            "C10orf105",
            "KCNE1",
            "PTGIS",
            "IL5RA",
            "SIAH3",
            "C6orf97",
            "HS3ST2",
            "TPSD1",
            "WNT2B",
            "ANGPTL1",
            "SLC22A4",
            "NTRK3",
            "CCDC89",
            "XPNPEP2",
            "IQSEC3",
            "PCDHGA12",
            "HTR2A",
            "SVEP1",
            "COL29A1",
            "BNC2",
            "IGF1",
            "PCDHGA9",
            "RCVRN",
            "GSTM5",
            "FAM38B",
            "LRRC4C",
            "CDH23",
            "COL14A1",
            "TXLNB",
            "MFAP4",
            "DPT",
            "ABCA9",
            "FBLN1",
            "SPON1",
            "SLIT2",
            "GPR68",
            "TUB",
            "LOC90586",
            "IGDCC4",
            "KAL1",
            "DLG2",
            "GPRASP1",
            "ABCA6",
            "KIAA1045",
            "ABCB6",
            "LSAMP",
            "CYR61",
            "PRICKLE1",
            "FAM131B",
            "MDGA1",
            "BHLHE41",
            "FAM198A",
            "AOC3",
            "PRELP",
            "CXCL12",
            "ZNF154",
            "CACNA1C",
            "MAN1C1",
            "CAMK1G",
            "MMP19",
            "LTBP2",
            "PRR5L",
            "ZC3H12B",
            "FILIP1L",
            "GGT5",
            "LAMA2",
            "PODN",
            "OLFML1",
            "AXL",
            "BHLHE22",
            "GJA5",
            "TCF4",
            "PLA2G5",
            "PLA2R1",
            "TMEM119",
            "CC2D2B",
            "IL16",
            "C18orf1",
            "RAI2",
            "MYLK",
            "SERPING1",
            "BDH1",
            "MAML2",
            "TSPAN9",
            "HSBP1L1",
            "RASA3",
            "PTGIR",
            "LRP1",
            "RORA",
            "C1R",
            "ZEB2",
            "DHRS11",
            "PLSCR4",
            "IL1R1",
            "SYNPO",
            "ADARB1",
            "ATP8B2",
            "FYN",
            "LOC100125556",
            "HSPE1",
            "PLEKHG1",
            "ZFP36L2",
            "PXMP2",
            "C22orf26",
            "PFDN6",
            "TGFB1",
            "EVC",
            "ANXA6",
            "ICOSLG",
            "ZCCHC24",
            "RG9MTD2",
            "DUSP18",
            "ST3GAL2",
            "NMT2",
            "POLR2H",
            "TRUB2",
            "CASP6",
            "ENTPD1",
            "SNX29",
            "TBC1D2B",
            "S1PR2",
            "KIAA0247",
            "TBCEL",
            "IQSEC1",
            "HECA",
            "BCCIP",
            "SPATA5L1",
            "C12orf65",
            "MAP3K3",
            "SLC37A4",
            "LITAF",
            "RIN2",
            "ATXN1",
            "DOLPP1",
            "SUFU",
            "PMPCA",
            "MRPS9",
            "ACP1",
            "TMEM109",
            "MRPS5",
            "ZFYVE1",
            "C10orf26",
            "AIMP1"
        ]
    },
    {
        "golabel": "GATAD2A_regulon_activity",
        "gene": [
            "RNFT1",
            "PLEKHG3",
            "PEX2",
            "PLXNA1",
            "LRRC8A",
            "COMMD3",
            "RWDD2A",
            "C1orf203",
            "FAM151B",
            "LPAR2",
            "ACTN4",
            "MYH9",
            "NCRNA00081",
            "PEX7",
            "DAB2IP",
            "TSNAX",
            "ACADM",
            "ALG14",
            "FPGT",
            "GLT25D1",
            "ZNF280D",
            "C12orf26",
            "CCDC76",
            "PIGH",
            "PIK3R2",
            "PEX19",
            "MAP1S",
            "NACC1",
            "ANKRD49",
            "ARMC6",
            "C15orf40",
            "EIF4G1",
            "FBXO9",
            "MIS12",
            "ATP13A1",
            "WIZ",
            "CHERP",
            "SPTAN1",
            "SLC35E1",
            "PPRC1",
            "JKAMP",
            "ELL",
            "AP1M1",
            "RAB8A",
            "C19orf50",
            "PRKACA"
        ]
    },
    {
        "golabel": "GLI4_regulon_activity",
        "gene": [
            "LRRC24",
            "POLR2J3",
            "HIST2H3D",
            "KIFC2",
            "COMTD1",
            "SLC27A5",
            "RHPN1",
            "FLJ39582",
            "CEBPD",
            "IL6ST",
            "MFSD3",
            "NAPRT1",
            "ADCK5",
            "ASPSCR1",
            "MGAT5",
            "LOC100132288",
            "C7orf47",
            "ZNF692",
            "UHMK1",
            "MGC70857",
            "ZDHHC20",
            "ZMAT3",
            "EXOSC4",
            "PPP1R16A",
            "SCAND1",
            "HERC3",
            "FBXL6",
            "C19orf60",
            "MXD3",
            "PRR5",
            "C9orf142",
            "C17orf90",
            "LNPEP",
            "PRKAR2A",
            "C6orf136",
            "SERPINB8",
            "EEF1D",
            "MRPL55",
            "CBX8",
            "RHBDD3",
            "RC3H2",
            "HIPK3",
            "GSDMD",
            "TRIM44",
            "GPAA1",
            "PWWP2B",
            "REST",
            "VPS28",
            "INO80B",
            "NT5C",
            "FASTK",
            "MTG1",
            "ARL15",
            "FAM110A",
            "RBCK1",
            "SNHG11",
            "ADAM10",
            "LRRC14",
            "PAFAH1B2",
            "TRMT61A",
            "TMEM30A",
            "CYHR1",
            "SUSD1",
            "ZC3H3",
            "TYSND1",
            "ANKRD16",
            "ZNF414",
            "NAT6",
            "C1orf35",
            "TMOD3",
            "MOSPD2",
            "PNKP",
            "SEC24D",
            "TRABD",
            "RFNG",
            "ANO6",
            "CCS",
            "CCNI",
            "UBTD2",
            "E4F1",
            "C6orf211",
            "IQGAP1",
            "CAB39",
            "SEC24A",
            "MAP3K2",
            "SCARB2",
            "PJA2",
            "CTTNBP2NL",
            "ZFPL1",
            "BMPR2",
            "G3BP2",
            "VPS4B",
            "BCS1L",
            "CSDE1",
            "EAF1",
            "MFAP3",
            "PTPN9",
            "AP3B1",
            "EIF4G2"
        ]
    },
    {
        "golabel": "GLYR1_regulon_activity",
        "gene": [
            "PIGR",
            "FAM64A",
            "UBE2C",
            "CDKN3",
            "CENPA",
            "SKA1",
            "AURKB",
            "NUF2",
            "REPS2",
            "BIRC5",
            "DSCC1",
            "ABCC6",
            "VWA2",
            "RASEF",
            "TMC5",
            "KPNA2",
            "SOX13",
            "EPS8",
            "CADPS2",
            "WWC1",
            "PDSS1",
            "CRY2",
            "DDX39",
            "MVP",
            "NIPAL3",
            "C9orf30",
            "LOC652276",
            "DNAJC9",
            "PHKB",
            "CLINT1",
            "PARN",
            "KIAA0319L",
            "PDXDC1",
            "PCGF6",
            "CLUAP1",
            "EEF2K",
            "WWP2",
            "EARS2",
            "ALG1",
            "STAT6",
            "PDPK1",
            "LONP2",
            "COG7",
            "ZNF500",
            "GSPT1",
            "UBN1",
            "ZC3H7A",
            "THUMPD1",
            "ZNF434"
        ]
    },
    {
        "golabel": "GMEB2_regulon_activity",
        "gene": [
            "CASKIN1",
            "CPA3",
            "RERG",
            "C7orf58",
            "RECQL4",
            "LUM",
            "DCN",
            "NFKBIL2",
            "RBM38",
            "HNMT",
            "MEF2C",
            "ARHGAP39",
            "ZEB1",
            "ZNF512B",
            "SOX12",
            "SCRIB",
            "RAB8B",
            "ARHGAP18",
            "PTCD1",
            "C20orf20",
            "GTPBP5",
            "ZGPAT",
            "ARFGAP1",
            "DHX34",
            "RBM43",
            "ZNF768",
            "MTA1",
            "RP2",
            "ZNF628",
            "TAF4",
            "TMEM201",
            "ZC3H3",
            "DNAJC5",
            "ACAD9",
            "CCNDBP1",
            "MTMR6",
            "MAT2B",
            "SH3BGRL",
            "POLK",
            "RABGAP1L",
            "C6orf211",
            "YTHDF1",
            "ACTR5",
            "CSGALNACT2",
            "CREBL2",
            "TESK1",
            "RAP1A",
            "ZNF746",
            "FAM114A2",
            "SRRT",
            "EID1",
            "SPATA2",
            "CHERP",
            "CAP1",
            "PTEN",
            "ZSWIM1",
            "SNX2",
            "AZI2",
            "DAZAP1"
        ]
    },
    {
        "golabel": "GPATCH8_regulon_activity",
        "gene": [
            "HSN2",
            "NNMT",
            "NDUFB1",
            "SSR4",
            "MYEOV2",
            "C8orf40",
            "C14orf142",
            "SERF2",
            "TRAPPC2L",
            "ZNF32",
            "MDN1",
            "COX4I1",
            "RAD54L2",
            "N6AMT2",
            "TMEM208",
            "ACOT1",
            "C11orf51",
            "MGC57346",
            "PRDX5",
            "BCORL1",
            "CD63",
            "C11orf75",
            "DECR1",
            "MSRB2",
            "MDC1",
            "MED1",
            "MGST2",
            "TXN2",
            "JTB",
            "TXLNG",
            "C9orf119",
            "ZCCHC11",
            "SEC61B",
            "NIPA1",
            "RNASEK",
            "C11orf59",
            "ZNF445",
            "HEATR6",
            "NDUFS3",
            "EP400",
            "MLL",
            "CHMP4A",
            "IMP3",
            "CYB561D2",
            "KIAA1267",
            "BPTF",
            "GABARAP",
            "PIP4K2B",
            "PIKFYVE",
            "C14orf43",
            "KIAA1310",
            "ATXN7L3",
            "SUPT6H",
            "RNF167",
            "STAT5B",
            "STX5",
            "SPG21",
            "AMMECR1L"
        ]
    },
    {
        "golabel": "GPN1_regulon_activity",
        "gene": [
            "CAPZA2",
            "RGS20",
            "CCL7",
            "GPR87",
            "FLJ42875",
            "SLAMF9",
            "ANKRD7",
            "LOC645166",
            "C13orf38",
            "LOC728819",
            "DNAH1",
            "CCNB2",
            "EPHX4",
            "CENPA",
            "MAD2L1",
            "DEPDC1",
            "EPR1",
            "CKAP2L",
            "CDK1",
            "MOCOS",
            "CCNA2",
            "CKS1B",
            "RRM2",
            "LOC374443",
            "LYPLA1",
            "C4orf36",
            "RAB32",
            "GRAMD4",
            "POP4",
            "FAM22A",
            "PAQR3",
            "ARPC1A",
            "GOLT1B",
            "KIF13B",
            "NOTCH4",
            "MMP15",
            "PON2",
            "IFT140",
            "KPNA2",
            "TSPYL2",
            "CABC1",
            "TENC1",
            "FRAT1",
            "DERA",
            "CALM2",
            "MXRA7",
            "SNX6",
            "MRPL33",
            "TMEM14B",
            "COMMD8",
            "DUSP8",
            "PGK1",
            "RPA3",
            "LOC339047",
            "CPNE8",
            "INSR",
            "GEMIN6",
            "UBA2",
            "PPP1R13B",
            "RAN",
            "CENPO",
            "CENPL",
            "MCM6",
            "MRPS23",
            "LRIG1",
            "STARD3NL",
            "H2AFZ",
            "CASZ1",
            "NPIP",
            "GPR180",
            "ARL6IP6",
            "MED28",
            "TUBGCP6",
            "CRTC1",
            "PPIAL4C",
            "CCDC90B",
            "ACTL6A",
            "COX7A2L",
            "SNAPC1",
            "PPIL1",
            "PGAM4",
            "ADSL",
            "TUBA1C",
            "PKD1",
            "IAH1",
            "NUP37",
            "PHF5A",
            "ANKHD1-EIF4EBP3",
            "TMEM165",
            "ZNF276",
            "KIAA0467",
            "C12orf29",
            "TNRC6C",
            "ADAM17",
            "BZW2",
            "SSR3",
            "WWC3",
            "TXNDC9",
            "CLDND1",
            "UBE2E3",
            "RRBP1",
            "MRPS10",
            "C9orf91",
            "OLA1",
            "PSMD14",
            "MEMO1",
            "PNO1",
            "C9orf30",
            "NMD3",
            "EIF4A3",
            "CCT4",
            "TSN",
            "SRRM2",
            "ZMIZ1",
            "SUMO3",
            "SLC43A2",
            "LOC100129034",
            "PSMC2",
            "YWHAQ",
            "MRPL45",
            "GPN3",
            "LRRC42",
            "HMGN4",
            "PSMA2",
            "GSTCD",
            "RARS2",
            "METTL2A",
            "C3orf38",
            "RAB10",
            "WDR43",
            "RPAP2",
            "CHD3",
            "DRG1",
            "C7orf70",
            "ITGB1BP1",
            "PSMD10",
            "NIP7",
            "POLE3",
            "PGAM1",
            "RNF7",
            "ARAP1",
            "SLC30A6",
            "DDX47",
            "YRDC",
            "GART",
            "PACRGL",
            "RDBP",
            "C12orf41",
            "ATG5",
            "ZBTB40",
            "SF3B14",
            "RPE",
            "CLEC16A",
            "UMPS",
            "SUPT4H1",
            "MRPS7",
            "ERCC8",
            "DUSP11",
            "DR1",
            "EBNA1BP2",
            "GTPBP10",
            "C2CD2L",
            "RTN4",
            "VRK2",
            "NUP54",
            "SEC22A",
            "C1orf174",
            "NUMA1",
            "KIAA0430",
            "TRMT61B",
            "C2orf43",
            "ZC3H15",
            "ACTR3",
            "SNRNP40",
            "ZCCHC4",
            "PHB",
            "MCFD2",
            "PCMT1",
            "MAP4K3",
            "ZCCHC14",
            "SYVN1",
            "HCCS",
            "CPSF3",
            "SUMO2",
            "NOL11",
            "HAT1",
            "CUL2",
            "UTP18",
            "UBXN2A",
            "PPP1CB",
            "BRD1",
            "AP2A2",
            "CAPZA1",
            "SNX17",
            "FEZ2",
            "CCT7",
            "PPM1G",
            "USP39",
            "UGP2",
            "PHF2",
            "GNAI3",
            "STAMBP",
            "CEBPZ",
            "HNRPLL",
            "SLC4A1AP",
            "SNRNP27",
            "TTC4",
            "SHQ1",
            "SLC35A4",
            "NRBP1",
            "THUMPD3",
            "HADHA",
            "ZNF207"
        ]
    },
    {
        "golabel": "GRHL2_regulon_activity",
        "gene": [
            "GFPT2",
            "LST1",
            "SRGN",
            "EVI2A",
            "PTPN22",
            "COL6A1",
            "FOXA1",
            "TYROBP",
            "GNGT2",
            "COL6A2",
            "GLIPR1",
            "HCST",
            "SEMA6B",
            "C1QTNF1",
            "C1orf54",
            "C1QA",
            "C5orf62",
            "DOK2",
            "EPN3",
            "TNFAIP8L2",
            "FCER1G",
            "AIF1",
            "GMFG",
            "EMP3",
            "EHF",
            "HAVCR2",
            "VIM",
            "C1orf162",
            "SPI1",
            "TUBB6",
            "TIMP1",
            "TRPV2",
            "TMPRSS13",
            "CD86",
            "SIX4",
            "CD40",
            "LAT2",
            "FERMT3",
            "CD53",
            "CYTH4",
            "IFI30",
            "GYPC",
            "LAPTM5",
            "SELPLG",
            "CNRIP1",
            "WAS",
            "SH3BGRL3",
            "IL3RA",
            "RAC2",
            "LYL1",
            "FHL3",
            "ABI3",
            "KIAA1949",
            "FAM83H",
            "PABPC1",
            "PLEKHO2",
            "PARVB",
            "SAMD12",
            "ZBTB42",
            "ANXA6",
            "ILDR1",
            "ESRP2",
            "CHD6",
            "FAM117B",
            "UBR5",
            "ZYX",
            "ZNF623",
            "ESRP1",
            "ZNF252",
            "INADL",
            "RGS19",
            "KIAA0146",
            "AKAP1",
            "YWHAZ",
            "ANXA5",
            "ZNF664",
            "MBTD1",
            "PTK2",
            "STRBP",
            "CYB561",
            "STK3",
            "PHF20L1",
            "RBM47",
            "TTC35",
            "GNAI2",
            "KIAA1429",
            "SMEK1",
            "RBM12B",
            "RHOG",
            "SUV420H1",
            "RABGAP1",
            "WDR20",
            "AFTPH"
        ]
    },
    {
        "golabel": "GTF2A1_regulon_activity",
        "gene": [
            "RAB39",
            "UCN",
            "ADAMTS12",
            "CAPN12",
            "MBNL3",
            "PPM1L",
            "PYGO1",
            "DDR2",
            "NPFF",
            "NPIPL3",
            "DLEU7",
            "TBC1D3B",
            "C6orf26",
            "NID1",
            "CRYGS",
            "GMCL1L",
            "HMGN3",
            "TIAF1",
            "LOC401052",
            "SYTL1",
            "IPMK",
            "CEMP1",
            "MYL5",
            "ZNF692",
            "FLJ35220",
            "SBF2",
            "RASSF7",
            "WWTR1",
            "TAOK1",
            "ECHDC2",
            "ZDHHC20",
            "CDK5RAP3",
            "ZNF813",
            "RAPGEF6",
            "C20orf177",
            "LOC729234",
            "HS2ST1",
            "CCDC57",
            "LAMC1",
            "GOLIM4",
            "RUNDC2A",
            "C16orf13",
            "CDK10",
            "FAM168A",
            "DAAM1",
            "NAA30",
            "STXBP5",
            "ACADVL",
            "HDHD3",
            "B3GNTL1",
            "ATE1",
            "LIMS1",
            "CCDC159",
            "LCORL",
            "STRN",
            "KBTBD7",
            "NHLRC2",
            "SHPRH",
            "MAN1A2",
            "DHX33",
            "ASXL2",
            "RAB24",
            "FERMT2",
            "SEL1L",
            "REST",
            "CSNK2A1P",
            "DPM2",
            "TMX1",
            "PRKRIP1",
            "APOOL",
            "LYSMD4",
            "TRAM2",
            "GLUD2",
            "ADAM10",
            "LIN52",
            "QTRT1",
            "ARRDC1",
            "PAFAH1B2",
            "SIRT7",
            "MAPK8",
            "LATS1",
            "PHKG2",
            "NAT6",
            "SH3GLB2",
            "ZNF689",
            "NIN",
            "ADAT1",
            "SPSB3",
            "FAM98B",
            "STAG1",
            "FUT11",
            "NAT9",
            "C14orf21",
            "COMMD4",
            "NUP153",
            "C14orf118",
            "RFNG",
            "PLBD2",
            "CCNI",
            "SAV1",
            "TRIP11",
            "TMED10P1",
            "CHMP2A",
            "PPP4R2",
            "PPP2R5E",
            "RSPRY1",
            "NPRL2",
            "EXOC5",
            "IRF3",
            "C14orf135",
            "KCTD20",
            "UBR7",
            "ZFAND2B",
            "ATF2",
            "NADSYN1",
            "SNX12",
            "CXorf56",
            "TAF3",
            "YLPM1",
            "XRN2",
            "PDS5B",
            "WDR7",
            "RBBP5",
            "MPP5",
            "SERINC3",
            "EIF5",
            "ZNF394",
            "RHBDD1",
            "CRK",
            "STAG2",
            "PPM1A",
            "FCF1",
            "SLC39A9",
            "RBM27",
            "STRADA",
            "ZFP91",
            "TMEM184C",
            "GMEB1",
            "CREB1"
        ]
    },
    {
        "golabel": "GTF2A2_regulon_activity",
        "gene": [
            "RSL24D1",
            "RPLP1",
            "KIAA0101",
            "COX6B1",
            "C1orf31",
            "TIMM8B",
            "SNRPG",
            "C12orf57",
            "RPS17",
            "MRPL48",
            "COX7B",
            "HIGD1A",
            "C2orf76",
            "UQCRQ",
            "NDUFB1",
            "COX7A2",
            "EMG1",
            "DLEU1",
            "C20orf7",
            "GSTP1",
            "MYEOV2",
            "RPS27L",
            "MFF",
            "TMED3",
            "LOC100130932",
            "RPL41",
            "LSM2",
            "MRPS15",
            "MRPL33",
            "TMEM14B",
            "C2orf79",
            "UQCRHL",
            "POMP",
            "HSBP1",
            "CRIPT",
            "ZNF608",
            "TMEM17",
            "ATP5I",
            "HDDC3",
            "HINT1",
            "PPIB",
            "C20orf24",
            "C1orf57",
            "CCDC72",
            "PTS",
            "PSTK",
            "ATP5G1",
            "SERF2",
            "UQCRH",
            "GLRX3",
            "VPS29",
            "C15orf63",
            "ALG5",
            "PHB2",
            "HBXIP",
            "USMG5",
            "C18orf32",
            "NOP10",
            "NAA20",
            "COX7A2L",
            "TMEM223",
            "CMC1",
            "HSPE1",
            "CYCS",
            "OSTC",
            "ATP5L",
            "AKNA",
            "TXNL1",
            "MTHFS",
            "AHDC1",
            "CCDC59",
            "FBXO22OS",
            "PHF5A",
            "RCCD1",
            "ATP5J",
            "SNRPA1",
            "COX5A",
            "UBL7",
            "C14orf2",
            "TIPIN",
            "NDUFV2",
            "NDUFA1",
            "TRANK1",
            "NDUFB4",
            "CNPY2",
            "CHMP1B",
            "MYL12B",
            "C1orf43",
            "MAGOHB",
            "TXNDC9",
            "C12orf73",
            "RCN2",
            "TPRKB",
            "MRPL42",
            "C15orf61",
            "ATP5G3",
            "TMEM183A",
            "LOC388789",
            "HDDC2",
            "COX7C",
            "NDUFB3",
            "FAM96A",
            "NDUFS5",
            "ATP5G2",
            "MGST3",
            "SARNP",
            "PRDX3",
            "WDR61",
            "MRPL22",
            "PSMD14",
            "NUDT5",
            "TMEM93",
            "TMED2",
            "PPCS",
            "ORMDL2",
            "C10orf84",
            "TMEM126A",
            "NUDT15",
            "VDAC2",
            "C16orf63",
            "SELS",
            "ATP5C1",
            "C1D",
            "MRPL27",
            "ETFA",
            "OVCA2",
            "MRPL51",
            "PSMA5",
            "NDUFB8",
            "PTGES3",
            "NDUFAB1",
            "CHCHD1",
            "SNRPE",
            "ATP6V1G1",
            "C12orf47",
            "RG9MTD1",
            "SYNJ1",
            "MKKS",
            "METTL9",
            "GPN3",
            "MRPS11",
            "ARPC5",
            "ARPC3",
            "NDUFA8",
            "SRP9",
            "C15orf24",
            "KCTD7",
            "ALG14",
            "TRIAP1",
            "OBFC2B",
            "FBXO22",
            "CISD1",
            "C11orf10",
            "TXNL4A",
            "TBCA",
            "NDUFC1",
            "MOBKL3",
            "ATP5F1",
            "PSMA4",
            "UBE2N",
            "GHITM",
            "SNRPB2",
            "WIBG",
            "TMEM85",
            "TXNDC12",
            "NDUFA12",
            "C20orf30",
            "MRPL46",
            "MYCBP",
            "PLEKHM1",
            "IQSEC1",
            "COPS2",
            "NDUFS3",
            "ZFAND6",
            "SNAPC5",
            "MYO9B",
            "ZFYVE26",
            "FAM103A1",
            "SPCS2",
            "DUT",
            "AAGAB",
            "MAP3K3",
            "RAB11A",
            "SEC11A",
            "SUMO1P3",
            "ARL1",
            "NIF3L1",
            "PRKAG1",
            "IMP3",
            "SKI",
            "PIGC",
            "LOC653566",
            "SNUPN",
            "PSMA1",
            "CDC123",
            "TIMM17A",
            "LSM3",
            "YWHAE",
            "TLN1",
            "CREBBP",
            "MRPS16",
            "EXOSC1",
            "INPP4A",
            "COPZ1",
            "ISCA1",
            "C8orf41",
            "ZMYM3",
            "MDH1",
            "SRP14",
            "MTFMT",
            "MRPL35",
            "MRPL44",
            "SUMO1",
            "TMX2",
            "MED22",
            "PPP1R9B",
            "PRKRA",
            "RPP30",
            "GABPB1",
            "C15orf44",
            "SPG21",
            "RBM4"
        ]
    },
    {
        "golabel": "GTF2E2_regulon_activity",
        "gene": [
            "DUSP4",
            "ATP13A4",
            "PBK",
            "CKS2",
            "ITGA9",
            "GSR",
            "CDCA2",
            "ESCO2",
            "KIAA0101",
            "C1orf31",
            "TXN",
            "SNRPG",
            "PER3",
            "SLC25A37",
            "COX7B",
            "TEF",
            "COX7A2",
            "HIP1",
            "NOD1",
            "NAT1",
            "MFF",
            "POMP",
            "RAPGEF5",
            "ZNF608",
            "C20orf24",
            "TOMM5",
            "H2AFZ",
            "USMG5",
            "NOP10",
            "S100A11",
            "HSPE1",
            "SNRPF",
            "SNRPD1",
            "SNRPA1",
            "TNFRSF10B",
            "COX5A",
            "KIF13A",
            "BZW1",
            "ATP5G3",
            "EIF5A",
            "NDUFB3",
            "MACF1",
            "SARNP",
            "PSMD14",
            "ORMDL2",
            "ARHGEF17",
            "ATP5C1",
            "EIF5AL1",
            "KCTD9",
            "KIAA0495",
            "SYNJ1",
            "ARPC3",
            "CABIN1",
            "NUTF2",
            "PSMA4",
            "BIN3",
            "CUL9",
            "CISD2",
            "GTF3C6",
            "MAK16",
            "DCTN6",
            "MAP3K3",
            "RAB11A",
            "POLR3D",
            "DYNLL1",
            "SKI",
            "CDC123",
            "CNOT7",
            "UBE2F",
            "LEPROTL1",
            "C8orf41",
            "MRPL44",
            "COQ10B",
            "SUMO1",
            "PWP1"
        ]
    },
    {
        "golabel": "GTF2H3_regulon_activity",
        "gene": [
            "B4GALT6",
            "FRRS1",
            "PRR11",
            "ASAH2B",
            "NPIPL3",
            "PRIM1",
            "DSG2",
            "GAS2L3",
            "CRIP2",
            "PSIMCT-1",
            "NUP155",
            "BAG4",
            "DEPDC4",
            "TIAF1",
            "RPRD1A",
            "STK38L",
            "TMEM48",
            "C12orf49",
            "ZRANB3",
            "C16orf48",
            "ALG10",
            "WBP11P1",
            "P4HA1",
            "RBBP8",
            "RBL1",
            "LOC402377",
            "ZAK",
            "MPHOSPH9",
            "JUND",
            "ARL5B",
            "TMPO",
            "ARRDC2",
            "FGFR1OP2",
            "CCNT1",
            "YPEL3",
            "GATC",
            "SNAPC1",
            "PGAM5",
            "RFC5",
            "SBNO1",
            "PGAM4",
            "DDX21",
            "NUP37",
            "RECQL",
            "ARSA",
            "TFAM",
            "PAWR",
            "RSRC1",
            "SLC25A40",
            "TMTC3",
            "PRR24",
            "PUS7L",
            "USP1",
            "ZNF444",
            "NMD3",
            "DCUN1D1",
            "AZIN1",
            "RAD18",
            "RABEP2",
            "TAF1A",
            "NRAS",
            "FBXW4",
            "ZZZ3",
            "MAPK8",
            "GPN3",
            "GSTCD",
            "WDR43",
            "ZNF268",
            "SLC30A6",
            "ALG10B",
            "NAA50",
            "KRR1",
            "HSPA8",
            "SLC33A1",
            "DR1",
            "RNPEPL1",
            "IPO11",
            "NAA15",
            "MBTPS2",
            "WBP11",
            "PPP4R2",
            "PTPN11",
            "MOBKL1B",
            "FYTTD1",
            "LUZP6",
            "NEDD1",
            "OSBPL8",
            "DNAJB2",
            "SRPK2",
            "UHRF1BP1L",
            "POLR3B",
            "RQCD1",
            "GFM2",
            "SCYL2",
            "HMGXB4",
            "CXorf56",
            "SRFBP1",
            "C17orf59",
            "VEZT",
            "PPP1CC",
            "VPS33A",
            "UBE3C",
            "GTF3C3",
            "METAP2",
            "DENR",
            "PWP1",
            "ATP6V0A2",
            "ITCH",
            "KIAA1033",
            "ABCB7",
            "HNRPLL",
            "NUDT21",
            "CDC27",
            "ARMC8",
            "ZFR",
            "C12orf43",
            "RBM12"
        ]
    },
    {
        "golabel": "GTF2IRD2_regulon_activity",
        "gene": [
            "DLEC1",
            "NWD1",
            "GAS2L2",
            "SPAG8",
            "SKINTL",
            "DMRTC1B",
            "ANKFN1",
            "EFCAB6",
            "C16orf89",
            "ACSM1",
            "PPIL6",
            "PLIN5",
            "TTC23L",
            "ZNF117",
            "FLJ36777",
            "EVPLL",
            "PCDP1",
            "C8orf79",
            "C1orf101",
            "FANK1",
            "AURKA",
            "SELENBP1",
            "MYBL2",
            "CENPA",
            "MAD2L1",
            "MCM10",
            "SKA1",
            "C12orf48",
            "DEPDC1",
            "ZMAT1",
            "AURKB",
            "PRR11",
            "DEPDC1B",
            "TTK",
            "FOXM1",
            "ORC1L",
            "DLGAP5",
            "TPX2",
            "EFCAB5",
            "EPR1",
            "KIF23",
            "KIF2C",
            "CDC6",
            "RAD51AP1",
            "BIRC5",
            "CDC20",
            "KIFC1",
            "KIAA1524",
            "CKAP2L",
            "C9orf68",
            "KATNAL2",
            "CCNA2",
            "SGOL1",
            "NCAPG",
            "BUB1B",
            "ARHGAP11A",
            "SKA3",
            "NCAPH",
            "BUB1",
            "MKI67",
            "TOP2A",
            "KIF4A",
            "CDCA5",
            "RRM2",
            "CDCA8",
            "C1orf133",
            "PLK1",
            "CEP55",
            "LOC100130015",
            "CTF1",
            "LCA5L",
            "SGOL2",
            "KIF11",
            "NEIL1",
            "PRC1",
            "CCT6B",
            "MTHFD2",
            "RACGAP1",
            "C15orf56",
            "FLJ40852",
            "C7orf23",
            "HYI",
            "KPNA2",
            "ZNF596",
            "MGC3771",
            "INCA1",
            "FAM116B",
            "C9orf130",
            "ECHDC2",
            "MPL",
            "TTC12",
            "PION",
            "GTF2IRD2B",
            "CENPO",
            "CDK10",
            "DNAJC28",
            "C1orf203",
            "ENTPD7",
            "LY6G5C",
            "DDX21",
            "RABL2A",
            "CCDC159",
            "GTF2IRD2P1",
            "SETD4",
            "C14orf79",
            "ZNF19",
            "DET1",
            "ERMAP",
            "DNAJC30",
            "PLBD2",
            "WDR5B",
            "OMA1",
            "RCOR3",
            "GTF2IP1",
            "LRRC59",
            "DCAF8",
            "COQ7",
            "LOC493754",
            "YME1L1"
        ]
    },
    {
        "golabel": "GTF2IRD2B_regulon_activity",
        "gene": [
            "FAM81B",
            "ANKFN1",
            "EFCAB6",
            "C6orf217",
            "ACSM1",
            "TNNI3K",
            "FAM64A",
            "EVPLL",
            "UBE2C",
            "AURKA",
            "MYBL2",
            "CENPA",
            "SKA1",
            "C12orf48",
            "AURKB",
            "DEPDC1B",
            "C1orf135",
            "EPR1",
            "KIF2C",
            "CENPW",
            "BIRC5",
            "CDC20",
            "CDCA3",
            "MELK",
            "FAM54A",
            "CDCA5",
            "CDCA8",
            "CCNB1",
            "MTHFD2",
            "FLJ40852",
            "ALDH1B1",
            "TTC12",
            "SUGT1L1",
            "PION",
            "HN1",
            "THOC4",
            "GTF2IRD2P1",
            "ANKAR",
            "ALS2CR8",
            "GTF2IRD2",
            "RNASEL",
            "ZC3H6",
            "C2orf67",
            "OMA1",
            "ACTG1",
            "BBS2",
            "GTF2IP1",
            "ZNF500",
            "TBRG1"
        ]
    },
    {
        "golabel": "GTF3C1_regulon_activity",
        "gene": [
            "CD48",
            "MAP1A",
            "RPS18",
            "QPRT",
            "RPS6",
            "RPSA",
            "C17orf44",
            "ABCC1",
            "MREG",
            "RPL7A",
            "NOMO2",
            "NOMO3",
            "NDE1",
            "USP31",
            "NIPSNAP3A",
            "PYROXD1",
            "FBXL19",
            "PSME1",
            "PPA1",
            "BTBD12",
            "SLC35D2",
            "C3orf23",
            "KIAA0556",
            "ZKSCAN2",
            "NOMO1",
            "IL4R",
            "RNASEH2B",
            "UBE2E1",
            "AK3",
            "JMJD5",
            "C16orf88",
            "UBA3",
            "TSC2",
            "ZNF646",
            "POLR3E",
            "SETD1A",
            "SPATA2",
            "RNF40",
            "DHX38",
            "HCFC1",
            "UBN1",
            "ATXN2L",
            "ARHGAP17",
            "TM9SF4",
            "XPO6",
            "RHOA",
            "USP7"
        ]
    },
    {
        "golabel": "GTF3C2_regulon_activity",
        "gene": [
            "OTX1",
            "PLAC9",
            "ORC1L",
            "IFI27L2",
            "EME1",
            "HSPB2",
            "COX7A1",
            "GMFG",
            "CARD16",
            "EPT1",
            "IGFBP7",
            "CNRIP1",
            "TRIM22",
            "PGCP",
            "CAD",
            "C2orf16",
            "PMP22",
            "CENPO",
            "DNMT3A",
            "PECAM1",
            "C10orf2",
            "SLC5A6",
            "RCBTB2",
            "ADAM17",
            "MYO19",
            "PNPT1",
            "ATL2",
            "CUL7",
            "TNFSF12",
            "AGBL5",
            "WDR43",
            "PDCD11",
            "HDGF",
            "LCLAT1",
            "NAA25",
            "RTKN",
            "TXNDC15",
            "GCN1L1",
            "MTA3",
            "LRPPRC",
            "NOLC1",
            "C2orf3",
            "RNASEH1",
            "PPP3CC",
            "SNRNP200",
            "CPSF3",
            "MTIF2",
            "DHX57",
            "PTCD3",
            "GTF3C3",
            "PPM1G",
            "NOL10",
            "MOGS",
            "CEBPZ",
            "TMEM214",
            "MRPL19",
            "SMYD5",
            "SUPT7L",
            "EIF2B4",
            "IMMT",
            "HADHA",
            "PUM2",
            "ERCC3"
        ]
    },
    {
        "golabel": "HAX1_regulon_activity",
        "gene": [
            "C1orf182",
            "GAS5",
            "ALG1L",
            "HIST2H4A",
            "RPS15A",
            "DST",
            "SNHG6",
            "NYNRIN",
            "C1orf31",
            "AHNAK",
            "MRPS6",
            "RPS27",
            "PFDN5",
            "GPR89C",
            "EFNA1",
            "TLN2",
            "C2orf76",
            "RPL24",
            "FUNDC2",
            "C1orf97",
            "FBXO16",
            "CREB3L4",
            "IER3IP1",
            "SSR4",
            "NDUFA2",
            "TOMM6",
            "BGLAP",
            "RAG1AP1",
            "PHPT1",
            "NDUFA4",
            "TMEM14B",
            "CCDC56",
            "UQCRHL",
            "C12orf62",
            "BOLA1",
            "CRIPT",
            "NQO2",
            "BRP44",
            "RPL38",
            "HINT1",
            "SHROOM2",
            "C1orf57",
            "RNF181",
            "PTPN21",
            "ACOT13",
            "EPB41L2",
            "TMEM9",
            "LRRC8A",
            "UQCRH",
            "NDUFAF2",
            "KRTCAP2",
            "NDUFB6",
            "LRRK1",
            "IMMP1L",
            "RPL37A",
            "MEGF8",
            "MRPL24",
            "APOA1BP",
            "COX7A2L",
            "SELK",
            "SAR1B",
            "HSD17B7",
            "RIT1",
            "FAM36A",
            "NDUFB11",
            "PLEKHA7",
            "ATP5J",
            "BNIP1",
            "MYO18A",
            "NDUFA1",
            "MAPKBP1",
            "CDKN2AIPNL",
            "SOD1",
            "PLXNB2",
            "LYPLAL1",
            "MAP3K5",
            "C1orf43",
            "MRPS36",
            "C12orf73",
            "HAUS4",
            "NHP2",
            "FDPS",
            "TMEM183A",
            "DPY30",
            "COX7C",
            "SEC14L1",
            "TOMM40L",
            "NEDD8",
            "MACF1",
            "MGST3",
            "TIMM9",
            "UQCRB",
            "COX17",
            "MRPL22",
            "ICT1",
            "GLRX2",
            "ERLEC1",
            "ROBLD3",
            "C1orf85",
            "SNAPIN",
            "ACTN4",
            "PSMB4",
            "PMF1",
            "SSR2",
            "JTB",
            "LUZP1",
            "FOXO3",
            "MYH9",
            "DAB2IP",
            "ANKRD39",
            "TOMM20",
            "DAD1",
            "FARP2",
            "PPA2",
            "AK2",
            "C20orf112",
            "COQ5",
            "EHBP1L1",
            "C12orf47",
            "GPN3",
            "SDHC",
            "POLR3K",
            "PRDX6",
            "OXSM",
            "PRELID1",
            "ILF2",
            "MEA1",
            "CLSTN1",
            "PSMD4",
            "SUCLG1",
            "FOXO3B",
            "ABR",
            "TBCA",
            "AIP",
            "GBA",
            "DERL2",
            "ATP5H",
            "TATDN3",
            "PEX19",
            "LGTN",
            "MRPS7",
            "ZNF622",
            "PCSK7",
            "UFC1",
            "WDFY2",
            "NUP88",
            "RBM9",
            "FH",
            "C12orf65",
            "CHMP4A",
            "MRPS14",
            "DAP3",
            "PCGF1",
            "TMCO1",
            "ZNHIT3",
            "PIGC",
            "TAF9",
            "TOR3A",
            "SLC35B1",
            "NDUFV3",
            "PHRF1",
            "DDX59",
            "RAB13",
            "ARF1",
            "VAMP4",
            "RABIF",
            "FAM40A"
        ]
    },
    {
        "golabel": "HBP1_regulon_activity",
        "gene": [
            "CYB5A",
            "KIF18B",
            "DDX12",
            "MKI67",
            "UHRF1",
            "C7orf60",
            "KBTBD3",
            "DDX11",
            "HNMT",
            "C14orf80",
            "TSC22D1",
            "ZNF415",
            "C4orf34",
            "MREG",
            "FAM175A",
            "SRI",
            "ZNF627",
            "RNF5P1",
            "POLE",
            "INTS1",
            "LMNB2",
            "TCP11L2",
            "CNOT8",
            "MR1",
            "ST7",
            "DSTN",
            "NOP2",
            "TBC1D15",
            "STK17B",
            "ZMIZ2",
            "ZNF277",
            "THOP1",
            "SLC25A22",
            "BNIP3L",
            "OXR1",
            "VKORC1L1",
            "TMEM201",
            "DOHH",
            "FAM188A",
            "AUH",
            "KLC2",
            "RAB33B",
            "CCNDBP1",
            "C3orf23",
            "TFB2M",
            "CCDC137",
            "YPEL5",
            "ASB3",
            "NEK7",
            "LZTFL1",
            "C12orf26",
            "RNF5",
            "ZNF598",
            "MAT2B",
            "PEX19",
            "RPTOR",
            "FBXL5",
            "LMBRD1",
            "MBD3",
            "FBXL3",
            "PIGY",
            "THAP5",
            "FBXO3",
            "NCOA4",
            "IKZF5",
            "MUTED",
            "SMPD4",
            "ISCA1",
            "SACM1L",
            "FBXO8",
            "RSBN1",
            "TBC1D23",
            "CEPT1",
            "RBM18",
            "STAM2",
            "MAP2K4",
            "DAZAP1",
            "EWSR1"
        ]
    },
    {
        "golabel": "HCFC1_regulon_activity",
        "gene": [
            "NTN3",
            "LEMD1",
            "S100A4",
            "RPL9",
            "FAM157A",
            "GSTO1",
            "PFDN5",
            "S100A13",
            "RPS8",
            "TPT1",
            "RPL5",
            "FBXL18",
            "CD58",
            "C5orf35",
            "NAT1",
            "TRAM1",
            "BPGM",
            "TMSL3",
            "VAMP8",
            "LGALS3",
            "SOCS7",
            "ADK",
            "FBXO4",
            "C4orf33",
            "C11orf1",
            "FAM83G",
            "RPL34",
            "MREG",
            "C20orf117",
            "CAD",
            "COMMD10",
            "CCDC72",
            "RPS13",
            "TMEM42",
            "KRCC1",
            "DHRS7",
            "RPL14",
            "TBC1D16",
            "INTS1",
            "CNIH4",
            "LOC389333",
            "SELK",
            "C9orf103",
            "RPS23",
            "C19orf55",
            "MSI2",
            "ACOT1",
            "RPL15",
            "NIPSNAP3A",
            "LIAS",
            "STX8",
            "TRRAP",
            "LYPLAL1",
            "DNMT1",
            "RPS4X",
            "NDUFS4",
            "BCORL1",
            "COX7C",
            "PPIL3",
            "COMMD6",
            "TET3",
            "CRBN",
            "ZNF277",
            "POLR1A",
            "MDC1",
            "DOT1L",
            "INSIG2",
            "NSA2",
            "ZNF496",
            "C17orf48",
            "RPL36AL",
            "ANKRD52",
            "C15orf57",
            "SFRS12IP1",
            "RPS25",
            "TOP3A",
            "SMC1A",
            "MOCS2",
            "MLL4",
            "DHX37",
            "ZNF687",
            "C2CD3",
            "CCDC104",
            "BAT2L1",
            "DRAM2",
            "HIRA",
            "PARP1",
            "RWDD1",
            "COX16",
            "RPTOR",
            "DIDO1",
            "THOC7",
            "GCN1L1",
            "PRR12",
            "LOC285033",
            "UBAP2",
            "IGBP1",
            "SAMD4B",
            "EP400",
            "CAMLG",
            "NCOA6",
            "PIGY",
            "ATG2A",
            "BAT2",
            "MAPKSP1",
            "CCNH",
            "EIF4G1",
            "UBE2B",
            "MED12",
            "UBE2O",
            "SPCS1",
            "C3orf10",
            "PCNXL3",
            "HEBP1",
            "ZNF646",
            "SNRNP200",
            "SETD1A",
            "ZFYVE21",
            "TAF12",
            "DEPDC5",
            "NDUFA5",
            "LAPTM4A",
            "BRD4",
            "ARL2BP",
            "GTF3C1",
            "UBR4",
            "EHMT1",
            "MARK2",
            "ATP6V1D",
            "RBM15",
            "VAMP4",
            "TMEM50A",
            "NAIF1",
            "ZNF142",
            "SEC22C",
            "DNAJC11",
            "SP2",
            "VCP",
            "UBTF",
            "RBM14"
        ]
    },
    {
        "golabel": "HDAC10_regulon_activity",
        "gene": [
            "SLC16A11",
            "C1orf127",
            "HSF4",
            "ATAD3C",
            "CACNB1",
            "FOXD4L6",
            "POM121L10P",
            "LOC284837",
            "ABCC6",
            "RAPGEF3",
            "PMS2L11",
            "IDUA",
            "ODF3B",
            "C22orf36",
            "PYROXD2",
            "EIF5A2",
            "CHKB-CPT1B",
            "SLC22A18",
            "MAPK11",
            "PLCB2",
            "ENGASE",
            "TNFRSF14",
            "SYTL1",
            "SHROOM1",
            "CEMP1",
            "LRRC29",
            "FAM116B",
            "D2HGDH",
            "DHX58",
            "SHANK3",
            "TYMP",
            "ARHGAP8",
            "FHOD1",
            "RASA4P",
            "JMJD7-PLA2G4B",
            "RAB17",
            "FDXR",
            "ANKS3",
            "CRELD2",
            "TUBGCP6",
            "LOC441089",
            "ELMO3",
            "CDK18",
            "RIPK3",
            "PRR5",
            "LOC150786",
            "RABL2B",
            "RABL2A",
            "SCO2",
            "ARSA",
            "ZNF276",
            "SCRN2",
            "SELO",
            "SPATA20",
            "SFI1",
            "DGKQ",
            "SBF1",
            "C21orf2",
            "RAD21",
            "ARHGAP27",
            "TMC6",
            "FES",
            "SLC12A9",
            "AMDHD2",
            "SH3TC1",
            "LOC221710",
            "USP1",
            "GAK",
            "GGA1",
            "IFT52",
            "NMD3",
            "SGSM3",
            "MIB1",
            "LRCH4",
            "AZIN1",
            "NRAS",
            "RAP2A",
            "RHOT2",
            "MAPK8",
            "LMF2",
            "TRABD",
            "ZNF639",
            "C22orf40",
            "ERCC8",
            "NCAPH2",
            "DR1",
            "RNPEPL1",
            "TOM1",
            "NAA15",
            "DNAJA1",
            "PPP4R2",
            "SGSH",
            "KPNA4",
            "DCAF10",
            "ALG12",
            "UBE2K",
            "OSBPL8",
            "EXOC5",
            "STAT6",
            "C2orf69",
            "C9orf80",
            "ZBTB6",
            "SAPS2",
            "PFKL",
            "CAMTA2",
            "CUL2",
            "PLD2",
            "BRD1",
            "RAB6A",
            "NUS1",
            "ITCH",
            "MAPRE1",
            "EML3",
            "TBC1D22A",
            "HNRPLL",
            "L3MBTL2",
            "PPP1R8",
            "GABPB1",
            "SPTLC1",
            "API5",
            "ZNF143",
            "HNRNPK"
        ]
    },
    {
        "golabel": "HDAC11_regulon_activity",
        "gene": [
            "GREM1",
            "C17orf50",
            "ADAM12",
            "GFPT2",
            "INHBA",
            "LOC388588",
            "SULF1",
            "LOX",
            "EXO1",
            "SKP2",
            "ADAMTS5",
            "C12orf48",
            "DEPDC1",
            "PRR11",
            "CASC5",
            "TTK",
            "GLOD5",
            "CENPI",
            "DLGAP5",
            "EPS8L1",
            "KIF14",
            "C4orf44",
            "EFCAB4A",
            "KIAA1524",
            "CKAP2L",
            "WISP1",
            "C11orf82",
            "CCNA2",
            "ASPM",
            "C1orf170",
            "ABCC6",
            "NCAPH",
            "BUB1",
            "C11orf35",
            "CHADL",
            "LOC113230",
            "IL17RE",
            "RHPN1",
            "GPRC5C",
            "FANCB",
            "ATP2B1",
            "KIF18A",
            "C22orf36",
            "SGOL2",
            "EIF5A2",
            "KIF11",
            "GSG2",
            "NUP155",
            "MTHFD2",
            "CCDC64B",
            "LOC653113",
            "C20orf151",
            "C18orf54",
            "RACGAP1",
            "MST1R",
            "EVPL",
            "RFC3",
            "CKAP2",
            "FHIT",
            "SPSB2",
            "LOC401052",
            "BRCA2",
            "SYTL1",
            "TMEM48",
            "TCEA3",
            "FBXO5",
            "ABHD14A",
            "KIF20B",
            "EPB49",
            "FKBP14",
            "D2HGDH",
            "SERINC2",
            "DBF4",
            "PLXNB1",
            "CCDC24",
            "RASSF7",
            "SMC2",
            "KLHDC8B",
            "RBL1",
            "FAAH",
            "ASMTL",
            "TMEM150A",
            "GNB4",
            "MPHOSPH9",
            "DGAT1",
            "GALE",
            "PPP1R16A",
            "PEX11G",
            "C17orf28",
            "SLC27A1",
            "KIF9",
            "MRPS25",
            "SLC38A2",
            "ZWILCH",
            "ELMO3",
            "TMC4",
            "C14orf106",
            "C1orf89",
            "RECQL",
            "NEK8",
            "LGALS3BP",
            "CLIC4",
            "SCRN2",
            "MVP",
            "LLGL2",
            "PCYT2",
            "SPATA20",
            "CHSY1",
            "C21orf2",
            "EPS8L2",
            "TMTC3",
            "LOC221710",
            "PUS7L",
            "CNKSR1",
            "C9orf7",
            "PLEKHH3",
            "CRELD1",
            "HEMK1",
            "ABHD14B",
            "SGSM3",
            "ABTB1",
            "ACBD4",
            "NICN1",
            "RABEP2",
            "PMVK",
            "PIGQ",
            "ARRDC1",
            "MVK",
            "CYHR1",
            "FBXW4",
            "ACAA1",
            "PRKRIR",
            "ORMDL3",
            "P4HTM",
            "NAT6",
            "SSH3",
            "PARP3",
            "TMEM129",
            "IL17RC",
            "CCDC12",
            "HMGCL",
            "LYPLA2",
            "TRIOBP",
            "TMEM53",
            "PRKCD",
            "TMCO4",
            "TEX264",
            "LZTS2",
            "OSBPL8",
            "EXOC5",
            "ENOX2",
            "SENP1",
            "MON1A",
            "WDR6",
            "DNAJB2",
            "DALRD3",
            "RNGTT",
            "USP15",
            "IP6K2",
            "NCKIPSD",
            "BNIP2",
            "TOLLIP",
            "TADA3",
            "GABPB1",
            "C2orf24",
            "SCAP",
            "TMEM115",
            "C3orf19",
            "GORASP1"
        ]
    },
    {
        "golabel": "HDAC5_regulon_activity",
        "gene": [
            "SLC7A10",
            "SMOX",
            "EFR3B",
            "ICAM5",
            "PRX",
            "SEMA6C",
            "BCAM",
            "KIAA1328",
            "STXBP1",
            "LOC220429",
            "GARNL3",
            "GRID2IP",
            "EVPL",
            "COX7B",
            "HIGD1A",
            "GPSM1",
            "APBA1",
            "BTBD9",
            "YPEL1",
            "BMF",
            "APBB1",
            "C20orf24",
            "NXN",
            "PBXIP1",
            "LOC100130581",
            "DBP",
            "VPS29",
            "MAPK6",
            "CRTC1",
            "CTAGE5",
            "CYCS",
            "EGLN1",
            "FAM117A",
            "SLC25A42",
            "STRAP",
            "NT5C3",
            "PYROXD1",
            "TWF1",
            "SERPINB8",
            "MAGOHB",
            "PDK2",
            "BZW1",
            "PCGF5",
            "TUBG2",
            "FAM96A",
            "CASKIN2",
            "MLLT6",
            "TOM1L2",
            "MPHOSPH6",
            "PLEKHH3",
            "SLC46A1",
            "KCTD9",
            "EPN2",
            "CUL7",
            "ARPC3",
            "CISD1",
            "BCAS3",
            "S1PR2",
            "C12orf5",
            "IDH3A",
            "XYLT2",
            "MAP3K3",
            "RAB11A",
            "AMD1",
            "MAP2K1",
            "ZC3H15",
            "EZH1",
            "TANK",
            "COPZ1",
            "HCCS",
            "SPCS3",
            "CAMTA2",
            "USP15",
            "TBC1D13",
            "CNNM3",
            "CEP68",
            "KCTD2",
            "ZER1",
            "CBFB",
            "FAM134C",
            "SCAP",
            "BAP1"
        ]
    },
    {
        "golabel": "HDAC7_regulon_activity",
        "gene": [
            "C1orf175",
            "LOC91450",
            "CCDC110",
            "HSPA4L",
            "GSR",
            "ADAM8",
            "ADAMTS10",
            "BTBD19",
            "RAPGEF3",
            "MEGF6",
            "LCAT",
            "GDPD5",
            "ADCY4",
            "COL16A1",
            "RARG",
            "TMEM86B",
            "MICALL2",
            "HIGD1A",
            "SLC36A4",
            "PLEKHG3",
            "PDLIM7",
            "PLXNA1",
            "IDI1",
            "C14orf126",
            "FECH",
            "SLMO2",
            "ATP5S",
            "SAR1B",
            "FAM38A",
            "BCL9L",
            "KIFC3",
            "ARAP3",
            "HSDL2",
            "ZSWIM4",
            "IQCE",
            "FAM109A",
            "PHOSPHO2",
            "CYP51A1",
            "RG9MTD2",
            "CCDC102A",
            "PTPLAD1",
            "WDR12",
            "PRDX3",
            "PI4K2B",
            "RHBDF1",
            "YIPF6",
            "BCAR1",
            "ARHGEF17",
            "C16orf63",
            "TRIM8",
            "RMI1",
            "TEAD3",
            "RBMS2",
            "SERP1",
            "C20orf112",
            "SLC12A4",
            "SVIP",
            "SOLH",
            "NCKAP5L",
            "OGFR",
            "COX11",
            "LOC729082",
            "TRIP10",
            "PRMT3",
            "MAP7D1",
            "STAT2",
            "IL4R",
            "SIN3B",
            "MED15",
            "KIAA0913",
            "NDUFS1",
            "TMED10P1",
            "ARHGEF18",
            "ARL5A",
            "RILPL1",
            "RAB2A",
            "EIF4E",
            "SKI",
            "LOC653566",
            "CNOT7",
            "TAF9",
            "YWHAE",
            "SPCS1",
            "TYK2",
            "PIP5K1C",
            "MTCH2",
            "RABL3",
            "TMX2",
            "METAP1",
            "PPP1R9B",
            "PRKRA",
            "EIF2A",
            "PRKD2",
            "MUDENG",
            "FASTKD2",
            "RPP14"
        ]
    },
    {
        "golabel": "HDGF_regulon_activity",
        "gene": [
            "LRRC31",
            "FAM83A",
            "OPN3",
            "CLEC4F",
            "SLC24A4",
            "MYOZ3",
            "HPGDS",
            "CX3CL1",
            "MFAP4",
            "EXO1",
            "KLHDC7A",
            "CYSLTR1",
            "SLC4A4",
            "ISM1",
            "ZDHHC15",
            "FAM72D",
            "DDO",
            "NUF2",
            "C1QTNF2",
            "HMGA1",
            "KIF14",
            "FAM72A",
            "CHML",
            "FAM72B",
            "MGP",
            "PLEKHH2",
            "CKS1B",
            "NEK2",
            "EBF4",
            "FAM198A",
            "RGAG4",
            "SDC2",
            "C18orf1",
            "RAI2",
            "PLEKHA4",
            "ARRDC4",
            "GSPT2",
            "C10orf47",
            "FLJ10357",
            "LPCAT2",
            "N4BP2L1",
            "PFDN2",
            "PIK3IP1",
            "KAT2B",
            "DARS2",
            "PARD3",
            "RCBTB2",
            "GTPBP4",
            "CA5B",
            "NUDT5",
            "RUVBL1",
            "FLAD1",
            "ZMYND19",
            "UAP1",
            "GPATCH4",
            "VPS72",
            "CCT3",
            "PRDX6",
            "ILF2",
            "MRPL9",
            "TCEANC",
            "FAM189B",
            "PSMD4",
            "B3GNT1",
            "UBQLN4",
            "SF3B4",
            "SMG5",
            "NOLC1",
            "COPA",
            "IPPK",
            "DAP3",
            "CDC123",
            "KCMF1",
            "EPRS",
            "IARS2",
            "ATIC",
            "SUPV3L1",
            "NDUFS2",
            "ARPC5L",
            "UBAP2L",
            "AHCTF1",
            "SET",
            "ISG20L2",
            "CTBP2",
            "TPM3",
            "PPM1G",
            "RAD23B",
            "PRCC",
            "MRPS5",
            "METTL13",
            "GTF3C2",
            "HNRNPU"
        ]
    },
    {
        "golabel": "HDX_regulon_activity",
        "gene": [
            "NDST3",
            "AMN",
            "S100P",
            "CD274",
            "TACC2",
            "RPS6KA6",
            "BEND6",
            "PMAIP1",
            "CLEC5A",
            "ALDH3B1",
            "PFKFB4",
            "FAM124A",
            "CLEC4A",
            "PABPC4L",
            "PTPN22",
            "P2RX7",
            "PLS3",
            "ALOX5AP",
            "RBM11",
            "CHSY3",
            "CYBB",
            "PTPRO",
            "CLEC7A",
            "ZC4H2",
            "CD80",
            "OPLAH",
            "LOC653653",
            "MNDA",
            "SPIRE2",
            "IFIH1",
            "MARCH1",
            "DDX60",
            "WLS",
            "DSE",
            "CNTLN",
            "STARD10",
            "FAM83E",
            "FPR3",
            "DOCK11",
            "SLC26A6",
            "IFI16",
            "MTMR8",
            "CDK2AP2",
            "TRAM1L1",
            "TUBA1A",
            "TJP3",
            "MMP15",
            "AP1S2",
            "BAG1",
            "IDI2",
            "CHKA",
            "GSTP1",
            "SLFN11",
            "SAMHD1",
            "FRAT1",
            "OGFRL1",
            "IDS",
            "PGK1",
            "ARMCX1",
            "P4HA2",
            "PLSCR1",
            "SLFN5",
            "LHFPL2",
            "FRAT2",
            "SPRED1",
            "SLC4A7",
            "UNC93B1",
            "ZNF430",
            "OVOL2",
            "NRIP1",
            "PER2",
            "EML2",
            "CNN3",
            "SLFN12",
            "PNKD",
            "PITPNM1",
            "ATP11C",
            "C6orf136",
            "KIF2A",
            "PWWP2B",
            "DNAJC18",
            "APLF",
            "CHIC1",
            "CHM",
            "SSH3",
            "TNK1",
            "BBS9",
            "NME7",
            "PJA1",
            "POLK",
            "UBTD2",
            "RAP1GDS1",
            "WDR41",
            "EXOC5",
            "PRPS1",
            "UBR7",
            "INPP5A",
            "SRFBP1",
            "RAD51L3",
            "USP38",
            "UPRT",
            "PPIP5K2",
            "VEZF1",
            "ABCB7",
            "BBS7",
            "ZNF207"
        ]
    },
    {
        "golabel": "HELZ_regulon_activity",
        "gene": [
            "FXYD3",
            "C14orf72",
            "NNMT",
            "C17orf61",
            "KIAA1328",
            "C12orf57",
            "NUDT2",
            "COX7B",
            "IFI27L1",
            "NBPF10",
            "LRRC37A2",
            "REL",
            "MRPL52",
            "NAV2",
            "MYEOV2",
            "NCOA2",
            "LOC651250",
            "HOOK3",
            "ATP5I",
            "USP13",
            "C14orf142",
            "RNF213",
            "MRPL34",
            "WNK1",
            "KIAA0922",
            "C11orf51",
            "LRRC37B",
            "NDUFA1",
            "DPCD",
            "SPAG9",
            "KIAA1109",
            "SYNJ1",
            "MED18",
            "ALG14",
            "AKAP1",
            "EEA1",
            "MLL3",
            "METTL11A",
            "ARL2",
            "C1orf151",
            "C1orf212",
            "ATXN7",
            "HEATR6",
            "TXNDC12",
            "EDEM2",
            "RAPGEF2",
            "SDHB",
            "ANKRD13A",
            "DYNLL2",
            "UQCRC1",
            "DYNLL1",
            "IMP3",
            "REXO2",
            "BPTF",
            "ITSN2",
            "KIDINS220",
            "ACOX1",
            "MYST2",
            "COG1",
            "TEX2",
            "GGA3",
            "STX18",
            "KCTD2",
            "USP36",
            "MKLN1",
            "NUFIP2",
            "FAM32A",
            "DDX42"
        ]
    },
    {
        "golabel": "HIC1_regulon_activity",
        "gene": [
            "CCL21",
            "HS3ST3A1",
            "SEMA7A",
            "FAM43B",
            "BOC",
            "CPZ",
            "SERPINF1",
            "CPNE5",
            "PCDHB7",
            "DCHS1",
            "MMP2",
            "COL6A3",
            "SAMD14",
            "COL6A2",
            "SCARF2",
            "CACNA1C",
            "SEMA6B",
            "C1QTNF1",
            "LAMA4",
            "TSHZ3",
            "REM1",
            "COL4A2",
            "CLIP2",
            "FAM176B",
            "CD248",
            "COL16A1",
            "EMILIN1",
            "STAB1",
            "LZTS1",
            "SOX18",
            "KIAA1755",
            "DEPDC4",
            "TNFRSF4",
            "CCDC85B",
            "LRRC32",
            "ARL4C",
            "TGFB1I1",
            "MRC2",
            "GRAP",
            "PDGFRB",
            "TNFAIP8L1",
            "JUNB",
            "PTGIR",
            "IL3RA",
            "MAL2",
            "TTYH3",
            "GPR124",
            "CYGB",
            "NUDT12",
            "SENP8",
            "C11orf54",
            "CEP70",
            "RNF122",
            "SH3YL1",
            "THNSL1",
            "RG9MTD2",
            "KCTD17",
            "C3orf33",
            "NUDT16P1",
            "PI4K2B",
            "DPP9",
            "RUSC2",
            "TOM1L1",
            "ST3GAL2",
            "DAPK3",
            "ZNF358",
            "PPA2",
            "MARVELD2",
            "C3orf23",
            "BPNT1",
            "PPP2R5B",
            "S1PR2",
            "CCDC125",
            "ARHGAP12",
            "PEX19",
            "MKL1",
            "OSGEPL1",
            "F11R",
            "PLA2G12A",
            "SCYL3",
            "MUT",
            "RBM47",
            "PLSCR3",
            "ERI2",
            "SCRN3",
            "PIP5K1C",
            "RABL3",
            "NVL",
            "NSUN4",
            "THAP9",
            "TMBIM6",
            "ELL",
            "SNX4",
            "KLHL12",
            "RBMX"
        ]
    },
    {
        "golabel": "HIF1A_regulon_activity",
        "gene": [
            "XDH",
            "SNAI2",
            "TGFBI",
            "CD274",
            "GPC6",
            "TNC",
            "PLAU",
            "TNNC1",
            "DCBLD2",
            "CD109",
            "ADAM12",
            "BEND6",
            "PLOD2",
            "CD163",
            "PMAIP1",
            "FBXO32",
            "IL2RA",
            "OVGP1",
            "GRAMD2",
            "LOX",
            "DDIT4",
            "ANLN",
            "NAMPT",
            "TNFAIP6",
            "FRMD6",
            "SELENBP1",
            "AK3L1",
            "PRR11",
            "POSTN",
            "CENPI",
            "LRRC56",
            "ERO1L",
            "DAPK2",
            "EFCAB4A",
            "DOK4",
            "CKAP2L",
            "WISP1",
            "SNAI1",
            "C6orf26",
            "STX19",
            "C22orf36",
            "PYGL",
            "SPIRE2",
            "SHCBP1",
            "DSE",
            "NEIL1",
            "ACCS",
            "CCDC64B",
            "ACSS1",
            "MAP1LC3A",
            "B3GNT5",
            "MMD",
            "TMEM125",
            "RGL3",
            "C11orf52",
            "BICD1",
            "NUDT13",
            "IFT140",
            "KIF20B",
            "C16orf48",
            "INCA1",
            "CHKA",
            "MAN2A1",
            "CABC1",
            "FLJ36031",
            "SEC23A",
            "FRAT1",
            "ITGAV",
            "ACTN1",
            "TNFRSF10A",
            "C1orf210",
            "ELK3",
            "CCDC24",
            "RASSF7",
            "WWTR1",
            "ECHDC2",
            "PGK1",
            "FAAH",
            "SLC20A1",
            "SUGT1L1",
            "ARHGAP8",
            "CCDC88A",
            "P4HA2",
            "JMJD7-PLA2G4B",
            "RAB17",
            "ACADS",
            "RALGPS1",
            "ANKS3",
            "TXNRD2",
            "WASH7P",
            "CTSB",
            "CDK10",
            "NRIP1",
            "YPEL3",
            "GBE1",
            "SNAPC1",
            "PGAM4",
            "CALU",
            "RECQL",
            "NEK8",
            "CCDC159",
            "SIGIRR",
            "B4GALT1",
            "LLGL2",
            "BZW1",
            "CHSY1",
            "AVL9",
            "KLC4",
            "C21orf2",
            "SETD4",
            "KIF2A",
            "SH2B1",
            "CEP170",
            "C2orf34",
            "TMTC3",
            "WASH3P",
            "ZSWIM7",
            "ROGDI",
            "C9orf30",
            "PPOX",
            "MED11",
            "CORO1C",
            "ZNF444",
            "C11orf49",
            "SGSM3",
            "ANKIB1",
            "FNDC3B",
            "C16orf58",
            "GNRHR2",
            "SAMD8",
            "CCDC121",
            "DHRS12",
            "PANX1",
            "HAGH",
            "NBN",
            "C1orf66",
            "SPSB3",
            "GMFB",
            "CCDC101",
            "PGAM1",
            "CLN3",
            "MYST1",
            "NAA50",
            "YWHAG",
            "C14orf118",
            "PEX16",
            "UBA6",
            "MLYCD",
            "NAA15",
            "C19orf39",
            "RTN4",
            "GEMIN8",
            "PPP4R2",
            "PPP2R5E",
            "MOBKL1B",
            "KPNA4",
            "VMAC",
            "LUZP6",
            "NEDD1",
            "OSBPL8",
            "EXOC5",
            "SEC24A",
            "MAP2K1",
            "ACTR3",
            "ARF6",
            "NARFL",
            "PAK2",
            "G3BP1",
            "DPH1",
            "PPP1R12A",
            "COG7",
            "GNA13",
            "MOB2",
            "CNNM3",
            "SIRT3",
            "PTPN12",
            "PICALM",
            "NAT15",
            "CDC27",
            "PRPF40A",
            "ACTR2",
            "ARFGAP2"
        ]
    },
    {
        "golabel": "HIPK2_regulon_activity",
        "gene": [
            "IFIT1",
            "ISG15",
            "S100A13",
            "GRAMD4",
            "MGAT5",
            "NAV1",
            "GAB2",
            "LSM2",
            "ACOT4",
            "GALNT7",
            "TRNAU1AP",
            "FAM115A",
            "NDUFB7",
            "GADD45GIP1",
            "TBC1D16",
            "HCFC1R1",
            "RBX1",
            "ZNF618",
            "TRIM56",
            "LOC151162",
            "ATP5O",
            "C9orf129",
            "MED13L",
            "C11orf74",
            "EIF3K",
            "TRRAP",
            "SUB1",
            "BCL7C",
            "ZFYVE19",
            "C19orf53",
            "KIAA1147",
            "CREB3L2",
            "ECHDC1",
            "C17orf106",
            "KIAA1109",
            "MRPL27",
            "LSM10",
            "CERK",
            "MARCH8",
            "ZMIZ1",
            "LOC100129034",
            "AKAP9",
            "REPIN1",
            "ENTPD4",
            "CAMSAP1",
            "ZNF799",
            "MLXIP",
            "BAT2L1",
            "DNAJC17",
            "MLL3",
            "MRPL38",
            "ZZEF1",
            "NDUFS3",
            "TRAPPC3",
            "DICER1",
            "MTF1",
            "CRYZL1",
            "KIAA2018",
            "KIAA0100",
            "YLPM1",
            "KIAA0317",
            "TECPR2",
            "C19orf62",
            "MLL5",
            "UBE3C",
            "C19orf56",
            "DNAJC8",
            "SFRS3",
            "FBXW2"
        ]
    },
    {
        "golabel": "HIST1H2BN_regulon_activity",
        "gene": [
            "HIST1H3J",
            "HIST1H4K",
            "HIST1H2BL",
            "HIST1H2AK",
            "HIST1H2BC",
            "CCR6",
            "HIST1H2BE",
            "SPN",
            "AMICA1",
            "DOK2",
            "HIST1H2BK",
            "BTK",
            "TBXAS1",
            "GAB3",
            "ARHGAP30",
            "TM6SF1",
            "HCLS1",
            "RASSF2",
            "HIVEP3",
            "TMOD2",
            "KCTD17",
            "SYK",
            "MRPS18A",
            "MRPS18B",
            "TRUB2",
            "VARS2",
            "ABR",
            "TARS2",
            "RNF5",
            "C22orf9",
            "HECA",
            "FARS2",
            "GTF2H4",
            "VPS52",
            "BAT3",
            "WDR46",
            "TRIM27"
        ]
    },
    {
        "golabel": "HIVEP1_regulon_activity",
        "gene": [
            "ROMO1",
            "C7orf59",
            "COX7B",
            "NDUFB1",
            "SDSL",
            "RALGAPA2",
            "MRPL52",
            "MYEOV2",
            "ZNHIT1",
            "LCOR",
            "MDP1",
            "POLE4",
            "FAM158A",
            "PSMB3",
            "BLOC1S1",
            "SIVA1",
            "ATP5G1",
            "TRAPPC5",
            "GADD45GIP1",
            "UQCR11",
            "RAD54L2",
            "SIK2",
            "MYO9A",
            "RBX1",
            "SOD1",
            "RPS19BP1",
            "ZFYVE19",
            "POLR2J",
            "ASXL2",
            "PLEKHM3",
            "MRPL53",
            "REST",
            "SF3B5",
            "JARID2",
            "PPCDC",
            "FAHD2A",
            "MRPL27",
            "OSGEP",
            "CISD3",
            "TRAM2",
            "ARID5B",
            "MYCBP2",
            "ASH1L",
            "CAMSAP1",
            "NDUFC1",
            "TGFBRAP1",
            "COMMD4",
            "ANKS1A",
            "BICD2",
            "ARL6IP4",
            "RNF169",
            "BCL2L11",
            "BOD1L",
            "KIAA2018",
            "SPEN",
            "ZNF407",
            "KIAA0240",
            "ATXN1L",
            "EP300",
            "BIRC6",
            "SETX",
            "SOS1",
            "USP34"
        ]
    },
    {
        "golabel": "HIVEP2_regulon_activity",
        "gene": [
            "GAS5",
            "TSHZ2",
            "C17orf61",
            "ETV2",
            "TMEM141",
            "DPM3",
            "BACH2",
            "AHNAK",
            "NUDT8",
            "LOC440957",
            "NCRNA00116",
            "C6orf204",
            "MYEOV2",
            "C6orf125",
            "ETS1",
            "SIRT4",
            "NUDT14",
            "SYNJ2",
            "NOTCH2",
            "NRL",
            "MRPS21",
            "C11orf31",
            "DDT",
            "PLEKHG1",
            "NDUFA7",
            "HDHD3",
            "CHCHD5",
            "AFAP1",
            "MRP63",
            "C22orf32",
            "SIPA1L1",
            "SVIL",
            "MACF1",
            "MRPL53",
            "C9orf23",
            "REST",
            "MMAB",
            "ZNRD1",
            "IGF2R",
            "POP5",
            "MRPL27",
            "MYH9",
            "FNDC3B",
            "LATS1",
            "OXSM",
            "SNX9",
            "NIN",
            "NCOA3",
            "PLEKHJ1",
            "SSH1",
            "ZNF691",
            "HECA",
            "ASCC3",
            "MLL",
            "BOD1L",
            "ABL2",
            "ITPRIPL2",
            "C19orf42",
            "ACTR1B",
            "EXOSC7",
            "PTPMT1",
            "ARID1B",
            "GLG1",
            "TAB2",
            "PICALM",
            "RRP8",
            "ZBTB2"
        ]
    },
    {
        "golabel": "HIVEP3_regulon_activity",
        "gene": [
            "IDO1",
            "PLA2G4A",
            "LGSN",
            "NCRNA00188",
            "CREB5",
            "GAS5",
            "ADSSL1",
            "EPHB2",
            "HCK",
            "RTN1",
            "ADAM19",
            "C14orf147",
            "SMPDL3B",
            "TIAM1",
            "P2RX7",
            "ITGAM",
            "HIST1H2BN",
            "BHLHE41",
            "HIST1H2AC",
            "SAMD9",
            "KRTCAP3",
            "CSF1",
            "AIM1",
            "TIAM2",
            "GPR39",
            "C14orf49",
            "SPN",
            "E2F5",
            "CLIP2",
            "CSF1R",
            "ITGAL",
            "CNTLN",
            "STARD10",
            "ITGB2",
            "RUNX3",
            "CSF2RB",
            "MAP7D3",
            "SNX20",
            "TLCD1",
            "DOCK2",
            "CIITA",
            "APOL3",
            "NCKAP1L",
            "PTP4A1",
            "MICAL3",
            "SLC15A3",
            "EBPL",
            "FBXO16",
            "LCP1",
            "BICD1",
            "IER3IP1",
            "GAB3",
            "MYO1F",
            "INPP5D",
            "C8orf55",
            "BAG1",
            "HSBP1L1",
            "DOCK10",
            "GSTP1",
            "SLFN11",
            "FLJ10357",
            "DOCK8",
            "KCNAB2",
            "SAMHD1",
            "SELPLG",
            "ZDHHC14",
            "CD4",
            "LCP2",
            "ARHGAP30",
            "WAS",
            "ACTN1",
            "SIRPA",
            "IDI1",
            "PYCR1",
            "IDS",
            "FLNA",
            "TBC1D1",
            "ARHGEF6",
            "TMOD2",
            "EPB41L2",
            "MCEE",
            "PCNXL2",
            "AFMID",
            "C15orf63",
            "C18orf32",
            "APOA1BP",
            "KIAA0922",
            "CLDN7",
            "FRMD4A",
            "RAB25",
            "SDC3",
            "ATP11C",
            "TMEM51",
            "CHMP1B",
            "C1orf43",
            "LOC645332",
            "STK10",
            "PCYOX1L",
            "C3orf33",
            "SFXN4",
            "NF2",
            "MACF1",
            "LASS2",
            "POLR1D",
            "SH2B3",
            "FMNL3",
            "PCBD1",
            "VAPA",
            "ELF4",
            "ATL2",
            "FAM18B",
            "TOMM20",
            "TSNAX",
            "FAM18B2",
            "ANKRD16",
            "BPNT1",
            "TFB2M",
            "ATP5A1",
            "MAP7D1",
            "KIAA0247",
            "GNL3",
            "ARFIP2",
            "MYO9B",
            "NUP88",
            "C1orf27",
            "SEC11A",
            "TMCO1",
            "WARS2",
            "FAM45A",
            "RAB18",
            "NDUFS2",
            "TMEM185A",
            "COG2",
            "TSG101",
            "PDHB",
            "GORASP2",
            "PEX13",
            "ARHGAP17",
            "PLEKHM2"
        ]
    },
    {
        "golabel": "HLF_regulon_activity",
        "gene": [
            "CPB2",
            "APOBEC2",
            "MEGF11",
            "HTR4",
            "MAP3K15",
            "CHIA",
            "LCT",
            "RXRG",
            "IRX6",
            "TMEM27",
            "F11",
            "SPRYD5",
            "HPGD",
            "PIGR",
            "MYBPHL",
            "GGTLC1",
            "HSD17B6",
            "C4BPA",
            "LOC400794",
            "LPPR1",
            "HAS3",
            "HOXD1",
            "SFTPA2",
            "HABP2",
            "SFTPA1",
            "LRRK2",
            "C16orf89",
            "PCDH20",
            "ARNT2",
            "SCTR",
            "PPP1R1B",
            "ACOXL",
            "CLEC4F",
            "PTPN13",
            "PLA2G4F",
            "CDKL2",
            "PTGER2",
            "FMO5",
            "COL4A3",
            "ATP13A4",
            "GGT3P",
            "KCNJ15",
            "C17orf50",
            "LOC644165",
            "ROS1",
            "RCAN2",
            "DLX3",
            "MAPK10",
            "RNF175",
            "ARHGAP20",
            "ZNF750",
            "ESYT3",
            "HPGDS",
            "C1orf130",
            "ANO5",
            "PCDP1",
            "MFSD2A",
            "LOC80054",
            "GPR116",
            "SHF",
            "OIP5",
            "NAPSA",
            "CMYA5",
            "TMEM37",
            "FAM184A",
            "NPC2",
            "CENPA",
            "TRIM16",
            "C1orf116",
            "SPHK1",
            "NHS",
            "TMPRSS2",
            "LMO3",
            "STK32A",
            "FOXM1",
            "CACNB1",
            "TPX2",
            "HMGA1",
            "SLC34A2",
            "SLC15A2",
            "KIF23",
            "KIF2C",
            "CDC20",
            "DOK4",
            "NFIX",
            "CDCA3",
            "LRP2BP",
            "NINJ2",
            "BUB1B",
            "LOC283070",
            "SNX30",
            "TLR2",
            "DEPDC6",
            "B3GNT8",
            "ST3GAL5",
            "CDCA5",
            "KCNK5",
            "SLC39A8",
            "LCA5",
            "PLK1",
            "SHROOM4",
            "SNX25",
            "CDC42EP1",
            "STXBP1",
            "HNF1B",
            "ATP11A",
            "PLCH1",
            "ZNF204P",
            "PRC1",
            "FNIP2",
            "SRGAP1",
            "C1orf21",
            "CISH",
            "NR3C2",
            "IL6R",
            "GALNT10",
            "SLAIN1",
            "ZNF238",
            "OCLN",
            "CYFIP2",
            "MTRR",
            "CYTSB",
            "FMO4",
            "MGLL",
            "NOD1",
            "MEF2C",
            "GPD1L",
            "FLJ90757",
            "BTBD9",
            "RAPGEF5",
            "N4BP2L1",
            "PPFIBP2",
            "TMEM173",
            "GGCX",
            "ACVR1B",
            "CCDC46",
            "ARHGDIB",
            "FAM117A",
            "SARM1",
            "TAPT1",
            "EHBP1",
            "CYP4V2",
            "B4GALT1",
            "UBE2E3",
            "STXBP4",
            "PLOD3",
            "C11orf24",
            "AKAP1",
            "MTMR2",
            "CXorf23",
            "DYNLL1",
            "GGA2",
            "CFL1"
        ]
    },
    {
        "golabel": "HLTF_regulon_activity",
        "gene": [
            "GABRQ",
            "C17orf104",
            "MED12L",
            "ZBTB8B",
            "SMC1B",
            "MGC2889",
            "NAT8L",
            "GPR156",
            "SEPT3",
            "KCNG3",
            "TSPAN1",
            "IGFBPL1",
            "HRASLS",
            "MPP2",
            "LOC728819",
            "ZNF280B",
            "COX4I2",
            "KLF2",
            "TSC22D2",
            "C1orf59",
            "MCM2",
            "MLF1",
            "TBC1D2",
            "C2orf52",
            "RHOBTB3",
            "EPB49",
            "SMC4",
            "ZC3HAV1L",
            "FAM161A",
            "SLC9A3R2",
            "IFITM2",
            "TOPBP1",
            "TFDP2",
            "TTC26",
            "PIAS2",
            "HOOK1",
            "TDRKH",
            "YEATS2",
            "GMPS",
            "CCDC21",
            "POT1",
            "RSRC1",
            "DDRGK1",
            "IQCB1",
            "PHTF2",
            "ATP2C1",
            "TRIM8",
            "BRAF",
            "NMD3",
            "TBCCD1",
            "SENP2",
            "OPA1",
            "CYB5R3",
            "HPS3",
            "BIN3",
            "DHX40",
            "SR140",
            "TMEM209",
            "MAP2K3",
            "MFN1",
            "GTF2E1",
            "ZMYM1",
            "SNX33",
            "C2orf44",
            "DHX36",
            "GFM1",
            "SRPK2",
            "C1orf109",
            "TOMM70A",
            "MOB2",
            "QTRTD1",
            "CHMP7",
            "ANXA11",
            "RNH1",
            "HPS6",
            "BET1L",
            "ARMC8"
        ]
    },
    {
        "golabel": "HMGA1_regulon_activity",
        "gene": [
            "MYH16",
            "TH",
            "FOSL1",
            "CDK6",
            "GPR115",
            "KIAA2022",
            "HLF",
            "IGF2BP2",
            "KCNA3",
            "CXCL17",
            "PNMA2",
            "MFSD2B",
            "ZMAT1",
            "CMAH",
            "FOXM1",
            "GPC4",
            "TPX2",
            "TUBB3",
            "KIF23",
            "KIF2C",
            "CDC20",
            "KIFC1",
            "LOC283070",
            "PLEKHH2",
            "BTG2",
            "SKA3",
            "PLK1",
            "LRFN4",
            "SMARCD3",
            "SLC22A15",
            "ARRDC3",
            "GNA14",
            "EFHA2",
            "CYFIP2",
            "FMO4",
            "NCRNA00182",
            "TP53INP1",
            "RPP40",
            "RALGPS1",
            "KLHDC1",
            "NIPSNAP3B",
            "TTLL12",
            "KIAA1609",
            "CLK4",
            "C5orf53",
            "SCAI",
            "DBN1",
            "YARS2",
            "TUBA1C",
            "NUDT3",
            "KAT2B",
            "CYP4V2",
            "ALS2CR8",
            "MRPS10",
            "ZNF441",
            "CLIC1",
            "CCDC86",
            "CPEB4",
            "HEATR2",
            "KIAA1370",
            "VARS",
            "TOMM34",
            "CCDC137",
            "SNRPC",
            "HDGF",
            "RDBP",
            "TXNDC15",
            "TPD52L2",
            "SRPK1",
            "RNF26",
            "RNF130",
            "EIF6",
            "FAM172A",
            "C6orf153",
            "PREPL",
            "RCE1",
            "EPM2AIP1",
            "REV1",
            "WRNIP1",
            "AP2A1",
            "CFL1",
            "CLCC1",
            "NRBP1",
            "CYP20A1",
            "RAB35"
        ]
    },
    {
        "golabel": "HMGB1_regulon_activity",
        "gene": [
            "DLEU2",
            "ZNF519",
            "C13orf37",
            "EAPP",
            "ATP5S",
            "TGDS",
            "TECPR1",
            "NIPSNAP3A",
            "EIF3K",
            "B3GALTL",
            "RAB11FIP3",
            "FICD",
            "CLIC1",
            "TPCN1",
            "SLC46A1",
            "C1D",
            "ARPC5",
            "MTMR6",
            "CLCN7",
            "RNASEH2B",
            "UBE2E1",
            "GOLGA3",
            "TAOK2",
            "NCDN",
            "TSC2",
            "STIM1",
            "PDS5B",
            "C11orf58",
            "TMEM104",
            "AP3D1",
            "PTMA",
            "CNBP",
            "SFRS3",
            "MED4",
            "SFRS7",
            "GOLGA1",
            "EIF4E2",
            "TXLNA"
        ]
    },
    {
        "golabel": "HMGB3_regulon_activity",
        "gene": [
            "CALCA",
            "CALCB",
            "CRYAA",
            "KLK12",
            "CHRNA9",
            "ASCL1",
            "PCP4",
            "LOC100190940",
            "FGL1",
            "CNGA3",
            "FOXI3",
            "ENO3",
            "LOC145837",
            "CRLF1",
            "PITX2",
            "C1orf95",
            "AKR7A3",
            "C20orf197",
            "HMGB3L1",
            "KCNMB4",
            "SYCP2L",
            "THPO",
            "SLC16A14",
            "DNAJC12",
            "BHLHA15",
            "GPR98",
            "CPE",
            "ERO1LB",
            "RNFT2",
            "DUSP4",
            "KIT",
            "SDK1",
            "BDKRB1",
            "ZNF710",
            "SH3RF2",
            "GPT2",
            "CXXC4",
            "EDARADD",
            "C2CD4D",
            "SYT7",
            "HPGDS",
            "GADD45G",
            "BDKRB2",
            "THEM5",
            "PITPNC1",
            "KREMEN1",
            "ANKRD22",
            "ITGB4",
            "PRKAA2",
            "C8orf4",
            "TTC39C",
            "C14orf147",
            "TIGD3",
            "PLCB1",
            "PAIP2B",
            "KSR1",
            "TLR2",
            "FOXA1",
            "SNHG6",
            "SCNN1A",
            "GYLTL1B",
            "OAT",
            "AIM1",
            "CHD7",
            "HLA-DRA",
            "PPP1R3B",
            "E2F5",
            "LPAR5",
            "HLA-DPA1",
            "TLR3",
            "LAPTM4B",
            "HLA-DPB1",
            "IL7",
            "GALNT3",
            "RIN1",
            "FXYD5",
            "IMPA2",
            "FZD3",
            "RPH3AL",
            "LGALS9",
            "THRB",
            "FAS",
            "ATP8B1",
            "IL18",
            "TPK1",
            "CD82",
            "ARHGAP31",
            "C1GALT1",
            "MAML2",
            "CASP1",
            "RELL1",
            "FMO4",
            "MGLL",
            "CD99L2",
            "VPS37A",
            "ANXA2P2",
            "BNIP3",
            "GKAP1",
            "MITF",
            "CD59",
            "FKBP3",
            "LOC653501",
            "MYL6B",
            "STAU2",
            "TRAF2",
            "APOBEC3C",
            "CHCHD7",
            "GNG12",
            "FRMD4B",
            "ZNF658",
            "CMTM7",
            "SNRPF",
            "KIAA0182",
            "MED13L",
            "MAP3K5",
            "HLA-E",
            "ARHGAP27",
            "MANF",
            "CCNJ",
            "HSP90B1",
            "TH1L",
            "C12orf44",
            "STAT5A",
            "ZBED1",
            "ALKBH8",
            "FDXACB1",
            "PTDSS2",
            "INTS8",
            "B3GNT1",
            "ZDHHC16",
            "TRAF3IP2",
            "LDLRAP1",
            "DDX55",
            "PARP4",
            "SUDS3",
            "RPS6KA1",
            "PHF20L1",
            "CDK5RAP1",
            "CRTAP",
            "PDCL3",
            "PAPOLA",
            "MOBKL2C",
            "SFRS9",
            "SLC35B1",
            "ANAPC7",
            "MAPKAPK5",
            "MORC3",
            "EIF2B1"
        ]
    },
    {
        "golabel": "HMGN2_regulon_activity",
        "gene": [
            "ZBTB8B",
            "LOC400759",
            "C19orf21",
            "STMN1",
            "SIP1",
            "CDKN2C",
            "MDK",
            "TCTEX1D2",
            "C3orf14",
            "ARHGAP26",
            "MLF1",
            "TMEM106C",
            "KIF13B",
            "HMGB2",
            "CFL2",
            "LAGE3",
            "PCDH1",
            "MAD2L2",
            "CENPQ",
            "EPAS1",
            "HPRT1",
            "ITGB3BP",
            "SIVA1",
            "INSR",
            "FKBP3",
            "RCC1",
            "SPATA13",
            "C15orf21",
            "AP4S1",
            "SLC25A33",
            "MRPL11",
            "PPIH",
            "IQCC",
            "PITPNM1",
            "CCDC23",
            "APITD1",
            "MYO18A",
            "ZNF138",
            "SUB1",
            "TUBA1B",
            "MAGOH",
            "RFC2",
            "KLHDC3",
            "FICD",
            "KIF22",
            "CETN3",
            "PEX3",
            "POLR2G",
            "PSME1",
            "OSGEP",
            "ZNF410",
            "RCC2",
            "MRTO4",
            "SUMO3",
            "ENO1",
            "ENTPD4",
            "PDE4A",
            "CHD3",
            "MIA3",
            "ZCCHC17",
            "MIIP",
            "C1orf151",
            "DOCK6",
            "SLBP",
            "HMGN1",
            "NCAPH2",
            "SDHB",
            "PARL",
            "CNNM2",
            "RPA2",
            "LSM6",
            "C1orf174",
            "C1orf172",
            "ERI3",
            "PSD4",
            "NUDC",
            "ADPRHL2",
            "SNRNP40",
            "EIF3I",
            "PARK7",
            "KATNA1",
            "H2AFV",
            "SUMO2",
            "MPHOSPH8",
            "MRPL20",
            "PSMB2",
            "TAF12",
            "UBE2J2",
            "DNAJC8",
            "TMEM39B",
            "FAF1",
            "CRTC3",
            "PEX14",
            "SSU72",
            "PNRC2",
            "C1orf128",
            "CAPZB",
            "C1orf144",
            "GPN2"
        ]
    },
    {
        "golabel": "HMGN3_regulon_activity",
        "gene": [
            "FLJ42875",
            "SCTR",
            "C5orf38",
            "GGT3P",
            "IRX2",
            "C17orf50",
            "LOC644165",
            "OVGP1",
            "PCDP1",
            "KRTAP5-9",
            "SDHAP3",
            "SELENBP1",
            "FAM184A",
            "PRR11",
            "CACNB1",
            "ZMYND12",
            "AK1",
            "ERO1L",
            "DAPK2",
            "ABCC6P2",
            "SFTA3",
            "GOLGA2B",
            "LOC91316",
            "GPR160",
            "TMEM91",
            "C22orf36",
            "NEIL1",
            "GOLGA6L9",
            "ACSS1",
            "GOLGA6L10",
            "TMEM125",
            "ZNF238",
            "C7orf23",
            "NKX2-1",
            "BICD1",
            "ABHD14A",
            "SNHG12",
            "PTPLB",
            "CHKA",
            "MAN2A1",
            "BRP44L",
            "ACTN1",
            "C11orf61",
            "ANKRD6",
            "CCDC84",
            "ELK3",
            "RASSF7",
            "TAOK1",
            "ECHDC2",
            "FAAH",
            "ARHGAP8",
            "JMJD7-PLA2G4B",
            "CCNT1",
            "MAPK6",
            "SBNO1",
            "LUC7L",
            "ITGB1",
            "CALU",
            "GTF2A1",
            "ASAP1",
            "LIMS1",
            "NEK8",
            "LNPEP",
            "MDM4",
            "WASH2P",
            "AVL9",
            "BCAT2",
            "ZSWIM7",
            "ROGDI",
            "LOC284900",
            "C10orf12",
            "VANGL1",
            "PPOX",
            "LUC7L3",
            "ADAM10",
            "PHIP",
            "PAFAH1B2",
            "SAMD8",
            "CYP2R1",
            "SETD7",
            "PJA1",
            "ANO6",
            "PCYT1A",
            "PLBD2",
            "RPS6KA1",
            "C6orf70",
            "PPP4R2",
            "RCOR3",
            "PAK2",
            "UBE2G2",
            "RSAD1",
            "REV1",
            "SIRT3",
            "TRA2A",
            "C1orf128",
            "TMEM184C"
        ]
    },
    {
        "golabel": "HMGN4_regulon_activity",
        "gene": [
            "XCL2",
            "CXCL10",
            "LOC400759",
            "CD48",
            "GZMA",
            "XCL1",
            "CD69",
            "PDCD1LG2",
            "CCL4",
            "EVI2A",
            "RPS3A",
            "CCL4L2",
            "RAP1B",
            "C12orf60",
            "PSMB9",
            "GPX7",
            "TAP1",
            "APOBEC3G",
            "TMC5",
            "IL15",
            "HAUS1",
            "HCP5",
            "TJP3",
            "SHANK2",
            "MYH14",
            "CENPQ",
            "PSMB8",
            "B2M",
            "GPR56",
            "DCK",
            "CELSR1",
            "CCDC90B",
            "KIAA1586",
            "KIAA1671",
            "ZNF585A",
            "NIPSNAP3A",
            "RAB3D",
            "GPN1",
            "MRPL39",
            "OSBPL2",
            "MAGED1",
            "TP53I11",
            "GLO1",
            "CLIC1",
            "CRBN",
            "ZNF383",
            "BCL6",
            "DTD1",
            "BAK1",
            "DNAJC5",
            "C3orf38",
            "C5orf44",
            "UBE2A",
            "IL10RB",
            "MIA3",
            "DPH3",
            "CYB561",
            "SEC16A",
            "DR1",
            "RAP2C",
            "CTTN",
            "NUP54",
            "TAF7",
            "GNPDA2",
            "SNX11",
            "ABT1",
            "TSC2",
            "GOLGA2",
            "OXNAD1",
            "OGG1",
            "MUTED",
            "EIF1B",
            "FRG1",
            "IRF2BP2",
            "ZNF652",
            "HDLBP",
            "DNAJC24",
            "STAT3",
            "MKRN2"
        ]
    },
    {
        "golabel": "HNF1A_regulon_activity",
        "gene": [
            "F2",
            "ANXA13",
            "A1CF",
            "RFX6",
            "GUCY2C",
            "AKR1C4",
            "UGT2B4",
            "PRAP1",
            "CELF3",
            "TM4SF5",
            "SLC39A5",
            "CDHR5",
            "NR1H4",
            "NPC1L1",
            "LGALS4",
            "EPS8L3",
            "RDH12",
            "GLTPD2",
            "FAM169B",
            "AAA1",
            "LOC100190940",
            "FGL1",
            "RIMBP2",
            "SLC7A9",
            "PIK3C2G",
            "XG",
            "ADH6",
            "PROC",
            "CDH17",
            "PDX1",
            "SPINK1",
            "RNF186",
            "LOC100240734",
            "TRIM15",
            "HNF4A",
            "ANKS4B",
            "TMED6",
            "GLYATL1",
            "MUC13",
            "TSPAN8",
            "BAIAP2L2",
            "C2orf72",
            "C5",
            "VIL1",
            "C12orf27",
            "GPX2",
            "HAVCR1",
            "HGD",
            "AKR7L",
            "KAAG1",
            "C12orf75",
            "TSPO2",
            "C10orf108",
            "F10",
            "TESC",
            "SGK2",
            "ABP1",
            "DNAJC12",
            "FOXA3",
            "LOC100130933",
            "LOC400043",
            "GRB14",
            "FA2H",
            "GPR35",
            "TRNP1",
            "BCMO1",
            "MIA2",
            "KIF12",
            "PBLD",
            "ATP2A3",
            "C8orf47",
            "GPT2",
            "RAMP1",
            "ARSE",
            "MAP2K6",
            "SEMA4G",
            "SCN8A",
            "HNF4G",
            "ANG",
            "MNX1",
            "GAL3ST1",
            "GLYCTK",
            "SLC34A2",
            "RNASE4",
            "ISG20",
            "SLC43A1",
            "GRHL1",
            "ICAM1",
            "LOC728855",
            "PLEKHA6",
            "SLC25A35",
            "LARGE",
            "VIM",
            "LOC151534",
            "BRI3BP",
            "CARD10",
            "ABHD3",
            "STK17A",
            "MXRA7",
            "OGFRL1",
            "KLHL25",
            "FLNA",
            "RNF144B",
            "MYOF",
            "SEPHS2",
            "ERBB3",
            "TSPAN4",
            "RAB31",
            "RAB40B",
            "C17orf28",
            "HIP1R",
            "CNN3",
            "AACS",
            "TDG",
            "FBRSL1",
            "LRP5",
            "MLEC",
            "PUS1",
            "C6orf136",
            "CD47",
            "HSP90B1",
            "SPRYD4",
            "BLVRA",
            "MSN",
            "SRC",
            "APPL2",
            "RUNX1",
            "PRR13",
            "SUDS3",
            "C6orf130",
            "SCLY",
            "RBM19",
            "ZYG11B"
        ]
    },
    {
        "golabel": "HNF1B_regulon_activity",
        "gene": [
            "IL1F7",
            "MAP3K15",
            "MST1P9",
            "BAMBI",
            "GGTLC1",
            "ELOVL4",
            "PRODH",
            "CEBPA",
            "ZDHHC8P1",
            "MMP12",
            "MST1P2",
            "SCTR",
            "GJB1",
            "LILRA3",
            "CDKL2",
            "HLF",
            "COL4A3",
            "KCND2",
            "ARSE",
            "TMEM163",
            "PLOD2",
            "RAP1GAP",
            "ACSM3",
            "OVGP1",
            "PCDP1",
            "GGTLC2",
            "CDKN3",
            "GAL3ST1",
            "NAPSA",
            "SLC2A5",
            "FAM149A",
            "CENPA",
            "MAD2L1",
            "C1orf116",
            "TMPRSS2",
            "PLLP",
            "TTK",
            "C12orf24",
            "DLGAP5",
            "TPX2",
            "COL4A4",
            "UNC5CL",
            "CENPW",
            "CDCA2",
            "DOK4",
            "PRR15L",
            "KIAA1524",
            "C11orf82",
            "CCNA2",
            "NCAPG",
            "MELK",
            "KIF4A",
            "SNAI1",
            "ST3GAL5",
            "CDCA5",
            "RUNX2",
            "EPDR1",
            "GPR160",
            "IL17RE",
            "TOB1",
            "FANCB",
            "C22orf36",
            "FAM83D",
            "ETV4",
            "DAPK1",
            "SLC16A5",
            "PLCH1",
            "ACSL5",
            "MTHFD2",
            "TMEM26",
            "ABCC3",
            "CHN1",
            "C14orf145",
            "RACGAP1",
            "EVPL",
            "CGN",
            "NR3C2",
            "AGPAT2",
            "CCND3",
            "TMEM133",
            "PYGB",
            "TCEA3",
            "ZNF69",
            "NKX2-1",
            "MMP15",
            "FBXO5",
            "SLC44A3",
            "MGLL",
            "PDE9A",
            "ITPR3",
            "ARSD",
            "FLJ90757",
            "CRYZ",
            "BTBD9",
            "CDKN2D",
            "IGSF3",
            "FGD6",
            "GNB4",
            "ERBB3",
            "ARHGAP8",
            "ACADS",
            "SAP30",
            "DDAH1",
            "ACVR1B",
            "LOC90110",
            "TBPL1",
            "PRKAB1",
            "TWSG1",
            "ASAP1",
            "TMEM63A",
            "NEK8",
            "TMEM63B",
            "LLGL2",
            "MARCKS",
            "FAM49B",
            "PRSS16",
            "C1orf198",
            "PDE8A",
            "CNKSR1",
            "DDR1",
            "SLC25A23",
            "RAP2A",
            "AKAP1",
            "SUOX",
            "C14orf118",
            "ACOX1",
            "YIPF3",
            "UBAC1",
            "AP2A2",
            "CNNM3"
        ]
    },
    {
        "golabel": "HNRNPK_regulon_activity",
        "gene": [
            "LOC728392",
            "SPNS3",
            "MUSTN1",
            "PABPC3",
            "BTBD19",
            "CSDC2",
            "CCDC88B",
            "TNFRSF14",
            "LRRC29",
            "EFEMP2",
            "C9orf40",
            "SMC2",
            "PAICS",
            "C21orf2",
            "CEP78",
            "ZFAND5",
            "C9orf30",
            "RMI1",
            "SGSM3",
            "HDAC10",
            "RAD18",
            "IPO5",
            "SLC12A4",
            "CCT3",
            "MRPL50",
            "DCAF12",
            "TEX10",
            "WDR43",
            "PLA2G15",
            "ISCA1P1",
            "C22orf25",
            "POFUT2",
            "PA2G4",
            "ZCCHC7",
            "PLAA",
            "NUFIP1",
            "DNAJA1",
            "RNF166",
            "DCAF10",
            "C9orf82",
            "EXOSC2",
            "TAF9",
            "IARS",
            "ABCE1",
            "C9orf80",
            "PRPF4",
            "UCHL5",
            "FAM108B1",
            "SET",
            "DARS",
            "ISCA1",
            "CRNKL1",
            "MRPS9",
            "NCBP1",
            "DIS3",
            "NAA35",
            "ANP32B",
            "FXN",
            "RAD23B",
            "UBE2R2",
            "FAM120A",
            "C9orf64",
            "HNRNPC",
            "HNRNPA1",
            "NOL8",
            "HNRNPA1L2",
            "HNRNPF",
            "RBM27",
            "PSMD5",
            "ERP44",
            "HIATL1",
            "SMU1",
            "TBRG1",
            "SPTLC1",
            "XRCC5",
            "CAPRIN1",
            "UBQLN1",
            "SPIN1",
            "VCP",
            "DHX9",
            "HNRNPH2",
            "PDCL",
            "FUBP3",
            "ECD",
            "KHDRBS1",
            "ZNF207"
        ]
    },
    {
        "golabel": "HNRNPR_regulon_activity",
        "gene": [
            "GUCY2D",
            "WBSCR26",
            "CLSPN",
            "HAGHL",
            "CASC5",
            "CENPF",
            "LTC4S",
            "MKI67",
            "CHADL",
            "SMARCD3",
            "N4BP2",
            "S1PR4",
            "SEPW1",
            "PPDPF",
            "ZNF596",
            "KIF20B",
            "MFSD7",
            "INCENP",
            "SPATA5",
            "C6orf1",
            "SMC2",
            "LOC401010",
            "TMEM150A",
            "RASA4P",
            "PRKDC",
            "CDK12",
            "RILP",
            "LAMC1",
            "FCGRT",
            "LOC341056",
            "SBNO1",
            "DPP7",
            "DDX21",
            "FIP1L1",
            "RIF1",
            "MSH6",
            "ZNF688",
            "SYNGR2",
            "C10orf12",
            "SMC3",
            "MED1",
            "HEMK1",
            "ABTB1",
            "ACBD4",
            "CKAP5",
            "NUP205",
            "PPM1M",
            "SUPT16H",
            "LRRC58",
            "TNFSF12",
            "SMC1A",
            "RSF1",
            "KIAA0090",
            "ANAPC1",
            "DIP2B",
            "KTN1",
            "FAM98B",
            "LMAN1",
            "RAB4B",
            "DEK",
            "KDM1A",
            "PSMD1",
            "SUZ12",
            "NUP153",
            "AFG3L2",
            "NAA15",
            "NOLC1",
            "PTPN11",
            "PSME4",
            "SENP1",
            "R3HDM1",
            "EIF3A",
            "ELMOD3",
            "KPNB1",
            "SSRP1",
            "MTOR",
            "GALT",
            "GPR108",
            "NCL",
            "SF3B3",
            "FUBP1",
            "DHX15",
            "RBM27",
            "PPIG",
            "ZFP91",
            "DDX46",
            "GNB1",
            "PRPF40A",
            "GMEB1",
            "DHX9",
            "FUBP3",
            "HNRNPU",
            "RBM12",
            "THRAP3",
            "KHDRBS1"
        ]
    },
    {
        "golabel": "HNRNPU_regulon_activity",
        "gene": [
            "LOC653786",
            "RGS13",
            "SPNS3",
            "CMTM2",
            "FPR1",
            "C10orf128",
            "HSPB2",
            "GLIPR2",
            "GMFG",
            "CACNA2D4",
            "ANP32E",
            "POU2F1",
            "NAALADL1",
            "NCF4",
            "LPAR6",
            "ICAM3",
            "LMCD1",
            "KIAA1598",
            "C9orf72",
            "PDLIM2",
            "ASL",
            "HOOK1",
            "MICA",
            "GSTK1",
            "NAGLU",
            "EIF5B",
            "ZNF146",
            "C22orf25",
            "C5orf51",
            "HDGF",
            "PLEKHA9",
            "TBC1D10A",
            "PARP1",
            "TOP1",
            "KDM5B",
            "SMARCC1",
            "GATAD2B",
            "PAPOLA",
            "THOC2",
            "NUCKS1",
            "HNRNPA3P1",
            "C17orf63",
            "BPTF",
            "MGAT1",
            "PPP3CC",
            "BAT2L2",
            "TOP1P1",
            "AATF",
            "UBAP2L",
            "AHCTF1",
            "PDS5A",
            "NOP58",
            "NAT10",
            "ADPGK",
            "IPO9",
            "NCL",
            "SF3B3",
            "ANP32A",
            "ILK",
            "FUS",
            "BMS1",
            "MSL3",
            "SFPQ",
            "ZNF638",
            "HNRNPR",
            "CWC22",
            "DHX9",
            "IWS1",
            "TARDBP"
        ]
    },
    {
        "golabel": "HOPX_regulon_activity",
        "gene": [
            "GKN2",
            "CHIA",
            "SCGB3A2",
            "SLC16A12",
            "PLA2G12B",
            "SYBU",
            "SFTA1P",
            "OIT3",
            "C16orf89",
            "ALOX15B",
            "SFTPB",
            "PON3",
            "AQP3",
            "MAOA",
            "SFTA2",
            "VAMP5",
            "NAPSA",
            "CYB5A",
            "RPS18",
            "PARM1",
            "NEDD9",
            "C1orf116",
            "CD55",
            "RHOBTB2",
            "LMO3",
            "MBIP",
            "CASC5",
            "C15orf42",
            "FOXM1",
            "ESPL1",
            "AK1",
            "POLQ",
            "KIF18B",
            "UCK2",
            "PRR15L",
            "NINJ2",
            "PIP5KL1",
            "SFTA3",
            "KIF4A",
            "ST3GAL5",
            "EPDR1",
            "PMM1",
            "MALL",
            "CLMN",
            "GPR39",
            "MEGF9",
            "GTSE1",
            "MGST1",
            "RFTN1",
            "GSG2",
            "ECHDC3",
            "ARRDC3",
            "SRGAP1",
            "CISH",
            "HSD17B11",
            "TXNDC17",
            "MICAL3",
            "TCEA3",
            "NKX2-1",
            "NCAPD2",
            "TIMELESS",
            "RPL10A",
            "ZKSCAN1",
            "INCENP",
            "TRAM1",
            "ACTN1",
            "VAMP8",
            "ADK",
            "PPT2",
            "MREG",
            "SLC25A16",
            "MAP4K4",
            "TMEM150A",
            "BTG3",
            "MPP7",
            "FCHO2",
            "SYNJ2",
            "UBTD1",
            "SHISA4",
            "PTGFRN",
            "C3orf18",
            "TCEAL1",
            "CNOT8",
            "ASAP1",
            "LNX2",
            "HSDL2",
            "CD47",
            "SLC25A4",
            "HAUS4",
            "STK17B",
            "FAM65A",
            "SEC14L1",
            "POLR2C",
            "CD46",
            "ZFAND5",
            "BLVRA",
            "VAPA",
            "TOM1L1",
            "ATL2",
            "SH3BP2",
            "AK2",
            "TMEM101",
            "SLC38A7",
            "STX10",
            "ASB3",
            "UBAP1",
            "TTC19",
            "BCKDHA",
            "GFOD2",
            "N6AMT1",
            "NKIRAS1",
            "SDCCAG8",
            "PCGF1",
            "NPRL2",
            "DALRD3",
            "PEX11B",
            "MLX",
            "MTERFD2",
            "INTS12",
            "SEC22C",
            "C16orf70",
            "SPOP"
        ]
    },
    {
        "golabel": "HSBP1_regulon_activity",
        "gene": [
            "SEC11C",
            "QPCT",
            "FUNDC2P2",
            "MRPS28",
            "GTF2A2",
            "NXT2",
            "EVPL",
            "MTCP1NB",
            "VDAC3",
            "COX7B",
            "HIGD1A",
            "FUNDC2",
            "LOH12CR2",
            "COX7A2",
            "PRDX4",
            "C7orf55",
            "SDR42E1",
            "GOLGA7",
            "PEX2",
            "C20orf196",
            "SMYD3",
            "C8orf40",
            "NOTCH3",
            "MYOF",
            "COMMD10",
            "PRIC285",
            "RNF213",
            "IMMP1L",
            "TSPAN6",
            "TRAPPC2L",
            "ACYP2",
            "COX4I1",
            "C18orf32",
            "COMMD3",
            "CNNM4",
            "N6AMT2",
            "COMMD1",
            "C4orf52",
            "TMEM208",
            "SELK",
            "APRT",
            "FAM96B",
            "C14orf167",
            "C2orf64",
            "HMHA1",
            "BCL9L",
            "C11orf51",
            "ASF1A",
            "CCDC23",
            "FAM104B",
            "APITD1",
            "UXT",
            "C16orf61",
            "NDUFA1",
            "MAPKBP1",
            "NOTCH1",
            "IFT46",
            "COPS5",
            "C15orf61",
            "ING4",
            "TMEM183A",
            "MANF",
            "LOC388789",
            "NDUFB3",
            "ERH",
            "SARNP",
            "TRIM14",
            "WDR61",
            "H3F3A",
            "LOC90784",
            "COMMD7",
            "SMURF1",
            "SPRYD4",
            "MAGED2",
            "CBL",
            "MPHOSPH6",
            "NCRNA00081",
            "HSDL1",
            "ARL3",
            "ALKBH8",
            "NDUFAB1",
            "SERP1",
            "COQ5",
            "EHBP1L1",
            "GTF2H5",
            "LMLN",
            "C12orf47",
            "PDF",
            "GABARAPL2",
            "MKKS",
            "METTL9",
            "SRP9",
            "SUCLG1",
            "NSL1",
            "MAST3",
            "C11orf10",
            "TP53RK",
            "SKP1",
            "NUTF2",
            "PEBP1",
            "UBE2N",
            "MAP1LC3B2",
            "COQ9",
            "SAP18",
            "NCOR2",
            "ATXN7",
            "COX16",
            "SIN3B",
            "EBAG9",
            "C20orf30",
            "MED15",
            "AKR7A2",
            "BCDIN3D",
            "FAM200B",
            "KIAA0226",
            "C1GALT1C1",
            "CHIC2",
            "AKTIP",
            "GMIP",
            "DIP2A",
            "MANBAL",
            "PARK7",
            "RBMX2",
            "DDX28",
            "MAP1LC3B",
            "ERGIC3",
            "NDFIP1",
            "UBB",
            "COX4NB",
            "TXNL4B",
            "TYK2",
            "PSMD7",
            "RNF216",
            "CIAPIN1",
            "C3orf75",
            "NAE1",
            "NDNL2",
            "CYTH1",
            "DEF8",
            "MAP4",
            "DNAJA2",
            "FRMD8",
            "C16orf80",
            "SUPT6H",
            "SDHAF2",
            "LCMT1",
            "FAM54B",
            "SIAH1",
            "MRFAP1L1",
            "THAP11"
        ]
    },
    {
        "golabel": "HSF1_regulon_activity",
        "gene": [
            "CPA3",
            "MS4A2",
            "ABCA6",
            "ADRB2",
            "LOC339524",
            "LSAMP",
            "BOP1",
            "RRS1",
            "RECQL4",
            "NDRG1",
            "SLC39A4",
            "NME1-NME2",
            "MTBP",
            "C8orf76",
            "SPARCL1",
            "TCEB1",
            "RASSF2",
            "PYCR1",
            "RORA",
            "EXOSC4",
            "F8",
            "LOC653501",
            "EIF2C2",
            "PABPC1",
            "MRPL12",
            "TIGD5",
            "CYP2U1",
            "PPP1R14B",
            "DVL1",
            "C8orf30A",
            "DIXDC1",
            "GPR172A",
            "TBC1D8B",
            "TUBG1",
            "GALC",
            "SHARPIN",
            "DTWD2",
            "SRM",
            "CCDC86",
            "MRPS2",
            "CHRAC1",
            "TBRG4",
            "HEATR2",
            "PUF60",
            "PTDSS2",
            "EIF3B",
            "ZC3H3",
            "GTF2IRD1",
            "RRP12",
            "NFATC3",
            "PTGES2",
            "MTM1",
            "SLC27A4",
            "SLC25A30",
            "TRAP1",
            "MAF1",
            "RRP9",
            "FAM172A",
            "GIT1",
            "SETDB2",
            "STIP1",
            "DDX56",
            "WDR74",
            "ZFX",
            "FCHSD2",
            "PMPCA",
            "WRNIP1",
            "KLHL20",
            "STK25",
            "COBRA1"
        ]
    },
    {
        "golabel": "HSF2BP_regulon_activity",
        "gene": [
            "PTGES",
            "RPL39L",
            "ABCA3",
            "OIP5",
            "CENPA",
            "LOC399815",
            "LOC654342",
            "SNX30",
            "BTG2",
            "CKS1B",
            "LOC541471",
            "ZP3",
            "CGNL1",
            "PLXNA2",
            "NAPSB",
            "NPM3",
            "CYFIP2",
            "CHAF1B",
            "PSMG3",
            "MAD2L2",
            "TMEM14B",
            "DPYSL2",
            "BOLA2",
            "TMEM173",
            "RANBP1",
            "C20orf24",
            "PPP1R13B",
            "CENPL",
            "CATSPER2P1",
            "DONSON",
            "PSMG1",
            "PPIL1",
            "ITGB1",
            "NUDT1",
            "TMEM206",
            "SNRPA1",
            "KAT2B",
            "ANKHD1-EIF4EBP3",
            "HMBS",
            "TRANK1",
            "BZW2",
            "PAIP1",
            "PSMD14",
            "LSM5",
            "C1orf122",
            "PPP4C",
            "TBRG4",
            "LRRC42",
            "PSMA2",
            "C7orf11",
            "CNO",
            "C7orf70",
            "CBX3",
            "ARID4A",
            "NISCH",
            "RDBP",
            "TSSC1",
            "FTSJ1",
            "C3orf1",
            "ASCC1",
            "DMXL1",
            "EIF2S2",
            "TTC4"
        ]
    },
    {
        "golabel": "HSF4_regulon_activity",
        "gene": [
            "TMEM89",
            "CALML6",
            "TUBB8",
            "KIAA1984",
            "CCDC154",
            "PRSS45",
            "PCP2",
            "LOC389791",
            "LCN12",
            "FAM183B",
            "PNPLA7",
            "SCNN1D",
            "C1orf223",
            "PAQR6",
            "ATHL1",
            "CYP2D7P1",
            "KRTAP5-8",
            "LOC150197",
            "DCST2",
            "LOC100128675",
            "C19orf36",
            "C17orf55",
            "C1orf228",
            "LOC619207",
            "SLC9A5",
            "NCRNA00105",
            "RHBDL1",
            "OR10AD1",
            "KRTAP5-9",
            "LOC391322",
            "MAMDC4",
            "SLC23A3",
            "KRTAP5-1",
            "PPIEL",
            "MYO15A",
            "FAM186A",
            "ADAMTS13",
            "C16orf3",
            "LOC100131434",
            "CES8",
            "CAPN12",
            "PRR5-ARHGAP8",
            "AGAP7",
            "SPACA4",
            "SLC24A5",
            "C9orf96",
            "NOXA1",
            "LOC100272228",
            "AMT",
            "NPFF",
            "FLJ45445",
            "C3orf47",
            "CRIPAK",
            "TBC1D3H",
            "POM121L10P",
            "WSB1",
            "C16orf79",
            "GOLGA8B",
            "EFCAB4A",
            "C8orf77",
            "LOC100272217",
            "PIP5KL1",
            "EME2",
            "FLJ45244",
            "GOLGA8A",
            "ANO9",
            "LOC80154",
            "C9orf163",
            "RPGRIP1",
            "GOLGA6L5",
            "NEAT1",
            "PCSK4",
            "NSUN5P1",
            "C14orf181",
            "NCRNA00204B",
            "C11orf35",
            "CPT1B",
            "FBXL8",
            "RNF207",
            "ATG16L2",
            "TSSK3",
            "ASB16",
            "TMEM91",
            "ANKRD9",
            "LOC100130015",
            "NSUN5P2",
            "FLJ10661",
            "PDXDC2",
            "NRBP2",
            "SPIRE2",
            "HEXDC",
            "MPP3",
            "DFNB59",
            "CSAD",
            "CHKB-CPT1B",
            "NEIL1",
            "SLC25A35",
            "GOLGA6L9",
            "AHSA2",
            "LOC146880",
            "CATSPER2",
            "ACCS",
            "TTLL3",
            "GOLGA6L10",
            "LOC646471",
            "FLJ43663",
            "ABCA7",
            "KIAA0895L",
            "ENGASE",
            "LOC401052",
            "HYI",
            "SHROOM1",
            "PPP1R3E",
            "LOC143666",
            "SLC26A1",
            "LOC440944",
            "MYL5",
            "ZNF692",
            "KIAA1530",
            "LOC100271722",
            "LRRC29",
            "BGLAP",
            "ME3",
            "C1orf63",
            "NPEPL1",
            "D2HGDH",
            "APBB3",
            "AP1G2",
            "LOC202781",
            "RASSF7",
            "ECHDC2",
            "NOL3",
            "LOC645676",
            "PRDXDD1P",
            "MZF1",
            "LOC285359",
            "JMJD7-PLA2G4B",
            "RAB17",
            "CCDC57",
            "LPIN3",
            "ZNF767",
            "ANKS3",
            "ACAP3",
            "ELMO3",
            "EXD3",
            "PAN2",
            "ACADVL",
            "NBR2",
            "PIGL",
            "SIGIRR",
            "SELO",
            "HOOK2",
            "TAF1C",
            "ENOSF1",
            "RPS10P7",
            "EPS8L2",
            "KIF2A",
            "C9orf37",
            "SH2B1",
            "DKFZP686I15217",
            "IFT27",
            "LOC284900",
            "CSNK2A1P",
            "FUK",
            "PPOX",
            "TRMU",
            "HEMK1",
            "HDAC10",
            "ACBD4",
            "LOC678655",
            "LRCH4",
            "BACH1",
            "TRADD",
            "RHOT2",
            "OGFOD2",
            "PHKG2",
            "POLM",
            "NAT6",
            "CYP2R1",
            "IL17RC",
            "PIK3CA",
            "QKI",
            "MRI1",
            "SETD6",
            "DR1",
            "DUSP28",
            "PRMT7",
            "PDDC1",
            "LMBR1",
            "PAK2",
            "G3BP1",
            "NADSYN1",
            "GNA13",
            "LMBR1L",
            "AGPS",
            "ZFYVE27",
            "TAB2",
            "GNAI3",
            "CDC27",
            "ACTR2",
            "YWHAB",
            "WDR82"
        ]
    },
    {
        "golabel": "HSFX2_regulon_activity",
        "gene": [
            "LOC158696",
            "LOC285593",
            "ZMAT1",
            "LOC100131434",
            "LDOC1",
            "EEF1B2",
            "LCAT",
            "C9orf45",
            "RAB40AL",
            "CROCC",
            "CROCCL2",
            "CNIH",
            "PNP",
            "TTC5",
            "EPB41L4A",
            "FLJ11235",
            "TUBGCP6",
            "IAH1",
            "KIAA0467",
            "LOC100129550",
            "TNK2",
            "C1orf43",
            "TCEAL6",
            "SFI1",
            "TMEM8B",
            "WDR12",
            "PRDX3",
            "TCEAL3",
            "ETFA",
            "BBS5",
            "TFB2M",
            "RPE",
            "UBE2E1",
            "ZC3H15",
            "GDI2",
            "EIF4A1",
            "USP20",
            "ANAPC2",
            "TMEM185A",
            "MECP2",
            "FAM35A",
            "C1orf55",
            "KIAA0892"
        ]
    },
    {
        "golabel": "HTATIP2_regulon_activity",
        "gene": [
            "AKR1B10",
            "ABCC2",
            "CBR1",
            "AKR1C2",
            "AKR1C1",
            "CBR3",
            "KYNU",
            "AKR1C3",
            "GPX2",
            "C21orf125",
            "S100P",
            "HGD",
            "PKD1L2",
            "PPP2R2C",
            "PTGR1",
            "NEIL3",
            "SLC16A4",
            "OSGIN1",
            "OPN3",
            "SRXN1",
            "AGPAT9",
            "TXNRD1",
            "PTPN13",
            "UGDH",
            "NQO1",
            "NMB",
            "CMBL",
            "TSKU",
            "COL21A1",
            "CTSL1",
            "C14orf72",
            "GCLM",
            "PIR",
            "NPAS1",
            "ME1",
            "PTPLA",
            "ADSSL1",
            "GABARAPL3",
            "TRIM16",
            "GULP1",
            "BZRAP1",
            "PGD",
            "GSR",
            "FLJ35776",
            "AGA",
            "BLVRB",
            "SEPX1",
            "ZNF660",
            "TXN",
            "MGST1",
            "GABARAPL1",
            "TALDO1",
            "SQSTM1",
            "CLYBL",
            "SPSB2",
            "RFK",
            "PRDX1",
            "TDP2",
            "C1orf97",
            "IDH1",
            "ZNF625",
            "C14orf149",
            "C5orf30",
            "C21orf57",
            "GSTP1",
            "SCCPDH",
            "SORD",
            "DERA",
            "MFF",
            "GLA",
            "AIFM2",
            "PPPDE2",
            "OTUD3",
            "RGL1",
            "TMEM17",
            "NLGN2",
            "TMEM173",
            "C20orf24",
            "LIX1L",
            "CCDC88C",
            "ACOT13",
            "FTHL3",
            "ATP8B2",
            "TKT",
            "FYN",
            "LOC100125556",
            "CTAGE5",
            "EGLN1",
            "KIAA1598",
            "C4orf52",
            "ABHD4",
            "TTLL11",
            "ZNF211",
            "PLCG1",
            "PTER",
            "DARS2",
            "PSMA3",
            "FTH1",
            "NDUFB3",
            "ETFB",
            "C16orf63",
            "FUCA2",
            "WSB2",
            "CABIN1",
            "KDM6B",
            "ACBD5",
            "S1PR2",
            "GHITM",
            "PRR13",
            "BLOC1S2",
            "TFG",
            "ZNF295",
            "MMADHC",
            "TMEM33",
            "RAB11A",
            "SKI",
            "UNC50",
            "PSMA1",
            "C2orf47",
            "ATIC",
            "PSMD7",
            "COPS7A",
            "OCIAD1",
            "BCL2L13",
            "NHEJ1",
            "TSG101",
            "ANXA7"
        ]
    },
    {
        "golabel": "HTATSF1_regulon_activity",
        "gene": [
            "SEPT3",
            "FGF13",
            "SPRY3",
            "RPS5",
            "LDOC1",
            "EEF1B2",
            "LOC100303728",
            "RPS6",
            "RPS16",
            "RPS14",
            "RPSA",
            "RPSAP58",
            "FKBP11",
            "RPL18A",
            "RPLP0",
            "RPL24",
            "TPT1",
            "RPL13A",
            "RPL29",
            "RPS9",
            "SMARCA1",
            "RPL10A",
            "RPL12",
            "RPL32",
            "RPL7A",
            "FAM127B",
            "RPS12",
            "RPL14",
            "F8A1",
            "CHD6",
            "POLR1D",
            "SLC9A6",
            "PHF6",
            "UPF3B",
            "CFDP1",
            "GDI1",
            "AIFM1",
            "TCEAL4",
            "DYNLL2",
            "THOC2",
            "FMR1",
            "ZNF326",
            "DALRD3",
            "ABCF1",
            "TMEM185A",
            "MECP2",
            "HNRNPUL2",
            "NKAP",
            "HNRNPH3",
            "HNRNPA2B1",
            "UBTF",
            "TARDBP"
        ]
    },
    {
        "golabel": "HTT_regulon_activity",
        "gene": [
            "RPL13AP6",
            "RPS21",
            "EAF2",
            "RPS16",
            "SNRPG",
            "RPL18A",
            "SNRPD2",
            "RPS19",
            "SLC26A1",
            "KIAA1530",
            "FGFRL1",
            "C20orf196",
            "CDC42BPG",
            "C5orf28",
            "C7orf36",
            "WHSC1",
            "PHF5A",
            "MTHFR",
            "UXT",
            "DGKQ",
            "ERH",
            "TIMM9",
            "SRPRB",
            "KIAA1109",
            "GAK",
            "WDR19",
            "NR2C2AP",
            "RGS12",
            "PIGH",
            "ANKS1A",
            "ANKRD49",
            "MOBKL1A",
            "YAF2",
            "DUSP11",
            "KIAA0232",
            "SPCS2",
            "USP22",
            "BOD1L",
            "TMEM216",
            "LETM1",
            "LOC653566",
            "KIAA0100",
            "TOR3A",
            "WDFY3",
            "C11orf46",
            "TBC1D14",
            "RFC1",
            "UBR4",
            "AGPAT3",
            "ZBTB49",
            "CTBP1",
            "FAM193A",
            "TADA2B",
            "RNF4",
            "ADD1",
            "BAP1"
        ]
    },
    {
        "golabel": "IKBKG_regulon_activity",
        "gene": [
            "G6PD",
            "RENBP",
            "C16orf79",
            "TREX2",
            "LDOC1",
            "NCRNA00204B",
            "THAP7",
            "BATF",
            "CCDC88B",
            "MICALL2",
            "CEMP1",
            "LRRC29",
            "LAGE3",
            "C14orf80",
            "FAM58A",
            "PLXNA3",
            "MTCP1",
            "FADS3",
            "FAM127B",
            "ANKS3",
            "ABCD1",
            "NAA10",
            "FAM122C",
            "CCM2",
            "HAUS7",
            "FAM50A",
            "SELO",
            "F8A1",
            "TMEM187",
            "ZGPAT",
            "RAB24",
            "KIAA0415",
            "SLC12A9",
            "FAM3A",
            "FAM127A",
            "TMEM175",
            "AMDHD2",
            "TREX1",
            "FASTK",
            "UBL4A",
            "C17orf56",
            "FAM122B",
            "IQSEC2",
            "IRAK1",
            "C7orf43",
            "DNASE1L1",
            "C7orf27",
            "RABEP2",
            "ZNF770",
            "TAZ",
            "FAM8A1",
            "TELO2",
            "OGFOD2",
            "SLC25A14",
            "OGFR",
            "SPSB3",
            "ACD",
            "LMF2",
            "NSUN5",
            "SIPA1",
            "GDI1",
            "SMARCC1",
            "NSDHL",
            "PEX16",
            "SLC10A3",
            "DGKZ",
            "GMCL1",
            "IDH3G",
            "FLYWCH1",
            "EIF4B",
            "ATG4B",
            "E4F1",
            "RNF166",
            "PIGN",
            "IRF3",
            "BCAP31",
            "CXorf40A",
            "MIER3",
            "RNF113A",
            "NARFL",
            "STX4",
            "BRMS1",
            "ANAPC2",
            "EMD",
            "VAC14",
            "CXorf40B",
            "TMEM185A",
            "SOCS5",
            "BMPR1A",
            "YTHDF3",
            "ATP6AP1",
            "SHOC2",
            "MAP3K11",
            "C1orf55",
            "NBAS",
            "C11orf68",
            "EPC2",
            "DCP1A",
            "APPL1",
            "ATAD1",
            "E2F4",
            "SP3"
        ]
    },
    {
        "golabel": "IKZF4_regulon_activity",
        "gene": [
            "C1orf95",
            "KLK11",
            "TSPAN11",
            "THPO",
            "SDCBP2",
            "GPR98",
            "ERO1LB",
            "NRXN3",
            "CACNA1D",
            "C19orf33",
            "CLIC6",
            "BZRAP1",
            "TLR9",
            "ALPK3",
            "KSR1",
            "ANXA2P1",
            "BCAR3",
            "RGAG4",
            "S100A16",
            "PPP1R3B",
            "ZC3H12D",
            "ATP11A",
            "PERP",
            "C4orf36",
            "UNC13B",
            "ZNF238",
            "NKX2-1",
            "ANXA2P2",
            "BTBD9",
            "RHOC",
            "FAM125B",
            "ANXA2",
            "SC4MOL",
            "ZNF37B",
            "PPP1R13B",
            "PGM2",
            "LRIG1",
            "NUAK2",
            "NOP10",
            "CCDC90B",
            "AP1S1",
            "MED13L",
            "DOCK1",
            "TNRC6C",
            "ZNF75D",
            "CHD6",
            "COQ10A",
            "ZBTB39",
            "PKM2",
            "C17orf68",
            "LOC100129034",
            "C12orf51",
            "LRRC42",
            "MLL2",
            "METTL5",
            "ZNF275",
            "SUOX",
            "MLL3",
            "RERE",
            "ATG2B",
            "ZNF445",
            "EBNA1BP2",
            "MMADHC",
            "CSRNP2",
            "C3orf1",
            "LDB1",
            "SMARCC2",
            "SETD5",
            "ELP4",
            "MDH1",
            "ZNF652",
            "SAMM50",
            "BCL2L13"
        ]
    },
    {
        "golabel": "IKZF5_regulon_activity",
        "gene": [
            "RGS13",
            "NCRNA00188",
            "GPAM",
            "RPS3A",
            "VASN",
            "A4GALT",
            "ACADSB",
            "PKMYT1",
            "RPS27",
            "DYSF",
            "C17orf44",
            "SLAIN1",
            "TACC3",
            "CD302",
            "SNHG8",
            "BMP1",
            "CDC42EP2",
            "PLEKHG3",
            "PEX2",
            "RPL10A",
            "ZDHHC2",
            "C14orf80",
            "PLXNA1",
            "TRAM1",
            "ACTN1",
            "TTYH3",
            "MREG",
            "SLC25A16",
            "FAM175A",
            "UBE2W",
            "MPP7",
            "ECE1",
            "RPS24",
            "ABCD1",
            "SFXN2",
            "GALNT2",
            "EIF3E",
            "INTS1",
            "RAB11FIP2",
            "LMNB2",
            "ANKRD46",
            "RRM2B",
            "ENPP4",
            "TMEM50B",
            "C1orf203",
            "ST14",
            "CCM2",
            "UBL3",
            "CHAF1A",
            "TMEM68",
            "LNX2",
            "HSDL2",
            "TRUB1",
            "KCTD5",
            "C8orf83",
            "MYLIP",
            "RBM42",
            "PLOD1",
            "C5orf41",
            "PLEKHA1",
            "VPS18",
            "STK17B",
            "ANKAR",
            "KLHDC2",
            "GALNS",
            "MAD1L1",
            "PI4K2B",
            "EHD1",
            "CRBN",
            "LASP1",
            "C10orf84",
            "BCAR1",
            "GAS2L1",
            "ZNF33B",
            "KLF16",
            "NCRNA00081",
            "C10orf118",
            "SGK3",
            "ARL3",
            "PDCD4",
            "OXR1",
            "SLC25A36",
            "MBLAC2",
            "FAM8A1",
            "ACADM",
            "ZNF250",
            "BBS10",
            "ZNF252",
            "C10orf32",
            "CPNE3",
            "MXI1",
            "TTC33",
            "PPARD",
            "SLC38A7",
            "HBP1",
            "PTAR1",
            "ZNF280D",
            "ZDHHC16",
            "NEK7",
            "LZTFL1",
            "RCHY1",
            "ANAPC16",
            "MAP7D1",
            "SIRT1",
            "YKT6",
            "PLEKHA9",
            "CUTC",
            "NACC1",
            "DPY19L4",
            "TRIM23",
            "RANGAP1",
            "DLGAP4",
            "MOV10",
            "AK3",
            "LMBRD1",
            "NSMCE4A",
            "WDSUB1",
            "KLHL8",
            "HCFC2",
            "RCOR3",
            "NKIRAS1",
            "FBXL3",
            "ZRANB2",
            "LYSMD3",
            "DBT",
            "ZNF25",
            "OGDH",
            "EPN1",
            "PCMTD1",
            "PCNP",
            "FBXO3",
            "UBA1",
            "SART1",
            "FBXO9",
            "NCOA4",
            "ZBTB6",
            "PCNXL3",
            "TRIM13",
            "GIN1",
            "SCAF1",
            "VAC14",
            "C2orf18",
            "APEX2",
            "RAVER1",
            "KIAA1704",
            "C11orf46",
            "FAM82B",
            "CDKN1B",
            "SNX5",
            "ZNF451",
            "SEPT9",
            "SOCS5",
            "NKIRAS2",
            "SACM1L",
            "C11orf58",
            "TBC1D10B",
            "C16orf57",
            "C5orf24",
            "RSBN1",
            "ING3",
            "TMEM104",
            "C10orf88",
            "BMPR1A",
            "SMAD4",
            "PAIP2",
            "DCTN4",
            "C9orf156",
            "FAM35B2",
            "FAM149B1",
            "FAM160B1",
            "GABPA",
            "ACP2",
            "CNP",
            "RUFY2",
            "YTHDF3",
            "NFE2L1",
            "EIF4EBP2",
            "THAP9",
            "FAM35A",
            "SHOC2",
            "DKFZp761E198",
            "MAP3K11",
            "AP2A1",
            "NHEJ1",
            "C10orf119",
            "AP1B1",
            "PPM1A",
            "MED4",
            "PAPOLG",
            "TBC1D12",
            "ATAD1",
            "PPP3CB",
            "SEC61A1",
            "FAM35B",
            "ABCF3",
            "WDR11",
            "TIAL1",
            "RAB8A",
            "C10orf28",
            "FAM175B",
            "C10orf76",
            "CREB1",
            "MATR3"
        ]
    },
    {
        "golabel": "ILF2_regulon_activity",
        "gene": [
            "C1orf182",
            "GALNT5",
            "LOC400931",
            "NUF2",
            "PSMA6",
            "SIP1",
            "CKS1B",
            "UBE2T",
            "AHNAK",
            "C15orf52",
            "LAPTM4B",
            "TMEM106C",
            "ECE2",
            "GPR89C",
            "C6orf129",
            "C8orf76",
            "TBC1D7",
            "ANP32E",
            "CD82",
            "C11orf63",
            "PFDN4",
            "DGKA",
            "PDCD2L",
            "LSM2",
            "RPP40",
            "RAN",
            "CENPL",
            "C5orf28",
            "SLC19A2",
            "EHD2",
            "BPHL",
            "SUV39H2",
            "HAX1",
            "PAK1IP1",
            "PPIL1",
            "PXMP2",
            "NIPSNAP1",
            "PSMB5",
            "UBA7",
            "NUDT3",
            "DARS2",
            "LIN9",
            "EEF1E1",
            "MAPKBP1",
            "PLXNB2",
            "TXNDC9",
            "C12orf73",
            "PTK2B",
            "SMARCA2",
            "COPS3",
            "SORBS3",
            "PAIP1",
            "TMEM183A",
            "ARHGAP27",
            "TBCE",
            "TOMM40L",
            "H3F3A",
            "RAE1",
            "SCFD1",
            "CHD1L",
            "CACYBP",
            "POLR1C",
            "APEX1",
            "RAD1",
            "DAB2IP",
            "EIF4A3",
            "TSEN15",
            "TSNAX",
            "VPS72",
            "ZBTB47",
            "SLC12A4",
            "SNRPE",
            "CCT3",
            "MRPL45",
            "SDHC",
            "FAM119A",
            "SRP9",
            "C1orf74",
            "TRIAP1",
            "ORC4L",
            "TFB2M",
            "NSL1",
            "ABR",
            "PIPSL",
            "SNRPC",
            "TBC1D2B",
            "RRN3P3",
            "HDGF",
            "YRDC",
            "PARP1",
            "C16orf87",
            "UMPS",
            "ZNF622",
            "ZNF669",
            "PCSK7",
            "RNF2",
            "TAF11",
            "ANKRD42",
            "PLEKHM1",
            "INTS7",
            "FH",
            "MORF4L2",
            "TIPRL",
            "C6orf153",
            "TADA1",
            "PDCL3",
            "DAP3",
            "NIF3L1",
            "PIGC",
            "TIMM17A",
            "TACO1",
            "EIF2B3",
            "ZBTB7A",
            "RBM8A",
            "UCHL5",
            "RRP15",
            "NOL7",
            "ABHD15",
            "SSR1",
            "NAE1",
            "TPM3",
            "POLR3C",
            "C1orf131",
            "WHAMM",
            "USP39",
            "GOLGA5",
            "EML3",
            "C1orf124",
            "HNRNPC",
            "NONO",
            "CSTF1",
            "PPP1R8",
            "TBRG1",
            "CDC73",
            "RFWD2",
            "RBM4",
            "RBMX",
            "HNRNPL"
        ]
    },
    {
        "golabel": "ILF3_regulon_activity",
        "gene": [
            "DLX1",
            "GPC2",
            "ATP2A1",
            "VAMP5",
            "EVI2A",
            "C19orf23",
            "DDX12",
            "FAM157A",
            "ADORA3",
            "PNN",
            "USP49",
            "LY96",
            "CELSR2",
            "CHTF18",
            "FNDC8",
            "CEP152",
            "CTSS",
            "CD59",
            "IFNGR1",
            "KRCC1",
            "POLE",
            "SAR1B",
            "ZNF696",
            "TMBIM1",
            "MR1",
            "DNMT1",
            "PQLC3",
            "ARL6IP5",
            "DHX34",
            "PFAS",
            "PCNT",
            "SMARCA4",
            "DOT1L",
            "GTPBP3",
            "MYBBP1A",
            "SNX3",
            "SFRS14",
            "ARPC5",
            "HEXB",
            "PTTG1IP",
            "EHMT2",
            "MAP1LC3B2",
            "AKAP8L",
            "C1GALT1C1",
            "KRI1",
            "ELOVL1",
            "SAMD1",
            "ZNF343",
            "MAPKSP1",
            "TANK",
            "MAP1LC3B",
            "RAB9A",
            "CMPK1",
            "PNRC1",
            "RAP1A",
            "SRRT",
            "SMPD4",
            "ZMYM3",
            "SFRS8",
            "FBXO8",
            "ARL2BP",
            "TNPO2",
            "COQ10B",
            "OSTF1",
            "PSPC1",
            "PPRC1",
            "USP36",
            "SYS1",
            "ATXN2L",
            "TMEM50A",
            "VAMP3",
            "STX12",
            "SAFB",
            "DHX30",
            "WDR33",
            "RBM14",
            "NRF1"
        ]
    },
    {
        "golabel": "INF2_regulon_activity",
        "gene": [
            "PSCA",
            "LOC100216001",
            "EPS8L3",
            "LRRC66",
            "BAIAP2L2",
            "C11orf9",
            "AMN",
            "LAMA3",
            "GJB3",
            "AIM1L",
            "SDCBP2",
            "ENTPD2",
            "SLCO4A1",
            "SEMA3B",
            "PLCD3",
            "AHNAK2",
            "GCOM1",
            "LPCAT4",
            "NPAS1",
            "ZFPM1",
            "PTK6",
            "NOXA1",
            "KRT7",
            "EPS8L1",
            "UNC13D",
            "C1orf170",
            "STYK1",
            "ALS2CL",
            "CARD11",
            "KRT19",
            "S100A16",
            "ANKRD9",
            "PLEKHN1",
            "RIN1",
            "MST1R",
            "MICALL2",
            "CLTB",
            "PLEC",
            "TNFRSF14",
            "CDC42EP2",
            "ACOT11",
            "OSBPL7",
            "C14orf80",
            "EFHD2",
            "AGRN",
            "NBEAL2",
            "BLMH",
            "TTLL12",
            "PKP3",
            "EXD3",
            "FAM38A",
            "C9orf167",
            "DVL1",
            "TCIRG1",
            "C16orf7",
            "SP4",
            "RDH13",
            "KIAA0284",
            "PXN",
            "DGKQ",
            "GLO1",
            "VAV2",
            "PHTF2",
            "GAK",
            "BCAR1",
            "PARP12",
            "RAD1",
            "FAM73B",
            "FBXW5",
            "ARRDC1",
            "TAF9B",
            "CCDC121",
            "KIAA1826",
            "NDOR1",
            "KIAA0649",
            "SOLH",
            "LMNA",
            "ITPK1",
            "OGFR",
            "FAM129B",
            "RPS6KA4",
            "PLCB3",
            "DHX40",
            "ZNF669",
            "MED15",
            "REEP4",
            "RNPEPL1",
            "CCDC117",
            "CDC42BPB",
            "PACS2",
            "TTC7A",
            "POLR2D",
            "AKT1",
            "MINK1",
            "NUP160",
            "SAPS1",
            "EPN1",
            "TNIP2",
            "MYO1C",
            "TNIP1",
            "NAP1L1",
            "RBBP4",
            "C9orf69",
            "STXBP2",
            "PPP2R4"
        ]
    },
    {
        "golabel": "ING4_regulon_activity",
        "gene": [
            "SEPP1",
            "LOC374443",
            "PMM1",
            "C12orf57",
            "PFDN5",
            "CCDC152",
            "METTL12",
            "C7orf59",
            "LOC100216545",
            "CD9",
            "HSD17B8",
            "FUNDC2",
            "LOH12CR2",
            "EMG1",
            "C7orf55",
            "TAS2R20",
            "C1orf63",
            "C18orf18",
            "C5orf45",
            "FLJ37453",
            "C12orf62",
            "HSBP1",
            "BLOC1S1",
            "MYOF",
            "LAMC1",
            "SRI",
            "ZNF32",
            "PHB2",
            "NUDT16L1",
            "C5orf54",
            "COMMD3",
            "RWDD2A",
            "TMEM50B",
            "ARL16",
            "PXMP2",
            "C2orf64",
            "CLIP1",
            "IFT46",
            "EIF4A2",
            "C22orf32",
            "C3orf71",
            "KLHDC2",
            "FAM195B",
            "AMZ2P1",
            "ZSWIM7",
            "COMMD7",
            "RPAIN",
            "CRBN",
            "SLK",
            "HEMK1",
            "LOC678655",
            "SNHG11",
            "TIA1",
            "TMEM128",
            "C12orf47",
            "HSPBAP1",
            "CCDC73",
            "HAGH",
            "ARMCX6",
            "NUBP2",
            "C12orf26",
            "HMGCL",
            "ATP2A2",
            "UBE2H",
            "ARL6IP4",
            "ACOT8",
            "ZNF691",
            "LOC729991",
            "TNPO3",
            "DUSP28",
            "FAM200B",
            "ZNF187",
            "NSMCE4A",
            "WBP1",
            "TRIP11",
            "ABL2",
            "RRP1B",
            "ZRANB2",
            "PATL1",
            "POM121C",
            "BAT2L2",
            "GIN1",
            "FXC1",
            "ZBED5",
            "ELMOD3",
            "COPS7A",
            "AATF",
            "CDKN1B",
            "C3orf75",
            "FAM76A",
            "TRIP12",
            "COQ7",
            "TMEM222",
            "NCL",
            "AP3D1",
            "PEF1",
            "HDLBP",
            "PICALM",
            "FAM54B",
            "BMS1",
            "ZC3H10",
            "MSL3",
            "HDAC3",
            "LASS5",
            "HNRNPD"
        ]
    },
    {
        "golabel": "ING5_regulon_activity",
        "gene": [
            "KIAA1984",
            "LENEP",
            "HAPLN2",
            "GREM1",
            "TFAP2E",
            "COL10A1",
            "INHBA",
            "FLRT1",
            "LOX",
            "TNFAIP6",
            "FAP",
            "POSTN",
            "VCAM1",
            "NOX4",
            "CRIPAK",
            "INPP4B",
            "PDLIM3",
            "B3GALNT1",
            "SPARC",
            "C5orf62",
            "C9orf45",
            "EIF5A2",
            "GPX8",
            "IL1RAP",
            "MMD",
            "NCEH1",
            "ENGASE",
            "PDGFC",
            "CABC1",
            "D2HGDH",
            "OGFRL1",
            "DGKD",
            "ANKMY1",
            "SGSM2",
            "SPRN",
            "JMJD7-PLA2G4B",
            "MAP1D",
            "PASK",
            "AFG3L1",
            "TPM4",
            "CAPN10",
            "CNTROB",
            "LUC7L3",
            "GYG1",
            "NEURL4",
            "ANXA5",
            "SEC24D",
            "ZBTB40",
            "ANKZF1",
            "UPF3A",
            "ATG4B",
            "USP40",
            "PEA15",
            "VAMP7",
            "RAC1",
            "SCLY",
            "ACIN1",
            "EXT2",
            "RBM33",
            "ORMDL1",
            "SEPT7",
            "STK25",
            "ZNF142",
            "DIS3L2",
            "WDR33"
        ]
    },
    {
        "golabel": "IRF2_regulon_activity",
        "gene": [
            "VILL",
            "SLC29A4",
            "MAST1",
            "ZNF695",
            "CCDC150",
            "BCL2L14",
            "EFR3B",
            "C16orf54",
            "C19orf26",
            "CD200R1",
            "CD40LG",
            "HLA-DOA",
            "PAQR8",
            "RTP4",
            "MAP6D1",
            "GPR3",
            "CD2",
            "HLA-DRA",
            "HLA-DPA1",
            "TLR3",
            "HLA-DPB1",
            "IL7",
            "APOBEC3G",
            "NFKBIL2",
            "CHTF18",
            "APOL3",
            "GIMAP7",
            "CD74",
            "ATAD3B",
            "HNMT",
            "CARD16",
            "CASP1",
            "GIMAP2",
            "FBXL18",
            "TMEM154",
            "TRIM22",
            "CTSS",
            "CARD6",
            "ARHGAP25",
            "CAD",
            "FLT3LG",
            "APOBEC3C",
            "BTN3A3",
            "C4orf32",
            "CYP4V2",
            "MYO19",
            "HLA-E",
            "CTSO",
            "BBS12",
            "IRGQ",
            "MAT2B",
            "SMG5",
            "CYLD",
            "LONP1",
            "PMS2",
            "MMAA",
            "NFKB1",
            "CDKN2AIP",
            "FBXO8",
            "CALCOCO2",
            "DCTD"
        ]
    },
    {
        "golabel": "IRF2BP1_regulon_activity",
        "gene": [
            "ZNF703",
            "C2CD4D",
            "VAX2",
            "MSR1",
            "PTPN22",
            "PTAFR",
            "MS4A6A",
            "PTPRO",
            "CLEC7A",
            "CD80",
            "MNDA",
            "MARCH1",
            "FPR3",
            "TLR4",
            "FAS",
            "ATP8B4",
            "HAVCR2",
            "CD86",
            "CCDC109B",
            "SLC31A2",
            "OGFRL1",
            "HS6ST1",
            "DAPP1",
            "LHFPL2",
            "FRAT2",
            "ZNF428",
            "CFLAR",
            "CNN3",
            "CLIP4",
            "SPATS2L",
            "GLTSCR1",
            "FBXO46",
            "DYRK1B",
            "ZNF768",
            "ATG4D",
            "LAP3",
            "ZNF628",
            "C19orf63",
            "SIX5",
            "MYPOP",
            "ARHGEF3",
            "PELP1",
            "RAP2C",
            "USP25",
            "ZNF267",
            "MFSD1",
            "DNAJB14",
            "MIER1",
            "ZNF574",
            "TBC1D23",
            "THAP4",
            "PPP5C",
            "HNRNPA0",
            "DIS3L2",
            "TTC15",
            "RNF220"
        ]
    },
    {
        "golabel": "IRF5_regulon_activity",
        "gene": [
            "COL25A1",
            "KCP",
            "SLC7A2",
            "KIAA1324",
            "ERO1LB",
            "STX1B",
            "ATG9B",
            "C1orf175",
            "CXXC4",
            "KCNJ11",
            "IRS2",
            "SORBS2",
            "PDE4D",
            "TTC39C",
            "C14orf147",
            "ALDH3A2",
            "FAM46A",
            "UNC13D",
            "SLC22A23",
            "FAM113B",
            "STARD3",
            "EPHA10",
            "PPP1R3B",
            "FZD3",
            "FCHO1",
            "MAPK11",
            "ATP8B1",
            "SPI1",
            "PHF17",
            "SMARCA1",
            "PLXNA1",
            "SMYD3",
            "HSD3B7",
            "FADS3",
            "FAAH2",
            "TRIM47",
            "METRNL",
            "LIMK1",
            "PDIA3",
            "RHBDF2",
            "PDIA3P",
            "CCM2",
            "MAML3",
            "ZNF620",
            "ARHGAP10",
            "TMEM51",
            "CHMP1B",
            "SH3BP1",
            "HSP90B1",
            "C2orf34",
            "AMDHD2",
            "EHD1",
            "VAT1",
            "FAM117B",
            "ELP3",
            "PARP12",
            "IQSEC2",
            "RAP2B",
            "ALDH7A1",
            "SH3BP2",
            "IKBKE",
            "TMEM106A",
            "GLT25D1",
            "TSC22D4",
            "ISOC1",
            "ADCK2",
            "KBTBD6",
            "KIAA1539",
            "PIGM",
            "SEC23B",
            "PAPD5",
            "ZSCAN2",
            "FASTKD5",
            "ZNF22",
            "CCDC90A",
            "PPPDE1",
            "TTC7A",
            "PIGN",
            "NARS",
            "CNST",
            "DBNL",
            "LARS",
            "ANP32A",
            "HCG18",
            "MBTPS1",
            "HNRNPA0",
            "STRADA",
            "GRB2"
        ]
    },
    {
        "golabel": "IRF7_regulon_activity",
        "gene": [
            "IFI6",
            "IFIT1",
            "ISG15",
            "IFI44L",
            "IFI27",
            "IFI44",
            "MX1",
            "RSAD2",
            "C1orf170",
            "C11orf35",
            "XAF1",
            "LY6E",
            "PLEKHN1",
            "MX2",
            "MGAT5",
            "IFI35",
            "USP18",
            "BST2",
            "LRDD",
            "ZNHIT2",
            "RASSF7",
            "DHX58",
            "TYMP",
            "PRIC285",
            "FBXO6",
            "FBXL6",
            "IFITM3",
            "PKP3",
            "HSH2D",
            "SBNO1",
            "HMHA1",
            "ATE1",
            "SCO2",
            "PARP10",
            "SIGIRR",
            "TCIRG1",
            "LGALS3BP",
            "ZNF341",
            "NHLRC2",
            "EPS8L2",
            "ASXL2",
            "TMC6",
            "TP53I13",
            "AMDHD2",
            "SLC25A22",
            "DAPK3",
            "C19orf66",
            "QTRT1",
            "IRF9",
            "OGFR",
            "C1orf35",
            "SSSCA1",
            "SF3A2",
            "TOR2A",
            "STT3B",
            "MIIP",
            "SIPA1",
            "PEX16",
            "C19orf22",
            "CCS",
            "RRP1",
            "DGKZ",
            "SIRT6",
            "GMCL1",
            "DPP8",
            "SLC39A13",
            "TCF12",
            "C17orf70",
            "IRF3",
            "DCAF15",
            "TGOLN2",
            "ATF2",
            "IREB2",
            "FAM108B1",
            "TSSC4",
            "RHOG",
            "FEM1B",
            "CCDC94",
            "PHRF1",
            "MOB2",
            "SIRT3",
            "USP8",
            "ZNF408",
            "SHISA5",
            "EML3",
            "PPP3R1",
            "ZNF148",
            "CAPN7",
            "UBE3A",
            "HECTD3",
            "UBQLN1",
            "SPIN1",
            "BCLAF1",
            "RIC8A"
        ]
    },
    {
        "golabel": "IRX3_regulon_activity",
        "gene": [
            "SLC14A2",
            "TMED6",
            "ENO3",
            "KIAA1984",
            "C16orf89",
            "CACNA2D2",
            "ERO1LB",
            "ATOH8",
            "EPHX1",
            "BNIPL",
            "PALM3",
            "SFTPB",
            "KLF15",
            "ANKRD29",
            "TMEM163",
            "TMEM108",
            "KCNJ11",
            "GPR133",
            "AQP3",
            "AXIN2",
            "IGF2BP2",
            "ANLN",
            "LDHD",
            "SELENBP1",
            "IRX5",
            "DEPDC1",
            "NDC80",
            "PRR11",
            "DIAPH3",
            "DEPDC1B",
            "TTK",
            "ALDH3A2",
            "DLGAP5",
            "TPX2",
            "KIF23",
            "SPC25",
            "KIAA1524",
            "CKAP2L",
            "C11orf82",
            "CCNA2",
            "SGOL1",
            "MELK",
            "BRIP1",
            "ESCO2",
            "NCAPH",
            "BUB1",
            "KIF4A",
            "CENPK",
            "CDCA5",
            "RRM2",
            "CDCA8",
            "GPRC5C",
            "FANCB",
            "KIF18A",
            "SGOL2",
            "RORC",
            "RFTN1",
            "DCXR",
            "ST6GALNAC4",
            "ZNF467",
            "FAM22A",
            "TMEM117",
            "STIL",
            "NCEH1",
            "BARD1",
            "TMEM48",
            "PLCXD2",
            "BICD1",
            "FANCI",
            "ABHD14A",
            "C6orf150",
            "NOL3",
            "PBXIP1",
            "PLSCR1",
            "MCM6",
            "TXNRD2",
            "ZWILCH",
            "C6orf167",
            "C6orf182",
            "FAM135A",
            "SNX7",
            "KDELC2",
            "ZBTB42",
            "MOAP1",
            "GAS8",
            "VAPA",
            "TBCCD1",
            "BACH1",
            "CDR2",
            "FBXW4",
            "ACAD10",
            "C1orf66",
            "UBA6",
            "VRK2",
            "AKTIP",
            "BIRC2",
            "PYCR2",
            "GNA13",
            "IRF2BP2",
            "DNAJB12"
        ]
    },
    {
        "golabel": "IRX5_regulon_activity",
        "gene": [
            "SLC14A2",
            "ENO3",
            "SCNN1B",
            "PALM3",
            "TMEM163",
            "TMEM108",
            "KCNJ11",
            "DAAM2",
            "IRX3",
            "OIP5",
            "PLBD1",
            "NDC80",
            "TTK",
            "KIF2C",
            "BACH2",
            "PLCH1",
            "PLXNA2",
            "ADA",
            "RFTN1",
            "TMEM117",
            "C18orf54",
            "ITPKB",
            "SNTB1",
            "BOK",
            "NKX2-1",
            "FANCI",
            "C13orf34",
            "PPP1R13B",
            "ZWILCH",
            "LOC100130093",
            "C6orf167",
            "RGS14",
            "C3orf18",
            "C15orf41",
            "MYLIP",
            "PPP2R5A",
            "TCTA",
            "BACH1",
            "MTHFD1L",
            "GLT25D1",
            "LACTB",
            "PRKCD",
            "AKTIP",
            "ALAD",
            "PYCR2",
            "RMND5B",
            "ZUFSP",
            "CALM3",
            "HAUS2",
            "SECISBP2"
        ]
    },
    {
        "golabel": "ITGB3BP_regulon_activity",
        "gene": [
            "CETN4P",
            "MT1F",
            "C12orf24",
            "MRPL21",
            "TCTEX1D2",
            "CENPK",
            "KHDC1",
            "C13orf27",
            "CDKL5",
            "ACYP1",
            "RFC4",
            "TTC32",
            "ACN9",
            "GEMIN8P4",
            "NUDT6",
            "RNASEH2A",
            "GLMN",
            "UQCRHL",
            "RPA3",
            "SGK223",
            "PPIAL4G",
            "COQ3",
            "ZNF684",
            "UQCRH",
            "NDUFB6",
            "C6orf162",
            "MTHFD2L",
            "MORN2",
            "MXD3",
            "C7orf36",
            "PSMG1",
            "PPIH",
            "ATP5J",
            "ATP5O",
            "SCNM1",
            "C11orf74",
            "NOTCH1",
            "SUB1",
            "TPRKB",
            "MRPL39",
            "BTF3L4",
            "DPY30",
            "MAGOH",
            "MRPL22",
            "FANCL",
            "C17orf75",
            "C7orf44",
            "HSPB11",
            "DPH5",
            "LSM5",
            "HMGN2",
            "MARCH8",
            "LOC100129034",
            "SNRPE",
            "PL-5283",
            "EFCAB7",
            "C1orf52",
            "METTL5",
            "C7orf11",
            "SLC25A14",
            "SSBP1",
            "LRP10",
            "TMEM69",
            "PPIE",
            "NCOR1",
            "MITD1",
            "C4orf27",
            "WDR81",
            "LRRC40",
            "PACRGL",
            "DGUOK",
            "TAF11",
            "EBNA1BP2",
            "MRPL37",
            "FAM200B",
            "ALG6",
            "C15orf39",
            "TJP1",
            "DUT",
            "VMA21",
            "RPF1",
            "LSM3",
            "ZCCHC4",
            "RBMX2",
            "RWDD3",
            "ZC3HC1",
            "EIF2B3",
            "WDFY3",
            "SUMO2",
            "MED8",
            "HK1",
            "MRPS18C",
            "EP300",
            "ABHD10",
            "MDH1",
            "DCTN1",
            "UTP11L",
            "ILKAP",
            "SFRS3",
            "SMG6",
            "PRPF38A",
            "STAT3",
            "GBF1",
            "SFRS7",
            "TTC4",
            "RAB28",
            "GIGYF2",
            "RBMX"
        ]
    },
    {
        "golabel": "JARID2_regulon_activity",
        "gene": [
            "TET1",
            "PON3",
            "BCL2L15",
            "WBSCR26",
            "SLC22A18AS",
            "VANGL2",
            "GLOD5",
            "OAZ3",
            "CHD7",
            "S100A13",
            "KIAA1549",
            "CKLF",
            "SRGAP1",
            "KDELR3",
            "TXNDC17",
            "ZNF697",
            "RBKS",
            "TMEM159",
            "VAMP8",
            "FBXO4",
            "C4orf33",
            "HSD3B7",
            "TSPAN3",
            "BET1",
            "MAP4K4",
            "LAMC1",
            "ZNF192",
            "PNPLA4",
            "ZNF618",
            "ASL",
            "ZKSCAN3",
            "EHBP1",
            "CRB3",
            "HCG11",
            "SPR",
            "E2F3",
            "TET3",
            "XPO5",
            "BLVRA",
            "MDC1",
            "IFNGR2",
            "CISD3",
            "ESF1",
            "C17orf85",
            "HMOX2",
            "ZNF8",
            "IL10RB",
            "FAM98B",
            "CCDC104",
            "EHMT2",
            "SMARCD1",
            "ANKS1A",
            "NUP153",
            "MIF4GD",
            "STK35",
            "HIVEP1",
            "MARCH2",
            "BRD3",
            "NCOA6",
            "ATG4A",
            "NCK2",
            "ZNF343",
            "BAT2",
            "STK38",
            "ABCF1",
            "KDM2B",
            "KIAA0317",
            "FAM168B",
            "MLX",
            "CDYL",
            "BCL7B",
            "BRD2",
            "TFCP2",
            "EXOC2",
            "TARDBP"
        ]
    },
    {
        "golabel": "JMJD1C_regulon_activity",
        "gene": [
            "SPAG4",
            "PTPRB",
            "ROMO1",
            "REEP3",
            "C7orf59",
            "POLR2I",
            "TIMM17B",
            "C2orf7",
            "LAGE3",
            "NDUFA11",
            "ZNHIT1",
            "C11orf83",
            "LCOR",
            "PSMB3",
            "NDUFB7",
            "ANAPC11",
            "TRAPPC5",
            "GADD45GIP1",
            "NAA10",
            "C11orf31",
            "RPP21",
            "C19orf70",
            "BCL7C",
            "NDUFS8",
            "POLR2J",
            "VCL",
            "SLK",
            "AURKAIP1",
            "ARF5",
            "DRAP1",
            "C10orf118",
            "PDCD4",
            "ERCC6",
            "ARID5B",
            "PPP4C",
            "COPE",
            "RNASEH2C",
            "CCDC6",
            "BCKDK",
            "HSD17B10",
            "SIRT1",
            "MYST4",
            "ARL6IP4",
            "NDUFS7",
            "RAPGEF2",
            "IDH3G",
            "TJP1",
            "BOD1L",
            "KIAA2018",
            "CXorf40A",
            "TMED9",
            "PTENP1",
            "SNRK",
            "CXorf40B",
            "FAM35B2",
            "FAM160B1",
            "SETX",
            "RUFY2",
            "EIF4EBP2",
            "SHOC2",
            "PTEN",
            "SON",
            "HERC4",
            "EPC2",
            "CSTF2T",
            "MEF2A",
            "TNKS2",
            "ZRANB1",
            "AP3M1",
            "WDR11",
            "WAPAL",
            "C10orf28"
        ]
    },
    {
        "golabel": "KAT2A_regulon_activity",
        "gene": [
            "RHBG",
            "UCN",
            "CCDC150",
            "ATP2A1",
            "FSCN2",
            "PVT1",
            "TMEM200A",
            "SNHG4",
            "PRKG1",
            "FAM69B",
            "KIFC2",
            "ANKRD13B",
            "DDX12",
            "TMEM184A",
            "RECQL4",
            "LOC642846",
            "SSPN",
            "MSRB3",
            "GDF9",
            "CHTF18",
            "NR1I3",
            "CDK14",
            "F2R",
            "SLMO1",
            "MORF4",
            "ZNF692",
            "RPL36A",
            "SNORD1C",
            "DAB2",
            "PPP2R3B",
            "DBF4B",
            "MITF",
            "CDK5RAP3",
            "DHRS11",
            "LOC388796",
            "ZMAT3",
            "LOC100130581",
            "GNG2",
            "CCBL1",
            "NT5C3L",
            "XRCC3",
            "TBKBP1",
            "B3GNTL1",
            "RCCD1",
            "PUS1",
            "SUZ12P",
            "MYO19",
            "PTCD1",
            "ZNF341",
            "TMEM120B",
            "LRRC45",
            "TUBG2",
            "TSEN2",
            "MRM1",
            "DHX34",
            "C17orf56",
            "TRMT1",
            "PLEKHH3",
            "GTPBP3",
            "LRRC14",
            "DUS1L",
            "RECQL5",
            "NLE1",
            "ANKRD16",
            "MBNL2",
            "CCDC137",
            "NAT9",
            "ARSB",
            "DDX55",
            "CCDC45",
            "POLG2",
            "RFNG",
            "TSEN54",
            "PARVA",
            "TMCO6",
            "GNAQ",
            "UBTD2",
            "CDK5RAP1",
            "MED24",
            "LITAF",
            "AARSD1",
            "C17orf70",
            "FBXL3",
            "NUP85",
            "ZNF845",
            "GTF2H4",
            "ACTR5",
            "LRRFIP1",
            "MEN1",
            "HGS",
            "RAP1A",
            "MSL1",
            "SRRT",
            "ELF1",
            "CAP1",
            "RSAD1",
            "BCS1L",
            "COASY",
            "STK25",
            "ERAL1",
            "SAP30BP",
            "COPS7B",
            "C10orf26",
            "VAMP3",
            "SMYD5",
            "TMUB2",
            "SH3GLB1",
            "EXOC7",
            "SUPT7L",
            "SLAIN2",
            "ATRIP",
            "SFRS2"
        ]
    },
    {
        "golabel": "KAT2B_regulon_activity",
        "gene": [
            "MACROD2",
            "HPDL",
            "CD96",
            "TPSD1",
            "RCOR2",
            "GRIN2D",
            "LRRK2",
            "BASP1",
            "RNFT2",
            "MDFI",
            "TEX9",
            "P2RY12",
            "TNIK",
            "GCNT4",
            "CBX2",
            "VAX2",
            "ABI3BP",
            "CYSLTR1",
            "PRR19",
            "HSF2BP",
            "MFSD2B",
            "C1orf190",
            "CD200R1",
            "RGS18",
            "HMGA1",
            "ETV1",
            "CDKL1",
            "SC65",
            "C10orf128",
            "CCR6",
            "C4orf12",
            "P2RY13",
            "FAT4",
            "SEPP1",
            "SLC39A8",
            "TLR7",
            "SNX25",
            "PIK3CG",
            "MNDA",
            "C15orf34",
            "FNIP2",
            "ECE2",
            "BYSL",
            "ANKRD44",
            "MTMR8",
            "TXNIP",
            "C16orf59",
            "ITGA4",
            "PAFAH1B3",
            "YDJC",
            "PRDM5",
            "MEF2C",
            "CELF2",
            "TMEM154",
            "NCRNA00182",
            "SLC25A10",
            "SARS2",
            "PYCR1",
            "DHCR7",
            "LOC401010",
            "TRIM22",
            "MARCKSL1",
            "ARHGEF6",
            "PDIA4",
            "JUP",
            "F8",
            "TOMM40",
            "C22orf27",
            "FCHO2",
            "HERC3",
            "RAB27A",
            "CAMK2D",
            "RAB11FIP2",
            "TGFBR2",
            "NR2F6",
            "PFDN2",
            "CSNK1E",
            "PPP1R14B",
            "FRMD4B",
            "PSMB5",
            "COL4A3BP",
            "SLC5A6",
            "MR1",
            "NOP2",
            "PIK3R1",
            "C5orf41",
            "GPR172A",
            "PTCD1",
            "SMARCA2",
            "CXorf42",
            "CTSO",
            "TGIF1",
            "LYST",
            "ZNF441",
            "GAB1",
            "ATAD3A",
            "RBM43",
            "CRBN",
            "EIF4E3",
            "MTX1",
            "FLAD1",
            "PXK",
            "LOC100132707",
            "PARP8",
            "CCT3",
            "GTF2IRD1",
            "RRP12",
            "ALG3",
            "PSMD4",
            "TMEM189",
            "ALG8",
            "FAM13B",
            "CHD9",
            "MTM1",
            "NOC2L",
            "HDGF",
            "PELP1",
            "ADRM1",
            "SF3B4",
            "FEM1C",
            "DDX27",
            "TRIM28",
            "MAZ",
            "POLK",
            "CYLD",
            "HCFC2",
            "SETDB2",
            "PIGU",
            "C16orf88",
            "ZNF25",
            "DPP3",
            "XPC",
            "DMXL1",
            "CREBL2",
            "CXorf38",
            "NFKB1",
            "NOL7",
            "NKIRAS2",
            "SMARCB1",
            "SACM1L",
            "PES1",
            "THAP4",
            "ZNF654",
            "NOL10",
            "WRNIP1",
            "NFS1",
            "TMEM110",
            "CENPC1",
            "GORASP2",
            "HELQ",
            "MORC3",
            "SEC22C",
            "PPP1R11",
            "PAPD4",
            "AZI2",
            "UBE2V1",
            "NGLY1",
            "MLH1",
            "EPS15"
        ]
    },
    {
        "golabel": "KDM2A_regulon_activity",
        "gene": [
            "NCRNA00188",
            "RSL24D1",
            "EEF1B2",
            "RPS14",
            "SPTBN2",
            "RPSAP58",
            "C6orf57",
            "RPL17",
            "LOC100271836",
            "HIGD1A",
            "TPT1",
            "NBPF10",
            "C9orf123",
            "NUDT6",
            "NAV2",
            "TRIO",
            "RPL10A",
            "SHANK2",
            "EXPH5",
            "HINT1",
            "C1orf57",
            "RNF213",
            "EVC2",
            "MAP3K9",
            "TCEAL1",
            "BCL9L",
            "ATP5O",
            "UBL7",
            "RPL15",
            "KIAA0467",
            "GNB2L1",
            "NHP2",
            "CEP250",
            "PARP14",
            "C1D",
            "KIAA1731",
            "C17orf48",
            "PAPD7",
            "EHBP1L1",
            "GABARAPL2",
            "MLL2",
            "ARPC5",
            "RSF1",
            "ZNF70",
            "SKP1",
            "CEP164",
            "PACS1",
            "BTF3",
            "STAT2",
            "JRKL",
            "EP400",
            "MLL",
            "NFRKB",
            "BAZ2A",
            "RBAK",
            "FARS2",
            "NUMA1",
            "SPEN",
            "GABARAP",
            "SPCS1",
            "C3orf10",
            "PCNXL3",
            "NDFIP1",
            "IGHMBP2",
            "PPFIA1",
            "EIF1B",
            "MARK2",
            "CELF1",
            "PHF12",
            "ATXN10",
            "DDX42",
            "EIF1AD",
            "SF3B2",
            "ZDHHC5",
            "RELA"
        ]
    },
    {
        "golabel": "KDM2B_regulon_activity",
        "gene": [
            "ZIC1",
            "MSI1",
            "HYMAI",
            "RAB39B",
            "WBSCR26",
            "SMO",
            "SDR16C5",
            "MCART6",
            "ITPRIPL1",
            "S100A6",
            "FAM171A1",
            "PGBD1",
            "LOC642846",
            "TMEM92",
            "MPZL2",
            "ABCC3",
            "ARID3B",
            "ADORA2B",
            "RBM38",
            "LAD1",
            "TXNDC17",
            "LOC338758",
            "KNTC1",
            "PON2",
            "TMEM159",
            "MAL2",
            "SC4MOL",
            "TTC7B",
            "ZDHHC9",
            "CBFA2T2",
            "SYNGAP1",
            "PDE7A",
            "FAM86D",
            "CLDN12",
            "PLCG1",
            "PRKX",
            "ZSCAN5A",
            "SPR",
            "JARID2",
            "TOM1L1",
            "SEMA4D",
            "CAPN2",
            "CEP135",
            "CRY1",
            "PTTG1IP",
            "SMARCD1",
            "EP400",
            "PPP3CA",
            "CHFR",
            "STK4",
            "ATP6V0A2",
            "SART3"
        ]
    },
    {
        "golabel": "KDM4B_regulon_activity",
        "gene": [
            "GULP1",
            "ACTR3C",
            "PLXNA3",
            "C2orf28",
            "C4orf52",
            "SBNO2",
            "ZSWIM4",
            "IQCE",
            "LYPLAL1",
            "ATPBD4",
            "RAI1",
            "SEMA4C",
            "DOT1L",
            "C16orf63",
            "GTF2H5",
            "NCKAP5L",
            "ADH5",
            "TCF3",
            "SUCLG1",
            "NSL1",
            "LRRC28",
            "SDHD",
            "CIC",
            "TATDN3",
            "EIF1AX",
            "SIN3B",
            "MLLT1",
            "MIER2",
            "ARHGEF18",
            "ASCC1",
            "C15orf40",
            "ZNF653",
            "HDGFRP2",
            "TYK2",
            "OCIAD1",
            "PIP5K1C",
            "CSNK1G2",
            "VPS37C",
            "AP3D1",
            "C19orf29",
            "FZR1",
            "ZDHHC6",
            "ELL",
            "PHF21A",
            "MAP2K7",
            "BRPF1",
            "ANXA7",
            "HADHB",
            "RANBP3"
        ]
    },
    {
        "golabel": "KDM5B_regulon_activity",
        "gene": [
            "APOC1",
            "CD48",
            "MEX3A",
            "TSPAN32",
            "CLEC10A",
            "TMEM150B",
            "LAT",
            "PTPRCAP",
            "MIR155HG",
            "C1QB",
            "PSMB9",
            "TBC1D10C",
            "ZNF217",
            "FCGR1B",
            "HCST",
            "C1QA",
            "LOC606724",
            "PSTPIP1",
            "CD72",
            "DOK2",
            "APOBEC3G",
            "IL15",
            "XPR1",
            "HLA-F",
            "GIMAP5",
            "MPP1",
            "GMFG",
            "SUSD3",
            "TRPV2",
            "HLA-H",
            "IFI30",
            "NR1H3",
            "SLC31A2",
            "STAC3",
            "ZNF610",
            "RAC2",
            "BRI3",
            "NOTCH3",
            "COTL1",
            "ZNF281",
            "SOX4",
            "BCL9",
            "GPR125",
            "GSTK1",
            "ASH1L",
            "SLC35D2",
            "ZNF532",
            "ARRB2",
            "GON4L",
            "SMARCC1",
            "CCDC53",
            "F11R",
            "COPA",
            "RNF166",
            "IVNS1ABP",
            "ZBTB41",
            "SBDSP1",
            "RPS6KC1",
            "CAMSAP1L1",
            "DCAF6",
            "ADNP",
            "ZC3H11A",
            "TPR",
            "POGK",
            "TP53BP2",
            "FAM20B",
            "CEP350",
            "ARID4B",
            "SH3BP5L",
            "MPZL1",
            "PRRC1",
            "NUP133",
            "STX6",
            "SMG7",
            "TROVE2",
            "DHX9",
            "SEC31A",
            "WDR26",
            "HNRNPU",
            "AMMECR1L"
        ]
    },
    {
        "golabel": "KHSRP_regulon_activity",
        "gene": [
            "SEPT3",
            "CYP39A1",
            "GPR161",
            "LOC441208",
            "LRRC70",
            "C4orf33",
            "ATP8B5P",
            "SLC38A6",
            "CHAF1A",
            "SMARCA4",
            "CLK1",
            "GNA12",
            "SLC25A20",
            "C9orf95",
            "CD3EAP",
            "TCF3",
            "HMGCL",
            "MPPE1",
            "NACC1",
            "RPTOR",
            "C2orf67",
            "PAFAH2",
            "COQ6",
            "C15orf40",
            "BAT2",
            "SH3GL1",
            "GIN1",
            "BRD4",
            "CHERP",
            "TM2D3",
            "PIAS4",
            "FAM54B",
            "CIZ1",
            "SAP130",
            "HNRNPUL1",
            "MRFAP1L1",
            "ELAVL1"
        ]
    },
    {
        "golabel": "KIAA1549_regulon_activity",
        "gene": [
            "C6orf176",
            "LOC441177",
            "SMOC1",
            "HES6",
            "CABYR",
            "TTLL7",
            "PPARGC1A",
            "ATP6V0A4",
            "SLC16A14",
            "CCL13",
            "AIM2",
            "MCF2L",
            "S100B",
            "MYO1G",
            "DUSP4",
            "KIT",
            "ATP2A3",
            "GPR110",
            "GPT2",
            "CBX2",
            "CXXC4",
            "C12orf34",
            "PDLIM4",
            "IRS2",
            "TIPARP",
            "HPGDS",
            "DPP4",
            "MARK1",
            "EFCAB4B",
            "LAYN",
            "CX3CL1",
            "SHC3",
            "TREM2",
            "LST1",
            "CLEC5A",
            "PRKAA2",
            "CLEC4A",
            "SNX21",
            "PTPN22",
            "C21orf67",
            "FAM176A",
            "SLC34A2",
            "ATP10A",
            "PLCB1",
            "ALOX5AP",
            "NRARP",
            "HLA-DRB1",
            "UPP1",
            "PAIP2B",
            "MS4A6A",
            "KSR1",
            "TLR2",
            "TYROBP",
            "FAM20A",
            "LY86",
            "LY6E",
            "IFI27L2",
            "HLA-DMB",
            "EMB",
            "CD80",
            "HCST",
            "C17orf60",
            "C1orf115",
            "HLA-DRA",
            "CDC42EP1",
            "MNDA",
            "RAP1GAP2",
            "C5orf62",
            "CD33",
            "HLA-DPA1",
            "HLA-DPB1",
            "PANK1",
            "FXYD5",
            "PPP2R1B",
            "TNFRSF12A",
            "S100A13",
            "TNFAIP8L2",
            "IGF1R",
            "SAMD4A",
            "AIF1",
            "GMFG",
            "SRGAP1",
            "EMP3",
            "FAS",
            "HAVCR2",
            "C1orf162",
            "RAB38",
            "FCGR2A",
            "ABLIM1",
            "CD74",
            "HLA-DMA",
            "DPYD",
            "ENDOD1",
            "CCDC109B",
            "CD40",
            "LAT2",
            "RGS10",
            "IL27RA",
            "CASP1",
            "CD44",
            "SMARCA1",
            "KIF21A",
            "PHLDA3",
            "NCF4",
            "MAP7",
            "STK17A",
            "RBKS",
            "SH3BGRL3",
            "PSMB10",
            "VAMP8",
            "LGALS3",
            "SOCS7",
            "GPX1",
            "ADK",
            "RAC2",
            "KLHL25",
            "FAM83G",
            "TBL1X",
            "HRH1",
            "FHOD1",
            "CAPG",
            "AGAP1",
            "FRAT2",
            "SPRED1",
            "SDC4",
            "TMTC4",
            "GNA15",
            "KCTD3",
            "ARHGDIB",
            "DNMT3A",
            "CAMK1",
            "PHF16",
            "KIAA1598",
            "ZFYVE9",
            "CMTM4",
            "ZNF618",
            "C13orf23",
            "ZFHX3",
            "MSI2",
            "DHTKD1",
            "TRAPPC9",
            "MED13L",
            "DNAJC10",
            "CASP4",
            "LRP5",
            "MAPKAPK3",
            "CD47",
            "IFIT5",
            "ICK",
            "BEND3",
            "ZBTB39",
            "ARL6IP5",
            "JARID2",
            "PFAS",
            "TRIM37",
            "SFXN3",
            "HSDL1",
            "ZBED1",
            "PPM1M",
            "SUMO3",
            "ANKRD52",
            "PARP3",
            "CNN2",
            "MFSD9",
            "STRBP",
            "RMND5A",
            "TBC1D10A",
            "AFG3L2",
            "ZSCAN2",
            "EIF2AK3",
            "OAZ1",
            "SUDS3",
            "NCOA6",
            "NECAP2",
            "TRAF3IP1",
            "KIF3B",
            "GNAI2",
            "REPS1",
            "FAM108B1",
            "FAM168B",
            "FXR2",
            "ZSCAN29",
            "ALS2",
            "TFCP2",
            "SEC22C"
        ]
    },
    {
        "golabel": "KIAA2018_regulon_activity",
        "gene": [
            "TAS2R3",
            "NCRNA00152",
            "LOC541471",
            "ATP5J2",
            "C12orf57",
            "CHCHD2",
            "ROMO1",
            "RNF168",
            "FUNDC2",
            "C2orf7",
            "MRPL52",
            "HIPK2",
            "MYEOV2",
            "TMEM160",
            "DZIP3",
            "MRPS15",
            "NQO2",
            "NDUFB7",
            "UBXN7",
            "GADD45GIP1",
            "MTP18",
            "NAA10",
            "C11orf31",
            "MYO9A",
            "FAM96B",
            "RBX1",
            "ATP5L",
            "PQBP1",
            "CP110",
            "LOC100129550",
            "NDUFB2",
            "NDUFS8",
            "C19orf53",
            "ATP6V1F",
            "CRYBG3",
            "SF3B5",
            "THAP3",
            "AURKAIP1",
            "KIAA1109",
            "NDUFA6",
            "ASNA1",
            "LSM10",
            "CDK5",
            "TFB1M",
            "NDUFB8",
            "COX8A",
            "DHFRL1",
            "ZNF37A",
            "C11orf59",
            "HERC1",
            "MLL3",
            "GOLGA4",
            "LOC646214",
            "CBLB",
            "MYST4",
            "COMMD4",
            "ARL2",
            "ZNF622",
            "PHC3",
            "HIPK1",
            "KIAA0226",
            "HIVEP1",
            "NDUFS3",
            "ATRX",
            "JMJD1C",
            "DLG1",
            "XRN1",
            "KIAA2026",
            "TNRC6B",
            "AFF1",
            "AUP1",
            "ATR",
            "SPEN",
            "BPTF",
            "GOLGB1",
            "DNAJC13",
            "GSK3B",
            "RANBP2",
            "NSD1",
            "BIRC6",
            "PIKFYVE",
            "PFN1",
            "QTRTD1",
            "ZNF654",
            "SETX",
            "PIK3R4",
            "MSL2",
            "SON",
            "FBXW2",
            "ZXDC",
            "ZNF148",
            "SETD2"
        ]
    },
    {
        "golabel": "KLF11_regulon_activity",
        "gene": [
            "TCAM1P",
            "SGEF",
            "C19orf21",
            "ZNF829",
            "ISG20",
            "MFSD3",
            "STARD10",
            "PER3",
            "KIAA0114",
            "ANKRD44",
            "FKBP2",
            "HIP1",
            "ZNF568",
            "SDF2L1",
            "PPIB",
            "SERF2",
            "LOC442454",
            "NOTCH2",
            "C15orf63",
            "PDIA3",
            "MRPL23",
            "TMEM208",
            "NDUFA7",
            "PDIA3P",
            "C19orf10",
            "TDRKH",
            "ZNF570",
            "CD47",
            "ADAM17",
            "MANF",
            "RPLP2",
            "PRKCE",
            "HRAS",
            "UQCRB",
            "VAT1",
            "ATF4",
            "MPDU1",
            "SELS",
            "KIAA1107",
            "DNAJC1",
            "TIMM13",
            "SYNJ1",
            "SEC61B",
            "RRAGC",
            "COQ9",
            "RLF",
            "SIRT6",
            "ARFIP2",
            "USP25",
            "KIAA0355",
            "TULP4",
            "RNF38",
            "WDR73",
            "PIH1D1",
            "VEZF1",
            "ZYG11B",
            "ANKRD40"
        ]
    },
    {
        "golabel": "KLF12_regulon_activity",
        "gene": [
            "BEND4",
            "ADAMTS15",
            "CDK5R1",
            "MAGIX",
            "COMTD1",
            "KRTCAP3",
            "NUDT8",
            "TCF4",
            "FAM195A",
            "SPSB2",
            "TIMM17B",
            "C7orf47",
            "RAG1AP1",
            "ZNHIT1",
            "ETS1",
            "NOL3",
            "SEPHS2",
            "MPDZ",
            "EBP",
            "GALE",
            "EPB41L2",
            "CATSPER2P1",
            "PSIP1",
            "GNG2",
            "MRPL24",
            "SPR",
            "ZFYVE19",
            "POLR2J",
            "KATNAL1",
            "CHCHD8",
            "FMNL3",
            "NMT2",
            "MRPS34",
            "TRAP1",
            "C14orf135",
            "LSM11",
            "RNF38",
            "SEPT8",
            "SETX",
            "WDR82"
        ]
    },
    {
        "golabel": "KLF13_regulon_activity",
        "gene": [
            "MGAT3",
            "DDIT3",
            "C6orf59",
            "MRPL21",
            "ZNF366",
            "CBX6",
            "ROMO1",
            "LAGE3",
            "NME1",
            "FAM158A",
            "PSMB3",
            "AKAP13",
            "PSMC1",
            "GEMIN6",
            "BOLA3",
            "ANAPC11",
            "NT5C3L",
            "H6PD",
            "C17orf58",
            "CMTM4",
            "UNC119B",
            "MAPKBP1",
            "PDPR",
            "DPY30",
            "CYB561D1",
            "PLEKHM3",
            "SNRNP25",
            "PSMB4",
            "PDZD11",
            "MRPL27",
            "TRMT112",
            "NDST1",
            "MYCBP2",
            "FAM53B",
            "CASP6",
            "MRPL17",
            "MEA1",
            "VPS13D",
            "ZFP106",
            "MTMR10",
            "HERC2",
            "TBC1D2B",
            "HERC1",
            "ATP5H",
            "BICD2",
            "ZZEF1",
            "SLC12A6",
            "NDUFA12",
            "IQSEC1",
            "LDOC1L",
            "SMCR8",
            "TNRC6B",
            "SLC37A4",
            "MTF1",
            "TMEM216",
            "PDPK1",
            "KIAA0100",
            "ZNF407",
            "WASF2",
            "THUMPD2",
            "CWC15",
            "ATXN1L",
            "TRIM35",
            "C17orf95",
            "TRAPPC10",
            "SON",
            "VPS39",
            "INO80",
            "IP6K1"
        ]
    },
    {
        "golabel": "KLF15_regulon_activity",
        "gene": [
            "PCSK2",
            "GKN2",
            "SLPI",
            "CHIA",
            "ORM2",
            "SCGB3A2",
            "CYP4A22",
            "PEBP4",
            "GREB1",
            "CYP4B1",
            "ZBTB16",
            "LPL",
            "CLU",
            "SFTPD",
            "GNMT",
            "C16orf89",
            "GPR115",
            "CACNA2D2",
            "DUOX1",
            "TSPAN7",
            "ATOH8",
            "POLR3H",
            "OTUD7A",
            "PLA2G4F",
            "FOLR1",
            "DUOXA1",
            "SEC14L4",
            "PLAU",
            "PLIN5",
            "SFTPB",
            "ADHFE1",
            "SLC7A8",
            "ADAM12",
            "MOSC1",
            "STEAP1",
            "MAOA",
            "CDH3",
            "RAP1GAP",
            "ACSM3",
            "C10orf55",
            "OVGP1",
            "IRX3",
            "GPR84",
            "ANLN",
            "LDHD",
            "C9orf152",
            "SORBS2",
            "SLC22A3",
            "SELENBP1",
            "FRMD5",
            "SPHK1",
            "PRR11",
            "C2",
            "ALDH3A2",
            "TUBB3",
            "CTHRC1",
            "CENPE",
            "PRR15L",
            "STEAP2",
            "GSTA4",
            "LOC80154",
            "MKI67",
            "TOP2A",
            "FHL2",
            "ACADSB",
            "PMM1",
            "CEP55",
            "TOB1",
            "CDCP1",
            "UHRF1",
            "FLJ42289",
            "MBOAT2",
            "SLC16A3",
            "LOC388152",
            "KIF11",
            "LARGE",
            "C1orf21",
            "ACSS1",
            "MMD",
            "TMEM125",
            "ALDH6A1",
            "CCND3",
            "FHIT",
            "ALDH2",
            "NUDT7",
            "CD302",
            "TPBG",
            "CCDC109B",
            "MOSC2",
            "KPNA2",
            "ACAT1",
            "CABC1",
            "FLJ36031",
            "TENC1",
            "FRAT1",
            "ITGAV",
            "C1orf210",
            "CMTM3",
            "MCCC1",
            "PECI",
            "PEX11A",
            "SHMT1",
            "RIPK2",
            "TRIM47",
            "MCM6",
            "TXNRD2",
            "KIAA1949",
            "NRIP1",
            "OSBPL3",
            "CRY2",
            "FAM165B",
            "PRKAB1",
            "DHTKD1",
            "MEX3D",
            "NUDT16",
            "LNX2",
            "HSDL2",
            "SPATS2L",
            "THRA",
            "MOAP1",
            "KLC4",
            "BCAT2",
            "BCL10",
            "MED11",
            "CORO1C",
            "GNA12",
            "ALDH7A1",
            "C16orf58",
            "BCKDHB",
            "CANT1",
            "HAGH",
            "PARN",
            "PEBP1",
            "VAMP2",
            "BCKDHA",
            "YWHAG",
            "UBA6",
            "MLYCD",
            "NPEPPS",
            "RCOR3",
            "ZNF76",
            "ACTG1",
            "ZNF267",
            "ARF6",
            "RAC1",
            "MED9",
            "NAPA",
            "SLC41A3",
            "AGPS",
            "DCAF8",
            "UBE3C",
            "RNF167",
            "SLC35A4",
            "UBE2Z"
        ]
    },
    {
        "golabel": "KLF16_regulon_activity",
        "gene": [
            "ANGPTL4",
            "SLC7A5P1",
            "STX1A",
            "IER5L",
            "SPHK1",
            "C4orf12",
            "LRFN4",
            "PHLDA2",
            "SLC16A3",
            "RIN1",
            "ALDH6A1",
            "ARPC1B",
            "ZDHHC2",
            "BCL3",
            "TRIM47",
            "LMNB2",
            "PKP3",
            "PLIN3",
            "SBNO2",
            "NFKB2",
            "RELB",
            "DENND1A",
            "ZSCAN12",
            "ULK2",
            "STXBP4",
            "PLOD3",
            "GAS2L1",
            "THOP1",
            "IRAK1",
            "DAPK3",
            "PPAN",
            "TICAM1",
            "DOHH",
            "PDIK1L",
            "RRP12",
            "BBS10",
            "VPS37B",
            "TCEANC",
            "TCF3",
            "RPS6KA4",
            "ARID4A",
            "SLC27A4",
            "ZNF598",
            "YKT6",
            "RNF126",
            "NACC1",
            "C19orf22",
            "ZNF187",
            "AKT1S1",
            "C2orf67",
            "MIER2",
            "DDA1",
            "PREPL",
            "DBT",
            "AKAP10",
            "SH3GL1",
            "IKZF5",
            "GAR1",
            "HDGFRP2",
            "GIN1",
            "NCLN",
            "C9orf69",
            "REXO1",
            "AMPD2",
            "CSNK1G2",
            "MAP2K2",
            "AP3D1",
            "THAP9",
            "KLRAQ1",
            "CCNT2",
            "RHOT1",
            "PPM1A",
            "PNRC2",
            "PPP2R4",
            "APPBP2",
            "KCTD18",
            "DAZAP1",
            "ZNF434",
            "SPOP",
            "PTBP1"
        ]
    },
    {
        "golabel": "KLF3_regulon_activity",
        "gene": [
            "FER1L6",
            "ONECUT3",
            "C12orf36",
            "SULT1B1",
            "PDX1",
            "ANKS4B",
            "F5",
            "SLC9A2",
            "BCAS1",
            "C9orf125",
            "SOX6",
            "ACER2",
            "RASSF6",
            "A1BG",
            "POF1B",
            "ATP7B",
            "NIPAL1",
            "GUCY2D",
            "XAGE1D",
            "SOX9",
            "GALNT4",
            "C4orf19",
            "FERMT1",
            "BACE2",
            "BATF3",
            "KLF4",
            "LIPH",
            "PPM1L",
            "ABHD2",
            "RHPN2",
            "MANSC1",
            "SLC12A2",
            "TMC7",
            "PAQR8",
            "ASAP2",
            "CTAGE1",
            "SH3BGRL2",
            "RPL35",
            "LOC220429",
            "C7orf40",
            "CRIM1",
            "ECHDC3",
            "IGF1R",
            "ATP8B1",
            "KLF5",
            "FLJ43663",
            "BEND7",
            "TNFRSF4",
            "N4BP2",
            "LIMA1",
            "SHROOM3",
            "PLS1",
            "GOLM1",
            "RALGAPA2",
            "NDUFA11",
            "MRPL14",
            "GNE",
            "GUK1",
            "LOC647288",
            "LCOR",
            "SSFA2",
            "GALNT7",
            "C6orf1",
            "MYO5B",
            "FADS3",
            "SH3BP4",
            "FLNB",
            "TRAPPC5",
            "CCDC109A",
            "MXD3",
            "TMEM149",
            "FAM63B",
            "MYO1D",
            "RGS14",
            "GALK1",
            "MAML3",
            "ARHGAP32",
            "C17orf90",
            "KIAA1671",
            "MRPL55",
            "SESTD1",
            "GPX4",
            "ROCK2",
            "LRRC1",
            "FAM114A1",
            "KBTBD7",
            "SPTBN1",
            "MAN1A2",
            "USP46",
            "RAB24",
            "TRMT1",
            "TJP2",
            "FDX1L",
            "DYNLT3",
            "PRKAA1",
            "TCF7L2",
            "TIRAP",
            "SOCS6",
            "ACBD5",
            "TMOD3",
            "GCC2",
            "RMND5A",
            "RNF103",
            "ZC3H13",
            "TM9SF2",
            "NDUFS7",
            "OAZ1",
            "TJP1",
            "PKN2",
            "GPD2",
            "BOD1L",
            "RNF166",
            "TRAF3IP1",
            "KIF3B",
            "RBM47",
            "AKAP11",
            "TGOLN2",
            "ARID2",
            "IREB2",
            "USF1",
            "UTP14C",
            "PDS5A",
            "CTNND1",
            "FEM1B",
            "STRADA",
            "SLAIN2",
            "AFTPH",
            "PUM1"
        ]
    },
    {
        "golabel": "KLF5_regulon_activity",
        "gene": [
            "ANXA10",
            "TFF1",
            "C12orf36",
            "FAM3D",
            "LGALS4",
            "HSD17B2",
            "VILL",
            "TSPAN8",
            "CYP2C18",
            "TRIM29",
            "EDAR",
            "BCAS1",
            "PLA2G10",
            "MSLN",
            "ERN2",
            "S100P",
            "C9orf125",
            "SDCBP2",
            "TSPAN1",
            "FA2H",
            "RAPGEFL1",
            "CKMT1A",
            "FXYD3",
            "HYAL1",
            "CKMT1B",
            "SEMA4G",
            "TACC2",
            "CAPN5",
            "PAQR5",
            "GALNT4",
            "FERMT1",
            "NPAS1",
            "C9orf152",
            "F2RL1",
            "AVPI1",
            "FAM110C",
            "ITGB4",
            "PLLP",
            "C12orf24",
            "PTK6",
            "EPS8L1",
            "MANSC1",
            "C19orf21",
            "FAM108C1",
            "TMC7",
            "LOC401431",
            "GPRC5A",
            "CBLC",
            "ANXA2P1",
            "ANXA4",
            "CCDC68",
            "CD80",
            "TOB1",
            "SALL2",
            "SPIRE2",
            "GALNT3",
            "FAM83E",
            "TTC22",
            "MPP1",
            "KIF13B",
            "ABLIM1",
            "NFATC4",
            "LAD1",
            "CALML4",
            "LMO7",
            "BEST1",
            "KCNK1",
            "TJP3",
            "LAT2",
            "KIAA1161",
            "SLC35C1",
            "PLS1",
            "LIMD2",
            "BAG1",
            "CERCAM",
            "C1orf106",
            "PCDH1",
            "RASSF4",
            "MYH14",
            "CHP",
            "MYO5C",
            "CORO2A",
            "SH2D4A",
            "DOK3",
            "GLCE",
            "PEX11A",
            "ERBB3",
            "ADAP2",
            "MGAT4A",
            "C6orf132",
            "ATP8B2",
            "CCDC109A",
            "IRF6",
            "FLJ35390",
            "C1orf38",
            "PER2",
            "ARHGEF16",
            "EML2",
            "KIAA0922",
            "NDFIP2",
            "RAB25",
            "C9orf167",
            "PTER",
            "ACSL3",
            "CALHM2",
            "OBFC1",
            "FUT10",
            "BFAR",
            "TRAK1",
            "NUDT15",
            "MGST2",
            "ST3GAL2",
            "SLC25A19",
            "SGTB",
            "PIBF1",
            "SOCS6",
            "KIAA1522",
            "STK24",
            "ACBD5",
            "CLN6",
            "S1PR2",
            "MIPEP",
            "SCAMP2",
            "C9orf25",
            "KLF3",
            "KIAA0564",
            "GNAQ",
            "F11R",
            "RAB11A",
            "RNF166",
            "LCMT2",
            "SNX33",
            "TRIM13",
            "ERCC5",
            "CXorf40B",
            "C1orf216",
            "VPS36",
            "CTNNA1",
            "ELF1",
            "DIS3",
            "ANXA11",
            "MFAP1",
            "GIT2",
            "RTF1",
            "PDCD6IP",
            "VPS24"
        ]
    },
    {
        "golabel": "KLF7_regulon_activity",
        "gene": [
            "SPRED3",
            "C5orf4",
            "ADAMTS12",
            "FN1",
            "INHBA",
            "MESP1",
            "AHNAK2",
            "VCAN",
            "ADAMTS2",
            "DDR2",
            "XYLT1",
            "DSC2",
            "DCHS1",
            "GPR161",
            "STX19",
            "DSG2",
            "COL4A1",
            "MGAT5",
            "CHCHD10",
            "ARL4C",
            "ZNF697",
            "SEPT11",
            "TMEM116",
            "ELK3",
            "TAOK1",
            "MAP4K4",
            "SH3PXD2B",
            "FLT1",
            "ECE1",
            "FAM165B",
            "PIGP",
            "AFAP1",
            "SOD1",
            "ARV1",
            "LYPLAL1",
            "RC3H2",
            "C10orf12",
            "KATNAL1",
            "C6orf203",
            "MYH9",
            "ZNF532",
            "NDUFAF1",
            "PLBD2",
            "OMA1",
            "IMP3",
            "C21orf59",
            "DDX28",
            "RPP38",
            "RPUSD2",
            "BMPR2",
            "NDUFV3"
        ]
    },
    {
        "golabel": "KLF8_regulon_activity",
        "gene": [
            "SLC16A14",
            "DUSP4",
            "COL4A3",
            "ZMAT1",
            "ZNF493",
            "ATP8B1",
            "MAP3K13",
            "ZNF431",
            "ARHGAP31",
            "FHOD1",
            "C1QBP",
            "PKD2",
            "EEF1E1",
            "NDUFV2",
            "CNPY2",
            "LYST",
            "PSMB6",
            "TMEM93",
            "PARP14",
            "MPDU1",
            "CASP10",
            "OVCA2",
            "SYNJ1",
            "MKKS",
            "POLR3K",
            "SLC7A6",
            "NUP88",
            "INPP4A",
            "COPZ1",
            "MKNK1",
            "STX18",
            "SENP3"
        ]
    },
    {
        "golabel": "KNTC1_regulon_activity",
        "gene": [
            "FAM57B",
            "ALX1",
            "FSD1",
            "TMEM145",
            "GPC2",
            "C2orf48",
            "MIAT",
            "OR2B6",
            "SCML2",
            "ATOH7",
            "MKRN3",
            "DSCR6",
            "SMTNL1",
            "FER1L4",
            "RNFT2",
            "CCDC150",
            "RNF157",
            "FBXO43",
            "TAS2R31",
            "CLIC3",
            "BRSK1",
            "ATP2A1",
            "SCN8A",
            "MYBL1",
            "MCF2L2",
            "KCNJ14",
            "ZNF300",
            "PIF1",
            "NUP107",
            "ESPL1",
            "POLQ",
            "KIF18B",
            "RAD54L",
            "DDX12",
            "LOC222699",
            "LOC642846",
            "DNA2",
            "FLJ37201",
            "EZH2",
            "NUP210",
            "ATAD5",
            "MTBP",
            "SLFN13",
            "DDX11",
            "HAUS5",
            "TMEM98",
            "MCM8",
            "LOC147804",
            "FANCA",
            "CCDC18",
            "ZNF519",
            "CEP152",
            "TRERF1",
            "RTTN",
            "CRYL1",
            "C4orf21",
            "KIAA1841",
            "TSC22D1",
            "SMC4",
            "ZC3HAV1L",
            "SH2D4A",
            "SEC61A2",
            "DBF4B",
            "CENPJ",
            "MPHOSPH9",
            "FANCD2",
            "NASP",
            "PASK",
            "EEF1A1P9",
            "POLE",
            "UBTD1",
            "DNAH14",
            "TOPBP1",
            "RFC5",
            "STOM",
            "USP31",
            "TNFSF13",
            "MARCH6",
            "RAD9B",
            "CCDC21",
            "GEN1",
            "QSOX2",
            "PARP2",
            "ZNF525",
            "LRRC8E",
            "FAM122B",
            "KIAA1731",
            "RETSAT",
            "ZNF26",
            "UPF3B",
            "NAA40",
            "ZNF8",
            "CCDC52",
            "ZNF507",
            "NAA25",
            "DDX55",
            "ATP6V0D1",
            "TAX1BP3",
            "SCAMP2",
            "SR140",
            "GLB1",
            "TPRG1L",
            "ANKLE2",
            "EP400",
            "CRTAP",
            "ALG1",
            "CHFR",
            "KDM2B",
            "MSL1",
            "SMPD4",
            "ANAPC7",
            "TADA2A",
            "TCERG1",
            "CSTF3",
            "RBM17",
            "XPO1",
            "RNF34",
            "HPS6",
            "COPS7B",
            "SART3",
            "DCTD",
            "ZCCHC8",
            "SUPT7L"
        ]
    },
    {
        "golabel": "KRBA1_regulon_activity",
        "gene": [
            "PLEKHG4B",
            "B4GALNT4",
            "H2BFXP",
            "BAI2",
            "SALL4",
            "ALX3",
            "SEMA6C",
            "SMO",
            "GLRX",
            "BZRAP1",
            "ABCC5",
            "LOC401431",
            "CAND2",
            "KIF7",
            "GPRC5A",
            "NYNRIN",
            "TMCC2",
            "GDPD5",
            "CADM4",
            "ARVCF",
            "CROCC",
            "RBM38",
            "NFATC4",
            "NINL",
            "C20orf96",
            "C4orf34",
            "BMF",
            "NLGN2",
            "HDAC6",
            "LOC200030",
            "ZNF512B",
            "GIGYF1",
            "CBFA2T2",
            "SYNGAP1",
            "PLCG1",
            "PTER",
            "ZNF74",
            "FBXO10",
            "SUCLG2",
            "TUBG2",
            "MAP4K2",
            "RAB11FIP3",
            "BFAR",
            "ZDHHC8",
            "SNAPC4",
            "CHMP5",
            "BBS5",
            "TMEM201",
            "PELI3",
            "NCKAP5L",
            "NEURL4",
            "TRIM62",
            "CHMP2B",
            "MMADHC",
            "ZFAND6",
            "UBOX5",
            "ZNF786",
            "RAB11A",
            "TMED7",
            "KIAA0195",
            "TANK",
            "ATG12",
            "AP3S1",
            "ZNF282",
            "COQ10B",
            "C5orf43",
            "IPO13",
            "UBE2D3",
            "NRF1"
        ]
    },
    {
        "golabel": "LARP1_regulon_activity",
        "gene": [
            "RGS13",
            "CLUL1",
            "TNNC1",
            "DHDH",
            "C1orf133",
            "TSPAN13",
            "COX7A1",
            "TMEM98",
            "BCAS4",
            "MTAP",
            "NEU1",
            "ZNF552",
            "C2orf64",
            "PARD3",
            "GDE1",
            "POLR1A",
            "CBX5",
            "SFXN1",
            "P2RX4",
            "POLR3A",
            "TCOF1",
            "PDCD11",
            "VDAC1",
            "SMCR7",
            "MCCC2",
            "LIPT1",
            "MEAF6",
            "PLAA",
            "PTPN11",
            "HSPA9",
            "GEMIN5",
            "EIF3A",
            "UTP14A",
            "NSD1",
            "RARS",
            "NOP14",
            "NAT10",
            "CDV3",
            "DIAPH1",
            "SDAD1",
            "CCDC115",
            "RBM27",
            "UTP3",
            "VCP"
        ]
    },
    {
        "golabel": "LARP4_regulon_activity",
        "gene": [
            "FGA",
            "CPS1",
            "ABCC2",
            "CYP24A1",
            "HAL",
            "BASP1",
            "TXNRD1",
            "C17orf50",
            "CX3CL1",
            "PLA2G16",
            "C1QTNF2",
            "MXRA8",
            "MEGF6",
            "SLC25A29",
            "C1orf133",
            "ATP2B1",
            "GGT5",
            "SCD",
            "C3orf54",
            "LGALS9",
            "LOXL1",
            "RACGAP1",
            "RTN4R",
            "PLCD1",
            "ZNF69",
            "SLC41A2",
            "EPT1",
            "PHLDA3",
            "MAP7",
            "SDC1",
            "LOC284440",
            "TMEM194A",
            "GALNTL4",
            "XPOT",
            "FDXR",
            "PEX11G",
            "HSD11B1L",
            "CCNT1",
            "SBNO1",
            "CMTM7",
            "PHKA1",
            "LOC727896",
            "TDG",
            "CTNNBIP1",
            "DDX21",
            "DARS2",
            "PPTC7",
            "CLIP1",
            "ACSL3",
            "TCEAL6",
            "ADIPOR2",
            "C21orf2",
            "SIRT2",
            "DGCR6L",
            "ZNF688",
            "ZNF563",
            "AEBP2",
            "TCEAL3",
            "TTLL1",
            "ABTB1",
            "AGFG1",
            "DEAF1",
            "TNFSF12",
            "ATF1",
            "B3GNT1",
            "NAA25",
            "SUZ12",
            "KRR1",
            "ATP2A2",
            "MPND",
            "UGGT1",
            "PQLC1",
            "SLC39A13",
            "CSRNP2",
            "NOLC1",
            "BAZ2A",
            "PTPN11",
            "TBK1",
            "PAPOLA",
            "HSPA9",
            "VMAC",
            "UBE2K",
            "IBTK",
            "SENP1",
            "PLSCR3",
            "FKBP8",
            "SCYL2",
            "ARF3",
            "MTIF2",
            "USP15",
            "CS",
            "PPP1R15B",
            "RPAP3",
            "RAD23B",
            "PARG",
            "KIAA1033",
            "TMEM109",
            "C1orf55",
            "LOC144438",
            "RAB11B",
            "C11orf68",
            "TFCP2",
            "PRDM4",
            "PRMT2",
            "CCAR1",
            "UBXN6",
            "UBA5",
            "UBQLN1",
            "PDE12"
        ]
    },
    {
        "golabel": "LARP4B_regulon_activity",
        "gene": [
            "TGFBI",
            "CNIH3",
            "JPH1",
            "TNC",
            "PLAU",
            "GPT2",
            "PDLIM4",
            "MOSC1",
            "C10orf55",
            "LAYN",
            "DFNA5",
            "SRPX2",
            "MT1F",
            "FRMD6",
            "PROCR",
            "COL8A2",
            "CTSK",
            "MFAP2",
            "SCD5",
            "TMEM121",
            "GLT8D2",
            "TNFSF4",
            "ISLR",
            "C6orf225",
            "PDLIM3",
            "C10orf110",
            "TSPAN2",
            "B3GALNT1",
            "SCNN1A",
            "IFI27L2",
            "COPZ2",
            "SSPN",
            "GADD45A",
            "GPX7",
            "SPIRE2",
            "C5orf62",
            "SDC2",
            "DSE",
            "GLIPR2",
            "C4orf36",
            "FSTL1",
            "CKLF",
            "LOXL1",
            "UNC13B",
            "CDK14",
            "SNHG7",
            "TUBA1A",
            "CERCAM",
            "IDI2",
            "PDGFC",
            "C10orf47",
            "EFEMP2",
            "STK17A",
            "BPGM",
            "CMTM3",
            "TTYH3",
            "TNFAIP8",
            "PITPNM2",
            "FAM83H",
            "TSPAN6",
            "KIAA1804",
            "APOBEC3C",
            "C13orf23",
            "DHTKD1",
            "TPST1",
            "PTER",
            "MED13L",
            "TMEM51",
            "GTPBP4",
            "TPM4",
            "ESRP2",
            "C10orf57",
            "ST3GAL2",
            "PITRM1",
            "ANKRD16",
            "BBS9",
            "ACBD5",
            "ZNF33A",
            "SUDS3",
            "UBTD2",
            "BCAS2",
            "MTPAP",
            "C10orf18",
            "MEF2D",
            "EXT2",
            "WDR37",
            "UPF2",
            "CHST14",
            "ATXN2",
            "TMEM185A",
            "ZMYND11",
            "MLLT10",
            "SEPT7",
            "MUL1",
            "FAM21C",
            "RBM17",
            "FBXO18",
            "PRPF18",
            "SEC24C"
        ]
    },
    {
        "golabel": "LARP6_regulon_activity",
        "gene": [
            "EYA2",
            "ELOVL4",
            "LYPD6",
            "SFTPB",
            "HOXB7",
            "BVES",
            "LRRC49",
            "SMO",
            "AHCYL2",
            "CIB2",
            "C1orf116",
            "LMO3",
            "MFAP2",
            "LOC654342",
            "STMN1",
            "PIP5KL1",
            "B3GALNT1",
            "SFTA3",
            "GPX7",
            "HDGFRP3",
            "LTBP1",
            "EIF5A2",
            "RORC",
            "CYB5R2",
            "MUC1",
            "CISH",
            "THAP10",
            "SLC38A1",
            "C3orf21",
            "ARHGEF38",
            "TPM1",
            "GPD1L",
            "UACA",
            "BLMH",
            "MRPS25",
            "LTA4H",
            "DUSP14",
            "TMEM63B",
            "UBE2E3",
            "MARCKS",
            "TMTC3",
            "ATP2C1",
            "TBCCD1",
            "CD276",
            "NCK2",
            "SENP1",
            "ALAD",
            "SECISBP2"
        ]
    },
    {
        "golabel": "LCOR_regulon_activity",
        "gene": [
            "NUPR1",
            "SLC12A2",
            "SGK196",
            "ZBTB10",
            "SH3BGR",
            "FTL",
            "RASEF",
            "GMCL1L",
            "LOC440957",
            "C7orf59",
            "N4BP2",
            "TP53TG1",
            "NUDT6",
            "LPP",
            "GUK1",
            "TRIP6",
            "TAOK1",
            "C6orf1",
            "BRWD3",
            "RICTOR",
            "FGD6",
            "MFHAS1",
            "INSR",
            "TMEM42",
            "PLEKHA5",
            "AGAP1",
            "LOC728323",
            "RAD54L2",
            "FAM63B",
            "TSPO",
            "MSI2",
            "ACOT1",
            "LOC401397",
            "MED13L",
            "NUDT18",
            "PLEKHA1",
            "ROCK2",
            "BCL7C",
            "NHLRC2",
            "RIF1",
            "DGCR6L",
            "ASXL2",
            "CREB3L2",
            "GSTK1",
            "REST",
            "TMPPE",
            "C10orf12",
            "C11orf67",
            "CARS2",
            "SLK",
            "FAHD2A",
            "SMC3",
            "DHRS4L2",
            "ZNF749",
            "LSM10",
            "OSGEP",
            "MIB1",
            "FDX1L",
            "C10orf118",
            "CDK5",
            "POLR3A",
            "DNMBP",
            "IDE",
            "DHRS4",
            "TCF7L2",
            "C17orf81",
            "LATS1",
            "RFXANK",
            "SGPL1",
            "RNASEH2C",
            "ELK4",
            "UROD",
            "NDUFAF3",
            "MFSD9",
            "GCC2",
            "B4GALT7",
            "SIRT1",
            "MYST4",
            "COMMD4",
            "FAM125A",
            "KDM5A",
            "TMEM60",
            "RNF169",
            "KLF3",
            "EIF2AK3",
            "HIVEP1",
            "ABCB8",
            "JMJD1C",
            "ESCO1",
            "USP37",
            "BAZ2A",
            "TM9SF3",
            "BPTF",
            "PRDM10",
            "TMEM131",
            "ARID2",
            "IREB2",
            "KIF5B",
            "MRPL16",
            "RANBP2",
            "BIRC6",
            "C21orf33",
            "BCL7B",
            "C19orf56",
            "VPS54",
            "SOS1",
            "NBAS",
            "SFRS2IP",
            "GBF1",
            "SEC23IP",
            "TNKS2",
            "DDX46",
            "ZRANB1",
            "WAPAL",
            "BTRC",
            "C10orf28",
            "CTCF"
        ]
    },
    {
        "golabel": "LDB1_regulon_activity",
        "gene": [
            "MST1P9",
            "PKIB",
            "LCN12",
            "ESPNP",
            "MST1P2",
            "WNT8B",
            "LOC100128675",
            "TMEM22",
            "LOC619207",
            "MBL1P",
            "PRICKLE4",
            "ESYT3",
            "PLA2G6",
            "BCL11A",
            "BZRAP1",
            "TMEM105",
            "GABBR1",
            "GOLGA6L5",
            "UBE2Q2P1",
            "ASB16",
            "KIAA0664P3",
            "GOLGA6L9",
            "CROCCL2",
            "AGAP5",
            "FAM22A",
            "GOLGA6L10",
            "LOC646471",
            "KIAA0895L",
            "ENGASE",
            "ZBED3",
            "BMS1P4",
            "CROCCL1",
            "ARHGEF19",
            "LOC283922",
            "AGAP4",
            "BAHCC1",
            "SOX13",
            "ANKRD6",
            "BMF",
            "SLC35E2",
            "LDHA",
            "LOC200030",
            "PBXIP1",
            "PPP1R13B",
            "DBP",
            "SFXN2",
            "TUBGCP6",
            "CRTC1",
            "GBE1",
            "LTBP3",
            "FAM22D",
            "ARAP3",
            "SNX7",
            "DOCK1",
            "ZNF75D",
            "MDM4",
            "UCHL3",
            "LRRC27",
            "SMAD7",
            "LYAR",
            "CALCOCO1",
            "ZNF785",
            "RGL2",
            "IKZF4",
            "ARHGEF17",
            "CIRBP",
            "RPF2",
            "KIAA0495",
            "FUCA2",
            "FBXW4",
            "ZNF362",
            "SSBP1",
            "C10orf137",
            "PBX2",
            "NISCH",
            "SUOX",
            "FNBP4",
            "CUL9",
            "CISD2",
            "KIAA0913",
            "DNAJC27",
            "PGS1",
            "LZTS2",
            "RALA",
            "ZNF259",
            "RNF44",
            "INPP5A",
            "SUFU",
            "AP3S1",
            "RARS",
            "ZNF500",
            "REV1",
            "POLL",
            "RXRB",
            "NDST2",
            "MMS19",
            "SEC24C",
            "C10orf76"
        ]
    },
    {
        "golabel": "LIMD1_regulon_activity",
        "gene": [
            "RS1",
            "CYP4B1",
            "GPR87",
            "TGFBI",
            "PPAPDC1A",
            "CACNA2D2",
            "SECISBP2L",
            "AFF3",
            "ATOH8",
            "SYT15",
            "PLA2G4F",
            "AQP4",
            "MT1X",
            "SEC14L4",
            "TMEM158",
            "PLAU",
            "AATK",
            "PCDH7",
            "CCL11",
            "SFTPB",
            "ANKRD29",
            "CACNA1D",
            "AASS",
            "GPR133",
            "SLC2A1",
            "RPL39L",
            "STEAP1",
            "BEND6",
            "FSCN1",
            "ABCA3",
            "PPP1R3G",
            "SRPX2",
            "TNFAIP6",
            "ATP8A1",
            "SELENBP1",
            "PLEK2",
            "AHCYL2",
            "SPHK1",
            "RHOBTB2",
            "DLC1",
            "ABCC4",
            "CTHRC1",
            "ZFAND2A",
            "MECOM",
            "CENPW",
            "NCRNA00152",
            "SNX30",
            "SFTA3",
            "CABLES1",
            "RND3",
            "FHL2",
            "KRT19",
            "MEGF9",
            "PXMP4",
            "STXBP1",
            "DAPK1",
            "CGNL1",
            "ATP11A",
            "PLXNA2",
            "C1QTNF6",
            "CHCHD2",
            "TK1",
            "CENPM",
            "TNFRSF12A",
            "LARGE",
            "RNF145",
            "CKLF",
            "GPX8",
            "UNC13B",
            "ASF1B",
            "MMD",
            "IL6R",
            "SLAIN1",
            "CDCA4",
            "ADCY7",
            "C1GALT1",
            "MTUS1",
            "PDLIM7",
            "RNASEH2A",
            "GPD1L",
            "C8orf42",
            "CABC1",
            "TNS1",
            "FLJ36031",
            "ARL4A",
            "MAD2L2",
            "RHOC",
            "EPAS1",
            "RPS6KA2",
            "BID",
            "ARRB1",
            "HPRT1",
            "RPA3",
            "PPP1R13B",
            "RALGPS1",
            "LRIG1",
            "H2AFZ",
            "KANK1",
            "MRPS25",
            "CCDC90B",
            "UTRN",
            "IKBIP",
            "NUDT1",
            "MTHFR",
            "LNX2",
            "DUSP14",
            "SPATS2L",
            "MYLIP",
            "PLOD1",
            "TMEM63B",
            "ZDHHC3",
            "CARHSP1",
            "TUBA1B",
            "ESRP2",
            "RFC2",
            "ULK2",
            "ZNF33B",
            "DRAP1",
            "RPF2",
            "SLC25A20",
            "CDR2",
            "SUMO3",
            "PSMC2",
            "ENO1",
            "LRRC42",
            "PSMA2",
            "C1orf69",
            "AKAP1",
            "MTMR10",
            "TANC1",
            "C7orf25",
            "HDHD2",
            "C1orf174",
            "ZBTB3",
            "RAC1",
            "XPC",
            "APEX2",
            "TBC1D14",
            "PSMB2",
            "SACM1L",
            "AP2A2",
            "SECISBP2",
            "CAPZB",
            "NRBP1"
        ]
    },
    {
        "golabel": "LMO3_regulon_activity",
        "gene": [
            "SPRYD5",
            "MMP28",
            "ZNF385B",
            "HOPX",
            "LRRK2",
            "C16orf89",
            "CDKL2",
            "AQP4",
            "HLF",
            "GPR110",
            "SMOX",
            "C4orf31",
            "ESYT3",
            "GPR116",
            "TINAGL1",
            "STEAP4",
            "NAPSA",
            "LARP6",
            "DLC1",
            "IFT57",
            "SLC34A2",
            "UCK2",
            "PLS3",
            "ABCC6",
            "A4GALT",
            "ICAM1",
            "TRPM2",
            "SNX25",
            "ATP2B1",
            "B4GALT4",
            "CDC42EP3",
            "CCNJL",
            "MAGI3",
            "FBP1",
            "FAM13A",
            "BRI3BP",
            "ARHGEF38",
            "EMP2",
            "GPD1L",
            "BTBD9",
            "EPS8",
            "RPS6KA2",
            "PTPRE",
            "SDC4",
            "CCDC46",
            "GRAMD3",
            "RAPH1",
            "LTA4H",
            "DNAJC10",
            "LRRC20",
            "CD47",
            "TMEM63B",
            "CPNE2",
            "FAM65A",
            "SPATS2",
            "GDE1",
            "CASD1",
            "MBNL1",
            "GFOD2",
            "ZFYVE20",
            "SMAP1",
            "HDAC1"
        ]
    },
    {
        "golabel": "LRRFIP1_regulon_activity",
        "gene": [
            "COL17A1",
            "ITGA6",
            "A1BG",
            "SRPK3",
            "HIST1H4J",
            "SH3RF2",
            "ABLIM3",
            "FMN1",
            "ABHD2",
            "TIGD3",
            "CLDN3",
            "LOC144486",
            "ASAP2",
            "CDH24",
            "AHNAK",
            "EFNB2",
            "C5orf55",
            "ROMO1",
            "NXT1",
            "SNHG10",
            "ADCK5",
            "C6orf129",
            "C16orf59",
            "LOC100216545",
            "LOC401588",
            "TIMM17B",
            "SGMS2",
            "ZNF692",
            "LAGE3",
            "PSMG3",
            "AP1S3",
            "NHLRC1",
            "FGD4",
            "C18orf18",
            "LOC202781",
            "LIN37",
            "SSFA2",
            "BOLA1",
            "AKAP13",
            "SDHAF1",
            "SMAD3",
            "FLNB",
            "TGFBR2",
            "U2AF1L4",
            "PDRG1",
            "KAT2A",
            "RAD9A",
            "ARAP2",
            "COL4A3BP",
            "C17orf90",
            "MRPL55",
            "SPTBN1",
            "RAE1",
            "CLCN3",
            "KIF22",
            "UCKL1",
            "TARBP2",
            "FASTK",
            "PSMB4",
            "DOM3Z",
            "MTX1",
            "FLAD1",
            "METTL3",
            "VPS72",
            "TAZ",
            "FOXRED1",
            "ZNF821",
            "ANKRD16",
            "PHKG2",
            "C7orf11",
            "WDR85",
            "FKBPL",
            "NUBP2",
            "SNRPC",
            "TMOD3",
            "DENND4A",
            "NAT9",
            "FOXP1",
            "KLHL22",
            "ACOT8",
            "TBCC",
            "PARP4",
            "NUPL2",
            "TSEN54",
            "GNAQ",
            "RPS6KB2",
            "TJP1",
            "CDK5RAP1",
            "IQGAP1",
            "CAB39",
            "SH3D19",
            "TRAF3IP1",
            "C7orf30",
            "ACTR5",
            "TGOLN2",
            "PJA2",
            "BMPR2",
            "MPHOSPH8",
            "C17orf62",
            "GPS1",
            "JAK1",
            "TRIP12",
            "STK19",
            "SLMAP",
            "SERINC1",
            "RHBDD1",
            "GIGYF2",
            "SLAIN2",
            "PGGT1B",
            "RAB3GAP1",
            "PDCD6IP"
        ]
    },
    {
        "golabel": "LYL1_regulon_activity",
        "gene": [
            "RAB33A",
            "TPSB2",
            "CFD",
            "RASGRP2",
            "LOC728392",
            "PLD4",
            "TPSAB1",
            "SPNS3",
            "PLAC9",
            "KANK3",
            "RASL10A",
            "LTB",
            "MUSTN1",
            "LIME1",
            "PTPRCAP",
            "FAM159A",
            "ARHGAP22",
            "GSR",
            "LTC4S",
            "GRAPL",
            "GAPT",
            "TBC1D10C",
            "ACAP1",
            "IFI27L2",
            "GAS6",
            "CD37",
            "LOC606724",
            "PYCARD",
            "LOC220429",
            "MAP4K1",
            "NAPSB",
            "PRCD",
            "RASAL3",
            "FXYD5",
            "ECT2",
            "C3orf54",
            "COX7A1",
            "CD1D",
            "TMC8",
            "SOX18",
            "IL16",
            "SPI1",
            "TNFRSF4",
            "ZMYND15",
            "HAAO",
            "TNFRSF14",
            "GIMAP1",
            "S1PR4",
            "P2RY11",
            "FAM167B",
            "SH2D3C",
            "LIMD2",
            "CYBA",
            "GRAP",
            "EPT1",
            "GYPC",
            "LMO2",
            "WAS",
            "TMSL3",
            "MFNG",
            "RASA4",
            "JUNB",
            "PTGIR",
            "LOC647288",
            "FLVCR1",
            "TYMP",
            "FLT3LG",
            "ABI3",
            "TSPAN4",
            "GBGT1",
            "RRAS",
            "POPDC2",
            "TMEM149",
            "ZNF671",
            "ICAM3",
            "HSPD1",
            "ICAM2",
            "PDLIM2",
            "PHKA1",
            "HOOK1",
            "HMHA1",
            "L2HGDH",
            "DPP7",
            "DHTKD1",
            "GPR125",
            "DARS2",
            "TGFB1",
            "ACSL3",
            "PAWR",
            "KCTD17",
            "SORBS3",
            "GTPBP4",
            "SSBP4",
            "ZNF688",
            "EHD1",
            "DEF6",
            "C5orf22",
            "ABTB1",
            "ST6GALNAC6",
            "JOSD2",
            "ZBTB47",
            "GRHL2",
            "ESRP1",
            "TNFSF12",
            "C19orf25",
            "FNBP1L",
            "S1PR2",
            "RPN2",
            "MCCC2",
            "LMF2",
            "LCLAT1",
            "DCAF16",
            "SRPK1",
            "SIPA1",
            "MPND",
            "PAOX",
            "RGS3",
            "DOK1",
            "AFG3L2",
            "HSP90AB1",
            "OAZ1",
            "MARCH2",
            "GMCL1",
            "PDHX",
            "TPST2",
            "SLC39A13",
            "LRPPRC",
            "NDUFS1",
            "FAM108A1",
            "NOLC1",
            "RNF166",
            "PAPOLA",
            "HSPA9",
            "UBE2K",
            "LARP1B",
            "PTPN18",
            "NARS",
            "NAGPA",
            "IARS2",
            "RASSF1",
            "APBA3",
            "FBXO21",
            "C17orf59",
            "DBNL",
            "PDS5A",
            "GRK6",
            "BMPR1A",
            "HPS1",
            "RNH1",
            "FUBP1",
            "AP1M1",
            "DHX15",
            "MRPL19",
            "UBXN6",
            "XRCC5",
            "CDC73",
            "PLEKHM2",
            "SAPS3",
            "DHX9"
        ]
    },
    {
        "golabel": "LZTFL1_regulon_activity",
        "gene": [
            "LRRC67",
            "ABHD12B",
            "NEK5",
            "CXorf41",
            "ZBBX",
            "C10orf79",
            "C13orf30",
            "WDR63",
            "SNTN",
            "EFHB",
            "RGS22",
            "LRRC48",
            "WDR65",
            "C2orf40",
            "RSPH4A",
            "ZMYND10",
            "C6orf165",
            "DNAH7",
            "CCDC11",
            "DCDC1",
            "CCDC13",
            "IL5RA",
            "CASC1",
            "ERBB4",
            "IQUB",
            "C5orf49",
            "C1orf192",
            "DYDC2",
            "C10orf93",
            "ANGPTL5",
            "NMBR",
            "WDR78",
            "LOC284276",
            "AK7",
            "EFCAB10",
            "C1orf88",
            "CCDC89",
            "PPIL6",
            "KLHL32",
            "IQCA1",
            "IL33",
            "C2orf77",
            "CORO2B",
            "C11orf70",
            "TMEM231",
            "PIH1D2",
            "LRRC6",
            "CERKL",
            "C9orf9",
            "FMO2",
            "C7orf63",
            "IFT57",
            "ENTPD3",
            "PALMD",
            "STK33",
            "CASC2",
            "IQGAP3",
            "LCA5",
            "FAM82A1",
            "MLF1",
            "PKMYT1",
            "NEK11",
            "LEKR1",
            "LRRC34",
            "ULK4",
            "C14orf45",
            "METTL7A",
            "TIGD4",
            "NPHP1",
            "SPA17",
            "CC2D2A",
            "FLJ40852",
            "AKD1",
            "OSCP1",
            "ZNF214",
            "EFHA2",
            "TACC3",
            "ZNF396",
            "LOC344595",
            "MYO7A",
            "DYX1C1",
            "SPATA6",
            "ZCWPW2",
            "TMEM67",
            "DUSP19",
            "IFT80",
            "FAM175A",
            "IRAK1BP1",
            "CAT",
            "KIF9",
            "ABCD1",
            "MORN2",
            "RRM2B",
            "FBXL2",
            "TCP11L2",
            "RABL2B",
            "APH1B",
            "ARL6",
            "ZNF487",
            "RPL15",
            "CYB5D1",
            "TCTN1",
            "CETN2",
            "C5orf41",
            "CTDSPL",
            "F8A1",
            "EIF4A2",
            "SLC3A2",
            "WDR35",
            "ZNF709",
            "CRBN",
            "BBS12",
            "EIF4E3",
            "WDR19",
            "BTD",
            "NR1D2",
            "IFT88",
            "C11orf24",
            "ABCD3",
            "RBBP9",
            "CDK16",
            "EFCAB7",
            "DNAL1",
            "BBS10",
            "C2orf86",
            "TCTN2",
            "C3orf23",
            "PIBF1",
            "CCDC137",
            "HBP1",
            "PLK1S1",
            "ARHGEF3",
            "CCDC104",
            "C12orf26",
            "PACS1",
            "MIPEP",
            "CLUAP1",
            "DYNC2LI1",
            "HACL1",
            "IFT74",
            "C2orf67",
            "NKIRAS1",
            "PREPL",
            "FBXL3",
            "WDR47",
            "ZFYVE20",
            "ZRANB2",
            "DBT",
            "KIAA0753",
            "PCNP",
            "FBXO3",
            "CMTM6",
            "DALRD3",
            "IKZF5",
            "EPM2AIP1",
            "HGS",
            "SACM1L",
            "EID1",
            "EIF1B",
            "RSBN1",
            "NPLOC4",
            "TUSC2",
            "TMF1",
            "ARHGDIA",
            "SLC25A38",
            "DCP1A",
            "PSMC5",
            "ARL8B",
            "NEK4",
            "SLC25A26",
            "APPL1",
            "PNRC2",
            "CAPN7",
            "SEC22C",
            "SHQ1",
            "AZI2",
            "CLASP2",
            "UBP1",
            "KIAA1143",
            "WDR48",
            "MLH1",
            "GLT8D1",
            "MKRN2"
        ]
    },
    {
        "golabel": "MACF1_regulon_activity",
        "gene": [
            "SVEP1",
            "FAM38B",
            "DYNC2H1",
            "RUNX1T1",
            "ALG1L",
            "SLIT2",
            "RPS7",
            "KIAA0754",
            "GPRASP1",
            "C17orf61",
            "NHSL2",
            "DST",
            "GTF3A",
            "PCDHGA6",
            "PLEKHH2",
            "TMEM141",
            "FAT4",
            "LSM1",
            "PCDHGB7",
            "SLC27A5",
            "CACNA1C",
            "SEPX1",
            "ATP5J2",
            "SHROOM4",
            "COX6B1",
            "C1orf31",
            "TIMM8B",
            "SNRPG",
            "ZC3H12B",
            "AHNAK",
            "LAMA2",
            "MRPS12",
            "C6orf57",
            "TALDO1",
            "FNIP2",
            "MYH10",
            "ROMO1",
            "ECE2",
            "NCRNA00116",
            "CHCHD10",
            "C6orf129",
            "MRPS35",
            "NDUFB9",
            "TIMM16",
            "TSFM",
            "MRPL48",
            "VDAC3",
            "COX7B",
            "C8orf76",
            "C2orf76",
            "NBPF14",
            "UQCRQ",
            "NDUFB1",
            "C8orf59",
            "TIMM17B",
            "IDH1",
            "MRPL13",
            "DCTPP1",
            "COX7A2",
            "LSMD1",
            "CYC1",
            "PRDX4",
            "SORBS1",
            "NBPF10",
            "EMG1",
            "SSR4",
            "C9orf123",
            "MAML2",
            "FGD5",
            "TMEM147",
            "HSBP1L1",
            "MRPL52",
            "MYEOV2",
            "ITPR3",
            "COX5B",
            "TCEB1",
            "NME1",
            "MFF",
            "ZNF462",
            "C11orf83",
            "LSM2",
            "LRP1",
            "TMEM14B",
            "C2orf79",
            "CRIPT",
            "NQO2",
            "RAPGEF5",
            "PSMB3",
            "ZNF608",
            "TOMM22",
            "BOLA2",
            "PRICKLE2",
            "ATP5I",
            "POP7",
            "HIVEP3",
            "SNRPB",
            "DOCK9",
            "C20orf24",
            "COX6A1",
            "GEMIN6",
            "BOLA3",
            "MAGI1",
            "NME4",
            "TMEM14C",
            "ADARB1",
            "SPATA13",
            "C2orf28",
            "PDCD6",
            "ATP5G1",
            "SERF2",
            "AHCY",
            "NDUFB6",
            "MRPL15",
            "NOTCH2",
            "LYRM4",
            "C1QBP",
            "C15orf63",
            "DYNLT1",
            "RPL26L1",
            "HBXIP",
            "USMG5",
            "APOA1BP",
            "HEBP2",
            "MRPL12",
            "COX7A2L",
            "C11orf31",
            "TMEM223",
            "CMC1",
            "HSPE1",
            "UTRN",
            "HAX1",
            "C4orf52",
            "C11orf48",
            "TTBK2",
            "NDUFA7",
            "OST4",
            "TXNL1",
            "ERP29",
            "MTHFS",
            "PSMB5",
            "C2orf64",
            "FBXO22OS",
            "C11orf51",
            "NDUFB11",
            "TIMM10",
            "MRPS33",
            "C14orf119",
            "CHCHD5",
            "COX5A",
            "HMBS",
            "KIF13A",
            "C14orf2",
            "EVC",
            "NIT2",
            "NDUFV2",
            "MRP63",
            "TRANK1",
            "NDUFB4",
            "SOD1",
            "CNPY2",
            "STOML2",
            "WWC3",
            "NDUFS8",
            "NHP2",
            "ATP5G3",
            "MTMR3",
            "SPTBN1",
            "TMEM183A",
            "SGK269",
            "EIF5A",
            "HDDC2",
            "LYST",
            "NDUFB3",
            "C14orf179",
            "ERH",
            "ATP5G2",
            "LSM4",
            "MGST3",
            "PRDX3",
            "MRPL53",
            "TIMM9",
            "PSMB6",
            "C9orf23",
            "ICT1",
            "REV3L",
            "COMMD7",
            "SRPRB",
            "NUDT5",
            "NFU1",
            "TMEM93",
            "ORMDL2",
            "TARBP2",
            "CHCHD8",
            "KIAA1109",
            "PSMB4",
            "POP5",
            "ATP5C1",
            "POLR2G",
            "MRPL27",
            "TRMT112",
            "EIF5AL1",
            "MRPS18A",
            "LUZP1",
            "ANKRD39",
            "NDUFC2",
            "CWF19L1",
            "TFB1M",
            "VPS13C",
            "NDUFB8",
            "POLR2H",
            "NDUFAB1",
            "DAD1",
            "MYCBP2",
            "PPA2",
            "TRUB2",
            "COQ5",
            "CHCHD1",
            "FYCO1",
            "COX8A",
            "C17orf81",
            "SNRPE",
            "PDF",
            "MRPL45",
            "TMEM177",
            "MRPL43",
            "JAGN1",
            "SYNJ1",
            "MRPL50",
            "MRPL17",
            "MRPS11",
            "TMEM18",
            "POLR3K",
            "PRDX6",
            "NDUFA8",
            "FAM119A",
            "MLLT4",
            "SEC61B",
            "C7orf11",
            "CNO",
            "TRIAP1",
            "SUCLG1",
            "CISD1",
            "ABR",
            "HIVEP2",
            "ALG8",
            "C11orf10",
            "TXNL4A",
            "SNRPC",
            "ZSWIM6",
            "CHD9",
            "C14orf166",
            "MRPL18",
            "C11orf59",
            "HERC1",
            "GTF2E2",
            "SSH1",
            "METTL11A",
            "WIBG",
            "ZHX3",
            "KIAA0247",
            "SLC12A6",
            "MRPL46",
            "EDEM2",
            "ECHS1",
            "IQSEC1",
            "HIPK1",
            "HECA",
            "NDUFS3",
            "PCCB",
            "FRYL",
            "WDFY2",
            "MLL",
            "RABEPK",
            "ZFYVE26",
            "FAM103A1",
            "TTC3",
            "APC",
            "AFF1",
            "ZNF264",
            "UQCRC1",
            "MTF1",
            "MANBAL",
            "NIF3L1",
            "SKI",
            "PIGC",
            "SNUPN",
            "CDC123",
            "ATXN1",
            "SPEN",
            "YWHAE",
            "ERGIC3",
            "TLN1",
            "SPCS1",
            "PSMD9",
            "C2orf47",
            "EXOSC1",
            "COX4NB",
            "AAK1",
            "COPZ1",
            "RPP38",
            "BMPR2",
            "SEC13",
            "EVI5",
            "MRPL16",
            "MADD",
            "CIAPIN1",
            "MECP2",
            "PIKFYVE",
            "JAK1",
            "NME6",
            "SPTAN1",
            "MRPL44",
            "SUMO1",
            "CALR",
            "PRKRA",
            "TRAPPC10",
            "SON",
            "PHF23",
            "CUEDC2",
            "SDHAF2",
            "MORC3"
        ]
    },
    {
        "golabel": "MAFB_regulon_activity",
        "gene": [
            "DIRC1",
            "AIM2",
            "LILRA3",
            "IGSF21",
            "PLAU",
            "MMP9",
            "GPT2",
            "BEND6",
            "CD163",
            "FBXO32",
            "C10orf55",
            "GAL3ST1",
            "MGC12916",
            "SLC2A5",
            "CLEC2B",
            "LILRB4",
            "PDCD1LG2",
            "TFEC",
            "SLC1A3",
            "MS4A6A",
            "CYBB",
            "C1QB",
            "FCGR1A",
            "FCGR1C",
            "C9orf110",
            "FCGR3A",
            "GLIPR1",
            "FCGR1B",
            "C1QC",
            "CMKLR1",
            "LILRB2",
            "IL17RE",
            "C3AR1",
            "C1QA",
            "SIGLEC7",
            "ETV4",
            "PLEK",
            "HAPLN3",
            "LOXL3",
            "CD14",
            "TTC39A",
            "SIGLEC9",
            "SLAMF8",
            "CSF1R",
            "DSE",
            "FPR3",
            "TLR4",
            "STAB1",
            "LILRB1",
            "FCER1G",
            "DYSF",
            "PILRA",
            "IFI16",
            "LAIR1",
            "AIF1",
            "TMEM26",
            "LOC154761",
            "HAVCR2",
            "GAL3ST4",
            "NCKAP1L",
            "LRRC25",
            "FAM115C",
            "CD86",
            "FERMT3",
            "MMP15",
            "CD53",
            "CYTH4",
            "SLA",
            "GIMAP4",
            "LAPTM5",
            "FAM164C",
            "FLJ36031",
            "CD4",
            "LCP2",
            "WAS",
            "C1orf210",
            "SIRPA",
            "FAM20C",
            "FZD5",
            "ERBB3",
            "ARHGAP8",
            "FAAH2",
            "KIAA1949",
            "CCDC109A",
            "CTSB",
            "WIPF1",
            "HIP1R",
            "TICAM2",
            "PLEKHO2",
            "PARVB",
            "CPPED1",
            "PRKAB1",
            "MARCKS",
            "ESRP2",
            "C2orf34",
            "GAS8",
            "PDE8A",
            "PIP4K2A",
            "BCL7A",
            "GLT25D1",
            "TMEM41B",
            "CTPS2",
            "SETD6",
            "NTAN1",
            "TPST2",
            "DLG3",
            "PICALM",
            "RDH14",
            "MAX"
        ]
    },
    {
        "golabel": "MAML3_regulon_activity",
        "gene": [
            "CACNA1H",
            "MUC5B",
            "CCL8",
            "OTUD7A",
            "CXCL10",
            "APOBEC3B",
            "CXXC4",
            "LOC400759",
            "FAM26F",
            "RPL39L",
            "IRS2",
            "KLC3",
            "UBE2C",
            "SORBS2",
            "CKS2",
            "P2RY6",
            "PDE4D",
            "BATF3",
            "CCL3",
            "CCL4",
            "CCL4L2",
            "SETBP1",
            "RHEBL1",
            "MIR155HG",
            "C17orf67",
            "KBTBD11",
            "PLEKHF1",
            "PSMB9",
            "FCGR1A",
            "FCGR1C",
            "FCGR1B",
            "DOCK5",
            "HCST",
            "SECTM1",
            "SNX10",
            "C7orf40",
            "APOBEC3G",
            "MEIS2",
            "THRB",
            "PBX1",
            "FAM59A",
            "KIF13B",
            "STOX2",
            "PHF17",
            "MICB",
            "PTPRM",
            "NEO1",
            "RGS10",
            "IFT140",
            "PPIL5",
            "NFIA",
            "PCDH1",
            "C9orf46",
            "DBF4",
            "IRF5",
            "PSMB3",
            "HPRT1",
            "CPSF4",
            "DISC1",
            "SH3BP4",
            "TOMM5",
            "MAGI1",
            "SPRY1",
            "FBXO6",
            "CENPL",
            "VPS29",
            "MED10",
            "GNG10",
            "GALM",
            "CMTM4",
            "TUBA1C",
            "MRPL11",
            "MED30",
            "ZNF827",
            "SKA2",
            "TOMM40L",
            "LYN",
            "WDR53",
            "TRAK1",
            "TJP2",
            "PARP12",
            "PDZD11",
            "DRAP1",
            "LRBA",
            "SLC25A19",
            "BCAP29",
            "RGS19",
            "KIF1C",
            "CHD3",
            "LRP10",
            "C7orf70",
            "C17orf42",
            "HPS3",
            "KLF3",
            "SEC22A",
            "TET2",
            "CLTA",
            "EED",
            "DEGS1",
            "PRPF8",
            "MBD4",
            "ZCCHC14",
            "TBCK",
            "KIAA1967",
            "APTX",
            "VPS39",
            "MBTPS1",
            "USP47",
            "ATG3",
            "DYNC1LI2",
            "TADA2B",
            "ADD1"
        ]
    },
    {
        "golabel": "MATR3_regulon_activity",
        "gene": [
            "SLC17A9",
            "WDR17",
            "LOC388242",
            "PLEKHG6",
            "CEACAM19",
            "TMEM184A",
            "SNURF",
            "ADAP1",
            "TXNDC16",
            "PRKCDBP",
            "CDR2L",
            "LOC151534",
            "RPRD1A",
            "H2AFJ",
            "FAM175A",
            "DTX2",
            "COMMD10",
            "UNC93B1",
            "ZNF627",
            "ABCD1",
            "CHPF",
            "MAP3K10",
            "ZNF385A",
            "PKP3",
            "ST14",
            "PRR5",
            "TCIRG1",
            "NFKB2",
            "C16orf7",
            "CTSA",
            "F8A1",
            "NFKBIB",
            "KIAA0415",
            "KLHL28",
            "TMUB1",
            "PWWP2B",
            "AMDHD2",
            "HEATR7A",
            "TMX1",
            "FASTK",
            "BCAR1",
            "GAS2L1",
            "CHST12",
            "GLTPD1",
            "SLC25A1",
            "C7orf43",
            "DTWD2",
            "C5orf15",
            "C11orf24",
            "ARRDC1",
            "MBLAC2",
            "TAF9B",
            "PHF6",
            "RBBP9",
            "EFCAB7",
            "ANKRD13D",
            "BBS10",
            "PURA",
            "SSH3",
            "TSC22D4",
            "ISOC1",
            "KBTBD6",
            "KIAA1539",
            "SKP1",
            "BIN1",
            "DEK",
            "TMEM8A",
            "C19orf6",
            "TMEM102",
            "TRABD",
            "CLCN7",
            "SIPA1",
            "ANKHD1",
            "MED15",
            "RNPEPL1",
            "LYRM7",
            "UBTD2",
            "FAM172A",
            "CCDC112",
            "GRPEL2",
            "MAPK3",
            "GNPDA2",
            "ZFP1",
            "EXOC5",
            "ZNF184",
            "NUP160",
            "CTDSPL2",
            "DBT",
            "EPN1",
            "MIER3",
            "NUCKS1",
            "SH3GL1",
            "TRNT1",
            "GMPPA",
            "IKZF5",
            "SPNS1",
            "TESK1",
            "ZNF668",
            "MUTED",
            "NAP1L1",
            "C11orf46",
            "RBBP4",
            "ATP6V0C",
            "NCLN",
            "KIFAP3",
            "RBBP5",
            "ADRBK1",
            "C11orf58",
            "CDKN2AIP",
            "SCYL1",
            "C5orf24",
            "SMAD5",
            "TMEM104",
            "PAIP2",
            "DCTN4",
            "TYW3",
            "GABPA",
            "MOGS",
            "CWC27",
            "ARMCX5",
            "LARS",
            "METT5D1",
            "MAP3K11",
            "CEP57",
            "RBMXL1",
            "STAG2",
            "PPP2R5C",
            "EPC2",
            "PPM1A",
            "PAPOLG",
            "NUP133",
            "DHX15",
            "HNRNPA0",
            "RBM27",
            "TMEM214",
            "CUL5",
            "CSNK1G3",
            "HECTD3",
            "CAPRIN1",
            "TROVE2",
            "CDC73",
            "UBE2D2",
            "AGGF1",
            "CDC23",
            "ECD",
            "RBM22",
            "RBMX",
            "CREB1"
        ]
    },
    {
        "golabel": "MAZ_regulon_activity",
        "gene": [
            "HES6",
            "SIX2",
            "CBX2",
            "LOC100133985",
            "IDH2",
            "E2F1",
            "PAG1",
            "KIAA0114",
            "SGPP2",
            "LIPT2",
            "C16orf59",
            "SHMT2",
            "SGMS2",
            "ZNF771",
            "YDJC",
            "BOLA2",
            "ATP6V1E2",
            "SOX12",
            "MRPS26",
            "RAB27A",
            "PUSL1",
            "CFLAR",
            "PTMS",
            "TGFBR2",
            "TIGD5",
            "COL4A3BP",
            "SAC3D1",
            "KAT2B",
            "C5orf41",
            "CBX8",
            "SPAG9",
            "KIF22",
            "ZNF768",
            "RCC2",
            "ZMYND19",
            "TMEM201",
            "PPP4C",
            "OSTM1",
            "FAM189B",
            "PGP",
            "KDM1A",
            "TAOK3",
            "DDX49",
            "C16orf53",
            "C3orf64",
            "POLK",
            "C6orf211",
            "IQGAP1",
            "CAST",
            "C16orf88",
            "SAMD1",
            "BANP",
            "TIMM44",
            "NUDC",
            "TUFM",
            "SPNS1",
            "ELF1",
            "MCRS1",
            "UBE2J2",
            "RNF187",
            "SNRPA",
            "SERINC1",
            "PRCC",
            "SMARCD2",
            "NAIF1",
            "KIAA2013",
            "RNPS1",
            "GPATCH3",
            "RNF220",
            "DAZAP1",
            "RBM4"
        ]
    },
    {
        "golabel": "MBD3_regulon_activity",
        "gene": [
            "PSPN",
            "PRSS53",
            "C19orf23",
            "C19orf76",
            "PRR22",
            "SOX18",
            "PPP1R3F",
            "CXADR",
            "P2RY11",
            "MBLAC1",
            "LRDD",
            "PTPLB",
            "CDKN2D",
            "SLC35A3",
            "DENND1B",
            "SPRN",
            "SLC30A1",
            "ZNF775",
            "SPPL2B",
            "FBXL20",
            "SMTN",
            "TRUB1",
            "LRRC45",
            "SLC19A1",
            "FUT10",
            "HRAS",
            "TMED5",
            "TMUB1",
            "SLC35F5",
            "ZDHHC8",
            "CD46",
            "DOT1L",
            "TOM1L1",
            "ZNF468",
            "ZNF816A",
            "DOHH",
            "TOR1AIP2",
            "KLC2",
            "TELO2",
            "ZNF414",
            "PPP1R12C",
            "FPGT",
            "CHM",
            "OGFR",
            "HBP1",
            "ACBD5",
            "PLEKHJ1",
            "SF3A2",
            "ARHGAP12",
            "C19orf6",
            "PQLC1",
            "DGKZ",
            "TAF1B",
            "UEVLD",
            "C6orf211",
            "LONP1",
            "PKN1",
            "C17orf70",
            "RILPL1",
            "MIER3",
            "HDGFRP2",
            "TESK1",
            "TAF6L",
            "ZNF668",
            "APBA3",
            "ACOX1",
            "BLZF1",
            "NCLN",
            "REXO1",
            "VEZT",
            "TSSC4",
            "MPP5",
            "ELF1",
            "CSNK1G2",
            "TMEM87B",
            "COPB1",
            "C19orf29",
            "POLR2E",
            "RHOT1",
            "KIAA0776",
            "SGTA",
            "PRPF31",
            "VPS35",
            "STAM2",
            "ZNF148",
            "CDC73",
            "SMEK2",
            "MARCH7",
            "PLEKHA3",
            "SP3",
            "SAFB",
            "DAZAP1",
            "RANBP3"
        ]
    },
    {
        "golabel": "MBNL1_regulon_activity",
        "gene": [
            "TMEM14E",
            "RCOR2",
            "VAX2",
            "TIPARP",
            "LOC401093",
            "PITPNC1",
            "LMO3",
            "IFT57",
            "EPDR1",
            "MAGI3",
            "MEF2C",
            "TP53INP2",
            "SEC61A2",
            "KLHL25",
            "IFT80",
            "C17orf28",
            "TGFBR2",
            "LTA4H",
            "NUDT16",
            "LRP5",
            "CD47",
            "CTSO",
            "ATG4D",
            "MSN",
            "PUS10",
            "PTDSS2",
            "KLC2",
            "C3orf23",
            "MFSD9",
            "TMEM8A",
            "TRIM23",
            "PHC3",
            "TMEM43",
            "GPR137",
            "HM13",
            "DPP3",
            "STRN4",
            "ZNF777",
            "PTEN"
        ]
    },
    {
        "golabel": "MBNL2_regulon_activity",
        "gene": [
            "C1QTNF7",
            "TROAP",
            "ESPL1",
            "UBE2S",
            "RECQL4",
            "E2F1",
            "SPAG5",
            "PKMYT1",
            "ECM2",
            "EME1",
            "MCM7",
            "PSRC1",
            "NFKBIL2",
            "C9orf100",
            "CDK14",
            "C16orf59",
            "SLC29A2",
            "TSC22D1",
            "PPP2R3B",
            "TRAIP",
            "CD59",
            "CPSF4",
            "PLSCR4",
            "DOCK9",
            "STARD13",
            "H2AFX",
            "POLE",
            "NDFIP2",
            "KAT2A",
            "TGDS",
            "UBL3",
            "C11orf84",
            "PUS1",
            "PTCD1",
            "LRWD1",
            "CLN5",
            "KLC2",
            "PIBF1",
            "DHX37",
            "KIAA0040",
            "TM9SF2",
            "ABHD13",
            "DNAJC3",
            "LMBRD1",
            "NOC4L",
            "FBXL17",
            "RIN2",
            "FBXL3",
            "SH3D19",
            "TRIM13",
            "TPP2",
            "ERCC5",
            "SRRT",
            "ELF1",
            "DIS3",
            "GABPA",
            "SERINC1",
            "COPS7B"
        ]
    },
    {
        "golabel": "MCM2_regulon_activity",
        "gene": [
            "SLC6A15",
            "GABRQ",
            "KCNH5",
            "C1QL4",
            "ALX1",
            "FAM171A2",
            "C1QL1",
            "GDF1",
            "HSPC072",
            "DLX6AS",
            "RIMS2",
            "DLX6",
            "NXPH4",
            "TAL2",
            "FOXD3",
            "MKRN3",
            "C6orf195",
            "SLC26A9",
            "CDKN2A",
            "HOXA10",
            "CCNE1",
            "APOBEC3B",
            "RIBC2",
            "SFTPB",
            "SYCE2",
            "PHGDH",
            "RPL39L",
            "SKP2",
            "NOSTRIN",
            "AHCYL2",
            "CAPN8",
            "TPX2",
            "RHEBL1",
            "MPP6",
            "CDC6",
            "TPI1P2",
            "RAD54L",
            "KIAA1524",
            "KBTBD11",
            "FOXRED2",
            "C1orf59",
            "MLPH",
            "TNFRSF10C",
            "CDC7",
            "MCM7",
            "RFC4",
            "SIAE",
            "MCM4",
            "TCF19",
            "MUC1",
            "XYLB",
            "C16orf75",
            "PTPRM",
            "MOSC2",
            "GINS3",
            "FIGNL1",
            "HLTF",
            "RCC1",
            "MCM6",
            "C17orf91",
            "ACTL6A",
            "GATC",
            "TOPBP1",
            "MSRA",
            "C3orf26",
            "MCM5",
            "FBXO45",
            "MCM3",
            "YEATS2",
            "GMPS",
            "TUBB",
            "CDK2",
            "POLA2",
            "LSG1",
            "CPEB2",
            "UNG",
            "WDR53",
            "RUVBL1",
            "RETSAT",
            "DPH2",
            "PSMD2",
            "KIAA0090",
            "OPA1",
            "POLE3",
            "NAA50",
            "UMPS",
            "PCBD2",
            "RNF26",
            "C16orf88",
            "SNRNP40",
            "REEP5",
            "RBBP7",
            "SAE1",
            "QTRTD1",
            "C3orf37",
            "KPNA1",
            "NUP93",
            "ISY1",
            "TRA2B"
        ]
    },
    {
        "golabel": "MCM6_regulon_activity",
        "gene": [
            "ISM2",
            "RIPPLY2",
            "RIMS2",
            "FOXD3",
            "COCH",
            "ERN2",
            "VSIG2",
            "CDKN2A",
            "AQP7",
            "DMC1",
            "RNF157",
            "APOBEC3B",
            "SFTPB",
            "SYCE2",
            "KLF15",
            "LOC728819",
            "SPC24",
            "REEP2",
            "PRICKLE4",
            "CCNE2",
            "IRX3",
            "LDHD",
            "SLC22A3",
            "GPR19",
            "PARM1",
            "RHOBTB2",
            "KCNQ1",
            "UBXN10",
            "ORC1L",
            "RHEBL1",
            "RAET1K",
            "MECOM",
            "CDC6",
            "CKAP2L",
            "BRIP1",
            "BUB1",
            "SLC44A4",
            "RAPGEF3",
            "CCDC138",
            "TYMS",
            "C5orf34",
            "TBX2",
            "MLPH",
            "MCM2",
            "PXMP4",
            "MLF1IP",
            "TNFRSF10C",
            "CDC7",
            "PDK3",
            "ZNF93",
            "MMD",
            "WDR76",
            "MOSC2",
            "KLHL5",
            "CHAF1B",
            "FRAT1",
            "TRIM59",
            "FIGNL1",
            "GLMN",
            "RBBP8",
            "HPRT1",
            "SLC9A3R2",
            "RPA3",
            "SLC20A1",
            "SUGT1L1",
            "GPSM2",
            "UBA2",
            "MSH2",
            "DONSON",
            "ARL6IP6",
            "C6orf182",
            "TMEM194B",
            "DSN1",
            "ZNF530",
            "GPN1",
            "SKA2",
            "POLA2",
            "ALS2CR4",
            "KLC4",
            "LRRC27",
            "POT1",
            "MSH6",
            "PNPLA2",
            "CALCOCO1",
            "TXNDC11",
            "ZNF131",
            "CES2",
            "PHTF2",
            "CRELD1",
            "TTL",
            "SLBP",
            "TMEM185B",
            "TMEM209",
            "SIDT2",
            "MLYCD",
            "VRK2",
            "POLR2D",
            "RAD51C",
            "FARSB",
            "R3HDM1",
            "CPSF3",
            "HAT1",
            "SAE1",
            "WDR75",
            "SPRYD3",
            "FAF1",
            "BET1L",
            "PRPF40A"
        ]
    },
    {
        "golabel": "MCM8_regulon_activity",
        "gene": [
            "SELV",
            "DLX2",
            "MAGEA9B",
            "HSPC072",
            "DLX6AS",
            "MKRN3",
            "GPR158",
            "LOC730101",
            "CLIC3",
            "CLSPN",
            "CIB2",
            "C15orf42",
            "AK1",
            "POLQ",
            "CLTCL1",
            "KIF23",
            "PLCB1",
            "GINS1",
            "BLM",
            "ERMP1",
            "FBP1",
            "ATAD5",
            "BOK",
            "KNTC1",
            "FANCI",
            "ZNF519",
            "TIMELESS",
            "ZNF286A",
            "ZDHHC23",
            "PCNA",
            "MID1IP1",
            "RILP",
            "GBGT1",
            "RNF24",
            "TNFSF13",
            "TTLL4",
            "CSNK2A1P",
            "TET3",
            "MDC1",
            "NOP56",
            "ANKRD5",
            "ABHD14B",
            "TRMT6",
            "PMVK",
            "ESF1",
            "ZNF146",
            "ACAA1",
            "TNFSF12",
            "C20orf72",
            "ZNF473",
            "STK35",
            "POLR3F",
            "CSNK2A1",
            "ZNF343",
            "ALAD",
            "MRE11A",
            "ZNF326",
            "DHX35",
            "DHX57",
            "FAM82A2",
            "GPR108",
            "ANXA11"
        ]
    },
    {
        "golabel": "MDM4_regulon_activity",
        "gene": [
            "C12orf27",
            "SLC26A5",
            "MST1P9",
            "TDRD10",
            "KRTAP5-7",
            "PRO0628",
            "TEDDM1",
            "KRTAP5-10",
            "LOC220594",
            "NCRNA00202",
            "KRTAP5-8",
            "TFAP2E",
            "AMAC1L3",
            "LOC162632",
            "FLJ12825",
            "OR10AD1",
            "SMCR5",
            "C6orf41",
            "OVGP1",
            "NCRNA00173",
            "AMAC1L2",
            "LRIT3",
            "SLC6A16",
            "SLC25A27",
            "PDZK1P1",
            "CMAH",
            "C15orf28",
            "MIR17HG",
            "HCG2P7",
            "LHX4",
            "GOLGA8B",
            "C10orf110",
            "RRN3P1",
            "C10orf68",
            "GOLGA2B",
            "CDRT15P",
            "MALAT1",
            "UCP3",
            "B3GAT2",
            "ASB16",
            "GNRH1",
            "TRPV1",
            "NCRNA00201",
            "OCLM",
            "CSAD",
            "GOLGA6L9",
            "RUNDC2C",
            "AHSA2",
            "CATSPER2",
            "C1orf104",
            "LOC100190986",
            "AGAP5",
            "GOLGA6L10",
            "TRIM78P",
            "LOC100272146",
            "LOC100130557",
            "LOC400927",
            "ABCA5",
            "HMGN3",
            "WHAMML1",
            "CG030",
            "LOC100128288",
            "HSD17B7P2",
            "AGAP6",
            "C2orf63",
            "BMS1P4",
            "ZNF692",
            "LOC253724",
            "LOC388692",
            "AGAP4",
            "TRAF5",
            "TES",
            "C11orf61",
            "BMS1P5",
            "ZNF397OS",
            "FLJ44606",
            "DNAJB1",
            "SUGT1L1",
            "LOC200030",
            "ATF7IP2",
            "CDRT4",
            "NKTR",
            "AFG3L1",
            "CALU",
            "PLIN3",
            "SPATS2L",
            "ZMYND17",
            "KIAA0907",
            "FAM114A1",
            "LOC253039",
            "AVL9",
            "RPAIN",
            "SFRS18",
            "RUFY3",
            "RBM6",
            "AHI1",
            "CORO1C",
            "PKM2",
            "LUC7L3",
            "PGM1",
            "C17orf68",
            "ZNF224",
            "POLI",
            "NAA16",
            "CANT1",
            "OFD1",
            "TTC13",
            "LOC400657",
            "PSMD2",
            "C14orf138",
            "AMFR",
            "ZNF193",
            "PGAM1",
            "RG9MTD3",
            "FNBP4",
            "ZNF33A",
            "UPF3A",
            "RBM5",
            "PCYT1A",
            "SEPSECS",
            "RCOR3",
            "DDX17",
            "LUZP6",
            "LDB1",
            "N4BP2L2",
            "BAT1",
            "DFFA",
            "PAN3",
            "ZC3H11A",
            "DCAF8",
            "MLH3",
            "SCAND2",
            "REV1",
            "SFRS12",
            "MAT2A",
            "MUL1",
            "RBM39",
            "ZNF18",
            "ICMT",
            "C22orf28",
            "CCNT2",
            "ZC3H7A",
            "USPL1",
            "RAB5C",
            "RC3H1",
            "WDR1",
            "TTC31",
            "GNB1",
            "HNRPDL"
        ]
    },
    {
        "golabel": "MECOM_regulon_activity",
        "gene": [
            "PGC",
            "GKN2",
            "BCAS1",
            "PLA2G10",
            "ERN2",
            "C16orf89",
            "CACNA2D2",
            "DUOX1",
            "GEM",
            "DUOXA1",
            "SFTPB",
            "TMEM163",
            "CNTN3",
            "SEMA4G",
            "MAOA",
            "TFCP2L1",
            "ACSM3",
            "ANLN",
            "C9orf152",
            "SORBS2",
            "GINS2",
            "PDE4D",
            "SELENBP1",
            "AHCYL2",
            "KCNQ1",
            "C2",
            "CENPI",
            "GMPR",
            "C11orf82",
            "SLC44A4",
            "KIF4A",
            "SH3BGRL2",
            "TOB1",
            "TBC1D2",
            "GTSE1",
            "CHEK1",
            "LARGE",
            "RNF145",
            "MMD",
            "NR3C2",
            "ABLIM1",
            "ALDH2",
            "FOXO1",
            "CYFIP2",
            "BAG1",
            "KPNA2",
            "RNASEH2A",
            "SNX8",
            "FRAT1",
            "CHP",
            "CMTM3",
            "MLLT3",
            "ERBB3",
            "LIMD1",
            "MCM6",
            "NUDT1",
            "CXCL16",
            "POLA2",
            "TUBA1B",
            "ZNF33B",
            "CDC34",
            "GNA12",
            "KLHL7",
            "HSD17B4",
            "ATP9B",
            "PARN",
            "C7orf70",
            "SEPT7",
            "LRRFIP2"
        ]
    },
    {
        "golabel": "MECP2_regulon_activity",
        "gene": [
            "LOC158696",
            "LOC285593",
            "GPRASP1",
            "C1orf31",
            "LYPLA1",
            "CBX6",
            "C9orf45",
            "CD99L2",
            "PLXNA3",
            "C14orf129",
            "CBX7",
            "IDS",
            "HSFX2",
            "ZNF862",
            "GLRX3",
            "OSTC",
            "PKD1",
            "TXNDC9",
            "ATP5G3",
            "CYB561D1",
            "MRPS10",
            "MACF1",
            "MLLT6",
            "ZNF395",
            "EIF5AL1",
            "ETFA",
            "TFB1M",
            "KCTD7",
            "BPNT1",
            "ZNF275",
            "HERC1",
            "BAT2L1",
            "GDI1",
            "ZHX3",
            "ZZEF1",
            "MMADHC",
            "MLL",
            "MAP3K3",
            "C6orf153",
            "TIMM17A",
            "EIF4A1",
            "TAF1",
            "FMR1",
            "C2orf47",
            "TBC1D9B",
            "GTF2F2",
            "HTATSF1",
            "RBM34",
            "MTMR1",
            "MED22",
            "ATP6AP1",
            "RAB1A"
        ]
    },
    {
        "golabel": "MED1_regulon_activity",
        "gene": [
            "ADAM22",
            "LMTK2",
            "C12orf57",
            "COX7A1",
            "ZNF221",
            "HYI",
            "SSR4",
            "FNDC8",
            "PPDPF",
            "CYBA",
            "PSMB10",
            "SOCS7",
            "TAOK1",
            "BRWD3",
            "BLOC1S1",
            "UBXN7",
            "KLHL11",
            "PRKDC",
            "CDK12",
            "ZNF32",
            "ACYP2",
            "TCEB2",
            "SBNO1",
            "FBXL20",
            "STRN",
            "RC3H2",
            "RIF1",
            "CD63",
            "NLN",
            "DHX33",
            "CCDC107",
            "ASXL2",
            "ZNF688",
            "IGF2R",
            "POLR1A",
            "SMC3",
            "CKAP5",
            "ACACA",
            "C9orf95",
            "ACLY",
            "UHRF1BP1",
            "TMEM219",
            "RSF1",
            "NSF",
            "ANAPC1",
            "MFSD9",
            "RAB4B",
            "SERPINB6",
            "AP2B1",
            "SUZ12",
            "KDM1B",
            "NUP153",
            "ZC3H13",
            "AKR1A1",
            "TAX1BP3",
            "NF1",
            "INTS2",
            "UGGT1",
            "WIPF2",
            "NPEPPS",
            "POLR1B",
            "RNMT",
            "PTPN11",
            "TP53BP1",
            "RALBP1",
            "C10orf18",
            "RNF113A",
            "KIAA0100",
            "OCRL",
            "C1orf123",
            "FTSJ3",
            "TAF3",
            "CASC3",
            "CSNK1G1",
            "KPNB1",
            "MSL1",
            "ZFYVE21",
            "RFC1",
            "PIP4K2B",
            "TRIP12",
            "CWC25",
            "QTRTD1",
            "XPO7",
            "GPATCH8",
            "NUFIP2",
            "PSME3",
            "C17orf71",
            "SRBD1",
            "SAP130",
            "DHX8",
            "DDX46",
            "GOSR1",
            "NBR1",
            "TPRA1",
            "VPRBP",
            "HNRNPR",
            "RUNDC1",
            "DHX9",
            "BECN1",
            "RBM12"
        ]
    },
    {
        "golabel": "MED13_regulon_activity",
        "gene": [
            "FIGNL2",
            "ANKRD31",
            "SLC12A2",
            "PRKCA",
            "CRIP1",
            "C7orf59",
            "CYBA",
            "ZNHIT1",
            "FGD6",
            "ATP6V0B",
            "USP13",
            "SCAND1",
            "ACVR1B",
            "TANC2",
            "WNK1",
            "GIYD2",
            "AGTRAP",
            "TSPO",
            "SMPD2",
            "COMT",
            "RABAC1",
            "FAM190B",
            "STXBP4",
            "SPAG9",
            "AURKAIP1",
            "EML4",
            "ARRDC1",
            "C17orf81",
            "TFPT",
            "AKAP1",
            "NIPA1",
            "CCDC12",
            "EEA1",
            "TOP1",
            "TAX1BP3",
            "NF1",
            "NUDT22",
            "HEATR6",
            "INTS2",
            "BDP1",
            "USP32",
            "MED14",
            "ABCB8",
            "RPS6KB1",
            "DYNLL2",
            "SLC25A11",
            "PPM1D",
            "BPTF",
            "DDX28",
            "CCDC47",
            "ACOX1",
            "MYST2",
            "PDS5A",
            "PRKAR1A",
            "TEX2",
            "CLTC",
            "VEZF1",
            "UBXN1",
            "DCAF7",
            "PPM1B",
            "APPBP2",
            "SRP68",
            "TLK2",
            "ANKRD40",
            "FBXO11",
            "AMMECR1L"
        ]
    },
    {
        "golabel": "MED15_regulon_activity",
        "gene": [
            "LHB",
            "TBX1",
            "UBE2NL",
            "RNF180",
            "UNC13D",
            "C1orf170",
            "PLEKHN1",
            "RIN1",
            "C1orf113",
            "EVPL",
            "RTN4R",
            "MICALL2",
            "PLEC",
            "PPP1R13L",
            "PDLIM7",
            "CGRRF1",
            "HSBP1",
            "CRIPT",
            "AGRN",
            "CRKL",
            "TYMP",
            "DTX2",
            "INF2",
            "FECH",
            "UBE2W",
            "CDC42BPG",
            "SLC19A2",
            "INTS1",
            "SCOC",
            "C18orf32",
            "RHBDF2",
            "MAST2",
            "CCM2",
            "DVL1",
            "BCL9L",
            "MAP3K6",
            "TBC1D15",
            "PLXNB2",
            "COMT",
            "IQCE",
            "KIAA0284",
            "PHOSPHO2",
            "PXN",
            "SH3BP1",
            "MYNN",
            "MANEA",
            "PDXK",
            "ZMIZ2",
            "TMC6",
            "MAD1L1",
            "EHD1",
            "ZDHHC8",
            "BCAR1",
            "GAS2L1",
            "DEF6",
            "IFT52",
            "SLC25A1",
            "C7orf43",
            "DAPK3",
            "IKBKE",
            "ASCC2",
            "LZTR1",
            "TSNAX",
            "RECQL5",
            "EHBP1L1",
            "NDOR1",
            "SOLH",
            "COX19",
            "ZNF252",
            "SRP9",
            "TTC33",
            "PPARD",
            "OGFR",
            "COX11",
            "NSL1",
            "RPS6KA4",
            "MOBKL3",
            "LMF2",
            "PLCB3",
            "TRIOBP",
            "DYM",
            "DGCR2",
            "THAP1",
            "RANGAP1",
            "PCSK7",
            "MKL1",
            "MOV10",
            "DGKZ",
            "ZNF22",
            "TTC7A",
            "PIGN",
            "DGCR14",
            "ARL5A",
            "HDAC7",
            "ZFP1",
            "PCNP",
            "CNOT7",
            "PPM1D",
            "UBE2L3",
            "CNST",
            "C9orf80",
            "FXC1",
            "ASNSD1",
            "PFKL",
            "C11orf46",
            "HGS",
            "FAM108B1",
            "ISCA1",
            "C11orf58",
            "CSK",
            "EIF1B",
            "CDC37",
            "CYTH1",
            "PAIP2",
            "ARHGDIA",
            "PPP1R9B",
            "THAP9",
            "PRKRA",
            "FRMD8",
            "MAP3K11",
            "MARCH5",
            "C1orf55",
            "RHOT1",
            "PPM1A",
            "RFWD2",
            "API5",
            "EWSR1",
            "RPP14",
            "MATR3"
        ]
    },
    {
        "golabel": "MED26_regulon_activity",
        "gene": [
            "CPAMD8",
            "DLX3",
            "ICAM5",
            "RNF133",
            "SUSD4",
            "C19orf18",
            "CACNB1",
            "PFN2",
            "LOC284837",
            "AUTS2",
            "SLC39A14",
            "STARD4",
            "GNG7",
            "POC1B",
            "RAB3A",
            "MTFR1",
            "EPT1",
            "LOC284440",
            "PGK1",
            "JUND",
            "SLC27A1",
            "MAPK6",
            "LOC90110",
            "SLC25A42",
            "C19orf44",
            "DARS2",
            "ARMC1",
            "CCDC102A",
            "ATP5B",
            "PDIA6",
            "ERLIN1",
            "TMED2",
            "YIPF6",
            "PGPEP1",
            "DYNLT3",
            "FUCA2",
            "ZNF362",
            "WSB2",
            "KLHL26",
            "PIK3R2",
            "MAP1S",
            "ZBTB43",
            "SIN3B",
            "MLLT1",
            "AKAP8L",
            "NDUFS1",
            "UPF1",
            "AAGAB",
            "TMED10P1",
            "MINPP1",
            "TYK2",
            "AP1AR",
            "CHERP",
            "RFX1",
            "SLC35E1",
            "ZER1",
            "ELL",
            "KIAA0892",
            "XAB2",
            "AP1M1",
            "MAPKAPK5",
            "EPS15L1",
            "CDK9",
            "C6orf47",
            "IMMT",
            "SF4"
        ]
    },
    {
        "golabel": "MEF2A_regulon_activity",
        "gene": [
            "SCN7A",
            "ITGA8",
            "VPS37D",
            "FAT4",
            "ROMO1",
            "FAM195A",
            "ECE2",
            "TIMM16",
            "C16orf59",
            "TIMM17B",
            "SYNM",
            "ARHGAP31",
            "PAFAH1B3",
            "YDJC",
            "MRPL52",
            "RNASEH2A",
            "C11orf83",
            "FAM158A",
            "BOLA2",
            "DTYMK",
            "POP7",
            "EBP",
            "NAA10",
            "TGFBR2",
            "MRPL12",
            "PSMB5",
            "PFDN6",
            "SAC3D1",
            "HMBS",
            "PIK3R1",
            "DDX39",
            "STOML2",
            "C5orf41",
            "RPP21",
            "PSMA7",
            "SGK269",
            "SNRNP25",
            "AURKAIP1",
            "MRPL2",
            "PSMB4",
            "MTX1",
            "FLAD1",
            "VPS13C",
            "TBRG4",
            "BANF1",
            "PSMD4",
            "OBFC2B",
            "FAM13B",
            "SNRPC",
            "TBC1D2B",
            "DENND4A",
            "HSD17B10",
            "RAPGEF2",
            "JMJD1C",
            "IQGAP1",
            "AHSA1",
            "RCE1",
            "WDFY3",
            "BMPR2",
            "CRTC3",
            "FAM178A",
            "CENPC1",
            "HMG20A"
        ]
    },
    {
        "golabel": "MEF2C_regulon_activity",
        "gene": [
            "HTR4",
            "AKR1C2",
            "KIAA0408",
            "CYS1",
            "HAL",
            "S100P",
            "CARD14",
            "TRIM16L",
            "PVRL3",
            "HLF",
            "ARHGEF4",
            "FGL2",
            "CYTH3",
            "CD1C",
            "ATP13A4",
            "GCNT4",
            "ROS1",
            "RCAN2",
            "SIGLECP3",
            "CPA3",
            "MS4A2",
            "ARHGAP20",
            "TPSB2",
            "HPGDS",
            "CX3CL1",
            "GPR116",
            "CYSLTR1",
            "C12orf69",
            "TPSAB1",
            "COLEC12",
            "EFEMP1",
            "IFT57",
            "ETV1",
            "ATP10A",
            "CDKL1",
            "ADRB2",
            "RBMS3",
            "PRKCA",
            "GAPT",
            "CBLC",
            "TLR2",
            "FAT4",
            "ENG",
            "EMB",
            "SHROOM4",
            "PAG1",
            "LOC647121",
            "PTPRG",
            "EPN3",
            "ANKRD44",
            "VIM",
            "TXNIP",
            "BTK",
            "ITGA4",
            "GNG7",
            "KRT8",
            "BDH1",
            "ARHGAP31",
            "FLI1",
            "RGL1",
            "TP53INP1",
            "ZNF608",
            "TMEM173",
            "SSBP2",
            "ARHGEF6",
            "C20orf24",
            "SNX18",
            "JUP",
            "CATSPER2P1",
            "ZFP36L1",
            "ARHGEF9",
            "GNG2",
            "CCDC46",
            "CNN3",
            "PKP3",
            "FRMD4B",
            "RCCD1",
            "SNRPA1",
            "KAT2B",
            "ACSL3",
            "CTSO",
            "LYST",
            "ZNF441",
            "WDR45L",
            "MSN",
            "SFXN3",
            "IFNAR2",
            "VAPB",
            "SYNJ1",
            "MBNL1",
            "MAP3K1",
            "RPN2",
            "MLF2",
            "RGS3",
            "TRIM23",
            "TRAK2",
            "TMEM43",
            "USP25",
            "MED24",
            "GMEB2",
            "CRTAP",
            "BANP",
            "FCHSD2",
            "SMPD4",
            "ZFP64",
            "COASY",
            "GSK3A",
            "DDX23",
            "MAEA",
            "IFNAR1"
        ]
    },
    {
        "golabel": "MEF2D_regulon_activity",
        "gene": [
            "MSLN",
            "KLHL30",
            "FASN",
            "C6orf141",
            "SYT7",
            "IRS2",
            "RLN2",
            "LOC100132111",
            "ALDH3B1",
            "SIK1",
            "FAM176A",
            "PLEKHG2",
            "PSPH",
            "LPIN2",
            "SCNN1A",
            "PTTG1",
            "PDK3",
            "CGN",
            "PPIL5",
            "ARL4A",
            "FAM118B",
            "EPAS1",
            "COMMD8",
            "NOTCH3",
            "TBL1X",
            "PBXIP1",
            "TSPAN6",
            "MED28",
            "PIM3",
            "BOD1",
            "PITPNM1",
            "LOC401397",
            "MTHFR",
            "CCDC126",
            "TMX1",
            "RABL5",
            "C7orf44",
            "PEX3",
            "LSM5",
            "KIAA0649",
            "PSMA2",
            "LMNA",
            "ZNF687",
            "C4orf27",
            "ZBTB7B",
            "GNPDA1",
            "SEC16A",
            "RREB1",
            "KIAA0913",
            "NMNAT1",
            "NUP54",
            "WDR41",
            "NCSTN",
            "VMA21",
            "MAPKSP1",
            "GOLGA2",
            "LARP4B",
            "ARHGEF11",
            "EIF3M",
            "RNF44",
            "ENOPH1",
            "ABL1",
            "MRPS18C",
            "MNT",
            "ATG9A",
            "IP6K1"
        ]
    },
    {
        "golabel": "MEN1_regulon_activity",
        "gene": [
            "RTN4RL2",
            "FHL5",
            "CCDC87",
            "TIGD3",
            "LOC339524",
            "MCTP1",
            "P2RY14",
            "FOXRED2",
            "SPTBN2",
            "ARRDC3",
            "ACSL4",
            "FOXO1",
            "SLC29A2",
            "TSC22D1",
            "DHCR7",
            "DAGLA",
            "ZNF512B",
            "NASP",
            "FCHO2",
            "AZI1",
            "MAST2",
            "KAT2A",
            "CCHCR1",
            "ZNF696",
            "RAD9A",
            "SAC3D1",
            "C11orf84",
            "FBXL19",
            "SERPINB8",
            "CLPB",
            "PTCD1",
            "PCGF5",
            "TUBG1",
            "RIOK3",
            "LRRC45",
            "MAP4K2",
            "ATAD3A",
            "PLEKHH3",
            "SLC25A22",
            "DCPS",
            "CCDC50",
            "C7orf27",
            "CCDC86",
            "PPIL2",
            "ITM2B",
            "TAF6",
            "TRMT61A",
            "TMEM201",
            "SEPT10",
            "NAA40",
            "KLC2",
            "CCNDBP1",
            "OTUD1",
            "FAM189B",
            "CCDC137",
            "YPEL5",
            "SKP1",
            "NEK7",
            "NOC2L",
            "MAT2B",
            "PLCB3",
            "FAM86C",
            "PAAF1",
            "YAF2",
            "SH3BGRL",
            "ATP13A2",
            "FBXL5",
            "RNF26",
            "NFRKB",
            "RNF14",
            "GIT1",
            "C6orf211",
            "FBXL17",
            "C17orf70",
            "TMED7",
            "NCDN",
            "PMS2",
            "ATG2A",
            "PPP2CB",
            "TANK",
            "UBE2B",
            "UBE2O",
            "SART1",
            "MAP1LC3B",
            "PCNXL3",
            "TAF6L",
            "PWP2",
            "SYVN1",
            "ZFPL1",
            "TUT1",
            "SRRT",
            "STX7",
            "FOXK2",
            "ZNF282",
            "SCYL1",
            "CHERP",
            "VPS37C",
            "FAM160B1",
            "COASY",
            "MARK2",
            "PRPF19",
            "PRKCSH",
            "SHOC2",
            "SNAP23",
            "SKIV2L",
            "PPP3CB",
            "PLDN",
            "DNAJC11",
            "ABI1",
            "RHOA",
            "BTBD1",
            "MTA2",
            "EIF1AD",
            "SF3B2",
            "RBM14",
            "SF1"
        ]
    },
    {
        "golabel": "MGA_regulon_activity",
        "gene": [
            "NR6A1",
            "SNORD116-4",
            "VAMP5",
            "C4orf48",
            "C19orf38",
            "GUK1",
            "SOCS7",
            "ZNF518B",
            "GPX1",
            "ZFYVE9",
            "TSPO",
            "MSI2",
            "C9orf89",
            "C19orf70",
            "SFMBT1",
            "GPX4",
            "REST",
            "NINJ1",
            "JOSD2",
            "ESF1",
            "TUBGCP5",
            "ELK4",
            "ZFP106",
            "FAM98B",
            "TSPAN17",
            "ZNF507",
            "RMND5A",
            "NUP153",
            "SNAPC2",
            "OAZ1",
            "MARCH2",
            "FAM108A1",
            "RNMT",
            "TP53BP1",
            "PHF3",
            "SPEN",
            "BPTF",
            "PRDM10",
            "ZNF609",
            "ARID2",
            "FAM168B",
            "RANBP2",
            "ZSCAN29",
            "NSD1",
            "RHOG",
            "PIKFYVE",
            "C11orf17",
            "INO80",
            "SIN3A",
            "CWC22",
            "RBBP6",
            "CTCF"
        ]
    },
    {
        "golabel": "MIER1_regulon_activity",
        "gene": [
            "P2RY12",
            "CLEC4A",
            "GPR34",
            "EVI2A",
            "RGS18",
            "ZNF702P",
            "KSR1",
            "OPLAH",
            "C5orf62",
            "C7orf60",
            "DPYD",
            "KBTBD8",
            "AP1S2",
            "TRAM1",
            "ITGAV",
            "MXRA7",
            "PRPF40B",
            "SPRED1",
            "TXNRD2",
            "ZNF430",
            "NRIP1",
            "CNN3",
            "GNG12",
            "FBRSL1",
            "TRAPPC9",
            "ARHGAP18",
            "KLHDC4",
            "C6orf136",
            "CD47",
            "SFRS16",
            "IFIT5",
            "RHBDD3",
            "GLTSCR1",
            "RIOK3",
            "BCL10",
            "PWWP2B",
            "GLO1",
            "ARL6IP5",
            "DHX34",
            "PPT1",
            "IRF2BP1",
            "CTBS",
            "INSIG2",
            "BCAP29",
            "KIAA0664",
            "OSTM1",
            "EFCAB7",
            "RAB33B",
            "SLC35D1",
            "FPGT",
            "CDC42",
            "NEK7",
            "LRRC40",
            "ZNF598",
            "CCDC9",
            "RLF",
            "TRIM23",
            "PELP1",
            "AIFM1",
            "DR1",
            "RAP2C",
            "USP25",
            "AKT1S1",
            "SEC22A",
            "SCP2",
            "GNPDA2",
            "MED25",
            "DDX54",
            "UBA3",
            "RNF11",
            "CMTM6",
            "CMPK1",
            "ANKRD13C",
            "ZNF136",
            "SCAF1",
            "ZNF644",
            "CNOT3",
            "RAP1A",
            "ATG4C",
            "ZNF777",
            "FXR2",
            "FAM76A",
            "DCTN1",
            "RSBN1",
            "FEZ2",
            "CAP1",
            "AAAS",
            "ANKRD11",
            "CEPT1",
            "PRKCSH",
            "SNAP23",
            "VEZF1",
            "LEMD2",
            "DNAJC24",
            "TMEM50A",
            "ZYG11B",
            "PNRC2",
            "DIS3L2",
            "STXBP3",
            "VAMP3",
            "RAB28",
            "STX12",
            "AZI2",
            "TMEM167B",
            "EPS15",
            "CREB1"
        ]
    },
    {
        "golabel": "MIER2_regulon_activity",
        "gene": [
            "KISS1R",
            "C2CD4C",
            "RGS11",
            "HSPA7",
            "PLXNB3",
            "ADAMTS14",
            "GULP1",
            "SHC2",
            "ADAMTSL5",
            "C1orf170",
            "CTAGE1",
            "PLEKHN1",
            "LOC220429",
            "ACTR3C",
            "NXT2",
            "HOMER3",
            "GPSM1",
            "TBXA2R",
            "TMEM17",
            "PEX11A",
            "PRIC285",
            "IER2",
            "LANCL1",
            "TBKBP1",
            "CCM2",
            "SBNO2",
            "TRUB1",
            "ZSWIM4",
            "TBC1D15",
            "ATPBD4",
            "SUCLG2",
            "PTPLAD1",
            "PI4K2B",
            "MIDN",
            "PEX3",
            "DPP9",
            "KLF16",
            "CDC34",
            "C7orf43",
            "DAPK3",
            "MAGT1",
            "TSNAX",
            "STK11",
            "SVIP",
            "ACADM",
            "ZNF252",
            "ATF1",
            "MCOLN1",
            "OGFR",
            "TRIP10",
            "KIAA1539",
            "CNN2",
            "SF3A2",
            "PNPLA6",
            "C19orf6",
            "EIF1AX",
            "MAP1S",
            "NACC1",
            "SIPA1",
            "SIN3B",
            "EVI5L",
            "UQCRC2",
            "MLLT1",
            "SNAPC2",
            "BCDIN3D",
            "CC2D1A",
            "TMED10P1",
            "RILPL1",
            "POLRMT",
            "DBT",
            "MUT",
            "DCAF15",
            "SUCLA2",
            "HDGFRP2",
            "TESK1",
            "MED16",
            "TYK2",
            "LYRM2",
            "RAVER1",
            "KIAA1704",
            "RBBP4",
            "NCLN",
            "REXO1",
            "KDM4B",
            "PIP5K1C",
            "ZNF282",
            "STXBP2",
            "C17orf80",
            "CSNK1G2",
            "TMED10",
            "PPP1R9B",
            "C19orf29",
            "MFAP1",
            "FRMD8",
            "DIS3L",
            "METT5D1",
            "MAP3K11",
            "FZR1",
            "NARG2",
            "GTF2H1",
            "XRCC6",
            "MUDENG",
            "SLC39A9",
            "ATXN10",
            "MAP2K7",
            "API5",
            "ZFP161"
        ]
    },
    {
        "golabel": "MINK1_regulon_activity",
        "gene": [
            "CYP2C19",
            "C14orf73",
            "GPR35",
            "FGFR4",
            "DNAH1",
            "MYO15B",
            "C19orf71",
            "C9orf139",
            "RPL39",
            "SEC16B",
            "LAMA5",
            "ALS2CL",
            "TTC22",
            "ACE",
            "PLCB2",
            "ZMYND15",
            "AGAP2",
            "PIK3C2B",
            "KCNAB2",
            "USP43",
            "FAM83G",
            "EAPP",
            "KCNC4",
            "SHANK3",
            "INF2",
            "NBEAL2",
            "DENND3",
            "BTG3",
            "MICAL1",
            "SPATA13",
            "ZNF627",
            "CNIH4",
            "PPIAL4C",
            "C7orf36",
            "ZBTB46",
            "FAM38A",
            "TECPR1",
            "MYO18A",
            "NOTCH1",
            "TNK2",
            "SUB1",
            "KIAA0284",
            "STK10",
            "ARHGAP27",
            "RANBP10",
            "FKBP7",
            "FAM65A",
            "ERH",
            "NEDD8",
            "TIMM9",
            "GLO1",
            "H3F3A",
            "SH3TC1",
            "PFAS",
            "CETN3",
            "TMEM126A",
            "BLVRA",
            "DPH5",
            "LSM5",
            "ARL3",
            "SRC",
            "TSEN15",
            "FARP2",
            "KIAA0664",
            "DENND1C",
            "EHBP1L1",
            "NUDCD2",
            "C17orf85",
            "MLL2",
            "SRP9",
            "MLL4",
            "PPP1R12C",
            "KIAA0556",
            "COX11",
            "NSL1",
            "CORO7",
            "CBX3",
            "NEURL4",
            "C14orf166",
            "C4orf27",
            "WDR81",
            "SETMAR",
            "PNPLA6",
            "ZCCHC17",
            "PLCB3",
            "ERICH1",
            "EIF1AX",
            "DOCK6",
            "FAM200A",
            "ZZEF1",
            "FLCN",
            "UBE2D4",
            "STK11IP",
            "KIAA0913",
            "MYO9B",
            "SMCR8",
            "BCAS2",
            "ARHGEF18",
            "ZNF335",
            "VMA21",
            "ATG2A",
            "IL17RA",
            "ANAPC10",
            "PARK7",
            "RAPGEF1",
            "RBMX2",
            "TAF9",
            "STYX",
            "EIF2B3",
            "FLII",
            "AMZ2",
            "SUMO2",
            "CWC15",
            "CAMTA2",
            "PTPMT1",
            "HARBI1",
            "PPP1CB",
            "PLD2",
            "TAF12",
            "PIP5K1C",
            "EDC4",
            "NDUFA5",
            "AIDA",
            "CYTH1",
            "DNAJC8",
            "DHX38",
            "SUMO1",
            "GGPS1",
            "DKFZp761E198",
            "PTMA",
            "ZNF592",
            "MNT",
            "SARS",
            "ANKFY1",
            "RNF123",
            "INTS12",
            "TROVE2",
            "UBE2D2",
            "TUBGCP2",
            "USP19"
        ]
    },
    {
        "golabel": "MITF_regulon_activity",
        "gene": [
            "FOXL1",
            "DHRS9",
            "SRPK3",
            "HEPH",
            "SH3RF2",
            "HMGB3",
            "GALNT5",
            "ABLIM3",
            "ANXA3",
            "EFNB1",
            "PAQR8",
            "GYLTL1B",
            "GBP3",
            "NRP2",
            "ETV4",
            "TLR3",
            "SYTL2",
            "CEBPD",
            "EEPD1",
            "ASPSCR1",
            "C1orf56",
            "SYTL4",
            "NCEH1",
            "NTN4",
            "DAB2",
            "FN3K",
            "ZEB2",
            "CARD6",
            "PRPF40B",
            "EPB41L2",
            "KAT2A",
            "ERP29",
            "ARHGAP10",
            "MAP3K5",
            "TBC1D8B",
            "TMEM81",
            "GAB1",
            "ATL2",
            "DUS1L",
            "ANKRD16",
            "ANXA5",
            "B4GALT3",
            "EHMT2",
            "UBQLN4",
            "CCDC90A",
            "USP21",
            "DUSP3",
            "UBE2Q1",
            "MRPS5",
            "C1orf77",
            "PAPSS1",
            "SH3GLB1",
            "RBM4"
        ]
    },
    {
        "golabel": "MKL1_regulon_activity",
        "gene": [
            "TBX3",
            "COL5A1",
            "RPS18",
            "SCARF2",
            "COL16A1",
            "EMILIN1",
            "PDGFB",
            "MICAL3",
            "RPL5",
            "HIC1",
            "GPR124",
            "MPP7",
            "CNIH4",
            "HBXIP",
            "SMTN",
            "BNIP1",
            "C12orf29",
            "ARV1",
            "C1orf43",
            "MRPS36",
            "SUN2",
            "NDUFS4",
            "FAM65A",
            "SNAPIN",
            "MYH9",
            "ZYX",
            "PPA2",
            "AK2",
            "PMPCB",
            "SDHC",
            "TMEM184B",
            "C3orf23",
            "C5orf44",
            "COX11",
            "PPM1F",
            "FBXO22",
            "ATP5F1",
            "MAP7D1",
            "PACS1",
            "TATDN3",
            "PEX19",
            "FAM200A",
            "MED15",
            "TMEM168",
            "GTPBP1",
            "TNRC6B",
            "ARHGEF18",
            "TADA1",
            "MRPS14",
            "PIP5K1C",
            "NDUFA5",
            "C19orf61",
            "DHX38",
            "PPP1R9B",
            "AP2A1",
            "RHOT1",
            "AP1B1"
        ]
    },
    {
        "golabel": "MKL2_regulon_activity",
        "gene": [
            "TMEM63C",
            "DNAH5",
            "PTPLA",
            "KCNQ3",
            "LOC100271836",
            "XPR1",
            "TBC1D24",
            "GNA14",
            "RPS19",
            "ZDHHC21",
            "HIP1",
            "ZNF462",
            "PPP1R9A",
            "BTBD9",
            "RAPGEF5",
            "PPP2R3A",
            "PPIB",
            "RAPGEF6",
            "SERF2",
            "NDUFA9",
            "ANKRD50",
            "RAPH1",
            "CP110",
            "HDDC2",
            "DCUN1D3",
            "PPCDC",
            "RPS6KA3",
            "CASD1",
            "FYCO1",
            "FUCA2",
            "DNAJC1",
            "MRPS11",
            "SEC61B",
            "CLN6",
            "EDF1",
            "ZKSCAN2",
            "MLL3",
            "METTL11A",
            "COMMD4",
            "RUNX1",
            "ERCC4",
            "PDPK1",
            "CREBBP",
            "AFF4",
            "ZNF720",
            "RRN3",
            "CEP68",
            "GSPT1",
            "THUMPD1"
        ]
    },
    {
        "golabel": "MLLT1_regulon_activity",
        "gene": [
            "NRGN",
            "IGSF9B",
            "APBA2",
            "RFX2",
            "BZRAP1",
            "CDC42EP1",
            "TBC1D24",
            "PTPRS",
            "ABHD3",
            "DERA",
            "C14orf129",
            "TMEM14B",
            "LPHN1",
            "MTSS1L",
            "ZSWIM4",
            "NFIC",
            "CHMP1B",
            "MRPL42",
            "NDUFB3",
            "RAB11FIP3",
            "PRDX3",
            "PSMD14",
            "TMED2",
            "SMARCA4",
            "LRRC8E",
            "C1D",
            "ST5",
            "SLC25A23",
            "C2orf49",
            "STK11",
            "RAB43",
            "LPPR2",
            "NCKAP5L",
            "NPHP4",
            "CABIN1",
            "ALG14",
            "MOBKL3",
            "S1PR2",
            "GHITM",
            "PNPLA6",
            "ATG5",
            "EVI5L",
            "BLOC1S2",
            "MMADHC",
            "C1GALT1C1",
            "NDUFS1",
            "MIER2",
            "RAB11A",
            "C2orf43",
            "SKI",
            "ZNF324B",
            "MUM1",
            "KCMF1",
            "NECAP1",
            "SPCS1",
            "C2orf47",
            "FAM45A",
            "TYK2",
            "MED6",
            "KDM4B",
            "PIP5K1C",
            "C6orf35",
            "ZNF324",
            "RABL3",
            "WIZ",
            "MED26",
            "SCAMP4",
            "RFX1",
            "GLOD4",
            "VPS26B",
            "COX15",
            "EML3",
            "KIAA0892",
            "XAB2",
            "TRIP4",
            "PPP3R1",
            "MAP2K7",
            "ABI1",
            "RANBP3",
            "PRKACA",
            "ZNF317"
        ]
    },
    {
        "golabel": "MLLT6_regulon_activity",
        "gene": [
            "GPR179",
            "TAS2R4",
            "SRCIN1",
            "C6orf124",
            "STARD3",
            "ASB16",
            "C9orf45",
            "FBXO41",
            "SPDYE7P",
            "FNDC8",
            "TSSK4",
            "C17orf69",
            "FLJ45340",
            "TBC1D3",
            "RAB11FIP4",
            "GIGYF1",
            "CREM",
            "NPIP",
            "OSTC",
            "LOC90110",
            "ABCA2",
            "LRRC37B",
            "TECPR1",
            "KIAA0467",
            "JRK",
            "STAG3L3",
            "TMEM126A",
            "PARP14",
            "PLEKHH3",
            "SRRM2",
            "RECQL5",
            "ARPC5",
            "PPIC",
            "TRIAP1",
            "DRG1",
            "TP53RK",
            "CRAMP1L",
            "RWDD1",
            "COPS2",
            "KIAA0226",
            "DIP2A",
            "NUMA1",
            "KIAA0195",
            "DYNLL1",
            "EZH1",
            "HDAC5",
            "KIAA1267",
            "YWHAE",
            "EIF3M",
            "RBM33",
            "HCCS",
            "MSL1",
            "MECP2",
            "PIP4K2B",
            "CWC25",
            "COPB1",
            "DNAJA2",
            "GGA3",
            "USP36",
            "ATP6V1D",
            "C22orf28",
            "PHF12",
            "EXOC7",
            "CSNK1D"
        ]
    },
    {
        "golabel": "MLX_regulon_activity",
        "gene": [
            "HOPX",
            "WBSCR26",
            "CRADD",
            "TSHZ2",
            "RPL27",
            "GLI2",
            "BACH2",
            "NAGS",
            "CRIM1",
            "COL16A1",
            "TLCD1",
            "SH3RF3",
            "PLEKHG3",
            "LACTB2",
            "RAG1AP1",
            "NFIA",
            "CRYL1",
            "LOC100133991",
            "MRPL14",
            "MRPL33",
            "MAL2",
            "ADK",
            "CCDC56",
            "MREG",
            "C20orf117",
            "LOC100130581",
            "FIS1",
            "MRPS23",
            "MEGF8",
            "LOC646762",
            "TTC28",
            "IAH1",
            "UQCR10",
            "PSMD3",
            "TMEM165",
            "C1orf43",
            "PCYT2",
            "RG9MTD2",
            "NUDT16P1",
            "SYNGR2",
            "ICT1",
            "MRPL49",
            "JARID2",
            "ZMAT5",
            "TOM1L1",
            "CISD3",
            "TRAM2",
            "TMEM120A",
            "CHMP5",
            "TMEM101",
            "NIN",
            "PACS1",
            "DYNC1H1",
            "ATP5H",
            "CIC",
            "MRPS7",
            "MIF4GD",
            "BRD3",
            "PCGF1",
            "ZNHIT3",
            "PHB",
            "MAD2L1BP",
            "FAM45A",
            "SMEK1",
            "ABL1",
            "FBXO8",
            "BRD4",
            "NME6",
            "GLG1",
            "COASY",
            "EIF1",
            "MRPL10",
            "PSME3",
            "APEH",
            "RAB5C",
            "PHF21A",
            "ZC3H4",
            "RBBP6"
        ]
    },
    {
        "golabel": "MLXIP_regulon_activity",
        "gene": [
            "SFMBT2",
            "TLR9",
            "ATP5EP2",
            "XYLT1",
            "GPR157",
            "CBX6",
            "RPL31",
            "RPS8",
            "RPL5",
            "HIPK2",
            "ZKSCAN1",
            "ADK",
            "FBXO4",
            "RPL37A",
            "FOXK1",
            "RPL14",
            "CNIH4",
            "RPS23",
            "CMTM4",
            "ACOT1",
            "PHF5A",
            "ATP5O",
            "UQCR10",
            "RPL23",
            "UNC119B",
            "MLEC",
            "ISCA2",
            "ARV1",
            "MYL12B",
            "LYPLAL1",
            "HAUS4",
            "NDUFS4",
            "COX7C",
            "MRPL1",
            "BLVRA",
            "IGF2R",
            "TPCN1",
            "RPL19",
            "POLR2G",
            "TRMT112",
            "MRPL40",
            "GORAB",
            "PPA2",
            "TMEM128",
            "ANKRD52",
            "TMEM101",
            "RPS25",
            "MYL12A",
            "COX18",
            "C4orf27",
            "BAT2L1",
            "SSH1",
            "SSH2",
            "ZZEF1",
            "TPMT",
            "EP400",
            "PIGY",
            "PARK7",
            "RAPGEF1",
            "CWC15",
            "PTPMT1",
            "NHP2L1",
            "KHNYN",
            "C17orf95",
            "GGPS1",
            "CAMKK2"
        ]
    },
    {
        "golabel": "MNAT1_regulon_activity",
        "gene": [
            "TMEM14A",
            "ARG2",
            "PRTFDC1",
            "SIP1",
            "RASGRP4",
            "ACYP1",
            "C14orf33",
            "SIX4",
            "FGD5",
            "STARD8",
            "DAB2",
            "LRP1",
            "C14orf104",
            "TNFRSF1B",
            "FKBP3",
            "LOC442454",
            "NDUFB6",
            "IMMP1L",
            "C8orf37",
            "POLR2K",
            "ATP5S",
            "SNAPC1",
            "SNRPF",
            "CCDC59",
            "L2HGDH",
            "MED30",
            "PSMA3",
            "NFATC1",
            "C14orf101",
            "STK10",
            "NGDN",
            "PSMC6",
            "ERH",
            "NEDD8",
            "TIMM9",
            "C17orf75",
            "PARP2",
            "PRMT5",
            "UBE2V2",
            "APEX1",
            "DPM1",
            "ZBTB25",
            "NUP35",
            "TTC8",
            "DNAL1",
            "WDR89",
            "PDE4A",
            "ACTR6",
            "C14orf138",
            "PRMT3",
            "TBCA",
            "C14orf166",
            "WDR81",
            "SMYD2",
            "GMIP",
            "EIF2S1",
            "SUMO1P3",
            "TRMT5",
            "ACTR10",
            "MYO1C",
            "ZBTB7A",
            "SOCS4",
            "SEPN1",
            "MED6",
            "PIP5K1C",
            "KIAA0831",
            "MAPK1IP1L",
            "CSTF3",
            "HNRNPC",
            "PPM1A",
            "SFRS7",
            "TOX4",
            "RBMX"
        ]
    },
    {
        "golabel": "MNDA_regulon_activity",
        "gene": [
            "CLC",
            "RXFP2",
            "OVCH1",
            "C6orf176",
            "MS4A3",
            "RETN",
            "CLEC4G",
            "CSF2",
            "CD1A",
            "VSTM1",
            "HRH4",
            "C19orf59",
            "ADRB3",
            "CCL17",
            "DNASE2B",
            "C20orf123",
            "AGRP",
            "FCER1A",
            "TESC",
            "EMR1",
            "IL22RA2",
            "TPSD1",
            "FPR2",
            "C19orf45",
            "CEACAM4",
            "CD1B",
            "F13A1",
            "GPR85",
            "CCL13",
            "EMR3",
            "CLEC12B",
            "S100B",
            "ATP6V0D2",
            "CD1E",
            "CLEC12A",
            "TM7SF4",
            "FLJ37543",
            "FCN1",
            "CCL23",
            "CD1C",
            "SLC24A4",
            "P2RY12",
            "HLA-DQA2",
            "C2CD4D",
            "SIRPD",
            "FAM23A",
            "EMR4P",
            "SLC37A2",
            "RNASE2",
            "CX3CR1",
            "FOLR2",
            "GLDN",
            "MRC1",
            "PPP2R2B",
            "HPGDS",
            "STAC",
            "OLR1",
            "VSIG4",
            "TLR8",
            "HLA-DQA1",
            "CYSLTR1",
            "CEACAM21",
            "ADSSL1",
            "CD300LF",
            "CLEC5A",
            "PLD4",
            "HCK",
            "ANKRD22",
            "DDO",
            "RTN1",
            "HLA-DRB6",
            "MSR1",
            "SIRPB1",
            "CLEC4A",
            "GPR34",
            "PLB1",
            "BST1",
            "CPVL",
            "GPR82",
            "CD300LB",
            "FPR1",
            "RGS18",
            "C12orf59",
            "NLRP3",
            "ABCB6",
            "IGSF6",
            "LILRA1",
            "C10orf128",
            "ALOX5AP",
            "MS4A4A",
            "ITGAM",
            "SLC40A1",
            "GAPT",
            "CD101",
            "MS4A6A",
            "TLR2",
            "CYBB",
            "BHLHE41",
            "CD300C",
            "P2RY13",
            "PTPRO",
            "GLIPR1",
            "ADORA3",
            "IFIT2",
            "LY86",
            "MS4A7",
            "UBASH3B",
            "RASGRP4",
            "CLEC7A",
            "TLR7",
            "HLA-DMB",
            "CD80",
            "C3AR1",
            "IFIT3",
            "LOC653653",
            "SPN",
            "HLA-DRA",
            "AMICA1",
            "PLEK",
            "SLCO2B1",
            "NLRC4",
            "CD33",
            "HLA-DPA1",
            "SIGLEC9",
            "CSF1R",
            "DOK2",
            "CSF2RA",
            "GYG2",
            "RAB32",
            "TNFAIP8L2",
            "KIAA1549",
            "LAIR1",
            "AIF1",
            "CXorf21",
            "FAS",
            "LIPA",
            "ZNF788",
            "ATP8B4",
            "TPK1",
            "HAVCR2",
            "FBP1",
            "FCGR2A",
            "SPI1",
            "NCF2",
            "GGTA1",
            "NCKAP1L",
            "EMILIN2",
            "BTK",
            "DPYD",
            "ARRDC4",
            "CD86",
            "RNASE6",
            "HDX",
            "RGS10",
            "MDFIC",
            "CASP1",
            "AP1S2",
            "TBC1D8",
            "ZBTB12",
            "IDI2",
            "CD44",
            "LAPTM5",
            "SLC29A2",
            "CD83",
            "FLVCR2",
            "CD4",
            "LPCAT2",
            "TM6SF1",
            "CTSC",
            "TMSL3",
            "OGFRL1",
            "TUFT1",
            "DBNDD1",
            "DAPP1",
            "IDS",
            "PRPF40B",
            "GPR56",
            "ADAP2",
            "LHFPL2",
            "SPRED1",
            "PTPLAD2",
            "RASGEF1B",
            "IFNGR1",
            "C22orf27",
            "FAM83H",
            "OVOL2",
            "ICA1",
            "PIM3",
            "C2orf15",
            "LOC100125556",
            "PDIA3",
            "ARHGDIB",
            "CAMK1",
            "CFLAR",
            "NAAA",
            "SLFN12",
            "APOBEC3C",
            "CSNK1E",
            "CMTM7",
            "PRNP",
            "MR1",
            "KAT2B",
            "ARHGAP18",
            "MAPKAPK3",
            "C6orf136",
            "TMEM81",
            "FBXO46",
            "LYN",
            "LAMP2",
            "ARL6IP5",
            "PPT1",
            "C9orf21",
            "IRF2BP1",
            "CORO1C",
            "SFXN3",
            "RP2",
            "MAGEF1",
            "TMEM106A",
            "PPM1M",
            "KIAA0664",
            "SNX3",
            "HEXB",
            "MTMR6",
            "ANXA5",
            "ARHGEF3",
            "EHMT2",
            "SETD6",
            "ATP6V0D1",
            "SLC25A46",
            "PELP1",
            "SH3BGRL",
            "SLC39A7",
            "FIG4",
            "PEA15",
            "NECAP2",
            "CAST",
            "MTPAP",
            "PTOV1",
            "ATP6V1B2",
            "GOLGA2",
            "TMEM188",
            "WHSC2",
            "RAP1A",
            "NDUFS2",
            "MYD88",
            "EHD4",
            "NUB1",
            "CAP1",
            "OSTF1",
            "YWHAH",
            "LOC643387",
            "NFS1",
            "ARPC2",
            "ANP32A",
            "ATG7",
            "COPG",
            "SNX2",
            "VAMP3",
            "STX12",
            "TM9SF4",
            "RHOA"
        ]
    },
    {
        "golabel": "MNT_regulon_activity",
        "gene": [
            "LOC400759",
            "RLN2",
            "EPPK1",
            "RAP1B",
            "PLEC",
            "CGRRF1",
            "SREBF1",
            "FAM83H",
            "IQCE",
            "ZNF101",
            "RAI1",
            "AMZ2P1",
            "PPT1",
            "GAK",
            "PSME1",
            "DAB2IP",
            "MYBBP1A",
            "TSEN15",
            "KIAA0664",
            "SLC43A2",
            "TAF9B",
            "DNAJC5",
            "KDM6B",
            "C5orf44",
            "KIF1C",
            "UBE2A",
            "NSL1",
            "CHD3",
            "WDR81",
            "TMEM102",
            "PLCB3",
            "NCOR2",
            "ZNF35",
            "ZZEF1",
            "TXNDC12",
            "RREB1",
            "KCTD11",
            "LSM6",
            "MINK1",
            "ZCCHC9",
            "ACTR10",
            "GOLGA2",
            "MEF2D",
            "MYO1C",
            "C11orf46",
            "CAMTA2",
            "TBC1D14",
            "PLD2",
            "AP3D1",
            "PPRC1",
            "ATP6AP2",
            "SMG6",
            "NDEL1",
            "PTPN23"
        ]
    },
    {
        "golabel": "MPHOSPH8_regulon_activity",
        "gene": [
            "CNFN",
            "RPL21P44",
            "CDK4",
            "KBTBD11",
            "PRR7",
            "PTCH1",
            "KRT10",
            "TAF1L",
            "C5orf55",
            "NBEAL1",
            "LAGE3",
            "CELF2",
            "NME1",
            "PSMB3",
            "AKAP13",
            "POP7",
            "SPATA13",
            "GALK1",
            "TUBA1C",
            "MRPL11",
            "ARHGEF7",
            "SNRNP25",
            "AURKAIP1",
            "ARF5",
            "DRAP1",
            "HMGN2",
            "IFT88",
            "VPS13C",
            "FNDC3A",
            "C1orf122",
            "PPP4C",
            "TCF7L2",
            "USP12",
            "LATS2",
            "SLC25A39",
            "PGP",
            "ZFP106",
            "DENND4A",
            "HERC1",
            "DIABLO",
            "ZC3H13",
            "SLC25A30",
            "PARP4",
            "SLC12A6",
            "KIAA0564",
            "APC",
            "SETDB2",
            "CHD2",
            "ERI3",
            "ZMYM2",
            "XPC",
            "AKAP11",
            "TGOLN2",
            "TACO1",
            "LRRFIP1",
            "KIAA0240",
            "ERCC5",
            "AMZ2",
            "VPS36",
            "PAN3",
            "PIK3C2A",
            "XPO4",
            "SPG11",
            "RNF6",
            "ANKFY1",
            "INO80",
            "SLTM"
        ]
    },
    {
        "golabel": "MRPL28_regulon_activity",
        "gene": [
            "LOC388242",
            "WBSCR27",
            "LOC654342",
            "SEPX1",
            "TIMM16",
            "TIMM17B",
            "MRPL52",
            "PSMB3",
            "BOLA2",
            "NTHL1",
            "NME4",
            "RPL26L1",
            "MXD3",
            "RAB11FIP2",
            "MRPL12",
            "TCEB2",
            "PPP1R14B",
            "ALDOA",
            "RPUSD1",
            "PET112L",
            "C16orf91",
            "CARHSP1",
            "PSMB6",
            "AMDHD2",
            "SF3B5",
            "TARBP2",
            "SNRNP25",
            "AURKAIP1",
            "MTX1",
            "C10orf118",
            "PPP4C",
            "DHODH",
            "B3GAT3",
            "PDF",
            "BANF1",
            "POLR3K",
            "CNO",
            "MAP3K1",
            "PGP",
            "NUBP2",
            "SNRPC",
            "CPEB3",
            "CTU2",
            "SSSCA1",
            "GCC2",
            "B4GALT7",
            "TMEM8A",
            "MRPS34",
            "COQ9",
            "GOLGA4",
            "NDUFB10",
            "DENND4C",
            "COMMD4",
            "THOC6",
            "MRPL38",
            "ADRM1",
            "RUVBL2",
            "HIPK1",
            "NMRAL1",
            "EIF6",
            "INO80E",
            "FAHD1",
            "GOT2",
            "GSS",
            "STUB1",
            "NARFL",
            "TUFM",
            "DDX28",
            "PHB",
            "NAGPA",
            "BRMS1",
            "EMD",
            "ZFPL1",
            "GFER",
            "MLST8",
            "EVI5",
            "FAM86A",
            "CSNK2B",
            "GPS1",
            "CHMP1A",
            "NPRL3",
            "TMF1",
            "OTUB1",
            "EIF4EBP2",
            "DNAJA3",
            "WBSCR16",
            "C16orf42",
            "ZNF510",
            "C16orf80",
            "ZNF800",
            "APPL1",
            "CD2BP2",
            "FAM192A",
            "RNPS1",
            "UBE2I",
            "EPS15"
        ]
    },
    {
        "golabel": "MRRF_regulon_activity",
        "gene": [
            "C9orf43",
            "NALCN",
            "COL8A2",
            "FBN1",
            "SGCD",
            "AEBP1",
            "ASS1",
            "MMP2",
            "PRELP",
            "FBLN2",
            "SCARF2",
            "SNHG1",
            "TXN",
            "PDGFRA",
            "PODN",
            "EMILIN1",
            "SNHG3",
            "RPL36A",
            "C21orf57",
            "PDGFC",
            "TIMP2",
            "RECK",
            "LRP1",
            "FLNA",
            "LOC645676",
            "RPL7A",
            "PDSS1",
            "SDC3",
            "HDHD3",
            "TGFB1",
            "SEMA4F",
            "ZNF485",
            "SFXN4",
            "MYH9",
            "ST3GAL2",
            "LETMD1",
            "ZNF169",
            "RG9MTD1",
            "C9orf95",
            "MRPL50",
            "TAF1D",
            "OXSM",
            "TEX10",
            "COQ4",
            "PLA2G15",
            "PTGES2",
            "GTF3C5",
            "GNL3",
            "C9orf6",
            "SDCCAG3",
            "EXOSC2",
            "IARS",
            "ACVR1",
            "DNAJC25",
            "DOLPP1",
            "PMPCA",
            "ARPC5L",
            "CDC26",
            "WDR5",
            "KIAA0368",
            "NAGA",
            "C9orf156",
            "ANP32B",
            "FXN",
            "INVS",
            "C9orf114",
            "ASB6",
            "ZFYVE1",
            "NOL8",
            "UIMC1",
            "GLE1",
            "GOLGA1",
            "PSMD5",
            "ERP44",
            "ALG2",
            "PDCL",
            "ADD1"
        ]
    },
    {
        "golabel": "MSL3_regulon_activity",
        "gene": [
            "RGS13",
            "ASB2",
            "CD48",
            "SIT1",
            "EVI2A",
            "TFEC",
            "MIR155HG",
            "ZCCHC18",
            "C6orf225",
            "ARHGAP15",
            "TBC1D10C",
            "LOC100270804",
            "TRIM69",
            "TRAF3IP3",
            "LOC100233209",
            "GPR65",
            "C13orf18",
            "GLIPR2",
            "MTMR9L",
            "IRF8",
            "GMFG",
            "ARHGAP9",
            "IL16",
            "BTK",
            "SASH3",
            "KBTBD8",
            "TUBA1A",
            "BCAS4",
            "CYTH4",
            "GIMAP2",
            "C1orf63",
            "TMSL3",
            "TMEM19",
            "LPAR6",
            "ARMCX1",
            "LPXN",
            "DDX26B",
            "COMMD3",
            "RWDD2A",
            "TBPL1",
            "UXT",
            "ARL6",
            "IFT46",
            "CLDND1",
            "ING4",
            "GFPT1",
            "CLK1",
            "GPATCH4",
            "TIA1",
            "ARHGEF5",
            "PRPF39",
            "HSPBAP1",
            "SLC25A14",
            "TCEANC",
            "CLEC2D",
            "CBX4",
            "TUBE1",
            "ANKRD49",
            "RPTOR",
            "RPRD2",
            "RREB1",
            "ZNF333",
            "RNPEP",
            "KTELC1",
            "SENP7",
            "ALG13",
            "RRAGB",
            "GOLGA2",
            "RBM47",
            "UBE2B",
            "C17orf63",
            "USP45",
            "EPRS",
            "KATNA1",
            "IRAK4",
            "HCCS",
            "LYRM2",
            "LINS1",
            "DCTN1",
            "ACOT9",
            "PAIP2",
            "FRG1",
            "HDLBP",
            "COPG",
            "WTAP",
            "TINF2",
            "ZBTB1",
            "SRP68",
            "SEC24C",
            "HNRNPU"
        ]
    },
    {
        "golabel": "MSRB2_regulon_activity",
        "gene": [
            "CBR3",
            "KIAA0754",
            "DPM3",
            "SH3BGR",
            "COX6B1",
            "PSENEN",
            "PFDN5",
            "ECHDC3",
            "MGAT5",
            "C2orf76",
            "UQCRQ",
            "RNF168",
            "TOMM6",
            "TMEM147",
            "MYEOV2",
            "PHYH",
            "COX5B",
            "NDUFA4",
            "CCDC56",
            "TAOK1",
            "BOLA1",
            "NQO2",
            "ATP5I",
            "BLOC1S1",
            "NENF",
            "RNF181",
            "CCDC72",
            "CDK12",
            "C2orf28",
            "UBL5",
            "SERF2",
            "KRTCAP2",
            "ZNF32",
            "DYNLT1",
            "COX4I1",
            "HBXIP",
            "USMG5",
            "MORN2",
            "HEBP2",
            "COMMD3",
            "S100A11",
            "TMEM208",
            "C9orf103",
            "TTBK2",
            "OST4",
            "RBX1",
            "TRIM56",
            "NDUFB11",
            "ATP5J",
            "ATP5O",
            "UXT",
            "NDUFA1",
            "SOD1",
            "NDUFS8",
            "C19orf53",
            "RC3H2",
            "RIF1",
            "ASXL2",
            "COX7C",
            "TRIM44",
            "C14orf179",
            "ATP5G2",
            "TOMM7",
            "H3F3A",
            "NUDT5",
            "ROBLD3",
            "PSMB4",
            "TMEM134",
            "ATP5C1",
            "SURF1",
            "MYCBP2",
            "CHCHD1",
            "GTF2H5",
            "DNAJC1",
            "SMG1",
            "ANKRD16",
            "TMEM219",
            "RSF1",
            "SEC61B",
            "RNASEK",
            "NDUFC1",
            "EDF1",
            "GNG5",
            "TGFBRAP1",
            "NDUFB10",
            "TRAPPC1",
            "ANKS1A",
            "C1orf151",
            "THOC7",
            "UFC1",
            "CCDC53",
            "MLL",
            "TEX264",
            "CDC123",
            "GABARAP",
            "RPP38",
            "DYNLRB1",
            "RAB18",
            "NPAT",
            "SRP14",
            "KIN",
            "GPATCH8",
            "CUEDC2",
            "PRPF18"
        ]
    },
    {
        "golabel": "MST1R_regulon_activity",
        "gene": [
            "DUOX2",
            "CDHR2",
            "ARL14",
            "ONECUT3",
            "CHST4",
            "ANXA10",
            "CYP2C19",
            "CYP2C9",
            "SYT8",
            "VILL",
            "ERN2",
            "KCP",
            "TRIM7",
            "ENTPD2",
            "TSPAN1",
            "FA2H",
            "PTPRH",
            "SEMA3B",
            "SH3RF2",
            "DOK7",
            "SOX9",
            "RAB27B",
            "LPCAT4",
            "BCL2L15",
            "C6orf141",
            "STX1A",
            "TBX6",
            "CAPN8",
            "B3GNT3",
            "ITGB4",
            "SERINC4",
            "EPHA2",
            "PTK6",
            "SH3D20",
            "ITGB6",
            "TMC7",
            "PROM2",
            "ANXA2P1",
            "FUT3",
            "TSPYL5",
            "LAMB3",
            "ALS2CL",
            "CCDC68",
            "KRT19",
            "TNNI1",
            "S100A16",
            "C1orf126",
            "CDCP1",
            "ADAP1",
            "EPHA10",
            "C15orf52",
            "PHLDA2",
            "ITGA3",
            "IRAK2",
            "GALNT3",
            "RIN1",
            "FAM83E",
            "LOC146880",
            "TTC22",
            "RARG",
            "ABCC3",
            "EVPL",
            "MICALL2",
            "LAD1",
            "LMO7",
            "SYTL1",
            "SHROOM1",
            "PPP1R13L",
            "GALNT12",
            "ACOT11",
            "C1orf106",
            "OSBPL7",
            "PCDH1",
            "AP1S3",
            "PLEKHM1P",
            "SH2D3A",
            "MYO5C",
            "MAGEH1",
            "SH2D4A",
            "TMEM170B",
            "INF2",
            "NBEAL2",
            "SMAD3",
            "CDC42BPG",
            "TRIM47",
            "FLNB",
            "LYRM4",
            "OSBPL3",
            "SLC25A33",
            "ELMO3",
            "ACP6",
            "TMC4",
            "RIPK3",
            "TSPAN15",
            "C9orf167",
            "TRIM24",
            "UBA7",
            "PLEKHA7",
            "TK2",
            "TNFRSF10B",
            "PML",
            "PLXNB2",
            "FAM109A",
            "MVP",
            "PXN",
            "COPS3",
            "EPS8L2",
            "ARHGAP27",
            "LOC221710",
            "TRAK1",
            "HDAC11",
            "TEP1",
            "SFXN3",
            "ARL3",
            "FAM160B2",
            "RETSAT",
            "TICAM1",
            "CAPN2",
            "C20orf3",
            "EHBP1L1",
            "NRSN2",
            "VPS37B",
            "SSH3",
            "TRIP10",
            "PARP3",
            "MGAT4B",
            "MKNK2",
            "HSF2",
            "RNF2",
            "PARP4",
            "ZNF22",
            "IFRD2",
            "CAPN1",
            "KATNA1",
            "ZBTB7A",
            "NLRX1",
            "WHAMM",
            "SLMAP",
            "RNF123",
            "OXSR1",
            "STARD7",
            "PTPN23",
            "PDCD6IP",
            "PDCL"
        ]
    },
    {
        "golabel": "MTA1_regulon_activity",
        "gene": [
            "ITGB6",
            "SLC40A1",
            "CRIP2",
            "ZBTB12",
            "C14orf80",
            "TRAM1",
            "DNAJB9",
            "CCDC85C",
            "ZNF512B",
            "IPO4",
            "AZI1",
            "SCRIB",
            "XRCC3",
            "CPSF1",
            "C14orf153",
            "CLN5",
            "SNAPC4",
            "ITM2B",
            "ANGEL1",
            "TAF6",
            "SUPT16H",
            "ZC3H3",
            "CINP",
            "BRF1",
            "YPEL5",
            "ZNF598",
            "POMT2",
            "PABPN1",
            "LMBRD1",
            "ZFAND6",
            "CDC42BPB",
            "TRAF3",
            "PACS2",
            "RNF14",
            "ZNF786",
            "GMEB2",
            "RNF13",
            "SAMD1",
            "CMTM6",
            "TTLL5",
            "GLRX5",
            "RBM10",
            "SMEK1",
            "KIAA0317",
            "FAM114A2",
            "KLC1",
            "SETD1A",
            "ZNF282",
            "LAPTM4A",
            "SNAP23",
            "BAG5",
            "ARL8B",
            "CCNK",
            "STK25",
            "MARK3",
            "DAZAP2"
        ]
    },
    {
        "golabel": "MTA3_regulon_activity",
        "gene": [
            "MAGEA4",
            "BCAR4",
            "MAGEA9B",
            "PKD1L2",
            "TDRD5",
            "ALDH3B2",
            "GDPD3",
            "SULT2B1",
            "MRC1",
            "PLEKHG6",
            "QPRT",
            "RTN1",
            "RHPN2",
            "ITGAM",
            "RASGRP4",
            "DNASE1",
            "SPN",
            "AMICA1",
            "SLCO2B1",
            "AQP11",
            "DOK2",
            "MCC",
            "CSF2RB",
            "VIM",
            "DOCK2",
            "NCF2",
            "CD74",
            "GSN",
            "TMPRSS13",
            "FGD5",
            "SELPLG",
            "CD4",
            "DAB2",
            "SIRPA",
            "FLI1",
            "CD97",
            "KCTD12",
            "ZEB2",
            "ATP6V1E2",
            "DUSP7",
            "LOC100125556",
            "LRRC8C",
            "DNAH14",
            "COX7A2L",
            "GALM",
            "UBA7",
            "RCBTB2",
            "SERPINB8",
            "LRRC1",
            "EPCAM",
            "SMARCA2",
            "DPY30",
            "TBCE",
            "GFPT1",
            "SH2B3",
            "ATL2",
            "CCDC121",
            "TMEM177",
            "SF3B14",
            "KIAA0247",
            "E2F6",
            "PIGU",
            "PIGC",
            "C2orf68",
            "GNAI2",
            "C2orf29",
            "YIPF4",
            "C2orf56",
            "PTCD3",
            "NOL10",
            "KIN",
            "STAMBP",
            "GTF3C2",
            "COIL",
            "PEX13",
            "CIAO1"
        ]
    },
    {
        "golabel": "MTF1_regulon_activity",
        "gene": [
            "C14orf72",
            "CNTF",
            "RPLP1",
            "RNF168",
            "HIPK2",
            "RPL13",
            "RANGRF",
            "RPL38",
            "BLOC1S1",
            "NDUFB7",
            "ANKRD36BP1",
            "TRAPPC5",
            "RPL37A",
            "FOXK1",
            "COX4I1",
            "FAM96B",
            "NDUFA7",
            "NDUFB11",
            "USP31",
            "UXT",
            "MRP63",
            "C19orf53",
            "DYRK4",
            "ASXL2",
            "RPLP2",
            "ATP5G2",
            "MACF1",
            "REST",
            "HIGD2A",
            "NT5C",
            "DECR1",
            "CBL",
            "RPL19",
            "KLF13",
            "LUZP1",
            "RPL23A",
            "NDUFB8",
            "PPARA",
            "LMLN",
            "MRPL43",
            "ZFP106",
            "NDUFC1",
            "AIP",
            "KIF1B",
            "TRAPPC1",
            "ZHX3",
            "ZNFX1",
            "STK35",
            "MPV17",
            "HIPK1",
            "ZSCAN20",
            "RBAK",
            "EIF2C1",
            "C22orf30",
            "TULP4",
            "WDR47",
            "SPEN",
            "WASF2",
            "CSNK1G1",
            "EXOSC7",
            "ATXN1L",
            "R3HCC1",
            "MTOR",
            "GCC1",
            "FAM120B",
            "IKBKAP",
            "HIF1AN",
            "CUEDC2",
            "ZC3HAV1",
            "KDM4A",
            "SNIP1",
            "KPNA6",
            "TXLNA"
        ]
    },
    {
        "golabel": "MXD3_regulon_activity",
        "gene": [
            "C2orf48",
            "CDKN2A",
            "HIST2H2AC",
            "LOC728875",
            "F12",
            "PIF1",
            "FAM24B",
            "DDIT3",
            "PRR7",
            "SNHG1",
            "CDKL5",
            "PTTG1",
            "LOC728855",
            "IL6ST",
            "GLI4",
            "NOL12",
            "SNHG10",
            "CHTF18",
            "TIMM16",
            "LOC100216545",
            "MIF",
            "SGMS2",
            "ARHGAP42",
            "C7orf47",
            "MRPL41",
            "MRPL52",
            "LAGE3",
            "ALKBH6",
            "LOC100286793",
            "C11orf83",
            "CENPT",
            "ITGB3BP",
            "DOCK9",
            "SIVA1",
            "NEURL2",
            "NDUFS6",
            "LSM7",
            "FAM128A",
            "TRAPPC5",
            "GADD45GIP1",
            "C19orf60",
            "MTP18",
            "NAA10",
            "U2AF1L4",
            "FAM63B",
            "ARL16",
            "MYO9A",
            "BOD1",
            "NUDT1",
            "FAM128B",
            "B3GNTL1",
            "C9orf142",
            "RCCD1",
            "C17orf90",
            "PSMG4",
            "BNIP1",
            "KIF13A",
            "DIXDC1",
            "C16orf61",
            "DDX39",
            "PRKAR2A",
            "HAUS7",
            "MRPL55",
            "ROCK2",
            "NDUFS8",
            "NHP2",
            "HIPK3",
            "TRMT2A",
            "MAN1A2",
            "ASXL2",
            "RAB24",
            "YAP1",
            "C9orf37",
            "FAM100B",
            "MRPL22",
            "REST",
            "HIGD2A",
            "FANCL",
            "KIF22",
            "PCYOX1",
            "SLK",
            "AURKAIP1",
            "TRMT1",
            "CIDECP",
            "DRAP1",
            "C10orf118",
            "POLR2H",
            "IDE",
            "PPP4C",
            "MFSD6",
            "TAZ",
            "LATS2",
            "SLC25A39",
            "COPE",
            "H1FX",
            "PRELID1",
            "RNASEH2C",
            "PGP",
            "ZFP106",
            "WDR85",
            "CTU2",
            "METT11D1",
            "PLEKHJ1",
            "B4GALT7",
            "MIIP",
            "COMMD4",
            "ARL6IP4",
            "TM9SF2",
            "NCAPH2",
            "KLF3",
            "NDUFS7",
            "TSEN54",
            "PARVA",
            "DNAJC3",
            "RAPGEF2",
            "NOC4L",
            "ZNF346",
            "TMCO6",
            "MRPL28",
            "UBR3",
            "TJP1",
            "INO80E",
            "IQGAP1",
            "ARHGEF12",
            "WDR47",
            "SH3D19",
            "NUP85",
            "TIMM44",
            "KIAA0494",
            "ZBTB44",
            "HNRNPAB",
            "EMD",
            "KIDINS220",
            "BMPR2",
            "C16orf68",
            "LOC647979",
            "EVI5",
            "EP300",
            "UBAC1",
            "SOCS5",
            "ELF1",
            "RNF25",
            "PRKAR1A",
            "GRK6",
            "BCS1L",
            "SNRPA",
            "EIF4EBP2",
            "ILKAP",
            "CSDE1",
            "SNX19",
            "MUS81",
            "DDX41",
            "NBAS",
            "EPC2",
            "USP47",
            "SFRS7",
            "SEC23IP",
            "GIGYF2",
            "RNF111",
            "PAFAH1B1",
            "RAB14",
            "RAB3GAP1",
            "DDX6",
            "SFRS2"
        ]
    },
    {
        "golabel": "MXD4_regulon_activity",
        "gene": [
            "DEPDC1",
            "CASC5",
            "TTK",
            "CENPI",
            "DLGAP5",
            "RAD51AP1",
            "KIAA1524",
            "CKAP2L",
            "CDK1",
            "PRKCZ",
            "SGOL1",
            "NUP62CL",
            "BUB1",
            "PRIM1",
            "CENPK",
            "HELLS",
            "KIF18A",
            "SGOL2",
            "TMLHE",
            "ECT2",
            "SOX18",
            "RACGAP1",
            "SLC9A3R2",
            "TMPO",
            "TXNRD2",
            "UNC93B1",
            "RAB40C",
            "UBTD1",
            "CRTC1",
            "YPEL3",
            "BBC3",
            "LRPAP1",
            "DGKQ",
            "MFSD10",
            "DYRK1B",
            "TMEM175",
            "C9orf7",
            "SLC43A2",
            "SPATA2L",
            "DEAF1",
            "RXRA",
            "TMEM129",
            "NAB1",
            "WDR81",
            "DEK",
            "ARAP1",
            "CYB561",
            "PQLC1",
            "SLC39A13",
            "SGSH",
            "CAMTA2",
            "SCAMP4",
            "RFX1",
            "PSKH1",
            "C11orf2",
            "CTBP1",
            "CTDSP1",
            "TADA2B",
            "TMEM115",
            "CDC23",
            "ADD1",
            "BAP1"
        ]
    },
    {
        "golabel": "MYBBP1A_regulon_activity",
        "gene": [
            "CD48",
            "SNHG4",
            "FCGR2B",
            "BCL2A1",
            "TLR7",
            "GPR65",
            "CD300A",
            "LPAR6",
            "CAD",
            "ACTR3B",
            "MAP1D",
            "IPO4",
            "RAB8B",
            "STOM",
            "CYB5D1",
            "TP53",
            "DHX33",
            "DHX34",
            "PFAS",
            "PLEKHF2",
            "KIAA0664",
            "DHODH",
            "RRP12",
            "VARS",
            "OTUD1",
            "PDCD11",
            "NEURL4",
            "EHMT2",
            "TFAP4",
            "GEMIN4",
            "TRIM21",
            "PELP1",
            "TDRD7",
            "SNX11",
            "DVL2",
            "DDX54",
            "KIAA0753",
            "DPH1",
            "TSR1",
            "PWP2",
            "RAP1A",
            "POLR3E",
            "FXR2",
            "JKAMP",
            "MNT",
            "ILF3",
            "ELAC2",
            "SND1",
            "SAFB2",
            "SAFB",
            "USP19"
        ]
    },
    {
        "golabel": "MYBL2_regulon_activity",
        "gene": [
            "GDF1",
            "DLX6",
            "FOXD3",
            "ZNF385B",
            "HIST1H3B",
            "SV2A",
            "HIST1H2AL",
            "SLC26A9",
            "SPATA18",
            "SFTA1P",
            "RCOR2",
            "MAST1",
            "YBX2",
            "ABCA8",
            "CCNE1",
            "ADH1B",
            "HIST1H2BO",
            "ZNF695",
            "ANKLE1",
            "STC2",
            "TUBB4",
            "SFTPB",
            "SYCE2",
            "PHGDH",
            "TMEM163",
            "MAMDC2",
            "HIST2H3C",
            "EDA2R",
            "WDR62",
            "SPC24",
            "RDM1",
            "FAM64A",
            "CCNB2",
            "CBS",
            "UBE2C",
            "GPR116",
            "CDKN3",
            "C9orf152",
            "SLC22A3",
            "TROAP",
            "POLE2",
            "GPR19",
            "CENPA",
            "PNMA2",
            "PARM1",
            "MCM10",
            "C1orf116",
            "SKA1",
            "NDC80",
            "AURKB",
            "C10orf95",
            "NUF2",
            "TTK",
            "GLOD5",
            "ESPL1",
            "C1orf135",
            "FADS2",
            "CDC45",
            "DLGAP5",
            "TPX2",
            "TRIP13",
            "RHEBL1",
            "KIF2C",
            "ENTPD3",
            "KIF18B",
            "DRAM1",
            "CDC6",
            "CENPW",
            "SPC25",
            "CDC25C",
            "BIRC5",
            "CDC20",
            "KIFC1",
            "STMN1",
            "HJURP",
            "RAD54L",
            "KIAA1524",
            "CDCA3",
            "CCNA2",
            "MELK",
            "CFI",
            "SNX30",
            "SKA3",
            "MAP6D1",
            "FAM54A",
            "NCAPH",
            "CDT1",
            "GPR3",
            "UBE2S",
            "ST3GAL5",
            "CCDC34",
            "CDCA5",
            "CDH24",
            "CDCA8",
            "E2F1",
            "C9orf140",
            "PLK1",
            "PKMYT1",
            "GTSE1",
            "VWA2",
            "FAM83D",
            "KIF20A",
            "EPHX2",
            "CHEK2",
            "ADA",
            "CENPM",
            "PSRC1",
            "C17orf96",
            "ZWINT",
            "ECE2",
            "ASF1B",
            "NR3C2",
            "HSD17B11",
            "TMEM133",
            "CDCA4",
            "SHMT2",
            "FADS1",
            "MOSC2",
            "CYFIP2",
            "EMP2",
            "RNASEH2A",
            "GPD1L",
            "ARSD",
            "CELF2",
            "TRAIP",
            "GANC",
            "MYO5C",
            "SUV39H1",
            "TLR5",
            "IVD",
            "ATP1A1",
            "DTYMK",
            "TMEM173",
            "ALDH5A1",
            "VWA5A",
            "GTF2IRD2B",
            "RCC1",
            "TOMM40",
            "FCHO2",
            "H2AFX",
            "CAT",
            "ASAH1",
            "TGFBR2",
            "C21orf45",
            "RRM2B",
            "CCDC123",
            "C5orf53",
            "TUBA1C",
            "TAPT1",
            "NUDT1",
            "C11orf84",
            "FANCG",
            "THOC4",
            "CYP4V2",
            "DDX39",
            "PSMC4",
            "MRPL47",
            "C5orf41",
            "CTDSPL",
            "GTF2IRD2P1",
            "TUBB",
            "POLA2",
            "C20orf20",
            "C19orf47",
            "CTSO",
            "TUBA1B",
            "ATAD3A",
            "GTF2IRD2",
            "RAE1",
            "HAUS8",
            "BCL2L12",
            "ZNF33B",
            "BTD",
            "RETSAT",
            "CCDC86",
            "CDS1",
            "POLD2",
            "MBLAC2",
            "TBRG4",
            "HSD17B4",
            "ERMAP",
            "PHKB",
            "CCNDBP1",
            "TMEM87A",
            "TMEM189",
            "GLT25D1",
            "MTMR10",
            "DNAJB11",
            "YKT6",
            "FBXO38",
            "PCBD2",
            "RNF26",
            "RBL2",
            "DVL3",
            "FBXL17",
            "SDCCAG8",
            "C16orf88",
            "KIAA0141",
            "GSS",
            "XPC",
            "TSPYL1",
            "C15orf17",
            "CREBL2",
            "TRIM13",
            "TRIM5",
            "FXC1",
            "NKIRAS2",
            "SACM1L",
            "ZFP64",
            "CNP",
            "PRPF19",
            "NUP93",
            "CTNNBL1",
            "SNX1",
            "NRBP1",
            "XPA",
            "MTA2",
            "C10orf76"
        ]
    },
    {
        "golabel": "MYEF2_regulon_activity",
        "gene": [
            "NKAIN2",
            "CTXN2",
            "OGDHL",
            "AP3B2",
            "PPM1E",
            "CELF4",
            "MYH7B",
            "WDR17",
            "LONRF2",
            "PRKAA2",
            "SLC24A5",
            "GDAP1",
            "ADAM8",
            "SBK1",
            "GBP3",
            "CD14",
            "DSE",
            "FZD3",
            "ITGB2",
            "EMP3",
            "OAF",
            "GOLGA6L10",
            "CLTB",
            "GBP2",
            "ZNF397",
            "CARD16",
            "CASP1",
            "CD44",
            "LAPTM5",
            "C17orf69",
            "IFT81",
            "PSMB10",
            "SIRPA",
            "RHOC",
            "GKAP1",
            "TMEM170B",
            "RAC2",
            "FAM161A",
            "SS18L1",
            "KIAA1949",
            "PIAS2",
            "ZNF620",
            "SUZ12P",
            "WDR35",
            "EHD1",
            "LUC7L3",
            "HSDL1",
            "POLI",
            "POGZ",
            "PATZ1",
            "MBTD1",
            "ZNF248",
            "DNAJC27",
            "TNIP1",
            "CASC3",
            "NLK",
            "PTCD3",
            "OSTF1"
        ]
    },
    {
        "golabel": "MYNN_regulon_activity",
        "gene": [
            "RPL21",
            "ZFAND1",
            "MLF1",
            "OSTCL",
            "ACAP2",
            "MED21",
            "GOLGA7",
            "SELT",
            "CENPQ",
            "ARPM1",
            "CRIPT",
            "PRKCI",
            "NDUFB5",
            "TTC5",
            "ACTL6A",
            "PDCD10",
            "TMEM182",
            "TGDS",
            "C20orf111",
            "SKIL",
            "MPRIP",
            "ARL6",
            "TBC1D15",
            "C12orf29",
            "NCK1",
            "SSR3",
            "CLDND1",
            "EIF4A2",
            "RCN2",
            "DGKQ",
            "C3orf33",
            "COMMD2",
            "METTL4",
            "PUS7L",
            "GAK",
            "UBE2Q2",
            "NMD3",
            "DCUN1D1",
            "RAD1",
            "DPM1",
            "TUBD1",
            "ZNF410",
            "TBCCD1",
            "LIN52",
            "CHMP5",
            "NANP",
            "RARS2",
            "COG6",
            "C3orf38",
            "POLE3",
            "GTPBP8",
            "MRPS22",
            "PACRGL",
            "C12orf41",
            "SEC62",
            "ZNF639",
            "PPP1R2P3",
            "ANKRD49",
            "SLC33A1",
            "NSUN3",
            "MED15",
            "MYCBP",
            "DUSP11",
            "DR1",
            "ZCCHC7",
            "AGAP3",
            "GTPBP1",
            "CTTN",
            "KTELC1",
            "MFN1",
            "SEC22A",
            "RNF13",
            "RYK",
            "CTDSPL2",
            "PCNP",
            "THAP5",
            "SLC35A5",
            "TMEM39A",
            "MYO1C",
            "RQCD1",
            "FLII",
            "KIAA1704",
            "RBBP4",
            "SNX5",
            "PPP1R2",
            "RNF114",
            "PLD2",
            "RNF41",
            "TBC1D23",
            "DHX38",
            "ARHGDIA",
            "PPP1R9B",
            "EIF2A",
            "CNBP",
            "SMG6",
            "ASTE1",
            "DBR1",
            "SNX4",
            "HNRPLL",
            "TTC15",
            "ARMC8",
            "TUBGCP2",
            "MARCH7",
            "C3orf17"
        ]
    },
    {
        "golabel": "NAA15_regulon_activity",
        "gene": [
            "KIF12",
            "GGT3P",
            "LOC644165",
            "CLSPN",
            "USHBP1",
            "SULT1A2",
            "MAD2L1",
            "DEPDC1",
            "PRR11",
            "HSPA4L",
            "MPP6",
            "CENPE",
            "CKAP2L",
            "CCNA2",
            "SGOL1",
            "TOP2A",
            "FBXL8",
            "MYC",
            "TMEM91",
            "PLK4",
            "LRP12",
            "NEIL1",
            "ACCS",
            "NUP155",
            "CCDC64B",
            "CKAP2",
            "LDLRAD2",
            "TMEM48",
            "C16orf86",
            "HIF1A",
            "HOMER1",
            "SPATA5",
            "FAAH",
            "PPAT",
            "JMJD7-PLA2G4B",
            "DBP",
            "FLJ11235",
            "ERI1",
            "CDK10",
            "YPEL3",
            "CCRN4L",
            "PAICS",
            "DDX21",
            "NEK8",
            "CCDC159",
            "SIGIRR",
            "THRA",
            "C21orf2",
            "NLN",
            "METTL2B",
            "C1orf103",
            "MAN2C1",
            "ROGDI",
            "DHRS1",
            "TMEM175",
            "KIAA0020",
            "SGSM3",
            "ABTB1",
            "HDAC10",
            "CCDC61",
            "LRCH4",
            "RAD18",
            "RABEP2",
            "PANX1",
            "TWISTNB",
            "DDX10",
            "GSTCD",
            "NBN",
            "TEX10",
            "WDR43",
            "SH3GLB2",
            "ANAPC1",
            "SPSB3",
            "CCDC101",
            "WDR3",
            "URB2",
            "LMAN1",
            "GTF2H3",
            "RAB4B",
            "CLN3",
            "GART",
            "UBA6",
            "LRPPRC",
            "POLR1B",
            "NUP54",
            "PPP4R2",
            "SRP72",
            "EIF2S1",
            "LMBR1",
            "VMAC",
            "LARP1B",
            "LUZP6",
            "EIF4E",
            "ZC3H15",
            "ANAPC10",
            "DHX36",
            "IARS",
            "ABCE1",
            "GFM1",
            "G3BP1",
            "SRPK2",
            "GAR1",
            "DFFA",
            "AP1AR",
            "SRFBP1",
            "C17orf59",
            "UTP15",
            "C4orf43",
            "NAPA",
            "AGPS",
            "RARS",
            "DDX18",
            "TBC1D17",
            "TOMM70A",
            "PHF1",
            "UBE3C",
            "MOB2",
            "NAA35",
            "EXOSC9",
            "HSPA4",
            "SMARCA5",
            "PPID",
            "METAP1",
            "RAD23B",
            "HPS1",
            "NUCB1",
            "SDAD1",
            "LIN54",
            "SMARCAD1",
            "NAT15",
            "BBS7",
            "NAF1",
            "PRPF40A",
            "HNRNPR",
            "RBM12"
        ]
    },
    {
        "golabel": "NCOA1_regulon_activity",
        "gene": [
            "HRC",
            "MARK1",
            "SLC22A18AS",
            "PYGO1",
            "UPP1",
            "S100A6",
            "NAGS",
            "PHLDA2",
            "C7orf40",
            "RIN1",
            "ZNF704",
            "RPL36",
            "TIMM16",
            "TXNDC17",
            "NEO1",
            "COBLL1",
            "NDUFA11",
            "GUK1",
            "EPAS1",
            "TRIP6",
            "BET1",
            "PNP",
            "GADD45GIP1",
            "ZNF192",
            "SASH1",
            "MED10",
            "SIK2",
            "NOP16",
            "ZFYVE9",
            "PHACTR2",
            "MED13L",
            "C19orf70",
            "ROCK2",
            "C19orf53",
            "SPTBN1",
            "ASXL2",
            "PLEKHM3",
            "MRPL1",
            "TRMT1",
            "ERC1",
            "MARCH8",
            "ALMS1",
            "LATS1",
            "PRELID1",
            "KTN1",
            "STX10",
            "NCOR1",
            "HERC1",
            "ZNF318",
            "MRPL4",
            "RMND5A",
            "ZC3H13",
            "ZZEF1",
            "ATAD2B",
            "IFRD2",
            "TMEM131",
            "KIDINS220",
            "WDR7",
            "BIRC6",
            "PIKFYVE",
            "HEATR5B",
            "SOS1",
            "NBAS",
            "USP34",
            "USP47",
            "ZRANB1",
            "AFTPH",
            "PUM2"
        ]
    },
    {
        "golabel": "NCOA2_regulon_activity",
        "gene": [
            "BTBD8",
            "FMN1",
            "ITGA9",
            "SESN3",
            "IFI27L2",
            "COX6B1",
            "NFATC2",
            "RASEF",
            "IL6ST",
            "ZNF704",
            "NBEAL1",
            "IL6R",
            "C2orf27A",
            "REL",
            "MYEOV2",
            "SERINC5",
            "WDR31",
            "TRAM1",
            "FAM160A1",
            "ZNF573",
            "FAM161B",
            "NIPAL2",
            "RAPGEF6",
            "ANKRD36BP1",
            "COX4I1",
            "C9orf5",
            "MYO9A",
            "RBX1",
            "ATP5E",
            "C14orf156",
            "KIF13A",
            "PRKAR2A",
            "C5orf41",
            "ZNF678",
            "HIPK3",
            "ARFGEF1",
            "ASXL2",
            "HRAS",
            "BRPF3",
            "REST",
            "AURKAIP1",
            "UBXN2B",
            "UBR5",
            "C10orf118",
            "ZHX1",
            "ITPA",
            "OXR1",
            "TFPT",
            "PDE4DIP",
            "PIN4",
            "VPS13B",
            "GTF2I",
            "GNG5",
            "VCPIP1",
            "MPV17L2",
            "COMMD4",
            "C1orf151",
            "C8orf58",
            "CNPY4",
            "USP25",
            "UBE2M",
            "PDPK1",
            "HELZ",
            "TAB3",
            "RNF25",
            "UBR2",
            "YTHDF3",
            "EPC1"
        ]
    },
    {
        "golabel": "NCOA4_regulon_activity",
        "gene": [
            "KCNJ5",
            "TNFSF18",
            "CCDC150",
            "BRSK1",
            "STX1A",
            "MSR1",
            "GPR34",
            "C19orf23",
            "NHLH1",
            "TMEM184A",
            "P2RY14",
            "TBC1D3B",
            "DNASE1",
            "IL6ST",
            "TLR4",
            "REEP3",
            "LIPA",
            "CHTF18",
            "SLFN13",
            "MGC12982",
            "IPMK",
            "PPP2R3B",
            "NIPAL2",
            "FAM175A",
            "NASP",
            "UGCG",
            "CAT",
            "ASAH1",
            "RP9P",
            "MAST2",
            "CCHCR1",
            "TCP11L2",
            "ATE1",
            "LEPROT",
            "SLC29A3",
            "PRKAR2A",
            "FBXL19",
            "C5orf41",
            "IFIT5",
            "STK17B",
            "ZNF341",
            "PCGF5",
            "ZDHHC3",
            "MBP",
            "TMUB1",
            "NR3C1",
            "DHX34",
            "PLEKHF2",
            "SGK3",
            "GLUD2",
            "MARCH8",
            "TAF6",
            "IDE",
            "SEPT10",
            "PPA1",
            "MAPK8",
            "CCNDBP1",
            "HBP1",
            "MTMR6",
            "PSAP",
            "GHITM",
            "STT3B",
            "RTKN",
            "PABPN1",
            "HSPA8",
            "C15orf38",
            "MAPK7",
            "UEVLD",
            "EIF4B",
            "PIGN",
            "C17orf70",
            "RNF13",
            "PHF13",
            "ATP6V1B2",
            "AKAP10",
            "ZBTB17",
            "ZBTB6",
            "PJA2",
            "CREBL2",
            "PTENP1",
            "IKZF5",
            "GLUD1",
            "HGS",
            "EXOC6",
            "SMPD4",
            "ELF1",
            "U2AF1",
            "FEM1B",
            "MTFMT",
            "PLEKHB2",
            "EIF4EBP2",
            "FAM35A",
            "USP8",
            "DDX50",
            "SHOC2",
            "PTEN",
            "SNX2",
            "CSTF2T",
            "PPP3CB",
            "NRBF2",
            "SEC23IP",
            "SAP30BP",
            "COPS7B",
            "C10orf26",
            "TNKS2",
            "ANXA7",
            "MAPK14",
            "AP3M1",
            "WAPAL",
            "ABI1",
            "RAB14",
            "VPS24",
            "FAM175B",
            "SAR1A",
            "CHTF8"
        ]
    },
    {
        "golabel": "NCOA6_regulon_activity",
        "gene": [
            "TET1",
            "OTX1",
            "APOBEC3H",
            "PCDHGA1",
            "LST1",
            "TNFSF12-TNFSF13",
            "NPC2",
            "DSP",
            "SH3BGR",
            "SMARCD3",
            "CLIC2",
            "LOC440957",
            "S100A13",
            "KIAA1549",
            "MED31",
            "NUDT6",
            "KIAA1958",
            "TP53INP2",
            "RBKS",
            "C4orf33",
            "TAOK1",
            "C20orf117",
            "TMEM42",
            "FAH",
            "CPNE1",
            "STOML1",
            "ICAM2",
            "SIK2",
            "C9orf103",
            "RNF144A",
            "ACOT1",
            "BDH2",
            "UQCR10",
            "PLAGL2",
            "RIF1",
            "CEP250",
            "DHX33",
            "ATP6V0E1",
            "MRPL32",
            "DOPEY2",
            "JARID2",
            "SMC3",
            "TXN2",
            "OSGEP",
            "CKAP5",
            "ZNF496",
            "TAF4",
            "POLR3A",
            "ESF1",
            "ZNF146",
            "UHRF1BP1",
            "TMEM219",
            "RSF1",
            "UROD",
            "ANAPC1",
            "NCOA3",
            "MFSD9",
            "ZNF318",
            "NUP153",
            "SMARCC1",
            "STK35",
            "BCL2L11",
            "BRD3",
            "BAZ2A",
            "POFUT1",
            "BAT2",
            "RALBP1",
            "KIF3B",
            "PATL1",
            "SNRNP200",
            "PHF20",
            "ADNP",
            "ITCH",
            "NFS1",
            "PEF1",
            "HCFC1",
            "RALGAPB",
            "SMG7",
            "TM9SF4",
            "DHX9",
            "TRPC4AP",
            "CTCF"
        ]
    },
    {
        "golabel": "NCOR1_regulon_activity",
        "gene": [
            "PFN4",
            "CDKL5",
            "MRPS6",
            "CHCHD2",
            "NBEAL1",
            "C21orf119",
            "C2orf7",
            "POU2F1",
            "PSMG3",
            "FZD5",
            "FAM83G",
            "C7orf50",
            "RPA3",
            "ITGB3BP",
            "INSR",
            "PPIAL4G",
            "RAD54L2",
            "C7orf36",
            "ZNF618",
            "BOD1",
            "C20orf111",
            "MED13L",
            "C16orf61",
            "RAD9B",
            "C16orf91",
            "DHX33",
            "GET4",
            "RAI1",
            "PLEKHM3",
            "MRPL32",
            "PFAS",
            "C7orf44",
            "HSPB11",
            "LSM5",
            "FAM18B",
            "C17orf68",
            "NCOA1",
            "PPIA",
            "TOP3A",
            "PSMA2",
            "ANKRD12",
            "SLC25A14",
            "UROD",
            "KIF1C",
            "CHD3",
            "C7orf70",
            "KTN1",
            "ADCK2",
            "ZBTB4",
            "MYST4",
            "POLR2A",
            "ZC3H13",
            "KDM5A",
            "ZZEF1",
            "NUPL2",
            "RAPGEF2",
            "TJP1",
            "SMCR8",
            "USP22",
            "BRD3",
            "C7orf30",
            "CXorf40A",
            "AKAP10",
            "BPTF",
            "BAT2L2",
            "PRPF8",
            "METT10D",
            "ZNF609",
            "FLII",
            "TAF3",
            "CXorf40B",
            "MCTS1",
            "VPS53",
            "C17orf39",
            "XPO7",
            "COX10",
            "LOC493754",
            "SMG6",
            "CRK",
            "KDM3B",
            "ANKFY1",
            "ATF7",
            "MAP2K4",
            "PAFAH1B1",
            "RABEP1",
            "PITPNA"
        ]
    },
    {
        "golabel": "NCOR2_regulon_activity",
        "gene": [
            "NSMCE2",
            "PLEC",
            "NDUFB1",
            "PRDX4",
            "ITPR3",
            "LSM2",
            "DGKD",
            "PECI",
            "HSBP1",
            "C8orf40",
            "NOTCH3",
            "TMEM17",
            "PITPNM2",
            "PRIC285",
            "C14orf142",
            "TSPAN6",
            "MORN2",
            "TANC2",
            "C4orf52",
            "SAR1B",
            "C20orf111",
            "BCL9L",
            "ASF1A",
            "NFIC",
            "NOTCH1",
            "SUB1",
            "NACC2",
            "WBP5",
            "PSMC6",
            "TIMM9",
            "MRPL32",
            "PEX3",
            "TPCN1",
            "MYH9",
            "TSEN15",
            "SERP1",
            "GTF2H5",
            "C14orf109",
            "C1orf74",
            "CCDC104",
            "MRPS22",
            "CIC",
            "PIGH",
            "EIF1AX",
            "FAM200A",
            "LIPT1",
            "ATN1",
            "EP400",
            "CHMP4A",
            "ATG2A",
            "SKI",
            "DDX54",
            "ANAPC10",
            "COPS4",
            "LYRM2",
            "MRPS18C",
            "PPP1R2",
            "MIS12",
            "NDUFA5",
            "SETD1B",
            "EIF1B",
            "RFX1",
            "ANAPC13",
            "DKFZp761E198",
            "METTL6",
            "ZDHHC6",
            "MNT",
            "MRFAP1L1",
            "DDX42",
            "PTPN23"
        ]
    },
    {
        "golabel": "NFAT5_regulon_activity",
        "gene": [
            "SKINTL",
            "DNAH1",
            "PDZD2",
            "GPRASP1",
            "MYLK4",
            "C7orf54",
            "RPS15AP10",
            "RPL21P44",
            "KIAA1377",
            "MALAT1",
            "FAM13AOS",
            "RPL35",
            "KCNQ1OT1",
            "NCRNA00201",
            "MRPS12",
            "RUNDC2C",
            "TAS2R14",
            "LOC153684",
            "LOC100190986",
            "LOC90834",
            "CROCCL2",
            "SNRPD2",
            "KIAA1407",
            "CG030",
            "COBLL1",
            "INE1",
            "FLJ10213",
            "LOC283922",
            "C1orf152",
            "TSSK4",
            "SHANK2",
            "DERA",
            "BMS1P5",
            "FLJ45340",
            "ZNF37B",
            "BSPRY",
            "SYNE2",
            "GADD45GIP1",
            "ZNF594",
            "UQCR11",
            "LOC646762",
            "NKTR",
            "GATC",
            "PSMD8",
            "PXMP2",
            "ADSL",
            "PRDX2",
            "STOML2",
            "PDPR",
            "COPS3",
            "FDPS",
            "RANBP10",
            "SFRS18",
            "UBL4A",
            "SRRM2",
            "RBMS2",
            "SMG1",
            "METTL2A",
            "UBN2",
            "ISCA1P1",
            "CHD9",
            "SLC7A6",
            "ZC3H6",
            "FNBP4",
            "METTL11A",
            "MRPS7",
            "ANKRD42",
            "BRWD1",
            "ZNF23",
            "CHD2",
            "SNTB2",
            "GRHPR",
            "PPP1CA",
            "ZNF576",
            "TNRC6A",
            "RBM33",
            "ZCCHC14",
            "ATXN1L",
            "RNF41",
            "EDC4",
            "URM1",
            "ANKRD11",
            "DHX38",
            "C16orf52",
            "INO80D",
            "TMEM203",
            "PCF11",
            "RBM25",
            "RC3H1",
            "ZNF638",
            "DYNC1LI2",
            "SURF4",
            "TMEM170A",
            "AP1G1"
        ]
    },
    {
        "golabel": "NFATC2_regulon_activity",
        "gene": [
            "GP5",
            "TNIK",
            "ROR1",
            "KIAA0754",
            "MBNL3",
            "ZFP92",
            "C17orf61",
            "IKZF3",
            "ZNF366",
            "C1orf31",
            "ERN1",
            "PIK3CG",
            "KRT10",
            "KIRREL",
            "PTPRG",
            "ZNF354C",
            "FNIP2",
            "TTYH2",
            "PLXNC1",
            "ANKRD44",
            "MGAT5",
            "MTMR8",
            "SEC61G",
            "ITPR2",
            "PRDX1",
            "MAML2",
            "C6orf204",
            "FOXN3",
            "ZBTB20",
            "LRRC3",
            "HSBP1L1",
            "PSMG3",
            "NCOA2",
            "MRPS15",
            "FAM161B",
            "COX6C",
            "RAPGEF6",
            "FKBP3",
            "PTS",
            "ACOT13",
            "SPATA13",
            "UQCRH",
            "RUNDC2A",
            "LRRK1",
            "FAM168A",
            "HBXIP",
            "USMG5",
            "RAD54L2",
            "TMEM223",
            "KIAA0922",
            "MYO9A",
            "C11orf48",
            "TTBK2",
            "C14orf156",
            "PFDN6",
            "C9orf129",
            "LNPEP",
            "C14orf2",
            "NDUFV2",
            "NFIC",
            "C5orf41",
            "RC3H2",
            "HIPK3",
            "TGIF1",
            "ATF7IP",
            "ASXL2",
            "NDUFS5",
            "MBP",
            "UQCRB",
            "REV3L",
            "RASA2",
            "C9orf102",
            "MRPL27",
            "MARCH8",
            "MYCBP2",
            "CHCHD1",
            "SNRPE",
            "PDF",
            "NEK1",
            "BANF1",
            "ABR",
            "TXNL4A",
            "PIN4",
            "GNG5",
            "ZBTB8OS",
            "ZNF619",
            "C14orf1",
            "AFF1",
            "SNRPD3",
            "IL17RA",
            "PCNX",
            "GNA11",
            "CXorf38",
            "GLRX5",
            "NFKB1",
            "GTF2F2",
            "RBM34",
            "SETX",
            "UTP11L",
            "STAT5B",
            "NDST2",
            "RDH14"
        ]
    },
    {
        "golabel": "NFATC3_regulon_activity",
        "gene": [
            "CACNA2D2",
            "FBXO32",
            "SPHK1",
            "NFIX",
            "RECQL4",
            "PLAUR",
            "PTCH1",
            "CGNL1",
            "SLC16A3",
            "TK1",
            "FAM162A",
            "OPHN1",
            "EMP2",
            "PSMG3",
            "TNS1",
            "TRAIP",
            "DPYSL2",
            "AKAP13",
            "DTYMK",
            "EPB41L4A",
            "ZNF778",
            "MRPL12",
            "CRY2",
            "TUBA1C",
            "ZFHX3",
            "GPR172A",
            "ESRP2",
            "PLEKHM3",
            "REV3L",
            "CES2",
            "CDC34",
            "TBRG4",
            "VPS13D",
            "SNX29",
            "CHD9",
            "HSF1",
            "PAPD5",
            "FTO",
            "RBL2",
            "WWP2",
            "ZBTB3",
            "GNPTAB",
            "SNTB2",
            "KIAA0240",
            "ATXN1L",
            "ZFP90",
            "CNOT6L",
            "TERF2IP",
            "EIF4EBP2",
            "CNOT1",
            "ATF7",
            "DYNC1LI2",
            "AP1G1",
            "TERF2",
            "CTCF"
        ]
    },
    {
        "golabel": "NFE2L1_regulon_activity",
        "gene": [
            "GAS5",
            "CYB5A",
            "RPS15A",
            "RPL35",
            "RPS6",
            "RPL31",
            "CLCN4",
            "METTL12",
            "SNHG3",
            "RPL36",
            "RPS8",
            "RPL27A",
            "C7orf47",
            "RPL5",
            "RPS15",
            "TAOK1",
            "RPL32",
            "LOC375190",
            "RPL7A",
            "RPS13",
            "RPS24",
            "RPL14",
            "PTGFRN",
            "ANKRD46",
            "NOMO2",
            "ZNF827",
            "PPP2R5A",
            "SEC14L1",
            "CLCN3",
            "LASP1",
            "IGF2R",
            "ERC1",
            "SS18L2",
            "POLR1C",
            "JTB",
            "ATP11B",
            "LUZP1",
            "MYH9",
            "FNDC3B",
            "TIA1",
            "PPA1",
            "PSMD11",
            "PMPCB",
            "CBX1",
            "KIAA0090",
            "GRN",
            "ZNF799",
            "BCAS3",
            "NOMO1",
            "AP2B1",
            "UGGT1",
            "BBX",
            "WIPF2",
            "ZCCHC7",
            "PCYT1A",
            "HUWE1",
            "FAM185A",
            "PLBD2",
            "XYLT2",
            "DYNLL2",
            "NPRL2",
            "ZRANB2",
            "EIF4G1",
            "IKZF5",
            "PIGS",
            "GSK3B",
            "KPNB1",
            "USP9X",
            "ABHD15",
            "SEPT9",
            "TRIP12",
            "TMEM104",
            "GLG1",
            "CLTC",
            "TRA2A",
            "SUPT6H",
            "STAT3",
            "DCAF7",
            "EFTUD2",
            "DHX8",
            "GOSR1",
            "DNAJC14",
            "MFN2",
            "NBR1",
            "SP2",
            "TMEM127",
            "UBE2Z",
            "BECN1",
            "NMT1",
            "GRB2",
            "ZDHHC5"
        ]
    },
    {
        "golabel": "NFIC_regulon_activity",
        "gene": [
            "XCL1",
            "FMN1",
            "LYG1",
            "PIF1",
            "FAM24B",
            "ITGA9",
            "SLC34A2",
            "RBMS3",
            "GTF3A",
            "PCDHGA6",
            "SCARNA12",
            "SNHG1",
            "ACYP1",
            "ERN1",
            "NFATC2",
            "PSENEN",
            "KIRREL",
            "IL6ST",
            "PTPRG",
            "CDC42BPA",
            "SGPP2",
            "LOC441208",
            "MAST4",
            "MAP3K13",
            "GALNT10",
            "COX7B",
            "TBC1D7",
            "EMG1",
            "SPDYA",
            "HIP1",
            "RALGAPA2",
            "VDR",
            "MICAL2",
            "POMP",
            "C6orf115",
            "RPS6KA2",
            "FLNA",
            "PTPRE",
            "PSMC1",
            "TIGD1",
            "MYOF",
            "DOCK9",
            "RUNDC2A",
            "CLOCK",
            "LOC282997",
            "TANC2",
            "MYO9A",
            "TBPL1",
            "TTLL11",
            "C14orf156",
            "ASF1A",
            "SNRPA1",
            "C9orf129",
            "EXOSC8",
            "KIF13A",
            "PSMA3",
            "C14orf2",
            "C16orf61",
            "PRKAR2A",
            "SMUG1",
            "RTN4IP1",
            "NACC2",
            "PHF15",
            "MTRF1",
            "SMARCA2",
            "SARNP",
            "SPRED2",
            "FANCL",
            "COMMD7",
            "PPCDC",
            "MTG1",
            "LRRC8E",
            "NDUFAF4",
            "POP5",
            "MSN",
            "C1orf91",
            "THOC1",
            "EEF2",
            "ZNF26",
            "FYCO1",
            "C12orf47",
            "PRPF39",
            "HSPBAP1",
            "ZNF426",
            "C14orf138",
            "FASTKD1",
            "C17orf42",
            "PSMA4",
            "MITD1",
            "DERL2",
            "SETD7",
            "DGUOK",
            "NCOR2",
            "ANKRD49",
            "GTF3C6",
            "MLLT1",
            "FAM200B",
            "FBXW11",
            "RAB11FIP5",
            "IQGAP1",
            "DYNLL1",
            "SH3D19",
            "C15orf40",
            "GNA11",
            "PDPK1",
            "RWDD3",
            "TLN1",
            "POM121C",
            "WDFY3",
            "ZBTB7A",
            "MED6",
            "C6orf35",
            "C2orf56",
            "MAP4",
            "SUMO1",
            "MRPS31",
            "SLC35E1",
            "GLOD4",
            "ORMDL1",
            "ILKAP",
            "RPP30",
            "FAM120A",
            "ARHGAP1",
            "SFRS7",
            "TMEM138",
            "TIAL1",
            "AP3B1",
            "SFRS2"
        ]
    },
    {
        "golabel": "NFIX_regulon_activity",
        "gene": [
            "LOC342346",
            "DMBT1",
            "NWD1",
            "PLA2G1B",
            "LOC723809",
            "KCNK17",
            "MACROD2",
            "TEPP",
            "CD207",
            "TMEM90A",
            "CES3",
            "C15orf59",
            "ERBB4",
            "HSD17B6",
            "HAS3",
            "LRRC31",
            "SUSD2",
            "TNN",
            "PRSS12",
            "SFTPD",
            "ABCA8",
            "ADH1B",
            "ADAMTS8",
            "SYT15",
            "IGSF9B",
            "ALPL",
            "KCND3",
            "ROBO2",
            "INMT",
            "HLF",
            "WBSCR17",
            "HMCN1",
            "RTN4RL1",
            "PGR",
            "TMEM132E",
            "CPAMD8",
            "LAMP3",
            "CACHD1",
            "MAP6",
            "SCN7A",
            "C1QTNF7",
            "FAM64A",
            "FGFR2",
            "PRDM16",
            "OLFM1",
            "CCNB2",
            "MICALCL",
            "ABCA3",
            "ADAMTS17",
            "UBE2C",
            "GATA6",
            "C4A",
            "SCN4B",
            "MFAP4",
            "ELN",
            "PDZD2",
            "OIP5",
            "AURKA",
            "C21orf34",
            "HSPB7",
            "ZDHHC15",
            "TROAP",
            "USP44",
            "CENPA",
            "MAD2L1",
            "C17orf53",
            "MCM10",
            "C1orf190",
            "SCARA3",
            "TUB",
            "C12orf48",
            "PHACTR1",
            "DEPDC1",
            "AURKB",
            "COLEC12",
            "NUF2",
            "ITGA9",
            "CDC45",
            "TUBB3",
            "EPR1",
            "KLHL29",
            "KIF2C",
            "PID1",
            "ADRB2",
            "REPS2",
            "FAM72B",
            "CDC25C",
            "BIRC5",
            "CDC20",
            "HJURP",
            "CDCA3",
            "CDK1",
            "CCNA2",
            "SGOL1",
            "NCAPG",
            "TECTA",
            "SKA3",
            "NEK2",
            "KIAA0101",
            "AUTS2",
            "ESAM",
            "RGAG4",
            "PFKP",
            "FAT4",
            "KAZ",
            "RRM2",
            "CASC2",
            "ORC6L",
            "LCA5",
            "MAN1C1",
            "UBE2T",
            "CEP55",
            "SHROOM4",
            "ENC1",
            "KIAA1324L",
            "CCNB1",
            "CGNL1",
            "PLXNA2",
            "RAD51",
            "MTHFD2",
            "RICH2",
            "TTYH2",
            "STEAP3",
            "C1orf21",
            "ADCY9",
            "MRPS35",
            "PLEKHA4",
            "C8orf76",
            "TMEM98",
            "TEF",
            "SORBS1",
            "MOSC2",
            "ARHGAP31",
            "IFT140",
            "CYFIP2",
            "KPNA2",
            "MOCS1",
            "NFIA",
            "TNS1",
            "POC1A",
            "TCEB1",
            "NME1",
            "AMIGO1",
            "PTK7",
            "CBX7",
            "ZNF608",
            "APBB1",
            "DPYSL2",
            "TRIM22",
            "PPFIBP2",
            "FAM161B",
            "SLCO3A1",
            "ARHGAP24",
            "GALNTL4",
            "C20orf24",
            "HN1",
            "SLC41A1",
            "WWC1",
            "H2AFZ",
            "C17orf103",
            "ARHGEF2",
            "RAB11FIP2",
            "CRY2",
            "SARM1",
            "RGMB",
            "SNRPA1",
            "KIAA1671",
            "THRA",
            "C16orf5",
            "CYP4V2",
            "CTDSPL",
            "RASSF5",
            "SMARCA2",
            "TGIF1",
            "WDR45L",
            "C1orf198",
            "ST5",
            "RILPL2",
            "KANK2",
            "ERMAP",
            "NFATC3",
            "B3GNT1",
            "SNX29",
            "TRAF3IP2",
            "LDLRAP1",
            "CLUAP1",
            "EEF2K",
            "CLEC16A",
            "KIAA0247",
            "GNL3",
            "TFG",
            "FAM136A",
            "RPS6KA1",
            "WWP2",
            "MAP3K3",
            "MRPL3",
            "JMJD6",
            "TSPYL1",
            "KIAA0494",
            "DNM2",
            "NME6",
            "ACP1",
            "CCT7",
            "KLHL20",
            "NUCB1",
            "ARHGAP1",
            "MAPKAPK5",
            "AMBRA1"
        ]
    },
    {
        "golabel": "NFKB1_regulon_activity",
        "gene": [
            "C1orf182",
            "AKR1E2",
            "GALNT5",
            "FMN1",
            "CCR4",
            "TIGD3",
            "HLA-DOA",
            "PTAFR",
            "SLC9A7",
            "ITGAM",
            "MCTP1",
            "TLR2",
            "CYBB",
            "NT5M",
            "AIM1",
            "SPN",
            "PIK3CG",
            "NFATC2",
            "TLR3",
            "IRAK2",
            "DDX60",
            "LIN7B",
            "IFI16",
            "CSF2RB",
            "SNX20",
            "ANKRD44",
            "DOCK2",
            "SGPP2",
            "CIITA",
            "GEMIN8P4",
            "GALNT10",
            "IFFO2",
            "CD82",
            "SGMS2",
            "C10orf41",
            "DOCK10",
            "DOCK8",
            "SAMHD1",
            "ANTXR2",
            "TNFRSF10A",
            "TMEM154",
            "LIN37",
            "BMP2K",
            "ARHGEF6",
            "SLFN5",
            "PTS",
            "LRRK1",
            "HERC3",
            "UGCG",
            "KPTN",
            "APOA1BP",
            "ARAP2",
            "COL4A3BP",
            "PTPRJ",
            "PFDN6",
            "KAT2B",
            "C17orf100",
            "TRANK1",
            "MAP3K5",
            "C12orf73",
            "C15orf61",
            "STK10",
            "ERAP1",
            "CTSO",
            "SEL1L3",
            "MID2",
            "TRIM14",
            "ZSCAN16",
            "FLAD1",
            "ARL3",
            "C12orf47",
            "KLHL2",
            "MANBA",
            "SEC24D",
            "SETD7",
            "RNF19B",
            "TAOK3",
            "PARP4",
            "TAF11",
            "WBP1",
            "CYLD",
            "AFF1",
            "PPP3CA",
            "PIGU",
            "CAST",
            "SH3D19",
            "DNAJB14",
            "GPS2",
            "ACTR5",
            "CXorf38",
            "WDFY3",
            "DYNLRB1",
            "SLC10A7",
            "JAK1",
            "USP38",
            "OTUD4",
            "FAM120A",
            "EIF2B4",
            "METTL14",
            "SEC24B",
            "IRF2"
        ]
    },
    {
        "golabel": "NFKB2_regulon_activity",
        "gene": [
            "SLC12A3",
            "KLRC3",
            "GRAMD1B",
            "RHOV",
            "KYNU",
            "WIPF3",
            "TTC24",
            "MAFK",
            "RHOF",
            "CYB5A",
            "ZAP70",
            "UBASH3A",
            "CTRL",
            "INSL3",
            "ZC3H12A",
            "RNF207",
            "SPATC1",
            "RASAL3",
            "PVRIG",
            "RARG",
            "CCDC88B",
            "TMC8",
            "MICALL2",
            "NLRC5",
            "PPP1R13L",
            "ZDHHC21",
            "LOC100270710",
            "DGKA",
            "TSPAN12",
            "ATL1",
            "ZNF254",
            "PSMB10",
            "MLKL",
            "CGRRF1",
            "APOL2",
            "STAMBPL1",
            "FMNL1",
            "MAP3K14",
            "STAU2",
            "HSH2D",
            "C14orf167",
            "FAM38A",
            "LNX2",
            "C8orf83",
            "TCIRG1",
            "RELB",
            "FAM65A",
            "BCAR1",
            "DEF6",
            "KLF16",
            "TICAM1",
            "OXR1",
            "MFSD6",
            "RBBP9",
            "SOLH",
            "ZNF252",
            "OGFR",
            "TRIP10",
            "TAPBP",
            "STAT2",
            "RNF126",
            "SLC24A6",
            "SIPA1",
            "CCDC9",
            "DHX40",
            "MOV10",
            "KLHL8",
            "TMED10P1",
            "ARHGEF18",
            "IRF3",
            "PTPN6",
            "FBXO3",
            "REXO1",
            "ATXN3",
            "CDC37",
            "SMAD5",
            "DKFZp761E198",
            "SLC25A28",
            "VEZF1",
            "XPNPEP1",
            "PPM1A",
            "ATXN2L",
            "MATR3"
        ]
    },
    {
        "golabel": "NFKBIB_regulon_activity",
        "gene": [
            "CCDC64",
            "CBLC",
            "SNURF",
            "MRPS12",
            "PSENEN",
            "PTPRG",
            "TIMM50",
            "FKBP2",
            "ALKBH6",
            "SARS2",
            "SDF2L1",
            "ECH1",
            "SPINT2",
            "SPRED1",
            "TOMM40",
            "ZNF430",
            "ZNF428",
            "C19orf60",
            "MAP3K10",
            "NANS",
            "MVD",
            "RBM42",
            "KLHDC10",
            "PSMC4",
            "C19orf47",
            "PAK4",
            "YIF1B",
            "KLHL28",
            "USF2",
            "ZNF787",
            "SHKBP1",
            "MBLAC2",
            "PGP",
            "C19orf54",
            "ADCK4",
            "PTGES2",
            "RAB4B",
            "ZNF619",
            "SUPT5H",
            "PAF1",
            "TRIM23",
            "AKT2",
            "ADRM1",
            "AASDH",
            "POLK",
            "DEDD2",
            "AKT1S1",
            "KLHL8",
            "EGLN2",
            "KIAA1430",
            "GMPPA",
            "PJA2",
            "BRMS1",
            "ZNF451",
            "MPP5",
            "C19orf61",
            "C3orf63",
            "CLASP2",
            "KIAA1143",
            "WDR48",
            "METTL14",
            "ELF2",
            "CREB1",
            "MATR3"
        ]
    },
    {
        "golabel": "NFXL1_regulon_activity",
        "gene": [
            "FXYD1",
            "RNASE1",
            "PLAC9",
            "MCM10",
            "ARHGAP11B",
            "DEPDC1",
            "PRKAA2",
            "PLLP",
            "PRR11",
            "CASC5",
            "KIF23",
            "KIF14",
            "CYP27A1",
            "CENPE",
            "NDRG2",
            "SGOL1",
            "NCAPG",
            "BUB1B",
            "ARHGAP11A",
            "PLK4",
            "ECT2",
            "PPP2R1B",
            "MTHFD2",
            "N4BP2",
            "EPT1",
            "KIF20B",
            "C6orf1",
            "PPAT",
            "XPOT",
            "PRKDC",
            "ARL5B",
            "UBTD1",
            "IGFBP4",
            "ARHGDIB",
            "ZWILCH",
            "FCGRT",
            "PAICS",
            "TDG",
            "DDX21",
            "POP1",
            "PAWR",
            "FIP1L1",
            "C21orf2",
            "WDR12",
            "ST6GALNAC6",
            "SFXN1",
            "POLR3A",
            "ZNF770",
            "TNFSF12",
            "GSTCD",
            "WDR43",
            "TAF2",
            "LMAN1",
            "POLR3GL",
            "NAA25",
            "KRR1",
            "DCAF16",
            "GNL3",
            "RPS6KA1",
            "LRPPRC",
            "NOLC1",
            "ESCO1",
            "UBE2K",
            "LARP1B",
            "IARS",
            "R3HDM1",
            "EIF3J",
            "GUF1",
            "POLR2B",
            "NOP14",
            "NAA35",
            "LEO1",
            "YME1L1",
            "DHX15",
            "CCAR1",
            "PRPF40A",
            "MED17"
        ]
    },
    {
        "golabel": "NFYB_regulon_activity",
        "gene": [
            "OBP2B",
            "ZMAT4",
            "TBX18",
            "KCND2",
            "ALDH1L2",
            "PLN",
            "FMN1",
            "C8orf73",
            "CSRP2",
            "WNT7B",
            "NUAK1",
            "AIM1",
            "ITGA3",
            "CD200",
            "ENPEP",
            "ABCC3",
            "CHN1",
            "C1orf113",
            "SGPP2",
            "ENDOD1",
            "MTERFD3",
            "TDG",
            "C9orf167",
            "PLEKHA7",
            "PAK6",
            "ARHGAP27",
            "TMC6",
            "CDC42EP4",
            "H3F3A",
            "BBS10",
            "SSH3",
            "FAM129B",
            "RPS6KA4",
            "KIAA1522",
            "IL17RC",
            "UBE2N",
            "MGAT4B",
            "BAHD1",
            "YAF2",
            "PLEKHM1",
            "ZNF22",
            "HCFC2",
            "RIC8B",
            "CAPN1",
            "NR2C1",
            "UBE2J1",
            "ZDHHC17",
            "PPP1CC",
            "DUSP3",
            "STXBP2",
            "WBP2",
            "CDK17",
            "TOLLIP",
            "SIAH1",
            "USP30"
        ]
    },
    {
        "golabel": "NKX2-1_regulon_activity",
        "gene": [
            "GDA",
            "ANXA8",
            "GJB4",
            "SH2D5",
            "ANXA8L2",
            "ABCC2",
            "FGF12",
            "NOTO",
            "VNN1",
            "ZNF488",
            "HNF4A",
            "GRAMD1B",
            "SERPINB5",
            "SH3TC2",
            "PLA2G12B",
            "FIBCD1",
            "TRIM50",
            "KYNU",
            "POPDC3",
            "SLC26A5",
            "SLC5A2",
            "LOC201651",
            "TNS4",
            "C15orf59",
            "PRMT8",
            "MYBPHL",
            "GGTLC1",
            "CNTNAP3",
            "LYPD3",
            "FAM83B",
            "TM4SF19",
            "TDRD10",
            "DMRTC1B",
            "LOC400794",
            "PPP2R2C",
            "PLEKHH1",
            "SUSD2",
            "HOXD1",
            "PKIB",
            "SLC16A1",
            "TMEM45A",
            "SCNN1B",
            "VEGFC",
            "FLJ42875",
            "OIT3",
            "HOPX",
            "PRR15",
            "RASSF6",
            "CDH15",
            "ITGA6",
            "C16orf89",
            "TMEM171",
            "MST1P2",
            "FAM183B",
            "SLCO4A1",
            "ARNTL2",
            "CIT",
            "FIGNL2",
            "PKP2",
            "SLC47A1",
            "RAG1",
            "ACOXL",
            "PLA2G4F",
            "CDKL2",
            "MTL5",
            "BNIPL",
            "TFAP2E",
            "TMEM158",
            "C5orf38",
            "SLFNL1",
            "SORCS2",
            "SMOX",
            "GUCY2D",
            "PCDH7",
            "GGT3P",
            "IRX2",
            "ENPP1",
            "PALM3",
            "GPR63",
            "MSC",
            "CHRFAM7A",
            "GUCY1B2",
            "CAMK2N1",
            "TMEM108",
            "DLX3",
            "PLCD3",
            "APOL1",
            "DAAM2",
            "GPR133",
            "MBL1P",
            "CTSL1",
            "LOC388588",
            "ICAM5",
            "ZNF750",
            "PRICKLE4",
            "KIAA1211",
            "ESYT3",
            "TFCP2L1",
            "BVES",
            "ABCA3",
            "LOC151009",
            "DPP4",
            "MFSD2A",
            "FAM81A",
            "SFTA2",
            "NHEDC2",
            "CXorf50B",
            "FIGN",
            "LOX",
            "PHYHD1",
            "GLS2",
            "TINAGL1",
            "SDHAP3",
            "PHLDB2",
            "CD163L1",
            "CXCL17",
            "ATP8A1",
            "JAG1",
            "NAPSA",
            "ENOX1",
            "FRRS1",
            "LONRF2",
            "DNAJB4",
            "SELENBP1",
            "TFRC",
            "FAM184A",
            "PLBD1",
            "MYO15A",
            "ATAD3C",
            "NPC2",
            "SULT1A2",
            "IRX5",
            "SULF2",
            "PARM1",
            "TMPRSS2",
            "CMAH",
            "KLF4",
            "USP27X",
            "MBIP",
            "CHST11",
            "NKX3-1",
            "BCAM",
            "GLOD5",
            "LPCAT1",
            "LDLRAD3",
            "CACNB1",
            "C9orf96",
            "SCARB1",
            "ABCC6P1",
            "RHPN2",
            "AMT",
            "FAM69B",
            "ACAD8",
            "FAM177A1",
            "UCK2",
            "WSB1",
            "C4orf44",
            "LOC284837",
            "DAPK2",
            "ABCC6P2",
            "DOK4",
            "INPP4B",
            "STEAP2",
            "LRP2BP",
            "PIP5KL1",
            "MCTP1",
            "LOC283070",
            "ANO9",
            "TMEM80",
            "ST3GAL4",
            "LOC441869",
            "BCAR3",
            "B3GALNT1",
            "ABCC6",
            "SFTA3",
            "B3GNT8",
            "ASAP2",
            "ST3GAL5",
            "KCNK5",
            "RND3",
            "GYLTL1B",
            "FHL2",
            "MALAT1",
            "UBASH3B",
            "LOC113230",
            "PMM1",
            "MALL",
            "C1orf59",
            "SLC39A14",
            "TMEM91",
            "SMARCD3",
            "HK2",
            "ATP2B1",
            "STXBP1",
            "ETV4",
            "TNFRSF10C",
            "HNF1B",
            "LPAR5",
            "KCNC3",
            "ATP11A",
            "CLIP2",
            "B4GALT4",
            "FUT4",
            "PERP",
            "CEBPD",
            "EIF5A2",
            "TGM2",
            "FAM102B",
            "TMLHE",
            "RARB",
            "RORC",
            "ADC",
            "ADA",
            "EEPD1",
            "NEIL1",
            "C12orf76",
            "ECHDC3",
            "TLR6",
            "SLC9A3R1",
            "NECAB3",
            "RAB32",
            "MTHFD2",
            "ACOX2",
            "GPX8",
            "GRID2IP",
            "UNC13B",
            "RPP25",
            "TMEM117",
            "OAF",
            "TSTD1",
            "FBP1",
            "C15orf56",
            "NUDT2",
            "TBC1D24",
            "GATSL3",
            "EFNA1",
            "AGPAT2",
            "LOC100302401",
            "HMGN3",
            "ABCC1",
            "TMEM125",
            "GNA14",
            "MYO1E",
            "RGL3",
            "PDLIM5",
            "PIGA",
            "SLAIN1",
            "RDX",
            "ZNF238",
            "LAMB1",
            "FAM13A",
            "TDP2",
            "ACSL4",
            "SNHG7",
            "BOK",
            "RBPMS",
            "ETHE1",
            "LXN",
            "PLD1",
            "ARHGEF19",
            "ZDHHC21",
            "ABHD14A",
            "CYTSB",
            "ROM1",
            "NOD1",
            "SYTL3",
            "BAHCC1",
            "C8orf42",
            "PALLD",
            "ZDHHC14",
            "WDR91",
            "KCNK6",
            "TM7SF2",
            "ZNF254",
            "ACTN1",
            "CACNB3",
            "FLJ90757",
            "C1orf210",
            "RASA3",
            "EPOR",
            "GLA",
            "LOC651250",
            "GNE",
            "BTBD9",
            "TLE2",
            "DGKD",
            "ECHDC2",
            "KLHDC8B",
            "APOL2",
            "UACA",
            "CARD6",
            "MAP4K4",
            "CADPS2",
            "ZDHHC9",
            "TBC1D1",
            "ZC3H12C",
            "TMEM150A",
            "GNB4",
            "PRMT6",
            "FHOD1",
            "MARVELD1",
            "PPP1R13B",
            "TMEM55A",
            "PDZD8",
            "PGM2",
            "GGCX",
            "MAPK6",
            "RAB40C",
            "KCTD3",
            "MGRN1",
            "UBTD1",
            "RNF24",
            "NUDT16L1",
            "NUAK2",
            "MRPS25",
            "SLC38A2",
            "CEP70",
            "CCDC90B",
            "NAB2",
            "LOC100130093",
            "ITGB5",
            "LOC90110",
            "SLC25A42",
            "STXBP5",
            "GALNT11",
            "ITGB1",
            "C15orf41",
            "TAPT1",
            "FBXO45",
            "C17orf51",
            "ASAP1",
            "EHBP1",
            "RAB23",
            "LIMS1",
            "NEK8",
            "MYLIP",
            "NCK1",
            "TMEM63B",
            "SLC44A1",
            "WWC3",
            "SPATA20",
            "UBE2E3",
            "PLEKHA2",
            "MARCKS",
            "TPM4",
            "ADIPOR2",
            "RPS10P7",
            "B3GNT2",
            "BCAT2",
            "ESRP2",
            "C13orf31",
            "CNTROB",
            "ZNF34",
            "RPAIN",
            "OPTN",
            "DPM2",
            "TXNDC11",
            "IKZF4",
            "CNKSR1",
            "VANGL1",
            "PMF1",
            "MPHOSPH6",
            "ZNF444",
            "CIRBP",
            "NMD3",
            "DCUN1D1",
            "CCDC50",
            "VASP",
            "AGFG1",
            "TRAM2",
            "TBCCD1",
            "CASD1",
            "SLC25A23",
            "ADAM10",
            "BACH1",
            "CDR2",
            "AK2",
            "EPN2",
            "MVK",
            "TTL",
            "FUCA2",
            "HPS5",
            "ORMDL3",
            "SLC38A7",
            "SLC35B4",
            "TMOD3",
            "ZDHHC16",
            "MTMR2",
            "NAB1",
            "TMEM140",
            "TBCD",
            "TTC19",
            "MYST1",
            "GTPBP8",
            "TCP1",
            "CCDC92",
            "C12orf5",
            "PCYT1A",
            "MMADHC",
            "SGSH",
            "LITAF",
            "BIRC2",
            "MED9",
            "PAK2",
            "VTA1",
            "AP1AR",
            "PYCR2",
            "PREP",
            "GTDC1",
            "CALM3",
            "GALT",
            "CDV3",
            "LEO1",
            "SIRT3",
            "MRPL35",
            "HAUS2",
            "LOC493754",
            "MESDC2",
            "ZNF672",
            "XPNPEP1",
            "GTF2H1",
            "CUL4B",
            "CDC27",
            "RAB35",
            "YWHAB"
        ]
    },
    {
        "golabel": "NME2_regulon_activity",
        "gene": [
            "GAS5",
            "XCR1",
            "C20orf199",
            "LOC285593",
            "F12",
            "RPS21",
            "RPS18",
            "RPS7",
            "RPLP1",
            "RPL27",
            "RPL39",
            "NME2P1",
            "RPS10",
            "PLCE1",
            "NHSL2",
            "RPS5",
            "RPS15A",
            "PCDHGA6",
            "SNHG6",
            "EEF1B2",
            "RPS3",
            "RPL35",
            "RPS6",
            "RPS16",
            "RPS14",
            "ZC3H12B",
            "RPS29",
            "RPSA",
            "NME1-NME2",
            "RPSAP58",
            "MRPS12",
            "RPL17",
            "USP51",
            "LOC150381",
            "RPL31",
            "RPL18A",
            "ZNF704",
            "RPS17",
            "RPL36",
            "TLCD1",
            "CHCHD10",
            "LOC202181",
            "RPLP0",
            "SNRPD2",
            "TIMM16",
            "RPL8",
            "RPS19",
            "TXNDC17",
            "RPS8",
            "RPL24",
            "MIF",
            "RPS11",
            "RPL27A",
            "RPL29",
            "NPM3",
            "FOXN3",
            "RPS9",
            "HSBP1L1",
            "SLC9A1",
            "GAPDH",
            "NME1",
            "RPL12",
            "ACY1",
            "RPS15",
            "RPL41",
            "C2orf79",
            "PPPDE2",
            "PYCR1",
            "RPL32",
            "PSMB3",
            "TOMM22",
            "RPL35A",
            "RPL38",
            "POP7",
            "RPL7A",
            "RPL37",
            "HN1",
            "ZNF593",
            "COX6A1",
            "RPL18",
            "EXOSC4",
            "GEMIN6",
            "NME4",
            "ANAPC11",
            "RPS27A",
            "FAM128A",
            "PPIAL4G",
            "ATP8B2",
            "RPS24",
            "UQCRH",
            "NDUFAF2",
            "MRPS23",
            "AFMID",
            "GADD45GIP1",
            "RPL37A",
            "EXOSC5",
            "PHB2",
            "UQCR11",
            "MRPL24",
            "RPL14",
            "USMG5",
            "SYNGAP1",
            "PPIAL4C",
            "NT5C3L",
            "MRPL12",
            "ZNF511",
            "HSPE1",
            "MRPS24",
            "PFDN2",
            "NOP16",
            "PPP1R14B",
            "C11orf48",
            "RPS20",
            "RPS2",
            "GALK1",
            "FAU",
            "RPL30",
            "FAM128B",
            "RPL23",
            "CP110",
            "C17orf89",
            "C19orf70",
            "C19orf53",
            "NHP2",
            "MID2",
            "SFXN4",
            "RPLP2",
            "C19orf24",
            "FAM100B",
            "C12orf45",
            "TIMM9",
            "SYNGR2",
            "ICT1",
            "FBL",
            "NT5C",
            "CHCHD8",
            "ZNRD1",
            "RPL19",
            "C18orf22",
            "EEF1G",
            "LOC388955",
            "VDAC2",
            "MRPL27",
            "FOXO3",
            "CISD3",
            "RPL23A",
            "MKI67IP",
            "KIAA1009",
            "MRPL45",
            "TIMM13",
            "NLE1",
            "PPIA",
            "PTRH2",
            "SLC25A39",
            "PI4KA",
            "PRELID1",
            "CDK2AP1",
            "METTL2A",
            "SNX29",
            "UBA52",
            "ECSIT",
            "TXNL4A",
            "TBCA",
            "EIF3H",
            "MTM1",
            "NAT9",
            "HERC1",
            "CCDC51",
            "ATP5H",
            "MRPL38",
            "KIAA0247",
            "MRPS7",
            "PRMT1",
            "UBE2E1",
            "THOC7",
            "IMP4",
            "NOB1",
            "RRP9",
            "IFRD2",
            "ACTG1",
            "DAP3",
            "WDR74",
            "ZNHIT3",
            "GRHPR",
            "CLPP",
            "STK40",
            "PHB",
            "TACO1",
            "PNPO",
            "SUMO2",
            "PRDM2",
            "LRRC59",
            "SNF8",
            "ATXN1L",
            "TECPR2",
            "SLC35B1",
            "NME6",
            "THAP4",
            "RFT1",
            "C17orf95",
            "EIF1",
            "MRPL10",
            "USP47",
            "FAM104A",
            "ADD1"
        ]
    },
    {
        "golabel": "NMI_regulon_activity",
        "gene": [
            "CARD17",
            "CXCL11",
            "GPR87",
            "C15orf48",
            "LYPD5",
            "CACNA1D",
            "GPR133",
            "CTSL1",
            "STEAP1",
            "SYT7",
            "OASL",
            "NAT8B",
            "SRGN",
            "CLEC2B",
            "PARM1",
            "GLRX",
            "RHOBTB2",
            "OAS1",
            "GBP1",
            "CENPW",
            "RTP4",
            "C12orf60",
            "PSMB9",
            "IFI27L2",
            "EPSTI1",
            "IFIT3",
            "GSTO1",
            "MLF1IP",
            "TAP1",
            "C7orf41",
            "IFIH1",
            "NEDD4L",
            "RAB32",
            "IL18",
            "NCEH1",
            "ITPKB",
            "IFI35",
            "STAT1",
            "S100A10",
            "CD58",
            "C9orf46",
            "GLA",
            "SOCS7",
            "COMMD8",
            "PSMB8",
            "ANXA2",
            "C6orf115",
            "HPRT1",
            "PSMC1",
            "UBE2L6",
            "PLSCR1",
            "MAGI1",
            "CRTC1",
            "CCDC90B",
            "S100A11",
            "C10orf78",
            "PSME2",
            "C6orf182",
            "CMTM4",
            "ZFHX3",
            "NUP37",
            "KIAA0182",
            "CASP4",
            "SPATS2L",
            "PSMA3",
            "TMEM51",
            "NCK1",
            "RALB",
            "TPRKB",
            "CARHSP1",
            "CREB3L2",
            "PSMD14",
            "CNTROB",
            "CLIC1",
            "LYSMD2",
            "CERK",
            "GYG1",
            "BAK1",
            "PSMA5",
            "SNX3",
            "PSMB1",
            "BCOR",
            "ARPC5",
            "METTL5",
            "KDM6B",
            "IL10RB",
            "MITD1",
            "MRPS22",
            "LIPT1",
            "LACTB",
            "TDRD7",
            "UBE2D1",
            "MMADHC",
            "RAP2C",
            "CASP3",
            "VRK2",
            "LSM6",
            "TTC3",
            "ACTR3",
            "TANK",
            "EED",
            "HAT1",
            "MRPS18C",
            "GTDC1",
            "MED6",
            "PSMB2",
            "SP100",
            "CAPZA1",
            "ACOT9",
            "FRG1",
            "OSTF1",
            "ARPC2",
            "RNF149",
            "WTAP",
            "ATG3",
            "DNPEP",
            "TEX261"
        ]
    },
    {
        "golabel": "NOC4L_regulon_activity",
        "gene": [
            "SCN7A",
            "ANGPT1",
            "TROAP",
            "AURKB",
            "ESPL1",
            "KIF18B",
            "CDCA3",
            "COMTD1",
            "C7orf58",
            "CDT1",
            "UBE2S",
            "FAT4",
            "RECQL4",
            "PKMYT1",
            "IL6ST",
            "NFKBIL2",
            "C16orf59",
            "MIF",
            "TACC3",
            "SGMS2",
            "ARHGAP42",
            "MAML2",
            "C19orf48",
            "SLC25A10",
            "SUV39H1",
            "TLR5",
            "RNF144B",
            "COX6A1",
            "FAM128A",
            "TOMM40",
            "H2AFX",
            "POLE",
            "DOCK4",
            "MXD3",
            "MRPL12",
            "XRCC3",
            "C9orf5",
            "PFDN2",
            "PGAM5",
            "SNRPF",
            "FAM128B",
            "FBRSL1",
            "C9orf142",
            "PIK3R1",
            "THOC4",
            "DDX39",
            "RBM42",
            "PUS1",
            "HAUS7",
            "C5orf41",
            "STK17B",
            "TBC1D8B",
            "TMEM120B",
            "HIPK3",
            "SEL1L3",
            "FAM100B",
            "GAB1",
            "C12orf45",
            "C21orf70",
            "RBM43",
            "TARBP2",
            "C12orf44",
            "ARL15",
            "MTX1",
            "ZDHHC12",
            "FLAD1",
            "SHKBP1",
            "C10orf118",
            "PPAN",
            "DUS1L",
            "TAF6",
            "POLD1",
            "MVK",
            "ZC3H3",
            "RNF141",
            "SLC25A39",
            "ALG3",
            "OGFOD2",
            "MBNL2",
            "CCDC137",
            "CTU2",
            "PTGES2",
            "NEK7",
            "MTM1",
            "BIN1",
            "DIABLO",
            "ARID4A",
            "RTKN",
            "NSUN5",
            "DDX51",
            "GTF3C5",
            "MRPL38",
            "ARL6IP4",
            "SNX13",
            "SLC25A30",
            "TRAK2",
            "ADRM1",
            "REEP4",
            "SF3B4",
            "FEM1C",
            "IMP4",
            "TRIM28",
            "POLK",
            "RBL2",
            "UBE2M",
            "RABGAP1L",
            "DDX56",
            "PREPL",
            "FBXL3",
            "WDR47",
            "ZFX",
            "LYSMD3",
            "DBT",
            "ZNF25",
            "PPP2CB",
            "DDX54",
            "CHFR",
            "KBTBD4",
            "ORAI1",
            "PSMD9",
            "KIAA0494",
            "ZNF791",
            "ZFPL1",
            "SNRNP35",
            "HGS",
            "SMPD4",
            "ANAPC7",
            "GPS1",
            "SFRS8",
            "MCRS1",
            "RSBN1",
            "AAAS",
            "PPM1G",
            "SNRPA",
            "PSMC5",
            "TOR1AIP1",
            "STX12",
            "EIF2B1",
            "TMEM167B",
            "DAZAP1",
            "EPS15",
            "CREB1"
        ]
    },
    {
        "golabel": "NOTCH1_regulon_activity",
        "gene": [
            "HMCN1",
            "COL27A1",
            "GPR20",
            "MRPL21",
            "ARHGEF15",
            "C3orf14",
            "VWF",
            "ZNF366",
            "ATP5J2",
            "TIMM8B",
            "SNRPG",
            "TMEM45B",
            "C6orf57",
            "CHCHD2",
            "TMEM106C",
            "MAST4",
            "NOTCH4",
            "COX7B",
            "NDUFB1",
            "COX7A2",
            "TNFAIP8L1",
            "BAHCC1",
            "HSBP1",
            "SHANK3",
            "RPA3",
            "ITGB3BP",
            "ATP5I",
            "C2orf28",
            "SEP15",
            "TSPAN6",
            "VBP1",
            "SCOC",
            "MED28",
            "HBXIP",
            "POLR2K",
            "C7orf36",
            "RWDD2A",
            "C17orf58",
            "TMEM182",
            "ABCA2",
            "ATP5L",
            "FAM38A",
            "PKD1",
            "CCNC",
            "PHF5A",
            "MRPS33",
            "NDUFA1",
            "NACC2",
            "TMEM135",
            "BTF3L4",
            "AIG1",
            "FUNDC1",
            "NDUFB3",
            "ERH",
            "OLA1",
            "PSMD14",
            "C17orf75",
            "PPCS",
            "ORMDL2",
            "TMEM126A",
            "C7orf44",
            "ARHGEF17",
            "C16orf63",
            "PDZD11",
            "DPM1",
            "DAB2IP",
            "LSM5",
            "TSN",
            "NDST1",
            "PSMA5",
            "ZMIZ1",
            "NDUFAB1",
            "LOC728758",
            "GTF2H5",
            "LOC550643",
            "FAM53B",
            "ARPC3",
            "RARS2",
            "SSBP1",
            "KIF1C",
            "GTF2B",
            "CAMSAP1",
            "PSMD10",
            "WDR81",
            "HERC1",
            "BAT2L1",
            "ARL6IP1",
            "ZCCHC17",
            "ATP5H",
            "CIC",
            "ATG5",
            "ANKS1A",
            "BICD2",
            "NCOR2",
            "CUL9",
            "CISD2",
            "ZZEF1",
            "TXNDC12",
            "NDUFA12",
            "SDHB",
            "C1GALT1C1",
            "MORF4L2",
            "C1orf174",
            "MINK1",
            "SUMO1P3",
            "KIAA0355",
            "ARL1",
            "ZNHIT3",
            "SKI",
            "PARK7",
            "LOC550112",
            "RAPGEF1",
            "SFT2D1",
            "ZNF407",
            "TLN1",
            "CWC15",
            "ENOPH1",
            "ABL1",
            "VPS53",
            "OCIAD1",
            "AP2A2",
            "MDH1",
            "DNAJC8",
            "COQ10B",
            "SUMO1",
            "SETX",
            "PHF2",
            "SMG6",
            "ATP6V1D",
            "NUP214",
            "PPP1R8"
        ]
    },
    {
        "golabel": "NOTCH2_regulon_activity",
        "gene": [
            "FXYD3",
            "KDR",
            "ID1",
            "PTPLA",
            "C17orf61",
            "ABCB6",
            "FLJ35776",
            "PRKCA",
            "SLC9A7",
            "TSPAN5",
            "OSMR",
            "ISG20",
            "SLC27A5",
            "RPS16",
            "FAM129A",
            "C12orf57",
            "STARD10",
            "PFKFB3",
            "IL1RAP",
            "PLXNC1",
            "MAGI3",
            "RPSAP9",
            "TIMM16",
            "NBPF14",
            "DPYD",
            "UQCRQ",
            "FBXO16",
            "NBPF10",
            "C7orf55",
            "CREB3L4",
            "MAML2",
            "B9D1",
            "REL",
            "HIP1",
            "C20orf7",
            "GSTP1",
            "TRIO",
            "PEMT",
            "RAI14",
            "CD320",
            "PHPT1",
            "FAM160A1",
            "ENDOG",
            "FLNA",
            "ELL3",
            "RANGRF",
            "SDF2L1",
            "HDDC3",
            "PPIB",
            "BMP2K",
            "SNX18",
            "SLFN5",
            "INO80C",
            "C6orf108",
            "MRPS26",
            "SERF2",
            "NRP1",
            "ANKRD36BP1",
            "ZNF430",
            "C15orf63",
            "FAM168A",
            "COX4I1",
            "MRPS21",
            "PLEKHG1",
            "TMEM208",
            "FAM165B",
            "NDUFA7",
            "ERP29",
            "ANKRD50",
            "C11orf51",
            "ASF1A",
            "ATP5J",
            "COX5A",
            "EXOSC8",
            "UBL7",
            "PSMG4",
            "AFAP1",
            "EEF1E1",
            "NDUFV2",
            "STRN",
            "MYO5A",
            "QDPR",
            "C6orf136",
            "RPP21",
            "TMEM107",
            "C15orf61",
            "MAN1A2",
            "MANF",
            "LOC388789",
            "IKZF2",
            "MID2",
            "SVIL",
            "MACF1",
            "POLR1D",
            "PSMB6",
            "TMEM93",
            "NT5C",
            "PPCDC",
            "DECR1",
            "MTG1",
            "EML4",
            "ATF4",
            "NDUFAF4",
            "POP5",
            "MPDU1",
            "SERTAD2",
            "AEN",
            "MED11",
            "MRPS18A",
            "TFB1M",
            "ITPA",
            "NDUFB8",
            "CHCHD1",
            "C12orf47",
            "C12orf10",
            "SRGAP2",
            "CLSTN1",
            "LRCH3",
            "HIVEP2",
            "TXNL4A",
            "KLF11",
            "DERL2",
            "COQ9",
            "COMMD4",
            "RUNX1",
            "TBCEL",
            "ZNFX1",
            "INTS10",
            "MRPL46",
            "SPAG7",
            "HIPK1",
            "DCTN6",
            "RNMTL1",
            "NSMCE4A",
            "DUT",
            "SYNRG",
            "SMYD2",
            "AFF1",
            "COQ6",
            "DCLRE1B",
            "IMP3",
            "SLC25A11",
            "ATXN1",
            "DDX28",
            "CTTNBP2NL",
            "AAK1",
            "ATP5SL",
            "JAK1",
            "PSMG2",
            "CSDE1",
            "KCTD2",
            "VEZF1",
            "RNF167",
            "ZYG11B"
        ]
    },
    {
        "golabel": "NOTCH3_regulon_activity",
        "gene": [
            "CYP24A1",
            "CTSH",
            "COL5A1",
            "HLA-DRB6",
            "C19orf21",
            "PLEKHG2",
            "EPHX3",
            "ADAMTS7",
            "HLA-DMB",
            "ST3GAL6",
            "HLA-DRA",
            "COL4A2",
            "C1QTNF6",
            "KCTD15",
            "COL4A1",
            "LZTS1",
            "CDR2L",
            "HCP5",
            "ABCC1",
            "HLA-DMA",
            "CYTSB",
            "BRP44L",
            "PSMB8",
            "HSBP1",
            "N4BP2L1",
            "LYRM1",
            "AGRN",
            "FOSL2",
            "LAMC1",
            "NUMBL",
            "GALNT2",
            "SENP8",
            "C9orf72",
            "ENTPD7",
            "TCEAL1",
            "DBN1",
            "BCL9L",
            "ZNF563",
            "SEMA4C",
            "CRBN",
            "GAS2L1",
            "HADH",
            "PLEKHF2",
            "SERGEF",
            "DMWD",
            "MED18",
            "ZCCHC10",
            "ZNF532",
            "TCEANC",
            "CYP2R1",
            "RCHY1",
            "TUBE1",
            "NCOR2",
            "KDM5B",
            "ANKRD49",
            "DOCK6",
            "RREB1",
            "CDC42BPB",
            "SAMD4B",
            "C15orf39",
            "LYRM7",
            "MARK4",
            "POC5",
            "FLJ33630",
            "EIF4G1",
            "MEF2D",
            "C17orf63",
            "TMEM188",
            "FXC1",
            "FAM76A",
            "BRD4",
            "UPRT",
            "HDLBP",
            "AP2A1",
            "PNRC2",
            "ATG9A",
            "SMARCAL1"
        ]
    },
    {
        "golabel": "NOTCH4_regulon_activity",
        "gene": [
            "SLC5A9",
            "LOXHD1",
            "VIP",
            "APLN",
            "C20orf160",
            "C19orf69",
            "USHBP1",
            "SEMA3G",
            "LAMC3",
            "TAL1",
            "FOXF1",
            "RASIP1",
            "HSPA12B",
            "GRAPL",
            "SAMD14",
            "ARHGEF15",
            "PEAR1",
            "ROBO4",
            "VWF",
            "GRK5",
            "TBX2",
            "TIE1",
            "ITGA7",
            "COL4A2",
            "CDH5",
            "ADCY4",
            "MTMR9L",
            "LZTS1",
            "GATA2",
            "SOX18",
            "NOVA2",
            "CD34",
            "CLEC14A",
            "N4BP3",
            "CXorf36",
            "LOC158376",
            "SYNM",
            "SH2D3C",
            "KIAA1274",
            "EXOC3L2",
            "EXOC3L",
            "KLHL3",
            "DLL4",
            "BCL6B",
            "PCDH12",
            "MMRN2",
            "MAL2",
            "KCNC4",
            "SHANK3",
            "VASH1",
            "FLT1",
            "ARHGEF10",
            "PLVAP",
            "MAP3K12",
            "C5orf28",
            "TTC28",
            "SYNGAP1",
            "PKD1",
            "ARAP3",
            "SMTN",
            "NOTCH1",
            "GPN1",
            "BTF3L4",
            "OLA1",
            "CASKIN2",
            "PTGES3",
            "METTL2A",
            "PPM1F",
            "CORO7",
            "PRMT3",
            "POLE3",
            "MRPS22",
            "DOCK6",
            "SLBP",
            "SIN3B",
            "SIDT2",
            "NUP54",
            "TIPRL",
            "POLR2D",
            "SNRNP40",
            "ZCRB1",
            "CNBP",
            "FAF1",
            "HNRNPC",
            "AIMP1"
        ]
    },
    {
        "golabel": "NPAT_regulon_activity",
        "gene": [
            "ADAM22",
            "EGFL7",
            "TALDO1",
            "ZNF467",
            "ASPSCR1",
            "CCDC15",
            "RNF168",
            "ARHGAP42",
            "MAML2",
            "MRPL41",
            "HSBP1L1",
            "PHPT1",
            "PPPDE2",
            "EXPH5",
            "GALE",
            "SLC4A7",
            "PSIP1",
            "NCAPD3",
            "SIK2",
            "SIL1",
            "USP28",
            "KDELC2",
            "DIXDC1",
            "NEU3",
            "SP4",
            "MRPL55",
            "GAB1",
            "SHARPIN",
            "PSMB6",
            "REV3L",
            "TMEM93",
            "C9orf102",
            "ETFB",
            "ROBLD3",
            "TMEM123",
            "MSRB2",
            "C12orf44",
            "CBL",
            "RBCK1",
            "CAPNS1",
            "ALKBH8",
            "KIAA1826",
            "ZZZ3",
            "SYNJ1",
            "PANX1",
            "RSF1",
            "CASP8AP2",
            "EDF1",
            "ATM",
            "COMMD4",
            "MRPL38",
            "TBCEL",
            "ECHS1",
            "SPAG7",
            "ABCB8",
            "TMEM11",
            "MLL",
            "ATPAF2",
            "UQCRC1",
            "BIRC2",
            "WDR47",
            "NUP160",
            "MRE11A",
            "LSM11",
            "FCHSD2",
            "UVRAG",
            "PSEN2",
            "CCDC82",
            "ZW10",
            "CWF19L2",
            "SNX19",
            "MFSD5",
            "ARF1",
            "ARL8A",
            "ZNF800",
            "UBE4A",
            "CUL5",
            "DDX6"
        ]
    },
    {
        "golabel": "NR2C2_regulon_activity",
        "gene": [
            "TAS2R3",
            "C9orf144B",
            "LOC148696",
            "C3orf48",
            "C11orf42",
            "IMPG1",
            "C15orf28",
            "SNORD116-28",
            "PAR5",
            "NCRNA00152",
            "LOC541471",
            "GNRHR",
            "ZC3H12B",
            "RUNDC2C",
            "LOC100190986",
            "ZNF397",
            "FLJ10213",
            "KIF27",
            "POLE4",
            "PSMB3",
            "LOC729799",
            "NIPSNAP3B",
            "NBPF9",
            "RAD54L2",
            "UNC119B",
            "KIAA1147",
            "ZNF141",
            "KIAA1109",
            "ASH1L",
            "LOC550643",
            "DRG1",
            "PTAR1",
            "AP2S1",
            "NISCH",
            "ZNF417",
            "MTX3",
            "ZBTB40",
            "ZNF33A",
            "DDX49",
            "ATXN7",
            "EIF2C4",
            "BTAF1",
            "NSDHL",
            "ZNF445",
            "RUVBL2",
            "PHC3",
            "EIF6",
            "KIAA2026",
            "ZBTB34",
            "POLH",
            "CHD2",
            "EIF3I",
            "TACO1",
            "SMC5",
            "WDR37",
            "PDE6D",
            "ZNF621",
            "EPM2AIP1",
            "VHL",
            "PIKFYVE",
            "PSMC3",
            "CALR",
            "C16orf80",
            "RC3H1",
            "VTI1B",
            "C20orf43",
            "USP19"
        ]
    },
    {
        "golabel": "NR2F6_regulon_activity",
        "gene": [
            "IER5L",
            "CYSLTR2",
            "CAMK4",
            "CD200R1",
            "GPR34",
            "RGS18",
            "IL7R",
            "C19orf21",
            "TNFSF8",
            "P2RX7",
            "C10orf128",
            "CD84",
            "TMEM184A",
            "COMTD1",
            "CBLC",
            "HES4",
            "CYBB",
            "C7orf58",
            "CD226",
            "ANKRD9",
            "MAN1A1",
            "PIK3CG",
            "PTGER4",
            "MARCH1",
            "SLC9A9",
            "PTPRC",
            "STARD10",
            "FAM83E",
            "TLR4",
            "EPN3",
            "FAM49A",
            "PLXNC1",
            "C20orf151",
            "ANKRD44",
            "ITGA4",
            "RNF208",
            "KBTBD8",
            "ZNF699",
            "ADAT3",
            "TJP3",
            "ARHGAP31",
            "AP1S2",
            "ANO8",
            "ZNHIT2",
            "TLR1",
            "SAMHD1",
            "PVRL4",
            "SH2D3A",
            "SLC25A10",
            "DBNDD1",
            "PACSIN3",
            "FN3K",
            "ZEB2",
            "PPAP2C",
            "RAPGEF6",
            "ARHGEF6",
            "JUP",
            "JUND",
            "PPP1R16A",
            "ZNF579",
            "SCAND1",
            "FAM83H",
            "C17orf28",
            "GNG2",
            "WDR34",
            "LRRC8C",
            "CTU1",
            "ATP10D",
            "PKP3",
            "KPNA5",
            "RAB8B",
            "FAM128B",
            "GPRASP2",
            "KAT2B",
            "LNPEP",
            "RAB3D",
            "KIAA1543",
            "C5orf41",
            "LLGL2",
            "OCEL1",
            "PGLS",
            "LSM4",
            "TMUB1",
            "PWWP2B",
            "WDR18",
            "DNAJC18",
            "LPAR2",
            "HSPBP1",
            "ATG4D",
            "GIPC1",
            "GTPBP3",
            "CDC34",
            "ZNF628",
            "DUS1L",
            "USP12",
            "DOHH",
            "NDOR1",
            "NEK1",
            "SGTB",
            "ZNF414",
            "COPE",
            "ZNF205",
            "CHM",
            "SSH3",
            "CCDC124",
            "CBX4",
            "TMEM161A",
            "MPV17L2",
            "RNF126",
            "DDX49",
            "SLC25A46",
            "C19orf22",
            "TRIM11",
            "FBXO48",
            "POLK",
            "AKT1S1",
            "LYRM7",
            "C19orf39",
            "DDA1",
            "KIAA1430",
            "SAMD1",
            "PTOV1",
            "HM13",
            "DNAJB14",
            "DMXL1",
            "GMPPA",
            "PJA2",
            "HDGFRP2",
            "NCLN",
            "C19orf43",
            "SLC39A3",
            "MAP2K2",
            "PPIP5K2",
            "SNX2",
            "TMEM214",
            "TTC15",
            "DAZAP1"
        ]
    },
    {
        "golabel": "NR3C2_regulon_activity",
        "gene": [
            "MACROD2",
            "KIAA0408",
            "MLLT11",
            "SHH",
            "PRSS12",
            "HOXC8",
            "FCGBP",
            "ANKFN1",
            "BMP3",
            "SCTR",
            "VEPH1",
            "AQP4",
            "HLF",
            "ATP13A4",
            "PDE4C",
            "GZMB",
            "SLC16A7",
            "C1QTNF7",
            "FAM64A",
            "C4orf31",
            "CX3CR1",
            "CCNB2",
            "PCDP1",
            "GPLD1",
            "ZBTB7C",
            "UBE2C",
            "GPR116",
            "CDKN3",
            "FAM189A2",
            "SLC4A4",
            "AURKA",
            "MYBL2",
            "TROAP",
            "FAM72D",
            "CENPA",
            "PITPNC1",
            "C1orf116",
            "SPHK1",
            "C12orf48",
            "TMPRSS2",
            "AURKB",
            "FAM24B",
            "NUF2",
            "ESPL1",
            "FLRT3",
            "TPX2",
            "ETV1",
            "MECOM",
            "CDKL1",
            "REPS2",
            "RBMS3",
            "CENPW",
            "FAM72B",
            "CDC25C",
            "BIRC5",
            "CDC20",
            "DSCC1",
            "HJURP",
            "PRR15L",
            "CDCA3",
            "NCAPG",
            "SKA3",
            "MGC72080",
            "FAM54A",
            "DEPDC6",
            "UBE2S",
            "CDCA5",
            "CASC2",
            "ORC6L",
            "ANK3",
            "PLK1",
            "CCNB1",
            "HNF1B",
            "C1QTNF6",
            "GCH1",
            "ADA",
            "MTHFD2",
            "CDC42BPA",
            "TRIM2",
            "DTX4",
            "THRB",
            "MAGI3",
            "RACGAP1",
            "SGPP2",
            "MAP3K13",
            "IL6R",
            "TMEM133",
            "TMEM98",
            "SHMT2",
            "TCEA3",
            "SGMS2",
            "SHROOM3",
            "FRY",
            "RAB11FIP1",
            "SPRY2",
            "APBA1",
            "SPATA6",
            "GLA",
            "AMIGO1",
            "EPS8",
            "EXPH5",
            "DPYSL2",
            "EPB41L4A",
            "SNX18",
            "RAN",
            "RALGPS1",
            "PARD6B",
            "DDAH1",
            "CAMK2D",
            "CRY2",
            "MAP9",
            "ZNF658",
            "USP54",
            "SNRPF",
            "PLEKHA7",
            "KIAA1671",
            "NUDT16",
            "PUS1",
            "AIMP2",
            "TMEM63B",
            "SH3RF1",
            "CTDSPL",
            "APLP2",
            "ILDR1",
            "NIPAL3",
            "CTSO",
            "KIF16B",
            "RBM43",
            "C12orf44",
            "SLC25A23",
            "ABCD3",
            "CDS1",
            "FYCO1",
            "USP53",
            "SORT1",
            "RNASEL",
            "MTMR12",
            "EXOSC3",
            "TRAK2",
            "RABGAP1L",
            "CBR4",
            "KIAA0494",
            "SFRS9",
            "MMAA",
            "TBCK",
            "SLC10A7",
            "CARS"
        ]
    },
    {
        "golabel": "NRBF2_regulon_activity",
        "gene": [
            "C5orf46",
            "ESYT3",
            "TNFAIP6",
            "DNAJB4",
            "CTSK",
            "FCGR2B",
            "TNFSF4",
            "SRCIN1",
            "GOLGA2B",
            "LRP5L",
            "LOC100170939",
            "GSTO1",
            "GPX8",
            "CROCCL2",
            "REEP3",
            "EVPL",
            "GOLT1B",
            "RGL3",
            "ENGASE",
            "NOD1",
            "P4HA1",
            "SGSM2",
            "C20orf24",
            "GIGYF1",
            "CREM",
            "MGRN1",
            "USMG5",
            "OSTC",
            "SARM1",
            "CYB5R4",
            "ITGB1",
            "ZNF337",
            "RAB23",
            "MPRIP",
            "NEK8",
            "LRRC37A",
            "TFAM",
            "NCK1",
            "SSR3",
            "SLC44A1",
            "PCGF5",
            "TUBG2",
            "CNTROB",
            "CLCN6",
            "C10orf84",
            "UBE2Q2",
            "VDAC2",
            "UAP1",
            "C17orf65",
            "RECQL5",
            "ATP6V1G1",
            "PPA1",
            "CABIN1",
            "ISCA1P1",
            "CISD1",
            "PGAM1",
            "TBCD",
            "ATG5",
            "BLOC1S2",
            "DUSP11",
            "UBE2D1",
            "C17orf70",
            "KIAA0195",
            "DYNLL1",
            "TSC2",
            "WDR6",
            "NCOA4",
            "UBE2J1",
            "RBM33",
            "GLUD1",
            "ISCA1",
            "ZMYM3",
            "CAPZA1",
            "ZNF500",
            "MORF4L1",
            "VPS26A",
            "HNRNPH1",
            "NUS1",
            "AGPAT3",
            "FAM35A",
            "SHOC2",
            "ZDHHC6",
            "HERC4",
            "WTAP",
            "SLC35B3",
            "PPP3CB",
            "FAM35B",
            "ANXA7",
            "ADO",
            "CSNK1D",
            "SAR1A"
        ]
    },
    {
        "golabel": "NRIP1_regulon_activity",
        "gene": [
            "EREG",
            "CATSPER1",
            "ALDH1A3",
            "KLF15",
            "CD109",
            "PRICKLE4",
            "RAP1GAP",
            "FBXO32",
            "EVPLL",
            "ELOVL6",
            "FRMD5",
            "PRR11",
            "CTHRC1",
            "FAM3C",
            "EFCAB4A",
            "CKAP2L",
            "FAM126A",
            "TSC22D2",
            "G2E3",
            "TOB1",
            "CCDC64B",
            "PAQR3",
            "MMD",
            "ALDH2",
            "FKBP2",
            "HDX",
            "ZNF219",
            "KLHL5",
            "GSTP1",
            "FRAT1",
            "ITGAV",
            "HIF1A",
            "AIFM2",
            "ELK3",
            "HOMER1",
            "PDP1",
            "ALDH1B1",
            "RBL1",
            "HSPA13",
            "SKAP2",
            "TMEM55A",
            "RIPK2",
            "JMJD7-PLA2G4B",
            "RAB17",
            "CCDC57",
            "NRP1",
            "TXNRD2",
            "CASZ1",
            "CDK10",
            "PNKD",
            "ACADVL",
            "CALU",
            "SPATS2L",
            "STRN",
            "C6orf136",
            "WASH2P",
            "AVL9",
            "KLC4",
            "FAM49B",
            "KIF2A",
            "MAN2C1",
            "DDRGK1",
            "LYN",
            "PNPLA2",
            "ANKIB1",
            "SLC48A1",
            "AZIN1",
            "SAMD8",
            "NRAS",
            "FBXW4",
            "TWISTNB",
            "NBN",
            "TMEM143",
            "MTDH",
            "YWHAZ",
            "SPG7",
            "DR1",
            "USP25",
            "PPP2R5E",
            "ZNF267",
            "LUZP6",
            "DCLRE1B",
            "OSBPL8",
            "ACTR3",
            "MIER1",
            "SLC25A32",
            "STYX",
            "GNA13",
            "NAPA",
            "AGPS",
            "TBC1D17",
            "PHF1",
            "ITCH",
            "SEPT7",
            "GNAI3",
            "HNRPLL"
        ]
    },
    {
        "golabel": "NRL_regulon_activity",
        "gene": [
            "LOC100129066",
            "CD109",
            "AHNAK2",
            "GADD45G",
            "CXCL17",
            "ITGA2",
            "POLR2F",
            "PRKCA",
            "LASS4",
            "ETV2",
            "CCNB1IP1",
            "OSMR",
            "DPM3",
            "LAMB3",
            "CDCP1",
            "LOC100270746",
            "IRS1",
            "PPFIBP1",
            "DCXR",
            "LIN7B",
            "ROMO1",
            "MTCP1NB",
            "PLEC",
            "PDLIM5",
            "NDUFB1",
            "LSMD1",
            "MRPL54",
            "C7orf55",
            "SSR4",
            "MBLAC1",
            "NDUFA2",
            "ABHD14A",
            "MRPL52",
            "MGC3771",
            "MAN2A1",
            "NDUFA11",
            "C6orf125",
            "C20orf196",
            "PHPT1",
            "TRAPPC6A",
            "ITGAV",
            "BRP44L",
            "MDP1",
            "SPATA24",
            "C12orf62",
            "EAPP",
            "FAM158A",
            "NDUFA13",
            "SIRT4",
            "SDHAF1",
            "NUDT14",
            "MYOF",
            "NDUFB7",
            "SIVA1",
            "FKBP3",
            "MRPS26",
            "TRAPPC5",
            "SCAND1",
            "IMMP1L",
            "PTPN14",
            "MTHFD2L",
            "CNNM4",
            "ALKBH7",
            "ATP5S",
            "DLG5",
            "C1orf203",
            "LY6G5C",
            "FAM165B",
            "NDUFA7",
            "C14orf167",
            "ACOT1",
            "BCL9L",
            "NDUFB11",
            "C14orf119",
            "FAM104B",
            "SIGIRR",
            "MRP63",
            "PCK2",
            "STRN",
            "RALGPS2",
            "SAT2",
            "RPS19BP1",
            "RPP21",
            "RABAC1",
            "C22orf32",
            "RASAL2",
            "C3orf71",
            "SDR39U1",
            "MOAP1",
            "KLHDC2",
            "FUZ",
            "BCAT2",
            "RIF1",
            "NGDN",
            "C14orf179",
            "NEDD8",
            "VCL",
            "C9orf23",
            "C10orf12",
            "C14orf79",
            "SMURF1",
            "THAP3",
            "SLK",
            "MMAB",
            "HADH",
            "ZNF133",
            "DHRS4L2",
            "MED11",
            "PSME1",
            "WDR25",
            "OSGEP",
            "LUZP1",
            "FNDC3B",
            "SERGEF",
            "FDX1L",
            "FAM73A",
            "DHRS4",
            "TMEM205",
            "THTPA",
            "HINT2",
            "C14orf109",
            "ZNF821",
            "COPE",
            "RFXANK",
            "DOCK7",
            "HAGH",
            "USE1",
            "HIVEP2",
            "CCDC101",
            "TMOD3",
            "CCDC6",
            "METT11D1",
            "MYST1",
            "SSH1",
            "PIGH",
            "ARL6IP4",
            "LOC729991",
            "TNPO3",
            "BBX",
            "NDUFS3",
            "FRYL",
            "C19orf39",
            "BOD1L",
            "CHMP4A",
            "ATPAF2",
            "COQ6",
            "GMPR2",
            "SLC25A11",
            "ANKRD28",
            "GCDH",
            "PIN1",
            "EIF3A",
            "RABGGTA",
            "TMEM55B",
            "NAPA",
            "R3HCC1",
            "C14orf93",
            "C21orf33",
            "TRIP12",
            "UCK1",
            "STK19",
            "C19orf56",
            "OXA1L",
            "MAP4",
            "SLMAP",
            "SLC30A7",
            "RNF31",
            "OTUD4",
            "TM9SF1",
            "NUFIP2",
            "PICALM",
            "DTNBP1",
            "TINF2",
            "DCAF11",
            "OXSR1",
            "C10orf46",
            "ACTR2"
        ]
    },
    {
        "golabel": "OVOL2_regulon_activity",
        "gene": [
            "AKR1C2",
            "AKR1C1",
            "BCAS1",
            "CABYR",
            "ITGB3",
            "S100P",
            "TGFBI",
            "MYO1G",
            "DEGS2",
            "TNC",
            "NDUFA10",
            "MRC1",
            "RASSF8",
            "ID1",
            "PIR",
            "CLEC5A",
            "ALG1L",
            "GPR68",
            "SERINC4",
            "PTPN22",
            "CHST3",
            "EFCAB4A",
            "ALOX5AP",
            "ATP1B1",
            "BFSP1",
            "AIM1",
            "IL17RE",
            "CD80",
            "FAM174B",
            "MNDA",
            "SPIRE2",
            "TALDO1",
            "KIRREL",
            "STARD10",
            "IFI16",
            "SAMD4A",
            "IL1RAP",
            "FCGR2A",
            "SERPINB9",
            "HDX",
            "MDFIC",
            "C20orf7",
            "C8orf55",
            "GSTP1",
            "SMURF2",
            "PEMT",
            "LCP2",
            "ANTXR2",
            "MYH14",
            "ProSAPiP1",
            "SARS2",
            "FLNA",
            "CMTM1",
            "CCDC88A",
            "LIX1L",
            "TMEM55A",
            "SPINT2",
            "LHFPL2",
            "C6orf132",
            "RAB40B",
            "FRAT2",
            "SPRED1",
            "MRPS26",
            "NRP1",
            "KIAA1949",
            "C17orf28",
            "C2orf15",
            "GBE1",
            "ARHGEF16",
            "IKBIP",
            "KIAA0922",
            "ELF3",
            "ERP29",
            "NGRN",
            "DSTN",
            "UBL7",
            "ZBTB42",
            "C6orf136",
            "LLGL2",
            "PCYT2",
            "PIGT",
            "KLC4",
            "DDRGK1",
            "DTNB",
            "ABHD12",
            "SH2B3",
            "DCUN1D3",
            "RASA1",
            "ZNRF1",
            "FAM110A",
            "ZNF133",
            "MSN",
            "CORO1C",
            "ST3GAL2",
            "ITPA",
            "C19orf63",
            "ENTPD6",
            "CLN6",
            "C20orf30",
            "FASTKD5",
            "PIGU",
            "CAST",
            "CXorf38",
            "PGAP2",
            "CSRP2BP",
            "ANP32A",
            "NSFL1C",
            "ESYT1",
            "PCIF1"
        ]
    },
    {
        "golabel": "PA2G4_regulon_activity",
        "gene": [
            "NEIL3",
            "PGR",
            "SCN7A",
            "C1QTNF7",
            "ITGA8",
            "CCNB2",
            "PBK",
            "UBE2C",
            "CDKN3",
            "MFAP4",
            "EXO1",
            "OIP5",
            "CKS2",
            "AURKA",
            "TROAP",
            "CENPA",
            "SKA1",
            "C12orf48",
            "AURKB",
            "FOXM1",
            "ORC1L",
            "TPX2",
            "KIF23",
            "SPC25",
            "CDCA2",
            "CDC25C",
            "CDC25A",
            "BIRC5",
            "CDC20",
            "CDCA3",
            "CDK1",
            "SGOL1",
            "NCAPG",
            "BUB1B",
            "SKA3",
            "NEK2",
            "KIAA0101",
            "RRS1",
            "CDT1",
            "RRM2",
            "MEGF6",
            "PLK1",
            "UBE2T",
            "CEP55",
            "TXN",
            "PTTG1",
            "SNRPG",
            "CCNB1",
            "KRT18",
            "KIF20A",
            "RAD51",
            "PODN",
            "KIF11",
            "PRC1",
            "GARNL3",
            "ZWINT",
            "BYSL",
            "RACGAP1",
            "OR2A1",
            "RPLP0",
            "NUSAP1",
            "SNED1",
            "TSFM",
            "C15orf23",
            "SHMT2",
            "CYC1",
            "C1orf183",
            "EMG1",
            "CENPH",
            "NACA2",
            "LOC728643",
            "GAPDH",
            "C19orf48",
            "NME1",
            "CBX7",
            "PA2G4P4",
            "XPOT",
            "RAN",
            "CCDC58",
            "ATP8B2",
            "MYL6B",
            "H2AFZ",
            "LLPH",
            "PDSS1",
            "USMG5",
            "MRPL12",
            "CRY2",
            "HSPD1",
            "NOP16",
            "PAICS",
            "C10orf2",
            "YARS2",
            "PGAM5",
            "TUBA1C",
            "SNRPF",
            "MARS",
            "CCDC59",
            "SNRPD1",
            "NUP37",
            "ALDOA",
            "SNRPA1",
            "PFDN6",
            "NOP2",
            "NPM1",
            "CNPY2",
            "DCTN2",
            "MRPL42",
            "CDK2",
            "PPIF",
            "ATP5B",
            "EIF5A",
            "TPI1",
            "LYAR",
            "ATP5G2",
            "C12orf45",
            "UNG",
            "SARNP",
            "FBL",
            "ORMDL2",
            "VDAC2",
            "RUVBL1",
            "EIF5AL1",
            "MRPL51",
            "MKI67IP",
            "PTGES3",
            "C12orf10",
            "DNAJC9",
            "RPL6",
            "PSMB7",
            "VDAC1",
            "OBFC2B",
            "TMEM69",
            "BBS9",
            "SMN2",
            "DKC1",
            "MLF2",
            "WIBG",
            "GTF3C6",
            "NACAP1",
            "BCCIP",
            "NOLC1",
            "SNRPD3",
            "NACA",
            "DDX54",
            "GOT2",
            "MRPS16",
            "GAR1",
            "COPZ1",
            "EIF3D",
            "PRDM2",
            "SUPV3L1",
            "NOL7",
            "BUB3",
            "SET",
            "ANAPC7",
            "NOP58",
            "CS",
            "NOP14",
            "PCBP2",
            "CCT7",
            "PPM1G",
            "SNRPA",
            "ANP32B",
            "PWP1",
            "KARS",
            "ANP32A",
            "MRPS5",
            "RPP30",
            "YARS",
            "HNRNPC",
            "HNRNPA1",
            "HNRNPA1L2",
            "DNAJC14",
            "AIMP1",
            "DNAJC7",
            "HNRNPK"
        ]
    },
    {
        "golabel": "PABPN1_regulon_activity",
        "gene": [
            "RNF183",
            "TUBB8",
            "FLRT1",
            "MSR1",
            "GPR34",
            "ZNF702P",
            "SLC40A1",
            "C14orf181",
            "CASS4",
            "PNN",
            "DCN",
            "ACYP1",
            "AHR",
            "TLR3",
            "MARCH1",
            "IL6ST",
            "TLR4",
            "LIPA",
            "MGC12982",
            "CXADR",
            "NFATC4",
            "SGMS2",
            "MORF4",
            "IPMK",
            "PTPLB",
            "AP1G2",
            "ELK3",
            "UHMK1",
            "MPZL3",
            "ZDHHC20",
            "DENND1B",
            "NASP",
            "RAB27A",
            "AFG3L1",
            "TMEM144",
            "HFE",
            "STOM",
            "FBRSL1",
            "LIMS1",
            "C9orf129",
            "CCDC75",
            "LEPROT",
            "ARHGAP18",
            "PRKAR2A",
            "RALB",
            "FAM114A1",
            "FBXO46",
            "SDR39U1",
            "HIPK3",
            "ZGPAT",
            "NGDN",
            "TMED5",
            "PARP2",
            "SLC17A5",
            "MTA1",
            "LUC7L3",
            "GLUD2",
            "ADCK1",
            "PAFAH1B2",
            "DHRS4",
            "SEPT10",
            "RNF141",
            "PATZ1",
            "PRR3",
            "C14orf138",
            "HOMEZ",
            "CHM",
            "ADAT1",
            "MTMR6",
            "CLK2",
            "RRAGC",
            "METT11D1",
            "NEK7",
            "SEC24D",
            "DDX51",
            "SNRNP70",
            "SPPL2A",
            "TM9SF2",
            "TDRD7",
            "AKAP8L",
            "UEVLD",
            "USP25",
            "MMGT1",
            "NPTN",
            "CDK5RAP1",
            "CHMP4A",
            "C6orf211",
            "VPS41",
            "RSPRY1",
            "FBXL3",
            "DNAJB14",
            "ACIN1",
            "BAT1",
            "PEX12",
            "MCFD2",
            "NCOA4",
            "CASC4",
            "SNRNP35",
            "SRRT",
            "C14orf93",
            "U2AF1",
            "SPOPL",
            "KHNYN",
            "CYFIP1",
            "OXA1L",
            "AAAS",
            "SNRPA",
            "TMEM87B",
            "RNF31",
            "PLEKHB2",
            "LOC643387",
            "RAB2B",
            "RHBDD1",
            "CRK",
            "RAB5C",
            "TOR1AIP1",
            "C10orf26",
            "HIAT1",
            "DSCR3",
            "MAPK14",
            "TMEM184C",
            "DAZAP1"
        ]
    },
    {
        "golabel": "PAPOLA_regulon_activity",
        "gene": [
            "SLC38A8",
            "C10orf71",
            "BANF2",
            "C6orf176",
            "LOC441177",
            "BMP6",
            "C1orf95",
            "MSI1",
            "CHRNA5",
            "SLC16A14",
            "ERO1LB",
            "FAM84A",
            "GPR110",
            "HMGB3",
            "CX3CL1",
            "PDE3B",
            "KCNN4",
            "C21orf67",
            "VASN",
            "TC2N",
            "CDC42EP1",
            "SYTL2",
            "RIN1",
            "FXYD5",
            "ZNF643",
            "TNFRSF12A",
            "FZD3",
            "LOC146880",
            "LGALS9",
            "CKLF",
            "MICALL2",
            "CD74",
            "PHLDA3",
            "VPS37A",
            "PLEKHM1P",
            "LGALS3",
            "GPX1",
            "LYL1",
            "GPHN",
            "TSPAN4",
            "HEATR5A",
            "AGAP1",
            "GNA15",
            "STOML1",
            "NAA30",
            "FAM86D",
            "C13orf23",
            "TSPO",
            "TDG",
            "L2HGDH",
            "TK2",
            "PML",
            "MED13L",
            "DARS2",
            "ZBTB42",
            "MAPKAPK3",
            "C14orf101",
            "BEND3",
            "PLK3",
            "CCNJ",
            "HSP90B1",
            "GSTK1",
            "AMDHD2",
            "EHD1",
            "HSP90AA1",
            "SMC3",
            "GIPC1",
            "SFXN3",
            "DAGLB",
            "TAF4",
            "ANGEL1",
            "SUPT16H",
            "ZNF146",
            "TNFSF12",
            "LBR",
            "HMOX2",
            "NAT6",
            "TRIP10",
            "KTN1",
            "ACD",
            "TAF2",
            "IL17RC",
            "RCOR1",
            "RPN2",
            "PTTG1IP",
            "ZNF664",
            "SIRT1",
            "STRBP",
            "NAA25",
            "SUZ12",
            "RGS3",
            "ATG2B",
            "SLC10A3",
            "FASTKD5",
            "UGGT1",
            "SUDS3",
            "B3GALNT2",
            "MARCH2",
            "ZNF22",
            "BTBD7",
            "DICER1",
            "PHF20L1",
            "PKN2",
            "TRIP11",
            "TMED10P1",
            "PTPN11",
            "EXOC5",
            "MOBKL2C",
            "LARP4",
            "HNRNPA3P1",
            "HSPA5",
            "SMEK1",
            "SOCS4",
            "DBNL",
            "KIAA0317",
            "CPSF2",
            "RBBP5",
            "TMED10",
            "WBP2",
            "NCL",
            "FAM20B",
            "GOLGA5",
            "MAPK1IP1L",
            "C11orf68",
            "C1orf124",
            "PPM1A",
            "YY1",
            "CCNK",
            "TFCP2",
            "MUDENG",
            "SLC39A9",
            "MARK3",
            "CCAR1",
            "ZRANB1",
            "UBXN6",
            "DHX9",
            "WAC",
            "HNRNPU",
            "RBM12",
            "CTCF",
            "SFRS1"
        ]
    },
    {
        "golabel": "PAPOLG_regulon_activity",
        "gene": [
            "ZFPM1",
            "PTK6",
            "MICALL2",
            "CEMP1",
            "C16orf48",
            "C20orf135",
            "GPR56",
            "EXOC6B",
            "SLC39A10",
            "ZNF420",
            "FBXL20",
            "RPUSD1",
            "CCDC75",
            "ZGPAT",
            "ARFGAP1",
            "PRR24",
            "IMPACT",
            "BCAR1",
            "ARFRP1",
            "GLTPD1",
            "PTPN4",
            "SLC37A1",
            "FOXN2",
            "YWHAQ",
            "RAP2A",
            "SOLH",
            "BBS10",
            "PRKD3",
            "ASB3",
            "TAPBP",
            "MESDC1",
            "DUSP11",
            "FBXO48",
            "GMCL1",
            "HCFC2",
            "SPAST",
            "ARL5A",
            "PREPL",
            "EPN1",
            "PCNP",
            "MIER3",
            "C9orf80",
            "IKZF5",
            "NLRX1",
            "ATP6V0C",
            "CDKN1B",
            "ATG4C",
            "PPP1CB",
            "SOCS5",
            "VPS54",
            "METAP2",
            "ATP6AP1",
            "KLRAQ1",
            "CEBPZ",
            "PPP3R1",
            "HNRPLL",
            "SMEK2",
            "ZFR",
            "MARCH7",
            "ZBTB11",
            "ZNF143",
            "SP3",
            "SPOP",
            "FBXO11",
            "MATR3"
        ]
    },
    {
        "golabel": "PARN_regulon_activity",
        "gene": [
            "SYBU",
            "PLA2G10",
            "MSLN",
            "SLC26A9",
            "SLC16A4",
            "C16orf89",
            "POLR3H",
            "CXCL10",
            "FOLR1",
            "SFTPB",
            "KLF15",
            "TACC2",
            "RHBDL1",
            "FAM64A",
            "MAOA",
            "ACSM3",
            "CDKN3",
            "SLC22A3",
            "SELENBP1",
            "AHCYL2",
            "CENPA",
            "MAD2L1",
            "C12orf48",
            "RHOBTB2",
            "DEPDC1",
            "PRR11",
            "DEPDC1B",
            "DLGAP5",
            "SMPDL3B",
            "EPR1",
            "MECOM",
            "BIRC5",
            "CDC20",
            "DSCC1",
            "ITPRIPL1",
            "ATP1B1",
            "KIAA1524",
            "CKAP2L",
            "CDK1",
            "C11orf82",
            "CCNA2",
            "ABCC6",
            "BUB1",
            "SCNN1A",
            "CDCA8",
            "GAS2L3",
            "MALL",
            "GPR39",
            "RNF145",
            "CCDC64B",
            "MUC1",
            "ALDH2",
            "KPNA2",
            "EMP2",
            "HGSNAT",
            "CHP",
            "SNX6",
            "DBF4",
            "C4orf46",
            "C6orf150",
            "CCDC88A",
            "TMEM55A",
            "DCK",
            "DECR2",
            "RAB40C",
            "NUDT16",
            "PNMA1",
            "PHF19",
            "MVP",
            "CALHM2",
            "BFAR",
            "TXNDC11",
            "C11orf49",
            "ALDH7A1",
            "C16orf58",
            "PIGQ",
            "TTL",
            "RAP2A",
            "SGTB",
            "PRKD3",
            "JMJD8",
            "PDXDC1",
            "MCCC2",
            "CLN3",
            "CLUAP1",
            "CLEC16A",
            "EIF3CL",
            "SCLT1",
            "RNPEP",
            "EARS2",
            "KIAA0430",
            "ALG1",
            "ZNF213",
            "DEXI",
            "COG7",
            "GNA13",
            "CTNNA1",
            "COQ7",
            "RRN3",
            "IRF2BP2",
            "NUBP1",
            "C16orf62",
            "SEPT7",
            "PRPSAP1",
            "STAT3",
            "NAT15",
            "GLYR1"
        ]
    },
    {
        "golabel": "PARP12_regulon_activity",
        "gene": [
            "CXCL11",
            "C12orf70",
            "CIT",
            "APOBEC3A",
            "HUNK",
            "CXXC4",
            "ISG15",
            "IFI44L",
            "MAOA",
            "OASL",
            "SORBS2",
            "IFI44",
            "SIGLEC1",
            "PARM1",
            "C8orf4",
            "RNF180",
            "GBP1",
            "RSAD2",
            "ATP1B1",
            "RTP4",
            "STYK1",
            "PSMB9",
            "SFTA3",
            "SAMD9",
            "IFIT2",
            "XAF1",
            "KRT19",
            "EPSTI1",
            "SECTM1",
            "IFIT3",
            "TAP1",
            "OAS2",
            "IFIH1",
            "SAMD9L",
            "DDX60",
            "GYG2",
            "CMPK2",
            "IFI35",
            "ARPC1B",
            "MTUS1",
            "IRF1",
            "C14orf80",
            "FLJ36031",
            "ZDHHC14",
            "DDX60L",
            "EPHA1",
            "EFHD2",
            "TAP2",
            "IRF5",
            "APOL2",
            "OBFC2A",
            "CPSF4",
            "DTX2",
            "INF2",
            "ZNF778",
            "XRCC3",
            "RHBDF2",
            "C14orf167",
            "MAML3",
            "LNX2",
            "SPATS2L",
            "SLC25A4",
            "PHF19",
            "GSTK1",
            "BFAR",
            "PLOD3",
            "PCYOX1",
            "C7orf43",
            "SH3BP2",
            "FAM8A1",
            "C10orf32",
            "OGFR",
            "GLT25D1",
            "RPS6KA4",
            "PIGM",
            "EIF3L",
            "MOV10",
            "DGKZ",
            "KLHL8",
            "PREPL",
            "PLA2G12A",
            "SP100",
            "RAB4A",
            "PRKAR1A",
            "NUB1",
            "BMPR1A",
            "SFRS2B",
            "SLC30A5",
            "ZC3H7A",
            "OAZ2"
        ]
    },
    {
        "golabel": "PATZ1_regulon_activity",
        "gene": [
            "LOC84931",
            "CDA",
            "IL1RN",
            "IL2RA",
            "VSIG4",
            "SRGN",
            "SIX1",
            "CRTAM",
            "BCL11A",
            "CCL3",
            "PDCD1LG2",
            "CCL4",
            "EVI2A",
            "FPR1",
            "FCGR2B",
            "IL7R",
            "BCL2A1",
            "PTAFR",
            "MS4A4A",
            "GPR183",
            "MS4A6A",
            "SAMSN1",
            "LOC441869",
            "TNFSF13B",
            "CYBB",
            "FCGR1A",
            "SBK1",
            "C5AR1",
            "FCGR3A",
            "FOXRED2",
            "CD80",
            "SNX10",
            "C3AR1",
            "MXD1",
            "SOD2",
            "TLR4",
            "FCER1G",
            "PILRA",
            "FAS",
            "C20orf151",
            "HAVCR2",
            "CD68",
            "MICB",
            "PIK3AP1",
            "TRPV2",
            "CD86",
            "SIX4",
            "CD53",
            "ARHGEF19",
            "SLA",
            "LAPTM5",
            "SLC31A2",
            "SLC7A7",
            "ZNRF3",
            "LCP2",
            "IL15RA",
            "MYEF2",
            "ProSAPiP1",
            "HRH1",
            "ARHGAP8",
            "LHFPL2",
            "SOX12",
            "IFNGR1",
            "PDXP",
            "C22orf27",
            "CTSB",
            "CRTC1",
            "C2orf15",
            "CFLAR",
            "SOX4",
            "ZNF620",
            "C4orf32",
            "LEPROT",
            "ZNF74",
            "RALB",
            "RHBDD3",
            "CHD6",
            "OPTN",
            "C9orf21",
            "FAM117B",
            "CORO1C",
            "MAGEF1",
            "TMEM106A",
            "RNF215",
            "DEAF1",
            "ZNF362",
            "OSTM1",
            "ZNF821",
            "ZNF70",
            "ZNF3",
            "ANXA5",
            "ZNF629",
            "TMEM140",
            "MBTD1",
            "PABPN1",
            "THOC5",
            "ANO6",
            "TDRD7",
            "LDOC1L",
            "CCDC117",
            "ZNF786",
            "MFSD1",
            "RBM4B",
            "DEPDC5",
            "C14orf93",
            "ZMYM3",
            "TUG1",
            "ARPC2",
            "RNF149",
            "L3MBTL2",
            "NCOA5",
            "EIF4ENIF1",
            "UBTF"
        ]
    },
    {
        "golabel": "PAWR_regulon_activity",
        "gene": [
            "TRIM16L",
            "ALOX15B",
            "GCLM",
            "FIGN",
            "GGTLC2",
            "TRIM16",
            "C12orf48",
            "PRR11",
            "CASC5",
            "SOD3",
            "DLGAP5",
            "KIF23",
            "ABCC6P2",
            "KIAA1524",
            "CKAP2L",
            "HLA-DRB1",
            "ARHGAP11A",
            "ASPM",
            "ATP2B1",
            "FAM83D",
            "NAPSB",
            "SGOL2",
            "LRP12",
            "ECT2",
            "RACGAP1",
            "CD74",
            "HLA-DMA",
            "S1PR4",
            "EPT1",
            "KIF20B",
            "MFSD7",
            "UTP20",
            "LYL1",
            "FAAH",
            "MPHOSPH9",
            "TMPO",
            "SIL1",
            "CHORDC1",
            "SBNO1",
            "LOC727896",
            "TDG",
            "EHBP1",
            "SLC44A1",
            "C21orf2",
            "RIF1",
            "TMTC3",
            "NFXL1",
            "GNPTG",
            "TAF1A",
            "TNFSF12",
            "WRN",
            "RAB10",
            "WDR43",
            "MTMR2",
            "GTF2H3",
            "POLR3GL",
            "NAA25",
            "KRR1",
            "ATP2A2",
            "FBXO30",
            "RPS6KA1",
            "PKN2",
            "PTPN11",
            "NEDD1",
            "COG5",
            "POLR3B",
            "PPP1R12A",
            "RAB6A",
            "SIRT3",
            "DENR",
            "ZNF672",
            "SART3",
            "SLC35A4",
            "PRPF40A"
        ]
    },
    {
        "golabel": "PAXIP1_regulon_activity",
        "gene": [
            "FOXP2",
            "CD48",
            "LRRN4CL",
            "LST1",
            "TMEM37",
            "CD52",
            "ITGB6",
            "LOC339524",
            "KLRB1",
            "XRCC2",
            "IFI27L2",
            "HCST",
            "HSPB2",
            "EZH2",
            "CCDC152",
            "GMFG",
            "NCAPG2",
            "MCM3APAS",
            "PHF8",
            "RASL12",
            "NAALADL1",
            "SLC29A2",
            "ZC3HAV1L",
            "GPX1",
            "CYGB",
            "CD59",
            "CLCN2",
            "SERTAD1",
            "PDIA4",
            "CAPG",
            "MFGE8",
            "ACYP2",
            "RRAS",
            "POLE",
            "IGFBP4",
            "DNMT3A",
            "PHKA1",
            "HOOK1",
            "TRIM24",
            "KIAA0182",
            "TRRAP",
            "MARCH6",
            "PTCD1",
            "RNASEN",
            "XPO5",
            "BRAF",
            "RBM28",
            "KIAA1731",
            "NUP205",
            "TAF4",
            "ITM2B",
            "REPIN1",
            "LIG3",
            "MYL12A",
            "ZNF687",
            "PARP1",
            "GON4L",
            "SH3BGRL",
            "ODF2",
            "ZNF786",
            "NOM1",
            "NECAP2",
            "PMS2",
            "SLC37A3",
            "MTMR4",
            "UBE2O",
            "OCRL",
            "PNRC1",
            "CASP2",
            "UBAP2L",
            "LAPTM4A",
            "UBE3C",
            "IPO9",
            "ISCU",
            "SNAP23",
            "ATG7",
            "ILK",
            "SAPS3",
            "LUC7L2"
        ]
    },
    {
        "golabel": "PBRM1_regulon_activity",
        "gene": [
            "SOCS1",
            "COMTD1",
            "BATF",
            "KRT10",
            "PCM1",
            "AMOTL1",
            "FAM58A",
            "PSMB10",
            "HSD3B7",
            "PSMB3",
            "BOLA2",
            "NDUFB7",
            "MAGI1",
            "FAM128A",
            "TRAPPC5",
            "ZNF192",
            "NAA10",
            "RAD54L2",
            "TCEB2",
            "MED13L",
            "LRP6",
            "SFMBT1",
            "C19orf53",
            "C19orf24",
            "FAM100B",
            "SYNGR2",
            "POLD4",
            "TMPPE",
            "AURKAIP1",
            "LSM10",
            "RPL23AP53",
            "YIF1A",
            "C1orf122",
            "PPP4C",
            "HECTD1",
            "CTU2",
            "FAM109B",
            "SSSCA1",
            "TNKS",
            "MRPS34",
            "GOLGA4",
            "DCAF16",
            "SMARCC1",
            "NSDHL",
            "ROCK1",
            "ZNF445",
            "BDP1",
            "ATRX",
            "AUP1",
            "ASB13",
            "TET2",
            "CXorf40A",
            "ZNF407",
            "GMPPA",
            "ARID1A",
            "SNRK",
            "TOP2B",
            "VHL",
            "RYBP",
            "MFSD5",
            "RAD23A",
            "USP34",
            "DCP1A",
            "NEK4",
            "APPL1",
            "CAPN7",
            "SETD2",
            "VPRBP",
            "CLASP2",
            "BCLAF1",
            "PUM1",
            "CREB1"
        ]
    },
    {
        "golabel": "PBX4_regulon_activity",
        "gene": [
            "KRT72",
            "CCDC28B",
            "TTC18",
            "RUFY4",
            "ANKK1",
            "C2orf85",
            "C14orf73",
            "LOC440896",
            "CCDC146",
            "OR52N4",
            "CXorf65",
            "LOC283663",
            "C1orf228",
            "CCDC153",
            "HSPA7",
            "TTC21A",
            "ZNF334",
            "SLFN14",
            "POM121L9P",
            "TSPAN32",
            "LOC115110",
            "LOC389634",
            "HLA-J",
            "RASGRP2",
            "PATL2",
            "C9orf139",
            "OXER1",
            "LOC728392",
            "ZAP70",
            "LAT",
            "RFX2",
            "COLQ",
            "CTRL",
            "ZBTB32",
            "TBC1D10C",
            "ARRDC5",
            "HCG26",
            "XAF1",
            "ATG16L2",
            "ACAP1",
            "ANGPTL6",
            "LCAT",
            "SEPT1",
            "C20orf107",
            "ZGLP1",
            "NCRNA00181",
            "MAP4K1",
            "PSTPIP1",
            "UAP1L1",
            "RASAL3",
            "IFFO1",
            "PVRIG",
            "TTLL3",
            "CCDC88B",
            "UBXN11",
            "TMC8",
            "C1orf113",
            "ARHGAP9",
            "TNFRSF14",
            "ARHGAP4",
            "LIMD2",
            "FGD3",
            "LOC729991-MEF2B",
            "TBX19",
            "CBLN3",
            "GALNT7",
            "GLCE",
            "FLT3LG",
            "MICAL1",
            "EGLN1",
            "HSH2D",
            "ANKDD1A",
            "HMHA1",
            "TNK2",
            "EVL",
            "SFI1",
            "SUCLG2",
            "LOC147727",
            "FCHSD1",
            "SSBP4",
            "ARHGEF1",
            "YIPF6",
            "LPAR2",
            "DEF6",
            "C1orf58",
            "C19orf66",
            "CCDC130",
            "BBS5",
            "IFT122",
            "PPP1R12C",
            "NSF",
            "IMPAD1",
            "GHITM",
            "PAOX",
            "ALDH18A1",
            "MYO9B",
            "CANX",
            "NDUFS1",
            "TMEM33",
            "GMIP",
            "RNF166",
            "RAB2A",
            "PTPN18",
            "TM9SF3",
            "RBM47",
            "EIF3J",
            "SSR1",
            "CDYL",
            "MKNK1",
            "ATF6",
            "TMBIM6",
            "COPB1",
            "TCTN3",
            "MARCH5",
            "ELL",
            "GRSF1",
            "SLC30A5",
            "PRRC1",
            "MRPL19",
            "RAB1A"
        ]
    },
    {
        "golabel": "PBXIP1_regulon_activity",
        "gene": [
            "PGC",
            "TMEM59L",
            "AQP7",
            "GNMT",
            "ARNTL2",
            "DAAM2",
            "CCNB2",
            "IRX3",
            "ANLN",
            "CDKN3",
            "ELOVL6",
            "SELENBP1",
            "TFRC",
            "CENPA",
            "MAD2L1",
            "SKA1",
            "C12orf48",
            "DEPDC1",
            "DIAPH3",
            "DEPDC1B",
            "CASC5",
            "TTK",
            "DLGAP5",
            "SMPDL3B",
            "KIF23",
            "CDC6",
            "RAD51AP1",
            "SPC25",
            "DSCC1",
            "KIAA1524",
            "CKAP2L",
            "CDK1",
            "C11orf82",
            "CCNA2",
            "SGOL1",
            "NCAPG",
            "MELK",
            "ARHGAP11A",
            "SKA3",
            "ESCO2",
            "NCAPH",
            "BUB1",
            "CDCA5",
            "RRM2",
            "CEP55",
            "PLD3",
            "HK2",
            "CHEK1",
            "PLK4",
            "RAD51",
            "KIF11",
            "MXD1",
            "RORC",
            "ENPP5",
            "RACGAP1",
            "NUSAP1",
            "CKAP2",
            "MMP15",
            "CABC1",
            "DBF4",
            "PTK7",
            "ATP1B3",
            "RAB40B",
            "HHAT",
            "ADCY3",
            "RAB40C",
            "SHISA4",
            "ZWILCH",
            "FAM117A",
            "C3orf18",
            "GALNT11",
            "FAM63A",
            "TMEM63B",
            "PIGT",
            "ATL3",
            "LASS2",
            "FUK",
            "PPOX",
            "C9orf7",
            "PMF1",
            "CORO1C",
            "C16orf58",
            "PMVK",
            "ZNF362",
            "NBN",
            "ORMDL3",
            "C1orf66",
            "JMJD8",
            "ZNF687",
            "SLC38A10",
            "ZBTB7B",
            "ZBTB4",
            "LDB1",
            "ZNF213",
            "HDAC5",
            "ACTR3",
            "USP21",
            "MEF2D",
            "DNAJB2",
            "PYGO2",
            "CRTC2",
            "POMT1",
            "ZNF720",
            "ZBTB22",
            "DCAF8",
            "PI4KB",
            "ZER1",
            "ARL8A",
            "PITPNB",
            "FAM134A"
        ]
    },
    {
        "golabel": "PCBD1_regulon_activity",
        "gene": [
            "ORM2",
            "CBR1",
            "AKR1C1",
            "NCRNA00188",
            "ARSE",
            "GAS5",
            "C20orf199",
            "OVGP1",
            "ASB9",
            "SFTA2",
            "RPS18",
            "RPS7",
            "RPLP1",
            "ADAM19",
            "GLOD5",
            "SMPDL3B",
            "RPS10",
            "TIAM1",
            "GSTO2",
            "GOLT1A",
            "DCHS1",
            "MMP2",
            "GPR161",
            "COL6A3",
            "BACH2",
            "BTBD19",
            "KRTCAP3",
            "TRIB2",
            "PMM1",
            "LAMA4",
            "RPS16",
            "RPS14",
            "GPR39",
            "MGST1",
            "SLC39A4",
            "LOXL3",
            "LTBP1",
            "KIAA1024",
            "RORC",
            "DCXR",
            "TRPS1",
            "RPL31",
            "TSTD1",
            "TLCD1",
            "RPLP0",
            "NDUFB9",
            "AGPAT2",
            "RPL8",
            "SPSB2",
            "HSD17B8",
            "RPS8",
            "RPL24",
            "RPL26",
            "TPBG",
            "EBPL",
            "RPL27A",
            "RPL29",
            "C6orf204",
            "C8orf55",
            "RPS9",
            "LACTB2",
            "C21orf57",
            "TATDN1",
            "GSTP1",
            "RPL10A",
            "SEPT11",
            "RPL13",
            "RPL12",
            "C1orf210",
            "MGMT",
            "MRPL14",
            "AIFM2",
            "RPL41",
            "LRP1",
            "ADK",
            "C2orf79",
            "CCDC56",
            "PPPDE2",
            "MGC70857",
            "TTYH3",
            "RPL32",
            "PALM2-AKAP2",
            "ELL3",
            "RANGRF",
            "SLC25A16",
            "RPL38",
            "HIVEP3",
            "ALDH5A1",
            "RPL7A",
            "TMEM180",
            "DGAT1",
            "EPB41L2",
            "MGC16275",
            "C6orf108",
            "RPS24",
            "LOC442454",
            "SYNJ2",
            "TKT",
            "RPL37A",
            "C1QBP",
            "MRPL24",
            "EIF3E",
            "RPL14",
            "OSBPL3",
            "USMG5",
            "APOA1BP",
            "ZNF511",
            "ATP10D",
            "CLDN7",
            "APRT",
            "RPS20",
            "STXBP5",
            "RPS23",
            "FAM36A",
            "RAB25",
            "ERP29",
            "PNKD",
            "RPL30",
            "C17orf51",
            "L3MBTL3",
            "LTA4H",
            "RPL15",
            "C10orf35",
            "FBXL15",
            "MYO5A",
            "RPL4",
            "SH3YL1",
            "C1orf43",
            "SLC25A4",
            "GNB2L1",
            "MRPS36",
            "LOC645332",
            "HAUS4",
            "SPR",
            "CHSY1",
            "RPS4X",
            "NHP2",
            "DPCD",
            "PRSS16",
            "OBFC1",
            "COX7C",
            "SLC25A6",
            "SFXN4",
            "SEC14L1",
            "ATP5G2",
            "PRDX3",
            "SHARPIN",
            "RPL3",
            "UQCRB",
            "C10orf57",
            "CBL",
            "RPL19",
            "VDAC2",
            "RUSC2",
            "POLR1C",
            "MED11",
            "TOM1L1",
            "ABHD14B",
            "LUZP1",
            "NCRNA00081",
            "SH3BP2",
            "RPL23A",
            "SLC48A1",
            "LETMD1",
            "EIF2C3",
            "NDUFB8",
            "MRPS18B",
            "CDR2",
            "CHCHD1",
            "MRPL43",
            "ITSN1",
            "PPA1",
            "CEP135",
            "TYSND1",
            "PRDX6",
            "CLSTN1",
            "KIAA1539",
            "ZDHHC16",
            "PEBP1",
            "PPP2R5B",
            "UROS",
            "GHITM",
            "ANAPC16",
            "CUTC",
            "LGTN",
            "MRPL38",
            "EBAG9",
            "BLOC1S2",
            "ECHS1",
            "C6orf130",
            "PCBD2",
            "SEC11A",
            "MRPS16",
            "EXOSC1",
            "CBARA1",
            "TMEM185A",
            "SLC41A3",
            "NHP2L1",
            "ANXA11",
            "COX15",
            "MARCH5",
            "NHEJ1",
            "CUEDC2",
            "HPS6",
            "POLL",
            "DNAJB12",
            "ANXA7",
            "C2orf24",
            "HADHB",
            "ECD",
            "ACTR1A"
        ]
    },
    {
        "golabel": "PCBD2_regulon_activity",
        "gene": [
            "SLC26A9",
            "C16orf89",
            "GREM1",
            "GPC6",
            "ADAM12",
            "INHBA",
            "COL3A1",
            "IGF2BP2",
            "ADAMTS4",
            "CLSPN",
            "COL5A2",
            "ADAMTS5",
            "GPR176",
            "SMO",
            "SELENBP1",
            "MYBL2",
            "EPHB2",
            "KIF3C",
            "CAPN8",
            "PRR11",
            "MFAP2",
            "TTK",
            "C1orf135",
            "TPX2",
            "CTHRC1",
            "CLTCL1",
            "KIF2C",
            "KIAA1524",
            "CKAP2L",
            "WISP1",
            "C9orf68",
            "GPR161",
            "ABCC6",
            "NCAPH",
            "RND3",
            "ARHGAP26",
            "CDCA8",
            "MMP14",
            "MCM2",
            "ANGPTL2",
            "FLJ42289",
            "EIF5A2",
            "LOC100129534",
            "EPHX2",
            "NCRNA00219",
            "RORC",
            "EIF4EBP3",
            "COL4A1",
            "FSTL1",
            "MCAM",
            "C18orf54",
            "MMD",
            "LOC100302401",
            "CATSPER3",
            "FHIT",
            "LAMB1",
            "SHROOM1",
            "SNHG8",
            "ZNF697",
            "NUDT13",
            "CERCAM",
            "C21orf57",
            "ACTN1",
            "TTYH3",
            "FLJ44606",
            "RBL1",
            "NUDT12",
            "FAAH2",
            "LAMC1",
            "MRPS25",
            "CLK4",
            "SIL1",
            "CALU",
            "RAB23",
            "FAM63A",
            "SH3YL1",
            "SLC25A4",
            "LOC645332",
            "PHF15",
            "TUBB",
            "CHSY1",
            "FBXO10",
            "MARCKS",
            "LRRC27",
            "ERGIC1",
            "SETD4",
            "MAN2C1",
            "AGXT2L2",
            "PCBD1",
            "ZNF33B",
            "ABHD14B",
            "GNA12",
            "NICN1",
            "TRAM2",
            "LETMD1",
            "HSD17B4",
            "PANX1",
            "CLINT1",
            "SLC22A5",
            "ISOC1",
            "TRIM41",
            "RRAGC",
            "CCDC125",
            "MCCC2",
            "FAM174A",
            "CNPY4",
            "MED7",
            "ANKRA2",
            "C1orf27",
            "FLJ33630",
            "CBR4",
            "PIGB",
            "KIAA0141",
            "TRAPPC2",
            "REEP5",
            "C15orf17",
            "MEX3C",
            "RMND5B",
            "CTNNA1",
            "DCAF8",
            "BRD8",
            "C9orf156",
            "ZFYVE27",
            "RUFY1",
            "SEPT7",
            "POLL",
            "WDR55",
            "SLC35A4",
            "NRBP1"
        ]
    },
    {
        "golabel": "PCBP1_regulon_activity",
        "gene": [
            "LOC100133985",
            "C2CD4D",
            "CBLC",
            "CD80",
            "TALDO1",
            "DOCK11",
            "CC2D2B",
            "ANKRD44",
            "DOCK2",
            "NAIP",
            "DOCK10",
            "ZEB2",
            "PPIB",
            "ZNF862",
            "C15orf63",
            "PDIA3",
            "LRRC8C",
            "PDIA3P",
            "COX5A",
            "PKD2",
            "EPCAM",
            "SPR",
            "ZNF441",
            "MRPL53",
            "GFPT1",
            "FMNL3",
            "KCTD7",
            "CNO",
            "CLN6",
            "RTKN",
            "ANKRD13A",
            "NACA",
            "PDCL3",
            "AUP1",
            "KCMF1",
            "ATIC",
            "MRPS9",
            "DCTN1",
            "THAP4",
            "CCT7",
            "RNF187",
            "ANP32A",
            "MRPS5",
            "GORASP2",
            "TMEM214",
            "MRPL19",
            "TTC15",
            "MPHOSPH10",
            "PPP2R1A",
            "RAB1A"
        ]
    },
    {
        "golabel": "PCGF6_regulon_activity",
        "gene": [
            "POLE2",
            "C12orf48",
            "DSCC1",
            "CDK1",
            "KIAA0101",
            "SNHG6",
            "CEP55",
            "CCNB1",
            "FAM92A1",
            "KIF11",
            "MTHFD2",
            "FLJ23867",
            "RFC3",
            "KIF20B",
            "PPL",
            "PDSS1",
            "USMG5",
            "C10orf78",
            "SUV39H2",
            "TRUB1",
            "THRA",
            "LGALS3BP",
            "TFAM",
            "ILDR1",
            "TCEA1",
            "CCNJ",
            "LOC221710",
            "PACSIN2",
            "CNKSR1",
            "CXXC5",
            "FARP2",
            "TAF5",
            "ZDHHC7",
            "RAB43",
            "RABGGTB",
            "DNAJC9",
            "METTL10",
            "GRN",
            "KIAA0319L",
            "TMEM129",
            "CUTC",
            "TRIOBP",
            "MAN2B2",
            "ZCCHC7",
            "TMCO4",
            "ZNF22",
            "BCCIP",
            "C2orf3",
            "SLC25A32",
            "MRPS16",
            "EXOSC1",
            "TBCK",
            "CHUK",
            "BUB3",
            "ZNF500",
            "C10orf88",
            "WBP2",
            "DDX50",
            "MARCH5",
            "RPP30",
            "C10orf119",
            "PPP3CB",
            "SMNDC1",
            "ADO",
            "TIAL1",
            "GLYR1",
            "SAR1A"
        ]
    },
    {
        "golabel": "PDCD11_regulon_activity",
        "gene": [
            "CTSH",
            "SLC7A5",
            "RNASE1",
            "KLHDC7A",
            "LST1",
            "SNHG4",
            "SACS",
            "C15orf42",
            "KIF14",
            "CENPF",
            "C6orf225",
            "ARHGAP11A",
            "RRS1",
            "MKI67",
            "MYC",
            "CHD7",
            "HLA-DRA",
            "DHRS3",
            "MTCP1NB",
            "MCM3APAS",
            "HLA-DMA",
            "BCAS4",
            "EPT1",
            "URB1",
            "TMSL3",
            "SLC7A1",
            "GUCY1B3",
            "N4BP2L1",
            "PGCP",
            "CAD",
            "CCDC28A",
            "FUCA1",
            "IPO4",
            "ARHGDIB",
            "FCGRT",
            "C10orf2",
            "CTNNBIP1",
            "PIK3IP1",
            "SLC5A6",
            "NOP2",
            "POP1",
            "GTPBP4",
            "CCNJ",
            "LOC90784",
            "PPT1",
            "XPO5",
            "POLR1A",
            "HADH",
            "RBM28",
            "IFNGR2",
            "MYBBP1A",
            "POLR3A",
            "TAF5",
            "ESF1",
            "RRP12",
            "NOL6",
            "VARS",
            "TCEAL8",
            "PGRMC1",
            "CD3EAP",
            "WDR43",
            "DHX37",
            "URB2",
            "SMCR7L",
            "TXNDC15",
            "ALDH18A1",
            "GCN1L1",
            "HEATR1",
            "EP400",
            "RNF130",
            "POLR1B",
            "NOLC1",
            "RRP1B",
            "LETM1",
            "LARP1",
            "EIF3A",
            "SUPV3L1",
            "MTIF2",
            "AHCTF1",
            "C10orf4",
            "CTBP2",
            "CS",
            "NOP14",
            "NAT10",
            "ZBED4",
            "NCL",
            "SF3B3",
            "NUBP1",
            "PPRC1",
            "XPNPEP1",
            "ILK",
            "HIF1AN",
            "GTF3C2",
            "ZNF142",
            "CCAR1",
            "MMS19"
        ]
    },
    {
        "golabel": "PDLIM4_regulon_activity",
        "gene": [
            "RPSAP52",
            "EREG",
            "CSF2",
            "SPOCD1",
            "ITGB3",
            "G0S2",
            "CATSPER1",
            "FABP6",
            "CDA",
            "ITPKA",
            "GPR87",
            "TGFBI",
            "SYT12",
            "CNIH3",
            "MYO1G",
            "FHOD3",
            "TNC",
            "MT1E",
            "PLAU",
            "BEAN",
            "DCBLD2",
            "NT5E",
            "AFAP1L2",
            "FBXO32",
            "C10orf55",
            "TIPARP",
            "STAC",
            "PDZD7",
            "CX3CL1",
            "SRPX2",
            "SLC22A18AS",
            "PDE4D",
            "CLEC5A",
            "BATF3",
            "DNTTIP1",
            "FAP",
            "GPR68",
            "ARSI",
            "SNX21",
            "KCNN4",
            "CHST3",
            "SLC16A2",
            "ALOX5AP",
            "UPP1",
            "CABLES1",
            "COL6A2",
            "GADD45A",
            "PLAUR",
            "PPP1R3B",
            "PHLDA2",
            "MBOAT2",
            "DAPK1",
            "C5orf62",
            "ITGA3",
            "FXYD5",
            "TNFRSF12A",
            "KIAA1549",
            "EMP3",
            "EMP1",
            "ATP8B1",
            "VIM",
            "TUBB6",
            "TIMP1",
            "NCS1",
            "CCDC109B",
            "RGS10",
            "IL27RA",
            "TUBA4A",
            "PDLIM7",
            "FLJ36031",
            "SHANK2",
            "STK17A",
            "SH3BGRL3",
            "MXRA7",
            "XBP1",
            "RHOC",
            "FZD5",
            "CMTM3",
            "FHL3",
            "FLNA",
            "FLVCR1",
            "HRH1",
            "ERBB3",
            "P4HA2",
            "FECH",
            "ECE1",
            "TRIM47",
            "MFGE8",
            "PLP2",
            "GNA15",
            "LIMK1",
            "CAMK1",
            "KIAA1598",
            "CCM2",
            "DHTKD1",
            "ZKSCAN3",
            "PML",
            "SPATS2L",
            "TGFB1",
            "ACSL3",
            "KBTBD7",
            "FAM127A",
            "FAM117B",
            "SFXN3",
            "MAP7D1",
            "BAHD1",
            "PAPD5",
            "ARNT",
            "SNAPC2",
            "FASTKD5",
            "RAB11FIP5",
            "ACTG1",
            "LARP4B",
            "GNAI2",
            "STX4",
            "ACTB",
            "DCAF8",
            "SUV420H1"
        ]
    },
    {
        "golabel": "PDS5B_regulon_activity",
        "gene": [
            "ATP7B",
            "C4orf44",
            "PFN4",
            "C1orf170",
            "PLEKHN1",
            "EPHA10",
            "PHLDA2",
            "TCF4",
            "GAMT",
            "TNFRSF12A",
            "BTBD3",
            "SDSL",
            "SHROOM1",
            "FAM53A",
            "HSPB1",
            "SLC25A10",
            "C7orf50",
            "DTX2",
            "NUDT17",
            "PPP1R16A",
            "TRIM47",
            "ABHD11",
            "LIMK1",
            "KCTD13",
            "TMEM54",
            "GTF2A1",
            "B3GNTL1",
            "ADAM15",
            "GAA",
            "LCORL",
            "LGALS3BP",
            "CTSA",
            "SPATA20",
            "KBTBD7",
            "ZNF341",
            "SHPRH",
            "B3GALTL",
            "TMC6",
            "POR",
            "TMUB1",
            "C9orf102",
            "FASTK",
            "PLEKHH3",
            "MIB1",
            "CISD3",
            "DUS1L",
            "IPO5",
            "LRCH1",
            "USP12",
            "HMGB1",
            "NAA16",
            "PTRH2",
            "KBTBD6",
            "BCKDK",
            "STAG1",
            "NAT9",
            "BIN1",
            "B4GALT7",
            "PQLC2",
            "CLCN7",
            "DNAJC30",
            "ZC3H13",
            "RFNG",
            "ZNF624",
            "TMEM53",
            "RFXAP",
            "CHMP6",
            "XYLT2",
            "RHBDD2",
            "PEX10",
            "TCF12",
            "TASP1",
            "AKAP11",
            "RCBTB1",
            "PNPO",
            "HGS",
            "RNF135",
            "C17orf62",
            "XRN2",
            "WDR7",
            "CRNKL1",
            "PIK3C2A",
            "XPO4",
            "WBP2",
            "C16orf42",
            "RNF6",
            "ZNF510",
            "SFRS2IP",
            "STRADA",
            "SPIN1"
        ]
    },
    {
        "golabel": "PER2_regulon_activity",
        "gene": [
            "NR4A2",
            "LGALS1",
            "TACC2",
            "BEND6",
            "IRS2",
            "PDE4D",
            "AVPI1",
            "BATF3",
            "SIK1",
            "MSR1",
            "CLEC4A",
            "ALOX5AP",
            "C1QB",
            "TYROBP",
            "FCGR1A",
            "SLC22A23",
            "FCGR1C",
            "PTPRO",
            "FCGR1B",
            "C1QC",
            "SNX10",
            "MLPH",
            "C1QA",
            "SIGLEC7",
            "SPIRE2",
            "PER1",
            "SIGLEC9",
            "GPR65",
            "FAM83E",
            "TMC5",
            "CD300A",
            "FCER1G",
            "PAQR3",
            "HAVCR2",
            "KLF5",
            "KIF13B",
            "LRRC25",
            "CCDC109B",
            "HDX",
            "TJP3",
            "LAT2",
            "RGS10",
            "TBC1D8",
            "IFI30",
            "CFL2",
            "SHANK2",
            "FRAT1",
            "ETS2",
            "MXRA7",
            "CENPQ",
            "CMTM3",
            "ERBB3",
            "FAAH2",
            "SH3BP4",
            "STARD3NL",
            "CASZ1",
            "CNN3",
            "TMEM206",
            "UBE2E2",
            "OSBPL2",
            "GLO1",
            "PPT1",
            "PDE8A",
            "TRAK1",
            "BCL6",
            "CORO1C",
            "DRAP1",
            "SLC25A19",
            "ME2",
            "TOB2",
            "NTAN1",
            "ANKRD42",
            "RREB1",
            "PEA15",
            "TRAF3IP1",
            "DEGS1",
            "PCMT1",
            "OGG1",
            "COG7",
            "SCAND2",
            "WHAMM",
            "INO80D",
            "ATG7",
            "DNASE2",
            "DIS3L2",
            "GIGYF2",
            "CTDSP1",
            "SLTM"
        ]
    },
    {
        "golabel": "PER3_regulon_activity",
        "gene": [
            "CPS1",
            "S100P",
            "HOXD1",
            "SLC16A14",
            "DUSP4",
            "ATP13A4",
            "USP2",
            "ARHGAP20",
            "ICAM5",
            "AMOT",
            "NNMT",
            "CACNB1",
            "LOC283070",
            "TLR2",
            "SERTAD4",
            "MEGF6",
            "CAMK1D",
            "FNIP2",
            "RNPC3",
            "GARNL3",
            "ADCY9",
            "MAP3K13",
            "NR1D1",
            "C8orf76",
            "TEF",
            "LRRC3",
            "HIP1",
            "SORD",
            "VPS37A",
            "ZNF608",
            "PPIB",
            "DBP",
            "CREM",
            "C1QBP",
            "C15orf63",
            "PHB2",
            "ATP9A",
            "HSPE1",
            "HSPD1",
            "AHDC1",
            "CTNNBIP1",
            "ZNF211",
            "C16orf5",
            "NDUFV2",
            "CNPY2",
            "CHMP1B",
            "PPIF",
            "ATP5B",
            "MANF",
            "EIF5A",
            "LYST",
            "ZNF441",
            "GAB1",
            "PSMD14",
            "AVEN",
            "ATF4",
            "MPDU1",
            "AEN",
            "VDAC2",
            "EIF5AL1",
            "NR1D2",
            "PDIK1L",
            "SYNJ1",
            "VDAC1",
            "BBS9",
            "KLF11",
            "PSMA4",
            "LDLRAP1",
            "GTF2E2",
            "TMEM85",
            "GNL3",
            "SPATA5L1",
            "RPS6KA1",
            "MAP3K3",
            "RAB11A",
            "EIF4A1",
            "EIF3J",
            "GGA2",
            "ANKRD13C",
            "PRDM2",
            "FAM76A",
            "SLC35E1",
            "SCO1",
            "VPS26B",
            "ZYG11B"
        ]
    },
    {
        "golabel": "PFDN1_regulon_activity",
        "gene": [
            "KIAA1244",
            "RPS14",
            "GSTO1",
            "MRPS6",
            "FUNDC2",
            "TMSB10",
            "RALGAPA2",
            "ACOT4",
            "SPATA24",
            "HINT1",
            "MYO10",
            "RNF181",
            "CCDC72",
            "NIPBL",
            "RPL26L1",
            "MYL6",
            "ATP5O",
            "CDKN2AIPNL",
            "NPM1",
            "TRRAP",
            "NHP2",
            "MRPL39",
            "COX7C",
            "ATP6V0E1",
            "SIPA1L3",
            "PPIL3",
            "MRPL22",
            "BLVRA",
            "LOC388955",
            "PSME1",
            "NSA2",
            "AK2",
            "AKAP9",
            "RWDD2B",
            "ATG10",
            "NUDCD2",
            "PPIA",
            "PI4KA",
            "ATOX1",
            "TMEM111",
            "PRELID1",
            "MYL12A",
            "UBN2",
            "TBCA",
            "NDUFC1",
            "SKP1",
            "C4orf27",
            "SRA1",
            "BTF3",
            "RERE",
            "SSH2",
            "ZZEF1",
            "THOC7",
            "C11orf30",
            "MED7",
            "SNX24",
            "TNRC6B",
            "TTC1",
            "CRYZL1",
            "PKP4",
            "ANAPC10",
            "LSM3",
            "RBMX2",
            "ARPC4",
            "C3orf10",
            "MRPS18C",
            "OCIAD1",
            "MLL5",
            "C3orf75",
            "FRG1",
            "HEATR5B",
            "DDX41",
            "SRP19",
            "RWDD4A",
            "H2AFY",
            "MRFAP1L1",
            "HDAC3",
            "ZMAT2",
            "UBE2D2",
            "PPP2CA",
            "HARS"
        ]
    },
    {
        "golabel": "PGBD1_regulon_activity",
        "gene": [
            "UGT3A1",
            "SCN3A",
            "GAL3ST3",
            "SELV",
            "HOXD13",
            "TMSB15A",
            "NCAM1",
            "ASCL1",
            "OPRD1",
            "ZMAT4",
            "DLL3",
            "KIF5C",
            "GPC2",
            "RNF182",
            "TMEM74",
            "ELOVL2",
            "PPM1E",
            "TMEFF1",
            "TUBB2B",
            "MLLT11",
            "SYCP2L",
            "SV2A",
            "PRPH2",
            "BCL2",
            "TET1",
            "MURC",
            "DLL1",
            "TRO",
            "TMSB15B",
            "LOC728819",
            "REEP2",
            "C14orf37",
            "GPR137C",
            "GJC1",
            "TUSC3",
            "ATP6V1G2",
            "TUBB2A",
            "JAM3",
            "SYT11",
            "GPR161",
            "MTSS1",
            "GPRC5A",
            "NAALADL2",
            "CSRP2",
            "ID2",
            "RHBDL2",
            "GALNT3",
            "CHN1",
            "ZNF286B",
            "MEX3B",
            "LAD1",
            "ZNF833",
            "CCDC14",
            "GALNT12",
            "TCEA3",
            "TJP3",
            "EID2B",
            "ZNF286A",
            "CDKAL1",
            "SERINC2",
            "EPS8",
            "SH2D4A",
            "TRIP6",
            "SEC61A2",
            "DTX2",
            "MGAT4A",
            "BLMH",
            "ZNF192",
            "ELMO3",
            "ZNF284",
            "C9orf167",
            "ZKSCAN3",
            "PHC1",
            "ZNF10",
            "SPR",
            "ZSCAN12",
            "FBXO10",
            "DDHD1",
            "THOC1",
            "TRADD",
            "TTL",
            "RAP2A",
            "ACAA1",
            "ZCCHC11",
            "SSH3",
            "ZNF193",
            "ZNF71",
            "ZNF187",
            "ZNF22",
            "POLR3F",
            "KATNA1",
            "KDM2B",
            "SOCS4",
            "KLC1",
            "ZKSCAN4",
            "TBP",
            "ANXA11",
            "ASXL1",
            "SFRS2",
            "NRF1"
        ]
    },
    {
        "golabel": "PHF1_regulon_activity",
        "gene": [
            "MST1P2",
            "HLA-J",
            "ZNF540",
            "PABPC3",
            "ZNF204P",
            "CSAD",
            "ENGASE",
            "LY6G5B",
            "TMEM48",
            "CROCCL1",
            "INCA1",
            "APBB3",
            "ECHDC2",
            "FAM193B",
            "CDK5RAP3",
            "IL11RA",
            "ANKS3",
            "WASH7P",
            "NRIP1",
            "YPEL3",
            "ENTPD7",
            "MIB2",
            "C21orf2",
            "RAB24",
            "SH2B1",
            "AGXT2L2",
            "DHRS1",
            "TMEM175",
            "POU6F1",
            "DOM3Z",
            "VANGL1",
            "ABTB1",
            "ACBD4",
            "ZBTB48",
            "DOCK7",
            "PHKG2",
            "WDR43",
            "SPSB3",
            "IL17RC",
            "CUL9",
            "C12orf5",
            "UBE2D1",
            "NAA15",
            "ABCE1",
            "GNL3L",
            "RMND5B",
            "AGPS",
            "RING1",
            "WBP2",
            "ISCU",
            "RXRB",
            "PRPF40A",
            "ACTR2"
        ]
    },
    {
        "golabel": "PHF12_regulon_activity",
        "gene": [
            "RSL24D1",
            "GPR179",
            "PROCA1",
            "ZNF217",
            "GSTO1",
            "KCNC3",
            "DPRXP4",
            "SLFN13",
            "RFK",
            "LOC651250",
            "POMP",
            "RAB11FIP4",
            "ZNF512B",
            "PCGF2",
            "RPS12",
            "CELSR1",
            "AHDC1",
            "LRRC37B",
            "PLCG1",
            "NEK8",
            "ZNF341",
            "TUBG2",
            "CHD6",
            "FAM96A",
            "C14orf4",
            "TNRC18",
            "MLLT6",
            "SLC46A1",
            "HEXIM1",
            "CDK11A",
            "BTBD12",
            "ORMDL3",
            "CISD1",
            "GHITM",
            "SERPINB6",
            "MAP1LC3B2",
            "CIC",
            "CUTC",
            "DPH3",
            "GON4L",
            "GIT1",
            "KIAA1267",
            "UBE2O",
            "MAP1LC3B",
            "NLK",
            "ISCA1",
            "ZMYM3",
            "PIP4K2B",
            "LRRC37B2",
            "SUPT6H",
            "KDM2A",
            "ERP44",
            "EXOC7",
            "DDX42",
            "FLOT2",
            "ZNF830",
            "CSNK1D",
            "SAR1A",
            "WDR33",
            "UBTF",
            "GGNBP2"
        ]
    },
    {
        "golabel": "PHF13_regulon_activity",
        "gene": [
            "ZBTB8B",
            "PLA2G10",
            "IL17RD",
            "CNIH2",
            "TSPAN7",
            "KCNQ5",
            "ARSE",
            "BAI2",
            "LOC148709",
            "ESPN",
            "PDE4D",
            "C19orf26",
            "NOSTRIN",
            "AHCYL2",
            "KIF3C",
            "SCD5",
            "PXDN",
            "RAD54L",
            "GPR161",
            "GPR3",
            "ARHGAP26",
            "KRTCAP3",
            "TCF19",
            "NCS1",
            "SIX4",
            "SNHG8",
            "SQRDL",
            "CABLES2",
            "BAG1",
            "ZNHIT6",
            "RPS27L",
            "FIGNL1",
            "PPPDE2",
            "TTYH3",
            "OTUD3",
            "GLCE",
            "NLGN2",
            "MARCKSL1",
            "GPSM2",
            "MCEE",
            "ECE1",
            "NASP",
            "ASAH1",
            "UBXN8",
            "AHDC1",
            "MEX3D",
            "YEATS2",
            "SAT2",
            "PLOD1",
            "DNMT1",
            "SUCLG2",
            "OBFC1",
            "SPSB1",
            "ATAD3A",
            "B4GALT5",
            "TTC38",
            "MED11",
            "GNA12",
            "RCC2",
            "LETMD1",
            "C17orf48",
            "TMEM201",
            "ENO1",
            "CAMTA1",
            "C10orf32",
            "CCNDBP1",
            "CLSTN1",
            "KIAA0090",
            "NOC2L",
            "KIF1B",
            "KDM1A",
            "PURB",
            "PQLC2",
            "LYPLA2P1",
            "SUN1",
            "RLF",
            "DLGAP4",
            "GALK2",
            "NDUFAF1",
            "NOL9",
            "DVL3",
            "B3GALT6",
            "LOC643837",
            "UBE4B",
            "DCLRE1B",
            "IMP3",
            "PIGB",
            "NUDC",
            "NCOA4",
            "CASP2",
            "GNL2",
            "C1orf216",
            "VPS36",
            "MTOR",
            "MTFMT",
            "PANK4",
            "C9orf156",
            "COX15",
            "ICMT",
            "NHEJ1",
            "CAPZB",
            "MFN2",
            "GNB1",
            "DNAJC11",
            "KBTBD2",
            "KIAA2013",
            "EXOSC10",
            "C1orf144",
            "SRRM1",
            "EIF1AD",
            "LRRC47",
            "FBXO42",
            "TARDBP"
        ]
    },
    {
        "golabel": "PHF15_regulon_activity",
        "gene": [
            "XKRX",
            "PCDHGB2",
            "LOC148696",
            "LOC148709",
            "C18orf56",
            "OIP5",
            "FKBP5",
            "LSM1",
            "ITGA3",
            "CIITA",
            "C6orf129",
            "IL6R",
            "GALNT10",
            "MRPL48",
            "PRDX1",
            "TBC1D7",
            "APBA1",
            "FLNA",
            "ACAT2",
            "PTPRE",
            "TMEM173",
            "RANBP1",
            "PTS",
            "PSMG1",
            "SNRPA1",
            "ANKHD1-EIF4EBP3",
            "TRANK1",
            "NFIC",
            "C5orf41",
            "SPRED2",
            "RASA1",
            "MSN",
            "FYCO1",
            "FAM119A",
            "TMEM189",
            "TAF11",
            "PCBD2",
            "FEM1C",
            "SNRPD3",
            "FBXW11",
            "CAST",
            "CDC42SE2",
            "PDPK1",
            "XPC",
            "DMXL1",
            "AFF4",
            "TNIP1",
            "TBC1D9B",
            "CEP120",
            "C1orf131",
            "DIAPH1",
            "KDM3B",
            "WDR55",
            "DDX24",
            "HDAC3",
            "SLC35A4"
        ]
    },
    {
        "golabel": "PHF17_regulon_activity",
        "gene": [
            "PGC",
            "KCNU1",
            "GLTPD2",
            "MYO16",
            "COL25A1",
            "C6orf176",
            "ENO3",
            "BARX1",
            "LOC441177",
            "CRLF1",
            "BMP6",
            "C1orf95",
            "ODC1",
            "PDE3A",
            "FSTL4",
            "PPARGC1A",
            "KIAA1984",
            "LOC100268168",
            "SLC7A2",
            "BHLHA15",
            "LCN12",
            "SECISBP2L",
            "KCNJ8",
            "ATOH8",
            "LGSN",
            "KIT",
            "GEM",
            "GPR110",
            "GPR133",
            "MOSC1",
            "CDH3",
            "TFCP2L1",
            "IRS2",
            "SORBS2",
            "PDE4D",
            "CLEC5A",
            "SIK1",
            "PDE3B",
            "FAM46A",
            "ALOX5AP",
            "ADAM8",
            "PAIP2B",
            "TYROBP",
            "EFCAB2",
            "ZNF330",
            "CSF1",
            "CLEC7A",
            "CDC42EP1",
            "MBOAT2",
            "CSF2RA",
            "FXYD5",
            "LGALS9",
            "CKLF",
            "LIMCH1",
            "NCEH1",
            "DPYD",
            "LAT2",
            "CASP1",
            "ACAT1",
            "VPS37A",
            "FRAT1",
            "TMEM159",
            "OGFRL1",
            "LGALS3",
            "RHOC",
            "GKAP1",
            "ANXA2",
            "IRF5",
            "BID",
            "DAPP1",
            "ARHGEF10",
            "FAAH2",
            "PLSCR1",
            "GNA15",
            "LIMK1",
            "ZCCHC2",
            "CEP70",
            "NUCB2",
            "C13orf23",
            "MAML3",
            "MED13L",
            "CASP4",
            "SPATS2L",
            "TMEM51",
            "BCL10",
            "VAPA",
            "BCL2L1",
            "GIPC1",
            "RGS19",
            "IL10RB",
            "SIRT1",
            "ZNF33A",
            "PLEKHM1",
            "ZNF267",
            "LARP1B",
            "FXR2",
            "EHD4",
            "FEZ2",
            "SUV420H1",
            "PGRMC2",
            "ARPC2"
        ]
    },
    {
        "golabel": "PHF19_regulon_activity",
        "gene": [
            "MGAT5B",
            "MSLN",
            "MFI2",
            "CD70",
            "CD274",
            "LYPD5",
            "CXCL10",
            "PLAU",
            "DCBLD2",
            "IL27",
            "SORBS2",
            "SPHK1",
            "DNM1",
            "ADAM19",
            "GBP1",
            "C9orf109",
            "ATP1B1",
            "GPRC5A",
            "PSMB9",
            "TOB1",
            "TAP1",
            "CNTLN",
            "SLC2A6",
            "MAP7D3",
            "EMP3",
            "ASF1B",
            "MICB",
            "TUBB6",
            "TACC3",
            "NLRC5",
            "NCS1",
            "CCDC109B",
            "HMGB2",
            "MTUS1",
            "BAG1",
            "CDKN2D",
            "PLEKHO1",
            "ERBB3",
            "COTL1",
            "UBE2L6",
            "FAAH2",
            "KIAA1949",
            "MCM5",
            "LNX2",
            "CD46",
            "PIP4K2A",
            "PARP12",
            "CORO1C",
            "SLC25A19",
            "PARN",
            "TMEM41B",
            "DGKZ",
            "C1orf27",
            "CASC4",
            "ACOX1",
            "UBAC1",
            "VPS36",
            "ADIPOR1",
            "DCAF6",
            "GRK6",
            "TMEM39B",
            "COBRA1",
            "REXO4"
        ]
    },
    {
        "golabel": "PHF2_regulon_activity",
        "gene": [
            "NCRNA00092",
            "PROCR",
            "SNX30",
            "BAG2",
            "PTCH1",
            "RASEF",
            "CELSR2",
            "MAST4",
            "ITPKB",
            "GNA14",
            "MRPL13",
            "EMG1",
            "GLA",
            "MRPS15",
            "COMMD8",
            "CORO2A",
            "FAM125B",
            "PSMB3",
            "TOMM22",
            "C20orf24",
            "RNF181",
            "GEMIN6",
            "CCDC88C",
            "RAN",
            "MRPS23",
            "LRIG1",
            "OSTC",
            "ADSL",
            "TNRC6C",
            "NOTCH1",
            "GPN1",
            "SSR3",
            "SMARCA2",
            "TMEM8B",
            "MRPS10",
            "FARP1",
            "PSMC6",
            "CLIC1",
            "ORMDL2",
            "TJP2",
            "POLR2G",
            "MRPL51",
            "PSMA5",
            "MRTO4",
            "SEMA4D",
            "ZMIZ1",
            "PTGES3",
            "NDUFAB1",
            "ASH1L",
            "LOC100129034",
            "PSMA2",
            "ZNF782",
            "METTL5",
            "RXRA",
            "DRG1",
            "PTPDC1",
            "SNRPC",
            "NIP7",
            "ATP5F1",
            "ANKS6",
            "PGAM1",
            "ZNF275",
            "HERC1",
            "NISCH",
            "DDX47",
            "ZBTB8OS",
            "BICD2",
            "PRR13",
            "ZBTB43",
            "SUPT4H1",
            "MRPS7",
            "EBNA1BP2",
            "KIAA0913",
            "PRR12",
            "PARL",
            "GNAQ",
            "VPS25",
            "KIAA2026",
            "ZBTB34",
            "BRD3",
            "C6orf153",
            "KIAA0430",
            "ZNHIT3",
            "EIF3I",
            "SFT2D1",
            "ARHGEF11",
            "PHB",
            "CREBBP",
            "SMC5",
            "ZCCHC6",
            "ABL1",
            "PSMD7",
            "TECPR2",
            "MADD",
            "INVS",
            "ZER1",
            "RABGAP1",
            "ZNF510",
            "FBXW2",
            "EIF2S2",
            "MAML1",
            "SECISBP2",
            "TSTD2",
            "TBC1D20",
            "XPA",
            "STX17"
        ]
    },
    {
        "golabel": "PHF5A_regulon_activity",
        "gene": [
            "RSL24D1",
            "OIP5",
            "CKS2",
            "LONRF2",
            "POLR2F",
            "CDC45",
            "CENPW",
            "MRPL21",
            "RAP1B",
            "C12orf60",
            "CKS1B",
            "KIAA0101",
            "POLB",
            "C13orf27",
            "TIMM8B",
            "SNRPG",
            "RPS29",
            "CHAC2",
            "MRPS12",
            "PPP1R12B",
            "CHCHD2",
            "CENPM",
            "GTF2A2",
            "HAUS1",
            "ACN9",
            "SNRPD2",
            "NSMCE2",
            "SYNE1",
            "UQCRFS1",
            "MRPL13",
            "COX7A2",
            "NBPF10",
            "EMG1",
            "PDCD5",
            "NME1",
            "RPL41",
            "BTBD9",
            "LSM2",
            "PCNA",
            "UQCRHL",
            "HECW2",
            "BID",
            "ANKMY1",
            "TOMM22",
            "RPL35A",
            "DTYMK",
            "NDUFB5",
            "ZNF37B",
            "RANBP1",
            "UBA2",
            "BOLA3",
            "TOMM5",
            "RAN",
            "CCDC58",
            "ATP5G1",
            "C14orf142",
            "UQCRH",
            "AHCY",
            "MRPS23",
            "GLRX3",
            "H2AFZ",
            "SLC25A33",
            "NOP10",
            "PPIAL4C",
            "NDUFA9",
            "ACTL6A",
            "CYCS",
            "PDCD10",
            "TBPL1",
            "RBX1",
            "ATP5L",
            "ADSL",
            "PKD1",
            "MRPL11",
            "C20orf111",
            "PPIH",
            "CCDC59",
            "NUP37",
            "DCUN1D5",
            "MRPS33",
            "C14orf119",
            "COX5A",
            "MPRIP",
            "EIF3K",
            "CDKN2AIPNL",
            "MRPL47",
            "NOTCH1",
            "STOML2",
            "GPN1",
            "WWC3",
            "TPRKB",
            "ATP5G3",
            "MRPL39",
            "BTF3L4",
            "TUBA1B",
            "RRP7A",
            "NDUFB3",
            "ERH",
            "NEDD8",
            "TIMM9",
            "SRPRB",
            "ZMAT5",
            "KIAA1109",
            "TMEM126A",
            "NDUFA6",
            "DPH5",
            "RPL23AP82",
            "POLR2G",
            "DPM1",
            "TMEM218",
            "LSM5",
            "ZNF410",
            "C17orf68",
            "MRPL51",
            "PSMA5",
            "SRRM2",
            "PTGES3",
            "DAD1",
            "ASH1L",
            "LOC100129034",
            "YBX1",
            "UFD1L",
            "FYCO1",
            "PSMB1",
            "NUDCD2",
            "PPIA",
            "C12orf51",
            "MRPS11",
            "PSMB7",
            "PSMA2",
            "METTL5",
            "METTL2A",
            "TRIAP1",
            "SSBP1",
            "OBFC2B",
            "DRG1",
            "C17orf42",
            "SDHD",
            "MLXIP",
            "NIP7",
            "POLE3",
            "ATP5F1",
            "C4orf27",
            "HERC1",
            "RNF7",
            "NISCH",
            "GTPBP8",
            "MRPS22",
            "ZBTB4",
            "MLL3",
            "C12orf41",
            "C1orf212",
            "ATXN7",
            "SUPT4H1",
            "MRPS7",
            "TXNDC12",
            "NCAPH2",
            "MRPL37",
            "SDHB",
            "KIAA0913",
            "TRAPPC3",
            "RABEPK",
            "EIF6",
            "LSM6",
            "SNRPD3",
            "C1orf174",
            "BCAS2",
            "NUMA1",
            "HTT",
            "RPF1",
            "PDCD2",
            "ZNF259",
            "EIF3I",
            "ZNF576",
            "LSM3",
            "EIF3M",
            "CREBBP",
            "HMGXB4",
            "COX4NB",
            "SUMO2",
            "TBC1D9B",
            "MRPS18C",
            "HARBI1",
            "NHP2L1",
            "SRRD",
            "SETD1B",
            "UTP11L",
            "ATP6V1E1",
            "TMEM199",
            "SFRS3",
            "C22orf28",
            "HNRNPC",
            "XRCC6"
        ]
    },
    {
        "golabel": "PHTF2_regulon_activity",
        "gene": [
            "CAPN9",
            "ERN2",
            "DUOX1",
            "DUOXA1",
            "KCND2",
            "SEMA4G",
            "GPR137C",
            "CCNE2",
            "AVPI1",
            "ALDH3B1",
            "ZFPM1",
            "CENPI",
            "CTHRC1",
            "TNFSF4",
            "C19orf21",
            "PDLIM3",
            "SGCE",
            "TMEM38B",
            "FANCB",
            "C15orf52",
            "PLEKHA6",
            "IL1RAP",
            "TMEM26",
            "C7orf60",
            "PAQR3",
            "MMD",
            "TRPC1",
            "MOSC2",
            "FBXO5",
            "PIK3C2B",
            "C1orf106",
            "SEC23A",
            "FRAT1",
            "MXRA7",
            "CHP",
            "OGFRL1",
            "MYO5C",
            "DBF4",
            "TRIM59",
            "C4orf46",
            "GUCY1B3",
            "IVD",
            "HSPA13",
            "HLTF",
            "INF2",
            "NBEAL2",
            "DCK",
            "C6orf132",
            "C5orf28",
            "MCM6",
            "RHEB",
            "SAP30",
            "GPR180",
            "ELMO3",
            "CNN3",
            "C6orf182",
            "TMC4",
            "CALU",
            "TWSG1",
            "C9orf167",
            "TMEM206",
            "TPST1",
            "DSN1",
            "SKA2",
            "FAM49B",
            "MANEA",
            "ZNF92",
            "SLC25A40",
            "PNPLA2",
            "CCDC126",
            "CES2",
            "TRIM8",
            "ABHD14B",
            "RAD1",
            "MGAT2",
            "TUBD1",
            "KLHL7",
            "BCAP29",
            "KIAA0664",
            "PSMC2",
            "NRAS",
            "RAP2A",
            "FBXW4",
            "OSTM1",
            "KIAA0649",
            "SGTB",
            "KIF1C",
            "RINT1",
            "FAM129B",
            "C7orf70",
            "LRRC40",
            "C1orf96",
            "ZNF555",
            "ME2",
            "SCAMP2",
            "TMEM60",
            "EIF3CL",
            "RAP2C",
            "MAP2K3",
            "RNPEP",
            "WWP2",
            "SEC22A",
            "HCFC2",
            "ATG4A",
            "TCF25",
            "EXOC5",
            "STAT6",
            "PRPS1",
            "DNAJB6",
            "DNAJB2",
            "SRPK2",
            "STYX",
            "MYO1C",
            "H2AFV",
            "FLII",
            "ERCC5",
            "IRAK4",
            "SPG11",
            "RUFY1",
            "UNC45A",
            "HNRPLL",
            "DIS3L2",
            "CDK9",
            "CTDSP1"
        ]
    },
    {
        "golabel": "PIKFYVE_regulon_activity",
        "gene": [
            "ASB1",
            "RPLP1",
            "PAR5",
            "IKZF3",
            "RPL35",
            "C12orf57",
            "NUDT8",
            "RHOD",
            "ROMO1",
            "RPL36",
            "NBEAL1",
            "RGPD5",
            "UQCRQ",
            "MIF",
            "ZDBF2",
            "GSTZ1",
            "LSMD1",
            "NBPF10",
            "RPL29",
            "PGAP1",
            "MRPL41",
            "OCIAD2",
            "NDUFA11",
            "BUD31",
            "RPL13",
            "C12orf35",
            "ZNHIT1",
            "MRPL14",
            "NQO2",
            "CIB1",
            "RPL38",
            "POP7",
            "NDUFB7",
            "MPDZ",
            "ZNF593",
            "ANAPC11",
            "ATP8B2",
            "C6orf108",
            "FIS1",
            "TRAPPC5",
            "GADD45GIP1",
            "MDN1",
            "UQCR11",
            "RAD54L2",
            "ALKBH7",
            "CEP192",
            "TCEB2",
            "MRPS24",
            "FMNL2",
            "ILVBL",
            "APRT",
            "MYO9A",
            "TTBK2",
            "NDUFA7",
            "FAU",
            "MYSM1",
            "UQCR10",
            "PRDX2",
            "STAP2",
            "DMXL2",
            "C19orf70",
            "ROCK2",
            "NDUFB2",
            "SPR",
            "NDUFS8",
            "C19orf53",
            "TMEM187",
            "KIAA1632",
            "C20orf194",
            "SMCHD1",
            "SHPRH",
            "DPCD",
            "DDHD1",
            "POLR2J",
            "RIF1",
            "C19orf24",
            "FAM100B",
            "MACF1",
            "LSM4",
            "PLEKHM3",
            "C17orf106",
            "PHLPP2",
            "SYNGR2",
            "POLD4",
            "REV3L",
            "RASA2",
            "TET3",
            "ETFB",
            "ZMAT5",
            "KIAA1109",
            "CBL",
            "ARF5",
            "DPY19L3",
            "NR2C2AP",
            "ZDHHC12",
            "TXN2",
            "TMEM134",
            "BSG",
            "ASNA1",
            "SSNA1",
            "CEP110",
            "OVCA2",
            "CISD3",
            "TAGLN2",
            "YIF1A",
            "MYCBP2",
            "AKAP9",
            "NCOA1",
            "COX8A",
            "TMEM101",
            "TMEM179B",
            "C12orf10",
            "CEP135",
            "SMG1",
            "MRPL17",
            "COPE",
            "PRELID1",
            "RFXANK",
            "ANKRD12",
            "YIPF2",
            "UBA52",
            "NIN",
            "C11orf10",
            "RGPD3",
            "EDF1",
            "C11orf59",
            "VPS13B",
            "HERC1",
            "ARID4A",
            "ATM",
            "FAM126B",
            "ZNF417",
            "ZNF81",
            "ZC3H13",
            "SSH2",
            "ARL6IP4",
            "TAF10",
            "ATG2B",
            "ROCK1",
            "TRAK2",
            "ZZEF1",
            "TMED1",
            "BDP1",
            "DICER1",
            "TMEM11",
            "MLL",
            "TEX264",
            "ATAD2B",
            "EIF6",
            "XRN1",
            "NR2C2",
            "BOD1L",
            "ESCO1",
            "SYNRG",
            "KIAA0355",
            "MGA",
            "ZDHHC4",
            "BAZ2B",
            "ZNF225",
            "TET2",
            "KIAA2018",
            "BCAP31",
            "PCNX",
            "CLPP",
            "MTR",
            "CLTA",
            "FADD",
            "ANUBL1",
            "PPP1CA",
            "RGPD4",
            "AKAP11",
            "BPTF",
            "ABI2",
            "PRDM10",
            "ITSN2",
            "RNF38",
            "INPP4A",
            "AAK1",
            "TMEM131",
            "KIDINS220",
            "BMPR2",
            "SEC13",
            "COPS7A",
            "RANBP2",
            "C19orf43",
            "BIRC6",
            "STK4",
            "ALS2",
            "PIK3C2A",
            "AP4E1",
            "C19orf56",
            "SETX",
            "HEATR5B",
            "TRAPPC10",
            "SOS1",
            "ARF1",
            "CLASP1",
            "GPATCH8",
            "USP34",
            "SFRS2IP",
            "TNKS2",
            "GIGYF2",
            "RAB1B",
            "CREB1",
            "SF3B1"
        ]
    },
    {
        "golabel": "PIN1_regulon_activity",
        "gene": [
            "SLC27A5",
            "LIN7B",
            "RPL18A",
            "RPL36",
            "C7orf59",
            "LOC100128822",
            "MRPL54",
            "C19orf20",
            "KHK",
            "MRPL41",
            "NDUFA11",
            "CD320",
            "TMEM160",
            "RPS15",
            "CDKN2D",
            "MDP1",
            "NDUFA13",
            "SDHAF1",
            "NDUFB7",
            "LSM7",
            "UBL5",
            "PEX11G",
            "TRAPPC5",
            "GADD45GIP1",
            "ATP5D",
            "C19orf60",
            "UQCR11",
            "NRL",
            "ALKBH7",
            "ICAM3",
            "MRPL34",
            "ILVBL",
            "NDUFA7",
            "PTRH1",
            "CLIP1",
            "C19orf70",
            "CHCHD6",
            "GPX4",
            "ROCK2",
            "NOSIP",
            "C9orf16",
            "C19orf53",
            "B9D2",
            "LOC147727",
            "ZNF688",
            "CD2AP",
            "SLK",
            "GIPC1",
            "ASNA1",
            "FBXW9",
            "FDX1L",
            "FAM98C",
            "JOSD2",
            "DCTN3",
            "TMEM205",
            "TFPT",
            "TIMM13",
            "ZNF414",
            "C19orf25",
            "RSF1",
            "COPE",
            "RFXANK",
            "RNASEH2C",
            "USE1",
            "YIPF2",
            "UBA52",
            "ECSIT",
            "STX10",
            "BAD",
            "PLEKHJ1",
            "AIP",
            "MRPL4",
            "MPV17L2",
            "ATP2A2",
            "MPND",
            "FAM125A",
            "ARL6IP4",
            "DOK1",
            "SNAPC2",
            "TMED1",
            "NDUFS7",
            "UGGT1",
            "LOC729991",
            "JRKL",
            "OAZ1",
            "SIRT6",
            "MARCH2",
            "SLC2A8",
            "TJP1",
            "BOD1L",
            "FAM108A1",
            "PTPN11",
            "DCAF10",
            "RRAGB",
            "CLPP",
            "AES",
            "TIMM44",
            "GCDH",
            "WDR83",
            "BPTF",
            "TRIM33",
            "BAT2L2",
            "DHPS",
            "APBA3",
            "ANKRD17",
            "EIF3G",
            "C19orf62",
            "C19orf43",
            "SLC39A3",
            "ELOF1",
            "FARSA",
            "BIRC6",
            "PDS5A",
            "C19orf56",
            "BAT4",
            "GPR108",
            "SOS1",
            "DNASE2",
            "ZC3HAV1",
            "UBXN6",
            "C19orf52",
            "AP1G1",
            "SEC31A",
            "C19orf50",
            "FBXL12",
            "DDX6",
            "PUM1"
        ]
    },
    {
        "golabel": "PIR_regulon_activity",
        "gene": [
            "NECAB2",
            "GSTA1",
            "ALDH3A1",
            "LRP1B",
            "GUCY2E",
            "NR0B1",
            "ALDH1A1",
            "ABCC2",
            "CES1",
            "CBR1",
            "AKR1C1",
            "CHODL",
            "AKR1C3",
            "KIAA0319",
            "NRG4",
            "GPX2",
            "CABYR",
            "JAKMIP3",
            "UCHL1",
            "PKD1L2",
            "BHMT2",
            "TRIM16L",
            "OSGIN1",
            "TPTE2P1",
            "TSPAN7",
            "EPHX1",
            "WIPF3",
            "NMB",
            "G6PD",
            "TPD52L1",
            "ME1",
            "PANX2",
            "PGD",
            "PFN2",
            "ALDH3A2",
            "DGKG",
            "CHST3",
            "ATP10A",
            "ABCB6",
            "FLJ35776",
            "AGA",
            "KRTCAP3",
            "ICAM1",
            "C10orf75",
            "ITGA3",
            "SQSTM1",
            "SAMD4A",
            "CLYBL",
            "FCGR2A",
            "LIPT2",
            "PRDX1",
            "C1orf97",
            "NUDT7",
            "GSTP1",
            "MICAL2",
            "PEMT",
            "TMEM116",
            "ANTXR2",
            "FLNA",
            "BRP44",
            "TMEM17",
            "C1orf57",
            "FECH",
            "ACOT13",
            "SPRED1",
            "ATP5G1",
            "DUSP7",
            "TKT",
            "HTATIP2",
            "OVOL2",
            "LOC100125556",
            "KIAA1598",
            "GCNT2",
            "RIT1",
            "FAM36A",
            "ERP29",
            "ABHD4",
            "TTLL11",
            "PIGP",
            "ASF1A",
            "APOO",
            "RCCD1",
            "APITD1",
            "PSMA3",
            "TGFB1",
            "NIT2",
            "SOD1",
            "SLC3A2",
            "RHBDD3",
            "HDDC2",
            "TBCE",
            "C10orf57",
            "EHD1",
            "SPRYD4",
            "MMAB",
            "NDUFAF4",
            "SFXN3",
            "SLC48A1",
            "ZBTB47",
            "TYSND1",
            "PRDX6",
            "FNBP1",
            "PPARD",
            "LRRC28",
            "COQ9",
            "CUTC",
            "RUNX1",
            "C14orf1",
            "SNAPC2",
            "E2F6",
            "PCCB",
            "TMEM43",
            "MOBKL2A",
            "GOT2",
            "GNAI2",
            "PGAP2",
            "RBBP7",
            "EHD4",
            "COX15",
            "ZNF197",
            "USP4"
        ]
    },
    {
        "golabel": "PLEK2_regulon_activity",
        "gene": [
            "ARL14",
            "LOC100216001",
            "PRSS3",
            "RPSAP52",
            "IL1R2",
            "MYEOV",
            "LOC554202",
            "CLCA3P",
            "GJB5",
            "TNS4",
            "MFI2",
            "FOSL1",
            "CDA",
            "GJB3",
            "LAMC2",
            "GPR87",
            "TGFBI",
            "TRIM7",
            "GPR115",
            "TMEM171",
            "ARNTL2",
            "NGEF",
            "LGALS1",
            "SH3RF2",
            "CAMK2N1",
            "LETM2",
            "GPR133",
            "SLC2A1",
            "LPCAT4",
            "BIK",
            "SEC14L2",
            "PMEPA1",
            "AK3L1",
            "B3GNT3",
            "ITGB4",
            "DLC1",
            "ANXA3",
            "ERO1L",
            "ANXA2P1",
            "LAMB3",
            "KRT19",
            "S100A16",
            "CDCP1",
            "MMP14",
            "GSTO1",
            "C9orf45",
            "CKLF",
            "UNC13B",
            "SMAGP",
            "TIMP1",
            "TMSB10",
            "S100A10",
            "TUBA4A",
            "OCIAD2",
            "ACTN1",
            "ANXA2P2",
            "SH3BGRL3",
            "PPP1R9A",
            "EFHD2",
            "RHOC",
            "TMEM170B",
            "ANXA2",
            "PNP",
            "LDHA",
            "LIMD1",
            "CDKN1A",
            "SFXN2",
            "S100A11",
            "LOC100130093",
            "KIAA0182",
            "PLIN3",
            "SNX7",
            "SPATS2L",
            "MYLIP",
            "TMEM51",
            "UCHL3",
            "TUBA1B",
            "CHD6",
            "FAM100B",
            "CLIC1",
            "SLC46A1",
            "PKM2",
            "VASP",
            "ARPC3",
            "UBN2",
            "ANXA5",
            "ZNF248",
            "RTN4",
            "DNAJC27",
            "RALA",
            "PHC2",
            "FADD",
            "RAC1",
            "AP2M1",
            "CNST",
            "CAP1",
            "YWHAH",
            "ATP6V1D",
            "VTI1B"
        ]
    },
    {
        "golabel": "PLXNA1_regulon_activity",
        "gene": [
            "MFI2",
            "LAMC2",
            "FHOD3",
            "PLAU",
            "PCDH7",
            "DCBLD2",
            "AFAP1L2",
            "FSCN1",
            "C10orf55",
            "EPHB2",
            "PVRL1",
            "C9orf109",
            "COL6A1",
            "AGA",
            "C9orf110",
            "GPC1",
            "CDCP1",
            "MMP14",
            "FBXO41",
            "PLEC",
            "HSD17B8",
            "RPL26",
            "NDUFB1",
            "ADI1",
            "MICAL3",
            "NCS1",
            "FBXO16",
            "BMP1",
            "PLEKHG3",
            "IER3IP1",
            "RPL5",
            "DLEU1",
            "ACAT1",
            "ACTN1",
            "PLXNA3",
            "NDUFA4",
            "IDI1",
            "C11orf1",
            "TTYH3",
            "IRF5",
            "FLNA",
            "BRP44",
            "ELL3",
            "AGRN",
            "RANGRF",
            "COMMD10",
            "C1orf57",
            "C14orf126",
            "MCEE",
            "ECE1",
            "DUSP7",
            "LOC442454",
            "KIAA1949",
            "NUMBL",
            "LIMK1",
            "ALG5",
            "FOXK1",
            "C18orf32",
            "RHBDF2",
            "MICALL1",
            "C1orf203",
            "ORAI2",
            "FAM36A",
            "FAM38A",
            "AHDC1",
            "PIGP",
            "ACOT1",
            "PML",
            "SBNO2",
            "YEATS2",
            "LYPLAL1",
            "C1orf43",
            "SLC25A4",
            "MRPS36",
            "NACC2",
            "C22orf32",
            "PXN",
            "C15orf61",
            "KLHDC2",
            "ZMIZ2",
            "POLR2C",
            "WDR61",
            "UQCRB",
            "RPAIN",
            "EHD1",
            "HADH",
            "ELF4",
            "MPDU1",
            "SSR2",
            "RAP2B",
            "LUZP1",
            "NCRNA00081",
            "GNA12",
            "SH3BP2",
            "ZYX",
            "TOMM20",
            "MRPS18B",
            "PPA2",
            "TSNAX",
            "RAB43",
            "EHBP1L1",
            "FAM8A1",
            "GABARAPL2",
            "SDHC",
            "HIBCH",
            "ZCCHC10",
            "SRP9",
            "CLSTN1",
            "PPARD",
            "BPNT1",
            "COX11",
            "SUCLG1",
            "TFB2M",
            "NSL1",
            "GLT25D1",
            "RPS6KA4",
            "MAP7D1",
            "PNPLA6",
            "SSH1",
            "TATDN3",
            "PIGH",
            "LGTN",
            "ZNFX1",
            "DLGAP4",
            "UFC1",
            "DGKZ",
            "MYO9B",
            "CCDC90A",
            "DVL3",
            "C1orf27",
            "SPCS2",
            "TTC7A",
            "ARHGEF18",
            "TADA1",
            "SEC11A",
            "MRPS14",
            "HDAC7",
            "GMPR2",
            "TMCO1",
            "SAPS1",
            "LOC653566",
            "PCNXL3",
            "IKZF5",
            "LEPROTL1",
            "NDUFA5",
            "CSK",
            "RAB4A",
            "CSNK1G2",
            "SPTAN1",
            "ARMCX5",
            "GGPS1",
            "GATAD2A",
            "AP2A1",
            "TSG101",
            "GNPAT",
            "PDHB",
            "XPO6",
            "PLEKHM2"
        ]
    },
    {
        "golabel": "PLXNA3_regulon_activity",
        "gene": [
            "DMBX1",
            "FER1L4",
            "ATG9B",
            "PPFIA4",
            "HSPA7",
            "ARHGAP33",
            "FSCN2",
            "PLXNB3",
            "FAM71F2",
            "C19orf26",
            "SLC6A8",
            "PFKFB4",
            "LOC100131434",
            "LOC100272228",
            "KIFC2",
            "EME2",
            "C7orf53",
            "TMEM184A",
            "TBC1D3B",
            "EEF1B2",
            "LOC91316",
            "ATG16L2",
            "LOC100128842",
            "ENO2",
            "LOC349114",
            "MAPK8IP3",
            "LOC90834",
            "C1orf113",
            "VEGFA",
            "MICALL2",
            "FBXO41",
            "SLFN13",
            "PILRB",
            "LENG8",
            "WDR27",
            "TPT1",
            "ANKRD23",
            "ARHGAP4",
            "INE1",
            "DLEU1",
            "KLHL17",
            "ANO8",
            "TRIO",
            "RPL10A",
            "DMPK",
            "PLXNA1",
            "CREG1",
            "PECI",
            "FLJ45340",
            "TBC1D3",
            "LPIN3",
            "CDC42BPG",
            "C14orf142",
            "GIGYF1",
            "LYRM4",
            "ACAP3",
            "C1QBP",
            "ALG5",
            "ABCD1",
            "N6AMT2",
            "MAST2",
            "FAM165B",
            "RELT",
            "C19orf55",
            "CCM2",
            "USP35",
            "TECPR1",
            "KIAA0467",
            "FAM50A",
            "F8A1",
            "ZNF341",
            "C1orf159",
            "BCORL1",
            "ZMIZ2",
            "KIAA0415",
            "SLC12A9",
            "FAM127A",
            "HEATR7A",
            "BFAR",
            "PCBP4",
            "TPCN1",
            "C1orf91",
            "IRAK1",
            "C7orf43",
            "SPHAR",
            "SH3BP2",
            "FAM160B2",
            "C17orf48",
            "PAPD7",
            "TOMM20",
            "TSNAX",
            "EHBP1L1",
            "ZNF449",
            "GTF2IRD1",
            "IKBKG",
            "ANKRD13D",
            "SDHC",
            "ZCCHC10",
            "PPARD",
            "KIAA1539",
            "PPP2R5B",
            "ANAPC16",
            "TATDN3",
            "PLCB3",
            "GDI1",
            "SIN3B",
            "MRPS27",
            "C9orf25",
            "C20orf30",
            "DLGAP4",
            "MOV10",
            "COPS2",
            "AGAP3",
            "MMADHC",
            "ALDH9A1",
            "C17orf70",
            "YWHAE",
            "TRIM13",
            "IGHMBP2",
            "POM121",
            "VPS36",
            "KDM4B",
            "NCKIPSD",
            "ZNF282",
            "MECP2",
            "ESD",
            "MED22",
            "MOGS",
            "EIF3F",
            "NHEJ1",
            "HMGXB3",
            "COPS7B",
            "EXOC7",
            "CSNK1D"
        ]
    },
    {
        "golabel": "PLXNB1_regulon_activity",
        "gene": [
            "C9orf117",
            "DLEC1",
            "TSNAXIP1",
            "DNAH7",
            "TEKT2",
            "SPAG8",
            "C3orf15",
            "FGFR3",
            "GPR162",
            "TNFRSF9",
            "KIF12",
            "LOC644165",
            "CACNA1D",
            "TTC21A",
            "RPL39L",
            "NRADDP",
            "ZNF662",
            "ERO1L",
            "EFHC1",
            "CCDC30",
            "LOC80154",
            "DNALI1",
            "OBSL1",
            "STK33",
            "ICA1L",
            "TMED7-TICAM2",
            "SNX10",
            "TMEM38B",
            "C15orf62",
            "LOC388152",
            "ARVCF",
            "PAQR3",
            "MICB",
            "ZNF321",
            "RGS10",
            "MDFIC",
            "TBC1D8",
            "IFT140",
            "ZNF219",
            "IFT172",
            "C20orf12",
            "STK17A",
            "P4HA1",
            "PGK1",
            "HPRT1",
            "NBEAL2",
            "MZF1",
            "RALGPS1",
            "RPGR",
            "KIF9",
            "VBP1",
            "IKBIP",
            "CALU",
            "PHC1",
            "CDK20",
            "LLGL2",
            "KLC4",
            "ATL3",
            "SETD4",
            "RCN1",
            "LAMP2",
            "TNRC18",
            "C9orf21",
            "PDE8A",
            "TRAK1",
            "WDR19",
            "HDAC11",
            "C16orf63",
            "BCL6",
            "CCT4",
            "SFT2D2",
            "BCAP29",
            "ADCY6",
            "SLC25A43",
            "PSMC2",
            "PANX1",
            "P4HTM",
            "NISCH",
            "ZNF33A",
            "UPF3A",
            "RBM5",
            "UBE2D1",
            "PDDC1",
            "LSM6",
            "TIPRL",
            "PEA15",
            "EIF2S1",
            "RNF115",
            "VMA21",
            "PRPS1",
            "VAMP7",
            "ACTR3",
            "WDR6",
            "DEGS1",
            "PCMT1",
            "STYX",
            "C4orf43",
            "BRD1",
            "TPM3",
            "POLR3C",
            "SCAND2",
            "QARS",
            "RNF123",
            "SCAP",
            "PTPN23",
            "TMEM115",
            "OGFOD1",
            "USP19",
            "RBM15B",
            "DHX30",
            "BAP1",
            "GORASP1"
        ]
    },
    {
        "golabel": "PLXNB2_regulon_activity",
        "gene": [
            "C11orf9",
            "TRPV4",
            "DOK7",
            "ZBTB7C",
            "B4GALNT3",
            "ITGB4",
            "EPHA2",
            "CKS1B",
            "WNT7B",
            "MEGF6",
            "C1orf126",
            "SIDT1",
            "E2F5",
            "CDC42EP1",
            "SYTL2",
            "COBL",
            "PTPRU",
            "MST1R",
            "EVPL",
            "RTN4R",
            "KIF13B",
            "SYTL4",
            "GSN",
            "C8orf59",
            "CD82",
            "MRPL13",
            "PFDN4",
            "TMEM70",
            "PPL",
            "SLC9A1",
            "TCEB1",
            "FAM116B",
            "AGRN",
            "C14orf126",
            "HSPG2",
            "TOMM5",
            "RAN",
            "CDC42BPG",
            "CREM",
            "C1QBP",
            "POLR2K",
            "HSPE1",
            "HAX1",
            "NUDCD1",
            "AHDC1",
            "CCDC59",
            "ASF1A",
            "DCAF13",
            "ARMC1",
            "C12orf29",
            "C12orf73",
            "MRPL42",
            "GTPBP4",
            "WDR12",
            "MEMO1",
            "PNPT1",
            "PACSIN2",
            "CACYBP",
            "NDUFAF4",
            "UBE2V2",
            "ATP5C1",
            "CXXC5",
            "DDR1",
            "NUP35",
            "SLC12A4",
            "SNRPE",
            "INTS8",
            "BCR",
            "GPN3",
            "ILF2",
            "ACTR6",
            "KIAA0556",
            "FASTKD1",
            "RARA",
            "UBE2N",
            "LMF2",
            "TRIOBP",
            "DGCR2",
            "MED15",
            "PLEKHM1",
            "ZCCHC7",
            "C12orf65",
            "SLC25A32",
            "ZBTB7A",
            "NLRX1",
            "SEPT9",
            "PPP1CC",
            "BRD1",
            "PRKRA",
            "TBC1D22A",
            "HNRNPC",
            "ARHGAP1",
            "AP1B1",
            "ANXA7"
        ]
    },
    {
        "golabel": "PLXNB3_regulon_activity",
        "gene": [
            "KISS1R",
            "TMEM88B",
            "EEF1A2",
            "SPTB",
            "MYO1G",
            "RGS11",
            "BEAN",
            "SRPK3",
            "DIRAS1",
            "TNFRSF18",
            "SPTBN5",
            "PDZD7",
            "REEP6",
            "SNX21",
            "UNC5CL",
            "C8orf73",
            "C1orf170",
            "ASAP2",
            "RHPN1",
            "ATP2B1",
            "PLEKHN1",
            "EPHA10",
            "PHLDA2",
            "ITGA3",
            "GRID2IP",
            "VEGFA",
            "ABCB9",
            "MICALL2",
            "SDC1",
            "PLXNA3",
            "EPHA1",
            "ZDHHC9",
            "FADS3",
            "CDC42BPG",
            "LIMK1",
            "FLJ35390",
            "CLDN4",
            "TBKBP1",
            "AHDC1",
            "ASF1A",
            "TMEM63A",
            "PARP10",
            "C4orf32",
            "PAK6",
            "KIAA0284",
            "HDDC2",
            "TMC6",
            "SLC12A9",
            "SEMA4C",
            "LRCH4",
            "SNX3",
            "QRSL1",
            "PRKRIR",
            "PIAS3",
            "LOC729082",
            "LRRC28",
            "PDSS2",
            "TBC1D10A",
            "RUNX1",
            "RWDD1",
            "XYLT2",
            "MIER2",
            "CC2D1A",
            "PDCD2",
            "VTA1",
            "UHRF1BP1L",
            "C6orf35",
            "EIF1B",
            "FEM1B",
            "NUS1",
            "CSNK1D"
        ]
    },
    {
        "golabel": "PLXNC1_regulon_activity",
        "gene": [
            "ADAMTS12",
            "ROR1",
            "CYSLTR2",
            "KAL1",
            "COL8A1",
            "ABCB6",
            "TNFSF8",
            "PTAFR",
            "P2RX7",
            "EFCAB4A",
            "CD84",
            "C9orf110",
            "KRTCAP3",
            "ARL10",
            "MAN1A1",
            "PIK3CG",
            "NFATC2",
            "SPIRE2",
            "MARCH1",
            "CYP7B1",
            "NUDT8",
            "MFSD3",
            "FPR3",
            "DOCK11",
            "CD28",
            "FLJ39653",
            "ASPSCR1",
            "ANKRD44",
            "RAB30",
            "ZNF699",
            "BDH1",
            "C6orf204",
            "HSBP1L1",
            "GSTP1",
            "SLFN11",
            "C6orf125",
            "SAMHD1",
            "ELK3",
            "MGC70857",
            "PACSIN3",
            "ZEB2",
            "ECH1",
            "BMP2K",
            "GALE",
            "GOLIM4",
            "SLC4A7",
            "NOTCH2",
            "MERTK",
            "NR2F6",
            "MRPL23",
            "RCCD1",
            "LIMS1",
            "GPR137B",
            "ATP11C",
            "APITD1",
            "LNPEP",
            "SLC36A1",
            "MYO5A",
            "C6orf136",
            "PCYT2",
            "MANEA",
            "HRAS",
            "MFSD10",
            "SEL1L",
            "C14orf79",
            "SLC9A6",
            "NT5C",
            "PIP4K2A",
            "C18orf22",
            "C11orf49",
            "PXK",
            "BACH1",
            "ESRRA",
            "LOC284441",
            "DHODH",
            "PDF",
            "PRKD3",
            "LATS1",
            "NIN",
            "TBC1D9",
            "C1orf35",
            "MOSPD2",
            "SIRT5",
            "COQ9",
            "ARSB",
            "WIBG",
            "TAOK3",
            "KIAA1432",
            "SETD6",
            "FAM86C",
            "TBCEL",
            "C14orf1",
            "NACAP1",
            "ANO6",
            "ACER3",
            "YPEL2",
            "SPATA5L1",
            "TRAP1",
            "CCDC90A",
            "NFKBIL1",
            "HCFC2",
            "AARSD1",
            "GNPTAB",
            "PDHA1",
            "PTOV1",
            "C21orf59",
            "GOT2",
            "MCAT",
            "TUFM",
            "NDUFV1",
            "FCHSD2",
            "GNA13",
            "PGAP2",
            "OSBPL11",
            "DENND5A",
            "GTF2F2",
            "NOP58",
            "MRPS9",
            "THAP4",
            "BCS1L",
            "SNRPA",
            "NFS1",
            "TMEM110",
            "PPP2R1A",
            "RDH14"
        ]
    },
    {
        "golabel": "PML_regulon_activity",
        "gene": [
            "C1orf95",
            "COL17A1",
            "MFI2",
            "FOSL1",
            "SLC7A2",
            "GJB3",
            "SEMA7A",
            "ERO1LB",
            "NGEF",
            "PLAU",
            "BIRC3",
            "SH3RF2",
            "CXXC4",
            "CAMK2N1",
            "IFI44L",
            "PDLIM4",
            "HCG4",
            "CDH3",
            "AFAP1L2",
            "NBEA",
            "IFI44",
            "ITGB4",
            "MX1",
            "EFNB1",
            "TTC39C",
            "ABCC4",
            "ALDH3A2",
            "ATP10A",
            "INSL3",
            "ADAM8",
            "RTP4",
            "PAIP2B",
            "FOXA1",
            "IL18R1",
            "SAMD9",
            "IFIT2",
            "GYLTL1B",
            "XAF1",
            "CARD11",
            "OAT",
            "CDCP1",
            "C17orf60",
            "E2F5",
            "LPAR5",
            "OAS2",
            "LAPTM4B",
            "ITGA3",
            "SAMD9L",
            "PRKCDBP",
            "PANK1",
            "RIN1",
            "GYG2",
            "IMPA2",
            "FZD3",
            "ETV7",
            "IFI16",
            "LGALS9",
            "HLA-F",
            "EMP3",
            "FAS",
            "UNC13B",
            "OAF",
            "MST1R",
            "CIITA",
            "APOL3",
            "CLTB",
            "SYTL4",
            "CD74",
            "PLEC",
            "GBP2",
            "SLC15A3",
            "CARD16",
            "CDC42EP2",
            "HLA-B",
            "ACAT1",
            "PTRF",
            "DGKA",
            "SELPLG",
            "PLXNA1",
            "KCNK6",
            "IL15RA",
            "DDX60L",
            "ANXA2P2",
            "SH3BGRL3",
            "EFHD2",
            "SOCS7",
            "IDI1",
            "GKAP1",
            "EPB41L5",
            "TAP2",
            "TMEM170B",
            "RAC2",
            "CD97",
            "ANXA2",
            "DHX58",
            "FLNA",
            "APOL2",
            "ARRB1",
            "CMTM1",
            "DTX2",
            "FECH",
            "CAPG",
            "CDKN1A",
            "LRRC8A",
            "MPP7",
            "RAB40B",
            "DUSP7",
            "KIAA1949",
            "STAU2",
            "SLC19A2",
            "OSBPL3",
            "STOML1",
            "APOA1BP",
            "SH3KBP1",
            "INPP1",
            "C18orf45",
            "RHBDF2",
            "FAM102A",
            "APOBEC3C",
            "HSD17B7",
            "RIT1",
            "PRKAB1",
            "HOOK1",
            "L2HGDH",
            "TRIM24",
            "UBA7",
            "PLIN3",
            "LYSMD1",
            "ZNF124",
            "PXN",
            "STK10",
            "TPM4",
            "RIN3",
            "TRIM14",
            "NARS2",
            "TH1L",
            "EHD1",
            "ELF4",
            "BCL2L1",
            "TRIM37",
            "RAP2B",
            "HSDL1",
            "ZYX",
            "TICAM1",
            "TSNAX",
            "CCDC121",
            "ACADM",
            "SRP9",
            "PPARD",
            "TFB2M",
            "FNBP1L",
            "CRY1",
            "RPS6KA4",
            "TRIP10",
            "PARP3",
            "PIGM",
            "MAP7D1",
            "SIRT1",
            "MBTD1",
            "PRUNE",
            "IL4R",
            "CD276",
            "ZNFX1",
            "GMCL1",
            "WDSUB1",
            "PPPDE1",
            "C1orf26",
            "PIGN",
            "PAPOLA",
            "ZBTB41",
            "MUT",
            "SH3GL1",
            "AP2M1",
            "CNST",
            "GNAI2",
            "TNIP1",
            "SP100",
            "CSK",
            "RHOG",
            "MYD88",
            "EHD4",
            "CDC37",
            "SUV420H1",
            "THAP9",
            "PRKRA",
            "SHISA5",
            "RHOT1",
            "C1orf124",
            "NUP133",
            "TROVE2",
            "RAB8A",
            "MAX"
        ]
    },
    {
        "golabel": "PNRC2_regulon_activity",
        "gene": [
            "KIAA0408",
            "CLUL1",
            "FAM83A",
            "TNNC1",
            "IFT57",
            "PFKP",
            "C21orf91",
            "IL28RA",
            "ZNF708",
            "CDC14A",
            "NOTCH3",
            "SESN1",
            "PARD6B",
            "FUCA1",
            "DDAH1",
            "CHPF",
            "MAP3K10",
            "ZNF680",
            "PKP3",
            "KPNA5",
            "CTNNBIP1",
            "SBNO2",
            "CD47",
            "HSPC157",
            "ZNF709",
            "THOP1",
            "BAG3",
            "KLF16",
            "ZNF14",
            "RPL11",
            "HMGN2",
            "PUS10",
            "ABCD3",
            "PDIK1L",
            "EFCAB7",
            "CAMTA1",
            "CDC42",
            "LZTFL1",
            "HMGCL",
            "SLC27A4",
            "NACC1",
            "C19orf22",
            "MYCBP",
            "MEAF6",
            "NMNAT1",
            "RPA2",
            "ZMYM1",
            "LONP1",
            "MIER1",
            "LYRM2",
            "TCEB3",
            "RBBP4",
            "NCLN",
            "RAP1A",
            "SNX14",
            "RPL22",
            "FAM76A",
            "RSBN1",
            "DNAJC8",
            "GABPA",
            "KLRAQ1",
            "CEP57",
            "FAM54B",
            "TMEM50A",
            "SEC61A1",
            "HELQ",
            "STX12",
            "SNIP1",
            "ZMYM6",
            "SYF2",
            "EPS15",
            "SFRS13A"
        ]
    },
    {
        "golabel": "POGZ_regulon_activity",
        "gene": [
            "LGSN",
            "VSIG4",
            "SEMA6C",
            "HCN3",
            "NBPF16",
            "BCL2A1",
            "KSR1",
            "LOC374443",
            "LY6E",
            "PNN",
            "RAP1GAP2",
            "CD14",
            "FCER1G",
            "CKLF",
            "HAVCR2",
            "CGN",
            "MCM3APAS",
            "FLJ42627",
            "CTSC",
            "MYEF2",
            "RHOC",
            "CLK2P",
            "ANXA2",
            "UBE2L6",
            "LOC200030",
            "GNA15",
            "STARD3NL",
            "ZNF594",
            "CBFA2T2",
            "STOML1",
            "DNMT3A",
            "PNPLA4",
            "PRKAB2",
            "KIAA0182",
            "MAPKAPK3",
            "GLTSCR1",
            "INPPL1",
            "ZNF236",
            "TET3",
            "SETDB1",
            "RPL23AP82",
            "PKM2",
            "GYG1",
            "SNX3",
            "KIAA0649",
            "MLL2",
            "MLL4",
            "KDM6B",
            "UBN2",
            "ZNF8",
            "AMFR",
            "ZNF193",
            "CLK2",
            "INTS3",
            "IRGQ",
            "DENND4B",
            "MBTD1",
            "GON4L",
            "ZNF445",
            "GATAD2B",
            "NPTN",
            "HEBP1",
            "SETD5",
            "RBM12B",
            "ATXN2",
            "BRD1",
            "TUG1",
            "ZC3H11A",
            "SUV420H1",
            "C4orf3",
            "ARPC2",
            "SARS",
            "ZNF638",
            "FAM193A"
        ]
    },
    {
        "golabel": "POLE3_regulon_activity",
        "gene": [
            "MYO15B",
            "CKS2",
            "CDK4",
            "RAP1B",
            "C13orf27",
            "TMEM38B",
            "MCM2",
            "RFC4",
            "GRAMD4",
            "KIF13B",
            "NOTCH4",
            "MED27",
            "CDCA4",
            "TMEM48",
            "DCTPP1",
            "PPIL5",
            "MYH14",
            "C9orf46",
            "C9orf40",
            "SMC2",
            "SGSM2",
            "RPL35A",
            "SHANK3",
            "NDUFB5",
            "BSPRY",
            "CTNNAL1",
            "NBEAL2",
            "TOMM5",
            "VBP1",
            "CELSR1",
            "ACTL6A",
            "LOC441089",
            "GNG10",
            "PDCD10",
            "C3orf26",
            "SLC25A5",
            "RFC5",
            "BOD1",
            "FBXO45",
            "PPIH",
            "PHF5A",
            "TMEM63A",
            "TMEM5",
            "NIPSNAP3A",
            "C12orf29",
            "MRPL47",
            "STOML2",
            "GPN1",
            "SUB1",
            "COPS3",
            "FAM49B",
            "BTF3L4",
            "MYNN",
            "WDR53",
            "COMMD2",
            "MRPS30",
            "C9orf21",
            "C9orf30",
            "TRAK1",
            "C16orf63",
            "TIFA",
            "RMI1",
            "NMD3",
            "LSM5",
            "GYG1",
            "CCT4",
            "PTGES3",
            "YBX1",
            "ATP6V1G1",
            "RG9MTD1",
            "SLC31A1",
            "MRPL50",
            "DNAJC9",
            "PSMB7",
            "TEX10",
            "ISCA1P1",
            "PSMD10",
            "ARAP1",
            "GNPDA1",
            "MRPS22",
            "ZCCHC17",
            "METTL11A",
            "DOCK6",
            "UMPS",
            "TDRD7",
            "EBNA1BP2",
            "MRPL37",
            "KIAA0913",
            "C9orf85",
            "C9orf6",
            "ATN1",
            "RABEPK",
            "EIF2S1",
            "ZCCHC9",
            "VMA21",
            "EXOSC2",
            "PRPS1",
            "EZH1",
            "SNRNP40",
            "IARS",
            "ARHGEF11",
            "C9orf80",
            "PRPF4",
            "ZBTB6",
            "PCMT1",
            "DNAJC25",
            "DFFA",
            "TOR1B",
            "HCCS",
            "CAMTA2",
            "FAM120AOS",
            "CDC26",
            "BUB3",
            "SET",
            "ISCA1",
            "APTX",
            "NAA35",
            "ANP32B",
            "UTP11L",
            "RAD23B",
            "CNBP",
            "RBM18",
            "TMEM203",
            "HNRNPC",
            "PSMD5",
            "SF3A3",
            "HIATL1",
            "PPP1R8",
            "SMNDC1",
            "SPTLC1",
            "TOR1A",
            "C9orf78",
            "MAPKAP1",
            "PDCL"
        ]
    },
    {
        "golabel": "POLR1A_regulon_activity",
        "gene": [
            "CLSPN",
            "ARHGAP11B",
            "CASC5",
            "SPTBN2",
            "GATSL1",
            "ZNF697",
            "NCAPD2",
            "SEPW1",
            "TRIO",
            "INCENP",
            "BRP44L",
            "FAM83G",
            "TAOK1",
            "CAD",
            "CCDC28A",
            "UBXN7",
            "PRKDC",
            "CDK12",
            "CENPO",
            "ZNF32",
            "EIF2C2",
            "NCAPD3",
            "FOXK1",
            "TBC1D16",
            "ATP8B5P",
            "LMNB2",
            "TOPBP1",
            "C9orf103",
            "SBNO1",
            "STRN",
            "YEATS2",
            "TRRAP",
            "CLPB",
            "RGP1",
            "ROCK2",
            "NACC2",
            "C22orf32",
            "RIF1",
            "DHX33",
            "ASXL2",
            "MICA",
            "ZSWIM7",
            "DHRS7B",
            "C10orf12",
            "MED1",
            "CKAP5",
            "TMEM59",
            "POLR3A",
            "C14orf28",
            "SUPT16H",
            "TMEM179B",
            "PDCD11",
            "SLC38A7",
            "ANAPC1",
            "ZNF799",
            "URB2",
            "MFSD9",
            "DYNC1H1",
            "TGFBRAP1",
            "C14orf21",
            "UGGT1",
            "HUWE1",
            "PLBD2",
            "UBAP2",
            "POLR1B",
            "ALG13",
            "C19orf42",
            "PHF11",
            "LARP1",
            "EIF4G1",
            "R3HDM1",
            "GABARAP",
            "SNRNP200",
            "MTIF3",
            "DHX57",
            "BIRC6",
            "TRIP12",
            "MTOR",
            "QTRTD1",
            "SF3B3",
            "ISCU",
            "HCFC1",
            "HDLBP",
            "LARS2",
            "IMMT"
        ]
    },
    {
        "golabel": "POLR2H_regulon_activity",
        "gene": [
            "SVEP1",
            "PGR",
            "SCN7A",
            "ITGA8",
            "RPL39L",
            "FAM38B",
            "CKS2",
            "SLIT2",
            "RPL22L1",
            "CCNB1IP1",
            "AOC3",
            "A2M",
            "ZNF366",
            "LTBP2",
            "SNRPG",
            "AHNAK",
            "PARD3B",
            "LAMA2",
            "RFC4",
            "FAM162A",
            "ECE2",
            "GEMIN8P4",
            "PDCD5",
            "BDH1",
            "LOC728554",
            "RPL36A",
            "CBWD3",
            "MRPL52",
            "GAS7",
            "CELF2",
            "C19orf48",
            "NME1",
            "FAM158A",
            "RPL35A",
            "DTYMK",
            "NDUFB5",
            "CLCN2",
            "POP7",
            "COX6A1",
            "PYCRL",
            "EXOSC4",
            "GEMIN6",
            "CCDC58",
            "TMEM44",
            "THOC3",
            "EXOSC5",
            "WWC2",
            "MXD3",
            "ACTL6A",
            "MRPL12",
            "UTRN",
            "PDRG1",
            "PDCD10",
            "NOP16",
            "MYO1D",
            "PHACTR2",
            "ALKBH2",
            "FRMD4B",
            "SNRPF",
            "LOC152217",
            "SNRPA1",
            "PFDN6",
            "NIT2",
            "NDUFB4",
            "MRPL47",
            "SGK269",
            "C3orf33",
            "MACF1",
            "WDR53",
            "COX17",
            "TARBP2",
            "MRPL2",
            "RUVBL1",
            "POLR1C",
            "FOXO3",
            "MAGEF1",
            "C9orf119",
            "ZMYND19",
            "MYCBP2",
            "PTRH2",
            "ALG3",
            "DNAJC19",
            "OBFC2B",
            "TMEM41A",
            "TMEM69",
            "MTM1",
            "RNF7",
            "DNAJB11",
            "RDBP",
            "PARL",
            "WDR5B",
            "RRP9",
            "C12orf65",
            "SEC22A",
            "SDCCAG3",
            "PCGF1",
            "SNTB2",
            "EXOSC2",
            "WDR74",
            "MRPL3",
            "AP2M1",
            "FAM131A",
            "THUMPD2",
            "NCBP2",
            "APTX",
            "JAK1",
            "SERINC1",
            "EIF2B5",
            "TRAF6",
            "ANKFY1",
            "ABCF3",
            "ADD1"
        ]
    },
    {
        "golabel": "POLR2J_regulon_activity",
        "gene": [
            "C7orf68",
            "RPS21",
            "SLIT2",
            "POLR2F",
            "LOC100144603",
            "LOC654342",
            "COMTD1",
            "DPM3",
            "SPAG4",
            "ZP3",
            "ZNF366",
            "UFSP1",
            "PARD3B",
            "MCC",
            "PTPRG",
            "ROMO1",
            "FAM195A",
            "C7orf59",
            "NBEAL1",
            "TIMM16",
            "POLR2I",
            "RNF32",
            "MIF",
            "TIMM17B",
            "MRPL36",
            "C7orf55",
            "C7orf47",
            "YDJC",
            "HSPB1",
            "KLF12",
            "LAGE3",
            "MYEOV2",
            "STAG3L4",
            "BUD31",
            "COX5B",
            "ZNHIT1",
            "C11orf83",
            "SLC25A10",
            "PSMB3",
            "BOLA2",
            "CPSF4",
            "ATP6V0B",
            "POP7",
            "NDUFB7",
            "COX6C",
            "EBP",
            "COX6A1",
            "PYCRL",
            "EXOSC4",
            "NDUFS6",
            "BOLA3",
            "TACC1",
            "ANAPC11",
            "LSM7",
            "FAM128A",
            "FIS1",
            "ABHD11",
            "TRAPPC5",
            "KRTCAP2",
            "GADD45GIP1",
            "NAA10",
            "MRPL12",
            "NDUFA3",
            "C11orf80",
            "MRPS24",
            "FAM96B",
            "SURF2",
            "FAM128B",
            "NDUFB11",
            "LOC401397",
            "SCNM1",
            "SMUG1",
            "MRPL55",
            "NDUFB2",
            "NDUFS8",
            "C19orf53",
            "ATP6V1F",
            "HIPK3",
            "TRIM44",
            "POR",
            "LSM4",
            "TMUB1",
            "MRPL53",
            "COX17",
            "ICT1",
            "REV3L",
            "DUSP18",
            "SNRNP25",
            "CHCHD8",
            "FASTK",
            "PSMB4",
            "ARF5",
            "NR2C2AP",
            "MRPL27",
            "TRMT112",
            "DRAP1",
            "ANKRD39",
            "NDUFC2",
            "C9orf119",
            "TMEM120A",
            "MYCBP2",
            "COX8A",
            "MOSPD3",
            "TRPT1",
            "BANF1",
            "SLC25A39",
            "C7orf11",
            "PGP",
            "ZFP106",
            "CTU2",
            "CHD9",
            "RP9",
            "MRPS34",
            "GNB2",
            "DNAJC30",
            "MRPL38",
            "TMEM60",
            "HIVEP1",
            "ALKBH4",
            "JMJD1C",
            "ZHX2",
            "APC",
            "RHBDD2",
            "PPP1CA",
            "RBMX2",
            "TACO1",
            "CTTNBP2NL",
            "WDFY3",
            "BMPR2",
            "TOP2B",
            "GPS1",
            "PIKFYVE",
            "WBSCR16",
            "OTUD4",
            "ANKFY1"
        ]
    },
    {
        "golabel": "POLR3A_regulon_activity",
        "gene": [
            "TET1",
            "SPNS3",
            "CD52",
            "SACS",
            "MKI67",
            "C1orf133",
            "CHD7",
            "PYCARD",
            "KIF11",
            "COX7A1",
            "DHRS3",
            "HLA-DMA",
            "TP53TG1",
            "KIF20B",
            "NCF4",
            "UTP20",
            "LGALS3",
            "LCOR",
            "SLC7A1",
            "SERTAD1",
            "CCDC28A",
            "PRKDC",
            "TSPAN4",
            "RILP",
            "DLG5",
            "ENTPD7",
            "TCEA2",
            "SBNO1",
            "DDX21",
            "ANKRD26",
            "PARD3",
            "PFKM",
            "RIF1",
            "CCNJ",
            "C10orf12",
            "C11orf67",
            "XPO5",
            "POLR1A",
            "SMC3",
            "UBR5",
            "CKAP5",
            "NFXL1",
            "ERCC6",
            "GNPTG",
            "PPM1M",
            "ZNF623",
            "TAF5",
            "MAPK8",
            "TNFSF12",
            "TMEM219",
            "SGPL1",
            "WDR43",
            "PDCD11",
            "ANAPC1",
            "TAF2",
            "RAB4B",
            "NAA25",
            "DCAF16",
            "ALDH18A1",
            "MARCH2",
            "NCOA6",
            "PTPN11",
            "DCAF10",
            "ARHGAP19",
            "LARP1",
            "RPL7L1",
            "C10orf18",
            "KIAA1429",
            "EIF3A",
            "UPF2",
            "CHUK",
            "KIAA1279",
            "SF3B3",
            "DDX50",
            "PEF1",
            "PARG",
            "C10orf119",
            "CSTF2T",
            "BMS1",
            "PRDM4",
            "CCDC115",
            "GBF1",
            "SEC23IP",
            "PRMT2",
            "CCAR1",
            "C10orf46",
            "ADO",
            "AP3M1",
            "WAPAL",
            "VTI1A",
            "HNRNPH3",
            "DHX9",
            "SEC24C",
            "WAC",
            "ECD",
            "FAM175B"
        ]
    },
    {
        "golabel": "POLR3E_regulon_activity",
        "gene": [
            "FCGR1A",
            "FCGR1B",
            "C1orf54",
            "APOBEC3G",
            "GLIPR2",
            "RAB32",
            "FCER1G",
            "AIF1",
            "CCDC109B",
            "RGS10",
            "AP1S2",
            "FAM186B",
            "GIMAP4",
            "TMSL3",
            "OGFRL1",
            "GUCY1B3",
            "SYT17",
            "TICAM2",
            "NOMO2",
            "ZNF48",
            "MYBBP1A",
            "ACAD10",
            "KIAA0556",
            "PDXDC1",
            "URB2",
            "ZNF598",
            "TFAP4",
            "RREB1",
            "EARS2",
            "HSPA9",
            "C16orf88",
            "RPAP1",
            "TSC2",
            "TUFM",
            "GNAI2",
            "RNF44",
            "UBFD1",
            "COG7",
            "SETD1A",
            "ATXN2",
            "GTF3C1",
            "YWHAH",
            "DNAJA3",
            "PPRC1",
            "ATXN2L"
        ]
    },
    {
        "golabel": "POU6F1_regulon_activity",
        "gene": [
            "CCDC114",
            "NTN5",
            "MYH3",
            "GPR162",
            "DZIP1L",
            "KIAA1683",
            "CCDC40",
            "LOC283663",
            "RNF112",
            "KCNAB3",
            "DNAH1",
            "RASGRP2",
            "PATL2",
            "OXER1",
            "LOC728392",
            "VENTX",
            "PXT1",
            "PTCH2",
            "ZMAT1",
            "BZRAP1",
            "GPRASP1",
            "COLQ",
            "FITM1",
            "LOC728264",
            "LRRC37A3",
            "LOC283070",
            "SLC25A34",
            "NLRP1",
            "NLGN3",
            "C14orf139",
            "ITGA7",
            "ZGLP1",
            "PERP",
            "ADC",
            "IFFO1",
            "TTLL3",
            "PLXDC1",
            "IDH1",
            "GAB3",
            "TSPYL2",
            "SORD",
            "CBLN3",
            "FAM193B",
            "ACAT2",
            "ZNF37B",
            "KCTD3",
            "POPDC2",
            "DARS2",
            "EVL",
            "COQ10A",
            "GLRX2",
            "LOC100190939",
            "ZBTB47",
            "BTN2A2",
            "MOBKL3",
            "DLD",
            "RNF2",
            "INTS7",
            "MMADHC",
            "ZNF333",
            "NDUFS1",
            "DLAT",
            "USP20",
            "C2orf47",
            "IARS2",
            "BLZF1",
            "UCHL5",
            "PHF1",
            "SCO1",
            "COPB1",
            "VPS35",
            "CDC73",
            "RFWD2"
        ]
    },
    {
        "golabel": "PPAN_regulon_activity",
        "gene": [
            "EPO",
            "C19orf23",
            "PRR7",
            "C4orf12",
            "RECQL4",
            "LRFN4",
            "BYSL",
            "CHTF18",
            "CCDC85B",
            "SGMS2",
            "C7orf47",
            "YDJC",
            "ZDHHC2",
            "C14orf80",
            "CD320",
            "C19orf48",
            "C11orf83",
            "LOC388796",
            "PLSCR4",
            "GNB1L",
            "EXOSC4",
            "LSM7",
            "FAM128A",
            "FCHO2",
            "IPO4",
            "WDR34",
            "CTU1",
            "TIGD5",
            "TCP11L2",
            "SURF2",
            "FAM128B",
            "CHAF1A",
            "PDAP1",
            "SAC3D1",
            "DDX39",
            "STK17B",
            "WDR4",
            "LRWD1",
            "MEIS3P1",
            "TMUB1",
            "NR3C1",
            "C21orf70",
            "WDR18",
            "ATAD3A",
            "CCPG1",
            "INO80B",
            "HSPBP1",
            "TRMT1",
            "THOP1",
            "SLC25A22",
            "KLF16",
            "DUS3L",
            "CDC34",
            "DRAP1",
            "C20orf27",
            "C10orf118",
            "SRM",
            "CCDC86",
            "CPEB4",
            "ZMYND19",
            "TRMT61A",
            "POLD2",
            "TMEM30A",
            "TBRG4",
            "DOHH",
            "ZC3H3",
            "CCDC124",
            "NEK7",
            "NOC2L",
            "SF3A2",
            "NSUN5",
            "RRP1",
            "RUVBL2",
            "NOC4L",
            "RBL2",
            "RRP9",
            "KRI1",
            "LONP1",
            "FBXL17",
            "POLRMT",
            "WDR74",
            "LYSMD3",
            "TIMM44",
            "PCMTD1",
            "SCARB2",
            "SCLY",
            "TSPYL1",
            "KIAA0494",
            "PJA2",
            "CREBL2",
            "BRMS1",
            "GAR1",
            "HDGFRP2",
            "NDUFV1",
            "RAVER1",
            "TSSC4",
            "ZMYND11",
            "FARSA",
            "PRKAR1A",
            "PES1",
            "SNRPA",
            "FAM160B1",
            "SERINC1",
            "SHOC2",
            "WDR46",
            "KIAA0776",
            "LAS1L",
            "PRPF31",
            "STAM2",
            "TOR1AIP1",
            "APPBP2",
            "SLAIN2",
            "C6orf89",
            "SAFB",
            "DAZAP1",
            "ATRIP",
            "VPS24"
        ]
    },
    {
        "golabel": "PPARD_regulon_activity",
        "gene": [
            "OR10H1",
            "LOC100126784",
            "SEC11C",
            "PLAU",
            "CDH3",
            "FSCN1",
            "C10orf55",
            "PDZD7",
            "PIR",
            "SRPX2",
            "RNF39",
            "FRMD5",
            "KCNN4",
            "ATP10A",
            "UNC13D",
            "C1orf170",
            "VASN",
            "KRT19",
            "MMP14",
            "PLAUR",
            "PLEKHN1",
            "ANKRD56",
            "MBOAT2",
            "SLC16A3",
            "ITGA3",
            "ZNF185",
            "SAMD4A",
            "PLEC",
            "BMP1",
            "PDLIM7",
            "TIMP2",
            "PLXNA1",
            "SH3BGRL3",
            "PLXNA3",
            "EPHA1",
            "GKAP1",
            "CMTM3",
            "TTYH3",
            "AGRN",
            "DTX2",
            "LRRC8A",
            "TRIM47",
            "KIAA1949",
            "METRNL",
            "GNA15",
            "LOC644936",
            "LIMK1",
            "RHBDF2",
            "FAM38A",
            "CCM2",
            "AHDC1",
            "BCL9L",
            "MEX3D",
            "PML",
            "ARHGAP10",
            "KCTD5",
            "SPATS2L",
            "PHOSPHO2",
            "RASAL2",
            "EHD1",
            "VAT1",
            "SFXN3",
            "GNA12",
            "SLC25A20",
            "ZYX",
            "TEAD3",
            "SERP1",
            "CCDC121",
            "AUH",
            "ZCCHC10",
            "ACTR6",
            "VPS37B",
            "FAM129B",
            "RPS6KA4",
            "ISOC1",
            "ZNF280D",
            "CNN2",
            "MAP7D1",
            "NACC1",
            "IL4R",
            "SLC10A3",
            "INTS10",
            "MED15",
            "BCDIN3D",
            "MOV10",
            "NSMCE4A",
            "RIC8B",
            "SH3GL1",
            "GNAI2",
            "IKZF5",
            "GTPBP2",
            "ACTB",
            "SEPT9",
            "EIF1B",
            "TMEM104",
            "DDX59",
            "ARHGDIA",
            "TM2D3",
            "C11orf68"
        ]
    },
    {
        "golabel": "PPP1R10_regulon_activity",
        "gene": [
            "KIAA1683",
            "RPS3A",
            "FCGR2B",
            "FCGR2C",
            "GSTO1",
            "DSE",
            "CD300A",
            "FCGR2A",
            "LOC399744",
            "ARHGAP39",
            "PGK1",
            "EEF1A1",
            "MED28",
            "NEK8",
            "SSR3",
            "CASKIN2",
            "GYG1",
            "SNX3",
            "OSTM1",
            "SGTB",
            "MTMR6",
            "SLC25A46",
            "YAF2",
            "RAP1GDS1",
            "TMED7",
            "RPAP1",
            "OSBPL8",
            "ATG12",
            "AP3S1",
            "SETD1A",
            "ZSCAN29",
            "OSTF1",
            "YIPF5",
            "DGCR8",
            "CNBP",
            "ARPC2",
            "BAT3",
            "LEMD2",
            "SFRS15",
            "C6orf47",
            "SPTLC1",
            "SAFB2",
            "TRIM39",
            "NCOA5",
            "TRIM26",
            "ZC3H4",
            "SAFB"
        ]
    },
    {
        "golabel": "PRDM1_regulon_activity",
        "gene": [
            "LOC96610",
            "MGC29506",
            "C8orf80",
            "FCRL5",
            "ALDH1L2",
            "LAX1",
            "POU2AF1",
            "SFMBT2",
            "CPNE5",
            "VCAM1",
            "POU2F2",
            "WISP1",
            "SLAMF6",
            "PIM2",
            "SLAMF1",
            "RHOH",
            "LEF1",
            "CXCR4",
            "PDE4B",
            "GCAT",
            "C14orf145",
            "CRISPLD2",
            "CYTIP",
            "TNFAIP3",
            "C11orf52",
            "TCEA3",
            "ETS1",
            "TRNAU1AP",
            "ARHGAP8",
            "TKT",
            "WIPF1",
            "TMEM54",
            "LRRC20",
            "PAK6",
            "ELL2",
            "SEL1L",
            "CNKSR1",
            "KIAA1522",
            "TMEM129",
            "HMGCL",
            "NMRAL1",
            "BCL2L11",
            "SLC37A4",
            "ADPRHL2",
            "CDK17",
            "MECR"
        ]
    },
    {
        "golabel": "PRDM2_regulon_activity",
        "gene": [
            "CNKSR2",
            "KIAA1529",
            "IGSF9B",
            "SCN7A",
            "ITGA8",
            "LOC285593",
            "DYNC2H1",
            "CKS2",
            "F12",
            "TUB",
            "GPRASP1",
            "RPL22L1",
            "CCDC30",
            "DMD",
            "COMTD1",
            "TECTA",
            "SERTAD4",
            "ZNF154",
            "LCA5",
            "TXN",
            "ZC3H12B",
            "FAM129A",
            "MASP2",
            "ZNF354C",
            "PER3",
            "TP53I3",
            "RALGAPA2",
            "TNS1",
            "DERA",
            "ACY1",
            "SPATA6",
            "NBPF3",
            "ASAP3",
            "RORA",
            "OTUD3",
            "RGL1",
            "APBB1",
            "SLC35E2",
            "EPB41L4A",
            "SLC41A1",
            "USMG5",
            "NME2",
            "PLEKHG1",
            "ZFP3",
            "CP110",
            "PSMG4",
            "PKD2",
            "SP4",
            "NBPF1",
            "NIPAL3",
            "EIF5A",
            "FAM100B",
            "PLEKHM3",
            "REV3L",
            "VDAC2",
            "EIF5AL1",
            "MRPS2",
            "BBS5",
            "KIAA0495",
            "KIAA1370",
            "PSMB7",
            "NPHP4",
            "KCTD7",
            "ZNF70",
            "SIGMAR1",
            "VPS13D",
            "SNX29",
            "FAM13B",
            "JHDM1D",
            "EIF2C4",
            "PA2G4",
            "ZNF436",
            "TRAK2",
            "TBCEL",
            "TTC3",
            "UQCRC1",
            "WDR47",
            "GRHPR",
            "AHSA1",
            "SPEN",
            "MRPS16",
            "ZBED5",
            "ZNF776",
            "FCHSD2",
            "TCEB3",
            "TMEM57",
            "PFN1",
            "CCT7",
            "URM1",
            "CEP68",
            "RNF146",
            "TRAF6",
            "IFNAR1",
            "CLCC1",
            "ZYG11B",
            "USP48",
            "DNAJC16",
            "KIAA0562",
            "DYRK1A",
            "ZMYM6",
            "FBXO42"
        ]
    },
    {
        "golabel": "PRDM4_regulon_activity",
        "gene": [
            "FOXP2",
            "LOC388588",
            "LOC100132111",
            "CCT6B",
            "GCAT",
            "NT5DC3",
            "MTCP1NB",
            "HHLA3",
            "HSD17B8",
            "C7orf23",
            "ZDBF2",
            "ZNF697",
            "NAV1",
            "TRERF1",
            "FAHD2B",
            "TRAPPC6A",
            "UTP20",
            "MDP1",
            "TRNAU1AP",
            "MPHOSPH9",
            "LOC729234",
            "NME3",
            "SENP8",
            "NUDT16L1",
            "SBNO1",
            "TDG",
            "ACOT1",
            "PPTC7",
            "CLIP1",
            "ARV1",
            "HAUS4",
            "IPO8",
            "CKAP4",
            "DGCR6L",
            "FICD",
            "THYN1",
            "GUSB",
            "BLVRA",
            "OSGEP",
            "PUS10",
            "ACOT2",
            "POLR3A",
            "HMOX2",
            "DNAJC4",
            "DHX37",
            "NAA25",
            "ATP2A2",
            "UGGT1",
            "GCN1L1",
            "SUDS3",
            "PLBD2",
            "ANKLE2",
            "EP400",
            "PLAA",
            "PTPN11",
            "NEDD1",
            "DDX54",
            "LARP4",
            "UHRF1BP1L",
            "SETD8",
            "PPP1R12A",
            "FBXO21",
            "KPNB1",
            "CDV3",
            "XPO7",
            "DENR",
            "CDK17",
            "MAPKAPK5",
            "DNAJC14",
            "SART3",
            "VCP",
            "RAB35",
            "TATDN2",
            "BRAP",
            "CAMKK2"
        ]
    },
    {
        "golabel": "PRKRIR_regulon_activity",
        "gene": [
            "TMEM74",
            "SEMA3B",
            "RAB39B",
            "PLXNB3",
            "C12orf24",
            "EPS8L1",
            "SYT11",
            "C8orf73",
            "FUT3",
            "PCSK4",
            "ID2",
            "ALS2CL",
            "RPS3",
            "GCH1",
            "TRIT1",
            "LOC145783",
            "ABCC3",
            "MUC1",
            "EVPL",
            "MRPL48",
            "SYTL1",
            "PITPNM3",
            "SLC36A4",
            "TJP3",
            "ANO8",
            "AGPAT5",
            "SH2D3A",
            "SERINC2",
            "XPOT",
            "DCK",
            "BAIAP2",
            "SLC27A1",
            "LOC90110",
            "EXD3",
            "TMC4",
            "LOC150786",
            "L2HGDH",
            "MAP3K6",
            "TFAM",
            "IFT46",
            "CLPB",
            "MVP",
            "ARHGAP27",
            "MANEA",
            "RHBDF1",
            "NARS2",
            "MRPL49",
            "TMX1",
            "CNKSR1",
            "HDAC11",
            "PLEKHF2",
            "TIFA",
            "MGAT2",
            "LIN52",
            "SGTB",
            "PRCP",
            "PDE4A",
            "LMNA",
            "TRIP10",
            "SDHD",
            "CRAT",
            "C11orf59",
            "LYPLA2",
            "PAAF1",
            "C11orf30",
            "ACER3",
            "ZNF22",
            "SPCS2",
            "TMED10P1",
            "RBM7",
            "HCFC2",
            "RNF115",
            "EXOC5",
            "NUP160",
            "TMEM216",
            "LOC653566",
            "CLNS1A",
            "UBR7",
            "ZNF765",
            "EED",
            "UHRF1BP1L",
            "EXT2",
            "UVRAG",
            "ATG4C",
            "HARBI1",
            "PPP1CC",
            "MTCH2",
            "STXBP2",
            "CDC37",
            "RAB6A",
            "C17orf80",
            "CWF19L2",
            "TMX2",
            "RFX1",
            "SUV420H1",
            "GANAB",
            "ANXA11",
            "AASDHPPT",
            "CEP57",
            "MAPRE1",
            "INTS4",
            "RNF121",
            "MUDENG",
            "C11orf57",
            "CUL5",
            "CLP1",
            "API5",
            "SAPS3",
            "RBM4"
        ]
    },
    {
        "golabel": "PRR12_regulon_activity",
        "gene": [
            "GPR153",
            "PSMA6",
            "TRPM4",
            "LY96",
            "CELSR2",
            "NSMCE2",
            "FUNDC2",
            "C8orf59",
            "CFL2",
            "TMEM70",
            "MYH14",
            "C9orf46",
            "TMEM126B",
            "HSPG2",
            "SGK223",
            "RHEB",
            "STARD3NL",
            "VPS29",
            "EML2",
            "BOD1",
            "PITPNM1",
            "LOC401397",
            "IQCE",
            "RNF139",
            "SUB1",
            "FAM49B",
            "RRBP1",
            "AIG1",
            "SIPA1L3",
            "RAI1",
            "TIMM9",
            "PPIL3",
            "TNRC18",
            "CASKIN2",
            "C9orf21",
            "TIFA",
            "GYG1",
            "ZNF496",
            "PSMC2",
            "NUDCD2",
            "MLL2",
            "PSMA2",
            "GRLF1",
            "COX11",
            "CIC",
            "OPA3",
            "RWDD1",
            "CISD2",
            "DOCK6",
            "UPF1",
            "ARHGEF18",
            "ZCCHC9",
            "ACTR10",
            "TAF9",
            "ZNF407",
            "ARHGEF11",
            "SCAF1",
            "AMZ2",
            "MCTS1",
            "KIAA1967",
            "TBC1D17",
            "PHRF1",
            "PAIP2",
            "PHF2",
            "HCFC1",
            "PRKD2",
            "ZDHHC6",
            "RNF123",
            "ZC3H4",
            "PTPN23",
            "USP19"
        ]
    },
    {
        "golabel": "PRR3_regulon_activity",
        "gene": [
            "GPC2",
            "IL1RN",
            "RAB27B",
            "GALNT5",
            "LOC284009",
            "ITGB4",
            "LOC222699",
            "FRS3",
            "GALNT3",
            "MSH5",
            "SGPP2",
            "LY6G5B",
            "PTBP2",
            "KCNK6",
            "TNFRSF10A",
            "TIGD1",
            "NIPAL2",
            "NASP",
            "GNA15",
            "C6orf134",
            "ZNF620",
            "ZNF10",
            "MAP3K5",
            "MUTYH",
            "GNL1",
            "ZSCAN16",
            "DOM3Z",
            "ZNF26",
            "PRPF3",
            "ZNF821",
            "ZNF193",
            "CLK2",
            "GCFC1",
            "SEC24D",
            "PABPN1",
            "ZNF691",
            "LITAF",
            "ZNF76",
            "GTF2H4",
            "C2orf68",
            "BAT1",
            "ZMYM3",
            "TMEM87B",
            "VPS52",
            "RAB2B",
            "ZSWIM1",
            "TRIM39",
            "TMEM127",
            "CPSF7",
            "RBMX"
        ]
    },
    {
        "golabel": "PSIP1_regulon_activity",
        "gene": [
            "KIF5C",
            "CDH2",
            "RNF182",
            "MYB",
            "GNAZ",
            "BCL2",
            "ADAM22",
            "GPR173",
            "RAB39B",
            "REEP2",
            "ST6GALNAC3",
            "FAM124A",
            "PTK6",
            "TMEM105",
            "RFX3",
            "C19orf21",
            "FUT3",
            "KRTCAP3",
            "KIAA1467",
            "ADAP1",
            "TXNDC16",
            "CNTLN",
            "UHRF2",
            "ZFP37",
            "KIF24",
            "C14orf145",
            "ZNF286B",
            "LAD1",
            "C20orf54",
            "TRPC1",
            "ZNF833",
            "MMP15",
            "HMGB2",
            "C9orf93",
            "C21orf91",
            "KLF12",
            "MTAP",
            "RTTN",
            "FAM55C",
            "TMED3",
            "SMC2",
            "RBL1",
            "MPDZ",
            "DGAT1",
            "NFIB",
            "CEP97",
            "CHPF",
            "ELMO3",
            "TOPBP1",
            "C9orf72",
            "DGKE",
            "CLDN7",
            "C14orf106",
            "HAUS6",
            "CP110",
            "SPINT1",
            "COMT",
            "SMCHD1",
            "DDHD1",
            "CEP78",
            "CD151",
            "LASS2",
            "POLD4",
            "IQCB1",
            "BCAR1",
            "TMEM134",
            "CEP110",
            "TMEM120A",
            "GNPTG",
            "POLA1",
            "SPATA2L",
            "RANBP6",
            "SUMF1",
            "SGTB",
            "PRKD3",
            "CASP8AP2",
            "SSH3",
            "ZBTB26",
            "AGTPBP1",
            "DEK",
            "TMEM102",
            "KIAA1432",
            "SNAPC3",
            "HSF2",
            "DCP2",
            "TMEM53",
            "SMC6",
            "RNPEPL1",
            "KLHL9",
            "IFT74",
            "TOM1",
            "PLAA",
            "XRN1",
            "KIAA2026",
            "PAFAH2",
            "RIC8B",
            "ELOVL1",
            "KLHL15",
            "GMPPA",
            "ABI2",
            "MYO1C",
            "LSM11",
            "ZBTB5",
            "RNF38",
            "NPAT",
            "YIPF3",
            "CORO1B",
            "MSL2",
            "SMU1"
        ]
    },
    {
        "golabel": "PSMC5_regulon_activity",
        "gene": [
            "KCNS2",
            "ANGPT1",
            "SLIT2",
            "FMO2",
            "C7orf58",
            "CASS4",
            "EPN3",
            "TLCD1",
            "RALGAPA2",
            "ZDHHC20",
            "MRPL24",
            "MRPL12",
            "MRPS24",
            "PFDN2",
            "SHFM1",
            "TCP11L2",
            "NUDT1",
            "C17orf89",
            "DIXDC1",
            "FAM50A",
            "C5orf41",
            "SLC39A11",
            "TUBG1",
            "LRRC45",
            "HIPK3",
            "PPAP2B",
            "ICT1",
            "PSMB4",
            "MTX1",
            "MRPL27",
            "EIF3B",
            "PTRH2",
            "SLC25A39",
            "PSMD4",
            "CCDC137",
            "NEK7",
            "LZTFL1",
            "ATP5H",
            "POLG2",
            "ADRM1",
            "RRP1",
            "NOC4L",
            "AARSD1",
            "DDX56",
            "FBXL3",
            "NUDC",
            "GSS",
            "AKAP11",
            "SART1",
            "PHB",
            "TACO1",
            "ZNF791",
            "PSMD12",
            "BRMS1",
            "SCAMP3",
            "FTSJ3",
            "SNF8",
            "FTSJD1",
            "MKS1",
            "AATF",
            "SLC35B1",
            "NKIRAS2",
            "SACM1L",
            "GPS1",
            "U2AF1",
            "RSBN1",
            "CNOT6L",
            "PSMC3",
            "SNRPA",
            "COASY",
            "C17orf95",
            "SMARCD2",
            "MRPS5",
            "DDX41",
            "RAD23A",
            "MRPL10",
            "PPM1A",
            "TBC1D12",
            "CAPN7",
            "SAP30BP",
            "DDX42",
            "CLASP2",
            "FAM122A",
            "FAM104A",
            "HNRNPA2B1"
        ]
    },
    {
        "golabel": "PSMD12_regulon_activity",
        "gene": [
            "ERN2",
            "VSIG2",
            "AFF3",
            "PDE4C",
            "PIP5K1B",
            "KRT80",
            "NCRNA00092",
            "SLC4A4",
            "MCM10",
            "KCNQ1",
            "CDC6",
            "BIRC5",
            "CKAP2L",
            "RNASE4",
            "LOC222699",
            "BTG2",
            "NPDC1",
            "BAG2",
            "TK1",
            "LARGE",
            "RHOBTB3",
            "ANP32E",
            "FRY",
            "KPNA2",
            "EPB49",
            "NME1",
            "ZFYVE28",
            "C17orf58",
            "MOAP1",
            "C14orf159",
            "TMEM8B",
            "C1orf103",
            "PSMD14",
            "CCDC61",
            "GLTSCR2",
            "EIF4A3",
            "PSMA5",
            "PSMC2",
            "PSMD11",
            "PANX1",
            "PTRH2",
            "METTL2A",
            "YWHAG",
            "MRPS7",
            "NDUFA12",
            "ITFG2",
            "RPS6KB1",
            "USP14",
            "PSD4",
            "JMJD6",
            "RAD51C",
            "DNTTIP2",
            "TACO1",
            "CCDC47",
            "AMZ2",
            "SUMO2",
            "NOL11",
            "LRRC59",
            "SNF8",
            "UTP18",
            "PSMB2",
            "FOXK2",
            "LSM12",
            "CCDC43",
            "CLTC",
            "RAD23B",
            "PSMC5",
            "COIL",
            "CDC27",
            "TBRG1",
            "OGFOD1",
            "UBE2Z",
            "FAM104A",
            "SRP68",
            "EIF1AD"
        ]
    },
    {
        "golabel": "PTCH1_regulon_activity",
        "gene": [
            "GLT25D2",
            "PCDH11X",
            "GFRA1",
            "SHH",
            "HR",
            "C20orf56",
            "C11orf92",
            "ACER2",
            "ABCA8",
            "THSD7B",
            "AFF3",
            "ROBO2",
            "TGFBR3",
            "PREX2",
            "ADAMTSL3",
            "UST",
            "BIRC5",
            "SH3BGRL2",
            "CGNL1",
            "TK1",
            "BEND7",
            "NME1",
            "SOX13",
            "PSMB3",
            "DTYMK",
            "BOLA3",
            "MAGI1",
            "MRPL12",
            "CRY2",
            "PPP1R14B",
            "TUBA1C",
            "MRPL11",
            "DCUN1D5",
            "THOC4",
            "RAVER2",
            "PLEKHM3",
            "BCL2L12",
            "TMEM49",
            "DRAP1",
            "PPP4C",
            "NFATC3",
            "FAM13B",
            "CPEB3",
            "MYST4",
            "SLC44A2",
            "JMJD6",
            "ZNF259",
            "XPC",
            "TSPYL1",
            "PDE6D",
            "UBE2F",
            "MPHOSPH8",
            "C17orf39",
            "PHF2",
            "EIF4EBP2",
            "EPC1",
            "CFL1"
        ]
    },
    {
        "golabel": "PTMA_regulon_activity",
        "gene": [
            "C20orf199",
            "RPS18",
            "RPS7",
            "RPL27",
            "RPL39",
            "CCNB1IP1",
            "RPS3",
            "SNRPG",
            "RPL23AP64",
            "RPSAP58",
            "RPL31",
            "RPLP0",
            "SNRPD2",
            "RPL8",
            "RPS19",
            "RPS8",
            "RPL24",
            "RPS11",
            "RPL27A",
            "RPL5",
            "RPL12",
            "RPL32",
            "RPL35A",
            "DTYMK",
            "RPL38",
            "RPL37",
            "DENND3",
            "RPL18",
            "CCDC72",
            "RPS27A",
            "RPS24",
            "LOC442454",
            "RPL37A",
            "RPL14",
            "HEBP2",
            "RPS2",
            "SNRPF",
            "CCDC59",
            "SNRPD1",
            "CCDC23",
            "SUB1",
            "ERH",
            "C12orf45",
            "SARNP",
            "OLA1",
            "H3F3A",
            "FBL",
            "SS18L2",
            "SLC46A1",
            "RPL23A",
            "TMEM106A",
            "LOC728758",
            "PPARA",
            "SNRPE",
            "HMGB1",
            "CDK2AP1",
            "UBA52",
            "TBCA",
            "NUTF2",
            "GNG5",
            "ATP6V0A1",
            "ZZEF1",
            "NDUFA12",
            "THOC7",
            "VPS41",
            "MINK1",
            "SUMO1P3",
            "IL17RA",
            "LSM3",
            "RBMX2",
            "PDE6D",
            "SUMO2",
            "STIM1",
            "NLRX1",
            "ABHD15",
            "C19orf43",
            "DUSP3",
            "RPL22",
            "SUMO1",
            "ANP32B",
            "TRAPPC10",
            "SFRS3",
            "MCM3AP",
            "HNRNPC",
            "HNRNPA1",
            "HNRNPA1L2",
            "PPP1R8",
            "XRCC5",
            "UBE2D2",
            "UBE2I",
            "KHDRBS1",
            "HNRNPL"
        ]
    },
    {
        "golabel": "PTRF_regulon_activity",
        "gene": [
            "MFAP5",
            "SRPX",
            "SEMA7A",
            "TWIST2",
            "CAV1",
            "LOC399959",
            "BNC2",
            "S100A3",
            "TOX2",
            "PHLDB2",
            "PMEPA1",
            "PDE2A",
            "ALG1L",
            "OLFML2A",
            "NXPH3",
            "ARSI",
            "FSTL3",
            "SYDE1",
            "CHST3",
            "ATP10A",
            "SLC16A2",
            "HSPA12B",
            "CYR61",
            "MDGA1",
            "TIMP3",
            "ROBO4",
            "NRP2",
            "LAMA4",
            "TSHZ3",
            "LIMS2",
            "TIE1",
            "TSPAN18",
            "AHNAK",
            "EFNB2",
            "CLIP2",
            "TTC39A",
            "KIAA1462",
            "OLFML1",
            "AXL",
            "MSRB3",
            "AGPAT4",
            "DYSF",
            "SAMD4A",
            "EMP3",
            "EMP1",
            "OAF",
            "VIM",
            "TUBB6",
            "PLEC",
            "MYLK",
            "ARHGAP23",
            "TGFB1I1",
            "MRC2",
            "FGD5",
            "LOC100270710",
            "TSPAN9",
            "PDGFRB",
            "TIMP2",
            "ITPRIP",
            "PCDH12",
            "MXRA7",
            "FLNA",
            "FLVCR1",
            "SEPHS2",
            "SYNPO",
            "MARVELD1",
            "LRRC8A",
            "RAB31",
            "DUSP7",
            "LOC644936",
            "MYADM",
            "RRAS",
            "EHD2",
            "C2orf15",
            "IGFBP4",
            "CEP70",
            "PDLIM2",
            "FAM38A",
            "MSI2",
            "PCDHGC3",
            "LYSMD1",
            "ZNF620",
            "PML",
            "C1orf43",
            "PHOSPHO2",
            "TPM4",
            "RIN3",
            "FAM65A",
            "VCL",
            "TMEM62",
            "TH1L",
            "EHD1",
            "GAS2L1",
            "MSN",
            "SFXN3",
            "LUZP1",
            "MYH9",
            "DAPK3",
            "ZYX",
            "KANK2",
            "ZBTB47",
            "MARS2",
            "GLT25D1",
            "CNN2",
            "ARHGAP12",
            "MAP7D1",
            "STRBP",
            "CTPS2",
            "RBM9",
            "C1orf27",
            "MOBKL2A",
            "GNAI2",
            "ACTB",
            "C2orf60",
            "MAP4",
            "THAP9",
            "SNX4",
            "AP1M1",
            "ZCCHC8",
            "UBXN4",
            "SFRS13A"
        ]
    },
    {
        "golabel": "PTTG1_regulon_activity",
        "gene": [
            "DSCR6",
            "MYOCD",
            "PTTG2",
            "CDCA7",
            "MND1",
            "CCNB2",
            "PTTG3P",
            "CDKN3",
            "GINS2",
            "CKS2",
            "TROAP",
            "CENPA",
            "AURKB",
            "DEPDC1B",
            "FAM24B",
            "HMMR",
            "CENPW",
            "SPC25",
            "CDC25C",
            "BIRC5",
            "CDC20",
            "HJURP",
            "CDCA3",
            "CDK1",
            "CCNA2",
            "NCAPG",
            "AOC3",
            "CCNB1",
            "KIF20A",
            "FAM162A",
            "PTPRU",
            "ASF1B",
            "NUSAP1",
            "OPHN1",
            "CENPH",
            "PPL",
            "KIAA0513",
            "CENPP",
            "LDHA",
            "H2AFZ",
            "CASZ1",
            "THOC3",
            "CELSR1",
            "MXD3",
            "NDUFA9",
            "PSME2",
            "MRPL11",
            "SNRPF",
            "KIAA1671",
            "SAAL1",
            "FBL",
            "EPB41L1",
            "PACSIN2",
            "RPF2",
            "SFXN1",
            "ZDHHC7",
            "KIAA1370",
            "VPS13D",
            "SSBP1",
            "PA2G4",
            "PSMA1",
            "MEF2D",
            "HNRNPAB",
            "RBBP7",
            "PSMB2",
            "PSMC3",
            "KLHL20",
            "H2AFY",
            "TADA2B"
        ]
    },
    {
        "golabel": "PWP1_regulon_activity",
        "gene": [
            "POPDC3",
            "UCHL1",
            "SRXN1",
            "TXNRD1",
            "TMEM22",
            "TMEM14A",
            "ICAM5",
            "CDKN3",
            "CKS2",
            "DNAH2",
            "MAD2L1",
            "C12orf48",
            "C12orf24",
            "EPR1",
            "HMMR",
            "CENPW",
            "CKS1B",
            "KIAA0101",
            "AUTS2",
            "PRIM1",
            "BAG2",
            "SNRPG",
            "CCNB1",
            "RAD51",
            "EVPL",
            "RPLP0",
            "NUDT2",
            "DEPDC4",
            "VDAC3",
            "C15orf23",
            "PITPNM3",
            "EMG1",
            "GMNN",
            "POC1B",
            "PFDN4",
            "TLE2",
            "EPB41L4A",
            "COX6A1",
            "RAN",
            "CCDC58",
            "COQ3",
            "GLRX3",
            "MRPL15",
            "VPS29",
            "H2AFZ",
            "PDSS1",
            "MGRN1",
            "VBP1",
            "NDUFA9",
            "ACTL6A",
            "COX7A2L",
            "IKBIP",
            "LOC90110",
            "C3orf26",
            "PAK1IP1",
            "ALKBH2",
            "PGAM5",
            "RFC5",
            "TUBA1C",
            "AHDC1",
            "SNRPF",
            "TDG",
            "CCDC59",
            "NUP37",
            "DCUN1D5",
            "TMEM63A",
            "SAMD12",
            "C12orf29",
            "TWF1",
            "STOML2",
            "C12orf73",
            "TPRKB",
            "MRPL42",
            "ATP5B",
            "CKAP4",
            "TUBA1B",
            "WDR12",
            "C12orf45",
            "UNG",
            "SARNP",
            "PSMD14",
            "TMED2",
            "CACYBP",
            "NDUFAF4",
            "POP5",
            "CORO1C",
            "DPM1",
            "DAB2IP",
            "CCT4",
            "PSMA5",
            "PTGES3",
            "COQ5",
            "SNRPE",
            "C12orf47",
            "GPN3",
            "WSB2",
            "ARPC3",
            "CDK2AP1",
            "ACTR6",
            "TRIAP1",
            "SSBP1",
            "OBFC2B",
            "PSMA4",
            "UBE2N",
            "GTF2H3",
            "DIABLO",
            "GTF2E2",
            "MRPS22",
            "CLEC16A",
            "UMPS",
            "PA2G4",
            "YAF2",
            "NDUFA12",
            "TAOK2",
            "SMYD2",
            "ARL1",
            "DYNLL1",
            "ZC3H15",
            "PDCD2",
            "TSC2",
            "PSMA1",
            "LSM3",
            "PSMD9",
            "POLR3B",
            "TXNL4B",
            "C12orf52",
            "SFRS9",
            "PSMD7",
            "ZNF140",
            "ANAPC7",
            "PPP1CC",
            "VPS33A",
            "NAE1",
            "PCBP2",
            "METAP2",
            "ANAPC5",
            "DENR",
            "SLC25A3",
            "CNBP",
            "RNF34",
            "SLC15A4",
            "MAPKAPK5",
            "SPPL3",
            "PPHLN1",
            "PSMD6",
            "EIF2B1",
            "C12orf43",
            "RAB35",
            "BRAP"
        ]
    },
    {
        "golabel": "PYGO2_regulon_activity",
        "gene": [
            "DCST2",
            "PLBD1",
            "KLF4",
            "FAM69B",
            "MCTP1",
            "C7orf58",
            "IL18R1",
            "SBK1",
            "GLIPR1",
            "UBASH3B",
            "CCRL2",
            "PTGER4",
            "DSE",
            "TLR4",
            "NECAB3",
            "C1orf226",
            "SLC2A9",
            "C1orf56",
            "EFNA1",
            "CREB3L4",
            "TM6SF1",
            "BMP2K",
            "PBXIP1",
            "TMEM55A",
            "EFNA4",
            "KLF6",
            "INPP1",
            "THEM4",
            "RIT1",
            "RAB25",
            "MSTO1",
            "RAB8B",
            "TDRKH",
            "LIMS1",
            "ZSCAN16",
            "RUSC1",
            "PMVK",
            "VPS72",
            "FAM189B",
            "C1orf66",
            "ZNF687",
            "BTBD6",
            "UBQLN4",
            "RB1",
            "MFSD1",
            "DNAJB14",
            "USP21",
            "SCAMP3",
            "PYCR2",
            "CRTC2",
            "NCKIPSD",
            "EHD4",
            "NVL",
            "RAB13",
            "UBE2Q1",
            "YY1AP1",
            "C9orf114",
            "ZNF672",
            "C1orf77",
            "SNAP47",
            "RNF220"
        ]
    },
    {
        "golabel": "RAD51_regulon_activity",
        "gene": [
            "SLC1A6",
            "VAX1",
            "CREG2",
            "OR1F1",
            "GBX2",
            "GLDC",
            "RHOV",
            "MKRN3",
            "HIST1H1B",
            "CYP4B1",
            "GGH",
            "SUSD2",
            "C7orf68",
            "FLJ42875",
            "LOC283174",
            "CACNA2D2",
            "HIST1H2BO",
            "ARNTL2",
            "IGSF9B",
            "HIST1H2AG",
            "LOC645166",
            "TMEM132E",
            "MAP6",
            "SPC24",
            "SHE",
            "SLC2A1",
            "ABO",
            "CCNB2",
            "ATP1B2",
            "GPR116",
            "C18orf56",
            "FAM189A2",
            "OIP5",
            "GINS2",
            "CKS2",
            "TPPP",
            "MAD2L1",
            "MCM10",
            "CIB2",
            "C1orf116",
            "TMPRSS2",
            "AGMAT",
            "RACGAP1P",
            "NUF2",
            "ITGA9",
            "CDC45",
            "EPR1",
            "KIF23",
            "CDC6",
            "CENPW",
            "SPC25",
            "UCK2",
            "CDC25C",
            "DAPK2",
            "BIRC5",
            "CDC20",
            "NFIX",
            "CDCA3",
            "CDK1",
            "LRP2BP",
            "CCNA2",
            "BUB1B",
            "LOC283070",
            "DNALI1",
            "CKS1B",
            "SKA3",
            "C19orf40",
            "FAM54A",
            "KIAA0101",
            "PFKP",
            "C19orf28",
            "ORC6L",
            "TYMS",
            "PLK1",
            "C14orf143",
            "UBE2T",
            "CEP55",
            "MALL",
            "CCNB1",
            "MLF1IP",
            "CGNL1",
            "C7orf41",
            "PPP1R12B",
            "SEMA4A",
            "CHEK2",
            "ADA",
            "TK1",
            "CENPM",
            "PRC1",
            "ECE2",
            "ACSS1",
            "RACGAP1",
            "RFC3",
            "CISH",
            "NUSAP1",
            "SNED1",
            "ACOT7",
            "DISP1",
            "SYNE1",
            "WDR76",
            "C15orf23",
            "GMNN",
            "LOC728554",
            "IFT140",
            "OPHN1",
            "CYFIP2",
            "NOD1",
            "CEBPG",
            "GPD1L",
            "ARSD",
            "POC1A",
            "CENPN",
            "TENC1",
            "FLJ90757",
            "GLA",
            "BTBD9",
            "PCNA",
            "PAM",
            "PTPRE",
            "PRICKLE2",
            "PPFIBP2",
            "ATP1A1",
            "DTYMK",
            "RANBP1",
            "EPB41L4A",
            "ATP1B3",
            "PBXIP1",
            "FANCD2",
            "UBA2",
            "RAN",
            "CCDC58",
            "HHAT",
            "H2AFZ",
            "ARHGEF9",
            "MAPK6",
            "PDSS1",
            "ZWILCH",
            "CRY2",
            "LTBP3",
            "C5orf53",
            "C3orf18",
            "PGAM5",
            "PXMP2",
            "MASTL",
            "GALNT11",
            "TUBA1C",
            "GPI",
            "C15orf41",
            "MRPL11",
            "SNRPD1",
            "NUP37",
            "DCUN1D5",
            "TMEM63A",
            "SNRPA1",
            "C16orf5",
            "TIPIN",
            "CYP4V2",
            "MRPL47",
            "TUBA1B",
            "TMEM8B",
            "C9orf30",
            "C20orf108",
            "EIF4A3",
            "PSMA5",
            "GNRHR2",
            "FUCA2",
            "SMPD1",
            "DNAJC9",
            "OBFC2B",
            "KIAA0319L",
            "PGAM1",
            "ARL6IP1",
            "PA2G4",
            "CHCHD3",
            "DUT",
            "BBS1",
            "RCE1",
            "SFRS9",
            "NIPA2",
            "SAE1",
            "AP2A2",
            "TPM3",
            "TERF2IP",
            "HAUS2",
            "PWP1",
            "CEP68",
            "LRRC57"
        ]
    },
    {
        "golabel": "RAD54B_regulon_activity",
        "gene": [
            "RIPPLY2",
            "TAL2",
            "TMEM132E",
            "CCNE2",
            "LOC148709",
            "ZBTB7C",
            "RNF39",
            "TROAP",
            "POLE2",
            "CENPA",
            "MCM10",
            "C12orf48",
            "DEPDC1",
            "AURKB",
            "FAM24B",
            "NUF2",
            "TTK",
            "KIF15",
            "DLGAP5",
            "EPR1",
            "KIF2C",
            "CDC6",
            "RAD51AP1",
            "DSCC1",
            "NCAPG",
            "MELK",
            "SIP1",
            "NEK2",
            "NCAPH",
            "BUB1",
            "RECQL4",
            "CDCA5",
            "ORC6L",
            "CCDC138",
            "DNA2",
            "FAM92A1",
            "ATAD2",
            "ZWINT",
            "MTBP",
            "WDR67",
            "DISP1",
            "MRPL13",
            "LOC728554",
            "TCEB1",
            "CD97",
            "DPYSL2",
            "TMEM173",
            "BAIAP2",
            "MRPL15",
            "CTSD",
            "B3GNT9",
            "PDRG1",
            "NUDCD1",
            "CHORDC1",
            "OTUD6B",
            "DCAF13",
            "RAD21",
            "MTERFD1",
            "RAE1",
            "HSP90AA1",
            "ZC3H8",
            "SLC25A23",
            "VAPB",
            "ZDHHC7",
            "INTS8",
            "PDE4A",
            "TAF2",
            "POLR3GL",
            "FOXP1",
            "PTDSS1",
            "CSTF3",
            "ARHGAP1"
        ]
    },
    {
        "golabel": "RAI1_regulon_activity",
        "gene": [
            "SMCR5",
            "DNAH2",
            "BAG2",
            "SNX10",
            "GSTO1",
            "ARL11",
            "PFDN5",
            "COX7B",
            "COX7A2",
            "SELT",
            "FOXP4",
            "NDUFA4",
            "FAM83G",
            "SREBF1",
            "B2M",
            "NDUFB5",
            "TMEM126B",
            "CCDC88C",
            "CELSR1",
            "MYL6",
            "LLGL1",
            "AHDC1",
            "PKD1",
            "MRPL11",
            "MPRIP",
            "UBE2E2",
            "LRP5",
            "SUB1",
            "KIAA0284",
            "HDDC2",
            "WBP5",
            "NDUFB3",
            "ATP6V0E1",
            "FAM96A",
            "SIPA1L3",
            "PPIL3",
            "TNRC18",
            "PFAS",
            "C9orf21",
            "LYSMD2",
            "TMEM126A",
            "TOM1L2",
            "DAB2IP",
            "SNX3",
            "C20orf112",
            "EPN2",
            "BCR",
            "TOP3A",
            "ARPC5",
            "ARPC3",
            "C15orf24",
            "KDM6B",
            "ABR",
            "CHD3",
            "NEURL4",
            "TNKS1BP1",
            "NCOR1",
            "C4orf27",
            "CIC",
            "RWDD1",
            "DPH3",
            "RERE",
            "RNASEH2B",
            "NDUFA12",
            "BLOC1S2",
            "MAPK7",
            "PRR12",
            "CCDC53",
            "SMCR8",
            "USP22",
            "ZNF786",
            "WDR41",
            "NUMA1",
            "ATG2A",
            "ANAPC10",
            "TSC2",
            "LSM3",
            "MED9",
            "SPCS1",
            "FLII",
            "TECPR2",
            "KDM4B",
            "MORC2",
            "MDH1",
            "EIF1B",
            "CNBP",
            "UBC",
            "MNT",
            "ATG3",
            "ALKBH5",
            "UBE2D3",
            "SAR1A"
        ]
    },
    {
        "golabel": "RAPGEF3_regulon_activity",
        "gene": [
            "AQP5",
            "VSIG2",
            "LOC100130933",
            "GIPR",
            "PRICKLE4",
            "CDKN3",
            "SLC25A27",
            "CAPN8",
            "MAD2L1",
            "MCM10",
            "C12orf48",
            "DEPDC1",
            "ZFPM1",
            "EPR1",
            "HMMR",
            "CKAP2L",
            "CCNA2",
            "SGOL1",
            "WDR52",
            "TOP2A",
            "ALS2CL",
            "TYMS",
            "CCNB1",
            "PDXDC2",
            "C15orf52",
            "NCRNA00174",
            "CSAD",
            "NEIL1",
            "CCDC64B",
            "CKAP2",
            "LDLRAD2",
            "KPNA2",
            "ZNF219",
            "C16orf86",
            "C16orf48",
            "IFT172",
            "KIAA0513",
            "TENC1",
            "FAM116B",
            "C11orf61",
            "PPAT",
            "UBA2",
            "JMJD7-PLA2G4B",
            "RAN",
            "MCM6",
            "CDK10",
            "TUBGCP6",
            "PAICS",
            "SELO",
            "TAF1C",
            "MRPL42",
            "NLN",
            "WDR12",
            "MAN2C1",
            "TRIM3",
            "OLA1",
            "IQSEC2",
            "SGSM3",
            "HDAC10",
            "SEH1L",
            "EIF4A3",
            "CCT4",
            "YWHAQ",
            "METTL2A",
            "WDR43",
            "TRIOBP",
            "USP14",
            "PSD4",
            "HDAC7",
            "ZC3H15",
            "ABCE1",
            "SUMO2",
            "NOL11",
            "SAPS2",
            "SET",
            "DARS",
            "LSM12",
            "HNRNPC",
            "YY1"
        ]
    },
    {
        "golabel": "RAPGEF5_regulon_activity",
        "gene": [
            "LYPD3",
            "GGH",
            "LRRC31",
            "LOC283174",
            "NEIL3",
            "IGSF9B",
            "PTPN13",
            "XKRX",
            "HLF",
            "CYTH3",
            "SCN7A",
            "COL21A1",
            "SHE",
            "VIPR1",
            "GPR116",
            "SCN4B",
            "PGD",
            "PFN2",
            "ITGA9",
            "TBX4",
            "ETV1",
            "SLC12A2",
            "RBMS3",
            "PLEKHH2",
            "AUTS2",
            "EPHA4",
            "DUSP6",
            "MACC1",
            "SHROOM4",
            "SALL2",
            "FAM129A",
            "C10orf72",
            "IL6ST",
            "FAM162A",
            "GALNT10",
            "PRDX1",
            "ZSWIM5",
            "FRY",
            "REL",
            "HIP1",
            "RALGAPA2",
            "MICAL2",
            "GUCY1A3",
            "HECW2",
            "RPS6KA2",
            "RGL1",
            "PTPRE",
            "CADPS2",
            "DOCK9",
            "C20orf24",
            "LIX1L",
            "MAGI1",
            "SPRY1",
            "CCDC58",
            "TOMM40",
            "H2AFZ",
            "TTC28",
            "C5orf53",
            "SARM1",
            "TMEM63A",
            "PIK3R1",
            "MRPL47",
            "EIF5A",
            "TPI1",
            "MID2",
            "PRKCE",
            "MACF1",
            "SPRED2",
            "C12orf44",
            "RUVBL1",
            "PKM2",
            "SYNJ1",
            "MKL2",
            "MITD1",
            "CXorf23",
            "ARID4A",
            "GTF2E2",
            "TPD52L2",
            "MYO1B",
            "SNX13",
            "TFG",
            "ZNF295",
            "YPEL2",
            "C3orf1",
            "FBXW11",
            "DYNLL1",
            "PSMD7",
            "MED6"
        ]
    },
    {
        "golabel": "RARA_regulon_activity",
        "gene": [
            "FAM83B",
            "CX3CL1",
            "CACNB1",
            "TREX2",
            "ICAM1",
            "CDC42EP1",
            "CRIP2",
            "CCNJL",
            "TDP2",
            "C13orf37",
            "ABHD3",
            "SDC1",
            "FLJ90757",
            "VWA1",
            "SLC9A3R2",
            "FHOD1",
            "PEX11G",
            "TMPO",
            "IGFBP4",
            "LTBP3",
            "AHDC1",
            "ATE1",
            "CUEDC1",
            "THRA",
            "PLXNB2",
            "SPATA20",
            "CPNE2",
            "TMEM25",
            "TUBG2",
            "ROGDI",
            "CASKIN2",
            "CHST12",
            "PLEKHH3",
            "IQSEC2",
            "C7orf27",
            "KCTD9",
            "ORMDL3",
            "LOC729082",
            "MITD1",
            "XYLT2",
            "MED24",
            "C17orf70",
            "ZNF213",
            "ZC3H15",
            "MED16",
            "DBNL",
            "FAM108B1",
            "BUB3",
            "CLPX",
            "PIP4K2B",
            "KCTD2",
            "NARG2",
            "RAB11B",
            "GTF2H1",
            "AP1M1",
            "FAM134C",
            "CSNK1D"
        ]
    },
    {
        "golabel": "RB1_regulon_activity",
        "gene": [
            "FGL2",
            "SRGN",
            "PDE1A",
            "SRCIN1",
            "DKK2",
            "CALCRL",
            "PCDH17",
            "LXN",
            "FAM53A",
            "ELTD1",
            "FAM175A",
            "PMP22",
            "ANKS3",
            "AZI1",
            "WDR34",
            "NDFIP2",
            "CCHCR1",
            "RAB8B",
            "C4orf32",
            "SERPINB8",
            "F8A1",
            "LRRC45",
            "BMI1",
            "BNIP3L",
            "C7orf27",
            "ITM2B",
            "KCTD9",
            "RAP2A",
            "SEPT10",
            "MTMR6",
            "DENND4A",
            "NSUN5",
            "C12orf4",
            "KLHL22",
            "KPNA3",
            "C3orf64",
            "ABHD13",
            "C12orf5",
            "DPP8",
            "XYLT2",
            "E4F1",
            "PEX10",
            "GRINL1A",
            "M6PR",
            "PPP2CB",
            "SUCLA2",
            "AP1AR",
            "SPCS3",
            "PYGO2",
            "STX7",
            "VPS4B",
            "ELF1",
            "FBXO8",
            "ESD",
            "SHOC2",
            "MED4",
            "PLDN",
            "AZI2",
            "BTBD1",
            "CSNK1D"
        ]
    },
    {
        "golabel": "RBBP4_regulon_activity",
        "gene": [
            "ZBTB8B",
            "RIMKLA",
            "GBAS",
            "ZNF681",
            "TXNDC16",
            "ADCY4",
            "RIN1",
            "ZNF675",
            "SOX18",
            "CLTB",
            "PLEC",
            "KLHL23",
            "SH2D3C",
            "RNF138P1",
            "MLKL",
            "FMNL1",
            "TYMP",
            "C20orf177",
            "INF2",
            "MSH2",
            "ZNF684",
            "ZNF670",
            "MED28",
            "C2orf15",
            "SLC25A33",
            "CEP70",
            "ZNF420",
            "L2HGDH",
            "IQCC",
            "CCDC23",
            "APITD1",
            "TRUB1",
            "CEP76",
            "LCORL",
            "FASTKD3",
            "ZNF124",
            "RCN2",
            "PXN",
            "CCDC21",
            "ALS2CR4",
            "BTF3L4",
            "MYNN",
            "ARHGEF1",
            "NARS2",
            "MRPL49",
            "COMMD2",
            "RMI1",
            "RAD1",
            "ARL3",
            "FAM160B2",
            "ZYX",
            "TICAM1",
            "LIN52",
            "AK2",
            "CCDC121",
            "YWHAQ",
            "PDIK1L",
            "ACADM",
            "EFCAB7",
            "SRP9",
            "AGBL5",
            "ORC4L",
            "TM2D1",
            "NSL1",
            "RPAP2",
            "CRY1",
            "MOBKL3",
            "DEM1",
            "LRRC40",
            "KDM1A",
            "ZCCHC17",
            "PACRGL",
            "DOCK6",
            "DHX40",
            "FAM200A",
            "ZNF669",
            "HSF2",
            "RNF2",
            "TAF1B",
            "GMCL1",
            "ALG6",
            "PARS2",
            "MEAF6",
            "MIER2",
            "LZIC",
            "TADA1",
            "ZFP1",
            "RYK",
            "NUP160",
            "DBT",
            "SNRNP40",
            "PCNP",
            "ZMPSTE24",
            "PPM1D",
            "THAP5",
            "SIKE1",
            "DFFA",
            "HMGXB4",
            "HDAC1",
            "ZBTB7A",
            "CDC5L",
            "MUTED",
            "AKIRIN1",
            "C1orf109",
            "CAMTA2",
            "PI4K2A",
            "REXO1",
            "DDOST",
            "PPP1CB",
            "PIP5K1C",
            "ZBTB8A",
            "CSK",
            "SMARCE1",
            "RHOG",
            "RTN3",
            "CDC37",
            "CYTH1",
            "C17orf80",
            "NSUN4",
            "PRKRA",
            "CEP57",
            "S100PBP",
            "RHOT1",
            "HNRPLL",
            "C1orf83",
            "DHX15",
            "PNRC2",
            "COIL",
            "SF3A3",
            "CSTF1",
            "PPP1R8",
            "XRCC5",
            "ZFR",
            "ZMYM4",
            "MARCH7",
            "BSDC1",
            "UBXN4",
            "YTHDF2",
            "RBMX",
            "SFRS13A",
            "MATR3",
            "KHDRBS1"
        ]
    },
    {
        "golabel": "RBL1_regulon_activity",
        "gene": [
            "DLX2",
            "CACNA2D1",
            "PLA2G10",
            "MSLN",
            "ERN2",
            "GPR158",
            "SLC16A1",
            "MMP12",
            "ADAM22",
            "RNF157",
            "CLIC3",
            "OVGP1",
            "CLSPN",
            "GJC1",
            "DNAJC6",
            "ATAD3C",
            "SULT1A2",
            "ALDH3B1",
            "METRN",
            "PRR11",
            "GSTT1",
            "C10orf95",
            "NOXA1",
            "TMEM105",
            "BRIP1",
            "SULT1A1",
            "FBXL8",
            "TST",
            "IDUA",
            "PMM1",
            "TMEM92",
            "MLPH",
            "GPRC5C",
            "LOXL3",
            "SLC22A18",
            "ZNF93",
            "FAM83E",
            "ERMP1",
            "EIF4EBP3",
            "NUP155",
            "CCDC64B",
            "MUC1",
            "TSTD1",
            "C14orf145",
            "TMEM125",
            "CCDC15",
            "C11orf52",
            "XYLB",
            "HYI",
            "SNHG8",
            "TJP3",
            "FBXO5",
            "KLHL5",
            "TRERF1",
            "ZNF286A",
            "TSTA3",
            "SEPT11",
            "SEC23A",
            "TMED3",
            "C1orf210",
            "ZNF518B",
            "HOMER1",
            "C6orf150",
            "RASSF7",
            "FAAH",
            "ELL3",
            "CCDC88A",
            "CHKB",
            "DGAT1",
            "PRSS8",
            "RILP",
            "MGC16275",
            "RAB17",
            "ACADS",
            "PEX11G",
            "FAH",
            "SNRPN",
            "ARRDC2",
            "PSIP1",
            "ATP13A3",
            "SYNJ2",
            "NRIP1",
            "FAM168A",
            "ELMO3",
            "TOPBP1",
            "MSRA",
            "C6orf167",
            "C9orf103",
            "CYB5D2",
            "RAB25",
            "TMC4",
            "C14orf106",
            "HAUS6",
            "ASAP1",
            "CRB3",
            "MGC57346",
            "RECQL",
            "YEATS2",
            "FBXL15",
            "DNMT1",
            "C22orf32",
            "SPR",
            "SMCHD1",
            "RIF1",
            "ZNF524",
            "KIF2A",
            "DDRGK1",
            "CD151",
            "ZSWIM7",
            "RPL3",
            "ETFB",
            "TTC38",
            "SMC3",
            "HDAC11",
            "B3GALT4",
            "TRIM8",
            "TMEM134",
            "ABHD14B",
            "CKAP5",
            "ANKIB1",
            "GLTSCR2",
            "EIF2C3",
            "GNPTG",
            "POLA1",
            "TTL",
            "PHF6",
            "DHRS12",
            "RAP2A",
            "ZNF146",
            "ACAA1",
            "C9orf95",
            "TMEM219",
            "PRKD3",
            "SMC1A",
            "CASP8AP2",
            "HAGH",
            "KIAA0947",
            "COQ4",
            "P4HTM",
            "ANAPC1",
            "JMJD8",
            "TMEM129",
            "GTF2H3",
            "DEK",
            "CLN3",
            "DNAJC17",
            "C1orf96",
            "TTPAL",
            "C14orf118",
            "SPAG7",
            "PCBD2",
            "ASCC3",
            "TOM1",
            "C6orf120",
            "BCL2L11",
            "RNPEP",
            "TEX264",
            "GEMIN8",
            "POFUT1",
            "TCF25",
            "ALG1",
            "NEDD1",
            "IMP3",
            "SRPK2",
            "DALRD3",
            "LSM11",
            "KIAA0406",
            "PPP1R12A",
            "RPRD1B",
            "GNA13",
            "DHX35",
            "MTIF3",
            "PHF20",
            "ZW10",
            "CBLL1",
            "ADNP",
            "SIRT3",
            "ITCH",
            "PALB2",
            "RALGAPB",
            "MAPRE1",
            "CTNNBL1",
            "CCDC115",
            "PRPF40A",
            "ZBTB2",
            "KBTBD2",
            "CTDSP1"
        ]
    },
    {
        "golabel": "RBL2_regulon_activity",
        "gene": [
            "GRIA1",
            "MUSK",
            "SCN7A",
            "ITGA8",
            "CCNB2",
            "UBE2C",
            "IER5L",
            "CDKN3",
            "F12",
            "MYBL2",
            "TROAP",
            "CENPA",
            "AURKB",
            "CDC45",
            "CENPW",
            "BIRC5",
            "CDC20",
            "HJURP",
            "CDCA3",
            "SKA3",
            "LOC541471",
            "UBE2S",
            "C9orf140",
            "LRFN4",
            "ERN1",
            "PKMYT1",
            "CENPM",
            "IL6R",
            "C16orf59",
            "RNASEH2A",
            "C19orf48",
            "NME1",
            "LOC92659",
            "DTYMK",
            "RANBP1",
            "TUBA1C",
            "SNRPF",
            "C14orf156",
            "MYLIP",
            "DDX39",
            "C5orf41",
            "ALS2CR8",
            "HRAS",
            "C12orf45",
            "POLR2C",
            "PPAN",
            "SRM",
            "PPIA",
            "NFATC3",
            "PHKB",
            "ADAT1",
            "PDP2",
            "CHD9",
            "SLC27A4",
            "C15orf38",
            "EIF2C4",
            "RUVBL2",
            "FTO",
            "NOC4L",
            "UBE2M",
            "WWP2",
            "AKTIP",
            "ITFG1",
            "TIMM44",
            "TSPYL1",
            "BBS2",
            "KIAA0240",
            "TBCK",
            "FTSJD1",
            "SAP30L",
            "ZMYND11",
            "MON1B",
            "PPM1G",
            "KLHL20",
            "KIAA0776",
            "ZC3H7A",
            "NUDT21",
            "KCTD18"
        ]
    },
    {
        "golabel": "RBM10_regulon_activity",
        "gene": [
            "CPA3",
            "GPR34",
            "EVI2A",
            "TRAM1",
            "HRH1",
            "SPRED1",
            "IFNGR1",
            "GNG10",
            "GRIPAP1",
            "MR1",
            "LEPROT",
            "ARL6IP5",
            "BBS12",
            "GAK",
            "ZNF768",
            "BTD",
            "UBLCP1",
            "MTA1",
            "CDK16",
            "RNF141",
            "DMAP1",
            "EHMT2",
            "DCAKD",
            "TMEM43",
            "ZNF335",
            "CCDC22",
            "PDHA1",
            "KDM5C",
            "BANP",
            "DDX54",
            "CMTM6",
            "ZNF561",
            "SRRT",
            "TSR2",
            "LAS1L",
            "ARL8B",
            "NAIF1",
            "DIS3L2",
            "AZI2",
            "RBM14"
        ]
    },
    {
        "golabel": "RBM27_regulon_activity",
        "gene": [
            "CSNK1A1L",
            "GGTLC2",
            "ANKRD32",
            "RENBP",
            "MAGIX",
            "EGFL8",
            "DPM3",
            "C22orf36",
            "GMCL1L",
            "FAM176B",
            "CCDC88B",
            "MAP1LC3A",
            "LOC151534",
            "N4BP2",
            "TNFRSF14",
            "ME3",
            "CENPT",
            "C6orf226",
            "FER",
            "LANCL1",
            "SBNO1",
            "TSPO",
            "GTF2A1",
            "DDX21",
            "LNPEP",
            "CTSA",
            "RC3H2",
            "TRMT2A",
            "KIF2A",
            "GET4",
            "TMUB1",
            "NR3C1",
            "FAM127A",
            "TP53I13",
            "C11orf67",
            "THAP3",
            "FASTK",
            "PANK3",
            "GGA1",
            "HSP90AA1",
            "C1orf91",
            "SGSM3",
            "ZHX1",
            "GTF3C4",
            "P2RX4",
            "CCDC130",
            "ZNF770",
            "C9orf41",
            "ZNF513",
            "HMGCR",
            "ANKRD13D",
            "TOPORS",
            "SH3GLB2",
            "GRN",
            "SPSB3",
            "FAM109B",
            "BAD",
            "STAG1",
            "LMF2",
            "MIIP",
            "SNAPC3",
            "TOP1",
            "IPO7",
            "SCAMP1",
            "KLHL22",
            "WDR45",
            "DPP8",
            "IPO11",
            "SLC39A13",
            "CANX",
            "EIF4B",
            "ATG4B",
            "RNF166",
            "SKIV2L2",
            "DGCR14",
            "DCAF10",
            "KIAA1430",
            "HSPA9",
            "TMED7",
            "GPR137",
            "TNPO1",
            "LARP1",
            "G3BP1",
            "LSM11",
            "AFF4",
            "GEMIN5",
            "FBXO21",
            "SRFBP1",
            "RFC1",
            "VEGFB",
            "MSH3",
            "CNOT6",
            "HSPA4",
            "CSNK1A1",
            "CWC27",
            "WDR36",
            "NEK4",
            "ATAD1",
            "FAM53C",
            "KDM3B",
            "MFAP3",
            "ZNF148",
            "CSNK1G3",
            "SLU7",
            "ZFP91",
            "DDX46",
            "ETF1",
            "WAPAL",
            "HNRNPR",
            "PGGT1B",
            "PHAX",
            "BCLAF1",
            "DHX9",
            "RBM12",
            "CTCF",
            "MATR3",
            "HNRNPK"
        ]
    },
    {
        "golabel": "RBM6_regulon_activity",
        "gene": [
            "TMEM89",
            "TBC1D3G",
            "FGF17",
            "C1orf168",
            "C17orf66",
            "UCKL1AS",
            "LOC440896",
            "C21orf96",
            "NCRNA00202",
            "CYP2D7P1",
            "DZIP1L",
            "AMAC1L3",
            "C12orf71",
            "LOC221442",
            "LOC283663",
            "LOC162632",
            "C3orf48",
            "LOC619207",
            "GABRR2",
            "NCRNA00105",
            "TTC21A",
            "SLC9A10",
            "C19orf34",
            "POM121L1P",
            "KCNAB3",
            "FLJ37307",
            "COL27A1",
            "DNAH1",
            "SMCR5",
            "FLJ40292",
            "NRADDP",
            "C20orf106",
            "NCRNA00173",
            "AMAC1L2",
            "NR2E3",
            "DNHD1",
            "SLC25A27",
            "GNB3",
            "CELF6",
            "PXT1",
            "TAS2R10",
            "POLN",
            "ADAM20",
            "LOC100131434",
            "NCRNA00107",
            "CNTD1",
            "TTN",
            "COLQ",
            "SNORD116-28",
            "LOC100272228",
            "MIR17HG",
            "WHAMML2",
            "ZNF662",
            "SNORA7B",
            "HCG2P7",
            "CRIPAK",
            "NPIPL3",
            "POM121L10P",
            "TAS2R4",
            "WSB1",
            "GOLGA8B",
            "SEC31B",
            "C3orf35",
            "PABPC1L",
            "GABBR1",
            "LOC100101266",
            "NBPF7",
            "GOLGA8A",
            "WDR52",
            "GOLGA6L5",
            "NEAT1",
            "RRN3P1",
            "AGAP8",
            "GOLGA2B",
            "C17orf47",
            "CPT1B",
            "C6orf201",
            "IPW",
            "UBE2Q2P1",
            "LRP5L",
            "LOC91316",
            "ATG16L2",
            "RBM44",
            "TSSK3",
            "C1orf220",
            "B3GAT2",
            "ASB16",
            "GNRH1",
            "PNN",
            "HERC2P2",
            "LOC100132247",
            "KCNQ1OT1",
            "RPL23AP64",
            "LOC100128842",
            "PDXDC2",
            "LOC286367",
            "NCRNA00201",
            "C9orf45",
            "C6orf163",
            "GHRLOS",
            "LOC338799",
            "SNORA39",
            "CSAD",
            "CHKB-CPT1B",
            "GOLGA6L9",
            "RGPD1",
            "RUNDC2C",
            "MAPK8IP3",
            "DPRXP4",
            "AHSA2",
            "TAS2R14",
            "CATSPER2",
            "KCNIP2",
            "SLC26A6",
            "C1orf104",
            "TTLL3",
            "LOC729603",
            "CC2D2B",
            "LOC100190986",
            "LOC90834",
            "LTB4R2",
            "CROCCL2",
            "L3MBTL",
            "GOLGA6L10",
            "LOC646471",
            "LOC100272146",
            "LOC100130557",
            "LOC100132287",
            "LOC400927",
            "KIAA0895L",
            "PILRB",
            "CDK3",
            "FAM118A",
            "LENG8",
            "WDR27",
            "ENGASE",
            "CCNL2",
            "CCDC14",
            "WHAMML1",
            "CG030",
            "LY6G5B",
            "ANKRD36",
            "PPP1R3E",
            "LOC283314",
            "AGAP6",
            "CROCCL1",
            "LOC100133331",
            "INE1",
            "FLJ10213",
            "KIAA1530",
            "GPR113",
            "SNHG12",
            "LOC388692",
            "AGAP4",
            "SNORD1C",
            "LOC150776",
            "TSSK4",
            "VAMP1",
            "KLHL3",
            "C5orf35",
            "LOC642826",
            "NBPF15",
            "CNIH",
            "BMS1P5",
            "OTUD3",
            "FLJ45340",
            "FAM193B",
            "CDK5RAP3",
            "TBC1D3",
            "LOC339047",
            "ZNF37B",
            "RPL32P3",
            "LOC200030",
            "ASB14",
            "MICAL1",
            "ZNF767",
            "MAP3K12",
            "WASH7P",
            "GIGYF1",
            "PLCD4",
            "NPIP",
            "FAM156A",
            "PASK",
            "NKTR",
            "TUBGCP6",
            "COX7A2L",
            "AFG3L1",
            "USP6",
            "SLC25A5",
            "TMEM182",
            "ACAD11",
            "ZNF589",
            "ANKDD1A",
            "PAN2",
            "LUC7L",
            "ZNF514",
            "ZNF337",
            "PHC1",
            "ZNF10",
            "ZNF276",
            "KIAA0467",
            "EVL",
            "STK36",
            "STX16",
            "TAF1C",
            "MDM4",
            "COPS3",
            "SFRS17A",
            "MRPL49",
            "ZNF785",
            "CLCN6",
            "SFRS18",
            "C17orf56",
            "GBA2",
            "LUC7L3",
            "LOC100190939",
            "SFRS14",
            "NPHP3",
            "OFD1",
            "INPP5E",
            "MOBKL3",
            "DENND4B",
            "FNBP4",
            "ERICH1",
            "TSC1",
            "ZBTB40",
            "ZRSR2",
            "SNRNP70",
            "PPP1R2P3",
            "RBM5",
            "PCGF3",
            "KIAA0913",
            "EXOG",
            "DIP2A",
            "ASCC1",
            "COPS8",
            "ZMPSTE24",
            "WDR6",
            "ACIN1",
            "BAT1",
            "RBM33",
            "SETD5",
            "RNF41",
            "DGCR8",
            "NXF1",
            "BCL2L13",
            "PCF11",
            "RBM25",
            "NFATC2IP",
            "BTN2A1",
            "PTPN23",
            "OGFOD1",
            "DDX5",
            "HNRPDL"
        ]
    },
    {
        "golabel": "RBM7_regulon_activity",
        "gene": [
            "IL8",
            "INE2",
            "FUNDC2P2",
            "OSTCL",
            "KBTBD3",
            "RDX",
            "MORF4",
            "SEC23A",
            "D2HGDH",
            "FDX1",
            "CNIH",
            "FAM118B",
            "MPZL3",
            "KCNC4",
            "DNAJB9",
            "CDK5RAP3",
            "GIGYF1",
            "CREM",
            "GPR180",
            "OSTC",
            "NDFIP2",
            "TGDS",
            "TWSG1",
            "PPP2R2A",
            "LOC150786",
            "CCNC",
            "TRUB1",
            "CASP4",
            "LEPROT",
            "TFAM",
            "TNK2",
            "TAF13",
            "LRRC45",
            "TMX1",
            "CASKIN2",
            "PUS7L",
            "TMEM123",
            "C17orf56",
            "DCUN1D1",
            "TMEM218",
            "LRCH4",
            "C7orf27",
            "C5orf15",
            "PAFAH1B2",
            "RECQL5",
            "KIAA1826",
            "NRAS",
            "PRKRIR",
            "METTL9",
            "COX19",
            "COG6",
            "ATF1",
            "SDHD",
            "INPP5E",
            "MOBKL3",
            "RCHY1",
            "SNRNP70",
            "HSPA8",
            "KPNA3",
            "ABHD13",
            "DR1",
            "AKAP8L",
            "IPO11",
            "UEVLD",
            "C6orf211",
            "MOBKL1B",
            "LRSAM1",
            "AMD1",
            "SRP72",
            "TMED7",
            "BIRC2",
            "SEC24A",
            "DLAT",
            "NUP160",
            "GRINL1A",
            "LYSMD3",
            "CTDSPL2",
            "REXO2",
            "ZNF259",
            "COPS4",
            "HDGFRP2",
            "ANAPC2",
            "CAMTA2",
            "REXO1",
            "RNGTT",
            "C5orf24",
            "RAB6A",
            "PUS3",
            "MORF4L1",
            "FBXL4",
            "COG1",
            "WBP2",
            "COPB1",
            "ITCH",
            "AASDHPPT",
            "SPTY2D1",
            "GTF2H1",
            "ABCB7",
            "C11orf57",
            "PLDN",
            "STRADA",
            "CUL5",
            "TTC15",
            "HIAT1",
            "CAPRIN1",
            "SEPT2",
            "API5",
            "PLEKHA3",
            "BTBD1"
        ]
    },
    {
        "golabel": "RBMX_regulon_activity",
        "gene": [
            "KCNIP4",
            "LOC728819",
            "SIP1",
            "CCNB1IP1",
            "VASN",
            "SOX18",
            "DEPDC4",
            "PLEC",
            "ZNF519",
            "RPL36A",
            "HIC1",
            "MMRN2",
            "EAPP",
            "TBXA2R",
            "SLC9A3R2",
            "ITGB3BP",
            "AGRN",
            "IMMP1L",
            "MYADM",
            "CHPF",
            "VBP1",
            "C8orf37",
            "ATP5S",
            "ITGB5",
            "SLC25A5",
            "RFC5",
            "LRRCC1",
            "TIMM8A",
            "WFS1",
            "ZNF620",
            "ZNF253",
            "LIN9",
            "ZNF124",
            "GTF2H2C",
            "PHOSPHO2",
            "CTSZ",
            "ZNF280C",
            "EHD1",
            "MNAT1",
            "SLC43A2",
            "NUP35",
            "TAF9B",
            "SNRPE",
            "ILF2",
            "SLC25A14",
            "PRR3",
            "NSL1",
            "PLA2G15",
            "KIAA1539",
            "ZBTB26",
            "ZNF195",
            "CYB5R3",
            "PACRGL",
            "MAN2B2",
            "SCAMP2",
            "HSF2",
            "ATP13A2",
            "ZNF187",
            "POLR3F",
            "C15orf39",
            "TTC7A",
            "C2orf3",
            "RCOR3",
            "RAB11FIP5",
            "TADA1",
            "POC5",
            "EXOSC2",
            "ZRANB2",
            "RBMX2",
            "TAF9",
            "MYO1C",
            "THUMPD2",
            "ZBTB7A",
            "NAP1L1",
            "RBBP4",
            "PMS1",
            "ZNF140",
            "PIP5K1C",
            "CPSF6",
            "TMEM104",
            "NVL",
            "METAP2",
            "THAP9",
            "ARMCX5",
            "DKFZp761E198",
            "SFRS3",
            "AP1B1",
            "HNRNPA1",
            "HNRNPA1L2",
            "SFRS7",
            "SFRS6",
            "ANGEL2",
            "TIAL1",
            "C3orf17",
            "ATG9A",
            "SFRS2",
            "TRA2B",
            "SFRS13A",
            "MATR3",
            "HNRPDL",
            "SFRS1",
            "HNRNPL",
            "ZNF207"
        ]
    },
    {
        "golabel": "RC3H2_regulon_activity",
        "gene": [
            "ADAM22",
            "RHBDL1",
            "CYSLTR2",
            "PYGO1",
            "C4orf44",
            "C1orf53",
            "NFATC2",
            "SLC22A18",
            "GLI4",
            "MGAT5",
            "SPSB2",
            "AKAP2",
            "HYI",
            "LSMD1",
            "ABCA1",
            "C21orf57",
            "FLJ35220",
            "MAN2A1",
            "TRAPPC6A",
            "C12orf35",
            "FAM173A",
            "CCDC56",
            "CCDC24",
            "RASSF7",
            "WWTR1",
            "TAOK1",
            "MPST",
            "BOLA1",
            "SMC2",
            "NOL3",
            "LOC375190",
            "BMP2K",
            "RAPGEF6",
            "NENF",
            "ARHGAP8",
            "ZNF593",
            "UBXN7",
            "LOC729234",
            "NME3",
            "CEP97",
            "UGCG",
            "MRPL24",
            "SHISA4",
            "TMEM208",
            "RBX1",
            "KLF7",
            "C14orf106",
            "SBNO1",
            "MYST3",
            "B3GNTL1",
            "C17orf90",
            "UQCR10",
            "C9orf129",
            "PRDX5",
            "LNPEP",
            "MRP63",
            "STRN",
            "HMBOX1",
            "MRPL55",
            "RGP1",
            "NACC2",
            "TMEM2",
            "RIF1",
            "ASXL2",
            "KIF2A",
            "IFT27",
            "REST",
            "RASA2",
            "C9orf102",
            "PANK3",
            "ZMAT5",
            "MSRB2",
            "IGF2R",
            "PPOX",
            "MED1",
            "MED11",
            "GTF3C4",
            "GNPTG",
            "TRADD",
            "SPATA2L",
            "SUSD1",
            "TMEM219",
            "WDR13",
            "USE1",
            "CAMSAP1",
            "EYA3",
            "C1orf35",
            "DENND4A",
            "ZBTB26",
            "CLN3",
            "DNAJC17",
            "SSH1",
            "PIK3CA",
            "TRAPPC1",
            "COMMD4",
            "ROCK1",
            "C22orf40",
            "CCS",
            "TMEM53",
            "MPV17",
            "BBX",
            "CHMP6",
            "PRMT7",
            "WBP1",
            "C19orf39",
            "ALG12",
            "NPRL2",
            "ADNP2",
            "MAP3K2",
            "STUB1",
            "MCAT",
            "NARFL",
            "FKBP8",
            "RFX7",
            "PPP1R12A",
            "ZCCHC6",
            "PYCR2",
            "FKTN",
            "NIT1",
            "WDFY1",
            "PHF20",
            "WDR7",
            "C21orf33",
            "RAB13",
            "SMARCA5",
            "SETX",
            "INVS",
            "RABGAP1",
            "FBXW2",
            "RBM27",
            "GMEB1",
            "RNF20",
            "FUBP3"
        ]
    },
    {
        "golabel": "RCOR3_regulon_activity",
        "gene": [
            "SLC26A9",
            "FOSL1",
            "HTR1D",
            "XIRP1",
            "ERO1LB",
            "ARNTL2",
            "PTPRH",
            "KLF15",
            "HUNK",
            "GAS5",
            "MOSC1",
            "IL1RN",
            "SLC2A1",
            "STEAP1",
            "C1orf101",
            "ATP8A1",
            "SELENBP1",
            "GLCCI1",
            "EPHB2",
            "SPHK1",
            "B3GNT3",
            "INPP4B",
            "SFTA3",
            "FHL2",
            "ACADSB",
            "GJD3",
            "MMP14",
            "UHRF1",
            "HAPLN3",
            "SLC16A3",
            "C7orf41",
            "TGM2",
            "HMGN3",
            "FAM115C",
            "ZNF238",
            "EFHA2",
            "CABC1",
            "FLJ36031",
            "SOX13",
            "EFHD2",
            "C5orf45",
            "EPB41L5",
            "SLC25A16",
            "SLC41A1",
            "TMEM9",
            "ECE1",
            "KIAA1949",
            "KLHDC1",
            "HHAT",
            "MYADM",
            "ZNF778",
            "CTSB",
            "ARHGEF2",
            "CEP70",
            "TMEM50B",
            "FAM102A",
            "ITGB5",
            "SCAI",
            "C1orf203",
            "ORAI2",
            "FAM36A",
            "TAPT1",
            "C17orf51",
            "SPATS2L",
            "YOD1",
            "TMEM51",
            "ZNF124",
            "SH3YL1",
            "ARV1",
            "LYPLAL1",
            "RELB",
            "MRPS36",
            "PPP2R5A",
            "MDM4",
            "SH3BP1",
            "MOAP1",
            "KLHDC2",
            "ALS2CR8",
            "GABPB2",
            "H3F3A",
            "ZSCAN16",
            "GTF2IRD2",
            "RPAIN",
            "PLOD3",
            "EHD1",
            "CD46",
            "FAM117B",
            "ACTN4",
            "PIP4K2A",
            "PPOX",
            "PMF1",
            "BCL2L1",
            "EXT1",
            "ATL2",
            "CORO1C",
            "GNA12",
            "SPHAR",
            "PUS10",
            "ZYX",
            "GORAB",
            "TOMM20",
            "TSNAX",
            "PDIK1L",
            "SRP9",
            "LOC400657",
            "CLSTN1",
            "BPNT1",
            "AMFR",
            "NSL1",
            "GLT25D1",
            "TMEM41B",
            "CCDC125",
            "TMEM140",
            "PRUNE",
            "PCMTD2",
            "YKT6",
            "TATDN3",
            "LGTN",
            "YWHAG",
            "CD276",
            "RFXAP",
            "ZNF187",
            "SEPSECS",
            "PLBD2",
            "HDHD2",
            "PPPDE1",
            "C1orf27",
            "SMYD2",
            "ALDH9A1",
            "C1orf26",
            "TADA1",
            "SDCCAG8",
            "SCYL3",
            "USP21",
            "SH3GL1",
            "IKZF5",
            "TRIM13",
            "PEX11B",
            "C2orf18",
            "PYCR2",
            "LRRC59",
            "MTERFD2",
            "CSK",
            "DCAF6",
            "RAB4A",
            "DCAF8",
            "C1orf25",
            "NVL",
            "NAGA",
            "C1orf131",
            "ATPAF1",
            "DDX59",
            "NSUN4",
            "GGPS1",
            "COG2",
            "GNPAT",
            "ZC3H7A",
            "RAB3GAP2",
            "NUP133",
            "CFL1",
            "KLHL12",
            "ANGEL2",
            "RFWD2",
            "TMEM127",
            "RAB35",
            "EIF4H",
            "RAB8A",
            "GRB2",
            "RBMX"
        ]
    },
    {
        "golabel": "REL_regulon_activity",
        "gene": [
            "MICALCL",
            "FMN1",
            "KCNQ3",
            "SESN3",
            "IL6ST",
            "FNIP2",
            "ANKRD44",
            "SGPP2",
            "MAP3K13",
            "SGMS2",
            "ARHGEF38",
            "ZDHHC21",
            "PELI1",
            "NCOA2",
            "RAPGEF5",
            "DOCK9",
            "DENND1B",
            "EXOC6B",
            "NOTCH2",
            "TMEM223",
            "MYO9A",
            "TTBK2",
            "RAPH1",
            "C14orf156",
            "ASF1A",
            "PSMA3",
            "MTMR3",
            "HIPK3",
            "IKZF2",
            "LYST",
            "PRKCE",
            "PSMB6",
            "CRYBG3",
            "RASA2",
            "DCUN1D3",
            "PPCDC",
            "EML4",
            "MRPL2",
            "NDUFAF4",
            "NDUFC2",
            "FYCO1",
            "KIAA1370",
            "BANF1",
            "WRAP53",
            "PDE4DIP",
            "KDM6A",
            "MPV17L2",
            "G6PC3",
            "UBE2M",
            "IQGAP1",
            "WDR74",
            "HELZ",
            "BRMS1",
            "ITSN2",
            "DYNLRB1",
            "KIDINS220",
            "ZFPL1",
            "MRPL16",
            "CSNK2B",
            "TIMM22"
        ]
    },
    {
        "golabel": "RELB_regulon_activity",
        "gene": [
            "LYPD3",
            "UBD",
            "C12orf70",
            "ARNTL2",
            "TNFRSF9",
            "MMP9",
            "BIRC3",
            "MSC",
            "RHOF",
            "GPR116",
            "SPHK1",
            "LTB",
            "PTPRCAP",
            "FUT7",
            "IL4I1",
            "ADAM8",
            "ZC3H12A",
            "SFTA3",
            "PLAUR",
            "MEGF9",
            "HAPLN3",
            "C7orf41",
            "PSTPIP1",
            "IRAK2",
            "ADA",
            "IL32",
            "NEDD4L",
            "SLC2A6",
            "EMP3",
            "UNC13B",
            "TNFRSF4",
            "TNFAIP3",
            "ALDH6A1",
            "ETHE1",
            "PPP1R13L",
            "OCLN",
            "GPD1L",
            "FAM164C",
            "FLJ36031",
            "JAK3",
            "IL15RA",
            "EFHD2",
            "GKAP1",
            "TMEM170B",
            "BCL3",
            "ARRB1",
            "ALCAM",
            "ZNF296",
            "FMNL1",
            "TYMP",
            "CAPG",
            "RRAS",
            "CEP70",
            "RHBDF2",
            "ENPP4",
            "NFKBIE",
            "PLIN3",
            "SBNO2",
            "HSDL2",
            "NFKB2",
            "SH3BP1",
            "BCL2L12",
            "C20orf108",
            "ARID5A",
            "KLF16",
            "SHKBP1",
            "VASP",
            "HSDL1",
            "IKBKE",
            "ERF",
            "TICAM1",
            "JOSD2",
            "DMWD",
            "HIBCH",
            "SCAPER",
            "INADL",
            "RGS19",
            "AP2S1",
            "IL4R",
            "TRAF3",
            "RCOR3",
            "PLA2G12A",
            "SAPS1",
            "DBT",
            "MUT",
            "TNIP2",
            "TNIP1",
            "APBA3",
            "CSK",
            "RHOG",
            "DCTN4",
            "PRKD2",
            "AP2A1",
            "NUP62",
            "NRBP1"
        ]
    },
    {
        "golabel": "RERE_regulon_activity",
        "gene": [
            "CECR2",
            "USP2",
            "ALX3",
            "SGSM1",
            "CABLES1",
            "TMCC2",
            "MYH10",
            "SERPINB1",
            "NFIA",
            "IL28RA",
            "SHANK2",
            "C9orf46",
            "IGSF3",
            "SC4MOL",
            "HINT1",
            "SHROOM2",
            "CCDC88C",
            "MAGI1",
            "ATP8B2",
            "GLRX3",
            "CASZ1",
            "RPL26L1",
            "SARM1",
            "SAR1B",
            "CYB5R4",
            "SSBP3",
            "KIAA0467",
            "TNRC6C",
            "SSR3",
            "BZW1",
            "CHD6",
            "RAB11FIP3",
            "RAI1",
            "LYN",
            "PPIL3",
            "CLCN6",
            "IKZF4",
            "PSME1",
            "KIAA0495",
            "ZNF362",
            "BCL7A",
            "NPHP4",
            "CABIN1",
            "C15orf24",
            "ZNF629",
            "CISD2",
            "EPB41",
            "BRWD1",
            "C12orf5",
            "RAP1GDS1",
            "LOC643837",
            "UBE4B",
            "NUMA1",
            "TULP4",
            "COQ2",
            "MINPP1",
            "ANAPC10",
            "UBA3",
            "SPEN",
            "OXNAD1",
            "GTF2IP1",
            "PFDN1",
            "TCEB3",
            "SEPN1",
            "BRD1",
            "TMEM57",
            "RARS",
            "PANK4",
            "CNNM3",
            "CDK11B",
            "ANO10",
            "WDTC1",
            "RNF149",
            "RWDD4A",
            "PPP2CA",
            "DYRK1A",
            "SFRS4",
            "LRRC47"
        ]
    },
    {
        "golabel": "REST_regulon_activity",
        "gene": [
            "TNFSF15",
            "BTBD8",
            "P2RY1",
            "KIAA0754",
            "MBNL3",
            "LOC100271831",
            "DDR2",
            "PFN4",
            "SGK196",
            "COMTD1",
            "CDKL5",
            "DNLZ",
            "PARD3B",
            "GMCL1L",
            "GLI4",
            "MGAT5",
            "ZNF221",
            "TIMM16",
            "N4BP2",
            "RNF168",
            "C7orf47",
            "MRPL41",
            "RALGAPA2",
            "C21orf57",
            "LPP",
            "SERINC5",
            "C6orf125",
            "ZKSCAN1",
            "CDC14C",
            "ZNHIT1",
            "NCOA2",
            "PRDM11",
            "LCOR",
            "ENDOG",
            "WWTR1",
            "TAOK1",
            "NQO2",
            "FAM115A",
            "ZMAT3",
            "COX6C",
            "NENF",
            "C20orf177",
            "UBXN7",
            "TMTC2",
            "PDZD8",
            "CEP97",
            "ANKRD36BP1",
            "TRAPPC5",
            "KRTCAP2",
            "CCNT1",
            "PTPN14",
            "DDI2",
            "MRPS21",
            "CLOCK",
            "MXD3",
            "RAD54L2",
            "C20orf94",
            "SIK2",
            "FAM63B",
            "ZFYVE9",
            "MYO9A",
            "TTBK2",
            "RPS20",
            "ETV3",
            "MYST3",
            "SURF2",
            "SKIL",
            "GTF2A1",
            "NDUFB11",
            "C9orf142",
            "C17orf90",
            "PQBP1",
            "C9orf129",
            "PRKAR2A",
            "ZNF827",
            "CBX8",
            "ROCK2",
            "C9orf16",
            "NDUFS8",
            "RC3H2",
            "GBAP1",
            "ZNF678",
            "SHPRH",
            "HIPK3",
            "MAN1A2",
            "USP46",
            "ATF7IP",
            "ASXL2",
            "TRIM44",
            "TMPPE",
            "RASA2",
            "DPM2",
            "CLCN3",
            "C9orf102",
            "NT5C",
            "FASTK",
            "JTB",
            "TMEM134",
            "LUZP1",
            "MARCH8",
            "ADAM10",
            "MYCBP2",
            "ZNF770",
            "HINT2",
            "ZNF426",
            "LATS1",
            "RSF1",
            "DOCK7",
            "TOPORS",
            "ZFP106",
            "LRCH3",
            "HIVEP2",
            "EYA3",
            "ZNF268",
            "STAG1",
            "GTF2I",
            "ATRN",
            "TGFBRAP1",
            "SSH1",
            "PIK3CA",
            "COMMD4",
            "ZNF619",
            "KDM5A",
            "ROCK1",
            "TM9SF2",
            "C19orf22",
            "NDUFS7",
            "BBX",
            "SIRT6",
            "HIVEP1",
            "DRG2",
            "DPP8",
            "SMCR8",
            "BOD1L",
            "CHMP4A",
            "AFF1",
            "INO80E",
            "TCF12",
            "MGA",
            "AUP1",
            "MTF1",
            "NPRL2",
            "ZFX",
            "GNA11",
            "GPS2",
            "TGOLN2",
            "PEX26",
            "IREB2",
            "CSNK1G1",
            "ATXN1L",
            "ANKRD17",
            "EP300",
            "PHF20",
            "NSD1",
            "CTNND1",
            "PIK3C2A",
            "UBR2",
            "SERINC3",
            "BCS1L",
            "C17orf95",
            "PIK3R4",
            "SOS1",
            "EPC1",
            "SON",
            "CNOT1",
            "NBAS",
            "RHBDD1",
            "CTR9",
            "RNF111",
            "TMEM184C",
            "GMEB1",
            "SIN3A",
            "NUP98"
        ]
    },
    {
        "golabel": "RFX1_regulon_activity",
        "gene": [
            "ANKRD24",
            "ICAM5",
            "IDUA",
            "C13orf27",
            "TMEM38B",
            "OSTCL",
            "MTHFD2",
            "CROCC",
            "EVPL",
            "TDP2",
            "C13orf37",
            "BAHCC1",
            "PPP2R3C",
            "CNIH",
            "C14orf129",
            "COMMD8",
            "C6orf115",
            "ANKMY1",
            "VRK1",
            "HSPA13",
            "FHOD1",
            "C14orf126",
            "UBA2",
            "DCK",
            "CDC42BPG",
            "BAIAP2",
            "SLC27A1",
            "MGRN1",
            "CYCS",
            "PDCD10",
            "TBPL1",
            "ABCA2",
            "AHDC1",
            "MAP3K6",
            "KIAA1543",
            "MIB2",
            "TFAM",
            "KIAA0284",
            "CCDC102A",
            "B3GNT2",
            "PSMC6",
            "ERH",
            "PNPLA2",
            "C18orf19",
            "COMMD2",
            "TMX1",
            "CASKIN2",
            "UBE2Q2",
            "TPCN1",
            "ARHGEF17",
            "MPHOSPH6",
            "C1D",
            "NMD3",
            "DPM1",
            "LRCH4",
            "ARMC5",
            "ZNF410",
            "TSN",
            "YWHAQ",
            "PRKRIR",
            "SIX5",
            "PL-5283",
            "SOLH",
            "PDE4A",
            "ZNF319",
            "FAM129B",
            "GMFB",
            "TNKS1BP1",
            "SLC38A10",
            "RDH11",
            "BAHD1",
            "MAP1S",
            "NCOR2",
            "MKNK2",
            "SIN3B",
            "ZNF35",
            "EVI5L",
            "MLLT1",
            "MXD4",
            "AGAP3",
            "RHOQ",
            "UPF1",
            "TAOK2",
            "NUP54",
            "CC2D1A",
            "EIF2S1",
            "C9orf82",
            "MED25",
            "EXOC5",
            "ZC3H15",
            "TSC2",
            "ZNF653",
            "VTA1",
            "RNF44",
            "FBRS",
            "ZBTB7A",
            "ENOPH1",
            "CAMTA2",
            "MDH1",
            "MED26",
            "NUS1",
            "MRPL35",
            "ZER1",
            "EML3",
            "PPP3R1",
            "MAP2K7",
            "PTPN23",
            "CSNK1D"
        ]
    },
    {
        "golabel": "RFX2_regulon_activity",
        "gene": [
            "SOX10",
            "FAM74A4",
            "C1QTNF8",
            "FAM74A3",
            "LOC400891",
            "C6orf103",
            "CCDC37",
            "TTLL10",
            "DNAH12",
            "VWA3A",
            "C9orf117",
            "DNAI2",
            "CDHR4",
            "WDR16",
            "DNAI1",
            "RSPH10B2",
            "C6orf118",
            "CCDC17",
            "ALS2CR12",
            "TCTE1",
            "C9orf171",
            "C1orf173",
            "CCDC42B",
            "C1orf158",
            "APOBEC4",
            "CCDC135",
            "TUBA4B",
            "YSK4",
            "C9orf24",
            "WDR63",
            "C1orf194",
            "OR7E37P",
            "NWD1",
            "C2orf39",
            "EFHB",
            "LRRC48",
            "WDR65",
            "CCDC81",
            "DNAH6",
            "TTC16",
            "FAM154B",
            "TTLL9",
            "TSNAXIP1",
            "LRRC46",
            "RTDR1",
            "C21orf121",
            "RSPH4A",
            "MS4A8B",
            "C11orf66",
            "ZMYND10",
            "DNAH7",
            "TXNDC6",
            "GAS2L2",
            "TEKT3",
            "SPAG6",
            "TEKT2",
            "ZNF474",
            "WDR49",
            "CCDC151",
            "RSPH1",
            "SERPINI2",
            "LOC285796",
            "SPAG8",
            "TCTEX1D4",
            "CCDC114",
            "C10orf107",
            "ARMC3",
            "CASC1",
            "FHAD1",
            "TTC18",
            "CCDC39",
            "DPY19L2P2",
            "ABCA13",
            "FKBP6",
            "C3orf15",
            "TTC25",
            "IGSF10",
            "C6orf97",
            "CCDC19",
            "TPPP3",
            "C7orf57",
            "CAPS",
            "SPAG17",
            "TNXB",
            "MAK",
            "LOC283174",
            "CCDC74B",
            "EFCAB6",
            "ANKK1",
            "ADAMTS8",
            "UCKL1AS",
            "CCDC146",
            "KIAA1529",
            "PLEKHG7",
            "CD164L2",
            "IGSF9B",
            "LOC541473",
            "PPIL6",
            "FOXJ1",
            "ALMS1P",
            "CCDC40",
            "ZDHHC11",
            "C6orf154",
            "LRRC4",
            "RIBC1",
            "C2orf77",
            "TTC23L",
            "LOC285419",
            "USP2",
            "MAPK10",
            "TTC21A",
            "TNFRSF19",
            "CXorf57",
            "C12orf68",
            "GPR172B",
            "DNAH5",
            "ARMC2",
            "CCDC157",
            "DYNC2H1",
            "FLJ13197",
            "LOC728392",
            "DNAH2",
            "BAIAP3",
            "RAB36",
            "CNTF",
            "SRGAP3",
            "GPRASP1",
            "LRRC56",
            "KIAA1377",
            "EFHC1",
            "CCDC30",
            "LRP2BP",
            "KATNAL2",
            "PLEKHH2",
            "PRRT3",
            "C16orf93",
            "ICA1L",
            "LCA5",
            "LCAT",
            "BAG2",
            "CLMN",
            "CCNB1",
            "C2orf55",
            "C2orf81",
            "LCA5L",
            "FAM47E",
            "LOC100131691",
            "LOC153684",
            "CROCC",
            "PBX4",
            "UBXN11",
            "ADCY9",
            "C18orf1",
            "AKD1",
            "KIAA1407",
            "WDR54",
            "IFT140",
            "C16orf48",
            "IFT172",
            "NFIA",
            "C20orf12",
            "GLB1L",
            "CBX7",
            "ZNF440",
            "CDC14A",
            "EXPH5",
            "APBB1",
            "C20orf24",
            "EPB41L4A",
            "CCDC88C",
            "RAN",
            "ZSCAN18",
            "SLC27A1",
            "RPGR",
            "SYNGAP1",
            "FAM188B",
            "SARM1",
            "PGAM5",
            "STRAP",
            "NUP37",
            "ZNF211",
            "DARS2",
            "KIAA0467",
            "ARMC1",
            "SFI1",
            "BZW1",
            "MRPL42",
            "C1orf201",
            "CA5B",
            "C16orf55",
            "TMED2",
            "AVEN",
            "VDAC2",
            "TTLL1",
            "CCT4",
            "BBS5",
            "GPN3",
            "NPHP4",
            "CABIN1",
            "IFT122",
            "KIAA0556",
            "SLC7A6",
            "PSMA4",
            "UBE2N",
            "PGAM1",
            "GHITM",
            "CCDC51",
            "FAM45B",
            "MLLT1",
            "UBE2E1",
            "ANKRD42",
            "TMEM33",
            "VMAC",
            "MRPL3",
            "GDI2",
            "TIMM17A",
            "GGA2",
            "SFRS9",
            "FAM45A",
            "PPP1CC",
            "SLC25A3",
            "MARCH5",
            "WDTC1",
            "C10orf119",
            "ARPP19",
            "MAPKAPK5",
            "UBQLN1"
        ]
    },
    {
        "golabel": "RFXANK_regulon_activity",
        "gene": [
            "ETV2",
            "RPL35",
            "MAN1A1",
            "RPL18A",
            "RPL36",
            "N4BP2",
            "RPS19",
            "RPL24",
            "MRPL54",
            "RPL27A",
            "RAB3A",
            "NDUFA2",
            "RPS9",
            "NDUFA11",
            "RPL28",
            "RPS15",
            "LCOR",
            "TAOK1",
            "NDUFA13",
            "NDUFB7",
            "ZNF593",
            "RPL18",
            "LSM7",
            "UBL5",
            "TRAPPC5",
            "GADD45GIP1",
            "ATP5D",
            "UQCR11",
            "C16orf13",
            "NRL",
            "ALKBH7",
            "NDUFA3",
            "MRPL34",
            "TCEB2",
            "FAM63B",
            "NDUFA7",
            "C1orf86",
            "TCEA2",
            "FAU",
            "FAM128B",
            "MPG",
            "UBL7",
            "STRN",
            "MRPL55",
            "C19orf70",
            "ROCK2",
            "BCL7C",
            "C9orf16",
            "C19orf53",
            "PGLS",
            "ASXL2",
            "RPLP2",
            "SSBP4",
            "C19orf24",
            "LSM4",
            "HAUS8",
            "NR2C2AP",
            "SSNA1",
            "FDX1L",
            "C10orf118",
            "QTRT1",
            "C12orf10",
            "LATS1",
            "COPE",
            "SOAT1",
            "UROD",
            "USE1",
            "UBA52",
            "CCDC124",
            "NUBP2",
            "TMEM161A",
            "VCPIP1",
            "MRPL4",
            "WWP1",
            "MPV17L2",
            "DDX49",
            "FAM125A",
            "ROCK1",
            "PEX16",
            "NDUFS7",
            "LOC729991",
            "SIRT6",
            "UBR3",
            "C19orf39",
            "BOD1L",
            "ARMC6",
            "DDA1",
            "C19orf42",
            "CLPP",
            "AES",
            "GCDH",
            "WDR83",
            "MAP3K2",
            "PIN1",
            "TGOLN2",
            "FKBP8",
            "TECR",
            "EIF3G",
            "C19orf62",
            "C19orf43",
            "PIH1D1",
            "ELOF1",
            "BIRC6",
            "RNF25",
            "PIKFYVE",
            "C19orf56",
            "RAD23A",
            "DDX3X",
            "FAM32A",
            "C19orf52",
            "C19orf50",
            "SF4"
        ]
    },
    {
        "golabel": "RGS14_regulon_activity",
        "gene": [
            "SLC34A1",
            "F12",
            "IRX5",
            "PRR7",
            "SRGAP1",
            "ZNF697",
            "GUK1",
            "RILP",
            "KCTD3",
            "ZFYVE9",
            "B3GNTL1",
            "SCO2",
            "C19orf70",
            "NHP2",
            "GSDMD",
            "RIF1",
            "RAB24",
            "AGXT2L2",
            "ZNF688",
            "LOC388955",
            "HDAC2",
            "ADAM10",
            "TNFSF12",
            "TMEM219",
            "PRELID1",
            "DIP2B",
            "STX10",
            "LMAN2",
            "B4GALT7",
            "TSPAN17",
            "RMND5A",
            "DOK1",
            "KLF3",
            "PKN2",
            "TCF12",
            "NPRL2",
            "ARID2",
            "GSK3B",
            "IREB2",
            "RMND5B",
            "SYNCRIP",
            "KHDRBS1"
        ]
    },
    {
        "golabel": "RNF141_regulon_activity",
        "gene": [
            "TROAP",
            "PIF1",
            "AURKB",
            "ESPL1",
            "KIF18B",
            "DDX12",
            "SERTAD4",
            "UBE2S",
            "RECQL4",
            "LOC642846",
            "SPAG5",
            "MPZL2",
            "C9orf100",
            "NTN4",
            "BDNFOS",
            "TMEM159",
            "DBF4B",
            "RNF144B",
            "CD59",
            "PRPF40B",
            "PRRG4",
            "LOC653501",
            "RAB27A",
            "POLE",
            "PTMS",
            "TMBIM1",
            "FBRSL1",
            "DDX39",
            "PUS1",
            "SFRS16",
            "MAP3K5",
            "RBM43",
            "TRIM34",
            "AMPD3",
            "SRM",
            "ABCD3",
            "FPGT",
            "DHX37",
            "PABPN1",
            "NOC4L",
            "UEVLD",
            "FBXO3",
            "CHFR",
            "TMEM9B",
            "FXC1",
            "RBM10",
            "RBM19",
            "SRRT",
            "C11orf58",
            "MPP5",
            "SFRS8",
            "FEZ2",
            "COPB1",
            "METT5D1",
            "GTF2H1",
            "CTR9",
            "TOR1AIP1",
            "DAZAP1",
            "VPS24"
        ]
    },
    {
        "golabel": "RNF166_regulon_activity",
        "gene": [
            "CLEC4GP1",
            "MYBPC3",
            "LOC26102",
            "C1orf228",
            "HSPA7",
            "TSPAN32",
            "PATL2",
            "C11orf21",
            "C9orf139",
            "RASL10A",
            "LAT",
            "CTRL",
            "SOCS1",
            "TBC1D10C",
            "HCG26",
            "ATG16L2",
            "DSG2",
            "LOC606724",
            "PSTPIP1",
            "RASAL3",
            "NFKBID",
            "PBX4",
            "MAPK11",
            "CCDC88B",
            "PARVG",
            "KLF5",
            "ARHGAP9",
            "LGR4",
            "CXADR",
            "CCDC85B",
            "P2RY11",
            "ARHGAP4",
            "PLS1",
            "CORO1A",
            "LIMD2",
            "CYBA",
            "C16orf86",
            "SNAI3",
            "RASSF4",
            "RASA4",
            "LYL1",
            "C19orf60",
            "IRF6",
            "POPDC2",
            "TMEM149",
            "NDFIP2",
            "LRRC16A",
            "ZNF276",
            "ACSL3",
            "KCTD17",
            "RAB24",
            "MGC23284",
            "ZNF688",
            "GFPT1",
            "AMDHD2",
            "CD2AP",
            "DEF6",
            "C1orf58",
            "FAM18B",
            "EIF5B",
            "IKBKG",
            "OGFR",
            "CORO7",
            "CTU2",
            "FAM98B",
            "MIIP",
            "CLCN7",
            "IPO7",
            "KDM5B",
            "UBE2H",
            "KLF3",
            "DGKZ",
            "TJP1",
            "TMED10P1",
            "TM9SF3",
            "ZBTB41",
            "RASSF1",
            "VAC14",
            "C17orf62",
            "UTP14C",
            "NCKAP1",
            "ADRBK1",
            "CAMSAP1L1",
            "ACBD3",
            "CHMP1A",
            "DEF8",
            "GRK6",
            "LEO1",
            "METAP1",
            "MFAP1",
            "FBXO28",
            "UBE2G1",
            "CEBPZ",
            "ARPP19",
            "RAB3GAP2",
            "SLC39A9",
            "ARIH1",
            "RBM27",
            "UBE3A",
            "CAPRIN1",
            "CDC73",
            "MAP2K4",
            "PLEKHM2",
            "PUM1",
            "CUL3",
            "HNRNPK"
        ]
    },
    {
        "golabel": "RORA_regulon_activity",
        "gene": [
            "GFRA1",
            "SLC18A2",
            "ABCA8",
            "LOC284276",
            "CACNB4",
            "CHRDL1",
            "CBFA2T3",
            "SOX5",
            "PREX2",
            "SCN7A",
            "C1QTNF7",
            "TNFRSF19",
            "FAM38B",
            "ABI3BP",
            "NCRNA00092",
            "CCR4",
            "ABCA9",
            "SLIT2",
            "FLT3",
            "CD40LG",
            "GPRASP1",
            "IL7R",
            "SETBP1",
            "ABCA6",
            "NHSL2",
            "ZNF662",
            "GVIN1",
            "LSAMP",
            "PLEKHH2",
            "ZNF483",
            "CCR6",
            "RGAG4",
            "MAN1C1",
            "C14orf139",
            "PRKCB",
            "KLHL6",
            "P2RY8",
            "ZC3H12D",
            "PIK3CG",
            "CGNL1",
            "LAMA2",
            "PDZRN3",
            "PLCL1",
            "TK1",
            "IKZF1",
            "ARPC1A",
            "ANKRD44",
            "IL16",
            "C18orf1",
            "RAI2",
            "GCET2",
            "ITGA4",
            "EFHA2",
            "WHAMML1",
            "SATB1",
            "GAB3",
            "GAS7",
            "DOCK8",
            "ADRBK2",
            "NME1",
            "NCRNA00182",
            "FLI1",
            "CBX7",
            "RASSF2",
            "ZEB2",
            "TP53INP1",
            "PRICKLE2",
            "POP7",
            "ARHGEF6",
            "RPP40",
            "TACC1",
            "TKT",
            "NIPSNAP3B",
            "GNG2",
            "MRPL12",
            "COPS6",
            "PKP3",
            "PPP1R14B",
            "TUBA1C",
            "SAC3D1",
            "HMBS",
            "C5orf41",
            "PARP11",
            "TUBG1",
            "ALS2CR8",
            "SGK269",
            "EIF5A",
            "CA5B",
            "C21orf70",
            "ARL15",
            "MTX1",
            "VPS13C",
            "CPEB4",
            "POLD2",
            "ALG3",
            "SIGMAR1",
            "MTMR10",
            "FAM13B",
            "SNRPC",
            "HERC1",
            "HSF1",
            "RDBP",
            "KIAA0247",
            "HECA",
            "CARD8",
            "DNAJC27",
            "DMXL1",
            "TACO1",
            "PRDM2",
            "NME6",
            "PPM1G",
            "CNP",
            "POLDIP2",
            "WDR46",
            "SNX1"
        ]
    },
    {
        "golabel": "RORC_regulon_activity",
        "gene": [
            "PGC",
            "ORM2",
            "PLA2G10",
            "SLC26A9",
            "LINGO4",
            "SLC16A1",
            "IGF2BP3",
            "LGSN",
            "BNIPL",
            "TMEM158",
            "APOBEC3B",
            "SFTPB",
            "GUCY1B2",
            "TACC2",
            "ADAM12",
            "GPR133",
            "INHBA",
            "AQP3",
            "FJX1",
            "MAOA",
            "BEND6",
            "EVPLL",
            "OVGP1",
            "SFTA2",
            "IRX3",
            "C9orf152",
            "TNFAIP6",
            "GPR176",
            "FRMD6",
            "SELENBP1",
            "AHCYL2",
            "LARP6",
            "KDELC1",
            "ALDH3B1",
            "RHOBTB2",
            "IGDCC4",
            "NOXA1",
            "VCAM1",
            "SMPDL3B",
            "TNFSF4",
            "PRR16",
            "RAD51AP1",
            "EFCAB4A",
            "ITPRIPL1",
            "ATP1B1",
            "KIAA1524",
            "PIP5KL1",
            "WISP1",
            "B3GALNT1",
            "CENPK",
            "EGFL7",
            "KRTCAP3",
            "LILRB2",
            "IDUA",
            "TOB1",
            "TSHZ3",
            "TMEM91",
            "MLPH",
            "GPRC5C",
            "KIF18A",
            "ARL10",
            "HAPLN3",
            "SPIRE2",
            "LOXL3",
            "CHEK1",
            "ATP11A",
            "EIF5A2",
            "FAM102B",
            "DSE",
            "GLIPR2",
            "FAM83E",
            "FSTL1",
            "NECAB3",
            "RPH3AL",
            "RNF145",
            "MAP7D3",
            "UNC13B",
            "C18orf54",
            "TSPAN33",
            "CDK2AP2",
            "TUBB6",
            "TMEM125",
            "TCEA3",
            "NKX2-1",
            "BICD1",
            "CREB3L4",
            "LONRF3",
            "NUDT13",
            "BAG1",
            "KLHL5",
            "EPB49",
            "SEPT11",
            "PC",
            "ACTN1",
            "FLJ90757",
            "C1orf210",
            "RASSF7",
            "FN3K",
            "TBC1D1",
            "COTL1",
            "UBE2L6",
            "PRMT6",
            "ATP1B3",
            "CCDC88A",
            "PBXIP1",
            "SHMT1",
            "NRM",
            "DGAT1",
            "EPB41L2",
            "RAB17",
            "HS2ST1",
            "RAB40B",
            "KIAA1949",
            "MRPS25",
            "ELMO3",
            "THEM4",
            "CLDN7",
            "RAB25",
            "TMC4",
            "PNKD",
            "PRKAB1",
            "ASAP1",
            "RECQL",
            "KDELC2",
            "FAM63A",
            "SLC36A1",
            "CLIC4",
            "TMEM63B",
            "SH3BP1",
            "KCTD17",
            "MARCKS",
            "B3GNT2",
            "TUBA1B",
            "ESRP2",
            "CD46",
            "PCBD1",
            "ZNF33B",
            "GOLPH3L",
            "PMF1",
            "MED11",
            "TBCCD1",
            "FBXW4",
            "AKAP1",
            "GLT25D1",
            "ZBTB7B",
            "LGTN",
            "PCBD2",
            "C1orf27",
            "FYTTD1",
            "RBM47",
            "PHTF1",
            "TMEM185A",
            "BRD1",
            "STK4",
            "DCAF8",
            "SEPT7",
            "CTNNBL1",
            "DIS3L2",
            "CAPZB",
            "C2orf24"
        ]
    },
    {
        "golabel": "RPL7A_regulon_activity",
        "gene": [
            "RPL9",
            "NCRNA00188",
            "GAS5",
            "C20orf199",
            "RPS21",
            "RPS18",
            "RPS7",
            "RPLP1",
            "RPL27",
            "RPL39",
            "RPS3A",
            "RPS10",
            "C17orf61",
            "RPL22L1",
            "ASS1",
            "RPS5",
            "RPS15A",
            "DST",
            "SNHG5",
            "CCNB1IP1",
            "EEF1B2",
            "RPS3",
            "RPL35",
            "RPS6",
            "RPS16",
            "RPS14",
            "RPS29",
            "RPSA",
            "RPSAP58",
            "RPL17",
            "RPS27",
            "RPL13AP3",
            "NCRNA00219",
            "EIF4EBP3",
            "PFDN5",
            "RPL31",
            "ST6GALNAC4",
            "RPL18A",
            "RPS17",
            "RPL36",
            "RPSAP9",
            "RPLP0",
            "RPL8",
            "RPS19",
            "RPS8",
            "RPL24",
            "RPL26",
            "C6orf48",
            "TPT1",
            "RPL13A",
            "MRPL54",
            "SNHG8",
            "RPS11",
            "RPL27A",
            "RPL29",
            "RPL5",
            "RPS9",
            "TRIO",
            "RPL10A",
            "RPL28",
            "PHPT1",
            "ANKRD19",
            "RPL13",
            "RPL12",
            "RPL13AP20",
            "RPS15",
            "RPL41",
            "C11orf1",
            "RPL34",
            "RPL32",
            "RPL35A",
            "RPL38",
            "EEF1A1",
            "RPL37",
            "RPL7",
            "RPL18",
            "CCDC72",
            "RPS13",
            "MGC16275",
            "RPS27A",
            "RPS24",
            "LYRM4",
            "RPL37A",
            "RPL10",
            "RPS12",
            "ZNF581",
            "EEF1A1P9",
            "EIF3E",
            "RPL14",
            "NME2",
            "ALKBH7",
            "ATP5S",
            "MYO1D",
            "RPS20",
            "RPS23",
            "RPS2",
            "FAU",
            "RPL30",
            "C19orf55",
            "ATP5O",
            "RPL23",
            "CUEDC1",
            "RPL15",
            "RPL4",
            "ZMYND17",
            "EEF1D",
            "GNB2L1",
            "DTWD1",
            "RPS4X",
            "CDH1",
            "TMEM183A",
            "RPLP2",
            "ATP5G2",
            "PHLPP2",
            "TIMM9",
            "RPL3",
            "POLR1D",
            "C9orf23",
            "HIGD2A",
            "DOPEY2",
            "PCBD1",
            "RPL19",
            "EEF1G",
            "SSR2",
            "SSNA1",
            "RPL11",
            "C22orf46",
            "RPL23A",
            "LETMD1",
            "NDUFB8",
            "MRPS2",
            "EEF2",
            "TRUB2",
            "AUH",
            "ITSN1",
            "PPA1",
            "JAGN1",
            "RPS25",
            "BTBD12",
            "TMEM18",
            "SMC1A",
            "RPL6",
            "NDUFA8",
            "ISCA1P1",
            "RSPH3",
            "UBA52",
            "ECSIT",
            "EDF1",
            "C2CD3",
            "AIP",
            "BTF3",
            "FKRP",
            "THOC7",
            "C9orf85",
            "RABEPK",
            "MRRF",
            "NACA",
            "GMPR2",
            "USP42",
            "NPRL2",
            "GRHPR",
            "C4orf14",
            "GABARAP",
            "SPCS1",
            "DALRD3",
            "C3orf10",
            "AAK1",
            "EIF3D",
            "EXOSC7",
            "CDC26",
            "EIF3G",
            "HTATSF1",
            "ISCA1",
            "RPL22",
            "MTOR",
            "GTF3C1",
            "OXA1L",
            "UBR4",
            "URM1",
            "ANP32B",
            "SLC25A38",
            "NFE2L1",
            "FXN",
            "EIF3F",
            "UBN1",
            "PDHB",
            "HNRNPA1",
            "UBE4A",
            "SLC25A26",
            "QARS",
            "ALG2",
            "MAPKAP1",
            "PPP6C"
        ]
    },
    {
        "golabel": "RREB1_regulon_activity",
        "gene": [
            "C21orf125",
            "FURIN",
            "RARRES3",
            "TMSB15B",
            "MAFK",
            "SEMA4G",
            "DHDH",
            "OTX1",
            "IFI27",
            "FAM27A",
            "SLC45A4",
            "C6orf225",
            "DOCK5",
            "EAF2",
            "IFI27L2",
            "HCST",
            "SGCE",
            "RAD51L1",
            "C1orf54",
            "LY96",
            "ETNK2",
            "GLIPR2",
            "RAB32",
            "TTC22",
            "TNFAIP8L2",
            "AIF1",
            "CKLF",
            "GMFG",
            "C7orf60",
            "NBEAL1",
            "MTCP1NB",
            "MAST4",
            "KIF13B",
            "CMIP",
            "LMO7",
            "TUBA1A",
            "WDR54",
            "BST2",
            "BCAS4",
            "ROM1",
            "SHANK2",
            "URB1",
            "BPGM",
            "TMSL3",
            "CHP",
            "C18orf18",
            "MDP1",
            "CGRRF1",
            "NOTCH3",
            "HPRT1",
            "FOSL2",
            "TBL1X",
            "UBE2L6",
            "SAP30",
            "RAD54L2",
            "PER2",
            "SLC38A6",
            "PITPNM1",
            "LOC401397",
            "IFT46",
            "ACSL3",
            "SUB1",
            "ROCK2",
            "KCTD17",
            "SLC6A6",
            "COMMD7",
            "WDR60",
            "THYN1",
            "SLK",
            "IFT52",
            "POLR2G",
            "SRRM2",
            "DCTN3",
            "ARHGAP21",
            "UHRF1BP1",
            "MLL2",
            "RNASEH2C",
            "UBE2A",
            "HERC2",
            "DAG1",
            "MFSD9",
            "RCOR1",
            "CCDC104",
            "C17orf79",
            "MYST4",
            "POLR2A",
            "NUP153",
            "SEC16A",
            "TMEM60",
            "CNPY4",
            "CCDC53",
            "CDC42BPB",
            "PSMD13",
            "EP400",
            "CHIC2",
            "TJP1",
            "LSM6",
            "BAZ2A",
            "POC5",
            "CHD2",
            "SNX11",
            "CXorf40A",
            "ACTR10",
            "MEF2D",
            "RNF113A",
            "DEGS1",
            "TOR3A",
            "ZNF609",
            "EIF3A",
            "POLR3E",
            "ANKRD17",
            "EP300",
            "ZSCAN29",
            "BIRC6",
            "CTNND1",
            "KIAA0368",
            "DNAJC8",
            "FRG1",
            "HEATR5B",
            "BRD2",
            "MNT",
            "MSL3",
            "KDM3B",
            "FIBP",
            "GBF1",
            "ATF7",
            "LASS5",
            "GIGYF2",
            "VPRBP",
            "SLTM",
            "USP19",
            "SEC31A",
            "IWS1"
        ]
    },
    {
        "golabel": "RSF1_regulon_activity",
        "gene": [
            "HSN2",
            "C12orf57",
            "INTS4L1",
            "UQCRQ",
            "MRPL54",
            "SEPW1",
            "MRPL41",
            "NDUFA2",
            "CYBA",
            "TRIO",
            "FAM160A1",
            "GAB2",
            "ZNF518B",
            "TAOK1",
            "NQO2",
            "NDUFA13",
            "BLOC1S1",
            "NDUFB7",
            "SERTAD1",
            "UBXN7",
            "NIPBL",
            "NCAPD3",
            "FAM168A",
            "COX4I1",
            "ALKBH7",
            "SIK2",
            "NDUFA7",
            "RNF144A",
            "TSPO",
            "HDHD3",
            "MPG",
            "SCO2",
            "EIF3K",
            "SAT2",
            "TRRAP",
            "INTS4L2",
            "C19orf70",
            "ROCK2",
            "RIF1",
            "ZNF524",
            "DYRK4",
            "NARS2",
            "REST",
            "HIGD2A",
            "C10orf12",
            "VPS28",
            "MSRB2",
            "MED1",
            "UBR5",
            "RBCK1",
            "KIAA1731",
            "CKAP5",
            "TFB1M",
            "EIF2C3",
            "ALMS1",
            "TMEM219",
            "PAK1",
            "COPE",
            "TOPORS",
            "KIAA0947",
            "RNASEK",
            "RSC1A1",
            "NCOA3",
            "C2CD3",
            "KIF1B",
            "C5orf51",
            "SRA1",
            "SERPINB6",
            "ARL6IP4",
            "RNF169",
            "NDUFS7",
            "JRKL",
            "C11orf30",
            "ASCC3",
            "NOL9",
            "MLL",
            "TEX264",
            "TRIP11",
            "FAM108A1",
            "NCOA6",
            "CYB561D2",
            "PIN1",
            "BPTF",
            "BAZ1B",
            "SNRNP200",
            "TAF3",
            "NPAT",
            "PPFIA1",
            "CTNND1",
            "C21orf33",
            "C19orf56",
            "TUSC2",
            "SUV420H1",
            "ARCN1",
            "INTS4",
            "PICALM",
            "HNRNPUL2",
            "KDM2A",
            "PPIG",
            "HNRNPR",
            "SAPS3",
            "SP3",
            "DDX6"
        ]
    },
    {
        "golabel": "RUNX1_regulon_activity",
        "gene": [
            "MUC21",
            "IPCEF1",
            "KAAG1",
            "PLEKHH1",
            "LRRN4",
            "SYT12",
            "HNF1A",
            "TRIM16L",
            "SPTB",
            "PODNL1",
            "KCNQ5",
            "XKRX",
            "GPR110",
            "TNIK",
            "COL10A1",
            "MAP2K6",
            "ELFN2",
            "TIPARP",
            "DPP4",
            "PLXNB3",
            "PIR",
            "CX3CL1",
            "PTPLA",
            "GLYCTK",
            "GPR68",
            "SLC5A3",
            "COL8A1",
            "GPC4",
            "SCARB1",
            "CHST3",
            "SLC34A2",
            "UCK2",
            "PLS3",
            "AGPHD1",
            "CHSY3",
            "CYR61",
            "OSMR",
            "EPDR1",
            "EMB",
            "ICAM1",
            "PAG1",
            "CDC42EP3",
            "CCNJL",
            "XPR1",
            "SAMD4A",
            "RNF19A",
            "CDC42BPA",
            "TRIM2",
            "MAGI3",
            "MAP3K13",
            "TMEM133",
            "ENDOD1",
            "HIP1",
            "C20orf7",
            "VDR",
            "PELI1",
            "SDC1",
            "APBA1",
            "LOC651250",
            "RPS6KA2",
            "IDS",
            "FLNA",
            "PTPRE",
            "GLCE",
            "PPP2R3A",
            "TMEM17",
            "MYOF",
            "SNX18",
            "COQ3",
            "NRP1",
            "ZFP36L1",
            "NOTCH2",
            "ARHGEF9",
            "CCDC46",
            "KCTD3",
            "GRAMD3",
            "NDUFA9",
            "CTAGE5",
            "RAPH1",
            "KIAA1217",
            "COX5A",
            "DNAJC10",
            "CPNE2",
            "ATP5G3",
            "ATP5B",
            "LYST",
            "MYO6",
            "SPSB1",
            "SPRED2",
            "UBE2CBP",
            "NDUFAF4",
            "SELS",
            "IFNAR2",
            "PHLDB1",
            "FYCO1",
            "PTDSS2",
            "SYNJ1",
            "MKKS",
            "MRPS11",
            "MKL2",
            "LRRC28",
            "CCDC6",
            "PSMA4",
            "GTPBP8",
            "TMEM43",
            "ARFIP2",
            "TTC3",
            "CAST",
            "RPF1",
            "SKI",
            "SMAP1",
            "ACVR1",
            "ANKRD13C",
            "WDR73",
            "ABHD10",
            "WDR77",
            "MCRS1",
            "IFNAR1"
        ]
    },
    {
        "golabel": "RXRA_regulon_activity",
        "gene": [
            "QPCT",
            "PRX",
            "C12orf48",
            "DSCC1",
            "UBE2T",
            "TUBBP5",
            "TBC1D2",
            "MTHFD2",
            "PTPRU",
            "MTFR1",
            "TNS1",
            "RAN",
            "IMMP1L",
            "CASZ1",
            "VBP1",
            "H6PD",
            "ZBTB46",
            "NUDCD1",
            "ABCA2",
            "AHDC1",
            "C9orf167",
            "MTHFR",
            "MAP3K6",
            "EEF1E1",
            "C16orf61",
            "ARMC1",
            "C12orf73",
            "TMED2",
            "C12orf23",
            "CACYBP",
            "PGPEP1",
            "TOM1L2",
            "MGAT2",
            "DPM1",
            "DAB2IP",
            "KLHL21",
            "COQ5",
            "FAM53B",
            "KIAA0649",
            "FAM129B",
            "MAST3",
            "KIAA1522",
            "ANKS6",
            "UBE2N",
            "BAT2L1",
            "LDLRAP1",
            "ZBTB4",
            "MKNK2",
            "C16orf87",
            "ZBTB43",
            "MXD4",
            "ALAD",
            "WASF2",
            "ENOPH1",
            "ABL1",
            "UTP18",
            "SLC35B1",
            "PPP1CC",
            "NAE1",
            "TBC1D13",
            "CCDC43",
            "GPR107",
            "DENR",
            "PHF2",
            "WDTC1",
            "ZER1",
            "SNRNP27",
            "CDK9",
            "CBFB",
            "IP6K1"
        ]
    },
    {
        "golabel": "SAFB_regulon_activity",
        "gene": [
            "FUNDC2P2",
            "ZNF702P",
            "LOC374443",
            "C4orf36",
            "OSTCL",
            "NXT2",
            "SELT",
            "TMEM19",
            "MREG",
            "SRI",
            "TMEM106B",
            "AZI1",
            "SCRIB",
            "SCOC",
            "TMEM144",
            "TMEM165",
            "LEPROT",
            "FBXL19",
            "DHX34",
            "PPT1",
            "CD46",
            "SNAPC4",
            "C16orf63",
            "PPAN",
            "MYBBP1A",
            "DOHH",
            "ZNRF2",
            "SDHD",
            "SF3A2",
            "SPPL2A",
            "CCDC9",
            "PELP1",
            "FBXL5",
            "CHMP2B",
            "AKAP8L",
            "ZFAND6",
            "NPTN",
            "C1GALT1C1",
            "MBD3",
            "RNF14",
            "C6orf211",
            "RNF13",
            "UBA3",
            "TANK",
            "COPS4",
            "SLC35A5",
            "SART1",
            "RAB9A",
            "HDGFRP2",
            "SCAF1",
            "RAVER1",
            "REXO1",
            "SETD1A",
            "PHRF1",
            "CHERP",
            "UGP2",
            "PPP1R10",
            "TMBIM6",
            "C19orf29",
            "ARL8B",
            "PIAS4",
            "FUS",
            "ILF3",
            "MAP2K7",
            "UBE2D3",
            "SAFB2",
            "AZI2",
            "RHOA",
            "DAZAP1",
            "HNRNPM",
            "RBM14"
        ]
    },
    {
        "golabel": "SAFB2_regulon_activity",
        "gene": [
            "FUNDC2P2",
            "C19orf23",
            "RAP1B",
            "TM2D2",
            "LOC374443",
            "LYPLA1",
            "OSTCL",
            "NXT2",
            "CD9",
            "POC1B",
            "MED21",
            "SELT",
            "CALM2",
            "MXRA7",
            "CNIH",
            "MREG",
            "SRI",
            "TMEM106B",
            "OSTC",
            "GNG10",
            "TMEM165",
            "RRBP1",
            "CCDC126",
            "PCNT",
            "SNAPC4",
            "GAK",
            "UBE2Q2",
            "PLEKHF2",
            "C1D",
            "ZNF410",
            "MYBBP1A",
            "SRRM2",
            "SNX3",
            "CDK11A",
            "ARPC5",
            "KDM6B",
            "C3orf38",
            "UBE2A",
            "PSMD10",
            "NEURL4",
            "EIF1AX",
            "SNRNP70",
            "DPH3",
            "THAP1",
            "DUSP11",
            "UBE2D1",
            "CHMP2B",
            "AKAP8L",
            "RAP2C",
            "C1GALT1C1",
            "TAOK2",
            "C6orf211",
            "NUMA1",
            "NCDN",
            "SNX11",
            "UBA3",
            "PCNP",
            "RAB18",
            "SETD1A",
            "PHRF1",
            "TBC1D23",
            "VPS26A",
            "UGP2",
            "PPP1R10",
            "PRKCSH",
            "ARL8B",
            "HMGXB3",
            "UBE2D3",
            "RHOA",
            "SAFB"
        ]
    },
    {
        "golabel": "SALL2_regulon_activity",
        "gene": [
            "FAM171A2",
            "CACNA1F",
            "KYNU",
            "S100P",
            "SCUBE3",
            "GJB3",
            "LOC283174",
            "SDCBP2",
            "LOC158696",
            "SLC7A11",
            "ARNTL2",
            "IGSF9B",
            "CECR2",
            "FXYD3",
            "TMEM63C",
            "DLX3",
            "COL21A1",
            "EFR3B",
            "C19orf33",
            "PTPLA",
            "SUSD4",
            "FAM184A",
            "TRIM16",
            "KRT7",
            "ACAD8",
            "PRRT3",
            "SBK1",
            "NYNRIN",
            "S100A16",
            "ADAP1",
            "PLAUR",
            "MGC23270",
            "ENPP5",
            "GDF11",
            "KLF5",
            "NFATC4",
            "SQRDL",
            "DNAJC15",
            "LOC100128640",
            "ARHGEF19",
            "HIP1",
            "LOC651250",
            "ANKRD6",
            "PTK7",
            "BTBD9",
            "EPB41L5",
            "RGL1",
            "RAPGEF5",
            "APBB1",
            "MAGEE1",
            "SLC41A1",
            "ATP8B2",
            "LOC100130093",
            "SLC25A42",
            "NANS",
            "GPRASP2",
            "ZNF620",
            "PYROXD1",
            "SP4",
            "SLC44A1",
            "CHD6",
            "MYO6",
            "RAB11FIP3",
            "C1orf198",
            "AVEN",
            "ZNF362",
            "ZNF821",
            "ZNF70",
            "S1PR2",
            "CHD8",
            "GLUD1",
            "ZMYM3",
            "STX18",
            "ERP44",
            "ZNF2"
        ]
    },
    {
        "golabel": "SAP30BP_regulon_activity",
        "gene": [
            "KLC3",
            "C17orf67",
            "QRICH2",
            "CTAGE1",
            "KIAA1244",
            "SIAE",
            "EVPL",
            "ALDH6A1",
            "FLJ35220",
            "FBF1",
            "TRAIP",
            "LIN37",
            "CDK5RAP3",
            "HN1",
            "NRM",
            "TMEM79",
            "TRIM47",
            "AZI1",
            "RHBDF2",
            "KAT2A",
            "CMTM4",
            "GALK1",
            "CCM2",
            "ATE1",
            "CUEDC1",
            "LNX2",
            "C17orf89",
            "THOC4",
            "RBM42",
            "SKA2",
            "KBTBD7",
            "LRRC45",
            "FAM195B",
            "TUBG2",
            "FAM100B",
            "C21orf70",
            "VAT1",
            "YIPF6",
            "C17orf56",
            "TMEM49",
            "ARMC7",
            "C1orf58",
            "DTWD2",
            "SLC25A19",
            "IDE",
            "C9orf41",
            "RECQL5",
            "SIRT7",
            "CCDC137",
            "NAT9",
            "MRPL38",
            "MRPS7",
            "MIF4GD",
            "RANGAP1",
            "RFNG",
            "TSEN54",
            "DPP8",
            "H3F3C",
            "CHMP6",
            "XYLT2",
            "TRIM65",
            "FN3KRP",
            "ACTG1",
            "DGCR14",
            "C17orf70",
            "NUP85",
            "JMJD6",
            "NCOA4",
            "PJA2",
            "SUMO2",
            "HGS",
            "C17orf62",
            "SEPT9",
            "FOXK2",
            "GPS1",
            "CDC37",
            "TMEM104",
            "CYTH1",
            "COG1",
            "WBP2",
            "UNK",
            "GGA3",
            "KCTD2",
            "H3F3B",
            "ZNF800",
            "PSMC5",
            "STRADA",
            "CUL5",
            "COPS7B",
            "TMUB2",
            "FAM134C",
            "EXOC7",
            "UBE2Z",
            "FAM104A",
            "SRP68",
            "CSNK1D",
            "GRB2"
        ]
    },
    {
        "golabel": "SCAND1_regulon_activity",
        "gene": [
            "HSPB9",
            "HIST1H4J",
            "SYCE1L",
            "C20orf134",
            "SNHG9",
            "IDH2",
            "C4orf48",
            "LOC100144603",
            "LOC100271831",
            "C17orf61",
            "C17orf82",
            "CLDN3",
            "MAGIX",
            "PPP1R14A",
            "COMTD1",
            "HES4",
            "DPM3",
            "SLC27A5",
            "UFSP1",
            "DNLZ",
            "C5orf55",
            "NUDT8",
            "FAM176B",
            "STARD10",
            "LOC440957",
            "C19orf73",
            "GLI4",
            "ROMO1",
            "NCRNA00116",
            "C7orf59",
            "PARD6A",
            "POLR2I",
            "CCDC85B",
            "MIF",
            "C11orf71",
            "TIMM17B",
            "FKBP2",
            "LSMD1",
            "C21orf119",
            "ADAT3",
            "C7orf55",
            "C19orf20",
            "ZNF771",
            "MBLAC1",
            "C7orf47",
            "PPDPF",
            "LOC100289341",
            "MRPL41",
            "YDJC",
            "H2AFJ",
            "ZNHIT2",
            "LAGE3",
            "NDUFA11",
            "PEMT",
            "COX5B",
            "RPL13",
            "ZNHIT1",
            "TMEM160",
            "C11orf83",
            "FAM173A",
            "ENDOG",
            "MPST",
            "NDUFA13",
            "C6orf226",
            "SDF2L1",
            "SDHAF1",
            "NDUFB7",
            "RAPGEF6",
            "SIVA1",
            "ZNF593",
            "EXOSC4",
            "FAM127B",
            "LSM7",
            "FAM128A",
            "C6orf108",
            "MRPS26",
            "SERF2",
            "ANKRD36BP1",
            "TRAPPC5",
            "GADD45GIP1",
            "ZNF428",
            "ATP5D",
            "C19orf60",
            "CPNE1",
            "COX4I1",
            "NRL",
            "CLOCK",
            "DDTL",
            "ALKBH7",
            "DDT",
            "MRPL34",
            "TMEM223",
            "NR2F6",
            "MRPL23",
            "TMEM208",
            "GIYD2",
            "FAM96B",
            "NDUFA7",
            "PTRH1",
            "C1orf86",
            "FAM128B",
            "LOC152217",
            "C11orf51",
            "NDUFB11",
            "C17orf90",
            "C17orf100",
            "MRP63",
            "RBM42",
            "FBXL15",
            "SMPD2",
            "RPS19BP1",
            "C5orf41",
            "RPP21",
            "MRPL55",
            "F8A1",
            "BCL7C",
            "RABAC1",
            "NOSIP",
            "C9orf16",
            "NDUFS8",
            "C15orf61",
            "HIPK3",
            "FAM195B",
            "ASXL2",
            "SLC25A6",
            "C14orf179",
            "TMUB1",
            "MRPL53",
            "ZNF688",
            "C16orf55",
            "TP53I13",
            "RASA2",
            "TMEM93",
            "INO80B",
            "AURKAIP1",
            "HSPBP1",
            "CHST12",
            "SLC25A1",
            "SNHG11",
            "ITPA",
            "JOSD2",
            "SPATA2L",
            "C1orf122",
            "USP12",
            "COX8A",
            "MED13",
            "TIMM13",
            "ZNF821",
            "ZNF414",
            "COPE",
            "H1FX",
            "CNO",
            "NDUFAF3",
            "MAPK1",
            "NUBP2",
            "C1orf35",
            "PTAR1",
            "CTU2",
            "BAD",
            "ZDHHC24",
            "PIK3CB",
            "COQ9",
            "DENND4C",
            "COMMD4",
            "JMJD4",
            "DDX49",
            "ARL6IP4",
            "PEX16",
            "ADRM1",
            "FLYWCH2",
            "POLK",
            "USP25",
            "PRMT7",
            "NFKBIL1",
            "FAM108A1",
            "APC",
            "FBXW11",
            "PIGU",
            "IQGAP1",
            "SLC25A11",
            "HM13",
            "MAP3K2",
            "GSS",
            "GPS2",
            "KLHL36",
            "DDX28",
            "ERGIC3",
            "RALY",
            "BRMS1",
            "AFF4",
            "DYNLRB1",
            "ZFPL1",
            "SLC35C2",
            "C19orf43",
            "TSSC4",
            "SLC39A3",
            "XPO4",
            "OTUD4",
            "ZC3HAV1",
            "CHMP4B",
            "MORC3",
            "C3orf63",
            "RNF111",
            "METTL14",
            "C20orf4"
        ]
    },
    {
        "golabel": "SERTAD1_regulon_activity",
        "gene": [
            "IL8",
            "C19orf33",
            "TREM2",
            "CCL3",
            "BCL2A1",
            "CCL2",
            "UPP1",
            "TYROBP",
            "S100A6",
            "BLVRB",
            "PLAUR",
            "TNFRSF12A",
            "ACVR2B",
            "EMP3",
            "ZNF286B",
            "MRPL54",
            "SEPW1",
            "SH3BGRL3",
            "JUNB",
            "LGALS3",
            "EFHD2",
            "SOCS7",
            "RHOC",
            "GPX1",
            "ANXA2",
            "DNAJB1",
            "ITPKC",
            "CAPG",
            "IFNGR1",
            "GNA15",
            "RRAS",
            "C13orf23",
            "ASL",
            "TSPO",
            "HOOK1",
            "TMBIM1",
            "NFKBIE",
            "MED13L",
            "ANKRD26",
            "NOSIP",
            "PLK3",
            "DHX33",
            "ZNF236",
            "SYNGR2",
            "PFAS",
            "SERTAD3",
            "SMC3",
            "BCL2L1",
            "GIPC1",
            "CKAP5",
            "VASP",
            "CAPNS1",
            "JOSD2",
            "POLR3A",
            "RSF1",
            "ZNF318",
            "PTTG1IP",
            "MBTD1",
            "STRBP",
            "PAXIP1",
            "ZNF605",
            "DCAF16",
            "SMARCC1",
            "C11orf30",
            "OAZ1",
            "SUDS3",
            "MARCH2",
            "DEDD2",
            "PTPN11",
            "NECAP2",
            "BPTF",
            "UPF2",
            "SETD5",
            "RBM12B",
            "XPO7",
            "SUV420H1",
            "CEP63",
            "MUL1",
            "NR1H2",
            "CCAR1",
            "TARDBP"
        ]
    },
    {
        "golabel": "SETBP1_regulon_activity",
        "gene": [
            "ODZ1",
            "TMEM59L",
            "COL25A1",
            "PAK3",
            "OCA2",
            "BMP6",
            "C1orf95",
            "ODC1",
            "FSTL4",
            "ST6GAL2",
            "GREB1",
            "KIF26A",
            "WNT4",
            "RNF150",
            "NCKAP5",
            "LPL",
            "DOK6",
            "KIAA1324",
            "ANK2",
            "IGFBP2",
            "CACNA2D2",
            "ERO1LB",
            "LRRTM2",
            "KIT",
            "PREX2",
            "ABCC9",
            "CXXC4",
            "PDE7B",
            "KCNJ11",
            "GPR133",
            "KHDRBS3",
            "ANO2",
            "SCN9A",
            "ADAMTSL3",
            "ATP1B2",
            "SLC24A3",
            "PDE3B",
            "TCF7L1",
            "ALDH3A2",
            "PRSS22",
            "UPP1",
            "MTSS1",
            "FAM13C",
            "CABLES1",
            "VWF",
            "SRD5A3",
            "PTPRB",
            "PPP1R3B",
            "PHLDA2",
            "SLC16A3",
            "C7orf41",
            "RNF152",
            "TCF4",
            "TK1",
            "RFTN1",
            "TNFRSF12A",
            "LARGE",
            "RHOD",
            "RAB38",
            "SNED1",
            "ITPKB",
            "IFI35",
            "FOXO1",
            "PON2",
            "C1GALT1",
            "S100A10",
            "TUBA4A",
            "OSBPL1A",
            "SNX8",
            "HS6ST1",
            "RHOC",
            "EPAS1",
            "RORA",
            "HSD3B7",
            "RPA3",
            "MPDZ",
            "DTX2",
            "EBP",
            "HEYL",
            "INSR",
            "RCC1",
            "FBXO6",
            "LRIG1",
            "LIMK1",
            "RPGR",
            "ZNF192",
            "TTC28",
            "MAPRE2",
            "AP1S1",
            "S100A11",
            "CLDN4",
            "MRPS24",
            "TUBA1C",
            "MAML3",
            "ZFHX3",
            "PHC1",
            "ALDOA",
            "MED13L",
            "KCTD5",
            "SPATS2L",
            "TNRC6C",
            "SESTD1",
            "C14orf101",
            "ATXN7L1",
            "FAM190B",
            "ULK2",
            "C21orf70",
            "CDC34",
            "CERK",
            "PGM1",
            "NDST1",
            "ZMIZ1",
            "PSMC2",
            "DNAL1",
            "C1orf69",
            "FOXO3B",
            "MTMR10",
            "TANC1",
            "TNKS",
            "ATRN",
            "NSUN5",
            "ATG2B",
            "LDOC1L",
            "KIAA0430",
            "FADD",
            "RAC1",
            "ZNF407",
            "TNIP2",
            "C17orf39",
            "CAPZA1",
            "CEP68",
            "ZC3H7A",
            "ZRANB1"
        ]
    },
    {
        "golabel": "SETDB2_regulon_activity",
        "gene": [
            "ADH1B",
            "ANGPTL4",
            "CAPN3",
            "SLC6A8",
            "MYLK4",
            "SC65",
            "TDRD6",
            "UBE2S",
            "C9orf140",
            "SEMA4B",
            "PKMYT1",
            "C15orf34",
            "CCDC152",
            "CC2D2B",
            "INPP5B",
            "CAB39L",
            "GANC",
            "ARGLU1",
            "CBX7",
            "N4BP2L1",
            "TRIM22",
            "SUGT1L1",
            "POP7",
            "ARHGEF6",
            "H2AFX",
            "CLK4",
            "ALDOA",
            "PDAP1",
            "KAT2B",
            "RCBTB2",
            "BIVM",
            "THSD1P1",
            "TUBG1",
            "ANKAR",
            "ALS2CR8",
            "CLN5",
            "VPS13C",
            "NAA16",
            "TCEANC",
            "MTMR10",
            "HSF1",
            "ARID4A",
            "TDRD3",
            "SLC25A30",
            "RFXAP",
            "SEPSECS",
            "WDFY2",
            "CARD8",
            "C2orf67",
            "ACTG1",
            "NHLRC3",
            "FBXL3",
            "PHF11",
            "N4BP2L2",
            "RCBTB1",
            "TRIM13",
            "TRPM7",
            "ERCC5",
            "MPHOSPH8",
            "LINS1",
            "VPS36",
            "PPM1G",
            "CDADC1",
            "CENPC1",
            "SNX1"
        ]
    },
    {
        "golabel": "SF3A2_regulon_activity",
        "gene": [
            "ESPN",
            "MEGF9",
            "IRF7",
            "CDKN2D",
            "SSFA2",
            "ZNF296",
            "ZNF579",
            "WDR34",
            "TMEM144",
            "MAD1L1",
            "WDR18",
            "PCYOX1",
            "CD46",
            "PPAN",
            "TCF3",
            "ACD",
            "RNF126",
            "C19orf22",
            "DGKZ",
            "SIRT6",
            "MAPK7",
            "TMEM168",
            "HMG20B",
            "MBD3",
            "MIER2",
            "PAFAH2",
            "DGCR14",
            "PREPL",
            "TMEM192",
            "POLRMT",
            "LYSMD3",
            "DNAJB14",
            "AKAP10",
            "SH3GL1",
            "SPG20",
            "HDGFRP2",
            "C4orf29",
            "CASC4",
            "RAVER1",
            "G3BP2",
            "TBCK",
            "FTSJD1",
            "REXO1",
            "CSK",
            "BTBD2",
            "MAP2K2",
            "VPS54",
            "SNRPA",
            "ARHGDIA",
            "PLEKHB2",
            "SLC30A9",
            "PRKCSH",
            "MFSD8",
            "FZR1",
            "RAD23A",
            "XAB2",
            "USO1",
            "SGTA",
            "STAM2",
            "CUL5",
            "PLEKHA3",
            "SAFB",
            "DAZAP1",
            "NGLY1",
            "PTBP1"
        ]
    },
    {
        "golabel": "SHPRH_regulon_activity",
        "gene": [
            "PROX1",
            "RAB39",
            "BCL2",
            "DKFZp686O24166",
            "SOX5",
            "GPR63",
            "FAR2",
            "SLIT2",
            "RFX3",
            "DLEU7",
            "S100A6",
            "WASF3",
            "SFN",
            "TMEM92",
            "KIAA1244",
            "KIAA1324L",
            "TXNDC16",
            "MGST1",
            "CBX6",
            "HIST1H2BD",
            "LOC100271836",
            "RPS6KA5",
            "TXNDC17",
            "RNF168",
            "TMSB10",
            "C6orf204",
            "FOXN3",
            "C9orf93",
            "OCIAD2",
            "CEBPB",
            "PHLDA3",
            "ZKSCAN1",
            "SBF2",
            "TAOK1",
            "DTX2",
            "KLHL11",
            "TMTC2",
            "SPATA13",
            "CEP97",
            "MDN1",
            "ZNF192",
            "LANCL1",
            "TUBGCP3",
            "SASH1",
            "LOC728323",
            "S100A11",
            "CEP192",
            "UTRN",
            "KPNA5",
            "TMEM54",
            "PPP1R14B",
            "STXBP5",
            "PHACTR2",
            "MSI2",
            "GTF2A1",
            "CP110",
            "LCORL",
            "NEU3",
            "ASXL2",
            "TRIM44",
            "WDR35",
            "REST",
            "REV3L",
            "C9orf102",
            "TXLNG",
            "TSPYL4",
            "POLA1",
            "EPM2A",
            "USP12",
            "RAB34",
            "ZCCHC11",
            "LATS1",
            "C2orf86",
            "CASP8AP2",
            "APPL2",
            "PDP2",
            "MOSPD2",
            "ZNF318",
            "EEA1",
            "C19orf22",
            "TTC21B",
            "C11orf30",
            "FBXO30",
            "P4HB",
            "PHF10",
            "RIC8B",
            "WDR47",
            "ANUBL1",
            "PPM1D",
            "TNIP2",
            "ZNF791",
            "OSBPL11",
            "PDS5B",
            "WDR7",
            "PIKFYVE",
            "ARID1B",
            "TAB2",
            "MED23",
            "UBC",
            "SHISA5",
            "FAM120B",
            "PHF23",
            "VPS8",
            "TRAF6",
            "BCLAF1",
            "C10orf28"
        ]
    },
    {
        "golabel": "SIN3B_regulon_activity",
        "gene": [
            "DOCK3",
            "EME2",
            "FAM157A",
            "ADAMTS10",
            "LOC91316",
            "LCAT",
            "LOC100128842",
            "MAPK8IP3",
            "LTB4R2",
            "GATA2",
            "ABCA7",
            "NOTCH4",
            "LENG8",
            "HIGD1A",
            "WDR90",
            "ANO8",
            "PTPRS",
            "DMPK",
            "C5orf35",
            "LOC729991-MEF2B",
            "PLXNA3",
            "CNIH",
            "HSBP1",
            "FLJ45340",
            "TOMM22",
            "SHANK3",
            "ZNF37B",
            "LOC642852",
            "GIGYF1",
            "NUMBL",
            "FAM156A",
            "TUBGCP6",
            "CRTC1",
            "MAP3K10",
            "TSSK6",
            "PKD1",
            "C19orf44",
            "KIAA0467",
            "C8orf33",
            "SFI1",
            "ZNF341",
            "PTPLAD1",
            "SEMA4C",
            "DOT1L",
            "RUSC2",
            "SRRM2",
            "LZTR1",
            "SFRS14",
            "SOLH",
            "NCKAP5L",
            "ALG14",
            "CISD1",
            "SDHD",
            "ATP5F1",
            "CEP164",
            "CRAMP1L",
            "EIF1AX",
            "RWDD1",
            "THAP1",
            "DOCK6",
            "SDHB",
            "AKAP8L",
            "MYO9B",
            "C1GALT1C1",
            "MIER2",
            "CC2D1A",
            "ABCC10",
            "HDAC7",
            "PRKAG1",
            "LOC653566",
            "MUM1",
            "COPS4",
            "YWHAE",
            "TYK2",
            "REXO1",
            "KDM4B",
            "ATP13A1",
            "WIZ",
            "MORF4L1",
            "CHERP",
            "MED26",
            "TMX2",
            "RFX1",
            "TMBIM6",
            "C19orf29",
            "DNAJA2",
            "ELL",
            "KIAA0892",
            "TSG101",
            "ANXA7",
            "UBE2D2"
        ]
    },
    {
        "golabel": "SIRT1_regulon_activity",
        "gene": [
            "C1orf95",
            "DNAJC12",
            "KIT",
            "PRSS22",
            "C17orf60",
            "MICALL2",
            "CLTB",
            "PHF17",
            "IFI35",
            "HOMER3",
            "CARD16",
            "ARPC1B",
            "PDLIM7",
            "SH3BGRL3",
            "PSMB10",
            "EFHD2",
            "LCOR",
            "RHOC",
            "GPX1",
            "TMEM170B",
            "ZNF24",
            "CIB1",
            "TYMP",
            "DTX2",
            "METRNL",
            "CCDC109A",
            "STAU2",
            "NAA30",
            "C9orf89",
            "PLIN3",
            "PML",
            "MED13L",
            "DOCK1",
            "FAM190B",
            "PI4K2B",
            "WDR35",
            "AMDHD2",
            "UBXN2B",
            "TRMT1",
            "GIPC1",
            "NAGLU",
            "ZYX",
            "IDE",
            "TRIP10",
            "TSC22D4",
            "MAP7D1",
            "PNKP",
            "LMF2",
            "MYST4",
            "PAPD5",
            "SIRT6",
            "ZNF22",
            "RB1CC1",
            "JMJD1C",
            "DSTYK",
            "DCAF10",
            "PAPOLA",
            "PTPN6",
            "ANUBL1",
            "MIER3",
            "GSS",
            "PPM1D",
            "SH3GL1",
            "AP2M1",
            "CNST",
            "NAGPA",
            "STX4",
            "IKZF5",
            "RNF38",
            "CBARA1",
            "DBNL",
            "ATP6V0C",
            "ACTB",
            "NAGK",
            "CHUK",
            "EXOC6",
            "ZMYND11",
            "KIAA1279",
            "CDC37",
            "BMPR1A",
            "EIF4EBP2",
            "DDX50",
            "PARG",
            "RAD23A",
            "EPC2",
            "APPL1",
            "TBC1D12",
            "PPM1B",
            "TNKS2",
            "ZRANB1",
            "ADO",
            "AP3M1",
            "WAC",
            "ECD",
            "PUM2"
        ]
    },
    {
        "golabel": "SIRT3_regulon_activity",
        "gene": [
            "SLC16A11",
            "C16orf89",
            "ATHL1",
            "BNIPL",
            "PLIN5",
            "GUCY1B2",
            "MESP1",
            "PRICKLE4",
            "EVPLL",
            "SFTA2",
            "SELENBP1",
            "WFDC2",
            "PRR11",
            "CASC5",
            "UBQLNL",
            "EFCAB4A",
            "KIAA1524",
            "CKAP2L",
            "FLJ45244",
            "PCSK4",
            "ABCC6",
            "SFTA3",
            "C11orf35",
            "GAS2L3",
            "KLHDC9",
            "LOC100134368",
            "DFNB59",
            "MXD1",
            "SLC22A18",
            "ECT2",
            "ACCS",
            "TSTD1",
            "B3GNT5",
            "C15orf56",
            "HMGN3",
            "TMEM125",
            "FHIT",
            "HSD17B8",
            "IRF7",
            "C1orf97",
            "LOC100128288",
            "NKX2-1",
            "IPMK",
            "NUDT13",
            "LRDD",
            "ABHD14A",
            "C21orf57",
            "FLJ35220",
            "FAM55C",
            "HIF1A",
            "C5orf45",
            "SPATA24",
            "RASSF7",
            "PACSIN3",
            "ECHDC2",
            "ZDHHC20",
            "RBL1",
            "TMEM150A",
            "NENF",
            "NUDT17",
            "LOC729234",
            "DCK",
            "IFITM2",
            "MAPK6",
            "MRPS25",
            "DNAJC28",
            "TOPBP1",
            "MRPL23",
            "ENTPD7",
            "SBNO1",
            "CALU",
            "SKIL",
            "DDX21",
            "RECQL",
            "SIGIRR",
            "CLIC4",
            "SCRN2",
            "ARV1",
            "PAWR",
            "LOC645332",
            "EPS8L2",
            "RIF1",
            "POLR2L",
            "SETD4",
            "CD151",
            "PNPLA2",
            "ROGDI",
            "TMEM175",
            "BLVRA",
            "CNKSR1",
            "C11orf49",
            "HEMK1",
            "NMD3",
            "FNDC3B",
            "SERGEF",
            "NICN1",
            "C16orf58",
            "ADAM10",
            "GNRHR2",
            "PIGQ",
            "SAMD8",
            "DEAF1",
            "DHRS12",
            "FBXW4",
            "NAT6",
            "CYP2R1",
            "OPA1",
            "TMEM41B",
            "IL17RC",
            "MYST1",
            "DAK",
            "MOBKL1B",
            "ZNF76",
            "KPNA4",
            "FYTTD1",
            "LUZP6",
            "OSBPL8",
            "C2orf68",
            "PAK2",
            "ZBED5",
            "TUT1",
            "FAM160A2",
            "PGAP2",
            "RMND5B",
            "TSSC4",
            "AGPS",
            "AP2A2",
            "MOB2",
            "RSAD1",
            "ZNF18",
            "RNH1",
            "BET1L",
            "CDK9",
            "MRFAP1L1",
            "RRP8",
            "RAB35",
            "RIC8A",
            "NAP1L4",
            "ARFGAP2"
        ]
    },
    {
        "golabel": "SIRT4_regulon_activity",
        "gene": [
            "ENO3",
            "FOSL1",
            "ANKRD29",
            "ALDH3A2",
            "AIM1",
            "CDCP1",
            "MBOAT2",
            "SYTL4",
            "TMEM125",
            "BICD1",
            "SSR4",
            "ABHD14A",
            "BGLAP",
            "FAM164C",
            "TMEM116",
            "PHPT1",
            "C5orf45",
            "MAGEH1",
            "C2orf79",
            "C12orf62",
            "RANGRF",
            "FOSL2",
            "COX6A1",
            "MCEE",
            "TMEM9",
            "ACADS",
            "SYNJ2",
            "NRL",
            "OSBPL3",
            "C17orf108",
            "MTERFD3",
            "LASS6",
            "C1orf203",
            "ERP29",
            "C2orf64",
            "PRKAB1",
            "SAT2",
            "MAP3K5",
            "C22orf32",
            "RASAL2",
            "KLHDC2",
            "ZSWIM7",
            "ZSCAN16",
            "MMAB",
            "POP5",
            "PMF1",
            "SSR2",
            "MED11",
            "GNA12",
            "SERP1",
            "COQ5",
            "C12orf47",
            "SUCLG1",
            "CYP2R1",
            "HIVEP2",
            "YPEL5",
            "ZDHHC16",
            "PEBP1",
            "PIGH",
            "BCDIN3D",
            "ASCC3",
            "NSMCE4A",
            "WBP1",
            "C12orf65",
            "SDF2",
            "ITPRIPL2",
            "COQ6",
            "DCLRE1B",
            "PATL1",
            "ZNF140",
            "RMND5B",
            "MTERFD2",
            "ISCU",
            "RNF167",
            "FAM54B",
            "XPO6",
            "USP30",
            "RAB8A"
        ]
    },
    {
        "golabel": "SIRT7_regulon_activity",
        "gene": [
            "C9orf169",
            "KCP",
            "AIM1L",
            "RHOF",
            "C19orf33",
            "LOC388242",
            "KRT7",
            "NHSL2",
            "EPS8L1",
            "UNC13D",
            "PRSS22",
            "CBLC",
            "C1orf170",
            "RGAG4",
            "KRT19",
            "S100A16",
            "PRKD1",
            "TXNDC16",
            "PLEKHN1",
            "SLC16A5",
            "SLC16A3",
            "USP51",
            "MPP3",
            "IL6ST",
            "EPN3",
            "STRA13",
            "TTC22",
            "ASPSCR1",
            "EVPL",
            "TMEM86B",
            "CDR2L",
            "CDK3",
            "KRT8",
            "TP53I3",
            "TUBA4A",
            "FLJ35220",
            "RECK",
            "SH2D3A",
            "SLC25A10",
            "RASSF7",
            "HN1",
            "SPRN",
            "JUP",
            "ANAPC11",
            "BAIAP2",
            "AFMID",
            "RAB11FIP2",
            "MRPL12",
            "ELMO3",
            "ARHGEF16",
            "PKP3",
            "TMEM54",
            "CYP2U1",
            "DVL1",
            "GTF2A1",
            "B3GNTL1",
            "GPRASP2",
            "C17orf90",
            "DIXDC1",
            "TCIRG1",
            "CBX8",
            "LLGL2",
            "PCYT2",
            "ZFYVE19",
            "CHSY1",
            "SLC39A11",
            "C1orf159",
            "LRRC45",
            "EPS8L2",
            "CAPN10",
            "PAK4",
            "TMC6",
            "GET4",
            "C17orf106",
            "TMUB1",
            "SYNGR2",
            "POLD4",
            "DNAJC18",
            "NT5C",
            "C17orf56",
            "ARL15",
            "ZDHHC12",
            "GIPC1",
            "JMY",
            "DUS1L",
            "BACE1",
            "ARRDC1",
            "NDOR1",
            "ZNF426",
            "SSH3",
            "CCDC137",
            "SLC38A10",
            "PNKP",
            "ARSB",
            "MRPL38",
            "RFNG",
            "TSSC1",
            "TRIM11",
            "ZNF295",
            "ATRX",
            "DEDD2",
            "P4HB",
            "CTTN",
            "FAM172A",
            "KLHL15",
            "ZFAND2B",
            "RCE1",
            "GMPPA",
            "TNIP2",
            "ZNF791",
            "PJA2",
            "HGS",
            "C17orf62",
            "C17orf39",
            "SMAD5",
            "NPLOC4",
            "CORO1B",
            "WBP2",
            "ARHGDIA",
            "COASY",
            "MAP3K11",
            "STAG2",
            "DDX24",
            "SAP30BP",
            "AAMP"
        ]
    },
    {
        "golabel": "SKI_regulon_activity",
        "gene": [
            "LOC100129066",
            "NACAD",
            "TMEM14A",
            "ITGA2",
            "COL8A1",
            "SSC5D",
            "ENG",
            "MEGF6",
            "ENC1",
            "LTBP2",
            "SNRPG",
            "KCNC3",
            "PTPRG",
            "GTF2A2",
            "GALNT10",
            "COX7B",
            "RFK",
            "IFFO2",
            "UQCRFS1",
            "ARHGAP23",
            "KIAA0427",
            "HIP1",
            "KIAA1274",
            "MICAL2",
            "SORD",
            "PLXND1",
            "GLA",
            "IDI1",
            "PTK7",
            "FLNA",
            "ACAT2",
            "NDUFB5",
            "SYNPO",
            "C20orf24",
            "HSPG2",
            "ADARB1",
            "CCDC58",
            "DUSP7",
            "ZFP36L1",
            "HTATIP2",
            "MARVELD3",
            "H6PD",
            "HSPE1",
            "LTBP3",
            "ZBTB46",
            "SLC25A5",
            "C11orf95",
            "AHDC1",
            "CCDC59",
            "GLIS2",
            "COX5A",
            "MPRIP",
            "TMEM5",
            "C16orf61",
            "EVC",
            "NOTCH1",
            "C12orf73",
            "COPS5",
            "ATP5G3",
            "SMAD7",
            "MACF1",
            "PIGF",
            "COX17",
            "PSMD14",
            "C17orf75",
            "SPRYD4",
            "ARHGEF17",
            "MYH9",
            "KLHL21",
            "KANK2",
            "CHMP5",
            "PHLDB1",
            "FUCA2",
            "NCKAP5L",
            "OXSM",
            "ACTR6",
            "ABR",
            "ACBD5",
            "PSMA4",
            "GTF2E2",
            "CIC",
            "NCOR2",
            "RUNX1",
            "ZHX3",
            "MLLT1",
            "PCCB",
            "RBM9",
            "B3GALT6",
            "MAP3K3",
            "HDAC7",
            "C2orf47",
            "MRPS16",
            "SUFU",
            "ZC3H7B",
            "HCCS",
            "RBBP7",
            "SEPN1",
            "MDH1",
            "ACP1",
            "GLOD4",
            "ZDHHC6",
            "PLEKHM2"
        ]
    },
    {
        "golabel": "SKIL_regulon_activity",
        "gene": [
            "BICC1",
            "INHBA",
            "KIAA1211",
            "TSHZ2",
            "VCAN",
            "DENND5B",
            "PYGO1",
            "AK1",
            "C8orf73",
            "PIP5KL1",
            "WISP1",
            "NUAK1",
            "ATP2B1",
            "HDGFRP3",
            "LTBP1",
            "EIF5A2",
            "MFSD3",
            "ECT2",
            "DCXR",
            "GAMT",
            "FSTL1",
            "ACAP2",
            "STON1",
            "MACROD1",
            "C3orf58",
            "FHIT",
            "RNF168",
            "STK38L",
            "PLD1",
            "FLJ35220",
            "ZNF460",
            "MRPL14",
            "TAOK1",
            "WEE1",
            "TMEM150A",
            "FHOD1",
            "UBXN7",
            "RILP",
            "MGC16275",
            "CEP97",
            "FDXR",
            "ATP13A3",
            "FBXL6",
            "CCNT1",
            "PTGFRN",
            "ELMO3",
            "SIL1",
            "ENTPD7",
            "DPP7",
            "HEXIM2",
            "ACPL2",
            "DNAJC10",
            "SCRN2",
            "STAP2",
            "EEF1D",
            "CHSY1",
            "MAN1A2",
            "MYNN",
            "RSRC1",
            "MRM1",
            "TMTC3",
            "SHARPIN",
            "REST",
            "DHRS1",
            "LOC221710",
            "RPL19",
            "ATP2C1",
            "ATP11B",
            "ABHD14B",
            "DCUN1D1",
            "MIB1",
            "CCDC50",
            "ACBD4",
            "FNDC3B",
            "TBCCD1",
            "YES1",
            "PMVK",
            "DHODH",
            "CYHR1",
            "PHF6",
            "DHRS12",
            "ACAA1",
            "HAGH",
            "COQ4",
            "OPA1",
            "STX10",
            "STAG1",
            "DNAJC17",
            "PIK3CA",
            "GHDC",
            "DAK",
            "DNAJC30",
            "LGTN",
            "MPND",
            "EIF2AK3",
            "ABCB8",
            "AGAP3",
            "CHMP6",
            "TEX264",
            "MFN1",
            "ESCO1",
            "KPNA4",
            "FYTTD1",
            "MON1A",
            "WDR83",
            "MAP3K2",
            "DHX36",
            "FKBP8",
            "NDUFV1",
            "AKIRIN1",
            "RNF135",
            "TECR",
            "TBL3",
            "SIRT3",
            "GPR108",
            "WBSCR16",
            "POLR2E",
            "RNH1",
            "C11orf2",
            "UBXN1",
            "ZNF148",
            "ACTR2"
        ]
    },
    {
        "golabel": "SLC30A9_regulon_activity",
        "gene": [
            "APOE",
            "CTRL",
            "NPIPL3",
            "EGFL8",
            "UAP1L1",
            "TMC8",
            "TMEM86B",
            "LIMCH1",
            "OCIAD2",
            "C4orf34",
            "TBC1D19",
            "ZNF385A",
            "LIAS",
            "TNK2",
            "FAM114A1",
            "SH3BP1",
            "SUCLG2",
            "PTPLAD1",
            "PI4K2B",
            "C17orf56",
            "CCDC149",
            "ARID5A",
            "TSNAX",
            "TMEM128",
            "OGFR",
            "TFB2M",
            "TMEM87A",
            "RCHY1",
            "SF3A2",
            "PACRGL",
            "AASDH",
            "FBXL5",
            "DGKZ",
            "SEPSECS",
            "KIAA0232",
            "CCNI",
            "TMEM33",
            "KIAA1430",
            "GNPDA2",
            "UBE2K",
            "TMEM192",
            "DNAJB14",
            "RBM47",
            "G3BP2",
            "CSK",
            "ATF6",
            "PIGG",
            "C1orf55",
            "USO1",
            "ATAD1",
            "MRFAP1L1",
            "RAB28",
            "SLAIN2"
        ]
    },
    {
        "golabel": "SMAD6_regulon_activity",
        "gene": [
            "CLDN18",
            "RSPO2",
            "CHRM1",
            "VSIG2",
            "VIPR1",
            "CDKN3",
            "CENPA",
            "MAD2L1",
            "DEPDC1",
            "KCNQ1",
            "TTK",
            "CENPI",
            "DLGAP5",
            "TPX2",
            "TRIP13",
            "EPR1",
            "HMMR",
            "KIAA1524",
            "CKAP2L",
            "CCNA2",
            "NCAPG",
            "MELK",
            "BUB1",
            "KIF4A",
            "TBX2",
            "CCNB1",
            "RACGAP1",
            "MOSC2",
            "KPNA2",
            "INCA1",
            "FRAT1",
            "SOX13",
            "DBF4",
            "SNX22",
            "PPAT",
            "PSMC2",
            "ENO1",
            "RINT1",
            "C7orf70",
            "MAN2A2",
            "TRIOBP",
            "GTPBP10",
            "COPS8",
            "INPP5A",
            "SNX1"
        ]
    },
    {
        "golabel": "SMARCA2_regulon_activity",
        "gene": [
            "DUSP13",
            "TNNI3",
            "QPCT",
            "KIAA2022",
            "AKR1E2",
            "LOC100133985",
            "PCSK5",
            "ABI3BP",
            "ZBTB7C",
            "QPRT",
            "SRGAP3",
            "SC65",
            "ARG2",
            "NFIX",
            "TLR2",
            "MGC72080",
            "ZNF366",
            "MC1R",
            "SNRPG",
            "GLIS3",
            "AHNAK",
            "KRT18",
            "PPP1R12B",
            "MCC",
            "TMEM106C",
            "ANKRD44",
            "C6orf129",
            "C18orf1",
            "NDUFB9",
            "C16orf59",
            "TIMM17B",
            "MRPL13",
            "MAML2",
            "DOCK8",
            "PSMG3",
            "NME1",
            "FLI1",
            "RASSF2",
            "AKAP13",
            "DTYMK",
            "SNRPB",
            "TLE4",
            "HN1",
            "BOLA3",
            "MRPS23",
            "MRPL12",
            "PSMB5",
            "DIAPH2",
            "COL4A3BP",
            "PSMD3",
            "KAT2B",
            "PIK3R1",
            "TRANK1",
            "SMUG1",
            "NFIC",
            "C5orf41",
            "C12orf73",
            "RASSF5",
            "TMEM164",
            "SGK269",
            "WDR45L",
            "C17orf75",
            "TARBP2",
            "PSMB4",
            "MTX1",
            "FLAD1",
            "FOXO3",
            "VPS13C",
            "TRAF4",
            "MRTO4",
            "ARID5B",
            "MYCBP2",
            "VPS72",
            "TBRG4",
            "FAM119A",
            "ILF2",
            "MRPL9",
            "ZFP106",
            "SNX29",
            "CPEB3",
            "RNASEL",
            "HERC1",
            "DIABLO",
            "DGUOK",
            "KIAA0247",
            "MTA3",
            "GNAQ",
            "VPS25",
            "KIAA2026",
            "APC",
            "ZNHIT3",
            "ZC3HC1",
            "KDM4C",
            "ZCCHC6",
            "ERCC5",
            "SNF8",
            "MADD",
            "SAP30L",
            "DDOST",
            "GPS1",
            "PHF2",
            "KLHL20",
            "EIF4EBP2",
            "ZNF490",
            "EIF2B1",
            "FAM122A"
        ]
    },
    {
        "golabel": "SMARCA4_regulon_activity",
        "gene": [
            "FAM171A2",
            "C14orf72",
            "AVPI1",
            "NNMT",
            "FLJ35776",
            "ANKRD13B",
            "CSGALNACT1",
            "CHPT1",
            "PFKFB3",
            "ACTR3C",
            "IL18",
            "TDP2",
            "SQRDL",
            "FDX1",
            "CREG1",
            "RAB11FIP4",
            "TTLL11",
            "MTHFS",
            "ZSWIM4",
            "FAM96A",
            "C14orf4",
            "TMEM218",
            "HEXA",
            "BCR",
            "LRRC28",
            "SDHD",
            "ATG5",
            "SPPL2A",
            "MLLT1",
            "EDEM2",
            "SNAPC5",
            "CC2D1A",
            "C15orf40",
            "RAVER1",
            "STX7",
            "WIZ",
            "MORF4L1",
            "CHERP",
            "CHD4",
            "KHSRP",
            "SNAP23",
            "ILF3",
            "DDX42"
        ]
    },
    {
        "golabel": "SMARCAL1_regulon_activity",
        "gene": [
            "C6orf195",
            "ACOXL",
            "FAM189A2",
            "ZNF662",
            "C3orf35",
            "LRP2BP",
            "C9orf68",
            "PLK1",
            "METTL7A",
            "ZNF321",
            "TACC3",
            "ZNF69",
            "C11orf61",
            "NOTCH3",
            "TP53INP1",
            "MAP4K4",
            "ZNF763",
            "ZMYND17",
            "ZNF441",
            "ZNF34",
            "GNRHR2",
            "ZNF44",
            "PSMD11",
            "PSMD2",
            "SLC38A7",
            "PSMD1",
            "PLEKHA9",
            "RPE",
            "YWHAG",
            "TMEM185B",
            "TFG",
            "USP5",
            "REEP5",
            "ATIC",
            "UBE2F",
            "NCKAP1",
            "TRIP12",
            "HDLBP",
            "ATG16L1",
            "ZNF142",
            "COPS7B",
            "DNPEP",
            "XRCC5",
            "ATG9A",
            "DYNC1I2",
            "AAMP",
            "FAM134A",
            "IWS1"
        ]
    },
    {
        "golabel": "SMARCC1_regulon_activity",
        "gene": [
            "MEX3A",
            "TAF4B",
            "BLVRB",
            "IFI27L2",
            "C17orf60",
            "BATF",
            "HSP90AB2P",
            "ACVR2B",
            "IFI35",
            "TNFRSF14",
            "XYLB",
            "GCHFR",
            "CARD16",
            "PSMB10",
            "SERTAD1",
            "MFHAS1",
            "PRKDC",
            "RRAS",
            "TMEM149",
            "U2AF1L4",
            "SOX4",
            "BEND3",
            "GSTK1",
            "ZNF688",
            "AMDHD2",
            "DNASE1L1",
            "RAD18",
            "ZNF623",
            "IKBKG",
            "RGS19",
            "WDR3",
            "RAB4B",
            "DCAF16",
            "TOP1",
            "KDM5B",
            "PHF14",
            "GNL3",
            "COPG2",
            "HSP90AB1",
            "NCOA6",
            "PPP4R2",
            "MOBKL2C",
            "NAGK",
            "PBRM1",
            "RHOG",
            "RYBP",
            "ADPGK",
            "MAP4",
            "XPO7",
            "TBC1D22A",
            "LARS2",
            "VPRBP",
            "DHX9",
            "RBM15B",
            "HNRNPU",
            "RBM12"
        ]
    },
    {
        "golabel": "SMARCD3_regulon_activity",
        "gene": [
            "C16orf89",
            "CTSH",
            "CD1C",
            "KCNJ15",
            "FLJ36777",
            "LOC388588",
            "ZDHHC15",
            "WFDC2",
            "ARHGAP11B",
            "INPP5J",
            "PRR11",
            "CASC5",
            "GLOD5",
            "HMGA1",
            "KIF14",
            "GOLT1A",
            "LOC284837",
            "ABCC6P2",
            "LTC4S",
            "ARHGAP11A",
            "PDE6B",
            "MKI67",
            "B3GNT8",
            "CHADL",
            "SLC25A29",
            "DSG2",
            "KIF11",
            "NEIL1",
            "ACOX2",
            "SRGAP1",
            "HYI",
            "NKX2-1",
            "SEPW1",
            "C10orf11",
            "ABHD14A",
            "KIF20B",
            "SLC7A1",
            "NUDT14",
            "SNRPN",
            "EIF2C2",
            "SHISA4",
            "ZDHHC1",
            "FCGRT",
            "MAPRE3",
            "DPP7",
            "DDX21",
            "EHBP1",
            "C22orf32",
            "MOAP1",
            "FBXO44",
            "RIF1",
            "AGXT2L2",
            "ROGDI",
            "SMC3",
            "CKAP5",
            "PPM1M",
            "TCEAL8",
            "DDX10",
            "MTMR2",
            "NCOA3",
            "NUP153",
            "NOLC1",
            "NCOA6",
            "RALBP1",
            "PATL1",
            "AGPS",
            "FUBP1",
            "FAM54B",
            "HNRNPR"
        ]
    },
    {
        "golabel": "SMURF2_regulon_activity",
        "gene": [
            "CSF2",
            "GPX2",
            "S100P",
            "HGD",
            "PPARGC1A",
            "ANXA1",
            "CKMT1A",
            "KCNQ5",
            "DUSP4",
            "FXYD3",
            "NQO1",
            "DCBLD2",
            "ARHGAP20",
            "PDZD7",
            "ITGA2",
            "P2RY6",
            "PDE4D",
            "FRMD5",
            "CCDC64",
            "PGD",
            "FAM176A",
            "ATP10A",
            "ABCB6",
            "C19orf21",
            "FLJ35776",
            "PLS3",
            "PRKCA",
            "FAM126A",
            "DUSP6",
            "TC2N",
            "AIM1",
            "ICAM1",
            "PAG1",
            "ANKRD56",
            "MBOAT2",
            "ITGA3",
            "AXL",
            "KIRREL",
            "CDC42EP3",
            "DPY19L1",
            "IRS1",
            "XPR1",
            "SAMD4A",
            "FAS",
            "LIPT2",
            "GALNT10",
            "DPYD",
            "TJP3",
            "BDH1",
            "IL27RA",
            "MDFIC",
            "HIP1",
            "DOCK10",
            "GSTP1",
            "ITGAV",
            "STK17A",
            "ZNF462",
            "MXRA7",
            "OGFRL1",
            "LOC651250",
            "AIFM2",
            "XBP1",
            "ELK3",
            "ADK",
            "KLHL25",
            "IDS",
            "FGD6",
            "PPIB",
            "ADAP2",
            "FAAH2",
            "SLFN5",
            "FRAT2",
            "SPRED1",
            "NRP1",
            "ZFP36L1",
            "LIMK1",
            "OVOL2",
            "PIM3",
            "PDIA3",
            "CFLAR",
            "CNN3",
            "PDIA3P",
            "ERP29",
            "TTLL11",
            "NANS",
            "CTNNB1",
            "C11orf51",
            "APOO",
            "COX5A",
            "NDUFV2",
            "MAPKAPK3",
            "CHMP1B",
            "APLP2",
            "PIGT",
            "LYST",
            "LYN",
            "SPRED2",
            "COX17",
            "SPAG9",
            "C10orf57",
            "TRIM34",
            "MPDU1",
            "MSN",
            "SFXN3",
            "IFNAR2",
            "SLC48A1",
            "ALKBH8",
            "SYNJ1",
            "COQ9",
            "G6PC3",
            "GFOD2",
            "TMEM43",
            "USP25",
            "MAP3K3",
            "PTOV1",
            "GPS2",
            "ATXN1",
            "VEZT",
            "SLC41A3",
            "AAAS",
            "RNF187",
            "PTPN12",
            "SNX15",
            "VEZF1",
            "VPS33B",
            "UBE2Z",
            "USP4"
        ]
    },
    {
        "golabel": "SNAI1_regulon_activity",
        "gene": [
            "IL1A",
            "CCL21",
            "GPR97",
            "G0S2",
            "CDA",
            "IL6",
            "TWIST1",
            "TGFBI",
            "AIM2",
            "XIRP1",
            "MT2A",
            "C16orf89",
            "LILRA3",
            "GREM1",
            "ITGA5",
            "SERPINE1",
            "MSC",
            "ADAM12",
            "STEAP1",
            "ZNF750",
            "PRICKLE4",
            "FSCN1",
            "COL3A1",
            "FBXO32",
            "ADAMTS4",
            "COL15A1",
            "GLS2",
            "COL5A2",
            "C9orf152",
            "TNFAIP6",
            "ADAMTS5",
            "SELENBP1",
            "SLC2A5",
            "PARM1",
            "C1orf116",
            "SPHK1",
            "POSTN",
            "ARSI",
            "CTHRC1",
            "OLFML2B",
            "PRR15L",
            "SFTA3",
            "LOC541471",
            "COL6A2",
            "RND3",
            "SLC12A8",
            "GPR160",
            "SH3BGRL2",
            "SEMA6B",
            "MMP14",
            "ACTA2",
            "THY1",
            "PLAUR",
            "HNF1B",
            "SOCS3",
            "EPHX2",
            "CD248",
            "COL4A1",
            "MCAM",
            "B3GNT5",
            "C15orf56",
            "MMD",
            "CRISPLD2",
            "LOC100302401",
            "TUBB6",
            "TNFAIP3",
            "TMEM125",
            "ZNF321",
            "SLAIN1",
            "C11orf52",
            "IER5",
            "NCS1",
            "BMP1",
            "OCLN",
            "LOC100270710",
            "CEBPB",
            "PALLD",
            "FLJ36031",
            "HIF1A",
            "JUNB",
            "PPP1R9A",
            "MYO5C",
            "BTBD9",
            "TBXA2R",
            "PPFIBP2",
            "TYMP",
            "MARVELD1",
            "GPR4",
            "RALGPS1",
            "METRNL",
            "MRPS25",
            "C2orf15",
            "DNAJC28",
            "ENPP4",
            "ZNF763",
            "PARVB",
            "CALU",
            "TAPT1",
            "MYLIP",
            "CHSY1",
            "ILDR1",
            "MOAP1",
            "PRSS16",
            "C9orf30",
            "ZNF33B",
            "CORO1C",
            "PDIK1L",
            "MARVELD2",
            "HIBCH",
            "PHKB",
            "OFD1",
            "RGS19",
            "CYP2R1",
            "AKAP1",
            "KIAA0319L",
            "GLT25D1",
            "TMEM41B",
            "TTC19",
            "NTAN1",
            "SEPSECS",
            "ZBTB3",
            "SCYL3",
            "ZNF564",
            "CYP20A1",
            "EIF4ENIF1"
        ]
    },
    {
        "golabel": "SNAPC1_regulon_activity",
        "gene": [
            "IL8",
            "LGALS1",
            "MT1X",
            "CDKN3",
            "POLE2",
            "MAD2L1",
            "RHOBTB2",
            "DEPDC1",
            "C12orf24",
            "DLGAP5",
            "CTHRC1",
            "EPR1",
            "CDK1",
            "SIP1",
            "G2E3",
            "MLPH",
            "CCNB1",
            "DAPK1",
            "SPIRE2",
            "FAM83E",
            "PAQR3",
            "MMD",
            "CDCA4",
            "TJP3",
            "CFL2",
            "PPIL5",
            "FRAT1",
            "STK17A",
            "MYH14",
            "HIF1A",
            "SNX6",
            "CENPQ",
            "DBF4",
            "P4HA1",
            "PGK1",
            "HPRT1",
            "VRK1",
            "PNP",
            "ERBB3",
            "NBEAL2",
            "RAN",
            "RALGPS1",
            "AP4S1",
            "STARD3NL",
            "C17orf28",
            "ARL6IP6",
            "IKBIP",
            "CNN3",
            "NUDCD1",
            "PAK1IP1",
            "TIMM8A",
            "DCUN1D5",
            "MED30",
            "CLIC4",
            "C12orf29",
            "GPN1",
            "CLDND1",
            "LLGL2",
            "FAM49B",
            "ESRP2",
            "PNPLA2",
            "C18orf19",
            "TMX1",
            "PGPEP1",
            "IFT52",
            "NMD3",
            "ZNF410",
            "CCT4",
            "MNAT1",
            "AZIN1",
            "KLF10",
            "ENO1",
            "FBXW4",
            "PSMA2",
            "CHD3",
            "NME7",
            "GTF2H3",
            "PGAM1",
            "LRRC40",
            "C14orf118",
            "SCAMP2",
            "RNPEPL1",
            "EIF2S1",
            "PSD4",
            "VMA21",
            "EXOC5",
            "C14orf135",
            "COPS8",
            "ARHGEF11",
            "STYX",
            "COG7",
            "UTP18",
            "DARS",
            "TBC1D17",
            "CNNM3",
            "C4orf3",
            "SEPT7",
            "VPS39",
            "NAT15",
            "BBS7",
            "CTDSP1"
        ]
    },
    {
        "golabel": "SNAPC2_regulon_activity",
        "gene": [
            "PRRX2",
            "ASPHD1",
            "LGSN",
            "LGALS1",
            "PDLIM4",
            "DIRAS1",
            "MARK1",
            "PIR",
            "MT1F",
            "REEP6",
            "HAGHL",
            "ADAMTSL5",
            "C1orf170",
            "LOC100130776",
            "C1orf115",
            "PHLDA2",
            "PRKCDBP",
            "RIN1",
            "GAMT",
            "RPL36",
            "CLTB",
            "STOX2",
            "CCDC85B",
            "KDELR3",
            "PRKAR1B",
            "SMARCA1",
            "NDUFA11",
            "RPL28",
            "C1orf93",
            "IFT81",
            "SH3BGRL3",
            "RPS15",
            "GPX1",
            "TRIP6",
            "HSD3B7",
            "NDUFB7",
            "METRNL",
            "GNA15",
            "TRAPPC5",
            "GADD45GIP1",
            "ALKBH7",
            "CCM2",
            "TSPO",
            "MPG",
            "DPP7",
            "PLIN3",
            "C19orf70",
            "C9orf16",
            "ATXN7L1",
            "C19orf53",
            "PGLS",
            "C19orf24",
            "LRRC8E",
            "KIAA1919",
            "GIPC1",
            "CDC34",
            "DAPK3",
            "C19orf25",
            "PDE4A",
            "HMOX2",
            "MCOLN1",
            "RPS6KA4",
            "TRIP10",
            "FAM89B",
            "CNN2",
            "STRBP",
            "MRPL4",
            "DIRC2",
            "RMND5A",
            "TBC1D10A",
            "MAP1S",
            "MPND",
            "PAPD5",
            "FAM125A",
            "RGS3",
            "EVI5L",
            "NDUFS7",
            "PQLC1",
            "OAZ1",
            "SIRT6",
            "MARCH2",
            "HMG20B",
            "RB1CC1",
            "PHF20L1",
            "MIER2",
            "FAM108A1",
            "PKN1",
            "CAPN1",
            "MGA",
            "CLPP",
            "AES",
            "MON1A",
            "SH3GL1",
            "PIN1",
            "CNST",
            "GNAI2",
            "PLSCR3",
            "FKBP8",
            "APBA3",
            "ARID2",
            "DBNL",
            "EIF3G",
            "TWF2",
            "TTC17",
            "SLC39A3",
            "ELOF1",
            "RHOG",
            "BTBD2",
            "STXBP2",
            "CDC37",
            "C19orf56",
            "TLK1",
            "MAP2K2",
            "VPS54",
            "SUV420H1",
            "SNX15",
            "FUBP1",
            "C11orf68",
            "AP1M1",
            "UBXN6",
            "FAM32A",
            "UBXN4",
            "GTF2F1"
        ]
    },
    {
        "golabel": "SNAPC4_regulon_activity",
        "gene": [
            "LRGUK",
            "FAM58B",
            "HIST2H3D",
            "RLTPR",
            "ADAMTS13",
            "C9orf163",
            "FAM22F",
            "C9orf45",
            "CROCC",
            "LOC100131193",
            "TMEM86B",
            "LENG8",
            "SNHG7",
            "P2RY11",
            "DFNB31",
            "LOC100133331",
            "WDR90",
            "GPSM1",
            "LRDD",
            "DMPK",
            "C5orf35",
            "CNIH",
            "CCDC88C",
            "SPRN",
            "SEP15",
            "TMEM106B",
            "GIGYF1",
            "SCOC",
            "NDFIP2",
            "ABCA2",
            "CCNC",
            "FBRSL1",
            "C8orf83",
            "KRBA1",
            "TNK2",
            "SFRS16",
            "IQCE",
            "TAF1C",
            "KIAA0284",
            "CD164",
            "FBXO46",
            "SBF1",
            "ZMIZ2",
            "ZNF707",
            "SLC35F5",
            "ERLEC1",
            "CCDC126",
            "C17orf56",
            "GAK",
            "DOT1L",
            "MTA1",
            "CTBS",
            "DAB2IP",
            "MAGT1",
            "SNX3",
            "OSTM1",
            "METTL9",
            "KIAA0649",
            "SOLH",
            "PRCP",
            "KDM6B",
            "PPP1R12C",
            "WDR85",
            "HEXB",
            "NEURL4",
            "SDHD",
            "INPP5E",
            "ANKS6",
            "CEP164",
            "TSC1",
            "SNRNP70",
            "ZBTB43",
            "SURF6",
            "ODF2",
            "CHMP2B",
            "AGAP3",
            "MMGT1",
            "PIGK",
            "ABCC10",
            "C6orf211",
            "LRSAM1",
            "TMED7",
            "ARL1",
            "RALGDS",
            "ASCC1",
            "COPS4",
            "RNF11",
            "PEX12",
            "ANAPC2",
            "ZCRB1",
            "LAPTM4A",
            "PHRF1",
            "MORF4L1",
            "UGP2",
            "EHMT1",
            "MED22",
            "TMBIM6",
            "YIPF5",
            "DGCR8",
            "ATP6AP2",
            "ANXA7",
            "SAFB2",
            "PLEKHA3",
            "SAFB",
            "RAB1A"
        ]
    },
    {
        "golabel": "SNRPB_regulon_activity",
        "gene": [
            "HIST1H3C",
            "PTPN13",
            "HIST2H2AC",
            "ATP13A4",
            "ROS1",
            "SCN7A",
            "C1QTNF7",
            "MS4A2",
            "FAM24B",
            "TRIB3",
            "REPS2",
            "MRPL21",
            "GINS1",
            "SNX30",
            "CDT1",
            "CSRP2",
            "ANK3",
            "KLF1",
            "SNRPG",
            "MRPS12",
            "MCM7",
            "FNIP2",
            "ROMO1",
            "CDC42BPA",
            "NXT1",
            "C6orf129",
            "SNRPD2",
            "GALNT10",
            "TIMM50",
            "SYNE1",
            "MED27",
            "TMEM133",
            "TBC1D7",
            "CYC1",
            "SGMS2",
            "PDCD5",
            "PAFAH1B3",
            "C20orf7",
            "RNASEH2A",
            "C20orf196",
            "C19orf48",
            "TRAIP",
            "C11orf83",
            "PCNA",
            "AKAP13",
            "DTYMK",
            "LOC388796",
            "POP7",
            "MYOF",
            "COX6A1",
            "EXOSC4",
            "PINX1",
            "BOLA3",
            "ANAPC11",
            "LSM7",
            "FAM128A",
            "SOX12",
            "MRPS26",
            "TOMM40",
            "AHCY",
            "MYL6B",
            "WWC1",
            "HERC3",
            "CCDC46",
            "NAA20",
            "TGFBR2",
            "TBCB",
            "MRPL12",
            "H6PD",
            "PFDN2",
            "WNK1",
            "PDRG1",
            "ALKBH2",
            "PXMP2",
            "C14orf156",
            "NUDT1",
            "FAM128B",
            "LOC152217",
            "SNRPD1",
            "TIMM10",
            "PFDN6",
            "EXOSC8",
            "SCNM1",
            "FANCG",
            "THOC4",
            "DDX39",
            "STOML2",
            "RPP21",
            "APLP2",
            "SMARCA2",
            "C20orf20",
            "PSMA7",
            "NIPAL3",
            "LOC388789",
            "EIF5A",
            "ERH",
            "MACF1",
            "LSM4",
            "SARNP",
            "RAE1",
            "SPAG9",
            "C12orf44",
            "MRPL2",
            "NOP56",
            "ATP7A",
            "RBCK1",
            "DTD1",
            "C20orf27",
            "TRMT6",
            "ITPA",
            "VPS72",
            "FYCO1",
            "PUF60",
            "BANF1",
            "MKKS",
            "NRSN2",
            "COPE",
            "MRPL9",
            "OBFC2B",
            "TXNL4A",
            "SNRPC",
            "RNASEL",
            "CHD9",
            "NUTF2",
            "C20orf72",
            "SNRPB2",
            "RDBP",
            "TAOK3",
            "DGUOK",
            "TPP1",
            "ATXN7",
            "PRMT1",
            "ADRM1",
            "C20orf30",
            "ANKRD42",
            "RUVBL2",
            "POLR3F",
            "PSMD13",
            "UBE2M",
            "RPS6KB2",
            "ARHGEF12",
            "SH3D19",
            "ABT1",
            "WDR74",
            "TIMM44",
            "PDPK1",
            "KIAA0494",
            "SEPHS1",
            "IDH3B",
            "MED6",
            "MCRS1",
            "FOXJ2",
            "ILKAP",
            "NSFL1C",
            "SENP3",
            "FKBP1A",
            "THUMPD1",
            "NBR1",
            "PSMF1",
            "C20orf43",
            "HNRNPL"
        ]
    },
    {
        "golabel": "SNRPD1_regulon_activity",
        "gene": [
            "SLC25A21",
            "TMEM74",
            "EGLN3",
            "FAM64A",
            "CCNB2",
            "PBK",
            "CDKN3",
            "OIP5",
            "CKS2",
            "CENPA",
            "MAD2L1",
            "SKA1",
            "C12orf48",
            "NDC80",
            "AURKB",
            "DEPDC1B",
            "NUF2",
            "TTC39C",
            "EPR1",
            "CENPW",
            "SPC25",
            "CDC25C",
            "BIRC5",
            "CDC20",
            "DSCC1",
            "HJURP",
            "CDCA3",
            "CDK1",
            "GTF3A",
            "CCNA2",
            "SCARF1",
            "NCAPG",
            "GINS1",
            "CKS1B",
            "SKA3",
            "NEK2",
            "KIAA0101",
            "CSRP2",
            "LSM1",
            "ORC6L",
            "UBE2T",
            "SNRPG",
            "CCNB1",
            "FAM92A1",
            "RIMBP3",
            "RAD51",
            "LOC649330",
            "HAUS1",
            "SNRPD2",
            "VDAC3",
            "CD82",
            "PDCD5",
            "LOC728554",
            "PFDN4",
            "C18orf21",
            "ABHD3",
            "TCEB1",
            "NME1",
            "LOC100130932",
            "UQCRHL",
            "POMP",
            "RBBP8",
            "C6orf115",
            "VRK1",
            "PSMC1",
            "SNRPB",
            "RANBP1",
            "FKBP3",
            "BOLA3",
            "TOMM5",
            "RAN",
            "INO80C",
            "CCDC58",
            "CDC42BPG",
            "UQCRH",
            "MRPL15",
            "WWC1",
            "H2AFZ",
            "BRIX1",
            "PDSS1",
            "C18orf45",
            "PSMG1",
            "HSPE1",
            "HSPD1",
            "CYCS",
            "LTBP3",
            "PFDN2",
            "TXNL1",
            "RNF138",
            "ADSL",
            "SNRPF",
            "C14orf156",
            "CCDC59",
            "TIMM8A",
            "CEP76",
            "PSMA3",
            "EEF1E1",
            "NDUFV2",
            "MRPL47",
            "MAGOHB",
            "APLP2",
            "TPRKB",
            "MRPL42",
            "MAGOH",
            "TGIF1",
            "EIF5A",
            "WDR12",
            "PRKCE",
            "ERH",
            "OLA1",
            "PSMD14",
            "C18orf19",
            "FBL",
            "METTL4",
            "ARHGEF17",
            "NUDT15",
            "MPHOSPH6",
            "EIF5AL1",
            "DPM1",
            "SEH1L",
            "MKI67IP",
            "MRTO4",
            "LOC728758",
            "LOC100132707",
            "SNRPE",
            "SMPD1",
            "ZNF319",
            "TXNL4A",
            "CPEB3",
            "C14orf166",
            "PSMA4",
            "UBE2MP1",
            "GTF2E2",
            "SMN2",
            "CLEC16A",
            "PA2G4",
            "GNL3",
            "ANKRD42",
            "PLEKHM1",
            "CASP3",
            "ESCO1",
            "MAP3K3",
            "MORF4L2",
            "C18orf55",
            "BBS1",
            "PSD4",
            "RPF1",
            "NARS",
            "FARSB",
            "SUFU",
            "GLRX5",
            "TBC1D9B",
            "NLRX1",
            "MTCH2",
            "CCT7",
            "AGPAT3",
            "MRPL35",
            "PSMG2",
            "PTPN2",
            "VPS26B",
            "PTMA",
            "SFRS3",
            "HNRNPC",
            "SFRS7",
            "C6orf89"
        ]
    },
    {
        "golabel": "SORBS2_regulon_activity",
        "gene": [
            "WIF1",
            "ASPG",
            "COL25A1",
            "GREB1",
            "PLA2G10",
            "AQP7",
            "LPL",
            "CLU",
            "AIM2",
            "CD274",
            "CACNA2D2",
            "DUOX1",
            "SECISBP2L",
            "AFF3",
            "GEM",
            "FOLR1",
            "CASP5",
            "KLF15",
            "HUNK",
            "CNTN3",
            "TACC2",
            "KCNJ11",
            "GPR133",
            "MAOA",
            "CDH3",
            "RAP1GAP",
            "IL27",
            "IRS2",
            "C10orf55",
            "UBE2C",
            "GPR84",
            "C9orf152",
            "PDZD2",
            "PDE4D",
            "SELENBP1",
            "AHCYL2",
            "FAM149A",
            "BATF3",
            "PARM1",
            "SPHK1",
            "CCL3",
            "RHOBTB2",
            "KCNQ1",
            "CCL4",
            "FOXA2",
            "GBP1",
            "ALDH3A2",
            "SMPDL3B",
            "MECOM",
            "FAM46A",
            "CENPW",
            "ATP1B1",
            "AGA",
            "FCGR1A",
            "TSC22D2",
            "FCGR1C",
            "FCGR3A",
            "FCGR1B",
            "C1QC",
            "TOB1",
            "MLPH",
            "C1QA",
            "HAPLN3",
            "SLC16A3",
            "C7orf41",
            "TK1",
            "LARGE",
            "FCER1G",
            "MMD",
            "PHF17",
            "DISP1",
            "CC2D2A",
            "ALDH2",
            "ZBED3",
            "CCDC109B",
            "MOSC2",
            "RGS10",
            "OPHN1",
            "FLJ36031",
            "FRAT1",
            "IL15RA",
            "FAM107B",
            "DBF4",
            "C6orf150",
            "PECI",
            "IRF5",
            "OBFC2A",
            "RIPK2",
            "KIAA1949",
            "HHAT",
            "CRY2",
            "RHBDF2",
            "IKBIP",
            "PDIA3P",
            "USP54",
            "UBL3",
            "MAML3",
            "THOC4",
            "CYP4V2",
            "FAM63A",
            "LRPAP1",
            "SLC25A4",
            "PHF19",
            "LRRC27",
            "TUBA1B",
            "WDR53",
            "C10orf57",
            "PARP12",
            "CORO1C",
            "C11orf49",
            "ZYX",
            "C10orf32",
            "RGS19",
            "GLT25D1",
            "VAMP2",
            "FOXP1",
            "C1orf96",
            "NTAN1",
            "MLYCD",
            "C2orf67",
            "ZNF267",
            "ACTR3",
            "TRIM13",
            "OSBPL9",
            "CAPZA1",
            "ZC3H7A",
            "GRB2"
        ]
    },
    {
        "golabel": "SOX12_regulon_activity",
        "gene": [
            "FAM171A2",
            "CASKIN1",
            "TSPAN1",
            "B4GALNT4",
            "CECR7",
            "TUBB4",
            "MEX3A",
            "ANKRD22",
            "PTAFR",
            "ANKRD13B",
            "PODXL2",
            "GYLTL1B",
            "CCDC68",
            "CCRL2",
            "ISYNA1",
            "LPAR5",
            "IL7",
            "TPK1",
            "NINL",
            "SLMO1",
            "C20orf96",
            "RAB3A",
            "ZBTB12",
            "DAB2",
            "ANXA2P2",
            "TMEM154",
            "ProSAPiP1",
            "ANXA2",
            "TNFAIP8",
            "ZNF239",
            "CTSS",
            "CD59",
            "CARD6",
            "SNRPB",
            "MRPS26",
            "RASGEF1B",
            "ZSCAN21",
            "PCGF2",
            "NUAK2",
            "DNMT3A",
            "DBN1",
            "ARAP2",
            "TMBIM1",
            "SERPINB8",
            "MAP3K5",
            "PFKM",
            "FAM110A",
            "NOP56",
            "LSM14B",
            "C20orf27",
            "MAGEF1",
            "TRMT6",
            "PATZ1",
            "NRSN2",
            "C20orf72",
            "EHMT2",
            "ZCCHC3",
            "STK35",
            "B3GALNT2",
            "MAZ",
            "CSNK2A1",
            "GMEB2",
            "CAST",
            "SAMD1",
            "ZNF343",
            "CDC42SE2",
            "CENPB",
            "SMPD4",
            "STX7",
            "VPS16",
            "PRCC",
            "NSFL1C",
            "SNAP47",
            "PDCD6IP"
        ]
    },
    {
        "golabel": "SOX13_regulon_activity",
        "gene": [
            "BTNL9",
            "FGFR3",
            "GZMB",
            "STEAP1",
            "FBXO32",
            "NAMPT",
            "TNFAIP6",
            "CTHRC1",
            "UPP1",
            "KCTD1",
            "C1orf115",
            "PTCH1",
            "SMAD6",
            "PLXNA2",
            "DPY19L1",
            "PLEKHA6",
            "IFT140",
            "ZNF219",
            "PIK3C2B",
            "FOXP4",
            "CABC1",
            "FLJ36031",
            "LDHA",
            "RHEB",
            "HHAT",
            "CREM",
            "CASZ1",
            "TICAM2",
            "IKBIP",
            "CALU",
            "SSBP3",
            "RAVER2",
            "SSR3",
            "METTL2B",
            "C12orf23",
            "DDR1",
            "EPM2A",
            "ZDHHC7",
            "PSMC2",
            "C1orf69",
            "RINT1",
            "YWHAG",
            "SLC44A2",
            "RCOR3",
            "LDB1",
            "INPP5A",
            "ARF4",
            "CNNM3",
            "RC3H1",
            "GLYR1",
            "ARFGAP2"
        ]
    },
    {
        "golabel": "SOX18_regulon_activity",
        "gene": [
            "CLDN5",
            "C20orf160",
            "USHBP1",
            "KANK3",
            "GRRP1",
            "RASIP1",
            "HSPA12B",
            "GRAPL",
            "ARHGEF15",
            "EGFL7",
            "ROBO4",
            "RAMP2",
            "TIE1",
            "ID3",
            "LGI4",
            "MAPK11",
            "NOVA2",
            "CD34",
            "NOTCH4",
            "CCDC85B",
            "GJA4",
            "CXorf36",
            "LDLRAD2",
            "BARD1",
            "FAM167B",
            "C19orf20",
            "SH2D3C",
            "GRAP",
            "EXOC3L2",
            "HIC1",
            "LYL1",
            "CYGB",
            "PRRG4",
            "FBXL20",
            "ARMC1",
            "FBXL15",
            "CCDC102A",
            "METTL2B",
            "PRR24",
            "SLC35F5",
            "TOM1L1",
            "RMI1",
            "ZNF468",
            "ARMC5",
            "SLC43A2",
            "ZNF358",
            "DOHH",
            "YWHAQ",
            "DCAF12",
            "GSTCD",
            "ZNF575",
            "DEK",
            "C19orf6",
            "GART",
            "C8orf58",
            "MXD4",
            "RNPEPL1",
            "MBD3",
            "LZIC",
            "IPP",
            "C4orf29",
            "ZNF668",
            "C17orf59",
            "RBBP4",
            "NCLN",
            "PIP5K1C",
            "GTF3C3",
            "METAP1",
            "ITCH",
            "NUCB1",
            "CEBPZ",
            "CAPRIN1",
            "ZFR",
            "CTDSP1",
            "TMEM115",
            "DULLARD",
            "RBMX",
            "SFRS13A"
        ]
    },
    {
        "golabel": "SP1_regulon_activity",
        "gene": [
            "CYP2C19",
            "PDX1",
            "TRIM10",
            "A1BG",
            "GALNT4",
            "LDHAL6B",
            "VAMP5",
            "HKDC1",
            "FAM176A",
            "C4orf44",
            "CSGALNACT1",
            "C5orf55",
            "GAMT",
            "ECHDC3",
            "RARG",
            "BEND7",
            "LIMA1",
            "VSIG10",
            "PCDH1",
            "CD320",
            "C7orf50",
            "FGD6",
            "AP4S1",
            "HSD11B1L",
            "STARD3NL",
            "NUDT16L1",
            "SHISA4",
            "ISCA2",
            "NDUFB2",
            "DGCR6L",
            "VKORC1",
            "SLK",
            "SNRNP25",
            "BLVRA",
            "C18orf22",
            "FDX1L",
            "KLHL7",
            "ZNF770",
            "STYXL1",
            "TCF7L2",
            "BBS9",
            "STK24",
            "SLC24A6",
            "AKR7A2",
            "UBE2D4",
            "BAZ2A",
            "ZDHHC4",
            "C7orf30",
            "GOLGB1",
            "ZCCHC6",
            "ARID2",
            "TMEM55B",
            "NT5C2",
            "HTRA2",
            "SLMAP",
            "INO80D",
            "XPNPEP1",
            "TINF2",
            "ATF7",
            "SLTM",
            "CTCF"
        ]
    },
    {
        "golabel": "SP100_regulon_activity",
        "gene": [
            "ENO3",
            "C19orf45",
            "RCOR2",
            "BHLHA15",
            "CASKIN1",
            "IFI6",
            "SDK1",
            "IFIT1",
            "BIRC3",
            "FBXO39",
            "GPT2",
            "IFI44L",
            "KHDRBS3",
            "MEX3A",
            "IFI27",
            "OASL",
            "IFI44",
            "MX1",
            "RSAD2",
            "RTP4",
            "PODXL2",
            "PSMB9",
            "IL18R1",
            "SAMD9",
            "GLIPR1",
            "IFIT2",
            "GYLTL1B",
            "XAF1",
            "GBP3",
            "IFI27L2",
            "EPSTI1",
            "AIM1",
            "HCST",
            "IFIT3",
            "OAS2",
            "IFIH1",
            "SAMD9L",
            "IL7",
            "DDX60",
            "APOBEC3G",
            "HERC5",
            "GYG2",
            "IFI16",
            "HLA-F",
            "KIAA0114",
            "FAS",
            "IL18",
            "GBP2",
            "IFI35",
            "PPP1R2P1",
            "DDX58",
            "HERC6",
            "CCDC109B",
            "CD40",
            "CASP1",
            "GIMAP2",
            "HLA-B",
            "DDX60L",
            "SOCS7",
            "RAC2",
            "DHX58",
            "B2M",
            "DAPP1",
            "TRIM22",
            "UBE2L6",
            "CAPG",
            "ACTR3B",
            "PDXP",
            "IPO4",
            "RRAS",
            "CFLAR",
            "ZNF517",
            "RAB8B",
            "ARAP2",
            "PML",
            "MLEC",
            "ZNF74",
            "RALB",
            "IFIT5",
            "BTN3A1",
            "NMI",
            "TH1L",
            "RBM43",
            "LYSMD2",
            "TRIM34",
            "ZNF48",
            "LSM14B",
            "PARP12",
            "LAP3",
            "IRF9",
            "SP110",
            "REPIN1",
            "TRIM21",
            "UBQLN4",
            "TDRD7",
            "NECAP2",
            "CAB39",
            "CASP8",
            "ARPC2"
        ]
    },
    {
        "golabel": "SP3_regulon_activity",
        "gene": [
            "ODF3B",
            "BARD1",
            "SHROOM1",
            "KLHL23",
            "C16orf48",
            "LRRC29",
            "SLC39A10",
            "ZNF420",
            "TMEM182",
            "SCO2",
            "RALGPS2",
            "SELO",
            "ZNF567",
            "PHOSPHO2",
            "RIF1",
            "RAB24",
            "POLD4",
            "AMDHD2",
            "ARFRP1",
            "MIB1",
            "NAGLU",
            "GTF3C4",
            "FOXN2",
            "IKBKG",
            "RSF1",
            "DCAF12",
            "COQ4",
            "MCOLN1",
            "RNASEK",
            "KBTBD6",
            "NAB1",
            "C19orf6",
            "FAM126B",
            "LMF2",
            "TRABD",
            "ZNF507",
            "RMND5A",
            "G6PC3",
            "TTC21B",
            "NDUFS7",
            "PQLC1",
            "SIRT6",
            "WDSUB1",
            "UBR3",
            "MBD3",
            "GPD2",
            "ZMYM1",
            "ESCO1",
            "SPAST",
            "ZNF845",
            "MON1A",
            "C1orf9",
            "C2orf69",
            "ATF2",
            "FKBP8",
            "SCYL2",
            "PPP1R12A",
            "ZNF644",
            "KATNB1",
            "RABGGTA",
            "GPATCH2",
            "RBMS1",
            "SCRN3",
            "AGPS",
            "CAMSAP1L1",
            "MPP5",
            "ADNP",
            "DDX18",
            "CDC37",
            "CCDC94",
            "KDM3A",
            "SPOPL",
            "TLK1",
            "ITCH",
            "CEP350",
            "SOS1",
            "APAF1",
            "CYBASC3",
            "RNH1",
            "CCNT2",
            "STAG2",
            "ZNF800",
            "EPC2",
            "YY1",
            "PAPOLG",
            "HNRPLL",
            "DCAF17",
            "PPIG",
            "ZNF148",
            "STARD7",
            "PRPF40A",
            "APPBP2",
            "CDC73",
            "SMEK2",
            "MARCH7",
            "PLEKHA3",
            "ZBTB11",
            "ZNF143",
            "CWC22",
            "AMMECR1L",
            "RBM12",
            "CUL3",
            "CREB1",
            "ACTR1A"
        ]
    },
    {
        "golabel": "SP4_regulon_activity",
        "gene": [
            "HGD",
            "SDCBP2",
            "FXYD3",
            "ADAM22",
            "ARHGAP28",
            "SYDE2",
            "ZNF853",
            "BRMS1L",
            "C19orf21",
            "CBLC",
            "BMP8B",
            "BLVRB",
            "SEPX1",
            "TXNDC16",
            "SALL2",
            "TALDO1",
            "LMBRD2",
            "IL1RAP",
            "CLTB",
            "MEX3B",
            "RPS6KA5",
            "LAD1",
            "SULT1A3",
            "TP53I3",
            "TJP3",
            "CDCA7L",
            "SLC35C1",
            "PGAP1",
            "GSTP1",
            "MLKL",
            "ZNF708",
            "C7orf46",
            "CDC14A",
            "FAM161A",
            "CIB1",
            "C20orf177",
            "INF2",
            "MGAT4A",
            "LTBR",
            "DAAM1",
            "ENPP4",
            "PKP3",
            "KPNA5",
            "RNF144A",
            "TSPO",
            "HDHD3",
            "NANS",
            "ACPL2",
            "SCO2",
            "KRBA2",
            "ZNF253",
            "GRINA",
            "VPS18",
            "ZNF524",
            "ZNF92",
            "KLHL28",
            "HACE1",
            "EML4",
            "BAG3",
            "RBCK1",
            "KLHL7",
            "FBXW5",
            "TAF9B",
            "PDIK1L",
            "TNFRSF1A",
            "PRKD3",
            "BBS9",
            "TRABD",
            "SLC24A6",
            "PRR13",
            "RLF",
            "SNX13",
            "TRAK2",
            "ZNF611",
            "FPGS",
            "FBXO48",
            "ZNF295",
            "CCDC117",
            "ARL13B",
            "ZNF543",
            "SENP7",
            "SYNRG",
            "SOS2",
            "DDX54",
            "ZNF644",
            "PRDM2",
            "ATP6V0C",
            "NPAT",
            "ZBTB33",
            "ZNF12",
            "RSBN1",
            "GABPA",
            "VEZF1",
            "MFSD5",
            "UBC",
            "ZFP161",
            "CREB1"
        ]
    },
    {
        "golabel": "SPEN_regulon_activity",
        "gene": [
            "C11orf42",
            "TP73",
            "FAM89A",
            "GTF3A",
            "LOC150381",
            "LOC100271836",
            "MED31",
            "UQCRQ",
            "TMSB10",
            "TP53I3",
            "SSR4",
            "MYEOV2",
            "ITPR3",
            "DERA",
            "NDUFA4",
            "CCDC56",
            "SC4MOL",
            "NENF",
            "RNF181",
            "CCDC88C",
            "DPH3B",
            "UBL5",
            "FLNB",
            "MDN1",
            "DYNLT1",
            "UQCR11",
            "DDI2",
            "HBXIP",
            "DHRSX",
            "NOP10",
            "RAD54L2",
            "H6PD",
            "OSTC",
            "COMMD1",
            "C4orf52",
            "OST4",
            "C19orf10",
            "TRIM56",
            "ATP5E",
            "IAH1",
            "C14orf119",
            "IFT20",
            "STX8",
            "PDPR",
            "MACF1",
            "NFU1",
            "MRPL27",
            "CEP110",
            "OVCA2",
            "TFB1M",
            "ZMIZ1",
            "DAD1",
            "AKAP9",
            "SMG1",
            "MLL2",
            "NPHP4",
            "C15orf24",
            "CLSTN1",
            "GRLF1",
            "VPS13D",
            "EYA3",
            "RGPD3",
            "RSC1A1",
            "UROS",
            "KIF1B",
            "BAT2L1",
            "DERL2",
            "ZNF417",
            "MLL3",
            "EEF2K",
            "ZBTB40",
            "TMEM85",
            "RERE",
            "COX16",
            "SUPT4H1",
            "GTF3C6",
            "EDEM2",
            "HIVEP1",
            "EP400",
            "MLL",
            "SDF2",
            "TNRC6B",
            "CHD2",
            "ZNF264",
            "EIF2C1",
            "MGA",
            "MTF1",
            "KIAA2018",
            "CLTA",
            "SFT2D1",
            "ZNF407",
            "ARID1A",
            "TAF1",
            "SPCS1",
            "TNRC6A",
            "CREBBP",
            "SEC13",
            "PRDM2",
            "ATXN1L",
            "EP300",
            "MADD",
            "R3HCC1",
            "C14orf43",
            "ARID1B",
            "UBR4",
            "PSMG2",
            "USP24",
            "ANO10",
            "CELF1",
            "ATP6V1E1",
            "ZDHHC6",
            "SON",
            "CUEDC2",
            "SFRS15",
            "KDM2A",
            "NUP214",
            "DNAJC16",
            "KIAA0562",
            "FAM193A",
            "MFN2",
            "SETD2",
            "RBBP6",
            "SRRM1"
        ]
    },
    {
        "golabel": "SPI1_regulon_activity",
        "gene": [
            "RETN",
            "PDYN",
            "LOC653786",
            "ACSM5",
            "C20orf123",
            "AGRP",
            "GPD1",
            "IL22RA2",
            "CAPN11",
            "FCGBP",
            "GPR120",
            "CLEC12B",
            "APOC2",
            "HAMP",
            "MARCO",
            "IGSF21",
            "APOC1",
            "APOC4",
            "SIGLEC16",
            "OSM",
            "SIRPD",
            "PTCRA",
            "EMR4P",
            "SLC37A2",
            "RNASE2",
            "TREML1",
            "SIGLEC11",
            "TMEM150B",
            "GPR84",
            "MATK",
            "APOE",
            "NAT8B",
            "TREM2",
            "LST1",
            "VENTX",
            "TNFSF12-TNFSF13",
            "HK3",
            "CRYBB1",
            "SIGLEC1",
            "MS4A14",
            "HCK",
            "CD52",
            "RENBP",
            "SLC11A1",
            "LILRA6",
            "PRAM1",
            "DPEP2",
            "OSCAR",
            "PLB1",
            "FUT7",
            "CD300LB",
            "GPBAR1",
            "C10orf125",
            "ITGAX",
            "C19orf38",
            "PRSS36",
            "PIK3R6",
            "CYP27A1",
            "NCF1",
            "APOB48R",
            "FGR",
            "C1QB",
            "TYROBP",
            "CD300C",
            "FCGR1A",
            "C5AR1",
            "GNGT2",
            "FCGR1C",
            "FCGR1B",
            "CSF1",
            "C1QC",
            "CARD9",
            "IFI27L2",
            "SPATC1",
            "ACP5",
            "HCST",
            "LILRB3",
            "C1orf54",
            "CD37",
            "HMOX1",
            "C1QA",
            "C17orf60",
            "LSP1",
            "SIGLEC7",
            "ARL11",
            "PYCARD",
            "MNDA",
            "CD33",
            "CD14",
            "NFAM1",
            "HLA-DPB1",
            "PSTPIP1",
            "SIGLEC9",
            "CSF1R",
            "ALOX5",
            "DOK2",
            "CSF2RA",
            "KCNMB1",
            "FXYD5",
            "GLIPR2",
            "IFFO1",
            "LILRB1",
            "TNFAIP8L2",
            "FCER1G",
            "PILRA",
            "ITGB2",
            "LGALS9",
            "LAIR1",
            "AIF1",
            "GMFG",
            "SLC2A6",
            "PARVG",
            "EMP3",
            "ATP8B1",
            "SNX20",
            "HAVCR2",
            "FBP1",
            "ARHGAP9",
            "VIM",
            "C1orf162",
            "CIITA",
            "FGD2",
            "SUSD3",
            "CD68",
            "CACNA2D4",
            "HAAO",
            "NCKAP1L",
            "CD74",
            "LRRC25",
            "ANKRD58",
            "EMILIN2",
            "TRPV2",
            "GIMAP1",
            "SASH3",
            "TBXAS1",
            "RAB3IL1",
            "SLC15A3",
            "CCDC109B",
            "CD40",
            "LAT2",
            "FERMT3",
            "CARD16",
            "RGS10",
            "CYTH4",
            "GAB3",
            "TMEM86A",
            "MYO1F",
            "CORO1A",
            "IFI30",
            "NAALADL1",
            "LAPTM5",
            "STAC3",
            "NCF4",
            "RASSF4",
            "SELPLG",
            "CD4",
            "WAS",
            "IFT81",
            "SH3BGRL3",
            "PSMB10",
            "SIRPA",
            "EFHD2",
            "IL3RA",
            "GPX1",
            "CMTM3",
            "RAC2",
            "LYL1",
            "DOK3",
            "IRF5",
            "FLVCR1",
            "PLEKHO1",
            "COTL1",
            "NOD2",
            "ABI3",
            "CAPG",
            "LPXN",
            "KIAA1949",
            "METRNL",
            "TMTC4",
            "GNA15",
            "CTSD",
            "C2orf15",
            "VAV1",
            "CAMK1",
            "C1orf38",
            "ZNF385A",
            "PLEKHO2",
            "RELT",
            "PARVB",
            "CPPED1",
            "CMTM7",
            "DHTKD1",
            "NFKBIE",
            "GPR125",
            "TGFB1",
            "TMEM51",
            "SLC29A3",
            "LRRC1",
            "SH3BP1",
            "KCTD17",
            "CTSZ",
            "CALHM2",
            "PLK3",
            "RIN3",
            "GFPT1",
            "NINJ1",
            "FAM117B",
            "ARID5A",
            "FAM18B",
            "ST3GAL2",
            "ZYX",
            "IKBKE",
            "SLC25A19",
            "PPM1M",
            "GRHL2",
            "RGS19",
            "MCOLN1",
            "GRN",
            "PLA2G15",
            "ARRB2",
            "PIGM",
            "MAP7D1",
            "MCCC2",
            "PNPLA6",
            "ATP6V0D1",
            "DOK1",
            "NTAN1",
            "AFG3L2",
            "OAZ1",
            "B3GALNT2",
            "TPST2",
            "FIG4",
            "C1orf27",
            "C10orf58",
            "GMIP",
            "MOBKL2A",
            "NECAP2",
            "MTPAP",
            "NARS",
            "PTPN6",
            "ZMYM2",
            "MAN2B1",
            "MUT",
            "RANBP9",
            "GNAI2",
            "MGAT1",
            "NAGPA",
            "STX4",
            "DBNL",
            "ACTB",
            "NAGK",
            "RRP15",
            "TWF2",
            "FAM82A2",
            "LIN7C",
            "CSK",
            "RHOG",
            "EHD4",
            "GRK6",
            "BMPR1A",
            "MKNK1",
            "NAGA",
            "ACP2",
            "SUV420H1",
            "DKFZp761E198",
            "FKBP15",
            "ANP32A",
            "ATG7",
            "HCG18",
            "TBC1D22A",
            "DNASE2",
            "AP1B1",
            "AP1M1",
            "TRIM27",
            "CAPZB",
            "MTMR14",
            "SAPS3",
            "AFTPH",
            "RDH14",
            "PRKACA",
            "GRB2"
        ]
    },
    {
        "golabel": "SSBP2_regulon_activity",
        "gene": [
            "SLITRK6",
            "S100B",
            "TMEM231",
            "HPGDS",
            "FOXM1",
            "FLJ42709",
            "WNT5A",
            "BLM",
            "SCD",
            "BCAS4",
            "MEF2C",
            "TMSL3",
            "PYCR1",
            "TNFAIP8",
            "N4BP2L1",
            "CD59",
            "CDKL3",
            "GRAMD3",
            "ARHGDIB",
            "RGMB",
            "DARS2",
            "NOP2",
            "PIK3R1",
            "ZNF441",
            "GPATCH4",
            "ATG10",
            "DHX37",
            "CDC42",
            "ATP2A2",
            "TRIM23",
            "GOLGA3",
            "ALDH18A1",
            "UGGT1",
            "SMG5",
            "FAM172A",
            "CCNH",
            "NDUFS2",
            "HDLBP",
            "ILK",
            "COPG",
            "IWS1"
        ]
    },
    {
        "golabel": "SSBP4_regulon_activity",
        "gene": [
            "TEKT2",
            "GPR162",
            "SPEG",
            "CCDC74A",
            "CTXN1",
            "MMP23B",
            "RHPN1",
            "ODF3B",
            "ISYNA1",
            "C2orf81",
            "GMCL1L",
            "CRIP2",
            "FCHO1",
            "CROCC",
            "PBX4",
            "LYL1",
            "SSFA2",
            "NAT14",
            "JUND",
            "HSD11B1L",
            "C19orf60",
            "CRTC1",
            "PTRH1",
            "DPP7",
            "BBC3",
            "PPTC7",
            "CCDC106",
            "OCEL1",
            "NHLRC2",
            "CCDC102A",
            "PGLS",
            "ZNF688",
            "SLC12A9",
            "TP53I13",
            "ZDHHC8",
            "PCBP4",
            "LPAR2",
            "APOOL",
            "C1orf58",
            "JOSD2",
            "QTRT1",
            "IDE",
            "C9orf41",
            "NCKAP5L",
            "ZNF414",
            "COPE",
            "RFXANK",
            "ABHD8",
            "SPSB3",
            "TOR2A",
            "SLC30A6",
            "STT3B",
            "MIIP",
            "MAP1S",
            "PAOX",
            "FAM199X",
            "DPP8",
            "SLC39A13",
            "CANX",
            "GPD2",
            "MBTPS2",
            "FAM108A1",
            "UBR1",
            "TNPO1",
            "MAP2K1",
            "ATF2",
            "PLSCR3",
            "FKBP8",
            "APBA3",
            "LONP2",
            "AP1AR",
            "NCKAP1",
            "RBBP5",
            "ATP13A1",
            "CSNK1G2",
            "ATF6",
            "USP8",
            "ATAD1",
            "VPS35",
            "SEC23IP",
            "UBE3A",
            "ZFP91",
            "AP3M1",
            "FBXL12",
            "SF4"
        ]
    },
    {
        "golabel": "SSH1_regulon_activity",
        "gene": [
            "CYB5A",
            "KIAA0754",
            "DDR2",
            "C17orf61",
            "DST",
            "COL6A3",
            "DPM3",
            "GPR160",
            "C1orf53",
            "TSHZ3",
            "MLPH",
            "KLHDC9",
            "KIRREL",
            "PPFIBP1",
            "DCXR",
            "STARD10",
            "TSTD1",
            "MGAT5",
            "TMEM125",
            "HSD17B8",
            "C11orf52",
            "NDUFB1",
            "MICAL3",
            "TIMM17B",
            "LSMD1",
            "ABCA1",
            "TOMM6",
            "RAG1AP1",
            "C6orf125",
            "PLXNA1",
            "TRAPPC6A",
            "C1orf210",
            "LRP1",
            "ELK3",
            "C2orf79",
            "CCDC56",
            "NEU1",
            "NDUFA13",
            "NTHL1",
            "BRP44",
            "RANGRF",
            "FOSL2",
            "MAP4K4",
            "SDHAF1",
            "ECH1",
            "NENF",
            "RNF181",
            "PRSS8",
            "EPB41L2",
            "MCEE",
            "TMEM9",
            "MRPS26",
            "RNF213",
            "KRTCAP2",
            "DCI",
            "NRL",
            "CNIH4",
            "MRPS21",
            "APOA1BP",
            "PTGFRN",
            "DDT",
            "TTBK2",
            "NDUFA7",
            "HSD17B7",
            "RAB25",
            "C2orf64",
            "C17orf51",
            "TEAD1",
            "LOC151162",
            "ASAP1",
            "NDUFB11",
            "C8orf83",
            "MRP63",
            "CLIP1",
            "ARV1",
            "RPP21",
            "MRPL55",
            "LYPLAL1",
            "SLC25A4",
            "TNS3",
            "C22orf32",
            "ATPIF1",
            "RC3H2",
            "PRRG2",
            "ATF7IP",
            "ASXL2",
            "MACF1",
            "C17orf106",
            "REST",
            "H3F3A",
            "SH2B3",
            "ROBLD3",
            "SNAPIN",
            "MAGED2",
            "ERC1",
            "CBL",
            "FLOT1",
            "PMF1",
            "JTB",
            "TMEM134",
            "C11orf49",
            "LUZP1",
            "MYH9",
            "PEX7",
            "FDX1L",
            "TRAM2",
            "PMVK",
            "TMEM205",
            "ATP6V1G1",
            "TMEM101",
            "TMEM179B",
            "HIVEP2",
            "SLC35B4",
            "MLXIP",
            "RNF5",
            "SAP18",
            "COX16",
            "TBCC",
            "C14orf1",
            "CUTA",
            "NDUFS3",
            "PLBD2",
            "TRAPPC4",
            "RBM9",
            "SDF2",
            "CHMP4A",
            "ITPRIPL2",
            "RPUSD3",
            "TLN1",
            "PEX11B",
            "DYNLRB1",
            "PTPMT1",
            "MAP4",
            "FOXJ2",
            "CDK17",
            "RNF167",
            "MRFAP1L1",
            "GIT2",
            "TATDN2",
            "KCTD10"
        ]
    },
    {
        "golabel": "SSH2_regulon_activity",
        "gene": [
            "TXK",
            "CYSLTR2",
            "C17orf61",
            "GVIN1",
            "RPS14",
            "DOCK11",
            "IKZF1",
            "PIK3R5",
            "DOCK2",
            "TMEM99",
            "AKAP2",
            "PLCL2",
            "C6orf204",
            "C8orf55",
            "ABCA1",
            "TOMM6",
            "DOCK10",
            "DOCK8",
            "TSTA3",
            "ARHGAP30",
            "C12orf35",
            "C11orf1",
            "ATP5I",
            "IMMP2L",
            "BMP2K",
            "TMOD2",
            "HSCB",
            "NDUFAF2",
            "RPL26L1",
            "RPL14",
            "SASH1",
            "RBX1",
            "AKNA",
            "FAM36A",
            "LOC151162",
            "LIAS",
            "MYO18A",
            "SPR",
            "ZFYVE19",
            "FBXO10",
            "NHP2",
            "DDHD1",
            "SEC14L1",
            "LOC348926",
            "PPCS",
            "ZNRD1",
            "IGF2R",
            "CBL",
            "DPH5",
            "TXN2",
            "MRPL40",
            "RWDD2B",
            "NUDCD2",
            "ENTPD4",
            "FNBP1",
            "COX18",
            "TBC1D9",
            "MLXIP",
            "AGTPBP1",
            "HERC1",
            "CBLB",
            "LGTN",
            "FAM86C",
            "TMEM85",
            "HECA",
            "TRAPPC4",
            "ZFYVE26",
            "GRPEL1",
            "TULP4",
            "MANBAL",
            "ZDHHC4",
            "RAPGEF1",
            "RPUSD2",
            "PFDN1",
            "NHP2L1",
            "PIKFYVE",
            "NDUFV3",
            "C14orf43",
            "TUSC2",
            "VPS8",
            "CCDC71",
            "NUFIP2",
            "MRFAP1L1",
            "STAT5B",
            "GIT2"
        ]
    },
    {
        "golabel": "SSH3_regulon_activity",
        "gene": [
            "TUBB2B",
            "AMN",
            "SV2A",
            "ELOVL4",
            "ANK2",
            "BCL2",
            "RAB39B",
            "FSCN2",
            "LRRC49",
            "CYSLTR2",
            "ALDH3B1",
            "SPACA4",
            "PTK6",
            "NOXA1",
            "APOL4",
            "EPS8L1",
            "SYT11",
            "C8orf73",
            "EFCAB4A",
            "TMEM184A",
            "C1orf170",
            "C11orf35",
            "GLIPR1",
            "FBXL8",
            "PGBD1",
            "AKT3",
            "OPLAH",
            "LOC653653",
            "ADAP1",
            "TXNDC16",
            "PLEKHN1",
            "ARL10",
            "MAN1A1",
            "HDGFRP3",
            "SPIRE2",
            "SPTBN2",
            "EIF5A2",
            "CCDC102B",
            "LMTK3",
            "LRP12",
            "NUDT8",
            "TCF4",
            "RIN1",
            "LEF1",
            "FAM83E",
            "CCDC64B",
            "RHOD",
            "NAPRT1",
            "MPP1",
            "TMEM26",
            "GRID2IP",
            "C20orf151",
            "MUC1",
            "CHN1",
            "STON1",
            "TLCD1",
            "MST1R",
            "EVPL",
            "C15orf56",
            "MACROD1",
            "RAB30",
            "LAD1",
            "RGL3",
            "SYTL1",
            "RNF208",
            "KBTBD8",
            "TUBA1A",
            "HDX",
            "TJP3",
            "MMP15",
            "AP1S2",
            "PPDPF",
            "C21orf91",
            "ZNHIT2",
            "EPB49",
            "SLC29A2",
            "RECK",
            "SAMHD1",
            "FAM55C",
            "TM6SF1",
            "PVRL4",
            "SH2D3A",
            "SERINC2",
            "TRIP6",
            "RASSF7",
            "PACSIN3",
            "KCTD12",
            "SAMD10",
            "SGSM2",
            "SLC9A3R2",
            "NOL3",
            "HSPA13",
            "GNB4",
            "DTX2",
            "ARHGAP8",
            "CCDC88A",
            "DGAT1",
            "PRSS8",
            "GALE",
            "EPB41L2",
            "DCK",
            "HS2ST1",
            "PPP1R16A",
            "CEP97",
            "BLMH",
            "CDC42BPG",
            "SLC4A7",
            "PSIP1",
            "ABHD11",
            "UNC93B1",
            "FAM83H",
            "C17orf28",
            "LRRC8C",
            "YPEL3",
            "C11orf80",
            "ELMO3",
            "ARHGEF16",
            "NR2F6",
            "PKP3",
            "ELF3",
            "TMEM54",
            "TBPL1",
            "RAB25",
            "TMC4",
            "C14orf106",
            "ZNF837",
            "TSPAN15",
            "DVL1",
            "BCL9L",
            "TMEM63A",
            "LIMS1",
            "PITPNM1",
            "SLC2A4RG",
            "MAP3K6",
            "SGCB",
            "ARL6",
            "LRP5",
            "TCIRG1",
            "KIAA1543",
            "SPINT1",
            "CLIC4",
            "PAK6",
            "PARP11",
            "RDH13",
            "LLGL2",
            "PCYT2",
            "LOC645332",
            "CHSY1",
            "NDUFS8",
            "ZNF341",
            "MARCKS",
            "PRRG2",
            "EPS8L2",
            "ARHGAP27",
            "ESRP2",
            "MANEA",
            "KIF2A",
            "TMC6",
            "FERMT2",
            "CEP170",
            "CD151",
            "PNPLA2",
            "TMUB1",
            "PWWP2B",
            "RHBDF1",
            "POLD4",
            "COMMD2",
            "GAS8",
            "DNAJC18",
            "TMX1",
            "METTL4",
            "FASTK",
            "CNKSR1",
            "HDAC11",
            "ATP2C1",
            "B3GALT4",
            "TMEM134",
            "STX2",
            "CCDC50",
            "LRCH4",
            "YIF1A",
            "DDR1",
            "FAM160B2",
            "SLC25A23",
            "TEAD3",
            "TMEM120A",
            "LIN52",
            "ESRRA",
            "ARRDC1",
            "ARHGEF5",
            "TTL",
            "PHF6",
            "MOSPD3",
            "SIRT7",
            "RAP2A",
            "NDOR1",
            "OSTM1",
            "ANKRD13D",
            "SGTB",
            "PRKD3",
            "SH3GLB2",
            "FAM129B",
            "TNK1",
            "KIAA1522",
            "TSC22D4",
            "GMFB",
            "TNKS1BP1",
            "CUX1",
            "ULK3",
            "IL17RC",
            "SLC38A10",
            "ZDHHC24",
            "DNAJC17",
            "QKI",
            "PLCB3",
            "DAK",
            "FAM86C",
            "CYB561",
            "SCAMP2",
            "NUDT22",
            "CCS",
            "TMEM53",
            "RNPEPL1",
            "FBXO30",
            "ARL13B",
            "IPO11",
            "CTTN",
            "WDR41",
            "EIF2S1",
            "TCF12",
            "NUMA1",
            "HBS1L",
            "RIC8B",
            "MAPK3",
            "CAPN1",
            "OSBPL8",
            "EXOC5",
            "C14orf135",
            "UBR7",
            "MAP3K2",
            "PPP1CA",
            "PPM1D",
            "CSGALNACT2",
            "MYO1C",
            "NADSYN1",
            "NDUFV1",
            "PPP1R12A",
            "COG7",
            "GNA13",
            "SOCS4",
            "OSBPL11",
            "ATG4C",
            "RNGTT",
            "SCYL1",
            "STXBP2",
            "CORO1B",
            "CDV3",
            "MARK2",
            "PPIP5K2",
            "ANXA11",
            "NFYB",
            "MAP3K11",
            "ARHGAP1",
            "MUDENG",
            "HNRPLL",
            "MFAP3",
            "TMEM214",
            "BBS7",
            "TTC15",
            "RAB1B",
            "MATR3",
            "RELA"
        ]
    },
    {
        "golabel": "STAT1_regulon_activity",
        "gene": [
            "CLEC6A",
            "IL21",
            "KIR2DL4",
            "KCNJ10",
            "CXCL11",
            "IFNG",
            "GBP7",
            "ADAMDEC1",
            "CD274",
            "CXCR2P1",
            "CCL8",
            "ARNTL2",
            "APOBEC3A",
            "CXCL9",
            "TNFRSF9",
            "SSTR2",
            "CXCL10",
            "GBP5",
            "WARS",
            "PDCD1LG2",
            "GBP1",
            "GBP4",
            "LOC80154",
            "TNFSF13B",
            "PSMB9",
            "SAMD9",
            "FCGR3A",
            "EPSTI1",
            "IFIT3",
            "AKAP5",
            "TAP1",
            "OAS2",
            "C7orf41",
            "IFIH1",
            "DDX60",
            "GCH1",
            "GSG2",
            "FPR3",
            "OAS3",
            "C15orf56",
            "MICB",
            "PPP1R2P1",
            "DDX58",
            "PLCXD2",
            "IFT140",
            "IRF1",
            "CAMKK1",
            "SLFN11",
            "TLE2",
            "TAP2",
            "C6orf150",
            "NTHL1",
            "UBE2L6",
            "RIPK2",
            "PRSS8",
            "RAB40B",
            "RNF213",
            "RAB40C",
            "APOL6",
            "TMEM194B",
            "EIF2AK2",
            "RECQL",
            "PRRG2",
            "NMI",
            "OPTN",
            "C20orf108",
            "PARP14",
            "LAP3",
            "C16orf58",
            "SP110",
            "SCMH1",
            "NBN",
            "TMEM140",
            "PARP9",
            "STAT2",
            "SCLT1",
            "FLYWCH2",
            "DTX3L",
            "UBA6",
            "XRN1",
            "DNAJA1",
            "MOBKL1B",
            "INPP5A",
            "PYCR2",
            "ROD1",
            "GNA13",
            "WDFY1",
            "UBE2Z"
        ]
    },
    {
        "golabel": "STAT6_regulon_activity",
        "gene": [
            "KCND2",
            "ADAM12",
            "CCNE2",
            "ADAMTS5",
            "DPYSL3",
            "C5orf34",
            "IDUA",
            "RNF145",
            "NUP155",
            "C18orf54",
            "C4orf46",
            "PPT2",
            "VRK1",
            "MBD6",
            "HSPA13",
            "ERBB3",
            "HS2ST1",
            "NAB2",
            "ELMO3",
            "CDK18",
            "TARS",
            "TMC4",
            "RAB23",
            "DSN1",
            "MARCKS",
            "EPS8L2",
            "CALCOCO1",
            "LOC221710",
            "PHTF2",
            "HDAC10",
            "KLHL7",
            "RAP2A",
            "TSGA14",
            "PARP3",
            "SUOX",
            "PSD4",
            "R3HDM2",
            "SMARCC2",
            "LMBR1L",
            "ZFYVE27",
            "POLL",
            "RAB5B",
            "GLYR1"
        ]
    },
    {
        "golabel": "STRN_regulon_activity",
        "gene": [
            "NR6A1",
            "NIPAL1",
            "GAS5",
            "BTBD8",
            "SNHG9",
            "AMAC1L2",
            "PCOTH",
            "LIME1",
            "PYGO1",
            "NPFF",
            "CPD",
            "SOCS1",
            "SLC9A7",
            "FLJ45244",
            "TSPAN5",
            "DENND2C",
            "ODF3B",
            "HK2",
            "DGKH",
            "LMBRD2",
            "NEDD4",
            "LOC441208",
            "CDK2AP2",
            "FHIT",
            "GAN",
            "XYLB",
            "HYI",
            "BARD1",
            "FKBP2",
            "BICD1",
            "SSR4",
            "IPMK",
            "ABHD14A",
            "KLHL5",
            "BGLAP",
            "PHPT1",
            "FAM160A1",
            "RPL13",
            "HOMER1",
            "UHMK1",
            "TAOK1",
            "MPZL3",
            "RPL34",
            "BRWD3",
            "SNX22",
            "UBXN7",
            "CDK12",
            "ARL5B",
            "SLC30A1",
            "EXOC6B",
            "NOTCH2",
            "FER",
            "CCNT1",
            "NRIP1",
            "FAM168A",
            "NRL",
            "DDI2",
            "CLOCK",
            "IFITM3",
            "MRPL23",
            "LASS6",
            "LY6G5C",
            "RPS20",
            "SBNO1",
            "ACADVL",
            "GTF2A1",
            "EIF2AK2",
            "ATP11C",
            "CCDC75",
            "SIGIRR",
            "FBXL15",
            "SAT2",
            "ZMYND17",
            "ADAM17",
            "ROCK2",
            "C22orf32",
            "ATPIF1",
            "WASH2P",
            "RC3H2",
            "ANKRD54",
            "OCEL1",
            "AVL9",
            "RIF1",
            "MAN1A2",
            "NLN",
            "B9D2",
            "ASXL2",
            "KIF2A",
            "SLC25A40",
            "ZSWIM7",
            "PRR24",
            "C10orf12",
            "RPAIN",
            "DOPEY2",
            "POLR1A",
            "VANGL1",
            "MED1",
            "BRAF",
            "RPL11",
            "QTRT1",
            "BACH1",
            "CCDC130",
            "FAM73A",
            "LOC284441",
            "SAMD8",
            "TMEM205",
            "BSCL2",
            "PANX1",
            "KIAA1715",
            "PRKD3",
            "SMC1A",
            "CCDC73",
            "RFXANK",
            "DOCK7",
            "DNAJC4",
            "COQ4",
            "CHM",
            "USE1",
            "ANAPC1",
            "ADAT1",
            "DIP2B",
            "MAPK1",
            "SPSB3",
            "CCDC101",
            "RRAGC",
            "EDF1",
            "RAB4B",
            "CCDC12",
            "SLC30A6",
            "DNAJC17",
            "AP2B1",
            "BIN3",
            "TRAPPC1",
            "ANO6",
            "FBXO48",
            "FAM199X",
            "SPAG7",
            "ACER3",
            "PCYT1A",
            "ASCC3",
            "C19orf39",
            "MBTPS2",
            "RCAN3",
            "MOBKL1B",
            "LMBR1",
            "RSPRY1",
            "MAP3K2",
            "GPS2",
            "GABARAP",
            "MCFD2",
            "SRPK2",
            "SNX12",
            "KIAA1429",
            "CXorf56",
            "MAP4K3",
            "AAK1",
            "SNRNP35",
            "DNAJC13",
            "GNL3L",
            "MTIF3",
            "C19orf43",
            "AGPS",
            "DHX57",
            "ELOF1",
            "IP6K2",
            "BIRC6",
            "TRIP12",
            "KDM3A",
            "SPOPL",
            "VPS54",
            "SLC25A28",
            "SOS1",
            "NBAS",
            "CUL4B",
            "RNF167",
            "SRBD1",
            "ZFR",
            "ACTR2",
            "SYF2"
        ]
    },
    {
        "golabel": "SUB1_regulon_activity",
        "gene": [
            "LOC728819",
            "RPL39",
            "POLB",
            "LOC374443",
            "EAF2",
            "C13orf27",
            "MLF1",
            "SNRPG",
            "GPX7",
            "C15orf52",
            "KRT10",
            "OSTCL",
            "COBL",
            "FAM162A",
            "C7orf60",
            "NXT1",
            "NSMCE2",
            "C8orf59",
            "MRPL36",
            "C13orf37",
            "PFDN4",
            "HIPK2",
            "FAHD2B",
            "TCEB1",
            "MAD2L2",
            "LSM2",
            "COMMD8",
            "FBXO4",
            "UQCRHL",
            "C6orf115",
            "AKAP13",
            "ITGB3BP",
            "NDUFB5",
            "NBEAL2",
            "UBL5",
            "CDC42BPG",
            "UQCRH",
            "C5orf28",
            "VPS29",
            "BRIX1",
            "VBP1",
            "SLC25A33",
            "C10orf78",
            "OSTC",
            "C3orf26",
            "TBPL1",
            "C6orf182",
            "ATP5L",
            "BOD1",
            "TRIM56",
            "MRPL11",
            "PPIH",
            "CCNC",
            "TRAPPC2P1",
            "PLEKHA7",
            "LOC401397",
            "TECPR1",
            "ANKHD1-EIF4EBP3",
            "NDUFA1",
            "C12orf29",
            "FASTKD3",
            "MRPL47",
            "TPRKB",
            "UCHL3",
            "PAIP1",
            "BTF3L4",
            "WBP5",
            "NDUFB3",
            "RAI1",
            "ERH",
            "SRPRB",
            "COMMD2",
            "MRPS30",
            "WDR70",
            "ZNF131",
            "TRAK1",
            "C5orf22",
            "DPH5",
            "RAD1",
            "DPM1",
            "LSM5",
            "RPF2",
            "HMGN2",
            "LOC728758",
            "SUMO3",
            "LOC100129034",
            "LAMB2",
            "FYCO1",
            "GTF2H5",
            "PSMB1",
            "RG9MTD1",
            "KIAA0649",
            "PSMA2",
            "TRIAP1",
            "KIF1C",
            "UBE2A",
            "PSMD10",
            "POLE3",
            "WDR81",
            "RNF7",
            "GOLPH3",
            "MRPS22",
            "ZCCHC17",
            "NCOR2",
            "C1orf151",
            "RWDD1",
            "DNAJC21",
            "DOCK6",
            "SUPT4H1",
            "ZNF622",
            "YAF2",
            "ZZEF1",
            "NDUFA12",
            "DUSP11",
            "RREB1",
            "PRR12",
            "CDC42BPB",
            "LSM6",
            "TIPRL",
            "SEC22A",
            "BCAS2",
            "MINK1",
            "SUMO1P3",
            "VMA21",
            "PDCD2",
            "ANAPC10",
            "GNA11",
            "RBMX2",
            "PCMT1",
            "MYO1C",
            "PDE6D",
            "SUMO2",
            "CWC15",
            "ZCRB1",
            "HAT1",
            "TECPR2",
            "MON1B",
            "DNAJC8",
            "SUMO1",
            "PTMA",
            "RPP30",
            "SFRS3",
            "SMG6",
            "RNF123",
            "POLG",
            "PPHLN1",
            "PTPN23",
            "USP19"
        ]
    },
    {
        "golabel": "SUPT4H1_regulon_activity",
        "gene": [
            "C3orf55",
            "RLN2",
            "RPL27",
            "PSMA6",
            "KRT10",
            "PFDN5",
            "S100A13",
            "SNRPD2",
            "FUNDC2",
            "PIK3C2B",
            "NME1",
            "VAMP8",
            "MRPL33",
            "CCDC56",
            "CGRRF1",
            "EAPP",
            "PSMB3",
            "TOMM22",
            "RPL38",
            "ARHGEF10",
            "RNF181",
            "GEMIN6",
            "CCDC88C",
            "ANAPC11",
            "MRPS23",
            "CASZ1",
            "LOC646762",
            "MYL6",
            "PSMD8",
            "COMMD1",
            "OST4",
            "CMTM4",
            "PHF5A",
            "UQCR10",
            "TECPR1",
            "C17orf89",
            "GPN1",
            "IQCE",
            "RNF139",
            "SUB1",
            "PCTP",
            "AIG1",
            "RANBP10",
            "FAM100B",
            "NEDD8",
            "GLO1",
            "ICT1",
            "TMEM49",
            "MRPL27",
            "DTD1",
            "GTF2H5",
            "PSMB1",
            "TMEM101",
            "PTRH2",
            "RAB34",
            "BCL2L2",
            "MEA1",
            "METTL2A",
            "COX11",
            "ZCCHC17",
            "ATP5H",
            "CIC",
            "HIRA",
            "MRPS7",
            "MIF4GD",
            "ZNF622",
            "SEC16A",
            "ZZEF1",
            "PSMD13",
            "VPS25",
            "RMND1",
            "FN3KRP",
            "NUMA1",
            "LMAN2L",
            "SUMO1P3",
            "SNX11",
            "ZNHIT3",
            "ANAPC10",
            "RAPGEF1",
            "RBMX2",
            "SPEN",
            "PHB",
            "TACO1",
            "COMMD9",
            "AMZ2",
            "SUMO2",
            "ZCRB1",
            "SNF8",
            "C19orf62",
            "SLC35B1",
            "FRG1",
            "SUMO1",
            "C17orf95",
            "PHF2",
            "EIF1",
            "H3F3B",
            "MRPL10",
            "INTS12",
            "LASS5",
            "SPOP"
        ]
    },
    {
        "golabel": "SUV39H2_regulon_activity",
        "gene": [
            "FCGBP",
            "FAM64A",
            "CCNB2",
            "CENPA",
            "MAD2L1",
            "MCM10",
            "C12orf48",
            "DEPDC1",
            "NUF2",
            "TTK",
            "DSCC1",
            "CKAP2L",
            "CDK1",
            "CCNA2",
            "SCARF1",
            "SGOL1",
            "MELK",
            "GINS1",
            "NEK2",
            "BUB1",
            "CCDC138",
            "BAG2",
            "UBE2T",
            "GCH1",
            "MEST",
            "RACGAP1",
            "C14orf33",
            "TXNIP",
            "GSN",
            "MTFR1",
            "KPNA2",
            "MGLL",
            "OSBPL7",
            "SLC9A1",
            "PLEKHM1P",
            "FAM116B",
            "DBF4",
            "ZNF239",
            "WDYHV1",
            "UBA2",
            "ARL5B",
            "CENPL",
            "ARRDC2",
            "BAIAP2",
            "SLMO2",
            "PDSS1",
            "CDK18",
            "HSPD1",
            "PAK1IP1",
            "CDK8",
            "PPIL1",
            "MASTL",
            "TDG",
            "MAP3K6",
            "DARS2",
            "LIN9",
            "CYP4V2",
            "MVP",
            "THNSL1",
            "GTPBP4",
            "FAM49B",
            "HSPA14",
            "WDR12",
            "NUDT5",
            "MEMO1",
            "PNPT1",
            "PNO1",
            "CACYBP",
            "RMI1",
            "DPM1",
            "YES1",
            "VAPB",
            "ZDHHC7",
            "NANP",
            "ILF2",
            "TEX10",
            "RIOK1",
            "TNKS1BP1",
            "PCGF6",
            "URB2",
            "LDLRAP1",
            "LCLAT1",
            "EXOSC3",
            "ZNF639",
            "ZNF544",
            "ZCCHC7",
            "RPS6KA1",
            "LRPPRC",
            "DNAJA1",
            "USP14",
            "MTPAP",
            "ASB13",
            "ZC3H15",
            "PINK1",
            "CDC123",
            "C10orf18",
            "SEPHS1",
            "CUL2",
            "UBXN2A",
            "PTCD3",
            "TOLLIP",
            "RBM17",
            "KIN"
        ]
    },
    {
        "golabel": "SUZ12_regulon_activity",
        "gene": [
            "C17orf104",
            "DLX6",
            "KCNG3",
            "RPS6KA6",
            "TOP2A",
            "NPDC1",
            "TMEM97",
            "BRCA1",
            "HMGCS1",
            "ATAD5",
            "CLTB",
            "ANP32E",
            "SLC36A4",
            "PPDPF",
            "SLC9A3R2",
            "CDK12",
            "BLMH",
            "HOOK1",
            "MSI2",
            "TNFSF13",
            "SMCHD1",
            "DDX52",
            "CD151",
            "MED1",
            "TRIM37",
            "YES1",
            "ACAA1",
            "PSMD11",
            "LIG3",
            "LBR",
            "CBX1",
            "DIP2B",
            "TAF2",
            "SERPINB6",
            "DNAJC17",
            "TMEM102",
            "TAX1BP3",
            "RPS6KB1",
            "USP37",
            "PAPOLA",
            "NEDD1",
            "AES",
            "C1orf9",
            "LARP4",
            "C2orf69",
            "RAD51L3",
            "KPNB1",
            "NLK",
            "MSL1",
            "RBM12B",
            "DHX57",
            "CPSF6",
            "TADA2A",
            "CCDC43",
            "IPO9",
            "GPR108",
            "RPAP3",
            "LRRC37B2",
            "RNH1",
            "HPS6",
            "BET1L",
            "DNAJB12",
            "GOSR1",
            "UBXN6",
            "PRPF40A",
            "HNRNPR",
            "TLK2",
            "GGNBP2",
            "SFRS1",
            "ZNF207"
        ]
    },
    {
        "golabel": "TADA2B_regulon_activity",
        "gene": [
            "CDKN3",
            "SLC22A3",
            "NUF2",
            "RHEBL1",
            "BIRC5",
            "LOC541471",
            "LOC93622",
            "PTTG1",
            "ASF1B",
            "RNASEH2A",
            "POC1A",
            "NME1",
            "TRAIP",
            "CENPP",
            "CRY2",
            "TAPT1",
            "NUDT1",
            "MAML3",
            "TMEM206",
            "WFS1",
            "DDX39",
            "LRPAP1",
            "CPEB2",
            "RFC2",
            "CCDC149",
            "SLC25A19",
            "ACOX3",
            "TMEM129",
            "MAN2B2",
            "NTAN1",
            "MXD4",
            "KIAA0232",
            "HTT",
            "NUP85",
            "C4orf42",
            "RBM47",
            "ZNF721",
            "TBC1D14",
            "CTBP1",
            "MRFAP1L1",
            "FAM193A",
            "C4orf23",
            "SLAIN2",
            "MRFAP1",
            "RNF4",
            "ADD1",
            "SFRS2"
        ]
    },
    {
        "golabel": "TAF11_regulon_activity",
        "gene": [
            "COL2A1",
            "GSTM3",
            "ZNF695",
            "TMEM14A",
            "CENPV",
            "MFAP2",
            "STMN1",
            "GINS1",
            "SIP1",
            "LOC144486",
            "ZNF614",
            "C13orf27",
            "C6orf129",
            "TBC1D7",
            "TDP2",
            "GMNN",
            "VDR",
            "CENPQ",
            "LSM2",
            "PPT2",
            "GLMN",
            "NEU1",
            "ITGB3BP",
            "MYOF",
            "COQ3",
            "MED20",
            "ZNF684",
            "UQCRH",
            "C6orf162",
            "IMMP1L",
            "SLC25A33",
            "PSMG1",
            "PDRG1",
            "PAK1IP1",
            "EXTL2",
            "TRIM56",
            "C20orf111",
            "TDG",
            "EEF1E1",
            "DSN1",
            "MRPL47",
            "RPP21",
            "PHF15",
            "TUBB",
            "ALS2CR4",
            "SNRNP48",
            "ZNF232",
            "BTF3L4",
            "KLHDC3",
            "GLO1",
            "ZSCAN16",
            "COMMD2",
            "SERF1A",
            "LOC221710",
            "MRPL2",
            "IQSEC2",
            "TUBD1",
            "CWF19L1",
            "KLHL7",
            "LOC100129034",
            "FYCO1",
            "C1orf52",
            "ILF2",
            "MEA1",
            "ABR",
            "FKBPL",
            "MTF2",
            "C17orf42",
            "SNRPC",
            "CUX1",
            "DEM1",
            "SNRPB2",
            "BAHD1",
            "RDBP",
            "ALG6",
            "POLR3F",
            "CHIC2",
            "VPS25",
            "RAB11FIP5",
            "C6orf153",
            "IQGAP1",
            "ABT1",
            "GTF2H4",
            "NFKB1",
            "STIM1",
            "C1orf109",
            "ZNF140",
            "RNF114",
            "CSNK2B",
            "C2orf56",
            "STK19",
            "HINFP",
            "TBP",
            "PSPC1",
            "HCG18",
            "FAM120A",
            "SFRS3",
            "DAXX"
        ]
    },
    {
        "golabel": "TAF13_regulon_activity",
        "gene": [
            "FRRS1",
            "C3orf47",
            "SARDH",
            "HCG27",
            "C1orf59",
            "CROCC",
            "DTX3",
            "TMEM48",
            "MPZL3",
            "SLC35A3",
            "GPR180",
            "MAPK6",
            "LOC728743",
            "EXTL2",
            "PGAM4",
            "CALU",
            "LOC150786",
            "PARP10",
            "BBC3",
            "FAM114A1",
            "C14orf159",
            "YIPF6",
            "DPH5",
            "CIRBP",
            "CTBS",
            "LUC7L3",
            "PGM1",
            "PSMA5",
            "PAFAH1B2",
            "C17orf65",
            "NRAS",
            "ACADM",
            "LRRC42",
            "ZNF28",
            "COG6",
            "OGFR",
            "ISCA1P1",
            "WDR3",
            "ATP5F1",
            "SLC30A6",
            "YRDC",
            "SEC22B",
            "DR1",
            "MMADHC",
            "UEVLD",
            "ELMOD2",
            "AAGAB",
            "RBM7",
            "BCAS2",
            "SRP72",
            "TAX1BP1",
            "BIRC2",
            "RPF1",
            "DNAJB6",
            "ZMPSTE24",
            "DNTTIP2",
            "SIKE1",
            "PTP4A2",
            "BLZF1",
            "AKIRIN1",
            "CAPZA1",
            "RTCD1",
            "SLC30A7",
            "PLEKHB2",
            "COPB1",
            "LRRC57",
            "CSDE1",
            "SLC25A28",
            "GNAI3",
            "YME1L1",
            "SPTY2D1",
            "TRIP4",
            "ARPP19",
            "SLC35B3",
            "STRADA",
            "HIAT1",
            "FAM98A",
            "TMEM167B",
            "BTBD1"
        ]
    },
    {
        "golabel": "TAF1C_regulon_activity",
        "gene": [
            "IZUMO1",
            "FGF17",
            "HIST3H3",
            "NTN5",
            "MYH7B",
            "C7orf4",
            "YJEFN3",
            "KRTAP5-10",
            "C1orf223",
            "CYP2D7P1",
            "KRTAP5-8",
            "BEST4",
            "ALOX12P2",
            "LOC26102",
            "HSF4",
            "NCRNA00105",
            "RNF112",
            "KCNAB3",
            "TTLL13",
            "FLJ40292",
            "LOC391322",
            "MYO15B",
            "AMAC1L2",
            "USHBP1",
            "LOC284009",
            "FAM71F2",
            "NR2E3",
            "PLA2G6",
            "SLC6A16",
            "SLC25A27",
            "C10orf111",
            "C16orf3",
            "SERINC4",
            "SLC24A5",
            "FAM157B",
            "NPFF",
            "C21orf58",
            "FLJ45445",
            "PLEKHG4",
            "C3orf47",
            "C19orf76",
            "CAPRIN2",
            "LOC390595",
            "SLC25A34",
            "GOLGA2B",
            "RAPGEF3",
            "LOC100133161",
            "LOC400752",
            "ASB16",
            "LCAT",
            "LOC100129726",
            "DNM1P35",
            "HERC2P2",
            "FLJ10661",
            "LOC100128842",
            "SGK494",
            "LOC349114",
            "SNORA39",
            "RAB40AL",
            "MAPK8IP3",
            "CROCCL2",
            "LOC100130557",
            "TMEM86B",
            "LOC100132287",
            "KIAA0895L",
            "DTX3",
            "SRRM5",
            "PILRB",
            "SDHAP2",
            "CDK3",
            "WDR27",
            "ENGASE",
            "LOC100128288",
            "LY6G5B",
            "ANKRD23",
            "PPP1R3E",
            "LOC100129637",
            "AGAP6",
            "CROCCL1",
            "LOC100133331",
            "LRDD",
            "LOC283922",
            "KIAA1530",
            "EXOC3L",
            "INCA1",
            "AGAP4",
            "FAM186B",
            "TSPYL2",
            "LOC150776",
            "LOC399744",
            "SUV420H2",
            "CNIH",
            "CENPT",
            "FLJ45340",
            "FAM193B",
            "SGSM2",
            "PRRG4",
            "PRDXDD1P",
            "SPRN",
            "ZNF767",
            "ANKS3",
            "WASH7P",
            "GIGYF1",
            "FAM156A",
            "PASK",
            "CDK10",
            "LOC100129387",
            "SYNGAP1",
            "GBE1",
            "AFG3L1",
            "EP400NL",
            "ATXN7L2",
            "GRIPAP1",
            "MVD",
            "KIAA0182",
            "KIFC3",
            "ZNF276",
            "KLHDC4",
            "STK36",
            "SFRS16",
            "SELO",
            "DGKQ",
            "SFRS17A",
            "CAPN10",
            "MGC23284",
            "CNTROB",
            "C16orf55",
            "HEATR7A",
            "GAS8",
            "ZNF277",
            "SNAPC4",
            "C17orf56",
            "GAK",
            "FUK",
            "CXXC1",
            "RBM6",
            "LRCH4",
            "FAM73B",
            "HSDL1",
            "FAM160B2",
            "AZIN1",
            "PPIL2",
            "ANKRD13D",
            "ACAD10",
            "NEURL4",
            "SNRNP70",
            "DPH3",
            "HSPA8",
            "SPG7",
            "DR1",
            "KIAA0913",
            "CHMP2B",
            "CCNI",
            "PRMT7",
            "ATG4B",
            "RAP1GDS1",
            "PARP6",
            "MTHFSD",
            "PGS1",
            "TJAP1",
            "LMBR1",
            "ZNF335",
            "EIF4E",
            "CDAN1",
            "BANP",
            "DPH1",
            "WDR59",
            "PHKA2",
            "FAM160A2",
            "EDC4",
            "DEF8",
            "ANKRD11",
            "DHX38",
            "C5orf43",
            "YIPF5",
            "NXF1",
            "SPTLC1",
            "PSEN1"
        ]
    },
    {
        "golabel": "TAF6_regulon_activity",
        "gene": [
            "C7orf61",
            "LOC100133985",
            "MCM7",
            "SH2B2",
            "FAM71D",
            "C14orf80",
            "CPSF4",
            "FCHO2",
            "ZSCAN21",
            "ZNF775",
            "COPS6",
            "PDAP1",
            "SPDYE3",
            "SLC2A4RG",
            "C11orf84",
            "AP4M1",
            "C5orf41",
            "PTCD1",
            "LRWD1",
            "ATAD3A",
            "PLOD3",
            "EIF4E3",
            "PRKRIP1",
            "ARL15",
            "MTA1",
            "C7orf43",
            "DTWD2",
            "MEPCE",
            "MOSPD3",
            "GTF2IRD1",
            "KLC2",
            "FAM189B",
            "TSC22D4",
            "ZNF598",
            "GNB2",
            "ADRM1",
            "SF3B4",
            "NOC4L",
            "ALKBH4",
            "GIT1",
            "FBXL17",
            "CDC42SE2",
            "FBXO3",
            "SART1",
            "NCOA4",
            "PJA2",
            "WHSC2",
            "MEN1",
            "SRRT",
            "VPS36",
            "SMPD4",
            "ZNF282",
            "TBC1D10B",
            "C5orf24",
            "WBSCR16",
            "ZFYVE16",
            "STK25",
            "COBRA1",
            "ABCF3",
            "COPS7B",
            "SLU7",
            "SMYD5",
            "PAPD4",
            "SF3B2"
        ]
    },
    {
        "golabel": "TAF9_regulon_activity",
        "gene": [
            "CKS2",
            "CENPK",
            "GTF2H2",
            "C13orf27",
            "LTBP4",
            "SNRPG",
            "CCNB1",
            "CHAC2",
            "LOC649330",
            "HAUS1",
            "NSMCE2",
            "XRCC4",
            "COX7B",
            "C8orf59",
            "CENPH",
            "PIK3C2B",
            "C5orf35",
            "BNIP3",
            "C9orf46",
            "LRP1",
            "NDUFB5",
            "HSPG2",
            "PINX1",
            "TOMM5",
            "UQCRH",
            "LOC442454",
            "NDUFB6",
            "VPS29",
            "H2AFZ",
            "LBH",
            "C1QBP",
            "HSPE1",
            "HAX1",
            "SAR1B",
            "DHFR",
            "AHDC1",
            "PKD1",
            "CCDC59",
            "FBXO22OS",
            "PSMA3",
            "CDKN2AIPNL",
            "GTF2H2C",
            "SSR3",
            "MRPL39",
            "NDUFB3",
            "FAM65A",
            "SARNP",
            "TIMM9",
            "UQCRB",
            "MRPL22",
            "SERF1A",
            "CASKIN2",
            "MRPL1",
            "TMEM126A",
            "ARHGEF17",
            "TOM1L2",
            "SS18L2",
            "MKI67IP",
            "FARP2",
            "AK2",
            "ATG10",
            "SNRPE",
            "MRPL50",
            "NCKAP5L",
            "PMPCB",
            "PI4KA",
            "MOCS2",
            "CDK7",
            "KIAA0556",
            "C5orf44",
            "TRIAP1",
            "COX11",
            "SSBP1",
            "VDAC1",
            "ISCA1P1",
            "ISOC1",
            "TBCA",
            "C14orf166",
            "PSMA4",
            "ARAP1",
            "CRAMP1L",
            "GNPDA1",
            "SMN2",
            "ATP5H",
            "CIC",
            "TRIOBP",
            "DIMT1L",
            "CISD2",
            "DGCR2",
            "SLBP",
            "CLEC16A",
            "ERCC8",
            "KIAA0913",
            "PRR12",
            "SLC44A2",
            "TTC7A",
            "WDR41",
            "MINK1",
            "ZCCHC9",
            "C9orf82",
            "SUGT1",
            "PSD4",
            "HDAC7",
            "ATG2A",
            "ANAPC10",
            "PSMA1",
            "LSM3",
            "TRNT1",
            "CREBBP",
            "THUMPD2",
            "GFM2",
            "EIF2B3",
            "ATG12",
            "ZC3H7B",
            "MRPS18C",
            "AP3S1",
            "MRPL16",
            "UTP15",
            "TAF12",
            "C5orf43",
            "EIF1",
            "CWC27",
            "SFRS3",
            "SLC30A5",
            "PDHB",
            "SRP19",
            "INTS12",
            "RAD17",
            "PSMD6",
            "AIMP1",
            "THUMPD3",
            "PPP2CA",
            "DYNC1LI1",
            "RBMX",
            "ZNF207",
            "HNRNPK"
        ]
    },
    {
        "golabel": "TAF9B_regulon_activity",
        "gene": [
            "RHOF",
            "C19orf21",
            "ALS2CL",
            "TXNDC16",
            "INF2",
            "BLMH",
            "CYP2U1",
            "FAM38A",
            "DVL1",
            "GPRASP2",
            "TCIRG1",
            "SP4",
            "ZSCAN12",
            "PWWP2B",
            "ZNF709",
            "BHLHB9",
            "TICAM1",
            "MAGT1",
            "LOC728758",
            "NDOR1",
            "TCEAL8",
            "SOLH",
            "PGRMC1",
            "PSMD10",
            "SLC27A4",
            "PLCB3",
            "EIF1AX",
            "SLC24A6",
            "CCDC9",
            "DHX40",
            "HSF2",
            "ATRX",
            "AKT1S1",
            "ZFP1",
            "PRPS1",
            "UBR7",
            "TRAF7",
            "C11orf46",
            "ZBTB33",
            "VEZF1",
            "STAG2",
            "MNT",
            "ABCB7",
            "RNF123",
            "SPOP",
            "RBMX",
            "MATR3"
        ]
    },
    {
        "golabel": "TARBP2_regulon_activity",
        "gene": [
            "POLR2F",
            "SCARNA12",
            "PTPRG",
            "PFDN5",
            "ROMO1",
            "CDC42BPA",
            "FAM195A",
            "TIMM16",
            "SPSB2",
            "LSMD1",
            "C6orf125",
            "C2orf79",
            "C12orf62",
            "BLOC1S1",
            "PRPF40B",
            "COX6A1",
            "MRPS26",
            "MYL6B",
            "HERC3",
            "VPS29",
            "PHB2",
            "EHD2",
            "MRPL12",
            "ZNF511",
            "PDRG1",
            "MYO1D",
            "ARL16",
            "ERP29",
            "CCDC59",
            "PIK3R1",
            "PUS1",
            "CNPY2",
            "SMUG1",
            "DCTN2",
            "RPS19BP1",
            "MAP3K5",
            "CBX8",
            "C12orf73",
            "RHBDD3",
            "SMARCA2",
            "PSMA7",
            "TRMT2A",
            "MID2",
            "ATP5G2",
            "MACF1",
            "LSM4",
            "C17orf106",
            "SARNP",
            "NT5C",
            "PPCDC",
            "MTG1",
            "SPRYD4",
            "MMAB",
            "C12orf44",
            "POP5",
            "TRMU",
            "MRPL27",
            "FOXO3",
            "LOC678655",
            "NR1D2",
            "SNHG11",
            "POLR2H",
            "ARID5B",
            "C12orf47",
            "C12orf10",
            "MRPS11",
            "OGFOD2",
            "CDK2AP1",
            "OBFC2B",
            "DIABLO",
            "MRPS34",
            "C12orf41",
            "WIBG",
            "COMMD4",
            "BICD2",
            "PRR13",
            "ARL6IP4",
            "PRMT1",
            "MRPL46",
            "LOC729991",
            "HIPK1",
            "NOC4L",
            "HECA",
            "DRG2",
            "MRPL28",
            "WDR47",
            "DYNLL1",
            "PRKAG1",
            "ABT1",
            "LRRFIP1",
            "PSMD9",
            "RNF38",
            "COPZ1",
            "C12orf52",
            "SFRS9",
            "MLST8",
            "LMBR1L",
            "WDR73",
            "ZNF140",
            "ANAPC7",
            "MCRS1",
            "PCBP2",
            "AAAS",
            "ANAPC5",
            "SETX",
            "OTUB1",
            "MFSD5",
            "SENP3",
            "MAEA",
            "MAPKAPK5",
            "LASS5",
            "NBR1",
            "EIF2B1"
        ]
    },
    {
        "golabel": "TARDBP_regulon_activity",
        "gene": [
            "AGRP",
            "CCL23",
            "LOC643677",
            "ZNF711",
            "FOLR2",
            "WBSCR26",
            "VSIG4",
            "TREM2",
            "CRYBB1",
            "C7orf54",
            "LHX4",
            "ALOX5AP",
            "MS4A4A",
            "TYROBP",
            "CD300C",
            "PTPRO",
            "ADORA3",
            "LY86",
            "ACP5",
            "PNN",
            "CHD7",
            "SIGLEC7",
            "CD14",
            "SIGLEC9",
            "CSF1R",
            "ALOX5",
            "CSF2RA",
            "PILRA",
            "HAVCR2",
            "CD68",
            "LAT2",
            "CRYL1",
            "LOC401010",
            "SERTAD1",
            "ADAP2",
            "CAPG",
            "GPSM3",
            "NASP",
            "GBGT1",
            "DHRS7",
            "ALKBH7",
            "LOC341056",
            "PNPLA4",
            "PLEKHO2",
            "LOC727896",
            "WHSC1",
            "MARCH6",
            "PCTP",
            "SYNGR2",
            "ORAI3",
            "JARID2",
            "MDC1",
            "CBX5",
            "UPF3B",
            "CEP290",
            "ADCK2",
            "PSAP",
            "C5orf51",
            "FOXJ3",
            "MIF4GD",
            "DDX27",
            "MARCH2",
            "THOC2",
            "PHF13",
            "HNRNPA3P1",
            "MGAT1",
            "ZNF326",
            "ACTR1B",
            "NRD1",
            "SMEK1",
            "RBM12B",
            "HTATSF1",
            "SNX17",
            "CEP63",
            "LOC643387",
            "ILK",
            "DNASE2",
            "HPS6",
            "APEH",
            "RAB5C",
            "CCAR1",
            "UBXN6",
            "DNAJC11",
            "HNRNPA3",
            "HNRNPD",
            "HNRNPH3",
            "RBBP6",
            "EXOSC10",
            "SRRM1",
            "HNRNPA2B1",
            "CPSF7",
            "HNRNPU",
            "LRRC47",
            "LUC7L2",
            "SFRS13A",
            "GGNBP2",
            "SFRS1"
        ]
    },
    {
        "golabel": "TAX1BP3_regulon_activity",
        "gene": [
            "SDCBP2",
            "C19orf33",
            "WFDC1",
            "FSTL3",
            "KRT7",
            "C19orf21",
            "TAGLN",
            "ZBTB10",
            "KRT19",
            "S100A16",
            "FOXS1",
            "PRKCDBP",
            "HSPB2",
            "RHOD",
            "COX7A1",
            "ATAD5",
            "CLTB",
            "LAD1",
            "PHF8",
            "KRT8",
            "KNTC1",
            "SLC35C1",
            "LOC100270710",
            "KIAA1958",
            "RNF138P1",
            "MFRP",
            "RHOC",
            "BRWD3",
            "MPHOSPH9",
            "KLHL11",
            "RILP",
            "RRAS",
            "FBLIM1",
            "TOPBP1",
            "CYB5D2",
            "TSPO",
            "HOOK1",
            "TSPAN15",
            "C9orf167",
            "ZNF620",
            "COMT",
            "MARCH6",
            "FAM109A",
            "PCYT2",
            "CD151",
            "ZNF280C",
            "BCAR1",
            "MPDU1",
            "BCL2L1",
            "MED1",
            "B3GALT4",
            "BRAF",
            "UBR5",
            "GIPC1",
            "OVCA2",
            "VASP",
            "CAPNS1",
            "ZNF623",
            "SLC43A2",
            "MED13",
            "KIF1C",
            "TNK1",
            "RNASEK",
            "CNN2",
            "SMCR7",
            "PTTG1IP",
            "STRBP",
            "ZNF81",
            "TMEM102",
            "TRAPPC1",
            "SUZ12",
            "C8orf58",
            "SPAG7",
            "RNPEPL1",
            "KCTD11",
            "C17orf49",
            "CSRP1",
            "C10orf18",
            "PLSCR3",
            "GABARAP",
            "MYO1C",
            "C17orf59",
            "HYAL2",
            "FKTN",
            "PMS1",
            "INPP5K",
            "RBM12B",
            "PLD2",
            "PFN1",
            "C17orf80",
            "ANXA11",
            "CELF1",
            "PHF23",
            "CCDC71",
            "TIMM22",
            "RBM15",
            "TMEM115",
            "PPP2R1A",
            "PITPNA",
            "DULLARD"
        ]
    },
    {
        "golabel": "TBC1D22A_regulon_activity",
        "gene": [
            "MATK",
            "OSCAR",
            "PIK3R6",
            "PRKCDBP",
            "LGALS9",
            "SPI1",
            "CLTB",
            "ANP32E",
            "CBX7",
            "RAC2",
            "TYMP",
            "PPAT",
            "MSH2",
            "RRAS",
            "STAU2",
            "APOBEC3C",
            "PARVB",
            "TSPO",
            "TDRKH",
            "OTUD6B",
            "C22orf26",
            "PIK3IP1",
            "LYSMD1",
            "PLXNB2",
            "CSE1L",
            "RIN3",
            "TTC38",
            "PACSIN2",
            "HDAC10",
            "SEH1L",
            "ZNF623",
            "PIP5K1A",
            "UTP23",
            "ZNF575",
            "PRUNE",
            "CYB5R3",
            "LMF2",
            "TRABD",
            "C22orf9",
            "SMARCC1",
            "SCAMP2",
            "TMEM209",
            "TOM1",
            "LRPPRC",
            "RB1CC1",
            "DCAF10",
            "ALG12",
            "MTPAP",
            "TRMT5",
            "PTPN6",
            "MAN2B1",
            "ACO2",
            "TNIP1",
            "SAPS2",
            "GPATCH2",
            "RRP15",
            "CSK",
            "CCDC94",
            "NAGA",
            "SAMM50",
            "HPS1",
            "RNH1",
            "CEBPZ",
            "AP1B1",
            "ATXN10",
            "UBXN6",
            "TROVE2",
            "SFRS13A"
        ]
    },
    {
        "golabel": "TBC1D2B_regulon_activity",
        "gene": [
            "PRG4",
            "C3",
            "TMEM52",
            "POLR2F",
            "LOC91450",
            "DST",
            "POLB",
            "LTBP4",
            "C1orf31",
            "SNRPG",
            "AHNAK",
            "GIMAP8",
            "STRA13",
            "ACN9",
            "NDUFB9",
            "MRPL48",
            "TBC1D7",
            "C8orf59",
            "PREX1",
            "GAS7",
            "RAG1AP1",
            "PHYH",
            "PDCD2L",
            "TCEB1",
            "NME1",
            "LOC100130932",
            "MRPS15",
            "CBX7",
            "CD97",
            "ZEB2",
            "AKAP13",
            "GEMIN6",
            "SMAD3",
            "UQCRH",
            "C5orf28",
            "MRPS23",
            "RHEB",
            "MTHFD2L",
            "CBY1",
            "APOA1BP",
            "SLC25A33",
            "C7orf36",
            "MRPL12",
            "DNAH14",
            "HSPE1",
            "ZBTB46",
            "C11orf48",
            "PXMP2",
            "FAM38A",
            "ARAP2",
            "PTPRJ",
            "APITD1",
            "HMBS",
            "SOD1",
            "C12orf73",
            "EPCAM",
            "STK10",
            "C20orf194",
            "DPY30",
            "MAGOH",
            "TBCE",
            "FAM65A",
            "ICT1",
            "C17orf75",
            "SERF1A",
            "CHCHD8",
            "KLF13",
            "NR2C2AP",
            "POLR1C",
            "ANKRD39",
            "MRTO4",
            "SNRPE",
            "TMEM177",
            "CASP6",
            "FAM119A",
            "ILF2",
            "DENND4A",
            "HERC1",
            "YRDC",
            "SLC25A17",
            "SLC12A6",
            "IQSEC1",
            "C12orf65",
            "ZHX2",
            "TTC7A",
            "POLR2D",
            "PDCL3",
            "ERI3",
            "SUMO1P3",
            "EIF3I",
            "MTX2",
            "SUFU",
            "SUMO2",
            "C1orf109",
            "MRPL20",
            "WDR77",
            "WHAMM",
            "N4BP1",
            "CRTC3",
            "VPS39",
            "MEF2A",
            "POLG"
        ]
    },
    {
        "golabel": "TBL1X_regulon_activity",
        "gene": [
            "FSTL4",
            "SLC16A14",
            "MUC4",
            "TACC2",
            "DHDH",
            "LST1",
            "PDE4D",
            "PLEKHG2",
            "DOCK5",
            "HLA-DMB",
            "HLA-DRA",
            "IL7",
            "GYG2",
            "KIAA1549",
            "CD58",
            "FAM118B",
            "N4BP2L1",
            "FAAH2",
            "PHKA1",
            "LOC401397",
            "PRKX",
            "ZNF563",
            "LYSMD2",
            "ZBED1",
            "C19orf25",
            "IL10RB",
            "CTPS2",
            "DOK1",
            "ALDH18A1",
            "ZSCAN2",
            "OAZ1",
            "RREB1",
            "CDC42BPB",
            "MAPKSP1",
            "MEF2D",
            "EIF3A",
            "USP9X",
            "ZBED4",
            "CCAR1"
        ]
    },
    {
        "golabel": "TBPL1_regulon_activity",
        "gene": [
            "RIPPLY2",
            "NUDT11",
            "GGH",
            "SLC2A12",
            "TCEAL7",
            "GSTM3",
            "TMSB15B",
            "TMEM14A",
            "RHOBTB2",
            "RHEBL1",
            "RAET1K",
            "C6orf225",
            "PRTFDC1",
            "B3GALNT1",
            "C13orf27",
            "GPX7",
            "HNF1B",
            "FAM92A1",
            "C6orf57",
            "EIF5A2",
            "RAB32",
            "ABCC3",
            "HAUS1",
            "MUC1",
            "EVPL",
            "TUBA1A",
            "PITPNM3",
            "WDR54",
            "COX7A2",
            "C20orf7",
            "GOLGA7",
            "PDK1",
            "PPIL5",
            "FLJ90757",
            "CENPQ",
            "C14orf129",
            "TMEM19",
            "COMMD8",
            "C6orf115",
            "ACAT2",
            "NDUFB5",
            "MYOF",
            "HSPA13",
            "PRMT6",
            "CCDC28A",
            "DCK",
            "COQ3",
            "CDC42BPG",
            "C15orf21",
            "IFNGR1",
            "BAIAP2",
            "C6orf162",
            "VPS29",
            "IMMP1L",
            "CREM",
            "GPR180",
            "DYNLT1",
            "RPS12",
            "ARL6IP6",
            "SLC25A33",
            "HEBP2",
            "CCDC90B",
            "COMMD3",
            "RWDD2A",
            "C9orf72",
            "PDCD10",
            "C6orf182",
            "CYB5R4",
            "TGDS",
            "ADSL",
            "RAPH1",
            "CCDC59",
            "CCNC",
            "NUP37",
            "PHF5A",
            "ASF1A",
            "RAB23",
            "ARL6",
            "C12orf29",
            "MRPL47",
            "TWF1",
            "NFIC",
            "TMEM63B",
            "PAK6",
            "SUB1",
            "RTN4IP1",
            "CD164",
            "UCHL3",
            "COPS3",
            "MARCKS",
            "ESRP2",
            "AIG1",
            "HDDC2",
            "MANEA",
            "FAM96A",
            "ECHDC1",
            "SERAC1",
            "BMI1",
            "C17orf75",
            "COMMD2",
            "SF3B5",
            "TMX1",
            "CCDC149",
            "UBE2Q2",
            "PEX3",
            "IFT52",
            "MPHOSPH6",
            "HDAC2",
            "TRIM8",
            "NMD3",
            "DCUN1D1",
            "TMEM218",
            "PEX7",
            "ZNF410",
            "GYG1",
            "TFB1M",
            "ARL3",
            "TBCCD1",
            "SLC25A23",
            "PTGES3",
            "SNX3",
            "LOC100129034",
            "QRSL1",
            "FYCO1",
            "GTF2H5",
            "PSMB1",
            "OSTM1",
            "MKKS",
            "METTL9",
            "KIAA0649",
            "ARPC5",
            "PRCP",
            "PDE4A",
            "RARS2",
            "ACTR6",
            "SSH3",
            "NME7",
            "MRPL18",
            "UBE2N",
            "GTPBP8",
            "ZBTB4",
            "TCP1",
            "ATG5",
            "RWDD1",
            "DPH3",
            "KPNA3",
            "ORC3L",
            "HSF2",
            "RNASEH2B",
            "RAPGEF2",
            "SDHB",
            "POLR3F",
            "CASP3",
            "CHIC2",
            "CTTN",
            "RMND1",
            "NUP54",
            "C6orf211",
            "LZIC",
            "C1orf174",
            "NT5DC1",
            "LRSAM1",
            "HBS1L",
            "CHD2",
            "C6orf72",
            "FYTTD1",
            "RPF1",
            "PDCD2",
            "ACTR3",
            "SNRNP40",
            "GOLGA2",
            "RBM47",
            "EED",
            "SFT2D1",
            "VTA1",
            "PCMT1",
            "KATNA1",
            "SYVN1",
            "HCCS",
            "LYRM2",
            "UTP18",
            "PPP1R2",
            "RNF114",
            "GTDC1",
            "STX7",
            "C6orf35",
            "CAPZA1",
            "SNX14",
            "EIF1B",
            "NUS1",
            "RFX1",
            "TBP",
            "TMEM199",
            "SFRS3",
            "WTAP",
            "GTF2H1",
            "MSL3",
            "SF3A3",
            "MTRF1L",
            "DDX42",
            "PPIL4"
        ]
    },
    {
        "golabel": "TBX2_regulon_activity",
        "gene": [
            "SLC6A13",
            "AGAP11",
            "GPR162",
            "FGFR4",
            "PTH1R",
            "GJC2",
            "C20orf46",
            "ATP1B2",
            "USHBP1",
            "GPR20",
            "PLAC9",
            "KANK3",
            "MUSTN1",
            "TBX4",
            "C17orf82",
            "DENND2A",
            "LOC728264",
            "FOXF1",
            "LTC4S",
            "PPP1R14A",
            "TOP2A",
            "ADAMTS10",
            "EGFL7",
            "PEAR1",
            "FOXS1",
            "LTBP4",
            "LIMS2",
            "ITGA7",
            "KIF18A",
            "SMAD6",
            "REM1",
            "SGOL2",
            "ECT2",
            "LGI4",
            "GATA2",
            "RACGAP1",
            "NOTCH4",
            "PALM",
            "SH2D3C",
            "MOCS1",
            "RASL12",
            "INCA1",
            "TENC1",
            "KCNC4",
            "CYGB",
            "SEPT4",
            "PPAT",
            "CENPL",
            "MCM6",
            "ACTL6A",
            "C3orf26",
            "GMPS",
            "SORBS3",
            "CCDC102A",
            "SMAD7",
            "ARHGEF17",
            "ST6GALNAC6",
            "METTL2A",
            "CD81",
            "CYB5R3",
            "UMPS",
            "C8orf58",
            "JMJD5",
            "MRPL3",
            "ZC3H15",
            "INPP5A",
            "TOMM70A",
            "SMG6"
        ]
    },
    {
        "golabel": "TBX4_regulon_activity",
        "gene": [
            "HPSE2",
            "CYP4Z2P",
            "ADRA1A",
            "SSTR4",
            "CAV3",
            "OVCH1",
            "SLC6A13",
            "C19orf59",
            "GPD1",
            "MAB21L1",
            "TYRP1",
            "ITIH5",
            "TCF21",
            "DUOX1",
            "MYOCD",
            "ROBO2",
            "GPR44",
            "DUOXA1",
            "PDE8B",
            "NPNT",
            "SCN7A",
            "NAALAD2",
            "C4orf31",
            "PGM5",
            "CCNB2",
            "ATP1B2",
            "UBE2C",
            "SCN4B",
            "CDKN3",
            "EGR1",
            "ANGPT1",
            "TROAP",
            "CENPA",
            "MCM10",
            "DLC1",
            "NUF2",
            "CCDC48",
            "ITGA9",
            "TPX2",
            "COL4A4",
            "FAM72B",
            "BIRC5",
            "CDC20",
            "RAD54L",
            "CCNA2",
            "NCAPG",
            "PLEKHH2",
            "SKA3",
            "CDT1",
            "CDCA5",
            "ORC6L",
            "TBX2",
            "SPAG5",
            "SHROOM4",
            "PKMYT1",
            "CCNB1",
            "PRC1",
            "TBX5",
            "ASF1B",
            "TACC3",
            "CD302",
            "C1orf183",
            "FRY",
            "KPNA2",
            "TNS1",
            "AMIGO1",
            "RAPGEF5",
            "SPRY1",
            "H2AFX",
            "H2AFZ",
            "FEN1",
            "PAICS",
            "CTDSPL",
            "PRKCE",
            "ULK2",
            "ZBTB4",
            "TRAK2",
            "INPP5A"
        ]
    },
    {
        "golabel": "TCEA1_regulon_activity",
        "gene": [
            "TPD52",
            "PRAM1",
            "ITGAX",
            "APOB48R",
            "SLC25A34",
            "RAB15",
            "LYPLA1",
            "NFAM1",
            "RASAL3",
            "ALOX5",
            "CCDC88B",
            "PARVG",
            "PIK3R5",
            "CIITA",
            "FGD2",
            "FERMT3",
            "SH2D3C",
            "GAB3",
            "PREX1",
            "MTFR1",
            "MYO1F",
            "FAM78A",
            "FGD3",
            "SELPLG",
            "WAS",
            "SHANK3",
            "MICAL1",
            "MRPL15",
            "SLMO2",
            "CCDC109A",
            "SCOC",
            "CHCHD7",
            "TMEM68",
            "TRUB1",
            "EVL",
            "COPS5",
            "EPCAM",
            "RIN3",
            "UBE2V2",
            "ARMC5",
            "DENND1C",
            "ESRP1",
            "CPNE3",
            "KIAA0146",
            "FNBP1",
            "YWHAZ",
            "CORO7",
            "TGS1",
            "PCGF6",
            "PNPLA6",
            "DPY19L4",
            "THAP1",
            "STK3",
            "MYO9B",
            "TAOK2",
            "GMIP",
            "RAB2A",
            "RALGDS",
            "MAN2B1",
            "USP20",
            "MAP4K3",
            "C2orf29",
            "ATP6V1H",
            "YIPF4",
            "PIP5K1C",
            "METAP1",
            "YTHDF3",
            "FKBP15",
            "MRPL19"
        ]
    },
    {
        "golabel": "TCEA3_regulon_activity",
        "gene": [
            "SPRYD5",
            "MYBPHL",
            "MMP28",
            "SUSD2",
            "SLC16A1",
            "RHCE",
            "HOPX",
            "MMP12",
            "C16orf89",
            "ADAMTS6",
            "CDKL2",
            "GPC6",
            "E2F7",
            "FOLR1",
            "SLFNL1",
            "C17orf50",
            "MFSD4",
            "C2orf58",
            "ADAM12",
            "RHBDL1",
            "MESP1",
            "LOC388588",
            "ALDH1L2",
            "C14orf37",
            "SULF1",
            "RAP1GAP",
            "EVPLL",
            "PCDP1",
            "SFTA2",
            "PBK",
            "CDKN3",
            "EXO1",
            "NAPSA",
            "SELENBP1",
            "PIF1",
            "C1orf116",
            "C12orf48",
            "CYP26B1",
            "ADAM19",
            "DEPDC1B",
            "GSTT1",
            "C10orf95",
            "CASC5",
            "CHST11",
            "GLOD5",
            "CACNB1",
            "DLGAP5",
            "SIGLEC10",
            "SMPDL3B",
            "KIF23",
            "SYT11",
            "RAD51AP1",
            "DSCC1",
            "ROBO1",
            "ITPRIPL1",
            "HJURP",
            "PRR15L",
            "CKAP2L",
            "WISP1",
            "C11orf82",
            "CCNA2",
            "NCAPG",
            "ESCO2",
            "NEK2",
            "BUB1",
            "PGBD1",
            "GLB1L2",
            "CHADL",
            "NUAK1",
            "AKT3",
            "C1orf53",
            "FANCB",
            "ATP2B1",
            "PYROXD2",
            "FAM83D",
            "HNF1B",
            "HDGFRP3",
            "MPZL2",
            "GCH1",
            "LRP12",
            "RARB",
            "RORC",
            "ADA",
            "GSG2",
            "GRID2IP",
            "ABCC3",
            "MUC1",
            "C18orf54",
            "TSTD1",
            "C14orf145",
            "RACGAP1",
            "NR3C2",
            "WDR67",
            "HHLA3",
            "TMEM125",
            "ZNF429",
            "AKAP2",
            "C11orf52",
            "SYTL1",
            "C7orf23",
            "ARL4C",
            "STK38L",
            "GALNT12",
            "ZNF697",
            "PRDM1",
            "FBXO5",
            "CLPTM1L",
            "FAM55C",
            "RBKS",
            "C1orf210",
            "ASAP3",
            "FBXO4",
            "ECHDC2",
            "FAAH",
            "MAP4K4",
            "TTC7B",
            "ALDH5A1",
            "BTG3",
            "LOC729234",
            "CENPO",
            "NME3",
            "BLMH",
            "FAH",
            "DDAH1",
            "SLC38A2",
            "TGIF2",
            "GALNT11",
            "TDG",
            "CTNNBIP1",
            "GPR137B",
            "MAP3K6",
            "PNMA1",
            "CYB5R1",
            "PAK6",
            "SLC2A11",
            "SPR",
            "CHSY1",
            "DAP",
            "FBXO10",
            "KCTD17",
            "MARCKS",
            "NIPAL3",
            "RPS10P7",
            "FBXO44",
            "SEC14L1",
            "SEL1L",
            "CNKSR1",
            "HDAC11",
            "MGAT2",
            "RPL11",
            "C16orf58",
            "SLC25A23",
            "TMEM120A",
            "PMVK",
            "TTL",
            "PDIK1L",
            "PIGV",
            "KIAA0319L",
            "KIAA1522",
            "HMGCL",
            "LDLRAP1",
            "BCKDHA",
            "C12orf5",
            "TMCO4",
            "RPS6KA1",
            "OMA1",
            "SCP2",
            "XKR8",
            "C1orf172",
            "ZFAND2B",
            "CPT2",
            "TCEB3",
            "KIAA0317",
            "SEPT8",
            "TAF12",
            "STK4",
            "NDUFV3",
            "ATPAF1",
            "MECR",
            "MTRF1L",
            "DHDDS",
            "BSDC1",
            "SYF2"
        ]
    },
    {
        "golabel": "TCEAL1_regulon_activity",
        "gene": [
            "HOPX",
            "BEX5",
            "CLIC2",
            "MTCP1NB",
            "C17orf44",
            "FUNDC2",
            "CRYL1",
            "CGRRF1",
            "NOTCH3",
            "PGCP",
            "COMMD10",
            "RPL10",
            "POLE",
            "TMEM50B",
            "SLC25A5",
            "CNOT8",
            "ACOT1",
            "GPRASP2",
            "SBNO2",
            "TCEAL6",
            "KLHDC2",
            "RBM3",
            "CRBN",
            "HADH",
            "TCEAL3",
            "ACOT2",
            "CLSTN3",
            "GABARAPL2",
            "TCEAL8",
            "C14orf109",
            "UBE2A",
            "YPEL5",
            "NEK7",
            "RCHY1",
            "CCDC111",
            "SLC24A6",
            "ATP2A2",
            "GOLGA3",
            "SH3BGRL",
            "GCN1L1",
            "FBXL5",
            "RAP2C",
            "MMGT1",
            "IGBP1",
            "CHURC1",
            "C1GALT1C1",
            "DVL3",
            "CAMLG",
            "TCEAL4",
            "BAZ2A",
            "NKIRAS1",
            "ALG13",
            "RRAGB",
            "GMPR2",
            "PIGY",
            "PRPS1",
            "ACTR10",
            "TMEM9B",
            "PCNXL3",
            "NDFIP1",
            "CNOT3",
            "CDKN2AIP",
            "EID1",
            "FBXO8",
            "UBR4",
            "MARK2",
            "ARMCX5",
            "HDLBP",
            "COPG",
            "VAMP4",
            "KDM2A"
        ]
    },
    {
        "golabel": "TCEAL8_regulon_activity",
        "gene": [
            "FGF13",
            "BEX5",
            "BEX2",
            "DSP",
            "LRFN4",
            "SMARCD3",
            "CLIC2",
            "NFKBIL2",
            "NXT2",
            "ENPP5",
            "BEX4",
            "FMO4",
            "INCENP",
            "NCRNA00182",
            "MAGEH1",
            "NGFRAP1",
            "C12orf62",
            "ARMCX2",
            "LYRM1",
            "PGCP",
            "ARMCX1",
            "F8",
            "TSPAN6",
            "ZNF32",
            "ACYP2",
            "LMNB2",
            "PNPLA4",
            "TCEAL1",
            "BOD1",
            "FAM38A",
            "GPRASP2",
            "PITPNM1",
            "CYB5R1",
            "CETN2",
            "ARV1",
            "MYO19",
            "TBC1D8B",
            "WBP5",
            "FUNDC1",
            "ATP6V0E1",
            "LAMP2",
            "MAGED2",
            "DOT1L",
            "RBM28",
            "GORAB",
            "MAGT1",
            "SERP1",
            "TAF9B",
            "PGRMC1",
            "ARMCX6",
            "TCEANC",
            "PDCD11",
            "PSMD10",
            "YPEL5",
            "C2CD3",
            "PLCB3",
            "TXNDC15",
            "SH3BGRL",
            "MED7",
            "ANKRA2",
            "RAP2C",
            "ANKLE2",
            "IGBP1",
            "RNF130",
            "UBTD2",
            "HSD17B12",
            "GEMIN8",
            "TCEAL4",
            "MORF4L2",
            "TTC1",
            "ATG4A",
            "FLJ33630",
            "VMA21",
            "C19orf42",
            "PRPS1",
            "RNF113A",
            "TMEM9B",
            "FXC1",
            "MCTS1",
            "STRN4",
            "ARMCX3",
            "UPRT",
            "EHMT1",
            "NUBP1",
            "SIK3",
            "ARMCX5",
            "INTS4",
            "LCMT1",
            "RIOK2",
            "XIAP",
            "MRFAP1L1",
            "HNRNPH2",
            "SF3B2"
        ]
    },
    {
        "golabel": "TCEANC_regulon_activity",
        "gene": [
            "GPR143",
            "SGCG",
            "LOC100131726",
            "FOSL1",
            "CLUL1",
            "FAM83A",
            "CYSLTR1",
            "BEX2",
            "MFSD2B",
            "ERRFI1",
            "KRT7",
            "SMAD5OS",
            "SEPP1",
            "TXNDC16",
            "KRT18",
            "USP51",
            "ZNF843",
            "C18orf1",
            "NMNAT3",
            "LOH12CR2",
            "BEX4",
            "FMO4",
            "MGC3771",
            "CEBPB",
            "NBPF3",
            "CBX7",
            "MAGEH1",
            "TNFRSF21",
            "NOTCH3",
            "PPFIBP2",
            "FOSL2",
            "ARMCX1",
            "F8",
            "LOC653501",
            "THAP2",
            "FAM83H",
            "SENP8",
            "C5orf54",
            "LMNB2",
            "LOC144571",
            "C17orf108",
            "PNPLA4",
            "PPP1R14B",
            "ZNF658",
            "PVR",
            "PIK3IP1",
            "ZNF546",
            "CA5B",
            "AMZ2P1",
            "ZNF709",
            "HADH",
            "BAG3",
            "KLF16",
            "MBOAT7",
            "CCDC121",
            "EIF3B",
            "TCEAL8",
            "C14orf109",
            "FAM13B",
            "MOSPD2",
            "HDGF",
            "PLCB3",
            "ZNF691",
            "LIPT1",
            "FBXO48",
            "GEMIN8",
            "SETDB2",
            "NT5DC1",
            "ZBTB3",
            "RRAGB",
            "ZFX",
            "TRAPPC2",
            "KBTBD4",
            "RAB9A",
            "GIN1",
            "FXC1",
            "ZBED5",
            "LYRM2",
            "HGS",
            "FTSJD1",
            "SAP30L",
            "ASTE1",
            "ZC3H10",
            "MSL3",
            "HELQ",
            "SND1",
            "ATG9A",
            "ZNF174",
            "ZFP161",
            "C2orf42"
        ]
    },
    {
        "golabel": "TCEB1_regulon_activity",
        "gene": [
            "FAM66A",
            "PVT1",
            "MRPS28",
            "CKS2",
            "ATP5EP2",
            "MRPL21",
            "NFIX",
            "PSMA6",
            "RRS1",
            "SNHG6",
            "POLB",
            "ZFAND1",
            "SNRPG",
            "E2F5",
            "NME1-NME2",
            "FAM92A1",
            "COBL",
            "C6orf129",
            "NDUFB9",
            "NSMCE2",
            "RAD54B",
            "VDAC3",
            "RPL8",
            "C8orf76",
            "C8orf59",
            "MRPL13",
            "CYC1",
            "EMG1",
            "FRY",
            "C8orf38",
            "MTFR1",
            "GOLGA7",
            "PIK3C2B",
            "LACTB2",
            "IFT172",
            "PFDN4",
            "TMEM70",
            "PPL",
            "NME1",
            "PSMB3",
            "AKAP13",
            "WDYHV1",
            "POP7",
            "TLE4",
            "PYCRL",
            "EXOSC4",
            "BOLA3",
            "UBE2W",
            "TOMM5",
            "RAN",
            "GLRX3",
            "NDUFB6",
            "MRPL15",
            "SLMO2",
            "BRIX1",
            "DYNLT1",
            "STAU2",
            "USMG5",
            "POLR2K",
            "MRPL12",
            "H6PD",
            "PSMG1",
            "HSPE1",
            "PFDN2",
            "SHFM1",
            "TUBA1C",
            "ATP5E",
            "SNRPF",
            "TIMM8A",
            "SNRPD1",
            "DCUN1D5",
            "PFDN6",
            "MED30",
            "KIAA1671",
            "FNTA",
            "PSMA3",
            "C16orf61",
            "CDKN2AIPNL",
            "PLXNB2",
            "C8orf33",
            "MAGOHB",
            "GPR172A",
            "C12orf73",
            "COPS5",
            "SUB1",
            "MRPL42",
            "COMMD5",
            "C20orf194",
            "PSMA7",
            "FAM49B",
            "SFXN4",
            "PSMC6",
            "MACF1",
            "MTERFD1",
            "SARNP",
            "TIMM9",
            "PSMD14",
            "DUSP18",
            "DECR1",
            "CACYBP",
            "MRPL1",
            "UBE2V2",
            "VDAC2",
            "ENY2",
            "PSMA5",
            "MRTO4",
            "PUF60",
            "INTS8",
            "PPIA",
            "ZNF836",
            "PTRH2",
            "IFT122",
            "VPS13D",
            "CISD1",
            "ABR",
            "MAST3",
            "CBX3",
            "TBC1D2B",
            "TBCA",
            "RNASEL",
            "UBE2N",
            "GCC2",
            "HERC1",
            "HSF1",
            "YRDC",
            "CISD2",
            "SLBP",
            "NDUFA12",
            "TERF1",
            "PLEKHM1",
            "BCCIP",
            "PSMD13",
            "MAF1",
            "POLH",
            "MORF4L2",
            "C6orf153",
            "SUMO1P3",
            "DYNLL1",
            "ZNHIT3",
            "PSMA1",
            "XPC",
            "TGOLN2",
            "CREBBP",
            "MRPS16",
            "FLII",
            "NME6",
            "SUMO1",
            "RPP30",
            "KIAA0892",
            "ANKFY1"
        ]
    },
    {
        "golabel": "TCEB2_regulon_activity",
        "gene": [
            "CBR3",
            "FBXO2",
            "WBSCR26",
            "METRN",
            "LOC100271831",
            "RPS15A",
            "BLVRB",
            "SEPX1",
            "COX6B1",
            "C12orf57",
            "PSENEN",
            "TNFRSF12A",
            "ROMO1",
            "FAM195A",
            "C7orf59",
            "TIMM16",
            "POLR2I",
            "UQCRQ",
            "TMSB10",
            "C1orf97",
            "LSMD1",
            "MRPL54",
            "PPDPF",
            "NDUFA2",
            "TMEM160",
            "MGMT",
            "FAM173A",
            "GUK1",
            "GPX1",
            "C6orf1",
            "NDUFA13",
            "ATP5I",
            "BLOC1S1",
            "NDUFB7",
            "NENF",
            "RNF181",
            "NME3",
            "UBL5",
            "SERF2",
            "DECR2",
            "TRAPPC2L",
            "C16orf13",
            "DCI",
            "COX4I1",
            "HCFC1R1",
            "NDUFA3",
            "MYL6",
            "TMEM208",
            "GIYD2",
            "FAM96B",
            "OST4",
            "RBX1",
            "MPG",
            "C11orf51",
            "UQCR10",
            "CHCHD5",
            "PQBP1",
            "PRDX5",
            "NDUFB4",
            "MRPL55",
            "PRKX",
            "GPX4",
            "BCL7C",
            "CARHSP1",
            "CD63",
            "DHX33",
            "POLR2L",
            "VKORC1",
            "C17orf106",
            "TOMM7",
            "SYNGR2",
            "POLD4",
            "HIGD2A",
            "BFAR",
            "ETFB",
            "ZMAT5",
            "BLVRA",
            "SERTAD3",
            "MED1",
            "UBR5",
            "GIPC1",
            "MRPL27",
            "FAM98C",
            "GNPTG",
            "NDUFAB1",
            "PPP4C",
            "TMEM219",
            "POLR3K",
            "COPE",
            "WRN",
            "RFXANK",
            "HAGH",
            "HMOX2",
            "UROD",
            "NDUFAF3",
            "ANAPC1",
            "JMJD8",
            "NUBP2",
            "ZNF37A",
            "NDUFC1",
            "VPS13B",
            "ZNF318",
            "SRA1",
            "DNAJC17",
            "MRPS34",
            "NDUFB10",
            "COMMD4",
            "RNF169",
            "FLYWCH2",
            "LOC729991",
            "TMEM53",
            "SMC6",
            "PMM2",
            "MRPL28",
            "NSMCE1",
            "MAP4K5",
            "SMCR8",
            "CHMP2A",
            "INO80E",
            "BCAP31",
            "FAHD1",
            "STUB1",
            "SMC5",
            "SEC13",
            "GFER",
            "ATP6V0C",
            "KIAA0317",
            "C19orf62",
            "PBRM1",
            "PIKFYVE",
            "C19orf56",
            "XPO4",
            "NUBP1",
            "MKLN1",
            "LCMT1",
            "WAPAL"
        ]
    },
    {
        "golabel": "TCF12_regulon_activity",
        "gene": [
            "C14orf37",
            "UNC5C",
            "FBN1",
            "PRKG1",
            "C8orf73",
            "ANTXR1",
            "ROBO1",
            "NUAK1",
            "TMEM47",
            "PLEKHN1",
            "PDGFRA",
            "LOC220429",
            "PDZRN3",
            "MEX3B",
            "HHLA3",
            "PCDH18",
            "IRF7",
            "BOK",
            "F2R",
            "TAOK1",
            "ZEB1",
            "DTX2",
            "ZNF192",
            "SLC30A4",
            "FAM63B",
            "RGS14",
            "EXTL2",
            "HDHD3",
            "ADAM15",
            "SGCB",
            "DIXDC1",
            "LCORL",
            "MRPL55",
            "ROCK2",
            "CHSY1",
            "FBXO44",
            "TRIM44",
            "REST",
            "ADAM10",
            "ZNF770",
            "LATS1",
            "OGFOD2",
            "SSH3",
            "STX10",
            "ZNF280D",
            "DENND4A",
            "FAM98B",
            "STAG1",
            "TGFBRAP1",
            "DPP8",
            "OSBPL8",
            "GRINL1A",
            "AKAP11",
            "ATF2",
            "RFX7",
            "BMPR2",
            "IREB2",
            "PDS5B",
            "SOCS5",
            "STXBP2",
            "FEM1B",
            "BMPR1A",
            "SMAD4",
            "USP8",
            "EFTUD1",
            "RNF111",
            "SPIN1",
            "BTBD1"
        ]
    },
    {
        "golabel": "TCF25_regulon_activity",
        "gene": [
            "SLC16A4",
            "OTUD7A",
            "AVPI1",
            "ALDH3B1",
            "PCOTH",
            "CKAP2L",
            "OBSL1",
            "BUB1",
            "TOP2A",
            "FBXL8",
            "SPIRE2",
            "SGOL2",
            "FAM22A",
            "PAQR3",
            "CCND3",
            "MMP15",
            "KPNA2",
            "C16orf48",
            "LRRC29",
            "C4orf46",
            "DBNDD1",
            "RBL1",
            "NOL3",
            "SLC4A7",
            "ARRDC2",
            "ATP13A3",
            "ZNF778",
            "CDK10",
            "ELMO3",
            "APRT",
            "PNKD",
            "MVD",
            "ACPL2",
            "ZNF276",
            "KLHDC4",
            "C16orf7",
            "SKA2",
            "ESRP2",
            "PNPLA2",
            "PWWP2B",
            "ETFB",
            "GAS8",
            "PHTF2",
            "EML4",
            "FUK",
            "B3GALT4",
            "TRIM8",
            "KLHL7",
            "ZNF19",
            "FBXW5",
            "TRADD",
            "SPATA2L",
            "ZDHHC7",
            "LMNA",
            "FAM129B",
            "COQ9",
            "BCKDHA",
            "DAK",
            "SPG7",
            "EIF3CL",
            "RNPEPL1",
            "ACER3",
            "TMCO4",
            "ARL13B",
            "MLYCD",
            "RNPEP",
            "PRMT7",
            "NEDD1",
            "EXOC5",
            "CRLF3",
            "DNAJB2",
            "MYO1C",
            "H2AFV",
            "KATNB1",
            "CHMP1A",
            "ACSF3",
            "MON1B",
            "RPAP3",
            "SEPT7",
            "DUS2L",
            "PSKH1",
            "VEZF1",
            "FBXO31",
            "COG4",
            "DNAJB12",
            "TTC15",
            "SLC35A4",
            "KBTBD2",
            "FAM192A",
            "TUBGCP2",
            "COG8"
        ]
    },
    {
        "golabel": "TCF3_regulon_activity",
        "gene": [
            "MAST1",
            "B4GALNT4",
            "REEP2",
            "MEX3A",
            "CTXN1",
            "PRR19",
            "C19orf26",
            "CYP39A1",
            "TUBB3",
            "IGSF9",
            "ANKRD13B",
            "GPR161",
            "TMEM220",
            "LRFN4",
            "TMEM132A",
            "MEGF9",
            "SH2B2",
            "ACTR3C",
            "THRB",
            "FBXO41",
            "HOMER3",
            "C11orf52",
            "NUDT7",
            "NCS1",
            "CAB39L",
            "CRYZ",
            "TTYH3",
            "NUDT12",
            "F8",
            "NT5DC2",
            "AZI1",
            "SENP8",
            "LMNB2",
            "PNPLA4",
            "TGIF2",
            "DBN1",
            "LLGL1",
            "PIGP",
            "CHAF1A",
            "MEX3D",
            "ZSWIM4",
            "SERPINH1",
            "CLN5",
            "CCPG1",
            "SEMA4C",
            "HADH",
            "KLF16",
            "CDC34",
            "BBS4",
            "ABCD3",
            "CLSTN3",
            "GTF2IRD1",
            "MOCS2",
            "CCNDBP1",
            "PIGV",
            "ZNF71",
            "SF3A2",
            "DLGAP4",
            "SEPSECS",
            "PAFAH2",
            "GIT1",
            "OMA1",
            "TRIM65",
            "ALDH9A1",
            "NT5DC1",
            "ALG13",
            "SAMD1",
            "HDGFRP2",
            "CASC4",
            "RAVER1",
            "STRN4",
            "FAM114A2",
            "REXO1",
            "KDM4B",
            "WIZ",
            "TMEM104",
            "CSNK1G2",
            "KHSRP",
            "TMBIM6",
            "C19orf29",
            "CARM1",
            "CALCOCO2",
            "DSCR3",
            "DAZAP1",
            "PTBP1"
        ]
    },
    {
        "golabel": "TCF4_regulon_activity",
        "gene": [
            "C11orf87",
            "GLI3",
            "LPPR5",
            "MEOX2",
            "MMP16",
            "MPPED2",
            "PCYT1B",
            "CCDC3",
            "PURG",
            "GHR",
            "DOK6",
            "PLXNA4",
            "HTR2A",
            "ZNF385D",
            "C3orf70",
            "FAM43A",
            "IGFBP5",
            "PCSK5",
            "SEMA5A",
            "C14orf37",
            "GPM6B",
            "ZNF423",
            "UNC5C",
            "ARHGAP28",
            "PTPRD",
            "TSHZ2",
            "DZIP1",
            "JAM3",
            "FAM26E",
            "SETBP1",
            "C14orf132",
            "SYT11",
            "ROBO1",
            "COMTD1",
            "TSPAN2",
            "FAM13C",
            "GLI2",
            "SGIP1",
            "BACH2",
            "AKT3",
            "LAMA4",
            "NID1",
            "ZNF660",
            "TMEM47",
            "EBF1",
            "ARL10",
            "PDZRN3",
            "OLFML1",
            "HEG1",
            "EML1",
            "CD200",
            "PLCL1",
            "TRPS1",
            "FEZ1",
            "JAM2",
            "CHN1",
            "TLCD1",
            "LDB2",
            "PCDH18",
            "SPSB2",
            "SPARCL1",
            "PDE5A",
            "C7orf47",
            "FAM101B",
            "FOXN3",
            "GAS7",
            "KLF12",
            "RAG1AP1",
            "RECK",
            "RHOJ",
            "GPR124",
            "UACA",
            "MPDZ",
            "ZEB1",
            "GALE",
            "TKT",
            "ELMO3",
            "ARHGEF16",
            "PKP3",
            "RNF122",
            "CYP2U1",
            "HDHD3",
            "APBB2",
            "C17orf90",
            "SGCB",
            "PIK3R1",
            "DIXDC1",
            "STAP2",
            "CHSY1",
            "NDUFS8",
            "SGK269",
            "CA5B",
            "FERMT2",
            "ARL15",
            "CCDC50",
            "TSPYL4",
            "CISD3",
            "LRCH1",
            "SSH3",
            "ZBTB7B",
            "NAT9",
            "PRR13",
            "MRPL38",
            "ZNF436",
            "HECA",
            "ZHX2",
            "C12orf52",
            "PDS5B",
            "COASY",
            "MFAP3"
        ]
    },
    {
        "golabel": "TCOF1_regulon_activity",
        "gene": [
            "IGJ",
            "PDE1A",
            "LMNB1",
            "KBTBD3",
            "PEX2",
            "CRYL1",
            "LMNB2",
            "DBN1",
            "CHAF1A",
            "NOP2",
            "HADH",
            "DNAJC2",
            "TMEM218",
            "ABCD3",
            "RRP12",
            "DHX37",
            "NEK7",
            "MOV10",
            "WDSUB1",
            "NHLRC3",
            "DDX54",
            "LARP1",
            "EIF4G1",
            "UBE2O",
            "SART1",
            "RNF44",
            "HNRNPAB",
            "AATF",
            "UTP14A",
            "LAPTM4A",
            "NCL",
            "UFM1",
            "TCERG1",
            "LAS1L",
            "STAM2",
            "HNRNPA0",
            "HELQ",
            "STX12",
            "REXO4",
            "DNAJC7",
            "PTBP1"
        ]
    },
    {
        "golabel": "TDG_regulon_activity",
        "gene": [
            "CA5A",
            "SELV",
            "GNAT1",
            "LOC731789",
            "ZMAT4",
            "DLL3",
            "NKAIN2",
            "RNF186",
            "MAGEA12",
            "WDR72",
            "MLLT11",
            "C12orf56",
            "C2CD4A",
            "FLJ22536",
            "HNF1A",
            "FCGBP",
            "LOC730101",
            "CD164L2",
            "TPD52",
            "NCRNA00093",
            "C17orf50",
            "MAP2K6",
            "VASH2",
            "PBK",
            "CX3CL1",
            "OIP5",
            "AURKA",
            "TROAP",
            "MCM10",
            "C12orf48",
            "DEPDC1",
            "PRKAA2",
            "NUF2",
            "TTC39C",
            "PFN2",
            "KIAA1908",
            "RAD51AP1",
            "SLC25A15",
            "DSCC1",
            "ARG2",
            "NCAPG",
            "GINS1",
            "ESCO2",
            "NEK2",
            "BUB1",
            "ATP2B1",
            "FAM60A",
            "ITGA3",
            "GCH1",
            "ECT2",
            "PPP2R1B",
            "MTHFD2",
            "ABCC3",
            "RACGAP1",
            "RFC3",
            "CD74",
            "RPRD1A",
            "TEF",
            "GALNT12",
            "TCEA3",
            "SLC36A4",
            "PDK1",
            "EPT1",
            "TIMELESS",
            "PPL",
            "TRIP6",
            "CD97",
            "FLVCR1",
            "ETNK1",
            "SLC9A3R2",
            "MPHOSPH9",
            "FECH",
            "XPOT",
            "KLHDC5",
            "TMPO",
            "BAIAP2",
            "CTSD",
            "DNM1L",
            "ZWILCH",
            "SUV39H2",
            "ENTPD7",
            "RFC5",
            "STRAP",
            "LOC727896",
            "TK2",
            "NUDT16",
            "SCRN2",
            "MVP",
            "C12orf73",
            "PAWR",
            "MRPL42",
            "TMEM135",
            "CPNE2",
            "SNRNP48",
            "CCNJ",
            "HSP90B1",
            "DHRS1",
            "C12orf23",
            "LOC221710",
            "TCEAL3",
            "MSN",
            "NFXL1",
            "ZDHHC7",
            "MAPK8",
            "APPL2",
            "RAB10",
            "CRY1",
            "FAM129B",
            "PARP3",
            "CRAT",
            "ATXN7L3B",
            "RPN2",
            "GHDC",
            "NAA25",
            "KRR1",
            "C16orf87",
            "TAF11",
            "E2F6",
            "SUDS3",
            "PDHX",
            "RIC8B",
            "PAPOLA",
            "C2orf43",
            "SENP1",
            "LARP4",
            "WDR24",
            "NR2C1",
            "SSB",
            "AKIRIN1",
            "RNF135",
            "ANAPC7",
            "SSR1",
            "USP15",
            "RAB6A",
            "WBP2",
            "DENR",
            "UPRT",
            "RPAP3",
            "PWP1",
            "ATP6V0A2",
            "C16orf42",
            "PSPC1",
            "NFYB",
            "KIAA1033",
            "RNF34",
            "PRDM4",
            "GABPB1",
            "UBXN4",
            "VPS11",
            "BRAP",
            "TRA2B"
        ]
    },
    {
        "golabel": "TEAD1_regulon_activity",
        "gene": [
            "VGLL3",
            "SLC2A14",
            "MAP1B",
            "DNAJC6",
            "PHLDB2",
            "KIAA0754",
            "GOLT1A",
            "TMEM141",
            "DPM3",
            "AKT3",
            "FAM195A",
            "C7orf59",
            "LSMD1",
            "C7orf55",
            "NDUFA2",
            "ABHD14A",
            "AMOTL2",
            "RANGRF",
            "ATP6V0B",
            "BLOC1S1",
            "RILP",
            "LOC283267",
            "ACADS",
            "C6orf108",
            "SERF2",
            "FIS1",
            "TCP11L1",
            "FAM63B",
            "TTBK2",
            "HDHD3",
            "UQCR10",
            "IFT20",
            "SAT2",
            "C22orf32",
            "RIF1",
            "KIF2A",
            "C17orf106",
            "C10orf12",
            "KATNAL1",
            "VPS28",
            "NT5C",
            "PPCDC",
            "SPRYD4",
            "CBL",
            "TMEM134",
            "MED11",
            "LUZP1",
            "SSNA1",
            "CISD3",
            "ITSN1",
            "DOCK7",
            "RNASEK",
            "AIP",
            "CCDC12",
            "HMGCL",
            "SSH1",
            "ARL6IP4",
            "QSER1",
            "RBM9",
            "TEX264",
            "NPRL2",
            "SLC25A11",
            "C14orf135",
            "GABARAP",
            "ZFP91"
        ]
    },
    {
        "golabel": "TEAD3_regulon_activity",
        "gene": [
            "TRIM17",
            "TULP1",
            "CLDN9",
            "FGFR3",
            "MDFI",
            "TLR8",
            "CLEC4A",
            "TFEC",
            "MS4A4A",
            "LAMA5",
            "MS4A6A",
            "CYBB",
            "C17orf87",
            "PTPRO",
            "CD80",
            "SNX10",
            "LOC653653",
            "PLEK",
            "NLRC4",
            "LY96",
            "GPR65",
            "MARCH1",
            "TLR4",
            "CD300A",
            "IL15",
            "AIF1",
            "MPP1",
            "PTPRU",
            "HAVCR2",
            "BTK",
            "KBTBD8",
            "CD86",
            "LCP1",
            "CD53",
            "AP1S2",
            "SLC7A7",
            "TM6SF1",
            "CTSC",
            "PVRL4",
            "C9orf46",
            "PACSIN3",
            "DCK",
            "LPXN",
            "C6orf132",
            "CYB5R4",
            "EPS8L2",
            "MANEA",
            "PAQR7",
            "PNPLA2",
            "TNRC18",
            "TIFA",
            "GYG1",
            "DDR1",
            "ZNF362",
            "CUL7",
            "SGTB",
            "PPARD",
            "SSH3",
            "KIAA1522",
            "PBX2",
            "SLC39A7",
            "POLK",
            "RAP1GDS1",
            "ATG4A",
            "HDAC7",
            "ATP6V1B2",
            "GOLGA2",
            "STK38",
            "SRF",
            "VPS52",
            "BAT3",
            "LEMD2",
            "PPP1R11",
            "TBC1D22B",
            "TRIM39",
            "ZFAND3"
        ]
    },
    {
        "golabel": "TERF2IP_regulon_activity",
        "gene": [
            "CD207",
            "CCNB2",
            "OIP5",
            "NDC80",
            "CASC5",
            "TTK",
            "KIF15",
            "CENPI",
            "CDC6",
            "RAD51AP1",
            "SPC25",
            "CDCA2",
            "KIFC1",
            "HJURP",
            "SGOL1",
            "SKA3",
            "ESCO2",
            "C19orf40",
            "FAM54A",
            "CDCA8",
            "KIF18A",
            "RAD51",
            "SGOL2",
            "NCALD",
            "ECT2",
            "WWOX",
            "RACGAP1",
            "STIL",
            "NCAPG2",
            "TMEM48",
            "FANCI",
            "C16orf48",
            "LRRC29",
            "ZNF778",
            "POLR2C",
            "ZNF19",
            "TRADD",
            "GABARAPL2",
            "ZNF821",
            "NFATC3",
            "CFDP1",
            "ATP6V0D1",
            "PRMT7",
            "WWP2",
            "TCEAL4",
            "MAP1LC3B",
            "WDR59",
            "FBXO31",
            "DYNC1LI2",
            "CBFB",
            "DDX19B",
            "SYF2"
        ]
    },
    {
        "golabel": "TFAM_regulon_activity",
        "gene": [
            "UBE2NL",
            "LOC728392",
            "ASAH2B",
            "SHC2",
            "CDK1",
            "APOB48R",
            "PRIM1",
            "LCAT",
            "BAG2",
            "LYPLA1",
            "OSTCL",
            "MAPK8IP3",
            "CROCC",
            "LOC649330",
            "CCDC88B",
            "REEP3",
            "ABCA7",
            "C14orf33",
            "LENG8",
            "CKAP2",
            "TNFRSF14",
            "CEMP1",
            "CNIH",
            "FAM193B",
            "HSPA13",
            "DCLRE1A",
            "TTC5",
            "MICAL1",
            "UBA2",
            "LMF1",
            "UBE2W",
            "RAN",
            "AHCY",
            "ANKS3",
            "GLRX3",
            "C1QBP",
            "FAM156A",
            "TUBGCP6",
            "ACTL6A",
            "NUDCD1",
            "PAK1IP1",
            "PPIL1",
            "SPPL2B",
            "C10orf2",
            "PGAM4",
            "PM20D2",
            "PKD1",
            "HMHA1",
            "CCNC",
            "DDX21",
            "NUP37",
            "MAP3K6",
            "TRUB1",
            "CCDC159",
            "LIN9",
            "TCIRG1",
            "ARMC1",
            "C12orf29",
            "TNK2",
            "RCN2",
            "SFI1",
            "MRPL42",
            "RG9MTD2",
            "COPS3",
            "RAD21",
            "WDR12",
            "ERLIN1",
            "SH2B1",
            "UNG",
            "PNPLA2",
            "PRDX3",
            "PRR24",
            "ARHGEF1",
            "TMEM175",
            "PNO1",
            "C10orf84",
            "ARFRP1",
            "C1orf163",
            "C16orf63",
            "DPH5",
            "DCUN1D1",
            "CCT4",
            "CWF19L1",
            "FAM160B2",
            "AZIN1",
            "IPO5",
            "RABEP2",
            "C2orf49",
            "C19orf66",
            "PTGES3",
            "PIGQ",
            "CCDC130",
            "BBS5",
            "FOXN2",
            "NRAS",
            "YWHAQ",
            "MRPL45",
            "RG9MTD1",
            "PRKRIR",
            "MAPK8",
            "GPN3",
            "PPP1R12C",
            "ATF1",
            "UTP23",
            "WDR43",
            "OGFR",
            "RPAP2",
            "CISD1",
            "CORO7",
            "GMFB",
            "PRMT3",
            "PCGF6",
            "PPP2R5B",
            "GTF2H3",
            "GHITM",
            "LRRC40",
            "DEK",
            "C19orf6",
            "LMF2",
            "PGBD3",
            "ZRSR2",
            "ZNF639",
            "THAP1",
            "ERCC8",
            "PCSK7",
            "RNF2",
            "UBE2E1",
            "COPS2",
            "TAF1B",
            "UBE2D1",
            "ZNF22",
            "SLC39A13",
            "FLYWCH1",
            "LRPPRC",
            "NOLC1",
            "NUP54",
            "CC2D1A",
            "RBM7",
            "EIF2S1",
            "MRPL30",
            "C9orf82",
            "VMAC",
            "NOC3L",
            "PTPN18",
            "ASCC1",
            "ZC3H15",
            "MINPP1",
            "GRINL1A",
            "CTDSPL2",
            "CLNS1A",
            "SLC25A32",
            "PCNP",
            "RPL7L1",
            "ZNF653",
            "CNOT7",
            "ABCE1",
            "USP20",
            "MRPS16",
            "TSR1",
            "DFFA",
            "FAM45A",
            "TYK2",
            "SRFBP1",
            "CUL2",
            "SUPV3L1",
            "FAM160A2",
            "CHUK",
            "BUB3",
            "PIP5K1C",
            "PPP1CC",
            "DDX18",
            "TBC1D17",
            "CTBP2",
            "TOMM70A",
            "CYTH1",
            "BMPR1A",
            "VPS26A",
            "FAM35B2",
            "RFX1",
            "METAP1",
            "YTHDF3",
            "FAM35A",
            "DDX50",
            "PARG",
            "MARCH5",
            "RPP30",
            "RAB11B",
            "C10orf119",
            "YY1",
            "ABCB7",
            "HNRPLL",
            "ATAD1",
            "HNRNPF",
            "NUDT21",
            "FAM35B",
            "NRBF2",
            "SEC23IP",
            "STARD7",
            "ANXA7",
            "C10orf46",
            "SMNDC1",
            "SMEK2",
            "WAPAL",
            "ECD",
            "FAM175B"
        ]
    },
    {
        "golabel": "TFAP4_regulon_activity",
        "gene": [
            "MSR1",
            "MS4A4A",
            "RRS1",
            "C5AR1",
            "FPR3",
            "STX11",
            "PROS1",
            "NCF2",
            "C13orf15",
            "CD86",
            "SLC31A2",
            "STARD8",
            "PTPN21",
            "TOP1MT",
            "EXOSC5",
            "C10orf2",
            "RPS2",
            "LIG4",
            "ADPRH",
            "SLC25A24",
            "NR2C2AP",
            "MYBBP1A",
            "MRPS2",
            "NLE1",
            "OSTM1",
            "LATS2",
            "DKC1",
            "PELP1",
            "LACTB",
            "TRAP1",
            "RSL1D1",
            "NOB1",
            "WDR74",
            "POLR3E",
            "FARSA",
            "SNX14",
            "CHERP",
            "PRPF19",
            "RNPS1"
        ]
    },
    {
        "golabel": "TFCP2_regulon_activity",
        "gene": [
            "NEB",
            "HAL",
            "HOXC9",
            "HOXC8",
            "HOXC6",
            "ATP7B",
            "DHDH",
            "EFCAB4B",
            "LOC100132111",
            "IFT57",
            "C21orf67",
            "PPM1H",
            "ATP10A",
            "FLJ42709",
            "ATP2B1",
            "ITGA3",
            "MMP24",
            "KIAA1549",
            "RAB38",
            "KIF21A",
            "PHLDA3",
            "CNN3",
            "C13orf23",
            "MAPKAPK3",
            "CD47",
            "ZSCAN5A",
            "PFKM",
            "HSP90B1",
            "JARID2",
            "SPATS2",
            "BLVRA",
            "ZBED1",
            "APPL2",
            "DIP2B",
            "CRAT",
            "ATXN7L3B",
            "RPN2",
            "ZNF664",
            "SMARCD1",
            "SEC23B",
            "RGS3",
            "FASTKD5",
            "SUDS3",
            "CSRNP2",
            "PAPOLA",
            "SMAP1",
            "LARP4",
            "ARID2",
            "ZNF384",
            "UBE2G1",
            "TMEM109",
            "DDX23",
            "ZNF740",
            "DNAJC14",
            "SEC22C",
            "SART3",
            "SAPS3",
            "BRAP",
            "ASB8",
            "CTCF"
        ]
    },
    {
        "golabel": "TFCP2L1_regulon_activity",
        "gene": [
            "SLC38A8",
            "TMEM229A",
            "KCNU1",
            "CTNND2",
            "SLC14A2",
            "RET",
            "CNGA3",
            "COL25A1",
            "TMED6",
            "BARX1",
            "LOC145837",
            "CNTN4",
            "PITX2",
            "FAM184B",
            "C1orf95",
            "ATP6V1B1",
            "KCNE4",
            "C20orf197",
            "SYBU",
            "PRMT8",
            "DACT2",
            "SYCP2L",
            "KIAA1984",
            "SLC7A2",
            "TSPAN11",
            "SEC11C",
            "SCNN1G",
            "C17orf76",
            "THPO",
            "SLC16A14",
            "LPL",
            "DNAJC12",
            "GPR87",
            "SCNN1B",
            "TBX15",
            "KIAA1324",
            "GPR98",
            "ATOH8",
            "CIT",
            "LYPD5",
            "LGSN",
            "KIT",
            "CXCL10",
            "NCRNA00086",
            "SDK1",
            "PLAU",
            "PCDH7",
            "ZNF710",
            "GPT2",
            "HUNK",
            "CACNA1D",
            "KCNJ11",
            "ULBP2",
            "GPR133",
            "MOSC1",
            "STEAP1",
            "CDH3",
            "BEND6",
            "SYT7",
            "FSCN1",
            "IRS2",
            "C10orf55",
            "LOC151009",
            "GADD45G",
            "ABLIM2",
            "AHCYL2",
            "KCNQ1",
            "C8orf4",
            "GBP1",
            "ALDH3A2",
            "MECOM",
            "PLEKHG2",
            "ATP1B1",
            "ANO9",
            "KSR1",
            "B3GALNT1",
            "LPIN2",
            "CABLES1",
            "SCNN1A",
            "SLC22A23",
            "RND3",
            "IFIT2",
            "ARHGAP26",
            "FCGR1B",
            "AIM1",
            "IFIT3",
            "PPP1R3B",
            "ATP11A",
            "C7orf41",
            "APOBEC3G",
            "DSE",
            "FXYD5",
            "TNFRSF12A",
            "IMPA2",
            "FZD3",
            "RAB32",
            "GRAMD4",
            "RHOU",
            "MAP7D3",
            "EMP3",
            "FAS",
            "ATP8B1",
            "UNC13B",
            "GOLGA6L10",
            "ULBP3",
            "PHF17",
            "NCEH1",
            "CDK2AP2",
            "TUBB6",
            "IFI35",
            "ZNF238",
            "NCS1",
            "CCDC109B",
            "CD40",
            "NKX2-1",
            "RGS10",
            "MDFIC",
            "TBC1D8",
            "MTUS1",
            "S100A10",
            "RELL1",
            "SNX8",
            "FRAT1",
            "STK17A",
            "ANXA2P2",
            "SH3BGRL3",
            "OGFRL1",
            "HS6ST1",
            "ProSAPiP1",
            "EFHD2",
            "TRIM68",
            "RHOC",
            "ELK3",
            "CMTM3",
            "ANXA2",
            "DAPP1",
            "OBFC2A",
            "UBE2L6",
            "FAAH2",
            "INSR",
            "PPP1R13B",
            "PGM2",
            "FRAT2",
            "KIAA1949",
            "LRIG1",
            "STAU2",
            "SLC19A2",
            "RAB40C",
            "PIM3",
            "MRPS25",
            "CCDC90B",
            "HIP1R",
            "PRKAB1",
            "NFKBIE",
            "KIAA0182",
            "PLIN3",
            "ARHGAP10",
            "MED13L",
            "CASP4",
            "SPATS2L",
            "MLEC",
            "TMEM51",
            "RALB",
            "SH3BP1",
            "TPM4",
            "OSBPL2",
            "BCL10",
            "WDR53",
            "EHD1",
            "VAT1",
            "RAP2B",
            "CORO1C",
            "ZYX",
            "SUMO3",
            "RGS19",
            "PLA2G15",
            "GLT25D1",
            "CHD3",
            "C7orf70",
            "ANXA5",
            "IRGQ",
            "MAP7D1",
            "NECAP2",
            "ZNF267",
            "DCLRE1B",
            "AP2M1",
            "GNAI2",
            "ACTB",
            "CAPZA1",
            "EHD4",
            "ZC3H7A",
            "CAPZB"
        ]
    },
    {
        "golabel": "TFEC_regulon_activity",
        "gene": [
            "CLEC4E",
            "PKD2L1",
            "CLEC4D",
            "CLEC12B",
            "HTRA4",
            "CD274",
            "HAMP",
            "LILRA3",
            "AQP9",
            "FLJ37543",
            "GPR141",
            "CXCL10",
            "VNN2",
            "CASP5",
            "LOC400759",
            "SIRPD",
            "HLA-DPB2",
            "IL10",
            "CD163",
            "IL27",
            "RAB42",
            "NAT8B",
            "GPNMB",
            "SRGN",
            "LILRA6",
            "SIRPB1",
            "EVI2A",
            "BST1",
            "PTPN22",
            "FCGR2B",
            "APOL4",
            "MIR155HG",
            "KMO",
            "GPR183",
            "SLC1A3",
            "MS4A6A",
            "SAMSN1",
            "FCGR2C",
            "OBSL1",
            "C1QB",
            "FCGR1A",
            "MCOLN2",
            "FCGR1C",
            "FCGR3A",
            "MS4A7",
            "FCGR1B",
            "C1QC",
            "EPSTI1",
            "SNX10",
            "KLF1",
            "C1QA",
            "NPL",
            "SIGLEC7",
            "PLEK",
            "LY96",
            "CD72",
            "GPR65",
            "SAMD9L",
            "MARCH1",
            "SIRPB2",
            "GYG2",
            "TLR4",
            "CD300A",
            "LAIR1",
            "MPP1",
            "HAVCR2",
            "KBTBD8",
            "BEST1",
            "NAIP",
            "CASP1",
            "SLA",
            "TLR1",
            "NR1H3",
            "SLC31A2",
            "MAFB",
            "DBNDD1",
            "PACSIN3",
            "ZEB2",
            "OBFC2A",
            "LPAR6",
            "GPR56",
            "GNB4",
            "C17orf28",
            "CHPF",
            "JAK2",
            "C9orf72",
            "CYB5R4",
            "SLC38A6",
            "GPR137B",
            "UBE2E2",
            "NIPSNAP3A",
            "LRP5",
            "SPINT1",
            "DMXL2",
            "FAM49B",
            "PRSS16",
            "MAGED1",
            "GAS8",
            "C9orf21",
            "AMPD3",
            "RP2",
            "SGK3",
            "TEAD3",
            "SNX3",
            "OSTM1",
            "SGTB",
            "PRCP",
            "HPS5",
            "TNK1",
            "KIAA1522",
            "SDCBP",
            "TMEM140",
            "C1orf96",
            "C12orf4",
            "CYB561",
            "C14orf118",
            "ME2",
            "EIF3CL",
            "LACTB",
            "ACER3",
            "FIG4",
            "RNF13",
            "ZNF267",
            "SNX11",
            "CRLF3",
            "GOLGA2",
            "PNRC1",
            "TMEM188",
            "IRAK4",
            "WHSC2",
            "OSBPL11",
            "YIPF3",
            "ATG4C",
            "USP15",
            "RNF187",
            "OSTF1",
            "CEPT1",
            "PRKCSH",
            "ARPC2",
            "KIAA1033",
            "MSL3",
            "CDC40",
            "TM9SF4",
            "LRRC47"
        ]
    },
    {
        "golabel": "TFPT_regulon_activity",
        "gene": [
            "C10orf125",
            "RARRES2",
            "C1orf54",
            "LOC606724",
            "NBEAL1",
            "TNFRSF4",
            "POLR2I",
            "CORO1A",
            "LIMD2",
            "CYBA",
            "H2AFJ",
            "NCOA2",
            "LIN37",
            "ATP6V0B",
            "PLEKHO1",
            "ALDH5A1",
            "TYMP",
            "GADD45GIP1",
            "C19orf60",
            "TBCB",
            "NDUFA3",
            "WNK1",
            "TRAPPC2P1",
            "RBM42",
            "RABAC1",
            "NOSIP",
            "C9orf16",
            "SH3BP1",
            "CCDC106",
            "KCTD17",
            "YIF1B",
            "YAP1",
            "SLK",
            "AURKAIP1",
            "HSPBP1",
            "BCL2L12",
            "ZNF787",
            "SHKBP1",
            "DRAP1",
            "JOSD2",
            "TOR1AIP2",
            "MED13",
            "ISOC2",
            "COPE",
            "RGS19",
            "EEA1",
            "AP2S1",
            "PNKP",
            "NDUFS7",
            "RUVBL2",
            "SIRT6",
            "SLC2A8",
            "UBE2M",
            "UBR3",
            "FAM108A1",
            "ARHGEF12",
            "RBM47",
            "TBC1D5",
            "BAX",
            "PIN1",
            "LENG1",
            "APBA3",
            "NAGK",
            "PIH1D1",
            "MYST2",
            "PDS5A",
            "C1orf25",
            "PRKAR1A",
            "C9orf64",
            "PRPF31",
            "NBR1",
            "VPRBP",
            "SEC24B"
        ]
    },
    {
        "golabel": "TGIF1_regulon_activity",
        "gene": [
            "VAX1",
            "AKR1C2",
            "S100P",
            "GCLC",
            "OPN3",
            "NR4A2",
            "ID1",
            "SIK1",
            "ZFP92",
            "KRT7",
            "SLC34A2",
            "FLJ35776",
            "DUSP5",
            "NFIX",
            "SNX30",
            "TLR2",
            "BAG2",
            "NFATC2",
            "FAM129A",
            "FNIP2",
            "ADCY9",
            "ANKRD44",
            "CIITA",
            "C6orf129",
            "GALNT10",
            "PTP4A1",
            "PRDX1",
            "GAB3",
            "HIP1",
            "SLC43A3",
            "MFF",
            "RAPGEF6",
            "ARHGEF6",
            "C20orf24",
            "CASP9",
            "LRRK1",
            "HBXIP",
            "S100A11",
            "AKNA",
            "SNRPD1",
            "KAT2B",
            "NDUFV2",
            "NDUFB4",
            "CHMP1B",
            "MYL12B",
            "RASSF5",
            "LYST",
            "SPTLC2",
            "PSMB6",
            "PSMD14",
            "SYNJ1",
            "MYL12A",
            "PSMD4",
            "HERC1",
            "MLL3",
            "ANKRD13A",
            "MAP3K3",
            "UQCRC1",
            "KCMF1",
            "SEC13",
            "VPS26B",
            "ZNF490",
            "DDX24",
            "NDST2"
        ]
    },
    {
        "golabel": "THAP1_regulon_activity",
        "gene": [
            "POLB",
            "LOC100133161",
            "LOC91316",
            "LYPLA1",
            "NCRNA00174",
            "RPS27",
            "MAPK8IP3",
            "BRF2",
            "BAG4",
            "NSMCE2",
            "LENG8",
            "VDAC3",
            "WDR90",
            "MED21",
            "GOLGA7",
            "TMEM70",
            "CNIH",
            "COMMD8",
            "C8orf40",
            "FLJ45340",
            "HOOK3",
            "CDK5RAP3",
            "UBE2W",
            "GIGYF1",
            "AP3M2",
            "ANKRD46",
            "ASF1A",
            "TMEM68",
            "TRUB1",
            "FNTA",
            "RNF170",
            "ARMC1",
            "TFAM",
            "ZNF124",
            "TXNDC9",
            "TCEA1",
            "PRDX3",
            "SDHC",
            "ATF1",
            "C1orf74",
            "NSL1",
            "MOBKL3",
            "EIF1AX",
            "HSPA8",
            "SIN3B",
            "MED15",
            "TAOK2",
            "TIPRL",
            "TADA1",
            "LRSAM1",
            "GRINL1A",
            "MAD2L1BP",
            "ANAPC2",
            "TYK2",
            "ASNSD1",
            "REXO1",
            "C11orf58",
            "YTHDF3",
            "SAFB2",
            "CDC73"
        ]
    },
    {
        "golabel": "THAP3_regulon_activity",
        "gene": [
            "A1BG",
            "LOC388588",
            "SNHG9",
            "POLR2F",
            "DPM3",
            "DNLZ",
            "THAP7",
            "C12orf57",
            "LIN7B",
            "ROMO1",
            "C7orf59",
            "LSMD1",
            "C7orf55",
            "KIAA1161",
            "C7orf47",
            "BGLAP",
            "NDUFA11",
            "FAM58A",
            "GUK1",
            "TRNAU1AP",
            "QPCTL",
            "VWA1",
            "ATP6V0B",
            "SDHAF1",
            "NUDT14",
            "NDUFB7",
            "FLT1",
            "SIVA1",
            "ZNF593",
            "GALE",
            "FBXO6",
            "LSM7",
            "PUSL1",
            "NRL",
            "NUDT16L1",
            "ARL16",
            "FAM96B",
            "C1orf86",
            "C9orf142",
            "CCDC23",
            "PQBP1",
            "APITD1",
            "PRDX5",
            "SMPD2",
            "ROCK2",
            "BCL7C",
            "ATPIF1",
            "TMEM2",
            "HSPC157",
            "FBXO44",
            "RIF1",
            "FAM195B",
            "ASXL2",
            "C14orf179",
            "FAM3A",
            "TP53I13",
            "SLK",
            "AURKAIP1",
            "ARF5",
            "GLTPD1",
            "TMEM134",
            "OSGEP",
            "SSNA1",
            "NDUFC2",
            "MVK",
            "LRRC58",
            "B3GAT3",
            "TRPT1",
            "BANF1",
            "CAMTA1",
            "ZBTB48",
            "C19orf25",
            "RNASEH2C",
            "UROD",
            "USE1",
            "FAM89B",
            "C1orf50",
            "PPIE",
            "BAD",
            "AIP",
            "HMGCL",
            "B4GALT7",
            "LYPLA2",
            "PQLC2",
            "MIIP",
            "C1orf151",
            "ZC3H13",
            "AKR1A1",
            "ARL6IP4",
            "ACOT8",
            "NUDT22",
            "ZNF691",
            "AKR7A2",
            "NDUFS7",
            "FAM200B",
            "SDHB",
            "POMGNT1",
            "DPP8",
            "CHMP6",
            "WBP1",
            "C1orf174",
            "INO80E",
            "PEX10",
            "XKR8",
            "ERI3",
            "LOC148413",
            "NPRL2",
            "KIAA2018",
            "TIMM44",
            "ADPRHL2",
            "PARK7",
            "ZFAND2B",
            "LENG1",
            "ZCCHC6",
            "RER1",
            "GFER",
            "USF1",
            "MRPL20",
            "UNC119",
            "DDOST",
            "BIRC6",
            "VEGFB",
            "RNF25",
            "WDR8",
            "TMEM222",
            "C19orf56",
            "SDF4",
            "UBE2J2",
            "SLMAP",
            "CPSF3L",
            "OTUB1",
            "PIK3R4",
            "PEF1",
            "OTUD4",
            "EAF1",
            "PEX14",
            "SSU72",
            "FAM54B",
            "RBM27",
            "WAPAL",
            "KIAA2013",
            "GPATCH3",
            "C1orf144"
        ]
    },
    {
        "golabel": "THAP4_regulon_activity",
        "gene": [
            "AKR1C1",
            "OSGIN1",
            "COMTD1",
            "SLC39A4",
            "TALDO1",
            "PLXNC1",
            "CHCHD10",
            "STK32C",
            "MAML2",
            "C21orf91",
            "GSTP1",
            "MYEOV2",
            "SLC25A10",
            "FN3K",
            "RGL1",
            "DTYMK",
            "EXOSC4",
            "RAB17",
            "FAM128A",
            "TOMM40",
            "RPL37A",
            "ATP5D",
            "C15orf63",
            "EXOSC5",
            "NME2",
            "LTBR",
            "MRPL12",
            "PKP3",
            "NOP16",
            "PPP1R14B",
            "FAM128B",
            "KAT2B",
            "PIK3R1",
            "PKD2",
            "ATP5G3",
            "CAPN10",
            "EIF5A",
            "SLC25A6",
            "GAB1",
            "LSM4",
            "PWWP2B",
            "ZNF347",
            "RASA2",
            "ETFB",
            "NT5C",
            "ATG4D",
            "IRF2BP1",
            "ANKRD39",
            "IFNAR2",
            "DUS1L",
            "NDUFB8",
            "MRPS2",
            "KIAA0664",
            "FBXW5",
            "PTDSS2",
            "TIMM13",
            "SYNJ1",
            "FAM119A",
            "MAP3K1",
            "CCDC124",
            "FAM13B",
            "PTGES2",
            "SLC27A4",
            "MRPL38",
            "TSSC1",
            "DCP2",
            "ECHS1",
            "PHC3",
            "RNPEPL1",
            "IMP4",
            "RNMTL1",
            "AKT1S1",
            "C9orf86",
            "DDX54",
            "SCLY",
            "DMXL1",
            "GMPPA",
            "ZNF136",
            "ATIC",
            "PMPCA",
            "UBE2F",
            "EVI5",
            "NDUFS2",
            "TSSC4",
            "ZFP90",
            "RNF25",
            "BCS1L",
            "RNF187",
            "MRPL44",
            "ILKAP",
            "S100PBP",
            "SGTA",
            "STK25",
            "ZBTB1",
            "ELAC2",
            "MORC3",
            "DIS3L2",
            "TTC15",
            "C3orf63",
            "C2orf24",
            "CTDSP1",
            "PPP1R7",
            "PPP2R1A",
            "ATG9A",
            "ZMYM6",
            "AAMP",
            "FAM134A",
            "PCBP1"
        ]
    },
    {
        "golabel": "THAP5_regulon_activity",
        "gene": [
            "CAPZA2",
            "ADAMTS7",
            "OSTCL",
            "C7orf60",
            "ACN9",
            "PMS2L1",
            "RBBP8",
            "BET1",
            "DNAJB9",
            "RFESD",
            "NBEAL2",
            "UBE2W",
            "C5orf28",
            "SENP8",
            "C5orf54",
            "TMEM182",
            "CLDN12",
            "MRPS33",
            "TRUB1",
            "C12orf29",
            "THNSL1",
            "MYNN",
            "POT1",
            "ORC5L",
            "SLC25A40",
            "PRR24",
            "ARMC10",
            "SH3TC1",
            "ZNF277",
            "RABL5",
            "PLEKHF2",
            "C16orf63",
            "TIFA",
            "RMI1",
            "RAD1",
            "CASD1",
            "BCAP29",
            "VKORC1L1",
            "CCDC121",
            "FOXN2",
            "PSMC2",
            "ZNRF2",
            "SOLH",
            "NCKAP5L",
            "RAB33B",
            "TTC33",
            "UTP23",
            "SYPL1",
            "TRIM4",
            "HBP1",
            "MOBKL3",
            "SLC38A10",
            "NAPEPLD",
            "ARAP1",
            "C19orf6",
            "SNRNP70",
            "ANKRD49",
            "FAM200A",
            "MYCBP",
            "DR1",
            "TMEM168",
            "GTPBP10",
            "MMGT1",
            "PNPLA8",
            "LYRM7",
            "NMNAT1",
            "ABCC10",
            "IPP",
            "KIAA1430",
            "GNPDA2",
            "VMA21",
            "MED25",
            "TBL2",
            "LYSMD3",
            "CTDSPL2",
            "EPN1",
            "ZBTB41",
            "PCNP",
            "C7orf64",
            "ZBTB6",
            "SBDSP1",
            "ASNSD1",
            "RBBP4",
            "ATP13A1",
            "NDUFA5",
            "CBLL1",
            "CDC37",
            "DCTN1",
            "RSBN1L",
            "TBC1D23",
            "CEP57",
            "RBM18",
            "ZNF800",
            "VAMP4",
            "RNF123",
            "HIAT1",
            "THUMPD3",
            "TMEM115"
        ]
    },
    {
        "golabel": "THAP9_regulon_activity",
        "gene": [
            "COL1A1",
            "SPHK1",
            "LAMB3",
            "COL6A2",
            "MMP14",
            "PLAUR",
            "SLC16A3",
            "EMILIN1",
            "TIGD4",
            "BMP1",
            "HIC1",
            "PTRF",
            "PDLIM7",
            "GKAP1",
            "TYMP",
            "KIAA1949",
            "GNA15",
            "LIMK1",
            "CTSB",
            "SENP8",
            "RHBDF2",
            "PLIN3",
            "ZNF620",
            "PML",
            "SBNO2",
            "THNSL1",
            "PXN",
            "RG9MTD2",
            "HSPC157",
            "KLHDC2",
            "RIN3",
            "KIAA1712",
            "MRPL1",
            "GAS2L1",
            "HADH",
            "KLF16",
            "MYH9",
            "VASP",
            "ZYX",
            "TICAM1",
            "CCDC121",
            "POLI",
            "TMEM128",
            "PDIK1L",
            "ZNF250",
            "ZNF252",
            "LOC400657",
            "CYP2R1",
            "COX18",
            "GLT25D1",
            "TRIP10",
            "RCHY1",
            "MAP7D1",
            "LIPT1",
            "MED15",
            "BCDIN3D",
            "SEPSECS",
            "KLHL8",
            "DNAJC27",
            "MOBKL2A",
            "CBR4",
            "PIGY",
            "ZNF559",
            "MAPKSP1",
            "ELAC1",
            "SH3GL1",
            "COPS4",
            "GNAI2",
            "IKZF5",
            "ZBED5",
            "ACTB",
            "FAM76B",
            "PIP5K1C",
            "PGRMC2",
            "AP2A1",
            "HELQ",
            "INTS12",
            "ZFP161",
            "RBMX",
            "ELF2",
            "YTHDC1"
        ]
    },
    {
        "golabel": "THRA_regulon_activity",
        "gene": [
            "RGS20",
            "IFNG",
            "APOD",
            "PCDHAC2",
            "GGT6",
            "KLF15",
            "RAP1GAP",
            "ZBTB7C",
            "UBE2C",
            "SCN4B",
            "KLHDC7A",
            "RAB36",
            "MAD2L1",
            "DLGAP5",
            "PLCE1",
            "NFIX",
            "CCNA2",
            "SGOL1",
            "NCAPG",
            "DNALI1",
            "SKA3",
            "CENPK",
            "RRM2",
            "CCNB1",
            "CTF1",
            "PYGL",
            "PLK4",
            "C7orf40",
            "ACSS1",
            "LRTOMT",
            "TEF",
            "IFT140",
            "IFT172",
            "KIAA0513",
            "TNS1",
            "IL28RA",
            "SPATA6",
            "AMIGO1",
            "PPFIBP2",
            "TTC12",
            "PEX11A",
            "LDHA",
            "EPB41L4A",
            "RIPK2",
            "ALDH4A1",
            "FLJ11235",
            "CASZ1",
            "PDSS1",
            "CYB5RL",
            "CRY2",
            "MYO1D",
            "C1orf89",
            "IQCK",
            "PDK2",
            "ILDR1",
            "TMEM8B",
            "RAB11FIP3",
            "ROGDI",
            "EPB41L1",
            "AVEN",
            "TTLL1",
            "SLC48A1",
            "DET1",
            "ORMDL3",
            "JMJD8",
            "BCAS3",
            "PCGF6",
            "RARA",
            "ITFG3",
            "C15orf38",
            "MLYCD",
            "NAA15",
            "WWP2",
            "BBS1",
            "ALG12",
            "ZNF213",
            "UBA3",
            "CASC3",
            "SEPN1",
            "CEP68",
            "PSKH1",
            "WDTC1",
            "NAT15",
            "PSMD6"
        ]
    },
    {
        "golabel": "THRB_regulon_activity",
        "gene": [
            "VILL",
            "UMODL1",
            "CYP2C18",
            "BCAS1",
            "SPATA18",
            "ACADL",
            "B4GALNT4",
            "MIA2",
            "POF1B",
            "BCL2L14",
            "SRPK3",
            "GCNT4",
            "C6orf155",
            "HMGB3",
            "MEX3A",
            "C4orf19",
            "THSD4",
            "UBE2C",
            "APBA2",
            "FMN1",
            "AURKB",
            "KLF4",
            "LIPH",
            "FAM69B",
            "KIAA1377",
            "PAQR8",
            "RNASE4",
            "TMEM220",
            "NAALADL2",
            "PTP4A3",
            "ASAP2",
            "CASC2",
            "CCDC68",
            "ARHGEF37",
            "RGNEF",
            "TOB1",
            "C15orf34",
            "TLR3",
            "VEGFA",
            "NR3C2",
            "BEND7",
            "CC2D2A",
            "LGR4",
            "CXADR",
            "MED27",
            "GALNT12",
            "SLMO1",
            "C11orf63",
            "FRY",
            "C8orf38",
            "PLS1",
            "GRAMD1C",
            "NR2F2",
            "CARD6",
            "ARHGAP24",
            "VWA5A",
            "DUSP19",
            "PTMS",
            "PPP1R14B",
            "FRMD4B",
            "USP54",
            "MAML3",
            "C11orf84",
            "THOC4",
            "DDX39",
            "FUT10",
            "CCPG1",
            "CLCN3",
            "EPB41L1",
            "CDC34",
            "RETSAT",
            "VPS72",
            "ZDHHC7",
            "ANKMY2",
            "DHFRL1",
            "TCF3",
            "CLINT1",
            "ZNF71",
            "RNASEL",
            "NARF",
            "TTC23",
            "RNF103",
            "SLC25A30",
            "ALPK1",
            "RABGAP1L",
            "TSPYL1",
            "C17orf62",
            "SPG11",
            "STK25",
            "PDCD6IP"
        ]
    },
    {
        "golabel": "TIGD3_regulon_activity",
        "gene": [
            "LRRC14B",
            "GNAT1",
            "MYCNOS",
            "CTXN2",
            "TMEM145",
            "TMEM74",
            "PPM1E",
            "NXPH4",
            "ZBTB8B",
            "HES6",
            "TUBB2B",
            "ATOH7",
            "C17orf76",
            "RIMKLA",
            "ACBD7",
            "SEPT3",
            "KSR2",
            "IGFBPL1",
            "B4GALNT4",
            "LOC728819",
            "NRTN",
            "HMGB3",
            "EFR3B",
            "MEX3A",
            "TMEM198",
            "GPR137C",
            "LOC148709",
            "TRIM46",
            "SEMA6C",
            "C6orf122",
            "TUBB2A",
            "HCN3",
            "FADS2",
            "ANKRD13B",
            "LOC401431",
            "FOXA1",
            "MAP6D1",
            "PTP4A3",
            "BMP8B",
            "SBK1",
            "GYLTL1B",
            "MAPK8IP1",
            "E2F1",
            "LPAR5",
            "TLR3",
            "CADM4",
            "RBM38",
            "MEX3B",
            "FADS1",
            "SQRDL",
            "PAFAH1B3",
            "CD44",
            "ANXA2P2",
            "CDKN2D",
            "FAM161A",
            "CARD6",
            "SS18L1",
            "AZI1",
            "CBFA2T2",
            "C6orf134",
            "DHRS13",
            "PXMP2",
            "C11orf84",
            "SUZ12P",
            "PXN",
            "NARS2",
            "ZNF48",
            "LSM14B",
            "ZNF821",
            "NARF",
            "TRAF3IP2",
            "TSEN54",
            "RAB11FIP5",
            "LRRFIP1",
            "MMAA",
            "NFKB1",
            "MEN1",
            "ELF1",
            "JAK1",
            "VPS37C",
            "SEC24B",
            "PDCD6IP"
        ]
    },
    {
        "golabel": "TIMELESS_regulon_activity",
        "gene": [
            "NBPF4",
            "LOC100132354",
            "SELV",
            "MAGEB2",
            "HOXD13",
            "LIN28B",
            "KCNH5",
            "C9orf4",
            "INHBE",
            "HOXB8",
            "LOC731789",
            "INA",
            "TBR1",
            "IGF2BP1",
            "CSAG3",
            "FGF12",
            "CSAG1",
            "HSPC072",
            "MAGEA12",
            "PPY2",
            "ZNF280A",
            "MAGEA2",
            "DLX6",
            "PATE2",
            "MAGEA6",
            "PRAME",
            "MAGEA3",
            "SCML2",
            "ATOH7",
            "ACRV1",
            "MKRN3",
            "C6orf195",
            "DSCR6",
            "WNK2",
            "AGRP",
            "FCER1A",
            "AQP1",
            "HOPX",
            "HOXC6",
            "S100B",
            "CD1E",
            "LYPD6",
            "RNFT2",
            "MURC",
            "CD1C",
            "RNF157",
            "CBX2",
            "C12orf34",
            "CCL14",
            "SFRS13B",
            "HPGDS",
            "MCF2L2",
            "MARK1",
            "FIGN",
            "FOXF2",
            "NPC2",
            "PLD4",
            "PLAC9",
            "CIB2",
            "DDIT3",
            "ESPL1",
            "FADS2",
            "RHPN2",
            "SLC34A2",
            "CFI",
            "LOC222699",
            "AURKAPS1",
            "SLC39A8",
            "C1orf133",
            "MPZL2",
            "SLC38A1",
            "C7orf23",
            "SHMT2",
            "MCM8",
            "PHLDA3",
            "UTP20",
            "TSPAN3",
            "CD59",
            "TMEM194A",
            "XPOT",
            "TSPAN4",
            "SPRED1",
            "RAB27A",
            "IGFBP4",
            "DNMT3A",
            "ICAM2",
            "PDLIM2",
            "MARS",
            "TDG",
            "TK2",
            "DNAJC10",
            "TNFSF13",
            "CDK2",
            "CTSO",
            "E2F3",
            "QSOX2",
            "TH1L",
            "SPATS2",
            "SFXN3",
            "ABHD14B",
            "ANKRD52",
            "TNFSF12",
            "DIP2B",
            "PARP3",
            "POLR3GL",
            "SMARCD1",
            "RGS3",
            "RFWD3",
            "SH3BGRL",
            "TRIM28",
            "TMEM43",
            "CRTAP",
            "PSME4",
            "SENP1",
            "RBBP7",
            "SAE1",
            "FAM82A2",
            "IPO9",
            "DDX23",
            "U2AF2",
            "SFPQ",
            "DNAJC14",
            "SART3",
            "IMMT"
        ]
    },
    {
        "golabel": "TLE2_regulon_activity",
        "gene": [
            "CPAMD8",
            "BZRAP1",
            "GBP1",
            "SHC2",
            "LOC441869",
            "PCSK4",
            "CHADL",
            "C22orf36",
            "TAP1",
            "SHCBP1",
            "ARVCF",
            "RGL3",
            "NKX2-1",
            "STAT1",
            "ARHGEF19",
            "CHRNB1",
            "PDE9A",
            "C12orf11",
            "EPOR",
            "YPEL1",
            "DUSP8",
            "UBTD1",
            "CRTC1",
            "LTBP3",
            "NUP37",
            "C4orf32",
            "SLC2A11",
            "CPNE2",
            "ADIPOR2",
            "C21orf2",
            "SETD4",
            "ROGDI",
            "ZDHHC8",
            "CIRBP",
            "SLC25A23",
            "LZTR1",
            "KIAA0495",
            "ZNF362",
            "RAB10",
            "FAM109B",
            "SMCR7",
            "TBC1D10A",
            "DGCR2",
            "KLHL22",
            "MOBKL1B",
            "KPNA4",
            "TBK1",
            "VMAC",
            "TNPO1",
            "ZC3H15",
            "AES",
            "ACTR3",
            "MUM1",
            "PATL1",
            "AP1AR",
            "PWP1",
            "CDC27"
        ]
    },
    {
        "golabel": "TLE4_regulon_activity",
        "gene": [
            "TRIM16L",
            "PTPN13",
            "UGDH",
            "CACHD1",
            "LRRC4",
            "FGFR2",
            "IQGAP2",
            "GCSH",
            "PANX2",
            "SPTLC3",
            "PAQR8",
            "PLEKHH2",
            "ZP3",
            "LCA5",
            "BAG2",
            "SHROOM4",
            "MGST1",
            "FNIP2",
            "PLCL2",
            "ZNF439",
            "C7orf47",
            "TCEB1",
            "AIFM2",
            "CDC14A",
            "TRIM22",
            "POP7",
            "LRIG1",
            "LRRK1",
            "C15orf63",
            "MRPL24",
            "MRPL12",
            "COPS6",
            "MRPS24",
            "PFDN6",
            "SLC3A2",
            "SMARCA2",
            "EIF5A",
            "UBL4A",
            "EIF5AL1",
            "CEP110",
            "CNO",
            "MDH2",
            "KIAA0247",
            "YPEL2",
            "DDX56",
            "ZNF776",
            "NOL7"
        ]
    },
    {
        "golabel": "TMF1_regulon_activity",
        "gene": [
            "IL6ST",
            "ASPSCR1",
            "MBLAC1",
            "SLC41A2",
            "NRM",
            "KPTN",
            "FAM63B",
            "CTNNB1",
            "HAUS7",
            "TBC1D8B",
            "HIPK3",
            "MUTYH",
            "FAM195B",
            "SLK",
            "MTG1",
            "PXK",
            "C10orf118",
            "TRMT61A",
            "LZTFL1",
            "GCC2",
            "ARHGEF3",
            "SEC24D",
            "GOLGA4",
            "DENND4C",
            "MIIP",
            "G6PC3",
            "ATXN7",
            "ADRM1",
            "C3orf64",
            "CNPY3",
            "MRPL28",
            "ARMC6",
            "SEC24A",
            "UBA3",
            "RALY",
            "SPNS1",
            "TAF6L",
            "ZCCHC6",
            "ARF4",
            "PFKL",
            "SACM1L",
            "GPS1",
            "ACBD3",
            "VEGFB",
            "SLMAP",
            "SLC30A7",
            "RUFY2",
            "PEX14",
            "USO1",
            "DCP1A",
            "KIAA2013",
            "ZBTB11",
            "GPATCH3",
            "SEC31A",
            "RAB5A",
            "PDCD6IP"
        ]
    },
    {
        "golabel": "TOB1_regulon_activity",
        "gene": [
            "PLA2G10",
            "MSLN",
            "SLC26A9",
            "ATOH8",
            "NR4A2",
            "KLF15",
            "ADAM12",
            "MAOA",
            "SORBS2",
            "AVPI1",
            "ALDH3B1",
            "MECOM",
            "ATP1B1",
            "WISP1",
            "IL21R",
            "IL17RE",
            "GPRC5C",
            "HNF1B",
            "RORC",
            "NEDD4L",
            "THRB",
            "KLF5",
            "ALDH2",
            "KCNK1",
            "BICD1",
            "CHP",
            "FIGNL1",
            "TTYH3",
            "PLEKHO1",
            "KIAA1949",
            "LIMK1",
            "NRIP1",
            "C11orf54",
            "CCDC99",
            "ORAI2",
            "RELT",
            "TMC4",
            "PNKD",
            "PRKAB1",
            "SH3YL1",
            "PHF19",
            "SUCLG2",
            "MEIS3P1",
            "VAPA",
            "GNA12",
            "ST3GAL2",
            "GLT25D1",
            "PPP2R5B",
            "MAP7D1",
            "SCLT1",
            "EXOC8",
            "PRKAR1A",
            "CALCOCO2",
            "PLEKHM2"
        ]
    },
    {
        "golabel": "TRERF1_regulon_activity",
        "gene": [
            "CXCL9",
            "GBP5",
            "AFAP1L2",
            "IGF2BP2",
            "ARHGAP11B",
            "PRR11",
            "ADAM19",
            "CASC5",
            "KIF15",
            "ESPL1",
            "HSPA4L",
            "POLQ",
            "ABCC6P2",
            "ITPRIPL1",
            "ARHGAP11A",
            "IL2RB",
            "GFI1",
            "C21orf63",
            "FAM83D",
            "GSG2",
            "GCAT",
            "C14orf145",
            "EFNA1",
            "BRCA2",
            "C7orf23",
            "KNTC1",
            "PLCXD2",
            "HMGB2",
            "NCAPD2",
            "C4orf21",
            "TMEM159",
            "C12orf35",
            "TAP2",
            "RBL1",
            "TMEM194A",
            "MPHOSPH9",
            "CCDC88A",
            "LOC729234",
            "LOC389333",
            "TOPBP1",
            "RAB25",
            "ASAP1",
            "CRB3",
            "UQCR10",
            "PRDX5",
            "CYB5R1",
            "ARV1",
            "LYPLAL1",
            "HAUS4",
            "STK10",
            "KIF2A",
            "ROBLD3",
            "ZMAT5",
            "BLVRA",
            "SSR2",
            "CEP110",
            "SLC25A23",
            "PMVK",
            "STAG1",
            "CLN3",
            "CUTA",
            "BBX",
            "UFC1",
            "XRN1",
            "NEDD1",
            "SAPS1",
            "RFX7",
            "PPP1R12A",
            "STK4",
            "CDV3",
            "GGPS1",
            "RNF34",
            "PRDM4",
            "BRPF1",
            "SART3"
        ]
    },
    {
        "golabel": "TRIM22_regulon_activity",
        "gene": [
            "UCHL1",
            "OR56B1",
            "SLC16A14",
            "SCN1A",
            "OPN3",
            "CPE",
            "BASP1",
            "OR52N4",
            "UGDH",
            "FGL2",
            "C14orf64",
            "LAMP3",
            "GCNT4",
            "ROS1",
            "CBX2",
            "MAPK10",
            "APOBEC3H",
            "SYT7",
            "HLA-J",
            "CYSLTR1",
            "ADSSL1",
            "CD40LG",
            "ADRB2",
            "NFIX",
            "TLR2",
            "ST8SIA4",
            "XAF1",
            "HLA-DMB",
            "KIAA0748",
            "SIDT1",
            "ST3GAL6",
            "IFIT3",
            "SLC39A4",
            "HLA-DPA1",
            "TLR3",
            "HLA-DPB1",
            "IL7",
            "CCDC152",
            "LGALS9",
            "CIITA",
            "NELF",
            "CD74",
            "NTN4",
            "HERC6",
            "CASP1",
            "GAB3",
            "EPT1",
            "PYCR1",
            "DBNDD1",
            "DHCR7",
            "N4BP2L1",
            "CD59",
            "TMEM173",
            "TLE4",
            "ARHGEF6",
            "SESN1",
            "ZFP36L1",
            "AKAP7",
            "DDX26B",
            "SLFN12",
            "APOBEC3C",
            "C10orf2",
            "RIPK3",
            "CMTM7",
            "STOM",
            "UBA7",
            "PIK3IP1",
            "BTN3A3",
            "KAT2B",
            "DARS2",
            "BTN2A3",
            "BTN3A1",
            "GTPBP4",
            "CXorf42",
            "GALC",
            "C14orf159",
            "DDB2",
            "TRIM34",
            "CASP10",
            "RILPL2",
            "C19orf66",
            "PARP8",
            "EIF3B",
            "CCT3",
            "RRP12",
            "FAM119A",
            "MAT2B",
            "TRIM21",
            "ALDH18A1",
            "LRPPRC",
            "SETDB2",
            "MOBKL2C",
            "YTHDC2",
            "TRIM5",
            "SP100",
            "CDYL",
            "CTBP2",
            "EIF2AK1",
            "TRIM38",
            "GTF3C2",
            "GORASP2",
            "IRF2"
        ]
    },
    {
        "golabel": "TRIM23_regulon_activity",
        "gene": [
            "GPR35",
            "NRARP",
            "LCA5",
            "IL6ST",
            "ARRDC3",
            "FNIP2",
            "OCLN",
            "MEF2C",
            "C14orf80",
            "SLC25A10",
            "SSBP2",
            "RAPGEF6",
            "SNX18",
            "PICK1",
            "ZNF844",
            "SPRED1",
            "FCHO2",
            "LTBR",
            "RRM2B",
            "TRAF2",
            "MICALL1",
            "CYP2U1",
            "MVD",
            "RGMB",
            "GPRASP2",
            "COL4A3BP",
            "NOP2",
            "PIK3R1",
            "PUS1",
            "C6orf136",
            "GTF2H2C",
            "C5orf41",
            "RHBDD3",
            "LRRC45",
            "ARFGAP1",
            "NFKBIB",
            "ECHDC1",
            "STXBP4",
            "SPAG9",
            "DNAJC18",
            "RASA1",
            "ZNRF1",
            "ARL15",
            "ZDHHC12",
            "CASD1",
            "OXR1",
            "FBXW5",
            "MBLAC2",
            "ARSK",
            "KIAA1826",
            "OSTM1",
            "SFRS12IP1",
            "MBNL1",
            "MARVELD2",
            "SGTB",
            "RAB33B",
            "C5orf44",
            "MAP3K1",
            "PURA",
            "TMEM189",
            "HEXB",
            "PTGES2",
            "PACS1",
            "ZNF598",
            "TXNDC15",
            "SCAMP1",
            "SLC25A46",
            "RANGAP1",
            "ADRM1",
            "DCP2",
            "REEP4",
            "FBXO38",
            "FEM1C",
            "TAF1B",
            "ZNF295",
            "POLK",
            "IPO11",
            "MMGT1",
            "AKT1S1",
            "C15orf39",
            "LYRM7",
            "FAM172A",
            "APC",
            "FBXW11",
            "FBXL17",
            "NKIRAS1",
            "POC5",
            "KIAA1430",
            "PREPL",
            "FBXL3",
            "LYSMD3",
            "TMEM161B",
            "C9orf86",
            "CDC42SE2",
            "MIER1",
            "MIER3",
            "DMXL1",
            "ZNF791",
            "PJA2",
            "IKZF5",
            "ZNF136",
            "ZFPL1",
            "FNIP1",
            "CEP120",
            "EID1",
            "C5orf24",
            "RSBN1",
            "SMAD5",
            "ZNF654",
            "ZNF384",
            "GABPA",
            "SERINC1",
            "PPIP5K2",
            "SFRS12",
            "ERBB2IP",
            "ZFYVE16",
            "VEZF1",
            "ASB6",
            "RBM17",
            "COPG",
            "LEMD2",
            "RHOT1",
            "PPWD1",
            "SNX2",
            "RIOK2",
            "VPS33B",
            "TOR1AIP1",
            "ZYG11B",
            "TMEM214",
            "THUMPD1",
            "RAD17",
            "PAPD4",
            "APPBP2",
            "AGGF1",
            "DAZAP1",
            "GPBP1",
            "SPOP"
        ]
    },
    {
        "golabel": "TRIM24_regulon_activity",
        "gene": [
            "KLRG2",
            "GJB3",
            "SDCBP2",
            "SVOPL",
            "CD109",
            "CAMK2N1",
            "PLCD3",
            "LOC148709",
            "ABLIM3",
            "ITGB4",
            "SYDE2",
            "LIFR",
            "IL18R1",
            "FHL2",
            "ZNF681",
            "S100A16",
            "CDCP1",
            "MMP14",
            "TNFRSF10D",
            "PRKCDBP",
            "RIN1",
            "OAF",
            "MST1R",
            "CLTB",
            "ETHE1",
            "SQRDL",
            "ARHGEF19",
            "PDLIM7",
            "CHKA",
            "NBL1",
            "ANXA2P2",
            "MLKL",
            "ANXA2",
            "CARD6",
            "HRH1",
            "CEP70",
            "TTC26",
            "PLIN3",
            "PML",
            "ZNF253",
            "MYLIP",
            "SERPINB8",
            "TPM4",
            "CHD6",
            "BRAF",
            "VASP",
            "TICAM1",
            "SLC25A36",
            "PDIK1L",
            "UBN2",
            "TRIP10",
            "OTUD7B",
            "PAXIP1",
            "FOXJ3",
            "IL4R",
            "EPB41",
            "COPG2",
            "TMEM209",
            "ZNF295",
            "GATAD2B",
            "FAM133B",
            "TNIP1",
            "TCEB3",
            "ATG7",
            "MKRN1"
        ]
    },
    {
        "golabel": "TRIM27_regulon_activity",
        "gene": [
            "FCGR2B",
            "NLRP3",
            "GPR183",
            "CYBB",
            "HIST1H2BN",
            "LILRB2",
            "C3AR1",
            "CD14",
            "SIGLEC9",
            "LY75",
            "CD300A",
            "CD28",
            "FCER1G",
            "LAIR1",
            "ATP8B4",
            "HAVCR2",
            "CYTIP",
            "SPI1",
            "PIK3AP1",
            "LRRC25",
            "CD86",
            "FERMT3",
            "CD53",
            "CYTH4",
            "EVI2B",
            "SLA",
            "APBB1IP",
            "LAPTM5",
            "PEX6",
            "LCP2",
            "WAS",
            "OGFRL1",
            "GNB4",
            "ZNF165",
            "C6orf136",
            "PRSS16",
            "ZSCAN16",
            "PIP4K2A",
            "MRPS18B",
            "SGTB",
            "VARS2",
            "TMEM140",
            "EHMT2",
            "SETD6",
            "NFKBIL1",
            "C1orf27",
            "GTF2H4",
            "MAD2L1BP",
            "PGAP2",
            "YIPF3",
            "SSR1",
            "RBM34",
            "VPS52",
            "BAT3",
            "HCG18",
            "WDR46",
            "METTL13",
            "RXRB",
            "PPP1R11",
            "C6orf62",
            "TRIM39"
        ]
    },
    {
        "golabel": "TRIM3_regulon_activity",
        "gene": [
            "USHBP1",
            "LRRC56",
            "RAPGEF3",
            "ADCY4",
            "ACSS1",
            "TRIM78P",
            "IFT140",
            "C11orf61",
            "DUSP8",
            "APBB1",
            "PPFIBP2",
            "GALNTL4",
            "CRTC1",
            "PKD1",
            "SIGIRR",
            "NPM1",
            "EPS8L2",
            "LYAR",
            "PNPLA2",
            "OLA1",
            "CCT4",
            "PSMA5",
            "SMPD1",
            "WDR43",
            "SF3B14",
            "SLC39A13",
            "C2CD2L",
            "PDDC1",
            "GRPEL1",
            "UBE2K",
            "ABCE1",
            "FAM160A2",
            "MADD",
            "DARS",
            "RARS",
            "AP2A2",
            "CAPZA1",
            "PHRF1",
            "MOB2",
            "RFT1",
            "RAD23B",
            "RNH1",
            "HNRNPC",
            "BET1L"
        ]
    },
    {
        "golabel": "TRIM5_regulon_activity",
        "gene": [
            "EDA2R",
            "MYBL2",
            "TRIP13",
            "CENPW",
            "CKS1B",
            "FAM54A",
            "UBE2S",
            "IFRD1",
            "VWA2",
            "DTX4",
            "TRIM78P",
            "MAD2L2",
            "TRIM68",
            "TRIM22",
            "DTYMK",
            "NUDT1",
            "ANKHD1-EIF4EBP3",
            "TRIM34",
            "SRM",
            "HSD17B4",
            "H1FX",
            "CLINT1",
            "TMEM41B",
            "FBXO38",
            "UBE2M",
            "KIAA0430",
            "FXC1",
            "ZBED5",
            "STIM1",
            "AP2A2",
            "UBE2J2",
            "CTR9",
            "BET1L",
            "TBRG1",
            "KIAA2013"
        ]
    },
    {
        "golabel": "TRIP11_regulon_activity",
        "gene": [
            "PFDN5",
            "NDUFA11",
            "COX5B",
            "C12orf62",
            "LSM7",
            "GTF2A1",
            "ENTPD5",
            "COMMD5",
            "ING4",
            "FAM179B",
            "FAM195B",
            "C19orf24",
            "SPTLC2",
            "CIDECP",
            "CISD3",
            "ASH1L",
            "RAB34",
            "RSF1",
            "RCOR1",
            "UROS",
            "DYNC1H1",
            "GOLGA4",
            "ATG2B",
            "SDCCAG1",
            "BTBD7",
            "CDC42BPB",
            "DICER1",
            "ZFYVE26",
            "BOD1L",
            "C17orf49",
            "PAPOLA",
            "NPRL2",
            "ASB13",
            "SOS2",
            "PCNX",
            "KIAA0586",
            "TTLL5",
            "CHD8",
            "SMEK1",
            "LOC647979",
            "YLPM1",
            "KIAA0317",
            "TECPR2",
            "EP300",
            "RANBP2",
            "CPSF2",
            "MPP5",
            "ATXN3",
            "TMED8",
            "MLH3",
            "EIF5",
            "NEK9",
            "CEP350",
            "BAG5",
            "SON",
            "CUEDC2",
            "SYNJ2BP",
            "DDX24",
            "CDK13"
        ]
    },
    {
        "golabel": "TRIP13_regulon_activity",
        "gene": [
            "SLC6A15",
            "SLC26A9",
            "SFTPB",
            "ZYG11A",
            "RPL39L",
            "ABO",
            "CCNB2",
            "C9orf152",
            "SLC22A3",
            "MYBL2",
            "CENPA",
            "MAD2L1",
            "MCM10",
            "SKA1",
            "DEPDC1",
            "KCNQ1",
            "TTK",
            "C1orf135",
            "PFN2",
            "TPX2",
            "RHEBL1",
            "KIF23",
            "KIF2C",
            "CDC6",
            "BIRC5",
            "CDC20",
            "HJURP",
            "RAD54L",
            "CCNA2",
            "MELK",
            "NCAPH",
            "BUB1",
            "CDCA5",
            "CDCA8",
            "C5orf34",
            "SRD5A1",
            "CEP55",
            "MALL",
            "SMAD6",
            "SEMA4A",
            "LARGE",
            "ACOX2",
            "CEP72",
            "MAST4",
            "MRPL36",
            "MOSC2",
            "CYFIP2",
            "KPNA2",
            "PCDH1",
            "MAD2L2",
            "ATP1A1",
            "SUGT1L1",
            "NDUFS6",
            "PDCD6",
            "BRIX1",
            "CCT5",
            "MED10",
            "CCDC123",
            "TARS",
            "DCUN1D5",
            "DUSP14",
            "NSUN2",
            "BRD9",
            "LYAR",
            "MRPS30",
            "ZNF131",
            "C5orf22",
            "CCDC86",
            "TBRG4",
            "HEATR2",
            "HSD17B4",
            "DPH2",
            "ATP9B",
            "SIGMAR1",
            "FGFR1OP",
            "YKT6",
            "KIAA0430",
            "KIAA0141",
            "JMJD6",
            "ALAD",
            "FARSB",
            "TRIM5"
        ]
    },
    {
        "golabel": "TRIP6_regulon_activity",
        "gene": [
            "C14orf37",
            "PDE3B",
            "C8orf73",
            "C1orf170",
            "PGBD1",
            "AKT3",
            "PLEKHN1",
            "RIN1",
            "FZD3",
            "ADORA2B",
            "N4BP2",
            "IL27RA",
            "MDFIC",
            "PRKAR1B",
            "HSPB1",
            "EPHA1",
            "LCOR",
            "IMMP2L",
            "EPHB4",
            "NME3",
            "FIS1",
            "AP1S1",
            "ELMO3",
            "CLDN4",
            "FAM86D",
            "ASL",
            "TDG",
            "ADAM15",
            "ATE1",
            "SLC2A4RG",
            "MED13L",
            "LCORL",
            "PLEKHA1",
            "PGLS",
            "HSP90B1",
            "LOC221710",
            "TRMT1",
            "CDK5",
            "NCOA1",
            "LMNA",
            "APPL2",
            "SSH3",
            "TRIM4",
            "FAM129B",
            "TSC22D4",
            "STX10",
            "ZNF81",
            "MRPL4",
            "RMND5A",
            "DNAJC30",
            "SNAPC2",
            "FAM185A",
            "IFRD2",
            "USP37",
            "SMAP1",
            "ARID2",
            "VPS54",
            "DDX3X",
            "PPM1B",
            "ZRANB1",
            "PPP2R4",
            "EIF4H"
        ]
    },
    {
        "golabel": "TRMT1_regulon_activity",
        "gene": [
            "C3orf45",
            "DAND5",
            "HAGHL",
            "SORL1",
            "PRR22",
            "C7orf40",
            "RPL36",
            "CXADR",
            "MYL5",
            "PLS1",
            "PTPLB",
            "LOC729991-MEF2B",
            "TRIP6",
            "NEURL2",
            "CCBL1",
            "MXD3",
            "KAT2A",
            "PHACTR2",
            "C9orf142",
            "TRMT2A",
            "MAN1A2",
            "KIAA0415",
            "KIAA1919",
            "DUS3L",
            "GTPBP3",
            "FDX1L",
            "PPAN",
            "QTRT1",
            "CCDC130",
            "POLD1",
            "TMEM30A",
            "MFSD6",
            "NCOA1",
            "SORT1",
            "NAT6",
            "WDR85",
            "STX10",
            "PLEKHJ1",
            "PNKP",
            "SIRT1",
            "C19orf6",
            "STT3B",
            "MIIP",
            "MRI1",
            "SEC62",
            "C15orf38",
            "KLF3",
            "NDUFS7",
            "SIRT6",
            "AKAP8L",
            "UEVLD",
            "HMG20B",
            "CC2D1A",
            "INO80E",
            "IRF3",
            "ITFG1",
            "TM9SF3",
            "GCDH",
            "SCARB2",
            "DCAF15",
            "TSPYL1",
            "CASC4",
            "RABGGTA",
            "CDC37",
            "FEM1B",
            "SPOPL",
            "BMPR1A",
            "CWF19L2",
            "TAB2",
            "ICMT",
            "RAD23A",
            "SPTY2D1",
            "XAB2",
            "C6orf89",
            "AFTPH",
            "ATRIP",
            "PSEN1",
            "ASB8",
            "CUL3"
        ]
    },
    {
        "golabel": "TRPS1_regulon_activity",
        "gene": [
            "ADAMTS12",
            "MXRA5",
            "SULF1",
            "COL1A2",
            "PRRX1",
            "SFTA2",
            "FRMD6",
            "SELENBP1",
            "SULT1A2",
            "SULF2",
            "TNFSF4",
            "WISP1",
            "MMP2",
            "COL6A3",
            "ARL10",
            "TCF4",
            "TSTD1",
            "TMEM125",
            "SPSB2",
            "LSMD1",
            "GSTP1",
            "C1orf210",
            "SH3PXD2B",
            "GNB4",
            "RAB17",
            "ACADS",
            "PNKD",
            "ASAP1",
            "CRB3",
            "UQCR10",
            "ATP11C",
            "CHCHD5",
            "PRDX5",
            "AFAP1",
            "CLIC4",
            "MARCKS",
            "BCAT2",
            "KIF2A",
            "PCBD1",
            "PMF1",
            "TMEM134",
            "MED11",
            "TRAPPC1",
            "BBX",
            "HECA",
            "XRN1",
            "G3BP1",
            "PPP1R12A",
            "CORO1B"
        ]
    },
    {
        "golabel": "TRRAP_regulon_activity",
        "gene": [
            "LMTK2",
            "PCLO",
            "ETV2",
            "PFDN5",
            "TMBIM4",
            "MRPL54",
            "HIPK2",
            "ZKSCAN1",
            "PPP1R9A",
            "ZC3HAV1L",
            "FAM115A",
            "EPHB4",
            "CHKB",
            "DPH3B",
            "ZNF512B",
            "GIGYF1",
            "ZNF32",
            "ALG5",
            "NCAPD3",
            "TBC1D16",
            "ORAI2",
            "SLC25A13",
            "TRIM56",
            "PEX1",
            "ATP5O",
            "TECPR1",
            "KLHDC10",
            "MYL12B",
            "PTCD1",
            "CD63",
            "MICA",
            "ATP6V0E1",
            "PHLPP2",
            "PPIL3",
            "SMURF1",
            "POLR1A",
            "DNAJC2",
            "RPL36AL",
            "AKAP9",
            "TMEM179B",
            "C15orf57",
            "MED18",
            "TMEM111",
            "RSF1",
            "ZCCHC10",
            "C15orf24",
            "ADH5",
            "MYL12A",
            "UBN2",
            "PAXIP1",
            "MLL3",
            "SAP18",
            "UBE2H",
            "TMED1",
            "EDEM2",
            "TNPO3",
            "EP400",
            "MLL",
            "C19orf42",
            "PHF11",
            "ACTR10",
            "UBE2O",
            "BAZ1B",
            "CASP2",
            "PFDN1",
            "MLL5",
            "ZNF498",
            "GCC1",
            "HCFC1",
            "ATP6V1E1",
            "MKLN1",
            "ILK"
        ]
    },
    {
        "golabel": "TSC2_regulon_activity",
        "gene": [
            "CXCL10",
            "RSL24D1",
            "PLBD1",
            "BAIAP3",
            "MAD2L1",
            "C12orf48",
            "NME2P1",
            "ABCC6",
            "KIAA0101",
            "EPSTI1",
            "SNX10",
            "TMEM38B",
            "MAPK8IP3",
            "RAB32",
            "CCDC64B",
            "SMAGP",
            "NUDT2",
            "TBC1D24",
            "IMPA1",
            "MMP15",
            "WDR90",
            "IFT140",
            "C13orf37",
            "SELT",
            "BAHCC1",
            "CNIH",
            "TMEM19",
            "COMMD8",
            "ITGAE",
            "C9orf40",
            "SLC9A3R2",
            "NDUFB5",
            "ATP1B3",
            "PLSCR1",
            "RAN",
            "DCK",
            "ZNF512B",
            "ANKS3",
            "RAB40C",
            "MGRN1",
            "CRTC1",
            "C10orf78",
            "CDK18",
            "LTBP3",
            "GNG10",
            "PDCD10",
            "PKD1",
            "CCDC59",
            "NUP37",
            "TMEM63A",
            "KIAA0182",
            "C12orf29",
            "TXNDC9",
            "DGKQ",
            "MARCKS",
            "B3GNT2",
            "RRBP1",
            "ESRP2",
            "INPPL1",
            "SH2B1",
            "FAM96A",
            "RAB11FIP3",
            "RAI1",
            "OLA1",
            "RHBDF1",
            "TNRC18",
            "C9orf21",
            "LYSMD2",
            "ARHGEF17",
            "TIFA",
            "NMD3",
            "ZNF410",
            "GYG1",
            "CCT4",
            "SRRM2",
            "PIGQ",
            "SNX3",
            "RHOT2",
            "HMGB1",
            "BTBD12",
            "TELO2",
            "HMGN4",
            "SLC35D2",
            "METTL10",
            "KIAA0556",
            "ISCA1P1",
            "CORO7",
            "UBE2N",
            "TBCD",
            "CRAMP1L",
            "TMEM8A",
            "MRPS22",
            "CLCN7",
            "RWDD1",
            "CLEC16A",
            "ZNF35",
            "RNASEH2B",
            "BLOC1S2",
            "DUSP11",
            "UBE2D1",
            "MMADHC",
            "TAOK2",
            "NUP54",
            "ABCC10",
            "NUMA1",
            "ZNF213",
            "ATG2A",
            "ACTR3",
            "AXIN1",
            "SUMO2",
            "TBC1D9B",
            "COG7",
            "POLR3E",
            "BUB3",
            "PPP1CC",
            "EDC4",
            "ZNF500",
            "GTF3C1",
            "RFX1",
            "HAUS2",
            "PWP1",
            "CNBP",
            "ARPC2",
            "METTL6",
            "DNAJC24",
            "NRBF2",
            "DYNC1LI1"
        ]
    },
    {
        "golabel": "TSC22D1_regulon_activity",
        "gene": [
            "GKN2",
            "SERP2",
            "C8orf4",
            "DUSP1",
            "ESPL1",
            "POLQ",
            "KIF18B",
            "E2F2",
            "ASPM",
            "IQGAP3",
            "SPAG5",
            "CSRNP1",
            "EME1",
            "SGK1",
            "BRCA1",
            "ATAD5",
            "TPT1",
            "KNTC1",
            "MYO7A",
            "RPL10A",
            "CCNF",
            "KLF9",
            "DBF4B",
            "POLE",
            "UBL3",
            "DNMT1",
            "MYO19",
            "POLR1D",
            "AUH",
            "MBNL2",
            "HBP1",
            "YPEL5",
            "EFHA1",
            "SMG5",
            "PPP2CB",
            "PNRC1",
            "MEN1",
            "MED4"
        ]
    },
    {
        "golabel": "TSC22D4_regulon_activity",
        "gene": [
            "C7orf61",
            "FBXO24",
            "POLR2J2",
            "INSL3",
            "C1orf170",
            "CARD11",
            "RIN1",
            "FCHO1",
            "BAIAP2L1",
            "P2RY11",
            "ARPC1B",
            "C7orf47",
            "HSPB1",
            "AGFG2",
            "ZNHIT1",
            "EPHA1",
            "TRIP6",
            "BRI3",
            "IRF5",
            "DTX2",
            "EPHB4",
            "IMPDH1",
            "GIGYF1",
            "LIMK1",
            "ORAI2",
            "ZNF837",
            "TSPO",
            "HMHA1",
            "RPUSD1",
            "SLC2A4RG",
            "TECPR1",
            "C9orf16",
            "PTPLAD1",
            "STXBP4",
            "POR",
            "TMUB1",
            "SLC12A9",
            "PLOD3",
            "LOC221710",
            "FASTK",
            "TPCN1",
            "DEF6",
            "GIPC1",
            "MIB1",
            "LRCH4",
            "C7orf43",
            "TAF6",
            "ARRDC1",
            "TSNAX",
            "MEPCE",
            "RAB43",
            "MOSPD3",
            "RBBP9",
            "SOLH",
            "RGS19",
            "OGFR",
            "SSH3",
            "RPS6KA4",
            "ACD",
            "CRAT",
            "CUX1",
            "SIRT1",
            "GNB2",
            "MKNK2",
            "SIPA1",
            "C16orf87",
            "HECTD2",
            "REEP4",
            "DGKZ",
            "AGAP3",
            "ALKBH4",
            "FAM108A1",
            "SPAST",
            "PKN1",
            "EXOC5",
            "TNIP2",
            "REXO1",
            "PPP1CB",
            "ADRBK1",
            "CSK",
            "BTBD2",
            "C5orf24",
            "STXBP2",
            "FEM1B",
            "CSNK1G2",
            "C19orf29",
            "MAP3K11",
            "ZNF394",
            "C1orf124",
            "COBRA1",
            "UBXN6",
            "TROVE2",
            "MATR3"
        ]
    },
    {
        "golabel": "TULP4_regulon_activity",
        "gene": [
            "NR6A1",
            "RSL24D1",
            "RPS3A",
            "RPS10",
            "RPS5",
            "HIST1H2AC",
            "EEF1B2",
            "FOXRED2",
            "CNKSR3",
            "RPS14",
            "GSTO1",
            "RPSA",
            "RPSAP58",
            "PFDN5",
            "LOC729603",
            "RPSAP9",
            "UQCRQ",
            "RPL24",
            "RPL26",
            "SNHG8",
            "RPL29",
            "RPS9",
            "RPL10A",
            "RPL13",
            "ACY1",
            "RPL41",
            "RPL32",
            "IGSF3",
            "NIPBL",
            "RPL14",
            "CMC1",
            "PLEKHG1",
            "RPS23",
            "C19orf10",
            "LRP11",
            "USP31",
            "RPL15",
            "DTWD1",
            "MYO6",
            "PPIL3",
            "DOPEY2",
            "CLIC1",
            "TMEM111",
            "MLLT4",
            "GRLF1",
            "COX18",
            "KLF11",
            "NDUFC1",
            "CCDC51",
            "ZNF292",
            "SERPINB6",
            "MLL3",
            "RERE",
            "SSH2",
            "INTS10",
            "MLL",
            "CDK19",
            "TNRC6B",
            "FARS2",
            "EIF2C1",
            "MTF1",
            "UBA3",
            "SPCS1",
            "CHD8",
            "DALRD3",
            "AAK1",
            "C3orf75",
            "MTOR",
            "ARID1B",
            "RFT1",
            "APEH"
        ]
    },
    {
        "golabel": "U2AF1_regulon_activity",
        "gene": [
            "C21orf58",
            "KHDC1",
            "RASEF",
            "IL6ST",
            "HHLA3",
            "HAUS5",
            "C21orf119",
            "SLC41A2",
            "C21orf57",
            "MAN2A1",
            "SERINC5",
            "C21orf56",
            "C21orf122",
            "NIPAL2",
            "NASP",
            "ZNF165",
            "DONSON",
            "PFDN6",
            "RBM42",
            "FAM50A",
            "LSS",
            "HIPK3",
            "MUTYH",
            "WDR4",
            "MAGOH",
            "PDXK",
            "C21orf70",
            "KIF22",
            "HAUS8",
            "MTG1",
            "AURKAIP1",
            "TUBB2C",
            "HSPB11",
            "RCC2",
            "C10orf118",
            "SLC37A1",
            "GLUD2",
            "FOXRED1",
            "ZXDA",
            "LRP10",
            "TMEM69",
            "TBC1D9",
            "MTF2",
            "GCFC1",
            "SEC24D",
            "STT3B",
            "MIIP",
            "PABPN1",
            "GTF3C5",
            "HMGN1",
            "RRP1",
            "SNRPD3",
            "LOC148413",
            "RRP1B",
            "SEC24A",
            "C21orf59",
            "NUDC",
            "ATF2",
            "NCOA4",
            "PWP2",
            "UBE2G2",
            "GNL2",
            "PFKL",
            "SRRT",
            "CSNK2B",
            "C21orf33",
            "NDUFV3",
            "SNRPA",
            "EXOSC9",
            "CPSF3L",
            "UTP11L",
            "PRPF38A",
            "MCM3AP",
            "PSMC5",
            "SFRS15",
            "PRMT2",
            "SF3A3",
            "EWSR1",
            "NAP1L4"
        ]
    },
    {
        "golabel": "U2AF1L4_regulon_activity",
        "gene": [
            "DUSP15",
            "LOC643719",
            "CXorf65",
            "LOC26102",
            "WDR62",
            "C20orf106",
            "SGK196",
            "PLEKHF1",
            "THAP7",
            "PSENEN",
            "ST20",
            "HSP90AB2P",
            "NFKBID",
            "LIN7B",
            "POLR2I",
            "HAUS5",
            "EID2B",
            "RINL",
            "ALKBH6",
            "LIN37",
            "CENPT",
            "SDHAF1",
            "WASH7P",
            "ZNF529",
            "MXD3",
            "TMEM149",
            "CCDC123",
            "HSH2D",
            "RBM42",
            "USF2",
            "CCDC130",
            "IDE",
            "HSPBAP1",
            "MLL4",
            "WDR85",
            "SETD7",
            "MIIP",
            "SMARCC1",
            "LDOC1L",
            "IRF3",
            "TM9SF3",
            "LRRFIP1",
            "EIF3A",
            "LONP2",
            "USF1",
            "ACBD3",
            "MSH3",
            "TEX2",
            "AASDHPPT",
            "TMUB2",
            "SLAIN2",
            "SEC31A",
            "HNRNPH2",
            "OSBP"
        ]
    },
    {
        "golabel": "UBE2K_regulon_activity",
        "gene": [
            "UGDH",
            "LOC115110",
            "RASGRP2",
            "CCDC157",
            "NCAPG",
            "ADCY4",
            "CCDC88B",
            "PLCB2",
            "MRPS35",
            "TNFRSF14",
            "PLEKHM1P",
            "CBX7",
            "COMMD8",
            "LYL1",
            "PPAT",
            "SLMO2",
            "SLC27A1",
            "CCT5",
            "MED28",
            "TUBGCP6",
            "HSPD1",
            "C4orf52",
            "PAICS",
            "PIK3IP1",
            "LIAS",
            "TWF1",
            "EVL",
            "PTK2B",
            "SFI1",
            "MRPL42",
            "FIP1L1",
            "RG9MTD2",
            "LYAR",
            "TRIM3",
            "ARHGEF1",
            "UBE2V2",
            "HDAC10",
            "NFXL1",
            "PTGES3",
            "CHMP5",
            "EIF5B",
            "SRP9",
            "MAST3",
            "YWHAZ",
            "CORO7",
            "PACRGL",
            "SLBP",
            "FAM103A1",
            "GRPEL1",
            "TMEM33",
            "SRP72",
            "GNPDA2",
            "EIF4E",
            "ZC3H15",
            "LARP4",
            "RBM47",
            "ZCCHC4",
            "GUF1",
            "TYK2",
            "ROD1",
            "ENOPH1",
            "RAB18",
            "CHUK",
            "OCIAD1",
            "RFC1",
            "POLR2B",
            "PDS5A",
            "SLC30A9",
            "RAD23B",
            "GRSF1",
            "KIAA0892",
            "ARPP19",
            "DHX15",
            "RWDD4A",
            "AIMP1",
            "MRFAP1",
            "RNF4",
            "FAM175B"
        ]
    },
    {
        "golabel": "UBN1_regulon_activity",
        "gene": [
            "GAS5",
            "RPLP1",
            "SNHG6",
            "RPS6",
            "RPS16",
            "RPSA",
            "RPSAP58",
            "LOC440957",
            "FKBP11",
            "PFDN5",
            "RPL31",
            "RPL36",
            "RPS19",
            "RPS8",
            "RPL27A",
            "RPL29",
            "SSR4",
            "PPL",
            "LRRC70",
            "RPL12",
            "RPS15",
            "RPL32",
            "RPL7A",
            "RPL18",
            "CHKB",
            "RPS24",
            "MAP3K9",
            "RPL37A",
            "RPL14",
            "NDUFA3",
            "ATP9A",
            "NOMO2",
            "SELK",
            "RPS20",
            "ARHGAP32",
            "NDE1",
            "SAT2",
            "C10orf84",
            "IGF2R",
            "PTPRF",
            "BTBD12",
            "CRAMP1L",
            "HN1L",
            "ITPRIPL2",
            "LITAF",
            "C17orf49",
            "ERCC4",
            "PDPK1",
            "GABARAP",
            "CREBBP",
            "PPP3CC",
            "BAZ1B",
            "TRAF7",
            "R3HCC1",
            "GTF3C1",
            "C16orf72",
            "GLYR1",
            "ZDHHC5"
        ]
    },
    {
        "golabel": "UBR4_regulon_activity",
        "gene": [
            "RPS18",
            "RPL27",
            "RPL39",
            "RPS3A",
            "ATP5EP2",
            "RPS5",
            "RPS15A",
            "LAMA5",
            "EEF1B2",
            "RPS3",
            "RPS6",
            "RPS14",
            "RPS29",
            "RPSA",
            "RPSAP58",
            "PFDN5",
            "MED31",
            "PLEC",
            "RPL24",
            "FUNDC2",
            "MICAL3",
            "SYNM",
            "MRPL54",
            "RPS11",
            "RPL27A",
            "RPL29",
            "SSR4",
            "C9orf123",
            "NDUFA2",
            "RPS9",
            "PEX2",
            "RPL10A",
            "RPL41",
            "C9orf3",
            "RPL32",
            "RPL38",
            "RPL7A",
            "COMMD10",
            "TMEM126B",
            "CCDC72",
            "RPS13",
            "UBL5",
            "NDUFAF2",
            "LOC442454",
            "RNF213",
            "LOC642852",
            "RPL10",
            "ZNF32",
            "DYNLT1",
            "UQCR11",
            "RPL14",
            "CBY1",
            "CNIH4",
            "GNG10",
            "DLG5",
            "SELK",
            "TCEAL1",
            "RPS23",
            "FAU",
            "FAM38A",
            "DBI",
            "C14orf119",
            "RPL15",
            "MYO18A",
            "ISCA2",
            "HAUS4",
            "RPS4X",
            "COMMD6",
            "PCNT",
            "SS18L2",
            "ASNA1",
            "DBNDD2",
            "DCTN3",
            "RPL36AL",
            "RPS25",
            "MLL2",
            "KIAA0556",
            "HERC2",
            "CEP164",
            "KIF1B",
            "DYNC1H1",
            "COX16",
            "HUWE1",
            "LOC285033",
            "ZSCAN20",
            "UBE4B",
            "HTT",
            "C19orf42",
            "CLTA",
            "MED12",
            "SPEN",
            "GABARAP",
            "EIF4G3",
            "PTPMT1",
            "FAM168B",
            "EDC4",
            "NDUFA5",
            "BIRC6",
            "MTOR",
            "DHX38",
            "HEATR5B",
            "EIF1",
            "HCFC1",
            "TRAPPC10",
            "ZNF592",
            "CLASP1",
            "USP34",
            "MCM3AP",
            "RBM15",
            "GBF1"
        ]
    },
    {
        "golabel": "UBTF_regulon_activity",
        "gene": [
            "FAM171A2",
            "HOXB4",
            "FAM89A",
            "SMPDL3A",
            "ZBTB12",
            "AZI1",
            "ZNF775",
            "C14orf102",
            "ZNF696",
            "NIPSNAP3A",
            "FBXL19",
            "IFIT5",
            "CEP250",
            "HEXIM1",
            "SLC31A1",
            "BCL7A",
            "PATZ1",
            "FBXL5",
            "C6orf211",
            "TAF15",
            "KIAA0195",
            "ACIN1",
            "MTMR4",
            "UBE2O",
            "SART1",
            "GLUD1",
            "FTSJ3",
            "SMARCC2",
            "ARF4",
            "SETD1A",
            "SRRT",
            "HTATSF1",
            "ISCA1",
            "ADPGK",
            "COQ10B",
            "UNK",
            "PPP1R9B",
            "ATXN7L3",
            "HCFC1",
            "ZDHHC6",
            "PHF12",
            "ERP44",
            "STX12",
            "NCOA5",
            "ZC3H4",
            "RBM15B",
            "EWSR1",
            "SAR1A"
        ]
    },
    {
        "golabel": "UPF1_regulon_activity",
        "gene": [
            "SRGN",
            "FCGR2B",
            "BCL2A1",
            "SNX10",
            "GSTO1",
            "GLA",
            "TMEM55A",
            "CRTC1",
            "KIAA0284",
            "AIG1",
            "PPT1",
            "CASKIN2",
            "C9orf21",
            "TMEM126A",
            "C16orf63",
            "BCAP29",
            "SNX3",
            "SGTB",
            "PRCP",
            "RARS2",
            "CISD1",
            "KLHL26",
            "RWDD1",
            "CISD2",
            "PRR12",
            "RAP2C",
            "SLC44A2",
            "SNX11",
            "CRLF3",
            "RNF44",
            "ATG12",
            "USP15",
            "ATP13A1",
            "BRD1",
            "DCTN1",
            "WIZ",
            "CHERP",
            "MED26",
            "ACOT9",
            "NUS1",
            "RFX1",
            "KIAA0892"
        ]
    },
    {
        "golabel": "USF1_regulon_activity",
        "gene": [
            "KIAA0754",
            "DPM3",
            "AKT3",
            "LOC441208",
            "EFNA1",
            "NR1I3",
            "NOTCH2NL",
            "MYL5",
            "ZNF692",
            "VAMP8",
            "GUK1",
            "TAOK1",
            "BOLA1",
            "IGSF8",
            "LOC645676",
            "NENF",
            "KRTCAP2",
            "EFNA4",
            "FAM168A",
            "MRPS21",
            "COMMD3",
            "U2AF1L4",
            "FAM63B",
            "ARL16",
            "SCO2",
            "SCNM1",
            "MRPL55",
            "ROCK2",
            "ASXL2",
            "RAB24",
            "MICA",
            "TRIM44",
            "GABPB2",
            "TOMM40L",
            "C10orf12",
            "ROBLD3",
            "THAP3",
            "ERC1",
            "PSMB4",
            "PPOX",
            "PMF1",
            "JTB",
            "TAGLN2",
            "GORAB",
            "PHKG2",
            "MAPK1",
            "C1orf35",
            "STX10",
            "METT11D1",
            "MITD1",
            "MIIP",
            "TBCC",
            "KLF3",
            "HUWE1",
            "C1orf156",
            "NPRL2",
            "GNA11",
            "NARFL",
            "TOR3A",
            "BMPR2",
            "ARPC5L",
            "NIT1",
            "DCAF8",
            "TRIM38",
            "DEDD"
        ]
    },
    {
        "golabel": "VAX2_regulon_activity",
        "gene": [
            "KLK12",
            "SLC38A8",
            "KLK13",
            "ZMAT4",
            "LOC100190940",
            "CTNND2",
            "GSC",
            "RET",
            "FOXI3",
            "BARX1",
            "LOC145837",
            "PITX2",
            "C1orf95",
            "ATP6V1B1",
            "HOXB13",
            "C20orf197",
            "KLK11",
            "SYCP2L",
            "RNF183",
            "THPO",
            "C19orf45",
            "DNAJC12",
            "HOXC9",
            "HOXC6",
            "CASKIN1",
            "B4GALNT4",
            "FAM84A",
            "GPT2",
            "LOC100133985",
            "ANKRD53",
            "KCNJ11",
            "GADD45G",
            "PITPNC1",
            "ATP10A",
            "PTAFR",
            "P2RX7",
            "ITGAM",
            "KSR1",
            "TNFSF13B",
            "CYBB",
            "PTP4A3",
            "GPR3",
            "SBK1",
            "AIM1",
            "HLA-DRA",
            "AHNAK",
            "FGD1",
            "HLA-DPA1",
            "CADM4",
            "FZD3",
            "GRAMD4",
            "FAS",
            "LIPA",
            "ANKRD44",
            "RBM38",
            "PLEKHG5",
            "CDK2AP2",
            "MDFIC",
            "MAML2",
            "PAFAH1B3",
            "HS6ST1",
            "SARS2",
            "KLHL25",
            "RANGRF",
            "NUDT14",
            "MRPS26",
            "ZNF428",
            "DNMT3A",
            "CFLAR",
            "PTMS",
            "AACS",
            "SOX4",
            "SNRPF",
            "ARAP2",
            "BTN3A3",
            "KAT2B",
            "CD47",
            "SMUG1",
            "RHBDD3",
            "MANF",
            "CCNJ",
            "HRAS",
            "PIP4K2A",
            "ATG4D",
            "IRF2BP1",
            "ANKRD39",
            "ZBED1",
            "PTDSS2",
            "MBNL1",
            "NAPEPLD",
            "ZNF195",
            "ARHGEF3",
            "MLF2",
            "LACTB",
            "USP25",
            "TAX1BP1",
            "PDCL3",
            "CAST",
            "MFSD1",
            "DPP3",
            "GLRX5",
            "RAP1A",
            "MYD88",
            "MCRS1",
            "AAAS",
            "DIAPH1",
            "CEPT1",
            "FKBP15",
            "ZNF438",
            "MORC3",
            "VAMP3",
            "STX12",
            "TMEM167B",
            "PDCD6IP"
        ]
    },
    {
        "golabel": "VDR_regulon_activity",
        "gene": [
            "ADORA1",
            "C5orf4",
            "MYO1G",
            "TNC",
            "COL1A1",
            "SRPX2",
            "ITGA2",
            "COL5A1",
            "ARSI",
            "PFN2",
            "ISLR",
            "MMP2",
            "COL6A3",
            "CDH11",
            "TIMP3",
            "AURKAPS1",
            "EDNRA",
            "ICAM1",
            "FILIP1L",
            "C10orf72",
            "BGN",
            "UNC5B",
            "MRC2",
            "PLXDC2",
            "IDI1",
            "GKAP1",
            "IDS",
            "PAM",
            "ACAT2",
            "P4HA2",
            "FECH",
            "COQ3",
            "MRPS26",
            "ZFP36L1",
            "LIMK1",
            "C2orf15",
            "CCM2",
            "EEF1E1",
            "NFIC",
            "C12orf73",
            "RASSF5",
            "SPSB1",
            "UBE2CBP",
            "DCUN1D3",
            "BAG3",
            "MSN",
            "SFXN3",
            "MYH9",
            "ST5",
            "PDE4A",
            "AGBL5",
            "SUCLG1",
            "SETD7",
            "RUNX1",
            "RGS3",
            "TAF11",
            "NSMCE4A",
            "RAB11FIP5",
            "C2orf43",
            "ACVR1",
            "GNAI2",
            "GLRX5",
            "PTCD3",
            "MRPL35",
            "TBP",
            "SLC35E1",
            "MAPKAPK2",
            "KCTD10"
        ]
    },
    {
        "golabel": "VEZF1_regulon_activity",
        "gene": [
            "C6orf176",
            "LCN12",
            "ALOX12P2",
            "MAFK",
            "AVPI1",
            "GLYCTK",
            "ARSJ",
            "ANKRD56",
            "GABARAPL1",
            "FKBP11",
            "SLC26A6",
            "TRIM2",
            "ATAD3B",
            "NET1",
            "SULT1A3",
            "RAB19",
            "FKBP2",
            "ZNF699",
            "HDX",
            "SMURF2",
            "CASP9",
            "TXNRD2",
            "NOTCH2",
            "LASS6",
            "TTC26",
            "MAP9",
            "ACADVL",
            "PRR5",
            "CTNNB1",
            "MGC57346",
            "CUEDC1",
            "CCDC75",
            "CCNG2",
            "PUS1",
            "KLHDC4",
            "C6orf136",
            "SEMA4F",
            "NFKB2",
            "SP4",
            "SH3RF1",
            "SKA2",
            "WASH3P",
            "CASD1",
            "OXR1",
            "ESRRA",
            "KIAA0664",
            "KLF10",
            "TAF9B",
            "MED13",
            "KIAA1715",
            "CANT1",
            "KLF11",
            "TRABD",
            "SETD6",
            "DHX40",
            "TRIM23",
            "CLK3",
            "ARL13B",
            "NPEPPS",
            "DYNLL2",
            "LMBR1",
            "KIAA1430",
            "TCF25",
            "WDR47",
            "MIER1",
            "ACVR1",
            "RABGGTA",
            "GNA13",
            "VEZT",
            "AAAS",
            "LRRC37B2",
            "DUS2L",
            "H3F3B",
            "PRPSAP1",
            "C17orf71",
            "APPBP2",
            "EIF4G2",
            "ANKRD40",
            "SPOP",
            "CREB1"
        ]
    },
    {
        "golabel": "WDHD1_regulon_activity",
        "gene": [
            "DLX2",
            "TMEFF1",
            "GPR137C",
            "CLSPN",
            "LDHD",
            "POLE2",
            "KCNQ1",
            "KIF15",
            "GLOD5",
            "DLGAP5",
            "TPX2",
            "CLTCL1",
            "ABCC6P2",
            "DSC2",
            "CKAP2L",
            "BRIP1",
            "TOP2A",
            "KIF4A",
            "SULT1A1",
            "CLDN23",
            "GPRC5C",
            "PYGL",
            "SGOL2",
            "ZNF93",
            "NEIL1",
            "C18orf54",
            "NCAPG2",
            "C14orf33",
            "ALDH2",
            "CCDC15",
            "C11orf52",
            "SPIN4",
            "BARD1",
            "TDP1",
            "FANCM",
            "ALG10",
            "ZNF286A",
            "SEC23A",
            "FIGNL1",
            "MID1IP1",
            "SMC2",
            "GPSM2",
            "RILP",
            "C17orf91",
            "ACYP2",
            "MSRA",
            "C14orf106",
            "L2HGDH",
            "KDELC2",
            "PRRG2",
            "TCTA",
            "ZNF92",
            "DDRGK1",
            "TTC38",
            "HEMK1",
            "ABHD14B",
            "SLC25A20",
            "RRM1",
            "SUPT16H",
            "ACAA1",
            "HAGH",
            "MTHFD1",
            "DEK",
            "TTPAL",
            "ZNF544",
            "SMC6",
            "MLYCD",
            "PPP2R5E",
            "EIF2S1",
            "EXOC5",
            "CYB561D2",
            "CSRP1",
            "SOCS4",
            "INPP5K",
            "SAE1",
            "DHX57",
            "FAM82A2",
            "C9orf156",
            "GPR108",
            "ISCU",
            "SPRYD3",
            "XPO1",
            "KHDRBS1"
        ]
    },
    {
        "golabel": "WHSC1_regulon_activity",
        "gene": [
            "IGJ",
            "RNF157",
            "PLAC9",
            "FAM162B",
            "ESPL1",
            "KIF18B",
            "NDRG2",
            "RAMP3",
            "DCN",
            "HSPB2",
            "ITM2A",
            "COX7A1",
            "C17orf44",
            "ECSCR",
            "TACC3",
            "MRPL54",
            "IGFBP7",
            "CYYR1",
            "EEF1A1",
            "ZNF718",
            "CCDC85C",
            "EEF1A1P9",
            "POLE",
            "CEP250",
            "PCGF3",
            "SMG5",
            "CRTAP",
            "HTT",
            "LETM1",
            "WHSC2",
            "RFC1",
            "EID1",
            "HAUS3",
            "ATXN2L",
            "CTBP1",
            "FAM193A",
            "HNRNPD",
            "RNF4",
            "HNRNPA2B1",
            "CPSF7",
            "TARDBP"
        ]
    },
    {
        "golabel": "WIZ_regulon_activity",
        "gene": [
            "ANKRD13B",
            "SEP15",
            "FAM151B",
            "ZSWIM4",
            "CD46",
            "PEX3",
            "SMARCA4",
            "TMEM18",
            "RARS2",
            "C5orf44",
            "TCF3",
            "GTF2B",
            "SPPL2A",
            "SIN3B",
            "MLLT1",
            "DLGAP4",
            "ZFAND6",
            "C1GALT1C1",
            "UPF1",
            "C6orf211",
            "C15orf40",
            "LYRM2",
            "RAVER1",
            "REXO1",
            "ATP13A1",
            "SNX14",
            "BRD4",
            "CHERP",
            "TNPO2",
            "CEPT1",
            "TMBIM6",
            "MFSD8",
            "GATAD2A",
            "SNAP23",
            "CARM1",
            "PIAS4",
            "AP1M1",
            "EPS15L1",
            "ZC3H4",
            "SF4"
        ]
    },
    {
        "golabel": "XBP1_regulon_activity",
        "gene": [
            "LOC145837",
            "BMP6",
            "S100P",
            "SEC11C",
            "DNAJC12",
            "BHLHA15",
            "KIAA1324",
            "PLA2G4A",
            "LOC100129066",
            "LGSN",
            "TNFRSF17",
            "PLAU",
            "DCBLD2",
            "LOC96610",
            "SH3RF2",
            "MGC29506",
            "PDLIM4",
            "FCRL5",
            "CDH3",
            "BEND6",
            "IGF2BP2",
            "C10orf55",
            "STAC",
            "ITGA2",
            "DERL3",
            "TTC39C",
            "EPHA2",
            "C14orf147",
            "KCNN4",
            "TIAM1",
            "ATP10A",
            "PRKCA",
            "ATP1B1",
            "PAIP2B",
            "ISG20",
            "PIM2",
            "TC2N",
            "OAT",
            "AIM1",
            "CDCP1",
            "MBOAT2",
            "ITGA3",
            "GCH1",
            "RIN1",
            "CNTLN",
            "STARD10",
            "FKBP11",
            "TNFRSF12A",
            "FZD3",
            "SAMD4A",
            "FAM46C",
            "ATP8B1",
            "CDK2AP2",
            "PLEC",
            "PTP4A1",
            "RFK",
            "NCS1",
            "FBXO16",
            "PRDX4",
            "BICD1",
            "CREB3L4",
            "SSR4",
            "GPSM1",
            "PDLIM7",
            "SMURF2",
            "C20orf196",
            "FAM107B",
            "EPHA1",
            "IDI1",
            "CMTM3",
            "FLNA",
            "DNAJB9",
            "SDF2L1",
            "MYOF",
            "SEPHS2",
            "PPIB",
            "FHOD1",
            "FAAH2",
            "HSCB",
            "MCEE",
            "LRRC8A",
            "TRIM47",
            "FLNB",
            "DUSP7",
            "LIMK1",
            "ALG5",
            "CRELD2",
            "C2orf15",
            "C18orf32",
            "NUCB2",
            "PDIA3",
            "CTAGE5",
            "RWDD2A",
            "RHBDF2",
            "PDIA3P",
            "ERP29",
            "FAM38A",
            "C19orf10",
            "CMTM7",
            "PXN",
            "RASAL2",
            "MANF",
            "PDIA6",
            "BCL10",
            "HERPUD1",
            "VCL",
            "TMED2",
            "TXNDC11",
            "C12orf23",
            "YIPF6",
            "RASA1",
            "ATF4",
            "ELF4",
            "MPDU1",
            "MSN",
            "SELS",
            "RAP2B",
            "SFXN3",
            "SLC25A20",
            "ZYX",
            "SERP1",
            "TSNAX",
            "TXNDC5",
            "SRGAP2",
            "ZNF280D",
            "ZSWIM6",
            "RPN2",
            "MAP7D1",
            "DERL2",
            "SEC23B",
            "EIF2AK3",
            "CCDC117",
            "SPCS2",
            "RAB11FIP5",
            "USP3",
            "ARL1",
            "HM13",
            "LOC653566",
            "AP2M1",
            "ERGIC3",
            "UBE2J1",
            "FLII",
            "ARFGAP3",
            "ACTB",
            "SLC35B1",
            "MIS12",
            "SSR1",
            "RAB4A",
            "SPTAN1",
            "TMED10"
        ]
    },
    {
        "golabel": "XPC_regulon_activity",
        "gene": [
            "MACROD2",
            "C6orf138",
            "EIF4EBP1",
            "FAM66A",
            "EDA2R",
            "CCNB2",
            "CDKN3",
            "MYBL2",
            "CENPA",
            "NUF2",
            "C1orf135",
            "SC65",
            "CENPW",
            "BIRC5",
            "CDC20",
            "FAM54A",
            "PTCH1",
            "SEC61G",
            "CC2D2A",
            "TBC1D7",
            "SATB1",
            "CYFIP2",
            "PFDN4",
            "TCEB1",
            "MRPS15",
            "C6orf115",
            "MAGEE1",
            "AKAP13",
            "DTYMK",
            "LIMD1",
            "BOLA3",
            "MAGI1",
            "C5orf28",
            "TGFBR2",
            "PSMG1",
            "TUBA1C",
            "C20orf111",
            "NUDT16",
            "KAT2B",
            "ANKHD1-EIF4EBP3",
            "SCNM1",
            "CTDSPL",
            "PHF15",
            "CALCOCO1",
            "PSMD14",
            "TRAK1",
            "NICN1",
            "UFD1L",
            "LAMB2",
            "ZBTB47",
            "PSMC2",
            "FYCO1",
            "PSMB1",
            "PARP3",
            "RNF7",
            "NISCH",
            "IQSEC1",
            "PRKCD",
            "POLH",
            "ZFYVE20",
            "DNAJB6",
            "TBC1D5",
            "WDR6",
            "DCP1B",
            "PCMT1",
            "EPM2AIP1",
            "MPHOSPH8",
            "C3orf31",
            "TRIM35",
            "SLC25A38",
            "KDM3B",
            "PTPN23",
            "UBE2V1",
            "WDR48",
            "USP19",
            "PDCD6IP",
            "C3orf19",
            "GORASP1",
            "IP6K1"
        ]
    },
    {
        "golabel": "XRCC5_regulon_activity",
        "gene": [
            "WDR72",
            "FAM183B",
            "CD164L2",
            "GGT3P",
            "ATG16L2",
            "HEXDC",
            "PERP",
            "CCDC88B",
            "FBP1",
            "TBC1D24",
            "TNFRSF14",
            "CEMP1",
            "SORD",
            "MFF",
            "LYL1",
            "FAM193B",
            "FADS3",
            "FHOD1",
            "ZNF862",
            "TUBGCP6",
            "HMHA1",
            "EHBP1",
            "SELO",
            "ACSL3",
            "PDIA6",
            "AGXT2L2",
            "ZDHHC8",
            "HDAC2",
            "IQSEC2",
            "RRM1",
            "NRAS",
            "YWHAQ",
            "FAM119A",
            "LOC729082",
            "SPSB3",
            "MTMR2",
            "MOBKL3",
            "PSMD1",
            "RPE",
            "PDHX",
            "MMADHC",
            "FLYWCH1",
            "NDUFS1",
            "NUFIP1",
            "SGSH",
            "SUMO1P3",
            "ZC3H15",
            "CTDSPL2",
            "CNOT7",
            "YWHAE",
            "RQCD1",
            "ATIC",
            "TYK2",
            "RBBP4",
            "CAMTA2",
            "PPP1CB",
            "SAE1",
            "MTCH2",
            "CRNKL1",
            "DIS3",
            "PPP1R9B",
            "DDX1",
            "PTMA",
            "MAPRE1",
            "EML3",
            "NHEJ1",
            "CAPRIN1",
            "CDC73",
            "SEPT2",
            "DYNC1I2",
            "ACTR2",
            "CUL3",
            "SMARCAL1",
            "KHDRBS1",
            "HNRNPK"
        ]
    },
    {
        "golabel": "XRCC6_regulon_activity",
        "gene": [
            "PTPLA",
            "AGA",
            "PMM1",
            "BAG2",
            "KCNQ1OT1",
            "MGST1",
            "TALDO1",
            "CLYBL",
            "GCAT",
            "IDH1",
            "RPL10A",
            "MRPL33",
            "PPPDE2",
            "PECI",
            "DOK3",
            "FLJ45340",
            "FAM193B",
            "TOMM22",
            "ZNF37B",
            "FAH",
            "MAP3K12",
            "GIGYF1",
            "SYNGAP1",
            "AKNA",
            "NIPSNAP1",
            "ADSL",
            "PIGP",
            "XPNPEP3",
            "PHF5A",
            "LIAS",
            "FAM10A4",
            "SERHL",
            "RPL4",
            "TNK2",
            "C22orf32",
            "ZNF814",
            "FDPS",
            "ZNF780B",
            "PACSIN2",
            "DPH5",
            "TXN2",
            "ST13",
            "SEMA4D",
            "MRPS18B",
            "GTF2H5",
            "MRPL45",
            "SDHC",
            "PPP1R12C",
            "ADH5",
            "CCDC134",
            "ATP5F1",
            "EIF3L",
            "CCDC51",
            "FNBP4",
            "SLC25A17",
            "THOC5",
            "TOB2",
            "RANGAP1",
            "MRPS27",
            "MYO9B",
            "C2CD2L",
            "KIAA2026",
            "MIER2",
            "RMND1",
            "EIF4E",
            "ASCC1",
            "EIF4A1",
            "MCAT",
            "ACO2",
            "CCT8",
            "HMGXB4",
            "ATIC",
            "EIF3D",
            "ARFGAP3",
            "REXO1",
            "ADRBK1",
            "NHP2L1",
            "PES1",
            "SAMM50",
            "MFAP1",
            "BCL2L13",
            "MRPL10",
            "PHF21A",
            "ATXN10",
            "POLDIP3",
            "MLH1"
        ]
    },
    {
        "golabel": "YAF2_regulon_activity",
        "gene": [
            "RPL39",
            "RAP1B",
            "FAM60A",
            "GPX7",
            "FAM92A1",
            "PFDN5",
            "TMEM106C",
            "EVPL",
            "GOLT1B",
            "XRCC4",
            "PPL",
            "PPP2R3C",
            "TMEM19",
            "DNAJB9",
            "EEF1A1",
            "TMEM55A",
            "CDC42BPG",
            "C6orf162",
            "VPS29",
            "CREM",
            "INTS1",
            "OSTC",
            "ERGIC2",
            "CCDC59",
            "CCNC",
            "KCTD6",
            "C12orf29",
            "PYROXD1",
            "SUB1",
            "COPS3",
            "LSS",
            "FAM96A",
            "SARNP",
            "EPB41L1",
            "C10orf84",
            "C22orf46",
            "C5orf15",
            "ACACA",
            "RARS2",
            "ATF1",
            "UBE2N",
            "C12orf41",
            "PLCB3",
            "SLC4A2",
            "C12orf4",
            "ZCCHC7",
            "SURF6",
            "TAOK2",
            "HCFC2",
            "HTT",
            "RPAP1",
            "OGDH",
            "PCNP",
            "UBE2B",
            "SART1",
            "ZC3H7B",
            "IRAK4",
            "MEN1",
            "ZCRB1",
            "NAP1L1",
            "TUT1",
            "CDKN1B",
            "ZNF140",
            "VEZT",
            "PPP1CC",
            "USP15",
            "C11orf58",
            "EIF1B",
            "RNF40",
            "PPP1R10",
            "MARK2",
            "PWP1",
            "CNBP",
            "NFYB",
            "KCTD2",
            "HNRPLL",
            "LASS5",
            "PPHLN1",
            "AZI2"
        ]
    },
    {
        "golabel": "YBX1_regulon_activity",
        "gene": [
            "LRP8",
            "CDKN3",
            "OIP5",
            "CKS2",
            "CAPN8",
            "MAD2L1",
            "DEPDC1",
            "ORC1L",
            "C1orf135",
            "EPR1",
            "KIF2C",
            "CENPW",
            "SPC25",
            "BIRC5",
            "CDC20",
            "CDK1",
            "CCNA2",
            "GOLGA6L5",
            "KIAA0101",
            "UBE2Q2P1",
            "CDCA8",
            "GSTO1",
            "TIMM8B",
            "GPX7",
            "CCNB1",
            "RPSA",
            "ATP11A",
            "CTPS",
            "FAM83E",
            "RAB32",
            "HAUS1",
            "SNRPD2",
            "PRDX1",
            "RPS8",
            "TMEM48",
            "GLA",
            "MAD2L2",
            "MRPS15",
            "COMMD8",
            "UQCRHL",
            "ANKMY1",
            "ATP6V0B",
            "RANBP1",
            "ATP1B3",
            "RAN",
            "RALGPS1",
            "UQCRH",
            "AHCY",
            "GLRX3",
            "H2AFZ",
            "TUBGCP6",
            "LOC90110",
            "C3orf26",
            "ADSL",
            "TUBA1C",
            "ZNF514",
            "RAPH1",
            "MRPL11",
            "PPIH",
            "PHF5A",
            "TMEM63A",
            "CCDC23",
            "ZNF75D",
            "BTF3L4",
            "TUBA1B",
            "MAGOH",
            "EIF5A",
            "OLA1",
            "FBL",
            "C1orf163",
            "EIF5AL1",
            "DRAP1",
            "FAM160B2",
            "PSMA5",
            "MRTO4",
            "LOC100129034",
            "PSMB1",
            "ARPC5",
            "DPH2",
            "DRG1",
            "POLE3",
            "AP2S1",
            "MRPS22",
            "C1orf212",
            "RWDD1",
            "EBNA1BP2",
            "MRPL37",
            "SDHB",
            "PTDSS1",
            "LSM6",
            "KIAA0430",
            "ERI3",
            "PDCD2",
            "ZMPSTE24",
            "ZNF259",
            "EIF3I",
            "EIF3M",
            "PCMT1",
            "COG7",
            "FAM160A2",
            "DDOST",
            "PSMB2",
            "ZNF500",
            "MDH1",
            "PFN1",
            "CAP1",
            "UTP11L",
            "AKIRIN2",
            "SECISBP2",
            "SERBP1",
            "SF3A3",
            "C1orf144"
        ]
    },
    {
        "golabel": "YEATS2_regulon_activity",
        "gene": [
            "FAM171A2",
            "MED12L",
            "SV2A",
            "IL17RD",
            "MURC",
            "DKFZp686O24166",
            "BVES",
            "CLSPN",
            "PFKFB4",
            "C8orf4",
            "DUSP1",
            "PRR11",
            "FAM89A",
            "C15orf42",
            "POLQ",
            "CLTCL1",
            "FOXRED2",
            "USP49",
            "MCM2",
            "KIAA1467",
            "LOXL3",
            "RHOB",
            "BRCA1",
            "TSTD1",
            "ATAD5",
            "FBXO41",
            "RNF168",
            "TPT1",
            "RPL13A",
            "TMBIM4",
            "BICD1",
            "SSR4",
            "C10orf11",
            "RPS9",
            "PLXNA1",
            "INCENP",
            "RPL13",
            "C3orf34",
            "RPL34",
            "RBL1",
            "ELL3",
            "RANGRF",
            "CAD",
            "HLTF",
            "UBXN7",
            "CHKB",
            "DPH3B",
            "ATP13A3",
            "ALG5",
            "TOPBP1",
            "N6AMT2",
            "DLG5",
            "FAM165B",
            "FBXO45",
            "ASAP1",
            "USP31",
            "SAT2",
            "ARV1",
            "MRPS36",
            "C22orf32",
            "FBXO10",
            "LSG1",
            "CD63",
            "ANKRD27",
            "ZSWIM7",
            "DHRS7B",
            "BFAR",
            "RBM3",
            "CBL",
            "POLR1A",
            "MPDU1",
            "MGST2",
            "MED11",
            "TAGLN2",
            "TBCCD1",
            "C17orf48",
            "OPA1",
            "LRCH3",
            "COX18",
            "RNASEK",
            "SAP18",
            "TRAPPC1",
            "LGTN",
            "TTPAL",
            "SPAG7",
            "UFC1",
            "KIAA0226",
            "PCYT1A",
            "NDUFAF1",
            "DVL3",
            "ZSCAN20",
            "FLJ33630",
            "FXR1",
            "ALG1",
            "ATR",
            "PHF13",
            "CYB561D2",
            "EIF4G1",
            "GABARAP",
            "PEX11B",
            "CASP2",
            "DNAJC13",
            "GSK3B",
            "RBM12B",
            "KDM3A",
            "QTRTD1",
            "GPR108",
            "NUBP1",
            "DCTD"
        ]
    },
    {
        "golabel": "YWHAE_regulon_activity",
        "gene": [
            "TRIM16L",
            "NCRNA00188",
            "TMEM14A",
            "RSL24D1",
            "C9orf139",
            "TRIM16",
            "C17orf61",
            "EME2",
            "APOB48R",
            "LOC91316",
            "LOC100132247",
            "TIMM8B",
            "SNRPG",
            "LOC100128842",
            "LOC349114",
            "MAPK8IP3",
            "BRF2",
            "GTF2A2",
            "LOC100190986",
            "LTB4R2",
            "TMC8",
            "CIITA",
            "ABCA7",
            "MED31",
            "LENG8",
            "PRDX1",
            "RPL26",
            "EBPL",
            "B9D1",
            "DLEU1",
            "FBF1",
            "TSSK4",
            "PEMT",
            "ARHGAP30",
            "PLEKHM1P",
            "PLXNA3",
            "LSM2",
            "TMEM14B",
            "CRIPT",
            "FLJ45340",
            "ZNF37B",
            "COQ3",
            "RNF213",
            "LYRM4",
            "C1QBP",
            "NKTR",
            "TUBGCP6",
            "ATP5S",
            "TMEM223",
            "N6AMT2",
            "ZNF589",
            "ABCA2",
            "AKNA",
            "FAM38A",
            "PKD1",
            "HMHA1",
            "ASF1A",
            "ZNF841",
            "CCDC23",
            "MYO18A",
            "KIAA0467",
            "TRANK1",
            "STX8",
            "TNK2",
            "TMEM107",
            "SFI1",
            "THNSL1",
            "MRPL39",
            "COPS3",
            "NDUFS4",
            "ATP5B",
            "ZNF232",
            "TMEM183A",
            "EIF5A",
            "LYST",
            "ZMIZ2",
            "ERH",
            "MACF1",
            "PRDX3",
            "OLA1",
            "PSMB6",
            "RPAIN",
            "TMEM93",
            "MRPL1",
            "MLLT6",
            "NUDT15",
            "MPDU1",
            "TEP1",
            "EIF5AL1",
            "OVCA2",
            "MRPS18B",
            "DENND1C",
            "PPA2",
            "TRUB2",
            "GTF2H5",
            "C17orf81",
            "FAM18B2",
            "SNRPE",
            "TMEM18",
            "SDHC",
            "KCTD7",
            "MAST3",
            "ATP5A1",
            "GHITM",
            "DERL2",
            "TTC19",
            "MRPS22",
            "SAP18",
            "GEMIN4",
            "SIN3B",
            "ZNFX1",
            "RNMTL1",
            "MMADHC",
            "MYO9B",
            "NUP88",
            "TMEM11",
            "RMND1",
            "ARHGEF18",
            "HDAC7",
            "RPF1",
            "SLC25A11",
            "PDCD2",
            "MUM1",
            "EIF4A1",
            "CNOT7",
            "C2orf47",
            "MRPS16",
            "TSR1",
            "RBM33",
            "TYK2",
            "MIS12",
            "MTCH2",
            "MRPS9",
            "CYTH1",
            "MRPL44",
            "COX10",
            "SCO1",
            "PPP1R9B",
            "GLOD4",
            "GGA3",
            "UBE2G1",
            "PHF23",
            "CRK",
            "PDHB",
            "SENP3",
            "RPA1",
            "PCF11",
            "RNF167",
            "TIMM22",
            "PSMD6",
            "XRCC5",
            "MAP2K4"
        ]
    },
    {
        "golabel": "YWHAZ_regulon_activity",
        "gene": [
            "PLIN5",
            "FBXO32",
            "SLC25A27",
            "OVOL1",
            "DSCC1",
            "PABPC3",
            "FAM60A",
            "GNPNAT1",
            "CHMP4C",
            "IMPA1",
            "MRPL13",
            "MTFR1",
            "IFT172",
            "NFIA",
            "CBX7",
            "PDP1",
            "OSGIN2",
            "HN1",
            "RIPK2",
            "MRPL15",
            "FZD6",
            "NRIP1",
            "PABPC1",
            "KIAA0196",
            "NUDCD1",
            "OTUD6B",
            "C19orf44",
            "DCAF13",
            "ARMC1",
            "BZW1",
            "FAM49B",
            "RAD21",
            "TCEA1",
            "FAM91A1",
            "PGPEP1",
            "EIF4A3",
            "AZIN1",
            "GRHL2",
            "INTS8",
            "ESRP1",
            "CABIN1",
            "NBN",
            "WDR43",
            "ZNF706",
            "VDAC1",
            "MTDH",
            "TAF2",
            "ARAP1",
            "STK3",
            "PTDSS1",
            "UBE2D1",
            "TAOK2",
            "ACTG1",
            "UBE2K",
            "PTPN18",
            "DERL1",
            "ACTR3",
            "SLC25A32",
            "ATP6V1C1",
            "KIAA1429",
            "FAM45A",
            "ZNF500",
            "VPS26A",
            "YTHDF3",
            "MARCH5",
            "KIAA0892",
            "C10orf119",
            "CLCC1",
            "HNRNPF",
            "L3MBTL2",
            "SMNDC1"
        ]
    },
    {
        "golabel": "YY1_regulon_activity",
        "gene": [
            "MBL1P",
            "DNAH1",
            "CDKN3",
            "USHBP1",
            "KANK3",
            "DLGAP5",
            "RAPGEF3",
            "NEIL1",
            "CDCA4",
            "OTUB2",
            "C16orf48",
            "C14orf129",
            "VRK1",
            "LMF1",
            "ACTL6A",
            "TFAM",
            "C1orf103",
            "MAN2C1",
            "ERH",
            "TMX1",
            "HSP90AA1",
            "DCUN1D1",
            "WDR89",
            "MCOLN1",
            "PNPLA6",
            "RPE",
            "DUSP11",
            "C2CD2L",
            "SAV1",
            "PPP2R5E",
            "KPNA4",
            "PAPOLA",
            "EXOC5",
            "STYX",
            "KATNB1",
            "ZFYVE27",
            "SCAMP4",
            "GOLGA5",
            "PPP2R5C",
            "CCNK",
            "WDR20",
            "SETD3",
            "SP3",
            "SNW1"
        ]
    },
    {
        "golabel": "ZBED3_regulon_activity",
        "gene": [
            "RGS20",
            "CATSPER1",
            "CDA",
            "GJB3",
            "GPR87",
            "C15orf48",
            "SDK1",
            "ZNF710",
            "PDE8B",
            "PREX2",
            "CXXC4",
            "STEAP1",
            "CDH3",
            "SRPX2",
            "SORBS2",
            "PHACTR1",
            "FAM3C",
            "NCRNA00152",
            "PRSS22",
            "S100A6",
            "CABLES1",
            "LOC541471",
            "RGAG4",
            "KRT19",
            "S100A16",
            "SFN",
            "ERN1",
            "PLEKHN1",
            "PHLDA2",
            "MBOAT2",
            "SLC16A3",
            "LOC728723",
            "USP51",
            "IL6ST",
            "LARGE",
            "MAST4",
            "STOX2",
            "ALDH6A1",
            "TMSB10",
            "CYFIP2",
            "RALGAPA2",
            "S100A10",
            "TUBA4A",
            "KIAA1958",
            "SERINC5",
            "BUD31",
            "SH3BGRL3",
            "CHST10",
            "AMIGO1",
            "RHOC",
            "ANXA2",
            "SLC35E2",
            "LRIG1",
            "ZNF192",
            "TTC28",
            "KANK1",
            "S100A11",
            "KPNA5",
            "ZNF618",
            "KCTD5",
            "SPATS2L",
            "RALB",
            "KBTBD7",
            "BCL10",
            "ULK2",
            "PLEKHM3",
            "HSPB11",
            "ZNF641",
            "HSD17B4",
            "SCAPER",
            "TRIP10",
            "ISOC1",
            "LDOC1L",
            "LDB1",
            "RAC1",
            "PRPF8",
            "TTC37",
            "ZNF500",
            "DIS3L",
            "EPC1",
            "UBC",
            "RNF149",
            "HNRNPA0",
            "AGGF1"
        ]
    },
    {
        "golabel": "ZBTB1_regulon_activity",
        "gene": [
            "GPR174",
            "AKAP5",
            "PTPRC",
            "GAB3",
            "C16orf13",
            "DDHD1",
            "ZNF101",
            "ZBTB25",
            "DUS1L",
            "ZFP14",
            "TIA1",
            "PRPF39",
            "DNAL1",
            "ZNF700",
            "C14orf138",
            "NDUFAF3",
            "ZNF280D",
            "ZBTB26",
            "ARID4A",
            "NACC1",
            "C14orf118",
            "ZNF187",
            "CHURC1",
            "CARD8",
            "LONP1",
            "EXOC5",
            "TRMT5",
            "ZNF548",
            "C14orf135",
            "ZNF845",
            "DDX54",
            "ACTR10",
            "N4BP2L2",
            "ZBTB6",
            "ZNF136",
            "ZBED5",
            "TRAF7",
            "SMEK1",
            "SOCS4",
            "ATP6V0C",
            "LINS1",
            "FAM76B",
            "EXD2",
            "NKIRAS2",
            "ATXN3",
            "SCYL1",
            "KIAA0831",
            "THAP4",
            "CORO1B",
            "WBP2",
            "EIF5",
            "POLDIP2",
            "ALKBH1",
            "JKAMP",
            "S100PBP",
            "POLR2E",
            "CCNT2",
            "SYNJ2BP",
            "PPWD1",
            "PPM1A",
            "USPL1",
            "MUDENG",
            "MSL3",
            "SLC39A9",
            "HELQ",
            "TMEM214",
            "RAB1B",
            "ZMYM6",
            "PSEN1",
            "MAX",
            "ZFP161"
        ]
    },
    {
        "golabel": "ZBTB10_regulon_activity",
        "gene": [
            "NDRG1",
            "IDUA",
            "FAM84B",
            "CNKSR3",
            "ACVR2B",
            "ZNF704",
            "IL18",
            "N4BP2",
            "ALDH2",
            "C10orf11",
            "OSBPL7",
            "LCOR",
            "HOMER1",
            "TRIB1",
            "RASSF7",
            "ACYP2",
            "B3GNT9",
            "STAU2",
            "TSPO",
            "HOOK1",
            "C9orf167",
            "ARV1",
            "ARHGEF1",
            "C10orf12",
            "UBR5",
            "RILPL2",
            "FAM98C",
            "ZNF623",
            "ACLY",
            "LIG3",
            "TAF2",
            "VCPIP1",
            "TAX1BP3",
            "USP32",
            "IMP3",
            "AES",
            "PHF11",
            "KIAA1429",
            "MINA",
            "DCAF7"
        ]
    },
    {
        "golabel": "ZBTB12_regulon_activity",
        "gene": [
            "MYCNOS",
            "FBN3",
            "MEX3A",
            "ALX3",
            "HPGDS",
            "TREM2",
            "CD52",
            "ANKRD22",
            "CLEC4A",
            "PTPN22",
            "ITGB6",
            "IGSF6",
            "ALOX5AP",
            "GAPT",
            "AMICA1",
            "MNDA",
            "CLIC2",
            "AIF1",
            "GMFG",
            "CD58",
            "B2M",
            "SOX12",
            "C13orf23",
            "BCL9",
            "HYOU1",
            "ATP6V0E1",
            "ARL6IP5",
            "LSM14B",
            "MTA1",
            "MAGEF1",
            "ZNF496",
            "KLHL2",
            "AGBL5",
            "ANXA5",
            "ARHGEF3",
            "EHMT2",
            "SAMD1",
            "ZNF777",
            "FANCF",
            "ZFP64",
            "CAP1",
            "OSTF1",
            "ATG7",
            "RNF149",
            "U2AF2",
            "FUS",
            "HNRNPA0",
            "NCOA5",
            "PCIF1",
            "RBM15B",
            "UBTF"
        ]
    },
    {
        "golabel": "ZBTB16_regulon_activity",
        "gene": [
            "SYBU",
            "ZNF385B",
            "CYP4B1",
            "ABCA8",
            "ADH1B",
            "SECISBP2L",
            "FAM107A",
            "INMT",
            "ATP1A2",
            "KLF15",
            "NPNT",
            "HUNK",
            "PRX",
            "EDNRB",
            "SDPR",
            "FHL5",
            "TROAP",
            "CENPA",
            "NEDD9",
            "RHOBTB2",
            "NDC80",
            "DEPDC1B",
            "FKBP5",
            "ITGA9",
            "KIF2C",
            "CDC6",
            "RAD51AP1",
            "CENPW",
            "SPC25",
            "FAM72B",
            "BIRC5",
            "CDC20",
            "HJURP",
            "CDCA3",
            "CDK1",
            "CCNA2",
            "NCAPG",
            "SKA3",
            "NEK2",
            "KIAA0101",
            "RRM2",
            "CDCA8",
            "UBE2T",
            "CEP55",
            "CCNB1",
            "PER1",
            "ASF1B",
            "IL6R",
            "EMP2",
            "CELF2",
            "TENC1",
            "AKAP13",
            "FCHO2",
            "CRY2",
            "TUBA1C",
            "LNX2",
            "VAMP2",
            "ZBTB4",
            "CNST"
        ]
    },
    {
        "golabel": "ZBTB17_regulon_activity",
        "gene": [
            "GPC2",
            "CNIH2",
            "GPR61",
            "BAI2",
            "MATN1",
            "TNFRSF25",
            "RPS3A",
            "CROCC",
            "TMEM86B",
            "PLEKHG5",
            "LOC100132287",
            "ATAD3B",
            "LOC100133331",
            "KLHL17",
            "DMPK",
            "SUV420H2",
            "PRRG4",
            "PHLDB3",
            "UBE2W",
            "ANKS3",
            "FCHO2",
            "AZI1",
            "ACAP3",
            "INTS1",
            "ZNF775",
            "MAST2",
            "CCHCR1",
            "DVL1",
            "C8orf83",
            "MIB2",
            "C1orf159",
            "SUCLG2",
            "ZGPAT",
            "ARFGAP1",
            "MAP4K2",
            "ZMIZ2",
            "KIAA0415",
            "MAD1L1",
            "ATAD3A",
            "CHST12",
            "C7orf43",
            "RCC2",
            "C7orf27",
            "SH3BP2",
            "TMEM201",
            "PPA1",
            "CDK11A",
            "DMAP1",
            "ZBTB48",
            "NPHP4",
            "CPNE3",
            "SYPL1",
            "MTMR6",
            "POFUT2",
            "NOC2L",
            "LYPLA2",
            "PQLC2",
            "MIIP",
            "EIF1AX",
            "SNRNP70",
            "IPO7",
            "SCAMP1",
            "SLC25A46",
            "ATP13A2",
            "AK3",
            "TMCO4",
            "AKAP8L",
            "JMJD5",
            "HSD17B12",
            "B3GALT6",
            "RAP1GDS1",
            "LOC643837",
            "C6orf211",
            "DGCR14",
            "ZNF335",
            "TMEM192",
            "GRINL1A",
            "PPP2CB",
            "NUDC",
            "FBXO3",
            "TRNT1",
            "CC2D1B",
            "NCOA4",
            "ZNF668",
            "GLUD1",
            "SRFBP1",
            "RAB18",
            "EXOC6",
            "VPS4B",
            "PANK4",
            "SDF4",
            "RING1",
            "UBE2J2",
            "ARFIP1",
            "CPSF3L",
            "CDK11B",
            "YTHDF3",
            "TMEM39B",
            "PEX14",
            "SLC30A5",
            "LEMD2",
            "KDSR",
            "ATAD1",
            "NAIF1",
            "CSNK1G3",
            "HP1BP3",
            "IPO13",
            "DNAJC11",
            "PLEKHM2",
            "KIAA2013",
            "API5",
            "GPATCH3",
            "PDE12",
            "EXOSC10",
            "TXLNA",
            "SFRS4",
            "VPS24",
            "LRRC47",
            "FBXO42"
        ]
    },
    {
        "golabel": "ZBTB2_regulon_activity",
        "gene": [
            "SACS",
            "KLHDC9",
            "GCHFR",
            "FBXO5",
            "LRRC29",
            "CCDC24",
            "RBL1",
            "FDXR",
            "PEX11G",
            "C6orf167",
            "ARV1",
            "FBXO10",
            "PRRG2",
            "IGF2R",
            "BBS4",
            "MTHFD1L",
            "SUMF1",
            "HIVEP2",
            "TCP1",
            "QKI",
            "FBXO30",
            "DYNC2LI1",
            "POMGNT1",
            "ANKRA2",
            "GEMIN8",
            "LTV1",
            "VTA1",
            "REPS1",
            "MTFMT",
            "NUP43",
            "FAM54B",
            "MTRF1L",
            "SYNCRIP",
            "RBM16",
            "PPIL4"
        ]
    },
    {
        "golabel": "ZBTB26_regulon_activity",
        "gene": [
            "ASFMR1",
            "FSD1L",
            "KRT7",
            "FLJ23867",
            "FANCM",
            "NCRNA00120",
            "ZNF519",
            "LOC100270710",
            "RNF138P1",
            "SERINC2",
            "STAG3L2",
            "LHPP",
            "PSIP1",
            "C5orf54",
            "PIAS2",
            "ADAM15",
            "LGALS3BP",
            "NEU3",
            "RC3H2",
            "CEP78",
            "ZNF141",
            "CD151",
            "ZNF280C",
            "IQCB1",
            "ZBTB25",
            "DAPK3",
            "ZNF641",
            "C2orf86",
            "LMNA",
            "JMJD8",
            "PTPDC1",
            "CNN2",
            "STRBP",
            "ZNF417",
            "TMEM102",
            "C11orf30",
            "KLHL9",
            "TOM1",
            "RNPEP",
            "ELOVL1",
            "RCBTB1",
            "MRE11A",
            "ZBTB6",
            "ZBTB5",
            "C4orf29",
            "SOCS4",
            "NCLN",
            "RBM12B",
            "ING3",
            "KDM3A",
            "TADA2A",
            "ZNF510",
            "TSTD2",
            "ZBTB1",
            "PRPF4B",
            "C3orf17",
            "RBMX"
        ]
    },
    {
        "golabel": "ZBTB3_regulon_activity",
        "gene": [
            "RGS20",
            "XIRP1",
            "NCRNA00203",
            "SERPINE1",
            "ADAMTS4",
            "SPHK1",
            "C9orf131",
            "BTBD18",
            "CTHRC1",
            "DUSP5",
            "SNAI1",
            "S100A16",
            "GADD45A",
            "PLAUR",
            "C7orf41",
            "DTX4",
            "ACSS1",
            "B3GNT5",
            "SHANK2",
            "TRIM68",
            "PPFIBP2",
            "SLC35E2",
            "SUGT1L1",
            "LIMD1",
            "RIPK2",
            "SENP8",
            "DNAJC28",
            "ZFP3",
            "NFIL3",
            "MYLIP",
            "BZW1",
            "NIPAL3",
            "CYB561D1",
            "ZNF785",
            "LOC100129034",
            "NFATC3",
            "C1orf69",
            "TCEANC",
            "FAM13B",
            "ZNF417",
            "ITFG2",
            "BBS1",
            "ZNF557",
            "KBTBD4",
            "ZBED5",
            "TUT1",
            "RBM4B",
            "SUV420H1",
            "SNX1",
            "ZNF434",
            "OSBP",
            "KAT5",
            "ARFGAP2",
            "DPF2"
        ]
    },
    {
        "golabel": "ZBTB38_regulon_activity",
        "gene": [
            "DNAJB4",
            "DGCR6",
            "MAGIX",
            "CSGALNACT1",
            "SBK1",
            "LOC113230",
            "SLC25A29",
            "CD226",
            "PIK3CG",
            "SOD2",
            "TLR6",
            "MYO1E",
            "AKAP2",
            "ROM1",
            "C6orf125",
            "ELK3",
            "WWTR1",
            "NTHL1",
            "FAAH",
            "CARD6",
            "ZC3H12C",
            "NAT14",
            "MRPS26",
            "HSD11B1L",
            "LUC7L",
            "ITGB1",
            "RAB8B",
            "C17orf90",
            "CLIP1",
            "B4GALT1",
            "ATPIF1",
            "TMEM2",
            "PCGF5",
            "SDR39U1",
            "C2orf34",
            "ROGDI",
            "SEL1L",
            "NR3C1",
            "FNDC3B",
            "SERGEF",
            "FBXW9",
            "TRAF4",
            "MVK",
            "C1orf35",
            "NARF",
            "NAT9",
            "TMEM140",
            "PIK3CA",
            "TSEN54",
            "BBX",
            "PCYT1A",
            "C19orf39",
            "XRN1",
            "SLC37A4",
            "SEC24A",
            "MFSD1",
            "DNAJB14",
            "GCDH",
            "DCAF15",
            "TAF6L",
            "DNAJC13",
            "ELF1",
            "CDV3",
            "SLMAP",
            "FAM160B1",
            "PIK3R4",
            "DTNBP1",
            "EIF2B4"
        ]
    },
    {
        "golabel": "ZBTB4_regulon_activity",
        "gene": [
            "RS1",
            "SLC16A12",
            "ZBTB16",
            "ALOX15B",
            "SECISBP2L",
            "EIF4EBP1",
            "LOC645166",
            "NPNT",
            "ABCC9",
            "CNTN3",
            "DAAM2",
            "GPR133",
            "ICAM5",
            "PRX",
            "CCNB2",
            "EVPLL",
            "CDKN3",
            "CENPA",
            "PNMA2",
            "MAD2L1",
            "NEDD9",
            "C12orf48",
            "RHOBTB2",
            "DLC1",
            "DEPDC1B",
            "FAM24B",
            "BCAM",
            "CDC45",
            "TBX4",
            "EPR1",
            "RAD51AP1",
            "CENPW",
            "SPC25",
            "BIRC5",
            "PSPH",
            "CDK1",
            "CCNA2",
            "NCAPG",
            "WTIP",
            "PLD3",
            "MRPS17",
            "PDK3",
            "FAM162A",
            "RICH2",
            "PTPRU",
            "FAM22A",
            "SEC61G",
            "IL6R",
            "LIMCH1",
            "USP18",
            "PITPNM3",
            "TNS1",
            "GLA",
            "RPS6KA2",
            "PTPRE",
            "AKAP13",
            "PNP",
            "ALDH5A1",
            "ATP1B3",
            "PBXIP1",
            "H2AFZ",
            "LLPH",
            "CYCS",
            "TBPL1",
            "FAM22D",
            "MRPL11",
            "ZFP3",
            "CCDC59",
            "NT5C3",
            "PHF5A",
            "CYB5D1",
            "TMEM63B",
            "WWC3",
            "CXCL16",
            "UCHL3",
            "MEIS3P1",
            "PSMC6",
            "ULK2",
            "PLEKHM3",
            "C17orf75",
            "SRPRB",
            "PCYOX1",
            "ARHGEF17",
            "TOM1L2",
            "TRIM8",
            "LSM5",
            "RPF2",
            "PTGES3",
            "RBMS2",
            "UFD1L",
            "LAMB2",
            "FYCO1",
            "PSMA2",
            "RXRA",
            "ATP9B",
            "KIF1C",
            "TNK1",
            "NCOR1",
            "WDR81",
            "VAMP2",
            "RNF7",
            "TTC19",
            "EXOSC3",
            "MAN2B2",
            "CASP3",
            "DSTYK",
            "C1orf174",
            "KIAA0753",
            "MYO1C",
            "PRPF8",
            "METT10D",
            "ENOPH1",
            "CAMTA2",
            "INPP5K",
            "VPS53",
            "MED6",
            "SMG6",
            "VPS39",
            "SMYD4",
            "ANKFY1",
            "PAFAH1B1",
            "OAZ2",
            "RABEP1",
            "PITPNA"
        ]
    },
    {
        "golabel": "ZBTB40_regulon_activity",
        "gene": [
            "MYH3",
            "SNORD116-4",
            "NFASC",
            "AMAC1L3",
            "C11orf42",
            "GABRR2",
            "FLJ37307",
            "C10orf140",
            "HIC2",
            "LOC284009",
            "SNORD116-20",
            "C9orf131",
            "BTBD18",
            "TTN",
            "FAM3C",
            "KSR1",
            "IPW",
            "UCP3",
            "ESR2",
            "PHLDA2",
            "C9orf45",
            "MASP2",
            "PRDM15",
            "KIF21B",
            "LOC100190986",
            "CROCCL2",
            "ACACB",
            "KDELR3",
            "LOC253724",
            "OCIAD2",
            "KLHL3",
            "CALM2",
            "ACOT4",
            "SHANK3",
            "SLC35E2",
            "HDAC6",
            "PLP2",
            "SLC23A2",
            "PASK",
            "CBFA2T2",
            "NKTR",
            "SYNGAP1",
            "PPIAL4C",
            "SLC25A5",
            "PKD1",
            "MTHFR",
            "KIAA0467",
            "GPN1",
            "JRK",
            "AIG1",
            "RANBP10",
            "ZNF236",
            "ARMC10",
            "CLCN6",
            "CLIC1",
            "SFRS18",
            "UBL4A",
            "RBM6",
            "GBA2",
            "PDZD11",
            "AHI1",
            "C17orf68",
            "SRRM2",
            "CDK11A",
            "FAM53B",
            "C12orf51",
            "MLL2",
            "NPHP4",
            "MLL4",
            "UBN2",
            "ING5",
            "CHD3",
            "NIP7",
            "HERC1",
            "DENND4B",
            "CRAMP1L",
            "TSC1",
            "BTAF1",
            "NSDHL",
            "DIDO1",
            "ZZEF1",
            "SLC9A8",
            "LOC285033",
            "NR2C2",
            "ZBTB34",
            "DNAJC27",
            "TBL2",
            "MAVS",
            "RAC1",
            "SPEN",
            "TNRC6A",
            "MAP3K4",
            "RBM33",
            "FAM168B",
            "CIRH1A",
            "DEPDC5",
            "CCDC93",
            "YWHAH",
            "ANO10",
            "KIAA1310",
            "KARS",
            "ZNF592",
            "ATP6V1D",
            "ZXDC",
            "PCF11",
            "ZNF740",
            "CXorf26",
            "PHF21A",
            "FAM193A"
        ]
    },
    {
        "golabel": "ZBTB41_regulon_activity",
        "gene": [
            "FITM1",
            "TBC1D10C",
            "ACAP1",
            "GMCL1L",
            "PSTPIP1",
            "RASAL3",
            "IFFO1",
            "AGPAT4",
            "EMP3",
            "TMEM86B",
            "SLC15A3",
            "P2RY11",
            "FERMT3",
            "LOC729991-MEF2B",
            "MICAL1",
            "DENND1B",
            "TMEM106B",
            "ENPP4",
            "EGLN1",
            "TMEM182",
            "RIT1",
            "C10orf54",
            "PML",
            "C8orf83",
            "TNK2",
            "EVL",
            "LOC143188",
            "ZNF678",
            "C3orf33",
            "FAM65A",
            "STXBP4",
            "PI4K2B",
            "GFPT1",
            "AMDHD2",
            "ZDHHC8",
            "CD46",
            "ARFRP1",
            "GOLPH3L",
            "ARID5A",
            "EDEM3",
            "C1orf58",
            "ZYX",
            "TOMM20",
            "TSNAX",
            "TOR1AIP2",
            "PDIK1L",
            "SDHC",
            "SOAT1",
            "SRP9",
            "DCAF12",
            "PPP1R12C",
            "BPNT1",
            "OGFR",
            "NSL1",
            "SH3GLB2",
            "PIPSL",
            "ACBD5",
            "NEK7",
            "MAP7D1",
            "PRUNE",
            "PNPLA6",
            "SIPA1",
            "KDM5B",
            "ZNF669",
            "RNF2",
            "TMEM209",
            "DGKZ",
            "GMCL1",
            "PPPDE1",
            "C1orf27",
            "TIPRL",
            "SPAST",
            "ALDH9A1",
            "C1orf26",
            "RNF166",
            "TADA1",
            "TMCO1",
            "EPN1",
            "C1orf9",
            "MUT",
            "NUCKS1",
            "THAP5",
            "EPRS",
            "ERI2",
            "IARS2",
            "HDGFRP2",
            "VAC14",
            "MUTED",
            "BLZF1",
            "ZNF644",
            "UCHL5",
            "RPS6KC1",
            "RAB18",
            "GPATCH2",
            "KIFAP3",
            "REXO1",
            "ABCB10",
            "YIPF4",
            "RBBP5",
            "CAMSAP1L1",
            "CSK",
            "DCAF6",
            "ACBD3",
            "RHOG",
            "CDC37",
            "C1orf25",
            "CCDC94",
            "SPOPL",
            "GRK6",
            "DDX59",
            "ADSS",
            "CLTC",
            "CEP350",
            "GGPS1",
            "COG2",
            "FBXO28",
            "C1orf55",
            "ARID4B",
            "MPZL1",
            "GNPAT",
            "C1orf124",
            "RAB3GAP2",
            "NUP133",
            "PRPF31",
            "AP1M1",
            "SLC35B3",
            "TOR1AIP1",
            "KLHL12",
            "PEX13",
            "MRPL19",
            "TROVE2",
            "CDC73",
            "RFWD2",
            "SMEK2",
            "PLEKHM2",
            "AFTPH",
            "TAF5L",
            "WDR26",
            "RANBP3"
        ]
    },
    {
        "golabel": "ZBTB43_regulon_activity",
        "gene": [
            "CMYA5",
            "SNX30",
            "BAG2",
            "STXBP1",
            "DCTPP1",
            "C13orf37",
            "ZNF462",
            "TTC5",
            "RAN",
            "AHCY",
            "C1QBP",
            "CCDC90B",
            "COX7A2L",
            "OSTC",
            "PPIL1",
            "CEP76",
            "LOC253039",
            "LYST",
            "PDIA6",
            "PRDX3",
            "SNAPC4",
            "UBE2Q2",
            "BCL6",
            "ZNF782",
            "RXRA",
            "FNBP1",
            "LRRC28",
            "NUP188",
            "TSC1",
            "ATXN7",
            "SEC16A",
            "MMADHC",
            "ZBTB34",
            "LRSAM1",
            "RALGDS",
            "MINPP1",
            "ALAD",
            "GOLGA2",
            "USP20",
            "C2orf47",
            "GAPVD1",
            "DDOST",
            "DDX31",
            "KIAA0368",
            "MED26",
            "C14orf43",
            "MRPL35",
            "PHF2",
            "SCO1",
            "FKBP15",
            "ZER1",
            "RABGAP1",
            "GLE1",
            "GOLGA1",
            "STX17",
            "RAB14"
        ]
    },
    {
        "golabel": "ZBTB46_regulon_activity",
        "gene": [
            "SCARF1",
            "VASN",
            "ADAMTS10",
            "CARD11",
            "MEGF6",
            "LTBP4",
            "KIAA1274",
            "PTPRS",
            "SORD",
            "PLXND1",
            "UQCRHL",
            "FLNA",
            "SHANK3",
            "VASH1",
            "PRIC285",
            "RAN",
            "UQCRH",
            "AHCY",
            "HSPE1",
            "HSPD1",
            "SLC25A5",
            "PXMP2",
            "ABCA2",
            "AKNA",
            "TXNL1",
            "ADSL",
            "FAM38A",
            "MRPS33",
            "RIN3",
            "WDR12",
            "FAM65A",
            "NARS2",
            "CACYBP",
            "ZBTB47",
            "EHBP1L1",
            "PL-5283",
            "MMACHC",
            "METTL2A",
            "RXRA",
            "ABR",
            "ATP5A1",
            "TBC1D2B",
            "IL4R",
            "IQSEC1",
            "MRPL30",
            "MINK1",
            "SKI",
            "WDR77",
            "PUS3"
        ]
    },
    {
        "golabel": "ZBTB47_regulon_activity",
        "gene": [
            "CABYR",
            "ANKRD24",
            "NRXN2",
            "COL13A1",
            "PIR",
            "CX3CL1",
            "ADAMTS14",
            "LOC728392",
            "LOC400931",
            "KANK3",
            "EFNB1",
            "LTC4S",
            "APOB48R",
            "CKS1B",
            "MDGA1",
            "NPDC1",
            "RASGRP4",
            "ADCY4",
            "IFFO1",
            "MAPK11",
            "PLXDC1",
            "PLEKHA4",
            "MRC2",
            "KIAA1274",
            "PTRF",
            "LYL1",
            "ACAT2",
            "PRICKLE2",
            "VASH1",
            "SEPHS2",
            "DCLRE1A",
            "PDIA4",
            "DUSP7",
            "SLMO2",
            "SLC27A1",
            "POPDC2",
            "ZBTB46",
            "ABCA2",
            "CMTM7",
            "L2HGDH",
            "UBA7",
            "TK2",
            "MRS2",
            "TCEAL6",
            "PLK3",
            "PTPLAD1",
            "PDIA6",
            "PRDX3",
            "TH1L",
            "POU6F1",
            "SFXN3",
            "DAB2IP",
            "DAPK3",
            "KANK2",
            "VAPB",
            "LAMB2",
            "FAM119A",
            "ILF2",
            "SUCLG1",
            "ABR",
            "KIAA1539",
            "PPP2R5B",
            "RPN2",
            "NISCH",
            "PNPLA6",
            "RGS3",
            "FAM200A",
            "E2F6",
            "IQSEC1",
            "PDHX",
            "BCCIP",
            "TMEM43",
            "SLC39A13",
            "NDUFS1",
            "GMIP",
            "NIF3L1",
            "PRKAG1",
            "ZC3H15",
            "PDCD2",
            "MUM1",
            "XPC",
            "C2orf47",
            "TYK2",
            "ABCB10",
            "PIP5K1C",
            "PCBP2",
            "PPP1R9B",
            "GOLGA5",
            "ELL",
            "EML3",
            "VGLL4",
            "COIL",
            "TMEM115",
            "PRKACA",
            "USP4",
            "BAP1"
        ]
    },
    {
        "golabel": "ZBTB48_regulon_activity",
        "gene": [
            "TRPC2",
            "CACNA1F",
            "SERPINI2",
            "PCP2",
            "FLJ42875",
            "C1orf127",
            "ESPNP",
            "NRN1L",
            "MAPK15",
            "COL9A2",
            "SCNN1D",
            "GGT3P",
            "ZDHHC11",
            "C1orf228",
            "CCDC153",
            "TTC21A",
            "CCDC157",
            "MYO15A",
            "ATAD3C",
            "MORN1",
            "C10orf111",
            "TNFRSF25",
            "INPP5J",
            "ZMAT1",
            "FITM1",
            "LRRC56",
            "KATNAL2",
            "LOC400752",
            "CORT",
            "HSP90AB2P",
            "ADAM9",
            "UBXN11",
            "C1orf113",
            "DTX3",
            "CCNL2",
            "TNFRSF14",
            "SYTL1",
            "HYI",
            "CROCCL1",
            "LOC100133331",
            "IPMK",
            "ARHGEF19",
            "CSDAP1",
            "ROM1",
            "WBP11P1",
            "C1orf63",
            "APBB3",
            "C5orf45",
            "FLJ37453",
            "CCDC24",
            "FAAH",
            "IL11RA",
            "ANKS3",
            "WASH7P",
            "ZSCAN18",
            "ACAP3",
            "CASZ1",
            "ITGB1",
            "DDX21",
            "IQCC",
            "CCDC159",
            "SIGIRR",
            "MIB2",
            "FBXO44",
            "C21orf2",
            "ERLIN1",
            "DHRS1",
            "CSNK2A1P",
            "THAP3",
            "TREX1",
            "CNKSR1",
            "C1orf91",
            "ADAM10",
            "PAFAH1B2",
            "KIAA0495",
            "DMAP1",
            "NPHP4",
            "MTDH",
            "TMOD3",
            "ZNF691",
            "TMEM185B",
            "DFFB",
            "C12orf5",
            "TMCO4",
            "JMJD5",
            "C6orf70",
            "MBTPS2",
            "LOC148413",
            "NCDN",
            "IRF3",
            "M6PR",
            "EIF3J",
            "NADK",
            "MCFD2",
            "DNAJB2",
            "ZBTB17",
            "HK1",
            "CHUK",
            "NCKAP1",
            "POMT1",
            "DDX18",
            "WDR8",
            "PHF1",
            "GALT",
            "EIF2AK4",
            "CYFIP1",
            "CPSF3L",
            "RAD23B",
            "TMEM39B",
            "UBE2G1",
            "PICALM",
            "CDC27",
            "PTPN9",
            "ATMIN",
            "DYNC1I2",
            "BSDC1"
        ]
    },
    {
        "golabel": "ZBTB5_regulon_activity",
        "gene": [
            "SCML2",
            "WNK2",
            "IGFBPL1",
            "KRT7",
            "TXNDC16",
            "PRKCDBP",
            "TNFRSF12A",
            "ACVR2B",
            "RHOD",
            "CLTB",
            "MCM3APAS",
            "LOC100270710",
            "ANXA2P2",
            "SH3BGRL3",
            "ANXA2",
            "SS18L1",
            "PSIP1",
            "ZNF121",
            "SCAI",
            "TSPO",
            "ACPL2",
            "UNC119B",
            "ZNF124",
            "HPCAL1",
            "FBXO10",
            "POLD4",
            "ZNF566",
            "BCAR1",
            "PKM2",
            "VASP",
            "CCDC41",
            "ZNF623",
            "ZNF527",
            "ZNF782",
            "POLR1E",
            "AMFR",
            "PTPDC1",
            "C10orf137",
            "ZBTB26",
            "RG9MTD3",
            "MBTD1",
            "MCART1",
            "EXOSC3",
            "RFXAP",
            "ZCCHC7",
            "KLHL9",
            "CCDC117",
            "DCAF10",
            "C9orf82",
            "PPM1D",
            "RNF38",
            "ACTB",
            "RBM12B",
            "NFX1",
            "UBC",
            "ZNF510",
            "TSTD2"
        ]
    },
    {
        "golabel": "ZBTB6_regulon_activity",
        "gene": [
            "RFK",
            "CEMP1",
            "LRRC29",
            "HSPB1",
            "C20orf135",
            "LOC402377",
            "ANKS3",
            "UGCG",
            "ZNF420",
            "MIB2",
            "ZGPAT",
            "TMEM175",
            "INO80B",
            "DCUN1D1",
            "HDAC10",
            "C7orf27",
            "RABEP2",
            "GTF3C4",
            "RANBP6",
            "DOHH",
            "B3GAT3",
            "TELO2",
            "POLE3",
            "SLC38A10",
            "ZBTB26",
            "RCHY1",
            "PQLC2",
            "IPO7",
            "ZNF669",
            "TDRD7",
            "C9orf85",
            "RNF219",
            "E4F1",
            "DCAF10",
            "C17orf70",
            "CCDC22",
            "GRINL1A",
            "ZNF845",
            "CTDSPL2",
            "MIER3",
            "THAP5",
            "SART1",
            "NAGPA",
            "C9orf80",
            "NCOA4",
            "IKZF5",
            "ROD1",
            "C11orf46",
            "HGS",
            "SOCS4",
            "FAM108B1",
            "SMAD4",
            "NPRL3",
            "TBL3",
            "SHOC2",
            "NARG2",
            "ZNF510",
            "RBM18",
            "POLR2E",
            "ZNF800",
            "COG4",
            "PPP3R1",
            "ZBTB1",
            "ZNF148",
            "PSMD5",
            "TRIM32",
            "ASB7",
            "UBE3A",
            "ALG2",
            "HIAT1",
            "SPTLC1",
            "API5",
            "MARCH7",
            "RAB14",
            "ZNF143",
            "MAPKAP1",
            "PDCL",
            "FAM175B",
            "PPP6C"
        ]
    },
    {
        "golabel": "ZBTB7A_regulon_activity",
        "gene": [
            "ONECUT3",
            "GJB4",
            "VILL",
            "EPHB6",
            "ZBTB8B",
            "ZG16B",
            "ERN2",
            "HR",
            "CTSE",
            "IGFBPL1",
            "RND2",
            "PLCD3",
            "IL1RN",
            "ASPHD2",
            "SFRS13B",
            "GPR137C",
            "RNF39",
            "ITGB4",
            "ZFPM1",
            "EPHA2",
            "GPR153",
            "BRMS1L",
            "SLC45A3",
            "PRTFDC1",
            "SIP1",
            "FUT3",
            "RIN1",
            "ZNF572",
            "LDLR",
            "RARG",
            "MST1R",
            "DEPDC4",
            "PLEC",
            "MYO1E",
            "PTBP2",
            "TJP3",
            "SLC35C1",
            "CFL2",
            "PCDH1",
            "PPP2R3C",
            "C1orf93",
            "KCNK6",
            "SH2D3A",
            "C4orf46",
            "CD97",
            "EAPP",
            "SLC25A16",
            "C14orf126",
            "SMAD3",
            "LRRC8A",
            "C6orf132",
            "LENG9",
            "STAU2",
            "VBP1",
            "SLC25A33",
            "CEP70",
            "FAM102A",
            "LRRCC1",
            "ADSL",
            "C9orf167",
            "BCL9L",
            "ASF1A",
            "SBNO2",
            "PLXNB2",
            "FASTKD3",
            "NFIC",
            "MVP",
            "TRAPPC6B",
            "PHOSPHO2",
            "RIN3",
            "NGDN",
            "PSMC6",
            "PRPSAP2",
            "NARS2",
            "C17orf75",
            "MIDN",
            "C7orf44",
            "DPP9",
            "TRIM8",
            "ATL2",
            "RAD1",
            "DAB2IP",
            "MNAT1",
            "METTL3",
            "TICAM1",
            "PDE4A",
            "ILF2",
            "SUCLG1",
            "FAM129B",
            "TRIP10",
            "FASTKD1",
            "TNKS1BP1",
            "CNN2",
            "LRRC40",
            "SETMAR",
            "MKNK2",
            "IL4R",
            "SLC25A17",
            "ZNFX1",
            "HMGN1",
            "E2F6",
            "MAP2K3",
            "TTC7A",
            "SMYD2",
            "ARHGEF18",
            "MOBKL2A",
            "ZNHIT3",
            "SNX33",
            "ACTR10",
            "C2orf68",
            "RBBP4",
            "DNM2",
            "PIP5K1C",
            "MTERFD2",
            "SPTAN1",
            "RFX1",
            "AP3D1",
            "SPRYD3",
            "ARHGAP1",
            "SFRS7",
            "GTF2F1",
            "FEM1A",
            "RBMX"
        ]
    },
    {
        "golabel": "ZBTB7B_regulon_activity",
        "gene": [
            "DCST2",
            "LAYN",
            "PDCD1LG2",
            "C12orf24",
            "CCL2",
            "TSPAN2",
            "OPLAH",
            "SSPN",
            "ANKRD9",
            "SPIRE2",
            "APOBEC3G",
            "TCF4",
            "RORC",
            "C1orf226",
            "MUC1",
            "CHN1",
            "CGN",
            "EFNA1",
            "ITGA4",
            "TRPC1",
            "TUBA1A",
            "SHC1",
            "ZNF699",
            "TJP3",
            "SLC26A1",
            "AP1S2",
            "ANO8",
            "C21orf91",
            "CNRIP1",
            "PVRL4",
            "KCTD12",
            "IGSF8",
            "LPAR6",
            "PBXIP1",
            "TMEM55A",
            "SLC4A7",
            "C17orf28",
            "RAB40C",
            "PIM3",
            "TRAF2",
            "ARHGEF16",
            "IKBIP",
            "C9orf72",
            "EXD3",
            "RAB25",
            "TWSG1",
            "ADAM15",
            "MTHFR",
            "ARL6",
            "ZBTB42",
            "KIAA1543",
            "CLIC4",
            "LLGL2",
            "KIAA0284",
            "DGKQ",
            "GABPB2",
            "PWWP2B",
            "DNAJC18",
            "GAK",
            "BACE1",
            "KIAA0664",
            "FBXW5",
            "ULK1",
            "PITRM1",
            "NDOR1",
            "SIX5",
            "KIAA0649",
            "SGTB",
            "TNK1",
            "KIAA1522",
            "ZNF687",
            "BRF1",
            "CBX4",
            "SLC38A10",
            "CCDC9",
            "NTAN1",
            "TRIM11",
            "F11R",
            "RNPEP",
            "NCSTN",
            "ZNF267",
            "ZNF213",
            "C9orf86",
            "SLC39A1",
            "MEF2D",
            "CMTM6",
            "NADK",
            "RNF44",
            "TMEM188",
            "ZBTB45",
            "SCAMP3",
            "NDUFS2",
            "NCKIPSD",
            "ADIPOR1",
            "SEPT7",
            "ZNF672",
            "ARF1",
            "ARL8A",
            "ATG9A"
        ]
    },
    {
        "golabel": "ZC3H11A_regulon_activity",
        "gene": [
            "TIMP4",
            "TEDDM1",
            "LILRA5",
            "VSIG4",
            "CCL3",
            "C10orf125",
            "BCL2A1",
            "RAP1B",
            "C1QB",
            "FCGR1A",
            "FCGR1C",
            "FCGR1B",
            "C1QC",
            "C1QA",
            "SIGLEC7",
            "ARL11",
            "CD14",
            "SIGLEC9",
            "RAB32",
            "CD300A",
            "FCER1G",
            "PILRA",
            "HAVCR2",
            "CD68",
            "LRRC25",
            "ATP2B4",
            "C1orf106",
            "LAPTM5",
            "SLC31A2",
            "CTSC",
            "FLJ90757",
            "TTC5",
            "CTSB",
            "ADSL",
            "TMEM63A",
            "YOD1",
            "CHCHD6",
            "MDM4",
            "TMEM81",
            "GABPB2",
            "LOC90784",
            "MRPL49",
            "UBL4A",
            "PEX3",
            "RPL23AP82",
            "GYG1",
            "SRRM2",
            "SNX3",
            "PEPD",
            "POGZ",
            "PRCP",
            "TTC13",
            "AMFR",
            "ADCK2",
            "SDHD",
            "MIA3",
            "PSAP",
            "MAP1LC3B2",
            "MTX3",
            "KDM5B",
            "C3orf39",
            "SEC16A",
            "GOLGA3",
            "SDHB",
            "C6orf120",
            "C1orf27",
            "SNX11",
            "PCMT1",
            "HCCS",
            "LYRM2",
            "TPR",
            "SNX17",
            "MLH3",
            "MTCH1",
            "TMEM199",
            "ARID4B",
            "TINF2",
            "MAPKAPK2",
            "C1orf144",
            "WDR26"
        ]
    },
    {
        "golabel": "ZC3H13_regulon_activity",
        "gene": [
            "SELM",
            "ST20",
            "FAM195A",
            "TIMM16",
            "ZNHIT1",
            "GUK1",
            "BOLA1",
            "ATP6V0B",
            "MAP4K4",
            "DISC1",
            "SIVA1",
            "TRAPPC5",
            "UQCR11",
            "ARL16",
            "C13orf23",
            "HCG11",
            "ROCK2",
            "ZFYVE19",
            "GSDMD",
            "SPTBN1",
            "RIF1",
            "KATNAL1",
            "THAP3",
            "SNRNP25",
            "ERC1",
            "MED1",
            "MYCBP2",
            "C1orf122",
            "USP12",
            "NCOA1",
            "LATS2",
            "FAM98B",
            "NCOR1",
            "KLF3",
            "KIAA0564",
            "TJP1",
            "BOD1L",
            "NUFIP1",
            "APC",
            "NPRL2",
            "CXorf40A",
            "AKAP11",
            "BAT2L2",
            "EIF3A",
            "KIDINS220",
            "BMPR2",
            "YLPM1",
            "MPHOSPH8",
            "C17orf62",
            "UTP14C",
            "ANKRD17",
            "UNC119",
            "EP300",
            "RANBP2",
            "PDS5B",
            "TOP2B",
            "NSD1",
            "ELF1",
            "PIKFYVE",
            "RBM26",
            "SMARCA5",
            "SOS1",
            "USP47",
            "GIGYF2",
            "RAB3GAP1",
            "CTCF",
            "THRAP3"
        ]
    },
    {
        "golabel": "ZC3H15_regulon_activity",
        "gene": [
            "SRXN1",
            "GGT3P",
            "CAPN3",
            "ICAM5",
            "GCLM",
            "CCNB2",
            "PBK",
            "FAM189A2",
            "OIP5",
            "MAD2L1",
            "C12orf48",
            "DEPDC1",
            "MUSTN1",
            "RAD51AP1",
            "SPC25",
            "DSCC1",
            "KIAA1524",
            "CKAP2L",
            "CDK1",
            "LRP2BP",
            "CCNA2",
            "SGOL1",
            "ESCO2",
            "NEK2",
            "EBF4",
            "BUB1",
            "RRM2",
            "RAPGEF3",
            "ADAMTSL2",
            "MEGF6",
            "SLC25A29",
            "TBX2",
            "BAG2",
            "LIMS2",
            "KIF18A",
            "CCNB1",
            "C22orf36",
            "LYPLA1",
            "SGOL2",
            "ECT2",
            "MTHFD2",
            "CROCC",
            "RACGAP1",
            "RFC3",
            "GOLT1B",
            "MRPS35",
            "SLC27A3",
            "CKAP2",
            "MRPL13",
            "MTFR1",
            "KPNA2",
            "C13orf37",
            "EPT1",
            "NOD1",
            "C16orf48",
            "C12orf11",
            "TENC1",
            "AGPAT5",
            "C14orf129",
            "TLE2",
            "COMMD8",
            "ECHDC2",
            "CRIPT",
            "SGSM2",
            "HSFX2",
            "PPAT",
            "RAN",
            "CCDC58",
            "ZNF862",
            "CENPL",
            "SLMO2",
            "MAPK6",
            "VBP1",
            "TUBGCP6",
            "ZWILCH",
            "CRY2",
            "SUV39H2",
            "HSPE1",
            "HSPD1",
            "CYCS",
            "OSTC",
            "PDCD10",
            "NUDCD1",
            "TMEM182",
            "CDK8",
            "ERGIC2",
            "YARS2",
            "STRAP",
            "OTUD6B",
            "NUP37",
            "ZNF211",
            "MAP3K6",
            "DNAJC10",
            "DARS2",
            "C16orf5",
            "EEF1E1",
            "KIAA0467",
            "ARMC1",
            "MIB2",
            "TFAM",
            "TWF1",
            "GPN1",
            "SSR3",
            "TXNDC9",
            "BZW1",
            "MRPL42",
            "ATP5G3",
            "RG9MTD2",
            "C21orf2",
            "LOC729020",
            "WDR12",
            "METTL2B",
            "ORC5L",
            "RSRC1",
            "NDUFB3",
            "RAB11FIP3",
            "OLA1",
            "PSMD14",
            "SLC35F5",
            "YIPF6",
            "PNO1",
            "PUS7L",
            "UBE2Q2",
            "HSP90AA1",
            "ARHGEF17",
            "NUDT15",
            "TOM1L2",
            "ZC3H8",
            "CIRBP",
            "NMD3",
            "AGFG1",
            "CCT4",
            "TSN",
            "MKI67IP",
            "C2orf49",
            "SFXN1",
            "PIGQ",
            "NUP35",
            "TAF1A",
            "LAMB2",
            "ZBTB47",
            "YWHAQ",
            "ZNF362",
            "KIAA1715",
            "NCKAP5L",
            "MTERF",
            "METTL2A",
            "TEX10",
            "RAB10",
            "MARS2",
            "WDR43",
            "ORC4L",
            "RINT1",
            "MTDH",
            "FASTKD1",
            "PRMT3",
            "MOBKL3",
            "RARA",
            "DLD",
            "NISCH",
            "NAA50",
            "CCDC92",
            "RPE",
            "CISD2",
            "DGCR2",
            "CLEC16A",
            "TMEM185B",
            "C12orf5",
            "MMADHC",
            "JMJD5",
            "NDUFS1",
            "NAA15",
            "GPD2",
            "VRK2",
            "GTF2E1",
            "AAGAB",
            "DNAJA1",
            "MAP3K3",
            "CSNK2A1",
            "MOBKL1B",
            "SRP72",
            "EIF2S1",
            "KPNA4",
            "ARL5A",
            "MRPL30",
            "SUMO1P3",
            "UBE2K",
            "NIF3L1",
            "MRPL3",
            "HDAC5",
            "COPS8",
            "ACTR3",
            "SLC25A32",
            "TIMM17A",
            "KCMF1",
            "C2orf69",
            "IARS",
            "ABCE1",
            "G3BP1",
            "EIF3J",
            "C2orf47",
            "RQCD1",
            "SSB",
            "ASNSD1",
            "UCHL5",
            "ENOPH1",
            "HAT1",
            "CAMTA2",
            "AGPS",
            "DARS",
            "DDX18",
            "TOMM70A",
            "ACP1",
            "TLK1",
            "GTF3C3",
            "WDR75",
            "NAA35",
            "MRPL44",
            "SUMO1",
            "TMX2",
            "RFX1",
            "PPID",
            "METAP1",
            "PWP1",
            "PRKRA",
            "WDTC1",
            "ZER1",
            "CEBPZ",
            "PPP3R1",
            "GORASP2",
            "GABPB1",
            "PRPF40A",
            "XRCC5",
            "CDC73",
            "FASTKD2",
            "MARCH7",
            "PLEKHA3",
            "ACTR2",
            "UBXN4",
            "ZNF207"
        ]
    },
    {
        "golabel": "ZC3H3_regulon_activity",
        "gene": [
            "GPT2",
            "CPA3",
            "RERG",
            "EPPK1",
            "C8orf73",
            "RRS1",
            "PTP4A3",
            "RECQL4",
            "OPLAH",
            "GLI4",
            "NFKBIL2",
            "PLEC",
            "MORF4",
            "AGPAT6",
            "PRDM5",
            "FAM118B",
            "ARHGAP39",
            "PPP1R16A",
            "TOP1MT",
            "FAM83H",
            "SCRIB",
            "FBXL6",
            "EIF2C2",
            "APH1B",
            "STOM",
            "FBRSL1",
            "TRAPPC9",
            "PUS1",
            "FBXL19",
            "CPSF1",
            "CLN5",
            "ZNF707",
            "BTD",
            "MTA1",
            "DTWD2",
            "PPAN",
            "TMEM30A",
            "CYHR1",
            "PTDSS2",
            "CCNDBP1",
            "MTMR6",
            "CBX4",
            "HSF1",
            "EHMT2",
            "RTKN",
            "TRIM11",
            "SF3B4",
            "ABHD13",
            "NOC4L",
            "C6orf211",
            "GMEB2",
            "C17orf70",
            "COPS4",
            "SLC35A5",
            "SART1",
            "SPG20",
            "LYRM2",
            "HGS",
            "REXO1",
            "SRRT",
            "CRTC2",
            "SMPD4",
            "FOXK2",
            "EID1",
            "ZNF282",
            "PLDN",
            "CDC40",
            "BTBD1",
            "DAZAP1"
        ]
    },
    {
        "golabel": "ZC3H4_regulon_activity",
        "gene": [
            "ANKRD37",
            "STON2",
            "STAG3L4",
            "PPP2R3C",
            "TRAM1",
            "MRPL33",
            "SYNE2",
            "UBE2W",
            "SEP15",
            "SRI",
            "STARD3NL",
            "PCNXL2",
            "CREM",
            "MRS2",
            "SSR3",
            "TET3",
            "RBM3",
            "YIPF6",
            "DPH5",
            "TM2D1",
            "RINT1",
            "ZNF629",
            "DYNC1H1",
            "YRDC",
            "DRAM2",
            "DPH3",
            "PRR12",
            "PNPLA8",
            "ATG4A",
            "NUMA1",
            "EIF2B3",
            "SETD1A",
            "MLX",
            "KIAA1967",
            "SETD1B",
            "WIZ",
            "ANKRD11",
            "PPP1R10",
            "ZNF766",
            "DGCR8",
            "ZC3H18",
            "SFRS15",
            "RBBP6",
            "RBM15B",
            "UBTF"
        ]
    },
    {
        "golabel": "ZC3H6_regulon_activity",
        "gene": [
            "EIF4EBP1",
            "ZMAT1",
            "KATNAL2",
            "MRPS12",
            "TIGD4",
            "GRID2IP",
            "BRI3BP",
            "PPP1R9A",
            "C6orf115",
            "BID",
            "FAM120C",
            "RANBP1",
            "GTF2IRD2B",
            "TUBA1C",
            "PSMC4",
            "KIAA1109",
            "VASP",
            "BAK1",
            "NFAT5",
            "AP2S1",
            "ARID4A",
            "EIF2C4",
            "SNX13",
            "PRMT1",
            "DNAJC27",
            "ZFYVE20",
            "HM13",
            "MTR",
            "ZNF720",
            "ZNF12",
            "PES1",
            "CALM3",
            "NEK9",
            "GRWD1",
            "ETAA1",
            "CDK13",
            "DYRK1A"
        ]
    },
    {
        "golabel": "ZC3H7A_regulon_activity",
        "gene": [
            "C15orf50",
            "PRMT8",
            "RGS20",
            "CST6",
            "C15orf48",
            "GPR98",
            "CACNA2D2",
            "ERO1LB",
            "AFF3",
            "CIT",
            "LGSN",
            "GPR133",
            "PPARG",
            "ABAT",
            "TFCP2L1",
            "OASL",
            "SORBS2",
            "ATP8A1",
            "AMIGO2",
            "ABCC4",
            "FAM3C",
            "SETBP1",
            "CENPW",
            "NCRNA00152",
            "UPP1",
            "PAIP2B",
            "TMEM80",
            "LPIN2",
            "CABLES1",
            "LOC541471",
            "EFCAB2",
            "SLC22A23",
            "RRM2",
            "KRT19",
            "OAT",
            "S100A16",
            "SFN",
            "PPP1R3B",
            "PLXNA2",
            "TK1",
            "CENPM",
            "UNC13B",
            "ZNF397",
            "HOMER3",
            "CDCA4",
            "NCS1",
            "TBC1D8",
            "IFT140",
            "OPHN1",
            "TUBA4A",
            "RNASEH2A",
            "GAPDH",
            "MAD2L2",
            "EPHA1",
            "RHOC",
            "GGT7",
            "BID",
            "PSMB3",
            "RPA3",
            "POP7",
            "ATF7IP2",
            "LIMK1",
            "CCDC90B",
            "CRY2",
            "MED10",
            "FMNL2",
            "TUBA1C",
            "C13orf23",
            "NUDT1",
            "LNX2",
            "CP110",
            "THOC4",
            "DOCK1",
            "ZNF75D",
            "MDM4",
            "ATP6V1F",
            "TUBA1B",
            "RFC2",
            "FAM100B",
            "C21orf70",
            "TXNDC11",
            "VAT1",
            "PARP12",
            "CDK5",
            "PDCD4",
            "SRRM2",
            "ASH1L",
            "SNN",
            "KIF3A",
            "SSBP1",
            "AP2S1",
            "ZNF33A",
            "SWAP70",
            "CLEC16A",
            "PAPD5",
            "C7orf25",
            "RBL2",
            "C7orf49",
            "RCOR3",
            "DDX17",
            "KIAA0430",
            "AP2M1",
            "CNST",
            "ZNF720",
            "ZNF500",
            "REV1",
            "ABCF2",
            "GSPT1",
            "ZXDC",
            "USP47",
            "USP7",
            "RAB8A",
            "GLYR1"
        ]
    },
    {
        "golabel": "ZC3H7B_regulon_activity",
        "gene": [
            "ELFN2",
            "POM121L10P",
            "LOC284837",
            "RAP1B",
            "COX6B1",
            "SNRPG",
            "CBX6",
            "TEF",
            "PFDN4",
            "ZNRF3",
            "PRDM11",
            "POMP",
            "CRIPT",
            "SHANK3",
            "VPS29",
            "CCDC59",
            "C1orf89",
            "MRPL47",
            "ZFP41",
            "MTMR3",
            "NF2",
            "SARNP",
            "ZDHHC8",
            "PACSIN2",
            "ARHGEF17",
            "MYH9",
            "C22orf46",
            "FAM18B2",
            "BCR",
            "PI4KA",
            "TMEM184B",
            "ARPC5",
            "ARPC3",
            "CABIN1",
            "SREBF2",
            "CCDC134",
            "MOBKL3",
            "PSMA4",
            "CYB5R3",
            "HIRA",
            "DGCR2",
            "TOB2",
            "YAF2",
            "NDUFA12",
            "GTPBP1",
            "RBM9",
            "TAOK2",
            "SKI",
            "IL17RA",
            "TAF9",
            "HCCS",
            "CYTSA",
            "EP300",
            "BRD1",
            "ISCA1",
            "DEPDC5",
            "DCTN1",
            "AGPAT3",
            "COQ10B",
            "AP1B1",
            "L3MBTL2",
            "AMBRA1",
            "POLDIP3",
            "EIF4ENIF1"
        ]
    },
    {
        "golabel": "ZC3HAV1_regulon_activity",
        "gene": [
            "MRPL54",
            "NDUFA13",
            "RNF213",
            "TRAPPC5",
            "SCAND1",
            "NUDT16L1",
            "ALKBH7",
            "MPG",
            "BCL7C",
            "KIAA1147",
            "VKORC1",
            "ERCC1",
            "TRIM14",
            "MAGED2",
            "CBL",
            "SMC3",
            "PARP14",
            "UHRF1BP1",
            "TRIM25",
            "ARMCX6",
            "USE1",
            "UBN2",
            "NUBP2",
            "B4GALT7",
            "SMCR7L",
            "ZNF828",
            "FLYWCH2",
            "DTX3L",
            "LOC729991",
            "CHMP6",
            "ADAR",
            "C22orf30",
            "MTF1",
            "PIN1",
            "HYAL2",
            "R3HCC1",
            "KIAA0368",
            "GPR107",
            "FAM120A",
            "FBXW2",
            "NUFIP2",
            "RBM15",
            "GOLGA1",
            "NUP214",
            "CNOT4"
        ]
    },
    {
        "golabel": "ZCCHC6_regulon_activity",
        "gene": [
            "NCR1",
            "MRPS28",
            "QPRT",
            "AHNAK",
            "MXD1",
            "STRA13",
            "ROMO1",
            "C6orf129",
            "MTCP1NB",
            "NDUFB9",
            "MACROD1",
            "HSD17B8",
            "TIMM17B",
            "LAGE3",
            "C6orf125",
            "PEMT",
            "ATP6V0E2",
            "C12orf35",
            "LSM2",
            "CCDC56",
            "CORO2A",
            "MDP1",
            "NEU1",
            "NTHL1",
            "MYOF",
            "ZNF593",
            "COX6A1",
            "ANAPC11",
            "TMEM9",
            "LRRC8A",
            "FLNB",
            "TSPAN6",
            "SHISA4",
            "BPHL",
            "C11orf31",
            "FAM63B",
            "FAM96B",
            "ARAP2",
            "NDUFB11",
            "C9orf129",
            "C10orf35",
            "RPS19BP1",
            "RPP21",
            "VPS13A",
            "BCL7C",
            "TMEM2",
            "NDUFS8",
            "SMARCA2",
            "RC3H2",
            "DGCR6L",
            "FAM195B",
            "GPAA1",
            "C13orf31",
            "MRPL53",
            "TRIM14",
            "FAM3A",
            "CRYBG3",
            "C9orf102",
            "THAP3",
            "AURKAIP1",
            "MRPL2",
            "FLOT1",
            "TJP2",
            "MRPL27",
            "CEP110",
            "ANKRD39",
            "NDUFC2",
            "SEMA4D",
            "MRPS18B",
            "MYCBP2",
            "C9orf41",
            "ARHGAP21",
            "COX8A",
            "BANF1",
            "ZNF821",
            "MEA1",
            "NUBP2",
            "SNRPC",
            "PTAR1",
            "TMOD3",
            "DENND4A",
            "HSD17B10",
            "SETMAR",
            "GOLGA4",
            "DENND4C",
            "BICD2",
            "KIAA1432",
            "ARL6IP4",
            "MIF4GD",
            "SLC12A6",
            "AKR7A2",
            "GNAQ",
            "VPS25",
            "WBP1",
            "KIAA2026",
            "SLC37A4",
            "RPUSD3",
            "ERI3",
            "SLC25A11",
            "EIF3I",
            "AKAP11",
            "ERGIC3",
            "GOLGB1",
            "SMC5",
            "GAPVD1",
            "DDOST",
            "VEGFB",
            "JAK1",
            "KIAA0368",
            "TMF1",
            "SETX",
            "PHF2",
            "FKBP15",
            "OTUD4",
            "TTF1",
            "FAM120A",
            "IKBKAP",
            "FBXW2",
            "C9orf64",
            "NOL8",
            "SP1",
            "HIATL1",
            "ALG2",
            "SPTLC1",
            "UBQLN1",
            "AP3B1",
            "SPIN1",
            "STX17",
            "RAB14",
            "RNF20"
        ]
    },
    {
        "golabel": "ZDHHC1_regulon_activity",
        "gene": [
            "SEC14L3",
            "C13orf26",
            "GSTA3",
            "SERPIND1",
            "CCDC108",
            "DLEC1",
            "SLC16A11",
            "SNTN",
            "DYNLRB2",
            "C2orf40",
            "C2orf62",
            "LRRC36",
            "SPEF1",
            "CCDC151",
            "RSPH1",
            "TCTEX1D4",
            "C10orf107",
            "C5orf49",
            "FAM81B",
            "RSPH9",
            "C16orf71",
            "TPPP3",
            "NHLRC4",
            "IFNG",
            "C17orf72",
            "EFCAB6",
            "C6orf217",
            "ACSM1",
            "PPIL6",
            "BEST4",
            "C6orf154",
            "NME5",
            "C9orf98",
            "RIBC1",
            "SLC9A5",
            "HSD11B2",
            "TMEM231",
            "CCNB2",
            "GPR172B",
            "CLSPN",
            "CCDC157",
            "FANK1",
            "C9orf9",
            "RAB36",
            "MCM10",
            "DEPDC1",
            "NDC80",
            "PRR11",
            "CES8",
            "DEPDC1B",
            "CASC5",
            "TTK",
            "KIF15",
            "ZMYND12",
            "DLGAP5",
            "TPX2",
            "POLQ",
            "KIF23",
            "KIF2C",
            "KIF14",
            "RAD51AP1",
            "CDCA2",
            "CENPE",
            "HJURP",
            "KIAA1524",
            "RGN",
            "CKAP2L",
            "CCNA2",
            "SGOL1",
            "NCAPG",
            "BUB1B",
            "MELK",
            "ARHGAP11A",
            "ASPM",
            "STK33",
            "NCAPH",
            "BUB1",
            "TOP2A",
            "KIF4A",
            "C17orf97",
            "SMARCD3",
            "KIF18A",
            "HSPB8",
            "PLK4",
            "KIF20A",
            "LCA5L",
            "SGOL2",
            "KIF11",
            "ECT2",
            "GSG2",
            "ATAD2",
            "LOC100130987",
            "C15orf56",
            "NUSAP1",
            "CKAP2",
            "OSCP1",
            "ZNF219",
            "KIF20B",
            "C16orf48",
            "FAM116B",
            "DBF4",
            "TMEM204",
            "FAAH",
            "PPAT",
            "LOC158572",
            "FDXR",
            "B3GNT9",
            "MAPRE3",
            "C3orf18",
            "LY6G5C",
            "TCTN1",
            "CDK20",
            "CCDC102A",
            "ZNF688",
            "GAS8",
            "KIAA0020",
            "FUK",
            "PIGQ",
            "BBS5",
            "TRADD",
            "FBXW4",
            "CLN3",
            "ATP6V0D1",
            "PRMT7",
            "GEMIN8",
            "KATNB1",
            "ARAF",
            "PSKH1",
            "FBXO31",
            "VPS4A"
        ]
    },
    {
        "golabel": "ZDHHC16_regulon_activity",
        "gene": [
            "UMODL1",
            "C15orf50",
            "LOC145837",
            "GFRA3",
            "GPR98",
            "ERO1LB",
            "HMGB3",
            "AQP3",
            "SYT7",
            "TSNARE1",
            "GOLGA7B",
            "TXLNB",
            "OVGP1",
            "PPP1R3G",
            "JAG1",
            "TFRC",
            "SULT1A2",
            "FAM124A",
            "ADAM19",
            "LDLRAD3",
            "DRAM1",
            "SEMA3C",
            "LASS4",
            "ATP1B1",
            "DST",
            "FYB",
            "AGA",
            "FAM131B",
            "IL18R1",
            "CABLES1",
            "SAMD9",
            "GYLTL1B",
            "GPR160",
            "OAT",
            "CDCP1",
            "KLHDC9",
            "GPR39",
            "C14orf49",
            "ETV4",
            "HAPLN3",
            "CLIP2",
            "LAPTM4B",
            "SAMD9L",
            "ACSL5",
            "MXD1",
            "CNTLN",
            "PPFIBP1",
            "DCXR",
            "STARD10",
            "GYG2",
            "TLR6",
            "RPH3AL",
            "GRAMD4",
            "MAP7D3",
            "LOC100302401",
            "CDK2AP2",
            "TNFAIP3",
            "SERPINB9",
            "GBP2",
            "SNHG7",
            "LOC220930",
            "TPBG",
            "NKX2-1",
            "PLCXD2",
            "BICD1",
            "C8orf38",
            "ACAT1",
            "DDX60L",
            "C1orf210",
            "SIRPA",
            "RASA3",
            "ProSAPiP1",
            "ELK3",
            "C3orf34",
            "FN3K",
            "ARRB1",
            "SIRT4",
            "NTHL1",
            "OBFC2A",
            "CMTM1",
            "SLC20A1",
            "RANGRF",
            "KCNS3",
            "TMEM9",
            "MPP7",
            "RAB40B",
            "KIAA1949",
            "SFXN2",
            "GBE1",
            "ATP10D",
            "CHCHD7",
            "PRKAB1",
            "ASAP1",
            "RALGPS2",
            "MAP3K5",
            "PLEKHA2",
            "LRRC27",
            "PRSS16",
            "FAM190B",
            "LASS2",
            "DHRS7B",
            "FBXO25",
            "RPAIN",
            "DPM2",
            "PCBD1",
            "PMF1",
            "ATL2",
            "ATP11B",
            "ZYX",
            "LRCH1",
            "BSCL2",
            "C10orf32",
            "KIAA0146",
            "HPS5",
            "GLT25D1",
            "PEBP1",
            "TMEM140",
            "TRAPPC1",
            "CYB561",
            "C14orf118",
            "ANO6",
            "BBX",
            "SAPS1",
            "PATL1",
            "EXOSC1",
            "IKZF5",
            "DNAJC13",
            "GNA13",
            "PTPMT1",
            "RNGTT",
            "SFT2D3",
            "CYFIP1",
            "MAP3K7",
            "PPP2R2D",
            "NUP62",
            "POLL",
            "OXSR1",
            "SEC24C",
            "C10orf76",
            "ACTR1A"
        ]
    },
    {
        "golabel": "ZDHHC2_regulon_activity",
        "gene": [
            "PKMYT1",
            "CHTF18",
            "HOMER3",
            "EFHA2",
            "CD302",
            "MTUS1",
            "PCM1",
            "C8orf42",
            "ASAH1",
            "BTG1",
            "FBXL19",
            "FBXO25",
            "KLF16",
            "ZNF395",
            "RPL23AP53",
            "PPAN",
            "BBS10",
            "ALG3",
            "C10orf32",
            "GLT25D1",
            "CCDC137",
            "ZNF598",
            "RNF126",
            "NACC1",
            "RANGAP1",
            "RRP1",
            "LMBRD1",
            "PIGN",
            "FBXL3",
            "CNOT7",
            "FBXO3",
            "SART1",
            "TMEM66",
            "PPP3CC",
            "IKZF5",
            "HDGFRP2",
            "RAVER1",
            "HGS",
            "NCLN",
            "REXO1",
            "SOCS5",
            "SACM1L",
            "CDC37",
            "SMAD4",
            "CARM1",
            "ABCF3",
            "AZI2",
            "API5",
            "DAZAP1",
            "PTBP1"
        ]
    },
    {
        "golabel": "ZDHHC21_regulon_activity",
        "gene": [
            "TNS4",
            "STK32A",
            "EGFL8",
            "SFTA3",
            "ATP11A",
            "FNIP2",
            "XPR1",
            "RNF19A",
            "TRIM2",
            "NKX2-1",
            "ARHGEF38",
            "REL",
            "H2AFJ",
            "PELI1",
            "C14orf80",
            "ZNF254",
            "MLLT3",
            "RAPGEF6",
            "PHLDB3",
            "NRM",
            "NFIB",
            "KANK1",
            "EDEM1",
            "ANKRD50",
            "LNX2",
            "NFKB2",
            "PPAPDC2",
            "ZNF678",
            "FAM65A",
            "BCAR1",
            "VASP",
            "CASD1",
            "WRAP53",
            "MKL2",
            "DCAF12",
            "TMEM189",
            "PTAR1",
            "ACD",
            "UBAP1",
            "DENND4C",
            "SNAPC3",
            "FBXO38",
            "AK3",
            "KLHL8",
            "KIAA2026",
            "TMEM192",
            "LYSMD3",
            "NUDC",
            "HDGFRP2",
            "RNF38",
            "CHMP1A",
            "USP38",
            "DCTN4",
            "ZMYM5",
            "NFX1",
            "PWWP2A",
            "PEX13",
            "PDE12"
        ]
    },
    {
        "golabel": "ZDHHC6_regulon_activity",
        "gene": [
            "RSL24D1",
            "RPL27",
            "C1orf31",
            "IDI1",
            "MRPL33",
            "MCEE",
            "SCOC",
            "HBXIP",
            "C18orf32",
            "COMMD3",
            "C10orf78",
            "TGDS",
            "C2orf64",
            "AHDC1",
            "MRS2",
            "C1orf43",
            "NDUFB3",
            "PIGF",
            "WDR61",
            "C10orf84",
            "ATP5C1",
            "NCRNA00081",
            "ARL3",
            "NDUFB8",
            "USP11",
            "CHMP5",
            "CHCHD1",
            "MRPL43",
            "MRPL50",
            "SRP9",
            "GRLF1",
            "TFB2M",
            "CISD1",
            "UROS",
            "GHITM",
            "DYNC1H1",
            "FAM45B",
            "NCOR2",
            "ECHS1",
            "PRR12",
            "ZFAND6",
            "FAM103A1",
            "DUT",
            "AAGAB",
            "SEC11A",
            "SKI",
            "PIGC",
            "UNC50",
            "TIMM17A",
            "MED12",
            "SPEN",
            "ARID1A",
            "CREBBP",
            "FAM45A",
            "YIPF4",
            "MIS12",
            "KDM4B",
            "APTX",
            "SETD1B",
            "SPTAN1",
            "VPS26A",
            "EIF1",
            "FAM35A",
            "SHOC2",
            "TSG101",
            "CUEDC2",
            "ARPP19",
            "SLC35B3",
            "ATAD1",
            "HNRNPF",
            "NRBF2",
            "ARHGAP17",
            "C15orf44",
            "TIAL1",
            "PLEKHM2",
            "SPG21",
            "SAR1A",
            "UBTF"
        ]
    },
    {
        "golabel": "ZDHHC7_regulon_activity",
        "gene": [
            "VILL",
            "COL17A1",
            "BCAS1",
            "SHH",
            "FA2H",
            "FAM64A",
            "REEP2",
            "CCNB2",
            "CCNE2",
            "CDKN3",
            "CKS2",
            "TROAP",
            "POLE2",
            "CENPA",
            "MAD2L1",
            "MCM10",
            "C12orf48",
            "AURKB",
            "PLLP",
            "LIPH",
            "ZFPM1",
            "NUF2",
            "EPHA2",
            "TTK",
            "C12orf24",
            "ABHD2",
            "EPR1",
            "PLCE1",
            "CENPW",
            "CDC25C",
            "BIRC5",
            "DSCC1",
            "TMC7",
            "CDK1",
            "PAQR8",
            "SGOL1",
            "NCAPG",
            "GINS1",
            "KIAA0101",
            "SNHG6",
            "ALS2CL",
            "CCDC138",
            "RGNEF",
            "UBE2T",
            "TRPM4",
            "PKDREJ",
            "WASF1",
            "PTTG1",
            "SNRPG",
            "CCNB1",
            "AHNAK",
            "C15orf52",
            "TTC22",
            "MTHFD2",
            "MEST",
            "PTPRU",
            "THRB",
            "HAUS1",
            "RACGAP1",
            "RAD54B",
            "C20orf54",
            "CALML4",
            "MAML2",
            "FBXO5",
            "KPNA2",
            "PPIL5",
            "PPL",
            "PCDH1",
            "KIAA0513",
            "POC1A",
            "MYH14",
            "NME1",
            "SOX13",
            "DBF4",
            "C9orf40",
            "AKAP13",
            "RNF144B",
            "VRK1",
            "GPR56",
            "PTPN21",
            "BOLA3",
            "TOMM5",
            "SGK223",
            "RAN",
            "C6orf132",
            "TMPO",
            "CENPL",
            "MYL6B",
            "H2AFZ",
            "CREM",
            "SLC27A1",
            "PDSS1",
            "SUV39H2",
            "MYO1D",
            "RFC5",
            "USP54",
            "FAM38A",
            "SNRPF",
            "TDG",
            "CCDC59",
            "WFS1",
            "TK2",
            "FANCG",
            "DDX39",
            "EZR",
            "C12orf73",
            "MRPL42",
            "COPS3",
            "CDH1",
            "ARHGAP27",
            "SERF1A",
            "EPB41L1",
            "PACSIN2",
            "CES2",
            "BCAR1",
            "TRAK1",
            "TIFA",
            "CAPN2",
            "SLC12A4",
            "RAP2A",
            "VPS13D",
            "OBFC2B",
            "KIAA1522",
            "RNASEL",
            "PCGF6",
            "UBE2N",
            "EXOSC3",
            "SCAMP2",
            "TPRG1L",
            "ZCCHC7",
            "C12orf65",
            "CSRNP2",
            "WWP2",
            "TCF25",
            "BBS2",
            "ZCCHC14",
            "NLRX1",
            "ATXN1L",
            "CTNND1",
            "WHAMM",
            "GLG1",
            "N4BP1",
            "MBTPS1",
            "DYNC1LI2",
            "AP1G1",
            "KIAA0174"
        ]
    },
    {
        "golabel": "ZEB1_regulon_activity",
        "gene": [
            "FLG",
            "HAS2",
            "TNN",
            "GRIA3",
            "WNT2B",
            "FBLN5",
            "FGF2",
            "KLF17",
            "C21orf7",
            "BNC2",
            "ITGA8",
            "NPR3",
            "PCDHGA9",
            "SEMA5A",
            "UNC5C",
            "MAP1A",
            "TMEM200A",
            "RUNX1T1",
            "PRKG1",
            "C14orf132",
            "C6orf114",
            "TSPAN2",
            "FAM13C",
            "GLI2",
            "ITGA1",
            "SGIP1",
            "SYNPO2",
            "EDNRA",
            "PCDHGB7",
            "CACNA1C",
            "TNFAIP8L3",
            "ECM2",
            "FILIP1L",
            "CLIP2",
            "C10orf72",
            "PDZRN3",
            "OLFML1",
            "KIRREL",
            "MCC",
            "MSRB3",
            "TCF4",
            "PPFIBP1",
            "AGPAT4",
            "TBX5",
            "CC2D2B",
            "LDB2",
            "MRVI1",
            "RFTN2",
            "PCDH18",
            "F2R",
            "PDE5A",
            "SYNM",
            "PDGFRB",
            "SLC29A2",
            "RECK",
            "FLJ10357",
            "CNRIP1",
            "ANTXR2",
            "RASA3",
            "RHOJ",
            "SLC25A10",
            "ZEB2",
            "PLSCR4",
            "BSPRY",
            "STARD13",
            "LIX1L",
            "ADARB1",
            "ATP8B2",
            "MARVELD3",
            "WDR34",
            "LMCD1",
            "PKP3",
            "AACS",
            "APBB2",
            "SGCB",
            "PKD2",
            "EVC",
            "ZCCHC24",
            "PTCD1",
            "FERMT2",
            "KATNAL1",
            "STX2",
            "NMT2",
            "BACE1",
            "NEK1",
            "ESRP1",
            "LATS2",
            "ENTPD1",
            "C3orf64",
            "PARVA",
            "C12orf65",
            "CDK5RAP1",
            "SLC37A4",
            "TCF12",
            "GMEB2",
            "RIN2",
            "MTMR9",
            "SNTB2",
            "NDUFV1",
            "ATIC",
            "DOLPP1",
            "BMPR2",
            "COASY",
            "SERINC1",
            "NFS1",
            "SMARCD2",
            "MFAP3"
        ]
    },
    {
        "golabel": "ZEB2_regulon_activity",
        "gene": [
            "TIMD4",
            "CD300E",
            "CLEC4G",
            "HS3ST2",
            "CRHBP",
            "DCC",
            "EMR3",
            "KCNJ5",
            "IQSEC3",
            "CD209",
            "PCDHGA12",
            "FCGR3B",
            "FGL2",
            "CXCR2",
            "LILRB5",
            "FAM38B",
            "CD163",
            "PTGS1",
            "TLR8",
            "CR1",
            "CD163L1",
            "HS3ST3B1",
            "CYSLTR2",
            "P2RY1",
            "COLEC12",
            "CD300LB",
            "DDR2",
            "IL7R",
            "TFEC",
            "NLRP3",
            "C10orf128",
            "EPB41L3",
            "TDRD6",
            "CD84",
            "MCTP1",
            "CYBB",
            "C7orf58",
            "EGR2",
            "C5AR1",
            "GLIPR1",
            "TLR7",
            "ZNF366",
            "CASS4",
            "CMKLR1",
            "C3AR1",
            "PLEK",
            "GPRIN3",
            "SLCO2B1",
            "LOXL3",
            "KIAA1462",
            "KIRREL",
            "MARCH1",
            "CSF1R",
            "SIRPB2",
            "FPR3",
            "TLR6",
            "TLR4",
            "DOCK11",
            "MPEG1",
            "CSF2RB",
            "FAM49A",
            "PLXNC1",
            "FLJ39653",
            "SLC2A9",
            "DOCK2",
            "GEMIN8P4",
            "NCKAP1L",
            "ITGA4",
            "CD93",
            "TBXAS1",
            "BDH1",
            "CD53",
            "C6orf204",
            "FGD5",
            "ABCA1",
            "GAS7",
            "FAM55C",
            "STARD8",
            "PLXDC2",
            "CD4",
            "LCP2",
            "DAB2",
            "SIRPA",
            "FLI1",
            "SLC8A1",
            "RORA",
            "DBNDD1",
            "PACSIN3",
            "KCTD12",
            "MITF",
            "DHRS11",
            "ZEB1",
            "IL1R1",
            "ARHGAP8",
            "CCDC88A",
            "PMP22",
            "PRSS8",
            "MAF",
            "TMOD2",
            "EPB41L2",
            "SLC30A4",
            "MRPL24",
            "MARVELD3",
            "DOCK4",
            "LOC100125556",
            "WIPF1",
            "JAK2",
            "ARHGEF16",
            "NR2F6",
            "ATP10D",
            "CCHCR1",
            "PLEKHO2",
            "PHACTR2",
            "FRMD4A",
            "RAB8B",
            "RCBTB2",
            "C10orf35",
            "SLC36A1",
            "MYO5A",
            "SPINT1",
            "TBC1D4",
            "ABHD6",
            "PARP11",
            "TNS3",
            "LOC645332",
            "EPCAM",
            "MRAS",
            "PLEKHA2",
            "JAZF1",
            "C13orf31",
            "LOC348926",
            "SH2B3",
            "DPM2",
            "FMNL3",
            "STX2",
            "TRAF4",
            "ZNF175",
            "MVK",
            "PDF",
            "TMEM177",
            "OTUD1",
            "ENTPD1",
            "CNO",
            "PSMD4",
            "NIN",
            "TBC1D9",
            "TBC1D2B",
            "QKI",
            "ARSB",
            "RTKN",
            "DAK",
            "KIAA1432",
            "FAM86C",
            "C14orf1",
            "AP1M2",
            "MTA3",
            "TRAP1",
            "CCDC90A",
            "TMEM11",
            "C10orf58",
            "SLC37A4",
            "LITAF",
            "C1orf172",
            "RIN2",
            "GNPTAB",
            "PCNX",
            "CSGALNACT2",
            "TSEN34",
            "ATIC",
            "DOLPP1",
            "WHSC2",
            "PGAP2",
            "OSBPL11",
            "CEP120",
            "DENND5A",
            "MRPS9",
            "COASY",
            "SERINC1",
            "NFS1",
            "TMEM110",
            "SMARCD2",
            "MFAP3",
            "MRFAP1L1",
            "NDST2",
            "EIF2B4",
            "GIT2",
            "RDH14",
            "AAMP",
            "EPS15",
            "RBM4",
            "PCBP1"
        ]
    },
    {
        "golabel": "ZFHX3_regulon_activity",
        "gene": [
            "C15orf48",
            "C10orf125",
            "SETBP1",
            "PSMB9",
            "PPP1R3B",
            "CSTB",
            "KIAA1549",
            "FAM162A",
            "MYH10",
            "IFI35",
            "SDSL",
            "POU2F1",
            "NAV1",
            "CD58",
            "C9orf46",
            "ACOT4",
            "FBXO4",
            "PSMB8",
            "ITGAE",
            "MPDZ",
            "ARHGEF10",
            "INSR",
            "MAGI1",
            "FBXO6",
            "NFIB",
            "TTC28",
            "LTBP3",
            "PSME2",
            "SOX4",
            "ASL",
            "NFKBIE",
            "KIAA0182",
            "CASP4",
            "DOCK1",
            "CLDND1",
            "CHD6",
            "GSTK1",
            "SH3PXD2A",
            "NMI",
            "CLIC1",
            "ERC1",
            "BAK1",
            "BCAP29",
            "SNX3",
            "SUMO3",
            "BCOR",
            "NFATC3",
            "KIF3A",
            "GTF2B",
            "DIP2C",
            "ZKSCAN2",
            "DYNC1H1",
            "GNPDA1",
            "DRAM2",
            "MRPS22",
            "PAPD5",
            "C7orf25",
            "UBR3",
            "CNNM2",
            "DSTYK",
            "C1orf174",
            "SNX11",
            "ZCCHC14",
            "KIDINS220",
            "YLPM1",
            "ATXN1L",
            "FAM168B",
            "DCTN1",
            "ADPGK",
            "GLG1",
            "ANKRD11",
            "MBTPS1",
            "ATG3",
            "DYNC1LI2"
        ]
    },
    {
        "golabel": "ZFP1_regulon_activity",
        "gene": [
            "ZBTB8B",
            "TSPYL3",
            "TMEM184A",
            "TXNDC16",
            "MICALL2",
            "MEX3B",
            "RPS6KA5",
            "SH2D3A",
            "CGRRF1",
            "ZNF670",
            "SBNO2",
            "TCIRG1",
            "MAN2C1",
            "DNAJC18",
            "IFT52",
            "HSDL1",
            "TAF9B",
            "NDOR1",
            "GABARAPL2",
            "SOLH",
            "RAB33B",
            "CFDP1",
            "NME7",
            "PDP2",
            "KBTBD6",
            "C19orf6",
            "TRABD",
            "RNF126",
            "SLC24A6",
            "C16orf87",
            "ZNF436",
            "ZNF669",
            "MED15",
            "MMGT1",
            "MEAF6",
            "EXOC5",
            "TRMT5",
            "COPS4",
            "KATNA1",
            "TMEM188",
            "CXorf56",
            "RBBP4",
            "FTSJD1",
            "NCLN",
            "REXO1",
            "ZFP90",
            "NAE1",
            "STXBP2",
            "CDC37",
            "STAG2",
            "PPM1A",
            "C11orf57",
            "NUDT21",
            "CUL5",
            "CBFB",
            "TMEM170A",
            "ATMIN",
            "THAP11",
            "ELF2",
            "MATR3"
        ]
    },
    {
        "golabel": "ZFP36L1_regulon_activity",
        "gene": [
            "EGR4",
            "ABCA4",
            "ITGB3",
            "HOXD1",
            "PTPN13",
            "MTL5",
            "TNC",
            "ROS1",
            "CKMT1B",
            "NT5E",
            "MFSD4",
            "SEMA4G",
            "ARHGAP20",
            "CX3CL1",
            "PTPLA",
            "PLD4",
            "GPR68",
            "TTC39C",
            "SLC45A4",
            "KCNN4",
            "SLC34A2",
            "RBMS3",
            "LOC284837",
            "CYR61",
            "TLR2",
            "BLM",
            "AUTS2",
            "DUSP6",
            "KCNK5",
            "CSF1",
            "ICAM1",
            "SHROOM4",
            "GADD45A",
            "MPZL2",
            "PPP2R1B",
            "CCNJL",
            "ARRDC3",
            "NFKBIZ",
            "EMP1",
            "STEAP3",
            "SGPP2",
            "MAP3K13",
            "LIPT2",
            "GALNT10",
            "DPYD",
            "IFFO2",
            "BRI3BP",
            "JUN",
            "GPR132",
            "VDR",
            "MEF2C",
            "MICAL2",
            "CD83",
            "SMURF2",
            "ABHD3",
            "BHLHE40",
            "AIFM2",
            "TRIB1",
            "FLNA",
            "TRIM22",
            "TMEM173",
            "SEPHS2",
            "DCLRE1A",
            "DOCK9",
            "PTS",
            "SLC4A7",
            "C15orf63",
            "CCDC46",
            "PDSS1",
            "USMG5",
            "ZWILCH",
            "KIAA1598",
            "TTLL11",
            "RGMB",
            "DHTKD1",
            "RCCD1",
            "SNRPA1",
            "COX5A",
            "EEF1E1",
            "TGFB1",
            "NDUFV2",
            "C6orf136",
            "C12orf73",
            "RASSF5",
            "PPIF",
            "GTPBP4",
            "ATP5B",
            "MID2",
            "COX17",
            "ATF4",
            "VDAC2",
            "SELS",
            "ATP5C1",
            "SFXN3",
            "BBS9",
            "RPN2",
            "RUNX1",
            "NDUFS1",
            "NIF3L1",
            "SKI",
            "NARS",
            "CDC123",
            "ATXN1",
            "MRPS16",
            "COPZ1",
            "SEPHS1",
            "NOL7",
            "COX15",
            "ANP32A",
            "NAIF1",
            "DNAJC14",
            "USP4"
        ]
    },
    {
        "golabel": "ZFP64_regulon_activity",
        "gene": [
            "TREML1",
            "HPGDS",
            "PCDP1",
            "AURKA",
            "MYBL2",
            "NPC2",
            "KIF3C",
            "ST3GAL5",
            "SLC39A8",
            "FAM83D",
            "HLA-DPB1",
            "NAPSB",
            "LOC146880",
            "CD74",
            "HLA-DMA",
            "C7orf23",
            "ZBTB12",
            "NOD1",
            "MEF2C",
            "PION",
            "CENPO",
            "ARHGDIB",
            "UBA7",
            "C20orf20",
            "RSRC1",
            "RAE1",
            "TH1L",
            "NICN1",
            "TRMT6",
            "TMEM189",
            "URB2",
            "UMPS",
            "ALPK1",
            "CSNK2A1",
            "MOCS3",
            "XRN2",
            "RNF114",
            "ISG20L2",
            "ADNP",
            "SPATA2",
            "CSRP2BP",
            "MAPRE1",
            "CSTF1",
            "PCIF1",
            "C20orf43",
            "UBE2V1",
            "YWHAB"
        ]
    },
    {
        "golabel": "ZFP91_regulon_activity",
        "gene": [
            "DKFZp686O24166",
            "INE2",
            "HPN",
            "COX4I2",
            "WBSCR27",
            "SULT1A2",
            "C19orf46",
            "NOXA1",
            "MAGIX",
            "PPP1R14A",
            "EGFL7",
            "PMM1",
            "ATP2B1",
            "C22orf36",
            "FHIT",
            "PPDPF",
            "INCA1",
            "TRAPPC6A",
            "SBF2",
            "KLHDC8B",
            "LOC375190",
            "ECH1",
            "TMEM150A",
            "LOC729234",
            "PEX11G",
            "YPEL3",
            "PTRH1",
            "SBNO1",
            "TEAD1",
            "GTF2A1",
            "DDX21",
            "BDH2",
            "COMT",
            "RABAC1",
            "ATL3",
            "BCAT2",
            "RIF1",
            "DGCR6L",
            "ASXL2",
            "TRIM44",
            "SSBP4",
            "MAGED2",
            "ADAM10",
            "JOSD2",
            "PANX1",
            "NDUFAF3",
            "SPSB3",
            "RAB4B",
            "CCDC12",
            "SMCR7L",
            "DRG2",
            "QSER1",
            "UEVLD",
            "ATPAF2",
            "LZTS2",
            "TNPO1",
            "ADNP2",
            "NUP160",
            "PATL1",
            "LMBR1L",
            "SSRP1",
            "CTNND1",
            "AP4E1",
            "GANAB",
            "ARCN1",
            "ZNF394",
            "RHBDD1",
            "SPTY2D1",
            "MFAP3",
            "RBM27",
            "CAPRIN1",
            "HNRNPR",
            "API5",
            "OSBP",
            "NUP98",
            "DDB1",
            "ZDHHC5"
        ]
    },
    {
        "golabel": "ZFPL1_regulon_activity",
        "gene": [
            "IL6ST",
            "GLI4",
            "MACROD1",
            "FKBP2",
            "SGMS2",
            "C7orf47",
            "REL",
            "YDJC",
            "ZNHIT2",
            "C14orf80",
            "ZNHIT1",
            "C11orf83",
            "SLC25A10",
            "FCHO2",
            "SCAND1",
            "ORAOV1",
            "RAB11FIP2",
            "TMEM223",
            "KPNA5",
            "PPP1R14B",
            "C11orf48",
            "RAD9A",
            "DIAPH2",
            "C9orf142",
            "COL4A3BP",
            "SAC3D1",
            "PIK3R1",
            "C5orf41",
            "GPR172A",
            "SLC3A2",
            "NDUFS8",
            "C1orf159",
            "HIPK3",
            "ARFGAP1",
            "GET4",
            "STXBP4",
            "TMUB1",
            "RBM43",
            "FASTK",
            "ZDHHC12",
            "DRAP1",
            "ESRRA",
            "COX8A",
            "B3GAT3",
            "TRPT1",
            "CDK16",
            "BANF1",
            "FOXRED1",
            "ANKRD13D",
            "PELI3",
            "KLC2",
            "COPE",
            "PGP",
            "SSSCA1",
            "BAD",
            "ZDHHC24",
            "NSUN5",
            "TRIM23",
            "SLC25A30",
            "RFNG",
            "PEX16",
            "ADRM1",
            "NUDT22",
            "CCS",
            "NOC4L",
            "IDH3G",
            "POLK",
            "MRPL28",
            "KLHL8",
            "RABGAP1L",
            "SLC37A4",
            "KIAA1430",
            "GPR137",
            "CCDC22",
            "WDR74",
            "RCE1",
            "SART1",
            "DMXL1",
            "GMPPA",
            "MED19",
            "PJA2",
            "BRMS1",
            "NDUFV1",
            "TAF6L",
            "ZNF668",
            "EMD",
            "BMPR2",
            "MEN1",
            "TSSC4",
            "SOCS5",
            "ADRBK1",
            "ELF1",
            "VEGFB",
            "SCYL1",
            "CHMP1A",
            "MCRS1",
            "CNOT6L",
            "PRKAR1A",
            "CORO1B",
            "OTUB1",
            "KLHL20",
            "ZNF408",
            "MAP3K11",
            "MUS81",
            "C11orf2",
            "UBXN1",
            "EPC2",
            "SMARCAD1",
            "TOR1AIP1",
            "E2F4",
            "STX5",
            "CLASP2",
            "RAB1B",
            "RAB14",
            "WDR48",
            "SEC24B",
            "CREB1",
            "RELA"
        ]
    },
    {
        "golabel": "ZFPM1_regulon_activity",
        "gene": [
            "A4GNT",
            "DPCR1",
            "PSCA",
            "DUOXA2",
            "CDHR2",
            "TFF1",
            "IHH",
            "CHST5",
            "EPS8L3",
            "CYP3A5",
            "VILL",
            "BAIAP2L2",
            "LGALS9C",
            "AMN",
            "HR",
            "ENTPD8",
            "ABP1",
            "SMPD3",
            "LOC100130933",
            "PTPRN2",
            "ENTPD2",
            "TSPAN1",
            "DOK7",
            "KLF2",
            "EPS8L1",
            "IGSF22",
            "FBXL8",
            "RAPGEF3",
            "NPDC1",
            "CLDN23",
            "ADAP1",
            "PLEKHA6",
            "FAM83E",
            "MICALL2",
            "CLTB",
            "KPNA2",
            "C16orf48",
            "EPB49",
            "OSBPL7",
            "KIAA0513",
            "HOMER1",
            "RASA4P",
            "INF2",
            "CDK10",
            "MSRA",
            "NUDCD1",
            "TSPO",
            "ARMC1",
            "C12orf29",
            "TNK2",
            "SORBS3",
            "ALS2CR4",
            "MSH6",
            "FAM65A",
            "TMTC3",
            "PNPLA2",
            "SH3TC1",
            "TREX1",
            "CES2",
            "PHTF2",
            "BCAR1",
            "C1orf163",
            "B3GALT4",
            "MGST2",
            "SGSM3",
            "ABTB1",
            "TUBD1",
            "KLHL7",
            "ARRDC1",
            "ZDHHC7",
            "YWHAQ",
            "FBXW4",
            "SOLH",
            "GPN3",
            "GSTCD",
            "METTL2A",
            "LRRC40",
            "TMEM102",
            "BIN3",
            "DHX40",
            "RNF2",
            "MESDC1",
            "RNPEPL1",
            "USP14",
            "PSD4",
            "NEDD1",
            "EXOC5",
            "PTPN18",
            "NUP160",
            "EPN1",
            "SNRNP40",
            "KCTD20",
            "KLHL36",
            "ABCE1",
            "STYX",
            "ZBTB7A",
            "NOL11",
            "HAT1",
            "UTP18",
            "TBC1D17",
            "ACSF3",
            "ANKRD11",
            "METAP2",
            "DENR",
            "FBXO31",
            "RHOT1",
            "PAPOLG",
            "C17orf71",
            "UTP6",
            "CTDSP1",
            "TMEM115",
            "RBM12"
        ]
    },
    {
        "golabel": "ZFR_regulon_activity",
        "gene": [
            "SKP2",
            "NOXA1",
            "OSMR",
            "FBXL8",
            "IDUA",
            "ODF3B",
            "ANKRD9",
            "GMCL1L",
            "PSIMCT-1",
            "LMBRD2",
            "NUP155",
            "CCDC88B",
            "SOX18",
            "PAQR3",
            "TNFRSF14",
            "TMEM48",
            "D2HGDH",
            "RBBP8",
            "LOC728024",
            "ARRDC2",
            "ZNF670",
            "CDK10",
            "ZNF420",
            "EXD3",
            "TRUB1",
            "ZNF276",
            "TCIRG1",
            "STRN",
            "ARMC1",
            "LGALS3BP",
            "C16orf7",
            "DGKQ",
            "PAIP1",
            "DDX52",
            "TMEM175",
            "CSNK2A1P",
            "ZNF131",
            "TREX1",
            "PUS7L",
            "C5orf22",
            "RAD1",
            "LRCH4",
            "PIGQ",
            "ARRDC1",
            "TRADD",
            "TTC33",
            "KIAA0947",
            "KBTBD6",
            "TGS1",
            "MTMR12",
            "GTF2H3",
            "DEK",
            "SLC30A6",
            "LCLAT1",
            "DPY19L4",
            "DNAJC21",
            "DHX40",
            "DR1",
            "RNPEPL1",
            "GMCL1",
            "AGAP3",
            "PPP4R2",
            "SPAST",
            "CTDSPL2",
            "NADSYN1",
            "TESK1",
            "MAP4K3",
            "SRFBP1",
            "C17orf59",
            "RBBP4",
            "PPP1CB",
            "DIS3",
            "YTHDF3",
            "ITCH",
            "AASDHPPT",
            "PAPOLG",
            "HNRPLL",
            "C17orf71",
            "DHX15",
            "COIL",
            "CDK9",
            "CAPRIN1",
            "CDC73",
            "EIF4G2",
            "RBM12"
        ]
    },
    {
        "golabel": "ZFYVE20_regulon_activity",
        "gene": [
            "LOC648740",
            "LOC283174",
            "BMP3",
            "AMY2B",
            "IGSF9B",
            "PTPN13",
            "CDKL2",
            "XKRX",
            "SMOX",
            "ATP13A4",
            "ROS1",
            "MAP2K6",
            "ARHGAP20",
            "C4orf31",
            "ICAM5",
            "ESYT3",
            "GPR116",
            "FAM189A2",
            "FAM184A",
            "GLCCI1",
            "C1orf116",
            "LMO3",
            "SYDE2",
            "GPC4",
            "RIMS3",
            "CACNB1",
            "ITGA9",
            "ZNF493",
            "SLC34A2",
            "RBMS3",
            "UCK2",
            "C6orf168",
            "PRRT3",
            "ST3GAL5",
            "GMDS",
            "ICAM1",
            "SHROOM4",
            "SNX25",
            "FNIP2",
            "CDC42BPA",
            "MAGI3",
            "IL6R",
            "PLCD1",
            "SH3BP5",
            "OCLN",
            "HIP1",
            "NOD1",
            "GPD1L",
            "GAPDH",
            "DERA",
            "APBA1",
            "GLA",
            "LOC651250",
            "BTBD9",
            "ZCWPW2",
            "YPEL1",
            "POMP",
            "RPS6KA2",
            "DPYSL2",
            "PTPRE",
            "TLR5",
            "DOCK9",
            "C20orf24",
            "EPB41L4A",
            "USP13",
            "COX6A1",
            "PTS",
            "RAN",
            "SLC41A1",
            "LOC653501",
            "CCDC46",
            "NDUFA9",
            "HSPE1",
            "EDEM1",
            "SCAI",
            "RGMB",
            "SNRPA1",
            "COX5A",
            "KIF13A",
            "C16orf61",
            "PSMC4",
            "SMUG1",
            "SLC3A2",
            "PPIF",
            "MTMR3",
            "TPI1",
            "MYO6",
            "PRKCE",
            "SPRED2",
            "COX17",
            "C12orf44",
            "MPHOSPH6",
            "EIF5AL1",
            "UFD1L",
            "FYCO1",
            "FUCA2",
            "OBFC2B",
            "LZTFL1",
            "ZC3H6",
            "ATXN7",
            "TMEM43",
            "POLH",
            "TTC3",
            "NKIRAS1",
            "DYNLL1",
            "ZNF25",
            "XPC",
            "ANKRD13C",
            "ZBTB8A",
            "MCRS1",
            "ZNF654",
            "ZNF197",
            "KIAA1143",
            "METTL14",
            "RAF1",
            "USP4",
            "BAP1",
            "IP6K1"
        ]
    },
    {
        "golabel": "ZFYVE26_regulon_activity",
        "gene": [
            "RTKN2",
            "NCRNA00188",
            "SIGLEC1",
            "MS4A14",
            "RPL39",
            "P2RX7",
            "RPS15A",
            "LOC100272216",
            "SNHG6",
            "RPS16",
            "C14orf49",
            "CBX6",
            "UAP1L1",
            "ITGAL",
            "RPL31",
            "GTF2A2",
            "LOC729603",
            "RPSAP9",
            "TIMM16",
            "NBPF14",
            "RPL24",
            "NAIP",
            "NBPF10",
            "IER3IP1",
            "SSR4",
            "KCNAB2",
            "FGD3",
            "SAMHD1",
            "ARHGAP30",
            "COX5B",
            "TMED3",
            "C9orf3",
            "TTC7B",
            "CCDC72",
            "LGMN",
            "RPS24",
            "RNF213",
            "MAP3K9",
            "PIK3CD",
            "RPL37A",
            "RPL14",
            "USMG5",
            "PSMD8",
            "N6AMT2",
            "C14orf102",
            "C4orf52",
            "SELK",
            "NDUFA7",
            "C19orf10",
            "PRDX2",
            "SLC36A1",
            "CDKN2AIPNL",
            "BTN2A3",
            "STK10",
            "NHP2",
            "KIAA1632",
            "C20orf194",
            "NDUFS4",
            "GALC",
            "DDHD1",
            "SIPA1L1",
            "MACF1",
            "ERLEC1",
            "TEP1",
            "NCRNA00081",
            "ADCK1",
            "NDUFAB1",
            "ANGEL1",
            "SERP1",
            "POLR3K",
            "BCL2L2",
            "SLC38A7",
            "FAM111A",
            "COX18",
            "NIN",
            "C11orf10",
            "CCDC104",
            "HERC1",
            "ANAPC16",
            "DYNC1H1",
            "POMT2",
            "PRKCH",
            "CUL9",
            "SSH2",
            "C14orf118",
            "ATG2B",
            "ZNFX1",
            "UFC1",
            "RSL1D1",
            "MYO9B",
            "WDFY2",
            "DICER1",
            "TRIP11",
            "ARL1",
            "IL17RA",
            "C14orf135",
            "PCNX",
            "KIAA0586",
            "TTLL5",
            "SPCS1",
            "CHD8",
            "ARF4",
            "SEC13",
            "YLPM1",
            "KIAA0317",
            "KLC1",
            "ABCD4",
            "CYTH1",
            "C14orf43",
            "DCAF5",
            "COQ10B",
            "NEK9",
            "FAM21C",
            "ARF1",
            "VPS8",
            "FAM178A",
            "RBM25",
            "ZFYVE1",
            "ANKFY1",
            "RWDD4A",
            "FTSJD2",
            "AIMP1",
            "NUMB",
            "FAM40A"
        ]
    },
    {
        "golabel": "ZGLP1_regulon_activity",
        "gene": [
            "FAM166A",
            "AMH",
            "FLJ33360",
            "DOC2A",
            "SERPINI2",
            "CLEC18B",
            "CCDC154",
            "C22orf43",
            "C3orf45",
            "ACCN3",
            "CLEC18A",
            "ANKK1",
            "CYP21A2",
            "DGCR10",
            "YJEFN3",
            "SLC25A41",
            "ANKRD24",
            "SCNN1D",
            "POM121L8P",
            "CYP2D7P1",
            "CRYBB3",
            "LOC646851",
            "LOC221442",
            "TRIM74",
            "DNASE1L2",
            "SPEG",
            "HSPA7",
            "SALL4",
            "POM121L1P",
            "ARHGAP33",
            "POM121L9P",
            "KCNAB3",
            "C19orf57",
            "NRADDP",
            "SLC23A3",
            "SDHAP3",
            "PFKFB1",
            "DNHD1",
            "VENTX",
            "CELF6",
            "RASL10A",
            "PTCH2",
            "BZRAP1",
            "REM2",
            "CACNB1",
            "C1orf70",
            "FOXD4L1",
            "NPFF",
            "FITM1",
            "ITGB1BP2",
            "TBC1D3H",
            "GSR",
            "C19orf76",
            "C16orf79",
            "PABPC1L",
            "TREX2",
            "C6orf124",
            "LTB4R",
            "RPGRIP1",
            "PROCA1",
            "QRICH2",
            "SLC25A34",
            "PRR22",
            "CPT1B",
            "TBC1D3B",
            "LRP5L",
            "LOC91316",
            "C14orf148",
            "UCP3",
            "ATG16L2",
            "SLC25A29",
            "LCAT",
            "C20orf107",
            "CRYGS",
            "CHRNA10",
            "LOC286367",
            "SGK494",
            "HEXDC",
            "GHRLOS",
            "KCND1",
            "CSAD",
            "CHKB-CPT1B",
            "ADC",
            "NFKBID",
            "LOC146880",
            "TTLL3",
            "PBX4",
            "UBXN11",
            "LTB4R2",
            "TMEM86B",
            "ABCA7",
            "DTX3",
            "PILRB",
            "CDK3",
            "ENGASE",
            "CCNL2",
            "HAUS5",
            "CCDC14",
            "LY6G5B",
            "P2RY11",
            "AGAP6",
            "LOC100133331",
            "SNHG12",
            "FBF1",
            "LOC150776",
            "PLEKHM1P",
            "APBB3",
            "EPOR",
            "CCDC84",
            "FAM193B",
            "CDK5RAP3",
            "MICAL1",
            "PDZD8",
            "ANKS3",
            "WASH7P",
            "FAM156A",
            "GUSBP1",
            "CCBL1",
            "EGLN1",
            "LUC7L",
            "ZNF337",
            "ATE1",
            "STAG3L3",
            "SFI1",
            "FAM114A1",
            "ZNF341",
            "LOC147727",
            "FCHSD1",
            "CSNK2A1P",
            "ZNF266",
            "POU6F1",
            "C17orf56",
            "LYSMD4",
            "C1orf58",
            "FAM73B",
            "CCDC130",
            "C17orf65",
            "ZNF700",
            "ACBD5",
            "MTMR2",
            "FAM98B",
            "DLD",
            "AKAP8L",
            "NOLC1",
            "VMAC",
            "RAB2A",
            "DLAT",
            "TM9SF3",
            "MUM1",
            "TYK2",
            "ELMOD3",
            "NIPA2",
            "WASL",
            "NCKAP1",
            "CDYL",
            "GALT",
            "ATF6",
            "GOLGA5",
            "UBE2G1",
            "CRK",
            "VPS35",
            "STRADA",
            "SEC23IP",
            "EXOC7",
            "MAP2K4",
            "EXOC4",
            "ATMIN"
        ]
    },
    {
        "golabel": "ZGPAT_regulon_activity",
        "gene": [
            "SLC17A9",
            "C20orf151",
            "PLEKHG5",
            "TIAF1",
            "C14orf80",
            "NPEPL1",
            "RTEL1",
            "C20orf135",
            "SAMD10",
            "AZI1",
            "SLC2A4RG",
            "SIGIRR",
            "LEPROT",
            "LRRC45",
            "RRBP1",
            "GTPBP5",
            "CAPN10",
            "ARFGAP1",
            "TMUB1",
            "TP53I13",
            "UCKL1",
            "ARFRP1",
            "C7orf43",
            "RABEP2",
            "KIAA0664",
            "SAMD8",
            "DOHH",
            "ZNF513",
            "IKBKG",
            "TELO2",
            "RAB33B",
            "PPP1R12C",
            "CHM",
            "OGFR",
            "BRF1",
            "NEURL4",
            "C19orf6",
            "PRPF6",
            "SNRNP70",
            "PABPN1",
            "CCDC9",
            "ADRM1",
            "CCS",
            "ZNF446",
            "MMGT1",
            "C6orf211",
            "GMEB2",
            "C17orf70",
            "KIAA1430",
            "CTDSPL2",
            "DNAJB14",
            "GPS2",
            "SART1",
            "ZBTB17",
            "ZBTB6",
            "HDGFRP2",
            "TESK1",
            "TAF6L",
            "SRFBP1",
            "G3BP2",
            "HGS",
            "C5orf24",
            "MAP3K11",
            "RBM18",
            "LEMD2",
            "C9orf64",
            "PAPOLG",
            "ABCB7",
            "APPL1",
            "PLDN",
            "CTBP1",
            "ZNF148",
            "MAPK14",
            "SPTLC1",
            "SEPT2",
            "CSNK1D"
        ]
    },
    {
        "golabel": "ZKSCAN1_regulon_activity",
        "gene": [
            "C7orf51",
            "HOPX",
            "LMTK2",
            "KIAA0754",
            "CLMN",
            "GATS",
            "NDUFA2",
            "PHLDA3",
            "VAMP8",
            "MRPL14",
            "TAOK1",
            "BRWD3",
            "C20orf117",
            "BTG3",
            "RILP",
            "IFITM2",
            "SYNJ2",
            "CCNT1",
            "FAM168A",
            "DDI2",
            "CNIH4",
            "IFITM3",
            "SIL1",
            "SBNO1",
            "MPG",
            "EHBP1",
            "PEX1",
            "CRB3",
            "NEU3",
            "TRRAP",
            "ROCK2",
            "JRK",
            "HAUS4",
            "ATXN7L1",
            "KIAA1147",
            "SHPRH",
            "RIF1",
            "DHX33",
            "ASXL2",
            "SYNGR2",
            "REST",
            "SERTAD3",
            "UBR5",
            "ZNF623",
            "AKAP9",
            "LATS1",
            "NDUFC1",
            "MLXIP",
            "ZKSCAN5",
            "ZNF81",
            "C11orf30",
            "CHMP6",
            "C22orf30",
            "ARFGEF2",
            "KIF3B",
            "PRDM10",
            "PTPMT1",
            "NUBP1",
            "RALGAPB",
            "LUC7L2"
        ]
    },
    {
        "golabel": "ZKSCAN3_regulon_activity",
        "gene": [
            "C1orf95",
            "KIT",
            "GPR110",
            "PDLIM4",
            "PDE3B",
            "CHML",
            "UPP1",
            "PAIP2B",
            "PGBD1",
            "PHLDA2",
            "FXYD5",
            "LGALS9",
            "RGS10",
            "PSMB10",
            "BHLHE40",
            "EFHD2",
            "SOCS7",
            "DTX2",
            "TRIM47",
            "LIMK1",
            "ZNF192",
            "LANCL1",
            "CCM2",
            "ATE1",
            "KRBA2",
            "KCTD5",
            "MRS2",
            "KBTBD7",
            "EHD1",
            "JARID2",
            "TRIM37",
            "HSDL1",
            "BBS10",
            "C1orf69",
            "TAF8",
            "SEC23B",
            "SIPA1",
            "ARNT",
            "ZSCAN2",
            "ZNF187",
            "KIAA0232",
            "C1orf26",
            "PIGN",
            "KCTD20",
            "RAC1",
            "ATF2",
            "ACTB",
            "ZKSCAN4",
            "BRD2",
            "EPC1",
            "CSTF2T",
            "PRPF4B",
            "RAB8A"
        ]
    },
    {
        "golabel": "ZMAT1_regulon_activity",
        "gene": [
            "SERPINI2",
            "MST1P9",
            "TTC18",
            "RUFY4",
            "ERAS",
            "C9orf128",
            "LOC283174",
            "GGT8P",
            "ANKK1",
            "CYP21A2",
            "MST1P2",
            "GABRE",
            "PRRT2",
            "CELF5",
            "ANKRD24",
            "NPY6R",
            "POM121L8P",
            "KIAA1683",
            "C1orf175",
            "COL4A3",
            "LOC148696",
            "GGT3P",
            "SLC9A5",
            "CAPN3",
            "TTC21A",
            "EMR4P",
            "CYP46A1",
            "POM121L1P",
            "FLJ36777",
            "POM121L9P",
            "PHKG1",
            "ICAM5",
            "LOC285593",
            "PATL2",
            "C1orf101",
            "CFLP1",
            "CMYA5",
            "FLJ13197",
            "LONRF2",
            "FAM184A",
            "ZDHHC15",
            "PXT1",
            "LOC92973",
            "LOC100128573",
            "LOC100131434",
            "CES8",
            "BZRAP1",
            "UBQLNL",
            "CACNB1",
            "C9orf96",
            "GPRASP1",
            "LOC100272228",
            "MYLK4",
            "HMGA1",
            "ZNF540",
            "SNORA7B",
            "HCG2P7",
            "POM121L10P",
            "LOC441204",
            "GOLGA8B",
            "SEC31B",
            "DAPK2",
            "CCDC30",
            "LRP2BP",
            "FLJ45244",
            "GOLGA8A",
            "LRRC37A3",
            "NEAT1",
            "ABCC6",
            "C10orf68",
            "MALAT1",
            "LOC91316",
            "RAB40A",
            "ATG16L2",
            "C6orf164",
            "LOC100303728",
            "FAM13AOS",
            "GNRHR",
            "HCG27",
            "LCAT",
            "DNM1P35",
            "SLC39A14",
            "PYROXD2",
            "LEKR1",
            "NCRNA00201",
            "KCNC3",
            "NCRNA00174",
            "LOC100129534",
            "ZNF204P",
            "FAM47E",
            "DFNB59",
            "KLF8",
            "CSAD",
            "CHKB-CPT1B",
            "RAB40AL",
            "RUNDC2C",
            "AHSA2",
            "CCT6B",
            "C1orf204",
            "ACCS",
            "LOC153684",
            "TTLL3",
            "RNPC3",
            "GRID2IP",
            "CROCCL2",
            "GOLGA6L10",
            "LOC646471",
            "LOC202181",
            "LOC100130557",
            "ZCWPW1",
            "KIAA1407",
            "LOC401052",
            "CCNL2",
            "LOC100128288",
            "RANBP17",
            "BEX4",
            "INE1",
            "C1orf152",
            "FMO4",
            "NOD1",
            "MGC3771",
            "INCA1",
            "OGT",
            "WDR91",
            "LOC284440",
            "TRIM66",
            "C5orf45",
            "ECHDC2",
            "FAM193B",
            "ZNF608",
            "C21orf122",
            "HSFX2",
            "MTCP1",
            "LOC375190",
            "IFT80",
            "PION",
            "IL11RA",
            "FHOD1",
            "ZNF862",
            "AHCY",
            "NSUN7",
            "DKFZP586I1420",
            "KLHDC1",
            "FAM156A",
            "NKTR",
            "TUBGCP6",
            "DNAJC28",
            "CLK4",
            "MAPRE3",
            "C17orf108",
            "C5orf53",
            "ACAD11",
            "ITGB1",
            "STRAP",
            "RABL2A",
            "CCDC159",
            "ZNF354B",
            "WWC3",
            "SLC2A11",
            "GTF2IRD2P1",
            "TCEAL6",
            "ZNF75D",
            "ATP5B",
            "TRIM52",
            "ALS2CR8",
            "ZNF546",
            "LYST",
            "SH2B1",
            "AGXT2L2",
            "TMEM175",
            "GTF2IRD2",
            "SFRS18",
            "POU6F1",
            "NUDT15",
            "NICN1",
            "IPO5",
            "KIAA0495",
            "C17orf65",
            "NPHP3",
            "BTN2A2",
            "ZBTB48",
            "WSB2",
            "OFD1",
            "KCTD7",
            "PARP3",
            "MTMR2",
            "ZC3H6",
            "CXorf23",
            "ZNF839",
            "ZRSR2",
            "ALPK1",
            "RBM5",
            "ZNF23",
            "WDR5B",
            "TCEAL4",
            "CSNK2A1",
            "EIF4A1",
            "ELMOD3",
            "SAE1",
            "SSR1",
            "UBE2G1"
        ]
    },
    {
        "golabel": "ZMAT5_regulon_activity",
        "gene": [
            "TMEM191A",
            "LOC388588",
            "WBSCR26",
            "WBSCR27",
            "GSTT1",
            "DPM3",
            "TST",
            "CHADL",
            "AKT3",
            "PMM1",
            "LOC440957",
            "GAMT",
            "LOC150381",
            "GCAT",
            "C7orf59",
            "TSTD1",
            "CHCHD10",
            "TP53TG1",
            "HSD17B8",
            "GCHFR",
            "GSTZ1",
            "LSMD1",
            "C21orf119",
            "MRPL54",
            "FLJ35220",
            "TRERF1",
            "NDUFA11",
            "TRAPPC6A",
            "RBKS",
            "MPST",
            "C6orf1",
            "NDUFA13",
            "NDUFB7",
            "CHKB",
            "HSCB",
            "RILP",
            "PEX11G",
            "SERF2",
            "TRAPPC5",
            "SYNJ2",
            "UQCR11",
            "CBY1",
            "DDTL",
            "ALKBH7",
            "DDT",
            "TCEB2",
            "PNPLA4",
            "FAM165B",
            "CYB5D2",
            "RBX1",
            "FAU",
            "TSPO",
            "HEXIM2",
            "PHF5A",
            "C17orf90",
            "UQCR10",
            "PRDX5",
            "RPS19BP1",
            "COMT",
            "C19orf70",
            "CHCHD6",
            "SLC2A11",
            "GPX4",
            "ROCK2",
            "BCL7C",
            "C22orf32",
            "ZFYVE19",
            "C19orf53",
            "RC3H2",
            "RIF1",
            "PMS2L4",
            "DGCR6L",
            "POLR2L",
            "RRP7A",
            "TCTA",
            "C19orf24",
            "AMZ2P1",
            "C17orf106",
            "TOMM7",
            "C11orf67",
            "PPCDC",
            "FAHD2A",
            "BLVRA",
            "NDUFA6",
            "RPL23AP82",
            "TXN2",
            "TTLL1",
            "MRPL40",
            "TMEM218",
            "SLC25A1",
            "CISD3",
            "TMEM120A",
            "ASCC2",
            "RNF215",
            "RWDD2B",
            "TMEM101",
            "SMG1",
            "TMEM219",
            "C19orf25",
            "ENTPD4",
            "C17orf101",
            "DRG1",
            "C22orf25",
            "DNAJC17",
            "WWP1",
            "TBC1D10A",
            "DNAJC30",
            "STK16",
            "MIF4GD",
            "C22orf40",
            "NCAPH2",
            "MARCH2",
            "CHMP6",
            "TOM1",
            "DICER1",
            "ABL2",
            "C15orf40",
            "MCAT",
            "RANBP2",
            "MLX",
            "NSD1",
            "NHP2L1",
            "BIRC6",
            "PIKFYVE",
            "C19orf56",
            "C22orf13",
            "ATP6V1E1",
            "SOS1",
            "CCDC71"
        ]
    },
    {
        "golabel": "ZMYM2_regulon_activity",
        "gene": [
            "HLA-DRB1",
            "TYROBP",
            "HCST",
            "CSF2RA",
            "TNFAIP8L2",
            "EMP3",
            "ATP8B1",
            "VIM",
            "SPI1",
            "CD40",
            "LAT2",
            "IL27RA",
            "ALG11",
            "SLC7A1",
            "CENPJ",
            "ARHGDIB",
            "CDK8",
            "C13orf23",
            "NEK3",
            "MTRF1",
            "TOMM7",
            "NINJ1",
            "IFT88",
            "C17orf85",
            "NAA16",
            "ENTPD4",
            "HMOX2",
            "MFSD9",
            "STRBP",
            "ZFC3H1",
            "DCAF16",
            "KIAA1468",
            "LARP1B",
            "N4BP2L2",
            "PRDM10",
            "COG3",
            "ARID2",
            "MPHOSPH8",
            "SETD5",
            "PAN3",
            "ELOF1",
            "TLK1",
            "XPO4",
            "FAM48A",
            "ZMYM5",
            "SUV420H1",
            "PSPC1",
            "INTS6",
            "DNASE2",
            "USPL1",
            "PRPF4B",
            "SF3B1"
        ]
    },
    {
        "golabel": "ZMYM3_regulon_activity",
        "gene": [
            "C5orf46",
            "S100A3",
            "LOC92973",
            "GOLGA2B",
            "GSTO1",
            "SALL2",
            "C9orf45",
            "PLA2G5",
            "GTF2A2",
            "ECSCR",
            "LXN",
            "IGFBP7",
            "OGT",
            "FAM120C",
            "GUSBL1",
            "ZNF862",
            "CREM",
            "OSTC",
            "C4orf32",
            "KIAA0467",
            "TPM4",
            "BCORL1",
            "FAM96A",
            "ZNF280C",
            "SELS",
            "SRRM2",
            "KIAA0495",
            "DNAJC1",
            "PATZ1",
            "ARPC5",
            "PRR3",
            "ZNF839",
            "CUL9",
            "GON4L",
            "CHIC2",
            "ZNF182",
            "DLG3",
            "ZNF324B",
            "ACIN1",
            "MAP1LC3B",
            "TAF1",
            "STX7",
            "COQ10B",
            "OSTF1",
            "ARPC2",
            "PHF12",
            "NONO",
            "NRBF2",
            "ILF3",
            "SRRM1"
        ]
    },
    {
        "golabel": "ZNF136_regulon_activity",
        "gene": [
            "CARD14",
            "OSGIN1",
            "G6PD",
            "THEM5",
            "PANX2",
            "CD200R1",
            "KAL1",
            "PGD",
            "ABCB6",
            "LOC339524",
            "FAM198A",
            "SCNN1A",
            "ANKRD9",
            "EPN3",
            "ZFP37",
            "C18orf1",
            "RPS6KA5",
            "ZNF625",
            "AP1S2",
            "C21orf91",
            "FAM118B",
            "CDC14A",
            "RGL1",
            "JUP",
            "ZNF597",
            "FAM83H",
            "ZNF627",
            "LTBR",
            "TESK2",
            "CYP2U1",
            "ZNF501",
            "PUS1",
            "CXorf42",
            "ZNF441",
            "ZNF709",
            "ZNF701",
            "ZNF383",
            "KIAA0664",
            "PITRM1",
            "RRP12",
            "VARS",
            "ZNF836",
            "MAP3K1",
            "SLC27A4",
            "MLF2",
            "ZNF416",
            "TRIM23",
            "P4HB",
            "CTTN",
            "KTELC1",
            "RRAGB",
            "FBXL3",
            "ZNF559",
            "DDX54",
            "MIER1",
            "ZNF791",
            "ZNF230",
            "C11orf46",
            "ZNF564",
            "RSBN1",
            "THAP4",
            "C16orf52",
            "GABPA",
            "COASY",
            "ASTE1",
            "ZBTB1",
            "HELQ",
            "TMEM214",
            "MORC3",
            "EPS15"
        ]
    },
    {
        "golabel": "ZNF142_regulon_activity",
        "gene": [
            "MRPS6",
            "HIGD1A",
            "NDUFA4",
            "ACOT4",
            "C4orf33",
            "CENPJ",
            "SEP15",
            "MAP3K9",
            "PLCD4",
            "MAFG",
            "C13orf23",
            "CETN2",
            "TOMM7",
            "TTLL4",
            "PPCS",
            "SEMA4C",
            "PFAS",
            "IFNGR2",
            "FARP2",
            "NUDCD2",
            "C12orf51",
            "MLL2",
            "MLL4",
            "PPIC",
            "PDCD11",
            "UBE2A",
            "GTF2B",
            "ING5",
            "CDC42",
            "KDELR2",
            "RWDD1",
            "UBE2D4",
            "LOC285033",
            "CHIC2",
            "ZNF335",
            "CRYZL1",
            "ZDHHC4",
            "TRAF3IP1",
            "ANAPC10",
            "RNF44",
            "CMPK1",
            "ARF4",
            "ZNF746",
            "KIAA1967",
            "ALS2",
            "SETD1B",
            "LAPTM4A",
            "DCTN1",
            "ASXL1",
            "HCFC1",
            "CLASP1",
            "SUPT6H",
            "GIGYF2",
            "FAM193A",
            "PTPN23",
            "ATG9A",
            "GLT8D1",
            "AMMECR1L",
            "SMARCAL1"
        ]
    },
    {
        "golabel": "ZNF146_regulon_activity",
        "gene": [
            "TET1",
            "CLSPN",
            "CENPF",
            "ACP5",
            "C15orf34",
            "MCM8",
            "NUDT19",
            "CEBPG",
            "LRRC29",
            "MFSD7",
            "GUK1",
            "ZNF518B",
            "RBL1",
            "UBA2",
            "PRKDC",
            "RILP",
            "FIS1",
            "C19orf55",
            "PVR",
            "ASL",
            "NUDT18",
            "ZNF567",
            "BEND3",
            "RIF1",
            "CCNJ",
            "ZNF260",
            "NINJ1",
            "CKAP5",
            "TMEM120A",
            "GNPTG",
            "ESF1",
            "ACAA1",
            "TNFSF12",
            "TMEM219",
            "ZNF507",
            "AFG3L2",
            "SMC6",
            "SAMD4B",
            "TEX264",
            "LSM14A",
            "ESCO1",
            "NCOA6",
            "PAPOLA",
            "BAT2L2",
            "ZNF227",
            "RANBP2",
            "ZBED4",
            "NCL",
            "HNRNPUL1",
            "DHX9",
            "HNRNPU"
        ]
    },
    {
        "golabel": "ZNF148_regulon_activity",
        "gene": [
            "HAGHL",
            "ACAP2",
            "C3orf58",
            "IRF7",
            "LPP",
            "PTPLB",
            "WWTR1",
            "SAMD10",
            "PPP2R3A",
            "PRKCI",
            "UBXN7",
            "FBXL6",
            "EHHADH",
            "TOPBP1",
            "SKIL",
            "SIGIRR",
            "TCIRG1",
            "NCK1",
            "ZGPAT",
            "CAPN10",
            "RSRC1",
            "KLHL24",
            "MAD1L1",
            "GGA1",
            "ARFRP1",
            "DCUN1D1",
            "DAGLB",
            "CCDC130",
            "LRRC58",
            "PTDSS2",
            "RHOT2",
            "ZZZ3",
            "ANKRD13D",
            "STAG1",
            "PIK3CB",
            "C19orf6",
            "LOC646214",
            "PIK3CA",
            "DIRC2",
            "NAA50",
            "ZNF639",
            "PPP1R2P3",
            "UMPS",
            "SLC33A1",
            "NSUN3",
            "DTX3L",
            "NDUFS7",
            "BBX",
            "SIRT6",
            "RB1CC1",
            "MBD3",
            "DLG1",
            "KTELC1",
            "E4F1",
            "GTF2E1",
            "PPP4R2",
            "KPNA4",
            "DCAF10",
            "TBL1XR1",
            "RYK",
            "TXNRD3IT1",
            "KIAA2018",
            "PCNP",
            "DHX36",
            "TMCC1",
            "ZNF653",
            "SLC35A5",
            "GFM1",
            "ZBTB6",
            "DNAJC13",
            "GSK3B",
            "OSBPL11",
            "TSSC4",
            "RABL3",
            "COPB2",
            "TOMM70A",
            "TBC1D23",
            "QTRTD1",
            "KPNA1",
            "SCAMP4",
            "FAM20B",
            "TAB2",
            "PIK3R4",
            "MSL2",
            "POLR2E",
            "ASTE1",
            "STAG2",
            "DBR1",
            "SNX4",
            "RLIM",
            "ATP6V1A",
            "RBM27",
            "SMU1",
            "UBA5",
            "ARMC8",
            "C16orf72",
            "ZMYM4",
            "ZBTB11",
            "C3orf17",
            "SP3"
        ]
    },
    {
        "golabel": "ZNF19_regulon_activity",
        "gene": [
            "SNTN",
            "LRRC48",
            "DNAH6",
            "WDR93",
            "FAM81B",
            "C1orf192",
            "FBXO15",
            "KIF6",
            "EFCAB6",
            "LILRA3",
            "C9orf98",
            "TTC23L",
            "FJX1",
            "DNAJB13",
            "ANLN",
            "CDKN3",
            "PRR11",
            "NID2",
            "CHST11",
            "KIF18B",
            "CDC20",
            "CCDC30",
            "CKAP2L",
            "C11orf82",
            "CCNA2",
            "MELK",
            "BUB1",
            "UBE2S",
            "CASC2",
            "GTSE1",
            "CCNB1",
            "LCA5L",
            "FAM47E",
            "GSG2",
            "NPHP1",
            "SPA17",
            "C15orf56",
            "CC2D2A",
            "ZFP2",
            "ZNF429",
            "LRTOMT",
            "C11orf52",
            "CDNF",
            "ZNF396",
            "NUDT7",
            "NUDT13",
            "KPNA2",
            "C16orf48",
            "FAM164C",
            "MPL",
            "GNB4",
            "ZNF778",
            "LMNB2",
            "C16orf46",
            "NEK8",
            "THOC4",
            "GTF2IRD2P1",
            "ESRP2",
            "POLR2C",
            "GTF2IRD2",
            "GAS8",
            "CES2",
            "FUK",
            "ZNF33B",
            "IFT88",
            "DHODH",
            "ZNF319",
            "CLUAP1",
            "DYNC2LI1",
            "ZNF23",
            "MLYCD",
            "PRMT7",
            "OMA1",
            "TCF25",
            "BBS2",
            "ZFP90",
            "TERF2IP",
            "DYNC1LI2",
            "AP1G1",
            "DDX19B",
            "KIAA0174"
        ]
    },
    {
        "golabel": "ZNF205_regulon_activity",
        "gene": [
            "LOC643719",
            "C1orf170",
            "RNF208",
            "FAM173A",
            "ZNF579",
            "UGCG",
            "NR2F6",
            "GIYD2",
            "ZNF837",
            "RPUSD1",
            "BBC3",
            "FAM135A",
            "MANEA",
            "KIF2A",
            "MFSD10",
            "INO80B",
            "ZNF768",
            "C7orf27",
            "RABEP2",
            "PIGQ",
            "SPATA2L",
            "FOXN2",
            "OSTM1",
            "SOLH",
            "ZNF414",
            "CCDC101",
            "FAM100A",
            "SLC38A10",
            "CLN3",
            "ZNF598",
            "FLYWCH2",
            "NFKBIL1",
            "E4F1",
            "LZTS2",
            "OSBPL8",
            "ZNF213",
            "UBA3",
            "KCTD20",
            "MIER3",
            "STUB1",
            "CMTM6",
            "NAGPA",
            "AXIN1",
            "UHRF1BP1L",
            "SCYL2",
            "ZNF668",
            "GFER",
            "CDIPT",
            "RNGTT",
            "RABL3",
            "NPRL3",
            "TBL3",
            "YTHDF3",
            "C16orf42",
            "KIAA1033",
            "EAF1",
            "ZNF672",
            "ZNF800",
            "CTBP1",
            "HIAT1",
            "FAM116A",
            "RNPS1",
            "API5"
        ]
    },
    {
        "golabel": "ZNF211_regulon_activity",
        "gene": [
            "ZSCAN4",
            "ATP13A4",
            "PTPLA",
            "RFX2",
            "BCAM",
            "CACNB1",
            "ZNF493",
            "CSGALNACT1",
            "PRRT3",
            "SLC25A29",
            "KCNC3",
            "PER3",
            "MRPS35",
            "NBPF14",
            "EXPH5",
            "C20orf24",
            "ZSCAN18",
            "C1QBP",
            "HTATIP2",
            "PHB2",
            "ZNF671",
            "BZW1",
            "MRPL42",
            "ZNF814",
            "ZNF547",
            "ATP5B",
            "PRDX3",
            "PSMD14",
            "TMED2",
            "VDAC2",
            "SYNJ1",
            "CABIN1",
            "ZNF773",
            "SLC7A6",
            "GHITM",
            "TRIM62",
            "ZNF160",
            "NDUFS1",
            "ZNF264",
            "ZC3H15",
            "MRPS16",
            "COPZ1",
            "PSMD7",
            "COX15",
            "USP4"
        ]
    },
    {
        "golabel": "ZNF219_regulon_activity",
        "gene": [
            "AIM2",
            "C14orf176",
            "PRICKLE4",
            "FITM1",
            "RAPGEF3",
            "SLC25A29",
            "MBOAT2",
            "CCDC109B",
            "KLHL5",
            "ITGAV",
            "SOX13",
            "AP1G2",
            "PLXNB1",
            "ECHDC2",
            "SGSM2",
            "MZF1",
            "JMJD7-PLA2G4B",
            "RAB31",
            "NRIP1",
            "CRTC1",
            "ZDHHC1",
            "CALU",
            "RECQL",
            "ZBTB42",
            "MIB2",
            "RAVER2",
            "RALB",
            "FAM114A1",
            "WASH2P",
            "SDR39U1",
            "MAN2C1",
            "LYN",
            "WASH3P",
            "OPTN",
            "RGL2",
            "ZNF444",
            "ANKIB1",
            "ZNF362",
            "BCL7A",
            "ZNF414",
            "VARS2",
            "METT11D1",
            "ZNF839",
            "ZNF446",
            "UBA6",
            "UBE2D1",
            "VRK2",
            "ZNF267",
            "LUZP6",
            "CDAN1",
            "SEC24A",
            "ACTR3",
            "ROD1",
            "GNA13",
            "AP3S1",
            "C14orf93",
            "STK19",
            "RING1",
            "SLC30A7",
            "VPS52",
            "PICALM",
            "DCAF11",
            "RXRB",
            "ACTR2"
        ]
    },
    {
        "golabel": "ZNF22_regulon_activity",
        "gene": [
            "SLC38A8",
            "TMEM229A",
            "ASCL1",
            "PCP4",
            "EPHA7",
            "RET",
            "FOXI3",
            "COL25A1",
            "LOC145837",
            "C1orf95",
            "C20orf197",
            "SEC11C",
            "ERO1LB",
            "LOC100129066",
            "NRXN3",
            "PTPRH",
            "KIT",
            "KHDRBS3",
            "RHOF",
            "C14orf37",
            "ST6GALNAC3",
            "ID2B",
            "REEP6",
            "BCL11A",
            "ITGB4",
            "LIPH",
            "PDE3B",
            "PLAG1",
            "PLCB1",
            "ADAMTSL5",
            "PRSS22",
            "C1orf170",
            "CCNB1IP1",
            "ID2",
            "PGBD1",
            "KRT19",
            "OAT",
            "PLEKHN1",
            "EPHA10",
            "E2F5",
            "SLC16A3",
            "TRIT1",
            "FZD3",
            "TTC22",
            "RARG",
            "MST1R",
            "MICALL2",
            "MRPL48",
            "SGPP1",
            "ACOT11",
            "FBF1",
            "PPL",
            "SLC9A1",
            "KCNK6",
            "BNIP3",
            "EPHA1",
            "IRF5",
            "AGRN",
            "RANGRF",
            "DTX2",
            "PRIC285",
            "C14orf104",
            "CDC42BPG",
            "LIMK1",
            "ZNF32",
            "PTMS",
            "CNNM4",
            "ATP5S",
            "C14orf167",
            "RNF138",
            "AHDC1",
            "BCL9L",
            "ACPL2",
            "PLIN3",
            "FBXO33",
            "TFAM",
            "ARHGEF10L",
            "ZNF124",
            "FAM109A",
            "TRAPPC6B",
            "C14orf101",
            "ZSCAN12",
            "SMURF1",
            "RPAIN",
            "DNAJC18",
            "IQSEC2",
            "CERK",
            "TICAM1",
            "ARHGEF5",
            "RAB43",
            "PRKRIR",
            "MAPK8",
            "KBTBD6",
            "PCGF6",
            "MGAT4B",
            "SIRT1",
            "CLCN7",
            "SLC24A6",
            "ZNFX1",
            "MED15",
            "ZNF187",
            "NSMCE4A",
            "URGCP",
            "TTC7A",
            "RAB11FIP5",
            "PAPOLA",
            "TRAF7",
            "SNX5",
            "PAIP2",
            "DDX50",
            "NFYB",
            "WBP4",
            "PPM1A",
            "MED4",
            "PPP3CB",
            "EIF4H"
        ]
    },
    {
        "golabel": "ZNF236_regulon_activity",
        "gene": [
            "ENO3",
            "C1orf95",
            "MYH7B",
            "ANKRD22",
            "C10orf125",
            "BCL2A1",
            "CRIPAK",
            "KSR1",
            "ARL11",
            "CSF2RA",
            "FXYD5",
            "TNFRSF12A",
            "S100A13",
            "RAB32",
            "GRAMD4",
            "CKLF",
            "ATP8B1",
            "ZNF397",
            "HLA-H",
            "PCM1",
            "RTTN",
            "LGALS3",
            "SOCS7",
            "RHOC",
            "BID",
            "NDUFB5",
            "SERTAD1",
            "PHLPP1",
            "SEP15",
            "ZCCHC2",
            "ZNF618",
            "MED13L",
            "CASP4",
            "ANKRD26",
            "ULK2",
            "ZADH2",
            "PPT1",
            "IFNGR2",
            "BAK1",
            "SUMO3",
            "LOC550643",
            "PEPD",
            "POGZ",
            "C12orf51",
            "KIAA0649",
            "C1orf69",
            "IL10RB",
            "ZNF37A",
            "PTTG1IP",
            "ZCCHC17",
            "ZBTB40",
            "RWDD1",
            "ZNF622",
            "KIAA1468",
            "KIAA0195",
            "ELOVL1",
            "ZNF343",
            "REXO2",
            "ZNF407",
            "RER1",
            "ARF4",
            "ZCRB1",
            "YIPF1",
            "SETD5",
            "ZSCAN29",
            "MLH3",
            "MBD1",
            "TCHP",
            "ARPC2",
            "ATG3",
            "FAM32A"
        ]
    },
    {
        "golabel": "ZNF25_regulon_activity",
        "gene": [
            "RANBP3L",
            "LOC100133985",
            "C1QTNF7",
            "HMGCLL1",
            "CHAC1",
            "KAL1",
            "ITGA9",
            "CDT1",
            "NHEDC1",
            "DCN",
            "KRT18",
            "ZFP2",
            "KRT8",
            "SLC25A10",
            "TP53INP1",
            "KLHDC1",
            "H2AFX",
            "ARHGEF9",
            "PKP3",
            "ST14",
            "KAT2B",
            "SLC3A2",
            "STK17B",
            "ALS2CR8",
            "PAK4",
            "ZNF441",
            "DCPS",
            "OTUD1",
            "CCDC137",
            "CLN6",
            "PTGES2",
            "NEK7",
            "ZNF248",
            "RUVBL2",
            "NOC4L",
            "SENP7",
            "WDR47",
            "ZFYVE20",
            "DDX54",
            "DPP3",
            "CSGALNACT2",
            "BRMS1",
            "IKZF5",
            "KIFAP3",
            "PES1",
            "KLHL20",
            "PRPF19",
            "ZNF408",
            "RNF146",
            "EPC1",
            "ZNF438",
            "VAMP4",
            "PPP3CB",
            "EI24",
            "SF3B2"
        ]
    },
    {
        "golabel": "ZNF267_regulon_activity",
        "gene": [
            "CLEC6A",
            "ENTHD1",
            "KIAA1984",
            "CD70",
            "G0S2",
            "CCL7",
            "TGFBI",
            "AIM2",
            "MMP12",
            "OSGIN1",
            "CD274",
            "ATOH8",
            "TNFRSF9",
            "CCL11",
            "KLF15",
            "TACC2",
            "KCNJ11",
            "MOSC1",
            "FASN",
            "PMAIP1",
            "RAP1GAP",
            "TFCP2L1",
            "GLS",
            "GPR84",
            "SORBS2",
            "CLEC2B",
            "BATF3",
            "PDCD1LG2",
            "CLEC4A",
            "GBP1",
            "PTPN22",
            "ALDH3A2",
            "TNFSF4",
            "TFEC",
            "SAMSN1",
            "OBSL1",
            "SCNN1A",
            "SLC22A23",
            "IL17RE",
            "CD80",
            "ANKRD9",
            "DSE",
            "NEDD4L",
            "GYG2",
            "IFI16",
            "FAS",
            "LOC154761",
            "HAVCR2",
            "MMD",
            "PHF17",
            "NCEH1",
            "XRCC4",
            "PIK3AP1",
            "FAM115C",
            "PPP1R2P1",
            "RNF208",
            "CD86",
            "CCDC109B",
            "MMP15",
            "CD53",
            "ZNF219",
            "GSTP1",
            "CABC1",
            "FLJ36031",
            "FRAT1",
            "LCP2",
            "ITGAV",
            "STK17A",
            "TRIM59",
            "FN3K",
            "DAPP1",
            "SHMT1",
            "PLSCR1",
            "SKAP2",
            "PICK1",
            "DCK",
            "TXNRD2",
            "C22orf27",
            "ZNF430",
            "C17orf28",
            "NRIP1",
            "KCTD5",
            "ZBTB42",
            "KIAA1543",
            "NCK1",
            "SLC25A4",
            "CLDND1",
            "ESRP2",
            "ZNF92",
            "BCL10",
            "LASS2",
            "PWWP2B",
            "C9orf7",
            "RAP2B",
            "IRF2BP1",
            "IFNAR2",
            "GYG1",
            "SFT2D2",
            "SLC48A1",
            "KIAA0664",
            "FOXN2",
            "FBXW4",
            "KIAA0649",
            "ACAD10",
            "C3orf38",
            "ZBTB7B",
            "C14orf118",
            "RAP2C",
            "MOBKL1B",
            "KIAA0195",
            "BIRC2",
            "C9orf86",
            "ACTR3",
            "ARF6",
            "CMTM6",
            "STYX",
            "TMEM188",
            "GNA13",
            "FXR2",
            "POMT1",
            "USP15",
            "CAPZA1",
            "DCTN1",
            "TBC1D23",
            "CNNM3",
            "DCTN5",
            "VPS52",
            "ITCH",
            "PALB2",
            "BAT3",
            "UNC45A",
            "ATG3",
            "POLL",
            "DIS3L2",
            "TTC15",
            "SCAP",
            "C16orf72",
            "ATG9A",
            "ACTR2"
        ]
    },
    {
        "golabel": "ZNF275_regulon_activity",
        "gene": [
            "PNMA6A",
            "FLJ40330",
            "C19orf33",
            "PPARG",
            "POU2AF1",
            "KCNN3",
            "SLC24A3",
            "ZFP92",
            "GSTO2",
            "XYLT1",
            "KRT19",
            "BLVRB",
            "SFN",
            "ERN1",
            "P2RY8",
            "KIF26B",
            "IL18",
            "ITPKB",
            "PRDX1",
            "SQRDL",
            "NAV1",
            "TP53INP1",
            "FAM120C",
            "ZDHHC9",
            "INSR",
            "SLC35A1",
            "SLC1A4",
            "RBX1",
            "MED13L",
            "LIAS",
            "DOCK1",
            "ZNF75D",
            "MID2",
            "CREB3L2",
            "FICD",
            "SH3PXD2A",
            "IKZF4",
            "SEMA4D",
            "ASH1L",
            "MED18",
            "GTF2B",
            "ATP5F1",
            "CCDC51",
            "ATP5H",
            "ZNF81",
            "MRPL46",
            "ATRX",
            "DSTYK",
            "KIAA2026",
            "RMND1",
            "DUT",
            "UQCRC1",
            "RPF1",
            "PHB",
            "TLE3",
            "ZBTB33",
            "MECP2",
            "MDH1",
            "PHF2",
            "ZNF41",
            "METTL6",
            "CCDC71",
            "XIAP",
            "MLH1"
        ]
    },
    {
        "golabel": "ZNF276_regulon_activity",
        "gene": [
            "CCDC78",
            "KRT73",
            "FAM138F",
            "LCNL1",
            "C10orf50",
            "H1FNT",
            "C17orf66",
            "C16orf81",
            "FAM183B",
            "LOC440896",
            "PRRT2",
            "MAPK15",
            "PAR1",
            "KRTAP5-8",
            "PLIN5",
            "C1orf175",
            "C12orf71",
            "CPNE7",
            "LOC283663",
            "CLDND2",
            "TNFSF14",
            "CAPN3",
            "HSPA7",
            "SLFN14",
            "GIPR",
            "DBH",
            "SLC6A7",
            "TSPAN32",
            "DNAH1",
            "LOC115110",
            "PRICKLE4",
            "LOC391322",
            "RASGRP2",
            "MYO15B",
            "PATL2",
            "C19orf71",
            "C11orf21",
            "C9orf139",
            "PARP15",
            "LOC728392",
            "LOC400931",
            "ZAP70",
            "PTCH2",
            "C16orf3",
            "MUSTN1",
            "LOC91450",
            "LOC728989",
            "FOXD4L6",
            "FITM1",
            "SEC16B",
            "GOLGA8B",
            "SEC31B",
            "LOC100272216",
            "NEAT1",
            "ARRDC5",
            "ALS2CL",
            "HCG26",
            "ATG16L2",
            "TSSK3",
            "C1orf220",
            "PMS2L11",
            "HCG27",
            "IDUA",
            "NLRP1",
            "TMEM38B",
            "FLJ10661",
            "CD160",
            "C15orf52",
            "NLRC3",
            "RASAL3",
            "LRP12",
            "NFKBID",
            "LOC146880",
            "TTLL3",
            "CCDC88B",
            "CC2D2B",
            "PLCB2",
            "AGAP5",
            "MICALL2",
            "LENG8",
            "TNFRSF14",
            "LOC283922",
            "C13orf37",
            "VAMP1",
            "OSBPL7",
            "PLEKHM1P",
            "MLKL",
            "TRIM66",
            "C14orf129",
            "ANKMY1",
            "ZFYVE28",
            "HSPA13",
            "FHOD1",
            "NBEAL2",
            "DENND3",
            "MZF1",
            "MICAL1",
            "JMJD7-PLA2G4B",
            "ARRDC2",
            "NPIP",
            "LOC100129387",
            "NKTR",
            "VBP1",
            "TUBGCP6",
            "ACTL6A",
            "ABCA2",
            "FAM38A",
            "HMHA1",
            "UBA7",
            "PARP10",
            "TCIRG1",
            "TWF1",
            "C16orf7",
            "GPN1",
            "TAF1C",
            "PTK2B",
            "DGKQ",
            "FCHSD1",
            "RSRC1",
            "MAN2C1",
            "TMTC3",
            "AGXT2L2",
            "ARHGEF1",
            "GLO1",
            "TMED2",
            "CCDC126",
            "DEF6",
            "TEP1",
            "RBM6",
            "FLJ10038",
            "DCUN1D1",
            "HDAC10",
            "LRCH4",
            "KLHL7",
            "FAM160B2",
            "TSN",
            "SRRM2",
            "DENND1C",
            "EHBP1L1",
            "YWHAQ",
            "KIAA1715",
            "POLM",
            "METTL2A",
            "NAT6",
            "MAST3",
            "TRIM41",
            "SLC7A6",
            "MOBKL3",
            "RDH11",
            "RRN3P3",
            "ARAP1",
            "ERICH1",
            "ZRSR2",
            "CUL9",
            "RNF2",
            "ZNF23",
            "LZIC",
            "RNF166",
            "LMBR1",
            "TCF25",
            "PSD4",
            "EXOC5",
            "ZMPSTE24",
            "C2orf69",
            "USP20",
            "VTA1",
            "H2AFV",
            "TYK2",
            "CAMTA2",
            "UBXN2A",
            "PPP1CB",
            "PLD2",
            "SMARCE1",
            "WHAMM",
            "ANKRD11",
            "COPB1",
            "SLC25A28",
            "NXF1",
            "UBE2R2",
            "EML3",
            "FBXO31",
            "POLG",
            "TBRG1",
            "ZFR",
            "DYNC1I2",
            "AKAP8"
        ]
    },
    {
        "golabel": "ZNF280D_regulon_activity",
        "gene": [
            "RSL24D1",
            "C15orf33",
            "C17orf44",
            "NEO1",
            "DYX1C1",
            "RPS27L",
            "XBP1",
            "MCEE",
            "TRIM47",
            "LIMK1",
            "ALG5",
            "LOC100129387",
            "SENP8",
            "LMNB2",
            "RHBDF2",
            "N6AMT2",
            "C1orf203",
            "FAM165B",
            "ORAI2",
            "CCM2",
            "DTWD1",
            "C15orf61",
            "TUBG1",
            "ALS2CR8",
            "WDR61",
            "CCPG1",
            "SELS",
            "SLC25A22",
            "RAP2B",
            "SHKBP1",
            "BBS4",
            "C17orf48",
            "POLI",
            "EIF3B",
            "AUH",
            "CCNDBP1",
            "PPARD",
            "LOC729082",
            "C12orf26",
            "EFHA1",
            "MAP1S",
            "NACC1",
            "INTS10",
            "HECTD2",
            "COPS2",
            "NSMCE4A",
            "TMEM168",
            "GIT1",
            "SENP7",
            "DNAJC27",
            "USP3",
            "TCF12",
            "ALG13",
            "PIGB",
            "C15orf40",
            "GRINL1A",
            "N4BP2L2",
            "FBXO3",
            "IKZF5",
            "GIN1",
            "TRPM7",
            "FXC1",
            "CASC4",
            "ACTB",
            "WDR73",
            "AATF",
            "LINS1",
            "SEPT9",
            "VPS36",
            "CLPX",
            "CDKN2AIP",
            "FEM1B",
            "TMEM104",
            "MTFMT",
            "MORF4L1",
            "SCAND2",
            "C9orf156",
            "ARHGDIA",
            "MAP2K5",
            "TM2D3",
            "USP8",
            "GATAD2A",
            "ZFYVE16",
            "NARG2",
            "CARM1",
            "CTNNBL1",
            "ARPP19",
            "AP1M1",
            "PLDN",
            "ARIH1",
            "ZBTB1",
            "HELQ",
            "WIPI2",
            "C15orf44",
            "RNF111",
            "XPO6",
            "PRPF4B"
        ]
    },
    {
        "golabel": "ZNF281_regulon_activity",
        "gene": [
            "SECISBP2L",
            "PLA2G4A",
            "LOC115110",
            "HLA-J",
            "LIME1",
            "EFNB1",
            "RTP4",
            "LPIN2",
            "TBC1D10C",
            "IFI27L2",
            "PYCARD",
            "PSTPIP1",
            "APOBEC3G",
            "PANK1",
            "IL15",
            "LGALS9",
            "HLA-F",
            "EMP3",
            "TNFRSF14",
            "CARD16",
            "LONRF3",
            "SMARCA1",
            "STAC3",
            "NCF4",
            "SH3BGRL3",
            "PSMB10",
            "EFHD2",
            "HLA-A",
            "COTL1",
            "FLT3LG",
            "LAMC1",
            "SLC19A2",
            "LOC728743",
            "NFKBIE",
            "UBA7",
            "TMEM51",
            "TREX1",
            "C1orf58",
            "C19orf66",
            "TOR1AIP2",
            "C19orf25",
            "PLEKHJ1",
            "KDM5B",
            "ARNT",
            "GMCL1",
            "CCDC53",
            "PPPDE1",
            "PTPN6",
            "RANBP9",
            "CNST",
            "SOCS5",
            "RBBP5",
            "SSR1",
            "CAMSAP1L1",
            "CSK",
            "ACBD3",
            "ATF6",
            "HPS1",
            "C1orf55",
            "ATG7",
            "C1orf124",
            "PRRC1",
            "RBM12"
        ]
    },
    {
        "golabel": "ZNF282_regulon_activity",
        "gene": [
            "PLEKHN1",
            "MGC12982",
            "HIGD1A",
            "TMBIM4",
            "FBF1",
            "RPS27L",
            "PLXNA3",
            "EPHA1",
            "OR2A7",
            "EPHB4",
            "IMPDH1",
            "AZI1",
            "LIMK1",
            "ALG5",
            "INTS1",
            "ZNF775",
            "MAST2",
            "ORAI2",
            "ARHGEF35",
            "AHDC1",
            "APH1B",
            "MEX3D",
            "KRBA1",
            "FBXL19",
            "PTCD1",
            "ZNF341",
            "ZMIZ2",
            "KIAA0415",
            "TMUB1",
            "SLC12A9",
            "ERLEC1",
            "CASKIN2",
            "FASTK",
            "UBLCP1",
            "MTA1",
            "NCRNA00081",
            "RUSC1",
            "C7orf27",
            "FNDC3A",
            "TAF6",
            "SERP1",
            "TSNAX",
            "ARHGEF5",
            "SEPT10",
            "ZC3H3",
            "PELI3",
            "TELO2",
            "ZCCHC10",
            "C15orf24",
            "ADH5",
            "FAM189B",
            "CHPF2",
            "CCDC137",
            "SKP1",
            "GHITM",
            "DPH3",
            "UQCRC2",
            "INTS10",
            "ABHD13",
            "MOV10",
            "DCTN6",
            "AGAP3",
            "ZFAND6",
            "MIER2",
            "TRIM65",
            "C17orf70",
            "RILPL1",
            "PPP2CB",
            "UNC50",
            "TANK",
            "SLC35A5",
            "UBE2O",
            "SART1",
            "TMEM66",
            "SPCS1",
            "SUCLA2",
            "NDFIP1",
            "IGHMBP2",
            "PWP2",
            "CASP2",
            "APEX2",
            "MEN1",
            "RAVER1",
            "ZNF212",
            "PFKL",
            "SPCS3",
            "HGS",
            "POM121",
            "ZNF746",
            "LEPROTL1",
            "REXO1",
            "SRRT",
            "SEPT9",
            "ADRBK1",
            "SACM1L",
            "C11orf58",
            "EIF1B",
            "AMPD2",
            "TMEM104",
            "MORF4L1",
            "CHERP",
            "C7orf26",
            "C19orf29",
            "ERP44",
            "EXOC7",
            "CSNK1D"
        ]
    },
    {
        "golabel": "ZNF286A_regulon_activity",
        "gene": [
            "GPC2",
            "ODZ3",
            "WNK3",
            "TET1",
            "EFNB3",
            "PHGDH",
            "MEX3A",
            "VASH2",
            "SFTA2",
            "DZIP1",
            "SMO",
            "GPR161",
            "PGBD1",
            "WDHD1",
            "GSG2",
            "ZNF643",
            "C18orf54",
            "C14orf145",
            "ZNF286B",
            "ATAD5",
            "MEX3B",
            "MCM8",
            "GALNT12",
            "ZNF697",
            "SQRDL",
            "PGAP1",
            "VAMP8",
            "PPT2",
            "RASSF7",
            "RBL1",
            "LMF1",
            "CEP97",
            "BLMH",
            "TOPBP1",
            "C6orf167",
            "EXTL2",
            "LLGL1",
            "ASL",
            "MPG",
            "ASAP1",
            "MVP",
            "SPR",
            "ZNF232",
            "CD63",
            "E2F3",
            "DHX33",
            "OBFC1",
            "ATP6V0E1",
            "WDR35",
            "ZBTB39",
            "LOC221710",
            "PFAS",
            "XPO5",
            "HDAC2",
            "MIB1",
            "ESF1",
            "UPF3B",
            "ACAA1",
            "TMEM219",
            "WRAP53",
            "TOP3A",
            "HAGH",
            "CBX1",
            "PIGV",
            "KBTBD6",
            "PARP3",
            "SMC6",
            "C11orf30",
            "TEX264",
            "USP22",
            "POFUT1",
            "DVL2",
            "CYB561D2",
            "C2orf44",
            "TSR1",
            "ATP6V0C",
            "C17orf39",
            "ADNP",
            "COX10",
            "SCO1",
            "ANXA11",
            "UBE2G1",
            "UBC",
            "RPA1",
            "RABEP1"
        ]
    },
    {
        "golabel": "ZNF317_regulon_activity",
        "gene": [
            "ACCN2",
            "VAMP5",
            "KRTCAP3",
            "MGST1",
            "STRA13",
            "RAG1AP1",
            "TMEM14B",
            "CCDC56",
            "BOLA1",
            "IMMP2L",
            "NENF",
            "TMEM9",
            "C2orf28",
            "PDCD6",
            "LRRK1",
            "PCNXL2",
            "HBXIP",
            "OST4",
            "CHCHD5",
            "RAB3D",
            "C16orf91",
            "DPY30",
            "MAGED2",
            "ELF4",
            "CEP110",
            "ZNF426",
            "FNBP1",
            "ZFP112",
            "NUBP2",
            "HMGCL",
            "MLLT1",
            "ENSA",
            "DICER1",
            "ZSCAN22",
            "YTHDC2",
            "ZNF791",
            "LSM11",
            "ZNF562",
            "NIT1",
            "STK4",
            "BRD4",
            "MSL2",
            "ZNF490",
            "FAM178A",
            "NOL8",
            "FEM1A",
            "AAMP"
        ]
    },
    {
        "golabel": "ZNF318_regulon_activity",
        "gene": [
            "DDIT4",
            "PDZK1IP1",
            "MT1F",
            "S100A6",
            "USP49",
            "PRKCDBP",
            "PANK1",
            "CYBA",
            "TUBA4A",
            "OCIAD2",
            "SOCS7",
            "GPX1",
            "CIB1",
            "SERTAD1",
            "ZNF192",
            "TCEB2",
            "SAT1",
            "MPG",
            "ICK",
            "SHPRH",
            "C19orf24",
            "POLD4",
            "ZBTB39",
            "REV3L",
            "XPO5",
            "MDC1",
            "ASH1L",
            "NCOA1",
            "UHRF1BP1",
            "ZCCHC11",
            "PRELID1",
            "ATRN",
            "TAF8",
            "ANKS1A",
            "NUP153",
            "AFG3L2",
            "C11orf30",
            "RNMT",
            "NCOA6",
            "USP42",
            "BPTF",
            "KIAA0240",
            "CDC5L",
            "UBR2",
            "SOS1",
            "SHISA5",
            "FTSJD2",
            "ZRANB1",
            "PRPF4B"
        ]
    },
    {
        "golabel": "ZNF32_regulon_activity",
        "gene": [
            "SMAD5OS",
            "PFDN5",
            "MTCP1NB",
            "PLEC",
            "C21orf119",
            "C10orf11",
            "NDUFA2",
            "C20orf196",
            "MGMT",
            "MAGEH1",
            "SPATA24",
            "TAOK1",
            "C12orf62",
            "EAPP",
            "NDUFA13",
            "NENF",
            "C1orf57",
            "RPS13",
            "CDK12",
            "PSTK",
            "RPS24",
            "RNF213",
            "COMMD3",
            "FAM165B",
            "C2orf64",
            "ACOT1",
            "BCL9L",
            "ATP5O",
            "LOC729678",
            "FAM104B",
            "UXT",
            "NDUFA1",
            "EIF3K",
            "CETN2",
            "TRRAP",
            "LYPLAL1",
            "HAUS4",
            "C15orf61",
            "ING4",
            "LOC388789",
            "ZNF485",
            "CREB3L2",
            "AMZ2P1",
            "H3F3A",
            "COMMD7",
            "MSRB2",
            "ZNRD1",
            "POLR1A",
            "MED1",
            "ZNF14",
            "OSGEP",
            "MYH9",
            "ARL3",
            "AK2",
            "EHBP1L1",
            "CHCHD1",
            "C17orf81",
            "MRPL43",
            "TCEAL8",
            "CCDC104",
            "ANAPC16",
            "SETMAR",
            "TATDN3",
            "LIPT1",
            "CUTA",
            "ALKBH3",
            "NDUFS3",
            "ZNF22",
            "RRAGB",
            "CRYZL1",
            "ASB13",
            "ELAC1",
            "DDX28",
            "ZNF140",
            "TRIP12",
            "C19orf56",
            "UBR4",
            "MAP4",
            "GPATCH8",
            "CUEDC2",
            "SPG21"
        ]
    },
    {
        "golabel": "ZNF335_regulon_activity",
        "gene": [
            "ANXA2P3",
            "SALL4",
            "RLTPR",
            "TNFRSF25",
            "FAM157B",
            "PABPC1L",
            "DDX12",
            "TMEM184A",
            "LAMA5",
            "FAM157A",
            "LOC642846",
            "PRDM15",
            "CHTF18",
            "PLEKHG5",
            "LOC100132287",
            "SLC26A1",
            "LOC100133331",
            "LOC150776",
            "LOC399744",
            "RTEL1",
            "KCNMB3",
            "MBD6",
            "PRPF40B",
            "PITPNM2",
            "LPIN3",
            "KRCC1",
            "TMEM106B",
            "ZNF627",
            "PASK",
            "CBFA2T2",
            "POLE",
            "HIP1R",
            "AFG3L1",
            "EP400NL",
            "ATXN7L2",
            "RAD9A",
            "GRIPAP1",
            "FBRSL1",
            "PLCG1",
            "C8orf83",
            "TNK2",
            "SLC26A11",
            "SFRS16",
            "RNF139",
            "TAF1C",
            "INPPL1",
            "DHX34",
            "BFAR",
            "C9orf21",
            "ZNF277",
            "C17orf56",
            "GAK",
            "ULK1",
            "SFRS12IP1",
            "BTBD12",
            "MLL2",
            "MLL4",
            "SYPL1",
            "CCDC142",
            "NEURL4",
            "CDC42",
            "DENND4B",
            "DDX51",
            "SNRNP70",
            "SEC62",
            "DPH3",
            "SCAMP1",
            "AARS2",
            "SLC9A8",
            "STK11IP",
            "KIAA0913",
            "AKAP8L",
            "UBTD2",
            "ABCC10",
            "C6orf211",
            "TJAP1",
            "MINK1",
            "KIAA0195",
            "KDM5C",
            "BANP",
            "ACIN1",
            "ACTR5",
            "COPS4",
            "RNF11",
            "ZBTB17",
            "CMPK1",
            "IGHMBP2",
            "GLUD1",
            "SMARCC2",
            "RBM10",
            "RBM19",
            "PHKA2",
            "SRRT",
            "ABHD5",
            "SETD1B",
            "SFRS8",
            "AAAS",
            "UNK",
            "DHX16",
            "YIPF5",
            "TCHP",
            "SKIV2L",
            "NAIF1",
            "ZNF142",
            "SPTLC1",
            "NCOA5",
            "PCIF1"
        ]
    },
    {
        "golabel": "ZNF33A_regulon_activity",
        "gene": [
            "TGFBI",
            "SPP1",
            "LYPD5",
            "ULBP2",
            "PRINS",
            "SRPX2",
            "LONRF2",
            "EPHB2",
            "BCL2A1",
            "UPP1",
            "TSPAN5",
            "FCGR1A",
            "PLCH1",
            "PDK3",
            "UNC13B",
            "PHF17",
            "IFI35",
            "PCM1",
            "SNX8",
            "FRAT1",
            "PLXNB1",
            "BID",
            "STARD3NL",
            "RPGR",
            "ZNF778",
            "CTSB",
            "SCAI",
            "TUBA1C",
            "MRPL11",
            "TPST1",
            "SPATS2L",
            "MDM4",
            "TUBA1B",
            "RFC2",
            "ZNF33B",
            "AHI1",
            "CORO1C",
            "RPL23AP7",
            "RGS19",
            "ZNF37A",
            "CPEB3",
            "GNPDA1",
            "ZNF248",
            "NTAN1",
            "UBE2D4",
            "NR2C2",
            "LSM6",
            "LARP4B",
            "DBNL",
            "PAN3",
            "C10orf4",
            "BCL7B",
            "MGEA5",
            "TMEM199",
            "EPC1",
            "ZC3H7A",
            "RAB5C",
            "PRPF4B",
            "SLTM"
        ]
    },
    {
        "golabel": "ZNF33B_regulon_activity",
        "gene": [
            "PLA2G10",
            "AQP7",
            "PBLD",
            "CCL11",
            "GZMB",
            "SEMA4G",
            "TACC2",
            "ADAM12",
            "BEND6",
            "OVGP1",
            "C9orf152",
            "PDE4D",
            "SELENBP1",
            "MYBL2",
            "ALDH3B1",
            "SPHK1",
            "PFKFB4",
            "C10orf95",
            "RCN3",
            "CTHRC1",
            "MECOM",
            "CENPW",
            "CDC20",
            "SNAI1",
            "CDCA8",
            "GADD45A",
            "HAPLN3",
            "RORC",
            "TK1",
            "EMP3",
            "ASF1B",
            "TUBB6",
            "ZNF321",
            "NUDT13",
            "BAG1",
            "KPNA2",
            "RNASEH2A",
            "FLJ36031",
            "FRAT1",
            "ALDH5A1",
            "ERBB3",
            "LIMD1",
            "CCNG1",
            "FRAT2",
            "SFXN2",
            "FAM22D",
            "RELT",
            "CALU",
            "NUDT1",
            "LEPRE1",
            "DUSP14",
            "KCTD5",
            "THOC4",
            "PLOD1",
            "KCTD17",
            "ANKAR",
            "LRRC27",
            "ALS2CR8",
            "TUBA1B",
            "RFC2",
            "ZNF485",
            "C10orf57",
            "PDE8A",
            "FAM117B",
            "GNA12",
            "DRAP1",
            "IFT88",
            "LETMD1",
            "ZNF19",
            "PPIP5K1",
            "TCF7L2",
            "DET1",
            "ZFP62",
            "GLT25D1",
            "C7orf70",
            "ANAPC16",
            "TTC19",
            "ZNF33A",
            "NTAN1",
            "CNPY4",
            "PCBD2",
            "RNF216L",
            "C2orf67",
            "EIF4B",
            "JMJD6",
            "N4BP2L2",
            "SH3GL1",
            "IKZF5",
            "PARP16",
            "ACTB",
            "VPS36",
            "COX15",
            "FAM21C",
            "CSTF2T",
            "POLL",
            "DNAJB12",
            "CAPZB",
            "NRBP1",
            "XPA",
            "C10orf76"
        ]
    },
    {
        "golabel": "ZNF341_regulon_activity",
        "gene": [
            "DUSP5P",
            "CACNG4",
            "DOCK3",
            "DCST2",
            "SNX21",
            "CLDN3",
            "PABPC1L",
            "TREX2",
            "C6orf124",
            "PROCA1",
            "C1orf170",
            "TBC1D3B",
            "ZGLP1",
            "LMTK3",
            "LOC146880",
            "GRID2IP",
            "C20orf151",
            "EVPL",
            "IRF7",
            "TFAP2C",
            "KLHL17",
            "FBF1",
            "PVRL4",
            "PLXNA3",
            "CDK5RAP3",
            "TBC1D3",
            "DTX2",
            "CCNG1",
            "LPIN3",
            "ABHD11",
            "AZI1",
            "CLDN4",
            "MAST2",
            "KAT2A",
            "ATXN7L2",
            "RAD9A",
            "ST14",
            "BTG1",
            "ATE1",
            "C4orf32",
            "ZSWIM4",
            "ELL2",
            "PCGF5",
            "C1orf159",
            "TUBG2",
            "MAP4K2",
            "GET4",
            "POR",
            "SLC12A9",
            "FASTK",
            "C17orf56",
            "UBLCP1",
            "PLEKHH3",
            "ZNF75A",
            "CCDC50",
            "C7orf27",
            "RECQL5",
            "SEPT10",
            "ANKRD13D",
            "SSH3",
            "CCDC137",
            "MTMR6",
            "NAT9",
            "CLCN7",
            "ZDHHC18",
            "SIPA1",
            "SCAMP1",
            "SIN3B",
            "RFNG",
            "TSEN54",
            "CANX",
            "XYLT2",
            "E4F1",
            "FBXL17",
            "DGCR14",
            "C17orf70",
            "TMED7",
            "TNPO1",
            "CTDSPL2",
            "GSS",
            "AXIN1",
            "NCOA4",
            "RALY",
            "SUCLA2",
            "ZNF212",
            "FAM108B1",
            "PDS5B",
            "ZNF282",
            "PAIP2",
            "GGA3",
            "MAP3K11",
            "PHF12",
            "CHMP4B",
            "STRADA",
            "EXOC7"
        ]
    },
    {
        "golabel": "ZNF35_regulon_activity",
        "gene": [
            "RPSA",
            "RPSAP58",
            "HAUS1",
            "HIGD1A",
            "LOC399744",
            "D2HGDH",
            "CNIH",
            "C14orf129",
            "IMMP1L",
            "MED28",
            "C7orf36",
            "HIP1R",
            "GNG10",
            "SELK",
            "PPIL1",
            "CYB5R4",
            "PKD1",
            "MYO18A",
            "TXNDC9",
            "MRPL39",
            "BTF3L4",
            "OLA1",
            "COMMD2",
            "SS18L2",
            "DPM1",
            "NSA2",
            "SRRM2",
            "RG9MTD1",
            "ACAD10",
            "C3orf38",
            "KIAA0556",
            "C5orf44",
            "CHD3",
            "GMFB",
            "TP53RK",
            "MOBKL3",
            "SNRPB2",
            "YRDC",
            "DPH3",
            "ZNF416",
            "ERCC8",
            "ZNF669",
            "THOC7",
            "DUSP11",
            "ABHD13",
            "DR1",
            "COPS2",
            "FLYWCH1",
            "NUP54",
            "WDR41",
            "C6orf153",
            "NUMA1",
            "SNRNP40",
            "ANAPC10",
            "UBA3",
            "TSC2",
            "ZNF561",
            "C3orf10",
            "ARF4",
            "ZNF140",
            "C11orf58",
            "ZKSCAN4",
            "DNAJC8",
            "FRG1",
            "RFX1",
            "UTP11L",
            "SFRS3",
            "MNT",
            "DNAJC24",
            "GBF1",
            "PPP1R8",
            "UBE2D3",
            "PSMD6",
            "AZI2",
            "THUMPD3",
            "DYNC1LI1",
            "MKRN2",
            "RPP14"
        ]
    },
    {
        "golabel": "ZNF358_regulon_activity",
        "gene": [
            "NRTN",
            "CTXN1",
            "C1orf229",
            "NPDC1",
            "LRP3",
            "SOX18",
            "LGR4",
            "CXADR",
            "CCDC85B",
            "CLEC11A",
            "FAM167B",
            "TGFB1I1",
            "C2orf27A",
            "HIC1",
            "MFRP",
            "FHL3",
            "PRAF2",
            "ZNF579",
            "HSD11B1L",
            "RP9P",
            "PTMS",
            "TUSC1",
            "ENTPD5",
            "ZBTB37",
            "KCTD17",
            "PRR24",
            "FAM127A",
            "PCBP4",
            "TOR1AIP2",
            "ZNF414",
            "CCDC92",
            "KLHL22",
            "IPP",
            "PKN1",
            "RILPL1",
            "TMEM161B",
            "CLPP",
            "AES",
            "AKAP10",
            "PLSCR3",
            "ERI2",
            "C4orf29",
            "CXorf38",
            "TRPM7",
            "C17orf59",
            "SLC39A3",
            "ELOF1",
            "MPP5",
            "UCK1",
            "MAP2K2",
            "C7orf26",
            "PIAS1",
            "C1orf55",
            "RBMXL1",
            "CDC40",
            "PPP2R4",
            "AP3M1",
            "WDR11",
            "USP16",
            "ZBTB11",
            "TMEM115",
            "NGLY1",
            "DULLARD",
            "RBM12"
        ]
    },
    {
        "golabel": "ZNF362_regulon_activity",
        "gene": [
            "GALNTL1",
            "C15orf48",
            "FGFR3",
            "COL9A2",
            "CPAMD8",
            "EMID1",
            "AMOT",
            "SCD5",
            "SLC22A17",
            "MYLK4",
            "PNMAL2",
            "KIF7",
            "AUTS2",
            "PIK3R3",
            "ISYNA1",
            "C22orf36",
            "CTF1",
            "SALL2",
            "WLS",
            "ARVCF",
            "PTPRU",
            "DTX3",
            "POC1B",
            "ARHGEF19",
            "MOCS1",
            "ZNF219",
            "FLJ10357",
            "IL28RA",
            "LOC284440",
            "CHST10",
            "PTK7",
            "TLE2",
            "ASAP3",
            "YPEL1",
            "APBB1",
            "C21orf122",
            "PBXIP1",
            "ZSCAN18",
            "LTBP3",
            "CYB5R4",
            "AHDC1",
            "C1orf89",
            "PYROXD1",
            "CCDC102A",
            "ERLIN1",
            "DTNB",
            "TNRC18",
            "C1orf198",
            "ARHGEF17",
            "TTLL1",
            "ARMC5",
            "TEAD3",
            "USP11",
            "KCTD9",
            "KIAA0495",
            "SAMD8",
            "PDIK1L",
            "PATZ1",
            "VDAC1",
            "ISCA1P1",
            "KIAA0319L",
            "BRF1",
            "ACBD5",
            "TRIM62",
            "LDLRAP1",
            "ZNF839",
            "DGCR2",
            "RERE",
            "C12orf5",
            "MEAF6",
            "AKT1",
            "LDB1",
            "SEC24A",
            "MAP2K1",
            "ZC3H15",
            "NFYC",
            "WDR24",
            "IARS",
            "DNAJC25",
            "GFM2",
            "ATG12",
            "USP15",
            "MED26",
            "DCAF5",
            "PLEKHB2",
            "PEF1",
            "TMEM39B",
            "KIAA1033",
            "WDTC1",
            "MECR",
            "C10orf119",
            "ALG2",
            "UBQLN1",
            "BSDC1",
            "SFRS4",
            "FBXO42"
        ]
    },
    {
        "golabel": "ZNF366_regulon_activity",
        "gene": [
            "MAS1L",
            "ADCYAP1R1",
            "CCDC141",
            "DCC",
            "KCND3",
            "KLHL33",
            "NFASC",
            "PREX2",
            "GFRA2",
            "XCR1",
            "ITGA8",
            "WNT9B",
            "SLIT3",
            "FAM38B",
            "TEK",
            "SLIT2",
            "PHACTR1",
            "ITGA9",
            "ZFP92",
            "PCDHGB7",
            "VWF",
            "GFOD1",
            "A2M",
            "CASS4",
            "CDKL5",
            "MRPS17",
            "KIAA1324L",
            "PARD3B",
            "NFATC2",
            "LAMA2",
            "KIRREL",
            "CDH5",
            "IL6ST",
            "GIMAP8",
            "ACE",
            "S1PR1",
            "MAST4",
            "SEC61G",
            "ITPR2",
            "CD93",
            "SPARCL1",
            "SYNM",
            "C1orf183",
            "PDCD5",
            "ARHGAP31",
            "FGD5",
            "AMOTL1",
            "ERG",
            "SERINC5",
            "PSMG3",
            "BUD31",
            "STARD8",
            "MMRN2",
            "ZEB2",
            "AKAP13",
            "LOC388796",
            "HSPG2",
            "TACC1",
            "PPIAL4G",
            "UQCRH",
            "BRIX1",
            "TGFBR2",
            "C11orf80",
            "UTRN",
            "SHFM1",
            "C11orf48",
            "PHACTR2",
            "PFDN6",
            "NOTCH1",
            "C5orf41",
            "SMARCA2",
            "C20orf194",
            "C20orf20",
            "HIPK3",
            "POLR2J",
            "MAGOH",
            "SGK269",
            "REV3L",
            "MRPL32",
            "CHCHD8",
            "KLF13",
            "POLR2H",
            "ZMIZ1",
            "MYCBP2",
            "TBRG4",
            "PPIA",
            "C7orf11",
            "ZFP106",
            "SNX29",
            "DENND4A",
            "HERC1",
            "SF3B14",
            "SIDT2",
            "RAPGEF2",
            "CDK5RAP1",
            "DDX56",
            "GNPTAB",
            "WDR74",
            "IL17RA",
            "GSS",
            "TGOLN2",
            "DMXL1",
            "THUMPD2",
            "WDR7",
            "CSNK2B",
            "BCS1L",
            "TRIM35",
            "SERINC1",
            "SETX",
            "NDST2"
        ]
    },
    {
        "golabel": "ZNF37A_regulon_activity",
        "gene": [
            "PAR5",
            "DERA",
            "RHOC",
            "POLE4",
            "INSR",
            "TSPAN6",
            "STOML1",
            "TCEB2",
            "ANKRD26",
            "ISCA2",
            "ZNF236",
            "LOC90784",
            "MRPL49",
            "B3GALT4",
            "ASH1L",
            "LOC550643",
            "TARSL2",
            "C17orf101",
            "UBE2A",
            "C11orf59",
            "GOLGA4",
            "ZNF33A",
            "ZNF445",
            "CHMP6",
            "KIAA2026",
            "TTC3",
            "ZNF343",
            "KIAA2018",
            "C10orf18",
            "GAPVD1",
            "TAF3",
            "UPF2",
            "DBNL",
            "ZSCAN29",
            "NFX1",
            "EPC1",
            "IKBKAP",
            "SETD2",
            "DNPEP",
            "SLTM",
            "RBBP6",
            "WAC"
        ]
    },
    {
        "golabel": "ZNF385A_regulon_activity",
        "gene": [
            "SLC2A5",
            "ITGAX",
            "TRPM2",
            "SPI1",
            "MYO7A",
            "SLC44A3",
            "STAC3",
            "CRYZ",
            "DOK3",
            "DDAH1",
            "ABCD1",
            "C11orf54",
            "DSTN",
            "SH3BP1",
            "KCTD17",
            "BTD",
            "SHKBP1",
            "PPA2",
            "FAM8A1",
            "NCKAP5L",
            "C3orf23",
            "C22orf9",
            "DGKZ",
            "NKIRAS1",
            "RANBP9",
            "SPNS1",
            "VAC14",
            "REXO1",
            "CSNK1G2",
            "SLC30A9",
            "METT5D1",
            "CEP57",
            "MATR3"
        ]
    },
    {
        "golabel": "ZNF385B_regulon_activity",
        "gene": [
            "CPB2",
            "CHIA",
            "SCGB3A2",
            "PEBP4",
            "PLA2G12B",
            "FAM150B",
            "HSD17B6",
            "CYP4B1",
            "SUSD2",
            "ZBTB16",
            "SFTA1P",
            "SFTPD",
            "OIT3",
            "LRRK2",
            "C16orf89",
            "LEPREL1",
            "ACADL",
            "CACNA2D2",
            "PLA2G4F",
            "CDKL2",
            "VEPH1",
            "AQP4",
            "FOLR1",
            "SLFNL1",
            "NPR1",
            "SFTPB",
            "NPNT",
            "TMEM163",
            "CAPN3",
            "C2orf58",
            "ABCA3",
            "PCDP1",
            "GLS2",
            "SCN4B",
            "ATP8A1",
            "SLC22A3",
            "SELENBP1",
            "FAM184A",
            "GLCCI1",
            "MYBL2",
            "TROAP",
            "CENPA",
            "C1orf116",
            "PHACTR1",
            "DLC1",
            "LMO3",
            "TTK",
            "FOXM1",
            "CDC45",
            "AK1",
            "CDKL1",
            "UCK2",
            "CDC20",
            "CYBRD1",
            "CDCA3",
            "NEK2",
            "C4orf12",
            "CDCA5",
            "RRM2",
            "ACADSB",
            "PMM1",
            "UHRF1",
            "TMEM132A",
            "SHROOM4",
            "MEGF9",
            "FAM83D",
            "RFTN1",
            "RACGAP1",
            "IL6R",
            "SYNE1",
            "CD302",
            "ARHGAP31",
            "KPNA2",
            "EMP2",
            "NOD1",
            "GANC",
            "AKAP13",
            "IVD",
            "FCHO2",
            "FEN1",
            "C9orf5",
            "ENTPD7",
            "NICN1",
            "ST6GALNAC6",
            "HSD17B4",
            "VAMP2"
        ]
    },
    {
        "golabel": "ZNF407_regulon_activity",
        "gene": [
            "IFI27",
            "SETBP1",
            "PFN4",
            "MRPS6",
            "TSHZ1",
            "RALGAPA2",
            "C2orf7",
            "RTTN",
            "BUD31",
            "DISC1",
            "RNF181",
            "PPIAL4G",
            "MDN1",
            "ZNF516",
            "HEBP2",
            "TMEM165",
            "NOTCH1",
            "KIAA1632",
            "AIG1",
            "ZNF236",
            "KLF13",
            "PDZD11",
            "MYCBP2",
            "ENTPD4",
            "PRELID1",
            "ZNF532",
            "C1orf69",
            "ATP9B",
            "HERC2",
            "SOCS6",
            "HERC1",
            "ATRN",
            "MYST4",
            "ROCK1",
            "ZNF622",
            "TMX3",
            "HIVEP1",
            "PRR12",
            "BRD3",
            "SEC22A",
            "APC",
            "PCGF1",
            "ADNP2",
            "SPEN",
            "BPTF",
            "ZNF609",
            "MED8",
            "YLPM1",
            "MEX3C",
            "WDR7",
            "TOP2B",
            "VPS4B",
            "PBRM1",
            "CTDP1",
            "FBXW2",
            "GIGYF2",
            "SP2"
        ]
    },
    {
        "golabel": "ZNF410_regulon_activity",
        "gene": [
            "CAPZA2",
            "ENTHD1",
            "RAP1B",
            "PSMA6",
            "RAD51L1",
            "C13orf27",
            "RPS29",
            "CHAC2",
            "NSMCE2",
            "UQCRFS1",
            "FUNDC2",
            "NDUFB1",
            "IFI27L1",
            "MED21",
            "SELT",
            "FUT8",
            "CNIH",
            "LSM2",
            "C14orf129",
            "ACOT4",
            "CGRRF1",
            "SHANK3",
            "TTC5",
            "SIVA1",
            "C14orf142",
            "AP4S1",
            "VPS29",
            "DHRS7",
            "ZNF627",
            "ATP5S",
            "COMMD1",
            "PDCD10",
            "SNAPC1",
            "TBPL1",
            "PKD1",
            "C20orf111",
            "SLC38A6",
            "ACOT1",
            "PHF5A",
            "C14orf119",
            "KIAA0467",
            "ISCA2",
            "RNF139",
            "KLHDC2",
            "MYNN",
            "ERH",
            "TIMM9",
            "COMMD2",
            "TMX1",
            "SPATA7",
            "PSME1",
            "WDR25",
            "MGAT2",
            "HMGN2",
            "CCT4",
            "SRRM2",
            "ACOT2",
            "LIN52",
            "DAD1",
            "RPL36AL",
            "COQ5",
            "YWHAQ",
            "C14orf109",
            "C3orf38",
            "UBE2A",
            "NSL1",
            "PSMD10",
            "GMFB",
            "TP53RK",
            "EIF2B2",
            "RDH11",
            "UBE2N",
            "NISCH",
            "PIGH",
            "C12orf41",
            "ATG5",
            "C1orf212",
            "COX16",
            "DUSP11",
            "CHURC1",
            "TAOK2",
            "CTTN",
            "NUP54",
            "LZIC",
            "ATG4A",
            "EIF2S1",
            "NUMA1",
            "COQ6",
            "GMPR2",
            "PRKAG1",
            "PIGC",
            "TSC2",
            "ACTR10",
            "COPS4",
            "MAD2L1BP",
            "TOR3A",
            "RNF44",
            "EXT2",
            "SYVN1",
            "ZFYVE21",
            "EXD2",
            "MED6",
            "DLST",
            "TMED10",
            "ANKRD11",
            "RFX1",
            "EIF5",
            "ALKBH1",
            "JKAMP",
            "ATP6V1D",
            "WTAP",
            "PPM1A",
            "MUDENG",
            "HNRPLL",
            "SLC39A9",
            "TINF2",
            "TMEM214",
            "RNF123",
            "VIPAR",
            "FNTB",
            "SAFB2",
            "UBE2D2",
            "PPP2CA",
            "PTPN23",
            "PSEN1"
        ]
    },
    {
        "golabel": "ZNF414_regulon_activity",
        "gene": [
            "FITM1",
            "PCSK4",
            "C1orf229",
            "C11orf35",
            "FBXL8",
            "SLC25A29",
            "GLI4",
            "ZNF467",
            "ADAT3",
            "C19orf20",
            "ZNF219",
            "ZNHIT2",
            "C20orf135",
            "UHMK1",
            "NUDT14",
            "ZNF579",
            "HSD11B1L",
            "TRAPPC5",
            "SCAND1",
            "ATP5D",
            "C19orf60",
            "ALKBH7",
            "NR2F6",
            "ZNF837",
            "CCDC159",
            "SIGIRR",
            "KIAA1543",
            "MIB2",
            "LOC147727",
            "SSBP4",
            "ZNF580",
            "PRR24",
            "FAM110A",
            "ARFRP1",
            "ATG4D",
            "QTRT1",
            "ZNF358",
            "TOR1AIP2",
            "COPE",
            "ZNF205",
            "DNAJC4",
            "COQ4",
            "USE1",
            "CCDC124",
            "TMEM161A",
            "C19orf6",
            "KLHL22",
            "NDUFS7",
            "SIRT6",
            "MBD3",
            "C19orf39",
            "FAM108A1",
            "VMAC",
            "SEC24A",
            "DNAJB14",
            "WDR83",
            "KCTD20",
            "MAP3K2",
            "ZNF653",
            "PRR14",
            "PIN1",
            "ATF2",
            "TAF6L",
            "C17orf59",
            "WDFY1",
            "C19orf43",
            "ELOF1",
            "VPS4B",
            "ATF6",
            "ITCH",
            "RBMXL1",
            "RAB11B",
            "XAB2",
            "DHX15",
            "AP3M1",
            "ACTR2"
        ]
    },
    {
        "golabel": "ZNF428_regulon_activity",
        "gene": [
            "PHGDH",
            "VAX2",
            "SBK1",
            "TLR3",
            "CADM4",
            "PAFAH1B3",
            "TMEM160",
            "MPZL3",
            "NIPAL2",
            "PHLDB3",
            "SPRED1",
            "SCAND1",
            "PTMS",
            "TBCB",
            "C19orf47",
            "NFKBIB",
            "ZNF580",
            "HSPBP1",
            "IRF2BP1",
            "C1orf58",
            "TOR1AIP2",
            "ZNF575",
            "PIN4",
            "PAF1",
            "EID2",
            "POLK",
            "XRCC1",
            "DNAJB14",
            "GPS2",
            "SRFBP1",
            "SLC10A7",
            "TSR2",
            "USO1",
            "TOR1AIP1",
            "TMEM184C",
            "RAB14",
            "CHTF8"
        ]
    },
    {
        "golabel": "ZNF430_regulon_activity",
        "gene": [
            "S100P",
            "HGD",
            "TESC",
            "C2CD4D",
            "ADSSL1",
            "NNMT",
            "FAM190A",
            "MFSD3",
            "FNIP2",
            "RNF19A",
            "CDK2AP2",
            "ZNF100",
            "ZNF699",
            "HDX",
            "LOC641367",
            "ZNF431",
            "GSTP1",
            "AIFM2",
            "SDF2L1",
            "SLFN5",
            "SPRED1",
            "NOTCH2",
            "CRELD2",
            "ICA1",
            "PIM3",
            "PDIA3",
            "TRAF2",
            "ERP29",
            "PNKD",
            "ZNF501",
            "C6orf136",
            "SLC3A2",
            "NFKBIB",
            "ZNF92",
            "MFSD10",
            "RBM43",
            "NR1D2",
            "FBXW5",
            "C19orf63",
            "PTDSS2",
            "G6PC3",
            "PPP2R5E",
            "ZNF267",
            "MIER1",
            "GPS2",
            "ZNF791",
            "SLC35E1",
            "TMEM214",
            "MORC3",
            "CREB1"
        ]
    },
    {
        "golabel": "ZNF441_regulon_activity",
        "gene": [
            "RGS13",
            "ATP13A4",
            "RBPMS2",
            "ZDHHC15",
            "MFSD2B",
            "HMGA1",
            "PER3",
            "ZFP37",
            "GARNL3",
            "ZNF214",
            "MEF2C",
            "CEBPB",
            "N4BP2L1",
            "SSBP2",
            "PDIA4",
            "JUP",
            "LOC653501",
            "ZNF442",
            "GALNT2",
            "ZNF671",
            "LTBR",
            "ZNF763",
            "KAT2B",
            "ZNF846",
            "CXorf42",
            "ZNF709",
            "ZNF563",
            "CRBN",
            "MBLAC2",
            "ZNF175",
            "RRP12",
            "MAP3K1",
            "ARID4A",
            "TSSC1",
            "YPEL2",
            "ZNF25",
            "DPP3",
            "GOT2",
            "ZNF136",
            "ZNF564",
            "GSK3A",
            "TMEM214",
            "ZMYM6",
            "ELF2",
            "SMARCAL1",
            "PCBP1"
        ]
    },
    {
        "golabel": "ZNF444_regulon_activity",
        "gene": [
            "SLC16A11",
            "KIAA1984",
            "LYPD5",
            "CREB3L1",
            "CD109",
            "BEND6",
            "GADD45G",
            "LOC80054",
            "C20orf134",
            "PDCD1LG2",
            "TCF7L1",
            "EFCAB4A",
            "LOC441869",
            "SNX10",
            "FAM174B",
            "DSE",
            "FAM83E",
            "C19orf73",
            "NEDD4",
            "C20orf151",
            "NCEH1",
            "CDK2AP2",
            "MICB",
            "TMEM125",
            "RNF208",
            "ZNF699",
            "NKX2-1",
            "ZNF219",
            "KLHL5",
            "CHKA",
            "ITGAV",
            "HIF1A",
            "FN3K",
            "OSGIN2",
            "CTNNAL1",
            "NAT14",
            "SKAP2",
            "PICK1",
            "LHFPL2",
            "RAB17",
            "PGM2",
            "C17orf28",
            "RAB40C",
            "CALU",
            "LIMS1",
            "CCDC75",
            "SIGIRR",
            "LEPROT",
            "KIAA1543",
            "RALB",
            "CCDC106",
            "AVL9",
            "ATL3",
            "FUZ",
            "BCAT2",
            "ESRP2",
            "SLC25A40",
            "DDRGK1",
            "ZNF580",
            "MFSD10",
            "CORO1C",
            "C11orf49",
            "GLTSCR2",
            "AZIN1",
            "PAFAH1B2",
            "SAMD8",
            "FOXN2",
            "NBN",
            "CHM",
            "C19orf54",
            "RRAGC",
            "FAM100A",
            "GTF2H3",
            "FIZ1",
            "SNRNP70",
            "ZNF446",
            "DR1",
            "UBA6",
            "PNPLA8",
            "C6orf120",
            "MOBKL1B",
            "LUZP6",
            "NOC3L",
            "RALA",
            "PTOV1",
            "COG5",
            "ENOX2",
            "DNAJB14",
            "KCTD20",
            "MCFD2",
            "SNRNP35",
            "GNA13",
            "MOB2",
            "GNAI3",
            "CDC27",
            "MAPK14"
        ]
    },
    {
        "golabel": "ZNF446_regulon_activity",
        "gene": [
            "CCDC37",
            "CCDC42B",
            "TSNAXIP1",
            "LRRC46",
            "C11orf16",
            "TEKT2",
            "SPEF1",
            "SPAG8",
            "CCDC114",
            "TTC25",
            "CCDC19",
            "CAPS",
            "LRRC43",
            "C17orf72",
            "RIBC1",
            "CCDC96",
            "CCDC157",
            "CARKD",
            "LIPE",
            "FCGR3A",
            "C17orf97",
            "MAPK8IP1",
            "CHADL",
            "LMTK3",
            "FAM83E",
            "C19orf73",
            "PAQR3",
            "DTX3",
            "RNF208",
            "ZNF219",
            "ITGAV",
            "SUV420H2",
            "FAM116B",
            "P4HA1",
            "CCDC24",
            "HSPA13",
            "ZNF552",
            "ADAP2",
            "MZF1",
            "SLC30A1",
            "ZNF837",
            "BBC3",
            "ARMC1",
            "CDK20",
            "SSR3",
            "RDH13",
            "FUZ",
            "RRBP1",
            "ZGPAT",
            "PNPLA2",
            "DYRK1B",
            "C9orf7",
            "ZNF444",
            "CCDC61",
            "CCNYL1",
            "RABEP2",
            "BBS5",
            "FOXN2",
            "NRAS",
            "ADCK4",
            "ZNF629",
            "FUT11",
            "FIZ1",
            "SPHK2",
            "HSPA8",
            "MAPK7",
            "PTDSS1",
            "UBOX5",
            "NOC3L",
            "XRCC1",
            "MED25",
            "MED9",
            "ABCE1",
            "ZBTB45",
            "NAPA",
            "TBC1D17",
            "DIS3L2"
        ]
    },
    {
        "golabel": "ZNF462_regulon_activity",
        "gene": [
            "S100P",
            "NMB",
            "ARHGAP20",
            "PRKCA",
            "EMB",
            "BAG2",
            "PTPRG",
            "FKBP11",
            "FNIP2",
            "MAP3K13",
            "HIP1",
            "C20orf7",
            "SMURF2",
            "FAM160A1",
            "APBA1",
            "EXPH5",
            "ZNF608",
            "ATP6V0B",
            "PPIB",
            "SLFN5",
            "PTS",
            "PSTK",
            "COMMD3",
            "MRPL34",
            "KIAA0922",
            "MYO9A",
            "TTLL11",
            "MTHFS",
            "COX5A",
            "SH3RF1",
            "ATF7IP",
            "SVIL",
            "FAM96A",
            "MACF1",
            "ZNF189",
            "TRIM14",
            "WDR61",
            "SPRED2",
            "EML4",
            "SELS",
            "RPS6KA3",
            "C1D",
            "SLC25A20",
            "C12orf47",
            "SYNJ1",
            "MKKS",
            "MRPS11",
            "MKL2",
            "SRGAP2",
            "GNG5",
            "DERL2",
            "ZBTB43",
            "DCTN6",
            "DUT",
            "SNUPN",
            "POM121C",
            "PREB",
            "STX18"
        ]
    },
    {
        "golabel": "ZNF468_regulon_activity",
        "gene": [
            "SEC31B",
            "ZNF702P",
            "ZNF614",
            "LYPLA1",
            "ADCY4",
            "SOX18",
            "EXOC3L",
            "SHANK3",
            "TTC5",
            "C5orf28",
            "TMEM182",
            "HMHA1",
            "LOC150786",
            "TWF1",
            "EVL",
            "SLC35F5",
            "YIPF6",
            "DEF6",
            "CIRBP",
            "ARMC5",
            "ZNF816A",
            "QTRT1",
            "ZNF28",
            "COG6",
            "CDC42",
            "MOBKL3",
            "C19orf6",
            "DPY19L4",
            "DR1",
            "WDSUB1",
            "MBD3",
            "LZIC",
            "LZTS2",
            "MAP4K3",
            "ENOPH1",
            "REXO1",
            "LRRC57",
            "C11orf57",
            "TUBGCP2",
            "ZNF143"
        ]
    },
    {
        "golabel": "ZNF500_regulon_activity",
        "gene": [
            "IGSF9B",
            "LOC148696",
            "ICAM5",
            "LOC285593",
            "LOC92973",
            "INPP5J",
            "CENPW",
            "CDK1",
            "TECTA",
            "KIAA0101",
            "LOC100170939",
            "MEGF6",
            "CEP55",
            "CHAC2",
            "LOC100271836",
            "SNED1",
            "ZBED3",
            "WDR90",
            "PFDN4",
            "ZNF608",
            "SLC35E2",
            "GTF2IRD2B",
            "ATF7IP2",
            "RIPK2",
            "ANKS3",
            "NPIP",
            "PDSS1",
            "MGRN1",
            "C10orf78",
            "CDK18",
            "TUBA1C",
            "CP110",
            "MRPL47",
            "TXNDC9",
            "MRPL42",
            "TMEM8B",
            "SH2B1",
            "OLA1",
            "CALCOCO1",
            "PSMD14",
            "ZNF785",
            "LOC652276",
            "VDAC2",
            "FARP2",
            "ADCY6",
            "YBX1",
            "WSB2",
            "NPHP4",
            "CABIN1",
            "KIAA0556",
            "CISD1",
            "YWHAZ",
            "PCGF6",
            "RRN3P3",
            "PGAM1",
            "CRAMP1L",
            "PGBD2",
            "CUL9",
            "NDUFA12",
            "BLOC1S2",
            "UBE2D1",
            "JMJD5",
            "BBS1",
            "SUGT1",
            "SUMO1P3",
            "LDB1",
            "TSC2",
            "WDR24",
            "CREBBP",
            "MRPS16",
            "GGA2",
            "ZNF646",
            "SUMO2",
            "TBC1D9B",
            "UBE2F",
            "FAM160A2",
            "TPM3",
            "RPP30",
            "KIAA0892",
            "ZC3H7A",
            "NRBF2",
            "ANXA7",
            "SMNDC1",
            "ZNF263",
            "GLYR1"
        ]
    },
    {
        "golabel": "ZNF511_regulon_activity",
        "gene": [
            "BARX1",
            "SNORA76",
            "GAS5",
            "RPS21",
            "PITPNC1",
            "RPS7",
            "RPLP1",
            "FAM24B",
            "C12orf24",
            "C17orf61",
            "MRPL21",
            "DST",
            "COMTD1",
            "CCNB1IP1",
            "SNHG6",
            "RPS3",
            "SLC27A5",
            "RPS16",
            "AHNAK",
            "METTL12",
            "ROMO1",
            "FAM195A",
            "RPLP0",
            "NDUFB9",
            "TIMM16",
            "MRPL48",
            "RPL8",
            "MIF",
            "C8orf59",
            "SHMT2",
            "LSMD1",
            "CYC1",
            "C7orf55",
            "NPM3",
            "STK32C",
            "MAML2",
            "NDUFA11",
            "RPL13",
            "BNIP3",
            "C5orf42",
            "C11orf83",
            "C2orf79",
            "C9orf3",
            "NTHL1",
            "RNF144B",
            "RPL38",
            "COX6A1",
            "EXOSC4",
            "ANAPC11",
            "LSM7",
            "PSTK",
            "RPS24",
            "GADD45GIP1",
            "UQCR11",
            "MTHFD2L",
            "LRRC61",
            "USMG5",
            "NME2",
            "MRPL12",
            "PPP1R14B",
            "C11orf48",
            "RPS20",
            "FAM96B",
            "NDUFA7",
            "ALKBH2",
            "FAU",
            "RPL30",
            "NDUFB11",
            "PRDX2",
            "MRP63",
            "EEF1D",
            "C12orf73",
            "NDUFS8",
            "C15orf61",
            "GALC",
            "DPCD",
            "IKZF2",
            "SFXN4",
            "RPLP2",
            "UQCRB",
            "C9orf23",
            "TMEM93",
            "TARBP2",
            "NT5C",
            "EPB41L1",
            "C10orf84",
            "PCBD1",
            "ATP11B",
            "LUZP1",
            "ANKRD39",
            "NDUFB8",
            "ESRRA",
            "CHCHD1",
            "COX8A",
            "TRPT1",
            "MRPL43",
            "TIMM13",
            "C12orf10",
            "LATS2",
            "SEC61B",
            "C11orf10",
            "NARF",
            "NCOA3",
            "AIP",
            "ARL6IP4",
            "SLC12A6",
            "ECHS1",
            "BCCIP",
            "C12orf65",
            "AFF1",
            "ATPAF2",
            "WDR74",
            "TIMM44",
            "MRPS16",
            "EXOSC1",
            "AAK1",
            "STK38",
            "DNAJC13",
            "RBMS1",
            "JAK1",
            "PPP2R2D",
            "CUEDC2",
            "POLL",
            "TIAL1",
            "RAB3GAP1"
        ]
    },
    {
        "golabel": "ZNF518B_regulon_activity",
        "gene": [
            "ZYG11A",
            "ZNF280B",
            "LOC387646",
            "TSPYL5",
            "RPSA",
            "NUP155",
            "N4BP2",
            "MSL3L2",
            "TPT1",
            "RPL13A",
            "SNHG8",
            "RPL29",
            "RPL13",
            "ACY1",
            "GPX1",
            "CD97",
            "RBL1",
            "ZNF718",
            "RILP",
            "HS2ST1",
            "NCAPD3",
            "TSPO",
            "RPL15",
            "NUDT18",
            "TIGD7",
            "MAN1A2",
            "OBFC1",
            "CHD6",
            "MSH6",
            "RPL3",
            "RNASEN",
            "BTD",
            "SERTAD2",
            "HEMK1",
            "RCC2",
            "LETMD1",
            "FAM73A",
            "PTPRF",
            "ZNF146",
            "ACAA1",
            "ZCCHC11",
            "SMC1A",
            "LIG3",
            "RSF1",
            "KIAA0947",
            "CBX1",
            "COQ4",
            "NAT6",
            "RSC1A1",
            "SERPINB6",
            "HUWE1",
            "TEX264",
            "POFUT1",
            "EIF2C1",
            "MGA",
            "AES",
            "DALRD3",
            "SNRNP200",
            "AKIRIN1",
            "RBM12B",
            "ADNP",
            "RALGAPB",
            "QARS",
            "TADA3",
            "KPNA6"
        ]
    },
    {
        "golabel": "ZNF530_regulon_activity",
        "gene": [
            "PLA2G10",
            "CXCL11",
            "SLC7A2",
            "TACC2",
            "CCNE2",
            "PDE4D",
            "RHOBTB2",
            "RHEBL1",
            "RAD51AP1",
            "ATP1B1",
            "KIAA1524",
            "KBTBD11",
            "XRCC2",
            "SCNN1A",
            "CENPK",
            "C5orf34",
            "GPRC5C",
            "EME1",
            "CDC7",
            "RFC4",
            "ZNF93",
            "RPH3AL",
            "C7orf60",
            "STIL",
            "MTBP",
            "THAP10",
            "ZNF833",
            "HAUS5",
            "CCDC18",
            "FBXO5",
            "ZNF519",
            "ZNF461",
            "TRAIP",
            "ETS2",
            "CENPQ",
            "DBF4",
            "EPAS1",
            "FIGNL1",
            "ZNF256",
            "CENPL",
            "MCM6",
            "PDIA3",
            "PDIA3P",
            "TRAPPC2P1",
            "DSN1",
            "POT1",
            "ZNF101",
            "ZNF92",
            "ZNF551",
            "WDR53",
            "COMMD2",
            "CCDC149",
            "ZNF525",
            "BCL2L12",
            "RETSAT",
            "MTERF",
            "C1orf52",
            "MTF2",
            "C17orf42",
            "MCCC2",
            "ZNF419",
            "C12orf41",
            "C12orf4",
            "ZNF416",
            "ZNF544",
            "ZMYM1",
            "DCLRE1B",
            "SENP5",
            "ZNF765",
            "EED",
            "C7orf64",
            "DBR1",
            "DDX20",
            "C3orf17"
        ]
    },
    {
        "golabel": "ZNF532_regulon_activity",
        "gene": [
            "ADAMTS12",
            "ADAM12",
            "COL5A3",
            "LOC388588",
            "COL3A1",
            "COL1A2",
            "COL5A2",
            "SULT1A2",
            "VCAN",
            "COL5A1",
            "ASS1",
            "DCHS1",
            "COL6A3",
            "SULT1A1",
            "LY6E",
            "NUAK1",
            "NID1",
            "C21orf63",
            "LRP12",
            "COL4A1",
            "LZTS1",
            "DHRS3",
            "C18orf54",
            "PARD6G",
            "MEX3B",
            "HSD17B8",
            "ZNF697",
            "SLC44A3",
            "NAV1",
            "NOTCH3",
            "BLOC1S1",
            "FLT1",
            "LHPP",
            "LAMC1",
            "FUCA1",
            "ACYP2",
            "TANC2",
            "C11orf95",
            "KLF7",
            "CYB5R1",
            "SMPD2",
            "CHSY1",
            "KIAA1632",
            "DHX33",
            "CEP170",
            "ECHDC1",
            "GSTK1",
            "CBL",
            "B3GALT4",
            "MIB1",
            "PEX7",
            "C18orf25",
            "TMEM219",
            "WRN",
            "PIGV",
            "ZNF8",
            "LMAN1",
            "HMGCL",
            "CLN3",
            "KDM5B",
            "ATP6V0D1",
            "ZNF445",
            "C9orf25",
            "AKR7A2",
            "QSER1",
            "RPS6KA1",
            "MAP4K5",
            "ABL2",
            "ZNF407",
            "RER1",
            "RPS6KC1",
            "MEX3C",
            "SETD5",
            "FBXO8",
            "TMBIM6",
            "MBD1",
            "PEF1",
            "CLASP1",
            "PHF21A",
            "SPIN1"
        ]
    },
    {
        "golabel": "ZNF561_regulon_activity",
        "gene": [
            "LOC100133985",
            "C22orf27",
            "ZNF627",
            "INTS1",
            "TGDS",
            "THG1L",
            "DTWD2",
            "ULK1",
            "RBBP9",
            "CDK16",
            "FAM188A",
            "PACS1",
            "AARS",
            "DDX51",
            "ZNF555",
            "ZNF35",
            "ZNF584",
            "KTELC1",
            "WDR41",
            "ZNF20",
            "SART1",
            "ZNF562",
            "RBM10",
            "SRRT",
            "EIF3G",
            "FOXK2",
            "ELP4",
            "ZNF564",
            "NPLOC4",
            "TSR2",
            "FAM32A",
            "PAPD4",
            "HNRNPA2B1"
        ]
    },
    {
        "golabel": "ZNF563_regulon_activity",
        "gene": [
            "CDH20",
            "LCT",
            "C6orf176",
            "LOC441177",
            "CD207",
            "CD1A",
            "CCL17",
            "FCER1A",
            "HOXD1",
            "SLC16A14",
            "CEACAM4",
            "CD1E",
            "CDKL2",
            "DUSP4",
            "CD1C",
            "C12orf34",
            "DHDH",
            "RNF175",
            "HPGDS",
            "BEX5",
            "SHC3",
            "CERKL",
            "SIK1",
            "PLEKHG2",
            "KCNK5",
            "DOCK5",
            "IGF1R",
            "ABCC1",
            "HLA-DMA",
            "CMIP",
            "C7orf23",
            "FMO4",
            "NOTCH3",
            "RFESD",
            "TBL1X",
            "PDIA4",
            "GALNT2",
            "ARHGDIB",
            "ENTPD7",
            "PDIA3P",
            "ITGB1",
            "ZNF846",
            "ACSL3",
            "CXorf42",
            "HYOU1",
            "ADIPOR2",
            "ZNF441",
            "THYN1",
            "AGFG1",
            "UROD",
            "B3GNT1",
            "URB2",
            "POLR3GL",
            "ATP2A2",
            "MPND",
            "UGGT1",
            "CDC42BPB",
            "SAMD4B",
            "CSNK2A1",
            "MARK4",
            "CRYZL1",
            "LARP4",
            "EIF3A",
            "C19orf56",
            "GSK3A",
            "FBXO18"
        ]
    },
    {
        "golabel": "ZNF592_regulon_activity",
        "gene": [
            "WFDC3",
            "CRABP2",
            "SNORD116-4",
            "DNTTIP1",
            "ABHD2",
            "POLB",
            "S100A13",
            "IGF1R",
            "MEIS2",
            "ARID3B",
            "KIF13B",
            "STOX2",
            "ABLIM1",
            "TXNDC17",
            "NEO1",
            "TBC1D8",
            "OCIAD2",
            "C9orf46",
            "MAL2",
            "KLHL25",
            "BET1",
            "AKAP13",
            "RNF181",
            "RHEB",
            "SIK2",
            "LOC401397",
            "RNF139",
            "RANBP10",
            "MAN2C1",
            "TOMM40L",
            "ICT1",
            "PDE8A",
            "NR2C2AP",
            "TJP2",
            "IFNGR2",
            "SFT2D2",
            "STYXL1",
            "DET1",
            "ENTPD4",
            "TARSL2",
            "TIRAP",
            "HERC2",
            "C7orf28A",
            "CLN6",
            "HERC1",
            "MAN2A2",
            "POLR2A",
            "ZBTB40",
            "SCAMP2",
            "ZZEF1",
            "THOC7",
            "MESDC1",
            "GTPBP10",
            "LOC285033",
            "C15orf39",
            "CNNM2",
            "MINK1",
            "SNX33",
            "RAPGEF1",
            "TGOLN2",
            "PDE6D",
            "WDR73",
            "ZSCAN29",
            "ARID1B",
            "SCAND2",
            "WHAMM",
            "UBR4",
            "ANKRD11",
            "CRTC3",
            "VPS39",
            "HIF1AN",
            "UNC45A",
            "VPS33B",
            "INTS12",
            "INO80",
            "POLG",
            "FAM193A",
            "SIN3A",
            "SLTM"
        ]
    },
    {
        "golabel": "ZNF593_regulon_activity",
        "gene": [
            "SCARNA2",
            "FBXO2",
            "MESP1",
            "RPS21",
            "RUNX1T1",
            "SFMBT2",
            "DUSP23",
            "PCDHGA6",
            "DNLZ",
            "CHCHD2",
            "NUDT8",
            "LOC440957",
            "GAMT",
            "FAM195A",
            "NCRNA00116",
            "CHCHD10",
            "HYAL3",
            "TIMM16",
            "POLR2I",
            "TXNDC17",
            "RPS8",
            "MIF",
            "MRPL36",
            "LSMD1",
            "NPM3",
            "C7orf47",
            "MRPL41",
            "MYEOV2",
            "TSTA3",
            "PSMG3",
            "RPL28",
            "FAHD2B",
            "FAM58A",
            "CD320",
            "COX5B",
            "ZNHIT1",
            "MRPL14",
            "MAD2L2",
            "C11orf83",
            "RPS15",
            "MRPS15",
            "C2orf79",
            "TAOK1",
            "RPL34",
            "TRNAU1AP",
            "C7orf50",
            "QPCTL",
            "BOLA2",
            "RPL37",
            "PYCRL",
            "EXOSC4",
            "NDUFS6",
            "GALE",
            "TMTC2",
            "LSM7",
            "TRAPPC5",
            "SCAND1",
            "GADD45GIP1",
            "ATP5D",
            "EXOSC5",
            "PUSL1",
            "C16orf13",
            "DCI",
            "NAA10",
            "NME2",
            "MRPL12",
            "ALKBH7",
            "MRPS24",
            "FAM63B",
            "MYO9A",
            "RPS2",
            "C1orf86",
            "RBX1",
            "AGTRAP",
            "SURF2",
            "FAM128B",
            "LOC151162",
            "NDUFB11",
            "SCO2",
            "UQCR10",
            "PSMG4",
            "MRP63",
            "RPS19BP1",
            "EEF1D",
            "MRPL55",
            "GPR172A",
            "GPX4",
            "C9orf16",
            "ZFYVE19",
            "TMEM2",
            "NDUFS8",
            "RPS4X",
            "C19orf53",
            "NHP2",
            "RC3H2",
            "FAM179B",
            "SPTBN1",
            "PGLS",
            "SGK269",
            "RPLP2",
            "NDUFS5",
            "C19orf24",
            "MRPL53",
            "TOMM7",
            "SEL1L",
            "C21orf70",
            "ROBLD3",
            "THAP3",
            "CHCHD8",
            "AURKAIP1",
            "PSMB4",
            "MTX1",
            "NR2C2AP",
            "JTB",
            "MRPL27",
            "LSM10",
            "CDC34",
            "ANKRD39",
            "FDX1L",
            "RPL11",
            "SRM",
            "MRTO4",
            "MYCBP2",
            "AK2",
            "ARHGAP21",
            "C1orf122",
            "CHCHD1",
            "COX8A",
            "MRPL43",
            "TIMM13",
            "ISOC2",
            "LATS1",
            "RFXANK",
            "YIPF2",
            "NUBP2",
            "STX10",
            "SSSCA1",
            "DENND4A",
            "C1orf50",
            "GNG5",
            "LYPLA2",
            "ZBTB8OS",
            "MRPS34",
            "NDUFB10",
            "MRPL4",
            "DENND4C",
            "LYPLA2P1",
            "KIAA1432",
            "JMJD4",
            "MRPL38",
            "FAM125A",
            "NUDT22",
            "SLC12A6",
            "IMP4",
            "SDHB",
            "NDUFS3",
            "TRAPPC3",
            "MAF1",
            "KIAA2026",
            "IFRD2",
            "APC",
            "C1orf172",
            "ERI3",
            "PCGF1",
            "NPRL2",
            "SNTB2",
            "WDR74",
            "C7orf30",
            "PCNX",
            "TIMM44",
            "NUDC",
            "EIF3I",
            "MCAT",
            "ZCCHC6",
            "MED8",
            "DDOST",
            "WDR7",
            "TAF12",
            "PIKFYVE",
            "NDUFV3",
            "SETX",
            "SOS1",
            "MECR",
            "TRAF6",
            "GPN2"
        ]
    },
    {
        "golabel": "ZNF598_regulon_activity",
        "gene": [
            "NOXO1",
            "MAFK",
            "HIST2H3C",
            "HIST2H3D",
            "C9orf172",
            "SLC40A1",
            "TMEM184A",
            "RECQL4",
            "IQGAP3",
            "SEPP1",
            "C9orf140",
            "PKMYT1",
            "NFKBIL2",
            "CHTF18",
            "C16orf59",
            "HSD17B11",
            "DDX11",
            "HNMT",
            "FANCA",
            "FBXL18",
            "ZDHHC2",
            "CCNF",
            "CGRRF1",
            "GUCY1B3",
            "PGCP",
            "F8",
            "TOMM40",
            "INTS1",
            "MAP3K10",
            "RAB11FIP2",
            "RRM2B",
            "ENPP4",
            "CSNK1E",
            "UBL3",
            "DVL1",
            "RPUSD1",
            "NOP2",
            "PUS1",
            "FBXL19",
            "PTCD1",
            "B3GALTL",
            "ATAD3A",
            "ZNF709",
            "CLN5",
            "DHX34",
            "CRBN",
            "EIF4E3",
            "GAK",
            "DPP9",
            "TPCN1",
            "LOC652276",
            "DOT1L",
            "SLC25A22",
            "KLF16",
            "BNIP3L",
            "MTA1",
            "C7orf43",
            "ITM2B",
            "TAF6",
            "EIF3B",
            "GTF2IRD1",
            "NOL6",
            "BTBD12",
            "SOLH",
            "TELO2",
            "ZNF205",
            "COX11",
            "DHX37",
            "HBP1",
            "NOC2L",
            "TRIM23",
            "TRIM11",
            "ABHD13",
            "LMBRD1",
            "E4F1",
            "RABGAP1L",
            "IPPK",
            "RNF13",
            "FBXL3",
            "SAMD1",
            "DDX54",
            "MIER1",
            "FBXO3",
            "AXIN1",
            "PCNXL3",
            "SCAF1",
            "TRAF7",
            "C11orf46",
            "HGS",
            "RAP1A",
            "POLR3E",
            "C11orf58",
            "CDKN2AIP",
            "SCYL1",
            "EIF1B",
            "RSBN1",
            "ESD",
            "GABPA",
            "COASY",
            "MOGS",
            "ATXN2L",
            "E2F4",
            "XPO6",
            "RNPS1",
            "SPOP"
        ]
    },
    {
        "golabel": "ZNF608_regulon_activity",
        "gene": [
            "CDH20",
            "SRXN1",
            "ATP13A4",
            "ROS1",
            "COL21A1",
            "DYNC2H1",
            "DNAH2",
            "SRGAP3",
            "SPTLC3",
            "LOC92973",
            "NHS",
            "ZMAT1",
            "KAL1",
            "C14orf147",
            "NFIX",
            "ISG20",
            "FAT4",
            "ANK3",
            "MACC1",
            "C1orf31",
            "MRPS12",
            "PER3",
            "GARNL3",
            "GTF2A2",
            "MAML2",
            "NOD1",
            "MEF2C",
            "ZNF462",
            "POMP",
            "C20orf24",
            "EPB41L4A",
            "MRPL15",
            "ARHGEF9",
            "CCDC46",
            "USMG5",
            "NOP10",
            "GRAMD3",
            "HSPE1",
            "SDC3",
            "RGMB",
            "COX5A",
            "BTN2A3",
            "BZW1",
            "GTPBP4",
            "PCYOX1L",
            "GAB1",
            "MACF1",
            "C12orf44",
            "NUDT15",
            "LOC100132707",
            "SYNJ1",
            "BBS9",
            "PSMA4",
            "ARID4A",
            "GTF2E2",
            "CDC123",
            "ZFP90",
            "ZNF500",
            "CEP68"
        ]
    },
    {
        "golabel": "ZNF618_regulon_activity",
        "gene": [
            "CATSPER1",
            "CST6",
            "CIT",
            "KPNA7",
            "CAV2",
            "PPM1J",
            "VANGL2",
            "S100A6",
            "FAM171A1",
            "PPP1R3B",
            "CSTB",
            "GYG2",
            "TNFRSF12A",
            "ACVR2B",
            "KIAA1549",
            "CKLF",
            "TACSTD2",
            "TP53TG1",
            "ZBED3",
            "ARPC1B",
            "KIAA1958",
            "HIPK2",
            "LGALS3",
            "SOCS7",
            "RHOC",
            "GPX1",
            "ACOT4",
            "ANXA2",
            "RPA3",
            "INSR",
            "RAD54L2",
            "MED13L",
            "FAM123B",
            "BEND3",
            "ZNF236",
            "POLD4",
            "ZBTB39",
            "JARID2",
            "RPL23AP7",
            "TMEM218",
            "PGM1",
            "BCOR",
            "BCL7A",
            "C12orf51",
            "MLL2",
            "DIP2C",
            "NCOR1",
            "BAT2L1",
            "STRBP",
            "MIF4GD",
            "USP22",
            "BRD3",
            "ELOVL1",
            "MAVS",
            "REXO2",
            "ABL1",
            "NSD1",
            "DNAJC8",
            "USP34",
            "HNRNPA0"
        ]
    },
    {
        "golabel": "ZNF620_regulon_activity",
        "gene": [
            "OPRD1",
            "PPM1E",
            "C1orf95",
            "DSCR6",
            "RNF183",
            "C17orf76",
            "CDA",
            "MIPOL1",
            "KCNJ11",
            "STEAP1",
            "RALGAPA1",
            "SPHK1",
            "ARSI",
            "TNFSF9",
            "GDAP1",
            "PAIP2B",
            "EML5",
            "S100A6",
            "COL6A2",
            "AADAT",
            "S100A16",
            "RHBDL2",
            "TMEM97",
            "C17orf60",
            "SALL2",
            "SLC16A3",
            "C1QTNF6",
            "PRKCDBP",
            "FXYD5",
            "ZNF572",
            "TNFRSF12A",
            "ACVR2B",
            "RARG",
            "EMP3",
            "FAS",
            "PTBP2",
            "BMP1",
            "ARPC1B",
            "RGS10",
            "LOC100128640",
            "S100A10",
            "LOC100270710",
            "PTRF",
            "PDLIM7",
            "TIMP2",
            "ITPRIP",
            "NBL1",
            "SH3BGRL3",
            "MYEF2",
            "EFHD2",
            "RHOC",
            "GKAP1",
            "RAC2",
            "GGT7",
            "ANXA2",
            "IRF5",
            "FAM161A",
            "GPHN",
            "DTX2",
            "MARVELD1",
            "CAPG",
            "METRNL",
            "GNA15",
            "LIMK1",
            "RRAS",
            "C2orf15",
            "RHBDF2",
            "ZFP36L2",
            "HOOK1",
            "L2HGDH",
            "PLIN3",
            "RALB",
            "ZSCAN12",
            "TPM4",
            "BEND3",
            "ZSCAN16",
            "BHLHB9",
            "GAS2L1",
            "ZYX",
            "TICAM1",
            "PATZ1",
            "LMNA",
            "PRR3",
            "RPS6KA4",
            "MAP7D1",
            "ZNF664",
            "TAX1BP3",
            "ZNF445",
            "TPST2",
            "TTC7A",
            "RAB11FIP5",
            "STX4",
            "EPM2AIP1",
            "ACTB",
            "RHOG",
            "C17orf80",
            "BRD8",
            "SUV420H1",
            "THAP9",
            "ANXA11",
            "UBC",
            "RPP14",
            "RBMX"
        ]
    },
    {
        "golabel": "ZNF622_regulon_activity",
        "gene": [
            "LOC728613",
            "SRD5A1",
            "MIF",
            "MRPL36",
            "LOC283314",
            "CLPTM1L",
            "NDUFA11",
            "FAHD2B",
            "NME1",
            "LOC25845",
            "BOLA2",
            "RPL37",
            "RNF181",
            "NDUFS6",
            "PDCD6",
            "BRIX1",
            "CCT5",
            "MED10",
            "HAX1",
            "TARS",
            "OST4",
            "C1orf43",
            "SUB1",
            "DAP",
            "C20orf194",
            "NSUN2",
            "BRD9",
            "SGK269",
            "ZNF236",
            "FAM173B",
            "ICT1",
            "REV3L",
            "MRPS30",
            "CCDC127",
            "KIAA1109",
            "SDHA",
            "JTB",
            "YIF1A",
            "C9orf119",
            "EXOC3",
            "MYCBP2",
            "PTRH2",
            "PRELID1",
            "ILF2",
            "YIPF2",
            "HERC1",
            "GOLPH3",
            "SUPT4H1",
            "EIF2C4",
            "MRPS7",
            "FTSJ1",
            "KIAA2026",
            "TET2",
            "KIAA2018",
            "PCNX",
            "MTR",
            "ZNF407",
            "SEC13",
            "MED8",
            "NEK9",
            "USP34",
            "RBM25",
            "SETD2"
        ]
    },
    {
        "golabel": "ZNF627_regulon_activity",
        "gene": [
            "RPS3A",
            "SNURF",
            "POLB",
            "ARRDC3",
            "KBTBD3",
            "PLEC",
            "TUBA1A",
            "BCAS4",
            "PEX2",
            "RPL10A",
            "NAT1",
            "TRAM1",
            "CALM2",
            "FAM118B",
            "CGRRF1",
            "C9orf3",
            "EAPP",
            "TTC5",
            "EEF1A1",
            "UBE2W",
            "UBL5",
            "THAP2",
            "RNF5P1",
            "NUDT16L1",
            "ANKRD46",
            "RWDD2A",
            "CNN3",
            "CNOT8",
            "FAM38A",
            "MED30",
            "PRDX2",
            "C8orf83",
            "RNF139",
            "KLHDC2",
            "GLO1",
            "ZNF709",
            "BMI1",
            "CRBN",
            "SNAPIN",
            "GAK",
            "IFT52",
            "PLEKHF2",
            "ASNA1",
            "ZNF410",
            "KLHL7",
            "SFT2D2",
            "EHBP1L1",
            "RBBP9",
            "C3orf38",
            "COX11",
            "HBP1",
            "CDC42",
            "RCHY1",
            "PACS1",
            "SETMAR",
            "ZCCHC17",
            "C22orf9",
            "PEX19",
            "ZNF555",
            "MOV10",
            "TADA1",
            "MINK1",
            "ZNF335",
            "PIGY",
            "ZNF20",
            "ZNF561",
            "OGG1",
            "ZNF136",
            "SETD8",
            "PEX11B",
            "C11orf46",
            "RBM19",
            "EDC4",
            "C11orf58",
            "APH1A",
            "ZNF564",
            "ANKRD11",
            "CDK11B",
            "DHX38",
            "C11orf57",
            "PPP1R8",
            "C19orf52",
            "ATG9A",
            "MATR3"
        ]
    },
    {
        "golabel": "ZNF638_regulon_activity",
        "gene": [
            "TIMP4",
            "TEDDM1",
            "LGALS1",
            "SCN8A",
            "LILRA5",
            "CRYBB1",
            "CTSK",
            "FPR1",
            "FCGR2B",
            "PDLIM3",
            "TAGLN",
            "GLIPR1",
            "C1QC",
            "RARRES2",
            "SIGLEC7",
            "CD14",
            "PLA2G5",
            "RGPD1",
            "CD300A",
            "FCER1G",
            "PILRA",
            "HAVCR2",
            "LRRC25",
            "CD86",
            "LAPTM5",
            "NBL1",
            "METRNL",
            "ICAM3",
            "LMCD1",
            "CALHM2",
            "LOC90784",
            "MRPL49",
            "KIAA1731",
            "ASNA1",
            "ZYX",
            "POGZ",
            "CECR5",
            "TARSL2",
            "CEP290",
            "ZFP62",
            "CCDC142",
            "NFAT5",
            "ZNF507",
            "ZNF518A",
            "OAZ1",
            "TPST2",
            "ATAD2B",
            "ASB13",
            "CLPP",
            "RGPD4",
            "BPTF",
            "TNRC6A",
            "HYAL2",
            "DHX57",
            "C10orf4",
            "BIRC6",
            "TPR",
            "MLH3",
            "INO80D",
            "MGEA5",
            "USP34",
            "TINF2",
            "PPM1B",
            "ETAA1",
            "UBXN6",
            "STX5",
            "SLTM",
            "AFTPH",
            "RBBP6",
            "FBXO11",
            "HNRNPU",
            "WDR33",
            "PUM2",
            "YTHDC1",
            "GGNBP2"
        ]
    },
    {
        "golabel": "ZNF652_regulon_activity",
        "gene": [
            "CD70",
            "FOSL1",
            "ARNTL2",
            "LILRA5",
            "SRGN",
            "CLIC6",
            "CCL3",
            "FPR1",
            "C10orf125",
            "DNAJB7",
            "PLAUR",
            "C6orf57",
            "ZNF238",
            "PRKAR1B",
            "POU2F1",
            "FLJ90757",
            "EXPH5",
            "CTNNAL1",
            "INSR",
            "NFIB",
            "C22orf27",
            "ACVR1B",
            "CTSB",
            "LOC90110",
            "SAMD12",
            "CLIC1",
            "IKZF4",
            "C9orf21",
            "ZYX",
            "PDIK1L",
            "HMGN4",
            "UBN2",
            "AKAP1",
            "CCDC111",
            "MBTD1",
            "GNPDA1",
            "ATG5",
            "TPD52L2",
            "CYB561",
            "HSPA8",
            "HACL1",
            "GATAD2B",
            "AMD1",
            "KIAA1267",
            "BPTF",
            "OGG1",
            "ACOX1",
            "ZNF805",
            "MYST2",
            "TMEM57",
            "COG1",
            "PPID",
            "APEH",
            "UBE2D3",
            "FAM134C",
            "MKRN1",
            "RUNDC1",
            "BECN1"
        ]
    },
    {
        "golabel": "ZNF664_regulon_activity",
        "gene": [
            "ASCL1",
            "RET",
            "FOXI3",
            "S100A3",
            "MATK",
            "ANXA3",
            "KRT19",
            "HCST",
            "C17orf60",
            "TNFRSF12A",
            "HLA-F",
            "GMFG",
            "EMP3",
            "CLTB",
            "RGS10",
            "HLA-B",
            "KIAA1958",
            "SNX8",
            "IFT81",
            "SH3BGRL3",
            "PSMB10",
            "RHOC",
            "GPX1",
            "ZDHHC23",
            "RAC2",
            "ANXA2",
            "HLA-A",
            "HLA-C",
            "CAPG",
            "RRAS",
            "PHF16",
            "AACS",
            "SBNO1",
            "TSPO",
            "HOOK1",
            "ZNF620",
            "MED13L",
            "MLEC",
            "KLHL24",
            "GSTK1",
            "ZYX",
            "GRHL2",
            "ESRP1",
            "BCL7A",
            "TRIP10",
            "ANXA5",
            "ATXN7L3B",
            "DNAJC17",
            "STRBP",
            "NAA25",
            "ATP2A2",
            "SUDS3",
            "EP400",
            "C12orf65",
            "PTPN11",
            "PAPOLA",
            "GNAI2",
            "STX4",
            "POLR3B",
            "TNIP1",
            "FBXO21",
            "ARID2",
            "DBNL",
            "ATXN2",
            "TWF2",
            "RHOG",
            "SUV420H1",
            "TFCP2",
            "SPPL3",
            "SART3",
            "MTMR14",
            "AFTPH",
            "USP30",
            "DHX9",
            "BRAP",
            "RNF10",
            "RSRC2"
        ]
    },
    {
        "golabel": "ZNF668_regulon_activity",
        "gene": [
            "NKX3-2",
            "SCT",
            "HTRA3",
            "RCN3",
            "C1orf70",
            "COL6A2",
            "LEPREL2",
            "MC1R",
            "C1QTNF6",
            "SOX18",
            "PPP1R3F",
            "TNFRSF4",
            "HOMER3",
            "CLEC11A",
            "C2orf27A",
            "ZNHIT2",
            "PDLIM7",
            "ZNF573",
            "FAM20C",
            "FHL3",
            "HSD3B7",
            "FCHO2",
            "ABCD1",
            "CHPF",
            "ZNF775",
            "TCP11L2",
            "PRR5",
            "LEPRE1",
            "HEXIM2",
            "SMTN",
            "HSDL2",
            "PRKAR2A",
            "FBXL19",
            "C5orf41",
            "FAM109A",
            "ARFGAP1",
            "YIF1B",
            "BCAR1",
            "PLEKHF2",
            "RUSC2",
            "ZNF787",
            "C11orf24",
            "ZNF628",
            "OXR1",
            "DOHH",
            "ZNF205",
            "CHPF2",
            "ADRM1",
            "POLK",
            "AKT1S1",
            "MBD3",
            "C6orf211",
            "RILPL1",
            "GPR137",
            "PREPL",
            "PPP2CB",
            "DNAJB14",
            "ZBTB17",
            "STX4",
            "SPNS1",
            "TESK1",
            "ZFPL1",
            "CHST14",
            "KIAA1704",
            "C17orf62",
            "TSSC4",
            "NKIRAS2",
            "SACM1L",
            "MPP5",
            "ZNF408",
            "SH3BP5L",
            "NARG2",
            "PRMT10",
            "RHOT1",
            "CAPN7",
            "MATR3"
        ]
    },
    {
        "golabel": "ZNF688_regulon_activity",
        "gene": [
            "TCTEX1D4",
            "C17orf72",
            "CD164L2",
            "ANKRD24",
            "RRAD",
            "BEST4",
            "C1orf228",
            "RIBC1",
            "CCDC153",
            "C9orf116",
            "FLJ36777",
            "LOC388242",
            "METRN",
            "MYOM2",
            "TMEM121",
            "LRRC23",
            "C4orf44",
            "MAGIX",
            "LTC4S",
            "SGK196",
            "FLJ45244",
            "C11orf35",
            "C16orf93",
            "FBXL8",
            "C1orf133",
            "FLJ39582",
            "SELM",
            "ODF3B",
            "KLHDC9",
            "CTF1",
            "PYCARD",
            "C2orf81",
            "HEXDC",
            "LCA5L",
            "SLC22A18",
            "C7orf59",
            "RNF32",
            "SYTL1",
            "S1PR4",
            "HYI",
            "C19orf20",
            "MYL5",
            "ROM1",
            "C16orf48",
            "MGC3771",
            "FLJ35220",
            "LRRC29",
            "TRAPPC6A",
            "FAM116B",
            "PSMB10",
            "FAM173A",
            "C5orf45",
            "SPATA5",
            "CCDC24",
            "MDP1",
            "LYL1",
            "TAOK1",
            "C6orf1",
            "C21orf122",
            "NDUFB7",
            "LMF1",
            "PRSS8",
            "LHPP",
            "NME3",
            "HEATR5A",
            "FDXR",
            "PEX11G",
            "HSD11B1L",
            "TRAPPC5",
            "SCAND1",
            "C19orf60",
            "STOML1",
            "HCFC1R1",
            "YPEL3",
            "ALKBH7",
            "ZDHHC1",
            "RGS14",
            "GIYD2",
            "PTRH1",
            "TCEA2",
            "SBNO1",
            "MPG",
            "HEXIM2",
            "DDX21",
            "C9orf142",
            "C1orf89",
            "CCDC159",
            "FBXL15",
            "NUDT18",
            "SMPD2",
            "C19orf70",
            "BCL7C",
            "TMEM2",
            "TMEM187",
            "OCEL1",
            "GSDMD",
            "C21orf2",
            "FUZ",
            "RIF1",
            "DGCR6L",
            "PGLS",
            "E2F3",
            "RAB24",
            "VKORC1",
            "SSBP4",
            "ROGDI",
            "FAM3A",
            "TMEM175",
            "CSNK2A1P",
            "ORAI3",
            "CD2AP",
            "TREX1",
            "XPO5",
            "SMC3",
            "MED1",
            "B3GALT4",
            "TMEM134",
            "MIB1",
            "ACBD4",
            "C16orf58",
            "RABEP2",
            "JOSD2",
            "PIGQ",
            "ARRDC1",
            "TRADD",
            "ESF1",
            "UHRF1BP1",
            "TMEM219",
            "C19orf25",
            "RNASEH2C",
            "PHKG2",
            "WDR13",
            "DNAJC4",
            "COQ4",
            "NAT6",
            "ANAPC1",
            "DIP2B",
            "SPSB3",
            "NUBP2",
            "CCDC101",
            "TMEM129",
            "FAM98B",
            "ZNF747",
            "BAD",
            "IL17RC",
            "LMAN1",
            "ZDHHC24",
            "SMCR7",
            "B4GALT7",
            "MYST1",
            "GHDC",
            "NDUFB10",
            "TOP1",
            "NUP153",
            "SRPK1",
            "STK16",
            "SMARCC1",
            "PEX16",
            "NUDT22",
            "FLYWCH2",
            "NDUFS7",
            "DPP8",
            "CHMP6",
            "FLYWCH1",
            "NSMCE1",
            "JMJD5",
            "FAM108A1",
            "ESCO1",
            "CSNK2A1",
            "PPP4R2",
            "PTPN11",
            "INO80E",
            "RHBDD2",
            "RNF166",
            "VMAC",
            "GPR137",
            "TNPO1",
            "LARP4",
            "RPL7L1",
            "STUB1",
            "PRR14",
            "PIN1",
            "NARFL",
            "STX4",
            "CDC5L",
            "DEXI",
            "EIF3A",
            "C17orf59",
            "CDIPT",
            "KIF5B",
            "VEGFB",
            "TRIP12",
            "TMEM222",
            "GALT",
            "C16orf42",
            "YME1L1",
            "C11orf68",
            "EXOC2",
            "MRPL19",
            "SYNCRIP",
            "CD2BP2",
            "PRPF40A",
            "HNRNPR",
            "ACTR2",
            "DHX9",
            "RBM12"
        ]
    },
    {
        "golabel": "ZNF69_regulon_activity",
        "gene": [
            "ZDHHC8P1",
            "PLOD2",
            "PLLP",
            "PRR11",
            "CENPI",
            "PFN2",
            "HMMR",
            "CKAP2L",
            "SLC25A29",
            "C22orf36",
            "HNF1B",
            "ZNF204P",
            "NEIL1",
            "RACGAP1",
            "RBPMS",
            "IPMK",
            "FBXO5",
            "GANC",
            "MYO5C",
            "P4HA1",
            "RASSF7",
            "PGK1",
            "SLC27A1",
            "LOC90110",
            "ZNF763",
            "SBNO1",
            "PGAM4",
            "C19orf44",
            "STAP2",
            "ARHGAP27",
            "LOC729020",
            "MSH6",
            "PDIA6",
            "YIPF6",
            "AGFG1",
            "ARRDC1",
            "SAMD8",
            "COQ4",
            "ULK3",
            "SLC30A6",
            "NAA50",
            "PARP1",
            "FAM199X",
            "PLBD2",
            "MOBKL1B",
            "PRPS1",
            "LARP4",
            "MAP3K2",
            "ATF2",
            "RQCD1",
            "RNGTT",
            "CDV3",
            "TAB2",
            "GNB1",
            "IMMT",
            "SMARCAL1"
        ]
    },
    {
        "golabel": "ZNF691_regulon_activity",
        "gene": [
            "CHODL",
            "FLJ36777",
            "ZNF323",
            "GLS2",
            "FGGY",
            "ZMYND12",
            "C1orf51",
            "FLJ45244",
            "GPR126",
            "SH3BGR",
            "FLJ39582",
            "TSTD1",
            "TMEM125",
            "MYO1E",
            "PRDX1",
            "HSD17B8",
            "AKAP2",
            "C11orf52",
            "CD93",
            "HYI",
            "NUDT7",
            "LOC100271722",
            "ZNF596",
            "ROM1",
            "C6orf125",
            "ST3GAL3",
            "C1orf210",
            "SPATA24",
            "TRNAU1AP",
            "RFESD",
            "FOSL2",
            "MAP4K4",
            "TMEM42",
            "RAB17",
            "ZNF684",
            "KLF6",
            "SENP8",
            "C5orf54",
            "DNAJC28",
            "C17orf108",
            "C1orf203",
            "C2orf64",
            "C17orf90",
            "CCDC23",
            "APITD1",
            "PPTC7",
            "FASTKD3",
            "LYPLAL1",
            "NACC2",
            "HAUS4",
            "ATPIF1",
            "C3orf71",
            "HSPC157",
            "ING4",
            "ZNF630",
            "MUTYH",
            "ZNF673",
            "VCL",
            "ZSCAN16",
            "C10orf12",
            "PPCS",
            "THYN1",
            "THAP3",
            "HADH",
            "PPOX",
            "PMF1",
            "ADAM10",
            "TMEM59",
            "LRCH1",
            "SAMD8",
            "AK2",
            "ARHGAP21",
            "DMAP1",
            "ZBTB48",
            "MED18",
            "ERMAP",
            "LOC400657",
            "ARMCX6",
            "TCEANC",
            "PRR3",
            "UROD",
            "CYP2R1",
            "HIVEP2",
            "CCDC101",
            "TMOD3",
            "C1orf50",
            "PPIE",
            "DEM1",
            "SETMAR",
            "FAM200A",
            "AKR1A1",
            "KTI12",
            "PAAF1",
            "ANO6",
            "LIPT1",
            "BCDIN3D",
            "FAM200B",
            "ASCC3",
            "PARS2",
            "WDR5B",
            "TRAPPC3",
            "MEAF6",
            "WBP1",
            "OMA1",
            "ERI3",
            "LOC148413",
            "C15orf40",
            "ADPRHL2",
            "GNA11",
            "NFYC",
            "C2orf68",
            "CPT2",
            "DDX28",
            "C1orf123",
            "ZBED5",
            "NIT1",
            "TAF12",
            "TMEM186",
            "TRIP12",
            "UCK1",
            "CYFIP1",
            "ATPAF1",
            "NSUN4",
            "PEF1",
            "MECR",
            "FAM54B",
            "MRFAP1L1"
        ]
    },
    {
        "golabel": "ZNF692_regulon_activity",
        "gene": [
            "FAM166A",
            "MSLNL",
            "TMEM89",
            "CALML6",
            "NCRNA00176",
            "KIAA1984",
            "PRSS45",
            "PCP2",
            "KIAA1875",
            "MST1P2",
            "FAM183B",
            "LOC149134",
            "MAPK15",
            "KRTAP5-10",
            "SCNN1D",
            "C1orf223",
            "PAQR6",
            "ATHL1",
            "KRTAP5-8",
            "DCAF4L1",
            "DCST2",
            "FLJ12825",
            "GUCY1B2",
            "C17orf55",
            "HSF4",
            "C6orf81",
            "TBC1D3C",
            "SLC25A2",
            "C6orf41",
            "CD163",
            "EVPLL",
            "SPTBN5",
            "SLC23A3",
            "AMAC1L2",
            "SDHAP3",
            "KRTAP5-1",
            "ADAMTS13",
            "PRR5-ARHGAP8",
            "AGAP7",
            "SLC24A5",
            "C9orf96",
            "HCN3",
            "OBSCN",
            "FBXO24",
            "TBC1D3H",
            "TNFSF8",
            "KIFC2",
            "SEC16B",
            "PTAFR",
            "GOLGA8B",
            "C3orf35",
            "PABPC1L",
            "MS4A4A",
            "C8orf77",
            "TLE6",
            "PIP5KL1",
            "FLJ45244",
            "KATNAL2",
            "BREA2",
            "TMEM184A",
            "PI4KAP1",
            "PCSK4",
            "TNFSF13B",
            "C1orf229",
            "GOLGA2B",
            "C17orf47",
            "EFCAB2",
            "TBC1D3B",
            "C6orf26",
            "FRS3",
            "RHPN1",
            "TRPV1",
            "LOC653653",
            "NCRNA00201",
            "MPP3",
            "DFNB59",
            "DSE",
            "SLC25A35",
            "GOLGA6L9",
            "GDF9",
            "TLR4",
            "NECAB3",
            "GLI4",
            "SLC26A6",
            "SNHG3",
            "C1orf104",
            "ZNF467",
            "C20orf151",
            "FLJ39653",
            "L3MBTL",
            "GOLGA6L10",
            "MSH5",
            "LOC100132287",
            "SRRM5",
            "PIK3AP1",
            "PILRB",
            "CDK3",
            "RGL3",
            "ATAD3B",
            "LOC401052",
            "SULT1A3",
            "CCNL2",
            "LOC100132288",
            "LY6G5B",
            "F2R",
            "ANKRD23",
            "TRIM45",
            "AGAP6",
            "SPDYA",
            "MORF4",
            "C20orf96",
            "TAS2R20",
            "MSTO2P",
            "KLHL17",
            "NUDT13",
            "FAM53A",
            "ADAT2",
            "IDI2",
            "SNHG12",
            "INCA1",
            "CHKA",
            "BGLAP",
            "AGAP4",
            "LOC150776",
            "SAMHD1",
            "DAB2",
            "NPEPL1",
            "ZNF789",
            "AP1G2",
            "LOC202781",
            "LOC100288778",
            "SGSM2",
            "CDK5RAP3",
            "LOC729375",
            "RRP7B",
            "TBC1D3",
            "LOC645676",
            "SS18L1",
            "PRPF40B",
            "ZMAT3",
            "PRRG4",
            "ARHGAP8",
            "LOC285359",
            "SPRN",
            "SNORA8",
            "WASH5P",
            "MAP1D",
            "ZNF767",
            "ANKS3",
            "TXNRD2",
            "CDRT4",
            "WASH7P",
            "ORAOV1",
            "TOP3B",
            "DNAH14",
            "TSSK6",
            "MTERFD3",
            "C6orf134",
            "KAT2A",
            "ATXN7L2",
            "LUC7L",
            "C17orf86",
            "MSTO1",
            "RAB8B",
            "TWSG1",
            "NBR2",
            "GTF2A1",
            "RCCD1",
            "LIMS1",
            "PIGL",
            "SGCB",
            "RAD52",
            "ARHGAP18",
            "LNPEP",
            "HKR1",
            "ZMYND17",
            "STX16",
            "KIAA0907",
            "ENOSF1",
            "MDM4",
            "WASH2P",
            "SDR39U1",
            "RPS10P7",
            "TRMT2A",
            "CAPN10",
            "SETD4",
            "WASH3P",
            "IFT27",
            "TARBP1",
            "LOC284900",
            "RGL2",
            "C9orf21",
            "C17orf56",
            "PRKRIP1",
            "GGA1",
            "DOM3Z",
            "PPOX",
            "TRMU",
            "CORO1C",
            "RP2",
            "LUC7L3",
            "SNHG11",
            "METTL3",
            "BACH1",
            "LOC284441",
            "PRPF3",
            "RECQL5",
            "ZNF513",
            "OSTM1",
            "ANKRD13D",
            "ANKRD16",
            "SGTB",
            "OGFOD2",
            "POLM",
            "C1orf66",
            "CYP2R1",
            "SNX9",
            "NSUN6",
            "SDCBP",
            "CLK2",
            "INTS3",
            "RRAGC",
            "ULK3",
            "ZNF839",
            "QKI",
            "SETD6",
            "CCDC45",
            "CLK3",
            "ANKZF1",
            "ANO6",
            "TRIM11",
            "DR1",
            "ACER3",
            "PCGF3",
            "AKAP8L",
            "TMCO6",
            "CCNI",
            "WBP1",
            "UBTD2",
            "CDK5RAP1",
            "PARP6",
            "ZNF76",
            "LZTS2",
            "TJAP1",
            "LMBR1",
            "CAB39",
            "C6orf72",
            "LUZP6",
            "OSBPL8",
            "MFSD1",
            "M6PR",
            "USP21",
            "ACIN1",
            "BAT1",
            "CMTM6",
            "LRRFIP1",
            "EXT2",
            "SNX12",
            "PYCR2",
            "SNRNP35",
            "GNA13",
            "USF1",
            "NIT1",
            "WDFY1",
            "CRTC2",
            "USP38",
            "CAP1",
            "RSAD1",
            "AAAS",
            "TAB2",
            "SH3BP5L",
            "ZNF18",
            "ZNF672",
            "C1orf77",
            "SPTY2D1",
            "PICALM",
            "POLL",
            "HIATL1",
            "PTPN9",
            "TMEM127",
            "WDR82"
        ]
    },
    {
        "golabel": "ZNF696_regulon_activity",
        "gene": [
            "BAI1",
            "SRGN",
            "FAM69B",
            "BCL2A1",
            "EPPK1",
            "SRCIN1",
            "PTP4A3",
            "GYLTL1B",
            "CCRL2",
            "RAB32",
            "NCF2",
            "LXN",
            "ANXA2P2",
            "B2M",
            "CTSS",
            "CARD6",
            "PMP22",
            "IFNGR1",
            "TOP1MT",
            "SCRIB",
            "CCDC90B",
            "ZNF517",
            "RAB8B",
            "SAMD12",
            "TRAPPC9",
            "ZNF74",
            "ZFP41",
            "ZNF707",
            "RP2",
            "KCTD9",
            "ZNF623",
            "SNX3",
            "ANXA5",
            "TMEM140",
            "SPPL2A",
            "TDRD7",
            "ZFAND6",
            "MFSD1",
            "PNRC1",
            "MEN1",
            "PPP1R2",
            "MORF4L1",
            "ADPGK",
            "ARPC2",
            "ILF3",
            "DDX42",
            "UBTF"
        ]
    },
    {
        "golabel": "ZNF697_regulon_activity",
        "gene": [
            "FLJ22536",
            "CDK6",
            "ADAM12",
            "CLSPN",
            "ADAMTS5",
            "NAPSA",
            "NPC2",
            "SACS",
            "AK1",
            "ABCC6P2",
            "SFTA3",
            "KCNK5",
            "MALL",
            "COL4A2",
            "PPFIBP1",
            "EIF4EBP3",
            "COL4A1",
            "GATSL1",
            "C18orf54",
            "TSTD1",
            "PDGFB",
            "TMEM125",
            "HLA-DMA",
            "LAMB1",
            "C7orf23",
            "MICAL3",
            "TCEA3",
            "NCAPD2",
            "SEPW1",
            "NDUFA2",
            "ZNF286A",
            "VAMP8",
            "C5orf45",
            "PPT2",
            "UACA",
            "MAP4K4",
            "BTG3",
            "PRKDC",
            "RILP",
            "NME3",
            "LAMC1",
            "CNIH4",
            "NUDT16L1",
            "PTGFRN",
            "RGS14",
            "ENTPD7",
            "KLF7",
            "SBNO1",
            "ASAP1",
            "MR1",
            "CRB3",
            "SMTN",
            "AFAP1",
            "ARV1",
            "PPP2R5A",
            "HAUS4",
            "CKAP4",
            "CCDC107",
            "AGXT2L2",
            "ROGDI",
            "C10orf12",
            "JARID2",
            "LOC221710",
            "POLR1A",
            "SMC3",
            "VANGL1",
            "MIB1",
            "LUZP1",
            "PUS10",
            "TRAM2",
            "AK2",
            "TTL",
            "HINT2",
            "ESF1",
            "TMEM219",
            "DOCK7",
            "HAGH",
            "ZNF532",
            "DIP2B",
            "GCN1L1",
            "PCBD2",
            "PTPN11",
            "NPRL2",
            "PEX11B",
            "PPP1R12A",
            "EIF3A",
            "ACTR1B",
            "RMND5B",
            "ZNF564",
            "GPR108",
            "NUBP1",
            "PRDM4",
            "CDC27"
        ]
    },
    {
        "golabel": "ZNF699_regulon_activity",
        "gene": [
            "KLHL4",
            "C2CD4D",
            "NOXA1",
            "EFCAB4A",
            "SPIRE2",
            "CNTLN",
            "PLXNC1",
            "C1orf56",
            "RNF208",
            "SEPT11",
            "D2HGDH",
            "BMP2K",
            "PICK1",
            "DGAT1",
            "PRSS8",
            "SLC4A7",
            "TXNRD2",
            "UGCG",
            "ZNF430",
            "SLC30A4",
            "ZNF420",
            "NR2F6",
            "ERP29",
            "PNKD",
            "LIMS1",
            "ATP11C",
            "RECQL",
            "CCDC75",
            "LEPROT",
            "LNPEP",
            "RHBDD3",
            "TMEM81",
            "MANEA",
            "MRM1",
            "GAB1",
            "RASA2",
            "ZNF444",
            "NMT2",
            "DUS1L",
            "RAP2A",
            "ZNF426",
            "C1orf66",
            "RRAGC",
            "SLC38A10",
            "MOSPD2",
            "ZBTB7B",
            "C12orf4",
            "SPG7",
            "SLC25A46",
            "TRIM11",
            "DR1",
            "POLK",
            "IPO11",
            "MMGT1",
            "RNPEP",
            "E4F1",
            "HCFC2",
            "LZTS2",
            "RSPRY1",
            "FBXL3",
            "WDR47",
            "OSBPL8",
            "PTOV1",
            "ZNF845",
            "CTDSPL2",
            "DNAJB14",
            "GPS2",
            "TUFM",
            "LSM11",
            "CXorf56",
            "SCAMP3",
            "NDUFS2",
            "GABPA",
            "EIF5",
            "PPIP5K2",
            "VEZF1",
            "ARL8A",
            "TRAF6",
            "CTBP1",
            "TMEM214",
            "MORC3",
            "TTC15"
        ]
    },
    {
        "golabel": "ZNF704_regulon_activity",
        "gene": [
            "IGSF10",
            "FOSL1",
            "FREM2",
            "FRAS1",
            "CECR2",
            "GZMB",
            "NKG7",
            "AMOT",
            "SYDE2",
            "SGSM1",
            "PPM1L",
            "PLCE1",
            "LIFR",
            "ZBTB10",
            "WASF3",
            "SEPX1",
            "RPL35",
            "KIAA1244",
            "PARD3B",
            "USP51",
            "MYH10",
            "STOX2",
            "TMSB10",
            "ZSWIM5",
            "RALGAPA2",
            "IL15RA",
            "NCOA2",
            "MLKL",
            "EFHD2",
            "AMIGO1",
            "EPB41L5",
            "IGSF3",
            "FAM161B",
            "TYMP",
            "MAGI1",
            "PLP2",
            "NME2",
            "DAAM1",
            "ATP9A",
            "ENPP4",
            "PSME2",
            "MYO9A",
            "PPP1R14B",
            "SCO2",
            "KRBA2",
            "CHD6",
            "ULK2",
            "KIF16B",
            "REV3L",
            "NCOA1",
            "BCL7A",
            "SORT1",
            "VPS13D",
            "MTMR12",
            "UBR3",
            "PPM1D",
            "KIAA0240",
            "KIDINS220",
            "CYTSA",
            "UBE2F",
            "ATXN1L",
            "ARPC5L",
            "TTC17",
            "PTPRA"
        ]
    },
    {
        "golabel": "ZNF709_regulon_activity",
        "gene": [
            "ABCC2",
            "RHOV",
            "KYNU",
            "LYPD3",
            "PPP2R2C",
            "LOC284276",
            "OPN3",
            "EFNB3",
            "KLHL32",
            "PTGES",
            "TMSB15B",
            "RIBC1",
            "TMEM231",
            "LRRC49",
            "CCDC148",
            "BEND5",
            "TSGA10",
            "RAB36",
            "DNALI1",
            "LOC441869",
            "STK33",
            "PFKP",
            "LAMB3",
            "ICA1L",
            "MLF1",
            "TXNDC16",
            "LCA5L",
            "NPHP1",
            "KBTBD3",
            "ABCC1",
            "RPS6KA5",
            "PLEC",
            "MYO1E",
            "TUBA1A",
            "WDR54",
            "SPATA6",
            "FAM118B",
            "CDC14A",
            "APBB1",
            "ZNF491",
            "FOSL2",
            "ZNF684",
            "ZNF627",
            "GALNT2",
            "TTLL12",
            "ZNF287",
            "PKP3",
            "TESK2",
            "CYP2U1",
            "PVR",
            "MYLIP",
            "CLIP1",
            "IFT46",
            "LOC147727",
            "ZNF441",
            "SPATA7",
            "IFT52",
            "PLEKHF2",
            "ZNF14",
            "C11orf24",
            "TAF9B",
            "KIAA1826",
            "RBBP9",
            "PDIK1L",
            "TNFRSF1A",
            "TCEANC",
            "LZTFL1",
            "CCDC104",
            "ZNF598",
            "PLEKHA9",
            "ACVR2A",
            "ZNF187",
            "MEAF6",
            "KTELC1",
            "RRAGB",
            "ZNF559",
            "DDX54",
            "ZNF20",
            "KIAA1737",
            "MYO1C",
            "ZNF136",
            "C2orf18",
            "ZFP90",
            "FAM76A",
            "NCRNA00094",
            "PAPSS1",
            "C11orf57",
            "PNRC2",
            "TMEM214",
            "ATG9A",
            "ELF2"
        ]
    },
    {
        "golabel": "ZNF76_regulon_activity",
        "gene": [
            "GLTPD2",
            "CBR1",
            "FAM41C",
            "C1orf95",
            "MST1",
            "AQP7",
            "GNMT",
            "LCN12",
            "KIF12",
            "WNT8B",
            "KLF15",
            "CD109",
            "MXRA5",
            "SULF1",
            "OVGP1",
            "SFTA2",
            "PLA2G6",
            "FRMD6",
            "SULT1A2",
            "VCAN",
            "SEMA3C",
            "FLJ35776",
            "PRKCZ",
            "TMEM80",
            "C1orf229",
            "C6orf26",
            "FRS3",
            "KLHDC9",
            "EIF5A2",
            "DSE",
            "DCXR",
            "NECAB3",
            "FAM22A",
            "MSH5",
            "PLD1",
            "ZNF692",
            "NUDT13",
            "ABHD14A",
            "PEX6",
            "ITGAV",
            "C1orf210",
            "ProSAPiP1",
            "ELK3",
            "MGC70857",
            "KCTD12",
            "SGSM2",
            "FAAH",
            "SLC20A1",
            "TMEM150A",
            "SHMT1",
            "LHFPL2",
            "CCDC57",
            "MRPS26",
            "TXNRD2",
            "WASH7P",
            "CDK10",
            "LOC100130093",
            "LASS6",
            "GCNT2",
            "C6orf134",
            "PNKD",
            "PRKAB1",
            "CALU",
            "NEK8",
            "C6orf136",
            "RALB",
            "CHSY1",
            "TPM4",
            "WASH3P",
            "ZSWIM7",
            "CNTROB",
            "ZSCAN16",
            "DOM3Z",
            "PMF1",
            "MED11",
            "C16orf58",
            "DEAF1",
            "PRR3",
            "C1orf66",
            "GLT25D1",
            "EHMT2",
            "SUOX",
            "SIRT5",
            "G6PC3",
            "ANO6",
            "CUTA",
            "C6orf130",
            "C12orf5",
            "ARFIP2",
            "E4F1",
            "SLC37A4",
            "TJAP1",
            "LMBR1",
            "LUZP6",
            "M6PR",
            "ACTR3",
            "ARF6",
            "MED9",
            "CPT2",
            "BAT1",
            "DPH1",
            "PMPCA",
            "POMT1",
            "BAT5",
            "FEZ2",
            "SIRT3",
            "YWHAH",
            "VPS52",
            "ARPC2",
            "BAT3",
            "RXRB",
            "ACTR2"
        ]
    },
    {
        "golabel": "ZNF763_regulon_activity",
        "gene": [
            "EPX",
            "AMY2B",
            "RIC3",
            "CA3",
            "TNNC1",
            "SLC7A5",
            "ADAMTS4",
            "NAMPT",
            "FAM189A2",
            "ZNF493",
            "ZNF540",
            "SNAI1",
            "ST3GAL6",
            "FAM47E",
            "C20orf132",
            "MTHFD2",
            "ZFP2",
            "ZNF214",
            "ZNF69",
            "ZNF439",
            "NOD1",
            "ZNF491",
            "PDIA4",
            "KLHDC1",
            "ZNF167",
            "GALNT2",
            "ZNF671",
            "DNAJC28",
            "ZNF433",
            "RIPK3",
            "PHKA1",
            "BDH2",
            "ZNF846",
            "B4GALT1",
            "CKAP4",
            "LOC147727",
            "PDIA6",
            "ZNF441",
            "CIRBP",
            "PKM2",
            "C14orf28",
            "ZNF44",
            "ZNF250",
            "LOC400657",
            "YWHAG",
            "ALDH18A1",
            "C6orf70",
            "NOLC1",
            "PTPN18",
            "LRRC59",
            "NCKAP1",
            "ZKSCAN4",
            "ABCD4",
            "HDLBP",
            "RNF146",
            "SEC61A1",
            "FAM98A",
            "SMARCAL1"
        ]
    },
    {
        "golabel": "ZNF765_regulon_activity",
        "gene": [
            "PCSK4",
            "C11orf35",
            "FBXL8",
            "ZNF614",
            "IDUA",
            "C1orf97",
            "LOC147804",
            "FBXO5",
            "ZNF813",
            "DCK",
            "ZNF420",
            "SIL1",
            "RNF138",
            "B3GNTL1",
            "CEP76",
            "ZNF530",
            "SCRN2",
            "B3GNT2",
            "ZNF92",
            "ZNF260",
            "COMMD2",
            "TMX1",
            "ZNF761",
            "PUS7L",
            "USP1",
            "ZNF525",
            "TPCN1",
            "ZNF749",
            "PMVK",
            "FBXW4",
            "PRKRIR",
            "ZNF28",
            "NAT6",
            "UBE2MP1",
            "C12orf4",
            "ZNF473",
            "ZNF611",
            "ZNF180",
            "TOM1",
            "RIC8B",
            "NUP160",
            "ZNF845",
            "CTDSPL2",
            "C2orf69",
            "USP45",
            "VTA1",
            "ZNF616",
            "SOCS4",
            "SAE1",
            "ZNF480",
            "WBP2",
            "USP33",
            "MUDENG",
            "POLL",
            "TUBGCP2",
            "API5"
        ]
    },
    {
        "golabel": "ZNF768_regulon_activity",
        "gene": [
            "CPLX1",
            "PRSS53",
            "GPR34",
            "EVI2A",
            "RGS18",
            "MS4A4A",
            "MS4A6A",
            "MS4A7",
            "SLC39A8",
            "CCR2",
            "GPR65",
            "ITM2A",
            "TLR4",
            "LIPA",
            "ZNF771",
            "PRPF40B",
            "GNG2",
            "ALDOA",
            "FBXL19",
            "STK17B",
            "ZNF48",
            "IRF2BP1",
            "MAGEF1",
            "ULK1",
            "ZNF205",
            "CBX4",
            "C16orf53",
            "MAZ",
            "C6orf211",
            "GMEB2",
            "BANP",
            "PRR14",
            "FBRS",
            "ZNF646",
            "ZNF764",
            "WHSC2",
            "RBM10",
            "RAP1A",
            "SETD1A",
            "TBC1D10B",
            "RNF40",
            "CEPT1",
            "FUS"
        ]
    },
    {
        "golabel": "ZNF770_regulon_activity",
        "gene": [
            "FAM83B",
            "A1BG",
            "PKP2",
            "DHDH",
            "ANP32C",
            "GABARAPL3",
            "RENBP",
            "CLDN3",
            "ASAP2",
            "CTAGE1",
            "LOC723972",
            "C5orf39",
            "NCRNA00181",
            "LOC220429",
            "GMCL1L",
            "C5orf55",
            "GRID2IP",
            "MYO1E",
            "CSDAP1",
            "HSPB1",
            "ME3",
            "C6orf1",
            "C7orf50",
            "ZAK",
            "ABHD11",
            "LANCL1",
            "SHISA4",
            "CLDN4",
            "EGLN1",
            "SBNO1",
            "C15orf41",
            "DDX21",
            "ATE1",
            "FAM50A",
            "ACSL3",
            "PCGF5",
            "GSDMD",
            "FAM195B",
            "REST",
            "FAM3A",
            "NINJ1",
            "SMAD2",
            "BLVRA",
            "CHST12",
            "NFXL1",
            "P2RX4",
            "TUBGCP4",
            "IKBKG",
            "RAB34",
            "WRN",
            "LOC729082",
            "ZFP106",
            "NIPA1",
            "SOCS6",
            "TMOD3",
            "DENND4A",
            "FAM98B",
            "LMAN1",
            "TOR2A",
            "LOC646214",
            "STT3B",
            "MPND",
            "MIF4GD",
            "COPS2",
            "DPP8",
            "CHMP6",
            "UBR1",
            "PTPN11",
            "TCF12",
            "IBTK",
            "CTDSPL2",
            "TM9SF3",
            "EIF3J",
            "RFX7",
            "TRPM7",
            "EIF3A",
            "AP1AR",
            "IREB2",
            "CSNK1G1",
            "NIPA2",
            "DBNL",
            "NAGK",
            "C17orf62",
            "UTP14C",
            "ZSCAN29",
            "CLPX",
            "VPS4B",
            "VEGFB",
            "FEM1B",
            "AP4E1",
            "RBM26",
            "EIF2AK4",
            "LEO1",
            "FAM35B2",
            "SLMAP",
            "AQR",
            "USP8",
            "MFAP1",
            "UBE2G1",
            "DCP1A",
            "CSTF2T",
            "ARPP19",
            "DTNBP1",
            "RLIM",
            "ARIH1",
            "RBM27",
            "SP1",
            "CUL5",
            "ASB7",
            "UBE3A",
            "RNF111",
            "WAPAL",
            "SIN3A",
            "BTBD1",
            "BCLAF1",
            "RTF1"
        ]
    },
    {
        "golabel": "ZNF777_regulon_activity",
        "gene": [
            "ARRDC3",
            "RNFT1",
            "ZBTB12",
            "C20orf117",
            "TGDS",
            "LRP5",
            "CD47",
            "TMEM49",
            "ZNF628",
            "TMEM128",
            "MBNL1",
            "PELI3",
            "KLC2",
            "ITPK1",
            "C5orf44",
            "FBXL14",
            "EHMT2",
            "GFOD2",
            "C15orf39",
            "GNPDA2",
            "ZRANB2",
            "MIER1",
            "UBA3",
            "ZNF746",
            "SPATA2",
            "PRKCSH",
            "SNX2",
            "ZC3H18",
            "EIF4E2",
            "CGGBP1",
            "PAPD4"
        ]
    },
    {
        "golabel": "ZNF778_regulon_activity",
        "gene": [
            "C16orf89",
            "TNNI3K",
            "SFTPB",
            "GPR133",
            "AQP3",
            "STEAP1",
            "MAOA",
            "ESYT3",
            "OASL",
            "NAPSA",
            "SELENBP1",
            "PARM1",
            "C16orf3",
            "RHOBTB2",
            "CENPW",
            "SFTA3",
            "EPSTI1",
            "ATP11A",
            "CENPM",
            "UNC13B",
            "MMD",
            "ALDH6A1",
            "EFHD2",
            "BTBD9",
            "RHOC",
            "RPS6KA2",
            "ALDH5A1",
            "PLSCR1",
            "CCDC90B",
            "CRY2",
            "DNAJC28",
            "KIAA0182",
            "SMS",
            "MTHFR",
            "MARCKS",
            "TUBA1B",
            "ESRP2",
            "CNTROB",
            "GAS8",
            "KIAA1109",
            "ARHGEF17",
            "PARP12",
            "HSDL1",
            "ZNF19",
            "NFATC3",
            "GLT25D1",
            "ZNF33A",
            "ZNF23",
            "TTC3",
            "RCOR3",
            "TCF25",
            "DYNLL1",
            "ACTR3",
            "RANBP9",
            "ZCCHC14",
            "ATXN1L",
            "EXOC8",
            "DCAF8",
            "TERF2IP",
            "ARPC2",
            "ZXDC",
            "MBTPS1",
            "RC3H1",
            "DYNC1LI2",
            "TRIM39",
            "AP1G1"
        ]
    },
    {
        "golabel": "ZNF791_regulon_activity",
        "gene": [
            "PKD1L2",
            "LOC100133985",
            "KRT7",
            "IKZF3",
            "SESN3",
            "ANKRD9",
            "IL6ST",
            "MFSD3",
            "FNIP2",
            "ANKRD44",
            "C14orf80",
            "ZNF573",
            "NCRNA00182",
            "SLC25A10",
            "RAPGEF6",
            "ZNF844",
            "C22orf27",
            "ZNF430",
            "PUS1",
            "C5orf41",
            "GPR172A",
            "SLC3A2",
            "LRRC45",
            "SHPRH",
            "PVRL2",
            "TMUB1",
            "PSMB6",
            "RBM43",
            "FASTK",
            "SLC25A1",
            "C1orf122",
            "ZNF175",
            "RANBP6",
            "SIRT7",
            "ZNF426",
            "C2orf86",
            "CNO",
            "MAP3K1",
            "PGP",
            "CCDC137",
            "DENND4A",
            "ZNF417",
            "MLF2",
            "ZNF619",
            "TRIM23",
            "SLC25A46",
            "ADRM1",
            "ANKHD1",
            "FBXO38",
            "NOC4L",
            "ZNF295",
            "YPEL2",
            "ABCB8",
            "POLK",
            "KIAA1430",
            "ZNF557",
            "WDR47",
            "FBXO3",
            "KBTBD4",
            "BRMS1",
            "ZNF616",
            "ZNF136",
            "CHMP1A",
            "RSBN1L",
            "GABPA",
            "COASY",
            "PPIP5K2",
            "WBSCR16",
            "ZNF41",
            "ZNF510",
            "PSMC5",
            "TRAF6",
            "CTBP1",
            "ZNF317",
            "ELF2"
        ]
    },
    {
        "golabel": "ZNF799_regulon_activity",
        "gene": [
            "IL7",
            "HIPK2",
            "ZNF461",
            "BET1",
            "NOMO2",
            "NIPSNAP3A",
            "POLR1A",
            "ZNF44",
            "ZNF443",
            "ZNF823",
            "TMEM184B",
            "C19orf25",
            "NOMO1",
            "POLR2A",
            "AARS",
            "ANKRD49",
            "UGGT1",
            "HUWE1",
            "C19orf39",
            "POC5",
            "BAT2",
            "RALBP1",
            "PHF11",
            "EIF4G1",
            "FTSJ3",
            "EIF3A",
            "ZNF564",
            "C19orf56",
            "RNF40",
            "NFE2L1",
            "HDLBP",
            "SNAP23",
            "EIF4E2",
            "TM9SF4",
            "SF3B2"
        ]
    },
    {
        "golabel": "ZNF800_regulon_activity",
        "gene": [
            "MDFIC",
            "IPMK",
            "BGLAP",
            "ANKS3",
            "KLHDC10",
            "PRKAR2A",
            "RHBDD3",
            "SLC25A40",
            "CASD1",
            "VKORC1L1",
            "ZNF205",
            "CCS",
            "MRPL28",
            "E4F1",
            "LMBR1",
            "AARSD1",
            "DGCR14",
            "SEC24A",
            "THAP5",
            "FKBP8",
            "ZBTB6",
            "SPNS1",
            "SNRNP35",
            "NPAT",
            "WASL",
            "NKIRAS2",
            "CBLL1",
            "ING3",
            "RSBN1L",
            "SPOPL",
            "TBL3",
            "AAAS",
            "TMEM87B",
            "RNF6",
            "DUS2L",
            "MKLN1",
            "POLR2E",
            "MIOS",
            "SAP30BP",
            "EXOC4",
            "SP3",
            "PDE12",
            "CUL1"
        ]
    },
    {
        "golabel": "ZNF821_regulon_activity",
        "gene": [
            "BIRC3",
            "PAQR5",
            "ASPH",
            "TIGD3",
            "FAM69B",
            "LASS4",
            "MAGIX",
            "C1orf229",
            "PTP4A3",
            "SBK1",
            "FRS3",
            "SALL2",
            "GALNT3",
            "ARVCF",
            "LIN7B",
            "MTCP1NB",
            "KIAA0895L",
            "MEX3B",
            "NFATC4",
            "MYO1E",
            "MBLAC1",
            "ARHGEF19",
            "CSDAP1",
            "LRRC29",
            "LAGE3",
            "TM7SF2",
            "LOC202781",
            "FLJ37453",
            "GGT7",
            "MDP1",
            "SSFA2",
            "BMF",
            "ZAK",
            "FAM127B",
            "PGM2",
            "SCAND1",
            "PCGF2",
            "NRL",
            "ZNF775",
            "C6orf134",
            "LY6G5C",
            "C17orf90",
            "PTER",
            "NCK1",
            "FAM50A",
            "BCL7C",
            "C3orf71",
            "SDR39U1",
            "TMEM25",
            "FAM195B",
            "ERLIN1",
            "FAM3A",
            "C14orf4",
            "TP53I13",
            "ZNF34",
            "PCBP4",
            "FUK",
            "C9orf7",
            "HSDL1",
            "C9orf41",
            "TAZ",
            "DMAP1",
            "PATZ1",
            "NRSN2",
            "PRR3",
            "ZNF193",
            "BRF1",
            "PIN4",
            "C1orf35",
            "TMOD3",
            "FAM89B",
            "TBCD",
            "RP9",
            "GDI1",
            "CCS",
            "EXOSC6",
            "IDH3G",
            "PRMT7",
            "WBP1",
            "CENPBD1",
            "C6orf211",
            "CAB39",
            "PRR14",
            "LRRFIP1",
            "RALY",
            "ZCCHC6",
            "EMD",
            "ZNF764",
            "TMEM55B",
            "C14orf93",
            "VEGFB",
            "TSR2",
            "TERF2IP",
            "RNF187",
            "SLMAP",
            "PLEKHB2",
            "ATP6AP1",
            "FAM120A",
            "ZSWIM1",
            "RHBDD1",
            "COG4",
            "PCIF1",
            "DDX19B",
            "USP30",
            "C16orf70",
            "RBM4",
            "KIAA0174"
        ]
    },
    {
        "golabel": "ZNF846_regulon_activity",
        "gene": [
            "LOC285419",
            "MAPK10",
            "SLC4A4",
            "CACNB1",
            "NDRG2",
            "SPATA9",
            "CCT6B",
            "C2orf63",
            "ZNF440",
            "GALNT2",
            "ZNF763",
            "BDH2",
            "CCDC159",
            "DENND1A",
            "HYOU1",
            "ALS2CR8",
            "HSP90B1",
            "ZNF441",
            "ZNF563",
            "ZBED1",
            "ZNF700",
            "AARS",
            "ATP2A2",
            "UGGT1",
            "PLBD2",
            "PTPN11",
            "CBR4",
            "VMAC",
            "DDX54",
            "GOT2",
            "TSR1",
            "CDV3",
            "GANAB",
            "UBE2G1",
            "SND1",
            "DNAJC14",
            "VCP",
            "RAB35",
            "ZMYM6"
        ]
    },
    {
        "golabel": "ZNFX1_regulon_activity",
        "gene": [
            "SEC11C",
            "C19orf45",
            "CENPV",
            "SIGLEC1",
            "C8orf4",
            "C17orf61",
            "RSAD2",
            "PTAFR",
            "SAMD9",
            "IFIT2",
            "XAF1",
            "IFIT3",
            "SPN",
            "AHNAK",
            "OAS2",
            "IFIH1",
            "SAMD9L",
            "DDX60",
            "MX2",
            "FPR3",
            "OAS3",
            "SAMD4A",
            "KIAA0114",
            "CMPK2",
            "C6orf129",
            "MRPL48",
            "C2orf76",
            "DDX58",
            "ADI1",
            "HERC6",
            "EBPL",
            "IER3IP1",
            "DLEU1",
            "TOMM6",
            "BGLAP",
            "PPL",
            "SAMHD1",
            "PEMT",
            "PLXNA1",
            "CD320",
            "DDX60L",
            "C12orf35",
            "SMYD3",
            "IDS",
            "RANGRF",
            "MYOF",
            "PRIC285",
            "CCDC72",
            "SLFN5",
            "MRPS26",
            "RNF213",
            "NOTCH2",
            "IMMP1L",
            "PIK3CD",
            "LYRM4",
            "C1QBP",
            "MTHFD2L",
            "DDTL",
            "APOL6",
            "FAM165B",
            "AKNA",
            "FAM36A",
            "PRKAB1",
            "ARAP2",
            "BCL9L",
            "PML",
            "MRP63",
            "TRANK1",
            "C12orf73",
            "C15orf61",
            "STK10",
            "IKZF2",
            "PRPSAP2",
            "ZSWIM7",
            "TRIM14",
            "POLR1D",
            "UQCRB",
            "RPAIN",
            "SERF1A",
            "ELF4",
            "PARP14",
            "LUZP1",
            "NDUFB8",
            "C19orf63",
            "EHBP1L1",
            "C12orf47",
            "SP110",
            "FNBP1",
            "CLSTN1",
            "SUCLG1",
            "PTPN1",
            "PEBP1",
            "SETMAR",
            "CUTC",
            "STAT2",
            "CUTA",
            "DTX3L",
            "SLC9A8",
            "ZNF22",
            "CCDC90A",
            "NUP88",
            "ZFYVE26",
            "TTC7A",
            "MTF1",
            "SLC25A11",
            "YWHAE",
            "TOR1B",
            "ZBTB7A",
            "ACBD6",
            "EIF1B",
            "SPATA2",
            "SPTAN1",
            "DIAPH1",
            "PRKRA",
            "ELMO2",
            "FKBP15",
            "N4BP1",
            "PDHB",
            "TMEM127",
            "STAU1"
        ]
    },
    {
        "golabel": "ZNHIT3_regulon_activity",
        "gene": [
            "RPL27",
            "CACNA1C",
            "SNRPG",
            "AHNAK",
            "HEG1",
            "COBL",
            "TMEM106C",
            "STRA13",
            "MAST4",
            "DEPDC4",
            "NDUFB9",
            "NSMCE2",
            "C8orf59",
            "MRPL13",
            "PIK3C2B",
            "TCEB1",
            "NME1",
            "LSM2",
            "LRP1",
            "TMEM14B",
            "CCDC56",
            "PSMB3",
            "AKAP13",
            "COX6A1",
            "HSPG2",
            "GEMIN6",
            "ANAPC11",
            "ATP5G1",
            "MRPS23",
            "RHEB",
            "C6orf162",
            "VBP1",
            "NT5C3L",
            "NME2",
            "MRPL12",
            "HAX1",
            "C17orf58",
            "ARL16",
            "BOD1",
            "MRPL11",
            "MRPS33",
            "CCDC23",
            "IFT20",
            "C10orf35",
            "NOTCH1",
            "ISCA2",
            "NACC2",
            "TPRKB",
            "SMARCA2",
            "DPY30",
            "SGK269",
            "NGDN",
            "AMZ2P1",
            "FANCL",
            "ICT1",
            "C17orf75",
            "UBE2CBP",
            "SNRNP25",
            "SNAPIN",
            "RPL19",
            "PDZD11",
            "POLR2G",
            "TMEM49",
            "MRPL27",
            "APEX1",
            "COQ5",
            "GTF2H5",
            "PSMB1",
            "SNRPE",
            "MRPL45",
            "NLE1",
            "PSMD11",
            "PTRH2",
            "GPN3",
            "COX11",
            "KIF1C",
            "C17orf42",
            "SNRPC",
            "NARF",
            "WDR81",
            "HERC1",
            "DIABLO",
            "C17orf79",
            "ATP5H",
            "C12orf41",
            "SF3B14",
            "SLC25A17",
            "SLBP",
            "SUPT4H1",
            "MRPS7",
            "ZZEF1",
            "NDUFA12",
            "GTPBP1",
            "VPS25",
            "RMND1",
            "SDF2",
            "ITPRIPL2",
            "FN3KRP",
            "AARSD1",
            "RAD51C",
            "ZCCHC4",
            "PHB",
            "TACO1",
            "TLN1",
            "ZBTB7A",
            "SUMO2",
            "SNF8",
            "UTP18",
            "TECPR2",
            "MLX",
            "SLC35B1",
            "SMARCE1",
            "LSM12",
            "C2orf56",
            "CCDC43",
            "FOXJ2",
            "C17orf95",
            "PHF2",
            "POLDIP2",
            "TMEM199",
            "MRPL10",
            "SFRS7",
            "COIL",
            "UTP6",
            "ERAL1",
            "ZNF207"
        ]
    },
    {
        "golabel": "ZRANB2_regulon_activity",
        "gene": [
            "C2orf58",
            "RNPC3",
            "PTBP2",
            "LOC440944",
            "RPL5",
            "ZNF519",
            "NUDT13",
            "MTRR",
            "CRYZ",
            "ARGLU1",
            "INTU",
            "TIGD1",
            "SH3PXD2B",
            "GPR56",
            "IFT80",
            "ZNF684",
            "CDKL3",
            "MYO1D",
            "BDH2",
            "EXOSC8",
            "ZNF354B",
            "GTF2H2C",
            "KIAA0907",
            "EIF4A2",
            "MTRF1",
            "ANKAR",
            "ING4",
            "ZNF141",
            "KIAA1712",
            "CRBN",
            "CETN3",
            "TTC14",
            "CLK1",
            "NUPL1",
            "SLC25A36",
            "TIA1",
            "RABGGTB",
            "PRPF39",
            "EFCAB7",
            "BBS10",
            "ZNF700",
            "OXSM",
            "CCDC73",
            "C1orf52",
            "C5orf44",
            "FPGT",
            "CYP2R1",
            "SNX9",
            "CCDC66",
            "LZTFL1",
            "LRRC40",
            "NOMO1",
            "PACS1",
            "SLC27A4",
            "TMEM8A",
            "CCDC76",
            "TUBE1",
            "PACRGL",
            "C22orf9",
            "ANKRD49",
            "UBE2E1",
            "FAM200B",
            "RBM5",
            "DMTF1",
            "ST7L",
            "WDR5B",
            "C15orf39",
            "LYRM7",
            "OMA1",
            "SFRS11",
            "ALG13",
            "DCUN1D4",
            "OGDH",
            "UBA3",
            "CCNH",
            "KIF3B",
            "N4BP2L2",
            "RWDD3",
            "TRNT1",
            "SIKE1",
            "IKZF5",
            "THUMPD2",
            "EXOSC7",
            "PMS1",
            "HK1",
            "ZNF777",
            "FAM76B",
            "SEPT9",
            "SACM1L",
            "C2orf56",
            "C3orf31",
            "GLG1",
            "TYW3",
            "NFE2L1",
            "CEPT1",
            "THAP6",
            "MFSD8",
            "HDLBP",
            "ANAPC4",
            "METTL6",
            "TRA2A",
            "PRPF38A",
            "CCNT2",
            "USP33",
            "ARHGAP1",
            "DNAJC24",
            "SFRS7",
            "SFRS6",
            "TMEM214",
            "RAB28",
            "PAPD4",
            "TM9SF4",
            "TMEM127",
            "ATG9A",
            "NGLY1",
            "MLH1",
            "RBMX",
            "SFRS2",
            "SFRS13A"
        ]
    },
    {
        "golabel": "ZRSR2_regulon_activity",
        "gene": [
            "EIF1AY",
            "XIST",
            "TTTY15",
            "CYorf15A",
            "CLEC4F",
            "ZFY",
            "LOC644165",
            "CAPN3",
            "OXER1",
            "ZMAT1",
            "LOC100131434",
            "LTB",
            "NPIPL3",
            "HCG26",
            "XAF1",
            "LOC91316",
            "ATG16L2",
            "LCAT",
            "NAPSB",
            "CHKB-CPT1B",
            "TTLL3",
            "CROCC",
            "CCDC88B",
            "CROCCL2",
            "GAB3",
            "INE1",
            "MTFR1",
            "TSPYL2",
            "PEX2",
            "ARSD",
            "ECHDC2",
            "FAM193B",
            "LOC339047",
            "FAM156A",
            "TUBGCP6",
            "NUDCD1",
            "TMEM182",
            "ZNF589",
            "ZNF337",
            "PTER",
            "ZNF276",
            "ARMC1",
            "TFAM",
            "SFI1",
            "SFRS17A",
            "TRIM52",
            "LOC729020",
            "METTL2B",
            "CA5B",
            "RBM6",
            "CIRBP",
            "C19orf66",
            "OFD1",
            "WDR43",
            "CA5BP",
            "SLC30A6",
            "NDUFS1",
            "GEMIN8",
            "KDM5C",
            "TRAPPC2",
            "CDYL",
            "NXF1",
            "YME1L1"
        ]
    },
    {
        "golabel": "ZSCAN16_regulon_activity",
        "gene": [
            "MFI2",
            "ITGA5",
            "C6orf41",
            "EFNB1",
            "PTAFR",
            "ITGAM",
            "C5AR1",
            "NRP2",
            "AIM1",
            "LOC100270746",
            "MXD1",
            "RIN1",
            "EMP3",
            "C6orf48",
            "TRIM45",
            "CREB3L4",
            "C6orf125",
            "SIRPA",
            "ProSAPiP1",
            "ELK3",
            "YPEL1",
            "SIRT4",
            "TEAD2",
            "ACOT13",
            "LHFPL2",
            "ZNF165",
            "DUSP7",
            "MYADM",
            "CTSB",
            "MTHFD2L",
            "C2orf15",
            "BPHL",
            "ZNF77",
            "SOX4",
            "C2orf64",
            "ZNF620",
            "PHOSPHO2",
            "PXN",
            "STK10",
            "ZNF232",
            "VCL",
            "H3F3A",
            "RPAIN",
            "ELF4",
            "ZNF133",
            "CORO1C",
            "ZYX",
            "FAM8A1",
            "PRR3",
            "AMFR",
            "ZNF193",
            "ZNF195",
            "SETMAR",
            "PRUNE",
            "ZNF248",
            "PCMTD2",
            "ZNF606",
            "CCDC45",
            "FAM200A",
            "TAF11",
            "ZNF691",
            "ZSCAN2",
            "FAM200B",
            "ZNF187",
            "CCDC90A",
            "RCOR3",
            "C6orf64",
            "ZNF16",
            "C1orf26",
            "ZNF76",
            "VPS45",
            "SCYL3",
            "RANBP9",
            "NFKB1",
            "PYGO2",
            "ZKSCAN4",
            "TMCO7",
            "C2orf56",
            "RSAD1",
            "MRPS31",
            "PSPC1",
            "DTNBP1",
            "TRIM27",
            "SFRS6",
            "RXRB",
            "PPP1R11"
        ]
    },
    {
        "golabel": "ZSCAN2_regulon_activity",
        "gene": [
            "BHLHA15",
            "RRAD",
            "KIT",
            "AIM1",
            "SAMD9L",
            "LY75",
            "FZD3",
            "KIAA1549",
            "LAIR1",
            "FAS",
            "NCF2",
            "CCDC109B",
            "MDFIC",
            "CASP1",
            "CD83",
            "STK17A",
            "OGFRL1",
            "KLHL25",
            "FN3K",
            "IRF5",
            "DAPP1",
            "TBL1X",
            "PTPLAD2",
            "SOX4",
            "ZKSCAN3",
            "CLIP4",
            "NGRN",
            "RCN2",
            "PLK3",
            "CCNJ",
            "ZSCAN16",
            "ZNF48",
            "ZBED1",
            "LDOC1L",
            "MOBKL2C",
            "DEGS1",
            "WDR73",
            "ZSCAN29",
            "FANCF",
            "ANP32A",
            "UNC45A",
            "VPS33B",
            "HNRNPA0"
        ]
    },
    {
        "golabel": "ZSCAN29_regulon_activity",
        "gene": [
            "CATSPER1",
            "PLEKHH1",
            "WNT10A",
            "SNORD116-4",
            "LGALS1",
            "DHDH",
            "IFI27",
            "LAYN",
            "TREM2",
            "MT1F",
            "LST1",
            "WDR66",
            "C19orf38",
            "PLEKHG2",
            "UPP1",
            "TYROBP",
            "NCRNA00095",
            "LY6E",
            "COPZ2",
            "C5orf62",
            "ETNK2",
            "KIAA1549",
            "MEIS2",
            "EMP3",
            "TP53TG1",
            "RGS10",
            "CEP152",
            "STK17A",
            "SH3BGRL3",
            "RHOC",
            "ZDHHC23",
            "CMTM3",
            "CAPG",
            "CATSPER2P1",
            "PDIA3",
            "CAMK1",
            "KIAA1598",
            "CNN3",
            "CMTM4",
            "PDIA3P",
            "NFKBIE",
            "TMEM51",
            "HMBOX1",
            "ZNF236",
            "C9orf21",
            "PGBD4",
            "IFNGR2",
            "ZNF770",
            "PPIP5K1",
            "TUBGCP4",
            "C17orf85",
            "C1orf69",
            "UROD",
            "PLA2G15",
            "HERC2",
            "NIPA1",
            "ZNF37A",
            "ZNF518A",
            "NTAN1",
            "ZSCAN2",
            "RREB1",
            "SPATA5L1",
            "RPA2",
            "PEA15",
            "NECAP2",
            "MGA",
            "LCMT2",
            "RPAP1",
            "CDAN1",
            "MAVS",
            "DEGS1",
            "PIGO",
            "MTMR15",
            "DBNL",
            "ACTB",
            "FAM168B",
            "TWF2",
            "ZBED4",
            "SPG11",
            "PPP1R10",
            "ZNF592",
            "VPS39",
            "HIF1AN",
            "GOLGA1",
            "INO80",
            "CCAR1",
            "CAPZB",
            "SLTM",
            "PDCD7"
        ]
    },
    {
        "golabel": "ZSWIM4_regulon_activity",
        "gene": [
            "PODNL1",
            "INHBB",
            "PRRX2",
            "PRSS27",
            "COL13A1",
            "COL8A2",
            "KCNN4",
            "IGSF9",
            "ICAM1",
            "TACSTD2",
            "HOMER3",
            "MRC2",
            "DUSP10",
            "DLEU1",
            "ACAT1",
            "IDI1",
            "CMTM3",
            "TTYH3",
            "TBX19",
            "NLGN2",
            "DTX2",
            "TRIM47",
            "ATP5S",
            "RHBDF2",
            "CLDN4",
            "PLEKHG1",
            "AHDC1",
            "MEX3D",
            "GLIS2",
            "FAM109A",
            "ZNF341",
            "SUCLG2",
            "PRDX3",
            "FAM127A",
            "C10orf57",
            "SEMA4C",
            "SMARCA4",
            "NCRNA00081",
            "DAPK3",
            "LPPR2",
            "TCF3",
            "LOC729082",
            "CNN2",
            "S1PR2",
            "GHITM",
            "MAP7D1",
            "PIK3R2",
            "MAP1S",
            "NACC1",
            "MLLT1",
            "MRPS27",
            "GALK2",
            "NSMCE4A",
            "SLC39A13",
            "MYO9B",
            "MIER2",
            "CC2D1A",
            "HDAC7",
            "NECAP1",
            "GFM2",
            "TYK2",
            "ACTB",
            "SNX5",
            "EXOC6",
            "KDM4B",
            "PIP5K1C",
            "C16orf57",
            "DLST",
            "WIZ",
            "TMEM104",
            "MTFMT",
            "CSNK1G2",
            "SCO1",
            "PPP1R9B",
            "COX15",
            "NARG2",
            "NHEJ1",
            "C15orf44"
        ]
    }
]